import "./3d.9be1671b.js";
import "./3d.ad60980c.js";
import "./prsm.2a1c811c.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("93qLg", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

parcelRegister("dKU2C", function(module, exports) {
module.exports = import("b2DGI").then(()=>parcelRequire('hdFHv'));

});

/********************************************************************************************* 

PRSM Participatory System Mapper 

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

This software is licenced under the PolyForm Noncommercial License 1.0.0

<https://polyformproject.org/licenses/noncommercial/1.0.0>

See the file LICENSE.md for details.

This is the main entry point for PRSM.  
********************************************************************************************/ 
var $eokS8 = parcelRequire("eokS8");

var $dGheI = parcelRequire("dGheI");

var $8L2sr = parcelRequire("8L2sr");

var $7AcYc = parcelRequire("7AcYc");
const $2e5ed1f18cd62599$var$richTypes = {
    Date: true,
    RegExp: true,
    String: true,
    Number: true
};
function $2e5ed1f18cd62599$export$2e2bcd8739ae039(obj, newObj, options = {
    cyclesFix: true
}, _stack = []) {
    let diffs = [];
    const isObjArray = Array.isArray(obj);
    for(const key in obj){
        const objKey = obj[key];
        const path = isObjArray ? +key : key;
        if (!(key in newObj)) {
            diffs.push({
                type: "REMOVE",
                path: [
                    path
                ],
                oldValue: obj[key]
            });
            continue;
        }
        const newObjKey = newObj[key];
        const areCompatibleObjects = typeof objKey === "object" && typeof newObjKey === "object" && Array.isArray(objKey) === Array.isArray(newObjKey);
        if (objKey && newObjKey && areCompatibleObjects && !$2e5ed1f18cd62599$var$richTypes[Object.getPrototypeOf(objKey)?.constructor?.name] && (!options.cyclesFix || !_stack.includes(objKey))) diffs.push.apply(diffs, $2e5ed1f18cd62599$export$2e2bcd8739ae039(objKey, newObjKey, options, options.cyclesFix ? _stack.concat([
            objKey
        ]) : []).map((difference)=>{
            difference.path.unshift(path);
            return difference;
        }));
        else if (objKey !== newObjKey && // treat NaN values as equivalent
        !(Number.isNaN(objKey) && Number.isNaN(newObjKey)) && !(areCompatibleObjects && (isNaN(objKey) ? objKey + "" === newObjKey + "" : +objKey === +newObjKey))) diffs.push({
            path: [
                path
            ],
            type: "CHANGE",
            value: newObjKey,
            oldValue: objKey
        });
    }
    const isNewObjArray = Array.isArray(newObj);
    for(const key in newObj)if (!(key in obj)) diffs.push({
        type: "CREATE",
        path: [
            isNewObjArray ? +key : key
        ],
        value: newObj[key]
    });
    return diffs;
}


var $3568a0eaf2cac7b9$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $3568a0eaf2cac7b9$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});



var $7hmfH = parcelRequire("7hmfH");
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

  Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module provides import and export functions, to read and save map files in a variety of formats.  
 ******************************************************************************************************************** */ 
var $8L2sr = parcelRequire("8L2sr");


var $7hmfH = parcelRequire("7hmfH");
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module provides the standard set of Styles for Factors and Links.  
 ******************************************************************************************************************** */ const $2044cce2dd0aa04b$export$9dd6ff9ea0189349 = {
    nodes: {
        base: {
            groupLabel: 'Sample',
            borderWidth: 0,
            borderWidthSelected: 4,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(255, 255, 255)',
                highlight: {
                    border: 'rgb(0, 0, 0)',
                    background: 'rgb(255, 255, 255)'
                },
                hover: {
                    border: 'rgb(0, 0, 0)',
                    background: 'rgb(255, 255, 255)'
                }
            },
            fixed: false,
            font: {
                face: 'Oxygen',
                color: 'rgb(0, 0, 0)',
                size: 14
            },
            labelHighlightBold: true,
            margin: 20,
            shape: 'ellipse',
            shapeProperties: {
                borderDashes: false
            },
            scaling: {
                min: 10,
                max: 40,
                label: {
                    enabled: false,
                    min: 10,
                    max: 40
                }
            },
            size: 25,
            heightConstraint: false,
            widthConstraint: false
        },
        group0: {
            color: {
                border: 'rgb(154, 219, 180)',
                background: 'rgb(154, 219, 180)'
            },
            shape: 'box'
        },
        group1: {
            color: {
                border: 'rgb(202, 219, 92)',
                background: 'rgb(202, 219, 92)'
            },
            shape: 'box'
        },
        group2: {
            color: {
                border: 'rgb(219, 165, 66)',
                background: 'rgb(219, 165, 66)'
            },
            shape: 'box'
        },
        group3: {
            color: {
                border: 'rgb(219, 110, 103)',
                background: 'rgb(219, 110, 103)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group4: {
            color: {
                border: 'rgb(131, 113, 183)',
                background: 'rgb(131, 113, 183)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group5: {
            font: {
                color: 'rgb(28, 95, 27)'
            },
            shape: 'text'
        },
        group6: {
            borderWidth: 4,
            color: {
                border: 'rgb(0, 0, 255)',
                background: 'rgb(179, 204, 255)'
            },
            shape: 'diamond'
        },
        group7: {
            borderWidth: 4,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(255, 255, 153)'
            },
            shape: 'circle',
            shapeProperties: {
                borderDashes: [
                    3,
                    3
                ]
            }
        },
        group8: {
            color: {
                border: 'rgb(2, 71, 254)',
                background: 'rgb(2, 71, 254)'
            },
            font: {
                color: 'rgb(255, 0, 0)'
            },
            shape: 'star'
        },
        group9: {
            color: {
                border: 'rgb(255, 0, 0)',
                background: 'rgb(255, 0, 0)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group10: {
            color: {
                border: 'rgb(0, 0, 255)',
                background: 'rgb(0, 0, 255)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group11: {
            color: {
                border: 'rgb(0, 255, 0)',
                background: 'rgb(0, 255, 0)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        group12: {
            color: {
                border: 'rgb(254, 254, 51)',
                background: 'rgb(254, 254, 51)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        group13: {
            color: {
                border: 'rgb(255, 0, 255)',
                background: 'rgb(255, 0, 255)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'box'
        },
        group14: {
            color: {
                border: 'rgb(0, 255, 255)',
                background: 'rgb(0, 255, 255)'
            },
            font: {
                color: 'rgb(0, 0, 0)'
            },
            shape: 'box'
        },
        cluster: {
            borderWidth: 3,
            color: {
                border: 'rgb(0, 0, 0)',
                background: 'rgb(221, 44, 0)'
            },
            font: {
                color: 'rgb(255, 255, 255)'
            },
            shape: 'database',
            margin: {
                top: 40,
                right: 20,
                bottom: 20,
                left: 20
            }
        }
    },
    edges: {
        base: {
            arrows: {
                to: {
                    enabled: true,
                    type: 'vee'
                },
                middle: {
                    enabled: false
                },
                from: {
                    enabled: false
                }
            },
            color: {
                color: 'rgb(0, 0, 0)',
                highlight: 'rgb(0, 0, 0)',
                hover: 'rgb(0, 0, 0)',
                inherit: false,
                opacity: 1
            },
            dashes: false,
            font: {
                size: 14,
                align: 'top',
                background: 'rgb(255,255,255)',
                strokeWidth: 0
            },
            labelHighlightBold: false,
            groupLabel: 'Sample',
            hoverWidth: 1,
            selectionWidth: 0,
            width: 1
        },
        edge0: {
            color: {
                color: 'rgb(0, 0, 0)'
            }
        },
        edge1: {
            color: {
                color: 'rgb(0, 204, 0)'
            }
        },
        edge2: {
            color: {
                color: 'rgb(255, 0, 0)'
            }
        },
        edge3: {
            color: {
                color: 'rgb(0, 0, 255)'
            }
        },
        edge4: {
            color: {
                color: 'rgb(128, 128, 128)'
            }
        },
        edge5: {
            color: {
                color: 'rgb(230, 184, 0)'
            }
        },
        edge6: {
            color: {
                color: 'rgb(0, 0, 0)'
            },
            dashes: [
                3,
                3
            ]
        },
        edge7: {
            color: {
                color: 'rgb(0, 128, 0)'
            },
            dashes: [
                10,
                10
            ],
            width: 3
        },
        edge8: {
            arrows: {
                to: {
                    enabled: false
                },
                middle: {
                    enabled: true,
                    type: 'arrow'
                }
            },
            color: {
                color: 'rgb(0, 0, 0)'
            }
        },
        cluster: {
            color: {
                color: 'rgb(141, 110, 99)'
            },
            width: 3
        }
    }
};


/********************************************************************************************* 

PRSM Participatory System Mapper 

MIT License

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

This software is licenced under the PolyForm Noncommercial License 1.0.0

<https://polyformproject.org/licenses/noncommercial/1.0.0>

See the file LICENSE.md for details.

This module provides the background object-oriented drawing for PRSM
********************************************************************************************/ 
//#region \0rolldown/runtime.js
var $9a54cbcfc1af41ba$var$__defProp = Object.defineProperty;
var $9a54cbcfc1af41ba$var$__exportAll = (all, no_symbols)=>{
    let target = {};
    for(var name in all)$9a54cbcfc1af41ba$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
    if (!no_symbols) $9a54cbcfc1af41ba$var$__defProp(target, Symbol.toStringTag, {
        value: "Module"
    });
    return target;
};
//#endregion
//#region \0@oxc-project+runtime@0.122.0/helpers/typeof.js
function $9a54cbcfc1af41ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9a54cbcfc1af41ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9a54cbcfc1af41ba$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.122.0/helpers/toPrimitive.js
function $9a54cbcfc1af41ba$var$toPrimitive(t, r) {
    if ("object" != $9a54cbcfc1af41ba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9a54cbcfc1af41ba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.122.0/helpers/toPropertyKey.js
function $9a54cbcfc1af41ba$var$toPropertyKey(t) {
    var i = $9a54cbcfc1af41ba$var$toPrimitive(t, "string");
    return "symbol" == $9a54cbcfc1af41ba$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.122.0/helpers/defineProperty.js
function $9a54cbcfc1af41ba$var$_defineProperty(e, r, t) {
    return (r = $9a54cbcfc1af41ba$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region src/config.ts
var $9a54cbcfc1af41ba$var$BaseConfiguration = class {
    constructor(){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
			* which is unitless and not rendered equally across browsers.
			*
			* Values that work quite well (as of October 2017) are:
			* - Chrome: 1.5
			* - Edge: 1.75
			* - Firefox: 0.9
			* - Safari: 0.95
			*
			* @since 2.0.0
			* @type Number
			* @default 1
			*/ "browserShadowBlurConstant", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
			*/ "DPI", 96);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Device Pixel Ratio
			* @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
			*/ "devicePixelRatio", typeof window !== "undefined" ? window.devicePixelRatio : 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
			* @since 1.7.14
			* @type Number
			*/ "perfLimitSizeTotal", 2097152);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
			* @since 1.7.14
			* @type Number
			*/ "maxCacheSideLimit", 4096);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Lowest pixel limit for cache canvases, set at 256PX
			* @since 1.7.14
			* @type Number
			*/ "minCacheSideLimit", 256);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* When 'true', style information is not retained when copy/pasting text, making
			* pasted text use destination style.
			* Defaults to 'false'.
			* @type Boolean
			* @deprecated
			*/ "disableStyleCopyPaste", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Enable webgl for filtering picture is available
			* A filtering backend will be initialized, this will both take memory and
			* time since a default 2048x2048 canvas will be created for the gl context
			* @since 2.0.0
			* @type Boolean
			*/ "enableGLFiltering", true);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* if webgl is enabled and available, textureSize will determine the size
			* of the canvas backend
			*
			* In order to support old hardware set to `2048` to avoid OOM
			*
			* @since 2.0.0
			* @type Number
			*/ "textureSize", 4096);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
			* Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
			* this has to be set before instantiating the filtering backend ( before filtering the first image )
			* @type Boolean
			* @default false
			*/ "forceGLPutImageData", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
			* With the standard behaviour of fabric to translate all curves in absolute commands and by not subtracting the starting point from
			* the curve is very hard to hit any cache.
			* Enable only if you know why it could be useful.
			* Candidate for removal/simplification
			* @default false
			*/ "cachesBoundsOfCurve", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Map of font files
			* Map<fontFamily, pathToFile> of font files
			*/ "fontPaths", {});
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Defines the number of fraction digits to use when serializing object values.
			* Used in exporting methods (`toObject`, `toJSON`, `toSVG`)
			* You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
			*/ "NUM_FRACTION_DIGITS", 4);
    }
};
var $9a54cbcfc1af41ba$var$Configuration = class extends $9a54cbcfc1af41ba$var$BaseConfiguration {
    constructor(config){
        super();
        this.configure(config);
    }
    configure(config = {}) {
        Object.assign(this, config);
    }
    /**
	* Map<fontFamily, pathToFile> of font files
	*/ addFonts(paths = {}) {
        this.fontPaths = {
            ...this.fontPaths,
            ...paths
        };
    }
    removeFonts(fontFamilys = []) {
        fontFamilys.forEach((fontFamily)=>{
            delete this.fontPaths[fontFamily];
        });
    }
    clearFonts() {
        this.fontPaths = {};
    }
    restoreDefaults(keys) {
        const defaults = new $9a54cbcfc1af41ba$var$BaseConfiguration();
        const config = (keys === null || keys === void 0 ? void 0 : keys.reduce((acc, key)=>{
            acc[key] = defaults[key];
            return acc;
        }, {})) || defaults;
        this.configure(config);
    }
};
const $9a54cbcfc1af41ba$export$e506a1d27d1eaa20 = new $9a54cbcfc1af41ba$var$Configuration();
//#endregion
//#region src/util/internals/console.ts
const $9a54cbcfc1af41ba$var$log = (severity, ...optionalParams)=>console[severity]("fabric", ...optionalParams);
var $9a54cbcfc1af41ba$var$FabricError = class extends Error {
    constructor(message, options){
        super(`fabric: ${message}`, options);
    }
};
var $9a54cbcfc1af41ba$var$SignalAbortedError = class extends $9a54cbcfc1af41ba$var$FabricError {
    constructor(context){
        super(`${context} 'options.signal' is in 'aborted' state`);
    }
};
//#endregion
//#region src/filters/GLProbes/GLProbe.ts
var $9a54cbcfc1af41ba$var$GLProbe = class {
};
//#endregion
//#region src/filters/GLProbes/WebGLProbe.ts
/**
* Lazy initialize WebGL constants
*/ var $9a54cbcfc1af41ba$var$WebGLProbe = class extends $9a54cbcfc1af41ba$var$GLProbe {
    /**
	* Tests if webgl supports certain precision
	* @param {WebGL} Canvas WebGL context to test on
	* @param {GLPrecision} Precision to test can be any of following
	* @returns {Boolean} Whether the user's browser WebGL supports given precision.
	*/ testPrecision(gl, precision) {
        const fragmentSource = `precision ${precision} float;\nvoid main(){}`;
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        if (!fragmentShader) return false;
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        return !!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS);
    }
    /**
	* query browser for WebGL
	*/ queryWebGL(canvas) {
        const gl = canvas.getContext("webgl");
        if (gl) {
            this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
            this.GLPrecision = [
                "highp",
                "mediump",
                "lowp"
            ].find((precision)=>this.testPrecision(gl, precision));
            gl.getExtension("WEBGL_lose_context").loseContext();
            $9a54cbcfc1af41ba$var$log("log", `WebGL: max texture size ${this.maxTextureSize}`);
        }
    }
    isSupported(textureSize) {
        return !!this.maxTextureSize && this.maxTextureSize >= textureSize;
    }
};
//#endregion
//#region src/env/browser.ts
const $9a54cbcfc1af41ba$var$copyPasteData = {};
const $9a54cbcfc1af41ba$var$getEnv$1 = ()=>{
    return {
        document: document,
        window: window,
        isTouchSupported: "ontouchstart" in window || "ontouchstart" in document || window && window.navigator && window.navigator.maxTouchPoints > 0,
        WebGLProbe: new $9a54cbcfc1af41ba$var$WebGLProbe(),
        dispose () {},
        copyPasteData: $9a54cbcfc1af41ba$var$copyPasteData
    };
};
//#endregion
//#region src/env/index.ts
/**
* This file is consumed by fabric.
* The `./node` and `./browser` files define the env variable that is used by this module.
* The `./browser` module is defined to be the default env and doesn't set the env at all.
* This is done in order to support isomorphic usage for browser and node applications
* since window and document aren't defined at time of import in SSR, we can't set env so we avoid it by deferring to the default env.
*/ let $9a54cbcfc1af41ba$var$env;
/**
* Sets the environment variables used by fabric.\
* This is exposed for special cases, such as configuring a test environment, and should be used with care.
*
* **CAUTION**: Must be called before using the package.
*
* @example
* <caption>Passing `window` and `document` objects to fabric (in case they are mocked or something)</caption>
* import { getEnv, setEnv } from 'fabric';
* // we want fabric to use the `window` and `document` objects exposed by the environment we are running in.
* setEnv({ ...getEnv(), window, document });
* // done with setup, using fabric is now safe
*/ const $9a54cbcfc1af41ba$export$84bc02d3c7a6b55f = (value)=>{
    $9a54cbcfc1af41ba$var$env = value;
};
/**
* In order to support SSR we **MUST** access the browser env only after the window has loaded
*/ const $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e = ()=>$9a54cbcfc1af41ba$var$env || ($9a54cbcfc1af41ba$var$env = $9a54cbcfc1af41ba$var$getEnv$1());
const $9a54cbcfc1af41ba$export$91e93c41e950ddbb = ()=>$9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().document;
const $9a54cbcfc1af41ba$export$4a3a3142573970c3 = ()=>$9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().window;
/**
* @returns the config value if defined, fallbacks to the environment value
*/ const $9a54cbcfc1af41ba$var$getDevicePixelRatio = ()=>{
    var _config$devicePixelRa;
    return Math.max((_config$devicePixelRa = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.devicePixelRatio) !== null && _config$devicePixelRa !== void 0 ? _config$devicePixelRa : $9a54cbcfc1af41ba$export$4a3a3142573970c3().devicePixelRatio, 1);
};
//#endregion
//#region src/cache.ts
var $9a54cbcfc1af41ba$var$Cache = class {
    constructor(){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
			* It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
			* you do not get any speed benefit and you get a big object in memory.
			* The object was a private variable before, while now is appended to the lib so that you have access to it and you
			* can eventually clear it.
			* It was an internal variable, is accessible since version 2.3.4
			*/ "boundsOfCurveCache", {});
        this.charWidthsCache = /* @__PURE__ */ new Map();
    }
    /**
	* @return {Object} reference to cache
	*/ getFontCache({ fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }) {
        fontFamily = fontFamily.toLowerCase();
        const cache = this.charWidthsCache;
        if (!cache.has(fontFamily)) cache.set(fontFamily, /* @__PURE__ */ new Map());
        const fontCache = cache.get(fontFamily);
        const cacheKey = `${fontStyle.toLowerCase()}_${(fontWeight + "").toLowerCase()}`;
        if (!fontCache.has(cacheKey)) fontCache.set(cacheKey, /* @__PURE__ */ new Map());
        return fontCache.get(cacheKey);
    }
    /**
	* Clear char widths cache for the given font family or all the cache if no
	* fontFamily is specified.
	* Use it if you know you are loading fonts in a lazy way and you are not waiting
	* for custom fonts to load properly when adding text objects to the canvas.
	* If a text object is added when its own font is not loaded yet, you will get wrong
	* measurement and so wrong bounding boxes.
	* After the font cache is cleared, either change the textObject text content or call
	* initDimensions() to trigger a recalculation
	* @param {String} [fontFamily] font family to clear
	*/ clearFontCache(fontFamily) {
        if (!fontFamily) this.charWidthsCache = /* @__PURE__ */ new Map();
        else this.charWidthsCache.delete((fontFamily || "").toLowerCase());
    }
    /**
	* Given current aspect ratio, determines the max width and height that can
	* respect the total allowed area for the cache.
	* @param {number} ar aspect ratio
	* @return {number[]} Limited dimensions X and Y
	*/ limitDimsByArea(ar) {
        const { perfLimitSizeTotal: perfLimitSizeTotal } = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20;
        const roughWidth = Math.sqrt(perfLimitSizeTotal * ar);
        return [
            Math.floor(roughWidth),
            Math.floor(perfLimitSizeTotal / roughWidth)
        ];
    }
};
const $9a54cbcfc1af41ba$export$69a3209f1a06c04d = new $9a54cbcfc1af41ba$var$Cache();
//#endregion
//#region src/constants.ts
const $9a54cbcfc1af41ba$export$83d89fbfd8236492 = "7.3.1";
function $9a54cbcfc1af41ba$var$noop() {}
const $9a54cbcfc1af41ba$var$halfPI = Math.PI / 2;
const $9a54cbcfc1af41ba$var$quarterPI = Math.PI / 4;
const $9a54cbcfc1af41ba$var$twoMathPi = Math.PI * 2;
const $9a54cbcfc1af41ba$var$PiBy180 = Math.PI / 180;
const $9a54cbcfc1af41ba$export$3c5a7f9475b116e0 = Object.freeze([
    1,
    0,
    0,
    1,
    0,
    0
]);
const $9a54cbcfc1af41ba$var$CENTER = "center";
const $9a54cbcfc1af41ba$var$LEFT = "left";
const $9a54cbcfc1af41ba$var$BOTTOM = "bottom";
const $9a54cbcfc1af41ba$var$RIGHT = "right";
const $9a54cbcfc1af41ba$var$NONE = "none";
const $9a54cbcfc1af41ba$var$reNewline = /\r?\n/;
const $9a54cbcfc1af41ba$var$MOVING = "moving";
const $9a54cbcfc1af41ba$var$SCALING = "scaling";
const $9a54cbcfc1af41ba$var$ROTATING = "rotating";
const $9a54cbcfc1af41ba$var$ROTATE = "rotate";
const $9a54cbcfc1af41ba$var$SKEWING = "skewing";
const $9a54cbcfc1af41ba$var$RESIZING = "resizing";
const $9a54cbcfc1af41ba$var$MODIFY_POLY = "modifyPoly";
const $9a54cbcfc1af41ba$var$MODIFY_PATH = "modifyPath";
const $9a54cbcfc1af41ba$var$CHANGED = "changed";
const $9a54cbcfc1af41ba$var$SCALE = "scale";
const $9a54cbcfc1af41ba$var$SCALE_X = "scaleX";
const $9a54cbcfc1af41ba$var$SCALE_Y = "scaleY";
const $9a54cbcfc1af41ba$var$SKEW_X = "skewX";
const $9a54cbcfc1af41ba$var$SKEW_Y = "skewY";
const $9a54cbcfc1af41ba$var$FILL = "fill";
const $9a54cbcfc1af41ba$var$STROKE = "stroke";
const $9a54cbcfc1af41ba$var$MODIFIED = "modified";
const $9a54cbcfc1af41ba$var$NORMAL = "normal";
//#endregion
//#region src/ClassRegistry.ts
const $9a54cbcfc1af41ba$var$JSON$1 = "json";
var $9a54cbcfc1af41ba$var$ClassRegistry = class {
    constructor(){
        this[$9a54cbcfc1af41ba$var$JSON$1] = /* @__PURE__ */ new Map();
        this["svg"] = /* @__PURE__ */ new Map();
    }
    has(classType) {
        return this[$9a54cbcfc1af41ba$var$JSON$1].has(classType);
    }
    getClass(classType) {
        const constructor = this[$9a54cbcfc1af41ba$var$JSON$1].get(classType);
        if (!constructor) throw new $9a54cbcfc1af41ba$var$FabricError(`No class registered for ${classType}`);
        return constructor;
    }
    setClass(classConstructor, classType) {
        if (classType) this[$9a54cbcfc1af41ba$var$JSON$1].set(classType, classConstructor);
        else {
            this[$9a54cbcfc1af41ba$var$JSON$1].set(classConstructor.type, classConstructor);
            this[$9a54cbcfc1af41ba$var$JSON$1].set(classConstructor.type.toLowerCase(), classConstructor);
        }
    }
    getSVGClass(SVGTagName) {
        return this["svg"].get(SVGTagName);
    }
    setSVGClass(classConstructor, SVGTagName) {
        this["svg"].set(SVGTagName !== null && SVGTagName !== void 0 ? SVGTagName : classConstructor.type.toLowerCase(), classConstructor);
    }
};
const $9a54cbcfc1af41ba$export$2792378e23a7920c = new $9a54cbcfc1af41ba$var$ClassRegistry();
//#endregion
//#region src/util/animation/AnimationRegistry.ts
/**
* Array holding all running animations
*/ var $9a54cbcfc1af41ba$var$AnimationRegistry = class extends Array {
    /**
	* Remove a single animation using an animation context
	* @param {AnimationBase} context
	*/ remove(context) {
        const index = this.indexOf(context);
        index > -1 && this.splice(index, 1);
    }
    /**
	* Cancel all running animations on the next frame
	*/ cancelAll() {
        const animations = this.splice(0);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
	* Cancel all running animations attached to a canvas on the next frame
	* @param {StaticCanvas} canvas
	*/ cancelByCanvas(canvas) {
        if (!canvas) return [];
        const animations = this.filter((animation)=>{
            var _animation$target;
            return animation.target === canvas || typeof animation.target === "object" && ((_animation$target = animation.target) === null || _animation$target === void 0 ? void 0 : _animation$target.canvas) === canvas;
        });
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
	* Cancel all running animations for target on the next frame
	* @param target
	*/ cancelByTarget(target) {
        if (!target) return [];
        const animations = this.filter((animation)=>animation.target === target);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
};
const $9a54cbcfc1af41ba$export$dc18923894d9e56a = new $9a54cbcfc1af41ba$var$AnimationRegistry();
//#endregion
//#region src/Observable.ts
/**
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-2#events}
* @see {@link http://fabric5.fabricjs.com/events|Events demo}
*/ var $9a54cbcfc1af41ba$export$77cea355fa80b5f4 = class {
    constructor(){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__eventListeners", {});
    }
    on(arg0, handler) {
        if (!this.__eventListeners) this.__eventListeners = {};
        if (typeof arg0 === "object") {
            Object.entries(arg0).forEach(([eventName, handler])=>{
                this.on(eventName, handler);
            });
            return ()=>this.off(arg0);
        } else if (handler) {
            const eventName = arg0;
            if (!this.__eventListeners[eventName]) this.__eventListeners[eventName] = [];
            this.__eventListeners[eventName].push(handler);
            return ()=>this.off(eventName, handler);
        } else return ()=>false;
    }
    once(arg0, handler) {
        if (typeof arg0 === "object") {
            const disposers = [];
            Object.entries(arg0).forEach(([eventName, handler])=>{
                disposers.push(this.once(eventName, handler));
            });
            return ()=>disposers.forEach((d)=>d());
        } else if (handler) {
            const disposer = this.on(arg0, function onceHandler(...args) {
                handler.call(this, ...args);
                disposer();
            });
            return disposer;
        } else return ()=>false;
    }
    /**
	* @private
	* @param {string} eventName
	* @param {Function} [handler]
	*/ _removeEventListener(eventName, handler) {
        if (!this.__eventListeners[eventName]) return;
        if (handler) {
            const eventListener = this.__eventListeners[eventName];
            const index = eventListener.indexOf(handler);
            index > -1 && eventListener.splice(index, 1);
        } else this.__eventListeners[eventName] = [];
    }
    off(arg0, handler) {
        if (!this.__eventListeners) return;
        if (typeof arg0 === "undefined") for(const eventName in this.__eventListeners)this._removeEventListener(eventName);
        else if (typeof arg0 === "object") Object.entries(arg0).forEach(([eventName, handler])=>{
            this._removeEventListener(eventName, handler);
        });
        else this._removeEventListener(arg0, handler);
    }
    /**
	* Fires event with an optional options object
	* @param {String} eventName Event name to fire
	* @param {Object} [options] Options object
	*/ fire(eventName, options) {
        var _this$__eventListener;
        if (!this.__eventListeners) return;
        const listenersForEvent = (_this$__eventListener = this.__eventListeners[eventName]) === null || _this$__eventListener === void 0 ? void 0 : _this$__eventListener.concat();
        if (listenersForEvent) for(let i = 0; i < listenersForEvent.length; i++)listenersForEvent[i].call(this, options || {});
    }
};
//#endregion
//#region src/util/internals/removeFromArray.ts
/**
* Removes value from an array.
* Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
* @param {Array} array
* @param {*} value
* @return {Array} original array
*/ const $9a54cbcfc1af41ba$var$removeFromArray = (array, value)=>{
    const idx = array.indexOf(value);
    if (idx !== -1) array.splice(idx, 1);
    return array;
};
//#endregion
//#region src/util/misc/cos.ts
/**
* Calculate the cos of an angle, avoiding returning floats for known results
* This function is here just to avoid getting 0.999999999999999 when dealing
* with numbers that are really 1 or 0.
* @param {TRadian} angle the angle
* @return {Number} the cosin value for angle.
*/ const $9a54cbcfc1af41ba$var$cos = (angle)=>{
    if (angle === 0) return 1;
    switch(Math.abs(angle) / $9a54cbcfc1af41ba$var$halfPI){
        case 1:
        case 3:
            return 0;
        case 2:
            return -1;
    }
    return Math.cos(angle);
};
//#endregion
//#region src/util/misc/sin.ts
/**
* Calculate the cos of an angle, avoiding returning floats for known results
* This function is here just to avoid getting 0.999999999999999 when dealing
* with numbers that are really 1 or 0.
* @param {TRadian} angle the angle
* @return {Number} the sin value for angle.
*/ const $9a54cbcfc1af41ba$var$sin = (angle)=>{
    if (angle === 0) return 0;
    const angleSlice = angle / $9a54cbcfc1af41ba$var$halfPI;
    const value = Math.sign(angle);
    switch(angleSlice){
        case 1:
            return value;
        case 2:
            return 0;
        case 3:
            return -value;
    }
    return Math.sin(angle);
};
//#endregion
//#region src/Point.ts
/**
* Adaptation of work of Kevin Lindsey(kevin@kevlindev.com)
*/ var $9a54cbcfc1af41ba$export$baf26146a414f24a = class Point {
    constructor(arg0 = 0, y = 0){
        if (typeof arg0 === "object") {
            this.x = arg0.x;
            this.y = arg0.y;
        } else {
            this.x = arg0;
            this.y = y;
        }
    }
    /**
	* Adds another point to this one and returns a new one with the sum
	* @param {XY} that
	* @return {Point} new Point instance with added values
	*/ add(that) {
        return new Point(this.x + that.x, this.y + that.y);
    }
    /**
	* Adds another point to this one
	* @param {XY} that
	* @return {Point} thisArg
	* @deprecated
	*/ addEquals(that) {
        this.x += that.x;
        this.y += that.y;
        return this;
    }
    /**
	* Adds value to this point and returns a new one
	* @param {Number} scalar
	* @return {Point} new Point with added value
	*/ scalarAdd(scalar) {
        return new Point(this.x + scalar, this.y + scalar);
    }
    /**
	* Adds value to this point
	* @param {Number} scalar
	* @return {Point} thisArg
	* @deprecated
	*/ scalarAddEquals(scalar) {
        this.x += scalar;
        this.y += scalar;
        return this;
    }
    /**
	* Subtracts another point from this point and returns a new one
	* @param {XY} that
	* @return {Point} new Point object with subtracted values
	*/ subtract(that) {
        return new Point(this.x - that.x, this.y - that.y);
    }
    /**
	* Subtracts another point from this point
	* @param {XY} that
	* @return {Point} thisArg
	* @deprecated
	*/ subtractEquals(that) {
        this.x -= that.x;
        this.y -= that.y;
        return this;
    }
    /**
	* Subtracts value from this point and returns a new one
	* @param {Number} scalar
	* @return {Point}
	*/ scalarSubtract(scalar) {
        return new Point(this.x - scalar, this.y - scalar);
    }
    /**
	* Subtracts value from this point
	* @param {Number} scalar
	* @return {Point} thisArg
	* @deprecated
	*/ scalarSubtractEquals(scalar) {
        this.x -= scalar;
        this.y -= scalar;
        return this;
    }
    /**
	* Multiplies this point by another value and returns a new one
	* @param {XY} that
	* @return {Point}
	*/ multiply(that) {
        return new Point(this.x * that.x, this.y * that.y);
    }
    /**
	* Multiplies this point by a value and returns a new one
	* @param {Number} scalar
	* @return {Point}
	*/ scalarMultiply(scalar) {
        return new Point(this.x * scalar, this.y * scalar);
    }
    /**
	* Multiplies this point by a value
	* @param {Number} scalar
	* @return {Point} thisArg
	* @deprecated
	*/ scalarMultiplyEquals(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	* Divides this point by another and returns a new one
	* @param {XY} that
	* @return {Point}
	*/ divide(that) {
        return new Point(this.x / that.x, this.y / that.y);
    }
    /**
	* Divides this point by a value and returns a new one
	* @param {Number} scalar
	* @return {Point}
	*/ scalarDivide(scalar) {
        return new Point(this.x / scalar, this.y / scalar);
    }
    /**
	* Divides this point by a value
	* @param {Number} scalar
	* @return {Point} thisArg
	* @deprecated
	*/ scalarDivideEquals(scalar) {
        this.x /= scalar;
        this.y /= scalar;
        return this;
    }
    /**
	* Returns true if this point is equal to another one
	* @param {XY} that
	* @return {Boolean}
	*/ eq(that) {
        return this.x === that.x && this.y === that.y;
    }
    /**
	* Returns true if this point is less than another one
	* @param {XY} that
	* @return {Boolean}
	*/ lt(that) {
        return this.x < that.x && this.y < that.y;
    }
    /**
	* Returns true if this point is less than or equal to another one
	* @param {XY} that
	* @return {Boolean}
	*/ lte(that) {
        return this.x <= that.x && this.y <= that.y;
    }
    /**
	
	* Returns true if this point is greater another one
	* @param {XY} that
	* @return {Boolean}
	*/ gt(that) {
        return this.x > that.x && this.y > that.y;
    }
    /**
	* Returns true if this point is greater than or equal to another one
	* @param {XY} that
	* @return {Boolean}
	*/ gte(that) {
        return this.x >= that.x && this.y >= that.y;
    }
    /**
	* Returns new point which is the result of linear interpolation with this one and another one
	* @param {XY} that
	* @param {Number} t , position of interpolation, between 0 and 1 default 0.5
	* @return {Point}
	*/ lerp(that, t = .5) {
        t = Math.max(Math.min(1, t), 0);
        return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    }
    /**
	* Returns distance from this point and another one
	* @param {XY} that
	* @return {Number}
	*/ distanceFrom(that) {
        const dx = this.x - that.x, dy = this.y - that.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
	* Returns the point between this point and another one
	* @param {XY} that
	* @return {Point}
	*/ midPointFrom(that) {
        return this.lerp(that);
    }
    /**
	* Returns a new point which is the min of this and another one
	* @param {XY} that
	* @return {Point}
	*/ min(that) {
        return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
    }
    /**
	* Returns a new point which is the max of this and another one
	* @param {XY} that
	* @return {Point}
	*/ max(that) {
        return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
    }
    /**
	* Returns string representation of this point
	* @return {String}
	*/ toString() {
        return `${this.x},${this.y}`;
    }
    /**
	* Sets x/y of this point
	* @param {Number} x
	* @param {Number} y
	*/ setXY(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	* Sets x of this point
	* @param {Number} x
	*/ setX(x) {
        this.x = x;
        return this;
    }
    /**
	* Sets y of this point
	* @param {Number} y
	*/ setY(y) {
        this.y = y;
        return this;
    }
    /**
	* Sets x/y of this point from another point
	* @param {XY} that
	*/ setFromPoint(that) {
        this.x = that.x;
        this.y = that.y;
        return this;
    }
    /**
	* Swaps x/y of this point and another point
	* @param {XY} that
	*/ swap(that) {
        const x = this.x, y = this.y;
        this.x = that.x;
        this.y = that.y;
        that.x = x;
        that.y = y;
    }
    /**
	* return a cloned instance of the point
	* @return {Point}
	*/ clone() {
        return new Point(this.x, this.y);
    }
    /**
	* Rotates `point` around `origin` with `radians`
	* @param {XY} origin The origin of the rotation
	* @param {TRadian} radians The radians of the angle for the rotation
	* @return {Point} The new rotated point
	*/ rotate(radians, origin = $9a54cbcfc1af41ba$var$ZERO) {
        const sinus = $9a54cbcfc1af41ba$var$sin(radians), cosinus = $9a54cbcfc1af41ba$var$cos(radians);
        const p = this.subtract(origin);
        return new Point(p.x * cosinus - p.y * sinus, p.x * sinus + p.y * cosinus).add(origin);
    }
    /**
	* Apply transform t to point p
	* @param  {TMat2D} t The transform
	* @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
	* @return {Point} The transformed point
	*/ transform(t, ignoreOffset = false) {
        return new Point(t[0] * this.x + t[2] * this.y + (ignoreOffset ? 0 : t[4]), t[1] * this.x + t[3] * this.y + (ignoreOffset ? 0 : t[5]));
    }
};
const $9a54cbcfc1af41ba$var$ZERO = new $9a54cbcfc1af41ba$export$baf26146a414f24a(0, 0);
//#endregion
//#region src/Collection.ts
const $9a54cbcfc1af41ba$var$isCollection = (fabricObject)=>{
    return !!fabricObject && Array.isArray(fabricObject._objects);
};
function $9a54cbcfc1af41ba$export$f589b6d5b7ad4722(Base) {
    class Collection extends Base {
        constructor(..._args){
            super(..._args);
            $9a54cbcfc1af41ba$var$_defineProperty(this, /**
				* @type {FabricObject[]}
				* @TODO needs to end up in the constructor too
				*/ "_objects", []);
        }
        _onObjectAdded(object) {}
        _onObjectRemoved(object) {}
        _onStackOrderChanged(object) {}
        /**
		* Adds objects to collection
		* Objects should be instances of (or inherit from) FabricObject
		* @param {...FabricObject[]} objects to add
		* @returns {number} new array length
		*/ add(...objects) {
            const size = this._objects.push(...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return size;
        }
        /**
		* Inserts an object into collection at specified index
		* @param {number} index Index to insert object at
		* @param {...FabricObject[]} objects Object(s) to insert
		* @returns {number} new array length
		*/ insertAt(index, ...objects) {
            this._objects.splice(index, 0, ...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return this._objects.length;
        }
        /**
		* Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
		* @private
		* @param {...FabricObject[]} objects objects to remove
		* @returns {FabricObject[]} removed objects
		*/ remove(...objects) {
            const array = this._objects, removed = [];
            objects.forEach((object)=>{
                const index = array.indexOf(object);
                if (index !== -1) {
                    array.splice(index, 1);
                    removed.push(object);
                    this._onObjectRemoved(object);
                }
            });
            return removed;
        }
        /**
		* Executes given function for each object in this group
		* A simple shortcut for getObjects().forEach, before es6 was more complicated,
		* now is just a shortcut.
		* @param {Function} callback
		*                   Callback invoked with current object as first argument,
		*                   index - as second and an array of all objects - as third.
		*/ forEachObject(callback) {
            this.getObjects().forEach((object, index, objects)=>callback(object, index, objects));
        }
        /**
		* Returns an array of children objects of this instance
		* @param {...String} [types] When specified, only objects of these types are returned
		* @return {Array}
		*/ getObjects(...types) {
            if (types.length === 0) return [
                ...this._objects
            ];
            return this._objects.filter((o)=>o.isType(...types));
        }
        /**
		* Returns object at specified index
		* @param {Number} index
		* @return {Object} object at index
		*/ item(index) {
            return this._objects[index];
        }
        /**
		* Returns true if collection contains no objects
		* @return {Boolean} true if collection is empty
		*/ isEmpty() {
            return this._objects.length === 0;
        }
        /**
		* Returns a size of a collection (i.e: length of an array containing its objects)
		* @return {Number} Collection size
		*/ size() {
            return this._objects.length;
        }
        /**
		* Returns true if collection contains an object.\
		* **Prefer using {@link FabricObject#isDescendantOf} for performance reasons**
		* instead of `a.contains(b)` use `b.isDescendantOf(a)`
		* @param {Object} object Object to check against
		* @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
		* @return {Boolean} `true` if collection contains an object
		*/ contains(object, deep) {
            if (this._objects.includes(object)) return true;
            else if (deep) return this._objects.some((obj)=>obj instanceof Collection && obj.contains(object, true));
            return false;
        }
        /**
		* Returns number representation of a collection complexity
		* @return {Number} complexity
		*/ complexity() {
            return this._objects.reduce((memo, current)=>{
                memo += current.complexity ? current.complexity() : 0;
                return memo;
            }, 0);
        }
        /**
		* Moves an object or the objects of a multiple selection
		* to the bottom of the stack of drawn objects
		* @param {fabric.Object} object Object to send to back
		* @returns {boolean} true if change occurred
		*/ sendObjectToBack(object) {
            if (!object || object === this._objects[0]) return false;
            $9a54cbcfc1af41ba$var$removeFromArray(this._objects, object);
            this._objects.unshift(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
		* Moves an object or the objects of a multiple selection
		* to the top of the stack of drawn objects
		* @param {fabric.Object} object Object to send
		* @returns {boolean} true if change occurred
		*/ bringObjectToFront(object) {
            if (!object || object === this._objects[this._objects.length - 1]) return false;
            $9a54cbcfc1af41ba$var$removeFromArray(this._objects, object);
            this._objects.push(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
		* Moves an object or a selection down in stack of drawn objects
		* An optional parameter, `intersecting` allows to move the object in behind
		* the first intersecting object. Where intersection is calculated with
		* bounding box. If no intersection is found, there will not be change in the
		* stack.
		* @param {fabric.Object} object Object to send
		* @param {boolean} [intersecting] If `true`, send object behind next lower intersecting object
		* @returns {boolean} true if change occurred
		*/ sendObjectBackwards(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== 0) {
                const newIdx = this.findNewLowerIndex(object, idx, intersecting);
                $9a54cbcfc1af41ba$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
		* Moves an object or a selection up in stack of drawn objects
		* An optional parameter, intersecting allows to move the object in front
		* of the first intersecting object. Where intersection is calculated with
		* bounding box. If no intersection is found, there will not be change in the
		* stack.
		* @param {fabric.Object} object Object to send
		* @param {boolean} [intersecting] If `true`, send object in front of next upper intersecting object
		* @returns {boolean} true if change occurred
		*/ bringObjectForward(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== this._objects.length - 1) {
                const newIdx = this.findNewUpperIndex(object, idx, intersecting);
                $9a54cbcfc1af41ba$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
		* Moves an object to specified level in stack of drawn objects
		* @param {fabric.Object} object Object to send
		* @param {number} index Position to move to
		* @returns {boolean} true if change occurred
		*/ moveObjectTo(object, index) {
            if (object === this._objects[index]) return false;
            $9a54cbcfc1af41ba$var$removeFromArray(this._objects, object);
            this._objects.splice(index, 0, object);
            this._onStackOrderChanged(object);
            return true;
        }
        findNewLowerIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                for(let i = idx - 1; i >= 0; --i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx - 1;
            return newIdx;
        }
        findNewUpperIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                for(let i = idx + 1; i < this._objects.length; ++i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx + 1;
            return newIdx;
        }
        /**
		* Given a bounding box, return all the objects of the collection that are contained in the bounding box.
		* If `includeIntersecting` is true, return also the objects that intersect the bounding box as well.
		* This is meant to work with selection. Is not a generic method.
		* @param {TBBox} bbox a bounding box in scene coordinates
		* @param {{ includeIntersecting?: boolean }} options an object with includeIntersecting
		* @returns array of objects contained in the bounding box, ordered from top to bottom stacking wise
		*/ collectObjects({ left: left, top: top, width: width, height: height }, { includeIntersecting: includeIntersecting = true } = {}) {
            const objects = [], tl = new $9a54cbcfc1af41ba$export$baf26146a414f24a(left, top), br = tl.add(new $9a54cbcfc1af41ba$export$baf26146a414f24a(width, height));
            for(let i = this._objects.length - 1; i >= 0; i--){
                const object = this._objects[i];
                if (object.selectable && object.visible && (includeIntersecting && object.intersectsWithRect(tl, br) || object.isContainedWithinRect(tl, br) || includeIntersecting && object.containsPoint(tl) || includeIntersecting && object.containsPoint(br))) objects.push(object);
            }
            return objects;
        }
    }
    return Collection;
}
//#endregion
//#region src/CommonMethods.ts
var $9a54cbcfc1af41ba$var$CommonMethods = class extends $9a54cbcfc1af41ba$export$77cea355fa80b5f4 {
    /**
	* Sets object's properties from options, for initialization only
	* @protected
	* @param {Object} [options] Options object
	*/ _setOptions(options = {}) {
        for(const prop in options)this.set(prop, options[prop]);
    }
    /**
	* @private
	*/ _setObject(obj) {
        for(const prop in obj)this._set(prop, obj[prop]);
    }
    /**
	* Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
	* @param {String|Object} key Property name or object (if object, iterate over the object properties)
	* @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
	*/ set(key, value) {
        if (typeof key === "object") this._setObject(key);
        else this._set(key, value);
        return this;
    }
    _set(key, value) {
        this[key] = value;
    }
    /**
	* Toggles specified property from `true` to `false` or from `false` to `true`
	* @param {String} property Property to toggle
	*/ toggle(property) {
        const value = this.get(property);
        if (typeof value === "boolean") this.set(property, !value);
        return this;
    }
    /**
	* Basic getter
	* @param {String} property Property name
	* @return {*} value of a property
	*/ get(property) {
        return this[property];
    }
};
//#endregion
//#region src/util/animation/AnimationFrameProvider.ts
function $9a54cbcfc1af41ba$var$requestAnimFrame(callback) {
    return $9a54cbcfc1af41ba$export$4a3a3142573970c3().requestAnimationFrame(callback);
}
function $9a54cbcfc1af41ba$var$cancelAnimFrame(handle) {
    return $9a54cbcfc1af41ba$export$4a3a3142573970c3().cancelAnimationFrame(handle);
}
//#endregion
//#region src/util/internals/uid.ts
let $9a54cbcfc1af41ba$var$id = 0;
const $9a54cbcfc1af41ba$var$uid = ()=>$9a54cbcfc1af41ba$var$id++;
//#endregion
//#region src/util/misc/dom.ts
/**
* Creates canvas element
* @return {CanvasElement} initialized canvas element
*/ const $9a54cbcfc1af41ba$var$createCanvasElement = ()=>{
    const element = $9a54cbcfc1af41ba$export$91e93c41e950ddbb().createElement("canvas");
    if (!element || typeof element.getContext === "undefined") throw new $9a54cbcfc1af41ba$var$FabricError("Failed to create `canvas` element");
    return element;
};
/**
* Creates image element (works on client and node)
* @return {HTMLImageElement} HTML image element
*/ const $9a54cbcfc1af41ba$var$createImage = ()=>$9a54cbcfc1af41ba$export$91e93c41e950ddbb().createElement("img");
/**
* Creates a canvas element that is a copy of another and is also painted
* @param {CanvasElement} canvas to copy size and content of
* @return {CanvasElement} initialized canvas element
*/ const $9a54cbcfc1af41ba$var$copyCanvasElement = (canvas)=>{
    var _newCanvas$getContext;
    const newCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor(canvas);
    (_newCanvas$getContext = newCanvas.getContext("2d")) === null || _newCanvas$getContext === void 0 || _newCanvas$getContext.drawImage(canvas, 0, 0);
    return newCanvas;
};
/**
* Creates a canvas element as big as another
* @param {CanvasElement} canvas to copy size and content of
* @return {CanvasElement} initialized canvas element
*/ const $9a54cbcfc1af41ba$var$createCanvasElementFor = (canvas)=>{
    const newCanvas = $9a54cbcfc1af41ba$var$createCanvasElement();
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    return newCanvas;
};
/**
* since 2.6.0 moved from canvas instance to utility.
* possibly useless
* @param {CanvasElement} canvasEl to copy size and content of
* @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
* @param {number} quality <= 1 and > 0
* @return {String} data url
*/ const $9a54cbcfc1af41ba$var$toDataURL = (canvasEl, format, quality)=>canvasEl.toDataURL(`image/${format}`, quality);
const $9a54cbcfc1af41ba$var$isHTMLCanvas = (canvas)=>{
    return !!canvas && canvas.getContext !== void 0;
};
const $9a54cbcfc1af41ba$var$toBlob = (canvasEl, format, quality)=>new Promise((resolve, _)=>{
        canvasEl.toBlob(resolve, `image/${format}`, quality);
    });
//#endregion
//#region src/util/misc/radiansDegreesConversion.ts
/**
* Transforms degrees to radians.
* @param {TDegree} degrees value in degrees
* @return {TRadian} value in radians
*/ const $9a54cbcfc1af41ba$var$degreesToRadians = (degrees)=>degrees * $9a54cbcfc1af41ba$var$PiBy180;
/**
* Transforms radians to degrees.
* @param {TRadian} radians value in radians
* @return {TDegree} value in degrees
*/ const $9a54cbcfc1af41ba$var$radiansToDegrees = (radians)=>radians / $9a54cbcfc1af41ba$var$PiBy180;
//#endregion
//#region src/util/misc/matrix.ts
const $9a54cbcfc1af41ba$var$isIdentityMatrix = (mat)=>mat.every((value, index)=>value === $9a54cbcfc1af41ba$export$3c5a7f9475b116e0[index]);
/**
* Apply transform t to point p
* @deprecated use {@link Point#transform}
* @param  {Point | XY} p The point to transform
* @param  {Array} t The transform
* @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
* @return {Point} The transformed point
*/ const $9a54cbcfc1af41ba$var$transformPoint = (p, t, ignoreOffset)=>new $9a54cbcfc1af41ba$export$baf26146a414f24a(p).transform(t, ignoreOffset);
/**
* Invert transformation t
* @param {Array} t The transform
* @return {Array} The inverted transform
*/ const $9a54cbcfc1af41ba$var$invertTransform = (t)=>{
    const a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [
        a * t[3],
        -a * t[1],
        -a * t[2],
        a * t[0],
        0,
        0
    ], { x: x, y: y } = new $9a54cbcfc1af41ba$export$baf26146a414f24a(t[4], t[5]).transform(r, true);
    r[4] = -x;
    r[5] = -y;
    return r;
};
/**
* Multiply matrix A by matrix B to nest transformations
* @param  {TMat2D} a First transformMatrix
* @param  {TMat2D} b Second transformMatrix
* @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
* @return {TMat2D} The product of the two transform matrices
*/ const $9a54cbcfc1af41ba$var$multiplyTransformMatrices = (a, b, is2x2)=>[
        a[0] * b[0] + a[2] * b[1],
        a[1] * b[0] + a[3] * b[1],
        a[0] * b[2] + a[2] * b[3],
        a[1] * b[2] + a[3] * b[3],
        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
    ];
/**
* Multiplies the matrices array such that a matrix defines the plane for the rest of the matrices **after** it
*
* `multiplyTransformMatrixArray([A, B, C, D])` is equivalent to `A(B(C(D)))`
*
* @param matrices an array of matrices
* @param [is2x2] flag to multiply matrices as 2x2 matrices
* @returns the multiplication product
*/ const $9a54cbcfc1af41ba$var$multiplyTransformMatrixArray = (matrices, is2x2)=>matrices.reduceRight((product, curr)=>curr && product ? $9a54cbcfc1af41ba$var$multiplyTransformMatrices(curr, product, is2x2) : curr || product, void 0) || $9a54cbcfc1af41ba$export$3c5a7f9475b116e0.concat();
const $9a54cbcfc1af41ba$var$calcPlaneRotation = ([a, b])=>Math.atan2(b, a);
/**
* Decomposes standard 2x3 matrix into transform components
* @param  {TMat2D} a transformMatrix
* @return {Object} Components of transform
*/ const $9a54cbcfc1af41ba$var$qrDecompose = (a)=>{
    const angle = $9a54cbcfc1af41ba$var$calcPlaneRotation(a), denom = Math.pow(a[0], 2) + Math.pow(a[1], 2), scaleX = Math.sqrt(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = Math.atan2(a[0] * a[2] + a[1] * a[3], denom);
    return {
        angle: $9a54cbcfc1af41ba$var$radiansToDegrees(angle),
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: $9a54cbcfc1af41ba$var$radiansToDegrees(skewX),
        skewY: 0,
        translateX: a[4] || 0,
        translateY: a[5] || 0
    };
};
/**
* Generate a translation matrix
*
* A translation matrix in the form of
* [ 1 0 x ]
* [ 0 1 y ]
* [ 0 0 1 ]
*
* See {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#translate} for more details
*
* @param {number} x translation on X axis
* @param {number} [y] translation on Y axis
* @returns {TMat2D} matrix
*/ const $9a54cbcfc1af41ba$var$createTranslateMatrix = (x, y = 0)=>[
        1,
        0,
        0,
        1,
        x,
        y
    ];
/**
* Generate a rotation matrix around around a point (x,y), defaulting to (0,0)
*
* A matrix in the form of
* [cos(a) -sin(a) -x*cos(a)+y*sin(a)+x]
* [sin(a)  cos(a) -x*sin(a)-y*cos(a)+y]
* [0       0      1                 ]
*
*
* @param {TDegree} angle rotation in degrees
* @param {XY} [pivotPoint] pivot point to rotate around
* @returns {TMat2D} matrix
*/ function $9a54cbcfc1af41ba$var$createRotateMatrix({ angle: angle = 0 } = {}, { x: x = 0, y: y = 0 } = {}) {
    const angleRadiant = $9a54cbcfc1af41ba$var$degreesToRadians(angle), cosValue = $9a54cbcfc1af41ba$var$cos(angleRadiant), sinValue = $9a54cbcfc1af41ba$var$sin(angleRadiant);
    return [
        cosValue,
        sinValue,
        -sinValue,
        cosValue,
        x ? x - (cosValue * x - sinValue * y) : 0,
        y ? y - (sinValue * x + cosValue * y) : 0
    ];
}
/**
* Generate a scale matrix around the point (0,0)
*
* A matrix in the form of
* [x 0 0]
* [0 y 0]
* [0 0 1]
*
* {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#scale}
*
* @param {number} x scale on X axis
* @param {number} [y] scale on Y axis
* @returns {TMat2D} matrix
*/ const $9a54cbcfc1af41ba$var$createScaleMatrix = (x, y = x)=>[
        x,
        0,
        0,
        y,
        0,
        0
    ];
const $9a54cbcfc1af41ba$var$angleToSkew = (angle)=>Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(angle));
/**
* Generate a skew matrix for the X axis
*
* A matrix in the form of
* [1 x 0]
* [0 1 0]
* [0 0 1]
*
* {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewx}
*
* @param {TDegree} skewValue translation on X axis
* @returns {TMat2D} matrix
*/ const $9a54cbcfc1af41ba$var$createSkewXMatrix = (skewValue)=>[
        1,
        0,
        $9a54cbcfc1af41ba$var$angleToSkew(skewValue),
        1,
        0,
        0
    ];
/**
* Generate a skew matrix for the Y axis
*
* A matrix in the form of
* [1 0 0]
* [y 1 0]
* [0 0 1]
*
* {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewy}
*
* @param {TDegree} skewValue translation on Y axis
* @returns {TMat2D} matrix
*/ const $9a54cbcfc1af41ba$var$createSkewYMatrix = (skewValue)=>[
        1,
        $9a54cbcfc1af41ba$var$angleToSkew(skewValue),
        0,
        1,
        0,
        0
    ];
/**
* Returns a transform matrix starting from an object of the same kind of
* the one returned from qrDecompose, useful also if you want to calculate some
* transformations from an object that is not enlived yet.
* is called DimensionsTransformMatrix because those properties are the one that influence
* the size of the resulting box of the object.
* @param  {Object} options
* @param  {Number} [options.scaleX]
* @param  {Number} [options.scaleY]
* @param  {Boolean} [options.flipX]
* @param  {Boolean} [options.flipY]
* @param  {Number} [options.skewX]
* @param  {Number} [options.skewY]
* @return {Number[]} transform matrix
*/ const $9a54cbcfc1af41ba$var$calcDimensionsMatrix = ({ scaleX: scaleX = 1, scaleY: scaleY = 1, flipX: flipX = false, flipY: flipY = false, skewX: skewX = 0, skewY: skewY = 0 })=>{
    let matrix = $9a54cbcfc1af41ba$var$createScaleMatrix(flipX ? -scaleX : scaleX, flipY ? -scaleY : scaleY);
    if (skewX) matrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(matrix, $9a54cbcfc1af41ba$var$createSkewXMatrix(skewX), true);
    if (skewY) matrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(matrix, $9a54cbcfc1af41ba$var$createSkewYMatrix(skewY), true);
    return matrix;
};
/**
* Returns a transform matrix starting from an object of the same kind of
* the one returned from qrDecompose, useful also if you want to calculate some
* transformations from an object that is not enlived yet
* Before changing this function look at: src/benchmarks/calcTransformMatrix.mjs
* @param  {Object} options
* @param  {Number} [options.angle]
* @param  {Number} [options.scaleX]
* @param  {Number} [options.scaleY]
* @param  {Boolean} [options.flipX]
* @param  {Boolean} [options.flipY]
* @param  {Number} [options.skewX]
* @param  {Number} [options.skewY]
* @param  {Number} [options.translateX]
* @param  {Number} [options.translateY]
* @return {Number[]} transform matrix
*/ const $9a54cbcfc1af41ba$var$composeMatrix = (options)=>{
    const { translateX: translateX = 0, translateY: translateY = 0, angle: angle = 0 } = options;
    let matrix = $9a54cbcfc1af41ba$var$createTranslateMatrix(translateX, translateY);
    if (angle) matrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(matrix, $9a54cbcfc1af41ba$var$createRotateMatrix({
        angle: angle
    }));
    const scaleMatrix = $9a54cbcfc1af41ba$var$calcDimensionsMatrix(options);
    if (!$9a54cbcfc1af41ba$var$isIdentityMatrix(scaleMatrix)) matrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(matrix, scaleMatrix);
    return matrix;
};
//#endregion
//#region src/util/misc/objectEnlive.ts
/**
* Loads image element from given url and resolve it, or catch.
* @param {String} url URL representing an image
* @param {LoadImageOptions} [options] image loading options
* @returns {Promise<HTMLImageElement>} the loaded image.
*/ const $9a54cbcfc1af41ba$var$loadImage = (url, { signal: signal, crossOrigin: crossOrigin = null } = {})=>new Promise(function(resolve, reject) {
        if (signal && signal.aborted) return reject(new $9a54cbcfc1af41ba$var$SignalAbortedError("loadImage"));
        const img = $9a54cbcfc1af41ba$var$createImage();
        let abort;
        if (signal) {
            abort = function(err) {
                img.src = "";
                reject(err);
            };
            signal.addEventListener("abort", abort, {
                once: true
            });
        }
        const done = function() {
            img.onload = img.onerror = null;
            abort && (signal === null || signal === void 0 || signal.removeEventListener("abort", abort));
            resolve(img);
        };
        if (!url) {
            done();
            return;
        }
        img.onload = done;
        img.onerror = function() {
            abort && (signal === null || signal === void 0 || signal.removeEventListener("abort", abort));
            reject(new $9a54cbcfc1af41ba$var$FabricError(`Error loading ${img.src}`));
        };
        crossOrigin && (img.crossOrigin = crossOrigin);
        img.src = url;
    });
/**
* @TODO type this correctly.
* Creates corresponding fabric instances from their object representations
* @param {Object[]} objects Objects to enliven
* @param {EnlivenObjectOptions} [options]
* @param {(serializedObj: object, instance: FabricObject) => any} [options.reviver] Method for further parsing of object elements,
* called after each fabric object created.
* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
* @returns {Promise<FabricObject[]>}
*/ const $9a54cbcfc1af41ba$var$enlivenObjects = (objects, { signal: signal, reviver: reviver = $9a54cbcfc1af41ba$var$noop } = {})=>new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener("abort", reject, {
            once: true
        });
        Promise.allSettled(objects.map((obj)=>$9a54cbcfc1af41ba$export$2792378e23a7920c.getClass(obj.type).fromObject(obj, {
                signal: signal
            }))).then(async (elementsResult)=>{
            for (const [index, result] of elementsResult.entries()){
                if (result.status === "fulfilled") {
                    await reviver(objects[index], result.value);
                    instances.push(result.value);
                }
                if (result.status === "rejected") {
                    const fallback = await reviver(objects[index], void 0, result.reason);
                    if (fallback) instances.push(fallback);
                }
            }
            resolve(instances);
        }).catch((error)=>{
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener("abort", reject);
        });
    });
/**
* Creates corresponding fabric instances residing in an object, e.g. `clipPath`
* @param {Object} object with properties to enlive ( fill, stroke, clipPath, path )
* @param {object} [options]
* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
* @returns {Promise<Record<string, FabricObject | TFiller | null>>} the input object with enlived values
*/ const $9a54cbcfc1af41ba$var$enlivenObjectEnlivables = (serializedObject, { signal: signal } = {})=>new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener("abort", reject, {
            once: true
        });
        const promises = Object.values(serializedObject).map((value)=>{
            if (!value) return value;
            /**
		* clipPath or shadow or gradient or text on a path or a pattern,
		* or the backgroundImage or overlayImage of canvas
		* If we have a type and there is a classe registered for it, we enlive it.
		* If there is no class registered for it we return the value as is
		* */ if (value.type && $9a54cbcfc1af41ba$export$2792378e23a7920c.has(value.type)) return $9a54cbcfc1af41ba$var$enlivenObjects([
                value
            ], {
                signal: signal
            }).then(([enlived])=>{
                instances.push(enlived);
                return enlived;
            });
            return value;
        });
        const keys = Object.keys(serializedObject);
        Promise.all(promises).then((enlived)=>{
            return enlived.reduce((acc, instance, index)=>{
                acc[keys[index]] = instance;
                return acc;
            }, {});
        }).then(resolve).catch((error)=>{
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener("abort", reject);
        });
    });
//#endregion
//#region src/util/misc/pick.ts
/**
* Populates an object with properties of another object
* @param {Object} source Source object
* @param {string[]} properties Properties names to include
* @returns object populated with the picked keys
*/ const $9a54cbcfc1af41ba$var$pick = (source, keys = [])=>{
    return keys.reduce((o, key)=>{
        if (key in source) o[key] = source[key];
        return o;
    }, {});
};
const $9a54cbcfc1af41ba$var$pickBy = (source, predicate)=>{
    return Object.keys(source).reduce((o, key)=>{
        if (predicate(source[key], key, source)) o[key] = source[key];
        return o;
    }, {});
};
//#endregion
//#region src/util/misc/toFixed.ts
/**
* A wrapper around Number#toFixed, which contrary to native method returns number, not string.
* @param {number|string} number number to operate on
* @param {number} fractionDigits number of fraction digits to "leave"
* @return {number}
*/ const $9a54cbcfc1af41ba$var$toFixed = (number, fractionDigits)=>parseFloat(Number(number).toFixed(fractionDigits));
//#endregion
//#region src/util/misc/svgExport.ts
/**
* given an array of 6 number returns something like `"matrix(...numbers)"`
* @param {TMat2D} transform an array with 6 numbers
* @return {String} transform matrix for svg
*/ const $9a54cbcfc1af41ba$var$matrixToSVG = (transform)=>"matrix(" + transform.map((value)=>$9a54cbcfc1af41ba$var$toFixed(value, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)).join(" ") + ")";
//#endregion
//#region src/util/typeAssertions.ts
const $9a54cbcfc1af41ba$var$isFiller = (filler)=>{
    return !!filler && filler.toLive !== void 0;
};
const $9a54cbcfc1af41ba$var$isSerializableFiller = (filler)=>{
    return !!filler && typeof filler.toObject === "function";
};
const $9a54cbcfc1af41ba$var$isPattern = (filler)=>{
    return !!filler && filler.offsetX !== void 0 && "source" in filler;
};
const $9a54cbcfc1af41ba$var$isTextObject = (fabricObject)=>{
    return !!fabricObject && typeof fabricObject._renderText === "function";
};
const $9a54cbcfc1af41ba$var$isPath = (fabricObject)=>{
    return !!fabricObject && typeof fabricObject._renderPathCommands === "function";
};
const $9a54cbcfc1af41ba$var$isActiveSelection = (fabricObject)=>!!fabricObject && "multiSelectionStacking" in fabricObject;
//#endregion
//#region src/util/dom_misc.ts
/**
* Returns element scroll offsets
* @param {HTMLElement} element Element to operate on
* @return {Object} Object with left/top values
*/ function $9a54cbcfc1af41ba$var$getScrollLeftTop(element) {
    const doc = element && $9a54cbcfc1af41ba$var$getDocumentFromElement(element);
    let left = 0, top = 0;
    if (!element || !doc) return {
        left: left,
        top: top
    };
    let elementLoop = element;
    const docElement = doc.documentElement, body = doc.body || {
        scrollLeft: 0,
        scrollTop: 0
    };
    while(elementLoop && (elementLoop.parentNode || elementLoop.host)){
        elementLoop = elementLoop.parentNode || elementLoop.host;
        if (elementLoop === doc) {
            left = body.scrollLeft || docElement.scrollLeft || 0;
            top = body.scrollTop || docElement.scrollTop || 0;
        } else {
            left += elementLoop.scrollLeft || 0;
            top += elementLoop.scrollTop || 0;
        }
        if (elementLoop.nodeType === 1 && elementLoop.style.position === "fixed") break;
    }
    return {
        left: left,
        top: top
    };
}
const $9a54cbcfc1af41ba$var$getDocumentFromElement = (el)=>el.ownerDocument || null;
const $9a54cbcfc1af41ba$var$getWindowFromElement = (el)=>{
    var _el$ownerDocument;
    return ((_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) || null;
};
//#endregion
//#region src/canvas/DOMManagers/util.ts
const $9a54cbcfc1af41ba$var$setCanvasDimensions = (el, ctx, { width: width, height: height }, retinaScaling = 1)=>{
    el.width = width;
    el.height = height;
    if (retinaScaling > 1) {
        el.setAttribute("width", (width * retinaScaling).toString());
        el.setAttribute("height", (height * retinaScaling).toString());
        ctx.scale(retinaScaling, retinaScaling);
    }
};
const $9a54cbcfc1af41ba$var$setCSSDimensions = (el, { width: width, height: height })=>{
    width && (el.style.width = typeof width === "number" ? `${width}px` : width);
    height && (el.style.height = typeof height === "number" ? `${height}px` : height);
};
/**
* Returns offset for a given element
* @param {HTMLElement} element Element to get offset for
* @return {Object} Object with "left" and "top" properties
*/ function $9a54cbcfc1af41ba$var$getElementOffset(element) {
    var _getWindowFromElement;
    const doc = element && $9a54cbcfc1af41ba$var$getDocumentFromElement(element), offset = {
        left: 0,
        top: 0
    };
    if (!doc) return offset;
    const elemStyle = ((_getWindowFromElement = $9a54cbcfc1af41ba$var$getWindowFromElement(element)) === null || _getWindowFromElement === void 0 ? void 0 : _getWindowFromElement.getComputedStyle(element, null)) || {};
    offset.left += parseInt(elemStyle.borderLeftWidth, 10) || 0;
    offset.top += parseInt(elemStyle.borderTopWidth, 10) || 0;
    offset.left += parseInt(elemStyle.paddingLeft, 10) || 0;
    offset.top += parseInt(elemStyle.paddingTop, 10) || 0;
    let box = {
        left: 0,
        top: 0
    };
    const docElem = doc.documentElement;
    if (typeof element.getBoundingClientRect !== "undefined") box = element.getBoundingClientRect();
    const scrollLeftTop = $9a54cbcfc1af41ba$var$getScrollLeftTop(element);
    return {
        left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
        top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
    };
}
/**
* Makes element unselectable
* @param {HTMLElement} element Element to make unselectable
* @return {HTMLElement} Element that was passed in
*/ function $9a54cbcfc1af41ba$var$makeElementUnselectable(element) {
    if (typeof element.onselectstart !== "undefined") element.onselectstart = ()=>false;
    element.style.userSelect = $9a54cbcfc1af41ba$var$NONE;
    return element;
}
//#endregion
//#region src/canvas/DOMManagers/StaticCanvasDOMManager.ts
var $9a54cbcfc1af41ba$export$cf489a44e232c033 = class {
    constructor(arg0){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_originalCanvasStyle", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "lower", void 0);
        const el = this.createLowerCanvas(arg0);
        this.lower = {
            el: el,
            ctx: el.getContext("2d")
        };
    }
    createLowerCanvas(arg0) {
        const el = $9a54cbcfc1af41ba$var$isHTMLCanvas(arg0) ? arg0 : arg0 && $9a54cbcfc1af41ba$export$91e93c41e950ddbb().getElementById(arg0) || $9a54cbcfc1af41ba$var$createCanvasElement();
        if (el.hasAttribute("data-fabric")) throw new $9a54cbcfc1af41ba$var$FabricError("Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?");
        this._originalCanvasStyle = el.style.cssText;
        el.setAttribute("data-fabric", "main");
        el.classList.add("lower-canvas");
        return el;
    }
    cleanupDOM({ width: width, height: height }) {
        const { el: el } = this.lower;
        el.classList.remove("lower-canvas");
        el.removeAttribute("data-fabric");
        el.setAttribute("width", `${width}`);
        el.setAttribute("height", `${height}`);
        el.style.cssText = this._originalCanvasStyle || "";
        this._originalCanvasStyle = void 0;
    }
    setDimensions(size, retinaScaling) {
        const { el: el, ctx: ctx } = this.lower;
        $9a54cbcfc1af41ba$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        $9a54cbcfc1af41ba$var$setCSSDimensions(this.lower.el, size);
    }
    /**
	* Calculates canvas element offset relative to the document
	*/ calcOffset() {
        return $9a54cbcfc1af41ba$var$getElementOffset(this.lower.el);
    }
    dispose() {
        $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().dispose(this.lower.el);
        delete this.lower;
    }
};
//#endregion
//#region src/canvas/StaticCanvasOptions.ts
const $9a54cbcfc1af41ba$var$staticCanvasDefaults = {
    backgroundVpt: true,
    backgroundColor: "",
    overlayVpt: true,
    overlayColor: "",
    includeDefaultValues: true,
    svgViewportTransformation: true,
    renderOnAddRemove: true,
    skipOffscreen: true,
    enableRetinaScaling: true,
    imageSmoothingEnabled: true,
    controlsAboveOverlay: false,
    allowTouchScrolling: false,
    viewportTransform: [
        ...$9a54cbcfc1af41ba$export$3c5a7f9475b116e0
    ],
    patternQuality: "best"
};
//#endregion
//#region src/util/lang_string.ts
var $9a54cbcfc1af41ba$var$lang_string_exports = /* @__PURE__ */ $9a54cbcfc1af41ba$var$__exportAll({
    capitalize: ()=>$9a54cbcfc1af41ba$var$capitalize,
    escapeXml: ()=>$9a54cbcfc1af41ba$var$escapeXml,
    graphemeSplit: ()=>$9a54cbcfc1af41ba$var$graphemeSplit
});
/**
* Capitalizes a string
* @param {String} string String to capitalize
* @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
* and other letters stay untouched, if false first letter is capitalized
* and other letters are converted to lowercase.
* @return {String} Capitalized version of a string
*/ const $9a54cbcfc1af41ba$var$capitalize = (string, firstLetterOnly = false)=>`${string.charAt(0).toUpperCase()}${firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase()}`;
/**
* Escapes XML in a string
* @param {String} string String to escape
* @return {String} Escaped version of a string
*/ const $9a54cbcfc1af41ba$var$escapeXml = (stringOrNumber)=>stringOrNumber.toString().replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
let $9a54cbcfc1af41ba$var$segmenter;
const $9a54cbcfc1af41ba$var$getSegmenter = ()=>{
    if (!$9a54cbcfc1af41ba$var$segmenter) $9a54cbcfc1af41ba$var$segmenter = "Intl" in $9a54cbcfc1af41ba$export$4a3a3142573970c3() && "Segmenter" in Intl && new Intl.Segmenter(void 0, {
        granularity: "grapheme"
    });
    return $9a54cbcfc1af41ba$var$segmenter;
};
/**
* Divide a string in the user perceived single units
* @param {String} textstring String to escape
* @return {Array} array containing the graphemes
*/ const $9a54cbcfc1af41ba$var$graphemeSplit = (textstring)=>{
    $9a54cbcfc1af41ba$var$segmenter || $9a54cbcfc1af41ba$var$getSegmenter();
    if ($9a54cbcfc1af41ba$var$segmenter) {
        const segments = $9a54cbcfc1af41ba$var$segmenter.segment(textstring);
        return Array.from(segments).map(({ segment: segment })=>segment);
    }
    return $9a54cbcfc1af41ba$var$graphemeSplitImpl(textstring);
};
const $9a54cbcfc1af41ba$var$graphemeSplitImpl = (textstring)=>{
    const graphemes = [];
    for(let i = 0, chr; i < textstring.length; i++){
        if ((chr = $9a54cbcfc1af41ba$var$getWholeChar(textstring, i)) === false) continue;
        graphemes.push(chr);
    }
    return graphemes;
};
const $9a54cbcfc1af41ba$var$getWholeChar = (str, i)=>{
    const code = str.charCodeAt(i);
    if (isNaN(code)) return "";
    if (code < 55296 || code > 57343) return str.charAt(i);
    if (55296 <= code && code <= 56319) {
        if (str.length <= i + 1) throw "High surrogate without following low surrogate";
        const next = str.charCodeAt(i + 1);
        if (56320 > next || next > 57343) throw "High surrogate without following low surrogate";
        return str.charAt(i) + str.charAt(i + 1);
    }
    if (i === 0) throw "Low surrogate without preceding high surrogate";
    const prev = str.charCodeAt(i - 1);
    if (55296 > prev || prev > 56319) throw "Low surrogate without preceding high surrogate";
    return false;
};
//#endregion
//#region src/canvas/StaticCanvas.ts
/**
* Static canvas class
* @see {@link http://fabric5.fabricjs.com/static_canvas|StaticCanvas demo}
* @fires before:render
* @fires after:render
* @fires canvas:cleared
* @fires object:added
* @fires object:removed
*/ var $9a54cbcfc1af41ba$export$ad01921fb0b1386e = class StaticCanvas extends $9a54cbcfc1af41ba$export$f589b6d5b7ad4722($9a54cbcfc1af41ba$var$CommonMethods) {
    /**
	* A reference to the canvas actual HTMLCanvasElement.
	* Can be use to read the raw pixels, but never write or manipulate
	* @type HTMLCanvasElement
	*/ get lowerCanvasEl() {
        var _this$elements$lower;
        return (_this$elements$lower = this.elements.lower) === null || _this$elements$lower === void 0 ? void 0 : _this$elements$lower.el;
    }
    get contextContainer() {
        var _this$elements$lower2;
        return (_this$elements$lower2 = this.elements.lower) === null || _this$elements$lower2 === void 0 ? void 0 : _this$elements$lower2.ctx;
    }
    static getDefaults() {
        return StaticCanvas.ownDefaults;
    }
    constructor(el, options = {}){
        super();
        Object.assign(this, this.constructor.getDefaults());
        this.set(options);
        this.initElements(el);
        this._setDimensionsImpl({
            width: this.width || this.elements.lower.el.width || 0,
            height: this.height || this.elements.lower.el.height || 0
        });
        this.skipControlsDrawing = false;
        this.viewportTransform = [
            ...this.viewportTransform
        ];
        this.calcViewportBoundaries();
    }
    initElements(el) {
        this.elements = new $9a54cbcfc1af41ba$export$cf489a44e232c033(el);
    }
    add(...objects) {
        const size = super.add(...objects);
        objects.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    insertAt(index, ...objects) {
        const size = super.insertAt(index, ...objects);
        objects.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    remove(...objects) {
        const removed = super.remove(...objects);
        removed.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return removed;
    }
    _onObjectAdded(obj) {
        if (obj.canvas && obj.canvas !== this) {
            $9a54cbcfc1af41ba$var$log("warn", "Canvas is trying to add an object that belongs to a different canvas.\nResulting to default behavior: removing object from previous canvas and adding to new canvas");
            obj.canvas.remove(obj);
        }
        obj._set("canvas", this);
        obj.setCoords();
        this.fire("object:added", {
            target: obj
        });
        obj.fire("added", {
            target: this
        });
    }
    _onObjectRemoved(obj) {
        obj._set("canvas", void 0);
        this.fire("object:removed", {
            target: obj
        });
        obj.fire("removed", {
            target: this
        });
    }
    _onStackOrderChanged() {
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
	* @private
	* @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
	* @return {Number} retinaScaling if applied, otherwise 1;
	*/ getRetinaScaling() {
        return this.enableRetinaScaling ? $9a54cbcfc1af41ba$var$getDevicePixelRatio() : 1;
    }
    /**
	* Calculates canvas element offset relative to the document
	* This method is also attached as "resize" event handler of window
	*/ calcOffset() {
        return this._offset = this.elements.calcOffset();
    }
    /**
	* Returns canvas width (in px)
	* @return {Number}
	*/ getWidth() {
        return this.width;
    }
    /**
	* Returns canvas height (in px)
	* @return {Number}
	*/ getHeight() {
        return this.height;
    }
    /**
	* Internal use only
	* @protected
	*/ _setDimensionsImpl(dimensions, { cssOnly: cssOnly = false, backstoreOnly: backstoreOnly = false } = {}) {
        if (!cssOnly) {
            const size = {
                width: this.width,
                height: this.height,
                ...dimensions
            };
            this.elements.setDimensions(size, this.getRetinaScaling());
            this.hasLostContext = true;
            this.width = size.width;
            this.height = size.height;
        }
        if (!backstoreOnly) this.elements.setCSSDimensions(dimensions);
        this.calcOffset();
    }
    setDimensions(dimensions, options) {
        this._setDimensionsImpl(dimensions, options);
        if (!options || !options.cssOnly) this.requestRenderAll();
    }
    /**
	* Returns canvas zoom level
	* @return {Number}
	*/ getZoom() {
        return this.viewportTransform[0];
    }
    /**
	* Sets viewport transformation of this canvas instance
	* @param {Array} vpt a Canvas 2D API transform matrix
	*/ setViewportTransform(vpt) {
        this.viewportTransform = vpt;
        this.calcViewportBoundaries();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
	* Sets zoom level of this canvas instance, the zoom centered around point
	* meaning that following zoom to point with the same point will have the visual
	* effect of the zoom originating from that point. The point won't move.
	* It has nothing to do with canvas center or visual center of the viewport.
	* @param {Point} point to zoom with respect to
	* @param {Number} value to set zoom to, less than 1 zooms out
	*/ zoomToPoint(point, value) {
        const before = point, vpt = [
            ...this.viewportTransform
        ];
        const newPoint = $9a54cbcfc1af41ba$var$transformPoint(point, $9a54cbcfc1af41ba$var$invertTransform(vpt));
        vpt[0] = value;
        vpt[3] = value;
        const after = $9a54cbcfc1af41ba$var$transformPoint(newPoint, vpt);
        vpt[4] += before.x - after.x;
        vpt[5] += before.y - after.y;
        this.setViewportTransform(vpt);
    }
    /**
	* Sets zoom level of this canvas instance
	* @param {Number} value to set zoom to, less than 1 zooms out
	*/ setZoom(value) {
        this.zoomToPoint(new $9a54cbcfc1af41ba$export$baf26146a414f24a(0, 0), value);
    }
    /**
	* Pan viewport so as to place point at top left corner of canvas
	* @param {Point} point to move to
	*/ absolutePan(point) {
        const vpt = [
            ...this.viewportTransform
        ];
        vpt[4] = -point.x;
        vpt[5] = -point.y;
        return this.setViewportTransform(vpt);
    }
    /**
	* Pans viewpoint relatively
	* @param {Point} point (position vector) to move by
	*/ relativePan(point) {
        return this.absolutePan(new $9a54cbcfc1af41ba$export$baf26146a414f24a(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
    }
    /**
	* Returns &lt;canvas> element corresponding to this instance
	* @return {HTMLCanvasElement}
	*/ getElement() {
        return this.elements.lower.el;
    }
    /**
	* Clears specified context of canvas element
	* @param {CanvasRenderingContext2D} ctx Context to clear
	*/ clearContext(ctx) {
        ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
	* Returns context of canvas where objects are drawn
	* @return {CanvasRenderingContext2D}
	*/ getContext() {
        return this.elements.lower.ctx;
    }
    /**
	* Clears all contexts (background, main, top) of an instance
	*/ clear() {
        this.remove(...this.getObjects());
        this.backgroundImage = void 0;
        this.overlayImage = void 0;
        this.backgroundColor = "";
        this.overlayColor = "";
        this.clearContext(this.getContext());
        this.fire("canvas:cleared");
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
	* Renders the canvas
	*/ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        this.renderCanvas(this.getContext(), this._objects);
    }
    /**
	* Function created to be instance bound at initialization
	* used in requestAnimationFrame rendering
	* Let the fabricJS call it. If you call it manually you could have more
	* animationFrame stacking on to of each other
	* for an imperative rendering, use canvas.renderAll
	* @private
	*/ renderAndReset() {
        this.nextRenderHandle = 0;
        this.renderAll();
    }
    /**
	* Append a renderAll request to next animation frame.
	* unless one is already in progress, in that case nothing is done
	* a boolean flag will avoid appending more.
	*/ requestRenderAll() {
        if (!this.nextRenderHandle && !this.disposed && !this.destroyed) this.nextRenderHandle = $9a54cbcfc1af41ba$var$requestAnimFrame(()=>this.renderAndReset());
    }
    /**
	* Calculate the position of the 4 corner of canvas with current viewportTransform.
	* helps to determinate when an object is in the current rendering viewport
	*/ calcViewportBoundaries() {
        const width = this.width, height = this.height, iVpt = $9a54cbcfc1af41ba$var$invertTransform(this.viewportTransform), a = $9a54cbcfc1af41ba$var$transformPoint({
            x: 0,
            y: 0
        }, iVpt), b = $9a54cbcfc1af41ba$var$transformPoint({
            x: width,
            y: height
        }, iVpt), min = a.min(b), max = a.max(b);
        return this.vptCoords = {
            tl: min,
            tr: new $9a54cbcfc1af41ba$export$baf26146a414f24a(max.x, min.y),
            bl: new $9a54cbcfc1af41ba$export$baf26146a414f24a(min.x, max.y),
            br: max
        };
    }
    cancelRequestedRender() {
        if (this.nextRenderHandle) {
            $9a54cbcfc1af41ba$var$cancelAnimFrame(this.nextRenderHandle);
            this.nextRenderHandle = 0;
        }
    }
    drawControls(_ctx) {}
    /**
	* Renders background, objects, overlay and controls.
	* @param {CanvasRenderingContext2D} ctx
	* @param {Array} objects to render
	*/ renderCanvas(ctx, objects) {
        if (this.destroyed) return;
        const v = this.viewportTransform, path = this.clipPath;
        this.calcViewportBoundaries();
        this.clearContext(ctx);
        ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
        ctx.patternQuality = this.patternQuality;
        this.fire("before:render", {
            ctx: ctx
        });
        this._renderBackground(ctx);
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this._renderObjects(ctx, objects);
        ctx.restore();
        if (!this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        if (path) {
            path._set("canvas", this);
            path.shouldCache();
            path._transformDone = true;
            path.renderCache({
                forClipping: true
            });
            this.drawClipPathOnCanvas(ctx, path);
        }
        this._renderOverlay(ctx);
        if (this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        this.fire("after:render", {
            ctx: ctx
        });
        if (this.__cleanupTask) {
            this.__cleanupTask();
            this.__cleanupTask = void 0;
        }
    }
    /**
	* Paint the cached clipPath on the lowerCanvasEl
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ drawClipPathOnCanvas(ctx, clipPath) {
        const v = this.viewportTransform;
        ctx.save();
        ctx.transform(...v);
        ctx.globalCompositeOperation = "destination-in";
        clipPath.transform(ctx);
        ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
        ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
        ctx.restore();
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Array} objects to render
	*/ _renderObjects(ctx, objects) {
        for(let i = 0, len = objects.length; i < len; ++i)objects[i] && objects[i].render(ctx);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {string} property 'background' or 'overlay'
	*/ _renderBackgroundOrOverlay(ctx, property) {
        const fill = this[`${property}Color`], object = this[`${property}Image`], v = this.viewportTransform, needsVpt = this[`${property}Vpt`];
        if (!fill && !object) return;
        const isAFiller = $9a54cbcfc1af41ba$var$isFiller(fill);
        if (fill) {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(this.width, 0);
            ctx.lineTo(this.width, this.height);
            ctx.lineTo(0, this.height);
            ctx.closePath();
            ctx.fillStyle = isAFiller ? fill.toLive(ctx) : fill;
            if (needsVpt) ctx.transform(...v);
            if (isAFiller) {
                ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
                const m = fill.gradientTransform || fill.patternTransform;
                m && ctx.transform(...m);
            }
            ctx.fill();
            ctx.restore();
        }
        if (object) {
            ctx.save();
            const { skipOffscreen: skipOffscreen } = this;
            this.skipOffscreen = needsVpt;
            if (needsVpt) ctx.transform(...v);
            object.render(ctx);
            this.skipOffscreen = skipOffscreen;
            ctx.restore();
        }
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderBackground(ctx) {
        this._renderBackgroundOrOverlay(ctx, "background");
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderOverlay(ctx) {
        this._renderBackgroundOrOverlay(ctx, "overlay");
    }
    /**
	* Returns coordinates of a center of canvas.
	* @return {Point}
	*/ getCenterPoint() {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.width / 2, this.height / 2);
    }
    /**
	* Centers object horizontally in the canvas
	*/ centerObjectH(object) {
        return this._centerObject(object, new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.getCenterPoint().x, object.getCenterPoint().y));
    }
    /**
	* Centers object vertically in the canvas
	* @param {FabricObject} object Object to center vertically
	*/ centerObjectV(object) {
        return this._centerObject(object, new $9a54cbcfc1af41ba$export$baf26146a414f24a(object.getCenterPoint().x, this.getCenterPoint().y));
    }
    /**
	* Centers object vertically and horizontally in the canvas
	* @param {FabricObject} object Object to center vertically and horizontally
	*/ centerObject(object) {
        return this._centerObject(object, this.getCenterPoint());
    }
    /**
	* Centers object vertically and horizontally in the viewport
	* @param {FabricObject} object Object to center vertically and horizontally
	*/ viewportCenterObject(object) {
        return this._centerObject(object, this.getVpCenter());
    }
    /**
	* Centers object horizontally in the viewport, object.top is unchanged
	* @param {FabricObject} object Object to center vertically and horizontally
	*/ viewportCenterObjectH(object) {
        return this._centerObject(object, new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.getVpCenter().x, object.getCenterPoint().y));
    }
    /**
	* Centers object Vertically in the viewport, object.top is unchanged
	* @param {FabricObject} object Object to center vertically and horizontally
	*/ viewportCenterObjectV(object) {
        return this._centerObject(object, new $9a54cbcfc1af41ba$export$baf26146a414f24a(object.getCenterPoint().x, this.getVpCenter().y));
    }
    /**
	* Calculate the point in canvas that correspond to the center of actual viewport.
	* @return {Point} vpCenter, viewport center
	*/ getVpCenter() {
        return $9a54cbcfc1af41ba$var$transformPoint(this.getCenterPoint(), $9a54cbcfc1af41ba$var$invertTransform(this.viewportTransform));
    }
    /**
	* @private
	* @param {FabricObject} object Object to center
	* @param {Point} center Center point
	*/ _centerObject(object, center) {
        object.setXY(center, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
        object.setCoords();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
	* Returns dataless JSON representation of canvas
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {String} json string
	*/ toDatalessJSON(propertiesToInclude) {
        return this.toDatalessObject(propertiesToInclude);
    }
    /**
	* Returns object representation of canvas
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude) {
        return this._toObjectMethod("toObject", propertiesToInclude);
    }
    /**
	* Returns Object representation of canvas
	* this alias is provided because if you call JSON.stringify on an instance,
	* the toJSON object will be invoked if it exists.
	* Having a toJSON method means you can do JSON.stringify(myCanvas)
	* JSON does not support additional properties because toJSON has its own signature
	* @return {Object} JSON compatible object
	* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-3#serialization}
	* @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
	* @example <caption>JSON representation of canvas </caption>
	* const json = canvas.toJSON();
	* @example <caption>JSON representation of canvas </caption>
	* const json = JSON.stringify(canvas);
	*/ toJSON() {
        return this.toObject();
    }
    /**
	* Returns dataless object representation of canvas
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toDatalessObject(propertiesToInclude) {
        return this._toObjectMethod("toDatalessObject", propertiesToInclude);
    }
    /**
	* @private
	*/ _toObjectMethod(methodName, propertiesToInclude) {
        const clipPath = this.clipPath;
        const clipPathData = clipPath && !clipPath.excludeFromExport ? this._toObject(clipPath, methodName, propertiesToInclude) : null;
        return {
            version: $9a54cbcfc1af41ba$export$83d89fbfd8236492,
            ...$9a54cbcfc1af41ba$var$pick(this, propertiesToInclude),
            objects: this._objects.filter((object)=>!object.excludeFromExport).map((instance)=>this._toObject(instance, methodName, propertiesToInclude)),
            ...this.__serializeBgOverlay(methodName, propertiesToInclude),
            ...clipPathData ? {
                clipPath: clipPathData
            } : null
        };
    }
    /**
	* @private
	*/ _toObject(instance, methodName, propertiesToInclude) {
        let originalValue;
        if (!this.includeDefaultValues) {
            originalValue = instance.includeDefaultValues;
            instance.includeDefaultValues = false;
        }
        const object = instance[methodName](propertiesToInclude);
        if (!this.includeDefaultValues) instance.includeDefaultValues = !!originalValue;
        return object;
    }
    /**
	* @private
	*/ __serializeBgOverlay(methodName, propertiesToInclude) {
        const data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
        if ($9a54cbcfc1af41ba$var$isFiller(bgColor)) {
            if (!bgColor.excludeFromExport) data.background = bgColor.toObject(propertiesToInclude);
        } else if (bgColor) data.background = bgColor;
        if ($9a54cbcfc1af41ba$var$isFiller(overlayColor)) {
            if (!overlayColor.excludeFromExport) data.overlay = overlayColor.toObject(propertiesToInclude);
        } else if (overlayColor) data.overlay = overlayColor;
        if (bgImage && !bgImage.excludeFromExport) data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
        if (overlayImage && !overlayImage.excludeFromExport) data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
        return data;
    }
    /**
	* Returns SVG representation of canvas
	* @param {Object} [options] Options object for SVG output
	* @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
	* @param {Object} [options.viewBox] SVG viewbox object
	* @param {Number} [options.viewBox.x] x-coordinate of viewbox
	* @param {Number} [options.viewBox.y] y-coordinate of viewbox
	* @param {Number} [options.viewBox.width] Width of viewbox
	* @param {Number} [options.viewBox.height] Height of viewbox
	* @param {String} [options.encoding=UTF-8] Encoding of SVG output
	* @param {String} [options.width] desired width of svg with or without units
	* @param {String} [options.height] desired height of svg with or without units
	* @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
	* @return {String} SVG string
	* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-3#serialization}
	* @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
	* @example <caption>Normal SVG output</caption>
	* var svg = canvas.toSVG();
	* @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
	* var svg = canvas.toSVG({suppressPreamble: true});
	* @example <caption>SVG output with viewBox attribute</caption>
	* var svg = canvas.toSVG({
	*   viewBox: {
	*     x: 100,
	*     y: 100,
	*     width: 200,
	*     height: 300
	*   }
	* });
	* @example <caption>SVG output with different encoding (default: UTF-8)</caption>
	* var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
	* @example <caption>Modify SVG output with reviver function</caption>
	* var svg = canvas.toSVG(null, function(svg) {
	*   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
	* });
	*/ toSVG(options = {}, reviver) {
        options.reviver = reviver;
        const markup = [];
        this._setSVGPreamble(markup, options);
        this._setSVGHeader(markup, options);
        if (this.clipPath) {
            var _this$clipPath$clipPa;
            markup.push(`<g clip-path="url(#${$9a54cbcfc1af41ba$var$escapeXml((_this$clipPath$clipPa = this.clipPath.clipPathId) !== null && _this$clipPath$clipPa !== void 0 ? _this$clipPath$clipPa : "")})" >\n`);
        }
        this._setSVGBgOverlayColor(markup, "background");
        this._setSVGBgOverlayImage(markup, "backgroundImage", reviver);
        this._setSVGObjects(markup, reviver);
        if (this.clipPath) markup.push("</g>\n");
        this._setSVGBgOverlayColor(markup, "overlay");
        this._setSVGBgOverlayImage(markup, "overlayImage", reviver);
        markup.push("</svg>");
        return markup.join("");
    }
    /**
	* @private
	*/ _setSVGPreamble(markup, options) {
        if (options.suppressPreamble) return;
        markup.push("<?xml version=\"1.0\" encoding=\"", options.encoding || "UTF-8", "\" standalone=\"no\" ?>\n", "<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" ", "\"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n");
    }
    /**
	* @private
	*/ _setSVGHeader(markup, options) {
        const width = options.width || `${this.width}`, height = options.height || `${this.height}`, NUM_FRACTION_DIGITS = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS, optViewBox = options.viewBox;
        let viewBox;
        if (optViewBox) viewBox = `viewBox="${optViewBox.x} ${optViewBox.y} ${optViewBox.width} ${optViewBox.height}" `;
        else if (this.svgViewportTransformation) {
            const vpt = this.viewportTransform;
            viewBox = `viewBox="${$9a54cbcfc1af41ba$var$toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS)} ${$9a54cbcfc1af41ba$var$toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS)} ${$9a54cbcfc1af41ba$var$toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS)} ${$9a54cbcfc1af41ba$var$toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS)}" `;
        } else viewBox = `viewBox="0 0 ${this.width} ${this.height}" `;
        markup.push("<svg ", "xmlns=\"http://www.w3.org/2000/svg\" ", "xmlns:xlink=\"http://www.w3.org/1999/xlink\" ", "version=\"1.1\" ", "width=\"", width, "\" ", "height=\"", height, "\" ", viewBox, "xml:space=\"preserve\">\n", "<desc>Created with Fabric.js ", $9a54cbcfc1af41ba$export$83d89fbfd8236492, "</desc>\n", "<defs>\n", this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), "</defs>\n");
    }
    createSVGClipPathMarkup(options) {
        const clipPath = this.clipPath;
        if (clipPath) {
            clipPath.clipPathId = `CLIPPATH_${$9a54cbcfc1af41ba$var$uid()}`;
            return `<clipPath id="${clipPath.clipPathId}" >\n${clipPath.toClipPathSVG(options.reviver)}</clipPath>\n`;
        }
        return "";
    }
    /**
	* Creates markup containing SVG referenced elements like patterns, gradients etc.
	* @return {String}
	*/ createSVGRefElementsMarkup() {
        return [
            "background",
            "overlay"
        ].map((prop)=>{
            const fill = this[`${prop}Color`];
            if ($9a54cbcfc1af41ba$var$isFiller(fill)) {
                const shouldTransform = this[`${prop}Vpt`], vpt = this.viewportTransform, object = {
                    isType: ()=>false,
                    width: this.width / (shouldTransform ? vpt[0] : 1),
                    height: this.height / (shouldTransform ? vpt[3] : 1)
                };
                return fill.toSVG(object, {
                    additionalTransform: shouldTransform ? $9a54cbcfc1af41ba$var$matrixToSVG(vpt) : ""
                });
            }
        }).join("");
    }
    /**
	* Creates markup containing SVG font faces,
	* font URLs for font faces must be collected by developers
	* and are not extracted from the DOM by fabricjs
	* @param {Array} objects Array of fabric objects
	* @return {String}
	*/ createSVGFontFacesMarkup() {
        const objects = [], fontList = {}, fontPaths = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.fontPaths;
        this._objects.forEach(function add(object) {
            objects.push(object);
            if ($9a54cbcfc1af41ba$var$isCollection(object)) object._objects.forEach(add);
        });
        objects.forEach((obj)=>{
            if (!$9a54cbcfc1af41ba$var$isTextObject(obj)) return;
            const { styles: styles, fontFamily: fontFamily } = obj;
            if (fontList[fontFamily] || !fontPaths[fontFamily]) return;
            fontList[fontFamily] = true;
            if (!styles) return;
            Object.values(styles).forEach((styleRow)=>{
                Object.values(styleRow).forEach(({ fontFamily: fontFamily = "" })=>{
                    if (!fontList[fontFamily] && fontPaths[fontFamily]) fontList[fontFamily] = true;
                });
            });
        });
        const fontListMarkup = Object.keys(fontList).map((fontFamily)=>`\t\t@font-face {\n\t\t\tfont-family: '${fontFamily}';\n\t\t\tsrc: url('${fontPaths[fontFamily]}');\n\t\t}\n`).join("");
        if (fontListMarkup) return `\t<style type="text/css"><![CDATA[\n${fontListMarkup}]]></style>\n`;
        return "";
    }
    /**
	* @private
	*/ _setSVGObjects(markup, reviver) {
        this.forEachObject((fabricObject)=>{
            if (fabricObject.excludeFromExport) return;
            this._setSVGObject(markup, fabricObject, reviver);
        });
    }
    /**
	* This is its own function because the Canvas ( non static ) requires extra code here
	* @private
	*/ _setSVGObject(markup, instance, reviver) {
        markup.push(instance.toSVG(reviver));
    }
    /**
	* @private
	*/ _setSVGBgOverlayImage(markup, property, reviver) {
        const bgOrOverlay = this[property];
        if (bgOrOverlay && !bgOrOverlay.excludeFromExport && bgOrOverlay.toSVG) markup.push(bgOrOverlay.toSVG(reviver));
    }
    /**
	* @TODO this seems to handle patterns but fail at gradients.
	* @private
	*/ _setSVGBgOverlayColor(markup, property) {
        const filler = this[`${property}Color`];
        if (!filler) return;
        if ($9a54cbcfc1af41ba$var$isFiller(filler)) {
            const repeat = filler.repeat || "", finalWidth = this.width, finalHeight = this.height, additionalTransform = this[`${property}Vpt`] ? $9a54cbcfc1af41ba$var$matrixToSVG($9a54cbcfc1af41ba$var$invertTransform(this.viewportTransform)) : "";
            markup.push(`<rect transform="${additionalTransform} translate(${finalWidth / 2},${finalHeight / 2})" x="${filler.offsetX - finalWidth / 2}" y="${filler.offsetY - finalHeight / 2}" width="${(repeat === "repeat-y" || repeat === "no-repeat") && $9a54cbcfc1af41ba$var$isPattern(filler) ? filler.source.width : finalWidth}" height="${(repeat === "repeat-x" || repeat === "no-repeat") && $9a54cbcfc1af41ba$var$isPattern(filler) ? filler.source.height : finalHeight}" fill="url(#SVGID_${filler.id})"></rect>\n`);
        } else markup.push("<rect x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" ", "fill=\"", filler, "\"", "></rect>\n");
    }
    /**
	* Populates canvas with data from the specified JSON.
	* JSON format must conform to the one of {@link fabric.Canvas#toJSON}
	*
	* **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
	*
	* @param {String|Object} json JSON string or object
	* @param {Promise<FabricObject> | Promise<void> | void} [reviver] Method for further parsing of JSON elements, called after each fabric object created with the instance
	* if creation was successfully or with defined error if not. If a FabricObject is returned in the reviver, and an error occurred, this instance will be used in place of that one witch generated error.
	* @param {Object} [options] options
	* @param {AbortSignal} [options.signal] see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @return {Promise<Canvas | StaticCanvas>} instance
	* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-3#deserialization}
	* @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
	* @example <caption>loadFromJSON</caption>
	* canvas.loadFromJSON(json).then((canvas) => canvas.requestRenderAll());
	* @example <caption>loadFromJSON with reviver</caption>
	* canvas.loadFromJSON(json, function(o, object, error) {
	*   // `o` = json object
	*   // `object` = fabric.Object instance or undefined
	*   // `error` = FabricError or undefined
	*   // ... do some stuff ...
	*   if(error){
	*      return new FabricText('placeholder-object');
	*   }
	* }).then((canvas) => {
	*   ... canvas is restored, add your code.
	* });
	*
	*/ loadFromJSON(json, reviver, { signal: signal } = {}) {
        if (!json) return Promise.reject(new $9a54cbcfc1af41ba$var$FabricError("`json` is undefined"));
        const { objects: objects = [], ...serialized } = typeof json === "string" ? JSON.parse(json) : json;
        const { backgroundImage: backgroundImage, background: background, overlayImage: overlayImage, overlay: overlay, clipPath: clipPath } = serialized;
        const renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        return Promise.all([
            $9a54cbcfc1af41ba$var$enlivenObjects(objects, {
                reviver: reviver,
                signal: signal
            }),
            $9a54cbcfc1af41ba$var$enlivenObjectEnlivables({
                backgroundImage: backgroundImage,
                backgroundColor: background,
                overlayImage: overlayImage,
                overlayColor: overlay,
                clipPath: clipPath
            }, {
                signal: signal
            })
        ]).then(([enlived, enlivedMap])=>{
            this.clear();
            this.add(...enlived);
            this.set(serialized);
            this.set(enlivedMap);
            this.renderOnAddRemove = renderOnAddRemove;
            return this;
        });
    }
    /**
	* Clones canvas instance
	* @param {string[]} [properties] Array of properties to include in the cloned canvas and children
	*/ clone(properties) {
        const data = this.toObject(properties);
        return this.cloneWithoutData().loadFromJSON(data);
    }
    /**
	* Clones canvas instance without cloning existing data.
	* This essentially copies canvas dimensions since loadFromJSON does not affect canvas size.
	*/ cloneWithoutData() {
        const el = $9a54cbcfc1af41ba$var$createCanvasElementFor(this);
        return new this.constructor(el);
    }
    /**
	* Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
	* @param {Object} [options] Options object
	* @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	* @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	* @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
	* @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	* @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	* @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	* @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	* @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
	* @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
	* @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	* @see {@link https://jsfiddle.net/xsjua1rd/ demo}
	* @example <caption>Generate jpeg dataURL with lower quality</caption>
	* var dataURL = canvas.toDataURL({
	*   format: 'jpeg',
	*   quality: 0.8
	* });
	* @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
	* var dataURL = canvas.toDataURL({
	*   format: 'png',
	*   left: 100,
	*   top: 100,
	*   width: 200,
	*   height: 200
	* });
	* @example <caption>Generate double scaled png dataURL</caption>
	* var dataURL = canvas.toDataURL({
	*   format: 'png',
	*   multiplier: 2
	* });
	* @example <caption>Generate dataURL with objects that overlap a specified object</caption>
	* var myObject;
	* var dataURL = canvas.toDataURL({
	*   filter: (object) => object.isContainedWithinObject(myObject) || object.intersectsWithObject(myObject)
	* });
	*/ toDataURL(options = {}) {
        const { format: format = "png", quality: quality = 1, multiplier: multiplier = 1, enableRetinaScaling: enableRetinaScaling = false } = options;
        const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
        return $9a54cbcfc1af41ba$var$toDataURL(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    toBlob(options = {}) {
        const { format: format = "png", quality: quality = 1, multiplier: multiplier = 1, enableRetinaScaling: enableRetinaScaling = false } = options;
        const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
        return $9a54cbcfc1af41ba$var$toBlob(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    /**
	* Create a new HTMLCanvas element painted with the current canvas content.
	* No need to resize the actual one or repaint it.
	* Will transfer object ownership to a new canvas, paint it, and set everything back.
	* This is an intermediary step used to get to a dataUrl but also it is useful to
	* create quick image copies of a canvas without passing for the dataUrl string
	* @param {Number} [multiplier] a zoom factor.
	* @param {Object} [options] Cropping informations
	* @param {Number} [options.left] Cropping left offset.
	* @param {Number} [options.top] Cropping top offset.
	* @param {Number} [options.width] Cropping width.
	* @param {Number} [options.height] Cropping height.
	* @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
	*/ toCanvasElement(multiplier = 1, { width: width, height: height, left: left, top: top, filter: filter } = {}) {
        const scaledWidth = (width || this.width) * multiplier, scaledHeight = (height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, originalSkipControlsDrawing = this.skipControlsDrawing, newZoom = zoom * multiplier, vp = this.viewportTransform, newVp = [
            newZoom,
            0,
            0,
            newZoom,
            (vp[4] - (left || 0)) * multiplier,
            (vp[5] - (top || 0)) * multiplier
        ], originalRetina = this.enableRetinaScaling, canvasEl = $9a54cbcfc1af41ba$var$createCanvasElementFor({
            width: scaledWidth,
            height: scaledHeight
        }), objectsToRender = filter ? this._objects.filter((obj)=>filter(obj)) : this._objects;
        this.enableRetinaScaling = false;
        this.viewportTransform = newVp;
        this.width = scaledWidth;
        this.height = scaledHeight;
        this.skipControlsDrawing = true;
        this.calcViewportBoundaries();
        this.renderCanvas(canvasEl.getContext("2d"), objectsToRender);
        this.viewportTransform = vp;
        this.width = originalWidth;
        this.height = originalHeight;
        this.calcViewportBoundaries();
        this.enableRetinaScaling = originalRetina;
        this.skipControlsDrawing = originalSkipControlsDrawing;
        return canvasEl;
    }
    /**
	* Waits until rendering has settled to destroy the canvas
	* @returns {Promise<boolean>} a promise resolving to `true` once the canvas has been destroyed or to `false` if the canvas has was already destroyed
	* @throws if aborted by a consequent call
	*/ dispose() {
        !this.disposed && this.elements.cleanupDOM({
            width: this.width,
            height: this.height
        });
        $9a54cbcfc1af41ba$export$dc18923894d9e56a.cancelByCanvas(this);
        this.disposed = true;
        return new Promise((resolve, reject)=>{
            const task = ()=>{
                this.destroy();
                resolve(true);
            };
            task.kill = reject;
            if (this.__cleanupTask) this.__cleanupTask.kill("aborted");
            if (this.destroyed) resolve(false);
            else if (this.nextRenderHandle) this.__cleanupTask = task;
            else task();
        });
    }
    /**
	* Clears the canvas element, disposes objects and frees resources.
	*
	* Invoked as part of the **async** operation of {@link dispose}.
	*
	* **CAUTION**:
	*
	* This method is **UNSAFE**.
	* You may encounter a race condition using it if there's a requested render.
	* Call this method only if you are sure rendering has settled.
	* Consider using {@link dispose} as it is **SAFE**
	*
	* @private
	*/ destroy() {
        this.destroyed = true;
        this.cancelRequestedRender();
        this.forEachObject((object)=>object.dispose());
        this._objects = [];
        if (this.backgroundImage) this.backgroundImage.dispose();
        this.backgroundImage = void 0;
        if (this.overlayImage) this.overlayImage.dispose();
        this.overlayImage = void 0;
        this.elements.dispose();
    }
    /**
	* Returns a string representation of an instance
	* @return {String} string representation of an instance
	*/ toString() {
        return `#<Canvas (${this.complexity()}): { objects: ${this._objects.length} }>`;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$ad01921fb0b1386e, "ownDefaults", $9a54cbcfc1af41ba$var$staticCanvasDefaults);
//#endregion
//#region src/util/dom_event.ts
const $9a54cbcfc1af41ba$var$touchEvents = [
    "touchstart",
    "touchmove",
    "touchend"
];
function $9a54cbcfc1af41ba$var$getTouchInfo(event) {
    const touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) return touchProp[0];
    return event;
}
const $9a54cbcfc1af41ba$var$getPointer = (event)=>{
    const element = event.target, scroll = $9a54cbcfc1af41ba$var$getScrollLeftTop(element), _evt = $9a54cbcfc1af41ba$var$getTouchInfo(event);
    return new $9a54cbcfc1af41ba$export$baf26146a414f24a(_evt.clientX + scroll.left, _evt.clientY + scroll.top);
};
const $9a54cbcfc1af41ba$var$isTouchEvent = (event)=>$9a54cbcfc1af41ba$var$touchEvents.includes(event.type) || event.pointerType === "touch";
const $9a54cbcfc1af41ba$var$stopEvent = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
//#endregion
//#region src/util/misc/boundingBoxFromPoints.ts
/**
* Calculates bounding box (left, top, width, height) from given `points`
* @param {XY[]} points
* @return {Object} Object with left, top, width, height properties
*/ const $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints = (points)=>{
    let left = 0, top = 0, width = 0, height = 0;
    for(let i = 0, len = points.length; i < len; i++){
        const { x: x, y: y } = points[i];
        if (x > width || !i) width = x;
        if (x < left || !i) left = x;
        if (y > height || !i) height = y;
        if (y < top || !i) top = y;
    }
    return {
        left: left,
        top: top,
        width: width - left,
        height: height - top
    };
};
//#endregion
//#region src/util/misc/objectTransforms.ts
/**
* given an object and a transform, apply the inverse transform to the object,
* this is equivalent to remove from that object that transformation, so that
* added in a space with the removed transform, the object will be the same as before.
* Removing from an object a transform that scale by 2 is like scaling it by 1/2.
* Removing from an object a transform that rotate by 30deg is like rotating by 30deg
* in the opposite direction.
* This util is used to add objects inside transformed groups or nested groups.
* @param {FabricObject} object the object you want to transform
* @param {TMat2D} transform the destination transform
*/ const $9a54cbcfc1af41ba$var$removeTransformFromObject = (object, transform)=>{
    $9a54cbcfc1af41ba$var$applyTransformToObject(object, $9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$invertTransform(transform), object.calcOwnMatrix()));
};
/**
* given an object and a transform, apply the transform to the object.
* this is equivalent to change the space where the object is drawn.
* Adding to an object a transform that scale by 2 is like scaling it by 2.
* This is used when removing an object from an active selection for example.
* @param {FabricObject} object the object you want to transform
* @param {Array} transform the destination transform
*/ const $9a54cbcfc1af41ba$var$addTransformToObject = (object, transform)=>$9a54cbcfc1af41ba$var$applyTransformToObject(object, $9a54cbcfc1af41ba$var$multiplyTransformMatrices(transform, object.calcOwnMatrix()));
/**
* discard an object transform state and apply the one from the matrix.
* @param {FabricObject} object the object you want to transform
* @param {Array} transform the destination transform
*/ const $9a54cbcfc1af41ba$var$applyTransformToObject = (object, transform)=>{
    const { translateX: translateX, translateY: translateY, scaleX: scaleX, scaleY: scaleY, ...otherOptions } = $9a54cbcfc1af41ba$var$qrDecompose(transform), center = new $9a54cbcfc1af41ba$export$baf26146a414f24a(translateX, translateY);
    object.flipX = false;
    object.flipY = false;
    Object.assign(object, otherOptions);
    object.set({
        scaleX: scaleX,
        scaleY: scaleY
    });
    object.setPositionByOrigin(center, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
};
/**
* reset an object transform state to neutral. Top and left are not accounted for
* @param  {FabricObject} target object to transform
*/ const $9a54cbcfc1af41ba$var$resetObjectTransform = (target)=>{
    target.scaleX = 1;
    target.scaleY = 1;
    target.skewX = 0;
    target.skewY = 0;
    target.flipX = false;
    target.flipY = false;
    target.rotate(0);
};
/**
* Extract Object transform values
* @param  {FabricObject} target object to read from
* @return {Object} Components of transform
*/ const $9a54cbcfc1af41ba$var$saveObjectTransform = (target)=>({
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
    });
/**
* given a width and height, return the size of the bounding box
* that can contains the box with width/height with applied transform.
* Use to calculate the boxes around objects for controls.
* @param {Number} width
* @param {Number} height
* @param {TMat2D} t
* @returns {Point} size
*/ const $9a54cbcfc1af41ba$var$sizeAfterTransform = (width, height, t)=>{
    const dimX = width / 2, dimY = height / 2, bbox = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints([
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(-dimX, -dimY),
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(dimX, -dimY),
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(-dimX, dimY),
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(dimX, dimY)
    ].map((p)=>p.transform(t)));
    return new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.width, bbox.height);
};
//#endregion
//#region src/util/misc/planeChange.ts
/**
* We are actually looking for the transformation from the destination plane to the source plane (change of basis matrix)\
* The object will exist on the destination plane and we want it to seem unchanged by it so we invert the destination matrix (`to`) and then apply the source matrix (`from`)
* @param [from]
* @param [to]
* @returns
*/ const $9a54cbcfc1af41ba$var$calcPlaneChangeMatrix = (from = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0, to = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0)=>$9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$invertTransform(to), from);
/**
* Sends a point from the source coordinate plane to the destination coordinate plane.\
* From the canvas/viewer's perspective the point remains unchanged.
*
* @example <caption>Send point from canvas plane to group plane</caption>
* var obj = new Rect({ left: 20, top: 20, width: 60, height: 60, strokeWidth: 0 });
* var group = new Group([obj], { strokeWidth: 0 });
* var sentPoint1 = sendPointToPlane(new Point(50, 50), undefined, group.calcTransformMatrix());
* var sentPoint2 = sendPointToPlane(new Point(50, 50), iMatrix, group.calcTransformMatrix());
* console.log(sentPoint1, sentPoint2) //  both points print (0,0) which is the center of group
*
* @param {Point} point
* @param {TMat2D} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `point` exists in the canvas coordinate plane.
* @param {TMat2D} [to] destination plane matrix to contain object. Passing `undefined` means `point` should be sent to the canvas coordinate plane.
* @returns {Point} transformed point
*/ const $9a54cbcfc1af41ba$var$sendPointToPlane = (point, from = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0, to = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0)=>point.transform($9a54cbcfc1af41ba$var$calcPlaneChangeMatrix(from, to));
/**
* See {@link sendPointToPlane}
*/ const $9a54cbcfc1af41ba$var$sendVectorToPlane = (point, from = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0, to = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0)=>point.transform($9a54cbcfc1af41ba$var$calcPlaneChangeMatrix(from, to), true);
/**
*
* A util that abstracts applying transform to objects.\
* Sends `object` to the destination coordinate plane by applying the relevant transformations.\
* Changes the space/plane where `object` is drawn.\
* From the canvas/viewer's perspective `object` remains unchanged.
*
* @example <caption>Move clip path from one object to another while preserving it's appearance as viewed by canvas/viewer</caption>
* let obj, obj2;
* let clipPath = new Circle({ radius: 50 });
* obj.clipPath = clipPath;
* // render
* sendObjectToPlane(clipPath, obj.calcTransformMatrix(), obj2.calcTransformMatrix());
* obj.clipPath = undefined;
* obj2.clipPath = clipPath;
* // render, clipPath now clips obj2 but seems unchanged from the eyes of the viewer
*
* @example <caption>Clip an object's clip path with an existing object</caption>
* let obj, existingObj;
* let clipPath = new Circle({ radius: 50 });
* obj.clipPath = clipPath;
* let transformTo = multiplyTransformMatrices(obj.calcTransformMatrix(), clipPath.calcTransformMatrix());
* sendObjectToPlane(existingObj, existingObj.group?.calcTransformMatrix(), transformTo);
* clipPath.clipPath = existingObj;
*
* @param {FabricObject} object
* @param {Matrix} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `object` is a direct child of canvas.
* @param {Matrix} [to] destination plane matrix to contain object. Passing `undefined` means `object` should be sent to the canvas coordinate plane.
* @returns {Matrix} the transform matrix that was applied to `object`
*/ const $9a54cbcfc1af41ba$var$sendObjectToPlane = (object, from, to)=>{
    const t = $9a54cbcfc1af41ba$var$calcPlaneChangeMatrix(from, to);
    $9a54cbcfc1af41ba$var$applyTransformToObject(object, $9a54cbcfc1af41ba$var$multiplyTransformMatrices(t, object.calcOwnMatrix()));
    return t;
};
//#endregion
//#region src/util/misc/resolveOrigin.ts
const $9a54cbcfc1af41ba$var$originOffset = {
    left: -0.5,
    top: -0.5,
    center: 0,
    bottom: .5,
    right: .5
};
/**
* Resolves origin value relative to center
* @private
* @param {TOriginX | TOriginY} originValue originX / originY
* @returns number
*/ const $9a54cbcfc1af41ba$var$resolveOrigin = (originValue)=>typeof originValue === "string" ? $9a54cbcfc1af41ba$var$originOffset[originValue] : originValue - .5;
//#endregion
//#region src/util/misc/vectors.ts
const $9a54cbcfc1af41ba$var$unitVectorX = new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 0);
const $9a54cbcfc1af41ba$var$zero = new $9a54cbcfc1af41ba$export$baf26146a414f24a();
/**
* Rotates `vector` with `radians`
* @param {Point} vector The vector to rotate (x and y)
* @param {Number} radians The radians of the angle for the rotation
* @return {Point} The new rotated point
*/ const $9a54cbcfc1af41ba$var$rotateVector = (vector, radians)=>vector.rotate(radians);
/**
* Creates a vector from points represented as a point
*
* @param {Point} from
* @param {Point} to
* @returns {Point} vector
*/ const $9a54cbcfc1af41ba$var$createVector = (from, to)=>new $9a54cbcfc1af41ba$export$baf26146a414f24a(to).subtract(from);
/**
* return the magnitude of a vector
* @return {number}
*/ const $9a54cbcfc1af41ba$var$magnitude = (point)=>point.distanceFrom($9a54cbcfc1af41ba$var$zero);
/**
* Calculates the angle between 2 vectors
* @param {Point} a
* @param {Point} b
* @returns the angle in radians from `a` to `b`
*/ const $9a54cbcfc1af41ba$var$calcAngleBetweenVectors = (a, b)=>Math.atan2($9a54cbcfc1af41ba$var$crossProduct(a, b), $9a54cbcfc1af41ba$var$dotProduct(a, b));
/**
* Calculates the angle between the x axis and the vector
* @param {Point} v
* @returns the angle in radians of `v`
*/ const $9a54cbcfc1af41ba$var$calcVectorRotation = (v)=>$9a54cbcfc1af41ba$var$calcAngleBetweenVectors($9a54cbcfc1af41ba$var$unitVectorX, v);
/**
* @param {Point} v
* @returns {Point} vector representing the unit vector pointing to the direction of `v`
*/ const $9a54cbcfc1af41ba$var$getUnitVector = (v)=>v.eq($9a54cbcfc1af41ba$var$zero) ? v : v.scalarDivide($9a54cbcfc1af41ba$var$magnitude(v));
/**
* @param {Point} v
* @param {Boolean} [counterClockwise] the direction of the orthogonal vector, defaults to `true`
* @returns {Point} the unit orthogonal vector
*/ const $9a54cbcfc1af41ba$var$getOrthonormalVector = (v, counterClockwise = true)=>$9a54cbcfc1af41ba$var$getUnitVector(new $9a54cbcfc1af41ba$export$baf26146a414f24a(-v.y, v.x).scalarMultiply(counterClockwise ? 1 : -1));
/**
* Cross product of two vectors in 2D
* @param {Point} a
* @param {Point} b
* @returns {number} the magnitude of Z vector
*/ const $9a54cbcfc1af41ba$var$crossProduct = (a, b)=>a.x * b.y - a.y * b.x;
/**
* Dot product of two vectors in 2D
* @param {Point} a
* @param {Point} b
* @returns {number}
*/ const $9a54cbcfc1af41ba$var$dotProduct = (a, b)=>a.x * b.x + a.y * b.y;
/**
* Checks if the vector is between two others. It is considered
* to be inside when the vector to be tested is between the
* initial vector and the final vector (included) in a counterclockwise direction.
* @param {Point} t vector to be tested
* @param {Point} a initial vector
* @param {Point} b final vector
* @returns {boolean} true if the vector is among the others
*/ const $9a54cbcfc1af41ba$var$isBetweenVectors = (t, a, b)=>{
    if (t.eq(a) || t.eq(b)) return true;
    const AxB = $9a54cbcfc1af41ba$var$crossProduct(a, b), AxT = $9a54cbcfc1af41ba$var$crossProduct(a, t), BxT = $9a54cbcfc1af41ba$var$crossProduct(b, t);
    return AxB >= 0 ? AxT >= 0 && BxT <= 0 : !(AxT <= 0 && BxT >= 0);
};
//#endregion
//#region src/controls/util.ts
const $9a54cbcfc1af41ba$var$NOT_ALLOWED_CURSOR = "not-allowed";
/**
* @param {Boolean} alreadySelected true if target is already selected
* @param {String} corner a string representing the corner ml, mr, tl ...
* @param {Event} e Event object
* @param {FabricObject} [target] inserted back to help overriding. Unused
*/ const $9a54cbcfc1af41ba$var$getActionFromCorner = (alreadySelected, corner, e, target)=>{
    if (!corner || !alreadySelected) return "drag";
    const control = target.controls[corner];
    return control.getActionName(e, control, target);
};
/**
* Checks if transform is centered
* @param {Object} transform transform data
* @return {Boolean} true if transform is centered
*/ function $9a54cbcfc1af41ba$var$isTransformCentered(transform) {
    return $9a54cbcfc1af41ba$var$resolveOrigin(transform.originX) === $9a54cbcfc1af41ba$var$resolveOrigin("center") && $9a54cbcfc1af41ba$var$resolveOrigin(transform.originY) === $9a54cbcfc1af41ba$var$resolveOrigin("center");
}
function $9a54cbcfc1af41ba$var$invertOrigin(origin) {
    return -$9a54cbcfc1af41ba$var$resolveOrigin(origin) + .5;
}
const $9a54cbcfc1af41ba$var$isLocked = (target, lockingKey)=>target[lockingKey];
const $9a54cbcfc1af41ba$var$commonEventInfo = (eventData, transform, x, y)=>{
    return {
        e: eventData,
        transform: transform,
        pointer: new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y)
    };
};
/**
* Combine control position and object angle to find the control direction compared
* to the object center.
* @param {FabricObject} fabricObject the fabric object for which we are rendering controls
* @param {Control} control the control class
* @return {Number} 0 - 7 a quadrant number
*/ function $9a54cbcfc1af41ba$var$findCornerQuadrant(fabricObject, control, coord) {
    const target = coord;
    const angle = $9a54cbcfc1af41ba$var$calcVectorRotation($9a54cbcfc1af41ba$var$createVector($9a54cbcfc1af41ba$var$sendPointToPlane(fabricObject.getCenterPoint(), fabricObject.canvas.viewportTransform, void 0), target)) + $9a54cbcfc1af41ba$var$twoMathPi;
    return Math.round(angle % $9a54cbcfc1af41ba$var$twoMathPi / $9a54cbcfc1af41ba$var$quarterPI);
}
/**
* @returns the normalized point (rotated relative to center) in local coordinates
*/ function $9a54cbcfc1af41ba$var$normalizePoint(target, point, originX, originY) {
    const center = target.getRelativeCenterPoint(), p = typeof originX !== "undefined" && typeof originY !== "undefined" ? target.translateToGivenOrigin(center, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER, originX, originY) : new $9a54cbcfc1af41ba$export$baf26146a414f24a(target.left, target.top);
    return (target.angle ? point.rotate(-$9a54cbcfc1af41ba$var$degreesToRadians(target.angle), center) : point).subtract(p);
}
/**
* Transforms a point to the offset from the given origin
* @param {Object} transform
* @param {String} originX
* @param {String} originY
* @param {number} x
* @param {number} y
* @return {Fabric.Point} the normalized point
*/ function $9a54cbcfc1af41ba$var$getLocalPoint({ target: target, corner: corner }, originX, originY, x, y) {
    var _target$canvas;
    const control = target.controls[corner], zoom = ((_target$canvas = target.canvas) === null || _target$canvas === void 0 ? void 0 : _target$canvas.getZoom()) || 1, padding = target.padding / zoom, localPoint = $9a54cbcfc1af41ba$var$normalizePoint(target, new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y), originX, originY);
    if (localPoint.x >= padding) localPoint.x -= padding;
    if (localPoint.x <= -padding) localPoint.x += padding;
    if (localPoint.y >= padding) localPoint.y -= padding;
    if (localPoint.y <= padding) localPoint.y += padding;
    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
}
//#endregion
//#region src/util/internals/normalizeWhiteSpace.ts
const $9a54cbcfc1af41ba$var$normalizeWs = (value)=>value.replace(/\s+/g, " ");
//#endregion
//#region src/color/color_map.ts
/**
* Map of the 148 color names with HEX code
* @see: https://www.w3.org/TR/css3-color/#svg-color
*/ const $9a54cbcfc1af41ba$var$ColorNameMap = {
    aliceblue: "#F0F8FF",
    antiquewhite: "#FAEBD7",
    aqua: "#0FF",
    aquamarine: "#7FFFD4",
    azure: "#F0FFFF",
    beige: "#F5F5DC",
    bisque: "#FFE4C4",
    black: "#000",
    blanchedalmond: "#FFEBCD",
    blue: "#00F",
    blueviolet: "#8A2BE2",
    brown: "#A52A2A",
    burlywood: "#DEB887",
    cadetblue: "#5F9EA0",
    chartreuse: "#7FFF00",
    chocolate: "#D2691E",
    coral: "#FF7F50",
    cornflowerblue: "#6495ED",
    cornsilk: "#FFF8DC",
    crimson: "#DC143C",
    cyan: "#0FF",
    darkblue: "#00008B",
    darkcyan: "#008B8B",
    darkgoldenrod: "#B8860B",
    darkgray: "#A9A9A9",
    darkgrey: "#A9A9A9",
    darkgreen: "#006400",
    darkkhaki: "#BDB76B",
    darkmagenta: "#8B008B",
    darkolivegreen: "#556B2F",
    darkorange: "#FF8C00",
    darkorchid: "#9932CC",
    darkred: "#8B0000",
    darksalmon: "#E9967A",
    darkseagreen: "#8FBC8F",
    darkslateblue: "#483D8B",
    darkslategray: "#2F4F4F",
    darkslategrey: "#2F4F4F",
    darkturquoise: "#00CED1",
    darkviolet: "#9400D3",
    deeppink: "#FF1493",
    deepskyblue: "#00BFFF",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1E90FF",
    firebrick: "#B22222",
    floralwhite: "#FFFAF0",
    forestgreen: "#228B22",
    fuchsia: "#F0F",
    gainsboro: "#DCDCDC",
    ghostwhite: "#F8F8FF",
    gold: "#FFD700",
    goldenrod: "#DAA520",
    gray: "#808080",
    grey: "#808080",
    green: "#008000",
    greenyellow: "#ADFF2F",
    honeydew: "#F0FFF0",
    hotpink: "#FF69B4",
    indianred: "#CD5C5C",
    indigo: "#4B0082",
    ivory: "#FFFFF0",
    khaki: "#F0E68C",
    lavender: "#E6E6FA",
    lavenderblush: "#FFF0F5",
    lawngreen: "#7CFC00",
    lemonchiffon: "#FFFACD",
    lightblue: "#ADD8E6",
    lightcoral: "#F08080",
    lightcyan: "#E0FFFF",
    lightgoldenrodyellow: "#FAFAD2",
    lightgray: "#D3D3D3",
    lightgrey: "#D3D3D3",
    lightgreen: "#90EE90",
    lightpink: "#FFB6C1",
    lightsalmon: "#FFA07A",
    lightseagreen: "#20B2AA",
    lightskyblue: "#87CEFA",
    lightslategray: "#789",
    lightslategrey: "#789",
    lightsteelblue: "#B0C4DE",
    lightyellow: "#FFFFE0",
    lime: "#0F0",
    limegreen: "#32CD32",
    linen: "#FAF0E6",
    magenta: "#F0F",
    maroon: "#800000",
    mediumaquamarine: "#66CDAA",
    mediumblue: "#0000CD",
    mediumorchid: "#BA55D3",
    mediumpurple: "#9370DB",
    mediumseagreen: "#3CB371",
    mediumslateblue: "#7B68EE",
    mediumspringgreen: "#00FA9A",
    mediumturquoise: "#48D1CC",
    mediumvioletred: "#C71585",
    midnightblue: "#191970",
    mintcream: "#F5FFFA",
    mistyrose: "#FFE4E1",
    moccasin: "#FFE4B5",
    navajowhite: "#FFDEAD",
    navy: "#000080",
    oldlace: "#FDF5E6",
    olive: "#808000",
    olivedrab: "#6B8E23",
    orange: "#FFA500",
    orangered: "#FF4500",
    orchid: "#DA70D6",
    palegoldenrod: "#EEE8AA",
    palegreen: "#98FB98",
    paleturquoise: "#AFEEEE",
    palevioletred: "#DB7093",
    papayawhip: "#FFEFD5",
    peachpuff: "#FFDAB9",
    peru: "#CD853F",
    pink: "#FFC0CB",
    plum: "#DDA0DD",
    powderblue: "#B0E0E6",
    purple: "#800080",
    rebeccapurple: "#639",
    red: "#F00",
    rosybrown: "#BC8F8F",
    royalblue: "#4169E1",
    saddlebrown: "#8B4513",
    salmon: "#FA8072",
    sandybrown: "#F4A460",
    seagreen: "#2E8B57",
    seashell: "#FFF5EE",
    sienna: "#A0522D",
    silver: "#C0C0C0",
    skyblue: "#87CEEB",
    slateblue: "#6A5ACD",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#FFFAFA",
    springgreen: "#00FF7F",
    steelblue: "#4682B4",
    tan: "#D2B48C",
    teal: "#008080",
    thistle: "#D8BFD8",
    tomato: "#FF6347",
    turquoise: "#40E0D0",
    violet: "#EE82EE",
    wheat: "#F5DEB3",
    white: "#FFF",
    whitesmoke: "#F5F5F5",
    yellow: "#FF0",
    yellowgreen: "#9ACD32"
};
//#endregion
//#region src/color/constants.ts
/**
* Regex matching color in RGB or RGBA formats (ex: `rgb(0, 0, 0)`, `rgba(255, 100, 10, 0.5)`, `rgba( 255 , 100 , 10 , 0.5 )`, `rgb(1,1,1)`, `rgba(100%, 60%, 10%, 0.5)`)
* Also matching rgba(r g b / a) as per new specs
* https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/rgb
*
* In order to avoid performance issues, you have to clean the input string for this regex from multiple spaces before.
* ex: colorString.replace(/\s+/g, ' ');
*
* Formal syntax at the time of writing:
* <rgb()> =
*  rgb( [ <percentage> | none ]{3} [ / [ <alpha-value> | none ] ]? )  |
*  rgb( [ <number> | none ]{3} [ / [ <alpha-value> | none ] ]? )
* <alpha-value> = <number> | <percentage>
*
* For learners this is how you can read this regex
* Regular expression for matching an rgba or rgb CSS color value
*
* /^          # Beginning of the string
* rgba?       # "rgb" or "rgba"
* \(\s?       # Opening parenthesis and zero or one whitespace character
* (\d{0,3}    # 0 to three digits R channel
*  (?:\.\d+)? # Optional decimal with one or more digits
* )           # End of capturing group for the first color component
* %?          # Optional percent sign after the first color component
* \s?         # Zero or one whitespace character
* [\s|,]      # Separator between color components can be a space or comma
* \s?         # Zero or one whitespace character
* (\d{0,3}    # 0 to three digits G channel
*  (?:\.\d+)? # Optional decimal with one or more digits
* )           # End of capturing group for the second color component
* %?          # Optional percent sign after the second color component
* \s?         # Zero or one whitespace character
* [\s|,]      # Separator between color components can be a space or comma
* \s?         # Zero or one whitespace character
* (\d{0,3}    # 0 to three digits B channel
*  (?:\.\d+)? # Optional decimal with one or more digits
* )           # End of capturing group for the third color component
* %?          # Optional percent sign after the third color component
* \s?         # Zero or one whitespace character
* (?:         # Beginning of non-capturing group for alpha value
*  \s?        # Zero or one whitespace character
*  [,/]       # Comma or slash separator for alpha value
*  \s?        # Zero or one whitespace character
*  (\d{0,3}   # Zero to three digits
*    (?:\.\d+)? # Optional decimal with one or more digits
*  )          # End of capturing group for alpha value
*  %?         # Optional percent sign after alpha value
*  \s?        # Zero or one whitespace character
* )?          # End of non-capturing group for alpha value (optional)
* \)          # Closing parenthesis
* $           # End of the string
*
* The alpha channel can be in the format 0.4 .7 or 1 or 73%
*
* WARNING this regex doesn't fail on off spec colors. it matches everything that could be a color.
* So the spec does not allow for `rgba(30 , 45%  35, 49%)` but this will work anyways for us
*/ const $9a54cbcfc1af41ba$var$reRGBa = ()=>/^rgba?\(\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d{0,3}(?:\.\d+)?%?)\s?)?\)$/i;
/**
* Regex matching color in HSL or HSLA formats (ex: hsl(0deg 0%, 0%), hsla(160, 100, 10, 0.5), hsla( 180 , 100 , 10 , 0.5 ), hsl(1,1,1))
* Also matching hsla(h s l / a) as per new specs
* https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/hsl
* In order to avoid performance issues, you have to clean the input string for this regex from multiple spaces before.
* ex: colorString.replace(/\s+/g, ' ');
* Formal syntax at the time of writing:
* <hsl()> =
*   hsl( [ <hue> | none ] [ <percentage> | none ] [ <percentage> | none ] [ / [ <alpha-value> | none ] ]? )
*
* <hue> =
*   <number>  |
*   <angle>
*
* <alpha-value> =
*   <number>      |
*   <percentage>
*
* For learners this is how you can read this regex
* Regular expression for matching an hsla or hsl CSS color value
*
* /^hsla?\(         // Matches the beginning of the string and the opening parenthesis of "hsl" or "hsla"
* \s?               // Matches any whitespace character (space, tab, etc.) zero or one time
* (\d{0,3}          // Hue: 0 to three digits - start capture in a group
* (?:\.\d+)?        // Hue: Optional (non capture group) decimal with one or more digits.
* (?:deg|turn|rad)? // Hue: Optionally include suffix deg or turn or rad
* )                 // Hue: End capture group
* \s?               // Matches any whitespace character zero or one time
* [\s|,]            // Matches a space, tab or comma
* \s?               // Matches any whitespace character zero or one time
* (\d{0,3}          // Saturation: 0 to three digits - start capture in a group
* (?:\.\d+)?        // Saturation: Optional decimal with one or more digits in a non-capturing group
* %?)               // Saturation: match optional % character and end capture group
* \s?               // Matches any whitespace character zero or one time
* [\s|,]            // Matches a space, tab or comma
* \s?               // Matches any whitespace character zero or one time
* (\d{0,3}          // Lightness: 0 to three digits - start capture in a group
* (?:\.\d+)?        // Lightness: Optional decimal with one or more digits in a non-capturing group
* %?)                // Lightness: match % character and end capture group
* \s?               // Matches any whitespace character zero or one time
* (?:               // Alpha: Begins a non-capturing group for the alpha value
*   \s?             // Matches any whitespace character zero or one time
*   [,/]            // Matches a comma or forward slash
*   \s?             // Matches any whitespace character zero or one time
*   (\d*(?:\.\d+)?%?) // Matches zero or more digits, optionally followed by a decimal point and one or more digits, followed by an optional percentage sign and captures it in a group
*   \s?             // Matches any whitespace character zero or one time
* )?                // Makes the alpha value group optional
* \)                // Matches the closing parenthesis
* $/i               // Matches the end of the string and sets the regular expression to case-insensitive mode
*
* WARNING this regex doesn't fail on off spec colors. It matches everything that could be a color.
* So the spec does not allow `hsl(30 , 45%  35, 49%)` but this will work anyways for us.
*/ const $9a54cbcfc1af41ba$var$reHSLa = ()=>/^hsla?\(\s?([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d*(?:\.\d+)?%?)\s?)?\)$/i;
/**
* Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
*/ const $9a54cbcfc1af41ba$var$reHex = ()=>/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i;
//#endregion
//#region src/color/util.ts
/**
* @param {Number} p
* @param {Number} q
* @param {Number} t
* @return {Number}
*/ const $9a54cbcfc1af41ba$var$hue2rgb = (p, q, t)=>{
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
/**
* Adapted from {@link https://gist.github.com/mjackson/5311256 https://gist.github.com/mjackson}
* @param {Number} r Red color value
* @param {Number} g Green color value
* @param {Number} b Blue color value
* @param {Number} a Alpha color value pass through
* @return {TRGBColorSource} Hsl color
*/ const $9a54cbcfc1af41ba$var$rgb2Hsl = (r, g, b, a)=>{
    r /= 255;
    g /= 255;
    b /= 255;
    const maxValue = Math.max(r, g, b), minValue = Math.min(r, g, b);
    let h, s;
    const l = (maxValue + minValue) / 2;
    if (maxValue === minValue) h = s = 0;
    else {
        const d = maxValue - minValue;
        s = l > .5 ? d / (2 - maxValue - minValue) : d / (maxValue + minValue);
        switch(maxValue){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [
        Math.round(h * 360),
        Math.round(s * 100),
        Math.round(l * 100),
        a
    ];
};
const $9a54cbcfc1af41ba$var$fromAlphaToFloat = (value = "1")=>parseFloat(value) / (value.endsWith("%") ? 100 : 1);
/**
* Convert a value in the inclusive range [0, 255] to hex
*/ const $9a54cbcfc1af41ba$var$hexify = (value)=>Math.min(Math.round(value), 255).toString(16).toUpperCase().padStart(2, "0");
/**
* Calculate the grey average value for rgb and pass through alpha
*/ const $9a54cbcfc1af41ba$var$greyAverage = ([r, g, b, a = 1])=>{
    const avg = Math.round(r * .3 + g * .59 + b * .11);
    return [
        avg,
        avg,
        avg,
        a
    ];
};
//#endregion
//#region src/color/Color.ts
/**
* @class Color common color operations
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-2#colors colors}
*/ var $9a54cbcfc1af41ba$export$892596cec99bc70e = class Color {
    /**
	*
	* @param {string} [color] optional in hex or rgb(a) or hsl format or from known color list
	*/ constructor(color){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "isUnrecognised", false);
        if (!color) this.setSource([
            0,
            0,
            0,
            1
        ]);
        else if (color instanceof Color) this.setSource([
            ...color._source
        ]);
        else if (Array.isArray(color)) {
            const [r, g, b, a = 1] = color;
            this.setSource([
                r,
                g,
                b,
                a
            ]);
        } else this.setSource(this._tryParsingColor(color));
    }
    /**
	* @private
	* @param {string} [color] Color value to parse
	* @returns {TRGBAColorSource}
	*/ _tryParsingColor(color) {
        color = color.toLowerCase();
        if (color in $9a54cbcfc1af41ba$var$ColorNameMap) color = $9a54cbcfc1af41ba$var$ColorNameMap[color];
        return color === "transparent" ? [
            255,
            255,
            255,
            0
        ] : Color.sourceFromHex(color) || Color.sourceFromRgb(color) || Color.sourceFromHsl(color) || (this.isUnrecognised = true, [
            0,
            0,
            0,
            1
        ]);
    }
    /**
	* Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	* @return {TRGBAColorSource}
	*/ getSource() {
        return this._source;
    }
    /**
	* Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	* @param {TRGBAColorSource} source
	*/ setSource(source) {
        this._source = source;
    }
    /**
	* Returns color representation in RGB format
	* @return {String} ex: rgb(0-255,0-255,0-255)
	*/ toRgb() {
        const [r, g, b] = this.getSource();
        return `rgb(${r},${g},${b})`;
    }
    /**
	* Returns color representation in RGBA format
	* @return {String} ex: rgba(0-255,0-255,0-255,0-1)
	*/ toRgba() {
        return `rgba(${this.getSource().join(",")})`;
    }
    /**
	* Returns color representation in HSL format
	* @return {String} ex: hsl(0-360,0%-100%,0%-100%)
	*/ toHsl() {
        const [h, s, l] = $9a54cbcfc1af41ba$var$rgb2Hsl(...this.getSource());
        return `hsl(${h},${s}%,${l}%)`;
    }
    /**
	* Returns color representation in HSLA format
	* @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
	*/ toHsla() {
        const [h, s, l, a] = $9a54cbcfc1af41ba$var$rgb2Hsl(...this.getSource());
        return `hsla(${h},${s}%,${l}%,${a})`;
    }
    /**
	* Returns color representation in HEX format
	* @return {String} ex: FF5555
	*/ toHex() {
        return this.toHexa().slice(0, 6);
    }
    /**
	* Returns color representation in HEXA format
	* @return {String} ex: FF5555CC
	*/ toHexa() {
        const [r, g, b, a] = this.getSource();
        return `${$9a54cbcfc1af41ba$var$hexify(r)}${$9a54cbcfc1af41ba$var$hexify(g)}${$9a54cbcfc1af41ba$var$hexify(b)}${$9a54cbcfc1af41ba$var$hexify(Math.round(a * 255))}`;
    }
    /**
	* Gets value of alpha channel for this color
	* @return {Number} 0-1
	*/ getAlpha() {
        return this.getSource()[3];
    }
    /**
	* Sets value of alpha channel for this color
	* @param {Number} alpha Alpha value 0-1
	* @return {Color} thisArg
	*/ setAlpha(alpha) {
        this._source[3] = alpha;
        return this;
    }
    /**
	* Transforms color to its grayscale representation
	* @return {Color} thisArg
	*/ toGrayscale() {
        this.setSource($9a54cbcfc1af41ba$var$greyAverage(this.getSource()));
        return this;
    }
    /**
	* Transforms color to its black and white representation
	* @param {Number} threshold
	* @return {Color} thisArg
	*/ toBlackWhite(threshold) {
        const [average, , , a] = $9a54cbcfc1af41ba$var$greyAverage(this.getSource()), bOrW = average < (threshold || 127) ? 0 : 255;
        this.setSource([
            bOrW,
            bOrW,
            bOrW,
            a
        ]);
        return this;
    }
    /**
	* Overlays color with another color
	* @param {String|Color} otherColor
	* @return {Color} thisArg
	*/ overlayWith(otherColor) {
        if (!(otherColor instanceof Color)) otherColor = new Color(otherColor);
        const source = this.getSource(), otherAlpha = .5, otherSource = otherColor.getSource(), [R, G, B] = source.map((value, index)=>Math.round(value * (1 - otherAlpha) + otherSource[index] * otherAlpha));
        this.setSource([
            R,
            G,
            B,
            source[3]
        ]);
        return this;
    }
    /**
	* Returns new color object, when given a color in RGB format
	* @param {String} color Color value ex: rgb(0-255,0-255,0-255)
	* @return {Color}
	*/ static fromRgb(color) {
        return Color.fromRgba(color);
    }
    /**
	* Returns new color object, when given a color in RGBA format
	* @param {String} color
	* @return {Color}
	*/ static fromRgba(color) {
        return new Color(Color.sourceFromRgb(color));
    }
    /**
	* Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
	* @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
	* @return {TRGBAColorSource | undefined} source
	*/ static sourceFromRgb(color) {
        const match = $9a54cbcfc1af41ba$var$normalizeWs(color).match($9a54cbcfc1af41ba$var$reRGBa());
        if (match) {
            const [r, g, b] = match.slice(1, 4).map((value)=>{
                const parsedValue = parseFloat(value);
                return value.endsWith("%") ? Math.round(parsedValue * 2.55) : parsedValue;
            });
            return [
                r,
                g,
                b,
                $9a54cbcfc1af41ba$var$fromAlphaToFloat(match[4])
            ];
        }
    }
    /**
	* Returns new color object, when given a color in HSL format
	* @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
	* @return {Color}
	*/ static fromHsl(color) {
        return Color.fromHsla(color);
    }
    /**
	* Returns new color object, when given a color in HSLA format
	* @param {String} color
	* @return {Color}
	*/ static fromHsla(color) {
        return new Color(Color.sourceFromHsl(color));
    }
    /**
	* Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
	* Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
	* @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
	* @return {TRGBAColorSource | undefined} source
	* @see http://http://www.w3.org/TR/css3-color/#hsl-color
	*/ static sourceFromHsl(color) {
        const match = $9a54cbcfc1af41ba$var$normalizeWs(color).match($9a54cbcfc1af41ba$var$reHSLa());
        if (!match) return;
        const h = (Color.parseAngletoDegrees(match[1]) % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / 100, l = parseFloat(match[3]) / 100;
        let r, g, b;
        if (s === 0) r = g = b = l;
        else {
            const q = l <= .5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
            r = $9a54cbcfc1af41ba$var$hue2rgb(p, q, h + 1 / 3);
            g = $9a54cbcfc1af41ba$var$hue2rgb(p, q, h);
            b = $9a54cbcfc1af41ba$var$hue2rgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255),
            $9a54cbcfc1af41ba$var$fromAlphaToFloat(match[4])
        ];
    }
    /**
	* Returns new color object, when given a color in HEX format
	* @param {String} color Color value ex: FF5555
	* @return {Color}
	*/ static fromHex(color) {
        return new Color(Color.sourceFromHex(color));
    }
    /**
	* Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
	* @param {String} color ex: FF5555 or FF5544CC (RGBa)
	* @return {TRGBAColorSource | undefined} source
	*/ static sourceFromHex(color) {
        if (color.match($9a54cbcfc1af41ba$var$reHex())) {
            const value = color.slice(color.indexOf("#") + 1), isShortNotation = value.length <= 4;
            let expandedValue;
            if (isShortNotation) expandedValue = value.split("").map((hex)=>hex + hex);
            else expandedValue = value.match(/.{2}/g);
            const [r, g, b, a = 255] = expandedValue.map((hexCouple)=>parseInt(hexCouple, 16));
            return [
                r,
                g,
                b,
                a / 255
            ];
        }
    }
    /**
	* Converts a string that could be any angle notation (50deg, 0.5turn, 2rad)
	* into degrees without the 'deg' suffix
	* @param {String} value ex: 0deg, 0.5turn, 2rad
	* @return {Number} number in degrees or NaN if inputs are invalid
	*/ static parseAngletoDegrees(value) {
        const lowercase = value.toLowerCase();
        const numeric = parseFloat(lowercase);
        if (lowercase.includes("rad")) return $9a54cbcfc1af41ba$var$radiansToDegrees(numeric);
        if (lowercase.includes("turn")) return numeric * 360;
        return numeric;
    }
};
//#endregion
//#region src/util/misc/svgParsing.ts
/**
* Returns array of attributes for given svg that fabric parses
* @param {SVGElementName} type Type of svg element (eg. 'circle')
* @return {Array} string names of supported attributes
*/ const $9a54cbcfc1af41ba$var$getSvgAttributes = (type)=>{
    const commonAttributes = [
        "instantiated_by_use",
        "style",
        "id",
        "class"
    ];
    switch(type){
        case "linearGradient":
            return commonAttributes.concat([
                "x1",
                "y1",
                "x2",
                "y2",
                "gradientUnits",
                "gradientTransform"
            ]);
        case "radialGradient":
            return commonAttributes.concat([
                "gradientUnits",
                "gradientTransform",
                "cx",
                "cy",
                "r",
                "fx",
                "fy",
                "fr"
            ]);
        case "stop":
            return commonAttributes.concat([
                "offset",
                "stop-color",
                "stop-opacity"
            ]);
    }
    return commonAttributes;
};
/**
* Converts from attribute value to pixel value if applicable.
* Returns converted pixels or original value not converted.
* @param {string} value number to operate on
* @param {number} fontSize
* @return {number}
*/ const $9a54cbcfc1af41ba$var$parseUnit = (value, fontSize = 16)=>{
    const unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
    const dpi = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.DPI;
    switch(unit === null || unit === void 0 ? void 0 : unit[0]){
        case "mm":
            return number * dpi / 25.4;
        case "cm":
            return number * dpi / 2.54;
        case "in":
            return number * dpi;
        case "pt":
            return number * dpi / 72;
        case "pc":
            return number * dpi / 72 * 12;
        case "em":
            return number * fontSize;
        default:
            return number;
    }
};
const $9a54cbcfc1af41ba$var$parseAlign = (align)=>{
    if (align && align !== "none") return [
        align.slice(1, 4),
        align.slice(5, 8)
    ];
    else if (align === "none") return [
        align,
        align
    ];
    return [
        "Mid",
        "Mid"
    ];
};
/**
* Parse preserveAspectRatio attribute from element
* https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
* @param {string} attribute to be parsed
* @return {Object} an object containing align and meetOrSlice attribute
*/ const $9a54cbcfc1af41ba$var$parsePreserveAspectRatioAttribute = (attribute)=>{
    const [firstPart, secondPart] = attribute.trim().split(" ");
    const [alignX, alignY] = $9a54cbcfc1af41ba$var$parseAlign(firstPart);
    return {
        meetOrSlice: secondPart || "meet",
        alignX: alignX,
        alignY: alignY
    };
};
/**
* Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
* we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
* @param prop
* @param value
* @param {boolean} inlineStyle The default is inline style, the separator used is ":", The other is "="
* @returns
*/ const $9a54cbcfc1af41ba$var$colorPropToSVG = (prop, value, inlineStyle = true)=>{
    let colorValue;
    let opacityValue;
    if (!value) colorValue = "none";
    else if (value.toLive) colorValue = `url(#SVGID_${$9a54cbcfc1af41ba$var$escapeXml(value.id)})`;
    else {
        const color = new $9a54cbcfc1af41ba$export$892596cec99bc70e(value), opacity = color.getAlpha();
        colorValue = color.toRgb();
        if (opacity !== 1) opacityValue = opacity.toString();
    }
    if (inlineStyle) return `${prop}: ${colorValue}; ${opacityValue ? `${prop}-opacity: ${opacityValue}; ` : ""}`;
    else return `${prop}="${colorValue}" ${opacityValue ? `${prop}-opacity="${opacityValue}" ` : ""}`;
};
const $9a54cbcfc1af41ba$var$createSVGRect = (color, { left: left, top: top, width: width, height: height }, precision = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)=>{
    const svgColor = $9a54cbcfc1af41ba$var$colorPropToSVG($9a54cbcfc1af41ba$var$FILL, color, false);
    const [x, y, w, h] = [
        left,
        top,
        width,
        height
    ].map((value)=>$9a54cbcfc1af41ba$var$toFixed(value, precision));
    return `<rect ${svgColor} x="${x}" y="${y}" width="${w}" height="${h}"></rect>`;
};
//#endregion
//#region src/shapes/Object/FabricObjectSVGExportMixin.ts
var $9a54cbcfc1af41ba$var$FabricObjectSVGExportMixin = class {
    /**
	* Returns styles-string for svg-export
	* @param {Boolean} skipShadow a boolean to skip shadow filter output
	* @return {String}
	*/ getSvgStyles(skipShadow) {
        const fillRule = this.fillRule ? this.fillRule : "nonzero", strokeWidth = this.strokeWidth ? this.strokeWidth : "0", strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(" ") : $9a54cbcfc1af41ba$var$NONE, strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : "0", strokeLineCap = this.strokeLineCap ? this.strokeLineCap : "butt", strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : "miter", strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : "4", opacity = typeof this.opacity !== "undefined" ? this.opacity : "1", visibility = this.visible ? "" : " visibility: hidden;", filter = skipShadow ? "" : this.getSvgFilter(), fill = $9a54cbcfc1af41ba$var$colorPropToSVG($9a54cbcfc1af41ba$var$FILL, this.fill);
        return [
            $9a54cbcfc1af41ba$var$colorPropToSVG($9a54cbcfc1af41ba$var$STROKE, this.stroke),
            "stroke-width: ",
            strokeWidth,
            "; ",
            "stroke-dasharray: ",
            strokeDashArray,
            "; ",
            "stroke-linecap: ",
            strokeLineCap,
            "; ",
            "stroke-dashoffset: ",
            strokeDashOffset,
            "; ",
            "stroke-linejoin: ",
            strokeLineJoin,
            "; ",
            "stroke-miterlimit: ",
            strokeMiterLimit,
            "; ",
            fill,
            "fill-rule: ",
            fillRule,
            "; ",
            "opacity: ",
            opacity,
            ";",
            filter,
            visibility
        ].map((v)=>$9a54cbcfc1af41ba$var$escapeXml(v)).join("");
    }
    /**
	* Returns filter for svg shadow
	* @return {String}
	*/ getSvgFilter() {
        return this.shadow ? `filter: url(#SVGID_${$9a54cbcfc1af41ba$var$escapeXml(this.shadow.id)});` : "";
    }
    /**
	* Returns id attribute for svg output
	* @return {String}
	*/ getSvgCommons() {
        return [
            this.id ? `id="${$9a54cbcfc1af41ba$var$escapeXml(String(this.id))}" ` : "",
            this.clipPath ? `clip-path="url(#${this.clipPath.clipPathId})" ` : ""
        ].join("");
    }
    /**
	* Returns transform-string for svg-export
	* @param {Boolean} use the full transform or the single object one.
	* @return {String}
	*/ getSvgTransform(full, additionalTransform = "") {
        return `${`transform="${$9a54cbcfc1af41ba$var$matrixToSVG(full ? this.calcTransformMatrix() : this.calcOwnMatrix())}`}${additionalTransform}" `;
    }
    /**
	* Returns svg representation of an instance
	* This function is implemented in each subclass
	* This is just because typescript otherwise cryies all the time
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG(_reviver) {
        return [
            ""
        ];
    }
    /**
	* Returns svg representation of an instance
	* @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
	* @return {String} svg representation of an instance
	*/ toSVG(reviver) {
        return this._createBaseSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
	* Returns svg clipPath representation of an instance
	* @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
	* @return {String} svg representation of an instance
	*/ toClipPathSVG(reviver) {
        return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
	* @private
	*/ _createBaseClipPathSVGMarkup(objectMarkup, { reviver: reviver, additionalTransform: additionalTransform = "" } = {}) {
        const commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons()
        ].join(""), index = objectMarkup.indexOf("COMMON_PARTS");
        objectMarkup[index] = commonPieces;
        return reviver ? reviver(objectMarkup.join("")) : objectMarkup.join("");
    }
    /**
	* @private
	*/ _createBaseSVGMarkup(objectMarkup, { noStyle: noStyle, reviver: reviver, withShadow: withShadow, additionalTransform: additionalTransform } = {}) {
        const styleInfo = noStyle ? "" : `style="${this.getSvgStyles()}" `, shadowInfo = withShadow ? `style="${this.getSvgFilter()}" ` : "", clipPath = this.clipPath, vectorEffect = this.strokeUniform ? "vector-effect=\"non-scaling-stroke\" " : "", absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, markup = [], index = objectMarkup.indexOf("COMMON_PARTS");
        let clipPathMarkup;
        if (clipPath) {
            clipPath.clipPathId = `CLIPPATH_${$9a54cbcfc1af41ba$var$uid()}`;
            clipPathMarkup = `<clipPath id="${clipPath.clipPathId}" >\n${clipPath.toClipPathSVG(reviver)}</clipPath>\n`;
        }
        if (absoluteClipPath) markup.push("<g ", shadowInfo, this.getSvgCommons(), " >\n");
        markup.push("<g ", this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : "", " >\n");
        objectMarkup[index] = [
            styleInfo,
            vectorEffect,
            noStyle ? "" : this.addPaintOrder(),
            " ",
            additionalTransform ? `transform="${additionalTransform}" ` : ""
        ].join("");
        if ($9a54cbcfc1af41ba$var$isFiller(fill)) markup.push(fill.toSVG(this));
        if ($9a54cbcfc1af41ba$var$isFiller(stroke)) markup.push(stroke.toSVG(this));
        if (shadow) markup.push(shadow.toSVG(this));
        if (clipPath) markup.push(clipPathMarkup);
        markup.push(objectMarkup.join(""));
        markup.push("</g>\n");
        absoluteClipPath && markup.push("</g>\n");
        return reviver ? reviver(markup.join("")) : markup.join("");
    }
    addPaintOrder() {
        return this.paintFirst !== "fill" ? ` paint-order="${$9a54cbcfc1af41ba$var$escapeXml(this.paintFirst)}" ` : "";
    }
};
//#endregion
//#region src/parser/getSvgRegex.ts
function $9a54cbcfc1af41ba$var$getSvgRegex(arr) {
    return new RegExp("^(" + arr.join("|") + ")\\b", "i");
}
//#endregion
//#region src/shapes/Text/constants.ts
const $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS = "textDecorationThickness";
const $9a54cbcfc1af41ba$var$TEXT_DECORATION_COLOR = "textDecorationColor";
const $9a54cbcfc1af41ba$var$fontProperties = [
    "fontSize",
    "fontWeight",
    "fontFamily",
    "fontStyle"
];
const $9a54cbcfc1af41ba$var$textDecorationProperties = [
    "underline",
    "overline",
    "linethrough"
];
const $9a54cbcfc1af41ba$var$textLayoutProperties = [
    ...$9a54cbcfc1af41ba$var$fontProperties,
    "lineHeight",
    "text",
    "charSpacing",
    "textAlign",
    "styles",
    "path",
    "pathStartOffset",
    "pathSide",
    "pathAlign"
];
const $9a54cbcfc1af41ba$var$additionalProps = [
    ...$9a54cbcfc1af41ba$var$textLayoutProperties,
    ...$9a54cbcfc1af41ba$var$textDecorationProperties,
    "textBackgroundColor",
    "direction",
    $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS,
    $9a54cbcfc1af41ba$var$TEXT_DECORATION_COLOR
];
const $9a54cbcfc1af41ba$var$styleProperties = [
    ...$9a54cbcfc1af41ba$var$fontProperties,
    ...$9a54cbcfc1af41ba$var$textDecorationProperties,
    $9a54cbcfc1af41ba$var$STROKE,
    "strokeWidth",
    $9a54cbcfc1af41ba$var$FILL,
    "deltaY",
    "textBackgroundColor",
    $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS,
    $9a54cbcfc1af41ba$var$TEXT_DECORATION_COLOR
];
const $9a54cbcfc1af41ba$var$textDefaultValues = {
    _reNewline: $9a54cbcfc1af41ba$var$reNewline,
    _reSpacesAndTabs: /[ \t\r]/g,
    _reSpaceAndTab: /[ \t\r]/,
    _reWords: /\S+/g,
    fontSize: 40,
    fontWeight: $9a54cbcfc1af41ba$var$NORMAL,
    fontFamily: "Times New Roman",
    underline: false,
    overline: false,
    linethrough: false,
    textAlign: $9a54cbcfc1af41ba$var$LEFT,
    fontStyle: $9a54cbcfc1af41ba$var$NORMAL,
    lineHeight: 1.16,
    textBackgroundColor: "",
    stroke: null,
    shadow: null,
    path: void 0,
    pathStartOffset: 0,
    pathSide: $9a54cbcfc1af41ba$var$LEFT,
    pathAlign: "baseline",
    charSpacing: 0,
    deltaY: 0,
    direction: "ltr",
    CACHE_FONT_SIZE: 400,
    MIN_TEXT_WIDTH: 2,
    superscript: {
        size: .6,
        baseline: -0.35
    },
    subscript: {
        size: .6,
        baseline: .11
    },
    _fontSizeFraction: .222,
    offsets: {
        underline: .1,
        linethrough: -0.28167,
        overline: -0.81333
    },
    _fontSizeMult: 1.13,
    [$9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS]: 66.667
};
const $9a54cbcfc1af41ba$var$JUSTIFY = "justify";
//#endregion
//#region src/parser/constants.ts
const $9a54cbcfc1af41ba$var$reNum = String.raw`[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?`;
const $9a54cbcfc1af41ba$var$viewportSeparator = String.raw`(?:\s*,?\s+|\s*,\s*)`;
const $9a54cbcfc1af41ba$var$svgNS = "http://www.w3.org/2000/svg";
const $9a54cbcfc1af41ba$var$reFontDeclaration = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + $9a54cbcfc1af41ba$var$reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + $9a54cbcfc1af41ba$var$reNum + "))?\\s+(.*)");
const $9a54cbcfc1af41ba$var$svgValidTagNames = [
    "path",
    "circle",
    "polygon",
    "polyline",
    "ellipse",
    "rect",
    "line",
    "image",
    "text"
];
const $9a54cbcfc1af41ba$var$svgViewBoxElements = [
    "symbol",
    "image",
    "marker",
    "pattern",
    "view",
    "svg"
];
const $9a54cbcfc1af41ba$var$svgInvalidAncestors = [
    "pattern",
    "defs",
    "symbol",
    "metadata",
    "clipPath",
    "mask",
    "desc"
];
const $9a54cbcfc1af41ba$var$svgValidParents = [
    "symbol",
    "g",
    "a",
    "svg",
    "clipPath",
    "defs"
];
const $9a54cbcfc1af41ba$var$attributesMap = {
    cx: $9a54cbcfc1af41ba$var$LEFT,
    x: $9a54cbcfc1af41ba$var$LEFT,
    r: "radius",
    cy: "top",
    y: "top",
    display: "visible",
    visibility: "visible",
    transform: "transformMatrix",
    "fill-opacity": "fillOpacity",
    "fill-rule": "fillRule",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "letter-spacing": "charSpacing",
    "paint-order": "paintFirst",
    "stroke-dasharray": "strokeDashArray",
    "stroke-dashoffset": "strokeDashOffset",
    "stroke-linecap": "strokeLineCap",
    "stroke-linejoin": "strokeLineJoin",
    "stroke-miterlimit": "strokeMiterLimit",
    "stroke-opacity": "strokeOpacity",
    "stroke-width": "strokeWidth",
    "text-decoration": "textDecoration",
    "text-anchor": "textAnchor",
    opacity: "opacity",
    "clip-path": "clipPath",
    "clip-rule": "clipRule",
    "vector-effect": "strokeUniform",
    "image-rendering": "imageSmoothing",
    "text-decoration-thickness": $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS,
    "text-decoration-color": $9a54cbcfc1af41ba$var$TEXT_DECORATION_COLOR
};
const $9a54cbcfc1af41ba$var$fSize = "font-size";
const $9a54cbcfc1af41ba$var$cPath = "clip-path";
const $9a54cbcfc1af41ba$var$svgValidTagNamesRegEx = $9a54cbcfc1af41ba$var$getSvgRegex($9a54cbcfc1af41ba$var$svgValidTagNames);
const $9a54cbcfc1af41ba$var$svgViewBoxElementsRegEx = $9a54cbcfc1af41ba$var$getSvgRegex($9a54cbcfc1af41ba$var$svgViewBoxElements);
const $9a54cbcfc1af41ba$var$svgValidParentsRegEx = $9a54cbcfc1af41ba$var$getSvgRegex($9a54cbcfc1af41ba$var$svgValidParents);
const $9a54cbcfc1af41ba$var$reViewBoxAttrValue = new RegExp(String.raw`^\s*(${$9a54cbcfc1af41ba$var$reNum})${$9a54cbcfc1af41ba$var$viewportSeparator}(${$9a54cbcfc1af41ba$var$reNum})${$9a54cbcfc1af41ba$var$viewportSeparator}(${$9a54cbcfc1af41ba$var$reNum})${$9a54cbcfc1af41ba$var$viewportSeparator}(${$9a54cbcfc1af41ba$var$reNum})\s*$`);
//#endregion
//#region src/Shadow.ts
/**
* Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
* - (?:\s|^): This part captures either a whitespace character (\s) or the beginning of a line (^). It's non-capturing (due to (?:...)), meaning it doesn't create a capturing group.
* - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: This captures the first component of the shadow, which is the horizontal offset. Breaking it down:
*   - (-?\d+): Captures an optional minus sign followed by one or more digits (integer part of the number).
*   - (?:\.\d*)?: Optionally captures a decimal point followed by zero or more digits (decimal part of the number).
*   - (?:px)?: Optionally captures the "px" unit.
*   - (?:\s?|$): Captures either an optional whitespace or the end of the line. This whole part is wrapped in a non-capturing group and marked as optional with ?.
* - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: Similar to the previous step, this captures the vertical offset.

(\d+(?:\.\d*)?(?:px)?)?: This captures the blur radius. It's similar to the horizontal offset but without the optional minus sign.

(?:\s+(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?){0,1}: This captures an optional part for the color. It allows for whitespace followed by a component with an optional minus sign, digits, decimal point, and "px" unit.

(?:$|\s): This captures either the end of the line or a whitespace character. It ensures that the match ends either at the end of the string or with a whitespace character.
*/ const $9a54cbcfc1af41ba$var$shadowOffsetRegex = "(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?";
const $9a54cbcfc1af41ba$var$reOffsetsAndBlur = new RegExp("(?:\\s|^)" + $9a54cbcfc1af41ba$var$shadowOffsetRegex + $9a54cbcfc1af41ba$var$shadowOffsetRegex + "(" + $9a54cbcfc1af41ba$var$reNum + "?(?:px)?)?(?:\\s?|$)(?:$|\\s)");
const $9a54cbcfc1af41ba$var$shadowDefaultValues = {
    color: "rgb(0,0,0)",
    blur: 0,
    offsetX: 0,
    offsetY: 0,
    affectStroke: false,
    includeDefaultValues: true,
    nonScaling: false
};
var $9a54cbcfc1af41ba$export$a24c14443968327c = class Shadow {
    constructor(arg0 = {}){
        const options = typeof arg0 === "string" ? Shadow.parseShadow(arg0) : arg0;
        Object.assign(this, Shadow.ownDefaults, options);
        this.id = $9a54cbcfc1af41ba$var$uid();
    }
    /**
	* @param {String} value Shadow value to parse
	* @return {Object} Shadow object with color, offsetX, offsetY and blur
	*/ static parseShadow(value) {
        const shadowStr = value.trim(), [, offsetX = 0, offsetY = 0, blur = 0] = ($9a54cbcfc1af41ba$var$reOffsetsAndBlur.exec(shadowStr) || []).map((value)=>parseFloat(value) || 0);
        return {
            color: (shadowStr.replace($9a54cbcfc1af41ba$var$reOffsetsAndBlur, "") || "rgb(0,0,0)").trim(),
            offsetX: offsetX,
            offsetY: offsetY,
            blur: blur
        };
    }
    /**
	* Returns a string representation of an instance
	* @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
	* @return {String} Returns CSS3 text-shadow declaration
	*/ toString() {
        return [
            this.offsetX,
            this.offsetY,
            this.blur,
            this.color
        ].join("px ");
    }
    /**
	* Returns SVG representation of a shadow
	* @param {FabricObject} object
	* @return {String} SVG representation of a shadow
	*/ toSVG(object) {
        const offset = $9a54cbcfc1af41ba$var$rotateVector(new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.offsetX, this.offsetY), $9a54cbcfc1af41ba$var$degreesToRadians(-object.angle)), BLUR_BOX = 20, NUM_FRACTION_DIGITS = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS, color = new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color);
        let fBoxX = 40, fBoxY = 40;
        if (object.width && object.height) {
            fBoxX = $9a54cbcfc1af41ba$var$toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            fBoxY = $9a54cbcfc1af41ba$var$toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        }
        if (object.flipX) offset.x *= -1;
        if (object.flipY) offset.y *= -1;
        return `<filter id="SVGID_${$9a54cbcfc1af41ba$var$escapeXml(this.id)}" y="-${fBoxY}%" height="${100 + 2 * fBoxY}%" x="-${fBoxX}%" width="${100 + 2 * fBoxX}%" >\n\t<feGaussianBlur in="SourceAlpha" stdDeviation="${$9a54cbcfc1af41ba$var$toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS)}"></feGaussianBlur>\n\t<feOffset dx="${$9a54cbcfc1af41ba$var$toFixed(offset.x, NUM_FRACTION_DIGITS)}" dy="${$9a54cbcfc1af41ba$var$toFixed(offset.y, NUM_FRACTION_DIGITS)}" result="oBlur" ></feOffset>\n\t<feFlood flood-color="${color.toRgb()}" flood-opacity="${color.getAlpha()}"/>\n\t<feComposite in2="oBlur" operator="in" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n\t</feMerge>\n</filter>\n`;
    }
    /**
	* Returns object representation of a shadow
	* @return {Object} Object representation of a shadow instance
	*/ toObject() {
        const data = {
            color: this.color,
            blur: this.blur,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            affectStroke: this.affectStroke,
            nonScaling: this.nonScaling,
            type: this.constructor.type
        };
        const defaults = Shadow.ownDefaults;
        return !this.includeDefaultValues ? $9a54cbcfc1af41ba$var$pickBy(data, (value, key)=>value !== defaults[key]) : data;
    }
    static async fromObject(options) {
        return new this(options);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$a24c14443968327c, "ownDefaults", $9a54cbcfc1af41ba$var$shadowDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$a24c14443968327c, "type", "shadow");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$a24c14443968327c, "shadow");
//#endregion
//#region src/util/misc/capValue.ts
const $9a54cbcfc1af41ba$var$capValue = (min, value, max)=>Math.max(min, Math.min(value, max));
//#endregion
//#region src/shapes/Object/defaultValues.ts
const $9a54cbcfc1af41ba$var$stateProperties = [
    "top",
    $9a54cbcfc1af41ba$var$LEFT,
    $9a54cbcfc1af41ba$var$SCALE_X,
    $9a54cbcfc1af41ba$var$SCALE_Y,
    "flipX",
    "flipY",
    "originX",
    "originY",
    "angle",
    "opacity",
    "globalCompositeOperation",
    "shadow",
    "visible",
    $9a54cbcfc1af41ba$var$SKEW_X,
    $9a54cbcfc1af41ba$var$SKEW_Y
];
const $9a54cbcfc1af41ba$var$cacheProperties = [
    $9a54cbcfc1af41ba$var$FILL,
    $9a54cbcfc1af41ba$var$STROKE,
    "strokeWidth",
    "strokeDashArray",
    "width",
    "height",
    "paintFirst",
    "strokeUniform",
    "strokeLineCap",
    "strokeDashOffset",
    "strokeLineJoin",
    "strokeMiterLimit",
    "backgroundColor",
    "clipPath"
];
const $9a54cbcfc1af41ba$var$fabricObjectDefaultValues = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    angle: 0,
    flipX: false,
    flipY: false,
    scaleX: 1,
    scaleY: 1,
    minScaleLimit: 0,
    skewX: 0,
    skewY: 0,
    originX: $9a54cbcfc1af41ba$var$CENTER,
    originY: $9a54cbcfc1af41ba$var$CENTER,
    strokeWidth: 1,
    strokeUniform: false,
    padding: 0,
    opacity: 1,
    paintFirst: $9a54cbcfc1af41ba$var$FILL,
    fill: "rgb(0,0,0)",
    fillRule: "nonzero",
    stroke: null,
    strokeDashArray: null,
    strokeDashOffset: 0,
    strokeLineCap: "butt",
    strokeLineJoin: "miter",
    strokeMiterLimit: 4,
    globalCompositeOperation: "source-over",
    backgroundColor: "",
    shadow: null,
    visible: true,
    includeDefaultValues: true,
    excludeFromExport: false,
    objectCaching: true,
    clipPath: void 0,
    inverted: false,
    absolutePositioned: false,
    centeredRotation: true,
    centeredScaling: false,
    dirty: true
};
const $9a54cbcfc1af41ba$var$interactiveObjectDefaultValues = {
    noScaleCache: true,
    lockMovementX: false,
    lockMovementY: false,
    lockRotation: false,
    lockScalingX: false,
    lockScalingY: false,
    lockSkewingX: false,
    lockSkewingY: false,
    lockScalingFlip: false,
    cornerSize: 13,
    touchCornerSize: 24,
    transparentCorners: true,
    cornerColor: "rgb(178,204,255)",
    cornerStrokeColor: "",
    cornerStyle: "rect",
    cornerDashArray: null,
    hasControls: true,
    borderColor: "rgb(178,204,255)",
    borderDashArray: null,
    borderOpacityWhenMoving: .4,
    borderScaleFactor: 1,
    hasBorders: true,
    selectionBackgroundColor: "",
    selectable: true,
    evented: true,
    perPixelTargetFind: false,
    activeOn: "down",
    hoverCursor: null,
    moveCursor: null
};
//#endregion
//#region src/util/animation/easing.ts
/**
* Easing functions
* @see {@link http://gizma.com/easing/ Easing Equations by Robert Penner}
*/ var $9a54cbcfc1af41ba$var$easing_exports = /* @__PURE__ */ $9a54cbcfc1af41ba$var$__exportAll({
    defaultEasing: ()=>$9a54cbcfc1af41ba$var$defaultEasing,
    easeInBack: ()=>$9a54cbcfc1af41ba$var$easeInBack,
    easeInBounce: ()=>$9a54cbcfc1af41ba$var$easeInBounce,
    easeInCirc: ()=>$9a54cbcfc1af41ba$var$easeInCirc,
    easeInCubic: ()=>$9a54cbcfc1af41ba$var$easeInCubic,
    easeInElastic: ()=>$9a54cbcfc1af41ba$var$easeInElastic,
    easeInExpo: ()=>$9a54cbcfc1af41ba$var$easeInExpo,
    easeInOutBack: ()=>$9a54cbcfc1af41ba$var$easeInOutBack,
    easeInOutBounce: ()=>$9a54cbcfc1af41ba$var$easeInOutBounce,
    easeInOutCirc: ()=>$9a54cbcfc1af41ba$var$easeInOutCirc,
    easeInOutCubic: ()=>$9a54cbcfc1af41ba$var$easeInOutCubic,
    easeInOutElastic: ()=>$9a54cbcfc1af41ba$var$easeInOutElastic,
    easeInOutExpo: ()=>$9a54cbcfc1af41ba$var$easeInOutExpo,
    easeInOutQuad: ()=>$9a54cbcfc1af41ba$var$easeInOutQuad,
    easeInOutQuart: ()=>$9a54cbcfc1af41ba$var$easeInOutQuart,
    easeInOutQuint: ()=>$9a54cbcfc1af41ba$var$easeInOutQuint,
    easeInOutSine: ()=>$9a54cbcfc1af41ba$var$easeInOutSine,
    easeInQuad: ()=>$9a54cbcfc1af41ba$var$easeInQuad,
    easeInQuart: ()=>$9a54cbcfc1af41ba$var$easeInQuart,
    easeInQuint: ()=>$9a54cbcfc1af41ba$var$easeInQuint,
    easeInSine: ()=>$9a54cbcfc1af41ba$var$easeInSine,
    easeOutBack: ()=>$9a54cbcfc1af41ba$var$easeOutBack,
    easeOutBounce: ()=>$9a54cbcfc1af41ba$var$easeOutBounce,
    easeOutCirc: ()=>$9a54cbcfc1af41ba$var$easeOutCirc,
    easeOutCubic: ()=>$9a54cbcfc1af41ba$var$easeOutCubic,
    easeOutElastic: ()=>$9a54cbcfc1af41ba$var$easeOutElastic,
    easeOutExpo: ()=>$9a54cbcfc1af41ba$var$easeOutExpo,
    easeOutQuad: ()=>$9a54cbcfc1af41ba$var$easeOutQuad,
    easeOutQuart: ()=>$9a54cbcfc1af41ba$var$easeOutQuart,
    easeOutQuint: ()=>$9a54cbcfc1af41ba$var$easeOutQuint,
    easeOutSine: ()=>$9a54cbcfc1af41ba$var$easeOutSine
});
const $9a54cbcfc1af41ba$var$normalize = (a, c, p, s)=>{
    if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
    } else if (c === 0 && a === 0) s = p / $9a54cbcfc1af41ba$var$twoMathPi * Math.asin(1);
    else s = p / $9a54cbcfc1af41ba$var$twoMathPi * Math.asin(c / a);
    return {
        a: a,
        c: c,
        p: p,
        s: s
    };
};
const $9a54cbcfc1af41ba$var$elastic = (a, s, p, t, d)=>a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * $9a54cbcfc1af41ba$var$twoMathPi / p);
/**
* Default sinusoidal easing
*/ const $9a54cbcfc1af41ba$var$defaultEasing = (t, b, c, d)=>-c * Math.cos(t / d * $9a54cbcfc1af41ba$var$halfPI) + c + b;
/**
* Cubic easing in
*/ const $9a54cbcfc1af41ba$var$easeInCubic = (t, b, c, d)=>c * (t / d) ** 3 + b;
/**
* Cubic easing out
*/ const $9a54cbcfc1af41ba$var$easeOutCubic = (t, b, c, d)=>c * ((t / d - 1) ** 3 + 1) + b;
/**
* Cubic easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutCubic = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 3 + b;
    return c / 2 * ((t - 2) ** 3 + 2) + b;
};
/**
* Quartic easing in
*/ const $9a54cbcfc1af41ba$var$easeInQuart = (t, b, c, d)=>c * (t /= d) * t ** 3 + b;
/**
* Quartic easing out
*/ const $9a54cbcfc1af41ba$var$easeOutQuart = (t, b, c, d)=>-c * ((t = t / d - 1) * t ** 3 - 1) + b;
/**
* Quartic easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutQuart = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 4 + b;
    return -c / 2 * ((t -= 2) * t ** 3 - 2) + b;
};
/**
* Quintic easing in
*/ const $9a54cbcfc1af41ba$var$easeInQuint = (t, b, c, d)=>c * (t / d) ** 5 + b;
/**
* Quintic easing out
*/ const $9a54cbcfc1af41ba$var$easeOutQuint = (t, b, c, d)=>c * ((t / d - 1) ** 5 + 1) + b;
/**
* Quintic easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutQuint = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 5 + b;
    return c / 2 * ((t - 2) ** 5 + 2) + b;
};
/**
* Sinusoidal easing in
*/ const $9a54cbcfc1af41ba$var$easeInSine = (t, b, c, d)=>-c * Math.cos(t / d * $9a54cbcfc1af41ba$var$halfPI) + c + b;
/**
* Sinusoidal easing out
*/ const $9a54cbcfc1af41ba$var$easeOutSine = (t, b, c, d)=>c * Math.sin(t / d * $9a54cbcfc1af41ba$var$halfPI) + b;
/**
* Sinusoidal easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutSine = (t, b, c, d)=>-c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
/**
* Exponential easing in
*/ const $9a54cbcfc1af41ba$var$easeInExpo = (t, b, c, d)=>t === 0 ? b : c * 2 ** (10 * (t / d - 1)) + b;
/**
* Exponential easing out
*/ const $9a54cbcfc1af41ba$var$easeOutExpo = (t, b, c, d)=>t === d ? b + c : c * -(2 ** (-10 * t / d) + 1) + b;
/**
* Exponential easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutExpo = (t, b, c, d)=>{
    if (t === 0) return b;
    if (t === d) return b + c;
    t /= d / 2;
    if (t < 1) return c / 2 * 2 ** (10 * (t - 1)) + b;
    return c / 2 * -(2 ** (-10 * --t) + 2) + b;
};
/**
* Circular easing in
*/ const $9a54cbcfc1af41ba$var$easeInCirc = (t, b, c, d)=>-c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
/**
* Circular easing out
*/ const $9a54cbcfc1af41ba$var$easeOutCirc = (t, b, c, d)=>c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
/**
* Circular easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutCirc = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return -c / 2 * (Math.sqrt(1 - t ** 2) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
};
/**
* Elastic easing in
*/ const $9a54cbcfc1af41ba$var$easeInElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * .3;
    const { a: normA, s: normS, p: normP } = $9a54cbcfc1af41ba$var$normalize(a, c, p, s);
    return -$9a54cbcfc1af41ba$var$elastic(normA, normS, normP, t, d) + b;
};
/**
* Elastic easing out
*/ const $9a54cbcfc1af41ba$var$easeOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * .3;
    const { a: normA, s: normS, p: normP, c: normC } = $9a54cbcfc1af41ba$var$normalize(a, c, p, s);
    return normA * 2 ** (-10 * t) * Math.sin((t * d - normS) * $9a54cbcfc1af41ba$var$twoMathPi / normP) + normC + b;
};
/**
* Elastic easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d / 2;
    if (t === 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    const { a: normA, s: normS, p: normP, c: normC } = $9a54cbcfc1af41ba$var$normalize(a, c, p, s);
    if (t < 1) return -0.5 * $9a54cbcfc1af41ba$var$elastic(normA, normS, normP, t, d) + b;
    return normA * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - normS) * $9a54cbcfc1af41ba$var$twoMathPi / normP) * .5 + normC + b;
};
/**
* Backwards easing in
*/ const $9a54cbcfc1af41ba$var$easeInBack = (t, b, c, d, s = 1.70158)=>c * (t /= d) * t * ((s + 1) * t - s) + b;
/**
* Backwards easing out
*/ const $9a54cbcfc1af41ba$var$easeOutBack = (t, b, c, d, s = 1.70158)=>c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
/**
* Backwards easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutBack = (t, b, c, d, s = 1.70158)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
};
/**
* Bouncing easing out
*/ const $9a54cbcfc1af41ba$var$easeOutBounce = (t, b, c, d)=>{
    if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
    else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
    else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
    else return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
};
/**
* Bouncing easing in
*/ const $9a54cbcfc1af41ba$var$easeInBounce = (t, b, c, d)=>c - $9a54cbcfc1af41ba$var$easeOutBounce(d - t, 0, c, d) + b;
/**
* Bouncing easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutBounce = (t, b, c, d)=>t < d / 2 ? $9a54cbcfc1af41ba$var$easeInBounce(t * 2, 0, c, d) * .5 + b : $9a54cbcfc1af41ba$var$easeOutBounce(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
/**
* Quadratic easing in
*/ const $9a54cbcfc1af41ba$var$easeInQuad = (t, b, c, d)=>c * (t /= d) * t + b;
/**
* Quadratic easing out
*/ const $9a54cbcfc1af41ba$var$easeOutQuad = (t, b, c, d)=>-c * (t /= d) * (t - 2) + b;
/**
* Quadratic easing in and out
*/ const $9a54cbcfc1af41ba$var$easeInOutQuad = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 2 + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
};
//#endregion
//#region src/util/animation/AnimationBase.ts
const $9a54cbcfc1af41ba$var$defaultAbort = ()=>false;
var $9a54cbcfc1af41ba$var$AnimationBase = class {
    constructor({ startValue: startValue, byValue: byValue, duration: duration = 500, delay: delay = 0, easing: easing = $9a54cbcfc1af41ba$var$defaultEasing, onStart: onStart = $9a54cbcfc1af41ba$var$noop, onChange: onChange = $9a54cbcfc1af41ba$var$noop, onComplete: onComplete = $9a54cbcfc1af41ba$var$noop, abort: abort = $9a54cbcfc1af41ba$var$defaultAbort, target: target }){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_state", "pending");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Time %, or the ratio of `timeElapsed / duration`
			* @see tick
			*/ "durationProgress", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Value %, or the ratio of `(currentValue - startValue) / (endValue - startValue)`
			*/ "valueProgress", 0);
        this.tick = this.tick.bind(this);
        this.duration = duration;
        this.delay = delay;
        this.easing = easing;
        this._onStart = onStart;
        this._onChange = onChange;
        this._onComplete = onComplete;
        this._abort = abort;
        this.target = target;
        this.startValue = startValue;
        this.byValue = byValue;
        this.value = this.startValue;
        this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
    get state() {
        return this._state;
    }
    isDone() {
        return this._state === "aborted" || this._state === "completed";
    }
    start() {
        const firstTick = (timestamp)=>{
            if (this._state !== "pending") return;
            this.startTime = timestamp || +/* @__PURE__ */ new Date();
            this._state = "running";
            this._onStart();
            this.tick(this.startTime);
        };
        this.register();
        if (this.delay > 0) this.timeout = $9a54cbcfc1af41ba$export$4a3a3142573970c3().setTimeout(()=>$9a54cbcfc1af41ba$var$requestAnimFrame(firstTick), this.delay);
        else $9a54cbcfc1af41ba$var$requestAnimFrame(firstTick);
    }
    tick(t) {
        const durationMs = (t || +/* @__PURE__ */ new Date()) - this.startTime;
        const boundDurationMs = Math.min(durationMs, this.duration);
        this.durationProgress = boundDurationMs / this.duration;
        const { value: value, valueProgress: valueProgress } = this.calculate(boundDurationMs);
        this.value = Object.freeze(value);
        this.valueProgress = valueProgress;
        if (this._state === "aborted") return;
        else if (this._abort(this.value, this.valueProgress, this.durationProgress)) {
            this._state = "aborted";
            this.unregister();
        } else if (durationMs >= this.duration) {
            this.durationProgress = this.valueProgress = 1;
            this._onChange(this.endValue, this.valueProgress, this.durationProgress);
            this._state = "completed";
            this._onComplete(this.endValue, this.valueProgress, this.durationProgress);
            this.unregister();
            this.timeout = null;
        } else {
            this._onChange(this.value, this.valueProgress, this.durationProgress);
            $9a54cbcfc1af41ba$var$requestAnimFrame(this.tick);
        }
    }
    register() {
        $9a54cbcfc1af41ba$export$dc18923894d9e56a.push(this);
    }
    unregister() {
        $9a54cbcfc1af41ba$export$dc18923894d9e56a.remove(this);
    }
    abort() {
        this._state = "aborted";
        this.unregister();
        this.timeout && $9a54cbcfc1af41ba$export$4a3a3142573970c3().clearTimeout(this.timeout);
    }
};
//#endregion
//#region src/util/animation/ValueAnimation.ts
var $9a54cbcfc1af41ba$var$ValueAnimation = class extends $9a54cbcfc1af41ba$var$AnimationBase {
    constructor({ startValue: startValue = 0, endValue: endValue = 100, ...otherOptions }){
        super({
            ...otherOptions,
            startValue: startValue,
            byValue: endValue - startValue
        });
    }
    calculate(timeElapsed) {
        const value = this.easing(timeElapsed, this.startValue, this.byValue, this.duration);
        return {
            value: value,
            valueProgress: Math.abs((value - this.startValue) / this.byValue)
        };
    }
};
//#endregion
//#region src/util/animation/ArrayAnimation.ts
var $9a54cbcfc1af41ba$var$ArrayAnimation = class extends $9a54cbcfc1af41ba$var$AnimationBase {
    constructor({ startValue: startValue = [
        0
    ], endValue: endValue = [
        100
    ], ...options }){
        super({
            ...options,
            startValue: startValue,
            byValue: endValue.map((value, i)=>value - startValue[i])
        });
    }
    calculate(timeElapsed) {
        const values = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        return {
            value: values,
            valueProgress: Math.abs((values[0] - this.startValue[0]) / this.byValue[0])
        };
    }
};
//#endregion
//#region src/util/animation/ColorAnimation.ts
const $9a54cbcfc1af41ba$var$defaultColorEasing = (timeElapsed, startValue, byValue, duration)=>{
    return startValue + byValue * (1 - Math.cos(timeElapsed / duration * $9a54cbcfc1af41ba$var$halfPI));
};
const $9a54cbcfc1af41ba$var$wrapColorCallback = (callback)=>callback && ((rgba, valueProgress, durationProgress)=>callback(new $9a54cbcfc1af41ba$export$892596cec99bc70e(rgba).toRgba(), valueProgress, durationProgress));
var $9a54cbcfc1af41ba$var$ColorAnimation = class extends $9a54cbcfc1af41ba$var$AnimationBase {
    constructor({ startValue: startValue, endValue: endValue, easing: easing = $9a54cbcfc1af41ba$var$defaultColorEasing, onChange: onChange, onComplete: onComplete, abort: abort, ...options }){
        const startColor = new $9a54cbcfc1af41ba$export$892596cec99bc70e(startValue).getSource();
        const endColor = new $9a54cbcfc1af41ba$export$892596cec99bc70e(endValue).getSource();
        super({
            ...options,
            startValue: startColor,
            byValue: endColor.map((value, i)=>value - startColor[i]),
            easing: easing,
            onChange: $9a54cbcfc1af41ba$var$wrapColorCallback(onChange),
            onComplete: $9a54cbcfc1af41ba$var$wrapColorCallback(onComplete),
            abort: $9a54cbcfc1af41ba$var$wrapColorCallback(abort)
        });
    }
    calculate(timeElapsed) {
        const [r, g, b, a] = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        const value = [
            ...[
                r,
                g,
                b
            ].map(Math.round),
            $9a54cbcfc1af41ba$var$capValue(0, a, 1)
        ];
        return {
            value: value,
            valueProgress: value.map((p, i)=>this.byValue[i] !== 0 ? Math.abs((p - this.startValue[i]) / this.byValue[i]) : 0).find((p)=>p !== 0) || 0
        };
    }
};
//#endregion
//#region src/util/animation/animate.ts
const $9a54cbcfc1af41ba$var$isArrayAnimation = (options)=>{
    return Array.isArray(options.startValue) || Array.isArray(options.endValue);
};
function $9a54cbcfc1af41ba$var$animate(options) {
    const animation = $9a54cbcfc1af41ba$var$isArrayAnimation(options) ? new $9a54cbcfc1af41ba$var$ArrayAnimation(options) : new $9a54cbcfc1af41ba$var$ValueAnimation(options);
    animation.start();
    return animation;
}
function $9a54cbcfc1af41ba$var$animateColor(options) {
    const animation = new $9a54cbcfc1af41ba$var$ColorAnimation(options);
    animation.start();
    return animation;
}
//#endregion
//#region src/Intersection.ts
var $9a54cbcfc1af41ba$export$869c896bf338bf5a = class Intersection {
    constructor(status){
        this.status = status;
        this.points = [];
    }
    /**
	* Used to verify if a point is alredy in the collection
	* @param {Point} point
	* @returns {boolean}
	*/ includes(point) {
        return this.points.some((p)=>p.eq(point));
    }
    /**
	* Appends points of intersection
	* @param {...Point[]} points
	* @return {Intersection} thisArg
	*/ append(...points) {
        this.points = this.points.concat(points.filter((point)=>{
            return !this.includes(point);
        }));
        return this;
    }
    /**
	* check if point T is on the segment or line defined between A and B
	*
	* @param {Point} T the point we are checking for
	* @param {Point} A one extremity of the segment
	* @param {Point} B the other extremity of the segment
	* @param [infinite] if true checks if `T` is on the line defined by `A` and `B`
	* @returns true if `T` is contained
	*/ static isPointContained(T, A, B, infinite = false) {
        if (A.eq(B)) return T.eq(A);
        else if (A.x === B.x) return T.x === A.x && (infinite || T.y >= Math.min(A.y, B.y) && T.y <= Math.max(A.y, B.y));
        else if (A.y === B.y) return T.y === A.y && (infinite || T.x >= Math.min(A.x, B.x) && T.x <= Math.max(A.x, B.x));
        else {
            const AB = $9a54cbcfc1af41ba$var$createVector(A, B);
            const s = $9a54cbcfc1af41ba$var$createVector(A, T).divide(AB);
            return infinite ? Math.abs(s.x) === Math.abs(s.y) : s.x === s.y && s.x >= 0 && s.x <= 1;
        }
    }
    /**
	* Use the ray casting algorithm to determine if point is in the polygon defined by points
	* @see https://en.wikipedia.org/wiki/Point_in_polygon
	* @param point
	* @param points polygon points
	* @returns
	*/ static isPointInPolygon(point, points) {
        const other = new $9a54cbcfc1af41ba$export$baf26146a414f24a(point).setX(Math.min(point.x - 1, ...points.map((p)=>p.x)));
        let hits = 0;
        for(let index = 0; index < points.length; index++){
            const inter = this.intersectSegmentSegment(points[index], points[(index + 1) % points.length], point, other);
            if (inter.includes(point)) return true;
            hits += Number(inter.status === "Intersection");
        }
        return hits % 2 === 1;
    }
    /**
	* Checks if a line intersects another
	* @see {@link https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection line intersection}
	* @see {@link https://en.wikipedia.org/wiki/Cramer%27s_rule Cramer's rule}
	* @param {Point} a1
	* @param {Point} a2
	* @param {Point} b1
	* @param {Point} b2
	* @param {boolean} [aInfinite=true] check segment intersection by passing `false`
	* @param {boolean} [bInfinite=true] check segment intersection by passing `false`
	* @return {Intersection}
	*/ static intersectLineLine(a1, a2, b1, b2, aInfinite = true, bInfinite = true) {
        const a2xa1x = a2.x - a1.x, a2ya1y = a2.y - a1.y, b2xb1x = b2.x - b1.x, b2yb1y = b2.y - b1.y, a1xb1x = a1.x - b1.x, a1yb1y = a1.y - b1.y, uaT = b2xb1x * a1yb1y - b2yb1y * a1xb1x, ubT = a2xa1x * a1yb1y - a2ya1y * a1xb1x, uB = b2yb1y * a2xa1x - b2xb1x * a2ya1y;
        if (uB !== 0) {
            const ua = uaT / uB, ub = ubT / uB;
            if ((aInfinite || 0 <= ua && ua <= 1) && (bInfinite || 0 <= ub && ub <= 1)) return new Intersection("Intersection").append(new $9a54cbcfc1af41ba$export$baf26146a414f24a(a1.x + ua * a2xa1x, a1.y + ua * a2ya1y));
            else return new Intersection();
        } else if (uaT === 0 || ubT === 0) return new Intersection(aInfinite || bInfinite || Intersection.isPointContained(a1, b1, b2) || Intersection.isPointContained(a2, b1, b2) || Intersection.isPointContained(b1, a1, a2) || Intersection.isPointContained(b2, a1, a2) ? "Coincident" : void 0);
        else return new Intersection("Parallel");
    }
    /**
	* Checks if a segment intersects a line
	* @see {@link intersectLineLine} for line intersection
	* @param {Point} s1 boundary point of segment
	* @param {Point} s2 other boundary point of segment
	* @param {Point} l1 point on line
	* @param {Point} l2 other point on line
	* @return {Intersection}
	*/ static intersectSegmentLine(s1, s2, l1, l2) {
        return Intersection.intersectLineLine(s1, s2, l1, l2, false, true);
    }
    /**
	* Checks if a segment intersects another
	* @see {@link intersectLineLine} for line intersection
	* @param {Point} a1 boundary point of segment
	* @param {Point} a2 other boundary point of segment
	* @param {Point} b1 boundary point of segment
	* @param {Point} b2 other boundary point of segment
	* @return {Intersection}
	*/ static intersectSegmentSegment(a1, a2, b1, b2) {
        return Intersection.intersectLineLine(a1, a2, b1, b2, false, false);
    }
    /**
	* Checks if line intersects polygon
	*
	* @todo account for stroke
	*
	* @see {@link intersectSegmentPolygon} for segment intersection
	* @param {Point} a1 point on line
	* @param {Point} a2 other point on line
	* @param {Point[]} points polygon points
	* @param {boolean} [infinite=true] check segment intersection by passing `false`
	* @return {Intersection}
	*/ static intersectLinePolygon(a1, a2, points, infinite = true) {
        const result = new Intersection();
        const length = points.length;
        for(let i = 0, b1, b2, inter; i < length; i++){
            b1 = points[i];
            b2 = points[(i + 1) % length];
            inter = Intersection.intersectLineLine(a1, a2, b1, b2, infinite, false);
            if (inter.status === "Coincident") return inter;
            result.append(...inter.points);
        }
        if (result.points.length > 0) result.status = "Intersection";
        return result;
    }
    /**
	* Checks if segment intersects polygon
	* @see {@link intersectLinePolygon} for line intersection
	* @param {Point} a1 boundary point of segment
	* @param {Point} a2 other boundary point of segment
	* @param {Point[]} points polygon points
	* @return {Intersection}
	*/ static intersectSegmentPolygon(a1, a2, points) {
        return Intersection.intersectLinePolygon(a1, a2, points, false);
    }
    /**
	* Checks if polygon intersects another polygon
	*
	* @todo account for stroke
	*
	* @param {Point[]} points1
	* @param {Point[]} points2
	* @return {Intersection}
	*/ static intersectPolygonPolygon(points1, points2) {
        const result = new Intersection(), length = points1.length;
        const coincidences = [];
        for(let i = 0; i < length; i++){
            const a1 = points1[i], a2 = points1[(i + 1) % length], inter = Intersection.intersectSegmentPolygon(a1, a2, points2);
            if (inter.status === "Coincident") {
                coincidences.push(inter);
                result.append(a1, a2);
            } else result.append(...inter.points);
        }
        if (coincidences.length > 0 && coincidences.length === points1.length) return new Intersection("Coincident");
        else if (result.points.length > 0) result.status = "Intersection";
        return result;
    }
    /**
	* Checks if polygon intersects rectangle
	* @see {@link intersectPolygonPolygon} for polygon intersection
	* @param {Point[]} points polygon points
	* @param {Point} r1 top left point of rect
	* @param {Point} r2 bottom right point of rect
	* @return {Intersection}
	*/ static intersectPolygonRectangle(points, r1, r2) {
        const min = r1.min(r2), max = r1.max(r2), topRight = new $9a54cbcfc1af41ba$export$baf26146a414f24a(max.x, min.y), bottomLeft = new $9a54cbcfc1af41ba$export$baf26146a414f24a(min.x, max.y);
        return Intersection.intersectPolygonPolygon(points, [
            min,
            topRight,
            max,
            bottomLeft
        ]);
    }
};
//#endregion
//#region src/shapes/Object/ObjectGeometry.ts
var $9a54cbcfc1af41ba$var$ObjectGeometry = class extends $9a54cbcfc1af41ba$var$CommonMethods {
    /**
	* @returns {number} x position according to object's originX property in canvas coordinate plane
	*/ getX() {
        return this.getXY().x;
    }
    /**
	* @param {number} value x position according to object's originX property in canvas coordinate plane
	*/ setX(value) {
        this.setXY(this.getXY().setX(value));
    }
    /**
	* @returns {number} y position according to object's originY property in canvas coordinate plane
	*/ getY() {
        return this.getXY().y;
    }
    /**
	* @param {number} value y position according to object's originY property in canvas coordinate plane
	*/ setY(value) {
        this.setXY(this.getXY().setY(value));
    }
    /**
	* @returns {number} x position according to object's originX property in parent's coordinate plane\
	* if parent is canvas then this property is identical to {@link getX}
	*/ getRelativeX() {
        return this.left;
    }
    /**
	* @param {number} value x position according to object's originX property in parent's coordinate plane\
	* if parent is canvas then this method is identical to {@link setX}
	*/ setRelativeX(value) {
        this.left = value;
    }
    /**
	* @returns {number} y position according to object's originY property in parent's coordinate plane\
	* if parent is canvas then this property is identical to {@link getY}
	*/ getRelativeY() {
        return this.top;
    }
    /**
	* @param {number} value y position according to object's originY property in parent's coordinate plane\
	* if parent is canvas then this property is identical to {@link setY}
	*/ setRelativeY(value) {
        this.top = value;
    }
    /**
	* @returns {Point} x position according to object's originX originY properties in canvas coordinate plane
	*/ getXY() {
        const relativePosition = this.getRelativeXY();
        return this.group ? $9a54cbcfc1af41ba$var$transformPoint(relativePosition, this.group.calcTransformMatrix()) : relativePosition;
    }
    /**
	* Set an object position to a particular point, the point is intended in absolute ( canvas ) coordinate.
	* You can specify originX and originY values,
	* that otherwise are the object's current values.
	* @example <caption>Set object's bottom left corner to point (5,5) on canvas</caption>
	* object.setXY(new Point(5, 5), 'left', 'bottom').
	* @param {Point} point position in scene coordinate plane
	* @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
	*/ setXY(point, originX, originY) {
        if (this.group) point = $9a54cbcfc1af41ba$var$transformPoint(point, $9a54cbcfc1af41ba$var$invertTransform(this.group.calcTransformMatrix()));
        this.setRelativeXY(point, originX, originY);
    }
    /**
	* @returns {Point} x,y position according to object's originX originY properties in parent's coordinate plane
	*/ getRelativeXY() {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.left, this.top);
    }
    /**
	* As {@link setXY}, but in current parent's coordinate plane (the current group if any or the canvas)
	* @param {Point} point position according to object's originX originY properties in parent's coordinate plane
	* @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
	*/ setRelativeXY(point, originX = this.originX, originY = this.originY) {
        this.setPositionByOrigin(point, originX, originY);
    }
    /**
	* @deprecated intermidiate method to be removed, do not use
	*/ isStrokeAccountedForInDimensions() {
        return false;
    }
    /**
	* @return {Point[]} [tl, tr, br, bl] in the scene plane
	*/ getCoords() {
        const { tl: tl, tr: tr, br: br, bl: bl } = this.aCoords || (this.aCoords = this.calcACoords());
        const coords = [
            tl,
            tr,
            br,
            bl
        ];
        if (this.group) {
            const t = this.group.calcTransformMatrix();
            return coords.map((p)=>$9a54cbcfc1af41ba$var$transformPoint(p, t));
        }
        return coords;
    }
    /**
	* Checks if object intersects with the scene rect formed by tl and br
	*/ intersectsWithRect(tl, br) {
        return $9a54cbcfc1af41ba$export$869c896bf338bf5a.intersectPolygonRectangle(this.getCoords(), tl, br).status === "Intersection";
    }
    /**
	* Checks if object intersects with another object
	* @param {Object} other Object to test
	* @return {Boolean} true if object intersects with another object
	*/ intersectsWithObject(other) {
        const intersection = $9a54cbcfc1af41ba$export$869c896bf338bf5a.intersectPolygonPolygon(this.getCoords(), other.getCoords());
        return intersection.status === "Intersection" || intersection.status === "Coincident" || other.isContainedWithinObject(this) || this.isContainedWithinObject(other);
    }
    /**
	* Checks if object is fully contained within area of another object
	* @param {Object} other Object to test
	* @return {Boolean} true if object is fully contained within area of another object
	*/ isContainedWithinObject(other) {
        return this.getCoords().every((point)=>other.containsPoint(point));
    }
    /**
	* Checks if object is fully contained within the scene rect formed by tl and br
	*/ isContainedWithinRect(tl, br) {
        const { left: left, top: top, width: width, height: height } = this.getBoundingRect();
        return left >= tl.x && left + width <= br.x && top >= tl.y && top + height <= br.y;
    }
    isOverlapping(other) {
        return this.intersectsWithObject(other) || this.isContainedWithinObject(other) || other.isContainedWithinObject(this);
    }
    /**
	* Checks if point is inside the object
	* @param {Point} point Point to check against
	* @return {Boolean} true if point is inside the object
	*/ containsPoint(point) {
        return $9a54cbcfc1af41ba$export$869c896bf338bf5a.isPointInPolygon(point, this.getCoords());
    }
    /**
	* Checks if object is contained within the canvas with current viewportTransform
	* the check is done stopping at first point that appears on screen
	* @return {Boolean} true if object is fully or partially contained within canvas
	*/ isOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        if (this.getCoords().some((point)=>point.x <= br.x && point.x >= tl.x && point.y <= br.y && point.y >= tl.y)) return true;
        if (this.intersectsWithRect(tl, br)) return true;
        return this.containsPoint(tl.midPointFrom(br));
    }
    /**
	* Checks if object is partially contained within the canvas with current viewportTransform
	* @return {Boolean} true if object is partially contained within canvas
	*/ isPartiallyOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        if (this.intersectsWithRect(tl, br)) return true;
        return this.getCoords().every((point)=>(point.x >= br.x || point.x <= tl.x) && (point.y >= br.y || point.y <= tl.y)) && this.containsPoint(tl.midPointFrom(br));
    }
    /**
	* Returns coordinates of object's bounding rectangle (left, top, width, height)
	* the box is intended as aligned to axis of canvas.
	* @return {Object} Object with left, top, width, height properties
	*/ getBoundingRect() {
        return $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(this.getCoords());
    }
    /**
	* Returns width of an object's bounding box counting transformations
	* @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
	* @return {Number} width value
	*/ getScaledWidth() {
        return this._getTransformedDimensions().x;
    }
    /**
	* Returns height of an object bounding box counting transformations
	* @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
	* @return {Number} height value
	*/ getScaledHeight() {
        return this._getTransformedDimensions().y;
    }
    /**
	* Scales an object (equally by x and y)
	* @param {Number} value Scale factor
	* @return {void}
	*/ scale(value) {
        this._set($9a54cbcfc1af41ba$var$SCALE_X, value);
        this._set($9a54cbcfc1af41ba$var$SCALE_Y, value);
        this.setCoords();
    }
    /**
	* Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
	* @param {Number} value New width value
	* @return {void}
	*/ scaleToWidth(value) {
        const boundingRectFactor = this.getBoundingRect().width / this.getScaledWidth();
        return this.scale(value / this.width / boundingRectFactor);
    }
    /**
	* Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
	* @param {Number} value New height value
	* @return {void}
	*/ scaleToHeight(value) {
        const boundingRectFactor = this.getBoundingRect().height / this.getScaledHeight();
        return this.scale(value / this.height / boundingRectFactor);
    }
    getCanvasRetinaScaling() {
        var _this$canvas;
        return ((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.getRetinaScaling()) || 1;
    }
    /**
	* Returns the object angle relative to canvas counting also the group property
	* @returns {TDegree}
	*/ getTotalAngle() {
        return this.group ? $9a54cbcfc1af41ba$var$radiansToDegrees($9a54cbcfc1af41ba$var$calcPlaneRotation(this.calcTransformMatrix())) : this.angle;
    }
    /**
	* Retrieves viewportTransform from Object's canvas if available
	* @return {TMat2D}
	*/ getViewportTransform() {
        var _this$canvas2;
        return ((_this$canvas2 = this.canvas) === null || _this$canvas2 === void 0 ? void 0 : _this$canvas2.viewportTransform) || $9a54cbcfc1af41ba$export$3c5a7f9475b116e0.concat();
    }
    /**
	* Calculates the coordinates of the 4 corner of the bbox, in absolute coordinates.
	* those never change with zoom or viewport changes.
	* @return {TCornerPoint}
	*/ calcACoords() {
        const rotateMatrix = $9a54cbcfc1af41ba$var$createRotateMatrix({
            angle: this.angle
        }), { x: x, y: y } = this.getRelativeCenterPoint(), finalMatrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$createTranslateMatrix(x, y), rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
        return {
            tl: $9a54cbcfc1af41ba$var$transformPoint({
                x: -w,
                y: -h
            }, finalMatrix),
            tr: $9a54cbcfc1af41ba$var$transformPoint({
                x: w,
                y: -h
            }, finalMatrix),
            bl: $9a54cbcfc1af41ba$var$transformPoint({
                x: -w,
                y: h
            }, finalMatrix),
            br: $9a54cbcfc1af41ba$var$transformPoint({
                x: w,
                y: h
            }, finalMatrix)
        };
    }
    /**
	* Sets corner and controls position coordinates based on current angle, width and height, left and top.
	* aCoords are used to quickly find an object on the canvas.
	* See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabric5.fabricjs.com/fabric-gotchas}
	*/ setCoords() {
        this.aCoords = this.calcACoords();
    }
    transformMatrixKey(skipGroup = false) {
        let prefix = [];
        if (!skipGroup && this.group) prefix = this.group.transformMatrixKey(skipGroup);
        prefix.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, $9a54cbcfc1af41ba$var$resolveOrigin(this.originX), $9a54cbcfc1af41ba$var$resolveOrigin(this.originY));
        return prefix;
    }
    /**
	* calculate transform matrix that represents the current transformations from the
	* object's properties.
	* @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
	* There are some situation in which this is useful to avoid the fake rotation.
	* @return {TMat2D} transform matrix for the object
	*/ calcTransformMatrix(skipGroup = false) {
        let matrix = this.calcOwnMatrix();
        if (skipGroup || !this.group) return matrix;
        const key = this.transformMatrixKey(skipGroup), cache = this.matrixCache;
        if (cache && cache.key.every((x, i)=>x === key[i])) return cache.value;
        if (this.group) matrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(this.group.calcTransformMatrix(false), matrix);
        this.matrixCache = {
            key: key,
            value: matrix
        };
        return matrix;
    }
    /**
	* calculate transform matrix that represents the current transformations from the
	* object's properties, this matrix does not include the group transformation
	* @return {TMat2D} transform matrix for the object
	*/ calcOwnMatrix() {
        const key = this.transformMatrixKey(true), cache = this.ownMatrixCache;
        if (cache && cache.key.every((x, i)=>x === key[i])) return cache.value;
        const center = this.getRelativeCenterPoint(), value = $9a54cbcfc1af41ba$var$composeMatrix({
            angle: this.angle,
            translateX: center.x,
            translateY: center.y,
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            flipX: this.flipX,
            flipY: this.flipY
        });
        this.ownMatrixCache = {
            key: key,
            value: value
        };
        return value;
    }
    /**
	* Calculate object dimensions from its properties
	* @private
	* @returns {Point} dimensions
	*/ _getNonTransformedDimensions() {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.width, this.height).scalarAdd(this.strokeWidth);
    }
    /**
	* Calculate object dimensions for controls box, including padding and canvas zoom.
	* and active selection
	* @private
	* @param {object} [options] transform options
	* @returns {Point} dimensions
	*/ _calculateCurrentDimensions(options) {
        return this._getTransformedDimensions(options).transform(this.getViewportTransform(), true).scalarAdd(2 * this.padding);
    }
    /**
	* Calculate object bounding box dimensions from its properties scale, skew.
	* This bounding box is aligned with object angle and not with canvas axis or screen.
	* @param {Object} [options]
	* @param {Number} [options.scaleX]
	* @param {Number} [options.scaleY]
	* @param {Number} [options.skewX]
	* @param {Number} [options.skewY]
	* @private
	* @returns {Point} dimensions
	*/ _getTransformedDimensions(options = {}) {
        const dimOptions = {
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            width: this.width,
            height: this.height,
            strokeWidth: this.strokeWidth,
            ...options
        };
        const strokeWidth = dimOptions.strokeWidth;
        let preScalingStrokeValue = strokeWidth, postScalingStrokeValue = 0;
        if (this.strokeUniform) {
            preScalingStrokeValue = 0;
            postScalingStrokeValue = strokeWidth;
        }
        const dimX = dimOptions.width + preScalingStrokeValue, dimY = dimOptions.height + preScalingStrokeValue, noSkew = dimOptions.skewX === 0 && dimOptions.skewY === 0;
        let finalDimensions;
        if (noSkew) finalDimensions = new $9a54cbcfc1af41ba$export$baf26146a414f24a(dimX * dimOptions.scaleX, dimY * dimOptions.scaleY);
        else finalDimensions = $9a54cbcfc1af41ba$var$sizeAfterTransform(dimX, dimY, $9a54cbcfc1af41ba$var$calcDimensionsMatrix(dimOptions));
        return finalDimensions.scalarAdd(postScalingStrokeValue);
    }
    /**
	* Translates the coordinates from a set of origin to another (based on the object's dimensions)
	* @param {Point} point The point which corresponds to the originX and originY params
	* @param {TOriginX} fromOriginX Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
	* @param {TOriginX} toOriginX Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} toOriginY Vertical origin: 'top', 'center' or 'bottom'
	* @return {Point}
	*/ translateToGivenOrigin(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
        let x = point.x, y = point.y;
        const offsetX = $9a54cbcfc1af41ba$var$resolveOrigin(toOriginX) - $9a54cbcfc1af41ba$var$resolveOrigin(fromOriginX), offsetY = $9a54cbcfc1af41ba$var$resolveOrigin(toOriginY) - $9a54cbcfc1af41ba$var$resolveOrigin(fromOriginY);
        if (offsetX || offsetY) {
            const dim = this._getTransformedDimensions();
            x += offsetX * dim.x;
            y += offsetY * dim.y;
        }
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y);
    }
    /**
	* Translates the coordinates from origin to center coordinates (based on the object's dimensions)
	* @param {Point} point The point which corresponds to the originX and originY params
	* @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
	* @return {Point}
	*/ translateToCenterPoint(point, originX, originY) {
        if (originX === "center" && originY === "center") return point;
        const p = this.translateToGivenOrigin(point, originX, originY, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
        if (this.angle) return p.rotate($9a54cbcfc1af41ba$var$degreesToRadians(this.angle), point);
        return p;
    }
    /**
	* Translates the coordinates from center to origin coordinates (based on the object's dimensions)
	* @param {Point} center The point which corresponds to center of the object
	* @param {OriginX} originX Horizontal origin: 'left', 'center' or 'right'
	* @param {OriginY} originY Vertical origin: 'top', 'center' or 'bottom'
	* @return {Point}
	*/ translateToOriginPoint(center, originX, originY) {
        const p = this.translateToGivenOrigin(center, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER, originX, originY);
        if (this.angle) return p.rotate($9a54cbcfc1af41ba$var$degreesToRadians(this.angle), center);
        return p;
    }
    /**
	* Returns the center coordinates of the object relative to canvas
	* @return {Point}
	*/ getCenterPoint() {
        const relCenter = this.getRelativeCenterPoint();
        return this.group ? $9a54cbcfc1af41ba$var$transformPoint(relCenter, this.group.calcTransformMatrix()) : relCenter;
    }
    /**
	* Returns the center coordinates of the object relative to it's parent
	* @return {Point}
	*/ getRelativeCenterPoint() {
        return this.translateToCenterPoint(new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.left, this.top), this.originX, this.originY);
    }
    /**
	* Alias of {@link getPositionByOrigin}
	* @deprecated use {@link getPositionByOrigin} instead
	*/ getPointByOrigin(originX, originY) {
        return this.getPositionByOrigin(originX, originY);
    }
    /**
	* This function is the mirror of {@link setPositionByOrigin}
	* Returns the position of the object based on specified origin.
	* Take an object that has left, top set to 100, 100 with origin 'left', 'top'.
	* Return the values of left top ( wrapped in a point ) that you would need to keep
	* the same position if origin where different ( ex: center, bottom )
	* Alternatively you can use this to also find which point in the parent plane is a specific origin
	* ( where is the bottom right corner of my object? )
	* @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
	* @return {Point}
	*/ getPositionByOrigin(originX, originY) {
        return this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
    }
    /**
	* Sets the position of the object taking into consideration the object's origin
	* @param {Point} pos The new position of the object
	* @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
	* @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
	* @return {void}
	*/ setPositionByOrigin(pos, originX, originY) {
        const center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
        this.set({
            left: position.x,
            top: position.y
        });
    }
    /**
	* @private
	*/ _getLeftTopCoords() {
        return this.getPositionByOrigin($9a54cbcfc1af41ba$var$LEFT, "top");
    }
    /**
	* An utility method to position the object by its left top corner.
	* Useful to reposition objects since now the default origin is center/center
	* Places the left/top corner of the object bounding box in p.
	*/ positionByLeftTop(p) {
        return this.setPositionByOrigin(p, $9a54cbcfc1af41ba$var$LEFT, "top");
    }
};
//#endregion
//#region src/shapes/Object/Object.ts
/**
* Root object class from which all 2d shape classes inherit from
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-1#objects}
*
* @fires added
* @fires removed
*
* @fires selected
* @fires deselected
*
* @fires rotating
* @fires scaling
* @fires moving
* @fires skewing
* @fires modified
*
* @fires mousedown
* @fires mouseup
* @fires mouseover
* @fires mouseout
* @fires mousewheel
* @fires mousedblclick
*
* @fires dragover
* @fires dragenter
* @fires dragleave
* @fires drop
*/ var $9a54cbcfc1af41ba$export$c2d2360b5ec84692 = class FabricObject extends $9a54cbcfc1af41ba$var$ObjectGeometry {
    static getDefaults() {
        return FabricObject.ownDefaults;
    }
    /**
	* Legacy identifier of the class. Prefer using utils like isType or instanceOf
	* Will be removed in fabric 7 or 8.
	* The setter exists to avoid type errors in old code and possibly current deserialization code.
	* DO NOT build new code around this type value
	* @TODO add sustainable warning message
	* @type string
	* @deprecated
	*/ get type() {
        const name = this.constructor.type;
        if (name === "FabricObject") return "object";
        return name.toLowerCase();
    }
    set type(value) {
        $9a54cbcfc1af41ba$var$log("warn", "Setting type has no effect", value);
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Quick access for the _cacheCanvas rendering context
			* This is part of the objectCaching feature
			* since 1.7.0
			* @type boolean
			* @default undefined
			* @private
			*/ "_cacheContext", null);
        Object.assign(this, FabricObject.ownDefaults);
        this.setOptions(options);
    }
    /**
	* Create a the canvas used to keep the cached copy of the object
	* @private
	*/ _createCacheCanvas() {
        this._cacheCanvas = $9a54cbcfc1af41ba$var$createCanvasElement();
        this._cacheContext = this._cacheCanvas.getContext("2d");
        this._updateCacheCanvas();
        this.dirty = true;
    }
    /**
	* Limit the cache dimensions so that X * Y do not cross config.perfLimitSizeTotal
	* and each side do not cross fabric.cacheSideLimit
	* those numbers are configurable so that you can get as much detail as you want
	* making bargain with performances.
	* It mutates the input object dims.
	* @param {TCacheCanvasDimensions} dims
	* @return {TCacheCanvasDimensions} dims
	*/ _limitCacheSize(dims) {
        const width = dims.width, height = dims.height, max = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.maxCacheSideLimit, min = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.minCacheSideLimit;
        if (width <= max && height <= max && width * height <= $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.perfLimitSizeTotal) {
            if (width < min) dims.width = min;
            if (height < min) dims.height = min;
            return dims;
        }
        const ar = width / height, [limX, limY] = $9a54cbcfc1af41ba$export$69a3209f1a06c04d.limitDimsByArea(ar), x = $9a54cbcfc1af41ba$var$capValue(min, limX, max), y = $9a54cbcfc1af41ba$var$capValue(min, limY, max);
        if (width > x) {
            dims.zoomX /= width / x;
            dims.width = x;
            dims.capped = true;
        }
        if (height > y) {
            dims.zoomY /= height / y;
            dims.height = y;
            dims.capped = true;
        }
        return dims;
    }
    /**
	* Return the dimension and the zoom level needed to create a cache canvas
	* big enough to host the object to be cached.
	* @private
	* @return {TCacheCanvasDimensions} Informations about the object to be cached
	*/ _getCacheCanvasDimensions() {
        const objectScale = this.getTotalObjectScaling(), dim = this._getTransformedDimensions({
            skewX: 0,
            skewY: 0
        }), neededX = dim.x * objectScale.x / this.scaleX, neededY = dim.y * objectScale.y / this.scaleY;
        return {
            width: Math.ceil(neededX + 2),
            height: Math.ceil(neededY + 2),
            zoomX: objectScale.x,
            zoomY: objectScale.y,
            x: neededX,
            y: neededY
        };
    }
    /**
	* Update width and height of the canvas for cache
	* returns true or false if canvas needed resize.
	* @private
	* @return {Boolean} true if the canvas has been resized
	*/ _updateCacheCanvas() {
        const canvas = this._cacheCanvas, context = this._cacheContext, { width: width, height: height, zoomX: zoomX, zoomY: zoomY, x: x, y: y } = this._limitCacheSize(this._getCacheCanvasDimensions()), dimensionsChanged = width !== canvas.width || height !== canvas.height, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY;
        if (!canvas || !context) return false;
        if (dimensionsChanged || zoomChanged) {
            if (width !== canvas.width || height !== canvas.height) {
                canvas.width = width;
                canvas.height = height;
            } else {
                context.setTransform(1, 0, 0, 1, 0, 0);
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
            const drawingWidth = x / 2;
            const drawingHeight = y / 2;
            this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
            this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
            context.translate(this.cacheTranslationX, this.cacheTranslationY);
            context.scale(zoomX, zoomY);
            this.zoomX = zoomX;
            this.zoomY = zoomY;
            return true;
        }
        return false;
    }
    /**
	* Sets object's properties from options, for class constructor only.
	* Needs to be overridden for different defaults.
	* @protected
	* @param {Object} [options] Options object
	*/ setOptions(options = {}) {
        this._setOptions(options);
    }
    /**
	* Transforms context when rendering an object
	* @param {CanvasRenderingContext2D} ctx Context
	*/ transform(ctx) {
        const needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
        const m = this.calcTransformMatrix(!needFullTransform);
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    }
    /**
	* Return the object scale factor counting also the group scaling
	* @return {Point}
	*/ getObjectScaling() {
        if (!this.group) return new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.abs(this.scaleX), Math.abs(this.scaleY));
        const options = $9a54cbcfc1af41ba$var$qrDecompose(this.calcTransformMatrix());
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.abs(options.scaleX), Math.abs(options.scaleY));
    }
    /**
	* Return the object scale factor counting also the group scaling, zoom and retina
	* @return {Object} object with scaleX and scaleY properties
	*/ getTotalObjectScaling() {
        const scale = this.getObjectScaling();
        if (this.canvas) {
            const zoom = this.canvas.getZoom();
            const retina = this.getCanvasRetinaScaling();
            return scale.scalarMultiply(zoom * retina);
        }
        return scale;
    }
    /**
	* Return the object opacity counting also the group property
	* @return {Number}
	*/ getObjectOpacity() {
        let opacity = this.opacity;
        if (this.group) opacity *= this.group.getObjectOpacity();
        return opacity;
    }
    /**
	* Makes sure the scale is valid and modifies it if necessary
	* @todo: this is a control action issue, not a geometry one
	* @private
	* @param {Number} value, unconstrained
	* @return {Number} constrained value;
	*/ _constrainScale(value) {
        if (Math.abs(value) < this.minScaleLimit) {
            if (value < 0) return -this.minScaleLimit;
            else return this.minScaleLimit;
        } else if (value === 0) return 1e-4;
        return value;
    }
    /**
	* Handles setting values on the instance and handling internal side effects
	* @protected
	* @param {String} key
	* @param {*} value
	*/ _set(key, value) {
        if (key === "scaleX" || key === "scaleY") value = this._constrainScale(value);
        if (key === "scaleX" && value < 0) {
            this.flipX = !this.flipX;
            value *= -1;
        } else if (key === "scaleY" && value < 0) {
            this.flipY = !this.flipY;
            value *= -1;
        } else if (key === "shadow" && value && !(value instanceof $9a54cbcfc1af41ba$export$a24c14443968327c)) value = new $9a54cbcfc1af41ba$export$a24c14443968327c(value);
        const isChanged = this[key] !== value;
        this[key] = value;
        if (isChanged && this.constructor.cacheProperties.includes(key)) this.dirty = true;
        this.parent && (this.dirty || isChanged && this.constructor.stateProperties.includes(key)) && this.parent._set("dirty", true);
        return this;
    }
    /**
	* return if the object would be visible in rendering
	* @return {Boolean}
	*/ isNotVisible() {
        return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }
    /**
	* Renders an object on a specified context
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ render(ctx) {
        if (this.isNotVisible()) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        ctx.save();
        this._setupCompositeOperation(ctx);
        this.drawSelectionBackground(ctx);
        this.transform(ctx);
        this._setOpacity(ctx);
        this._setShadow(ctx);
        if (this.shouldCache()) {
            this.renderCache();
            this.drawCacheOnCanvas(ctx);
        } else {
            this._removeCacheCanvas();
            this.drawObject(ctx, false, {});
            this.dirty = false;
        }
        ctx.restore();
    }
    drawSelectionBackground(_ctx) {}
    renderCache(options) {
        options = options || {};
        if (!this._cacheCanvas || !this._cacheContext) this._createCacheCanvas();
        if (this.isCacheDirty() && this._cacheContext) {
            const { zoomX: zoomX, zoomY: zoomY, cacheTranslationX: cacheTranslationX, cacheTranslationY: cacheTranslationY } = this;
            const { width: width, height: height } = this._cacheCanvas;
            this.drawObject(this._cacheContext, options.forClipping, {
                zoomX: zoomX,
                zoomY: zoomY,
                cacheTranslationX: cacheTranslationX,
                cacheTranslationY: cacheTranslationY,
                width: width,
                height: height,
                parentClipPaths: []
            });
            this.dirty = false;
        }
    }
    /**
	* Remove cacheCanvas and its dimensions from the objects
	*/ _removeCacheCanvas() {
        this._cacheCanvas = void 0;
        this._cacheContext = null;
    }
    /**
	* return true if the object will draw a stroke
	* Does not consider text styles. This is just a shortcut used at rendering time
	* We want it to be an approximation and be fast.
	* wrote to avoid extra caching, it has to return true when stroke happens,
	* can guess when it will not happen at 100% chance, does not matter if it misses
	* some use case where the stroke is invisible.
	* @since 3.0.0
	* @returns Boolean
	*/ hasStroke() {
        return !!this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
    }
    /**
	* return true if the object will draw a fill
	* Does not consider text styles. This is just a shortcut used at rendering time
	* We want it to be an approximation and be fast.
	* wrote to avoid extra caching, it has to return true when fill happens,
	* can guess when it will not happen at 100% chance, does not matter if it misses
	* some use case where the fill is invisible.
	* @since 3.0.0
	* @returns Boolean
	*/ hasFill() {
        return !!this.fill && this.fill !== "transparent";
    }
    /**
	* When returns `true`, force the object to have its own cache, even if it is inside a group
	* it may be needed when your object behave in a particular way on the cache and always needs
	* its own isolated canvas to render correctly.
	* Created to be overridden
	* since 1.7.12
	* @returns Boolean
	*/ needsItsOwnCache() {
        if (this.paintFirst === "stroke" && this.hasFill() && this.hasStroke() && !!this.shadow) return true;
        if (this.clipPath) return true;
        return false;
    }
    /**
	* Decide if the object should cache or not. Create its own cache level
	* objectCaching is a global flag, wins over everything
	* needsItsOwnCache should be used when the object drawing method requires
	* a cache step.
	* Generally you do not cache objects in groups because the group outside is cached.
	* Read as: cache if is needed, or if the feature is enabled but we are not already caching.
	* @return {Boolean}
	*/ shouldCache() {
        this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache();
        return this.ownCaching;
    }
    /**
	* Check if this object will cast a shadow with an offset.
	* used by Group.shouldCache to know if child has a shadow recursively
	* @return {Boolean}
	* @deprecated
	*/ willDrawShadow() {
        return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }
    /**
	* Execute the drawing operation for an object clipPath
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {FabricObject} clipPath
	*/ drawClipPathOnCache(ctx, clipPath, canvasWithClipPath) {
        ctx.save();
        if (clipPath.inverted) ctx.globalCompositeOperation = "destination-out";
        else ctx.globalCompositeOperation = "destination-in";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(canvasWithClipPath, 0, 0);
        ctx.restore();
    }
    /**
	* Execute the drawing operation for an object on a specified context
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {boolean} forClipping apply clipping styles
	* @param {DrawContext} context additional context for rendering
	*/ drawObject(ctx, forClipping, context) {
        const originalFill = this.fill, originalStroke = this.stroke;
        if (forClipping) {
            this.fill = "black";
            this.stroke = "";
            this._setClippingProperties(ctx);
        } else this._renderBackground(ctx);
        this.fire("before:render", {
            ctx: ctx
        });
        this._render(ctx);
        this._drawClipPath(ctx, this.clipPath, context);
        this.fill = originalFill;
        this.stroke = originalStroke;
    }
    createClipPathLayer(clipPath, context) {
        const canvas = $9a54cbcfc1af41ba$var$createCanvasElementFor(context);
        const ctx = canvas.getContext("2d");
        ctx.translate(context.cacheTranslationX, context.cacheTranslationY);
        ctx.scale(context.zoomX, context.zoomY);
        clipPath._cacheCanvas = canvas;
        context.parentClipPaths.forEach((prevClipPath)=>{
            prevClipPath.transform(ctx);
        });
        context.parentClipPaths.push(clipPath);
        if (clipPath.absolutePositioned) {
            const m = $9a54cbcfc1af41ba$var$invertTransform(this.calcTransformMatrix());
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        clipPath.transform(ctx);
        clipPath.drawObject(ctx, true, context);
        return canvas;
    }
    /**
	* Prepare clipPath state and cache and draw it on instance's cache
	* @param {CanvasRenderingContext2D} ctx
	* @param {FabricObject} clipPath
	*/ _drawClipPath(ctx, clipPath, context) {
        if (!clipPath) return;
        clipPath._transformDone = true;
        const canvas = this.createClipPathLayer(clipPath, context);
        this.drawClipPathOnCache(ctx, clipPath, canvas);
    }
    /**
	* Paint the cached copy of the object on the target context.
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ drawCacheOnCanvas(ctx) {
        ctx.scale(1 / this.zoomX, 1 / this.zoomY);
        ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }
    /**
	* Check if cache is dirty and if is dirty clear the context.
	* This check has a big side effect, it changes the underlying cache canvas if necessary.
	* Do not call this method on your own to check if the cache is dirty, because if it is,
	* it is also going to wipe the cache. This is badly designed and needs to be fixed.
	* @param {Boolean} skipCanvas skip canvas checks because this object is painted
	* on parent canvas.
	*/ isCacheDirty(skipCanvas = false) {
        if (this.isNotVisible()) return false;
        const canvas = this._cacheCanvas;
        const ctx = this._cacheContext;
        if (canvas && ctx && !skipCanvas && this._updateCacheCanvas()) return true;
        else if (this.dirty || this.clipPath && this.clipPath.absolutePositioned) {
            if (canvas && ctx && !skipCanvas) {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.restore();
            }
            return true;
        }
        return false;
    }
    /**
	* Draws a background for the object big as its untransformed dimensions
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderBackground(ctx) {
        if (!this.backgroundColor) return;
        const dim = this._getNonTransformedDimensions();
        ctx.fillStyle = this.backgroundColor;
        ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
        this._removeShadow(ctx);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _setOpacity(ctx) {
        if (this.group && !this.group._transformDone) ctx.globalAlpha = this.getObjectOpacity();
        else ctx.globalAlpha *= this.opacity;
    }
    _setStrokeStyles(ctx, decl) {
        const stroke = decl.stroke;
        if (stroke) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = decl.strokeLineCap;
            ctx.lineDashOffset = decl.strokeDashOffset;
            ctx.lineJoin = decl.strokeLineJoin;
            ctx.miterLimit = decl.strokeMiterLimit;
            if ($9a54cbcfc1af41ba$var$isFiller(stroke)) {
                if (stroke.gradientUnits === "percentage" || stroke.gradientTransform || stroke.patternTransform) this._applyPatternForTransformedGradient(ctx, stroke);
                else {
                    ctx.strokeStyle = stroke.toLive(ctx);
                    this._applyPatternGradientTransform(ctx, stroke);
                }
            } else ctx.strokeStyle = decl.stroke;
        }
    }
    _setFillStyles(ctx, { fill: fill }) {
        if (fill) {
            if ($9a54cbcfc1af41ba$var$isFiller(fill)) {
                ctx.fillStyle = fill.toLive(ctx);
                this._applyPatternGradientTransform(ctx, fill);
            } else ctx.fillStyle = fill;
        }
    }
    _setClippingProperties(ctx) {
        ctx.globalAlpha = 1;
        ctx.strokeStyle = "transparent";
        ctx.fillStyle = "#000000";
    }
    /**
	* @private
	* Sets line dash
	* @param {CanvasRenderingContext2D} ctx Context to set the dash line on
	* @param {Array} dashArray array representing dashes
	*/ _setLineDash(ctx, dashArray) {
        if (!dashArray || dashArray.length === 0) return;
        ctx.setLineDash(dashArray);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _setShadow(ctx) {
        if (!this.shadow) return;
        const shadow = this.shadow, canvas = this.canvas, retinaScaling = this.getCanvasRetinaScaling(), [sx, , , sy] = (canvas === null || canvas === void 0 ? void 0 : canvas.viewportTransform) || $9a54cbcfc1af41ba$export$3c5a7f9475b116e0, multX = sx * retinaScaling, multY = sy * retinaScaling, scaling = shadow.nonScaling ? new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.browserShadowBlurConstant * (multX + multY) * (scaling.x + scaling.y) / 4;
        ctx.shadowOffsetX = shadow.offsetX * multX * scaling.x;
        ctx.shadowOffsetY = shadow.offsetY * multY * scaling.y;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _removeShadow(ctx) {
        if (!this.shadow) return;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {TFiller} filler {@link Pattern} or {@link Gradient}
	*/ _applyPatternGradientTransform(ctx, filler) {
        if (!$9a54cbcfc1af41ba$var$isFiller(filler)) return {
            offsetX: 0,
            offsetY: 0
        };
        const t = filler.gradientTransform || filler.patternTransform;
        const offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
        if (filler.gradientUnits === "percentage") ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
        else ctx.transform(1, 0, 0, 1, offsetX, offsetY);
        if (t) ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderPaintInOrder(ctx) {
        if (this.paintFirst === "stroke") {
            this._renderStroke(ctx);
            this._renderFill(ctx);
        } else {
            this._renderFill(ctx);
            this._renderStroke(ctx);
        }
    }
    /**
	* @private
	* function that actually render something on the context.
	* empty here to allow Obects to work on tests to benchmark fabric functionalites
	* not related to rendering
	* @param {CanvasRenderingContext2D} _ctx Context to render on
	*/ _render(_ctx) {}
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderFill(ctx) {
        if (!this.fill) return;
        ctx.save();
        this._setFillStyles(ctx, this);
        if (this.fillRule === "evenodd") ctx.fill("evenodd");
        else ctx.fill();
        ctx.restore();
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderStroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        if (this.strokeUniform) {
            const scaling = this.getObjectScaling();
            ctx.scale(1 / scaling.x, 1 / scaling.y);
        }
        this._setLineDash(ctx, this.strokeDashArray);
        this._setStrokeStyles(ctx, this);
        ctx.stroke();
        ctx.restore();
    }
    /**
	* This function try to patch the missing gradientTransform on canvas gradients.
	* transforming a context to transform the gradient, is going to transform the stroke too.
	* we want to transform the gradient but not the stroke operation, so we create
	* a transformed gradient on a pattern and then we use the pattern instead of the gradient.
	* this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
	* is limited.
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Gradient} filler
	*/ _applyPatternForTransformedGradient(ctx, filler) {
        var _pCtx$createPattern;
        const dims = this._limitCacheSize(this._getCacheCanvasDimensions()), retinaScaling = this.getCanvasRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling, pCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor({
            width: Math.ceil(width),
            height: Math.ceil(height)
        });
        const pCtx = pCanvas.getContext("2d");
        if (!pCtx) return;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fillStyle = filler.toLive(ctx);
        pCtx.fill();
        ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
        ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
        ctx.strokeStyle = (_pCtx$createPattern = pCtx.createPattern(pCanvas, "no-repeat")) !== null && _pCtx$createPattern !== void 0 ? _pCtx$createPattern : "";
    }
    /**
	* This function is an helper for svg import. it returns the center of the object in the svg
	* untransformed coordinates
	* It doesn't matter where the objects origin are, svg has left and top in the top left corner,
	* And this method is only run once on the object after the fromElement parser.
	* @private
	* @return {Point} center point from element coordinates
	*/ _findCenterFromElement() {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.left + this.width / 2, this.top + this.height / 2);
    }
    /**
	* Clones an instance.
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @returns {Promise<FabricObject>}
	*/ clone(propertiesToInclude) {
        const objectForm = this.toObject(propertiesToInclude);
        return this.constructor.fromObject(objectForm);
    }
    /**
	* Creates an instance of Image out of an object
	* makes use of toCanvasElement.
	* Once this method was based on toDataUrl and loadImage, so it also had a quality
	* and format option. toCanvasElement is faster and produce no loss of quality.
	* If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
	* toCanvasElement and then toBlob from the obtained canvas is also a good option.
	* @todo fix the export type, it could not be Image but the type that getClass return for 'image'.
	* @param {ObjectToCanvasElementOptions} [options] for clone as image, passed to toDataURL
	* @param {Number} [options.multiplier=1] Multiplier to scale by
	* @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	* @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	* @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	* @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	* @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	* @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	* @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	* @return {FabricImage} Object cloned as image.
	*/ cloneAsImage(options) {
        const canvasEl = this.toCanvasElement(options);
        return new ($9a54cbcfc1af41ba$export$2792378e23a7920c.getClass("image"))(canvasEl);
    }
    /**
	* Converts an object into a HTMLCanvas element
	* @param {ObjectToCanvasElementOptions} options Options object
	* @param {Number} [options.multiplier=1] Multiplier to scale by
	* @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	* @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	* @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	* @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	* @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	* @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	* @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	* @param {Boolean} [options.viewportTransform] Account for canvas viewport transform
	* @param {(el?: HTMLCanvasElement) => StaticCanvas} [options.canvasProvider] Create the output canvas
	* @return {HTMLCanvasElement} Returns DOM element <canvas> with the FabricObject
	*/ toCanvasElement(options = {}) {
        const origParams = $9a54cbcfc1af41ba$var$saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs = Math.abs, retinaScaling = options.enableRetinaScaling ? $9a54cbcfc1af41ba$var$getDevicePixelRatio() : 1, multiplier = (options.multiplier || 1) * retinaScaling, canvasProvider = options.canvasProvider || ((el)=>new $9a54cbcfc1af41ba$export$ad01921fb0b1386e(el, {
                enableRetinaScaling: false,
                renderOnAddRemove: false,
                skipOffscreen: false
            }));
        delete this.group;
        if (options.withoutTransform) $9a54cbcfc1af41ba$var$resetObjectTransform(this);
        if (options.withoutShadow) this.shadow = null;
        if (options.viewportTransform) $9a54cbcfc1af41ba$var$sendObjectToPlane(this, this.getViewportTransform());
        this.setCoords();
        const el = $9a54cbcfc1af41ba$var$createCanvasElement(), boundingRect = this.getBoundingRect(), shadow = this.shadow, shadowOffset = new $9a54cbcfc1af41ba$export$baf26146a414f24a();
        if (shadow) {
            const shadowBlur = shadow.blur;
            const scaling = shadow.nonScaling ? new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
            shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.x);
            shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.y);
        }
        const width = boundingRect.width + shadowOffset.x, height = boundingRect.height + shadowOffset.y;
        el.width = Math.ceil(width);
        el.height = Math.ceil(height);
        const canvas = canvasProvider(el);
        if (options.format === "jpeg") canvas.backgroundColor = "#fff";
        this.setPositionByOrigin(new $9a54cbcfc1af41ba$export$baf26146a414f24a(canvas.width / 2, canvas.height / 2), $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
        const originalCanvas = this.canvas;
        canvas._objects = [
            this
        ];
        this.set("canvas", canvas);
        this.setCoords();
        const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
        this.set("canvas", originalCanvas);
        this.shadow = originalShadow;
        if (originalGroup) this.group = originalGroup;
        this.set(origParams);
        this.setCoords();
        canvas._objects = [];
        canvas.destroy();
        return canvasEl;
    }
    /**
	* Converts an object into a data-url-like string
	* @param {Object} options Options object
	* @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	* @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	* @param {Number} [options.multiplier=1] Multiplier to scale by
	* @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	* @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	* @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	* @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	* @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	* @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	* @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	* @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	*/ toDataURL(options = {}) {
        return $9a54cbcfc1af41ba$var$toDataURL(this.toCanvasElement(options), options.format || "png", options.quality || 1);
    }
    toBlob(options = {}) {
        return $9a54cbcfc1af41ba$var$toBlob(this.toCanvasElement(options), options.format || "png", options.quality || 1);
    }
    /**
	* Checks if the instance is of any of the specified types.
	* We use this to filter a list of objects for the `getObjects` function.
	*
	* For detecting an instance type `instanceOf` is a better check,
	* but to avoid to make specific classes a dependency of generic code
	* internally we use this.
	*
	* This compares both the static class `type` and the instance's own `type` property
	* against the provided list of types.
	*
	* @param types - A list of type strings to check against.
	* @returns `true` if the object's type or class type matches any in the list, otherwise `false`.
	*/ isType(...types) {
        return types.includes(this.constructor.type) || types.includes(this.type);
    }
    /**
	* Returns complexity of an instance
	* @return {Number} complexity of this instance (is 1 unless subclassed)
	*/ complexity() {
        return 1;
    }
    /**
	* Returns a JSON representation of an instance
	* @return {Object} JSON
	*/ toJSON() {
        return this.toObject();
    }
    /**
	* Sets "angle" of an instance with centered rotation
	* @param {TDegree} angle Angle value (in degrees)
	*/ rotate(angle) {
        const { centeredRotation: centeredRotation, originX: originX, originY: originY } = this;
        if (centeredRotation) {
            const { x: x, y: y } = this.getRelativeCenterPoint();
            this.originX = $9a54cbcfc1af41ba$var$CENTER;
            this.originY = $9a54cbcfc1af41ba$var$CENTER;
            this.left = x;
            this.top = y;
        }
        this.set("angle", angle);
        if (centeredRotation) {
            const { x: x, y: y } = this.getPositionByOrigin(originX, originY);
            this.left = x;
            this.top = y;
            this.originX = originX;
            this.originY = originY;
        }
    }
    /**
	* This callback function is called by the parent group of an object every
	* time a non-delegated property changes on the group. It is passed the key
	* and value as parameters. Not adding in this function's signature to avoid
	* Travis build error about unused variables.
	*/ setOnGroup() {}
    /**
	* Sets canvas globalCompositeOperation for specific object
	* custom composition operation for the particular object can be specified using globalCompositeOperation property
	* @param {CanvasRenderingContext2D} ctx Rendering canvas context
	*/ _setupCompositeOperation(ctx) {
        if (this.globalCompositeOperation) ctx.globalCompositeOperation = this.globalCompositeOperation;
    }
    /**
	* cancel instance's running animations
	* override if necessary to dispose artifacts such as `clipPath`
	*/ dispose() {
        $9a54cbcfc1af41ba$export$dc18923894d9e56a.cancelByTarget(this);
        this.off();
        this._set("canvas", void 0);
        this._cacheCanvas && $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().dispose(this._cacheCanvas);
        this._cacheCanvas = void 0;
        this._cacheContext = null;
    }
    /**
	* Animates object's properties
	* @param {Record<string, number | number[] | TColorArg>} animatable map of keys and end values
	* @param {Partial<AnimationOptions<T>>} options
	* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-2#animation}
	* @return {Record<string, TAnimation<T>>} map of animation contexts
	*
	* As object — multiple properties
	*
	* object.animate({ left: ..., top: ... });
	* object.animate({ left: ..., top: ... }, { duration: ... });
	*/ animate(animatable, options) {
        return Object.entries(animatable).reduce((acc, [key, endValue])=>{
            acc[key] = this._animate(key, endValue, options);
            return acc;
        }, {});
    }
    /**
	* @private
	* @param {String} key Property to animate
	* @param {String} to Value to animate to
	* @param {Object} [options] Options object
	*/ _animate(key, endValue, options = {}) {
        const path = key.split(".");
        const propIsColor = this.constructor.colorProperties.includes(path[path.length - 1]);
        const { abort: abort, startValue: startValue, onChange: onChange, onComplete: onComplete } = options;
        const animationOptions = {
            ...options,
            target: this,
            startValue: startValue !== null && startValue !== void 0 ? startValue : path.reduce((deep, key)=>deep[key], this),
            endValue: endValue,
            abort: abort === null || abort === void 0 ? void 0 : abort.bind(this),
            onChange: (value, valueProgress, durationProgress)=>{
                path.reduce((deep, key, index)=>{
                    if (index === path.length - 1) deep[key] = value;
                    return deep[key];
                }, this);
                onChange && onChange(value, valueProgress, durationProgress);
            },
            onComplete: (value, valueProgress, durationProgress)=>{
                this.setCoords();
                onComplete && onComplete(value, valueProgress, durationProgress);
            }
        };
        return propIsColor ? $9a54cbcfc1af41ba$var$animateColor(animationOptions) : $9a54cbcfc1af41ba$var$animate(animationOptions);
    }
    /**
	* Checks if object is descendant of target
	* Should be used instead of {@link Group.contains} or {@link StaticCanvas.contains} for performance reasons
	* @param {TAncestor} target
	* @returns {boolean}
	*/ isDescendantOf(target) {
        const { parent: parent, group: group } = this;
        return parent === target || group === target || !!parent && parent.isDescendantOf(target) || !!group && group !== parent && group.isDescendantOf(target);
    }
    /**
	* @returns {Ancestors} ancestors (excluding `ActiveSelection`) from bottom to top
	*/ getAncestors() {
        const ancestors = [];
        let parent = this;
        do {
            parent = parent.parent;
            parent && ancestors.push(parent);
        }while (parent);
        return ancestors;
    }
    /**
	* Compare ancestors
	*
	* @param {StackedObject} other
	* @returns {AncestryComparison} an object that represent the ancestry situation.
	*/ findCommonAncestors(other) {
        if (this === other) return {
            fork: [],
            otherFork: [],
            common: [
                this,
                ...this.getAncestors()
            ]
        };
        const ancestors = this.getAncestors();
        const otherAncestors = other.getAncestors();
        if (ancestors.length === 0 && otherAncestors.length > 0 && this === otherAncestors[otherAncestors.length - 1]) return {
            fork: [],
            otherFork: [
                other,
                ...otherAncestors.slice(0, otherAncestors.length - 1)
            ],
            common: [
                this
            ]
        };
        for(let i = 0, ancestor; i < ancestors.length; i++){
            ancestor = ancestors[i];
            if (ancestor === other) return {
                fork: [
                    this,
                    ...ancestors.slice(0, i)
                ],
                otherFork: [],
                common: ancestors.slice(i)
            };
            for(let j = 0; j < otherAncestors.length; j++){
                if (this === otherAncestors[j]) return {
                    fork: [],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: [
                        this,
                        ...ancestors
                    ]
                };
                if (ancestor === otherAncestors[j]) return {
                    fork: [
                        this,
                        ...ancestors.slice(0, i)
                    ],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: ancestors.slice(i)
                };
            }
        }
        return {
            fork: [
                this,
                ...ancestors
            ],
            otherFork: [
                other,
                ...otherAncestors
            ],
            common: []
        };
    }
    /**
	*
	* @param {StackedObject} other
	* @returns {boolean}
	*/ hasCommonAncestors(other) {
        const commonAncestors = this.findCommonAncestors(other);
        return commonAncestors && !!commonAncestors.common.length;
    }
    /**
	*
	* @param {FabricObject} other object to compare against
	* @returns {boolean | undefined} if objects do not share a common ancestor or they are strictly equal it is impossible to determine which is in front of the other; in such cases the function returns `undefined`
	*/ isInFrontOf(other) {
        if (this === other) return;
        const ancestorData = this.findCommonAncestors(other);
        if (ancestorData.fork.includes(other)) return true;
        if (ancestorData.otherFork.includes(this)) return false;
        const firstCommonAncestor = ancestorData.common[0] || this.canvas;
        if (!firstCommonAncestor) return;
        const headOfFork = ancestorData.fork.pop(), headOfOtherFork = ancestorData.otherFork.pop(), thisIndex = firstCommonAncestor._objects.indexOf(headOfFork), otherIndex = firstCommonAncestor._objects.indexOf(headOfOtherFork);
        return thisIndex > -1 && thisIndex > otherIndex;
    }
    /**
	* Returns an object representation of an instance
	* @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} Object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        const propertiesToSerialize = propertiesToInclude.concat(FabricObject.customProperties, this.constructor.customProperties || []);
        let clipPathData;
        const NUM_FRACTION_DIGITS = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        const { clipPath: clipPath, fill: fill, stroke: stroke, shadow: shadow, strokeDashArray: strokeDashArray, left: left, top: top, originX: originX, originY: originY, width: width, height: height, strokeWidth: strokeWidth, strokeLineCap: strokeLineCap, strokeDashOffset: strokeDashOffset, strokeLineJoin: strokeLineJoin, strokeUniform: strokeUniform, strokeMiterLimit: strokeMiterLimit, scaleX: scaleX, scaleY: scaleY, angle: angle, flipX: flipX, flipY: flipY, opacity: opacity, visible: visible, backgroundColor: backgroundColor, fillRule: fillRule, paintFirst: paintFirst, globalCompositeOperation: globalCompositeOperation, skewX: skewX, skewY: skewY } = this;
        if (clipPath && !clipPath.excludeFromExport) clipPathData = clipPath.toObject(propertiesToSerialize.concat("inverted", "absolutePositioned"));
        const toFixedBound = (val)=>$9a54cbcfc1af41ba$var$toFixed(val, NUM_FRACTION_DIGITS);
        const object = {
            ...$9a54cbcfc1af41ba$var$pick(this, propertiesToSerialize),
            type: this.constructor.type,
            version: $9a54cbcfc1af41ba$export$83d89fbfd8236492,
            originX: originX,
            originY: originY,
            left: toFixedBound(left),
            top: toFixedBound(top),
            width: toFixedBound(width),
            height: toFixedBound(height),
            fill: $9a54cbcfc1af41ba$var$isSerializableFiller(fill) ? fill.toObject() : fill,
            stroke: $9a54cbcfc1af41ba$var$isSerializableFiller(stroke) ? stroke.toObject() : stroke,
            strokeWidth: toFixedBound(strokeWidth),
            strokeDashArray: strokeDashArray ? strokeDashArray.concat() : strokeDashArray,
            strokeLineCap: strokeLineCap,
            strokeDashOffset: strokeDashOffset,
            strokeLineJoin: strokeLineJoin,
            strokeUniform: strokeUniform,
            strokeMiterLimit: toFixedBound(strokeMiterLimit),
            scaleX: toFixedBound(scaleX),
            scaleY: toFixedBound(scaleY),
            angle: toFixedBound(angle),
            flipX: flipX,
            flipY: flipY,
            opacity: toFixedBound(opacity),
            shadow: shadow ? shadow.toObject() : shadow,
            visible: visible,
            backgroundColor: backgroundColor,
            fillRule: fillRule,
            paintFirst: paintFirst,
            globalCompositeOperation: globalCompositeOperation,
            skewX: toFixedBound(skewX),
            skewY: toFixedBound(skewY),
            ...clipPathData ? {
                clipPath: clipPathData
            } : null
        };
        return !this.includeDefaultValues ? this._removeDefaultValues(object) : object;
    }
    /**
	* Returns (dataless) object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} Object representation of an instance
	*/ toDatalessObject(propertiesToInclude) {
        return this.toObject(propertiesToInclude);
    }
    /**
	* @private
	* @param {Object} object
	*/ _removeDefaultValues(object) {
        const defaults = this.constructor.getDefaults();
        const baseValues = Object.keys(defaults).length > 0 ? defaults : Object.getPrototypeOf(this);
        return $9a54cbcfc1af41ba$var$pickBy(object, (value, key)=>{
            if (key === "left" || key === "top" || key === "type") return true;
            const baseValue = baseValues[key];
            return value !== baseValue && !(Array.isArray(value) && Array.isArray(baseValue) && value.length === 0 && baseValue.length === 0);
        });
    }
    /**
	* Returns a string representation of an instance
	* @return {String}
	*/ toString() {
        return `#<${this.constructor.type}>`;
    }
    /**
	*
	* @param {Function} klass
	* @param {object} object
	* @param {object} [options]
	* @param {string} [options.extraParam] property to pass as first argument to the constructor
	* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @returns {Promise<FabricObject>}
	*/ static _fromObject({ type: type, ...serializedObjectOptions }, { extraParam: extraParam, ...options } = {}) {
        return $9a54cbcfc1af41ba$var$enlivenObjectEnlivables(serializedObjectOptions, options).then((enlivedObjectOptions)=>{
            if (extraParam) {
                delete enlivedObjectOptions[extraParam];
                return new this(serializedObjectOptions[extraParam], enlivedObjectOptions);
            } else return new this(enlivedObjectOptions);
        });
    }
    /**
	*
	* @param {object} object
	* @param {object} [options]
	* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @returns {Promise<FabricObject>}
	*/ static fromObject(object, options) {
        return this._fromObject(object, options);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "stateProperties", $9a54cbcfc1af41ba$var$stateProperties);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "cacheProperties", $9a54cbcfc1af41ba$var$cacheProperties);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "ownDefaults", $9a54cbcfc1af41ba$var$fabricObjectDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "type", "FabricObject");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "colorProperties", [
    $9a54cbcfc1af41ba$var$FILL,
    $9a54cbcfc1af41ba$var$STROKE,
    "backgroundColor"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "customProperties", []);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c2d2360b5ec84692);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c2d2360b5ec84692, "object");
//#endregion
//#region src/controls/fireEvent.ts
const $9a54cbcfc1af41ba$var$fireEvent = (eventName, options)=>{
    var _target$canvas;
    const { transform: { target: target } } = options;
    (_target$canvas = target.canvas) === null || _target$canvas === void 0 || _target$canvas.fire(`object:${eventName}`, {
        ...options,
        target: target
    });
    target.fire(eventName, options);
};
//#endregion
//#region src/controls/wrapWithFireEvent.ts
/**
* Wrap an action handler with firing an event if the action is performed
* @param {TModificationEvents} eventName the event we want to fire
* @param {TransformActionHandler<T>} actionHandler the function to wrap
* @param {object} extraEventInfo extra information to pas to the event handler
* @return {TransformActionHandler<T>} a function with an action handler signature
*/ const $9a54cbcfc1af41ba$var$wrapWithFireEvent = (eventName, actionHandler, extraEventInfo)=>{
    return (eventData, transform, x, y)=>{
        const actionPerformed = actionHandler(eventData, transform, x, y);
        if (actionPerformed) $9a54cbcfc1af41ba$var$fireEvent(eventName, {
            ...$9a54cbcfc1af41ba$var$commonEventInfo(eventData, transform, x, y),
            ...extraEventInfo
        });
        return actionPerformed;
    };
};
//#endregion
//#region src/controls/wrapWithFixedAnchor.ts
/**
* Wrap an action handler with saving/restoring object position on the transform.
* this is the code that permits to objects to keep their position while transforming.
* @param {Function} actionHandler the function to wrap
* @return {Function} a function with an action handler signature
*/ function $9a54cbcfc1af41ba$var$wrapWithFixedAnchor(actionHandler) {
    return (eventData, transform, x, y)=>{
        const { target: target, originX: originX, originY: originY } = transform, constraint = target.getPositionByOrigin(originX, originY), actionPerformed = actionHandler(eventData, transform, x, y);
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return actionPerformed;
    };
}
//#endregion
//#region src/controls/changeWidth.ts
const $9a54cbcfc1af41ba$var$changeObjectDimensionGen = (dimension, origin, xorY, scale)=>(eventData, transform, x, y)=>{
        const localPointValue = $9a54cbcfc1af41ba$var$getLocalPoint(transform, transform.originX, transform.originY, x, y)[xorY];
        const originValue = $9a54cbcfc1af41ba$var$resolveOrigin(transform[origin]);
        if (originValue === 0 || originValue > 0 && localPointValue < 0 || originValue < 0 && localPointValue > 0) {
            const { target: target } = transform, strokePadding = target.strokeWidth / (target.strokeUniform ? target[scale] : 1), multiplier = $9a54cbcfc1af41ba$var$isTransformCentered(transform) ? 2 : 1, oldWidth = target[dimension], newWidth = Math.abs(localPointValue * multiplier / target[scale]) - strokePadding;
            target.set(dimension, Math.max(newWidth, 1));
            return oldWidth !== target[dimension];
        }
        return false;
    };
/**
* Action handler to change object's width
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* You want to use this only if you are building a new control handler and you want
* to reuse some logic. use "changeWidth" if you are looking to just use a control for width
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$changeObjectWidth = $9a54cbcfc1af41ba$var$changeObjectDimensionGen("width", "originX", "x", "scaleX");
/**
* Action handler to change object's height
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* You want to use this only if you are building a new control handler and you want
* to reuse some logic. use "changeHeight" if you are looking to just use a control for height
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$changeObjectHeight = $9a54cbcfc1af41ba$var$changeObjectDimensionGen("height", "originY", "y", "scaleY");
/**
* Control handler for changing width
*/ const $9a54cbcfc1af41ba$var$changeWidth = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$RESIZING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$changeObjectWidth));
/**
* Control handler for changing height
*/ const $9a54cbcfc1af41ba$var$changeHeight = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$RESIZING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$changeObjectHeight));
//#endregion
//#region src/controls/controlRendering.ts
/**
* Render a round control, as per fabric features.
* This function is written to respect object properties like transparentCorners, cornerSize
* cornerColor, cornerStrokeColor
* plus the addition of offsetY and offsetX.
* @param {CanvasRenderingContext2D} ctx context to render on
* @param {Number} left x coordinate where the control center should be
* @param {Number} top y coordinate where the control center should be
* @param {Object} styleOverride override for FabricObject controls style
* @param {FabricObject} fabricObject the fabric object for which we are rendering controls
*/ function $9a54cbcfc1af41ba$var$renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
    ctx.save();
    const { stroke: stroke, xSize: xSize, ySize: ySize, opName: opName } = this.commonRenderProps(ctx, left, top, fabricObject, styleOverride);
    let size = xSize;
    if (xSize > ySize) ctx.scale(1, ySize / xSize);
    else if (ySize > xSize) {
        size = ySize;
        ctx.scale(xSize / ySize, 1);
    }
    ctx.beginPath();
    ctx.arc(0, 0, size / 2, 0, $9a54cbcfc1af41ba$var$twoMathPi, false);
    ctx[opName]();
    if (stroke) ctx.stroke();
    ctx.restore();
}
/**
* Render a square control, as per fabric features.
* This function is written to respect object properties like transparentCorners, cornerSize
* cornerColor, cornerStrokeColor
* plus the addition of offsetY and offsetX.
* @param {CanvasRenderingContext2D} ctx context to render on
* @param {Number} left x coordinate where the control center should be
* @param {Number} top y coordinate where the control center should be
* @param {Object} styleOverride override for FabricObject controls style
* @param {FabricObject} fabricObject the fabric object for which we are rendering controls
*/ function $9a54cbcfc1af41ba$var$renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    ctx.save();
    const { stroke: stroke, xSize: xSize, ySize: ySize, opName: opName } = this.commonRenderProps(ctx, left, top, fabricObject, styleOverride), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
    ctx[`${opName}Rect`](-xSizeBy2, -ySizeBy2, xSize, ySize);
    if (stroke) ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx.restore();
}
//#endregion
//#region src/controls/Control.ts
var $9a54cbcfc1af41ba$export$7a7fa4424cb20976 = class {
    constructor(options){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* keep track of control visibility.
			* mainly for backward compatibility.
			* if you do not want to see a control, you can remove it
			* from the control set.
			* @type {Boolean}
			* @default true
			*/ "visible", true);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Name of the action that the control will likely execute.
			* This is optional. FabricJS uses to identify what the user is doing for some
			* extra optimizations. If you are writing a custom control and you want to know
			* somewhere else in the code what is going on, you can use this string here.
			* you can also provide a custom getActionName if your control run multiple actions
			* depending on some external state.
			* default to scale since is the most common, used on 4 corners by default
			* @type {String}
			* @default 'scale'
			*/ "actionName", $9a54cbcfc1af41ba$var$SCALE);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Drawing angle of the control.
			* NOT used for now, but name marked as needed for internal logic
			* example: to reuse the same drawing function for different rotated controls
			* @type {Number}
			* @default 0
			*/ "angle", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Relative position of the control. X
			* 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
			* of the bounding box.
			* @type {Number}
			* @default 0
			*/ "x", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Relative position of the control. Y
			* 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
			* of the bounding box.
			* @type {Number}
			* @default 0
			*/ "y", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Horizontal offset of the control from the defined position. In pixels
			* Positive offset moves the control to the right, negative to the left.
			* It used when you want to have position of control that does not scale with
			* the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
			* the boundind box, with an offset of 30 pixels vertically. Those 30 pixels will
			* stay 30 pixels no matter how the object is big. Another example is having 2
			* controls in the corner, that stay in the same position when the object scale.
			* of the bounding box.
			* @type {Number}
			* @default 0
			*/ "offsetX", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Vertical offset of the control from the defined position. In pixels
			* Positive offset moves the control to the bottom, negative to the top.
			* @type {Number}
			* @default 0
			*/ "offsetY", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Sets the length of the control. If null, defaults to object's cornerSize.
			* Expects both sizeX and sizeY to be set when set.
			* @type {?Number}
			* @default null
			*/ "sizeX", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Sets the height of the control. If null, defaults to object's cornerSize.
			* Expects both sizeX and sizeY to be set when set.
			* @type {?Number}
			* @default null
			*/ "sizeY", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
			* Expects both touchSizeX and touchSizeY to be set when set.
			* @type {?Number}
			* @default null
			*/ "touchSizeX", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
			* Expects both touchSizeX and touchSizeY to be set when set.
			* @type {?Number}
			* @default null
			*/ "touchSizeY", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Css cursor style to display when the control is hovered.
			* if the method `cursorStyleHandler` is provided, this property is ignored.
			* @type {String}
			* @default 'crosshair'
			*/ "cursorStyle", "crosshair");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* If controls has an offsetY or offsetX, draw a line that connects
			* the control to the bounding box
			* @type {Boolean}
			* @default false
			*/ "withConnection", false);
        Object.assign(this, options);
    }
    getTransformAnchorPoint() {
        var _this$transformAnchor;
        return (_this$transformAnchor = this.transformAnchorPoint) !== null && _this$transformAnchor !== void 0 ? _this$transformAnchor : new $9a54cbcfc1af41ba$export$baf26146a414f24a(-this.x + .5, -this.y + .5);
    }
    shouldActivate(controlKey, fabricObject, pointer, { tl: tl, tr: tr, br: br, bl: bl }) {
        var _fabricObject$canvas;
        return ((_fabricObject$canvas = fabricObject.canvas) === null || _fabricObject$canvas === void 0 ? void 0 : _fabricObject$canvas.getActiveObject()) === fabricObject && fabricObject.isControlVisible(controlKey) && $9a54cbcfc1af41ba$export$869c896bf338bf5a.isPointInPolygon(pointer, [
            tl,
            tr,
            br,
            bl
        ]);
    }
    /**
	* Returns control actionHandler
	* @param {Event} eventData the native mouse event
	* @param {FabricObject} fabricObject on which the control is displayed
	* @param {Control} control control for which the action handler is being asked
	* @return {Function} the action handler
	*/ getActionHandler(eventData, fabricObject, control) {
        return this.actionHandler;
    }
    /**
	* Returns control mouseDown handler
	* @param {Event} eventData the native mouse event
	* @param {FabricObject} fabricObject on which the control is displayed
	* @param {Control} control control for which the action handler is being asked
	* @return {Function} the action handler
	*/ getMouseDownHandler(eventData, fabricObject, control) {
        return this.mouseDownHandler;
    }
    /**
	* Returns control mouseUp handler.
	* During actions the fabricObject or the control can be of different obj
	* @param {Event} eventData the native mouse event
	* @param {FabricObject} fabricObject on which the control is displayed
	* @param {Control} control control for which the action handler is being asked
	* @return {Function} the action handler
	*/ getMouseUpHandler(eventData, fabricObject, control) {
        return this.mouseUpHandler;
    }
    /**
	* Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
	* function you can pass one in the constructor
	* the cursorStyle property
	* @param {Event} eventData the native mouse event
	* @param {Control} control the current control ( likely this)
	* @param {FabricObject} object on which the control is displayed
	* @return {String}
	*/ cursorStyleHandler(eventData, control, fabricObject, coord) {
        return control.cursorStyle;
    }
    /**
	* Returns the action name. The basic implementation just return the actionName property.
	* @param {Event} eventData the native mouse event
	* @param {Control} control the current control ( likely this)
	* @param {FabricObject} object on which the control is displayed
	* @return {String}
	*/ getActionName(eventData, control, fabricObject) {
        return control.actionName;
    }
    /**
	* Returns controls visibility
	* @param {FabricObject} object on which the control is displayed
	* @param {String} controlKey key where the control is memorized on the
	* @return {Boolean}
	*/ getVisibility(fabricObject, controlKey) {
        var _fabricObject$_contro, _fabricObject$_contro2;
        return (_fabricObject$_contro = (_fabricObject$_contro2 = fabricObject._controlsVisibility) === null || _fabricObject$_contro2 === void 0 ? void 0 : _fabricObject$_contro2[controlKey]) !== null && _fabricObject$_contro !== void 0 ? _fabricObject$_contro : this.visible;
    }
    /**
	* Sets controls visibility
	* @param {Boolean} visibility for the object
	* @return {Void}
	*/ setVisibility(visibility, name, fabricObject) {
        this.visible = visibility;
    }
    positionHandler(dim, finalMatrix, fabricObject, currentControl) {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.x * dim.x + this.offsetX, this.y * dim.y + this.offsetY).transform(finalMatrix);
    }
    /**
	* Returns the coords for this control based on object values.
	* @param {Number} objectAngle angle from the fabric object holding the control
	* @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
	*   isTouch is true)
	* @param {Number} centerX x coordinate where the control center should be
	* @param {Number} centerY y coordinate where the control center should be
	* @param {boolean} isTouch true if touch corner, false if normal corner
	*/ calcCornerCoords(angle, objectCornerSize, centerX, centerY, isTouch, fabricObject) {
        const t = $9a54cbcfc1af41ba$var$multiplyTransformMatrixArray([
            $9a54cbcfc1af41ba$var$createTranslateMatrix(centerX, centerY),
            $9a54cbcfc1af41ba$var$createRotateMatrix({
                angle: angle
            }),
            $9a54cbcfc1af41ba$var$createScaleMatrix((isTouch ? this.touchSizeX : this.sizeX) || objectCornerSize, (isTouch ? this.touchSizeY : this.sizeY) || objectCornerSize)
        ]);
        return {
            tl: new $9a54cbcfc1af41ba$export$baf26146a414f24a(-0.5, -0.5).transform(t),
            tr: new $9a54cbcfc1af41ba$export$baf26146a414f24a(.5, -0.5).transform(t),
            br: new $9a54cbcfc1af41ba$export$baf26146a414f24a(.5, .5).transform(t),
            bl: new $9a54cbcfc1af41ba$export$baf26146a414f24a(-0.5, .5).transform(t)
        };
    }
    /**
	* This is an helper method to prepare the canvas to render a control
	* It detectes common control properties and sets the correct fill and
	* stroke styles on the context. It does not execute translations or
	* rotations since different controls need differnt combination of these.
	*/ commonRenderProps(ctx, left, top, fabricObject, styleOverride = {}) {
        const { cornerSize: cornerSize, cornerColor: cornerColor, transparentCorners: transparentCorners, cornerStrokeColor: cornerStrokeColor } = styleOverride, sizeFromProps = cornerSize || fabricObject.cornerSize, xSize = this.sizeX || sizeFromProps, ySize = this.sizeY || sizeFromProps, transparent = typeof transparentCorners !== "undefined" ? transparentCorners : fabricObject.transparentCorners, opName = transparent ? $9a54cbcfc1af41ba$var$STROKE : $9a54cbcfc1af41ba$var$FILL, strokeColor = cornerStrokeColor || fabricObject.cornerStrokeColor, stroke = !transparent && !!strokeColor;
        ctx.fillStyle = cornerColor || fabricObject.cornerColor || "";
        ctx.strokeStyle = strokeColor || "";
        ctx.translate(left, top);
        ctx.rotate($9a54cbcfc1af41ba$var$degreesToRadians(fabricObject.getTotalAngle()));
        return {
            stroke: stroke,
            xSize: xSize,
            ySize: ySize,
            transparentCorners: transparent,
            opName: opName
        };
    }
    /**
	* Render function for the control.
	* When this function runs the context is unscaled. unrotate. Just retina scaled.
	* all the functions will have to translate to the point left,top before starting Drawing
	* if they want to draw a control where the position is detected.
	* left and top are the result of the positionHandler function
	* @param {RenderingContext2D} ctx the context where the control will be drawn
	* @param {Number} left position of the canvas where we are about to render the control.
	* @param {Number} top position of the canvas where we are about to render the control.
	* @param {Object} styleOverride
	* @param {FabricObject} fabricObject the object where the control is about to be rendered
	*/ render(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        switch(styleOverride.cornerStyle || fabricObject.cornerStyle){
            case "circle":
                $9a54cbcfc1af41ba$var$renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
                break;
            default:
                $9a54cbcfc1af41ba$var$renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }
    }
};
//#endregion
//#region src/controls/rotate.ts
/**
* Find the correct style for the control that is used for rotation.
* this function is very simple and it just take care of not-allowed or standard cursor
* @param {Event} eventData the javascript event that is causing the scale
* @param {Control} control the control that is interested in the action
* @param {FabricObject} fabricObject the fabric object that is interested in the action
* @return {String} a valid css string for the cursor
*/ const $9a54cbcfc1af41ba$var$rotationStyleHandler = (eventData, control, fabricObject)=>{
    if (fabricObject.lockRotation) return $9a54cbcfc1af41ba$var$NOT_ALLOWED_CURSOR;
    return control.cursorStyle;
};
/**
* Action handler for rotation and snapping, without anchor point.
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
* @private
*/ const $9a54cbcfc1af41ba$var$rotateObjectWithSnapping = (eventData, { target: target, ex: ex, ey: ey, theta: theta, originX: originX, originY: originY }, x, y)=>{
    const pivotPoint = target.getPositionByOrigin(originX, originY);
    if ($9a54cbcfc1af41ba$var$isLocked(target, "lockRotation")) return false;
    const lastAngle = Math.atan2(ey - pivotPoint.y, ex - pivotPoint.x);
    let angle = $9a54cbcfc1af41ba$var$radiansToDegrees(Math.atan2(y - pivotPoint.y, x - pivotPoint.x) - lastAngle + theta);
    if (target.snapAngle && target.snapAngle > 0) {
        const snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
        if (Math.abs(angle - leftAngleLocked) < snapThreshold) angle = leftAngleLocked;
        else if (Math.abs(angle - rightAngleLocked) < snapThreshold) angle = rightAngleLocked;
    }
    if (angle < 0) angle = 360 + angle;
    angle %= 360;
    const hasRotated = target.angle !== angle;
    target.angle = angle;
    return hasRotated;
};
const $9a54cbcfc1af41ba$var$rotationWithSnapping = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$ROTATING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$rotateObjectWithSnapping));
//#endregion
//#region src/controls/scale.ts
/**
* Inspect event and fabricObject properties to understand if the scaling action
* @param {Event} eventData from the user action
* @param {FabricObject} fabricObject the fabric object about to scale
* @return {Boolean} true if scale is proportional
*/ function $9a54cbcfc1af41ba$var$scaleIsProportional(eventData, fabricObject) {
    const canvas = fabricObject.canvas, uniformIsToggled = eventData[canvas.uniScaleKey];
    return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
}
/**
* Inspect fabricObject to understand if the current scaling action is allowed
* @param {FabricObject} fabricObject the fabric object about to scale
* @param {String} by 'x' or 'y' or ''
* @param {Boolean} scaleProportionally true if we are trying to scale proportionally
* @return {Boolean} true if scaling is not allowed at current conditions
*/ function $9a54cbcfc1af41ba$var$scalingIsForbidden(fabricObject, by, scaleProportionally) {
    const lockX = $9a54cbcfc1af41ba$var$isLocked(fabricObject, "lockScalingX"), lockY = $9a54cbcfc1af41ba$var$isLocked(fabricObject, "lockScalingY");
    if (lockX && lockY) return true;
    if (!by && (lockX || lockY) && scaleProportionally) return true;
    if (lockX && by === "x") return true;
    if (lockY && by === "y") return true;
    const { width: width, height: height, strokeWidth: strokeWidth } = fabricObject;
    if (width === 0 && strokeWidth === 0 && by !== "y") return true;
    if (height === 0 && strokeWidth === 0 && by !== "x") return true;
    return false;
}
const $9a54cbcfc1af41ba$var$scaleMap = [
    "e",
    "se",
    "s",
    "sw",
    "w",
    "nw",
    "n",
    "ne",
    "e"
];
/**
* return the correct cursor style for the scale action
* @param {Event} eventData the javascript event that is causing the scale
* @param {Control} control the control that is interested in the action
* @param {FabricObject} fabricObject the fabric object that is interested in the action
* @return {String} a valid css string for the cursor
*/ const $9a54cbcfc1af41ba$var$scaleCursorStyleHandler = (eventData, control, fabricObject, coord)=>{
    const scaleProportionally = $9a54cbcfc1af41ba$var$scaleIsProportional(eventData, fabricObject);
    if ($9a54cbcfc1af41ba$var$scalingIsForbidden(fabricObject, control.x !== 0 && control.y === 0 ? "x" : control.x === 0 && control.y !== 0 ? "y" : "", scaleProportionally)) return $9a54cbcfc1af41ba$var$NOT_ALLOWED_CURSOR;
    return `${$9a54cbcfc1af41ba$var$scaleMap[$9a54cbcfc1af41ba$var$findCornerQuadrant(fabricObject, control, coord)]}-resize`;
};
/**
* Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @param {Object} options additional information for scaling
* @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
* @return {Boolean} true if some change happened
* @private
*/ function $9a54cbcfc1af41ba$var$scaleObject(eventData, transform, x, y, options = {}) {
    const target = transform.target, by = options.by, scaleProportionally = $9a54cbcfc1af41ba$var$scaleIsProportional(eventData, target), forbidScaling = $9a54cbcfc1af41ba$var$scalingIsForbidden(target, by, scaleProportionally);
    let newPoint, scaleX, scaleY, dim, signX, signY;
    if (forbidScaling) return false;
    if (transform.gestureScale) {
        scaleX = transform.scaleX * transform.gestureScale;
        scaleY = transform.scaleY * transform.gestureScale;
    } else {
        newPoint = $9a54cbcfc1af41ba$var$getLocalPoint(transform, transform.originX, transform.originY, x, y);
        signX = by !== "y" ? Math.sign(newPoint.x || transform.signX || 1) : 1;
        signY = by !== "x" ? Math.sign(newPoint.y || transform.signY || 1) : 1;
        if (!transform.signX) transform.signX = signX;
        if (!transform.signY) transform.signY = signY;
        if ($9a54cbcfc1af41ba$var$isLocked(target, "lockScalingFlip") && (transform.signX !== signX || transform.signY !== signY)) return false;
        dim = target._getTransformedDimensions();
        if (scaleProportionally && !by) {
            const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), { original: original } = transform, scale = distance / (Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY));
            scaleX = original.scaleX * scale;
            scaleY = original.scaleY * scale;
        } else {
            scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
            scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
        }
        if ($9a54cbcfc1af41ba$var$isTransformCentered(transform)) {
            scaleX *= 2;
            scaleY *= 2;
        }
        if (transform.signX !== signX && by !== "y") {
            transform.originX = $9a54cbcfc1af41ba$var$invertOrigin(transform.originX);
            scaleX *= -1;
            transform.signX = signX;
        }
        if (transform.signY !== signY && by !== "x") {
            transform.originY = $9a54cbcfc1af41ba$var$invertOrigin(transform.originY);
            scaleY *= -1;
            transform.signY = signY;
        }
    }
    const oldScaleX = target.scaleX, oldScaleY = target.scaleY;
    if (!by) {
        !$9a54cbcfc1af41ba$var$isLocked(target, "lockScalingX") && target.set("scaleX", scaleX);
        !$9a54cbcfc1af41ba$var$isLocked(target, "lockScalingY") && target.set("scaleY", scaleY);
    } else {
        by === "x" && target.set("scaleX", scaleX);
        by === "y" && target.set("scaleY", scaleY);
    }
    return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
}
/**
* Generic scaling logic, to scale from corners either equally or freely.
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$scaleObjectFromCorner = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$scaleObject(eventData, transform, x, y);
};
/**
* Scaling logic for the X axis.
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$scaleObjectX = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$scaleObject(eventData, transform, x, y, {
        by: "x"
    });
};
/**
* Scaling logic for the Y axis.
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$scaleObjectY = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$scaleObject(eventData, transform, x, y, {
        by: "y"
    });
};
const $9a54cbcfc1af41ba$var$scalingEqually = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$SCALING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$scaleObjectFromCorner));
const $9a54cbcfc1af41ba$var$scalingX = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$SCALING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$scaleObjectX));
const $9a54cbcfc1af41ba$var$scalingY = $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$SCALING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor($9a54cbcfc1af41ba$var$scaleObjectY));
//#endregion
//#region src/controls/skew.ts
const $9a54cbcfc1af41ba$var$AXIS_KEYS = {
    x: {
        counterAxis: "y",
        scale: $9a54cbcfc1af41ba$var$SCALE_X,
        skew: $9a54cbcfc1af41ba$var$SKEW_X,
        lockSkewing: "lockSkewingX",
        origin: "originX",
        flip: "flipX"
    },
    y: {
        counterAxis: "x",
        scale: $9a54cbcfc1af41ba$var$SCALE_Y,
        skew: $9a54cbcfc1af41ba$var$SKEW_Y,
        lockSkewing: "lockSkewingY",
        origin: "originY",
        flip: "flipY"
    }
};
const $9a54cbcfc1af41ba$var$skewMap = [
    "ns",
    "nesw",
    "ew",
    "nwse"
];
/**
* return the correct cursor style for the skew action
* @param {Event} eventData the javascript event that is causing the scale
* @param {Control} control the control that is interested in the action
* @param {FabricObject} fabricObject the fabric object that is interested in the action
* @return {String} a valid css string for the cursor
*/ const $9a54cbcfc1af41ba$var$skewCursorStyleHandler = (eventData, control, fabricObject, coord)=>{
    if (control.x !== 0 && $9a54cbcfc1af41ba$var$isLocked(fabricObject, "lockSkewingY")) return $9a54cbcfc1af41ba$var$NOT_ALLOWED_CURSOR;
    if (control.y !== 0 && $9a54cbcfc1af41ba$var$isLocked(fabricObject, "lockSkewingX")) return $9a54cbcfc1af41ba$var$NOT_ALLOWED_CURSOR;
    return `${$9a54cbcfc1af41ba$var$skewMap[$9a54cbcfc1af41ba$var$findCornerQuadrant(fabricObject, control, coord) % 4]}-resize`;
};
/**
* Since skewing is applied before scaling, calculations are done in a scaleless plane
* @see https://github.com/fabricjs/fabric.js/pull/8380
*/ function $9a54cbcfc1af41ba$var$skewObject(axis, { target: target, ex: ex, ey: ey, skewingSide: skewingSide, ...transform }, pointer) {
    const { skew: skewKey } = $9a54cbcfc1af41ba$var$AXIS_KEYS[axis], offset = pointer.subtract(new $9a54cbcfc1af41ba$export$baf26146a414f24a(ex, ey)).divide(new $9a54cbcfc1af41ba$export$baf26146a414f24a(target.scaleX, target.scaleY))[axis], skewingBefore = target[skewKey], skewingStart = transform[skewKey], shearingStart = Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(skewingStart)), b = axis === "y" ? target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1,
        skewX: 0
    }).x : target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1
    }).y;
    const shearing = 2 * offset * skewingSide / Math.max(b, 1) + shearingStart;
    const skewing = $9a54cbcfc1af41ba$var$radiansToDegrees(Math.atan(shearing));
    target.set(skewKey, skewing);
    const changed = skewingBefore !== target[skewKey];
    if (changed && axis === "y") {
        const { skewX: skewX, scaleX: scaleX } = target, dimBefore = target._getTransformedDimensions({
            skewY: skewingBefore
        }), dimAfter = target._getTransformedDimensions(), compensationFactor = skewX !== 0 ? dimBefore.x / dimAfter.x : 1;
        compensationFactor !== 1 && target.set("scaleX", compensationFactor * scaleX);
    }
    return changed;
}
/**
* Wrapped Action handler for skewing on a given axis, takes care of the
* skew direction and determines the correct transform origin for the anchor point
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ function $9a54cbcfc1af41ba$var$skewHandler(axis, eventData, transform, x, y) {
    const { target: target } = transform, { counterAxis: counterAxis, origin: originKey, lockSkewing: lockSkewingKey, skew: skewKey, flip: flipKey } = $9a54cbcfc1af41ba$var$AXIS_KEYS[axis];
    if ($9a54cbcfc1af41ba$var$isLocked(target, lockSkewingKey)) return false;
    const { origin: counterOriginKey, flip: counterFlipKey } = $9a54cbcfc1af41ba$var$AXIS_KEYS[counterAxis], counterOriginFactor = $9a54cbcfc1af41ba$var$resolveOrigin(transform[counterOriginKey]) * (target[counterFlipKey] ? -1 : 1), skewingSide = -Math.sign(counterOriginFactor) * (target[flipKey] ? -1 : 1), origin = -((target[skewKey] === 0 && $9a54cbcfc1af41ba$var$getLocalPoint(transform, "center", "center", x, y)[axis] > 0 || target[skewKey] > 0 ? 1 : -1) * skewingSide) * .5 + .5;
    return $9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$SKEWING, $9a54cbcfc1af41ba$var$wrapWithFixedAnchor((eventData, transform, x, y)=>$9a54cbcfc1af41ba$var$skewObject(axis, transform, new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y))))(eventData, {
        ...transform,
        [originKey]: origin,
        skewingSide: skewingSide
    }, x, y);
}
/**
* Wrapped Action handler for skewing on the X axis, takes care of the
* skew direction and determines the correct transform origin for the anchor point
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$skewHandlerX = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$skewHandler("x", eventData, transform, x, y);
};
/**
* Wrapped Action handler for skewing on the Y axis, takes care of the
* skew direction and determines the correct transform origin for the anchor point
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$skewHandlerY = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$skewHandler("y", eventData, transform, x, y);
};
//#endregion
//#region src/controls/scaleSkew.ts
function $9a54cbcfc1af41ba$var$isAltAction(eventData, target) {
    return eventData[target.canvas.altActionKey];
}
/**
* Inspect event, control and fabricObject to return the correct action name
* @param {Event} eventData the javascript event that is causing the scale
* @param {Control} control the control that is interested in the action
* @param {FabricObject} fabricObject the fabric object that is interested in the action
* @return {String} an action name
*/ const $9a54cbcfc1af41ba$var$scaleOrSkewActionName = (eventData, control, fabricObject)=>{
    const isAlternative = $9a54cbcfc1af41ba$var$isAltAction(eventData, fabricObject);
    if (control.x === 0) return isAlternative ? $9a54cbcfc1af41ba$var$SKEW_X : $9a54cbcfc1af41ba$var$SCALE_Y;
    if (control.y === 0) return isAlternative ? $9a54cbcfc1af41ba$var$SKEW_Y : $9a54cbcfc1af41ba$var$SCALE_X;
    return "";
};
/**
* Combine skew and scale style handlers to cover fabric standard use case
* @param {Event} eventData the javascript event that is causing the scale
* @param {Control} control the control that is interested in the action
* @param {FabricObject} fabricObject the fabric object that is interested in the action
* @return {String} a valid css string for the cursor
*/ const $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler = (eventData, control, fabricObject, coord)=>{
    return $9a54cbcfc1af41ba$var$isAltAction(eventData, fabricObject) ? $9a54cbcfc1af41ba$var$skewCursorStyleHandler(eventData, control, fabricObject, coord) : $9a54cbcfc1af41ba$var$scaleCursorStyleHandler(eventData, control, fabricObject, coord);
};
/**
* Composed action handler to either scale X or skew Y
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$scalingXOrSkewingY = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$isAltAction(eventData, transform.target) ? $9a54cbcfc1af41ba$var$skewHandlerY(eventData, transform, x, y) : $9a54cbcfc1af41ba$var$scalingX(eventData, transform, x, y);
};
/**
* Composed action handler to either scale Y or skew X
* Needs to be wrapped with `wrapWithFixedAnchor` to be effective
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if some change happened
*/ const $9a54cbcfc1af41ba$var$scalingYOrSkewingX = (eventData, transform, x, y)=>{
    return $9a54cbcfc1af41ba$var$isAltAction(eventData, transform.target) ? $9a54cbcfc1af41ba$var$skewHandlerX(eventData, transform, x, y) : $9a54cbcfc1af41ba$var$scalingY(eventData, transform, x, y);
};
//#endregion
//#region src/controls/commonControls.ts
const $9a54cbcfc1af41ba$var$createObjectDefaultControls = ()=>({
        ml: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingXOrSkewingY,
            getActionName: $9a54cbcfc1af41ba$var$scaleOrSkewActionName
        }),
        mr: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: .5,
            y: 0,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingXOrSkewingY,
            getActionName: $9a54cbcfc1af41ba$var$scaleOrSkewActionName
        }),
        mb: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: 0,
            y: .5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingYOrSkewingX,
            getActionName: $9a54cbcfc1af41ba$var$scaleOrSkewActionName
        }),
        mt: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingYOrSkewingX,
            getActionName: $9a54cbcfc1af41ba$var$scaleOrSkewActionName
        }),
        tl: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: -0.5,
            y: -0.5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingEqually
        }),
        tr: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: .5,
            y: -0.5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingEqually
        }),
        bl: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: -0.5,
            y: .5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingEqually
        }),
        br: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: .5,
            y: .5,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleCursorStyleHandler,
            actionHandler: $9a54cbcfc1af41ba$var$scalingEqually
        }),
        mtr: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            actionHandler: $9a54cbcfc1af41ba$var$rotationWithSnapping,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$rotationStyleHandler,
            offsetY: -40,
            withConnection: true,
            actionName: $9a54cbcfc1af41ba$var$ROTATE
        })
    });
const $9a54cbcfc1af41ba$var$createResizeControls = ()=>({
        mr: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: .5,
            y: 0,
            actionHandler: $9a54cbcfc1af41ba$var$changeWidth,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionName: $9a54cbcfc1af41ba$var$RESIZING
        }),
        ml: new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            actionHandler: $9a54cbcfc1af41ba$var$changeWidth,
            cursorStyleHandler: $9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
            actionName: $9a54cbcfc1af41ba$var$RESIZING
        })
    });
const $9a54cbcfc1af41ba$var$createTextboxDefaultControls = ()=>({
        ...$9a54cbcfc1af41ba$var$createObjectDefaultControls(),
        ...$9a54cbcfc1af41ba$var$createResizeControls()
    });
//#endregion
//#region src/shapes/Object/InteractiveObject.ts
var $9a54cbcfc1af41ba$export$bee544043763fa88 = class InteractiveFabricObject extends $9a54cbcfc1af41ba$export$c2d2360b5ec84692 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...InteractiveFabricObject.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        Object.assign(this, this.constructor.createControls(), InteractiveFabricObject.ownDefaults);
        this.setOptions(options);
    }
    /**
	* Creates the default control object.
	* If you prefer to have on instance of controls shared among all objects
	* make this function return an empty object and add controls to the ownDefaults
	* @param {Object} [options] Options object
	*/ static createControls() {
        return {
            controls: $9a54cbcfc1af41ba$var$createObjectDefaultControls()
        };
    }
    /**
	* Update width and height of the canvas for cache
	* returns true or false if canvas needed resize.
	* @private
	* @return {Boolean} true if the canvas has been resized
	*/ _updateCacheCanvas() {
        const targetCanvas = this.canvas;
        if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
            const transform = targetCanvas._currentTransform, target = transform.target, action = transform.action;
            if (this === target && action && action.startsWith("scale")) return false;
        }
        return super._updateCacheCanvas();
    }
    getActiveControl() {
        const key = this.__corner;
        return key ? {
            key: key,
            control: this.controls[key],
            coord: this.oCoords[key]
        } : void 0;
    }
    /**
	* Determines which corner is under the mouse cursor, represented by `pointer`.
	* This function returns a corner only if the object is the active one.
	* This is done to avoid selecting corner of non active object and activating transformations
	* rather than drag action. The default behavior of fabricJS is that if you want to transform
	* an object, first you select it to show the control set
	* @private
	* @param {Object} pointer The pointer indicating the mouse position
	* @param {boolean} forTouch indicates if we are looking for interaction area with a touch action
	* @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or 0 if nothing is found.
	*/ findControl(pointer, forTouch = false) {
        if (!this.hasControls || !this.canvas) return;
        this.__corner = void 0;
        const cornerEntries = Object.entries(this.oCoords);
        for(let i = cornerEntries.length - 1; i >= 0; i--){
            const [key, corner] = cornerEntries[i];
            const control = this.controls[key];
            if (control.shouldActivate(key, this, pointer, forTouch ? corner.touchCorner : corner.corner)) {
                this.__corner = key;
                return {
                    key: key,
                    control: control,
                    coord: this.oCoords[key]
                };
            }
        }
    }
    /**
	* Calculates the coordinates of the center of each control plus the corners of the control itself
	* This basically just delegates to each control positionHandler
	* WARNING: changing what is passed to positionHandler is a breaking change, since position handler
	* is a public api and should be done just if extremely necessary
	* @return {Record<string, TOCoord>}
	*/ calcOCoords() {
        const vpt = this.getViewportTransform(), center = this.getCenterPoint(), finalMatrix = $9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$multiplyTransformMatrices(vpt, $9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$createTranslateMatrix(center.x, center.y), $9a54cbcfc1af41ba$var$createRotateMatrix({
            angle: this.getTotalAngle() - (!!this.group && this.flipX ? 180 : 0)
        }))), [
            1 / vpt[0],
            0,
            0,
            1 / vpt[3],
            0,
            0
        ]), transformOptions = this.group ? $9a54cbcfc1af41ba$var$qrDecompose(this.calcTransformMatrix()) : void 0;
        if (transformOptions) {
            transformOptions.scaleX = Math.abs(transformOptions.scaleX);
            transformOptions.scaleY = Math.abs(transformOptions.scaleY);
        }
        const dim = this._calculateCurrentDimensions(transformOptions), coords = {};
        this.forEachControl((control, key)=>{
            const position = control.positionHandler(dim, finalMatrix, this, control);
            coords[key] = Object.assign(position, this._calcCornerCoords(control, position));
        });
        return coords;
    }
    /**
	* Sets the coordinates that determine the interaction area of each control
	* note: if we would switch to ROUND corner area, all of this would disappear.
	* everything would resolve to a single point and a pythagorean theorem for the distance
	* @todo evaluate simplification of code switching to circle interaction area at runtime
	* @private
	*/ _calcCornerCoords(control, position) {
        const angle = this.getTotalAngle();
        return {
            corner: control.calcCornerCoords(angle, this.cornerSize, position.x, position.y, false, this),
            touchCorner: control.calcCornerCoords(angle, this.touchCornerSize, position.x, position.y, true, this)
        };
    }
    /**
	* @override set controls' coordinates as well
	* See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link https://fabric5.fabricjs.com/fabric-gotchas}
	* @return {void}
	*/ setCoords() {
        super.setCoords();
        this.canvas && (this.oCoords = this.calcOCoords());
    }
    /**
	* Calls a function for each control. The function gets called,
	* with the control, the control's key and the object that is calling the iterator
	* @param {Function} fn function to iterate over the controls over
	*/ forEachControl(fn) {
        for(const i in this.controls)fn(this.controls[i], i, this);
    }
    /**
	* Draws a colored layer behind the object, inside its selection borders.
	* Requires public options: padding, selectionBackgroundColor
	* this function is called when the context is transformed
	* has checks to be skipped when the object is on a staticCanvas
	* @todo evaluate if make this disappear in favor of a pre-render hook for objects
	* this was added by Andrea Bogazzi to make possible some feature for work reasons
	* it seemed a good option, now is an edge case
	* @param {CanvasRenderingContext2D} ctx Context to draw on
	*/ drawSelectionBackground(ctx) {
        if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
        ctx.save();
        const center = this.getRelativeCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.getViewportTransform();
        ctx.translate(center.x, center.y);
        ctx.scale(1 / vpt[0], 1 / vpt[3]);
        ctx.rotate($9a54cbcfc1af41ba$var$degreesToRadians(this.angle));
        ctx.fillStyle = this.selectionBackgroundColor;
        ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
        ctx.restore();
    }
    /**
	* @public override this function in order to customize the drawing of the control box, e.g. rounded corners, different border style.
	* @param {CanvasRenderingContext2D} ctx ctx is rotated and translated so that (0,0) is at object's center
	* @param {Point} size the control box size used
	*/ strokeBorders(ctx, size) {
        ctx.strokeRect(-size.x / 2, -size.y / 2, size.x, size.y);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to draw on
	* @param {Point} size
	* @param {TStyleOverride} styleOverride object to override the object style
	*/ _drawBorders(ctx, size, styleOverride = {}) {
        const options = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            borderDashArray: this.borderDashArray,
            ...styleOverride
        };
        ctx.save();
        ctx.strokeStyle = options.borderColor;
        this._setLineDash(ctx, options.borderDashArray);
        this.strokeBorders(ctx, size);
        options.hasControls && this.drawControlsConnectingLines(ctx, size);
        ctx.restore();
    }
    /**
	* Renders controls and borders for the object
	* the context here is not transformed
	* @todo move to interactivity
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {TStyleOverride} [styleOverride] properties to override the object style
	*/ _renderControls(ctx, styleOverride = {}) {
        const { hasBorders: hasBorders, hasControls: hasControls } = this;
        const styleOptions = {
            hasBorders: hasBorders,
            hasControls: hasControls,
            ...styleOverride
        };
        const vpt = this.getViewportTransform(), shouldDrawBorders = styleOptions.hasBorders, shouldDrawControls = styleOptions.hasControls;
        const options = $9a54cbcfc1af41ba$var$qrDecompose($9a54cbcfc1af41ba$var$multiplyTransformMatrices(vpt, this.calcTransformMatrix()));
        ctx.save();
        ctx.translate(options.translateX, options.translateY);
        ctx.lineWidth = this.borderScaleFactor;
        if (this.group === this.parent) ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        if (this.flipX) options.angle -= 180;
        ctx.rotate($9a54cbcfc1af41ba$var$degreesToRadians(this.group ? options.angle : this.angle));
        shouldDrawBorders && this.drawBorders(ctx, options, styleOverride);
        shouldDrawControls && this.drawControls(ctx, styleOverride);
        ctx.restore();
    }
    /**
	* Draws borders of an object's bounding box.
	* Requires public properties: width, height
	* Requires public options: padding, borderColor
	* @param {CanvasRenderingContext2D} ctx Context to draw on
	* @param {object} options object representing current object parameters
	* @param {TStyleOverride} [styleOverride] object to override the object style
	*/ drawBorders(ctx, options, styleOverride) {
        let size;
        if (styleOverride && styleOverride.forActiveSelection || this.group) {
            const bbox = $9a54cbcfc1af41ba$var$sizeAfterTransform(this.width, this.height, $9a54cbcfc1af41ba$var$calcDimensionsMatrix(options)), stroke = !this.isStrokeAccountedForInDimensions() ? (this.strokeUniform ? new $9a54cbcfc1af41ba$export$baf26146a414f24a().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : new $9a54cbcfc1af41ba$export$baf26146a414f24a(options.scaleX, options.scaleY)).scalarMultiply(this.strokeWidth) : $9a54cbcfc1af41ba$var$ZERO;
            size = bbox.add(stroke).scalarAdd(this.borderScaleFactor).scalarAdd(this.padding * 2);
        } else size = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
        this._drawBorders(ctx, size, styleOverride);
    }
    /**
	* Draws lines from a borders of an object's bounding box to controls that have `withConnection` property set.
	* Requires public properties: width, height
	* Requires public options: padding, borderColor
	* @param {CanvasRenderingContext2D} ctx Context to draw on
	* @param {Point} size object size x = width, y = height
	*/ drawControlsConnectingLines(ctx, size) {
        let shouldStroke = false;
        ctx.beginPath();
        this.forEachControl((control, key)=>{
            if (control.withConnection && control.getVisibility(this, key)) {
                shouldStroke = true;
                ctx.moveTo(control.x * size.x, control.y * size.y);
                ctx.lineTo(control.x * size.x + control.offsetX, control.y * size.y + control.offsetY);
            }
        });
        shouldStroke && ctx.stroke();
    }
    /**
	* Draws corners of an object's bounding box.
	* Requires public properties: width, height
	* Requires public options: cornerSize, padding
	* Be aware that since fabric 6.0 this function does not call setCoords anymore.
	* setCoords needs to be called manually if the object of which we are rendering controls
	* is outside the standard selection and transform process.
	* @param {CanvasRenderingContext2D} ctx Context to draw on
	* @param {ControlRenderingStyleOverride} styleOverride object to override the object style
	*/ drawControls(ctx, styleOverride = {}) {
        ctx.save();
        const retinaScaling = this.getCanvasRetinaScaling();
        const { cornerStrokeColor: cornerStrokeColor, cornerDashArray: cornerDashArray, cornerColor: cornerColor } = this;
        const options = {
            cornerStrokeColor: cornerStrokeColor,
            cornerDashArray: cornerDashArray,
            cornerColor: cornerColor,
            ...styleOverride
        };
        ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
        ctx.strokeStyle = ctx.fillStyle = options.cornerColor;
        if (!this.transparentCorners) ctx.strokeStyle = options.cornerStrokeColor;
        this._setLineDash(ctx, options.cornerDashArray);
        this.forEachControl((control, key)=>{
            if (control.getVisibility(this, key)) {
                const p = this.oCoords[key];
                control.render(ctx, p.x, p.y, options, this);
            }
        });
        ctx.restore();
    }
    /**
	* Returns true if the specified control is visible, false otherwise.
	* @param {string} controlKey The key of the control. Possible values are usually 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr',
	* but since the control api allow for any control name, can be any string.
	* @returns {boolean} true if the specified control is visible, false otherwise
	*/ isControlVisible(controlKey) {
        return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    }
    /**
	* Sets the visibility of the specified control.
	* please do not use.
	* @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
	* but since the control api allow for any control name, can be any string.
	* @param {Boolean} visible true to set the specified control visible, false otherwise
	* @todo discuss this overlap of priority here with the team. Andrea Bogazzi for details
	*/ setControlVisible(controlKey, visible) {
        if (!this._controlsVisibility) this._controlsVisibility = {};
        this._controlsVisibility[controlKey] = visible;
    }
    /**
	* Sets the visibility state of object controls, this is just a bulk option for setControlVisible;
	* @param {Record<string, boolean>} [options] with an optional key per control
	* example: {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
	*/ setControlsVisibility(options = {}) {
        Object.entries(options).forEach(([controlKey, visibility])=>this.setControlVisible(controlKey, visibility));
    }
    /**
	* Clears the canvas.contextTop in a specific area that corresponds to the object's bounding box
	* that is in the canvas.contextContainer.
	* This function is used to clear pieces of contextTop where we render ephemeral effects on top of the object.
	* Example: blinking cursor text selection, drag effects.
	* @todo discuss swapping restoreManually with a renderCallback, but think of async issues
	* @param {Boolean} [restoreManually] When true won't restore the context after clear, in order to draw something else.
	* @return {CanvasRenderingContext2D|undefined} canvas.contextTop that is either still transformed
	* with the object transformMatrix, or restored to neutral transform
	*/ clearContextTop(restoreManually) {
        if (!this.canvas) return;
        const ctx = this.canvas.contextTop;
        if (!ctx) return;
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this.transform(ctx);
        const width = this.width + 4, height = this.height + 4;
        ctx.clearRect(-width / 2, -height / 2, width, height);
        restoreManually || ctx.restore();
        return ctx;
    }
    /**
	* This callback function is called every time _discardActiveObject or _setActiveObject
	* try to to deselect this object. If the function returns true, the process is cancelled
	* @param {Object} [_options] options sent from the upper functions
	* @param {TPointerEvent} [options.e] event if the process is generated by an event
	* @param {FabricObject} [options.object] next object we are setting as active, and reason why
	* this is being deselected
	*/ onDeselect(_options) {
        return false;
    }
    /**
	* This callback function is called every time _discardActiveObject or _setActiveObject
	* try to to select this object. If the function returns true, the process is cancelled
	* @param {Object} [_options] options sent from the upper functions
	* @param {Event} [_options.e] event if the process is generated by an event
	*/ onSelect(_options) {
        return false;
    }
    /**
	* Override to customize Drag behavior
	* Fired from {@link Canvas#_onMouseMove}
	* @returns true in order for the window to start a drag session
	*/ shouldStartDragging(_e) {
        return false;
    }
    /**
	* Override to customize Drag behavior\
	* Fired once a drag session has started
	* @returns true to handle the drag event
	*/ onDragStart(_e) {
        return false;
    }
    /**
	* Override to customize drag and drop behavior
	* @public
	* @param {DragEvent} _e
	* @returns {boolean} true if the object currently dragged can be dropped on the target
	*/ canDrop(_e) {
        return false;
    }
    /**
	* Override to customize drag and drop behavior
	* render a specific effect when an object is the source of a drag event
	* example: render the selection status for the part of text that is being dragged from a text object
	* @public
	* @param {DragEvent} _e
	*/ renderDragSourceEffect(_e) {}
    /**
	* Override to customize drag and drop behavior
	* render a specific effect when an object is the target of a drag event
	* used to show that the underly object can receive a drop, or to show how the
	* object will change when dropping. example: show the cursor where the text is about to be dropped
	* @public
	* @param {DragEvent} _e
	*/ renderDropTargetEffect(_e) {}
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$bee544043763fa88, "ownDefaults", $9a54cbcfc1af41ba$var$interactiveObjectDefaultValues);
//#endregion
//#region src/util/applyMixins.ts
/***
* https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern
*/ function $9a54cbcfc1af41ba$var$applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor)=>{
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name)=>{
            name !== "constructor" && Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
        });
    });
    return derivedCtor;
}
//#endregion
//#region src/shapes/Object/FabricObject.ts
var $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 = class extends $9a54cbcfc1af41ba$export$bee544043763fa88 {
};
$9a54cbcfc1af41ba$var$applyMixins($9a54cbcfc1af41ba$export$5a5fba7eea6847b1, [
    $9a54cbcfc1af41ba$var$FabricObjectSVGExportMixin
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$5a5fba7eea6847b1);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$5a5fba7eea6847b1, "object");
//#endregion
//#region src/util/misc/isTransparent.ts
/**
* Returns true if context has transparent pixel
* at specified location (taking tolerance into account)
* @param {CanvasRenderingContext2D} ctx context
* @param {Number} x x coordinate in canvasElementCoordinate, not fabric space. integer
* @param {Number} y y coordinate in canvasElementCoordinate, not fabric space. integer
* @param {Number} tolerance Tolerance pixels around the point, not alpha tolerance, integer
* @return {boolean} true if transparent
*/ const $9a54cbcfc1af41ba$var$isTransparent = (ctx, x, y, tolerance)=>{
    tolerance = Math.round(tolerance);
    const size = tolerance * 2 + 1;
    const { data: data } = ctx.getImageData(x - tolerance, y - tolerance, size, size);
    for(let i = 3; i < data.length; i += 4)if (data[i] > 0) return false;
    return true;
};
//#endregion
//#region src/util/internals/findRight.ts
const $9a54cbcfc1af41ba$var$findIndexRight = (array, predicate)=>{
    for(let index = array.length - 1; index >= 0; index--)if (predicate(array[index], index, array)) return index;
    return -1;
};
//#endregion
//#region src/util/misc/projectStroke/StrokeProjectionsBase.ts
/**
* @see https://github.com/fabricjs/fabric.js/pull/8344
* @todo consider removing skewing from points before calculating stroke projection,
* see https://github.com/fabricjs/fabric.js/commit/494a10ee2f8c2278ae9a55b20bf50cf6ee25b064#commitcomment-94751537
*/ var $9a54cbcfc1af41ba$var$StrokeProjectionsBase = class {
    constructor(options){
        this.options = options;
        this.strokeProjectionMagnitude = this.options.strokeWidth / 2;
        this.scale = new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.options.scaleX, this.options.scaleY);
        this.strokeUniformScalar = this.options.strokeUniform ? new $9a54cbcfc1af41ba$export$baf26146a414f24a(1 / this.options.scaleX, 1 / this.options.scaleY) : new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1);
    }
    /**
	* When the stroke is uniform, scaling affects the arrangement of points. So we must take it into account.
	*/ createSideVector(from, to) {
        const v = $9a54cbcfc1af41ba$var$createVector(from, to);
        return this.options.strokeUniform ? v.multiply(this.scale) : v;
    }
    projectOrthogonally(from, to, magnitude) {
        return this.applySkew(from.add(this.calcOrthogonalProjection(from, to, magnitude)));
    }
    isSkewed() {
        return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(point) {
        const p = new $9a54cbcfc1af41ba$export$baf26146a414f24a(point);
        p.y += p.x * Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(this.options.skewY));
        p.x += p.y * Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(this.options.skewX));
        return p;
    }
    scaleUnitVector(unitVector, scalar) {
        return unitVector.multiply(this.strokeUniformScalar).scalarMultiply(scalar);
    }
};
//#endregion
//#region src/util/misc/projectStroke/StrokeLineJoinProjections.ts
const $9a54cbcfc1af41ba$var$zeroVector = new $9a54cbcfc1af41ba$export$baf26146a414f24a();
/**
* class in charge of finding projections for each type of line join
* @see {@link [Closed path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#2-closed-path)}
*
* - MDN:
*   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineJoin
*   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linejoin
* - Spec: https://svgwg.org/svg2-draft/painting.html#StrokeLinejoinProperty
* - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
* - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
*
*/ var $9a54cbcfc1af41ba$var$StrokeLineJoinProjections = class StrokeLineJoinProjections extends $9a54cbcfc1af41ba$var$StrokeProjectionsBase {
    static getOrthogonalRotationFactor(vector1, vector2) {
        const angle = vector2 ? $9a54cbcfc1af41ba$var$calcAngleBetweenVectors(vector1, vector2) : $9a54cbcfc1af41ba$var$calcVectorRotation(vector1);
        return Math.abs(angle) < $9a54cbcfc1af41ba$var$halfPI ? -1 : 1;
    }
    constructor(A, B, C, options){
        super(options);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* The AB vector
			*/ "AB", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* The AC vector
			*/ "AC", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* The angle of A (∠BAC)
			*/ "alpha", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* The bisector of A (∠BAC)
			*/ "bisector", void 0);
        this.A = new $9a54cbcfc1af41ba$export$baf26146a414f24a(A);
        this.B = new $9a54cbcfc1af41ba$export$baf26146a414f24a(B);
        this.C = new $9a54cbcfc1af41ba$export$baf26146a414f24a(C);
        this.AB = this.createSideVector(this.A, this.B);
        this.AC = this.createSideVector(this.A, this.C);
        this.alpha = $9a54cbcfc1af41ba$var$calcAngleBetweenVectors(this.AB, this.AC);
        this.bisector = $9a54cbcfc1af41ba$var$getUnitVector($9a54cbcfc1af41ba$var$rotateVector(this.AB.eq($9a54cbcfc1af41ba$var$zeroVector) ? this.AC : this.AB, this.alpha / 2));
    }
    calcOrthogonalProjection(from, to, magnitude = this.strokeProjectionMagnitude) {
        const orthogonalProjection = $9a54cbcfc1af41ba$var$getOrthonormalVector(this.createSideVector(from, to));
        const correctSide = StrokeLineJoinProjections.getOrthogonalRotationFactor(orthogonalProjection, this.bisector);
        return this.scaleUnitVector(orthogonalProjection, magnitude * correctSide);
    }
    /**
	* BEVEL
	* Calculation: the projection points are formed by the vector orthogonal to the vertex.
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#2-2-bevel
	*/ projectBevel() {
        const projections = [];
        (this.alpha % $9a54cbcfc1af41ba$var$twoMathPi === 0 ? [
            this.B
        ] : [
            this.B,
            this.C
        ]).forEach((to)=>{
            projections.push(this.projectOrthogonally(this.A, to));
            projections.push(this.projectOrthogonally(this.A, to, -this.strokeProjectionMagnitude));
        });
        return projections;
    }
    /**
	* MITER
	* Calculation: the corner is formed by extending the outer edges of the stroke
	* at the tangents of the path segments until they intersect.
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#2-1-miter
	*/ projectMiter() {
        const projections = [], alpha = Math.abs(this.alpha), hypotUnitScalar = 1 / Math.sin(alpha / 2), miterVector = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * hypotUnitScalar);
        const strokeMiterLimit = this.options.strokeUniform ? $9a54cbcfc1af41ba$var$magnitude(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
        if ($9a54cbcfc1af41ba$var$magnitude(miterVector) / this.strokeProjectionMagnitude <= strokeMiterLimit) projections.push(this.applySkew(this.A.add(miterVector)));
        projections.push(...this.projectBevel());
        return projections;
    }
    /**
	* ROUND (without skew)
	* Calculation: the projections are the two vectors parallel to X and Y axes
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-1-round-without-skew
	*/ projectRoundNoSkew(startCircle, endCircle) {
        const projections = [], correctSide = new $9a54cbcfc1af41ba$export$baf26146a414f24a(StrokeLineJoinProjections.getOrthogonalRotationFactor(this.bisector), StrokeLineJoinProjections.getOrthogonalRotationFactor(new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.bisector.y, this.bisector.x)));
        [
            new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide),
            new $9a54cbcfc1af41ba$export$baf26146a414f24a(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide)
        ].forEach((vector)=>{
            if ($9a54cbcfc1af41ba$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.A.add(vector));
        });
        return projections;
    }
    /**
	* ROUND (with skew)
	* Calculation: the projections are the points furthest from the vertex in
	* the direction of the X and Y axes after distortion.
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-2-round-skew
	*/ projectRoundWithSkew(startCircle, endCircle) {
        const projections = [];
        const { skewX: skewX, skewY: skewY, scaleX: scaleX, scaleY: scaleY, strokeUniform: strokeUniform } = this.options, shearing = new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(skewX)), Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(skewY)));
        const circleRadius = this.strokeProjectionMagnitude, newY = strokeUniform ? circleRadius / scaleY / Math.sqrt(1 / scaleY ** 2 + 1 / scaleX ** 2 * shearing.y ** 2) : circleRadius / Math.sqrt(1 + shearing.y ** 2), furthestY = new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.sqrt(Math.max(circleRadius ** 2 - newY ** 2, 0)), newY), newX = strokeUniform ? circleRadius / Math.sqrt(1 + shearing.x ** 2 * (1 / scaleY) ** 2 / (1 / scaleX + 1 / scaleX * shearing.x * shearing.y) ** 2) : circleRadius / Math.sqrt(1 + shearing.x ** 2 / (1 + shearing.x * shearing.y) ** 2), furthestX = new $9a54cbcfc1af41ba$export$baf26146a414f24a(newX, Math.sqrt(Math.max(circleRadius ** 2 - newX ** 2, 0)));
        [
            furthestX,
            furthestX.scalarMultiply(-1),
            furthestY,
            furthestY.scalarMultiply(-1)
        ].map((vector)=>this.applySkew(strokeUniform ? vector.multiply(this.strokeUniformScalar) : vector)).forEach((vector)=>{
            if ($9a54cbcfc1af41ba$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.applySkew(this.A).add(vector));
        });
        return projections;
    }
    projectRound() {
        const projections = [];
        projections.push(...this.projectBevel());
        const isStraightLine = this.alpha % $9a54cbcfc1af41ba$var$twoMathPi === 0, newOrigin = this.applySkew(this.A), proj0 = projections[isStraightLine ? 0 : 2].subtract(newOrigin), proj1 = projections[isStraightLine ? 1 : 0].subtract(newOrigin), isProj0Start = $9a54cbcfc1af41ba$var$crossProduct(proj0, isStraightLine ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1))) > 0, startCircle = isProj0Start ? proj0 : proj1, endCircle = isProj0Start ? proj1 : proj0;
        if (!this.isSkewed()) projections.push(...this.projectRoundNoSkew(startCircle, endCircle));
        else projections.push(...this.projectRoundWithSkew(startCircle, endCircle));
        return projections;
    }
    /**
	* Project stroke width on points returning projections for each point as follows:
	* - `miter`: 1 point corresponding to the outer boundary. If the miter limit is exceeded, it will be 2 points (becomes bevel)
	* - `bevel`: 2 points corresponding to the bevel possible boundaries, orthogonal to the stroke.
	* - `round`: same as `bevel` when it has no skew, with skew are 4 points.
	*/ projectPoints() {
        switch(this.options.strokeLineJoin){
            case "miter":
                return this.projectMiter();
            case "round":
                return this.projectRound();
            default:
                return this.projectBevel();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point,
                angle: this.alpha,
                bisector: this.bisector
            }));
    }
};
//#endregion
//#region src/util/misc/projectStroke/StrokeLineCapProjections.ts
/**
* class in charge of finding projections for each type of line cap for start/end of an open path
* @see {@link [Open path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#1-open-path)}
*
* Reference:
* - MDN:
*   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineCap
*   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linecap
* - Spec: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-linecap-dev
* - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
* - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
*/ var $9a54cbcfc1af41ba$var$StrokeLineCapProjections = class extends $9a54cbcfc1af41ba$var$StrokeProjectionsBase {
    constructor(A, T, options){
        super(options);
        this.A = new $9a54cbcfc1af41ba$export$baf26146a414f24a(A);
        this.T = new $9a54cbcfc1af41ba$export$baf26146a414f24a(T);
    }
    calcOrthogonalProjection(from, to, magnitude = this.strokeProjectionMagnitude) {
        const vector = this.createSideVector(from, to);
        return this.scaleUnitVector($9a54cbcfc1af41ba$var$getOrthonormalVector(vector), magnitude);
    }
    /**
	* OPEN PATH START/END - Line cap: Butt
	* Calculation: to find the projections, just find the points orthogonal to the stroke
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#1-1-butt
	*/ projectButt() {
        return [
            this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude),
            this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)
        ];
    }
    /**
	* OPEN PATH START/END - Line cap: Round
	* Calculation: same as stroke line join `round`
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#1-2-round
	*/ projectRound() {
        const projections = [];
        if (!this.isSkewed() && this.A.eq(this.T)) {
            const projection = new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.applySkew(this.A.add(projection)), this.applySkew(this.A.subtract(projection)));
        } else projections.push(...new $9a54cbcfc1af41ba$var$StrokeLineJoinProjections(this.A, this.T, this.T, this.options).projectRound());
        return projections;
    }
    /**
	* OPEN PATH START/END - Line cap: Square
	* Calculation: project a rectangle of points on the stroke in the opposite direction of the vector `AT`
	*
	* @see https://github.com/fabricjs/fabric.js/pull/8344#1-3-square
	*/ projectSquare() {
        const projections = [];
        if (this.A.eq(this.T)) {
            const projection = new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.A.add(projection), this.A.subtract(projection));
        } else {
            const orthogonalProjection = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude);
            const strokePointingOut = this.scaleUnitVector($9a54cbcfc1af41ba$var$getUnitVector(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude);
            const projectedA = this.A.add(strokePointingOut);
            projections.push(projectedA.add(orthogonalProjection), projectedA.subtract(orthogonalProjection));
        }
        return projections.map((p)=>this.applySkew(p));
    }
    projectPoints() {
        switch(this.options.strokeLineCap){
            case "round":
                return this.projectRound();
            case "square":
                return this.projectSquare();
            default:
                return this.projectButt();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point
            }));
    }
};
//#endregion
//#region src/util/misc/projectStroke/index.ts
/**
*
* Used to calculate object's bounding box
*
* @see https://github.com/fabricjs/fabric.js/pull/8344
*
*/ const $9a54cbcfc1af41ba$var$projectStrokeOnPoints = (points, options, openPath = false)=>{
    const projections = [];
    if (points.length === 0) return projections;
    const reduced = points.reduce((reduced, point)=>{
        if (!reduced[reduced.length - 1].eq(point)) reduced.push(new $9a54cbcfc1af41ba$export$baf26146a414f24a(point));
        return reduced;
    }, [
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(points[0])
    ]);
    if (reduced.length === 1) openPath = true;
    else if (!openPath) {
        const start = reduced[0];
        const index = $9a54cbcfc1af41ba$var$findIndexRight(reduced, (point)=>!point.eq(start));
        reduced.splice(index + 1);
    }
    reduced.forEach((A, index, points)=>{
        let B, C;
        if (index === 0) {
            C = points[1];
            B = openPath ? A : points[points.length - 1];
        } else if (index === points.length - 1) {
            B = points[index - 1];
            C = openPath ? A : points[0];
        } else {
            B = points[index - 1];
            C = points[index + 1];
        }
        if (openPath && points.length === 1) projections.push(...new $9a54cbcfc1af41ba$var$StrokeLineCapProjections(A, A, options).project());
        else if (openPath && (index === 0 || index === points.length - 1)) projections.push(...new $9a54cbcfc1af41ba$var$StrokeLineCapProjections(A, index === 0 ? C : B, options).project());
        else projections.push(...new $9a54cbcfc1af41ba$var$StrokeLineJoinProjections(A, B, C, options).project());
    });
    return projections;
};
//#endregion
//#region src/util/internals/cloneStyles.ts
const $9a54cbcfc1af41ba$var$cloneStyles = (style)=>{
    const newObj = {};
    Object.keys(style).forEach((key)=>{
        newObj[key] = {};
        Object.keys(style[key]).forEach((keyInner)=>{
            newObj[key][keyInner] = {
                ...style[key][keyInner]
            };
        });
    });
    return newObj;
};
//#endregion
//#region src/util/misc/textStyles.ts
/**
* @param {Object} prevStyle first style to compare
* @param {Object} thisStyle second style to compare
* @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
* @return {boolean} true if the style changed
*/ const $9a54cbcfc1af41ba$var$hasStyleChanged = (prevStyle, thisStyle, forTextSpans = false)=>prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textDecorationThickness !== thisStyle.textDecorationThickness || prevStyle.textDecorationColor !== thisStyle.textDecorationColor || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
/**
* Returns the array form of a text object's inline styles property with styles grouped in ranges
* rather than per character. This format is less verbose, and is better suited for storage
* so it is used in serialization (not during runtime).
* @param {object} styles per character styles for a text object
* @param {String} text the text string that the styles are applied to
* @return {{start: number, end: number, style: object}[]}
*/ const $9a54cbcfc1af41ba$var$stylesToArray = (styles, text)=>{
    const textLines = text.split("\n"), stylesArray = [];
    let charIndex = -1, prevStyle = {};
    styles = $9a54cbcfc1af41ba$var$cloneStyles(styles);
    for(let i = 0; i < textLines.length; i++){
        const chars = $9a54cbcfc1af41ba$var$graphemeSplit(textLines[i]);
        if (!styles[i]) {
            charIndex += chars.length;
            prevStyle = {};
            continue;
        }
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            const thisStyle = styles[i][c];
            if (thisStyle && Object.keys(thisStyle).length > 0) {
                if ($9a54cbcfc1af41ba$var$hasStyleChanged(prevStyle, thisStyle, true)) stylesArray.push({
                    start: charIndex,
                    end: charIndex + 1,
                    style: thisStyle
                });
                else stylesArray[stylesArray.length - 1].end++;
            }
            prevStyle = thisStyle || {};
        }
    }
    return stylesArray;
};
/**
* Returns the object form of the styles property with styles that are assigned per
* character rather than grouped by range. This format is more verbose, and is
* only used during runtime (not for serialization/storage)
* @param {Array} styles the serialized form of a text object's styles
* @param {String} text the text string that the styles are applied to
* @return {Object}
*/ const $9a54cbcfc1af41ba$var$stylesFromArray = (styles, text)=>{
    if (!Array.isArray(styles)) return $9a54cbcfc1af41ba$var$cloneStyles(styles);
    const textLines = text.split($9a54cbcfc1af41ba$var$reNewline), stylesObject = {};
    let charIndex = -1, styleIndex = 0;
    for(let i = 0; i < textLines.length; i++){
        const chars = $9a54cbcfc1af41ba$var$graphemeSplit(textLines[i]);
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
                stylesObject[i] = stylesObject[i] || {};
                stylesObject[i][c] = {
                    ...styles[styleIndex].style
                };
                if (charIndex === styles[styleIndex].end - 1) styleIndex++;
            }
        }
    }
    return stylesObject;
};
//#endregion
//#region src/parser/attributes.ts
/**
* Attributes parsed from all SVG elements
* @type array
*/ const $9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES = [
    "display",
    "transform",
    $9a54cbcfc1af41ba$var$FILL,
    "fill-opacity",
    "fill-rule",
    "opacity",
    $9a54cbcfc1af41ba$var$STROKE,
    "stroke-dasharray",
    "stroke-linecap",
    "stroke-dashoffset",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "id",
    "paint-order",
    "vector-effect",
    "instantiated_by_use",
    "clip-path"
];
//#endregion
//#region src/parser/selectorMatches.ts
function $9a54cbcfc1af41ba$var$selectorMatches(element, selector) {
    const nodeName = element.nodeName;
    const classNames = element.getAttribute("class");
    const id = element.getAttribute("id");
    const azAz = "(?![a-zA-Z\\-]+)";
    let matcher;
    matcher = new RegExp("^" + nodeName, "i");
    selector = selector.replace(matcher, "");
    if (id && selector.length) {
        matcher = new RegExp("#" + id + azAz, "i");
        selector = selector.replace(matcher, "");
    }
    if (classNames && selector.length) {
        const splitClassNames = classNames.split(" ");
        for(let i = splitClassNames.length; i--;){
            matcher = new RegExp("\\." + splitClassNames[i] + azAz, "i");
            selector = selector.replace(matcher, "");
        }
    }
    return selector.length === 0;
}
//#endregion
//#region src/parser/doesSomeParentMatch.ts
function $9a54cbcfc1af41ba$var$doesSomeParentMatch(element, selectors) {
    let selector, parentMatching = true;
    while(element.parentElement && element.parentElement.nodeType === 1 && selectors.length){
        if (parentMatching) selector = selectors.pop();
        element = element.parentElement;
        parentMatching = $9a54cbcfc1af41ba$var$selectorMatches(element, selector);
    }
    return selectors.length === 0;
}
//#endregion
//#region src/parser/elementMatchesRule.ts
/**
* @private
*/ function $9a54cbcfc1af41ba$var$elementMatchesRule(element, selectors) {
    let parentMatching = true;
    const firstMatching = $9a54cbcfc1af41ba$var$selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) parentMatching = $9a54cbcfc1af41ba$var$doesSomeParentMatch(element, selectors);
    return firstMatching && parentMatching && selectors.length === 0;
}
//#endregion
//#region src/parser/getGlobalStylesForElement.ts
/**
* @private
*/ function $9a54cbcfc1af41ba$var$getGlobalStylesForElement(element, cssRules = {}) {
    let styles = {};
    for(const rule in cssRules)if ($9a54cbcfc1af41ba$var$elementMatchesRule(element, rule.split(" "))) styles = {
        ...styles,
        ...cssRules[rule]
    };
    return styles;
}
//#endregion
//#region src/parser/normalizeAttr.ts
const $9a54cbcfc1af41ba$var$normalizeAttr = (attr)=>{
    var _attributesMap;
    return (_attributesMap = $9a54cbcfc1af41ba$var$attributesMap[attr]) !== null && _attributesMap !== void 0 ? _attributesMap : attr;
};
//#endregion
//#region src/util/internals/cleanupSvgAttribute.ts
const $9a54cbcfc1af41ba$var$regex$1 = new RegExp(`(${$9a54cbcfc1af41ba$var$reNum})`, "gi");
const $9a54cbcfc1af41ba$var$cleanupSvgAttribute = (attributeValue)=>$9a54cbcfc1af41ba$var$normalizeWs(attributeValue.replace($9a54cbcfc1af41ba$var$regex$1, " $1 ").replace(/,/gi, " "));
//#endregion
//#region src/parser/parseTransformAttribute.ts
const $9a54cbcfc1af41ba$var$p$1 = `(${$9a54cbcfc1af41ba$var$reNum})`;
const $9a54cbcfc1af41ba$var$skewX = String.raw`(skewX)\(${$9a54cbcfc1af41ba$var$p$1}\)`;
const $9a54cbcfc1af41ba$var$skewY = String.raw`(skewY)\(${$9a54cbcfc1af41ba$var$p$1}\)`;
const $9a54cbcfc1af41ba$var$rotate = String.raw`(rotate)\(${$9a54cbcfc1af41ba$var$p$1}(?: ${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1})?\)`;
const $9a54cbcfc1af41ba$var$scale = String.raw`(scale)\(${$9a54cbcfc1af41ba$var$p$1}(?: ${$9a54cbcfc1af41ba$var$p$1})?\)`;
const $9a54cbcfc1af41ba$var$translate = String.raw`(translate)\(${$9a54cbcfc1af41ba$var$p$1}(?: ${$9a54cbcfc1af41ba$var$p$1})?\)`;
const $9a54cbcfc1af41ba$var$transform = `(?:${String.raw`(matrix)\(${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1} ${$9a54cbcfc1af41ba$var$p$1}\)`}|${$9a54cbcfc1af41ba$var$translate}|${$9a54cbcfc1af41ba$var$rotate}|${$9a54cbcfc1af41ba$var$scale}|${$9a54cbcfc1af41ba$var$skewX}|${$9a54cbcfc1af41ba$var$skewY})`;
const $9a54cbcfc1af41ba$var$transforms = `(?:${$9a54cbcfc1af41ba$var$transform}*)`;
const $9a54cbcfc1af41ba$var$transformList = String.raw`^\s*(?:${$9a54cbcfc1af41ba$var$transforms}?)\s*$`;
const $9a54cbcfc1af41ba$var$reTransformList = new RegExp($9a54cbcfc1af41ba$var$transformList);
const $9a54cbcfc1af41ba$var$reTransform = new RegExp($9a54cbcfc1af41ba$var$transform);
const $9a54cbcfc1af41ba$var$reTransformAll = new RegExp($9a54cbcfc1af41ba$var$transform, "g");
/**
* Parses "transform" attribute, returning an array of values
* @param {String} attributeValue String containing attribute value
* @return {TTransformMatrix} Array of 6 elements representing transformation matrix
*/ function $9a54cbcfc1af41ba$var$parseTransformAttribute(attributeValue) {
    attributeValue = $9a54cbcfc1af41ba$var$cleanupSvgAttribute(attributeValue).replace(/\s*([()])\s*/gi, "$1");
    const matrices = [];
    if (!attributeValue || attributeValue && !$9a54cbcfc1af41ba$var$reTransformList.test(attributeValue)) return [
        ...$9a54cbcfc1af41ba$export$3c5a7f9475b116e0
    ];
    for (const match of attributeValue.matchAll($9a54cbcfc1af41ba$var$reTransformAll)){
        const transformMatch = $9a54cbcfc1af41ba$var$reTransform.exec(match[0]);
        if (!transformMatch) continue;
        let matrix = $9a54cbcfc1af41ba$export$3c5a7f9475b116e0;
        const [, operation, ...rawArgs] = transformMatch.filter((m)=>!!m);
        const [arg0, arg1, arg2, arg3, arg4, arg5] = rawArgs.map((arg)=>parseFloat(arg));
        switch(operation){
            case "translate":
                matrix = $9a54cbcfc1af41ba$var$createTranslateMatrix(arg0, arg1);
                break;
            case $9a54cbcfc1af41ba$var$ROTATE:
                matrix = $9a54cbcfc1af41ba$var$createRotateMatrix({
                    angle: arg0
                }, {
                    x: arg1,
                    y: arg2
                });
                break;
            case $9a54cbcfc1af41ba$var$SCALE:
                matrix = $9a54cbcfc1af41ba$var$createScaleMatrix(arg0, arg1);
                break;
            case $9a54cbcfc1af41ba$var$SKEW_X:
                matrix = $9a54cbcfc1af41ba$var$createSkewXMatrix(arg0);
                break;
            case $9a54cbcfc1af41ba$var$SKEW_Y:
                matrix = $9a54cbcfc1af41ba$var$createSkewYMatrix(arg0);
                break;
            case "matrix":
                matrix = [
                    arg0,
                    arg1,
                    arg2,
                    arg3,
                    arg4,
                    arg5
                ];
                break;
        }
        matrices.push(matrix);
    }
    return $9a54cbcfc1af41ba$var$multiplyTransformMatrixArray(matrices);
}
//#endregion
//#region src/parser/normalizeValue.ts
function $9a54cbcfc1af41ba$var$normalizeValue(attr, value, parentAttributes, fontSize) {
    const isArray = Array.isArray(value);
    let parsed;
    let ouputValue = value;
    if ((attr === "fill" || attr === "stroke") && value === "none") ouputValue = "";
    else if (attr === "strokeUniform") return value === "non-scaling-stroke";
    else if (attr === "strokeDashArray") {
        if (value === "none") ouputValue = null;
        else ouputValue = value.replace(/,/g, " ").split(/\s+/).map(parseFloat);
    } else if (attr === "transformMatrix") {
        if (parentAttributes && parentAttributes.transformMatrix) ouputValue = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(parentAttributes.transformMatrix, $9a54cbcfc1af41ba$var$parseTransformAttribute(value));
        else ouputValue = $9a54cbcfc1af41ba$var$parseTransformAttribute(value);
    } else if (attr === "visible") {
        ouputValue = value !== "none" && value !== "hidden";
        if (parentAttributes && parentAttributes.visible === false) ouputValue = false;
    } else if (attr === "opacity") {
        ouputValue = parseFloat(value);
        if (parentAttributes && typeof parentAttributes.opacity !== "undefined") ouputValue *= parentAttributes.opacity;
    } else if (attr === "textAnchor") ouputValue = value === "start" ? $9a54cbcfc1af41ba$var$LEFT : value === "end" ? $9a54cbcfc1af41ba$var$RIGHT : $9a54cbcfc1af41ba$var$CENTER;
    else if (attr === "charSpacing" || attr === "textDecorationThickness") parsed = $9a54cbcfc1af41ba$var$parseUnit(value, fontSize) / fontSize * 1e3;
    else if (attr === "paintFirst") {
        const fillIndex = value.indexOf($9a54cbcfc1af41ba$var$FILL);
        const strokeIndex = value.indexOf($9a54cbcfc1af41ba$var$STROKE);
        ouputValue = $9a54cbcfc1af41ba$var$FILL;
        if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) ouputValue = $9a54cbcfc1af41ba$var$STROKE;
        else if (fillIndex === -1 && strokeIndex > -1) ouputValue = $9a54cbcfc1af41ba$var$STROKE;
    } else if (attr === "href" || attr === "xlink:href" || attr === "font" || attr === "id") return value;
    else if (attr === "imageSmoothing") return value === "optimizeQuality";
    else parsed = isArray ? value.map($9a54cbcfc1af41ba$var$parseUnit) : $9a54cbcfc1af41ba$var$parseUnit(value, fontSize);
    return !isArray && isNaN(parsed) ? ouputValue : parsed;
}
//#endregion
//#region src/parser/parseFontDeclaration.ts
/**
* Parses a short font declaration, building adding its properties to a style object
* @param {String} value font declaration
* @param {Object} oStyle definition
*/ function $9a54cbcfc1af41ba$var$parseFontDeclaration(value, oStyle) {
    const match = value.match($9a54cbcfc1af41ba$var$reFontDeclaration);
    if (!match) return;
    const fontStyle = match[1], fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
    if (fontStyle) oStyle.fontStyle = fontStyle;
    if (fontWeight) oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
    if (fontSize) oStyle.fontSize = $9a54cbcfc1af41ba$var$parseUnit(fontSize);
    if (fontFamily) oStyle.fontFamily = fontFamily;
    if (lineHeight) oStyle.lineHeight = lineHeight === "normal" ? 1 : lineHeight;
}
//#endregion
//#region src/parser/parseStyleObject.ts
/**
* Takes a style object and parses it in one that has only defined values
* and lowercases properties
* @param style
* @param oStyle
*/ function $9a54cbcfc1af41ba$var$parseStyleObject(style, oStyle) {
    Object.entries(style).forEach(([prop, value])=>{
        if (value === void 0) return;
        oStyle[prop.toLowerCase()] = value;
    });
}
//#endregion
//#region src/parser/parseStyleString.ts
/**
* Takes a style string and parses it in one that has only defined values
* and lowercases properties
* @param style
* @param oStyle
*/ function $9a54cbcfc1af41ba$var$parseStyleString(style, oStyle) {
    style.replace(/;\s*$/, "").split(";").forEach((chunk)=>{
        if (!chunk) return;
        const [attr, value] = chunk.split(":");
        oStyle[attr.trim().toLowerCase()] = value.trim();
    });
}
//#endregion
//#region src/parser/parseStyleAttribute.ts
/**
* Parses "style" attribute, retuning an object with values
* @param {SVGElement} element Element to parse
* @return {Object} Objects with values parsed from style attribute of an element
*/ function $9a54cbcfc1af41ba$var$parseStyleAttribute(element) {
    const oStyle = {}, style = element.getAttribute("style");
    if (!style) return oStyle;
    if (typeof style === "string") $9a54cbcfc1af41ba$var$parseStyleString(style, oStyle);
    else $9a54cbcfc1af41ba$var$parseStyleObject(style, oStyle);
    return oStyle;
}
//#endregion
//#region src/parser/setStrokeFillOpacity.ts
const $9a54cbcfc1af41ba$var$colorAttributesMap = {
    stroke: "strokeOpacity",
    fill: "fillOpacity"
};
/**
* @private
* @param {Object} attributes Array of attributes to parse
*/ function $9a54cbcfc1af41ba$var$setStrokeFillOpacity(attributes) {
    const defaults = $9a54cbcfc1af41ba$export$5a5fba7eea6847b1.getDefaults();
    Object.entries($9a54cbcfc1af41ba$var$colorAttributesMap).forEach(([attr, colorAttr])=>{
        if (typeof attributes[colorAttr] === "undefined" || attributes[attr] === "") return;
        if (typeof attributes[attr] === "undefined") {
            if (!defaults[attr]) return;
            attributes[attr] = defaults[attr];
        }
        if (attributes[attr].indexOf("url(") === 0) return;
        const color = new $9a54cbcfc1af41ba$export$892596cec99bc70e(attributes[attr]);
        attributes[attr] = color.setAlpha($9a54cbcfc1af41ba$var$toFixed(color.getAlpha() * attributes[colorAttr], 2)).toRgba();
    });
    return attributes;
}
//#endregion
//#region src/parser/parseAttributes.ts
/**
* Returns an object of attributes' name/value, given element and an array of attribute names;
* Parses parent "g" nodes recursively upwards.
* @param {SVGElement | HTMLElement} element Element to parse
* @param {Array} attributes Array of attributes to parse
* @return {Object} object containing parsed attributes' names/values
*/ function $9a54cbcfc1af41ba$var$parseAttributes(element, attributes, cssRules) {
    if (!element) return {};
    let parentAttributes = {}, fontSize, parentFontSize = 16;
    if (element.parentNode && $9a54cbcfc1af41ba$var$svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = $9a54cbcfc1af41ba$var$parseAttributes(element.parentElement, attributes, cssRules);
        if (parentAttributes.fontSize) fontSize = parentFontSize = $9a54cbcfc1af41ba$var$parseUnit(parentAttributes.fontSize);
    }
    const ownAttributes = {
        ...attributes.reduce((memo, attr)=>{
            const value = element.getAttribute(attr);
            if (value) memo[attr] = value;
            return memo;
        }, {}),
        ...$9a54cbcfc1af41ba$var$getGlobalStylesForElement(element, cssRules),
        ...$9a54cbcfc1af41ba$var$parseStyleAttribute(element)
    };
    if (ownAttributes["clip-path"]) element.setAttribute($9a54cbcfc1af41ba$var$cPath, ownAttributes[$9a54cbcfc1af41ba$var$cPath]);
    if (ownAttributes["font-size"]) {
        fontSize = $9a54cbcfc1af41ba$var$parseUnit(ownAttributes[$9a54cbcfc1af41ba$var$fSize], parentFontSize);
        ownAttributes[$9a54cbcfc1af41ba$var$fSize] = `${fontSize}`;
    }
    const normalizedStyle = {};
    for(const attr in ownAttributes){
        const normalizedAttr = $9a54cbcfc1af41ba$var$normalizeAttr(attr);
        normalizedStyle[normalizedAttr] = $9a54cbcfc1af41ba$var$normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
    }
    if (normalizedStyle && normalizedStyle.font) $9a54cbcfc1af41ba$var$parseFontDeclaration(normalizedStyle.font, normalizedStyle);
    const mergedAttrs = {
        ...parentAttributes,
        ...normalizedStyle
    };
    return $9a54cbcfc1af41ba$var$svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : $9a54cbcfc1af41ba$var$setStrokeFillOpacity(mergedAttrs);
}
//#endregion
//#region src/shapes/Rect.ts
const $9a54cbcfc1af41ba$var$rectDefaultValues = {
    rx: 0,
    ry: 0
};
const $9a54cbcfc1af41ba$var$RECT_PROPS = [
    "rx",
    "ry"
];
var $9a54cbcfc1af41ba$export$c79fc6492f3af13d = class Rect extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Rect.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        Object.assign(this, Rect.ownDefaults);
        this.setOptions(options);
        this._initRxRy();
    }
    /**
	* Initializes rx/ry attributes
	* @private
	*/ _initRxRy() {
        const { rx: rx, ry: ry } = this;
        if (rx && !ry) this.ry = rx;
        else if (ry && !rx) this.rx = ry;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        const { width: w, height: h } = this;
        const x = -w / 2;
        const y = -h / 2;
        const rx = this.rx ? Math.min(this.rx, w / 2) : 0;
        const ry = this.ry ? Math.min(this.ry, h / 2) : 0;
        const isRounded = rx !== 0 || ry !== 0;
        ctx.beginPath();
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x + w - rx, y);
        isRounded && ctx.bezierCurveTo(x + w - .4477152502 * rx, y, x + w, y + .4477152502 * ry, x + w, y + ry);
        ctx.lineTo(x + w, y + h - ry);
        isRounded && ctx.bezierCurveTo(x + w, y + h - .4477152502 * ry, x + w - .4477152502 * rx, y + h, x + w - rx, y + h);
        ctx.lineTo(x + rx, y + h);
        isRounded && ctx.bezierCurveTo(x + .4477152502 * rx, y + h, x, y + h - .4477152502 * ry, x, y + h - ry);
        ctx.lineTo(x, y + ry);
        isRounded && ctx.bezierCurveTo(x, y + .4477152502 * ry, x + .4477152502 * rx, y, x + rx, y);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return super.toObject([
            ...$9a54cbcfc1af41ba$var$RECT_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const { width: width, height: height, rx: rx, ry: ry } = this;
        return [
            "<rect ",
            "COMMON_PARTS",
            `x="${-width / 2}" y="${-height / 2}" rx="${$9a54cbcfc1af41ba$var$escapeXml(rx)}" ry="${$9a54cbcfc1af41ba$var$escapeXml(ry)}" width="${$9a54cbcfc1af41ba$var$escapeXml(width)}" height="${$9a54cbcfc1af41ba$var$escapeXml(height)}" />\n`
        ];
    }
    /**
	* Returns {@link Rect} instance from an SVG element
	* @param {HTMLElement} element Element to parse
	* @param {Object} [options] Options object
	*/ static async fromElement(element, options, cssRules) {
        const { left: left = 0, top: top = 0, width: width = 0, height: height = 0, visible: visible = true, ...restOfparsedAttributes } = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return new this({
            ...options,
            ...restOfparsedAttributes,
            left: left,
            top: top,
            width: width,
            height: height,
            visible: Boolean(visible && width && height)
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c79fc6492f3af13d, "type", "Rect");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c79fc6492f3af13d, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$RECT_PROPS
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c79fc6492f3af13d, "ownDefaults", $9a54cbcfc1af41ba$var$rectDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c79fc6492f3af13d, "ATTRIBUTE_NAMES", [
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES,
    "x",
    "y",
    "rx",
    "ry",
    "width",
    "height"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c79fc6492f3af13d);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$c79fc6492f3af13d);
//#endregion
//#region src/LayoutManager/constants.ts
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_INITIALIZATION = "initialization";
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_ADDED = "added";
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_REMOVED = "removed";
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_IMPERATIVE = "imperative";
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_OBJECT_MODIFIED = "object_modified";
const $9a54cbcfc1af41ba$var$LAYOUT_TYPE_OBJECT_MODIFYING = "object_modifying";
//#endregion
//#region src/LayoutManager/LayoutStrategies/utils.ts
/**
* @returns 2 points, the tl and br corners of the non rotated bounding box of an object
* in the {@link group} plane, taking into account objects that {@link group} is their parent
* but also belong to the active selection.
*/ const $9a54cbcfc1af41ba$var$getObjectBounds = (destinationGroup, object)=>{
    const { strokeUniform: strokeUniform, strokeWidth: strokeWidth, width: width, height: height, group: currentGroup } = object;
    const t = currentGroup && currentGroup !== destinationGroup ? $9a54cbcfc1af41ba$var$calcPlaneChangeMatrix(currentGroup.calcTransformMatrix(), destinationGroup.calcTransformMatrix()) : null;
    const objectCenter = t ? object.getRelativeCenterPoint().transform(t) : object.getRelativeCenterPoint();
    const accountForStroke = !object["isStrokeAccountedForInDimensions"]();
    const strokeUniformVector = strokeUniform && accountForStroke ? $9a54cbcfc1af41ba$var$sendVectorToPlane(new $9a54cbcfc1af41ba$export$baf26146a414f24a(strokeWidth, strokeWidth), void 0, destinationGroup.calcTransformMatrix()) : $9a54cbcfc1af41ba$var$ZERO;
    const scalingStrokeWidth = !strokeUniform && accountForStroke ? strokeWidth : 0;
    const sizeVector = $9a54cbcfc1af41ba$var$sizeAfterTransform(width + scalingStrokeWidth, height + scalingStrokeWidth, $9a54cbcfc1af41ba$var$multiplyTransformMatrixArray([
        t,
        object.calcOwnMatrix()
    ], true)).add(strokeUniformVector).scalarDivide(2);
    return [
        objectCenter.subtract(sizeVector),
        objectCenter.add(sizeVector)
    ];
};
//#endregion
//#region src/LayoutManager/LayoutStrategies/LayoutStrategy.ts
/**
* Exposes a main public method {@link calcLayoutResult} that is used by the `LayoutManager` to perform layout.
* Returning `undefined` signals the `LayoutManager` to skip the layout.
*
* In charge of calculating the bounding box of the passed objects.
*/ var $9a54cbcfc1af41ba$export$f7b260234c293505 = class {
    /**
	* Used by the `LayoutManager` to perform layout
	* @TODO/fix: if this method is calcResult, should calc unconditionally.
	* the condition to not calc should be evaluated by the layoutManager.
	* @returns layout result **OR** `undefined` to skip layout
	*/ calcLayoutResult(context, objects) {
        if (this.shouldPerformLayout(context)) return this.calcBoundingBox(objects, context);
    }
    shouldPerformLayout({ type: type, prevStrategy: prevStrategy, strategy: strategy }) {
        return type === "initialization" || type === "imperative" || !!prevStrategy && strategy !== prevStrategy;
    }
    shouldLayoutClipPath({ type: type, target: { clipPath: clipPath } }) {
        return type !== "initialization" && clipPath && !clipPath.absolutePositioned;
    }
    getInitialSize(context, result) {
        return result.size;
    }
    /**
	* Override this method to customize layout.
	*/ calcBoundingBox(objects, context) {
        const { type: type, target: target } = context;
        if (type === "imperative" && context.overrides) return context.overrides;
        if (objects.length === 0) return;
        const { left: left, top: top, width: width, height: height } = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(objects.map((object)=>$9a54cbcfc1af41ba$var$getObjectBounds(target, object)).reduce((coords, curr)=>coords.concat(curr), []));
        const bboxSize = new $9a54cbcfc1af41ba$export$baf26146a414f24a(width, height);
        const bboxCenter = new $9a54cbcfc1af41ba$export$baf26146a414f24a(left, top).add(bboxSize.scalarDivide(2));
        if (type === "initialization") {
            const actualSize = this.getInitialSize(context, {
                size: bboxSize,
                center: bboxCenter
            });
            return {
                center: bboxCenter,
                relativeCorrection: new $9a54cbcfc1af41ba$export$baf26146a414f24a(0, 0),
                size: actualSize
            };
        } else return {
            center: bboxCenter.transform(target.calcOwnMatrix()),
            size: bboxSize
        };
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$f7b260234c293505, "type", "strategy");
//#endregion
//#region src/LayoutManager/LayoutStrategies/FitContentLayout.ts
/**
* Layout will adjust the bounding box to fit target's objects.
*/ var $9a54cbcfc1af41ba$export$36cf2cf6e71f4d55 = class extends $9a54cbcfc1af41ba$export$f7b260234c293505 {
    /**
	* @override layout on all triggers
	* Override at will
	*/ shouldPerformLayout(context) {
        return true;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$36cf2cf6e71f4d55, "type", "fit-content");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$36cf2cf6e71f4d55);
//#endregion
//#region src/LayoutManager/LayoutManager.ts
const $9a54cbcfc1af41ba$var$LAYOUT_MANAGER = "layoutManager";
var $9a54cbcfc1af41ba$export$4a04ad01c410b415 = class {
    constructor(strategy = new $9a54cbcfc1af41ba$export$36cf2cf6e71f4d55()){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "strategy", void 0);
        this.strategy = strategy;
        this._subscriptions = /* @__PURE__ */ new Map();
    }
    performLayout(context) {
        const strictContext = {
            bubbles: true,
            strategy: this.strategy,
            ...context,
            prevStrategy: this._prevLayoutStrategy,
            stopPropagation () {
                this.bubbles = false;
            }
        };
        this.onBeforeLayout(strictContext);
        const layoutResult = this.getLayoutResult(strictContext);
        if (layoutResult) this.commitLayout(strictContext, layoutResult);
        this.onAfterLayout(strictContext, layoutResult);
        this._prevLayoutStrategy = strictContext.strategy;
    }
    /**
	* Attach handlers for events that we know will invalidate the layout when
	* performed on child objects ( general transforms ).
	* Returns the disposers for later unsubscribing and cleanup
	* @param {FabricObject} object
	* @param {RegistrationContext & Partial<StrictLayoutContext>} context
	* @returns {VoidFunction[]} disposers remove the handlers
	*/ attachHandlers(object, context) {
        const { target: target } = context;
        return [
            $9a54cbcfc1af41ba$var$MODIFIED,
            $9a54cbcfc1af41ba$var$MOVING,
            $9a54cbcfc1af41ba$var$RESIZING,
            $9a54cbcfc1af41ba$var$ROTATING,
            $9a54cbcfc1af41ba$var$SCALING,
            $9a54cbcfc1af41ba$var$SKEWING,
            $9a54cbcfc1af41ba$var$CHANGED,
            $9a54cbcfc1af41ba$var$MODIFY_POLY,
            $9a54cbcfc1af41ba$var$MODIFY_PATH
        ].map((key)=>object.on(key, (e)=>this.performLayout(key === "modified" ? {
                    type: $9a54cbcfc1af41ba$var$LAYOUT_TYPE_OBJECT_MODIFIED,
                    trigger: key,
                    e: e,
                    target: target
                } : {
                    type: $9a54cbcfc1af41ba$var$LAYOUT_TYPE_OBJECT_MODIFYING,
                    trigger: key,
                    e: e,
                    target: target
                })));
    }
    /**
	* Subscribe an object to transform events that will trigger a layout change on the parent
	* This is important only for interactive groups.
	* @param object
	* @param context
	*/ subscribe(object, context) {
        this.unsubscribe(object, context);
        const disposers = this.attachHandlers(object, context);
        this._subscriptions.set(object, disposers);
    }
    /**
	* unsubscribe object layout triggers
	*/ unsubscribe(object, _context) {
        (this._subscriptions.get(object) || []).forEach((d)=>d());
        this._subscriptions.delete(object);
    }
    unsubscribeTargets(context) {
        context.targets.forEach((object)=>this.unsubscribe(object, context));
    }
    subscribeTargets(context) {
        context.targets.forEach((object)=>this.subscribe(object, context));
    }
    onBeforeLayout(context) {
        const { target: target, type: type } = context;
        const { canvas: canvas } = target;
        if (type === "initialization" || type === "added") this.subscribeTargets(context);
        else if (type === "removed") this.unsubscribeTargets(context);
        target.fire("layout:before", {
            context: context
        });
        canvas && canvas.fire("object:layout:before", {
            target: target,
            context: context
        });
        if (type === "imperative" && context.deep) {
            const { strategy: _, ...tricklingContext } = context;
            target.forEachObject((object)=>object.layoutManager && object.layoutManager.performLayout({
                    ...tricklingContext,
                    bubbles: false,
                    target: object
                }));
        }
    }
    getLayoutResult(context) {
        const { target: target, strategy: strategy, type: type } = context;
        const result = strategy.calcLayoutResult(context, target.getObjects());
        if (!result) return;
        const prevCenter = type === "initialization" ? new $9a54cbcfc1af41ba$export$baf26146a414f24a() : target.getRelativeCenterPoint();
        const { center: nextCenter, correction: correction = new $9a54cbcfc1af41ba$export$baf26146a414f24a(), relativeCorrection: relativeCorrection = new $9a54cbcfc1af41ba$export$baf26146a414f24a() } = result;
        return {
            result: result,
            prevCenter: prevCenter,
            nextCenter: nextCenter,
            offset: prevCenter.subtract(nextCenter).add(correction).transform(type === "initialization" ? $9a54cbcfc1af41ba$export$3c5a7f9475b116e0 : $9a54cbcfc1af41ba$var$invertTransform(target.calcOwnMatrix()), true).add(relativeCorrection)
        };
    }
    commitLayout(context, layoutResult) {
        const { target: target } = context;
        const { result: { size: size }, nextCenter: nextCenter } = layoutResult;
        target.set({
            width: size.x,
            height: size.y
        });
        this.layoutObjects(context, layoutResult);
        if (context.type === "initialization") {
            var _context$x, _context$y;
            target.set({
                left: (_context$x = context.x) !== null && _context$x !== void 0 ? _context$x : nextCenter.x + size.x * $9a54cbcfc1af41ba$var$resolveOrigin(target.originX),
                top: (_context$y = context.y) !== null && _context$y !== void 0 ? _context$y : nextCenter.y + size.y * $9a54cbcfc1af41ba$var$resolveOrigin(target.originY)
            });
        } else {
            target.setPositionByOrigin(nextCenter, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
            target.setCoords();
            target.set("dirty", true);
        }
    }
    layoutObjects(context, layoutResult) {
        const { target: target } = context;
        target.forEachObject((object)=>{
            object.group === target && this.layoutObject(context, layoutResult, object);
        });
        context.strategy.shouldLayoutClipPath(context) && this.layoutObject(context, layoutResult, target.clipPath);
    }
    /**
	* @param {FabricObject} object
	* @param {Point} offset
	*/ layoutObject(context, { offset: offset }, object) {
        object.set({
            left: object.left + offset.x,
            top: object.top + offset.y
        });
    }
    onAfterLayout(context, layoutResult) {
        const { target: target, strategy: strategy, bubbles: bubbles, prevStrategy: _, ...bubblingContext } = context;
        const { canvas: canvas } = target;
        target.fire("layout:after", {
            context: context,
            result: layoutResult
        });
        canvas && canvas.fire("object:layout:after", {
            context: context,
            result: layoutResult,
            target: target
        });
        const parent = target.parent;
        if (bubbles && (parent === null || parent === void 0 ? void 0 : parent.layoutManager)) {
            (bubblingContext.path || (bubblingContext.path = [])).push(target);
            parent.layoutManager.performLayout({
                ...bubblingContext,
                target: parent
            });
        }
        target.set("dirty", true);
    }
    dispose() {
        const { _subscriptions: _subscriptions } = this;
        _subscriptions.forEach((disposers)=>disposers.forEach((d)=>d()));
        _subscriptions.clear();
    }
    toObject() {
        return {
            type: $9a54cbcfc1af41ba$var$LAYOUT_MANAGER,
            strategy: this.strategy.constructor.type
        };
    }
    toJSON() {
        return this.toObject();
    }
};
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$4a04ad01c410b415, $9a54cbcfc1af41ba$var$LAYOUT_MANAGER);
//#endregion
//#region src/shapes/Group.ts
/**
* This class handles the specific case of creating a group using {@link Group#fromObject} and is not meant to be used in any other case.
* We could have used a boolean in the constructor, as we did previously, but we think the boolean
* would stay in the group's constructor interface and create confusion, therefore it was removed.
* This layout manager doesn't do anything and therefore keeps the exact layout the group had when {@link Group#toObject} was called.
*/ var $9a54cbcfc1af41ba$var$NoopLayoutManager = class extends $9a54cbcfc1af41ba$export$4a04ad01c410b415 {
    performLayout() {}
};
const $9a54cbcfc1af41ba$var$groupDefaultValues = {
    strokeWidth: 0,
    subTargetCheck: false,
    interactive: false
};
/**
* @fires object:added
* @fires object:removed
* @fires layout:before
* @fires layout:after
*/ var $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4 = class Group extends $9a54cbcfc1af41ba$export$f589b6d5b7ad4722($9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Group.ownDefaults
        };
    }
    /**
	* Constructor
	*
	* @param {FabricObject[]} [objects] instance objects
	* @param {Object} [options] Options object
	*/ constructor(objects = [], options = {}){
        super();
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_activeObjects", []);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__objectSelectionTracker", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__objectSelectionDisposer", void 0);
        Object.assign(this, Group.ownDefaults);
        this.setOptions(options);
        this.groupInit(objects, options);
    }
    /**
	* Shared code between group and active selection
	* Meant to be used by the constructor.
	*/ groupInit(objects, options) {
        var _options$layoutManage;
        this._objects = [
            ...objects
        ];
        this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true);
        this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false);
        this.forEachObject((object)=>{
            this.enterGroup(object, false);
        });
        this.layoutManager = (_options$layoutManage = options.layoutManager) !== null && _options$layoutManage !== void 0 ? _options$layoutManage : new $9a54cbcfc1af41ba$export$4a04ad01c410b415();
        this.layoutManager.performLayout({
            type: $9a54cbcfc1af41ba$var$LAYOUT_TYPE_INITIALIZATION,
            target: this,
            targets: [
                ...objects
            ],
            x: options.left,
            y: options.top
        });
    }
    /**
	* Checks if object can enter group and logs relevant warnings
	* @private
	* @param {FabricObject} object
	* @returns
	*/ canEnterGroup(object) {
        if (object === this || this.isDescendantOf(object)) {
            $9a54cbcfc1af41ba$var$log("error", "Group: circular object trees are not supported, this call has no effect");
            return false;
        } else if (this._objects.indexOf(object) !== -1) {
            $9a54cbcfc1af41ba$var$log("error", "Group: duplicate objects are not supported inside group, this call has no effect");
            return false;
        }
        return true;
    }
    /**
	* Override this method to enhance performance (for groups with a lot of objects).
	* If Overriding, be sure not pass illegal objects to group - it will break your app.
	* @private
	*/ _filterObjectsBeforeEnteringGroup(objects) {
        return objects.filter((object, index, array)=>{
            return this.canEnterGroup(object) && array.indexOf(object) === index;
        });
    }
    /**
	* Add objects
	* @param {...FabricObject[]} objects
	*/ add(...objects) {
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.add(...allowedObjects);
        this._onAfterObjectsChange($9a54cbcfc1af41ba$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
	* Inserts an object into collection at specified index
	* @param {FabricObject[]} objects Object to insert
	* @param {Number} index Index to insert object at
	*/ insertAt(index, ...objects) {
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.insertAt(index, ...allowedObjects);
        this._onAfterObjectsChange($9a54cbcfc1af41ba$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
	* Remove objects
	* @param {...FabricObject[]} objects
	* @returns {FabricObject[]} removed objects
	*/ remove(...objects) {
        const removed = super.remove(...objects);
        this._onAfterObjectsChange($9a54cbcfc1af41ba$var$LAYOUT_TYPE_REMOVED, removed);
        return removed;
    }
    _onObjectAdded(object) {
        this.enterGroup(object, true);
        this.fire("object:added", {
            target: object
        });
        object.fire("added", {
            target: this
        });
    }
    /**
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
	*/ _onObjectRemoved(object, removeParentTransform) {
        this.exitGroup(object, removeParentTransform);
        this.fire("object:removed", {
            target: object
        });
        object.fire("removed", {
            target: this
        });
    }
    /**
	* @private
	* @param {'added'|'removed'} type
	* @param {FabricObject[]} targets
	*/ _onAfterObjectsChange(type, targets) {
        this.layoutManager.performLayout({
            type: type,
            targets: targets,
            target: this
        });
    }
    _onStackOrderChanged() {
        this._set("dirty", true);
    }
    /**
	* @private
	* @param {string} key
	* @param {*} value
	*/ _set(key, value) {
        const prev = this[key];
        super._set(key, value);
        if (key === "canvas" && prev !== value) (this._objects || []).forEach((object)=>{
            object._set(key, value);
        });
        return this;
    }
    /**
	* @private
	*/ _shouldSetNestedCoords() {
        return this.subTargetCheck;
    }
    /**
	* Remove all objects
	* @returns {FabricObject[]} removed objects
	*/ removeAll() {
        this._activeObjects = [];
        return this.remove(...this._objects);
    }
    /**
	* keeps track of the selected objects
	* @private
	*/ __objectSelectionMonitor(selected, { target: object }) {
        const activeObjects = this._activeObjects;
        if (selected) {
            activeObjects.push(object);
            this._set("dirty", true);
        } else if (activeObjects.length > 0) {
            const index = activeObjects.indexOf(object);
            if (index > -1) {
                activeObjects.splice(index, 1);
                this._set("dirty", true);
            }
        }
    }
    /**
	* @private
	* @param {boolean} watch
	* @param {FabricObject} object
	*/ _watchObject(watch, object) {
        watch && this._watchObject(false, object);
        if (watch) {
            object.on("selected", this.__objectSelectionTracker);
            object.on("deselected", this.__objectSelectionDisposer);
        } else {
            object.off("selected", this.__objectSelectionTracker);
            object.off("deselected", this.__objectSelectionDisposer);
        }
    }
    /**
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
	*/ enterGroup(object, removeParentTransform) {
        object.group && object.group.remove(object);
        object._set("parent", this);
        this._enterGroup(object, removeParentTransform);
    }
    /**
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
	*/ _enterGroup(object, removeParentTransform) {
        if (removeParentTransform) $9a54cbcfc1af41ba$var$applyTransformToObject(object, $9a54cbcfc1af41ba$var$multiplyTransformMatrices($9a54cbcfc1af41ba$var$invertTransform(this.calcTransformMatrix()), object.calcTransformMatrix()));
        this._shouldSetNestedCoords() && object.setCoords();
        object._set("group", this);
        object._set("canvas", this.canvas);
        this._watchObject(true, object);
        const activeObject = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
        if (activeObject && (activeObject === object || object.isDescendantOf(activeObject))) this._activeObjects.push(object);
    }
    /**
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
	*/ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        object._set("parent", void 0);
        object._set("canvas", void 0);
    }
    /**
	* Executes the inner fabric logic of exiting a group.
	* - Stop watching the object
	* - Remove the object from the optimization map this._activeObjects
	* - unset the group property of the object
	* @protected
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
	*/ _exitGroup(object, removeParentTransform) {
        object._set("group", void 0);
        if (!removeParentTransform) {
            $9a54cbcfc1af41ba$var$applyTransformToObject(object, $9a54cbcfc1af41ba$var$multiplyTransformMatrices(this.calcTransformMatrix(), object.calcTransformMatrix()));
            object.setCoords();
        }
        this._watchObject(false, object);
        const index = this._activeObjects.length > 0 ? this._activeObjects.indexOf(object) : -1;
        if (index > -1) this._activeObjects.splice(index, 1);
    }
    /**
	* Decide if the group should cache or not. Create its own cache level
	* needsItsOwnCache should be used when the object drawing method requires
	* a cache step.
	* Generally you do not cache objects in groups because the group is already cached.
	* @return {Boolean}
	*/ shouldCache() {
        const ownCache = $9a54cbcfc1af41ba$export$5a5fba7eea6847b1.prototype.shouldCache.call(this);
        if (ownCache) {
            for(let i = 0; i < this._objects.length; i++)if (this._objects[i].willDrawShadow()) {
                this.ownCaching = false;
                return false;
            }
        }
        return ownCache;
    }
    /**
	* Check if this object or a child object will cast a shadow
	* @return {Boolean}
	*/ willDrawShadow() {
        if (super.willDrawShadow()) return true;
        for(let i = 0; i < this._objects.length; i++)if (this._objects[i].willDrawShadow()) return true;
        return false;
    }
    /**
	* Check if instance or its group are caching, recursively up
	* @return {Boolean}
	*/ isOnACache() {
        return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }
    /**
	* Execute the drawing operation for an object on a specified context
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ drawObject(ctx, forClipping, context) {
        this._renderBackground(ctx);
        for(let i = 0; i < this._objects.length; i++){
            var _this$canvas;
            const obj = this._objects[i];
            if (((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.preserveObjectStacking) && obj.group !== this) {
                ctx.save();
                ctx.transform(...$9a54cbcfc1af41ba$var$invertTransform(this.calcTransformMatrix()));
                obj.render(ctx);
                ctx.restore();
            } else if (obj.group === this) obj.render(ctx);
        }
        this._drawClipPath(ctx, this.clipPath, context);
    }
    /**
	* @override
	* @return {Boolean}
	*/ setCoords() {
        super.setCoords();
        this._shouldSetNestedCoords() && this.forEachObject((object)=>object.setCoords());
    }
    triggerLayout(options = {}) {
        this.layoutManager.performLayout({
            target: this,
            type: $9a54cbcfc1af41ba$var$LAYOUT_TYPE_IMPERATIVE,
            ...options
        });
    }
    /**
	* Renders instance on a given context
	* @param {CanvasRenderingContext2D} ctx context to render instance on
	*/ render(ctx) {
        this._transformDone = true;
        super.render(ctx);
        this._transformDone = false;
    }
    /**
	*
	* @private
	* @param {'toObject'|'toDatalessObject'} [method]
	* @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @returns {FabricObject[]} serialized objects
	*/ __serializeObjects(method, propertiesToInclude) {
        const _includeDefaultValues = this.includeDefaultValues;
        return this._objects.filter(function(obj) {
            return !obj.excludeFromExport;
        }).map(function(obj) {
            const originalDefaults = obj.includeDefaultValues;
            obj.includeDefaultValues = _includeDefaultValues;
            const data = obj[method || "toObject"](propertiesToInclude);
            obj.includeDefaultValues = originalDefaults;
            return data;
        });
    }
    /**
	* Returns object representation of an instance
	* @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        const layoutManager = this.layoutManager.toObject();
        return {
            ...super.toObject([
                "subTargetCheck",
                "interactive",
                ...propertiesToInclude
            ]),
            ...layoutManager.strategy !== "fit-content" || this.includeDefaultValues ? {
                layoutManager: layoutManager
            } : {},
            objects: this.__serializeObjects("toObject", propertiesToInclude)
        };
    }
    toString() {
        return `#<Group: (${this.complexity()})>`;
    }
    dispose() {
        this.layoutManager.unsubscribeTargets({
            targets: this.getObjects(),
            target: this
        });
        this._activeObjects = [];
        this.forEachObject((object)=>{
            this._watchObject(false, object);
            object.dispose();
        });
        super.dispose();
    }
    /**
	* @private
	*/ _createSVGBgRect(reviver) {
        if (!this.backgroundColor) return "";
        const fillStroke = $9a54cbcfc1af41ba$export$c79fc6492f3af13d.prototype._toSVG.call(this);
        const commons = fillStroke.indexOf("COMMON_PARTS");
        fillStroke[commons] = "for=\"group\" ";
        const markup = fillStroke.join("");
        return reviver ? reviver(markup) : markup;
    }
    /**
	* Returns svg representation of an instance
	* @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
	* @return {String} svg representation of an instance
	*/ _toSVG(reviver) {
        const svgString = [
            "<g ",
            "COMMON_PARTS",
            " >\n"
        ];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push("		", bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push("		", this._objects[i].toSVG(reviver));
        svgString.push("</g>\n");
        return svgString;
    }
    /**
	* Returns styles-string for svg-export, specific version for group
	* @return {String}
	*/ getSvgStyles() {
        const opacity = typeof this.opacity !== "undefined" && this.opacity !== 1 ? `opacity: ${$9a54cbcfc1af41ba$var$escapeXml(this.opacity)};` : "", visibility = this.visible ? "" : " visibility: hidden;";
        return [
            opacity,
            this.getSvgFilter(),
            visibility
        ].join("");
    }
    /**
	* Returns svg clipPath representation of an instance
	* @param {Function} [reviver] Method for further parsing of svg representation.
	* @return {String} svg representation of an instance
	*/ toClipPathSVG(reviver) {
        const svgString = [];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push("	", bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push("	", this._objects[i].toClipPathSVG(reviver));
        return this._createBaseClipPathSVGMarkup(svgString, {
            reviver: reviver
        });
    }
    /**
	* @todo support loading from svg
	* @private
	* @param {Object} object Object to create a group from
	* @returns {Promise<Group>}
	*/ static fromObject({ type: type, objects: objects = [], layoutManager: layoutManager, ...options }, abortable) {
        return Promise.all([
            $9a54cbcfc1af41ba$var$enlivenObjects(objects, abortable),
            $9a54cbcfc1af41ba$var$enlivenObjectEnlivables(options, abortable)
        ]).then(([objects, hydratedOptions])=>{
            const group = new this(objects, {
                ...options,
                ...hydratedOptions,
                layoutManager: new $9a54cbcfc1af41ba$var$NoopLayoutManager()
            });
            if (layoutManager) group.layoutManager = new ($9a54cbcfc1af41ba$export$2792378e23a7920c.getClass(layoutManager.type))(new ($9a54cbcfc1af41ba$export$2792378e23a7920c.getClass(layoutManager.strategy))());
            else group.layoutManager = new $9a54cbcfc1af41ba$export$4a04ad01c410b415();
            group.layoutManager.subscribeTargets({
                type: $9a54cbcfc1af41ba$var$LAYOUT_TYPE_INITIALIZATION,
                target: group,
                targets: group.getObjects()
            });
            group.setCoords();
            return group;
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4, "type", "Group");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4, "ownDefaults", $9a54cbcfc1af41ba$var$groupDefaultValues);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4);
//#endregion
//#region src/util/misc/groupSVGElements.ts
/**
* TODO experiment with different layout manager and svg results ( fixed fit content )
* Groups SVG elements (usually those retrieved from SVG document)
* @param {FabricObject[]} elements FabricObject(s) parsed from svg, to group
* @return {FabricObject | Group}
*/ const $9a54cbcfc1af41ba$var$groupSVGElements = (elements, options)=>{
    if (elements && elements.length === 1) return elements[0];
    return new $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4(elements, options);
};
//#endregion
//#region src/util/misc/findScaleTo.ts
/**
* Finds the scale for the object source to fit inside the object destination,
* keeping aspect ratio intact.
* respect the total allowed area for the cache.
* @param {TSize} source natural unscaled size of the object
* @param {TSize} destination natural unscaled size of the object
* @return {Number} scale factor to apply to source to fit into destination
*/ const $9a54cbcfc1af41ba$var$findScaleToFit = (source, destination)=>Math.min(destination.width / source.width, destination.height / source.height);
/**
* Finds the scale for the object source to cover entirely the object destination,
* keeping aspect ratio intact.
* respect the total allowed area for the cache.
* @param {TSize} source natural unscaled size of the object
* @param {TSize} destination natural unscaled size of the object
* @return {Number} scale factor to apply to source to cover destination
*/ const $9a54cbcfc1af41ba$var$findScaleToCover = (source, destination)=>Math.max(destination.width / source.width, destination.height / source.height);
//#endregion
//#region src/util/path/regex.ts
const $9a54cbcfc1af41ba$var$commaWsp = `\\s*,?\\s*`;
/**
* p for param
* using "bad naming" here because it makes the regex much easier to read
* p is a number that is preceded by an arbitary number of spaces, maybe 0,
* a comma or not, and then possibly more spaces or not.
*/ const $9a54cbcfc1af41ba$var$p = `${$9a54cbcfc1af41ba$var$commaWsp}(${$9a54cbcfc1af41ba$var$reNum})`;
const $9a54cbcfc1af41ba$var$reArcCommandPoints = `${$9a54cbcfc1af41ba$var$p}${$9a54cbcfc1af41ba$var$p}${$9a54cbcfc1af41ba$var$p}${$9a54cbcfc1af41ba$var$commaWsp}([01])${$9a54cbcfc1af41ba$var$commaWsp}([01])${$9a54cbcfc1af41ba$var$p}${$9a54cbcfc1af41ba$var$p}`;
const $9a54cbcfc1af41ba$var$rePathCommand = "[mzlhvcsqta][^mzlhvcsqta]*";
//#endregion
//#region src/util/path/index.ts
/**
* Commands that may be repeated
*/ const $9a54cbcfc1af41ba$var$repeatedCommands = {
    m: "l",
    M: "L"
};
/**
* Convert an arc of a rotated ellipse to a Bezier Curve
* @param {TRadian} theta1 start of the arc
* @param {TRadian} theta2 end of the arc
* @param cosTh cosine of the angle of rotation
* @param sinTh sine of the angle of rotation
* @param rx x-axis radius (before rotation)
* @param ry y-axis radius (before rotation)
* @param cx1 center x of the ellipse
* @param cy1 center y of the ellipse
* @param mT
* @param fromX starting point of arc x
* @param fromY starting point of arc y
*/ const $9a54cbcfc1af41ba$var$segmentToBezier = (theta1, theta2, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY)=>{
    const costh1 = $9a54cbcfc1af41ba$var$cos(theta1), sinth1 = $9a54cbcfc1af41ba$var$sin(theta1), costh2 = $9a54cbcfc1af41ba$var$cos(theta2), sinth2 = $9a54cbcfc1af41ba$var$sin(theta2), toX = cosTh * rx * costh2 - sinTh * ry * sinth2 + cx1, toY = sinTh * rx * costh2 + cosTh * ry * sinth2 + cy1;
    return [
        "C",
        fromX + mT * (-cosTh * rx * sinth1 - sinTh * ry * costh1),
        fromY + mT * (-sinTh * rx * sinth1 + cosTh * ry * costh1),
        toX + mT * (cosTh * rx * sinth2 + sinTh * ry * costh2),
        toY + mT * (sinTh * rx * sinth2 - cosTh * ry * costh2),
        toX,
        toY
    ];
};
/**
* Adapted from {@link http://dxr.mozilla.org/mozilla-central/source/dom/svg/SVGPathDataParser.cpp}
* by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
* http://mozilla.org/MPL/2.0/
* @param toX
* @param toY
* @param rx
* @param ry
* @param {number} large 0 or 1 flag
* @param {number} sweep 0 or 1 flag
* @param rotateX
*/ const $9a54cbcfc1af41ba$var$arcToSegments = (toX, toY, rx, ry, large, sweep, rotateX)=>{
    if (rx === 0 || ry === 0) return [];
    let fromX = 0, fromY = 0, root = 0;
    const PI = Math.PI, theta = rotateX * $9a54cbcfc1af41ba$var$PiBy180, sinTheta = $9a54cbcfc1af41ba$var$sin(theta), cosTh = $9a54cbcfc1af41ba$var$cos(theta), px = .5 * (-cosTh * toX - sinTheta * toY), py = .5 * (-cosTh * toY + sinTheta * toX), rx2 = rx ** 2, ry2 = ry ** 2, py2 = py ** 2, px2 = px ** 2, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2;
    let _rx = Math.abs(rx);
    let _ry = Math.abs(ry);
    if (pl < 0) {
        const s = Math.sqrt(1 - pl / (rx2 * ry2));
        _rx *= s;
        _ry *= s;
    } else root = (large === sweep ? -1 : 1) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
    const cx = root * _rx * py / _ry, cy = -root * _ry * px / _rx, cx1 = cosTh * cx - sinTheta * cy + toX * .5, cy1 = sinTheta * cx + cosTh * cy + toY * .5;
    let mTheta = $9a54cbcfc1af41ba$var$calcVectorAngle(1, 0, (px - cx) / _rx, (py - cy) / _ry);
    let dtheta = $9a54cbcfc1af41ba$var$calcVectorAngle((px - cx) / _rx, (py - cy) / _ry, (-px - cx) / _rx, (-py - cy) / _ry);
    if (sweep === 0 && dtheta > 0) dtheta -= 2 * PI;
    else if (sweep === 1 && dtheta < 0) dtheta += 2 * PI;
    const segments = Math.ceil(Math.abs(dtheta / PI * 2)), result = [], mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2);
    let th3 = mTheta + mDelta;
    for(let i = 0; i < segments; i++){
        result[i] = $9a54cbcfc1af41ba$var$segmentToBezier(mTheta, th3, cosTh, sinTheta, _rx, _ry, cx1, cy1, mT, fromX, fromY);
        fromX = result[i][5];
        fromY = result[i][6];
        mTheta = th3;
        th3 += mDelta;
    }
    return result;
};
/**
* @private
* Calculate the angle between two vectors
* @param ux u endpoint x
* @param uy u endpoint y
* @param vx v endpoint x
* @param vy v endpoint y
*/ const $9a54cbcfc1af41ba$var$calcVectorAngle = (ux, uy, vx, vy)=>{
    const ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
    if (tb >= ta) return tb - ta;
    else return 2 * Math.PI - (ta - tb);
};
const $9a54cbcfc1af41ba$var$CB1 = (t)=>t ** 3;
const $9a54cbcfc1af41ba$var$CB2 = (t)=>3 * t ** 2 * (1 - t);
const $9a54cbcfc1af41ba$var$CB3 = (t)=>3 * t * (1 - t) ** 2;
const $9a54cbcfc1af41ba$var$CB4 = (t)=>(1 - t) ** 3;
/**
* Calculate bounding box of a cubic Bezier curve
* Taken from http://jsbin.com/ivomiq/56/edit (no credits available)
* TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
* @param {number} begx starting point
* @param {number} begy
* @param {number} cp1x first control point
* @param {number} cp1y
* @param {number} cp2x second control point
* @param {number} cp2y
* @param {number} endx end of bezier
* @param {number} endy
* @return {TRectBounds} the rectangular bounds
*/ function $9a54cbcfc1af41ba$var$getBoundsOfCurve(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy) {
    let argsString;
    if ($9a54cbcfc1af41ba$export$e506a1d27d1eaa20.cachesBoundsOfCurve) {
        argsString = [
            ...arguments
        ].join();
        if ($9a54cbcfc1af41ba$export$69a3209f1a06c04d.boundsOfCurveCache[argsString]) return $9a54cbcfc1af41ba$export$69a3209f1a06c04d.boundsOfCurveCache[argsString];
    }
    const sqrt = Math.sqrt, abs = Math.abs, tvalues = [], bounds = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    let b = 6 * begx - 12 * cp1x + 6 * cp2x;
    let a = -3 * begx + 9 * cp1x - 9 * cp2x + 3 * endx;
    let c = 3 * cp1x - 3 * begx;
    for(let i = 0; i < 2; ++i){
        if (i > 0) {
            b = 6 * begy - 12 * cp1y + 6 * cp2y;
            a = -3 * begy + 9 * cp1y - 9 * cp2y + 3 * endy;
            c = 3 * cp1y - 3 * begy;
        }
        if (abs(a) < 1e-12) {
            if (abs(b) < 1e-12) continue;
            const t = -c / b;
            if (0 < t && t < 1) tvalues.push(t);
            continue;
        }
        const b2ac = b * b - 4 * c * a;
        if (b2ac < 0) continue;
        const sqrtb2ac = sqrt(b2ac);
        const t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) tvalues.push(t1);
        const t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) tvalues.push(t2);
    }
    let j = tvalues.length;
    const jlen = j;
    const iterator = $9a54cbcfc1af41ba$var$getPointOnCubicBezierIterator(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy);
    while(j--){
        const { x: x, y: y } = iterator(tvalues[j]);
        bounds[0][j] = x;
        bounds[1][j] = y;
    }
    bounds[0][jlen] = begx;
    bounds[1][jlen] = begy;
    bounds[0][jlen + 1] = endx;
    bounds[1][jlen + 1] = endy;
    const result = [
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.min(...bounds[0]), Math.min(...bounds[1])),
        new $9a54cbcfc1af41ba$export$baf26146a414f24a(Math.max(...bounds[0]), Math.max(...bounds[1]))
    ];
    if ($9a54cbcfc1af41ba$export$e506a1d27d1eaa20.cachesBoundsOfCurve) $9a54cbcfc1af41ba$export$69a3209f1a06c04d.boundsOfCurveCache[argsString] = result;
    return result;
}
/**
* Converts arc to a bunch of cubic Bezier curves
* @param {number} fx starting point x
* @param {number} fy starting point y
* @param {TParsedArcCommand} coords Arc command
*/ const $9a54cbcfc1af41ba$var$fromArcToBeziers = (fx, fy, [_, rx, ry, rot, large, sweep, tx, ty])=>{
    const segsNorm = $9a54cbcfc1af41ba$var$arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
    for(let i = 0, len = segsNorm.length; i < len; i++){
        segsNorm[i][1] += fx;
        segsNorm[i][2] += fy;
        segsNorm[i][3] += fx;
        segsNorm[i][4] += fy;
        segsNorm[i][5] += fx;
        segsNorm[i][6] += fy;
    }
    return segsNorm;
};
/**
* This function takes a parsed SVG path and makes it simpler for fabricJS logic.
* Simplification consist of:
* - All commands converted to absolute (lowercase to uppercase)
* - S converted to C
* - T converted to Q
* - A converted to C
* @param {TComplexPathData} path the array of commands of a parsed SVG path for `Path`
* @return {TSimplePathData} the simplified array of commands of a parsed SVG path for `Path`
* TODO: figure out how to remove the type assertions in a nice way
*/ const $9a54cbcfc1af41ba$var$makePathSimpler = (path)=>{
    let x = 0, y = 0;
    let x1 = 0, y1 = 0;
    const destinationPath = [];
    let previous, controlX = 0, controlY = 0;
    for (const parsedCommand of path){
        const current = [
            ...parsedCommand
        ];
        let converted;
        switch(current[0]){
            case "l":
                current[1] += x;
                current[2] += y;
            case "L":
                x = current[1];
                y = current[2];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "h":
                current[1] += x;
            case "H":
                x = current[1];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "v":
                current[1] += y;
            case "V":
                y = current[1];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "m":
                current[1] += x;
                current[2] += y;
            case "M":
                x = current[1];
                y = current[2];
                x1 = current[1];
                y1 = current[2];
                converted = [
                    "M",
                    x,
                    y
                ];
                break;
            case "c":
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
                current[5] += x;
                current[6] += y;
            case "C":
                controlX = current[3];
                controlY = current[4];
                x = current[5];
                y = current[6];
                converted = [
                    "C",
                    current[1],
                    current[2],
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "s":
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            case "S":
                if (previous === "C") {
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    controlX = x;
                    controlY = y;
                }
                x = current[3];
                y = current[4];
                converted = [
                    "C",
                    controlX,
                    controlY,
                    current[1],
                    current[2],
                    x,
                    y
                ];
                controlX = converted[3];
                controlY = converted[4];
                break;
            case "q":
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            case "Q":
                controlX = current[1];
                controlY = current[2];
                x = current[3];
                y = current[4];
                converted = [
                    "Q",
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "t":
                current[1] += x;
                current[2] += y;
            case "T":
                if (previous === "Q") {
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    controlX = x;
                    controlY = y;
                }
                x = current[1];
                y = current[2];
                converted = [
                    "Q",
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "a":
                current[6] += x;
                current[7] += y;
            case "A":
                $9a54cbcfc1af41ba$var$fromArcToBeziers(x, y, current).forEach((b)=>destinationPath.push(b));
                x = current[6];
                y = current[7];
                break;
            case "z":
            case "Z":
                x = x1;
                y = y1;
                converted = [
                    "Z"
                ];
                break;
            default:
        }
        if (converted) {
            destinationPath.push(converted);
            previous = converted[0];
        } else previous = "";
    }
    return destinationPath;
};
/**
* Calc length from point x1,y1 to x2,y2
* @param {number} x1 starting point x
* @param {number} y1 starting point y
* @param {number} x2 starting point x
* @param {number} y2 starting point y
* @return {number} length of segment
*/ const $9a54cbcfc1af41ba$var$calcLineLength = (x1, y1, x2, y2)=>Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
/**
* Get an iterator that takes a percentage and returns a point
* @param {number} begx
* @param {number} begy
* @param {number} cp1x
* @param {number} cp1y
* @param {number} cp2x
* @param {number} cp2y
* @param {number} endx
* @param {number} endy
*/ const $9a54cbcfc1af41ba$var$getPointOnCubicBezierIterator = (begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy)=>(pct)=>{
        const c1 = $9a54cbcfc1af41ba$var$CB1(pct), c2 = $9a54cbcfc1af41ba$var$CB2(pct), c3 = $9a54cbcfc1af41ba$var$CB3(pct), c4 = $9a54cbcfc1af41ba$var$CB4(pct);
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(endx * c1 + cp2x * c2 + cp1x * c3 + begx * c4, endy * c1 + cp2y * c2 + cp1y * c3 + begy * c4);
    };
const $9a54cbcfc1af41ba$var$QB1 = (t)=>t ** 2;
const $9a54cbcfc1af41ba$var$QB2 = (t)=>2 * t * (1 - t);
const $9a54cbcfc1af41ba$var$QB3 = (t)=>(1 - t) ** 2;
const $9a54cbcfc1af41ba$var$getTangentCubicIterator = (p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y)=>(pct)=>{
        const qb1 = $9a54cbcfc1af41ba$var$QB1(pct), qb2 = $9a54cbcfc1af41ba$var$QB2(pct), qb3 = $9a54cbcfc1af41ba$var$QB3(pct), tangentX = 3 * (qb3 * (p2x - p1x) + qb2 * (p3x - p2x) + qb1 * (p4x - p3x)), tangentY = 3 * (qb3 * (p2y - p1y) + qb2 * (p3y - p2y) + qb1 * (p4y - p3y));
        return Math.atan2(tangentY, tangentX);
    };
const $9a54cbcfc1af41ba$var$getPointOnQuadraticBezierIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const c1 = $9a54cbcfc1af41ba$var$QB1(pct), c2 = $9a54cbcfc1af41ba$var$QB2(pct), c3 = $9a54cbcfc1af41ba$var$QB3(pct);
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(p3x * c1 + p2x * c2 + p1x * c3, p3y * c1 + p2y * c2 + p1y * c3);
    };
const $9a54cbcfc1af41ba$var$getTangentQuadraticIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const invT = 1 - pct, tangentX = 2 * (invT * (p2x - p1x) + pct * (p3x - p2x)), tangentY = 2 * (invT * (p2y - p1y) + pct * (p3y - p2y));
        return Math.atan2(tangentY, tangentX);
    };
const $9a54cbcfc1af41ba$var$pathIterator = (iterator, x1, y1)=>{
    let tempP = new $9a54cbcfc1af41ba$export$baf26146a414f24a(x1, y1), tmpLen = 0;
    for(let perc = 1; perc <= 100; perc += 1){
        const p = iterator(perc / 100);
        tmpLen += $9a54cbcfc1af41ba$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        tempP = p;
    }
    return tmpLen;
};
/**
* Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
* that correspond to that pixels run over the path.
* The percentage will be then used to find the correct point on the canvas for the path.
* @param {Array} segInfo fabricJS collection of information on a parsed path
* @param {number} distance from starting point, in pixels.
* @return {TPointAngle} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
*/ const $9a54cbcfc1af41ba$var$findPercentageForDistance = (segInfo, distance)=>{
    let perc = 0, tmpLen = 0, tempP = {
        x: segInfo.x,
        y: segInfo.y
    }, p = {
        ...tempP
    }, nextLen, nextStep = .01, lastPerc = 0;
    const iterator = segInfo.iterator, angleFinder = segInfo.angleFinder;
    while(tmpLen < distance && nextStep > 1e-4){
        p = iterator(perc);
        lastPerc = perc;
        nextLen = $9a54cbcfc1af41ba$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        if (nextLen + tmpLen > distance) {
            perc -= nextStep;
            nextStep /= 2;
        } else {
            tempP = p;
            perc += nextStep;
            tmpLen += nextLen;
        }
    }
    return {
        ...p,
        angle: angleFinder(lastPerc)
    };
};
/**
* Run over a parsed and simplified path and extract some information (length of each command and starting point)
* @param {TSimplePathData} path parsed path commands
* @return {TPathSegmentInfo[]} path commands information
*/ const $9a54cbcfc1af41ba$var$getPathSegmentsInfo = (path)=>{
    let totalLength = 0, x1 = 0, y1 = 0, x2 = 0, y2 = 0, iterator, tempInfo;
    const info = [];
    for (const current of path){
        const basicInfo = {
            x: x1,
            y: y1,
            command: current[0],
            length: 0
        };
        switch(current[0]){
            case "M":
                tempInfo = basicInfo;
                tempInfo.x = x2 = x1 = current[1];
                tempInfo.y = y2 = y1 = current[2];
                break;
            case "L":
                tempInfo = basicInfo;
                tempInfo.length = $9a54cbcfc1af41ba$var$calcLineLength(x1, y1, current[1], current[2]);
                x1 = current[1];
                y1 = current[2];
                break;
            case "C":
                iterator = $9a54cbcfc1af41ba$var$getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $9a54cbcfc1af41ba$var$getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo.length = $9a54cbcfc1af41ba$var$pathIterator(iterator, x1, y1);
                x1 = current[5];
                y1 = current[6];
                break;
            case "Q":
                iterator = $9a54cbcfc1af41ba$var$getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $9a54cbcfc1af41ba$var$getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo.length = $9a54cbcfc1af41ba$var$pathIterator(iterator, x1, y1);
                x1 = current[3];
                y1 = current[4];
                break;
            case "Z":
                tempInfo = basicInfo;
                tempInfo.destX = x2;
                tempInfo.destY = y2;
                tempInfo.length = $9a54cbcfc1af41ba$var$calcLineLength(x1, y1, x2, y2);
                x1 = x2;
                y1 = y2;
                break;
        }
        totalLength += tempInfo.length;
        info.push(tempInfo);
    }
    info.push({
        length: totalLength,
        x: x1,
        y: y1
    });
    return info;
};
/**
* Get the point on the path that is distance along the path
* @param path
* @param distance
* @param infos
*/ const $9a54cbcfc1af41ba$var$getPointOnPath = (path, distance, infos = $9a54cbcfc1af41ba$var$getPathSegmentsInfo(path))=>{
    let i = 0;
    while(distance - infos[i].length > 0 && i < infos.length - 2){
        distance -= infos[i].length;
        i++;
    }
    const segInfo = infos[i], segPercent = distance / segInfo.length, segment = path[i];
    switch(segInfo.command){
        case "M":
            return {
                x: segInfo.x,
                y: segInfo.y,
                angle: 0
            };
        case "Z":
            return {
                ...new $9a54cbcfc1af41ba$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $9a54cbcfc1af41ba$export$baf26146a414f24a(segInfo.destX, segInfo.destY), segPercent),
                angle: Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x)
            };
        case "L":
            return {
                ...new $9a54cbcfc1af41ba$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $9a54cbcfc1af41ba$export$baf26146a414f24a(segment[1], segment[2]), segPercent),
                angle: Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x)
            };
        case "C":
            return $9a54cbcfc1af41ba$var$findPercentageForDistance(segInfo, distance);
        case "Q":
            return $9a54cbcfc1af41ba$var$findPercentageForDistance(segInfo, distance);
        default:
    }
};
const $9a54cbcfc1af41ba$var$rePathCmdAll = new RegExp($9a54cbcfc1af41ba$var$rePathCommand, "gi");
const $9a54cbcfc1af41ba$var$regExpArcCommandPoints = new RegExp($9a54cbcfc1af41ba$var$reArcCommandPoints, "g");
const $9a54cbcfc1af41ba$var$reMyNum = new RegExp($9a54cbcfc1af41ba$var$reNum, "gi");
const $9a54cbcfc1af41ba$var$commandLengths = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
};
/**
*
* @param {string} pathString
* @return {TComplexPathData} An array of SVG path commands
* @example <caption>Usage</caption>
* parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
*   ['M', 3, 4],
*   ['Q', 3, 5, 2, 1, 4, 0],
*   ['Q', 9, 12, 2, 1, 4, 0],
* ];
*/ const $9a54cbcfc1af41ba$var$parsePath = (pathString)=>{
    var _pathString$match;
    const chain = [];
    const all = (_pathString$match = pathString.match($9a54cbcfc1af41ba$var$rePathCmdAll)) !== null && _pathString$match !== void 0 ? _pathString$match : [];
    for (const matchStr of all){
        const commandLetter = matchStr[0];
        if (commandLetter === "z" || commandLetter === "Z") {
            chain.push([
                commandLetter
            ]);
            continue;
        }
        const commandLength = $9a54cbcfc1af41ba$var$commandLengths[commandLetter.toLowerCase()];
        let paramArr = [];
        if (commandLetter === "a" || commandLetter === "A") {
            $9a54cbcfc1af41ba$var$regExpArcCommandPoints.lastIndex = 0;
            for(let out = null; out = $9a54cbcfc1af41ba$var$regExpArcCommandPoints.exec(matchStr);)paramArr.push(...out.slice(1));
        } else paramArr = matchStr.match($9a54cbcfc1af41ba$var$reMyNum) || [];
        for(let i = 0; i < paramArr.length; i += commandLength){
            const newCommand = new Array(commandLength);
            const transformedCommand = $9a54cbcfc1af41ba$var$repeatedCommands[commandLetter];
            newCommand[0] = i > 0 && transformedCommand ? transformedCommand : commandLetter;
            for(let j = 0; j < commandLength; j++)newCommand[j + 1] = parseFloat(paramArr[i + j]);
            chain.push(newCommand);
        }
    }
    return chain;
};
/**
*
* Converts points to a smooth SVG path
* @param {XY[]} points Array of points
* @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
* @return {(string|number)[][]} An array of SVG path commands
*/ const $9a54cbcfc1af41ba$var$getSmoothPathFromPoints = (points, correction = 0)=>{
    let p1 = new $9a54cbcfc1af41ba$export$baf26146a414f24a(points[0]), p2 = new $9a54cbcfc1af41ba$export$baf26146a414f24a(points[1]), multSignX = 1, multSignY = 0;
    const path = [], len = points.length, manyPoints = len > 2;
    if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
    }
    path.push([
        "M",
        p1.x - multSignX * correction,
        p1.y - multSignY * correction
    ]);
    let i;
    for(i = 1; i < len; i++){
        if (!p1.eq(p2)) {
            const midPoint = p1.midPointFrom(p2);
            path.push([
                "Q",
                p1.x,
                p1.y,
                midPoint.x,
                midPoint.y
            ]);
        }
        p1 = points[i];
        if (i + 1 < points.length) p2 = points[i + 1];
    }
    if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
    }
    path.push([
        "L",
        p1.x + multSignX * correction,
        p1.y + multSignY * correction
    ]);
    return path;
};
/**
* Transform a path by transforming each segment.
* it has to be a simplified path or it won't work.
* WARNING: this depends from pathOffset for correct operation
* @param {TSimplePathData} path fabricJS parsed and simplified path commands
* @param {TMat2D} transform matrix that represent the transformation
* @param {Point} [pathOffset] `Path.pathOffset`
* @returns {TSimplePathData} the transformed path
*/ const $9a54cbcfc1af41ba$var$transformPath = (path, transform, pathOffset)=>{
    if (pathOffset) transform = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(transform, [
        1,
        0,
        0,
        1,
        -pathOffset.x,
        -pathOffset.y
    ]);
    return path.map((pathSegment)=>{
        const newSegment = [
            ...pathSegment
        ];
        for(let i = 1; i < pathSegment.length - 1; i += 2){
            const { x: x, y: y } = $9a54cbcfc1af41ba$var$transformPoint({
                x: pathSegment[i],
                y: pathSegment[i + 1]
            }, transform);
            newSegment[i] = x;
            newSegment[i + 1] = y;
        }
        return newSegment;
    });
};
/**
* Returns an array of path commands to create a regular polygon
* @param {number} numVertexes
* @param {number} radius
* @returns {TSimplePathData} An array of SVG path commands
*/ const $9a54cbcfc1af41ba$var$getRegularPolygonPath = (numVertexes, radius)=>{
    const interiorAngle = Math.PI * 2 / numVertexes;
    let rotationAdjustment = -$9a54cbcfc1af41ba$var$halfPI;
    if (numVertexes % 2 === 0) rotationAdjustment += interiorAngle / 2;
    const d = new Array(numVertexes + 1);
    for(let i = 0; i < numVertexes; i++){
        const rad = i * interiorAngle + rotationAdjustment;
        const { x: x, y: y } = new $9a54cbcfc1af41ba$export$baf26146a414f24a($9a54cbcfc1af41ba$var$cos(rad), $9a54cbcfc1af41ba$var$sin(rad)).scalarMultiply(radius);
        d[i] = [
            i === 0 ? "M" : "L",
            x,
            y
        ];
    }
    d[numVertexes] = [
        "Z"
    ];
    return d;
};
/**
* Join path commands to go back to svg format
* @param {TSimplePathData} pathData fabricJS parsed path commands
* @param {number} fractionDigits number of fraction digits to "leave"
* @return {String} joined path 'M 0 0 L 20 30'
*/ const $9a54cbcfc1af41ba$var$joinPath = (pathData, fractionDigits)=>pathData.map((segment)=>{
        return segment.map((arg, i)=>{
            if (i === 0) return arg;
            return fractionDigits === void 0 ? arg : $9a54cbcfc1af41ba$var$toFixed(arg, fractionDigits);
        }).join(" ");
    }).join(" ");
//#endregion
//#region src/util/misc/mergeClipPaths.ts
/**
* Merges 2 clip paths into one visually equal clip path
*
* **IMPORTANT**:\
* Does **NOT** clone the arguments, clone them proir if necessary.
*
* Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
* Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
*
* In order to handle the `inverted` property we follow logic described in the following cases:\
* **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
* **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
* **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
*
* @param {fabric.Object} c1
* @param {fabric.Object} c2
* @returns {fabric.Object} merged clip path
*/ const $9a54cbcfc1af41ba$var$mergeClipPaths = (c1, c2)=>{
    var _b$group;
    let a = c1, b = c2;
    if (a.inverted && !b.inverted) {
        a = c2;
        b = c1;
    }
    $9a54cbcfc1af41ba$var$sendObjectToPlane(b, (_b$group = b.group) === null || _b$group === void 0 ? void 0 : _b$group.calcTransformMatrix(), a.calcTransformMatrix());
    const inverted = a.inverted && b.inverted;
    if (inverted) a.inverted = b.inverted = false;
    return new $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4([
        a
    ], {
        clipPath: b,
        inverted: inverted
    });
};
//#endregion
//#region src/util/internals/getRandomInt.ts
/**
* Returns random number between 2 specified ones.
* @param {Number} min lower limit
* @param {Number} max upper limit
* @return {Number} random value (between min and max)
*/ const $9a54cbcfc1af41ba$var$getRandomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
//#endregion
//#region src/util/transform_matrix_removal.ts
/**
* This function is an helper for svg import. it decompose the transformMatrix
* and assign properties to object.
* untransformed coordinates
* @private
*/ const $9a54cbcfc1af41ba$var$_assignTransformMatrixProps = (object)=>{
    if (object.transformMatrix) {
        const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX } = $9a54cbcfc1af41ba$var$qrDecompose(object.transformMatrix);
        object.flipX = false;
        object.flipY = false;
        object.set($9a54cbcfc1af41ba$var$SCALE_X, scaleX);
        object.set($9a54cbcfc1af41ba$var$SCALE_Y, scaleY);
        object.angle = angle;
        object.skewX = skewX;
        object.skewY = 0;
    }
};
/**
* This function is an helper for svg import. it removes the transform matrix
* and set to object properties that fabricjs can handle
* @private
* @param {Object} preserveAspectRatioOptions
*/ const $9a54cbcfc1af41ba$var$removeTransformMatrixForSvgParsing = (object, preserveAspectRatioOptions)=>{
    let center = object._findCenterFromElement();
    if (object.transformMatrix) {
        $9a54cbcfc1af41ba$var$_assignTransformMatrixProps(object);
        center = center.transform(object.transformMatrix);
    }
    delete object.transformMatrix;
    if (preserveAspectRatioOptions) {
        object.scaleX *= preserveAspectRatioOptions.scaleX;
        object.scaleY *= preserveAspectRatioOptions.scaleY;
        object.cropX = preserveAspectRatioOptions.cropX;
        object.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        object.width = preserveAspectRatioOptions.width;
        object.height = preserveAspectRatioOptions.height;
    }
    object.setPositionByOrigin(center, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
};
//#endregion
//#region src/util/index.ts
var $9a54cbcfc1af41ba$export$7debb50ef11d5e0b = /* @__PURE__ */ $9a54cbcfc1af41ba$var$__exportAll({
    addTransformToObject: ()=>$9a54cbcfc1af41ba$var$addTransformToObject,
    animate: ()=>$9a54cbcfc1af41ba$var$animate,
    animateColor: ()=>$9a54cbcfc1af41ba$var$animateColor,
    applyTransformToObject: ()=>$9a54cbcfc1af41ba$var$applyTransformToObject,
    calcAngleBetweenVectors: ()=>$9a54cbcfc1af41ba$var$calcAngleBetweenVectors,
    calcDimensionsMatrix: ()=>$9a54cbcfc1af41ba$var$calcDimensionsMatrix,
    calcPlaneChangeMatrix: ()=>$9a54cbcfc1af41ba$var$calcPlaneChangeMatrix,
    calcVectorRotation: ()=>$9a54cbcfc1af41ba$var$calcVectorRotation,
    cancelAnimFrame: ()=>$9a54cbcfc1af41ba$var$cancelAnimFrame,
    capValue: ()=>$9a54cbcfc1af41ba$var$capValue,
    composeMatrix: ()=>$9a54cbcfc1af41ba$var$composeMatrix,
    copyCanvasElement: ()=>$9a54cbcfc1af41ba$var$copyCanvasElement,
    cos: ()=>$9a54cbcfc1af41ba$var$cos,
    createCanvasElement: ()=>$9a54cbcfc1af41ba$var$createCanvasElement,
    createImage: ()=>$9a54cbcfc1af41ba$var$createImage,
    createRotateMatrix: ()=>$9a54cbcfc1af41ba$var$createRotateMatrix,
    createScaleMatrix: ()=>$9a54cbcfc1af41ba$var$createScaleMatrix,
    createSkewXMatrix: ()=>$9a54cbcfc1af41ba$var$createSkewXMatrix,
    createSkewYMatrix: ()=>$9a54cbcfc1af41ba$var$createSkewYMatrix,
    createTranslateMatrix: ()=>$9a54cbcfc1af41ba$var$createTranslateMatrix,
    createVector: ()=>$9a54cbcfc1af41ba$var$createVector,
    crossProduct: ()=>$9a54cbcfc1af41ba$var$crossProduct,
    degreesToRadians: ()=>$9a54cbcfc1af41ba$var$degreesToRadians,
    dotProduct: ()=>$9a54cbcfc1af41ba$var$dotProduct,
    ease: ()=>$9a54cbcfc1af41ba$var$easing_exports,
    enlivenObjectEnlivables: ()=>$9a54cbcfc1af41ba$var$enlivenObjectEnlivables,
    enlivenObjects: ()=>$9a54cbcfc1af41ba$var$enlivenObjects,
    findScaleToCover: ()=>$9a54cbcfc1af41ba$var$findScaleToCover,
    findScaleToFit: ()=>$9a54cbcfc1af41ba$var$findScaleToFit,
    getBoundsOfCurve: ()=>$9a54cbcfc1af41ba$var$getBoundsOfCurve,
    getOrthonormalVector: ()=>$9a54cbcfc1af41ba$var$getOrthonormalVector,
    getPathSegmentsInfo: ()=>$9a54cbcfc1af41ba$var$getPathSegmentsInfo,
    getPointOnPath: ()=>$9a54cbcfc1af41ba$var$getPointOnPath,
    getPointer: ()=>$9a54cbcfc1af41ba$var$getPointer,
    getRandomInt: ()=>$9a54cbcfc1af41ba$var$getRandomInt,
    getRegularPolygonPath: ()=>$9a54cbcfc1af41ba$var$getRegularPolygonPath,
    getSmoothPathFromPoints: ()=>$9a54cbcfc1af41ba$var$getSmoothPathFromPoints,
    getSvgAttributes: ()=>$9a54cbcfc1af41ba$var$getSvgAttributes,
    getUnitVector: ()=>$9a54cbcfc1af41ba$var$getUnitVector,
    groupSVGElements: ()=>$9a54cbcfc1af41ba$var$groupSVGElements,
    hasStyleChanged: ()=>$9a54cbcfc1af41ba$var$hasStyleChanged,
    invertTransform: ()=>$9a54cbcfc1af41ba$var$invertTransform,
    isBetweenVectors: ()=>$9a54cbcfc1af41ba$var$isBetweenVectors,
    isIdentityMatrix: ()=>$9a54cbcfc1af41ba$var$isIdentityMatrix,
    isTouchEvent: ()=>$9a54cbcfc1af41ba$var$isTouchEvent,
    isTransparent: ()=>$9a54cbcfc1af41ba$var$isTransparent,
    joinPath: ()=>$9a54cbcfc1af41ba$var$joinPath,
    loadImage: ()=>$9a54cbcfc1af41ba$var$loadImage,
    magnitude: ()=>$9a54cbcfc1af41ba$var$magnitude,
    makeBoundingBoxFromPoints: ()=>$9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints,
    makePathSimpler: ()=>$9a54cbcfc1af41ba$var$makePathSimpler,
    matrixToSVG: ()=>$9a54cbcfc1af41ba$var$matrixToSVG,
    mergeClipPaths: ()=>$9a54cbcfc1af41ba$var$mergeClipPaths,
    multiplyTransformMatrices: ()=>$9a54cbcfc1af41ba$var$multiplyTransformMatrices,
    multiplyTransformMatrixArray: ()=>$9a54cbcfc1af41ba$var$multiplyTransformMatrixArray,
    parsePath: ()=>$9a54cbcfc1af41ba$var$parsePath,
    parsePreserveAspectRatioAttribute: ()=>$9a54cbcfc1af41ba$var$parsePreserveAspectRatioAttribute,
    parseUnit: ()=>$9a54cbcfc1af41ba$var$parseUnit,
    pick: ()=>$9a54cbcfc1af41ba$var$pick,
    projectStrokeOnPoints: ()=>$9a54cbcfc1af41ba$var$projectStrokeOnPoints,
    qrDecompose: ()=>$9a54cbcfc1af41ba$var$qrDecompose,
    radiansToDegrees: ()=>$9a54cbcfc1af41ba$var$radiansToDegrees,
    removeFromArray: ()=>$9a54cbcfc1af41ba$var$removeFromArray,
    removeTransformFromObject: ()=>$9a54cbcfc1af41ba$var$removeTransformFromObject,
    removeTransformMatrixForSvgParsing: ()=>$9a54cbcfc1af41ba$var$removeTransformMatrixForSvgParsing,
    requestAnimFrame: ()=>$9a54cbcfc1af41ba$var$requestAnimFrame,
    resetObjectTransform: ()=>$9a54cbcfc1af41ba$var$resetObjectTransform,
    rotateVector: ()=>$9a54cbcfc1af41ba$var$rotateVector,
    saveObjectTransform: ()=>$9a54cbcfc1af41ba$var$saveObjectTransform,
    sendObjectToPlane: ()=>$9a54cbcfc1af41ba$var$sendObjectToPlane,
    sendPointToPlane: ()=>$9a54cbcfc1af41ba$var$sendPointToPlane,
    sendVectorToPlane: ()=>$9a54cbcfc1af41ba$var$sendVectorToPlane,
    sin: ()=>$9a54cbcfc1af41ba$var$sin,
    sizeAfterTransform: ()=>$9a54cbcfc1af41ba$var$sizeAfterTransform,
    string: ()=>$9a54cbcfc1af41ba$var$lang_string_exports,
    stylesFromArray: ()=>$9a54cbcfc1af41ba$var$stylesFromArray,
    stylesToArray: ()=>$9a54cbcfc1af41ba$var$stylesToArray,
    toBlob: ()=>$9a54cbcfc1af41ba$var$toBlob,
    toDataURL: ()=>$9a54cbcfc1af41ba$var$toDataURL,
    toFixed: ()=>$9a54cbcfc1af41ba$var$toFixed,
    transformPath: ()=>$9a54cbcfc1af41ba$var$transformPath,
    transformPoint: ()=>$9a54cbcfc1af41ba$var$transformPoint
});
//#endregion
//#region src/util/internals/dom_style.ts
/**
* wrapper for setting element's style
* @param {HTMLElement} element an HTMLElement
* @param {Object} styles to apply to element
*/ function $9a54cbcfc1af41ba$var$setStyle(element, styles) {
    const elementStyle = element.style;
    if (!elementStyle) return;
    Object.entries(styles).forEach(([property, value])=>elementStyle.setProperty(property, value));
}
//#endregion
//#region src/canvas/DOMManagers/CanvasDOMManager.ts
var $9a54cbcfc1af41ba$export$fc395a588fa002d0 = class extends $9a54cbcfc1af41ba$export$cf489a44e232c033 {
    constructor(arg0, { allowTouchScrolling: allowTouchScrolling = false, containerClass: containerClass = "" } = {}){
        super(arg0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "upper", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "container", void 0);
        const { el: lowerCanvasEl } = this.lower;
        const upperCanvasEl = this.createUpperCanvas();
        this.upper = {
            el: upperCanvasEl,
            ctx: upperCanvasEl.getContext("2d")
        };
        this.applyCanvasStyle(lowerCanvasEl, {
            allowTouchScrolling: allowTouchScrolling
        });
        this.applyCanvasStyle(upperCanvasEl, {
            allowTouchScrolling: allowTouchScrolling,
            styles: {
                position: "absolute",
                left: "0",
                top: "0"
            }
        });
        const container = this.createContainerElement();
        container.classList.add(containerClass);
        if (lowerCanvasEl.parentNode) lowerCanvasEl.parentNode.replaceChild(container, lowerCanvasEl);
        container.append(lowerCanvasEl, upperCanvasEl);
        this.container = container;
    }
    createUpperCanvas() {
        const { el: lowerCanvasEl } = this.lower;
        const el = $9a54cbcfc1af41ba$var$createCanvasElement();
        el.className = lowerCanvasEl.className;
        el.classList.remove("lower-canvas");
        el.classList.add("upper-canvas");
        el.setAttribute("data-fabric", "top");
        el.style.cssText = lowerCanvasEl.style.cssText;
        el.setAttribute("draggable", "true");
        return el;
    }
    createContainerElement() {
        const container = $9a54cbcfc1af41ba$export$91e93c41e950ddbb().createElement("div");
        container.setAttribute("data-fabric", "wrapper");
        $9a54cbcfc1af41ba$var$setStyle(container, {
            position: "relative"
        });
        $9a54cbcfc1af41ba$var$makeElementUnselectable(container);
        return container;
    }
    /**
	* @private
	* @param {HTMLCanvasElement} element canvas element to apply styles on
	*/ applyCanvasStyle(element, options) {
        const { styles: styles, allowTouchScrolling: allowTouchScrolling } = options;
        $9a54cbcfc1af41ba$var$setStyle(element, {
            ...styles,
            "touch-action": allowTouchScrolling ? "manipulation" : $9a54cbcfc1af41ba$var$NONE
        });
        $9a54cbcfc1af41ba$var$makeElementUnselectable(element);
    }
    setDimensions(size, retinaScaling) {
        super.setDimensions(size, retinaScaling);
        const { el: el, ctx: ctx } = this.upper;
        $9a54cbcfc1af41ba$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        super.setCSSDimensions(size);
        $9a54cbcfc1af41ba$var$setCSSDimensions(this.upper.el, size);
        $9a54cbcfc1af41ba$var$setCSSDimensions(this.container, size);
    }
    cleanupDOM(size) {
        const container = this.container, { el: lowerCanvasEl } = this.lower, { el: upperCanvasEl } = this.upper;
        super.cleanupDOM(size);
        container.removeChild(upperCanvasEl);
        container.removeChild(lowerCanvasEl);
        if (container.parentNode) container.parentNode.replaceChild(lowerCanvasEl, container);
    }
    dispose() {
        super.dispose();
        $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().dispose(this.upper.el);
        delete this.upper;
        delete this.container;
    }
};
//#endregion
//#region src/canvas/CanvasOptions.ts
const $9a54cbcfc1af41ba$var$canvasDefaults = {
    uniformScaling: true,
    uniScaleKey: "shiftKey",
    centeredScaling: false,
    centeredRotation: false,
    centeredKey: "altKey",
    altActionKey: "shiftKey",
    selection: true,
    selectionKey: "shiftKey",
    selectionColor: "rgba(100, 100, 255, 0.3)",
    selectionDashArray: [],
    selectionBorderColor: "rgba(255, 255, 255, 0.3)",
    selectionLineWidth: 1,
    selectionFullyContained: false,
    hoverCursor: "move",
    moveCursor: "move",
    defaultCursor: "default",
    freeDrawingCursor: "crosshair",
    notAllowedCursor: "not-allowed",
    perPixelTargetFind: false,
    targetFindTolerance: 0,
    skipTargetFind: false,
    stopContextMenu: true,
    fireRightClick: true,
    fireMiddleClick: true,
    enablePointerEvents: false,
    containerClass: "canvas-container",
    preserveObjectStacking: true
};
//#endregion
//#region src/controls/drag.ts
/**
* Action handler
* @private
* @param {Event} eventData javascript event that is doing the transform
* @param {Object} transform javascript object containing a series of information around the current transform
* @param {number} x current mouse x position, canvas normalized
* @param {number} y current mouse y position, canvas normalized
* @return {Boolean} true if the translation occurred
*/ const $9a54cbcfc1af41ba$var$dragHandler = (eventData, transform, x, y)=>{
    const { target: target, offsetX: offsetX, offsetY: offsetY } = transform, newLeft = x - offsetX, newTop = y - offsetY, moveX = !$9a54cbcfc1af41ba$var$isLocked(target, "lockMovementX") && target.left !== newLeft, moveY = !$9a54cbcfc1af41ba$var$isLocked(target, "lockMovementY") && target.top !== newTop;
    moveX && target.set("left", newLeft);
    moveY && target.set("top", newTop);
    if (moveX || moveY) $9a54cbcfc1af41ba$var$fireEvent($9a54cbcfc1af41ba$var$MOVING, $9a54cbcfc1af41ba$var$commonEventInfo(eventData, transform, x, y));
    return moveX || moveY;
};
//#endregion
//#region src/controls/polyControl.ts
const $9a54cbcfc1af41ba$var$ACTION_NAME$1 = $9a54cbcfc1af41ba$var$MODIFY_POLY;
/**
* This function locates the controls.
* It'll be used both for drawing and for interaction.
*/ const $9a54cbcfc1af41ba$var$createPolyPositionHandler = (pointIndex)=>{
    return function(dim, finalMatrix, polyObject) {
        const { points: points, pathOffset: pathOffset } = polyObject;
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(points[pointIndex]).subtract(pathOffset).transform($9a54cbcfc1af41ba$var$multiplyTransformMatrices(polyObject.getViewportTransform(), polyObject.calcTransformMatrix()));
    };
};
/**
* This function defines what the control does.
* It'll be called on every mouse move after a control has been clicked and is being dragged.
* The function receives as argument the mouse event, the current transform object
* and the current position in canvas coordinate `transform.target` is a reference to the
* current object being transformed.
*/ const $9a54cbcfc1af41ba$var$polyActionHandler = (eventData, transform, x, y)=>{
    const { target: target, pointIndex: pointIndex } = transform;
    const poly = target;
    const mouseLocalPosition = $9a54cbcfc1af41ba$var$sendPointToPlane(new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y), void 0, poly.calcOwnMatrix());
    poly.points[pointIndex] = mouseLocalPosition.add(poly.pathOffset);
    poly.setDimensions();
    poly.set("dirty", true);
    return true;
};
/**
* Keep the polygon in the same position when we change its `width`/`height`/`top`/`left`.
*/ const $9a54cbcfc1af41ba$var$factoryPolyActionHandler = (pointIndex, fn)=>{
    return function(eventData, transform, x, y) {
        const poly = transform.target, anchorPoint = new $9a54cbcfc1af41ba$export$baf26146a414f24a(poly.points[(pointIndex > 0 ? pointIndex : poly.points.length) - 1]), anchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix()), actionPerformed = fn(eventData, {
            ...transform,
            pointIndex: pointIndex
        }, x, y);
        const diff = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix()).subtract(anchorPointInParentPlane);
        poly.left -= diff.x;
        poly.top -= diff.y;
        return actionPerformed;
    };
};
const $9a54cbcfc1af41ba$var$createPolyActionHandler = (pointIndex)=>$9a54cbcfc1af41ba$var$wrapWithFireEvent($9a54cbcfc1af41ba$var$ACTION_NAME$1, $9a54cbcfc1af41ba$var$factoryPolyActionHandler(pointIndex, $9a54cbcfc1af41ba$var$polyActionHandler));
function $9a54cbcfc1af41ba$var$createPolyControls(arg0, options = {}) {
    const controls = {};
    for(let idx = 0; idx < (typeof arg0 === "number" ? arg0 : arg0.points.length); idx++)controls[`p${idx}`] = new $9a54cbcfc1af41ba$export$7a7fa4424cb20976({
        actionName: $9a54cbcfc1af41ba$var$ACTION_NAME$1,
        positionHandler: $9a54cbcfc1af41ba$var$createPolyPositionHandler(idx),
        actionHandler: $9a54cbcfc1af41ba$var$createPolyActionHandler(idx),
        ...options
    });
    return controls;
}
//#endregion
//#region src/controls/pathControl.ts
const $9a54cbcfc1af41ba$var$ACTION_NAME = "modifyPath";
const $9a54cbcfc1af41ba$var$calcPathPointPosition = (pathObject, commandIndex, pointIndex)=>{
    const { path: path, pathOffset: pathOffset } = pathObject;
    const command = path[commandIndex];
    return new $9a54cbcfc1af41ba$export$baf26146a414f24a(command[pointIndex] - pathOffset.x, command[pointIndex + 1] - pathOffset.y).transform($9a54cbcfc1af41ba$var$multiplyTransformMatrices(pathObject.getViewportTransform(), pathObject.calcTransformMatrix()));
};
const $9a54cbcfc1af41ba$var$movePathPoint = (pathObject, x, y, commandIndex, pointIndex)=>{
    const { path: path, pathOffset: pathOffset } = pathObject;
    const anchorCommand = path[(commandIndex > 0 ? commandIndex : path.length) - 1];
    const anchorPoint = new $9a54cbcfc1af41ba$export$baf26146a414f24a(anchorCommand[pointIndex], anchorCommand[pointIndex + 1]);
    const anchorPointInParentPlane = anchorPoint.subtract(pathOffset).transform(pathObject.calcOwnMatrix());
    const mouseLocalPosition = $9a54cbcfc1af41ba$var$sendPointToPlane(new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y), void 0, pathObject.calcOwnMatrix());
    path[commandIndex][pointIndex] = mouseLocalPosition.x + pathOffset.x;
    path[commandIndex][pointIndex + 1] = mouseLocalPosition.y + pathOffset.y;
    pathObject.setDimensions();
    const diff = anchorPoint.subtract(pathObject.pathOffset).transform(pathObject.calcOwnMatrix()).subtract(anchorPointInParentPlane);
    pathObject.left -= diff.x;
    pathObject.top -= diff.y;
    pathObject.set("dirty", true);
    return true;
};
/**
* This function locates the controls.
* It'll be used both for drawing and for interaction.
*/ function $9a54cbcfc1af41ba$var$pathPositionHandler(dim, finalMatrix, pathObject) {
    const { commandIndex: commandIndex, pointIndex: pointIndex } = this;
    return $9a54cbcfc1af41ba$var$calcPathPointPosition(pathObject, commandIndex, pointIndex);
}
/**
* This function defines what the control does.
* It'll be called on every mouse move after a control has been clicked and is being dragged.
* The function receives as argument the mouse event, the current transform object
* and the current position in canvas coordinate `transform.target` is a reference to the
* current object being transformed.
*/ function $9a54cbcfc1af41ba$var$pathActionHandler(eventData, transform, x, y) {
    const { target: target } = transform;
    const { commandIndex: commandIndex, pointIndex: pointIndex } = this;
    const actionPerformed = $9a54cbcfc1af41ba$var$movePathPoint(target, x, y, commandIndex, pointIndex);
    if (actionPerformed) $9a54cbcfc1af41ba$var$fireEvent(this.actionName, {
        ...$9a54cbcfc1af41ba$var$commonEventInfo(eventData, transform, x, y),
        commandIndex: commandIndex,
        pointIndex: pointIndex
    });
    return actionPerformed;
}
const $9a54cbcfc1af41ba$var$indexFromPrevCommand = (previousCommandType)=>previousCommandType === "C" ? 5 : previousCommandType === "Q" ? 3 : 1;
var $9a54cbcfc1af41ba$var$PathPointControl = class extends $9a54cbcfc1af41ba$export$7a7fa4424cb20976 {
    constructor(options){
        super(options);
    }
    render(ctx, left, top, styleOverride, fabricObject) {
        const overrides = {
            ...styleOverride,
            cornerColor: this.controlFill,
            cornerStrokeColor: this.controlStroke,
            transparentCorners: !this.controlFill
        };
        super.render(ctx, left, top, overrides, fabricObject);
    }
};
var $9a54cbcfc1af41ba$var$PathControlPointControl = class extends $9a54cbcfc1af41ba$var$PathPointControl {
    constructor(options){
        super(options);
    }
    render(ctx, left, top, styleOverride, fabricObject) {
        const { path: path } = fabricObject;
        const { commandIndex: commandIndex, pointIndex: pointIndex, connectToCommandIndex: connectToCommandIndex, connectToPointIndex: connectToPointIndex } = this;
        ctx.save();
        ctx.strokeStyle = this.controlStroke;
        if (this.connectionDashArray) ctx.setLineDash(this.connectionDashArray);
        const [commandType] = path[commandIndex];
        const point = $9a54cbcfc1af41ba$var$calcPathPointPosition(fabricObject, connectToCommandIndex, connectToPointIndex);
        if (commandType === "Q") {
            const point2 = $9a54cbcfc1af41ba$var$calcPathPointPosition(fabricObject, commandIndex, pointIndex + 2);
            ctx.moveTo(point2.x, point2.y);
            ctx.lineTo(left, top);
        } else ctx.moveTo(left, top);
        ctx.lineTo(point.x, point.y);
        ctx.stroke();
        ctx.restore();
        super.render(ctx, left, top, styleOverride, fabricObject);
    }
};
const $9a54cbcfc1af41ba$var$createControl = (commandIndexPos, pointIndexPos, isControlPoint, options, connectToCommandIndex, connectToPointIndex)=>new (isControlPoint ? $9a54cbcfc1af41ba$var$PathControlPointControl : $9a54cbcfc1af41ba$var$PathPointControl)({
        commandIndex: commandIndexPos,
        pointIndex: pointIndexPos,
        actionName: $9a54cbcfc1af41ba$var$ACTION_NAME,
        positionHandler: $9a54cbcfc1af41ba$var$pathPositionHandler,
        actionHandler: $9a54cbcfc1af41ba$var$pathActionHandler,
        connectToCommandIndex: connectToCommandIndex,
        connectToPointIndex: connectToPointIndex,
        ...options,
        ...isControlPoint ? options.controlPointStyle : options.pointStyle
    });
function $9a54cbcfc1af41ba$var$createPathControls(path, options = {}) {
    const controls = {};
    let previousCommandType = "M";
    path.path.forEach((command, commandIndex)=>{
        const commandType = command[0];
        if (commandType !== "Z") controls[`c_${commandIndex}_${commandType}`] = $9a54cbcfc1af41ba$var$createControl(commandIndex, command.length - 2, false, options);
        switch(commandType){
            case "C":
                controls[`c_${commandIndex}_C_CP_1`] = $9a54cbcfc1af41ba$var$createControl(commandIndex, 1, true, options, commandIndex - 1, $9a54cbcfc1af41ba$var$indexFromPrevCommand(previousCommandType));
                controls[`c_${commandIndex}_C_CP_2`] = $9a54cbcfc1af41ba$var$createControl(commandIndex, 3, true, options, commandIndex, 5);
                break;
            case "Q":
                controls[`c_${commandIndex}_Q_CP_1`] = $9a54cbcfc1af41ba$var$createControl(commandIndex, 1, true, options, commandIndex, 3);
                break;
        }
        previousCommandType = commandType;
    });
    return controls;
}
//#endregion
//#region src/controls/index.ts
var $9a54cbcfc1af41ba$export$d13a0d9b79355c3 = /* @__PURE__ */ $9a54cbcfc1af41ba$var$__exportAll({
    changeHeight: ()=>$9a54cbcfc1af41ba$var$changeHeight,
    changeObjectHeight: ()=>$9a54cbcfc1af41ba$var$changeObjectHeight,
    changeObjectWidth: ()=>$9a54cbcfc1af41ba$var$changeObjectWidth,
    changeWidth: ()=>$9a54cbcfc1af41ba$var$changeWidth,
    createObjectDefaultControls: ()=>$9a54cbcfc1af41ba$var$createObjectDefaultControls,
    createPathControls: ()=>$9a54cbcfc1af41ba$var$createPathControls,
    createPolyActionHandler: ()=>$9a54cbcfc1af41ba$var$createPolyActionHandler,
    createPolyControls: ()=>$9a54cbcfc1af41ba$var$createPolyControls,
    createPolyPositionHandler: ()=>$9a54cbcfc1af41ba$var$createPolyPositionHandler,
    createResizeControls: ()=>$9a54cbcfc1af41ba$var$createResizeControls,
    createTextboxDefaultControls: ()=>$9a54cbcfc1af41ba$var$createTextboxDefaultControls,
    dragHandler: ()=>$9a54cbcfc1af41ba$var$dragHandler,
    factoryPolyActionHandler: ()=>$9a54cbcfc1af41ba$var$factoryPolyActionHandler,
    getLocalPoint: ()=>$9a54cbcfc1af41ba$var$getLocalPoint,
    polyActionHandler: ()=>$9a54cbcfc1af41ba$var$polyActionHandler,
    renderCircleControl: ()=>$9a54cbcfc1af41ba$var$renderCircleControl,
    renderSquareControl: ()=>$9a54cbcfc1af41ba$var$renderSquareControl,
    rotationStyleHandler: ()=>$9a54cbcfc1af41ba$var$rotationStyleHandler,
    rotationWithSnapping: ()=>$9a54cbcfc1af41ba$var$rotationWithSnapping,
    scaleCursorStyleHandler: ()=>$9a54cbcfc1af41ba$var$scaleCursorStyleHandler,
    scaleOrSkewActionName: ()=>$9a54cbcfc1af41ba$var$scaleOrSkewActionName,
    scaleSkewCursorStyleHandler: ()=>$9a54cbcfc1af41ba$var$scaleSkewCursorStyleHandler,
    scalingEqually: ()=>$9a54cbcfc1af41ba$var$scalingEqually,
    scalingX: ()=>$9a54cbcfc1af41ba$var$scalingX,
    scalingXOrSkewingY: ()=>$9a54cbcfc1af41ba$var$scalingXOrSkewingY,
    scalingY: ()=>$9a54cbcfc1af41ba$var$scalingY,
    scalingYOrSkewingX: ()=>$9a54cbcfc1af41ba$var$scalingYOrSkewingX,
    skewCursorStyleHandler: ()=>$9a54cbcfc1af41ba$var$skewCursorStyleHandler,
    skewHandlerX: ()=>$9a54cbcfc1af41ba$var$skewHandlerX,
    skewHandlerY: ()=>$9a54cbcfc1af41ba$var$skewHandlerY,
    wrapWithFireEvent: ()=>$9a54cbcfc1af41ba$var$wrapWithFireEvent,
    wrapWithFixedAnchor: ()=>$9a54cbcfc1af41ba$var$wrapWithFixedAnchor
});
//#endregion
//#region src/canvas/SelectableCanvas.ts
/**
* Canvas class
* @class Canvas
* @extends StaticCanvas
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-1#canvas}
*
* @fires object:modified at the end of a transform
* @fires object:rotating while an object is being rotated from the control
* @fires object:scaling while an object is being scaled by controls
* @fires object:moving while an object is being dragged
* @fires object:skewing while an object is being skewed from the controls
*
* @fires before:transform before a transform is is started
* @fires before:selection:cleared
* @fires selection:cleared
* @fires selection:updated
* @fires selection:created
*
* @fires path:created after a drawing operation ends and the path is added
* @fires mouse:down
* @fires mouse:move
* @fires mouse:up
* @fires mouse:down:before  on mouse down, before the inner fabric logic runs
* @fires mouse:move:before on mouse move, before the inner fabric logic runs
* @fires mouse:up:before on mouse up, before the inner fabric logic runs
* @fires mouse:over
* @fires mouse:out
* @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
*
* @fires dragover
* @fires dragenter
* @fires dragleave
* @fires drag:enter object drag enter
* @fires drag:leave object drag leave
* @fires drop:before before drop event. Prepare for the drop event (same native event).
* @fires drop
* @fires drop:after after drop event. Run logic on canvas after event has been accepted/declined (same native event).
* @example
* let a: fabric.Object, b: fabric.Object;
* let flag = false;
* canvas.add(a, b);
* a.on('drop:before', opt => {
*  //  we want a to accept the drop even though it's below b in the stack
*  flag = this.canDrop(opt.e);
* });
* b.canDrop = function(e) {
*  !flag && this.draggableTextDelegate.canDrop(e);
* }
* b.on('dragover', opt => b.set('fill', opt.dropTarget === b ? 'pink' : 'black'));
* a.on('drop', opt => {
*  opt.e.defaultPrevented  //  drop occurred
*  opt.didDrop             //  drop occurred on canvas
*  opt.target              //  drop target
*  opt.target !== a && a.set('text', 'I lost');
* });
* canvas.on('drop:after', opt => {
*  //  inform user who won
*  if(!opt.e.defaultPrevented) {
*    // no winners
*  }
*  else if(!opt.didDrop) {
*    //  my objects didn't win, some other lucky object
*  }
*  else {
*    //  we have a winner it's opt.target!!
*  }
* })
*
* @fires after:render at the end of the render process, receives the context in the callback
* @fires before:render at start the render process, receives the context in the callback
*
* @fires contextmenu:before
* @fires contextmenu
* @example
* let handler;
* targets.forEach(target => {
*   target.on('contextmenu:before', opt => {
*     //  decide which target should handle the event before canvas hijacks it
*     if (someCaseHappens && opt.targets.includes(target)) {
*       handler = target;
*     }
*   });
*   target.on('contextmenu', opt => {
*     //  do something fantastic
*   });
* });
* canvas.on('contextmenu', opt => {
*   if (!handler) {
*     //  no one takes responsibility, it's always left to me
*     //  let's show them how it's done!
*   }
* });
*
*/ var $9a54cbcfc1af41ba$var$SelectableCanvas = class SelectableCanvas extends $9a54cbcfc1af41ba$export$ad01921fb0b1386e {
    constructor(..._args){
        super(..._args);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* hold the list of nested targets hovered in the previous events
			* @type FabricObject[]
			* @private
			*/ "_hoveredTargets", []);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* hold a reference to a data structure that contains information
			* on the current on going transform
			* @type
			* @private
			*/ "_currentTransform", null);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_groupSelector", null);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* internal flag used to understand if the context top requires a cleanup
			* in case this is true, the contextTop will be cleared at the next render
			* @type boolean
			* @private
			*/ "contextTopDirty", false);
    }
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...SelectableCanvas.ownDefaults
        };
    }
    get upperCanvasEl() {
        var _this$elements$upper;
        return (_this$elements$upper = this.elements.upper) === null || _this$elements$upper === void 0 ? void 0 : _this$elements$upper.el;
    }
    get contextTop() {
        var _this$elements$upper2;
        return (_this$elements$upper2 = this.elements.upper) === null || _this$elements$upper2 === void 0 ? void 0 : _this$elements$upper2.ctx;
    }
    get wrapperEl() {
        return this.elements.container;
    }
    initElements(el) {
        this.elements = new $9a54cbcfc1af41ba$export$fc395a588fa002d0(el, {
            allowTouchScrolling: this.allowTouchScrolling,
            containerClass: this.containerClass
        });
        this._createCacheCanvas();
    }
    /**
	* @private
	* @param {FabricObject} obj Object that was added
	*/ _onObjectAdded(obj) {
        this._objectsToRender = void 0;
        super._onObjectAdded(obj);
    }
    /**
	* @private
	* @param {FabricObject} obj Object that was removed
	*/ _onObjectRemoved(obj) {
        this._objectsToRender = void 0;
        if (obj === this._activeObject) {
            this.fire("before:selection:cleared", {
                deselected: [
                    obj
                ]
            });
            this._discardActiveObject();
            this.fire("selection:cleared", {
                deselected: [
                    obj
                ]
            });
            obj.fire("deselected", {
                target: obj
            });
        }
        if (obj === this._hoveredTarget) {
            this._hoveredTarget = void 0;
            this._hoveredTargets = [];
        }
        super._onObjectRemoved(obj);
    }
    _onStackOrderChanged() {
        this._objectsToRender = void 0;
        super._onStackOrderChanged();
    }
    /**
	* Divides objects in two groups, one to render immediately
	* and one to render as activeGroup.
	* @return {Array} objects to render immediately and pushes the other in the activeGroup.
	*/ _chooseObjectsToRender() {
        const activeObject = this._activeObject;
        return !this.preserveObjectStacking && activeObject ? this._objects.filter((object)=>!object.group && object !== activeObject).concat(activeObject) : this._objects;
    }
    /**
	* Renders both the top canvas and the secondary container canvas.
	*/ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
            this.clearContext(this.contextTop);
            this.contextTopDirty = false;
        }
        if (this.hasLostContext) {
            this.renderTopLayer(this.contextTop);
            this.hasLostContext = false;
        }
        !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender());
        this.renderCanvas(this.getContext(), this._objectsToRender);
    }
    /**
	* text selection is rendered by the active text instance during the rendering cycle
	*/ renderTopLayer(ctx) {
        ctx.save();
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this.freeDrawingBrush && this.freeDrawingBrush._render();
            this.contextTopDirty = true;
        }
        if (this.selection && this._groupSelector) {
            this._drawSelection(ctx);
            this.contextTopDirty = true;
        }
        ctx.restore();
    }
    /**
	* Method to render only the top canvas.
	* Also used to render the group selection box.
	* Does not render text selection.
	*/ renderTop() {
        const ctx = this.contextTop;
        this.clearContext(ctx);
        this.renderTopLayer(ctx);
        this.fire("after:render", {
            ctx: ctx
        });
    }
    /**
	* Set the canvas tolerance value for pixel taret find.
	* Use only integer numbers.
	* @private
	*/ setTargetFindTolerance(value) {
        value = Math.round(value);
        this.targetFindTolerance = value;
        const retina = this.getRetinaScaling();
        const size = Math.ceil((value * 2 + 1) * retina);
        this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = size;
        this.pixelFindContext.scale(retina, retina);
    }
    /**
	* Returns true if object is transparent at a certain location
	* Clarification: this is `is target transparent at location X or are controls there`
	* @TODO this seems dumb that we treat controls with transparency. we can find controls
	* programmatically without painting them, the cache canvas optimization is always valid
	* @param {FabricObject} target Object to check
	* @param {Number} x Left coordinate in viewport space
	* @param {Number} y Top coordinate in viewport space
	* @return {Boolean}
	*/ isTargetTransparent(target, x, y) {
        const tolerance = this.targetFindTolerance;
        const ctx = this.pixelFindContext;
        this.clearContext(ctx);
        ctx.save();
        ctx.translate(-x + tolerance, -y + tolerance);
        ctx.transform(...this.viewportTransform);
        const selectionBgc = target.selectionBackgroundColor;
        target.selectionBackgroundColor = "";
        target.render(ctx);
        target.selectionBackgroundColor = selectionBgc;
        ctx.restore();
        const enhancedTolerance = Math.round(tolerance * this.getRetinaScaling());
        return $9a54cbcfc1af41ba$var$isTransparent(ctx, enhancedTolerance, enhancedTolerance, enhancedTolerance);
    }
    /**
	* takes an event and determines if selection key has been pressed
	* @private
	* @param {TPointerEvent} e Event object
	*/ _isSelectionKeyPressed(e) {
        const sKey = this.selectionKey;
        if (!sKey) return false;
        if (Array.isArray(sKey)) return !!sKey.find((key)=>!!key && e[key] === true);
        else return e[sKey];
    }
    /**
	* @private
	* @param {TPointerEvent} e Event object
	* @param {FabricObject} target
	*/ _shouldClearSelection(e, target) {
        const activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
        return !!(!target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target);
    }
    /**
	* This method will take in consideration a modifier key pressed and the control we are
	* about to drag, and try to guess the anchor point ( origin ) of the transormation.
	* This should be really in the realm of controls, and we should remove specific code for legacy
	* embedded actions.
	* @TODO this probably deserve discussion/rediscovery and change/refactor
	* @private
	* @deprecated
	* @param {FabricObject} target
	* @param {string} action
	* @param {boolean} altKey
	* @returns {boolean} true if the transformation should be centered
	*/ _shouldCenterTransform(target, action, modifierKeyPressed) {
        if (!target) return;
        let centerTransform;
        if (action === "scale" || action === "scaleX" || action === "scaleY" || action === "resizing") centerTransform = this.centeredScaling || target.centeredScaling;
        else if (action === "rotate") centerTransform = this.centeredRotation || target.centeredRotation;
        return centerTransform ? !modifierKeyPressed : modifierKeyPressed;
    }
    /**
	* Given the control clicked, determine the origin of the transform.
	* This is bad because controls can totally have custom names
	* should disappear before release 4.0
	* Fabric 7.1, jan 2026 we are still using this.
	* Needs to go.
	* @private
	* @deprecated
	*/ _getOriginFromCorner(target, controlName) {
        const origin = controlName ? target.controls[controlName].getTransformAnchorPoint() : {
            x: target.originX,
            y: target.originY
        };
        if (!controlName) return origin;
        if ([
            "ml",
            "tl",
            "bl"
        ].includes(controlName)) origin.x = $9a54cbcfc1af41ba$var$RIGHT;
        else if ([
            "mr",
            "tr",
            "br"
        ].includes(controlName)) origin.x = $9a54cbcfc1af41ba$var$LEFT;
        if ([
            "tl",
            "mt",
            "tr"
        ].includes(controlName)) origin.y = $9a54cbcfc1af41ba$var$BOTTOM;
        else if ([
            "bl",
            "mb",
            "br"
        ].includes(controlName)) origin.y = "top";
        return origin;
    }
    /**
	* @private
	* @param {Event} e Event object
	* @param {FabricObject} target
	* @param {boolean} [alreadySelected] pass true to setup the active control
	*/ _setupCurrentTransform(e, target, alreadySelected) {
        var _control$getActionHan;
        const pointer = target.group ? $9a54cbcfc1af41ba$var$sendPointToPlane(this.getScenePoint(e), void 0, target.group.calcTransformMatrix()) : this.getScenePoint(e);
        const { key: corner = "", control: control } = target.getActiveControl() || {}, actionHandler = alreadySelected && control ? (_control$getActionHan = control.getActionHandler(e, target, control)) === null || _control$getActionHan === void 0 ? void 0 : _control$getActionHan.bind(control) : $9a54cbcfc1af41ba$var$dragHandler, action = $9a54cbcfc1af41ba$var$getActionFromCorner(alreadySelected, corner, e, target), altKey = e[this.centeredKey], origin = this._shouldCenterTransform(target, action, altKey) ? {
            x: $9a54cbcfc1af41ba$var$CENTER,
            y: $9a54cbcfc1af41ba$var$CENTER
        } : this._getOriginFromCorner(target, corner), { scaleX: scaleX, scaleY: scaleY, skewX: skewX, skewY: skewY, left: left, top: top, angle: angle, width: width, height: height, cropX: cropX, cropY: cropY } = target, transform = {
            target: target,
            action: action,
            actionHandler: actionHandler,
            actionPerformed: false,
            corner: corner,
            scaleX: scaleX,
            scaleY: scaleY,
            skewX: skewX,
            skewY: skewY,
            offsetX: pointer.x - left,
            offsetY: pointer.y - top,
            originX: origin.x,
            originY: origin.y,
            ex: pointer.x,
            ey: pointer.y,
            lastX: pointer.x,
            lastY: pointer.y,
            theta: $9a54cbcfc1af41ba$var$degreesToRadians(angle),
            width: width,
            height: height,
            shiftKey: e.shiftKey,
            altKey: altKey,
            original: {
                ...$9a54cbcfc1af41ba$var$saveObjectTransform(target),
                originX: origin.x,
                originY: origin.y,
                cropX: cropX,
                cropY: cropY
            }
        };
        this._currentTransform = transform;
        this.fire("before:transform", {
            e: e,
            transform: transform
        });
    }
    /**
	* Set the cursor type of the canvas element
	* @param {String} value Cursor type of the canvas element.
	* @see http://www.w3.org/TR/css3-ui/#cursor
	*/ setCursor(value) {
        this.upperCanvasEl.style.cursor = value;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx to draw the selection on
	*/ _drawSelection(ctx) {
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, start = new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y).transform(this.viewportTransform), extent = new $9a54cbcfc1af41ba$export$baf26146a414f24a(x + deltaX, y + deltaY).transform(this.viewportTransform), strokeOffset = this.selectionLineWidth / 2;
        let minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y);
        if (this.selectionColor) {
            ctx.fillStyle = this.selectionColor;
            ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
        }
        if (!this.selectionLineWidth || !this.selectionBorderColor) return;
        ctx.lineWidth = this.selectionLineWidth;
        ctx.strokeStyle = this.selectionBorderColor;
        minX += strokeOffset;
        minY += strokeOffset;
        maxX -= strokeOffset;
        maxY -= strokeOffset;
        $9a54cbcfc1af41ba$export$5a5fba7eea6847b1.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
        ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
    }
    /**
	* This function is in charge of deciding which is the object that is the current target of an interaction event.
	* For interaction event we mean a pointer related action on the canvas.
	* Which is the
	* 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
	* or the outside part of the corner.
	* @param {Event} e mouse event
	* @return {TargetsInfoWithContainer} the target found
	*/ findTarget(e) {
        if (this._targetInfo) return this._targetInfo;
        if (this.skipTargetFind) return {
            subTargets: [],
            currentSubTargets: []
        };
        const pointer = this.getScenePoint(e), activeObject = this._activeObject, aObjects = this.getActiveObjects(), targetInfo = this.searchPossibleTargets(this._objects, pointer);
        const { subTargets: currentSubTargets, container: currentContainer, target: currentTarget } = targetInfo;
        const fullTargetInfo = {
            ...targetInfo,
            currentSubTargets: currentSubTargets,
            currentContainer: currentContainer,
            currentTarget: currentTarget
        };
        if (!activeObject) return fullTargetInfo;
        const activeObjectTargetInfo = {
            ...this.searchPossibleTargets([
                activeObject
            ], pointer),
            currentSubTargets: currentSubTargets,
            currentContainer: currentContainer,
            currentTarget: currentTarget
        };
        if (activeObject.findControl(this.getViewportPoint(e), $9a54cbcfc1af41ba$var$isTouchEvent(e))) return {
            ...activeObjectTargetInfo,
            target: activeObject
        };
        if (activeObjectTargetInfo.target) {
            if (aObjects.length > 1) return activeObjectTargetInfo;
            if (!this.preserveObjectStacking) return activeObjectTargetInfo;
            if (this.preserveObjectStacking && e[this.altSelectionKey]) return activeObjectTargetInfo;
        }
        return fullTargetInfo;
    }
    /**
	* Checks if the point is inside the object selection area including padding
	* @param {FabricObject} obj Object to test against
	* @param {Object} [pointer] point in scene coordinates
	* @return {Boolean} true if point is contained within an area of given object
	* @private
	*/ _pointIsInObjectSelectionArea(obj, point) {
        let coords = obj.getCoords();
        const viewportZoom = this.getZoom();
        const padding = obj.padding / viewportZoom;
        if (padding) {
            const [tl, tr, br, bl] = coords;
            const angleRadians = Math.atan2(tr.y - tl.y, tr.x - tl.x), cosP = $9a54cbcfc1af41ba$var$cos(angleRadians) * padding, sinP = $9a54cbcfc1af41ba$var$sin(angleRadians) * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP;
            coords = [
                new $9a54cbcfc1af41ba$export$baf26146a414f24a(tl.x - cosPMinusSinP, tl.y - cosPSinP),
                new $9a54cbcfc1af41ba$export$baf26146a414f24a(tr.x + cosPSinP, tr.y - cosPMinusSinP),
                new $9a54cbcfc1af41ba$export$baf26146a414f24a(br.x + cosPMinusSinP, br.y + cosPSinP),
                new $9a54cbcfc1af41ba$export$baf26146a414f24a(bl.x - cosPSinP, bl.y + cosPMinusSinP)
            ];
        }
        return $9a54cbcfc1af41ba$export$869c896bf338bf5a.isPointInPolygon(point, coords);
    }
    /**
	* Checks point is inside the object selection condition. Either area with padding
	* or over pixels if perPixelTargetFind is enabled
	* @param {FabricObject} obj Object to test against
	* @param {Point} pointer point from scene.
	* @return {Boolean} true if point is contained within an area of given object
	* @private
	*/ _checkTarget(obj, pointer) {
        if (obj && obj.visible && obj.evented && this._pointIsInObjectSelectionArea(obj, pointer)) {
            if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
                const viewportPoint = pointer.transform(this.viewportTransform);
                if (!this.isTargetTransparent(obj, viewportPoint.x, viewportPoint.y)) return true;
            } else return true;
        }
        return false;
    }
    /**
	* Given an array of objects search possible targets under the pointer position
	* Returns an
	* @param {Array} objects objects array to look into
	* @param {Object} pointer x,y object of point of scene coordinates we want to check.
	* @param {Object} subTargets If passed, subtargets will be collected inside the array
	* @return {TargetsInfo} **top most object from given `objects`** that contains pointer
	* @private
	*/ _searchPossibleTargets(objects, pointer, subTargets) {
        let i = objects.length;
        while(i--){
            const target = objects[i];
            if (this._checkTarget(target, pointer)) {
                if ($9a54cbcfc1af41ba$var$isCollection(target) && target.subTargetCheck) {
                    const { target: subTarget } = this._searchPossibleTargets(target._objects, pointer, subTargets);
                    subTarget && subTargets.push(subTarget);
                }
                return {
                    target: target,
                    subTargets: subTargets
                };
            }
        }
        return {
            subTargets: []
        };
    }
    /**
	* Search inside an objects array the fiurst object that contains pointer
	* Collect subTargets of that object inside the subTargets array passed as parameter
	* @param {FabricObject[]} objects objects array to look into
	* @param {Point} pointer coordinates from viewport to check.
	* @return {FabricObject} **top most object on screen** that contains pointer
	*/ searchPossibleTargets(objects, pointer) {
        const targetInfo = this._searchPossibleTargets(objects, pointer, []);
        targetInfo.container = targetInfo.target;
        const { container: container, subTargets: subTargets } = targetInfo;
        if (container && $9a54cbcfc1af41ba$var$isCollection(container) && container.interactive && subTargets[0]) {
            /** subTargets[0] is the innermost nested target, but it could be inside non interactive groups
			* and so not a possible selection target.
			* We loop the array from the end that is outermost innertarget.
			*/ for(let i = subTargets.length - 1; i > 0; i--){
                const t = subTargets[i];
                if (!($9a54cbcfc1af41ba$var$isCollection(t) && t.interactive)) {
                    targetInfo.target = t;
                    return targetInfo;
                }
            }
            targetInfo.target = subTargets[0];
            return targetInfo;
        }
        return targetInfo;
    }
    /**
	* @returns point existing in the same plane as the {@link HTMLCanvasElement},
	* `(0, 0)` being the top left corner of the {@link HTMLCanvasElement}.
	* This means that changes to the {@link viewportTransform} do not change the values of the point
	* and it remains unchanged from the viewer's perspective.
	*
	* @example
	* const scenePoint = sendPointToPlane(
	*  this.getViewportPoint(e),
	*  undefined,
	*  canvas.viewportTransform
	* );
	*
	*/ getViewportPoint(e) {
        if (this._viewportPoint) return this._viewportPoint;
        return this._getPointerImpl(e, true);
    }
    /**
	* @returns point existing in the scene (the same plane as the plane {@link FabricObject#getCenterPoint} exists in).
	* This means that changes to the {@link viewportTransform} do not change the values of the point,
	* however, from the viewer's perspective, the point is changed.
	*
	* @example
	* const viewportPoint = sendPointToPlane(
	*  this.getScenePoint(e),
	*  canvas.viewportTransform
	* );
	*
	*/ getScenePoint(e) {
        if (this._scenePoint) return this._scenePoint;
        return this._getPointerImpl(e);
    }
    /**
	* Returns pointer relative to canvas.
	*
	* Use {@link getViewportPoint} or {@link getScenePoint} instead.
	*
	* @param {Event} e
	* @param {Boolean} [fromViewport] whether to return the point from the viewport or in the scene
	* @return {Point}
	*/ _getPointerImpl(e, fromViewport = false) {
        const upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect();
        let pointer = $9a54cbcfc1af41ba$var$getPointer(e), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0;
        if (!boundsWidth || !boundsHeight) {
            if ("top" in bounds && "bottom" in bounds) boundsHeight = Math.abs(bounds.top - bounds.bottom);
            if ("right" in bounds && "left" in bounds) boundsWidth = Math.abs(bounds.right - bounds.left);
        }
        this.calcOffset();
        pointer.x = pointer.x - this._offset.left;
        pointer.y = pointer.y - this._offset.top;
        if (!fromViewport) pointer = $9a54cbcfc1af41ba$var$sendPointToPlane(pointer, void 0, this.viewportTransform);
        const retinaScaling = this.getRetinaScaling();
        if (retinaScaling !== 1) {
            pointer.x /= retinaScaling;
            pointer.y /= retinaScaling;
        }
        const cssScale = boundsWidth === 0 || boundsHeight === 0 ? new $9a54cbcfc1af41ba$export$baf26146a414f24a(1, 1) : new $9a54cbcfc1af41ba$export$baf26146a414f24a(upperCanvasEl.width / boundsWidth, upperCanvasEl.height / boundsHeight);
        return pointer.multiply(cssScale);
    }
    /**
	* Internal use only
	* @protected
	*/ _setDimensionsImpl(dimensions, options) {
        this._resetTransformEventData();
        super._setDimensionsImpl(dimensions, options);
        if (this._isCurrentlyDrawing) this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
    }
    _createCacheCanvas() {
        this.pixelFindCanvasEl = $9a54cbcfc1af41ba$var$createCanvasElement();
        this.pixelFindContext = this.pixelFindCanvasEl.getContext("2d", {
            willReadFrequently: true
        });
        this.setTargetFindTolerance(this.targetFindTolerance);
    }
    /**
	* Returns context of top canvas where interactions are drawn
	* @returns {CanvasRenderingContext2D}
	*/ getTopContext() {
        return this.elements.upper.ctx;
    }
    /**
	* Returns context of canvas where object selection is drawn
	* @alias
	* @return {CanvasRenderingContext2D}
	*/ getSelectionContext() {
        return this.elements.upper.ctx;
    }
    /**
	* Returns &lt;canvas> element on which object selection is drawn
	* @return {HTMLCanvasElement}
	*/ getSelectionElement() {
        return this.elements.upper.el;
    }
    /**
	* Returns currently active object
	* @return {FabricObject | null} active object
	*/ getActiveObject() {
        return this._activeObject;
    }
    /**
	* Returns an array with the current selected objects
	* @return {FabricObject[]} active objects array
	*/ getActiveObjects() {
        const active = this._activeObject;
        return $9a54cbcfc1af41ba$var$isActiveSelection(active) ? active.getObjects() : active ? [
            active
        ] : [];
    }
    /**
	* @private
	* Compares the old activeObject with the current one and fires correct events
	* @param {FabricObject[]} oldObjects old activeObject
	* @param {TPointerEvent} e mouse event triggering the selection events
	*/ _fireSelectionEvents(oldObjects, e) {
        let somethingChanged = false, invalidate = false;
        const objects = this.getActiveObjects(), added = [], removed = [];
        oldObjects.forEach((target)=>{
            if (!objects.includes(target)) {
                somethingChanged = true;
                target.fire("deselected", {
                    e: e,
                    target: target
                });
                removed.push(target);
            }
        });
        objects.forEach((target)=>{
            if (!oldObjects.includes(target)) {
                somethingChanged = true;
                target.fire("selected", {
                    e: e,
                    target: target
                });
                added.push(target);
            }
        });
        if (oldObjects.length > 0 && objects.length > 0) {
            invalidate = true;
            somethingChanged && this.fire("selection:updated", {
                e: e,
                selected: added,
                deselected: removed
            });
        } else if (objects.length > 0) {
            invalidate = true;
            this.fire("selection:created", {
                e: e,
                selected: added
            });
        } else if (oldObjects.length > 0) {
            invalidate = true;
            this.fire("selection:cleared", {
                e: e,
                deselected: removed
            });
        }
        invalidate && (this._objectsToRender = void 0);
    }
    /**
	* Sets given object as the only active object on canvas
	* @param {FabricObject} object Object to set as an active one
	* @param {TPointerEvent} [e] Event (passed along when firing "object:selected")
	* @return {Boolean} true if the object has been selected
	*/ setActiveObject(object, e) {
        const currentActives = this.getActiveObjects();
        const selected = this._setActiveObject(object, e);
        this._fireSelectionEvents(currentActives, e);
        return selected;
    }
    /**
	* This is supposed to be equivalent to setActiveObject but without firing
	* any event. There is commitment to have this stay this way.
	* This is the functional part of setActiveObject.
	* @param {Object} object to set as active
	* @param {Event} [e] Event (passed along when firing "object:selected")
	* @return {Boolean} true if the object has been selected
	*/ _setActiveObject(object, e) {
        const prevActiveObject = this._activeObject;
        if (prevActiveObject === object) return false;
        if (!this._discardActiveObject(e, object) && this._activeObject) return false;
        if (object.onSelect({
            e: e
        })) return false;
        this._activeObject = object;
        if ($9a54cbcfc1af41ba$var$isActiveSelection(object) && prevActiveObject !== object) object.set("canvas", this);
        object.setCoords();
        return true;
    }
    /**
	* This is supposed to be equivalent to discardActiveObject but without firing
	* any selection events ( can still fire object transformation events ). There is commitment to have this stay this way.
	* This is the functional part of discardActiveObject.
	* @param {Event} [e] Event (passed along when firing "object:deselected")
	* @param {Object} object the next object to set as active, reason why we are discarding this
	* @return {Boolean} true if the active object has been discarded
	*/ _discardActiveObject(e, object) {
        const obj = this._activeObject;
        if (obj) {
            if (obj.onDeselect({
                e: e,
                object: object
            })) return false;
            if (this._currentTransform && this._currentTransform.target === obj) this.endCurrentTransform(e);
            if ($9a54cbcfc1af41ba$var$isActiveSelection(obj) && obj === this._hoveredTarget) this._hoveredTarget = void 0;
            this._activeObject = void 0;
            return true;
        }
        return false;
    }
    /**
	* Discards currently active object and fire events. If the function is called by fabric
	* as a consequence of a mouse event, the event is passed as a parameter and
	* sent to the fire function for the custom events. When used as a method the
	* e param does not have any application.
	* @param {event} e
	* @return {Boolean} true if the active object has been discarded
	*/ discardActiveObject(e) {
        const currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
        if (currentActives.length) this.fire("before:selection:cleared", {
            e: e,
            deselected: [
                activeObject
            ]
        });
        const discarded = this._discardActiveObject(e);
        this._fireSelectionEvents(currentActives, e);
        return discarded;
    }
    /**
	* End the current transform.
	* You don't usually need to call this method unless you are interrupting a user initiated transform
	* because of some other event ( a press of key combination, or something that block the user UX )
	* @param {Event} [e] send the mouse event that generate the finalize down, so it can be used in the event
	*/ endCurrentTransform(e) {
        const transform = this._currentTransform;
        this._finalizeCurrentTransform(e);
        if (transform && transform.target) transform.target.isMoving = false;
        this._currentTransform = null;
    }
    /**
	* @private
	* @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
	*/ _finalizeCurrentTransform(e) {
        const transform = this._currentTransform, target = transform.target, options = {
            e: e,
            target: target,
            transform: transform,
            action: transform.action
        };
        if (target._scaling) target._scaling = false;
        target.setCoords();
        if (transform.actionPerformed) {
            this.fire("object:modified", options);
            target.fire($9a54cbcfc1af41ba$var$MODIFIED, options);
        }
    }
    /**
	* Sets viewport transformation of this canvas instance
	* @param {Array} vpt a Canvas 2D API transform matrix
	*/ setViewportTransform(vpt) {
        super.setViewportTransform(vpt);
        const activeObject = this._activeObject;
        if (activeObject) activeObject.setCoords();
    }
    /**
	* @override clears active selection ref and interactive canvas elements and contexts
	*/ destroy() {
        const activeObject = this._activeObject;
        if ($9a54cbcfc1af41ba$var$isActiveSelection(activeObject)) {
            activeObject.removeAll();
            activeObject.dispose();
        }
        delete this._activeObject;
        super.destroy();
        this.pixelFindContext = null;
        this.pixelFindCanvasEl = void 0;
    }
    /**
	* Clears all contexts (background, main, top) of an instance
	*/ clear() {
        this.discardActiveObject();
        this._activeObject = void 0;
        this.clearContext(this.contextTop);
        super.clear();
    }
    /**
	* Draws objects' controls (borders/controls)
	* @param {CanvasRenderingContext2D} ctx Context to render controls on
	*/ drawControls(ctx) {
        const activeObject = this._activeObject;
        if (activeObject) activeObject._renderControls(ctx);
    }
    /**
	* @private
	*/ _toObject(instance, methodName, propertiesToInclude) {
        const originalProperties = this._realizeGroupTransformOnObject(instance), object = super._toObject(instance, methodName, propertiesToInclude);
        instance.set(originalProperties);
        return object;
    }
    /**
	* Realizes an object's group transformation on it
	* @private
	* @param {FabricObject} [instance] the object to transform (gets mutated)
	* @returns the original values of instance which were changed
	*/ _realizeGroupTransformOnObject(instance) {
        const { group: group } = instance;
        if (group && $9a54cbcfc1af41ba$var$isActiveSelection(group) && this._activeObject === group) {
            const originalValues = $9a54cbcfc1af41ba$var$pick(instance, [
                "angle",
                "flipX",
                "flipY",
                $9a54cbcfc1af41ba$var$LEFT,
                $9a54cbcfc1af41ba$var$SCALE_X,
                $9a54cbcfc1af41ba$var$SCALE_Y,
                $9a54cbcfc1af41ba$var$SKEW_X,
                $9a54cbcfc1af41ba$var$SKEW_Y,
                "top"
            ]);
            $9a54cbcfc1af41ba$var$addTransformToObject(instance, group.calcOwnMatrix());
            return originalValues;
        } else return {};
    }
    /**
	* @private
	*/ _setSVGObject(markup, instance, reviver) {
        const originalProperties = this._realizeGroupTransformOnObject(instance);
        super._setSVGObject(markup, instance, reviver);
        instance.set(originalProperties);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$SelectableCanvas, "ownDefaults", $9a54cbcfc1af41ba$var$canvasDefaults);
//#endregion
//#region src/canvas/TextEditingManager.ts
/**
* In charge of synchronizing all interactive text instances of a canvas
*/ var $9a54cbcfc1af41ba$var$TextEditingManager = class {
    constructor(canvas){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "targets", []);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__disposer", void 0);
        const cb = ()=>{
            const { hiddenTextarea: hiddenTextarea } = canvas.getActiveObject() || {};
            hiddenTextarea && hiddenTextarea.focus();
        };
        const el = canvas.upperCanvasEl;
        el.addEventListener("click", cb);
        this.__disposer = ()=>el.removeEventListener("click", cb);
    }
    exitTextEditing() {
        this.target = void 0;
        this.targets.forEach((target)=>{
            if (target.isEditing) target.exitEditing();
        });
    }
    add(target) {
        this.targets.push(target);
    }
    remove(target) {
        this.unregister(target);
        $9a54cbcfc1af41ba$var$removeFromArray(this.targets, target);
    }
    register(target) {
        this.target = target;
    }
    unregister(target) {
        if (target === this.target) this.target = void 0;
    }
    onMouseMove(e) {
        var _this$target;
        !((_this$target = this.target) === null || _this$target === void 0) && _this$target.isEditing && this.target.updateSelectionOnMouseMove(e);
    }
    clear() {
        this.targets = [];
        this.target = void 0;
    }
    dispose() {
        this.clear();
        this.__disposer();
        delete this.__disposer;
    }
};
//#endregion
//#region src/canvas/Canvas.ts
const $9a54cbcfc1af41ba$var$addEventOptions = {
    passive: false
};
const $9a54cbcfc1af41ba$var$getEventPoints = (canvas, e)=>{
    return {
        viewportPoint: canvas.getViewportPoint(e),
        scenePoint: canvas.getScenePoint(e)
    };
};
const $9a54cbcfc1af41ba$var$addListener = (el, ...args)=>el.addEventListener(...args);
const $9a54cbcfc1af41ba$var$removeListener = (el, ...args)=>el.removeEventListener(...args);
const $9a54cbcfc1af41ba$var$syntheticEventConfig = {
    mouse: {
        in: "over",
        out: "out",
        targetIn: "mouseover",
        targetOut: "mouseout",
        canvasIn: "mouse:over",
        canvasOut: "mouse:out"
    },
    drag: {
        in: "enter",
        out: "leave",
        targetIn: "dragenter",
        targetOut: "dragleave",
        canvasIn: "drag:enter",
        canvasOut: "drag:leave"
    }
};
var $9a54cbcfc1af41ba$export$8d01c972ee8b14a9 = class extends $9a54cbcfc1af41ba$var$SelectableCanvas {
    constructor(el, options = {}){
        super(el, options);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_isClick", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "textEditingManager", new $9a54cbcfc1af41ba$var$TextEditingManager(this));
        [
            "_onMouseDown",
            "_onTouchStart",
            "_onMouseMove",
            "_onMouseUp",
            "_onTouchEnd",
            "_onResize",
            "_onMouseWheel",
            "_onMouseOut",
            "_onMouseEnter",
            "_onContextMenu",
            "_onClick",
            "_onDragStart",
            "_onDragEnd",
            "_onDragProgress",
            "_onDragOver",
            "_onDragEnter",
            "_onDragLeave",
            "_onDrop"
        ].forEach((eventHandler)=>{
            this[eventHandler] = this[eventHandler].bind(this);
        });
        this.addOrRemove($9a54cbcfc1af41ba$var$addListener);
    }
    /**
	* return an event prefix pointer or mouse.
	* @private
	*/ _getEventPrefix() {
        return this.enablePointerEvents ? "pointer" : "mouse";
    }
    addOrRemove(functor, forTouch = false) {
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        functor($9a54cbcfc1af41ba$var$getWindowFromElement(canvasElement), "resize", this._onResize);
        functor(canvasElement, eventTypePrefix + "down", this._onMouseDown);
        functor(canvasElement, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        functor(canvasElement, `${eventTypePrefix}out`, this._onMouseOut);
        functor(canvasElement, `${eventTypePrefix}enter`, this._onMouseEnter);
        functor(canvasElement, "wheel", this._onMouseWheel, {
            passive: false
        });
        functor(canvasElement, "contextmenu", this._onContextMenu);
        if (!forTouch) {
            functor(canvasElement, "click", this._onClick);
            functor(canvasElement, "dblclick", this._onClick);
        }
        functor(canvasElement, "dragstart", this._onDragStart);
        functor(canvasElement, "dragend", this._onDragEnd);
        functor(canvasElement, "dragover", this._onDragOver);
        functor(canvasElement, "dragenter", this._onDragEnter);
        functor(canvasElement, "dragleave", this._onDragLeave);
        functor(canvasElement, "drop", this._onDrop);
        if (!this.enablePointerEvents) functor(canvasElement, "touchstart", this._onTouchStart, $9a54cbcfc1af41ba$var$addEventOptions);
    }
    /**
	* Removes all event listeners, used when disposing the instance
	*/ removeListeners() {
        this.addOrRemove($9a54cbcfc1af41ba$var$removeListener);
        const eventTypePrefix = this._getEventPrefix();
        const doc = $9a54cbcfc1af41ba$var$getDocumentFromElement(this.upperCanvasEl);
        $9a54cbcfc1af41ba$var$removeListener(doc, `${eventTypePrefix}up`, this._onMouseUp);
        $9a54cbcfc1af41ba$var$removeListener(doc, "touchend", this._onTouchEnd, $9a54cbcfc1af41ba$var$addEventOptions);
        $9a54cbcfc1af41ba$var$removeListener(doc, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        $9a54cbcfc1af41ba$var$removeListener(doc, "touchmove", this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        clearTimeout(this._willAddMouseDown);
    }
    /**
	* @private
	* @param {Event} [e] Event object fired on wheel event
	*/ _onMouseWheel(e) {
        this._cacheTransformEventData(e);
        this._handleEvent(e, "wheel");
        this._resetTransformEventData();
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onMouseOut(e) {
        const target = this._hoveredTarget;
        const shared = {
            e: e,
            ...$9a54cbcfc1af41ba$var$getEventPoints(this, e)
        };
        this.fire("mouse:out", {
            ...shared,
            target: target
        });
        this._hoveredTarget = void 0;
        target && target.fire("mouseout", {
            ...shared
        });
        this._hoveredTargets.forEach((nestedTarget)=>{
            this.fire("mouse:out", {
                ...shared,
                target: nestedTarget
            });
            nestedTarget && nestedTarget.fire("mouseout", {
                ...shared
            });
        });
        this._hoveredTargets = [];
    }
    /**
	* @private
	* Used when the mouse cursor enter the canvas from outside
	* @param {Event} e Event object fired on mouseenter
	*/ _onMouseEnter(e) {
        const { target: target } = this.findTarget(e);
        if (!this._currentTransform && !target) {
            this.fire("mouse:over", {
                e: e,
                ...$9a54cbcfc1af41ba$var$getEventPoints(this, e)
            });
            this._hoveredTarget = void 0;
            this._hoveredTargets = [];
        }
    }
    /**
	* supports native like text dragging
	* @private
	* @param {DragEvent} e
	*/ _onDragStart(e) {
        this._isClick = false;
        const activeObject = this.getActiveObject();
        if (activeObject && activeObject.onDragStart(e)) {
            this._dragSource = activeObject;
            const options = {
                e: e,
                target: activeObject
            };
            this.fire("dragstart", options);
            activeObject.fire("dragstart", options);
            $9a54cbcfc1af41ba$var$addListener(this.upperCanvasEl, "drag", this._onDragProgress);
            return;
        }
        $9a54cbcfc1af41ba$var$stopEvent(e);
    }
    /**
	* First we clear top context where the effects are being rendered.
	* Then we render the effects.
	* Doing so will render the correct effect for all cases including an overlap between `source` and `target`.
	* @private
	*/ _renderDragEffects(e, source, target) {
        let dirty = false;
        const dropTarget = this._dropTarget;
        if (dropTarget && dropTarget !== source && dropTarget !== target) {
            dropTarget.clearContextTop();
            dirty = true;
        }
        source === null || source === void 0 || source.clearContextTop();
        target !== source && (target === null || target === void 0 || target.clearContextTop());
        const ctx = this.contextTop;
        ctx.save();
        ctx.transform(...this.viewportTransform);
        if (source) {
            ctx.save();
            source.transform(ctx);
            source.renderDragSourceEffect(e);
            ctx.restore();
            dirty = true;
        }
        if (target) {
            ctx.save();
            target.transform(ctx);
            target.renderDropTargetEffect(e);
            ctx.restore();
            dirty = true;
        }
        ctx.restore();
        dirty && (this.contextTopDirty = true);
    }
    /**
	* supports native like text dragging
	* https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
	* @private
	* @param {DragEvent} e
	*/ _onDragEnd(e) {
        const { currentSubTargets: currentSubTargets } = this.findTarget(e);
        const didDrop = !!e.dataTransfer && e.dataTransfer.dropEffect !== "none", dropTarget = didDrop ? this._activeObject : void 0, options = {
            e: e,
            target: this._dragSource,
            subTargets: currentSubTargets,
            dragSource: this._dragSource,
            didDrop: didDrop,
            dropTarget: dropTarget
        };
        $9a54cbcfc1af41ba$var$removeListener(this.upperCanvasEl, "drag", this._onDragProgress);
        this.fire("dragend", options);
        this._dragSource && this._dragSource.fire("dragend", options);
        delete this._dragSource;
        this._onMouseUp(e);
    }
    /**
	* fire `drag` event on canvas and drag source
	* @private
	* @param {DragEvent} e
	*/ _onDragProgress(e) {
        const options = {
            e: e,
            target: this._dragSource,
            dragSource: this._dragSource,
            dropTarget: this._draggedoverTarget
        };
        this.fire("drag", options);
        this._dragSource && this._dragSource.fire("drag", options);
    }
    /**
	* prevent default to allow drop event to be fired
	* https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#specifying_drop_targets
	* @private
	* @param {DragEvent} [e] Event object fired on Event.js shake
	*/ _onDragOver(e) {
        const eventType = "dragover";
        const { currentContainer: target, currentSubTargets: currentSubTargets } = this.findTarget(e);
        const dragSource = this._dragSource;
        const options = {
            e: e,
            target: target,
            subTargets: currentSubTargets,
            dragSource: dragSource,
            canDrop: false,
            dropTarget: void 0
        };
        let dropTarget;
        this.fire(eventType, options);
        this._fireEnterLeaveEvents(e, target, options);
        if (target) {
            if (target.canDrop(e)) dropTarget = target;
            target.fire(eventType, options);
        }
        for(let i = 0; i < currentSubTargets.length; i++){
            const subTarget = currentSubTargets[i];
            if (subTarget.canDrop(e)) dropTarget = subTarget;
            subTarget.fire(eventType, options);
        }
        this._renderDragEffects(e, dragSource, dropTarget);
        this._dropTarget = dropTarget;
    }
    /**
	* fire `dragleave` on `dragover` targets
	* @private
	* @param {Event} [e] Event object fired on Event.js shake
	*/ _onDragEnter(e) {
        const { currentContainer: currentContainer, currentSubTargets: currentSubTargets } = this.findTarget(e);
        const options = {
            e: e,
            target: currentContainer,
            subTargets: currentSubTargets,
            dragSource: this._dragSource
        };
        this.fire("dragenter", options);
        this._fireEnterLeaveEvents(e, currentContainer, options);
    }
    /**
	* fire `dragleave` on `dragover` targets
	* @private
	* @param {Event} [e] Event object fired on Event.js shake
	*/ _onDragLeave(e) {
        const { currentSubTargets: currentSubTargets } = this.findTarget(e);
        const options = {
            e: e,
            target: this._draggedoverTarget,
            subTargets: currentSubTargets,
            dragSource: this._dragSource
        };
        this.fire("dragleave", options);
        this._fireEnterLeaveEvents(e, void 0, options);
        this._renderDragEffects(e, this._dragSource);
        this._dropTarget = void 0;
        this._hoveredTargets = [];
    }
    /**
	* `drop:before` is a an event that allows you to schedule logic
	* before the `drop` event. Prefer `drop` event always, but if you need
	* to run some drop-disabling logic on an event, since there is no way
	* to handle event handlers ordering, use `drop:before`
	* @private
	* @param {Event} e
	*/ _onDrop(e) {
        const { currentContainer: currentContainer, currentSubTargets: currentSubTargets } = this.findTarget(e);
        const options = this._basicEventHandler("drop:before", {
            e: e,
            target: currentContainer,
            subTargets: currentSubTargets,
            dragSource: this._dragSource,
            ...$9a54cbcfc1af41ba$var$getEventPoints(this, e)
        });
        options.didDrop = false;
        options.dropTarget = void 0;
        this._basicEventHandler("drop", options);
        this.fire("drop:after", options);
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onContextMenu(e) {
        const { target: target, subTargets: subTargets } = this.findTarget(e);
        const options = this._basicEventHandler("contextmenu:before", {
            e: e,
            target: target,
            subTargets: subTargets
        });
        this.stopContextMenu && $9a54cbcfc1af41ba$var$stopEvent(e);
        this._basicEventHandler("contextmenu", options);
        return false;
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onClick(e) {
        const clicks = e.detail;
        if (clicks > 3 || clicks < 2) return;
        this._cacheTransformEventData(e);
        clicks == 2 && e.type === "dblclick" && this._handleEvent(e, "dblclick");
        clicks == 3 && this._handleEvent(e, "tripleclick");
        this._resetTransformEventData();
    }
    /**
	* This supports gesture event firing
	* It is a method to keep some code organized, it exposes private methods
	* in a way that works and still keep them private
	* This is supposed to mirror _handleEvent
	*/ fireEventFromPointerEvent(e, eventName, secondaryName, extraData = {}) {
        this._cacheTransformEventData(e);
        const { target: target, subTargets: subTargets } = this.findTarget(e), options = {
            e: e,
            target: target,
            subTargets: subTargets,
            ...$9a54cbcfc1af41ba$var$getEventPoints(this, e),
            transform: this._currentTransform,
            ...extraData
        };
        this.fire(eventName, options);
        target && target.fire(secondaryName, options);
        for(let i = 0; i < subTargets.length; i++)subTargets[i] !== target && subTargets[i].fire(secondaryName, options);
        this._resetTransformEventData();
    }
    /**
	* Return a the id of an event.
	* returns either the pointerId or the identifier or 0 for the mouse event
	* @private
	* @param {Event} evt Event object
	*/ getPointerId(evt) {
        const changedTouches = evt.changedTouches;
        if (changedTouches) return changedTouches[0] && changedTouches[0].identifier;
        if (this.enablePointerEvents) return evt.pointerId;
        return -1;
    }
    /**
	* Determines if an event has the id of the event that is considered main
	* @private
	* @param {evt} event Event object
	*/ _isMainEvent(evt) {
        if (evt.isPrimary === true) return true;
        if (evt.isPrimary === false) return false;
        if (evt.type === "touchend" && evt.touches.length === 0) return true;
        if (evt.changedTouches) return evt.changedTouches[0].identifier === this.mainTouchId;
        return true;
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onTouchStart(e) {
        this._cacheTransformEventData(e);
        let shouldPreventScrolling = !this.allowTouchScrolling;
        const currentActiveObject = this._activeObject;
        if (this.mainTouchId === void 0) this.mainTouchId = this.getPointerId(e);
        this.__onMouseDown(e);
        const { target: target } = this.findTarget(e);
        if (this.isDrawingMode || currentActiveObject && target === currentActiveObject) shouldPreventScrolling = true;
        shouldPreventScrolling && e.preventDefault();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        const doc = $9a54cbcfc1af41ba$var$getDocumentFromElement(canvasElement);
        $9a54cbcfc1af41ba$var$addListener(doc, "touchend", this._onTouchEnd, $9a54cbcfc1af41ba$var$addEventOptions);
        shouldPreventScrolling && $9a54cbcfc1af41ba$var$addListener(doc, "touchmove", this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        $9a54cbcfc1af41ba$var$removeListener(canvasElement, `${eventTypePrefix}down`, this._onMouseDown);
        this._resetTransformEventData();
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onMouseDown(e) {
        this._cacheTransformEventData(e);
        this.__onMouseDown(e);
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        $9a54cbcfc1af41ba$var$removeListener(canvasElement, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        const doc = $9a54cbcfc1af41ba$var$getDocumentFromElement(canvasElement);
        $9a54cbcfc1af41ba$var$addListener(doc, `${eventTypePrefix}up`, this._onMouseUp);
        $9a54cbcfc1af41ba$var$addListener(doc, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        this._resetTransformEventData();
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onTouchEnd(e) {
        if (e.touches.length > 0) return;
        this._cacheTransformEventData(e);
        this.__onMouseUp(e);
        this._resetTransformEventData();
        delete this.mainTouchId;
        const eventTypePrefix = this._getEventPrefix();
        const doc = $9a54cbcfc1af41ba$var$getDocumentFromElement(this.upperCanvasEl);
        $9a54cbcfc1af41ba$var$removeListener(doc, "touchend", this._onTouchEnd, $9a54cbcfc1af41ba$var$addEventOptions);
        $9a54cbcfc1af41ba$var$removeListener(doc, "touchmove", this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        if (this._willAddMouseDown) clearTimeout(this._willAddMouseDown);
        this._willAddMouseDown = setTimeout(()=>{
            $9a54cbcfc1af41ba$var$addListener(this.upperCanvasEl, `${eventTypePrefix}down`, this._onMouseDown);
            this._willAddMouseDown = 0;
        }, 400);
    }
    /**
	* @private
	* @param {Event} e Event object fired on mouseup
	*/ _onMouseUp(e) {
        this._cacheTransformEventData(e);
        this.__onMouseUp(e);
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        if (this._isMainEvent(e)) {
            const doc = $9a54cbcfc1af41ba$var$getDocumentFromElement(this.upperCanvasEl);
            $9a54cbcfc1af41ba$var$removeListener(doc, `${eventTypePrefix}up`, this._onMouseUp);
            $9a54cbcfc1af41ba$var$removeListener(doc, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
            $9a54cbcfc1af41ba$var$addListener(canvasElement, `${eventTypePrefix}move`, this._onMouseMove, $9a54cbcfc1af41ba$var$addEventOptions);
        }
        this._resetTransformEventData();
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousemove
	*/ _onMouseMove(e) {
        this._cacheTransformEventData(e);
        const activeObject = this.getActiveObject();
        !this.allowTouchScrolling && (!activeObject || !activeObject.shouldStartDragging(e)) && e.preventDefault && e.preventDefault();
        this.__onMouseMove(e);
        this._resetTransformEventData();
    }
    /**
	* @private
	*/ _onResize() {
        this.calcOffset();
        this._resetTransformEventData();
    }
    /**
	* Decides whether the canvas should be redrawn in mouseup and mousedown events.
	* @private
	* @param {Object} target
	*/ _shouldRender(target) {
        const activeObject = this.getActiveObject();
        return !!activeObject !== !!target || activeObject && target && activeObject !== target;
    }
    /**
	* Method that defines the actions when mouse is released on canvas.
	* The method resets the currentTransform parameters, store the image corner
	* position in the image object and render the canvas on top.
	* @private
	* @param {Event} e Event object fired on mouseup
	*/ __onMouseUp(e) {
        var _this$_activeObject;
        this._handleEvent(e, "up:before");
        const transform = this._currentTransform;
        const isClick = this._isClick;
        const { target: target } = this.findTarget(e);
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, "up");
            return;
        }
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this._onMouseUpInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        let shouldRender = false;
        if (transform) {
            this._finalizeCurrentTransform(e);
            shouldRender = transform.actionPerformed;
        }
        if (!isClick) {
            const targetWasActive = target === this._activeObject;
            this.handleSelection(e);
            if (!shouldRender) shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
        }
        let pointer, corner;
        if (target) {
            const { key: key, control: control } = target.findControl(this.getViewportPoint(e), $9a54cbcfc1af41ba$var$isTouchEvent(e)) || {};
            corner = key;
            if (target.selectable && target !== this._activeObject && target.activeOn === "up") {
                this.setActiveObject(target, e);
                shouldRender = true;
            } else if (control) {
                const mouseUpHandler = control.getMouseUpHandler(e, target, control);
                if (mouseUpHandler) {
                    pointer = this.getScenePoint(e);
                    mouseUpHandler.call(control, e, transform, pointer.x, pointer.y);
                }
            }
            target.isMoving = false;
        }
        if (transform && (transform.target !== target || transform.corner !== corner)) {
            const originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, transform.target, originalControl);
            pointer = pointer || this.getScenePoint(e);
            originalMouseUpHandler && originalMouseUpHandler.call(originalControl, e, transform, pointer.x, pointer.y);
        }
        this._setCursorFromEvent(e, target);
        this._handleEvent(e, "up");
        this._groupSelector = null;
        this._currentTransform = null;
        target && (target.__corner = void 0);
        if (shouldRender) this.requestRenderAll();
        else if (!isClick && !((_this$_activeObject = this._activeObject) === null || _this$_activeObject === void 0 ? void 0 : _this$_activeObject.isEditing)) this.renderTop();
    }
    _basicEventHandler(eventType, options) {
        const { target: target, subTargets: subTargets = [] } = options;
        this.fire(eventType, options);
        target && target.fire(eventType, options);
        for(let i = 0; i < subTargets.length; i++)subTargets[i] !== target && subTargets[i].fire(eventType, options);
        return options;
    }
    /**
	* @private
	* Handle event firing for target and subtargets
	* @param {TPointerEvent} e event from mouse
	* @param {TPointerEventNames} eventType
	*/ _handleEvent(e, eventType, extraData) {
        const { target: target, subTargets: subTargets } = this.findTarget(e), options = {
            e: e,
            target: target,
            subTargets: subTargets,
            ...$9a54cbcfc1af41ba$var$getEventPoints(this, e),
            transform: this._currentTransform,
            ...eventType === "down:before" || eventType === "down" ? extraData : {}
        };
        if (eventType === "up:before" || eventType === "up") options.isClick = this._isClick;
        this.fire(`mouse:${eventType}`, options);
        target && target.fire(`mouse${eventType}`, options);
        for(let i = 0; i < subTargets.length; i++)subTargets[i] !== target && subTargets[i].fire(`mouse${eventType}`, options);
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ _onMouseDownInDrawingMode(e) {
        this._isCurrentlyDrawing = true;
        if (this.getActiveObject()) {
            this.discardActiveObject(e);
            this.requestRenderAll();
        }
        const pointer = this.getScenePoint(e);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(pointer, {
            e: e,
            pointer: pointer
        });
        this._handleEvent(e, "down", {
            alreadySelected: false
        });
    }
    /**
	* @private
	* @param {Event} e Event object fired on mousemove
	*/ _onMouseMoveInDrawingMode(e) {
        if (this._isCurrentlyDrawing) {
            const pointer = this.getScenePoint(e);
            this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(pointer, {
                e: e,
                pointer: pointer
            });
        }
        this.setCursor(this.freeDrawingCursor);
        this._handleEvent(e, "move");
    }
    /**
	* @private
	* @param {Event} e Event object fired on mouseup
	*/ _onMouseUpInDrawingMode(e) {
        const pointer = this.getScenePoint(e);
        if (this.freeDrawingBrush) this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({
            e: e,
            pointer: pointer
        });
        else this._isCurrentlyDrawing = false;
        this._handleEvent(e, "up");
    }
    /**
	* Method that defines the actions when mouse is clicked on canvas.
	* The method inits the currentTransform parameters and renders all the
	* canvas so the current image can be placed on the top canvas and the rest
	* in on the container one.
	* @private
	* @param {Event} e Event object fired on mousedown
	*/ __onMouseDown(e) {
        this._isClick = true;
        this._handleEvent(e, "down:before");
        let { target: target } = this.findTarget(e);
        let alreadySelected = !!target && target === this._activeObject;
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, "down", {
                alreadySelected: alreadySelected
            });
            return;
        }
        if (this.isDrawingMode) {
            this._onMouseDownInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        if (this._currentTransform) return;
        let shouldRender = this._shouldRender(target);
        let grouped = false;
        if (this.handleMultiSelection(e, target)) {
            target = this._activeObject;
            grouped = true;
            shouldRender = true;
        } else if (this._shouldClearSelection(e, target)) this.discardActiveObject(e);
        if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
            const p = this.getScenePoint(e);
            this._groupSelector = {
                x: p.x,
                y: p.y,
                deltaY: 0,
                deltaX: 0
            };
        }
        alreadySelected = !!target && target === this._activeObject;
        if (target) {
            if (target.selectable && target.activeOn === "down") this.setActiveObject(target, e);
            const handle = target.findControl(this.getViewportPoint(e), $9a54cbcfc1af41ba$var$isTouchEvent(e));
            if (target === this._activeObject && (handle || !grouped)) {
                this._setupCurrentTransform(e, target, alreadySelected);
                const control = handle ? handle.control : void 0, pointer = this.getScenePoint(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
                mouseDownHandler && mouseDownHandler.call(control, e, this._currentTransform, pointer.x, pointer.y);
            }
        }
        shouldRender && (this._objectsToRender = void 0);
        this._handleEvent(e, "down", {
            alreadySelected: alreadySelected
        });
        shouldRender && this.requestRenderAll();
    }
    /**
	* reset cache form common information needed during event processing
	* @private
	*/ _resetTransformEventData() {
        this._targetInfo = this._viewportPoint = this._scenePoint = void 0;
    }
    /**
	* Cache common information needed during event processing
	* @private
	* @param {Event} e Event object fired on event
	*/ _cacheTransformEventData(e) {
        this._resetTransformEventData();
        this._viewportPoint = this.getViewportPoint(e);
        this._scenePoint = $9a54cbcfc1af41ba$var$sendPointToPlane(this._viewportPoint, void 0, this.viewportTransform);
        this._targetInfo = this.findTarget(e);
        if (this._currentTransform) this._targetInfo.target = this._currentTransform.target;
    }
    /**
	* Method that defines the actions when mouse is hovering the canvas.
	* The currentTransform parameter will define whether the user is rotating/scaling/translating
	* an image or neither of them (only hovering). A group selection is also possible and would cancel
	* all any other type of action.
	* In case of an image transformation only the top canvas will be rendered.
	* @private
	* @param {Event} e Event object fired on mousemove
	*/ __onMouseMove(e) {
        this._isClick = false;
        this._handleEvent(e, "move:before");
        if (this.isDrawingMode) {
            this._onMouseMoveInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        const groupSelector = this._groupSelector;
        if (groupSelector) {
            const pointer = this.getScenePoint(e);
            groupSelector.deltaX = pointer.x - groupSelector.x;
            groupSelector.deltaY = pointer.y - groupSelector.y;
            this.renderTop();
        } else if (!this._currentTransform) {
            const { target: target } = this.findTarget(e);
            this._setCursorFromEvent(e, target);
            this._fireOverOutEvents(e, target);
        } else this._transformObject(e);
        this.textEditingManager.onMouseMove(e);
        this._handleEvent(e, "move");
    }
    /**
	* Manage the mouseout, mouseover events for the fabric object on the canvas
	* @param {Fabric.Object} target the target where the target from the mousemove event
	* @param {Event} e Event object fired on mousemove
	* @private
	*/ _fireOverOutEvents(e, target) {
        const { _hoveredTarget: _hoveredTarget, _hoveredTargets: _hoveredTargets } = this, { subTargets: subTargets, currentTarget: actualTarget } = this.findTarget(e), length = Math.max(_hoveredTargets.length, subTargets.length);
        this.fireSyntheticInOutEvents("mouse", {
            e: e,
            target: target,
            oldTarget: _hoveredTarget,
            actualTarget: actualTarget,
            oldActualTarget: this._hoveredActualTarget,
            fireCanvas: true
        });
        for(let i = 0; i < length; i++){
            if (subTargets[i] === target || _hoveredTargets[i] && _hoveredTargets[i] === _hoveredTarget) continue;
            this.fireSyntheticInOutEvents("mouse", {
                e: e,
                target: subTargets[i],
                oldTarget: _hoveredTargets[i]
            });
        }
        this._hoveredActualTarget = actualTarget;
        this._hoveredTarget = target;
        this._hoveredTargets = subTargets;
    }
    /**
	* Manage the dragEnter, dragLeave events for the fabric objects on the canvas
	* @param {Fabric.Object} target the target where the target from the onDrag event
	* @param {Object} data Event object fired on dragover
	* @private
	*/ _fireEnterLeaveEvents(e, target, data) {
        const draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, { subTargets: subTargets } = this.findTarget(e), length = Math.max(_hoveredTargets.length, subTargets.length);
        this.fireSyntheticInOutEvents("drag", {
            ...data,
            target: target,
            oldTarget: draggedoverTarget,
            fireCanvas: true
        });
        for(let i = 0; i < length; i++)this.fireSyntheticInOutEvents("drag", {
            ...data,
            target: subTargets[i],
            oldTarget: _hoveredTargets[i]
        });
        this._draggedoverTarget = target;
    }
    /**
	* Manage the synthetic in/out events for the fabric objects on the canvas
	* @param {Fabric.Object} target the target where the target from the supported events
	* @param {Object} data Event object fired
	* @param {Object} config configuration for the function to work
	* @param {String} config.targetName property on the canvas where the old target is stored
	* @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
	* @param {String} config.evtOut name of the event to fire for out
	* @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
	* @param {String} config.evtIn name of the event to fire for in
	* @private
	*/ fireSyntheticInOutEvents(type, { target: target, oldTarget: oldTarget, actualTarget: actualTarget, oldActualTarget: oldActualTarget, fireCanvas: fireCanvas, e: e, ...data }) {
        const { targetIn: targetIn, targetOut: targetOut, canvasIn: canvasIn, canvasOut: canvasOut } = $9a54cbcfc1af41ba$var$syntheticEventConfig[type];
        const targetChanged = oldTarget !== target;
        const actualTargetChanged = oldActualTarget !== actualTarget;
        const targetFires = target && targetChanged;
        const actualTargetFires = actualTarget && actualTargetChanged;
        const oldTargetFires = oldTarget && targetChanged;
        const oldActualTargetFires = oldActualTarget && actualTargetChanged;
        const commonData = {
            ...data,
            e: e,
            ...$9a54cbcfc1af41ba$var$getEventPoints(this, e)
        };
        const outOpt = {
            ...commonData,
            target: oldTarget,
            nextTarget: target,
            actualTarget: oldActualTarget,
            nextActualTarget: actualTarget
        };
        if (oldTargetFires || oldActualTargetFires) fireCanvas && this.fire(canvasOut, outOpt);
        oldTargetFires && oldTarget.fire(targetOut, outOpt);
        oldActualTargetFires && oldTarget !== oldActualTarget && oldActualTarget.fire(targetOut, outOpt);
        const inOpt = {
            ...commonData,
            target: target,
            previousTarget: oldTarget,
            actualTarget: actualTarget,
            previousActualTarget: oldActualTarget
        };
        if (targetFires || actualTargetFires) fireCanvas && this.fire(canvasIn, inOpt);
        targetFires && target.fire(targetIn, inOpt);
        actualTargetFires && actualTarget !== target && actualTarget.fire(targetIn, inOpt);
    }
    /**
	* @private
	* @param {Event} e Event fired on mousemove
	*/ _transformObject(e) {
        const scenePoint = this.getScenePoint(e), transform = this._currentTransform, target = transform.target, localPointer = target.group ? $9a54cbcfc1af41ba$var$sendPointToPlane(scenePoint, void 0, target.group.calcTransformMatrix()) : scenePoint;
        transform.shiftKey = e.shiftKey;
        transform.altKey = !!this.centeredKey && e[this.centeredKey];
        this._performTransformAction(e, transform, localPointer);
        transform.actionPerformed && this.requestRenderAll();
    }
    /**
	* @private
	*/ _performTransformAction(e, transform, pointer) {
        const { action: action, actionHandler: actionHandler, target: target } = transform;
        const actionPerformed = !!actionHandler && actionHandler(e, transform, pointer.x, pointer.y);
        actionPerformed && target.setCoords();
        if (action === "drag" && actionPerformed) {
            transform.target.isMoving = true;
            this.setCursor(transform.target.moveCursor || this.moveCursor);
        }
        transform.actionPerformed = transform.actionPerformed || actionPerformed;
    }
    /**
	* Sets the cursor depending on where the canvas is being hovered.
	* Note: very buggy in Opera
	* @param {Event} e Event object
	* @param {Object} target Object that the mouse is hovering, if so.
	*/ _setCursorFromEvent(e, target) {
        if (!target) {
            this.setCursor(this.defaultCursor);
            return;
        }
        let hoverCursor = target.hoverCursor || this.hoverCursor;
        const activeSelection = $9a54cbcfc1af41ba$var$isActiveSelection(this._activeObject) ? this._activeObject : null, corner = (!activeSelection || target.group !== activeSelection) && target.findControl(this.getViewportPoint(e));
        if (!corner) {
            if (target.subTargetCheck) {
                const { subTargets: subTargets } = this.findTarget(e);
                subTargets.concat().reverse().forEach((_target)=>{
                    hoverCursor = _target.hoverCursor || hoverCursor;
                });
            }
            this.setCursor(hoverCursor);
        } else {
            const { control: control, coord: coord } = corner;
            this.setCursor(control.cursorStyleHandler(e, control, target, coord));
        }
    }
    /**
	* ## Handles multiple selection
	* - toggles `target` selection (selects/deselects `target` if it isn't/is selected respectively)
	* - sets the active object in case it is not set or in case there is a single active object left under active selection.
	* ---
	* - If the active object is the active selection we add/remove `target` from it
	* - If not, add the active object and `target` to the active selection and make it the active object.
	* @TODO rewrite this after find target is refactored
	* @private
	* @param {TPointerEvent} e Event object
	* @param {FabricObject} target target of event to select/deselect
	* @returns true if grouping occurred
	*/ handleMultiSelection(e, target) {
        const activeObject = this._activeObject;
        const isAS = $9a54cbcfc1af41ba$var$isActiveSelection(activeObject);
        if (!!activeObject && this._isSelectionKeyPressed(e) && this.selection && !!target && target.selectable && (activeObject !== target || isAS) && (isAS || !target.isDescendantOf(activeObject) && !activeObject.isDescendantOf(target)) && !target.onSelect({
            e: e
        }) && !activeObject.getActiveControl()) {
            if (isAS) {
                const prevActiveObjects = activeObject.getObjects();
                let subTargets = [];
                if (target === activeObject) {
                    const pointer = this.getScenePoint(e);
                    let targetInfo = this.searchPossibleTargets(prevActiveObjects, pointer);
                    if (targetInfo.target) {
                        target = targetInfo.target;
                        subTargets = targetInfo.subTargets;
                    } else {
                        targetInfo = this.searchPossibleTargets(this._objects, pointer);
                        target = targetInfo.target;
                        subTargets = targetInfo.subTargets;
                    }
                    if (!target || !target.selectable) return false;
                }
                if (target.group === activeObject) {
                    activeObject.remove(target);
                    this._hoveredTarget = target;
                    this._hoveredTargets = subTargets;
                    if (activeObject.size() === 1) this._setActiveObject(activeObject.item(0), e);
                } else {
                    activeObject.multiSelectAdd(target);
                    this._hoveredTarget = activeObject;
                    this._hoveredTargets = subTargets;
                }
                this._fireSelectionEvents(prevActiveObjects, e);
            } else {
                activeObject.isEditing && activeObject.exitEditing();
                const newActiveSelection = new ($9a54cbcfc1af41ba$export$2792378e23a7920c.getClass("ActiveSelection"))([], {
                    canvas: this
                });
                newActiveSelection.multiSelectAdd(activeObject, target);
                this._hoveredTarget = newActiveSelection;
                this._setActiveObject(newActiveSelection, e);
                this._fireSelectionEvents([
                    activeObject
                ], e);
            }
            return true;
        }
        return false;
    }
    /**
	* ## Handles selection
	* - selects objects that are contained in (and possibly intersecting) the selection bounding box
	* - sets the active object
	* ---
	* runs on mouse up after a mouse move
	*/ handleSelection(e) {
        if (!this.selection || !this._groupSelector) return false;
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, point1 = new $9a54cbcfc1af41ba$export$baf26146a414f24a(x, y), point2 = point1.add(new $9a54cbcfc1af41ba$export$baf26146a414f24a(deltaX, deltaY)), tl = point1.min(point2), size = point1.max(point2).subtract(tl);
        const collectedObjects = this.collectObjects({
            left: tl.x,
            top: tl.y,
            width: size.x,
            height: size.y
        }, {
            includeIntersecting: !this.selectionFullyContained
        });
        const objects = point1.eq(point2) ? collectedObjects[0] ? [
            collectedObjects[0]
        ] : [] : collectedObjects.length > 1 ? collectedObjects.filter((object)=>!object.onSelect({
                e: e
            })).reverse() : collectedObjects;
        if (objects.length === 1) this.setActiveObject(objects[0], e);
        else if (objects.length > 1) {
            const klass = $9a54cbcfc1af41ba$export$2792378e23a7920c.getClass("ActiveSelection");
            this.setActiveObject(new klass(objects, {
                canvas: this
            }), e);
        }
        this._groupSelector = null;
        return true;
    }
    /**
	* Wraps the original toCanvasElement with a function that removes
	* the context top for the time the function is run.
	* So we avoid painting side effects on the upper canvas when exporting
	*/ toCanvasElement(multiplier = 1, options) {
        const { upper: upper } = this.elements;
        upper.ctx = void 0;
        const htmlElement = super.toCanvasElement(multiplier, options);
        upper.ctx = upper.el.getContext("2d");
        return htmlElement;
    }
    /**
	* @override clear {@link textEditingManager}
	*/ clear() {
        this.textEditingManager.clear();
        super.clear();
    }
    /**
	* @override clear {@link textEditingManager}
	*/ destroy() {
        this.removeListeners();
        this.textEditingManager.dispose();
        super.destroy();
    }
};
//#endregion
//#region src/gradient/constants.ts
const $9a54cbcfc1af41ba$var$linearDefaultCoords = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
};
const $9a54cbcfc1af41ba$var$radialDefaultCoords = {
    ...$9a54cbcfc1af41ba$var$linearDefaultCoords,
    r1: 0,
    r2: 0
};
//#endregion
//#region src/util/internals/ifNaN.ts
/**
*
* @param value value to check if NaN
* @param [valueIfNaN]
* @returns `fallback` is `value is NaN
*/ const $9a54cbcfc1af41ba$var$ifNaN = (value, valueIfNaN)=>{
    return isNaN(value) && typeof valueIfNaN === "number" ? valueIfNaN : value;
};
//#endregion
//#region src/parser/percent.ts
/**
* Will loosely accept as percent numbers that are not like
* 3.4a%. This function does not check for the correctness of a percentage
* but it checks that values that are in theory correct are or arent percentages
*/ function $9a54cbcfc1af41ba$var$isPercent(value) {
    return value && /%$/.test(value) && Number.isFinite(parseFloat(value));
}
/**
* Parse a percentage value in an svg.
* @param value
* @param fallback in case of not possible to parse the number
* @returns ∈ [0, 1]
*/ function $9a54cbcfc1af41ba$var$parsePercent(value, valueIfNaN) {
    return $9a54cbcfc1af41ba$var$capValue(0, $9a54cbcfc1af41ba$var$ifNaN(typeof value === "number" ? value : typeof value === "string" ? parseFloat(value) / ($9a54cbcfc1af41ba$var$isPercent(value) ? 100 : 1) : NaN, valueIfNaN), 1);
}
//#endregion
//#region src/gradient/parser/parseColorStops.ts
const $9a54cbcfc1af41ba$var$RE_KEY_VALUE_PAIRS = /\s*;\s*/;
const $9a54cbcfc1af41ba$var$RE_KEY_VALUE = /\s*:\s*/;
function $9a54cbcfc1af41ba$var$parseColorStop(el, opacityMultiplier) {
    let colorValue, opacityValue;
    const style = el.getAttribute("style");
    if (style) {
        const keyValuePairs = style.split($9a54cbcfc1af41ba$var$RE_KEY_VALUE_PAIRS);
        if (keyValuePairs[keyValuePairs.length - 1] === "") keyValuePairs.pop();
        for(let i = keyValuePairs.length; i--;){
            const [key, value] = keyValuePairs[i].split($9a54cbcfc1af41ba$var$RE_KEY_VALUE).map((s)=>s.trim());
            if (key === "stop-color") colorValue = value;
            else if (key === "stop-opacity") opacityValue = value;
        }
    }
    colorValue = colorValue || el.getAttribute("stop-color") || "rgb(0,0,0)";
    opacityValue = $9a54cbcfc1af41ba$var$ifNaN(parseFloat(opacityValue || el.getAttribute("stop-opacity") || ""), 1);
    const color = new $9a54cbcfc1af41ba$export$892596cec99bc70e(colorValue);
    color.setAlpha(color.getAlpha() * opacityValue * opacityMultiplier);
    return {
        offset: $9a54cbcfc1af41ba$var$parsePercent(el.getAttribute("offset"), 0),
        color: color.toRgba()
    };
}
function $9a54cbcfc1af41ba$var$parseColorStops(el, opacityAttr) {
    const colorStops = [], colorStopEls = el.getElementsByTagName("stop"), multiplier = $9a54cbcfc1af41ba$var$parsePercent(opacityAttr, 1);
    for(let i = colorStopEls.length; i--;)colorStops.push($9a54cbcfc1af41ba$var$parseColorStop(colorStopEls[i], multiplier));
    return colorStops;
}
//#endregion
//#region src/gradient/parser/misc.ts
function $9a54cbcfc1af41ba$var$parseType(el) {
    return el.nodeName === "linearGradient" || el.nodeName === "LINEARGRADIENT" ? "linear" : "radial";
}
function $9a54cbcfc1af41ba$var$parseGradientUnits(el) {
    return el.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage";
}
//#endregion
//#region src/gradient/parser/parseCoords.ts
function $9a54cbcfc1af41ba$var$convertPercentUnitsToValues(valuesToConvert, { width: width, height: height, gradientUnits: gradientUnits }) {
    let finalValue;
    return Object.entries(valuesToConvert).reduce((acc, [prop, propValue])=>{
        if (propValue === "Infinity") finalValue = 1;
        else if (propValue === "-Infinity") finalValue = 0;
        else {
            const isString = typeof propValue === "string";
            finalValue = isString ? parseFloat(propValue) : propValue;
            if (isString && $9a54cbcfc1af41ba$var$isPercent(propValue)) {
                finalValue *= .01;
                if (gradientUnits === "pixels") {
                    if (prop === "x1" || prop === "x2" || prop === "r2") finalValue *= width;
                    if (prop === "y1" || prop === "y2") finalValue *= height;
                }
            }
        }
        acc[prop] = finalValue;
        return acc;
    }, {});
}
function $9a54cbcfc1af41ba$var$getValue(el, key) {
    return el.getAttribute(key);
}
function $9a54cbcfc1af41ba$var$parseLinearCoords(el) {
    return {
        x1: $9a54cbcfc1af41ba$var$getValue(el, "x1") || 0,
        y1: $9a54cbcfc1af41ba$var$getValue(el, "y1") || 0,
        x2: $9a54cbcfc1af41ba$var$getValue(el, "x2") || "100%",
        y2: $9a54cbcfc1af41ba$var$getValue(el, "y2") || 0
    };
}
function $9a54cbcfc1af41ba$var$parseRadialCoords(el) {
    return {
        x1: $9a54cbcfc1af41ba$var$getValue(el, "fx") || $9a54cbcfc1af41ba$var$getValue(el, "cx") || "50%",
        y1: $9a54cbcfc1af41ba$var$getValue(el, "fy") || $9a54cbcfc1af41ba$var$getValue(el, "cy") || "50%",
        r1: 0,
        x2: $9a54cbcfc1af41ba$var$getValue(el, "cx") || "50%",
        y2: $9a54cbcfc1af41ba$var$getValue(el, "cy") || "50%",
        r2: $9a54cbcfc1af41ba$var$getValue(el, "r") || "50%"
    };
}
function $9a54cbcfc1af41ba$var$parseCoords(el, size) {
    return $9a54cbcfc1af41ba$var$convertPercentUnitsToValues($9a54cbcfc1af41ba$var$parseType(el) === "linear" ? $9a54cbcfc1af41ba$var$parseLinearCoords(el) : $9a54cbcfc1af41ba$var$parseRadialCoords(el), {
        ...size,
        gradientUnits: $9a54cbcfc1af41ba$var$parseGradientUnits(el)
    });
}
//#endregion
//#region src/gradient/Gradient.ts
/**
* Gradient class
* @class Gradient
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-2#gradients}
*/ var $9a54cbcfc1af41ba$export$3d3dd8f63ff0f876 = class {
    constructor(options){
        const { type: type = "linear", gradientUnits: gradientUnits = "pixels", coords: coords = {}, colorStops: colorStops = [], offsetX: offsetX = 0, offsetY: offsetY = 0, gradientTransform: gradientTransform, id: id } = options || {};
        Object.assign(this, {
            type: type,
            gradientUnits: gradientUnits,
            coords: {
                ...type === "radial" ? $9a54cbcfc1af41ba$var$radialDefaultCoords : $9a54cbcfc1af41ba$var$linearDefaultCoords,
                ...coords
            },
            colorStops: colorStops,
            offsetX: offsetX,
            offsetY: offsetY,
            gradientTransform: gradientTransform,
            id: id ? `${id}_${$9a54cbcfc1af41ba$var$uid()}` : $9a54cbcfc1af41ba$var$uid()
        });
    }
    /**
	* Adds another colorStop
	* @param {Record<string, string>} colorStop Object with offset and color
	* @return {Gradient} thisArg
	*/ addColorStop(colorStops) {
        for(const position in colorStops)this.colorStops.push({
            offset: parseFloat(position),
            color: colorStops[position]
        });
        return this;
    }
    /**
	* Returns object representation of a gradient
	* @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {object}
	*/ toObject(propertiesToInclude) {
        return {
            ...$9a54cbcfc1af41ba$var$pick(this, propertiesToInclude),
            type: this.type,
            coords: {
                ...this.coords
            },
            colorStops: this.colorStops.map((colorStop)=>({
                    ...colorStop
                })),
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            gradientUnits: this.gradientUnits,
            gradientTransform: this.gradientTransform ? [
                ...this.gradientTransform
            ] : void 0
        };
    }
    /**
	* Returns SVG representation of an gradient
	* @param {FabricObject} object Object to create a gradient for
	* @return {String} SVG representation of an gradient (linear/radial)
	*/ toSVG(object, { additionalTransform: preTransform } = {}) {
        const markup = [], transform = this.gradientTransform ? this.gradientTransform.concat() : $9a54cbcfc1af41ba$export$3c5a7f9475b116e0.concat(), gradientUnits = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox";
        const colorStops = this.colorStops.map((colorStop)=>({
                ...colorStop
            })).sort((a, b)=>{
            return a.offset - b.offset;
        });
        let offsetX = -this.offsetX, offsetY = -this.offsetY;
        if (gradientUnits === "objectBoundingBox") {
            offsetX /= object.width;
            offsetY /= object.height;
        } else {
            offsetX += object.width / 2;
            offsetY += object.height / 2;
        }
        if ($9a54cbcfc1af41ba$var$isPath(object) && this.gradientUnits !== "percentage") {
            offsetX -= object.pathOffset.x;
            offsetY -= object.pathOffset.y;
        }
        transform[4] -= offsetX;
        transform[5] -= offsetY;
        const commonAttributes = [
            `id="SVGID_${$9a54cbcfc1af41ba$var$escapeXml(String(this.id))}"`,
            `gradientUnits="${gradientUnits}"`,
            `gradientTransform="${preTransform ? preTransform + " " : ""}${$9a54cbcfc1af41ba$var$matrixToSVG(transform)}"`,
            ""
        ].join(" ");
        const sanitizeCoord = (value)=>parseFloat(String(value));
        if (this.type === "linear") {
            const { x1: x1, y1: y1, x2: x2, y2: y2 } = this.coords;
            const sx1 = sanitizeCoord(x1);
            const sy1 = sanitizeCoord(y1);
            const sx2 = sanitizeCoord(x2);
            const sy2 = sanitizeCoord(y2);
            markup.push("<linearGradient ", commonAttributes, " x1=\"", sx1, "\" y1=\"", sy1, "\" x2=\"", sx2, "\" y2=\"", sy2, "\">\n");
        } else if (this.type === "radial") {
            const { x1: x1, y1: y1, x2: x2, y2: y2, r1: r1, r2: r2 } = this.coords;
            const sx1 = sanitizeCoord(x1);
            const sy1 = sanitizeCoord(y1);
            const sx2 = sanitizeCoord(x2);
            const sy2 = sanitizeCoord(y2);
            const sr1 = sanitizeCoord(r1);
            const sr2 = sanitizeCoord(r2);
            const needsSwap = sr1 > sr2;
            markup.push("<radialGradient ", commonAttributes, " cx=\"", needsSwap ? sx1 : sx2, "\" cy=\"", needsSwap ? sy1 : sy2, "\" r=\"", needsSwap ? sr1 : sr2, "\" fx=\"", needsSwap ? sx2 : sx1, "\" fy=\"", needsSwap ? sy2 : sy1, "\">\n");
            if (needsSwap) {
                colorStops.reverse();
                colorStops.forEach((colorStop)=>{
                    colorStop.offset = 1 - colorStop.offset;
                });
            }
            const minRadius = Math.min(sr1, sr2);
            if (minRadius > 0) {
                const percentageShift = minRadius / Math.max(sr1, sr2);
                colorStops.forEach((colorStop)=>{
                    colorStop.offset += percentageShift * (1 - colorStop.offset);
                });
            }
        }
        colorStops.forEach(({ color: color, offset: offset })=>{
            markup.push(`<stop offset="${offset * 100}%" style="stop-color:${color};"/>\n`);
        });
        markup.push(this.type === "linear" ? "</linearGradient>" : "</radialGradient>", "\n");
        return markup.join("");
    }
    /**
	* Returns an instance of CanvasGradient
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @return {CanvasGradient}
	*/ toLive(ctx) {
        const { x1: x1, y1: y1, x2: x2, y2: y2, r1: r1, r2: r2 } = this.coords;
        const gradient = this.type === "linear" ? ctx.createLinearGradient(x1, y1, x2, y2) : ctx.createRadialGradient(x1, y1, r1, x2, y2, r2);
        this.colorStops.forEach(({ color: color, offset: offset })=>{
            gradient.addColorStop(offset, color);
        });
        return gradient;
    }
    static async fromObject(options) {
        const { colorStops: colorStops, gradientTransform: gradientTransform } = options;
        return new this({
            ...options,
            colorStops: colorStops ? colorStops.map((colorStop)=>({
                    ...colorStop
                })) : void 0,
            gradientTransform: gradientTransform ? [
                ...gradientTransform
            ] : void 0
        });
    }
    /**
	* Returns {@link Gradient} instance from an SVG element
	* @param {SVGGradientElement} el SVG gradient element
	* @param {FabricObject} instance
	* @param {String} opacity A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
	* @param {SVGOptions} svgOptions an object containing the size of the SVG in order to parse correctly gradients
	* that uses gradientUnits as 'userSpaceOnUse' and percentages.
	* @return {Gradient} Gradient instance
	* @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
	* @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
	*
	*  @example
	*
	*  <linearGradient id="linearGrad1">
	*    <stop offset="0%" stop-color="white"/>
	*    <stop offset="100%" stop-color="black"/>
	*  </linearGradient>
	*
	*  OR
	*
	*  <linearGradient id="linearGrad2">
	*    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
	*    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
	*  </linearGradient>
	*
	*  OR
	*
	*  <radialGradient id="radialGrad1">
	*    <stop offset="0%" stop-color="white" stop-opacity="1" />
	*    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
	*    <stop offset="100%" stop-color="white" stop-opacity="1" />
	*  </radialGradient>
	*
	*  OR
	*
	*  <radialGradient id="radialGrad2">
	*    <stop offset="0" stop-color="rgb(255,255,255)" />
	*    <stop offset="0.5" stop-color="rgb(0,0,0)" />
	*    <stop offset="1" stop-color="rgb(255,255,255)" />
	*  </radialGradient>
	*
	*/ static fromElement(el, instance, svgOptions) {
        const gradientUnits = $9a54cbcfc1af41ba$var$parseGradientUnits(el);
        const center = instance._findCenterFromElement();
        return new this({
            id: el.getAttribute("id") || void 0,
            type: $9a54cbcfc1af41ba$var$parseType(el),
            coords: $9a54cbcfc1af41ba$var$parseCoords(el, {
                width: svgOptions.viewBoxWidth || svgOptions.width,
                height: svgOptions.viewBoxHeight || svgOptions.height
            }),
            colorStops: $9a54cbcfc1af41ba$var$parseColorStops(el, svgOptions.opacity),
            gradientUnits: gradientUnits,
            gradientTransform: $9a54cbcfc1af41ba$var$parseTransformAttribute(el.getAttribute("gradientTransform") || ""),
            ...gradientUnits === "pixels" ? {
                offsetX: instance.width / 2 - center.x,
                offsetY: instance.height / 2 - center.y
            } : {
                offsetX: 0,
                offsetY: 0
            }
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$3d3dd8f63ff0f876, "type", "Gradient");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$3d3dd8f63ff0f876, "gradient");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$3d3dd8f63ff0f876, "linear");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$3d3dd8f63ff0f876, "radial");
//#endregion
//#region src/Pattern/Pattern.ts
/**
* @see {@link http://fabric5.fabricjs.com/patterns demo}
* @see {@link http://fabric5.fabricjs.com/dynamic-patterns demo}
*/ var $9a54cbcfc1af41ba$export$47606a6ae3eaed8e = class {
    /**
	* Legacy identifier of the class. Prefer using this.constructor.type 'Pattern'
	* or utils like isPattern, or instance of to indentify a pattern in your code.
	* Will be removed in future versiones
	* @TODO add sustainable warning message
	* @type string
	* @deprecated
	*/ get type() {
        return "pattern";
    }
    set type(value) {
        $9a54cbcfc1af41ba$var$log("warn", "Setting type has no effect", value);
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	* @param {option.source} [source] the pattern source, eventually empty or a drawable
	*/ constructor(options){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* @type PatternRepeat
			* @defaults
			*/ "repeat", "repeat");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Pattern horizontal offset from object's left/top corner
			* @type Number
			*/ "offsetX", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Pattern vertical offset from object's left/top corner
			* @type Number
			*/ "offsetY", 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* @type TCrossOrigin
			*/ "crossOrigin", "");
        this.id = $9a54cbcfc1af41ba$var$uid();
        Object.assign(this, options);
    }
    /**
	* @returns true if {@link source} is an <img> element
	*/ isImageSource() {
        return !!this.source && typeof this.source.src === "string";
    }
    /**
	* @returns true if {@link source} is a <canvas> element
	*/ isCanvasSource() {
        return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
        return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : "";
    }
    /**
	* Returns an instance of CanvasPattern
	* @param {CanvasRenderingContext2D} ctx Context to create pattern
	* @return {CanvasPattern}
	*/ toLive(ctx) {
        if (!this.source || this.isImageSource() && (!this.source.complete || this.source.naturalWidth === 0 || this.source.naturalHeight === 0)) return null;
        return ctx.createPattern(this.source, this.repeat);
    }
    /**
	* Returns object representation of a pattern
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {object} Object representation of a pattern instance
	*/ toObject(propertiesToInclude = []) {
        const { repeat: repeat, crossOrigin: crossOrigin } = this;
        return {
            ...$9a54cbcfc1af41ba$var$pick(this, propertiesToInclude),
            type: "pattern",
            source: this.sourceToString(),
            repeat: repeat,
            crossOrigin: crossOrigin,
            offsetX: $9a54cbcfc1af41ba$var$toFixed(this.offsetX, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            offsetY: $9a54cbcfc1af41ba$var$toFixed(this.offsetY, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            patternTransform: this.patternTransform ? [
                ...this.patternTransform
            ] : null
        };
    }
    /**
	* Returns SVG representation of a pattern
	*/ toSVG({ width: width, height: height }) {
        const { source: patternSource, repeat: repeat, id: id } = this, patternOffsetX = $9a54cbcfc1af41ba$var$ifNaN(this.offsetX / width, 0), patternOffsetY = $9a54cbcfc1af41ba$var$ifNaN(this.offsetY / height, 0), patternWidth = repeat === "repeat-y" || repeat === "no-repeat" ? 1 + Math.abs(patternOffsetX || 0) : $9a54cbcfc1af41ba$var$ifNaN(patternSource.width / width, 0), patternHeight = repeat === "repeat-x" || repeat === "no-repeat" ? 1 + Math.abs(patternOffsetY || 0) : $9a54cbcfc1af41ba$var$ifNaN(patternSource.height / height, 0);
        return [
            `<pattern id="SVGID_${$9a54cbcfc1af41ba$var$escapeXml(id)}" x="${patternOffsetX}" y="${patternOffsetY}" width="${patternWidth}" height="${patternHeight}">`,
            `<image x="0" y="0" width="${patternSource.width}" height="${patternSource.height}" xlink:href="${$9a54cbcfc1af41ba$var$escapeXml(this.sourceToString())}"></image>`,
            `</pattern>`,
            ""
        ].join("\n");
    }
    static async fromObject({ type: type, source: source, patternTransform: patternTransform, ...otherOptions }, options) {
        const img = await $9a54cbcfc1af41ba$var$loadImage(source, {
            ...options,
            crossOrigin: otherOptions.crossOrigin
        });
        return new this({
            ...otherOptions,
            patternTransform: patternTransform && patternTransform.slice(0),
            source: img
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$47606a6ae3eaed8e, "type", "Pattern");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$47606a6ae3eaed8e);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$47606a6ae3eaed8e, "pattern");
//#endregion
//#region src/brushes/BaseBrush.ts
/**
* @see {@link http://fabric5.fabricjs.com/freedrawing|Freedrawing demo}
*/ var $9a54cbcfc1af41ba$export$c7531c1a025bcfe2 = class {
    constructor(canvas){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Color of a brush
			* @type String
			*/ "color", "rgb(0, 0, 0)");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Width of a brush, has to be a Number, no string literals
			* @type Number
			*/ "width", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Shadow object representing shadow of this shape.
			* <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
			* "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
			* @type Shadow
			*/ "shadow", null);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Line endings style of a brush (one of "butt", "round", "square")
			* @type String
			*/ "strokeLineCap", "round");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Corner style of a brush (one of "bevel", "round", "miter")
			* @type String
			*/ "strokeLineJoin", "round");
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Maximum miter length (used for strokeLineJoin = "miter") of a brush's
			* @type Number
			*/ "strokeMiterLimit", 10);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Stroke Dash Array.
			* @type Array
			*/ "strokeDashArray", null);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* When `true`, the free drawing is limited to the whiteboard size. Default to false.
			* @type Boolean
			* @default false
			*/ "limitedToCanvasSize", false);
        this.canvas = canvas;
    }
    /**
	* Sets brush styles
	* @private
	* @param {CanvasRenderingContext2D} ctx
	*/ _setBrushStyles(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
    }
    /**
	* Sets the transformation on given context
	* @param {CanvasRenderingContext2D} ctx context to render on
	* @private
	*/ _saveAndTransform(ctx) {
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    }
    needsFullRender() {
        return new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).getAlpha() < 1 || !!this.shadow;
    }
    /**
	* Sets brush shadow styles
	* @private
	*/ _setShadow() {
        if (!this.shadow || !this.canvas) return;
        const canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom() * canvas.getRetinaScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
    }
    /**
	* Removes brush shadow styles
	* @private
	*/ _resetShadow() {
        const ctx = this.canvas.contextTop;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
	* Check is pointer is outside canvas boundaries
	* @param {Object} pointer
	* @private
	*/ _isOutSideCanvas(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
};
//#endregion
//#region src/shapes/Path.ts
var $9a54cbcfc1af41ba$export$4b2950bdac9b6ee9 = class Path extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    /**
	* Constructor
	* @param {TComplexPathData} path Path data (sequence of coordinates and corresponding "command" tokens)
	* @param {Partial<PathProps>} [options] Options object
	* @return {Path} thisArg
	*/ constructor(path, { path: _, left: left, top: top, ...options } = {}){
        super();
        Object.assign(this, Path.ownDefaults);
        this.setOptions(options);
        this._setPath(path || [], true);
        typeof left === "number" && this.set("left", left);
        typeof top === "number" && this.set("top", top);
    }
    /**
	* @private
	* @param {TComplexPathData | string} path Path data (sequence of coordinates and corresponding "command" tokens)
	* @param {boolean} [adjustPosition] pass true to reposition the object according to the bounding box
	* @returns {Point} top left position of the bounding box, useful for complementary positioning
	*/ _setPath(path, adjustPosition) {
        this.path = $9a54cbcfc1af41ba$var$makePathSimpler(Array.isArray(path) ? path : $9a54cbcfc1af41ba$var$parsePath(path));
        this.setBoundingBox(adjustPosition);
    }
    /**
	* This function is an helper for svg import. it returns the center of the object in the svg
	* untransformed coordinates, by look at the polyline/polygon points.
	* @private
	* @return {Point} center point from element coordinates
	*/ _findCenterFromElement() {
        const bbox = this._calcBoundsFromPath();
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx context to render path on
	*/ _renderPathCommands(ctx) {
        const l = -this.pathOffset.x, t = -this.pathOffset.y;
        ctx.beginPath();
        for (const command of this.path)switch(command[0]){
            case "L":
                ctx.lineTo(command[1] + l, command[2] + t);
                break;
            case "M":
                ctx.moveTo(command[1] + l, command[2] + t);
                break;
            case "C":
                ctx.bezierCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t, command[5] + l, command[6] + t);
                break;
            case "Q":
                ctx.quadraticCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t);
                break;
            case "Z":
                ctx.closePath();
                break;
        }
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx context to render path on
	*/ _render(ctx) {
        this._renderPathCommands(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns string representation of an instance
	* @return {string} string representation of an instance
	*/ toString() {
        return `#<Path (${this.complexity()}): { "top": ${this.top}, "left": ${this.left} }>`;
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return {
            ...super.toObject(propertiesToInclude),
            path: this.path.map((pathCmd)=>pathCmd.slice())
        };
    }
    /**
	* Returns dataless object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toDatalessObject(propertiesToInclude = []) {
        const o = this.toObject(propertiesToInclude);
        if (this.sourcePath) {
            delete o.path;
            o.sourcePath = this.sourcePath;
        }
        return o;
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        return [
            "<path ",
            "COMMON_PARTS",
            `d="${$9a54cbcfc1af41ba$var$joinPath(this.path, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)}" stroke-linecap="round" />\n`
        ];
    }
    /**
	* @private
	* @return the path command's translate transform attribute
	*/ _getOffsetTransform() {
        const digits = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        return ` translate(${$9a54cbcfc1af41ba$var$toFixed(-this.pathOffset.x, digits)}, ${$9a54cbcfc1af41ba$var$toFixed(-this.pathOffset.y, digits)})`;
    }
    /**
	* Returns svg clipPath representation of an instance
	* @param {Function} [reviver] Method for further parsing of svg representation.
	* @return {string} svg representation of an instance
	*/ toClipPathSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
	* Returns svg representation of an instance
	* @param {Function} [reviver] Method for further parsing of svg representation.
	* @return {string} svg representation of an instance
	*/ toSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
	* Returns number representation of an instance complexity
	* @return {number} complexity of this instance
	*/ complexity() {
        return this.path.length;
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { width: width, height: height, pathOffset: pathOffset } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset
        });
        adjustPosition && this.setPositionByOrigin(pathOffset, "center", "center");
    }
    _calcBoundsFromPath() {
        const bounds = [];
        let subpathStartX = 0, subpathStartY = 0, x = 0, y = 0;
        for (const command of this.path)switch(command[0]){
            case "L":
                x = command[1];
                y = command[2];
                bounds.push({
                    x: subpathStartX,
                    y: subpathStartY
                }, {
                    x: x,
                    y: y
                });
                break;
            case "M":
                x = command[1];
                y = command[2];
                subpathStartX = x;
                subpathStartY = y;
                break;
            case "C":
                bounds.push(...$9a54cbcfc1af41ba$var$getBoundsOfCurve(x, y, command[1], command[2], command[3], command[4], command[5], command[6]));
                x = command[5];
                y = command[6];
                break;
            case "Q":
                bounds.push(...$9a54cbcfc1af41ba$var$getBoundsOfCurve(x, y, command[1], command[2], command[1], command[2], command[3], command[4]));
                x = command[3];
                y = command[4];
                break;
            case "Z":
                x = subpathStartX;
                y = subpathStartY;
                break;
        }
        return $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(bounds);
    }
    /**
	* @private
	*/ _calcDimensions() {
        const bbox = this._calcBoundsFromPath();
        return {
            ...bbox,
            pathOffset: new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2)
        };
    }
    /**
	* Creates an instance of Path from an object
	* @param {Object} object
	* @returns {Promise<Path>}
	*/ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: "path"
        });
    }
    /**
	* Creates an instance of Path from an SVG <path> element
	* @param {HTMLElement} element to parse
	* @param {Partial<PathProps>} [options] Options object
	*/ static async fromElement(element, options, cssRules) {
        const { d: d, ...parsedAttributes } = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return new this(d, {
            ...parsedAttributes,
            ...options,
            left: void 0,
            top: void 0
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$4b2950bdac9b6ee9, "type", "Path");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$4b2950bdac9b6ee9, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    "path",
    "fillRule"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$4b2950bdac9b6ee9, "ATTRIBUTE_NAMES", [
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES,
    "d"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$4b2950bdac9b6ee9);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$4b2950bdac9b6ee9);
//#endregion
//#region src/brushes/PencilBrush.ts
/**
* @private
* @param {TSimplePathData} pathData SVG path commands
* @returns {boolean}
*/ function $9a54cbcfc1af41ba$var$isEmptySVGPath(pathData) {
    return $9a54cbcfc1af41ba$var$joinPath(pathData) === "M 0 0 Q 0 0 0 0 L 0 0";
}
var $9a54cbcfc1af41ba$export$672d658927d3b57b = class PencilBrush extends $9a54cbcfc1af41ba$export$c7531c1a025bcfe2 {
    constructor(canvas){
        super(canvas);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Discard points that are less than `decimate` pixel distant from each other
			* @type Number
			* @default 0.4
			*/ "decimate", .4);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Draws a straight line between last recorded point to current pointer
			* Used for `shift` functionality
			*
			* @type boolean
			* @default false
			*/ "drawStraightLine", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* The event modifier key that makes the brush draw a straight line.
			* If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
			* @type {ModifierKey | undefined | null}
			*/ "straightLineKey", "shiftKey");
        this._points = [];
        this._hasStraightLine = false;
    }
    needsFullRender() {
        return super.needsFullRender() || this._hasStraightLine;
    }
    static drawSegment(ctx, p1, p2) {
        const midPoint = p1.midPointFrom(p2);
        ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
        return midPoint;
    }
    /**
	* Invoked on mouse down
	* @param {Point} pointer
	*/ onMouseDown(pointer, { e: e }) {
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        this._prepareForDrawing(pointer);
        this._addPoint(pointer);
        this._render();
    }
    /**
	* Invoked on mouse move
	* @param {Point} pointer
	*/ onMouseMove(pointer, { e: e }) {
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this._addPoint(pointer) && this._points.length > 1) {
            if (this.needsFullRender()) {
                this.canvas.clearContext(this.canvas.contextTop);
                this._render();
            } else {
                const points = this._points, length = points.length, ctx = this.canvas.contextTop;
                this._saveAndTransform(ctx);
                if (this.oldEnd) {
                    ctx.beginPath();
                    ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                }
                this.oldEnd = PencilBrush.drawSegment(ctx, points[length - 2], points[length - 1]);
                ctx.stroke();
                ctx.restore();
            }
        }
    }
    /**
	* Invoked on mouse up
	*/ onMouseUp({ e: e }) {
        if (!this.canvas._isMainEvent(e)) return true;
        this.drawStraightLine = false;
        this.oldEnd = void 0;
        this._finalizeAndAddPath();
        return false;
    }
    /**
	* @private
	* @param {Point} pointer Actual mouse position related to the canvas.
	*/ _prepareForDrawing(pointer) {
        this._reset();
        this._addPoint(pointer);
        this.canvas.contextTop.moveTo(pointer.x, pointer.y);
    }
    /**
	* @private
	* @param {Point} point Point to be added to points array
	*/ _addPoint(point) {
        if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) return false;
        if (this.drawStraightLine && this._points.length > 1) {
            this._hasStraightLine = true;
            this._points.pop();
        }
        this._points.push(point);
        return true;
    }
    /**
	* Clear points array and set contextTop canvas style.
	* @private
	*/ _reset() {
        this._points = [];
        this._setBrushStyles(this.canvas.contextTop);
        this._setShadow();
        this._hasStraightLine = false;
    }
    /**
	* Draw a smooth path on the topCanvas using quadraticCurveTo
	* @private
	* @param {CanvasRenderingContext2D} [ctx]
	*/ _render(ctx = this.canvas.contextTop) {
        let p1 = this._points[0], p2 = this._points[1];
        this._saveAndTransform(ctx);
        ctx.beginPath();
        if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
            const width = this.width / 1e3;
            p1.x -= width;
            p2.x += width;
        }
        ctx.moveTo(p1.x, p1.y);
        for(let i = 1; i < this._points.length; i++){
            PencilBrush.drawSegment(ctx, p1, p2);
            p1 = this._points[i];
            p2 = this._points[i + 1];
        }
        ctx.lineTo(p1.x, p1.y);
        ctx.stroke();
        ctx.restore();
    }
    /**
	* Converts points to SVG path
	* @param {Point[]} points Array of points
	* @return {TSimplePathData} SVG path commands
	*/ convertPointsToSVGPath(points) {
        return $9a54cbcfc1af41ba$var$getSmoothPathFromPoints(points, this.width / 1e3);
    }
    /**
	* Creates a Path object to add on canvas
	* @param {TSimplePathData} pathData Path data
	* @return {Path} Path to add on canvas
	*/ createPath(pathData) {
        const path = new $9a54cbcfc1af41ba$export$4b2950bdac9b6ee9(pathData, {
            fill: null,
            stroke: this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray
        });
        if (this.shadow) {
            this.shadow.affectStroke = true;
            path.shadow = new $9a54cbcfc1af41ba$export$a24c14443968327c(this.shadow);
        }
        return path;
    }
    /**
	* Decimate points array with the decimate value
	*/ decimatePoints(points, distance) {
        if (points.length <= 2) return points;
        let lastPoint = points[0], cDistance;
        const zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), l = points.length - 1, newPoints = [
            lastPoint
        ];
        for(let i = 1; i < l - 1; i++){
            cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
            if (cDistance >= adjustedDistance) {
                lastPoint = points[i];
                newPoints.push(lastPoint);
            }
        }
        newPoints.push(points[l]);
        return newPoints;
    }
    /**
	* On mouseup after drawing the path on contextTop canvas
	* we use the points captured to create an new Path object
	* and add it to the canvas.
	*/ _finalizeAndAddPath() {
        this.canvas.contextTop.closePath();
        if (this.decimate) this._points = this.decimatePoints(this._points, this.decimate);
        const pathData = this.convertPointsToSVGPath(this._points);
        if ($9a54cbcfc1af41ba$var$isEmptySVGPath(pathData)) {
            this.canvas.requestRenderAll();
            return;
        }
        const path = this.createPath(pathData);
        this.canvas.clearContext(this.canvas.contextTop);
        this.canvas.fire("before:path:created", {
            path: path
        });
        this.canvas.add(path);
        this.canvas.requestRenderAll();
        path.setCoords();
        this._resetShadow();
        this.canvas.fire("path:created", {
            path: path
        });
    }
};
//#endregion
//#region src/shapes/Circle.ts
const $9a54cbcfc1af41ba$var$CIRCLE_PROPS = [
    "radius",
    "startAngle",
    "endAngle",
    "counterClockwise"
];
const $9a54cbcfc1af41ba$var$circleDefaultValues = {
    radius: 0,
    startAngle: 0,
    endAngle: 360,
    counterClockwise: false
};
var $9a54cbcfc1af41ba$export$c89a927ffc67e6fa = class Circle extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Circle.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        Object.assign(this, Circle.ownDefaults);
        this.setOptions(options);
    }
    /**
	* @private
	* @param {String} key
	* @param {*} value
	*/ _set(key, value) {
        super._set(key, value);
        if (key === "radius") this.setRadius(value);
        return this;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx context to render on
	*/ _render(ctx) {
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, $9a54cbcfc1af41ba$var$degreesToRadians(this.startAngle), $9a54cbcfc1af41ba$var$degreesToRadians(this.endAngle), this.counterClockwise);
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns horizontal radius of an object (according to how an object is scaled)
	* @return {Number}
	*/ getRadiusX() {
        return this.get("radius") * this.get($9a54cbcfc1af41ba$var$SCALE_X);
    }
    /**
	* Returns vertical radius of an object (according to how an object is scaled)
	* @return {Number}
	*/ getRadiusY() {
        return this.get("radius") * this.get($9a54cbcfc1af41ba$var$SCALE_Y);
    }
    /**
	* Sets radius of an object (and updates width accordingly)
	*/ setRadius(value) {
        this.radius = value;
        this.set({
            width: value * 2,
            height: value * 2
        });
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return super.toObject([
            ...$9a54cbcfc1af41ba$var$CIRCLE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const { radius: radius, startAngle: startAngle, endAngle: endAngle } = this;
        const angle = (endAngle - startAngle) % 360;
        if (angle === 0) return [
            "<circle ",
            "COMMON_PARTS",
            "cx=\"0\" cy=\"0\" ",
            "r=\"",
            `${$9a54cbcfc1af41ba$var$escapeXml(radius)}`,
            "\" />\n"
        ];
        else {
            const start = $9a54cbcfc1af41ba$var$degreesToRadians(startAngle), end = $9a54cbcfc1af41ba$var$degreesToRadians(endAngle), startX = $9a54cbcfc1af41ba$var$cos(start) * radius, startY = $9a54cbcfc1af41ba$var$sin(start) * radius, endX = $9a54cbcfc1af41ba$var$cos(end) * radius, endY = $9a54cbcfc1af41ba$var$sin(end) * radius;
            return [
                `<path d="M ${startX} ${startY} A ${radius} ${radius} 0 ${angle > 180 ? 1 : 0} ${this.counterClockwise ? 0 : 1} ${endX} ${endY}" `,
                "COMMON_PARTS",
                " />\n"
            ];
        }
    }
    /**
	* Returns {@link Circle} instance from an SVG element
	* @param {HTMLElement} element Element to parse
	* @param {Object} [options] Partial Circle object to default missing properties on the element.
	* @throws {Error} If value of `r` attribute is missing or invalid
	*/ static async fromElement(element, options, cssRules) {
        const { left: left = 0, top: top = 0, radius: radius = 0, ...otherParsedAttributes } = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return new this({
            ...otherParsedAttributes,
            radius: radius,
            left: left - radius,
            top: top - radius
        });
    }
    /**
	* @todo how do we declare this??
	*/ static fromObject(object) {
        return super._fromObject(object);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c89a927ffc67e6fa, "type", "Circle");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c89a927ffc67e6fa, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$CIRCLE_PROPS
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c89a927ffc67e6fa, "ownDefaults", $9a54cbcfc1af41ba$var$circleDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c89a927ffc67e6fa, "ATTRIBUTE_NAMES", [
    "cx",
    "cy",
    "r",
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c89a927ffc67e6fa);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$c89a927ffc67e6fa);
//#endregion
//#region src/brushes/CircleBrush.ts
var $9a54cbcfc1af41ba$export$c5553759ab21b788 = class extends $9a54cbcfc1af41ba$export$c7531c1a025bcfe2 {
    constructor(canvas){
        super(canvas);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Width of a brush
			* @type Number
			*/ "width", 10);
        this.points = [];
    }
    /**
	* Invoked inside on mouse down and mouse move
	* @param {Point} pointer
	*/ drawDot(pointer) {
        const point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
    }
    dot(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
    }
    /**
	* Invoked on mouse down
	*/ onMouseDown(pointer) {
        this.points = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
    }
    /**
	* Render the full state of the brush
	* @private
	*/ _render() {
        const ctx = this.canvas.contextTop, points = this.points;
        this._saveAndTransform(ctx);
        for(let i = 0; i < points.length; i++)this.dot(ctx, points[i]);
        ctx.restore();
    }
    /**
	* Invoked on mouse move
	* @param {Point} pointer
	*/ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this.needsFullRender()) {
            this.canvas.clearContext(this.canvas.contextTop);
            this.addPoint(pointer);
            this._render();
        } else this.drawDot(pointer);
    }
    /**
	* Invoked on mouse up
	*/ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const circles = [];
        for(let i = 0; i < this.points.length; i++){
            const point = this.points[i], circle = new $9a54cbcfc1af41ba$export$c89a927ffc67e6fa({
                radius: point.radius,
                left: point.x,
                top: point.y,
                originX: $9a54cbcfc1af41ba$var$CENTER,
                originY: $9a54cbcfc1af41ba$var$CENTER,
                fill: point.fill
            });
            this.shadow && (circle.shadow = new $9a54cbcfc1af41ba$export$a24c14443968327c(this.shadow));
            circles.push(circle);
        }
        const group = new $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4(circles, {
            canvas: this.canvas
        });
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    /**
	* @param {Object} pointer
	* @return {Point} Just added pointer point
	*/ addPoint({ x: x, y: y }) {
        const pointerPoint = {
            x: x,
            y: y,
            radius: $9a54cbcfc1af41ba$var$getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
            fill: new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).setAlpha($9a54cbcfc1af41ba$var$getRandomInt(0, 100) / 100).toRgba()
        };
        this.points.push(pointerPoint);
        return pointerPoint;
    }
};
//#endregion
//#region src/brushes/SprayBrush.ts
/**
*
* @param rects
* @returns
*/ function $9a54cbcfc1af41ba$var$getUniqueRects(rects) {
    const uniqueRects = {};
    const uniqueRectsArray = [];
    for(let i = 0, key; i < rects.length; i++){
        key = `${rects[i].left}${rects[i].top}`;
        if (!uniqueRects[key]) {
            uniqueRects[key] = true;
            uniqueRectsArray.push(rects[i]);
        }
    }
    return uniqueRectsArray;
}
var $9a54cbcfc1af41ba$export$6bbd078120d9a520 = class extends $9a54cbcfc1af41ba$export$c7531c1a025bcfe2 {
    /**
	* Constructor
	* @param {Canvas} canvas
	* @return {SprayBrush} Instance of a spray brush
	*/ constructor(canvas){
        super(canvas);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Width of a spray
			* @type Number
			*/ "width", 10);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Density of a spray (number of dots per chunk)
			* @type Number
			*/ "density", 20);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Width of spray dots
			* @type Number
			*/ "dotWidth", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Width variance of spray dots
			* @type Number
			*/ "dotWidthVariance", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Whether opacity of a dot should be random
			* @type Boolean
			*/ "randomOpacity", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Whether overlapping dots (rectangles) should be removed (for performance reasons)
			* @type Boolean
			*/ "optimizeOverlapping", true);
        this.sprayChunks = [];
        this.sprayChunk = [];
    }
    /**
	* Invoked on mouse down
	* @param {Point} pointer
	*/ onMouseDown(pointer) {
        this.sprayChunks = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
	* Invoked on mouse move
	* @param {Point} pointer
	*/ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
	* Invoked on mouse up
	*/ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const rects = [];
        for(let i = 0; i < this.sprayChunks.length; i++){
            const sprayChunk = this.sprayChunks[i];
            for(let j = 0; j < sprayChunk.length; j++){
                const chunck = sprayChunk[j];
                const rect = new $9a54cbcfc1af41ba$export$c79fc6492f3af13d({
                    width: chunck.width,
                    height: chunck.width,
                    left: chunck.x + 1,
                    top: chunck.y + 1,
                    originX: $9a54cbcfc1af41ba$var$CENTER,
                    originY: $9a54cbcfc1af41ba$var$CENTER,
                    fill: this.color
                });
                rects.push(rect);
            }
        }
        const group = new $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4(this.optimizeOverlapping ? $9a54cbcfc1af41ba$var$getUniqueRects(rects) : rects, {
            objectCaching: true,
            subTargetCheck: false,
            interactive: false
        });
        this.shadow && group.set("shadow", new $9a54cbcfc1af41ba$export$a24c14443968327c(this.shadow));
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    renderChunck(sprayChunck) {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < sprayChunck.length; i++){
            const point = sprayChunck[i];
            ctx.globalAlpha = point.opacity;
            ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
    }
    /**
	* Render all spray chunks
	*/ _render() {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < this.sprayChunks.length; i++)this.renderChunck(this.sprayChunks[i]);
        ctx.restore();
    }
    /**
	* @param {Point} pointer
	*/ addSprayChunk(pointer) {
        this.sprayChunk = [];
        const radius = this.width / 2;
        for(let i = 0; i < this.density; i++)this.sprayChunk.push({
            x: $9a54cbcfc1af41ba$var$getRandomInt(pointer.x - radius, pointer.x + radius),
            y: $9a54cbcfc1af41ba$var$getRandomInt(pointer.y - radius, pointer.y + radius),
            width: this.dotWidthVariance ? $9a54cbcfc1af41ba$var$getRandomInt(Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance) : this.dotWidth,
            opacity: this.randomOpacity ? $9a54cbcfc1af41ba$var$getRandomInt(0, 100) / 100 : 1
        });
        this.sprayChunks.push(this.sprayChunk);
    }
};
//#endregion
//#region src/brushes/PatternBrush.ts
var $9a54cbcfc1af41ba$export$3c92be346cf41088 = class extends $9a54cbcfc1af41ba$export$672d658927d3b57b {
    constructor(canvas){
        super(canvas);
    }
    getPatternSrc() {
        const dotWidth = 20, dotDistance = 5, patternCanvas = $9a54cbcfc1af41ba$var$createCanvasElement(), patternCtx = patternCanvas.getContext("2d");
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        if (patternCtx) {
            patternCtx.fillStyle = this.color;
            patternCtx.beginPath();
            patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
            patternCtx.closePath();
            patternCtx.fill();
        }
        return patternCanvas;
    }
    /**
	* Creates "pattern" instance property
	* @param {CanvasRenderingContext2D} ctx
	*/ getPattern(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), "repeat");
    }
    /**
	* Sets brush styles
	* @param {CanvasRenderingContext2D} ctx
	*/ _setBrushStyles(ctx) {
        super._setBrushStyles(ctx);
        const pattern = this.getPattern(ctx);
        pattern && (ctx.strokeStyle = pattern);
    }
    /**
	* Creates path
	*/ createPath(pathData) {
        const path = super.createPath(pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new $9a54cbcfc1af41ba$export$47606a6ae3eaed8e({
            source: this.source || this.getPatternSrc(),
            offsetX: -topLeft.x,
            offsetY: -topLeft.y
        });
        return path;
    }
};
//#endregion
//#region src/shapes/Line.ts
const $9a54cbcfc1af41ba$var$coordProps = [
    "x1",
    "x2",
    "y1",
    "y2"
];
/**
* A Class to draw a line
* A bunch of methods will be added to Polyline to handle the line case
* The line class is very strange to work with, is all special, it hardly aligns
* to what a developer want everytime there is an angle
* @deprecated
*/ var $9a54cbcfc1af41ba$export$17d680238e50603e = class Line extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    /**
	* Constructor
	* @param {Array} [points] Array of points
	* @param {Object} [options] Options object
	* @return {Line} thisArg
	*/ constructor([x1, y1, x2, y2] = [
        0,
        0,
        0,
        0
    ], options = {}){
        super();
        Object.assign(this, Line.ownDefaults);
        this.setOptions(options);
        this.x1 = x1;
        this.x2 = x2;
        this.y1 = y1;
        this.y2 = y2;
        this._setWidthHeight();
        const { left: left, top: top } = options;
        typeof left === "number" && this.set("left", left);
        typeof top === "number" && this.set("top", top);
    }
    /**
	* @private
	* @param {Object} [options] Options
	*/ _setWidthHeight() {
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        this.width = Math.abs(x2 - x1);
        this.height = Math.abs(y2 - y1);
        const { left: left, top: top, width: width, height: height } = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints([
            {
                x: x1,
                y: y1
            },
            {
                x: x2,
                y: y2
            }
        ]);
        const position = new $9a54cbcfc1af41ba$export$baf26146a414f24a(left + width / 2, top + height / 2);
        this.setPositionByOrigin(position, $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
    }
    /**
	* @private
	* @param {String} key
	* @param {*} value
	*/ _set(key, value) {
        super._set(key, value);
        if ($9a54cbcfc1af41ba$var$coordProps.includes(key)) this._setWidthHeight();
        return this;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        ctx.beginPath();
        const p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
        ctx.lineWidth = this.strokeWidth;
        const origStrokeStyle = ctx.strokeStyle;
        if ($9a54cbcfc1af41ba$var$isFiller(this.stroke)) ctx.strokeStyle = this.stroke.toLive(ctx);
        else {
            var _this$stroke;
            ctx.strokeStyle = (_this$stroke = this.stroke) !== null && _this$stroke !== void 0 ? _this$stroke : ctx.fillStyle;
        }
        this.stroke && this._renderStroke(ctx);
        ctx.strokeStyle = origStrokeStyle;
    }
    /**
	* This function is an helper for svg import. it returns the center of the object in the svg
	* untransformed coordinates
	* @private
	* @return {Point} center point from element coordinates
	*/ _findCenterFromElement() {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return {
            ...super.toObject(propertiesToInclude),
            ...this.calcLinePoints()
        };
    }
    _getNonTransformedDimensions() {
        const dim = super._getNonTransformedDimensions();
        if (this.strokeLineCap === "butt") {
            if (this.width === 0) dim.y -= this.strokeWidth;
            if (this.height === 0) dim.x -= this.strokeWidth;
        }
        return dim;
    }
    /**
	* Recalculates line points given width and height
	* Those points are simply placed around the center,
	* This is not useful outside internal render functions and svg output
	* Is not meant to be for the developer.
	* @private
	*/ calcLinePoints() {
        const { x1: _x1, x2: _x2, y1: _y1, y2: _y2, width: width, height: height } = this;
        const xMult = _x1 <= _x2 ? -0.5 : .5, yMult = _y1 <= _y2 ? -0.5 : .5;
        return {
            x1: xMult * width,
            x2: xMult * -width,
            y1: yMult * height,
            y2: yMult * -height
        };
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const { x1: x1, x2: x2, y1: y1, y2: y2 } = this.calcLinePoints();
        return [
            "<line ",
            "COMMON_PARTS",
            `x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" />\n`
        ];
    }
    /**
	* Returns Line instance from an SVG element
	* @param {HTMLElement} element Element to parse
	* @param {Object} [options] Options object
	* @param {Function} [callback] callback function invoked after parsing
	*/ static async fromElement(element, options, cssRules) {
        const { x1: x1 = 0, y1: y1 = 0, x2: x2 = 0, y2: y2 = 0, ...parsedAttributes } = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return new this([
            x1,
            y1,
            x2,
            y2
        ], parsedAttributes);
    }
    /**
	* Returns Line instance from an object representation
	* @param {Object} object Object to create an instance from
	* @returns {Promise<Line>}
	*/ static fromObject({ x1: x1, y1: y1, x2: x2, y2: y2, ...object }) {
        return this._fromObject({
            ...object,
            points: [
                x1,
                y1,
                x2,
                y2
            ]
        }, {
            extraParam: "points"
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$17d680238e50603e, "type", "Line");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$17d680238e50603e, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$coordProps
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$17d680238e50603e, "ATTRIBUTE_NAMES", $9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES.concat($9a54cbcfc1af41ba$var$coordProps));
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$17d680238e50603e);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$17d680238e50603e);
//#endregion
//#region src/shapes/Triangle.ts
const $9a54cbcfc1af41ba$var$triangleDefaultValues = {
    width: 100,
    height: 100
};
var $9a54cbcfc1af41ba$export$5a465592bfe74b48 = class Triangle extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Triangle.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        Object.assign(this, Triangle.ownDefaults);
        this.setOptions(options);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-widthBy2, heightBy2);
        ctx.lineTo(0, -heightBy2);
        ctx.lineTo(widthBy2, heightBy2);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2;
        return [
            "<polygon ",
            "COMMON_PARTS",
            "points=\"",
            `${-widthBy2} ${heightBy2},0 ${-heightBy2},${widthBy2} ${heightBy2}`,
            "\" />"
        ];
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$5a465592bfe74b48, "type", "Triangle");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$5a465592bfe74b48, "ownDefaults", $9a54cbcfc1af41ba$var$triangleDefaultValues);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$5a465592bfe74b48);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$5a465592bfe74b48);
//#endregion
//#region src/shapes/Ellipse.ts
const $9a54cbcfc1af41ba$var$ellipseDefaultValues = {
    rx: 0,
    ry: 0
};
const $9a54cbcfc1af41ba$var$ELLIPSE_PROPS = [
    "rx",
    "ry"
];
var $9a54cbcfc1af41ba$export$80b0269ab108fa11 = class Ellipse extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Ellipse.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor(options){
        super();
        Object.assign(this, Ellipse.ownDefaults);
        this.setOptions(options);
    }
    /**
	* @private
	* @param {String} key
	* @param {*} value
	* @return {Ellipse} thisArg
	*/ _set(key, value) {
        super._set(key, value);
        switch(key){
            case "rx":
                this.rx = value;
                this.set("width", value * 2);
                break;
            case "ry":
                this.ry = value;
                this.set("height", value * 2);
                break;
        }
        return this;
    }
    /**
	* Returns horizontal radius of an object (according to how an object is scaled)
	* @return {Number}
	*/ getRx() {
        return this.get("rx") * this.get($9a54cbcfc1af41ba$var$SCALE_X);
    }
    /**
	* Returns Vertical radius of an object (according to how an object is scaled)
	* @return {Number}
	*/ getRy() {
        return this.get("ry") * this.get($9a54cbcfc1af41ba$var$SCALE_Y);
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return super.toObject([
            ...$9a54cbcfc1af41ba$var$ELLIPSE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        return [
            "<ellipse ",
            "COMMON_PARTS",
            `cx="0" cy="0" rx="${$9a54cbcfc1af41ba$var$escapeXml(this.rx)}" ry="${$9a54cbcfc1af41ba$var$escapeXml(this.ry)}" />\n`
        ];
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx context to render on
	*/ _render(ctx) {
        ctx.beginPath();
        ctx.save();
        ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
        ctx.arc(0, 0, this.rx, 0, $9a54cbcfc1af41ba$var$twoMathPi, false);
        ctx.restore();
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns {@link Ellipse} instance from an SVG element
	* @param {HTMLElement} element Element to parse
	* @return {Ellipse}
	*/ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
        return new this(parsedAttributes);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$80b0269ab108fa11, "type", "Ellipse");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$80b0269ab108fa11, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$ELLIPSE_PROPS
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$80b0269ab108fa11, "ownDefaults", $9a54cbcfc1af41ba$var$ellipseDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$80b0269ab108fa11, "ATTRIBUTE_NAMES", [
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES,
    "cx",
    "cy",
    "rx",
    "ry"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$80b0269ab108fa11);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$80b0269ab108fa11);
//#endregion
//#region src/parser/parsePointsAttribute.ts
/**
* Parses "points" attribute, returning an array of values
* @param {String} points points attribute string
* @return {Array} array of points
*/ function $9a54cbcfc1af41ba$var$parsePointsAttribute(points) {
    if (!points) return [];
    const pointsSplit = points.replace(/,/g, " ").trim().split(/\s+/);
    const parsedPoints = [];
    for(let i = 0; i < pointsSplit.length; i += 2)parsedPoints.push({
        x: parseFloat(pointsSplit[i]),
        y: parseFloat(pointsSplit[i + 1])
    });
    return parsedPoints;
}
//#endregion
//#region src/shapes/Polyline.ts
const $9a54cbcfc1af41ba$var$polylineDefaultValues = {
    exactBoundingBox: false
};
var $9a54cbcfc1af41ba$export$79f3ee03e63e7073 = class Polyline extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Polyline.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {Array} points Array of points (where each point is an object with x and y)
	* @param {Object} [options] Options object
	* @return {Polyline} thisArg
	* @example
	* var poly = new Polyline([
	*     { x: 10, y: 10 },
	*     { x: 50, y: 30 },
	*     { x: 40, y: 70 },
	*     { x: 60, y: 50 },
	*     { x: 100, y: 150 },
	*     { x: 40, y: 100 }
	*   ], {
	*   stroke: 'red',
	*   left: 100,
	*   top: 100
	* });
	*/ constructor(points = [], options = {}){
        super();
        $9a54cbcfc1af41ba$var$_defineProperty(this, "strokeDiff", void 0);
        Object.assign(this, Polyline.ownDefaults);
        this.setOptions(options);
        this.points = points;
        const { left: left, top: top } = options;
        this.initialized = true;
        this.setBoundingBox(true);
        typeof left === "number" && this.set("left", left);
        typeof top === "number" && this.set("top", top);
    }
    isOpen() {
        return true;
    }
    _projectStrokeOnPoints(options) {
        return $9a54cbcfc1af41ba$var$projectStrokeOnPoints(this.points, options, this.isOpen());
    }
    /**
	* Calculate the polygon bounding box
	* @private
	*/ _calcDimensions(options) {
        options = {
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            strokeLineCap: this.strokeLineCap,
            strokeLineJoin: this.strokeLineJoin,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeUniform: this.strokeUniform,
            strokeWidth: this.strokeWidth,
            ...options || {}
        };
        const points = this.exactBoundingBox ? this._projectStrokeOnPoints(options).map((projection)=>projection.projectedPoint) : this.points;
        if (points.length === 0) return {
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            pathOffset: new $9a54cbcfc1af41ba$export$baf26146a414f24a(),
            strokeOffset: new $9a54cbcfc1af41ba$export$baf26146a414f24a(),
            strokeDiff: new $9a54cbcfc1af41ba$export$baf26146a414f24a()
        };
        const bbox = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(points), matrix = $9a54cbcfc1af41ba$var$calcDimensionsMatrix({
            ...options,
            scaleX: 1,
            scaleY: 1
        }), bboxNoStroke = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(this.points.map((p)=>$9a54cbcfc1af41ba$var$transformPoint(p, matrix, true))), scale = new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.scaleX, this.scaleY);
        let offsetX = bbox.left + bbox.width / 2, offsetY = bbox.top + bbox.height / 2;
        if (this.exactBoundingBox) {
            offsetX = offsetX - offsetY * Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(this.skewX));
            offsetY = offsetY - offsetX * Math.tan($9a54cbcfc1af41ba$var$degreesToRadians(this.skewY));
        }
        return {
            ...bbox,
            pathOffset: new $9a54cbcfc1af41ba$export$baf26146a414f24a(offsetX, offsetY),
            strokeOffset: new $9a54cbcfc1af41ba$export$baf26146a414f24a(bboxNoStroke.left, bboxNoStroke.top).subtract(new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.left, bbox.top)).multiply(scale),
            strokeDiff: new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.width, bbox.height).subtract(new $9a54cbcfc1af41ba$export$baf26146a414f24a(bboxNoStroke.width, bboxNoStroke.height)).multiply(scale)
        };
    }
    /**
	* This function is an helper for svg import. it returns the center of the object in the svg
	* untransformed coordinates, by look at the polyline/polygon points.
	* @private
	* @return {Point} center point from element coordinates
	*/ _findCenterFromElement() {
        const bbox = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints(this.points);
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { left: left, top: top, width: width, height: height, pathOffset: pathOffset, strokeOffset: strokeOffset, strokeDiff: strokeDiff } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset,
            strokeOffset: strokeOffset,
            strokeDiff: strokeDiff
        });
        adjustPosition && this.setPositionByOrigin(new $9a54cbcfc1af41ba$export$baf26146a414f24a(left + width / 2, top + height / 2), "center", "center");
    }
    /**
	* @deprecated intermidiate method to be removed, do not use
	*/ isStrokeAccountedForInDimensions() {
        return this.exactBoundingBox;
    }
    /**
	* @override stroke is taken in account in size
	*/ _getNonTransformedDimensions() {
        return this.exactBoundingBox ? new $9a54cbcfc1af41ba$export$baf26146a414f24a(this.width, this.height) : super._getNonTransformedDimensions();
    }
    /**
	* @override stroke and skewing are taken into account when projecting stroke on points,
	* therefore we don't want the default calculation to account for skewing as well.
	* Though it is possible to pass `width` and `height` in `options`, doing so is very strange, use with discretion.
	*
	* @private
	*/ _getTransformedDimensions(options = {}) {
        if (this.exactBoundingBox) {
            let size;
            if (Object.keys(options).some((key)=>this.strokeUniform || this.constructor.layoutProperties.includes(key))) {
                var _options$width, _options$height;
                const { width: width, height: height } = this._calcDimensions(options);
                size = new $9a54cbcfc1af41ba$export$baf26146a414f24a((_options$width = options.width) !== null && _options$width !== void 0 ? _options$width : width, (_options$height = options.height) !== null && _options$height !== void 0 ? _options$height : height);
            } else {
                var _options$width2, _options$height2;
                size = new $9a54cbcfc1af41ba$export$baf26146a414f24a((_options$width2 = options.width) !== null && _options$width2 !== void 0 ? _options$width2 : this.width, (_options$height2 = options.height) !== null && _options$height2 !== void 0 ? _options$height2 : this.height);
            }
            return size.multiply(new $9a54cbcfc1af41ba$export$baf26146a414f24a(options.scaleX || this.scaleX, options.scaleY || this.scaleY));
        } else return super._getTransformedDimensions(options);
    }
    /**
	* Recalculates dimensions when changing skew and scale
	* @private
	*/ _set(key, value) {
        const changed = this.initialized && this[key] !== value;
        const output = super._set(key, value);
        if (this.exactBoundingBox && changed && ((key === "scaleX" || key === "scaleY") && this.strokeUniform && this.constructor.layoutProperties.includes("strokeUniform") || this.constructor.layoutProperties.includes(key))) this.setDimensions();
        return output;
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} Object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return {
            ...super.toObject(propertiesToInclude),
            points: this.points.map(({ x: x, y: y })=>({
                    x: x,
                    y: y
                }))
        };
    }
    /**
	* Returns svg representation of an instance
	* @return {Array} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        const points = this.points.map(({ x: x, y: y })=>`${$9a54cbcfc1af41ba$var$toFixed(x - diffX, NUM_FRACTION_DIGITS)},${$9a54cbcfc1af41ba$var$toFixed(y - diffY, NUM_FRACTION_DIGITS)}`).join(" ");
        return [
            `<${$9a54cbcfc1af41ba$var$escapeXml(this.constructor.type).toLowerCase()} `,
            "COMMON_PARTS",
            `points="${points}" />\n`
        ];
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        const len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
        if (!len || isNaN(this.points[len - 1].y)) return;
        ctx.beginPath();
        ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
        for(let i = 0; i < len; i++){
            const point = this.points[i];
            ctx.lineTo(point.x - x, point.y - y);
        }
        !this.isOpen() && ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
	* Returns complexity of an instance
	* @return {Number} complexity of this instance
	*/ complexity() {
        return this.points.length;
    }
    /**
	* Returns Polyline instance from an SVG element
	* @param {HTMLElement} element Element to parser
	* @param {Object} [options] Options object
	*/ static async fromElement(element, options, cssRules) {
        const points = $9a54cbcfc1af41ba$var$parsePointsAttribute(element.getAttribute("points")), { left: left, top: top, ...parsedAttributes } = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return new this(points, {
            ...parsedAttributes,
            ...options
        });
    }
    /**
	* Returns Polyline instance from an object representation
	* @param {Object} object Object to create an instance from
	* @returns {Promise<Polyline>}
	*/ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: "points"
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$79f3ee03e63e7073, "ownDefaults", $9a54cbcfc1af41ba$var$polylineDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$79f3ee03e63e7073, "type", "Polyline");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$79f3ee03e63e7073, "layoutProperties", [
    $9a54cbcfc1af41ba$var$SKEW_X,
    $9a54cbcfc1af41ba$var$SKEW_Y,
    "strokeLineCap",
    "strokeLineJoin",
    "strokeMiterLimit",
    "strokeWidth",
    "strokeUniform",
    "points"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$79f3ee03e63e7073, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    "points"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$79f3ee03e63e7073, "ATTRIBUTE_NAMES", [
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$79f3ee03e63e7073);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$79f3ee03e63e7073);
//#endregion
//#region src/shapes/Polygon.ts
var $9a54cbcfc1af41ba$export$7d31b617c820d435 = class extends $9a54cbcfc1af41ba$export$79f3ee03e63e7073 {
    isOpen() {
        return false;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$7d31b617c820d435, "ownDefaults", $9a54cbcfc1af41ba$var$polylineDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$7d31b617c820d435, "type", "Polygon");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$7d31b617c820d435);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$7d31b617c820d435);
//#endregion
//#region src/shapes/Text/StyledText.ts
var $9a54cbcfc1af41ba$var$StyledText = class extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    /**
	* Returns true if object has no styling or no styling in a line
	* @param {Number} lineIndex , lineIndex is on wrapped lines.
	* @return {Boolean}
	*/ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return true;
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1])for(const p3 in obj[p1][p2])return false;
        return true;
    }
    /**
	* Returns true if object has a style property or has it ina specified line
	* This function is used to detect if a text will use a particular property or not.
	* @param {String} property to check for
	* @param {Number} lineIndex to check the style on
	* @return {Boolean}
	*/ styleHas(property, lineIndex) {
        if (!this.styles) return false;
        if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return false;
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            0: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1])if (typeof obj[p1][p2][property] !== "undefined") return true;
        return false;
    }
    /**
	* Check if characters in a text have a value for a property
	* whose value matches the textbox's value for that property.  If so,
	* the character-level property is deleted.  If the character
	* has no other properties, then it is also deleted.  Finally,
	* if the line containing that character has no other characters
	* then it also is deleted.
	*/ cleanStyle(property) {
        if (!this.styles) return false;
        const obj = this.styles;
        let stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0;
        for(const p1 in obj){
            letterCount = 0;
            for(const p2 in obj[p1]){
                const styleObject = obj[p1][p2] || {}, stylePropertyHasBeenSet = styleObject[property] !== void 0;
                stylesCount++;
                if (stylePropertyHasBeenSet) {
                    if (!stylePropertyValue) stylePropertyValue = styleObject[property];
                    else if (styleObject[property] !== stylePropertyValue) allStyleObjectPropertiesMatch = false;
                    if (styleObject[property] === this[property]) delete styleObject[property];
                } else allStyleObjectPropertiesMatch = false;
                if (Object.keys(styleObject).length !== 0) letterCount++;
                else delete obj[p1][p2];
            }
            if (letterCount === 0) delete obj[p1];
        }
        for(let i = 0; i < this._textLines.length; i++)graphemeCount += this._textLines[i].length;
        if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
            this[property] = stylePropertyValue;
            this.removeStyle(property);
        }
    }
    /**
	* Remove a style property or properties from all individual character styles
	* in a text object.  Deletes the character style object if it contains no other style
	* props.  Deletes a line style object if it contains no other character styles.
	*
	* @param {String} props The property to remove from character styles.
	*/ removeStyle(property) {
        if (!this.styles) return;
        const obj = this.styles;
        let line, lineNum, charNum;
        for(lineNum in obj){
            line = obj[lineNum];
            for(charNum in line){
                delete line[charNum][property];
                if (Object.keys(line[charNum]).length === 0) delete line[charNum];
            }
            if (Object.keys(line).length === 0) delete obj[lineNum];
        }
    }
    _extendStyles(index, style) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(index);
        if (!this._getLineStyle(lineIndex)) this._setLineStyle(lineIndex);
        const newStyle = $9a54cbcfc1af41ba$var$pickBy({
            ...this._getStyleDeclaration(lineIndex, charIndex),
            ...style
        }, (value)=>value !== void 0);
        this._setStyleDeclaration(lineIndex, charIndex, newStyle);
    }
    /**
	* Gets style of a current selection/cursor (at the start position)
	* @param {Number} startIndex Start index to get styles at
	* @param {Number} endIndex End index to get styles at, if not specified startIndex + 1
	* @param {Boolean} [complete] get full style or not
	* @return {Array} styles an array with one, zero or more Style objects
	*/ getSelectionStyles(startIndex, endIndex, complete) {
        const styles = [];
        for(let i = startIndex; i < (endIndex || startIndex); i++)styles.push(this.getStyleAtPosition(i, complete));
        return styles;
    }
    /**
	* Gets style of a current selection/cursor position
	* @param {Number} position  to get styles at
	* @param {Boolean} [complete] full style if true
	* @return {Object} style Style object at a specified index
	* @private
	*/ getStyleAtPosition(position, complete) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(position);
        return complete ? this.getCompleteStyleDeclaration(lineIndex, charIndex) : this._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
	* Sets style of a current selection, if no selection exist, do not set anything.
	* @param {Object} styles Styles object
	* @param {Number} startIndex Start index to get styles at
	* @param {Number} [endIndex] End index to get styles at, if not specified startIndex + 1
	*/ setSelectionStyles(styles, startIndex, endIndex) {
        for(let i = startIndex; i < (endIndex || startIndex); i++)this._extendStyles(i, styles);
        this._forceClearCache = true;
    }
    /**
	* Get a reference, not a clone, to the style object for a given character,
	* if no style is set for a line or char, return a new empty object.
	* This is tricky and confusing because when you get an empty object you can't
	* determine if it is a reference or a new one.
	* @TODO this should always return a reference or always a clone or undefined when necessary.
	* @protected
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
	*/ _getStyleDeclaration(lineIndex, charIndex) {
        var _lineStyle$charIndex;
        const lineStyle = this.styles && this.styles[lineIndex];
        return lineStyle ? (_lineStyle$charIndex = lineStyle[charIndex]) !== null && _lineStyle$charIndex !== void 0 ? _lineStyle$charIndex : {} : {};
    }
    /**
	* return a new object that contains all the style property for a character
	* the object returned is newly created
	* @param {Number} lineIndex of the line where the character is
	* @param {Number} charIndex position of the character on the line
	* @return {Object} style object
	*/ getCompleteStyleDeclaration(lineIndex, charIndex) {
        return {
            ...$9a54cbcfc1af41ba$var$pick(this, this.constructor._styleProperties),
            ...this._getStyleDeclaration(lineIndex, charIndex)
        };
    }
    /**
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @param {Object} style
	* @private
	*/ _setStyleDeclaration(lineIndex, charIndex, style) {
        this.styles[lineIndex][charIndex] = style;
    }
    /**
	*
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @private
	*/ _deleteStyleDeclaration(lineIndex, charIndex) {
        delete this.styles[lineIndex][charIndex];
    }
    /**
	* @param {Number} lineIndex
	* @return {Boolean} if the line exists or not
	* @private
	*/ _getLineStyle(lineIndex) {
        return !!this.styles[lineIndex];
    }
    /**
	* Set the line style to an empty object so that is initialized
	* @param {Number} lineIndex
	* @private
	*/ _setLineStyle(lineIndex) {
        this.styles[lineIndex] = {};
    }
    _deleteLineStyle(lineIndex) {
        delete this.styles[lineIndex];
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$StyledText, "_styleProperties", $9a54cbcfc1af41ba$var$styleProperties);
//#endregion
//#region src/shapes/Text/TextSVGExportMixin.ts
const $9a54cbcfc1af41ba$var$multipleSpacesRegex = /  +/g;
const $9a54cbcfc1af41ba$var$dblQuoteRegex = /"/g;
function $9a54cbcfc1af41ba$var$createSVGInlineRect(color, left, top, width, height) {
    return `\t\t${$9a54cbcfc1af41ba$var$createSVGRect(color, {
        left: left,
        top: top,
        width: width,
        height: height
    })}\n`;
}
var $9a54cbcfc1af41ba$var$TextSVGExportMixin = class extends $9a54cbcfc1af41ba$var$FabricObjectSVGExportMixin {
    _toSVG() {
        const offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
        return this._wrapSVGTextAndBg(textAndBg);
    }
    toSVG(reviver) {
        const textSvg = this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            noStyle: true,
            withShadow: true
        }), path = this.path;
        if (path) return textSvg + path._createBaseSVGMarkup(path._toSVG(), {
            reviver: reviver,
            withShadow: true,
            additionalTransform: $9a54cbcfc1af41ba$var$matrixToSVG(this.calcOwnMatrix())
        });
        return textSvg;
    }
    _getSVGLeftTopOffsets() {
        return {
            textLeft: -this.width / 2,
            textTop: -this.height / 2,
            lineTop: this.getHeightOfLine(0)
        };
    }
    _wrapSVGTextAndBg({ textBgRects: textBgRects, textSpans: textSpans }) {
        const noShadow = true, textDecoration = this.getSvgTextDecoration(this);
        return [
            textBgRects.join(""),
            "		<text xml:space=\"preserve\" ",
            `font-family="${$9a54cbcfc1af41ba$var$escapeXml(this.fontFamily.replace($9a54cbcfc1af41ba$var$dblQuoteRegex, "'"))}" `,
            `font-size="${$9a54cbcfc1af41ba$var$escapeXml(this.fontSize)}" `,
            this.fontStyle ? `font-style="${$9a54cbcfc1af41ba$var$escapeXml(this.fontStyle)}" ` : "",
            this.fontWeight ? `font-weight="${$9a54cbcfc1af41ba$var$escapeXml(this.fontWeight)}" ` : "",
            textDecoration ? `text-decoration="${textDecoration}" ` : "",
            this.direction === "rtl" ? `direction="rtl" ` : "",
            "style=\"",
            this.getSvgStyles(noShadow),
            "\"",
            this.addPaintOrder(),
            " >",
            textSpans.join(""),
            "</text>\n"
        ];
    }
    /**
	* @private
	* @param {Number} textTopOffset Text top offset
	* @param {Number} textLeftOffset Text left offset
	* @return {Object}
	*/ _getSVGTextAndBg(textTopOffset, textLeftOffset) {
        const textSpans = [], textBgRects = [];
        let height = textTopOffset, lineOffset;
        this.backgroundColor && textBgRects.push($9a54cbcfc1af41ba$var$createSVGInlineRect(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
        for(let i = 0, len = this._textLines.length; i < len; i++){
            lineOffset = this._getLineLeftOffset(i);
            if (this.direction === "rtl") lineOffset += this.width;
            if (this.textBackgroundColor || this.styleHas("textBackgroundColor", i)) this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
            this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
            height += this.getHeightOfLine(i);
        }
        return {
            textSpans: textSpans,
            textBgRects: textBgRects
        };
    }
    _createTextCharSpan(char, styleDecl, left, top, charBox) {
        const numFractionDigit = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        const styleProps = this.getSvgSpanStyles(styleDecl, char !== char.trim() || !!char.match($9a54cbcfc1af41ba$var$multipleSpacesRegex)), fillStyles = styleProps ? `style="${styleProps}"` : "", dy = styleDecl.deltaY, dySpan = dy ? ` dy="${$9a54cbcfc1af41ba$var$toFixed(dy, numFractionDigit)}" ` : "", { angle: angle, renderLeft: renderLeft, renderTop: renderTop, width: width } = charBox;
        let angleAttr = "";
        if (renderLeft !== void 0) {
            const wBy2 = width / 2;
            angle && (angleAttr = ` rotate="${$9a54cbcfc1af41ba$var$toFixed($9a54cbcfc1af41ba$var$radiansToDegrees(angle), numFractionDigit)}"`);
            const m = $9a54cbcfc1af41ba$var$createRotateMatrix({
                angle: $9a54cbcfc1af41ba$var$radiansToDegrees(angle)
            });
            m[4] = renderLeft;
            m[5] = renderTop;
            const renderPoint = new $9a54cbcfc1af41ba$export$baf26146a414f24a(-wBy2, 0).transform(m);
            left = renderPoint.x;
            top = renderPoint.y;
        }
        return `<tspan x="${$9a54cbcfc1af41ba$var$toFixed(left, numFractionDigit)}" y="${$9a54cbcfc1af41ba$var$toFixed(top, numFractionDigit)}" ${dySpan}${angleAttr}${fillStyles}>${$9a54cbcfc1af41ba$var$escapeXml(char)}</tspan>`;
    }
    _setSVGTextLineText(textSpans, lineIndex, textLeftOffset, textTopOffset) {
        const lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.includes($9a54cbcfc1af41ba$var$JUSTIFY), line = this._textLines[lineIndex];
        let actualStyle, nextStyle, charsToRender = "", charBox, style, boxWidth = 0, timeToRender;
        textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing || this.path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                textLeftOffset += charBox.kernedWidth - charBox.width;
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $9a54cbcfc1af41ba$var$hasStyleChanged(actualStyle, nextStyle, true);
            }
            if (timeToRender) {
                style = this._getStyleDeclaration(lineIndex, i);
                textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset, charBox));
                charsToRender = "";
                actualStyle = nextStyle;
                if (this.direction === "rtl") textLeftOffset -= boxWidth;
                else textLeftOffset += boxWidth;
                boxWidth = 0;
            }
        }
    }
    _setSVGTextLineBg(textBgRects, i, leftOffset, textTopOffset) {
        const line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight;
        let boxWidth = 0, boxStart = 0, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
        for(let j = 0; j < line.length; j++){
            const { left: left, width: width, kernedWidth: kernedWidth } = this.__charBounds[i][j];
            currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
            if (currentColor !== lastColor) {
                lastColor && textBgRects.push($9a54cbcfc1af41ba$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
                boxStart = left;
                boxWidth = width;
                lastColor = currentColor;
            } else boxWidth += kernedWidth;
        }
        currentColor && textBgRects.push($9a54cbcfc1af41ba$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
    }
    /**
	* Returns styles-string for svg-export
	* @param {Boolean} skipShadow a boolean to skip shadow filter output
	* @return {String}
	*/ getSvgStyles(skipShadow) {
        const objectLevelTextDecorationColor = this["textDecorationColor"] ? ` text-decoration-color: ${$9a54cbcfc1af41ba$var$escapeXml(this[$9a54cbcfc1af41ba$var$TEXT_DECORATION_COLOR])};` : "";
        return `${super.getSvgStyles(skipShadow)} text-decoration-thickness: ${$9a54cbcfc1af41ba$var$toFixed(this.textDecorationThickness * this.getObjectScaling().y / 10, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)}%;${objectLevelTextDecorationColor} white-space: pre;`;
    }
    /**
	* Returns styles-string for svg-export
	* @param {Object} style the object from which to retrieve style properties
	* @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
	* @return {String}
	*/ getSvgSpanStyles(style, useWhiteSpace) {
        const { fontFamily: fontFamily, strokeWidth: strokeWidth, stroke: stroke, fill: fill, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, textDecorationThickness: textDecorationThickness, textDecorationColor: textDecorationColor, linethrough: linethrough, overline: overline, underline: underline } = style;
        const textDecoration = this.getSvgTextDecoration({
            underline: underline !== null && underline !== void 0 ? underline : this.underline,
            overline: overline !== null && overline !== void 0 ? overline : this.overline,
            linethrough: linethrough !== null && linethrough !== void 0 ? linethrough : this.linethrough
        });
        const thickness = textDecorationThickness || this["textDecorationThickness"];
        const decorationColor = textDecorationColor || this["textDecorationColor"];
        return [
            stroke ? $9a54cbcfc1af41ba$var$colorPropToSVG($9a54cbcfc1af41ba$var$STROKE, stroke) : "",
            strokeWidth ? `stroke-width: ${$9a54cbcfc1af41ba$var$escapeXml(strokeWidth)}; ` : "",
            fontFamily ? `font-family: ${!fontFamily.includes("'") && !fontFamily.includes("\"") ? `'${$9a54cbcfc1af41ba$var$escapeXml(fontFamily)}'` : $9a54cbcfc1af41ba$var$escapeXml(fontFamily)}; ` : "",
            fontSize ? `font-size: ${$9a54cbcfc1af41ba$var$escapeXml(fontSize)}px; ` : "",
            fontStyle ? `font-style: ${$9a54cbcfc1af41ba$var$escapeXml(fontStyle)}; ` : "",
            fontWeight ? `font-weight: ${$9a54cbcfc1af41ba$var$escapeXml(fontWeight)}; ` : "",
            textDecoration ? `text-decoration: ${textDecoration}; text-decoration-thickness: ${$9a54cbcfc1af41ba$var$toFixed(thickness * this.getObjectScaling().y / 10, $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)}%;${decorationColor ? ` text-decoration-color: ${$9a54cbcfc1af41ba$var$escapeXml(decorationColor)};` : ""} ` : "",
            fill ? $9a54cbcfc1af41ba$var$colorPropToSVG($9a54cbcfc1af41ba$var$FILL, fill) : "",
            useWhiteSpace ? "white-space: pre; " : ""
        ].join("");
    }
    /**
	* Returns text-decoration property for svg-export
	* @param {Object} style the object from which to retrieve style properties
	* @return {String}
	*/ getSvgTextDecoration(style) {
        return [
            "overline",
            "underline",
            "line-through"
        ].filter((decoration)=>style[decoration.replace("-", "")]).join(" ");
    }
};
//#endregion
//#region src/shapes/Text/Text.ts
let $9a54cbcfc1af41ba$var$measuringContext;
/**
* Return a context for measurement of text string.
* if created it gets stored for reuse
*/ function $9a54cbcfc1af41ba$var$getMeasuringContext() {
    if (!$9a54cbcfc1af41ba$var$measuringContext) $9a54cbcfc1af41ba$var$measuringContext = $9a54cbcfc1af41ba$var$createCanvasElementFor({
        width: 0,
        height: 0
    }).getContext("2d");
    return $9a54cbcfc1af41ba$var$measuringContext;
}
/**
* Text class
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-2#text}
*/ var $9a54cbcfc1af41ba$export$72cf63a35cb577f7 = class FabricText extends $9a54cbcfc1af41ba$var$StyledText {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...FabricText.ownDefaults
        };
    }
    constructor(text, options){
        super();
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* contains characters bounding boxes
			* This variable is considered to be protected.
			* But for how mixins are implemented right now, we can't leave it private
			* @protected
			*/ "__charBounds", []);
        Object.assign(this, FabricText.ownDefaults);
        this.setOptions(options);
        if (!this.styles) this.styles = {};
        this.text = text;
        this.initialized = true;
        if (this.path) this.setPathInfo();
        this.initDimensions();
        this.setCoords();
    }
    /**
	* If text has a path, it will add the extra information needed
	* for path and text calculations
	*/ setPathInfo() {
        const path = this.path;
        if (path) path.segmentsInfo = $9a54cbcfc1af41ba$var$getPathSegmentsInfo(path.path);
    }
    /**
	* @private
	* Divides text into lines of text and lines of graphemes.
	*/ _splitText() {
        const newLines = this._splitTextIntoLines(this.text);
        this.textLines = newLines.lines;
        this._textLines = newLines.graphemeLines;
        this._unwrappedTextLines = newLines._unwrappedLines;
        this._text = newLines.graphemeText;
        return newLines;
    }
    /**
	* Initialize or update text dimensions.
	* Updates this.width and this.height with the proper values.
	* Does not return dimensions.
	*/ initDimensions() {
        this._splitText();
        this._clearCache();
        this.dirty = true;
        if (this.path) {
            this.width = this.path.width;
            this.height = this.path.height;
        } else {
            this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
            this.height = this.calcTextHeight();
        }
        if (this.textAlign.includes("justify")) this.enlargeSpaces();
    }
    /**
	* Enlarge space boxes and shift the others
	*/ enlargeSpaces() {
        let diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
        for(let i = 0, len = this._textLines.length; i < len; i++){
            if (this.textAlign !== "justify" && (i === len - 1 || this.isEndOfWrapping(i))) continue;
            accumulatedSpace = 0;
            line = this._textLines[i];
            currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
                numberOfSpaces = spaces.length;
                diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
                for(let j = 0; j <= line.length; j++){
                    charBound = this.__charBounds[i][j];
                    if (this._reSpaceAndTab.test(line[j])) {
                        charBound.width += diffSpace;
                        charBound.kernedWidth += diffSpace;
                        charBound.left += accumulatedSpace;
                        accumulatedSpace += diffSpace;
                    } else charBound.left += accumulatedSpace;
                }
            }
        }
    }
    /**
	* Detect if the text line is ended with an hard break
	* text and itext do not have wrapping, return false
	* @return {Boolean}
	*/ isEndOfWrapping(lineIndex) {
        return lineIndex === this._textLines.length - 1;
    }
    missingNewlineOffset(_lineIndex) {
        return 1;
    }
    /**
	* Returns 2d representation (lineIndex and charIndex) of cursor
	* @param {Number} selectionStart
	* @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
	*/ get2DCursorLocation(selectionStart, skipWrapping) {
        const lines = skipWrapping ? this._unwrappedTextLines : this._textLines;
        let i;
        for(i = 0; i < lines.length; i++){
            if (selectionStart <= lines[i].length) return {
                lineIndex: i,
                charIndex: selectionStart
            };
            selectionStart -= lines[i].length + this.missingNewlineOffset(i, skipWrapping);
        }
        return {
            lineIndex: i - 1,
            charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
        };
    }
    /**
	* Returns string representation of an instance
	* @return {String} String representation of text object
	*/ toString() {
        return `#<Text (${this.complexity()}): { "text": "${this.text}", "fontFamily": "${this.fontFamily}" }>`;
    }
    /**
	* Return the dimension and the zoom level needed to create a cache canvas
	* big enough to host the object to be cached.
	* @private
	* @param {Object} dim.x width of object to be cached
	* @param {Object} dim.y height of object to be cached
	* @return {Object}.width width of canvas
	* @return {Object}.height height of canvas
	* @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	* @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	*/ _getCacheCanvasDimensions() {
        const dims = super._getCacheCanvasDimensions();
        const fontSize = this.fontSize;
        dims.width += fontSize * dims.zoomX;
        dims.height += fontSize * dims.zoomY;
        return dims;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        const path = this.path;
        path && !path.isNotVisible() && path._render(ctx);
        this._setTextStyles(ctx);
        this._renderTextLinesBackground(ctx);
        this._renderTextDecoration(ctx, "underline");
        this._renderText(ctx);
        this._renderTextDecoration(ctx, "overline");
        this._renderTextDecoration(ctx, "linethrough");
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderText(ctx) {
        if (this.paintFirst === "stroke") {
            this._renderTextStroke(ctx);
            this._renderTextFill(ctx);
        } else {
            this._renderTextFill(ctx);
            this._renderTextStroke(ctx);
        }
    }
    /**
	* Set the font parameter of the context with the object properties or with charStyle
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Object} [charStyle] object with font style properties
	* @param {String} [charStyle.fontFamily] Font Family
	* @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
	* @param {String} [charStyle.fontWeight] Font weight
	* @param {String} [charStyle.fontStyle] Font style (italic|normal)
	*/ _setTextStyles(ctx, charStyle, forMeasuring) {
        ctx.textBaseline = "alphabetic";
        if (this.path) switch(this.pathAlign){
            case $9a54cbcfc1af41ba$var$CENTER:
                ctx.textBaseline = "middle";
                break;
            case "ascender":
                ctx.textBaseline = "top";
                break;
            case "descender":
                ctx.textBaseline = $9a54cbcfc1af41ba$var$BOTTOM;
                break;
        }
        ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    }
    /**
	* calculate and return the text Width measuring each line.
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @return {Number} Maximum width of Text object
	*/ calcTextWidth() {
        let maxWidth = this.getLineWidth(0);
        for(let i = 1, len = this._textLines.length; i < len; i++){
            const currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth > maxWidth) maxWidth = currentLineWidth;
        }
        return maxWidth;
    }
    /**
	* @private
	* @param {String} method Method name ("fillText" or "strokeText")
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {String} line Text to render
	* @param {Number} left Left position of text
	* @param {Number} top Top position of text
	* @param {Number} lineIndex Index of a line in a text
	*/ _renderTextLine(method, ctx, line, left, top, lineIndex) {
        this._renderChars(method, ctx, line, left, top, lineIndex);
    }
    /**
	* Renders the text background for lines, taking care of style
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderTextLinesBackground(ctx) {
        if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) return;
        const originalFill = ctx.fillStyle, leftOffset = this._getLeftOffset();
        let lineTopOffset = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", i)) {
                lineTopOffset += heightOfLine;
                continue;
            }
            const jlen = this._textLines[i].length;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxWidth = 0;
            let boxStart = 0;
            let drawStart;
            let currentColor;
            let lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
            const bgHeight = this.getHeightOfLineImpl(i);
            for(let j = 0; j < jlen; j++){
                const charBox = this.__charBounds[i][j];
                currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
                if (this.path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillStyle = currentColor;
                    currentColor && ctx.fillRect(-charBox.width / 2, -bgHeight * (1 - this._fontSizeFraction), charBox.width, bgHeight);
                    ctx.restore();
                } else if (currentColor !== lastColor) {
                    drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                    ctx.fillStyle = lastColor;
                    lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, bgHeight);
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastColor = currentColor;
                } else boxWidth += charBox.kernedWidth;
            }
            if (currentColor && !this.path) {
                drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                ctx.fillStyle = currentColor;
                ctx.fillRect(drawStart, lineTopOffset, boxWidth, bgHeight);
            }
            lineTopOffset += heightOfLine;
        }
        ctx.fillStyle = originalFill;
        this._removeShadow(ctx);
    }
    /**
	* measure and return the width of a single character.
	* possibly overridden to accommodate different measure logic or
	* to hook some external lib for character measurement
	* @private
	* @param {String} _char, char to be measured
	* @param {Object} charStyle style of char to be measured
	* @param {String} [previousChar] previous char
	* @param {Object} [prevCharStyle] style of previous char
	*/ _measureChar(_char, charStyle, previousChar, prevCharStyle) {
        const fontCache = $9a54cbcfc1af41ba$export$69a3209f1a06c04d.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), couple = previousChar ? previousChar + _char : _char, stylesAreEqual = previousChar && fontDeclaration === this._getFontDeclaration(prevCharStyle), fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;
        let width, coupleWidth, previousWidth, kernedWidth;
        if (previousChar && fontCache.has(previousChar)) previousWidth = fontCache.get(previousChar);
        if (fontCache.has(_char)) kernedWidth = width = fontCache.get(_char);
        if (stylesAreEqual && fontCache.has(couple)) {
            coupleWidth = fontCache.get(couple);
            kernedWidth = coupleWidth - previousWidth;
        }
        if (width === void 0 || previousWidth === void 0 || coupleWidth === void 0) {
            const ctx = $9a54cbcfc1af41ba$var$getMeasuringContext();
            this._setTextStyles(ctx, charStyle, true);
            if (width === void 0) {
                kernedWidth = width = ctx.measureText(_char).width;
                fontCache.set(_char, width);
            }
            if (previousWidth === void 0 && stylesAreEqual && previousChar) {
                previousWidth = ctx.measureText(previousChar).width;
                fontCache.set(previousChar, previousWidth);
            }
            if (stylesAreEqual && coupleWidth === void 0) {
                coupleWidth = ctx.measureText(couple).width;
                fontCache.set(couple, coupleWidth);
                kernedWidth = coupleWidth - previousWidth;
            }
        }
        return {
            width: width * fontMultiplier,
            kernedWidth: kernedWidth * fontMultiplier
        };
    }
    /**
	* Computes height of character at given position
	* @param {Number} line the line index number
	* @param {Number} _char the character index number
	* @return {Number} fontSize of the character
	*/ getHeightOfChar(line, _char) {
        return this.getValueOfPropertyAt(line, _char, "fontSize");
    }
    /**
	* measure a text line measuring all characters.
	* @param {Number} lineIndex line number
	*/ measureLine(lineIndex) {
        const lineInfo = this._measureLine(lineIndex);
        if (this.charSpacing !== 0) lineInfo.width -= this._getWidthOfCharSpacing();
        if (lineInfo.width < 0) lineInfo.width = 0;
        return lineInfo;
    }
    /**
	* measure every grapheme of a line, populating __charBounds
	* @param {Number} lineIndex
	* @return {Object} object.width total width of characters
	* @return {Object} object.numOfSpaces length of chars that match this._reSpacesAndTabs
	*/ _measureLine(lineIndex) {
        let width = 0, prevGrapheme, graphemeInfo;
        const reverse = this.pathSide === $9a54cbcfc1af41ba$var$RIGHT, path = this.path, line = this._textLines[lineIndex], llength = line.length, lineBounds = new Array(llength);
        this.__charBounds[lineIndex] = lineBounds;
        for(let i = 0; i < llength; i++){
            const grapheme = line[i];
            graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
            lineBounds[i] = graphemeInfo;
            width += graphemeInfo.kernedWidth;
            prevGrapheme = grapheme;
        }
        lineBounds[llength] = {
            left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
            width: 0,
            kernedWidth: 0,
            height: this.fontSize,
            deltaY: 0
        };
        if (path && path.segmentsInfo) {
            let positionInPath = 0;
            const totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
            switch(this.textAlign){
                case $9a54cbcfc1af41ba$var$LEFT:
                    positionInPath = reverse ? totalPathLength - width : 0;
                    break;
                case $9a54cbcfc1af41ba$var$CENTER:
                    positionInPath = (totalPathLength - width) / 2;
                    break;
                case $9a54cbcfc1af41ba$var$RIGHT:
                    positionInPath = reverse ? 0 : totalPathLength - width;
                    break;
            }
            positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
            for(let i = reverse ? llength - 1 : 0; reverse ? i >= 0 : i < llength; reverse ? i-- : i++){
                graphemeInfo = lineBounds[i];
                if (positionInPath > totalPathLength) positionInPath %= totalPathLength;
                else if (positionInPath < 0) positionInPath += totalPathLength;
                this._setGraphemeOnPath(positionInPath, graphemeInfo);
                positionInPath += graphemeInfo.kernedWidth;
            }
        }
        return {
            width: width,
            numOfSpaces: 0
        };
    }
    /**
	* Calculate the angle  and the left,top position of the char that follow a path.
	* It appends it to graphemeInfo to be reused later at rendering
	* @private
	* @param {Number} positionInPath to be measured
	* @param {GraphemeBBox} graphemeInfo current grapheme box information
	* @param {Object} startingPoint position of the point
	*/ _setGraphemeOnPath(positionInPath, graphemeInfo) {
        const centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
        const info = $9a54cbcfc1af41ba$var$getPointOnPath(path.path, centerPosition, path.segmentsInfo);
        graphemeInfo.renderLeft = info.x - path.pathOffset.x;
        graphemeInfo.renderTop = info.y - path.pathOffset.y;
        graphemeInfo.angle = info.angle + (this.pathSide === "right" ? Math.PI : 0);
    }
    /**
	*
	* @param {String} grapheme to be measured
	* @param {Number} lineIndex index of the line where the char is
	* @param {Number} charIndex position in the line
	* @param {String} [prevGrapheme] character preceding the one to be measured
	* @returns {GraphemeBBox} grapheme bbox
	*/ _getGraphemeBox(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
        const style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle);
        let kernedWidth = info.kernedWidth, width = info.width, charSpacing;
        if (this.charSpacing !== 0) {
            charSpacing = this._getWidthOfCharSpacing();
            width += charSpacing;
            kernedWidth += charSpacing;
        }
        const box = {
            width: width,
            left: 0,
            height: style.fontSize,
            kernedWidth: kernedWidth,
            deltaY: style.deltaY
        };
        if (charIndex > 0 && !skipLeft) {
            const previousBox = this.__charBounds[lineIndex][charIndex - 1];
            box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
        }
        return box;
    }
    /**
	* Calculate height of line at 'lineIndex',
	* without the lineHeigth multiplication factor
	* @private
	* @param {Number} lineIndex index of line to calculate
	* @return {Number}
	*/ getHeightOfLineImpl(lineIndex) {
        const lh = this.__lineHeights;
        if (lh[lineIndex]) return lh[lineIndex];
        let maxHeight = this.getHeightOfChar(lineIndex, 0);
        for(let i = 1, len = this._textLines[lineIndex].length; i < len; i++)maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
        return lh[lineIndex] = maxHeight * this._fontSizeMult;
    }
    /**
	* Calculate height of line at 'lineIndex'
	* @param {Number} lineIndex index of line to calculate
	* @return {Number}
	*/ getHeightOfLine(lineIndex) {
        return this.getHeightOfLineImpl(lineIndex) * this.lineHeight;
    }
    /**
	* Calculate text box height
	*/ calcTextHeight() {
        let height = 0;
        for(let i = 0, len = this._textLines.length; i < len; i++)height += i === len - 1 ? this.getHeightOfLineImpl(i) : this.getHeightOfLine(i);
        return height;
    }
    /**
	* @private
	* @return {Number} Left offset
	*/ _getLeftOffset() {
        return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
    }
    /**
	* @private
	* @return {Number} Top offset
	*/ _getTopOffset() {
        return -this.height / 2;
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {String} method Method name ("fillText" or "strokeText")
	*/ _renderTextCommon(ctx, method) {
        ctx.save();
        let lineHeights = 0;
        const left = this._getLeftOffset(), top = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            this._renderTextLine(method, ctx, this._textLines[i], left + this._getLineLeftOffset(i), top + lineHeights + this.getHeightOfLineImpl(i), i);
            lineHeights += this.getHeightOfLine(i);
        }
        ctx.restore();
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderTextFill(ctx) {
        if (!this.fill && !this.styleHas("fill")) return;
        this._renderTextCommon(ctx, "fillText");
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderTextStroke(ctx) {
        if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        this._setLineDash(ctx, this.strokeDashArray);
        ctx.beginPath();
        this._renderTextCommon(ctx, "strokeText");
        ctx.closePath();
        ctx.restore();
    }
    /**
	* @private
	* @param {String} method fillText or strokeText.
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Array} line Content of the line, splitted in an array by grapheme
	* @param {Number} left
	* @param {Number} top
	* @param {Number} lineIndex
	*/ _renderChars(method, ctx, line, left, top, lineIndex) {
        const isJustify = this.textAlign.includes($9a54cbcfc1af41ba$var$JUSTIFY), path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === "ltr", sign = this.direction === "ltr" ? 1 : -1, currentDirection = ctx.direction;
        let actualStyle, nextStyle, charsToRender = "", charBox, boxWidth = 0, timeToRender, drawingLeft;
        ctx.save();
        if (currentDirection !== this.direction) {
            ctx.canvas.setAttribute("dir", isLtr ? "ltr" : "rtl");
            ctx.direction = isLtr ? "ltr" : "rtl";
            ctx.textAlign = isLtr ? $9a54cbcfc1af41ba$var$LEFT : $9a54cbcfc1af41ba$var$RIGHT;
        }
        top -= this.getHeightOfLineImpl(lineIndex) * this._fontSizeFraction;
        if (shortCut) {
            this._renderChar(method, ctx, lineIndex, 0, line.join(""), left, top);
            ctx.restore();
            return;
        }
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing || path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                left += sign * (charBox.kernedWidth - charBox.width);
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $9a54cbcfc1af41ba$var$hasStyleChanged(actualStyle, nextStyle, false);
            }
            if (timeToRender) {
                if (path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0);
                    ctx.restore();
                } else {
                    drawingLeft = left;
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top);
                }
                charsToRender = "";
                actualStyle = nextStyle;
                left += sign * boxWidth;
                boxWidth = 0;
            }
        }
        ctx.restore();
    }
    /**
	* This function try to patch the missing gradientTransform on canvas gradients.
	* transforming a context to transform the gradient, is going to transform the stroke too.
	* we want to transform the gradient but not the stroke operation, so we create
	* a transformed gradient on a pattern and then we use the pattern instead of the gradient.
	* this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
	* is limited.
	* @private
	* @param {TFiller} filler a fabric gradient instance
	* @return {CanvasPattern} a pattern to use as fill/stroke style
	*/ _applyPatternGradientTransformText(filler) {
        const width = this.width + this.strokeWidth, height = this.height + this.strokeWidth, pCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor({
            width: width,
            height: height
        }), pCtx = pCanvas.getContext("2d");
        pCanvas.width = width;
        pCanvas.height = height;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.fillStyle = filler.toLive(pCtx);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fill();
        return pCtx.createPattern(pCanvas, "no-repeat");
    }
    handleFiller(ctx, property, filler) {
        let offsetX, offsetY;
        if ($9a54cbcfc1af41ba$var$isFiller(filler)) {
            if (filler.gradientUnits === "percentage" || filler.gradientTransform || filler.patternTransform) {
                offsetX = -this.width / 2;
                offsetY = -this.height / 2;
                ctx.translate(offsetX, offsetY);
                ctx[property] = this._applyPatternGradientTransformText(filler);
                return {
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            } else {
                ctx[property] = filler.toLive(ctx);
                return this._applyPatternGradientTransform(ctx, filler);
            }
        } else ctx[property] = filler;
        return {
            offsetX: 0,
            offsetY: 0
        };
    }
    /**
	* This function prepare the canvas for a stroke style, and stroke and strokeWidth
	* need to be sent in as defined
	* @param {CanvasRenderingContext2D} ctx
	* @param {CompleteTextStyleDeclaration} style with stroke and strokeWidth defined
	* @returns
	*/ _setStrokeStyles(ctx, { stroke: stroke, strokeWidth: strokeWidth }) {
        ctx.lineWidth = strokeWidth;
        ctx.lineCap = this.strokeLineCap;
        ctx.lineDashOffset = this.strokeDashOffset;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.miterLimit = this.strokeMiterLimit;
        return this.handleFiller(ctx, "strokeStyle", stroke);
    }
    /**
	* This function prepare the canvas for a ill style, and fill
	* need to be sent in as defined
	* @param {CanvasRenderingContext2D} ctx
	* @param {CompleteTextStyleDeclaration} style with ill defined
	* @returns
	*/ _setFillStyles(ctx, { fill: fill }) {
        return this.handleFiller(ctx, "fillStyle", fill);
    }
    /**
	* @private
	* @param {String} method
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @param {String} _char
	* @param {Number} left Left coordinate
	* @param {Number} top Top coordinate
	* @param {Number} lineHeight Height of the line
	*/ _renderChar(method, ctx, lineIndex, charIndex, _char, left, top) {
        const decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === "fillText" && fullDecl.fill, shouldStroke = method === "strokeText" && fullDecl.stroke && fullDecl.strokeWidth;
        if (!shouldStroke && !shouldFill) return;
        ctx.save();
        ctx.font = this._getFontDeclaration(fullDecl);
        if (decl.textBackgroundColor) this._removeShadow(ctx);
        if (decl.deltaY) top += decl.deltaY;
        if (shouldFill) {
            const fillOffsets = this._setFillStyles(ctx, fullDecl);
            ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
        }
        if (shouldStroke) {
            const strokeOffsets = this._setStrokeStyles(ctx, fullDecl);
            ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
        }
        ctx.restore();
    }
    /**
	* Turns the character into a 'superior figure' (i.e. 'superscript')
	* @param {Number} start selection start
	* @param {Number} end selection end
	*/ setSuperscript(start, end) {
        this._setScript(start, end, this.superscript);
    }
    /**
	* Turns the character into an 'inferior figure' (i.e. 'subscript')
	* @param {Number} start selection start
	* @param {Number} end selection end
	*/ setSubscript(start, end) {
        this._setScript(start, end, this.subscript);
    }
    /**
	* Applies 'schema' at given position
	* @private
	* @param {Number} start selection start
	* @param {Number} end selection end
	* @param {Number} schema
	*/ _setScript(start, end, schema) {
        const loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "fontSize"), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "deltaY"), style = {
            fontSize: fontSize * schema.size,
            deltaY: dy + fontSize * schema.baseline
        };
        this.setSelectionStyles(style, start, end);
    }
    /**
	* @private
	* @param {Number} lineIndex index text line
	* @return {Number} Line left offset
	*/ _getLineLeftOffset(lineIndex) {
        const lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
        let leftOffset = 0;
        if (textAlign === "justify" || textAlign === "justify-center" && !isEndOfWrapping || textAlign === "justify-right" && !isEndOfWrapping || textAlign === "justify-left" && !isEndOfWrapping) return 0;
        if (textAlign === "center") leftOffset = lineDiff / 2;
        if (textAlign === "right") leftOffset = lineDiff;
        if (textAlign === "justify-center") leftOffset = lineDiff / 2;
        if (textAlign === "justify-right") leftOffset = lineDiff;
        if (direction === "rtl") {
            if (textAlign === "right" || textAlign === "justify-right") leftOffset = 0;
            else if (textAlign === "left" || textAlign === "justify-left") leftOffset = -lineDiff;
            else if (textAlign === "center" || textAlign === "justify-center") leftOffset = -lineDiff / 2;
        }
        return leftOffset;
    }
    /**
	* @private
	*/ _clearCache() {
        this._forceClearCache = false;
        this.__lineWidths = [];
        this.__lineHeights = [];
        this.__charBounds = [];
    }
    /**
	* Measure a single line given its index. Used to calculate the initial
	* text bounding box. The values are calculated and stored in __lineWidths cache.
	* @private
	* @param {Number} lineIndex line number
	* @return {Number} Line width
	*/ getLineWidth(lineIndex) {
        if (this.__lineWidths[lineIndex] !== void 0) return this.__lineWidths[lineIndex];
        const { width: width } = this.measureLine(lineIndex);
        this.__lineWidths[lineIndex] = width;
        return width;
    }
    _getWidthOfCharSpacing() {
        if (this.charSpacing !== 0) return this.fontSize * this.charSpacing / 1e3;
        return 0;
    }
    /**
	* Retrieves the value of property at given character position
	* @param {Number} lineIndex the line number
	* @param {Number} charIndex the character number
	* @param {String} property the property name
	* @returns the value of 'property'
	*/ getValueOfPropertyAt(lineIndex, charIndex, property) {
        var _charStyle$property;
        return (_charStyle$property = this._getStyleDeclaration(lineIndex, charIndex)[property]) !== null && _charStyle$property !== void 0 ? _charStyle$property : this[property];
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _renderTextDecoration(ctx, type) {
        if (!this[type] && !this.styleHas(type)) return;
        let topOffset = this._getTopOffset();
        const leftOffset = this._getLeftOffset(), path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetAligner = type === "linethrough" ? .5 : type === "overline" ? 1 : 0, offsetY = this.offsets[type];
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this[type] && !this.styleHas(type, i)) {
                topOffset += heightOfLine;
                continue;
            }
            const line = this._textLines[i];
            const maxHeight = heightOfLine / this.lineHeight;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxStart = 0;
            let boxWidth = 0;
            let lastDecoration = this.getValueOfPropertyAt(i, 0, type);
            let lastFill = this.getValueOfPropertyAt(i, 0, $9a54cbcfc1af41ba$var$FILL);
            let lastDecorationColor = this.getValueOfPropertyAt(i, 0, "textDecorationColor") || lastFill;
            let lastTickness = this.getValueOfPropertyAt(i, 0, $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS);
            let currentDecoration = lastDecoration;
            let currentFill = lastFill;
            let currentDecorationColor = lastDecorationColor;
            let currentTickness = lastTickness;
            const top = topOffset + maxHeight * (1 - this._fontSizeFraction);
            let size = this.getHeightOfChar(i, 0);
            let dy = this.getValueOfPropertyAt(i, 0, "deltaY");
            for(let j = 0, jlen = line.length; j < jlen; j++){
                const charBox = this.__charBounds[i][j];
                currentDecoration = this.getValueOfPropertyAt(i, j, type);
                currentFill = this.getValueOfPropertyAt(i, j, $9a54cbcfc1af41ba$var$FILL);
                currentDecorationColor = this.getValueOfPropertyAt(i, j, "textDecorationColor") || currentFill;
                currentTickness = this.getValueOfPropertyAt(i, j, $9a54cbcfc1af41ba$var$TEXT_DECORATION_THICKNESS);
                const currentSize = this.getHeightOfChar(i, j);
                const currentDy = this.getValueOfPropertyAt(i, j, "deltaY");
                if (path && currentDecoration && currentFill) {
                    const finalTickness = this.fontSize * currentTickness / 1e3;
                    ctx.save();
                    ctx.fillStyle = currentDecorationColor;
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillRect(-charBox.kernedWidth / 2, offsetY * currentSize + currentDy - offsetAligner * finalTickness, charBox.kernedWidth, finalTickness);
                    ctx.restore();
                } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || currentDecorationColor !== lastDecorationColor || currentSize !== size || currentTickness !== lastTickness || currentDy !== dy) && boxWidth > 0) {
                    const finalTickness = this.fontSize * lastTickness / 1e3;
                    let drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                    if (lastDecoration && lastDecorationColor && lastTickness) {
                        ctx.fillStyle = lastDecorationColor;
                        ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth, finalTickness);
                    }
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastDecoration = currentDecoration;
                    lastDecorationColor = currentDecorationColor;
                    lastTickness = currentTickness;
                    lastFill = currentFill;
                    size = currentSize;
                    dy = currentDy;
                } else boxWidth += charBox.kernedWidth;
            }
            let drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
            ctx.fillStyle = currentDecorationColor;
            const finalTickness = this.fontSize * currentTickness / 1e3;
            currentDecoration && currentDecorationColor && currentTickness && ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth - charSpacing, finalTickness);
            topOffset += heightOfLine;
        }
        this._removeShadow(ctx);
    }
    /**
	* return font declaration string for canvas context
	* @param {Object} [styleObject] object
	* @returns {String} font declaration formatted for canvas context.
	*/ _getFontDeclaration({ fontFamily: fontFamily = this.fontFamily, fontStyle: fontStyle = this.fontStyle, fontWeight: fontWeight = this.fontWeight, fontSize: fontSize = this.fontSize } = {}, forMeasuring) {
        const parsedFontFamily = fontFamily.includes("'") || fontFamily.includes("\"") || fontFamily.includes(",") || FabricText.genericFonts.includes(fontFamily.toLowerCase()) ? fontFamily : `"${fontFamily}"`;
        return [
            fontStyle,
            fontWeight,
            `${forMeasuring ? this.CACHE_FONT_SIZE : fontSize}px`,
            parsedFontFamily
        ].join(" ");
    }
    /**
	* Renders text instance on a specified context
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ render(ctx) {
        if (!this.visible) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        if (this._forceClearCache) this.initDimensions();
        super.render(ctx);
    }
    /**
	* Override this method to customize grapheme splitting
	* @todo the util `graphemeSplit` needs to be injectable in some way.
	* is more comfortable to inject the correct util rather than having to override text
	* in the middle of the prototype chain
	* @param {string} value
	* @returns {string[]} array of graphemes
	*/ graphemeSplit(value) {
        return $9a54cbcfc1af41ba$var$graphemeSplit(value);
    }
    /**
	* Returns the text as an array of lines.
	* @param {String} text text to split
	* @returns  Lines in the text
	*/ _splitTextIntoLines(text) {
        const lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = [
            "\n"
        ];
        let newText = [];
        for(let i = 0; i < lines.length; i++){
            newLines[i] = this.graphemeSplit(lines[i]);
            newText = newText.concat(newLines[i], newLine);
        }
        newText.pop();
        return {
            _unwrappedLines: newLines,
            lines: lines,
            graphemeText: newText,
            graphemeLines: newLines
        };
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} Object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return {
            ...super.toObject([
                ...$9a54cbcfc1af41ba$var$additionalProps,
                ...propertiesToInclude
            ]),
            styles: $9a54cbcfc1af41ba$var$stylesToArray(this.styles, this.text),
            ...this.path ? {
                path: this.path.toObject()
            } : {}
        };
    }
    set(key, value) {
        const { textLayoutProperties: textLayoutProperties } = this.constructor;
        super.set(key, value);
        let needsDims = false;
        let isAddingPath = false;
        if (typeof key === "object") for(const _key in key){
            if (_key === "path") this.setPathInfo();
            needsDims = needsDims || textLayoutProperties.includes(_key);
            isAddingPath = isAddingPath || _key === "path";
        }
        else {
            needsDims = textLayoutProperties.includes(key);
            isAddingPath = key === "path";
        }
        if (isAddingPath) this.setPathInfo();
        if (needsDims && this.initialized) {
            this.initDimensions();
            this.setCoords();
        }
        return this;
    }
    /**
	* Returns complexity of an instance
	* @return {Number} complexity
	*/ complexity() {
        return 1;
    }
    /**
	* Returns FabricText instance from an SVG element (<b>not yet implemented</b>)
	* @param {HTMLElement} element Element to parse
	* @param {Object} [options] Options object
	*/ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $9a54cbcfc1af41ba$var$parseAttributes(element, FabricText.ATTRIBUTE_NAMES, cssRules);
        const { textAnchor: textAnchor = $9a54cbcfc1af41ba$var$LEFT, textDecoration: textDecoration = "", dx: dx = 0, dy: dy = 0, top: top = 0, left: left = 0, fontSize: fontSize = 16, strokeWidth: strokeWidth = 1, ...restOfOptions } = {
            ...options,
            ...parsedAttributes
        };
        const textContent = $9a54cbcfc1af41ba$var$normalizeWs(element.textContent || "").trim();
        const text = new this(textContent, {
            left: left + dx,
            top: top + dy,
            underline: textDecoration.includes("underline"),
            overline: textDecoration.includes("overline"),
            linethrough: textDecoration.includes("line-through"),
            strokeWidth: 0,
            fontSize: fontSize,
            ...restOfOptions
        }), textHeightScaleFactor = text.getScaledHeight() / text.height, scaledDiff = ((text.height + text.strokeWidth) * text.lineHeight - text.height) * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff;
        let offX = 0;
        if (textAnchor === "center") offX = text.getScaledWidth() / 2;
        if (textAnchor === "right") offX = text.getScaledWidth();
        text.set({
            left: text.left - offX,
            top: text.top - (textHeight - text.fontSize * (.07 + text._fontSizeFraction)) / text.lineHeight,
            strokeWidth: strokeWidth
        });
        return text;
    }
    /**
	* Returns FabricText instance from an object representation
	* @param {Object} object plain js Object to create an instance from
	* @returns {Promise<FabricText>}
	*/ static fromObject(object) {
        return this._fromObject({
            ...object,
            styles: $9a54cbcfc1af41ba$var$stylesFromArray(object.styles || {}, object.text)
        }, {
            extraParam: "text"
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "textLayoutProperties", $9a54cbcfc1af41ba$var$textLayoutProperties);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$additionalProps
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "ownDefaults", $9a54cbcfc1af41ba$var$textDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "type", "Text");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "genericFonts", [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$72cf63a35cb577f7, "ATTRIBUTE_NAMES", $9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES.concat("x", "y", "dx", "dy", "font-family", "font-style", "font-weight", "font-size", "letter-spacing", "text-decoration", "text-decoration-thickness", "text-decoration-color", "text-anchor"));
$9a54cbcfc1af41ba$var$applyMixins($9a54cbcfc1af41ba$export$72cf63a35cb577f7, [
    $9a54cbcfc1af41ba$var$TextSVGExportMixin
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$72cf63a35cb577f7);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$72cf63a35cb577f7);
//#endregion
//#region src/shapes/IText/DraggableTextDelegate.ts
/**
* #### Dragging IText/Textbox Lifecycle
* - {@link start} is called from `mousedown` {@link IText#_mouseDownHandler} and determines if dragging should start by testing {@link isPointerOverSelection}
* - if true `mousedown` {@link IText#_mouseDownHandler} is blocked to keep selection
* - if the pointer moves, canvas fires numerous mousemove {@link Canvas#_onMouseMove} that we make sure **aren't** prevented ({@link IText#shouldStartDragging}) in order for the window to start a drag session
* - once/if the session starts canvas calls {@link onDragStart} on the active object to determine if dragging should occur
* - canvas fires relevant drag events that are handled by the handlers defined in this scope
* - {@link end} is called from `mouseup` {@link IText#mouseUpHandler}, blocking IText default click behavior
* - in case the drag session didn't occur, {@link end} handles a click, since logic to do so was blocked during `mousedown`
*/ var $9a54cbcfc1af41ba$var$DraggableTextDelegate = class {
    constructor(target){
        $9a54cbcfc1af41ba$var$_defineProperty(this, "target", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__mouseDownInPlace", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__dragStartFired", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__isDraggingOver", false);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__dragStartSelection", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "__dragImageDisposer", void 0);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_dispose", void 0);
        this.target = target;
        const disposers = [
            this.target.on("dragenter", this.dragEnterHandler.bind(this)),
            this.target.on("dragover", this.dragOverHandler.bind(this)),
            this.target.on("dragleave", this.dragLeaveHandler.bind(this)),
            this.target.on("dragend", this.dragEndHandler.bind(this)),
            this.target.on("drop", this.dropHandler.bind(this))
        ];
        this._dispose = ()=>{
            disposers.forEach((d)=>d());
            this._dispose = void 0;
        };
    }
    isPointerOverSelection(e) {
        const target = this.target;
        const newSelection = target.getSelectionStartFromPointer(e);
        return target.isEditing && newSelection >= target.selectionStart && newSelection <= target.selectionEnd && target.selectionStart < target.selectionEnd;
    }
    /**
	* @public override this method to disable dragging and default to mousedown logic
	*/ start(e) {
        return this.__mouseDownInPlace = this.isPointerOverSelection(e);
    }
    /**
	* @public override this method to disable dragging without discarding selection
	*/ isActive() {
        return this.__mouseDownInPlace;
    }
    /**
	* Ends interaction and sets cursor in case of a click
	* @returns true if was active
	*/ end(e) {
        const active = this.isActive();
        if (active && !this.__dragStartFired) {
            this.target.setCursorByClick(e);
            this.target.initDelayedCursor(true);
        }
        this.__mouseDownInPlace = false;
        this.__dragStartFired = false;
        this.__isDraggingOver = false;
        return active;
    }
    getDragStartSelection() {
        return this.__dragStartSelection;
    }
    /**
	* Override to customize the drag image
	* https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage
	*/ setDragImage(e, { selectionStart: selectionStart, selectionEnd: selectionEnd }) {
        var _e$dataTransfer;
        const target = this.target;
        const canvas = target.canvas;
        const flipFactor = new $9a54cbcfc1af41ba$export$baf26146a414f24a(target.flipX ? -1 : 1, target.flipY ? -1 : 1);
        const boundaries = target._getCursorBoundaries(selectionStart);
        const pos = new $9a54cbcfc1af41ba$export$baf26146a414f24a(boundaries.left + boundaries.leftOffset, boundaries.top + boundaries.topOffset).multiply(flipFactor).transform(target.calcTransformMatrix());
        const diff = canvas.getScenePoint(e).subtract(pos);
        const retinaScaling = target.getCanvasRetinaScaling();
        const bbox = target.getBoundingRect();
        const correction = pos.subtract(new $9a54cbcfc1af41ba$export$baf26146a414f24a(bbox.left, bbox.top));
        const vpt = canvas.viewportTransform;
        const offset = correction.add(diff).transform(vpt, true);
        const bgc = target.backgroundColor;
        const styles = $9a54cbcfc1af41ba$var$cloneStyles(target.styles);
        target.backgroundColor = "";
        const styleOverride = {
            stroke: "transparent",
            fill: "transparent",
            textBackgroundColor: "transparent"
        };
        target.setSelectionStyles(styleOverride, 0, selectionStart);
        target.setSelectionStyles(styleOverride, selectionEnd, target.text.length);
        target.dirty = true;
        const dragImage = target.toCanvasElement({
            enableRetinaScaling: canvas.enableRetinaScaling,
            viewportTransform: true
        });
        target.backgroundColor = bgc;
        target.styles = styles;
        target.dirty = true;
        $9a54cbcfc1af41ba$var$setStyle(dragImage, {
            position: "fixed",
            left: `${-dragImage.width}px`,
            border: $9a54cbcfc1af41ba$var$NONE,
            width: `${dragImage.width / retinaScaling}px`,
            height: `${dragImage.height / retinaScaling}px`
        });
        this.__dragImageDisposer && this.__dragImageDisposer();
        this.__dragImageDisposer = ()=>{
            dragImage.remove();
        };
        $9a54cbcfc1af41ba$var$getDocumentFromElement(e.target || this.target.hiddenTextarea).body.appendChild(dragImage);
        (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || _e$dataTransfer.setDragImage(dragImage, offset.x, offset.y);
    }
    /**
	* @returns {boolean} determines whether {@link target} should/shouldn't become a drag source
	*/ onDragStart(e) {
        this.__dragStartFired = true;
        const target = this.target;
        const active = this.isActive();
        if (active && e.dataTransfer) {
            const selection = this.__dragStartSelection = {
                selectionStart: target.selectionStart,
                selectionEnd: target.selectionEnd
            };
            const value = target._text.slice(selection.selectionStart, selection.selectionEnd).join("");
            const data = {
                text: target.text,
                value: value,
                ...selection
            };
            e.dataTransfer.setData("text/plain", value);
            e.dataTransfer.setData("application/fabric", JSON.stringify({
                value: value,
                styles: target.getSelectionStyles(selection.selectionStart, selection.selectionEnd, true)
            }));
            e.dataTransfer.effectAllowed = "copyMove";
            this.setDragImage(e, data);
        }
        target.abortCursorAnimation();
        return active;
    }
    /**
	* use {@link targetCanDrop} to respect overriding
	* @returns {boolean} determines whether {@link target} should/shouldn't become a drop target
	*/ canDrop(e) {
        if (this.target.editable && !this.target.getActiveControl() && !e.defaultPrevented) {
            if (this.isActive() && this.__dragStartSelection) {
                const index = this.target.getSelectionStartFromPointer(e);
                const dragStartSelection = this.__dragStartSelection;
                return index < dragStartSelection.selectionStart || index > dragStartSelection.selectionEnd;
            }
            return true;
        }
        return false;
    }
    /**
	* in order to respect overriding {@link IText#canDrop} we call that instead of calling {@link canDrop} directly
	*/ targetCanDrop(e) {
        return this.target.canDrop(e);
    }
    dragEnterHandler({ e: e }) {
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
    }
    dragOverHandler(ev) {
        const { e: e } = ev;
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
        else if (this.__isDraggingOver && !canDrop) this.__isDraggingOver = false;
        if (this.__isDraggingOver) {
            e.preventDefault();
            ev.canDrop = true;
            ev.dropTarget = this.target;
        }
    }
    dragLeaveHandler() {
        if (this.__isDraggingOver || this.isActive()) this.__isDraggingOver = false;
    }
    /**
	* Override the `text/plain | application/fabric` types of {@link DragEvent#dataTransfer}
	* in order to change the drop value or to customize styling respectively, by listening to the `drop:before` event
	* https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#performing_a_drop
	*/ dropHandler(ev) {
        var _e$dataTransfer2;
        const { e: e } = ev;
        const didDrop = e.defaultPrevented;
        this.__isDraggingOver = false;
        e.preventDefault();
        let insert = (_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : _e$dataTransfer2.getData("text/plain");
        if (insert && !didDrop) {
            const target = this.target;
            const canvas = target.canvas;
            let insertAt = target.getSelectionStartFromPointer(e);
            const { styles: styles } = e.dataTransfer.types.includes("application/fabric") ? JSON.parse(e.dataTransfer.getData("application/fabric")) : {};
            const trailing = insert[Math.max(0, insert.length - 1)];
            const selectionStartOffset = 0;
            if (this.__dragStartSelection) {
                const selectionStart = this.__dragStartSelection.selectionStart;
                const selectionEnd = this.__dragStartSelection.selectionEnd;
                if (insertAt > selectionStart && insertAt <= selectionEnd) insertAt = selectionStart;
                else if (insertAt > selectionEnd) insertAt -= selectionEnd - selectionStart;
                target.removeChars(selectionStart, selectionEnd);
                delete this.__dragStartSelection;
            }
            if (target._reNewline.test(trailing) && (target._reNewline.test(target._text[insertAt]) || insertAt === target._text.length)) insert = insert.trimEnd();
            ev.didDrop = true;
            ev.dropTarget = target;
            target.insertChars(insert, styles, insertAt);
            canvas.setActiveObject(target);
            target.enterEditing(e);
            target.selectionStart = Math.min(insertAt + selectionStartOffset, target._text.length);
            target.selectionEnd = Math.min(target.selectionStart + insert.length, target._text.length);
            target.hiddenTextarea.value = target.text;
            target._updateTextarea();
            target.hiddenTextarea.focus();
            target.fire($9a54cbcfc1af41ba$var$CHANGED, {
                index: insertAt + selectionStartOffset,
                action: "drop"
            });
            canvas.fire("text:changed", {
                target: target
            });
            canvas.contextTopDirty = true;
            canvas.requestRenderAll();
        }
    }
    /**
	* fired only on the drag source after drop (if occurred)
	* handle changes to the drag source in case of a drop on another object or a cancellation
	* https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
	*/ dragEndHandler({ e: e }) {
        if (this.isActive() && this.__dragStartFired) {
            if (this.__dragStartSelection) {
                var _e$dataTransfer3;
                const target = this.target;
                const canvas = this.target.canvas;
                const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.__dragStartSelection;
                const dropEffect = ((_e$dataTransfer3 = e.dataTransfer) === null || _e$dataTransfer3 === void 0 ? void 0 : _e$dataTransfer3.dropEffect) || "none";
                if (dropEffect === "none") {
                    target.selectionStart = selectionStart;
                    target.selectionEnd = selectionEnd;
                    target._updateTextarea();
                    target.hiddenTextarea.focus();
                } else {
                    target.clearContextTop();
                    if (dropEffect === "move") {
                        target.removeChars(selectionStart, selectionEnd);
                        target.selectionStart = target.selectionEnd = selectionStart;
                        target.hiddenTextarea && (target.hiddenTextarea.value = target.text);
                        target._updateTextarea();
                        target.fire($9a54cbcfc1af41ba$var$CHANGED, {
                            index: selectionStart,
                            action: "dragend"
                        });
                        canvas.fire("text:changed", {
                            target: target
                        });
                        canvas.requestRenderAll();
                    }
                    target.exitEditing();
                }
            }
        }
        this.__dragImageDisposer && this.__dragImageDisposer();
        delete this.__dragImageDisposer;
        delete this.__dragStartSelection;
        this.__isDraggingOver = false;
    }
    dispose() {
        this._dispose && this._dispose();
    }
};
//#endregion
//#region src/shapes/IText/ITextBehavior.ts
/**
*  extend this regex to support non english languages
*
*  - ` `      Matches a SPACE character (char code 32).
*  - `\n`     Matches a LINE FEED character (char code 10).
*  - `\.`     Matches a "." character (char code 46).
*  - `,`      Matches a "," character (char code 44).
*  - `;`      Matches a ";" character (char code 59).
*  - `!`      Matches a "!" character (char code 33).
*  - `\?`     Matches a "?" character (char code 63).
*  - `\-`     Matches a "-" character (char code 45).
*/ const $9a54cbcfc1af41ba$var$reNonWord = /[ \n\.,;!\?\-]/;
var $9a54cbcfc1af41ba$var$ITextBehavior = class extends $9a54cbcfc1af41ba$export$72cf63a35cb577f7 {
    constructor(..._args){
        super(..._args);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_currentCursorOpacity", 1);
    }
    /**
	* Initializes all the interactive behavior of IText
	*/ initBehavior() {
        this._tick = this._tick.bind(this);
        this._onTickComplete = this._onTickComplete.bind(this);
        this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(options) {
        this.isEditing && this.exitEditing();
        this.selected = false;
        return super.onDeselect(options);
    }
    /**
	* @private
	*/ _animateCursor({ toValue: toValue, duration: duration, delay: delay, onComplete: onComplete }) {
        return $9a54cbcfc1af41ba$var$animate({
            startValue: this._currentCursorOpacity,
            endValue: toValue,
            duration: duration,
            delay: delay,
            onComplete: onComplete,
            abort: ()=>!this.canvas || this.selectionStart !== this.selectionEnd,
            onChange: (value)=>{
                this._currentCursorOpacity = value;
                this.renderCursorOrSelection();
            }
        });
    }
    /**
	* changes the cursor from visible to invisible
	*/ _tick(delay) {
        this._currentTickState = this._animateCursor({
            toValue: 0,
            duration: this.cursorDuration / 2,
            delay: Math.max(delay || 0, 100),
            onComplete: this._onTickComplete
        });
    }
    /**
	* Changes the cursor from invisible to visible
	*/ _onTickComplete() {
        var _this$_currentTickCom;
        (_this$_currentTickCom = this._currentTickCompleteState) === null || _this$_currentTickCom === void 0 || _this$_currentTickCom.abort();
        this._currentTickCompleteState = this._animateCursor({
            toValue: 1,
            duration: this.cursorDuration,
            onComplete: this._tick
        });
    }
    /**
	* Initializes delayed cursor
	*/ initDelayedCursor(restart) {
        this.abortCursorAnimation();
        this._tick(restart ? 0 : this.cursorDelay);
    }
    /**
	* Aborts cursor animation, clears all timeouts and clear textarea context if necessary
	*/ abortCursorAnimation() {
        let shouldClear = false;
        [
            this._currentTickState,
            this._currentTickCompleteState
        ].forEach((cursorAnimation)=>{
            if (cursorAnimation && !cursorAnimation.isDone()) {
                shouldClear = true;
                cursorAnimation.abort();
            }
        });
        this._currentCursorOpacity = 1;
        if (shouldClear) this.clearContextTop();
    }
    /**
	* Restart tue cursor animation if either is in complete state ( between animations )
	* or if it never started before
	*/ restartCursorIfNeeded() {
        if ([
            this._currentTickState,
            this._currentTickCompleteState
        ].some((cursorAnimation)=>!cursorAnimation || cursorAnimation.isDone())) this.initDelayedCursor();
    }
    /**
	* Selects entire text
	*/ selectAll() {
        this.selectionStart = 0;
        this.selectionEnd = this._text.length;
        this._fireSelectionChanged();
        this._updateTextarea();
        return this;
    }
    /**
	* Selects entire text and updates the visual state
	*/ cmdAll() {
        this.selectAll();
        this.renderCursorOrSelection();
    }
    /**
	* Returns selected text
	* @return {String}
	*/ getSelectedText() {
        return this._text.slice(this.selectionStart, this.selectionEnd).join("");
    }
    /**
	* Find new selection index representing start of current word according to current selection index
	* @param {Number} startFrom Current selection index
	* @return {Number} New selection index
	*/ findWordBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index--;
        }
        while(/\S/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
	* Find new selection index representing end of current word according to current selection index
	* @param {Number} startFrom Current selection index
	* @return {Number} New selection index
	*/ findWordBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index++;
        }
        while(/\S/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
	* Find new selection index representing start of current line according to current selection index
	* @param {Number} startFrom Current selection index
	* @return {Number} New selection index
	*/ findLineBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        while(!/\n/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
	* Find new selection index representing end of current line according to current selection index
	* @param {Number} startFrom Current selection index
	* @return {Number} New selection index
	*/ findLineBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        while(!/\n/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
	* Finds index corresponding to beginning or end of a word
	* @param {Number} selectionStart Index of a character
	* @param {Number} direction 1 or -1
	* @return {Number} Index of the beginning or end of a word
	*/ searchWordBoundary(selectionStart, direction) {
        const text = this._text;
        let index = selectionStart > 0 && this._reSpace.test(text[selectionStart]) && (direction === -1 || !$9a54cbcfc1af41ba$var$reNewline.test(text[selectionStart - 1])) ? selectionStart - 1 : selectionStart, _char = text[index];
        while(index > 0 && index < text.length && !$9a54cbcfc1af41ba$var$reNonWord.test(_char)){
            index += direction;
            _char = text[index];
        }
        if (direction === -1 && $9a54cbcfc1af41ba$var$reNonWord.test(_char)) index++;
        return index;
    }
    /**
	* Selects the word that contains the char at index selectionStart
	* @param {Number} selectionStart Index of a character
	*/ selectWord(selectionStart) {
        var _selectionStart;
        selectionStart = (_selectionStart = selectionStart) !== null && _selectionStart !== void 0 ? _selectionStart : this.selectionStart;
        const newSelectionStart = this.searchWordBoundary(selectionStart, -1), newSelectionEnd = Math.max(newSelectionStart, this.searchWordBoundary(selectionStart, 1));
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
        this.renderCursorOrSelection();
    }
    /**
	* Selects the line that contains selectionStart
	* @param {Number} selectionStart Index of a character
	*/ selectLine(selectionStart) {
        var _selectionStart2;
        selectionStart = (_selectionStart2 = selectionStart) !== null && _selectionStart2 !== void 0 ? _selectionStart2 : this.selectionStart;
        const newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
    }
    /**
	* Enters editing state
	*/ enterEditing(e) {
        if (this.isEditing || !this.editable) return;
        this.enterEditingImpl();
        this.fire("editing:entered", e ? {
            e: e
        } : void 0);
        this._fireSelectionChanged();
        if (this.canvas) {
            this.canvas.fire("text:editing:entered", {
                target: this,
                e: e
            });
            this.canvas.requestRenderAll();
        }
    }
    /**
	* runs the actual logic that enter from editing state, see {@link enterEditing}
	*/ enterEditingImpl() {
        if (this.canvas) {
            this.canvas.calcOffset();
            this.canvas.textEditingManager.exitTextEditing();
        }
        this.isEditing = true;
        this.initHiddenTextarea();
        this.hiddenTextarea.focus();
        this.hiddenTextarea.value = this.text;
        this._updateTextarea();
        this._saveEditingProps();
        this._setEditingProps();
        this._textBeforeEdit = this.text;
        this._tick();
    }
    /**
	* called by {@link Canvas#textEditingManager}
	*/ updateSelectionOnMouseMove(e) {
        if (this.getActiveControl()) return;
        const el = this.hiddenTextarea;
        $9a54cbcfc1af41ba$var$getDocumentFromElement(el).activeElement !== el && el.focus();
        const newSelectionStart = this.getSelectionStartFromPointer(e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
        if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) return;
        if (newSelectionStart > this.__selectionStartOnMouseDown) {
            this.selectionStart = this.__selectionStartOnMouseDown;
            this.selectionEnd = newSelectionStart;
        } else {
            this.selectionStart = newSelectionStart;
            this.selectionEnd = this.__selectionStartOnMouseDown;
        }
        if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
        }
    }
    /**
	* @private
	*/ _setEditingProps() {
        this.hoverCursor = "text";
        if (this.canvas) this.canvas.defaultCursor = this.canvas.moveCursor = "text";
        this.borderColor = this.editingBorderColor;
        this.hasControls = this.selectable = false;
        this.lockMovementX = this.lockMovementY = true;
    }
    /**
	* convert from textarea to grapheme indexes
	*/ fromStringToGraphemeSelection(start, end, text) {
        const smallerTextStart = text.slice(0, start), graphemeStart = this.graphemeSplit(smallerTextStart).length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        const smallerTextEnd = text.slice(start, end);
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + this.graphemeSplit(smallerTextEnd).length
        };
    }
    /**
	* convert from fabric to textarea values
	*/ fromGraphemeToStringSelection(start, end, graphemes) {
        const graphemeStart = graphemes.slice(0, start).join("").length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + graphemes.slice(start, end).join("").length
        };
    }
    /**
	* @private
	*/ _updateTextarea() {
        this.cursorOffsetCache = {};
        if (!this.hiddenTextarea) return;
        if (!this.inCompositionMode) {
            const newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
            this.hiddenTextarea.selectionStart = newSelection.selectionStart;
            this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
        }
        this.updateTextareaPosition();
    }
    /**
	* This function updates the text value from the hidden textarea and recalculates the text bounding box
	* size and position.
	* It is called by fabricJS internals, do not use it directly.
	* @private
	*/ updateFromTextArea() {
        const { hiddenTextarea: hiddenTextarea, direction: direction, textAlign: textAlign, inCompositionMode: inCompositionMode } = this;
        if (!hiddenTextarea) return;
        const anchorX = textAlign !== "justify" ? textAlign.replace("justify-", "") : direction === "ltr" ? $9a54cbcfc1af41ba$var$LEFT : $9a54cbcfc1af41ba$var$RIGHT;
        const originalPosition = this.getPositionByOrigin(anchorX, "top");
        this.cursorOffsetCache = {};
        this.text = hiddenTextarea.value;
        this.set("dirty", true);
        this.initDimensions();
        this.setPositionByOrigin(originalPosition, anchorX, "top");
        this.setCoords();
        const newSelection = this.fromStringToGraphemeSelection(hiddenTextarea.selectionStart, hiddenTextarea.selectionEnd, hiddenTextarea.value);
        this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
        if (!inCompositionMode) this.selectionStart = newSelection.selectionStart;
        this.updateTextareaPosition();
    }
    /**
	* @private
	*/ updateTextareaPosition() {
        if (this.selectionStart === this.selectionEnd) {
            const style = this._calcTextareaPosition();
            this.hiddenTextarea.style.left = style.left;
            this.hiddenTextarea.style.top = style.top;
        }
    }
    /**
	* @private
	* @return {Object} style contains style for hiddenTextarea
	*/ _calcTextareaPosition() {
        if (!this.canvas) return {
            left: "1px",
            top: "1px"
        };
        const desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize") * this.lineHeight, leftOffset = boundaries.leftOffset, retinaScaling = this.getCanvasRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight;
        const p = new $9a54cbcfc1af41ba$export$baf26146a414f24a(boundaries.left + leftOffset, boundaries.top + boundaries.topOffset + charHeight).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new $9a54cbcfc1af41ba$export$baf26146a414f24a(upperCanvas.clientWidth / upperCanvasWidth, upperCanvas.clientHeight / upperCanvasHeight));
        if (p.x < 0) p.x = 0;
        if (p.x > maxWidth) p.x = maxWidth;
        if (p.y < 0) p.y = 0;
        if (p.y > maxHeight) p.y = maxHeight;
        p.x += this.canvas._offset.left;
        p.y += this.canvas._offset.top;
        return {
            left: `${p.x}px`,
            top: `${p.y}px`,
            fontSize: `${charHeight}px`,
            charHeight: charHeight
        };
    }
    /**
	* @private
	*/ _saveEditingProps() {
        this._savedProps = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            lockMovementX: this.lockMovementX,
            lockMovementY: this.lockMovementY,
            hoverCursor: this.hoverCursor,
            selectable: this.selectable,
            defaultCursor: this.canvas && this.canvas.defaultCursor,
            moveCursor: this.canvas && this.canvas.moveCursor
        };
    }
    /**
	* @private
	*/ _restoreEditingProps() {
        if (!this._savedProps) return;
        this.hoverCursor = this._savedProps.hoverCursor;
        this.hasControls = this._savedProps.hasControls;
        this.borderColor = this._savedProps.borderColor;
        this.selectable = this._savedProps.selectable;
        this.lockMovementX = this._savedProps.lockMovementX;
        this.lockMovementY = this._savedProps.lockMovementY;
        if (this.canvas) {
            this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor;
            this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor;
        }
        delete this._savedProps;
    }
    /**
	* runs the actual logic that exits from editing state, see {@link exitEditing}
	* But it does not fire events
	*/ exitEditingImpl() {
        const hiddenTextarea = this.hiddenTextarea;
        this.selected = false;
        this.isEditing = false;
        if (hiddenTextarea) {
            hiddenTextarea.blur && hiddenTextarea.blur();
            hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
        }
        this.hiddenTextarea = null;
        this.abortCursorAnimation();
        this.selectionStart !== this.selectionEnd && this.clearContextTop();
        this.selectionEnd = this.selectionStart;
        this._restoreEditingProps();
        if (this._forceClearCache) {
            this.initDimensions();
            this.setCoords();
        }
    }
    /**
	* Exits from editing state and fires relevant events
	*/ exitEditing() {
        const isTextChanged = this._textBeforeEdit !== this.text;
        this.exitEditingImpl();
        this.fire("editing:exited");
        isTextChanged && this.fire("modified");
        if (this.canvas) {
            this.canvas.fire("text:editing:exited", {
                target: this
            });
            isTextChanged && this.canvas.fire("object:modified", {
                target: this
            });
        }
        return this;
    }
    /**
	* @private
	*/ _removeExtraneousStyles() {
        for(const prop in this.styles)if (!this._textLines[prop]) delete this.styles[prop];
    }
    /**
	* remove and reflow a style block from start to end.
	* @param {Number} start linear start position for removal (included in removal)
	* @param {Number} end linear end position for removal ( excluded from removal )
	*/ removeStyleFromTo(start, end) {
        const { lineIndex: lineStart, charIndex: charStart } = this.get2DCursorLocation(start, true), { lineIndex: lineEnd, charIndex: charEnd } = this.get2DCursorLocation(end, true);
        if (lineStart !== lineEnd) {
            if (this.styles[lineStart]) for(let i = charStart; i < this._unwrappedTextLines[lineStart].length; i++)delete this.styles[lineStart][i];
            if (this.styles[lineEnd]) for(let i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++){
                const styleObj = this.styles[lineEnd][i];
                if (styleObj) {
                    this.styles[lineStart] || (this.styles[lineStart] = {});
                    this.styles[lineStart][charStart + i - charEnd] = styleObj;
                }
            }
            for(let i = lineStart + 1; i <= lineEnd; i++)delete this.styles[i];
            this.shiftLineStyles(lineEnd, lineStart - lineEnd);
        } else if (this.styles[lineStart]) {
            const styleObj = this.styles[lineStart];
            const diff = charEnd - charStart;
            for(let i = charStart; i < charEnd; i++)delete styleObj[i];
            for(const char in this.styles[lineStart]){
                const numericChar = parseInt(char, 10);
                if (numericChar >= charEnd) {
                    styleObj[numericChar - diff] = styleObj[char];
                    delete styleObj[char];
                }
            }
        }
    }
    /**
	* Shifts line styles up or down
	* @param {Number} lineIndex Index of a line
	* @param {Number} offset Can any number?
	*/ shiftLineStyles(lineIndex, offset) {
        const clonedStyles = Object.assign({}, this.styles);
        for(const line in this.styles){
            const numericLine = parseInt(line, 10);
            if (numericLine > lineIndex) {
                this.styles[numericLine + offset] = clonedStyles[numericLine];
                if (!clonedStyles[numericLine - offset]) delete this.styles[numericLine];
            }
        }
    }
    /**
	* Handle insertion of more consecutive style lines for when one or more
	* newlines gets added to the text. Since current style needs to be shifted
	* first we shift the current style of the number lines needed, then we add
	* new lines from the last to the first.
	* @param {Number} lineIndex Index of a line
	* @param {Number} charIndex Index of a char
	* @param {Number} qty number of lines to add
	* @param {Array} copiedStyle Array of objects styles
	*/ insertNewlineStyleObject(lineIndex, charIndex, qty, copiedStyle) {
        const newLineStyles = {};
        const originalLineLength = this._unwrappedTextLines[lineIndex].length;
        const isEndOfLine = originalLineLength === charIndex;
        let someStyleIsCarryingOver = false;
        qty || (qty = 1);
        this.shiftLineStyles(lineIndex, qty);
        const currentCharStyle = this.styles[lineIndex] ? this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1] : void 0;
        for(const index in this.styles[lineIndex]){
            const numIndex = parseInt(index, 10);
            if (numIndex >= charIndex) {
                someStyleIsCarryingOver = true;
                newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
                if (!(isEndOfLine && charIndex === 0)) delete this.styles[lineIndex][index];
            }
        }
        let styleCarriedOver = false;
        if (someStyleIsCarryingOver && !isEndOfLine) {
            this.styles[lineIndex + qty] = newLineStyles;
            styleCarriedOver = true;
        }
        if (styleCarriedOver || originalLineLength > charIndex) qty--;
        while(qty > 0){
            if (copiedStyle && copiedStyle[qty - 1]) this.styles[lineIndex + qty] = {
                0: {
                    ...copiedStyle[qty - 1]
                }
            };
            else if (currentCharStyle) this.styles[lineIndex + qty] = {
                0: {
                    ...currentCharStyle
                }
            };
            else delete this.styles[lineIndex + qty];
            qty--;
        }
        this._forceClearCache = true;
    }
    /**
	* Inserts style object for a given line/char index
	* @param {Number} lineIndex Index of a line
	* @param {Number} charIndex Index of a char
	* @param {Number} quantity number Style object to insert, if given
	* @param {Array} copiedStyle array of style objects
	*/ insertCharStyleObject(lineIndex, charIndex, quantity, copiedStyle) {
        if (!this.styles) this.styles = {};
        const currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? {
            ...currentLineStyles
        } : {};
        quantity || (quantity = 1);
        for(const index in currentLineStylesCloned){
            const numericIndex = parseInt(index, 10);
            if (numericIndex >= charIndex) {
                currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                if (!currentLineStylesCloned[numericIndex - quantity]) delete currentLineStyles[numericIndex];
            }
        }
        this._forceClearCache = true;
        if (copiedStyle) {
            while(quantity--){
                if (!Object.keys(copiedStyle[quantity]).length) continue;
                if (!this.styles[lineIndex]) this.styles[lineIndex] = {};
                this.styles[lineIndex][charIndex + quantity] = {
                    ...copiedStyle[quantity]
                };
            }
            return;
        }
        if (!currentLineStyles) return;
        const newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
        while(newStyle && quantity--)this.styles[lineIndex][charIndex + quantity] = {
            ...newStyle
        };
    }
    /**
	* Inserts style object(s)
	* @param {Array} insertedText Characters at the location where style is inserted
	* @param {Number} start cursor index for inserting style
	* @param {Array} [copiedStyle] array of style objects to insert.
	*/ insertNewStyleBlock(insertedText, start, copiedStyle) {
        const cursorLoc = this.get2DCursorLocation(start, true), addedLines = [
            0
        ];
        let linesLength = 0;
        for(let i = 0; i < insertedText.length; i++)if (insertedText[i] === "\n") {
            linesLength++;
            addedLines[linesLength] = 0;
        } else addedLines[linesLength]++;
        if (addedLines[0] > 0) {
            this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
        }
        linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
        let i;
        for(i = 1; i < linesLength; i++){
            if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
            else if (copiedStyle) {
                if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
            }
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
        }
        if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
    }
    /**
	* Removes characters from start/end
	* start/end ar per grapheme position in _text array.
	*
	* @param {Number} start
	* @param {Number} end default to start + 1
	*/ removeChars(start, end = start + 1) {
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join("");
        this.set("dirty", true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
	* insert characters at start position, before start position.
	* start  equal 1 it means the text get inserted between actual grapheme 0 and 1
	* if style array is provided, it must be as the same length of text in graphemes
	* if end is provided and is bigger than start, old text is replaced.
	* start/end ar per grapheme position in _text array.
	*
	* @param {String} text text to insert
	* @param {Array} style array of style objects
	* @param {Number} start
	* @param {Number} end default to start + 1
	*/ insertChars(text, style, start, end = start) {
        if (end > start) this.removeStyleFromTo(start, end);
        const graphemes = this.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [
            ...this._text.slice(0, start),
            ...graphemes,
            ...this._text.slice(end)
        ];
        this.text = this._text.join("");
        this.set("dirty", true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
	* Set the selectionStart and selectionEnd according to the new position of cursor
	* mimic the key - mouse navigation when shift is pressed.
	*/ setSelectionStartEndWithShift(start, end, newSelection) {
        if (newSelection <= start) {
            if (end === start) this._selectionDirection = $9a54cbcfc1af41ba$var$LEFT;
            else if (this._selectionDirection === "right") {
                this._selectionDirection = $9a54cbcfc1af41ba$var$LEFT;
                this.selectionEnd = start;
            }
            this.selectionStart = newSelection;
        } else if (newSelection > start && newSelection < end) {
            if (this._selectionDirection === "right") this.selectionEnd = newSelection;
            else this.selectionStart = newSelection;
        } else {
            if (end === start) this._selectionDirection = $9a54cbcfc1af41ba$var$RIGHT;
            else if (this._selectionDirection === "left") {
                this._selectionDirection = $9a54cbcfc1af41ba$var$RIGHT;
                this.selectionStart = end;
            }
            this.selectionEnd = newSelection;
        }
    }
};
//#endregion
//#region src/shapes/IText/ITextKeyBehavior.ts
var $9a54cbcfc1af41ba$var$ITextKeyBehavior = class extends $9a54cbcfc1af41ba$var$ITextBehavior {
    /**
	* Initializes hidden textarea (needed to bring up keyboard in iOS)
	*/ initHiddenTextarea() {
        const doc = this.canvas && $9a54cbcfc1af41ba$var$getDocumentFromElement(this.canvas.getElement()) || $9a54cbcfc1af41ba$export$91e93c41e950ddbb();
        const textarea = doc.createElement("textarea");
        Object.entries({
            autocapitalize: "off",
            autocorrect: "off",
            autocomplete: "off",
            spellcheck: "false",
            "data-fabric": "textarea",
            wrap: "off",
            name: "fabricTextarea"
        }).map(([attribute, value])=>textarea.setAttribute(attribute, value));
        const { top: top, left: left, fontSize: fontSize } = this._calcTextareaPosition();
        textarea.style.cssText = `position: absolute; top: ${top}; left: ${left}; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ${fontSize};`;
        (this.hiddenTextareaContainer || doc.body).appendChild(textarea);
        Object.entries({
            blur: "blur",
            keydown: "onKeyDown",
            keyup: "onKeyUp",
            input: "onInput",
            copy: "copy",
            cut: "copy",
            paste: "paste",
            compositionstart: "onCompositionStart",
            compositionupdate: "onCompositionUpdate",
            compositionend: "onCompositionEnd"
        }).map(([eventName, handler])=>textarea.addEventListener(eventName, this[handler].bind(this)));
        this.hiddenTextarea = textarea;
    }
    /**
	* Override this method to customize cursor behavior on textbox blur
	*/ blur() {
        this.abortCursorAnimation();
    }
    /**
	* Handles keydown event
	* only used for arrows and combination of modifier keys.
	* @param {KeyboardEvent} e Event object
	*/ onKeyDown(e) {
        if (!this.isEditing) return;
        const keyMap = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) this[keyMap[e.keyCode]](e);
        else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapDown[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
            this.inCompositionMode = false;
            this.clearContextTop();
            this.renderCursorOrSelection();
        } else this.canvas && this.canvas.requestRenderAll();
    }
    /**
	* Handles keyup event
	* We handle KeyUp because ie11 and edge have difficulties copy/pasting
	* if a copy/cut event fired, keyup is dismissed
	* @param {KeyboardEvent} e Event object
	*/ onKeyUp(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
            this._copyDone = false;
            return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapUp[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
    }
    /**
	* Handles onInput event
	* @param {Event} e Event object
	*/ onInput(e) {
        const fromPaste = this.fromPaste;
        const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.hiddenTextarea;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) return;
        const updateAndFire = ()=>{
            this.updateFromTextArea();
            this.fire($9a54cbcfc1af41ba$var$CHANGED);
            if (this.canvas) {
                this.canvas.fire("text:changed", {
                    target: this
                });
                this.canvas.requestRenderAll();
            }
        };
        if (this.hiddenTextarea.value === "") {
            this.styles = {};
            updateAndFire();
            return;
        }
        const nextText = this._splitTextIntoLines(value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, _selectionStart = this.selectionStart, _selectionEnd = this.selectionEnd, selection = _selectionStart !== _selectionEnd;
        let copiedStyle, removedText, charDiff = nextCharCount - charCount, removeFrom, removeTo;
        const textareaSelection = this.fromStringToGraphemeSelection(selectionStart, selectionEnd, value);
        const backDelete = _selectionStart > textareaSelection.selectionStart;
        if (selection) {
            removedText = this._text.slice(_selectionStart, _selectionEnd);
            charDiff += _selectionEnd - _selectionStart;
        } else if (nextCharCount < charCount) {
            if (backDelete) removedText = this._text.slice(_selectionEnd + charDiff, _selectionEnd);
            else removedText = this._text.slice(_selectionStart, _selectionStart - charDiff);
        }
        const insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
            if (insertedText.length) {
                copiedStyle = this.getSelectionStyles(_selectionStart, _selectionStart + 1, false);
                copiedStyle = insertedText.map(()=>copiedStyle[0]);
            }
            if (selection) {
                removeFrom = _selectionStart;
                removeTo = _selectionEnd;
            } else if (backDelete) {
                removeFrom = _selectionEnd - removedText.length;
                removeTo = _selectionEnd;
            } else {
                removeFrom = _selectionEnd;
                removeTo = _selectionEnd + removedText.length;
            }
            this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
            const { copyPasteData: copyPasteData } = $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e();
            if (fromPaste && insertedText.join("") === copyPasteData.copiedText && !$9a54cbcfc1af41ba$export$e506a1d27d1eaa20.disableStyleCopyPaste) copiedStyle = copyPasteData.copiedTextStyle;
            this.insertNewStyleBlock(insertedText, _selectionStart, copiedStyle);
        }
        updateAndFire();
    }
    /**
	* Composition start
	*/ onCompositionStart() {
        this.inCompositionMode = true;
    }
    /**
	* Composition end
	*/ onCompositionEnd() {
        this.inCompositionMode = false;
    }
    onCompositionUpdate({ target: target }) {
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
        this.compositionStart = selectionStart;
        this.compositionEnd = selectionEnd;
        this.updateTextareaPosition();
    }
    /**
	* Copies selected text
	*/ copy() {
        if (this.selectionStart === this.selectionEnd) return;
        const { copyPasteData: copyPasteData } = $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e();
        copyPasteData.copiedText = this.getSelectedText();
        if (!$9a54cbcfc1af41ba$export$e506a1d27d1eaa20.disableStyleCopyPaste) copyPasteData.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        else copyPasteData.copiedTextStyle = void 0;
        this._copyDone = true;
    }
    /**
	* Pastes text
	*/ paste() {
        this.fromPaste = true;
    }
    /**
	* Finds the width in pixels before the cursor on the same line
	* @private
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @return {Number} widthBeforeCursor width before cursor
	*/ _getWidthBeforeCursor(lineIndex, charIndex) {
        let widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
            bound = this.__charBounds[lineIndex][charIndex - 1];
            widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
    }
    /**
	* Gets start offset of a selection
	* @param {KeyboardEvent} e Event object
	* @param {Boolean} isRight
	* @return {Number}
	*/ getDownCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) return this._text.length - selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor);
        return this._textLines[lineIndex].slice(charIndex).length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    }
    /**
	* private
	* Helps finding if the offset should be counted from Start or End
	* @param {KeyboardEvent} e Event object
	* @param {Boolean} isRight
	* @return {Number}
	*/ _getSelectionForOffset(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) return this.selectionEnd;
        else return this.selectionStart;
    }
    /**
	* @param {KeyboardEvent} e Event object
	* @param {Boolean} isRight
	* @return {Number}
	*/ getUpCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) return -selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    }
    /**
	* for a given width it founds the matching character.
	* @private
	*/ _getIndexOnLine(lineIndex, width) {
        const line = this._textLines[lineIndex];
        let widthOfCharsOnLine = this._getLineLeftOffset(lineIndex), indexOnLine = 0, charWidth, foundMatch;
        for(let j = 0, jlen = line.length; j < jlen; j++){
            charWidth = this.__charBounds[lineIndex][j].width;
            widthOfCharsOnLine += charWidth;
            if (widthOfCharsOnLine > width) {
                foundMatch = true;
                const leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width);
                indexOnLine = Math.abs(rightEdge - width) < offsetFromLeftEdge ? j : j - 1;
                break;
            }
        }
        if (!foundMatch) indexOnLine = line.length - 1;
        return indexOnLine;
    }
    /**
	* Moves cursor down
	* @param {KeyboardEvent} e Event object
	*/ moveCursorDown(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorUpOrDown("Down", e);
    }
    /**
	* Moves cursor up
	* @param {KeyboardEvent} e Event object
	*/ moveCursorUp(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorUpOrDown("Up", e);
    }
    /**
	* Moves cursor up or down, fires the events
	* @param {String} direction 'Up' or 'Down'
	* @param {KeyboardEvent} e Event object
	*/ _moveCursorUpOrDown(direction, e) {
        const offset = this[`get${direction}CursorOffset`](e, this._selectionDirection === $9a54cbcfc1af41ba$var$RIGHT);
        if (e.shiftKey) this.moveCursorWithShift(offset);
        else this.moveCursorWithoutShift(offset);
        if (offset !== 0) {
            const max = this.text.length;
            this.selectionStart = $9a54cbcfc1af41ba$var$capValue(0, this.selectionStart, max);
            this.selectionEnd = $9a54cbcfc1af41ba$var$capValue(0, this.selectionEnd, max);
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
	* Moves cursor with shift
	* @param {Number} offset
	*/ moveCursorWithShift(offset) {
        const newSelection = this._selectionDirection === "left" ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
    }
    /**
	* Moves cursor up without shift
	* @param {Number} offset
	*/ moveCursorWithoutShift(offset) {
        if (offset < 0) {
            this.selectionStart += offset;
            this.selectionEnd = this.selectionStart;
        } else {
            this.selectionEnd += offset;
            this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
    }
    /**
	* Moves cursor left
	* @param {KeyboardEvent} e Event object
	*/ moveCursorLeft(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorLeftOrRight("Left", e);
    }
    /**
	* @private
	* @return {Boolean} true if a change happened
	*
	* @todo refactor not to use method name composition
	*/ _move(e, prop, direction) {
        let newValue;
        if (e.altKey) newValue = this[`findWordBoundary${direction}`](this[prop]);
        else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) newValue = this[`findLineBoundary${direction}`](this[prop]);
        else {
            this[prop] += direction === "Left" ? -1 : 1;
            return true;
        }
        if (typeof newValue !== "undefined" && this[prop] !== newValue) {
            this[prop] = newValue;
            return true;
        }
        return false;
    }
    /**
	* @private
	*/ _moveLeft(e, prop) {
        return this._move(e, prop, "Left");
    }
    /**
	* @private
	*/ _moveRight(e, prop) {
        return this._move(e, prop, "Right");
    }
    /**
	* Moves cursor left without keeping selection
	* @param {KeyboardEvent} e
	*/ moveCursorLeftWithoutShift(e) {
        let change = true;
        this._selectionDirection = $9a54cbcfc1af41ba$var$LEFT;
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) change = this._moveLeft(e, "selectionStart");
        this.selectionEnd = this.selectionStart;
        return change;
    }
    /**
	* Moves cursor left while keeping selection
	* @param {KeyboardEvent} e
	*/ moveCursorLeftWithShift(e) {
        if (this._selectionDirection === "right" && this.selectionStart !== this.selectionEnd) return this._moveLeft(e, "selectionEnd");
        else if (this.selectionStart !== 0) {
            this._selectionDirection = $9a54cbcfc1af41ba$var$LEFT;
            return this._moveLeft(e, "selectionStart");
        }
    }
    /**
	* Moves cursor right
	* @param {KeyboardEvent} e Event object
	*/ moveCursorRight(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorLeftOrRight("Right", e);
    }
    /**
	* Moves cursor right or Left, fires event
	* @param {String} direction 'Left', 'Right'
	* @param {KeyboardEvent} e Event object
	*/ _moveCursorLeftOrRight(direction, e) {
        const actionName = `moveCursor${direction}${e.shiftKey ? "WithShift" : "WithoutShift"}`;
        this._currentCursorOpacity = 1;
        if (this[actionName](e)) {
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
	* Moves cursor right while keeping selection
	* @param {KeyboardEvent} e
	*/ moveCursorRightWithShift(e) {
        if (this._selectionDirection === "left" && this.selectionStart !== this.selectionEnd) return this._moveRight(e, "selectionStart");
        else if (this.selectionEnd !== this._text.length) {
            this._selectionDirection = $9a54cbcfc1af41ba$var$RIGHT;
            return this._moveRight(e, "selectionEnd");
        }
    }
    /**
	* Moves cursor right without keeping selection
	* @param {KeyboardEvent} e Event object
	*/ moveCursorRightWithoutShift(e) {
        let changed = true;
        this._selectionDirection = $9a54cbcfc1af41ba$var$RIGHT;
        if (this.selectionStart === this.selectionEnd) {
            changed = this._moveRight(e, "selectionStart");
            this.selectionEnd = this.selectionStart;
        } else this.selectionStart = this.selectionEnd;
        return changed;
    }
};
//#endregion
//#region src/shapes/IText/ITextClickBehavior.ts
/**
* `LEFT_CLICK === 0`
*/ const $9a54cbcfc1af41ba$var$notALeftClick = (e)=>!!e.button;
var $9a54cbcfc1af41ba$var$ITextClickBehavior = class extends $9a54cbcfc1af41ba$var$ITextKeyBehavior {
    constructor(..._args){
        super(..._args);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "draggableTextDelegate", void 0);
    }
    initBehavior() {
        this.on("mousedown", this._mouseDownHandler);
        this.on("mouseup", this.mouseUpHandler);
        this.on("mousedblclick", this.doubleClickHandler);
        this.on("mousetripleclick", this.tripleClickHandler);
        this.draggableTextDelegate = new $9a54cbcfc1af41ba$var$DraggableTextDelegate(this);
        super.initBehavior();
    }
    /**
	* If this method returns true a mouse move operation over a text selection
	* will not prevent the native mouse event allowing the browser to start a drag operation.
	* shouldStartDragging can be read 'do not prevent default for mouse move event'
	* To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
	* @returns
	*/ shouldStartDragging() {
        return this.draggableTextDelegate.isActive();
    }
    /**
	* @public override this method to control whether instance should/shouldn't become a drag source,
	* @see also {@link DraggableTextDelegate#isActive}
	* To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
	* @returns {boolean} should handle event
	*/ onDragStart(e) {
        return this.draggableTextDelegate.onDragStart(e);
    }
    /**
	* @public override this method to control whether instance should/shouldn't become a drop target
	*/ canDrop(e) {
        return this.draggableTextDelegate.canDrop(e);
    }
    /**
	* Default handler for double click, select a word
	*/ doubleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectWord(this.getSelectionStartFromPointer(options.e));
        this.renderCursorOrSelection();
    }
    /**
	* Default handler for triple click, select a line
	*/ tripleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectLine(this.getSelectionStartFromPointer(options.e));
        this.renderCursorOrSelection();
    }
    /**
	* Default event handler for the basic functionalities needed on _mouseDown
	* can be overridden to do something different.
	* Scope of this implementation is: find the click position, set selectionStart
	* find selectionEnd, initialize the drawing of either cursor or selection area
	* initializing a mousedDown on a text area will cancel fabricjs knowledge of
	* current compositionMode. It will be set to false.
	*/ _mouseDownHandler({ e: e, alreadySelected: alreadySelected }) {
        if (!this.canvas || !this.editable || $9a54cbcfc1af41ba$var$notALeftClick(e) || this.getActiveControl()) return;
        if (this.draggableTextDelegate.start(e)) return;
        this.canvas.textEditingManager.register(this);
        if (alreadySelected) {
            this.inCompositionMode = false;
            this.setCursorByClick(e);
        }
        if (this.isEditing) {
            this.__selectionStartOnMouseDown = this.selectionStart;
            if (this.selectionStart === this.selectionEnd) this.abortCursorAnimation();
            this.renderCursorOrSelection();
        }
        this.selected || (this.selected = alreadySelected || this.isEditing);
    }
    /**
	* standard handler for mouse up, overridable
	* @private
	*/ mouseUpHandler({ e: e, transform: transform }) {
        const didDrag = this.draggableTextDelegate.end(e);
        if (this.canvas) {
            this.canvas.textEditingManager.unregister(this);
            const activeObject = this.canvas._activeObject;
            if (activeObject && activeObject !== this) return;
        }
        if (!this.editable || this.group && !this.group.interactive || transform && transform.actionPerformed || $9a54cbcfc1af41ba$var$notALeftClick(e) || didDrag) return;
        if (this.selected && !this.getActiveControl()) {
            this.enterEditing(e);
            if (this.selectionStart === this.selectionEnd) this.initDelayedCursor(true);
            else this.renderCursorOrSelection();
        }
    }
    /**
	* Changes cursor location in a text depending on passed pointer (x/y) object
	* @param {TPointerEvent} e Event object
	*/ setCursorByClick(e) {
        const newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) this.setSelectionStartEndWithShift(start, end, newSelection);
        else {
            this.selectionStart = newSelection;
            this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
	* Returns index of a character corresponding to where an object was clicked
	* @param {TPointerEvent} e Event object
	* @return {Number} Index of a character
	*/ getSelectionStartFromPointer(e) {
        const mouseOffset = this.canvas.getScenePoint(e).transform($9a54cbcfc1af41ba$var$invertTransform(this.calcTransformMatrix())).add(new $9a54cbcfc1af41ba$export$baf26146a414f24a(-this._getLeftOffset(), -this._getTopOffset()));
        let height = 0, charIndex = 0, lineIndex = 0;
        for(let i = 0; i < this._textLines.length; i++)if (height <= mouseOffset.y) {
            height += this.getHeightOfLine(i);
            lineIndex = i;
            if (i > 0) charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
        } else break;
        let width = Math.abs(this._getLineLeftOffset(lineIndex));
        const charLength = this._textLines[lineIndex].length;
        const chars = this.__charBounds[lineIndex];
        for(let j = 0; j < charLength; j++){
            const charWidth = chars[j].kernedWidth;
            const widthAfter = width + charWidth;
            if (mouseOffset.x <= widthAfter) {
                if (Math.abs(mouseOffset.x - widthAfter) <= Math.abs(mouseOffset.x - width)) charIndex++;
                break;
            }
            width = widthAfter;
            charIndex++;
        }
        return Math.min(this.flipX ? charLength - charIndex : charIndex, this._text.length);
    }
};
//#endregion
//#region src/shapes/IText/constants.ts
const $9a54cbcfc1af41ba$var$MOVE_CURSOR_UP = "moveCursorUp";
const $9a54cbcfc1af41ba$var$MOVE_CURSOR_DOWN = "moveCursorDown";
const $9a54cbcfc1af41ba$var$MOVE_CURSOR_LEFT = "moveCursorLeft";
const $9a54cbcfc1af41ba$var$MOVE_CURSOR_RIGHT = "moveCursorRight";
const $9a54cbcfc1af41ba$var$EXIT_EDITING = "exitEditing";
const $9a54cbcfc1af41ba$var$keysMap = {
    9: $9a54cbcfc1af41ba$var$EXIT_EDITING,
    27: $9a54cbcfc1af41ba$var$EXIT_EDITING,
    33: $9a54cbcfc1af41ba$var$MOVE_CURSOR_UP,
    34: $9a54cbcfc1af41ba$var$MOVE_CURSOR_DOWN,
    35: $9a54cbcfc1af41ba$var$MOVE_CURSOR_RIGHT,
    36: $9a54cbcfc1af41ba$var$MOVE_CURSOR_LEFT,
    37: $9a54cbcfc1af41ba$var$MOVE_CURSOR_LEFT,
    38: $9a54cbcfc1af41ba$var$MOVE_CURSOR_UP,
    39: $9a54cbcfc1af41ba$var$MOVE_CURSOR_RIGHT,
    40: $9a54cbcfc1af41ba$var$MOVE_CURSOR_DOWN
};
const $9a54cbcfc1af41ba$var$keysMapRtl = {
    9: $9a54cbcfc1af41ba$var$EXIT_EDITING,
    27: $9a54cbcfc1af41ba$var$EXIT_EDITING,
    33: $9a54cbcfc1af41ba$var$MOVE_CURSOR_UP,
    34: $9a54cbcfc1af41ba$var$MOVE_CURSOR_DOWN,
    35: $9a54cbcfc1af41ba$var$MOVE_CURSOR_LEFT,
    36: $9a54cbcfc1af41ba$var$MOVE_CURSOR_RIGHT,
    37: $9a54cbcfc1af41ba$var$MOVE_CURSOR_RIGHT,
    38: $9a54cbcfc1af41ba$var$MOVE_CURSOR_UP,
    39: $9a54cbcfc1af41ba$var$MOVE_CURSOR_LEFT,
    40: $9a54cbcfc1af41ba$var$MOVE_CURSOR_DOWN
};
/**
* For functionalities on keyUp + ctrl || cmd
*/ const $9a54cbcfc1af41ba$var$ctrlKeysMapUp = {
    67: "copy",
    88: "cut"
};
/**
* For functionalities on keyDown + ctrl || cmd
*/ const $9a54cbcfc1af41ba$var$ctrlKeysMapDown = {
    65: "cmdAll"
};
//#endregion
//#region src/util/internals/applyCanvasTransform.ts
/**
* Set the transform of the passed context to the same of a specific Canvas or StaticCanvas.
* setTransform is used since this utility will RESET the ctx transform to the basic value
* of retina scaling and viewport transform
* It is not meant to be added to other transforms, it is used internally to preapre canvases to draw
* @param ctx
* @param canvas
*/ const $9a54cbcfc1af41ba$var$applyCanvasTransform = (ctx, canvas)=>{
    const scale = canvas.getRetinaScaling();
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    const v = canvas.viewportTransform;
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
};
const $9a54cbcfc1af41ba$var$iTextDefaultValues = {
    selectionStart: 0,
    selectionEnd: 0,
    selectionColor: "rgba(17,119,255,0.3)",
    isEditing: false,
    editable: true,
    editingBorderColor: "rgba(102,153,255,0.25)",
    cursorWidth: 2,
    cursorColor: "",
    cursorDelay: 1e3,
    cursorDuration: 600,
    caching: true,
    hiddenTextareaContainer: null,
    keysMap: $9a54cbcfc1af41ba$var$keysMap,
    keysMapRtl: $9a54cbcfc1af41ba$var$keysMapRtl,
    ctrlKeysMapDown: $9a54cbcfc1af41ba$var$ctrlKeysMapDown,
    ctrlKeysMapUp: $9a54cbcfc1af41ba$var$ctrlKeysMapUp,
    _selectionDirection: null,
    _reSpace: /\s|\r?\n/,
    inCompositionMode: false
};
/**
* @fires changed
* @fires selection:changed
* @fires editing:entered
* @fires editing:exited
* @fires dragstart
* @fires drag drag event firing on the drag source
* @fires dragend
* @fires copy
* @fires cut
* @fires paste
*
* #### Supported key combinations
* ```
*   Move cursor:                    left, right, up, down
*   Select character:               shift + left, shift + right
*   Select text vertically:         shift + up, shift + down
*   Move cursor by word:            alt + left, alt + right
*   Select words:                   shift + alt + left, shift + alt + right
*   Move cursor to line start/end:  cmd + left, cmd + right or home, end
*   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
*   Jump to start/end of text:      cmd + up, cmd + down
*   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
*   Delete character:               backspace
*   Delete word:                    alt + backspace
*   Delete line:                    cmd + backspace
*   Forward delete:                 delete
*   Copy text:                      ctrl/cmd + c
*   Paste text:                     ctrl/cmd + v
*   Cut text:                       ctrl/cmd + x
*   Select entire text:             ctrl/cmd + a
*   Quit editing                    tab or esc
* ```
*
* #### Supported mouse/touch combination
* ```
*   Position cursor:                click/touch
*   Create selection:               click/touch & drag
*   Create selection:               click & shift + click
*   Select word:                    double click
*   Select line:                    triple click
* ```
*/ var $9a54cbcfc1af41ba$export$6e837253f56cbab0 = class IText extends $9a54cbcfc1af41ba$var$ITextClickBehavior {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...IText.ownDefaults
        };
    }
    get type() {
        const type = super.type;
        return type === "itext" ? "i-text" : type;
    }
    /**
	* Constructor
	* @param {String} text Text string
	* @param {Object} [options] Options object
	*/ constructor(text, options){
        super(text, {
            ...IText.ownDefaults,
            ...options
        });
        this.initBehavior();
    }
    /**
	* While editing handle differently
	* @private
	* @param {string} key
	* @param {*} value
	*/ _set(key, value) {
        if (this.isEditing && this._savedProps && key in this._savedProps) {
            this._savedProps[key] = value;
            return this;
        }
        if (key === "canvas") {
            this.canvas instanceof $9a54cbcfc1af41ba$export$8d01c972ee8b14a9 && this.canvas.textEditingManager.remove(this);
            value instanceof $9a54cbcfc1af41ba$export$8d01c972ee8b14a9 && value.textEditingManager.add(this);
        }
        return super._set(key, value);
    }
    /**
	* Sets selection start (left boundary of a selection)
	* @param {Number} index Index to set selection start to
	*/ setSelectionStart(index) {
        index = Math.max(index, 0);
        this._updateAndFire("selectionStart", index);
    }
    /**
	* Sets selection end (right boundary of a selection)
	* @param {Number} index Index to set selection end to
	*/ setSelectionEnd(index) {
        index = Math.min(index, this.text.length);
        this._updateAndFire("selectionEnd", index);
    }
    /**
	* @private
	* @param {String} property 'selectionStart' or 'selectionEnd'
	* @param {Number} index new position of property
	*/ _updateAndFire(property, index) {
        if (this[property] !== index) {
            this._fireSelectionChanged();
            this[property] = index;
        }
        this._updateTextarea();
    }
    /**
	* Fires the even of selection changed
	* @private
	*/ _fireSelectionChanged() {
        this.fire("selection:changed");
        this.canvas && this.canvas.fire("text:selection:changed", {
            target: this
        });
    }
    /**
	* Initialize text dimensions. Render all text on given context
	* or on a offscreen canvas to get the text width with measureText.
	* Updates this.width and this.height with the proper values.
	* Does not return dimensions.
	* @private
	*/ initDimensions() {
        this.isEditing && this.initDelayedCursor();
        super.initDimensions();
    }
    /**
	* Gets style of a current selection/cursor (at the start position)
	* if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
	* @param {Number} startIndex Start index to get styles at
	* @param {Number} endIndex End index to get styles at, if not specified selectionEnd or startIndex + 1
	* @param {Boolean} [complete] get full style or not
	* @return {Array} styles an array with one, zero or more Style objects
	*/ getSelectionStyles(startIndex = this.selectionStart || 0, endIndex = this.selectionEnd, complete) {
        return super.getSelectionStyles(startIndex, endIndex, complete);
    }
    /**
	* Sets style of a current selection, if no selection exist, do not set anything.
	* @param {Object} [styles] Styles object
	* @param {Number} [startIndex] Start index to get styles at
	* @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
	*/ setSelectionStyles(styles, startIndex = this.selectionStart || 0, endIndex = this.selectionEnd) {
        return super.setSelectionStyles(styles, startIndex, endIndex);
    }
    /**
	* Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
	* @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
	* @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
	*/ get2DCursorLocation(selectionStart = this.selectionStart, skipWrapping) {
        return super.get2DCursorLocation(selectionStart, skipWrapping);
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ render(ctx) {
        super.render(ctx);
        this.cursorOffsetCache = {};
        this.renderCursorOrSelection();
    }
    /**
	* @override block cursor/selection logic while rendering the exported canvas
	* @todo this workaround should be replaced with a more robust solution
	*/ toCanvasElement(options) {
        const isEditing = this.isEditing;
        this.isEditing = false;
        const canvas = super.toCanvasElement(options);
        this.isEditing = isEditing;
        return canvas;
    }
    /**
	* Renders cursor or selection (depending on what exists)
	* it does on the contextTop. If contextTop is not available, do nothing.
	*/ renderCursorOrSelection() {
        if (!this.isEditing || !this.canvas) return;
        const ctx = this.clearContextTop(true);
        if (!ctx) return;
        const boundaries = this._getCursorBoundaries();
        const ancestors = this.findAncestorsWithClipPath();
        const hasAncestorsWithClipping = ancestors.length > 0;
        let drawingCtx = ctx;
        let drawingCanvas = void 0;
        if (hasAncestorsWithClipping) {
            drawingCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor(ctx.canvas);
            drawingCtx = drawingCanvas.getContext("2d");
            $9a54cbcfc1af41ba$var$applyCanvasTransform(drawingCtx, this.canvas);
            const m = this.calcTransformMatrix();
            drawingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        if (this.selectionStart === this.selectionEnd && !this.inCompositionMode) this.renderCursor(drawingCtx, boundaries);
        else this.renderSelection(drawingCtx, boundaries);
        if (hasAncestorsWithClipping) for (const ancestor of ancestors){
            const clipPath = ancestor.clipPath;
            const clippingCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor(ctx.canvas);
            const clippingCtx = clippingCanvas.getContext("2d");
            $9a54cbcfc1af41ba$var$applyCanvasTransform(clippingCtx, this.canvas);
            if (!clipPath.absolutePositioned) {
                const m = ancestor.calcTransformMatrix();
                clippingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            }
            clipPath.transform(clippingCtx);
            clipPath.drawObject(clippingCtx, true, {});
            this.drawClipPathOnCache(drawingCtx, clipPath, clippingCanvas);
        }
        if (hasAncestorsWithClipping) {
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(drawingCanvas, 0, 0);
        }
        this.canvas.contextTopDirty = true;
        ctx.restore();
    }
    /**
	* Finds and returns an array of clip paths that are applied to the parent
	* group(s) of the current FabricObject instance. The object's hierarchy is
	* traversed upwards (from the current object towards the root of the canvas),
	* checking each parent object for the presence of a `clipPath` that is not
	* absolutely positioned.
	*/ findAncestorsWithClipPath() {
        const clipPathAncestors = [];
        let obj = this;
        while(obj){
            if (obj.clipPath) clipPathAncestors.push(obj);
            obj = obj.parent;
        }
        return clipPathAncestors;
    }
    /**
	* Returns cursor boundaries (left, top, leftOffset, topOffset)
	* left/top are left/top of entire text box
	* leftOffset/topOffset are offset from that left/top point of a text box
	* @private
	* @param {number} [index] index from start
	* @param {boolean} [skipCaching]
	*/ _getCursorBoundaries(index = this.selectionStart, skipCaching) {
        const left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(index, skipCaching);
        return {
            left: left,
            top: top,
            leftOffset: offsets.left,
            topOffset: offsets.top
        };
    }
    /**
	* Caches and returns cursor left/top offset relative to instance's center point
	* @private
	* @param {number} index index from start
	* @param {boolean} [skipCaching]
	*/ _getCursorBoundariesOffsets(index, skipCaching) {
        if (skipCaching) return this.__getCursorBoundariesOffsets(index);
        if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) return this.cursorOffsetCache;
        return this.cursorOffsetCache = this.__getCursorBoundariesOffsets(index);
    }
    /**
	* Calculates cursor left/top offset relative to instance's center point
	* @private
	* @param {number} index index from start
	*/ __getCursorBoundariesOffsets(index) {
        let topOffset = 0, leftOffset = 0;
        const { charIndex: charIndex, lineIndex: lineIndex } = this.get2DCursorLocation(index);
        const { textAlign: textAlign, direction: direction } = this;
        for(let i = 0; i < lineIndex; i++)topOffset += this.getHeightOfLine(i);
        const lineLeftOffset = this._getLineLeftOffset(lineIndex);
        const bound = this.__charBounds[lineIndex][charIndex];
        bound && (leftOffset = bound.left);
        if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) leftOffset -= this._getWidthOfCharSpacing();
        let left = lineLeftOffset + (leftOffset > 0 ? leftOffset : 0);
        if (direction === "rtl") {
            if (textAlign === "right" || textAlign === "justify" || textAlign === "justify-right") left *= -1;
            else if (textAlign === "left" || textAlign === "justify-left") left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
            else if (textAlign === "center" || textAlign === "justify-center") left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
        }
        return {
            top: topOffset,
            left: left
        };
    }
    /**
	* Renders cursor on context Top, outside the animation cycle, on request
	* Used for the drag/drop effect.
	* If contextTop is not available, do nothing.
	*/ renderCursorAt(selectionStart) {
        this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(selectionStart, true), selectionStart);
    }
    /**
	* Renders cursor
	* @param {Object} boundaries
	* @param {CanvasRenderingContext2D} ctx transformed context to draw on
	*/ renderCursor(ctx, boundaries) {
        this._renderCursor(ctx, boundaries, this.selectionStart);
    }
    /**
	* Return the data needed to render the cursor for given selection start
	* The left,top are relative to the object, while width and height are prescaled
	* to look think with canvas zoom and object scaling,
	* so they depend on canvas and object scaling
	*/ getCursorRenderingData(selectionStart = this.selectionStart, boundaries = this._getCursorBoundaries(selectionStart)) {
        const cursorLocation = this.get2DCursorLocation(selectionStart), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize"), multiplier = this.getObjectScaling().x * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, dy = this.getValueOfPropertyAt(lineIndex, charIndex, "deltaY"), topOffset = boundaries.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
        return {
            color: this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, "fill"),
            opacity: this._currentCursorOpacity,
            left: boundaries.left + boundaries.leftOffset - cursorWidth / 2,
            top: topOffset + boundaries.top + dy,
            width: cursorWidth,
            height: charHeight
        };
    }
    /**
	* Render the cursor at the given selectionStart.
	* @param {CanvasRenderingContext2D} ctx transformed context to draw on
	*/ _renderCursor(ctx, boundaries, selectionStart) {
        const { color: color, opacity: opacity, left: left, top: top, width: width, height: height } = this.getCursorRenderingData(selectionStart, boundaries);
        ctx.fillStyle = color;
        ctx.globalAlpha = opacity;
        ctx.fillRect(left, top, width, height);
    }
    /**
	* Renders text selection
	* @param {Object} boundaries Object with left/top/leftOffset/topOffset
	* @param {CanvasRenderingContext2D} ctx transformed context to draw on
	*/ renderSelection(ctx, boundaries) {
        const selection = {
            selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
            selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd
        };
        this._renderSelection(ctx, selection, boundaries);
    }
    /**
	* Renders drag start text selection
	*/ renderDragSourceEffect() {
        const dragStartSelection = this.draggableTextDelegate.getDragStartSelection();
        this._renderSelection(this.canvas.contextTop, dragStartSelection, this._getCursorBoundaries(dragStartSelection.selectionStart, true));
    }
    renderDropTargetEffect(e) {
        const dragSelection = this.getSelectionStartFromPointer(e);
        this.renderCursorAt(dragSelection);
    }
    /**
	* Renders text selection
	* @private
	* @param {{ selectionStart: number, selectionEnd: number }} selection
	* @param {Object} boundaries Object with left/top/leftOffset/topOffset
	* @param {CanvasRenderingContext2D} ctx transformed context to draw on
	*/ _renderSelection(ctx, selection, boundaries) {
        const { textAlign: textAlign, direction: direction } = this;
        const selectionStart = selection.selectionStart, selectionEnd = selection.selectionEnd, isJustify = textAlign.includes($9a54cbcfc1af41ba$var$JUSTIFY), start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
        for(let i = startLine; i <= endLine; i++){
            const lineOffset = this._getLineLeftOffset(i) || 0;
            let lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
            if (i === startLine) boxStart = this.__charBounds[startLine][startChar].left;
            if (i >= startLine && i < endLine) boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5;
            else if (i === endLine) {
                if (endChar === 0) boxEnd = this.__charBounds[endLine][endChar].left;
                else {
                    const charSpacing = this._getWidthOfCharSpacing();
                    boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
                }
            }
            realLineHeight = lineHeight;
            if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) lineHeight /= this.lineHeight;
            let drawStart = boundaries.left + lineOffset + boxStart, drawHeight = lineHeight, extraTop = 0;
            const drawWidth = boxEnd - boxStart;
            if (this.inCompositionMode) {
                ctx.fillStyle = this.compositionColor || "black";
                drawHeight = 1;
                extraTop = lineHeight;
            } else ctx.fillStyle = this.selectionColor;
            if (direction === "rtl") {
                if (textAlign === "right" || textAlign === "justify" || textAlign === "justify-right") drawStart = this.width - drawStart - drawWidth;
                else if (textAlign === "left" || textAlign === "justify-left") drawStart = boundaries.left + lineOffset - boxEnd;
                else if (textAlign === "center" || textAlign === "justify-center") drawStart = boundaries.left + lineOffset - boxEnd;
            }
            ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
            boundaries.topOffset += realLineHeight;
        }
    }
    /**
	* High level function to know the height of the cursor.
	* the currentChar is the one that precedes the cursor
	* Returns fontSize of char at the current cursor
	* Unused from the library, is for the end user
	* @return {Number} Character font size
	*/ getCurrentCharFontSize() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, "fontSize");
    }
    /**
	* High level function to know the color of the cursor.
	* the currentChar is the one that precedes the cursor
	* Returns color (fill) of char at the current cursor
	* if the text object has a pattern or gradient for filler, it will return that.
	* Unused by the library, is for the end user
	* @return {String | TFiller} Character color (fill)
	*/ getCurrentCharColor() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, $9a54cbcfc1af41ba$var$FILL);
    }
    /**
	* Returns the cursor position for the getCurrent.. functions
	* @private
	*/ _getCurrentCharIndex() {
        const cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
        return {
            l: cursorPosition.lineIndex,
            c: charIndex
        };
    }
    dispose() {
        this.exitEditingImpl();
        this.draggableTextDelegate.dispose();
        super.dispose();
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$6e837253f56cbab0, "ownDefaults", $9a54cbcfc1af41ba$var$iTextDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$6e837253f56cbab0, "type", "IText");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$6e837253f56cbab0);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$6e837253f56cbab0, "i-text");
//#endregion
//#region src/shapes/Textbox.ts
const $9a54cbcfc1af41ba$var$textboxDefaultValues = {
    minWidth: 20,
    dynamicMinWidth: 2,
    lockScalingFlip: true,
    noScaleCache: false,
    _wordJoiners: /[ \t\r]/,
    splitByGrapheme: false
};
/**
* Textbox class, based on IText, allows the user to resize the text rectangle
* and wraps lines automatically. Textboxes have their Y scaling locked, the
* user can only change width. Height is adjusted automatically based on the
* wrapping of lines.
*/ var $9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b = class Textbox extends $9a54cbcfc1af41ba$export$6e837253f56cbab0 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...Textbox.ownDefaults
        };
    }
    /**
	* Constructor
	* @param {String} text Text string
	* @param {Object} [options] Options object
	*/ constructor(text, options){
        super(text, {
            ...Textbox.ownDefaults,
            ...options
        });
    }
    /**
	* Creates the default control object.
	* If you prefer to have on instance of controls shared among all objects
	* make this function return an empty object and add controls to the ownDefaults object
	*/ static createControls() {
        return {
            controls: $9a54cbcfc1af41ba$var$createTextboxDefaultControls()
        };
    }
    /**
	* Unlike superclass's version of this function, Textbox does not update
	* its width.
	* @private
	* @override
	*/ initDimensions() {
        if (!this.initialized) return;
        this.isEditing && this.initDelayedCursor();
        this._clearCache();
        this.dynamicMinWidth = 0;
        this._styleMap = this._generateStyleMap(this._splitText());
        if (this.dynamicMinWidth > this.width) this._set("width", this.dynamicMinWidth);
        if (this.textAlign.includes("justify")) this.enlargeSpaces();
        this.height = this.calcTextHeight();
    }
    /**
	* Generate an object that translates the style object so that it is
	* broken up by visual lines (new lines and automatic wrapping).
	* The original text styles object is broken up by actual lines (new lines only),
	* which is only sufficient for Text / IText
	* @private
	*/ _generateStyleMap(textInfo) {
        let realLineCount = 0, realLineCharCount = 0, charCount = 0;
        const map = {};
        for(let i = 0; i < textInfo.graphemeLines.length; i++){
            if (textInfo.graphemeText[charCount] === "\n" && i > 0) {
                realLineCharCount = 0;
                charCount++;
                realLineCount++;
            } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
                realLineCharCount++;
                charCount++;
            }
            map[i] = {
                line: realLineCount,
                offset: realLineCharCount
            };
            charCount += textInfo.graphemeLines[i].length;
            realLineCharCount += textInfo.graphemeLines[i].length;
        }
        return map;
    }
    /**
	* Returns true if object has a style property or has it on a specified line
	* @param {Number} lineIndex
	* @return {Boolean}
	*/ styleHas(property, lineIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (map) lineIndex = map.line;
        }
        return super.styleHas(property, lineIndex);
    }
    /**
	* Returns true if object has no styling or no styling in a line
	* @param {Number} lineIndex , lineIndex is on wrapped lines.
	* @return {Boolean}
	*/ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        let offset = 0, nextLineIndex = lineIndex + 1, nextOffset, shouldLimit = false;
        const map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
        if (map) {
            lineIndex = map.line;
            offset = map.offset;
        }
        if (mapNextLine) {
            nextLineIndex = mapNextLine.line;
            shouldLimit = nextLineIndex === lineIndex;
            nextOffset = mapNextLine.offset;
        }
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1]){
            const p2Number = parseInt(p2, 10);
            if (p2Number >= offset && (!shouldLimit || p2Number < nextOffset)) for(const p3 in obj[p1][p2])return false;
        }
        return true;
    }
    /**
	* @protected
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
	*/ _getStyleDeclaration(lineIndex, charIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (!map) return {};
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
        }
        return super._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @param {Object} style
	* @private
	*/ _setStyleDeclaration(lineIndex, charIndex, style) {
        const map = this._styleMap[lineIndex];
        super._setStyleDeclaration(map.line, map.offset + charIndex, style);
    }
    /**
	* @param {Number} lineIndex
	* @param {Number} charIndex
	* @private
	*/ _deleteStyleDeclaration(lineIndex, charIndex) {
        const map = this._styleMap[lineIndex];
        super._deleteStyleDeclaration(map.line, map.offset + charIndex);
    }
    /**
	* probably broken need a fix
	* Returns the real style line that correspond to the wrapped lineIndex line
	* Used just to verify if the line does exist or not.
	* @param {Number} lineIndex
	* @returns {Boolean} if the line exists or not
	* @private
	*/ _getLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        return !!this.styles[map.line];
    }
    /**
	* Set the line style to an empty object so that is initialized
	* @param {Number} lineIndex
	* @param {Object} style
	* @private
	*/ _setLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        super._setLineStyle(map.line);
    }
    /**
	* Wraps text using the 'width' property of Textbox. First this function
	* splits text on newlines, so we preserve newlines entered by the user.
	* Then it wraps each line using the width of the Textbox by calling
	* _wrapLine().
	* @param {Array} lines The string array of text that is split into lines
	* @param {Number} desiredWidth width you want to wrap to
	* @returns {Array} Array of lines
	*/ _wrapText(lines, desiredWidth) {
        this.isWrapping = true;
        const data = this.getGraphemeDataForRender(lines);
        const wrapped = [];
        for(let i = 0; i < data.wordsData.length; i++)wrapped.push(...this._wrapLine(i, desiredWidth, data));
        this.isWrapping = false;
        return wrapped;
    }
    /**
	* For each line of text terminated by an hard line stop,
	* measure each word width and extract the largest word from all.
	* The returned words here are the one that at the end will be rendered.
	* @param {string[]} lines the lines we need to measure
	*
	*/ getGraphemeDataForRender(lines) {
        const splitByGrapheme = this.splitByGrapheme, infix = splitByGrapheme ? "" : " ";
        let largestWordWidth = 0;
        return {
            wordsData: lines.map((line, lineIndex)=>{
                let offset = 0;
                const wordsOrGraphemes = splitByGrapheme ? this.graphemeSplit(line) : this.wordSplit(line);
                if (wordsOrGraphemes.length === 0) return [
                    {
                        word: [],
                        width: 0
                    }
                ];
                return wordsOrGraphemes.map((word)=>{
                    const graphemeArray = splitByGrapheme ? [
                        word
                    ] : this.graphemeSplit(word);
                    const width = this._measureWord(graphemeArray, lineIndex, offset);
                    largestWordWidth = Math.max(width, largestWordWidth);
                    offset += graphemeArray.length + infix.length;
                    return {
                        word: graphemeArray,
                        width: width
                    };
                });
            }),
            largestWordWidth: largestWordWidth
        };
    }
    /**
	* Helper function to measure a string of text, given its lineIndex and charIndex offset
	* It gets called when charBounds are not available yet.
	* Override if necessary
	* Use with {@link Textbox#wordSplit}
	*
	* @param {CanvasRenderingContext2D} ctx
	* @param {String} text
	* @param {number} lineIndex
	* @param {number} charOffset
	* @returns {number}
	*/ _measureWord(word, lineIndex, charOffset = 0) {
        let width = 0, prevGrapheme;
        const skipLeft = true;
        for(let i = 0, len = word.length; i < len; i++){
            const box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
            width += box.kernedWidth;
            prevGrapheme = word[i];
        }
        return width;
    }
    /**
	* Override this method to customize word splitting
	* Use with {@link Textbox#_measureWord}
	* @param {string} value
	* @returns {string[]} array of words
	*/ wordSplit(value) {
        return value.split(this._wordJoiners);
    }
    /**
	* Wraps a line of text using the width of the Textbox as desiredWidth
	* and leveraging the known width o words from GraphemeData
	* @private
	* @param {Number} lineIndex
	* @param {Number} desiredWidth width you want to wrap the line to
	* @param {GraphemeData} graphemeData an object containing all the lines' words width.
	* @param {Number} reservedSpace space to remove from wrapping for custom functionalities
	* @returns {Array} Array of line(s) into which the given text is wrapped
	* to.
	*/ _wrapLine(lineIndex, desiredWidth, { largestWordWidth: largestWordWidth, wordsData: wordsData }, reservedSpace = 0) {
        const additionalSpace = this._getWidthOfCharSpacing(), splitByGrapheme = this.splitByGrapheme, graphemeLines = [], infix = splitByGrapheme ? "" : " ";
        let lineWidth = 0, line = [], offset = 0, infixWidth = 0, lineJustStarted = true;
        desiredWidth -= reservedSpace;
        const maxWidth = Math.max(desiredWidth, largestWordWidth, this.dynamicMinWidth);
        const data = wordsData[lineIndex];
        offset = 0;
        let i;
        for(i = 0; i < data.length; i++){
            const { word: word, width: wordWidth } = data[i];
            offset += word.length;
            lineWidth += infixWidth + wordWidth - additionalSpace;
            if (lineWidth > maxWidth && !lineJustStarted) {
                graphemeLines.push(line);
                line = [];
                lineWidth = wordWidth;
                lineJustStarted = true;
            } else lineWidth += additionalSpace;
            if (!lineJustStarted && !splitByGrapheme) line.push(infix);
            line = line.concat(word);
            infixWidth = splitByGrapheme ? 0 : this._measureWord([
                infix
            ], lineIndex, offset);
            offset++;
            lineJustStarted = false;
        }
        i && graphemeLines.push(line);
        if (largestWordWidth + reservedSpace > this.dynamicMinWidth) this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
        return graphemeLines;
    }
    /**
	* Detect if the text line is ended with an hard break
	* text and itext do not have wrapping, return false
	* @param {Number} lineIndex text to split
	* @return {Boolean}
	*/ isEndOfWrapping(lineIndex) {
        if (!this._styleMap[lineIndex + 1]) return true;
        if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) return true;
        return false;
    }
    /**
	* Detect if a line has a linebreak and so we need to account for it when moving
	* and counting style.
	* This is important only for splitByGrapheme at the end of wrapping.
	* If we are not wrapping the offset is always 1
	* @return Number
	*/ missingNewlineOffset(lineIndex, skipWrapping) {
        if (this.splitByGrapheme && !skipWrapping) return this.isEndOfWrapping(lineIndex) ? 1 : 0;
        return 1;
    }
    /**
	* Gets lines of text to render in the Textbox. This function calculates
	* text wrapping on the fly every time it is called.
	* @param {String} text text to split
	* @returns {Array} Array of lines in the Textbox.
	* @override
	*/ _splitTextIntoLines(text) {
        const newText = super._splitTextIntoLines(text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
        for(let i = 0; i < graphemeLines.length; i++)lines[i] = graphemeLines[i].join("");
        newText.lines = lines;
        newText.graphemeLines = graphemeLines;
        return newText;
    }
    getMinWidth() {
        return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
        const linesToKeep = /* @__PURE__ */ new Map();
        for(const prop in this._styleMap){
            const propNumber = parseInt(prop, 10);
            if (this._textLines[propNumber]) {
                const lineIndex = this._styleMap[prop].line;
                linesToKeep.set(`${lineIndex}`, true);
            }
        }
        for(const prop in this.styles)if (!linesToKeep.has(prop)) delete this.styles[prop];
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        return super.toObject([
            "minWidth",
            "splitByGrapheme",
            ...propertiesToInclude
        ]);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b, "type", "Textbox");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b, "textLayoutProperties", [
    ...$9a54cbcfc1af41ba$export$6e837253f56cbab0.textLayoutProperties,
    "width"
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b, "ownDefaults", $9a54cbcfc1af41ba$var$textboxDefaultValues);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b);
//#endregion
//#region src/LayoutManager/LayoutStrategies/ClipPathLayout.ts
/**
* Layout will adjust the bounding box to match the clip path bounding box.
*/ var $9a54cbcfc1af41ba$export$73ee6802ebd70462 = class extends $9a54cbcfc1af41ba$export$f7b260234c293505 {
    shouldPerformLayout(context) {
        return !!context.target.clipPath && super.shouldPerformLayout(context);
    }
    shouldLayoutClipPath() {
        return false;
    }
    calcLayoutResult(context, objects) {
        const { target: target } = context;
        const { clipPath: clipPath, group: group } = target;
        if (!clipPath || !this.shouldPerformLayout(context)) return;
        const { width: width, height: height } = $9a54cbcfc1af41ba$var$makeBoundingBoxFromPoints($9a54cbcfc1af41ba$var$getObjectBounds(target, clipPath));
        const size = new $9a54cbcfc1af41ba$export$baf26146a414f24a(width, height);
        if (clipPath.absolutePositioned) return {
            center: $9a54cbcfc1af41ba$var$sendPointToPlane(clipPath.getRelativeCenterPoint(), void 0, group ? group.calcTransformMatrix() : void 0),
            size: size
        };
        else {
            const clipPathCenter = clipPath.getRelativeCenterPoint().transform(target.calcOwnMatrix(), true);
            if (this.shouldPerformLayout(context)) {
                const { center: center = new $9a54cbcfc1af41ba$export$baf26146a414f24a(), correction: correction = new $9a54cbcfc1af41ba$export$baf26146a414f24a() } = this.calcBoundingBox(objects, context) || {};
                return {
                    center: center.add(clipPathCenter),
                    correction: correction.subtract(clipPathCenter),
                    size: size
                };
            } else return {
                center: target.getRelativeCenterPoint().add(clipPathCenter),
                size: size
            };
        }
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$73ee6802ebd70462, "type", "clip-path");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$73ee6802ebd70462);
//#endregion
//#region src/LayoutManager/LayoutStrategies/FixedLayout.ts
/**
* Layout will keep target's initial size.
*/ var $9a54cbcfc1af41ba$export$50774ba6edfcc9a = class extends $9a54cbcfc1af41ba$export$f7b260234c293505 {
    /**
	* @override respect target's initial size
	*/ getInitialSize({ target: target }, { size: size }) {
        return new $9a54cbcfc1af41ba$export$baf26146a414f24a(target.width || size.x, target.height || size.y);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$50774ba6edfcc9a, "type", "fixed");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$50774ba6edfcc9a);
//#endregion
//#region src/LayoutManager/ActiveSelectionLayoutManager.ts
/**
* Today the LayoutManager class also takes care of subscribing event handlers
* to update the group layout when the group is interactive and a transform is applied
* to a child object.
* The ActiveSelection is never interactive, but it could contain objects from
* groups that are.
* The standard LayoutManager would subscribe the children of the activeSelection to
* perform layout changes to the active selection itself, what we need instead is that
* the transformation applied to the active selection will trigger changes to the
* original group of the children ( the one referenced under the parent property )
* This subclass of the LayoutManager has a single duty to fill the gap of this difference.`
*/ var $9a54cbcfc1af41ba$var$ActiveSelectionLayoutManager = class extends $9a54cbcfc1af41ba$export$4a04ad01c410b415 {
    subscribeTargets(context) {
        const activeSelection = context.target;
        context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, /* @__PURE__ */ new Set()).forEach((parent)=>{
            parent.layoutManager.subscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
    /**
	* unsubscribe from parent only if all its children were deselected
	*/ unsubscribeTargets(context) {
        const activeSelection = context.target;
        const selectedObjects = activeSelection.getObjects();
        context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, /* @__PURE__ */ new Set()).forEach((parent)=>{
            !selectedObjects.some((object)=>object.parent === parent) && parent.layoutManager.unsubscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
};
//#endregion
//#region src/shapes/ActiveSelection.ts
const $9a54cbcfc1af41ba$var$activeSelectionDefaultValues = {
    multiSelectionStacking: "canvas-stacking"
};
/**
* Used by Canvas to manage selection.
*
* @example
* class MyActiveSelection extends ActiveSelection {
*   ...
* }
*
* // override the default `ActiveSelection` class
* classRegistry.setClass(MyActiveSelection)
*/ var $9a54cbcfc1af41ba$export$c57a942eef0ccd19 = class ActiveSelection extends $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...ActiveSelection.ownDefaults
        };
    }
    constructor(objects = [], options = {}){
        super();
        Object.assign(this, ActiveSelection.ownDefaults);
        this.setOptions(options);
        const { left: left, top: top, layoutManager: layoutManager } = options;
        this.groupInit(objects, {
            left: left,
            top: top,
            layoutManager: layoutManager !== null && layoutManager !== void 0 ? layoutManager : new $9a54cbcfc1af41ba$var$ActiveSelectionLayoutManager()
        });
    }
    /**
	* @private
	*/ _shouldSetNestedCoords() {
        return true;
    }
    /**
	* @private
	* @override we don't want the selection monitor to be active
	*/ __objectSelectionMonitor() {}
    /**
	* Adds objects with respect to {@link multiSelectionStacking}
	* @param targets object to add to selection
	*/ multiSelectAdd(...targets) {
        if (this.multiSelectionStacking === "selection-order") this.add(...targets);
        else targets.forEach((target)=>{
            const index = this._objects.findIndex((obj)=>obj.isInFrontOf(target));
            const insertAt = index === -1 ? this.size() : index;
            this.insertAt(insertAt, target);
        });
    }
    /**
	* @override block ancestors/descendants of selected objects from being selected to prevent a circular object tree
	*/ canEnterGroup(object) {
        if (this.getObjects().some((o)=>o.isDescendantOf(object) || object.isDescendantOf(o))) {
            $9a54cbcfc1af41ba$var$log("error", "ActiveSelection: circular object trees are not supported, this call has no effect");
            return false;
        }
        return super.canEnterGroup(object);
    }
    /**
	* Change an object so that it can be part of an active selection.
	* this method is called by multiselectAdd from canvas code.
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
	*/ enterGroup(object, removeParentTransform) {
        if (object.parent && object.parent === object.group) object.parent._exitGroup(object);
        else if (object.group && object.parent !== object.group) object.group.remove(object);
        this._enterGroup(object, removeParentTransform);
    }
    /**
	* we want objects to retain their canvas ref when exiting instance
	* @private
	* @param {FabricObject} object
	* @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
	*/ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        object.parent && object.parent._enterGroup(object, true);
    }
    /**
	* @private
	* @param {'added'|'removed'} type
	* @param {FabricObject[]} targets
	*/ _onAfterObjectsChange(type, targets) {
        super._onAfterObjectsChange(type, targets);
        const groups = /* @__PURE__ */ new Set();
        targets.forEach((object)=>{
            const { parent: parent } = object;
            parent && groups.add(parent);
        });
        if (type === "removed") groups.forEach((group)=>{
            group._onAfterObjectsChange($9a54cbcfc1af41ba$var$LAYOUT_TYPE_ADDED, targets);
        });
        else groups.forEach((group)=>{
            group._set("dirty", true);
        });
    }
    /**
	* @override remove all objects
	*/ onDeselect() {
        this.removeAll();
        return false;
    }
    /**
	* Returns string representation of a group
	* @return {String}
	*/ toString() {
        return `#<ActiveSelection: (${this.complexity()})>`;
    }
    /**
	* Decide if the object should cache or not. The Active selection never caches
	* @return {Boolean}
	*/ shouldCache() {
        return false;
    }
    /**
	* Check if this group or its parent group are caching, recursively up
	* @return {Boolean}
	*/ isOnACache() {
        return false;
    }
    /**
	* Renders controls and borders for the object
	* @param {CanvasRenderingContext2D} ctx Context to render on
	* @param {Object} [styleOverride] properties to override the object style
	* @param {Object} [childrenOverride] properties to override the children overrides
	*/ _renderControls(ctx, styleOverride, childrenOverride) {
        ctx.save();
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        const options = {
            hasControls: false,
            ...childrenOverride,
            forActiveSelection: true
        };
        for(let i = 0; i < this._objects.length; i++)this._objects[i]._renderControls(ctx, options);
        super._renderControls(ctx, styleOverride);
        ctx.restore();
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c57a942eef0ccd19, "type", "ActiveSelection");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$c57a942eef0ccd19, "ownDefaults", $9a54cbcfc1af41ba$var$activeSelectionDefaultValues);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c57a942eef0ccd19);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$c57a942eef0ccd19, "activeSelection");
//#endregion
//#region src/filters/Canvas2dFilterBackend.ts
var $9a54cbcfc1af41ba$export$eaf5984e5c8f09c5 = class {
    constructor(){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Experimental. This object is a sort of repository of help layers used to avoid
			* of recreating them during frequent filtering. If you are previewing a filter with
			* a slider you probably do not want to create help layers every filter step.
			* in this object there will be appended some canvases, created once, resized sometimes
			* cleared never. Clearing is left to the developer.
			**/ "resources", {});
    }
    /**
	* Apply a set of filters against a source image and draw the filtered output
	* to the provided destination canvas.
	*
	* @param {EnhancedFilter} filters The filter to apply.
	* @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
	* @param {Number} sourceWidth The width of the source input.
	* @param {Number} sourceHeight The height of the source input.
	* @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	*/ applyFilters(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
        const ctx = targetCanvas.getContext("2d", {
            willReadFrequently: true,
            desynchronized: true
        });
        if (!ctx) return;
        ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
        const pipelineState = {
            sourceWidth: sourceWidth,
            sourceHeight: sourceHeight,
            imageData: ctx.getImageData(0, 0, sourceWidth, sourceHeight),
            originalEl: sourceElement,
            originalImageData: ctx.getImageData(0, 0, sourceWidth, sourceHeight),
            canvasEl: targetCanvas,
            ctx: ctx,
            filterBackend: this
        };
        filters.forEach((filter)=>{
            filter.applyTo(pipelineState);
        });
        const { imageData: imageDataPostFilter } = pipelineState;
        if (imageDataPostFilter.width !== sourceWidth || imageDataPostFilter.height !== sourceHeight) {
            targetCanvas.width = imageDataPostFilter.width;
            targetCanvas.height = imageDataPostFilter.height;
        }
        ctx.putImageData(imageDataPostFilter, 0, 0);
        return pipelineState;
    }
};
//#endregion
//#region src/filters/WebGLFilterBackend.ts
var $9a54cbcfc1af41ba$export$42da2a27efef173b = class {
    constructor({ tileSize: tileSize = $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.textureSize } = {}){
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Define ...
			**/ "aPosition", new Float32Array([
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1
        ]));
        $9a54cbcfc1af41ba$var$_defineProperty(this, /**
			* Experimental. This object is a sort of repository of help layers used to avoid
			* of recreating them during frequent filtering. If you are previewing a filter with
			* a slider you probably do not want to create help layers every filter step.
			* in this object there will be appended some canvases, created once, resized sometimes
			* cleared never. Clearing is left to the developer.
			**/ "resources", {});
        this.tileSize = tileSize;
        this.setupGLContext(tileSize, tileSize);
        this.captureGPUInfo();
    }
    /**
	* Setup a WebGL context suitable for filtering, and bind any needed event handlers.
	*/ setupGLContext(width, height) {
        this.dispose();
        this.createWebGLCanvas(width, height);
    }
    /**
	* Create a canvas element and associated WebGL context and attaches them as
	* class properties to the GLFilterBackend class.
	*/ createWebGLCanvas(width, height) {
        const canvas = $9a54cbcfc1af41ba$var$createCanvasElementFor({
            width: width,
            height: height
        });
        const gl = canvas.getContext("webgl", {
            alpha: true,
            premultipliedAlpha: false,
            depth: false,
            stencil: false,
            antialias: false
        });
        if (!gl) return;
        gl.clearColor(0, 0, 0, 0);
        this.canvas = canvas;
        this.gl = gl;
    }
    /**
	* Attempts to apply the requested filters to the source provided, drawing the filtered output
	* to the provided target canvas.
	*
	* @param {Array} filters The filters to apply.
	* @param {TexImageSource} source The source to be filtered.
	* @param {Number} width The width of the source input.
	* @param {Number} height The height of the source input.
	* @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	* @param {String|undefined} cacheKey A key used to cache resources related to the source. If
	* omitted, caching will be skipped.
	*/ applyFilters(filters, source, width, height, targetCanvas, cacheKey) {
        const gl = this.gl;
        const ctx = targetCanvas.getContext("2d");
        if (!gl || !ctx) return;
        let cachedTexture;
        if (cacheKey) cachedTexture = this.getCachedTexture(cacheKey, source);
        const pipelineState = {
            originalWidth: source.width || source.naturalWidth || 0,
            originalHeight: source.height || source.naturalHeight || 0,
            sourceWidth: width,
            sourceHeight: height,
            destinationWidth: width,
            destinationHeight: height,
            context: gl,
            sourceTexture: this.createTexture(gl, width, height, !cachedTexture ? source : void 0),
            targetTexture: this.createTexture(gl, width, height),
            originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture ? source : void 0),
            passes: filters.length,
            webgl: true,
            aPosition: this.aPosition,
            programCache: this.programCache,
            pass: 0,
            filterBackend: this,
            targetCanvas: targetCanvas
        };
        const tempFbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
        filters.forEach((filter)=>{
            filter && filter.applyTo(pipelineState);
        });
        $9a54cbcfc1af41ba$var$resizeCanvasIfNeeded(pipelineState);
        this.copyGLTo2D(gl, pipelineState);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.deleteTexture(pipelineState.sourceTexture);
        gl.deleteTexture(pipelineState.targetTexture);
        gl.deleteFramebuffer(tempFbo);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        return pipelineState;
    }
    /**
	* Detach event listeners, remove references, and clean up caches.
	*/ dispose() {
        if (this.canvas) {
            this.canvas = null;
            this.gl = null;
        }
        this.clearWebGLCaches();
    }
    /**
	* Wipe out WebGL-related caches.
	*/ clearWebGLCaches() {
        this.programCache = {};
        this.textureCache = {};
    }
    /**
	* Create a WebGL texture object.
	*
	* Accepts specific dimensions to initialize the texture to or a source image.
	*
	* @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
	* @param {number} width The width to initialize the texture at.
	* @param {number} height The height to initialize the texture.
	* @param {TexImageSource} textureImageSource A source for the texture data.
	* @param {number} filter gl.NEAREST default or gl.LINEAR filters for the texture.
	* This filter is very useful for LUTs filters. If you need interpolation use gl.LINEAR
	* @returns {WebGLTexture}
	*/ createTexture(gl, width, height, textureImageSource, filter) {
        const { NEAREST: NEAREST, TEXTURE_2D: TEXTURE_2D, RGBA: RGBA, UNSIGNED_BYTE: UNSIGNED_BYTE, CLAMP_TO_EDGE: CLAMP_TO_EDGE, TEXTURE_MAG_FILTER: TEXTURE_MAG_FILTER, TEXTURE_MIN_FILTER: TEXTURE_MIN_FILTER, TEXTURE_WRAP_S: TEXTURE_WRAP_S, TEXTURE_WRAP_T: TEXTURE_WRAP_T } = gl;
        const texture = gl.createTexture();
        gl.bindTexture(TEXTURE_2D, texture);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MAG_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MIN_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
        if (textureImageSource) gl.texImage2D(TEXTURE_2D, 0, RGBA, RGBA, UNSIGNED_BYTE, textureImageSource);
        else gl.texImage2D(TEXTURE_2D, 0, RGBA, width, height, 0, RGBA, UNSIGNED_BYTE, null);
        return texture;
    }
    /**
	* Can be optionally used to get a texture from the cache array
	*
	* If an existing texture is not found, a new texture is created and cached.
	*
	* @param {String} uniqueId A cache key to use to find an existing texture.
	* @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
	* texture cache entry if one does not already exist.
	*/ getCachedTexture(uniqueId, textureImageSource, filter) {
        const { textureCache: textureCache } = this;
        if (textureCache[uniqueId]) return textureCache[uniqueId];
        else {
            const texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource, filter);
            if (texture) textureCache[uniqueId] = texture;
            return texture;
        }
    }
    /**
	* Clear out cached resources related to a source image that has been
	* filtered previously.
	*
	* @param {String} cacheKey The cache key provided when the source image was filtered.
	*/ evictCachesForKey(cacheKey) {
        if (this.textureCache[cacheKey]) {
            this.gl.deleteTexture(this.textureCache[cacheKey]);
            delete this.textureCache[cacheKey];
        }
    }
    /**
	* Copy an input WebGL canvas on to an output 2D canvas.
	*
	* The WebGL canvas is assumed to be upside down, with the top-left pixel of the
	* desired output image appearing in the bottom-left corner of the WebGL canvas.
	*
	* @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	* @param {Object} pipelineState The 2D target canvas to copy on to.
	*/ copyGLTo2D(gl, pipelineState) {
        const glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d");
        if (!ctx) return;
        ctx.translate(0, targetCanvas.height);
        ctx.scale(1, -1);
        const sourceY = glCanvas.height - targetCanvas.height;
        ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
    }
    /**
	* Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
	* API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
	*
	* @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	* @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
	* @param {Object} pipelineState The 2D target canvas to copy on to.
	*/ copyGLTo2DPutImageData(gl, pipelineState) {
        const ctx = pipelineState.targetCanvas.getContext("2d"), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
        if (!ctx) return;
        const u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
        const u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
        gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
        const imgData = new ImageData(u8Clamped, dWidth, dHeight);
        ctx.putImageData(imgData, 0, 0);
    }
    /**
	* Attempt to extract GPU information strings from a WebGL context.
	*
	* Useful information when debugging or blacklisting specific GPUs.
	*
	* @returns {Object} A GPU info object with renderer and vendor strings.
	*/ captureGPUInfo() {
        if (this.gpuInfo) return this.gpuInfo;
        const gl = this.gl, gpuInfo = {
            renderer: "",
            vendor: ""
        };
        if (!gl) return gpuInfo;
        const ext = gl.getExtension("WEBGL_debug_renderer_info");
        if (ext) {
            const renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
            const vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
            if (renderer) gpuInfo.renderer = renderer.toLowerCase();
            if (vendor) gpuInfo.vendor = vendor.toLowerCase();
        }
        this.gpuInfo = gpuInfo;
        return gpuInfo;
    }
};
function $9a54cbcfc1af41ba$var$resizeCanvasIfNeeded(pipelineState) {
    const targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
        targetCanvas.width = dWidth;
        targetCanvas.height = dHeight;
    }
}
//#endregion
//#region src/filters/FilterBackend.ts
let $9a54cbcfc1af41ba$var$filterBackend;
/**
* Verifies if it is possible to initialize webgl or fallback on a canvas2d filtering backend
*/ function $9a54cbcfc1af41ba$export$4747bee7c8857651() {
    const { WebGLProbe: WebGLProbe } = $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e();
    WebGLProbe.queryWebGL($9a54cbcfc1af41ba$var$createCanvasElement());
    if ($9a54cbcfc1af41ba$export$e506a1d27d1eaa20.enableGLFiltering && WebGLProbe.isSupported($9a54cbcfc1af41ba$export$e506a1d27d1eaa20.textureSize)) return new $9a54cbcfc1af41ba$export$42da2a27efef173b({
        tileSize: $9a54cbcfc1af41ba$export$e506a1d27d1eaa20.textureSize
    });
    else return new $9a54cbcfc1af41ba$export$eaf5984e5c8f09c5();
}
/**
* Get the current fabricJS filter backend  or initialize one if not available yet
* @param [strict] pass `true` to create the backend if it wasn't created yet (default behavior),
* pass `false` to get the backend ref without mutating it
*/ function $9a54cbcfc1af41ba$export$8c3a6bdf56bdf106(strict = true) {
    if (!$9a54cbcfc1af41ba$var$filterBackend && strict) $9a54cbcfc1af41ba$var$filterBackend = $9a54cbcfc1af41ba$export$4747bee7c8857651();
    return $9a54cbcfc1af41ba$var$filterBackend;
}
function $9a54cbcfc1af41ba$export$99b8b463935976a6(backend) {
    $9a54cbcfc1af41ba$var$filterBackend = backend;
}
//#endregion
//#region src/shapes/Image.ts
const $9a54cbcfc1af41ba$var$imageDefaultValues = {
    strokeWidth: 0,
    srcFromAttribute: false,
    minimumScaleTrigger: .5,
    cropX: 0,
    cropY: 0,
    imageSmoothing: true
};
const $9a54cbcfc1af41ba$var$IMAGE_PROPS = [
    "cropX",
    "cropY"
];
/**
* @see {@link http://fabric5.fabricjs.com/fabric-intro-part-1#images}
*/ var $9a54cbcfc1af41ba$export$3148ec5c6497ddc8 = class FabricImage extends $9a54cbcfc1af41ba$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return {
            ...super.getDefaults(),
            ...FabricImage.ownDefaults
        };
    }
    constructor(arg0, options){
        super();
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_lastScaleX", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_lastScaleY", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_filterScalingX", 1);
        $9a54cbcfc1af41ba$var$_defineProperty(this, "_filterScalingY", 1);
        this.filters = [];
        Object.assign(this, FabricImage.ownDefaults);
        this.setOptions(options);
        this.cacheKey = `texture${$9a54cbcfc1af41ba$var$uid()}`;
        this.setElement(typeof arg0 === "string" ? (this.canvas && $9a54cbcfc1af41ba$var$getDocumentFromElement(this.canvas.getElement()) || $9a54cbcfc1af41ba$export$91e93c41e950ddbb()).getElementById(arg0) : arg0, options);
    }
    /**
	* Returns image element which this instance if based on
	*/ getElement() {
        return this._element;
    }
    /**
	* Sets image element for this instance to a specified one.
	* If filters defined they are applied to new image.
	* You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
	* @param {HTMLImageElement} element
	* @param {Partial<TSize>} [size] Options object
	*/ setElement(element, size = {}) {
        this.removeTexture(this.cacheKey);
        this.removeTexture(`${this.cacheKey}_filtered`);
        this._element = element;
        this._originalElement = element;
        this._setWidthHeight(size);
        if (this.filters.length !== 0) this.applyFilters();
        if (this.resizeFilter) this.applyResizeFilters();
    }
    /**
	* Delete a single texture if in webgl mode
	*/ removeTexture(key) {
        const backend = $9a54cbcfc1af41ba$export$8c3a6bdf56bdf106(false);
        if (backend instanceof $9a54cbcfc1af41ba$export$42da2a27efef173b) backend.evictCachesForKey(key);
    }
    /**
	* Delete textures, reference to elements and eventually JSDOM cleanup
	*/ dispose() {
        super.dispose();
        this.removeTexture(this.cacheKey);
        this.removeTexture(`${this.cacheKey}_filtered`);
        this._cacheContext = null;
        [
            "_originalElement",
            "_element",
            "_filteredEl",
            "_cacheCanvas"
        ].forEach((elementKey)=>{
            const el = this[elementKey];
            el && $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e().dispose(el);
            this[elementKey] = void 0;
        });
    }
    /**
	* Get the crossOrigin value (of the corresponding image element)
	*/ getCrossOrigin() {
        return this._originalElement && (this._originalElement.crossOrigin || null);
    }
    /**
	* Returns original size of an image
	*/ getOriginalSize() {
        const element = this.getElement();
        if (!element) return {
            width: 0,
            height: 0
        };
        return {
            width: element.naturalWidth || element.width,
            height: element.naturalHeight || element.height
        };
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _stroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        const w = this.width / 2, h = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-w, -h);
        ctx.lineTo(w, -h);
        ctx.lineTo(w, h);
        ctx.lineTo(-w, h);
        ctx.lineTo(-w, -h);
        ctx.closePath();
    }
    /**
	* Returns object representation of an instance
	* @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	* @return {Object} Object representation of an instance
	*/ toObject(propertiesToInclude = []) {
        const filters = [];
        this.filters.forEach((filterObj)=>{
            filterObj && filters.push(filterObj.toObject());
        });
        return {
            ...super.toObject([
                ...$9a54cbcfc1af41ba$var$IMAGE_PROPS,
                ...propertiesToInclude
            ]),
            src: this.getSrc(),
            crossOrigin: this.getCrossOrigin(),
            filters: filters,
            ...this.resizeFilter ? {
                resizeFilter: this.resizeFilter.toObject()
            } : {}
        };
    }
    /**
	* Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
	* @return {Boolean}
	*/ hasCrop() {
        return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }
    /**
	* Returns svg representation of an instance
	* @return {string[]} an array of strings with the specific svg representation
	* of the instance
	*/ _toSVG() {
        const imageMarkup = [], element = this._element, x = -this.width / 2, y = -this.height / 2;
        let svgString = [], strokeSvg = [], clipPath = "", imageRendering = "";
        if (!element) return [];
        if (this.hasCrop()) {
            const clipPathId = $9a54cbcfc1af41ba$var$uid();
            svgString.push("<clipPath id=\"imageCrop_" + clipPathId + "\">\n", "	<rect x=\"" + x + "\" y=\"" + y + "\" width=\"" + $9a54cbcfc1af41ba$var$escapeXml(this.width) + "\" height=\"" + $9a54cbcfc1af41ba$var$escapeXml(this.height) + "\" />\n", "</clipPath>\n");
            clipPath = " clip-path=\"url(#imageCrop_" + clipPathId + ")\" ";
        }
        if (!this.imageSmoothing) imageRendering = " image-rendering=\"optimizeSpeed\"";
        imageMarkup.push("	<image ", "COMMON_PARTS", `xlink:href="${$9a54cbcfc1af41ba$var$escapeXml(this.getSrc(true))}" x="${x - this.cropX}" y="${y - this.cropY}" width="${element.width || element.naturalWidth}" height="${element.height || element.naturalHeight}"${imageRendering}${clipPath}></image>\n`);
        if (this.stroke || this.strokeDashArray) {
            const origFill = this.fill;
            this.fill = null;
            strokeSvg = [
                `\t<rect x="${x}" y="${y}" width="${$9a54cbcfc1af41ba$var$escapeXml(this.width)}" height="${$9a54cbcfc1af41ba$var$escapeXml(this.height)}" style="${this.getSvgStyles()}" />\n`
            ];
            this.fill = origFill;
        }
        if (this.paintFirst !== "fill") svgString = svgString.concat(strokeSvg, imageMarkup);
        else svgString = svgString.concat(imageMarkup, strokeSvg);
        return svgString;
    }
    /**
	* Returns source of an image
	* @param {Boolean} filtered indicates if the src is needed for svg
	* @return {String} Source of an image
	*/ getSrc(filtered) {
        const element = filtered ? this._element : this._originalElement;
        if (element) {
            if (element.toDataURL) return element.toDataURL();
            if (this.srcFromAttribute) return element.getAttribute("src") || "";
            else return element.src;
        } else return this.src || "";
    }
    /**
	* Alias for getSrc
	* @param filtered
	* @deprecated
	*/ getSvgSrc(filtered) {
        return this.getSrc(filtered);
    }
    /**
	* Loads and sets source of an image\
	* **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
	* @param {String} src Source string (URL)
	* @param {LoadImageOptions} [options] Options object
	*/ setSrc(src, { crossOrigin: crossOrigin, signal: signal } = {}) {
        return $9a54cbcfc1af41ba$var$loadImage(src, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>{
            typeof crossOrigin !== "undefined" && this.set({
                crossOrigin: crossOrigin
            });
            this.setElement(img);
        });
    }
    /**
	* Returns string representation of an instance
	* @return {String} String representation of an instance
	*/ toString() {
        return `#<Image: { src: "${this.getSrc()}" }>`;
    }
    applyResizeFilters() {
        const filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.x, scaleY = objectScale.y, elementToFilter = this._filteredEl || this._originalElement;
        if (this.group) this.set("dirty", true);
        if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
            this._element = elementToFilter;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            this._lastScaleX = scaleX;
            this._lastScaleY = scaleY;
            return;
        }
        const canvasEl = $9a54cbcfc1af41ba$var$createCanvasElementFor(elementToFilter), { width: width, height: height } = elementToFilter;
        this._element = canvasEl;
        this._lastScaleX = filter.scaleX = scaleX;
        this._lastScaleY = filter.scaleY = scaleY;
        $9a54cbcfc1af41ba$export$8c3a6bdf56bdf106().applyFilters([
            filter
        ], elementToFilter, width, height, this._element);
        this._filterScalingX = canvasEl.width / this._originalElement.width;
        this._filterScalingY = canvasEl.height / this._originalElement.height;
    }
    /**
	* Applies filters assigned to this image (from "filters" array) or from filter param
	* @param {Array} filters to be applied
	* @param {Boolean} forResizing specify if the filter operation is a resize operation
	*/ applyFilters(filters = this.filters || []) {
        filters = filters.filter((filter)=>filter && !filter.isNeutralState());
        this.set("dirty", true);
        this.removeTexture(`${this.cacheKey}_filtered`);
        if (filters.length === 0) {
            this._element = this._originalElement;
            this._filteredEl = void 0;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            return;
        }
        const imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
        if (this._element === this._originalElement) {
            const canvasEl = $9a54cbcfc1af41ba$var$createCanvasElementFor({
                width: sourceWidth,
                height: sourceHeight
            });
            this._element = canvasEl;
            this._filteredEl = canvasEl;
        } else if (this._filteredEl) {
            this._element = this._filteredEl;
            this._filteredEl.getContext("2d").clearRect(0, 0, sourceWidth, sourceHeight);
            this._lastScaleX = 1;
            this._lastScaleY = 1;
        }
        $9a54cbcfc1af41ba$export$8c3a6bdf56bdf106().applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
        if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
            this._filterScalingX = this._element.width / this._originalElement.width;
            this._filterScalingY = this._element.height / this._originalElement.height;
        }
    }
    /**
	* @private
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ _render(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        if (this.isMoving !== true && this.resizeFilter && this._needsResize()) this.applyResizeFilters();
        this._stroke(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
	* Paint the cached copy of the object on the target context.
	* it will set the imageSmoothing for the draw operation
	* @param {CanvasRenderingContext2D} ctx Context to render on
	*/ drawCacheOnCanvas(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        super.drawCacheOnCanvas(ctx);
    }
    /**
	* Decide if the FabricImage should cache or not. Create its own cache level
	* needsItsOwnCache should be used when the object drawing method requires
	* a cache step.
	* Generally you do not cache objects in groups because the group outside is cached.
	* This is the special Image version where we would like to avoid caching where possible.
	* Essentially images do not benefit from caching. They may require caching, and in that
	* case we do it. Also caching an image usually ends in a loss of details.
	* A full performance audit should be done.
	* @return {Boolean}
	*/ shouldCache() {
        return this.needsItsOwnCache();
    }
    _renderFill(ctx) {
        const elementToDraw = this._element;
        if (!elementToDraw) return;
        const scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, cropX = Math.max(this.cropX, 0), cropY = Math.max(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, sW = Math.min(w * scaleX, elWidth - sX), sH = Math.min(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = Math.min(w, elWidth / scaleX - cropX), maxDestH = Math.min(h, elHeight / scaleY - cropY);
        elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    }
    /**
	* needed to check if image needs resize
	* @private
	*/ _needsResize() {
        const scale = this.getTotalObjectScaling();
        return scale.x !== this._lastScaleX || scale.y !== this._lastScaleY;
    }
    /**
	* @private
	* @deprecated unused
	*/ _resetWidthHeight() {
        this.set(this.getOriginalSize());
    }
    /**
	* @private
	* Set the width and the height of the image object, using the element or the
	* options.
	*/ _setWidthHeight({ width: width, height: height } = {}) {
        const size = this.getOriginalSize();
        this.width = width || size.width;
        this.height = height || size.height;
    }
    /**
	* Calculate offset for center and scale factor for the image in order to respect
	* the preserveAspectRatio attribute
	* @private
	*/ parsePreserveAspectRatioAttribute() {
        const pAR = $9a54cbcfc1af41ba$var$parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""), pWidth = this.width, pHeight = this.height, parsedAttributes = {
            width: pWidth,
            height: pHeight
        };
        let rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset;
        if (pAR && (pAR.alignX !== "none" || pAR.alignY !== "none")) {
            if (pAR.meetOrSlice === "meet") {
                scaleX = scaleY = $9a54cbcfc1af41ba$var$findScaleToFit(this._element, parsedAttributes);
                offset = (pWidth - rWidth * scaleX) / 2;
                if (pAR.alignX === "Min") offsetLeft = -offset;
                if (pAR.alignX === "Max") offsetLeft = offset;
                offset = (pHeight - rHeight * scaleY) / 2;
                if (pAR.alignY === "Min") offsetTop = -offset;
                if (pAR.alignY === "Max") offsetTop = offset;
            }
            if (pAR.meetOrSlice === "slice") {
                scaleX = scaleY = $9a54cbcfc1af41ba$var$findScaleToCover(this._element, parsedAttributes);
                offset = rWidth - pWidth / scaleX;
                if (pAR.alignX === "Mid") cropX = offset / 2;
                if (pAR.alignX === "Max") cropX = offset;
                offset = rHeight - pHeight / scaleY;
                if (pAR.alignY === "Mid") cropY = offset / 2;
                if (pAR.alignY === "Max") cropY = offset;
                rWidth = pWidth / scaleX;
                rHeight = pHeight / scaleY;
            }
        } else {
            scaleX = pWidth / rWidth;
            scaleY = pHeight / rHeight;
        }
        return {
            width: rWidth,
            height: rHeight,
            scaleX: scaleX,
            scaleY: scaleY,
            offsetLeft: offsetLeft,
            offsetTop: offsetTop,
            cropX: cropX,
            cropY: cropY
        };
    }
    /**
	* Creates an instance of FabricImage from its object representation
	* @param {Object} object Object to create an instance from
	* @param {object} [options] Options object
	* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @returns {Promise<FabricImage>}
	*/ static fromObject({ filters: f, resizeFilter: rf, src: src, crossOrigin: crossOrigin, type: type, ...object }, options) {
        return Promise.all([
            $9a54cbcfc1af41ba$var$loadImage(src, {
                ...options,
                crossOrigin: crossOrigin
            }),
            f && $9a54cbcfc1af41ba$var$enlivenObjects(f, options),
            rf ? $9a54cbcfc1af41ba$var$enlivenObjects([
                rf
            ], options) : [],
            $9a54cbcfc1af41ba$var$enlivenObjectEnlivables(object, options)
        ]).then(([el, filters = [], [resizeFilter], hydratedProps = {}])=>{
            return new this(el, {
                ...object,
                src: src,
                filters: filters,
                resizeFilter: resizeFilter,
                ...hydratedProps
            });
        });
    }
    /**
	* Creates an instance of Image from an URL string
	* @param {String} url URL to create an image from
	* @param {LoadImageOptions} [options] Options object
	* @returns {Promise<FabricImage>}
	*/ static fromURL(url, { crossOrigin: crossOrigin = null, signal: signal } = {}, imageOptions) {
        return $9a54cbcfc1af41ba$var$loadImage(url, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>new this(img, imageOptions));
    }
    /**
	* Returns {@link FabricImage} instance from an SVG element
	* @param {HTMLElement} element Element to parse
	* @param {Object} [options] Options object
	* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @param {Function} callback Callback to execute when Image object is created
	*/ static async fromElement(element, options = {}, cssRules) {
        const parsedAttributes = $9a54cbcfc1af41ba$var$parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
        return this.fromURL(parsedAttributes["xlink:href"] || parsedAttributes["href"], options, parsedAttributes).catch((err)=>{
            $9a54cbcfc1af41ba$var$log("log", "Unable to parse Image", err);
            return null;
        });
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$3148ec5c6497ddc8, "type", "Image");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$3148ec5c6497ddc8, "cacheProperties", [
    ...$9a54cbcfc1af41ba$var$cacheProperties,
    ...$9a54cbcfc1af41ba$var$IMAGE_PROPS
]);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$3148ec5c6497ddc8, "ownDefaults", $9a54cbcfc1af41ba$var$imageDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$export$3148ec5c6497ddc8, "ATTRIBUTE_NAMES", [
    ...$9a54cbcfc1af41ba$var$SHARED_ATTRIBUTES,
    "x",
    "y",
    "width",
    "height",
    "preserveAspectRatio",
    "xlink:href",
    "href",
    "crossOrigin",
    "image-rendering"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$export$3148ec5c6497ddc8);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setSVGClass($9a54cbcfc1af41ba$export$3148ec5c6497ddc8);
//#endregion
//#region src/parser/applyViewboxTransform.ts
/**
* Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
*/ function $9a54cbcfc1af41ba$var$applyViewboxTransform(element) {
    if (!$9a54cbcfc1af41ba$var$svgViewBoxElementsRegEx.test(element.nodeName)) return {};
    const viewBoxAttr = element.getAttribute("viewBox");
    let scaleX = 1;
    let scaleY = 1;
    let minX = 0;
    let minY = 0;
    let matrix;
    let el;
    const widthAttr = element.getAttribute("width");
    const heightAttr = element.getAttribute("height");
    const x = element.getAttribute("x") || 0;
    const y = element.getAttribute("y") || 0;
    const missingViewBox = !(viewBoxAttr && $9a54cbcfc1af41ba$var$reViewBoxAttrValue.test(viewBoxAttr));
    const missingDimAttr = !widthAttr || !heightAttr || widthAttr === "100%" || heightAttr === "100%";
    let translateMatrix = "";
    let widthDiff = 0;
    let heightDiff = 0;
    if (missingViewBox) {
        if ((x || y) && element.parentNode && element.parentNode.nodeName !== "#document") {
            translateMatrix = " translate(" + $9a54cbcfc1af41ba$var$parseUnit(x || "0") + " " + $9a54cbcfc1af41ba$var$parseUnit(y || "0") + ") ";
            matrix = (element.getAttribute("transform") || "") + translateMatrix;
            element.setAttribute("transform", matrix);
            element.removeAttribute("x");
            element.removeAttribute("y");
        }
    }
    if (missingViewBox && missingDimAttr) return {
        width: 0,
        height: 0
    };
    const parsedDim = {
        width: 0,
        height: 0
    };
    if (missingViewBox) {
        parsedDim.width = $9a54cbcfc1af41ba$var$parseUnit(widthAttr);
        parsedDim.height = $9a54cbcfc1af41ba$var$parseUnit(heightAttr);
        return parsedDim;
    }
    const pasedViewBox = viewBoxAttr.match($9a54cbcfc1af41ba$var$reViewBoxAttrValue);
    minX = -parseFloat(pasedViewBox[1]);
    minY = -parseFloat(pasedViewBox[2]);
    const viewBoxWidth = parseFloat(pasedViewBox[3]);
    const viewBoxHeight = parseFloat(pasedViewBox[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
        parsedDim.width = $9a54cbcfc1af41ba$var$parseUnit(widthAttr);
        parsedDim.height = $9a54cbcfc1af41ba$var$parseUnit(heightAttr);
        scaleX = parsedDim.width / viewBoxWidth;
        scaleY = parsedDim.height / viewBoxHeight;
    } else {
        parsedDim.width = viewBoxWidth;
        parsedDim.height = viewBoxHeight;
    }
    const preserveAspectRatio = $9a54cbcfc1af41ba$var$parsePreserveAspectRatioAttribute(element.getAttribute("preserveAspectRatio") || "");
    if (preserveAspectRatio.alignX !== "none") {
        if (preserveAspectRatio.meetOrSlice === "meet") scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
        if (preserveAspectRatio.meetOrSlice === "slice") scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
        widthDiff = parsedDim.width - viewBoxWidth * scaleX;
        heightDiff = parsedDim.height - viewBoxHeight * scaleX;
        if (preserveAspectRatio.alignX === "Mid") widthDiff /= 2;
        if (preserveAspectRatio.alignY === "Mid") heightDiff /= 2;
        if (preserveAspectRatio.alignX === "Min") widthDiff = 0;
        if (preserveAspectRatio.alignY === "Min") heightDiff = 0;
    }
    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) return parsedDim;
    if ((x || y) && element.parentNode.nodeName !== "#document") translateMatrix = " translate(" + $9a54cbcfc1af41ba$var$parseUnit(x || "0") + " " + $9a54cbcfc1af41ba$var$parseUnit(y || "0") + ") ";
    matrix = translateMatrix + " matrix(" + scaleX + " 0 0 " + scaleY + " " + (minX * scaleX + widthDiff) + " " + (minY * scaleY + heightDiff) + ") ";
    if (element.nodeName === "svg") {
        el = element.ownerDocument.createElementNS($9a54cbcfc1af41ba$var$svgNS, "g");
        while(element.firstChild)el.appendChild(element.firstChild);
        element.appendChild(el);
    } else {
        el = element;
        el.removeAttribute("x");
        el.removeAttribute("y");
        matrix = el.getAttribute("transform") + matrix;
    }
    el.setAttribute("transform", matrix);
    return parsedDim;
}
//#endregion
//#region src/parser/getTagName.ts
const $9a54cbcfc1af41ba$var$getTagName = (node)=>node.tagName.replace("svg:", "");
//#endregion
//#region src/parser/hasInvalidAncestor.ts
const $9a54cbcfc1af41ba$var$svgInvalidAncestorsRegEx = $9a54cbcfc1af41ba$var$getSvgRegex($9a54cbcfc1af41ba$var$svgInvalidAncestors);
function $9a54cbcfc1af41ba$var$hasInvalidAncestor(element) {
    let _element = element;
    while(_element && (_element = _element.parentElement))if (_element && _element.nodeName && $9a54cbcfc1af41ba$var$svgInvalidAncestorsRegEx.test($9a54cbcfc1af41ba$var$getTagName(_element)) && !_element.getAttribute("instantiated_by_use")) return true;
    return false;
}
//#endregion
//#region src/parser/getMultipleNodes.ts
function $9a54cbcfc1af41ba$var$getMultipleNodes(doc, nodeNames) {
    let nodeName, nodeArray = [], nodeList, i, len;
    for(i = 0, len = nodeNames.length; i < len; i++){
        nodeName = nodeNames[i];
        nodeList = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", nodeName);
        nodeArray = nodeArray.concat(Array.from(nodeList));
    }
    return nodeArray;
}
//#endregion
//#region src/parser/parseUseDirectives.ts
function $9a54cbcfc1af41ba$var$parseUseDirectives(doc) {
    const nodelist = $9a54cbcfc1af41ba$var$getMultipleNodes(doc, [
        "use",
        "svg:use"
    ]);
    const skipAttributes = [
        "x",
        "y",
        "xlink:href",
        "href",
        "transform"
    ];
    for (const useElement of nodelist){
        const useAttributes = useElement.attributes;
        const useAttrMap = {};
        for (const attr of useAttributes)attr.value && (useAttrMap[attr.name] = attr.value);
        const xlink = (useAttrMap["xlink:href"] || useAttrMap.href || "").slice(1);
        if (xlink === "") return;
        const referencedElement = doc.getElementById(xlink);
        if (referencedElement === null) return;
        let clonedOriginal = referencedElement.cloneNode(true);
        const originalAttributes = clonedOriginal.attributes;
        const originalAttrMap = {};
        for (const attr of originalAttributes)attr.value && (originalAttrMap[attr.name] = attr.value);
        const { x: x = 0, y: y = 0, transform: transform = "" } = useAttrMap;
        const currentTrans = `${transform} ${originalAttrMap.transform || ""} translate(${x}, ${y})`;
        $9a54cbcfc1af41ba$var$applyViewboxTransform(clonedOriginal);
        if (/^svg$/i.test(clonedOriginal.nodeName)) {
            const el3 = clonedOriginal.ownerDocument.createElementNS($9a54cbcfc1af41ba$var$svgNS, "g");
            Object.entries(originalAttrMap).forEach(([name, value])=>el3.setAttributeNS($9a54cbcfc1af41ba$var$svgNS, name, value));
            el3.append(...clonedOriginal.childNodes);
            clonedOriginal = el3;
        }
        for (const attr of useAttributes){
            if (!attr) continue;
            const { name: name, value: value } = attr;
            if (skipAttributes.includes(name)) continue;
            if (name === "style") {
                const styleRecord = {};
                $9a54cbcfc1af41ba$var$parseStyleString(value, styleRecord);
                Object.entries(originalAttrMap).forEach(([name, value])=>{
                    styleRecord[name] = value;
                });
                $9a54cbcfc1af41ba$var$parseStyleString(originalAttrMap.style || "", styleRecord);
                const mergedStyles = Object.entries(styleRecord).map((entry)=>entry.join(":")).join(";");
                clonedOriginal.setAttribute(name, mergedStyles);
            } else !originalAttrMap[name] && clonedOriginal.setAttribute(name, value);
        }
        clonedOriginal.setAttribute("transform", currentTrans);
        clonedOriginal.setAttribute("instantiated_by_use", "1");
        clonedOriginal.removeAttribute("id");
        useElement.parentNode.replaceChild(clonedOriginal, useElement);
    }
}
//#endregion
//#region src/parser/recursivelyParseGradientsXlink.ts
const $9a54cbcfc1af41ba$var$gradientsAttrs = [
    "gradientTransform",
    "x1",
    "x2",
    "y1",
    "y2",
    "gradientUnits",
    "cx",
    "cy",
    "r",
    "fx",
    "fy"
];
const $9a54cbcfc1af41ba$var$xlinkAttr = "xlink:href";
function $9a54cbcfc1af41ba$var$recursivelyParseGradientsXlink(doc, gradient) {
    var _gradient$getAttribut;
    const xLink = ((_gradient$getAttribut = gradient.getAttribute($9a54cbcfc1af41ba$var$xlinkAttr)) === null || _gradient$getAttribut === void 0 ? void 0 : _gradient$getAttribut.slice(1)) || "", referencedGradient = doc.getElementById(xLink);
    if (referencedGradient && referencedGradient.getAttribute($9a54cbcfc1af41ba$var$xlinkAttr)) $9a54cbcfc1af41ba$var$recursivelyParseGradientsXlink(doc, referencedGradient);
    if (referencedGradient) {
        $9a54cbcfc1af41ba$var$gradientsAttrs.forEach((attr)=>{
            const value = referencedGradient.getAttribute(attr);
            if (!gradient.hasAttribute(attr) && value) gradient.setAttribute(attr, value);
        });
        if (!gradient.children.length) {
            const referenceClone = referencedGradient.cloneNode(true);
            while(referenceClone.firstChild)gradient.appendChild(referenceClone.firstChild);
        }
    }
    gradient.removeAttribute($9a54cbcfc1af41ba$var$xlinkAttr);
}
//#endregion
//#region src/parser/getGradientDefs.ts
const $9a54cbcfc1af41ba$var$tagArray = [
    "linearGradient",
    "radialGradient",
    "svg:linearGradient",
    "svg:radialGradient"
];
/**
* Parses an SVG document, returning all of the gradient declarations found in it
* @param {SVGDocument} doc SVG document to parse
* @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
*/ function $9a54cbcfc1af41ba$var$getGradientDefs(doc) {
    const elList = $9a54cbcfc1af41ba$var$getMultipleNodes(doc, $9a54cbcfc1af41ba$var$tagArray);
    const gradientDefs = {};
    let j = elList.length;
    while(j--){
        const el = elList[j];
        if (el.getAttribute("xlink:href")) $9a54cbcfc1af41ba$var$recursivelyParseGradientsXlink(doc, el);
        const id = el.getAttribute("id");
        if (id) gradientDefs[id] = el;
    }
    return gradientDefs;
}
//#endregion
//#region src/parser/getCSSRules.ts
/**
* Returns CSS rules for a given SVG document
* @param {HTMLElement} doc SVG document to parse
* @return {Object} CSS rules of this document
*/ function $9a54cbcfc1af41ba$var$getCSSRules(doc) {
    const styles = doc.getElementsByTagName("style");
    const allRules = {};
    for(let i = 0; i < styles.length; i++){
        const styleContents = (styles[i].textContent || "").replace(/\/\*[\s\S]*?\*\//g, "");
        if (styleContents.trim() === "") continue;
        styleContents.split("}").filter((rule, index, array)=>array.length > 1 && rule.trim()).forEach((rule)=>{
            if ((rule.match(/{/g) || []).length > 1 && rule.trim().startsWith("@")) return;
            const match = rule.split("{"), ruleObj = {}, propertyValuePairs = match[1].trim().split(";").filter(function(pair) {
                return pair.trim();
            });
            for(let j = 0; j < propertyValuePairs.length; j++){
                const pair = propertyValuePairs[j].split(":"), property = pair[0].trim();
                ruleObj[property] = pair[1].trim();
            }
            rule = match[0].trim();
            rule.split(",").forEach((_rule)=>{
                _rule = _rule.replace(/^svg/i, "").trim();
                if (_rule === "") return;
                allRules[_rule] = {
                    ...allRules[_rule] || {},
                    ...ruleObj
                };
            });
        });
    }
    return allRules;
}
//#endregion
//#region src/parser/elements_parser.ts
const $9a54cbcfc1af41ba$var$findTag = (el)=>$9a54cbcfc1af41ba$export$2792378e23a7920c.getSVGClass($9a54cbcfc1af41ba$var$getTagName(el).toLowerCase());
var $9a54cbcfc1af41ba$var$ElementsParser = class {
    constructor(elements, options, reviver, doc, clipPaths){
        this.elements = elements;
        this.options = options;
        this.reviver = reviver;
        this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
        this.doc = doc;
        this.clipPaths = clipPaths;
        this.gradientDefs = $9a54cbcfc1af41ba$var$getGradientDefs(doc);
        this.cssRules = $9a54cbcfc1af41ba$var$getCSSRules(doc);
    }
    parse() {
        return Promise.all(this.elements.map((element)=>this.createObject(element)));
    }
    async createObject(el) {
        const klass = $9a54cbcfc1af41ba$var$findTag(el);
        if (klass) {
            const obj = await klass.fromElement(el, this.options, this.cssRules);
            this.resolveGradient(obj, el, $9a54cbcfc1af41ba$var$FILL);
            this.resolveGradient(obj, el, $9a54cbcfc1af41ba$var$STROKE);
            if (obj instanceof $9a54cbcfc1af41ba$export$3148ec5c6497ddc8 && obj._originalElement) $9a54cbcfc1af41ba$var$removeTransformMatrixForSvgParsing(obj, obj.parsePreserveAspectRatioAttribute());
            else $9a54cbcfc1af41ba$var$removeTransformMatrixForSvgParsing(obj);
            await this.resolveClipPath(obj, el);
            this.reviver && this.reviver(el, obj);
            return obj;
        }
        return null;
    }
    extractPropertyDefinition(obj, property, storage) {
        const value = obj[property], regex = this.regexUrl;
        if (!regex.test(value)) return;
        regex.lastIndex = 0;
        const id = regex.exec(value)[1];
        regex.lastIndex = 0;
        return storage[id];
    }
    resolveGradient(obj, el, property) {
        const gradientDef = this.extractPropertyDefinition(obj, property, this.gradientDefs);
        if (gradientDef) {
            const opacityAttr = el.getAttribute(property + "-opacity");
            const gradient = $9a54cbcfc1af41ba$export$3d3dd8f63ff0f876.fromElement(gradientDef, obj, {
                ...this.options,
                opacity: opacityAttr
            });
            obj.set(property, gradient);
        }
    }
    async resolveClipPath(obj, usingElement, exactOwner) {
        const clipPathElements = this.extractPropertyDefinition(obj, "clipPath", this.clipPaths);
        if (clipPathElements) {
            const objTransformInv = $9a54cbcfc1af41ba$var$invertTransform(obj.calcTransformMatrix());
            const clipPathTag = clipPathElements[0].parentElement;
            let clipPathOwner = usingElement;
            while(!exactOwner && clipPathOwner.parentElement && clipPathOwner.getAttribute("clip-path") !== obj.clipPath)clipPathOwner = clipPathOwner.parentElement;
            clipPathOwner.parentElement.appendChild(clipPathTag);
            const finalTransform = $9a54cbcfc1af41ba$var$parseTransformAttribute(`${clipPathOwner.getAttribute("transform") || ""} ${clipPathTag.getAttribute("originalTransform") || ""}`);
            clipPathTag.setAttribute("transform", `matrix(${finalTransform.join(",")})`);
            const container = await Promise.all(clipPathElements.map((clipPathElement)=>{
                return $9a54cbcfc1af41ba$var$findTag(clipPathElement).fromElement(clipPathElement, this.options, this.cssRules).then((enlivedClippath)=>{
                    $9a54cbcfc1af41ba$var$removeTransformMatrixForSvgParsing(enlivedClippath);
                    enlivedClippath.fillRule = enlivedClippath.clipRule;
                    delete enlivedClippath.clipRule;
                    return enlivedClippath;
                });
            }));
            const clipPath = container.length === 1 ? container[0] : new $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4(container);
            const gTransform = $9a54cbcfc1af41ba$var$multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
            if (clipPath.clipPath) await this.resolveClipPath(clipPath, clipPathOwner, clipPathTag.getAttribute("clip-path") ? clipPathOwner : void 0);
            const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX, translateX: translateX, translateY: translateY } = $9a54cbcfc1af41ba$var$qrDecompose(gTransform);
            clipPath.set({
                flipX: false,
                flipY: false
            });
            clipPath.set({
                scaleX: scaleX,
                scaleY: scaleY,
                angle: angle,
                skewX: skewX,
                skewY: 0
            });
            clipPath.setPositionByOrigin(new $9a54cbcfc1af41ba$export$baf26146a414f24a(translateX, translateY), $9a54cbcfc1af41ba$var$CENTER, $9a54cbcfc1af41ba$var$CENTER);
            obj.clipPath = clipPath;
        } else {
            delete obj.clipPath;
            return;
        }
    }
};
//#endregion
//#region src/parser/parseSVGDocument.ts
const $9a54cbcfc1af41ba$var$isValidSvgTag = (el)=>$9a54cbcfc1af41ba$var$svgValidTagNamesRegEx.test($9a54cbcfc1af41ba$var$getTagName(el));
const $9a54cbcfc1af41ba$var$createEmptyResponse = ()=>({
        objects: [],
        elements: [],
        options: {},
        allElements: []
    });
/**
* Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
* @param {HTMLElement} doc SVG document to parse
* @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
* @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
* Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
* or extra custom manipulation
* @param {Object} [options] Object containing options for parsing
* @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
* @return {SVGParsingOutput}
* {@link SVGParsingOutput} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
* You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
*/ async function $9a54cbcfc1af41ba$export$7489c3bacab04ae5(doc, reviver, { crossOrigin: crossOrigin, signal: signal } = {}) {
    if (signal && signal.aborted) {
        $9a54cbcfc1af41ba$var$log("log", new $9a54cbcfc1af41ba$var$SignalAbortedError("parseSVGDocument"));
        return $9a54cbcfc1af41ba$var$createEmptyResponse();
    }
    const documentElement = doc.documentElement;
    $9a54cbcfc1af41ba$var$parseUseDirectives(doc);
    const descendants = Array.from(documentElement.getElementsByTagName("*")), options = {
        ...$9a54cbcfc1af41ba$var$applyViewboxTransform(documentElement),
        crossOrigin: crossOrigin,
        signal: signal
    };
    const elements = descendants.filter((el)=>{
        $9a54cbcfc1af41ba$var$applyViewboxTransform(el);
        return $9a54cbcfc1af41ba$var$isValidSvgTag(el) && !$9a54cbcfc1af41ba$var$hasInvalidAncestor(el);
    });
    if (!elements || elements && !elements.length) return {
        ...$9a54cbcfc1af41ba$var$createEmptyResponse(),
        options: options,
        allElements: descendants
    };
    const localClipPaths = {};
    descendants.filter((el)=>$9a54cbcfc1af41ba$var$getTagName(el) === "clipPath").forEach((el)=>{
        el.setAttribute("originalTransform", el.getAttribute("transform") || "");
        const id = el.getAttribute("id");
        localClipPaths[id] = Array.from(el.getElementsByTagName("*")).filter((el)=>$9a54cbcfc1af41ba$var$isValidSvgTag(el));
    });
    return {
        objects: await new $9a54cbcfc1af41ba$var$ElementsParser(elements, options, reviver, doc, localClipPaths).parse(),
        elements: elements,
        options: options,
        allElements: descendants
    };
}
//#endregion
//#region src/parser/loadSVGFromString.ts
/**
* Takes string corresponding to an SVG document, and parses it into a set of fabric objects
* @param {String} string representing the svg
* @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
* {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
* You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
* @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
* Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
* or extra custom manipulation
* @param {Object} [options] Object containing options for parsing
* @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
*/ function $9a54cbcfc1af41ba$export$a0c5917fb6a8d612(string, reviver, options) {
    return $9a54cbcfc1af41ba$export$7489c3bacab04ae5(new ($9a54cbcfc1af41ba$export$4a3a3142573970c3()).DOMParser().parseFromString(string.trim(), "text/xml"), reviver, options);
}
//#endregion
//#region src/parser/loadSVGFromURL.ts
/**
* Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
* Note that SVG is fetched via fetch API, so it needs to conform to SOP (Same Origin Policy)
* @param {string} url where the SVG is
* @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
* {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
* You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
* @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
* Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
* or extra custom manipulation
* @param {Object} [options] Object containing options for parsing
* @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
* @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
*/ function $9a54cbcfc1af41ba$export$2b20e5519a374(url, reviver, options = {}) {
    return fetch(url.replace(/^\n\s*/, "").trim(), {
        signal: options.signal
    }).then((response)=>{
        if (!response.ok) throw new $9a54cbcfc1af41ba$var$FabricError(`HTTP error! status: ${response.status}`);
        return response.text();
    }).then((svgText)=>{
        return $9a54cbcfc1af41ba$export$a0c5917fb6a8d612(svgText, reviver, options);
    }).catch(()=>{
        return $9a54cbcfc1af41ba$var$createEmptyResponse();
    });
}
//#endregion
//#region src/filters/utils.ts
const $9a54cbcfc1af41ba$export$ec9091584da1706b = (options)=>{
    return options.webgl !== void 0;
};
/**
* Pick a method to copy data from GL context to 2d canvas.  In some browsers using
* drawImage should be faster, but is also bugged for a small combination of old hardware
* and drivers.
* putImageData is faster than drawImage for that specific operation.
*/ const $9a54cbcfc1af41ba$export$be5e33ed1f656bf4 = (width, height)=>{
    const targetCanvas = $9a54cbcfc1af41ba$var$createCanvasElementFor({
        width: width,
        height: height
    });
    const gl = $9a54cbcfc1af41ba$var$createCanvasElement().getContext("webgl");
    const testContext = {
        imageBuffer: /* @__PURE__ */ new ArrayBuffer(width * height * 4)
    };
    const testPipelineState = {
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
    };
    let startTime;
    startTime = $9a54cbcfc1af41ba$export$4a3a3142573970c3().performance.now();
    $9a54cbcfc1af41ba$export$42da2a27efef173b.prototype.copyGLTo2D.call(testContext, gl, testPipelineState);
    const drawImageTime = $9a54cbcfc1af41ba$export$4a3a3142573970c3().performance.now() - startTime;
    startTime = $9a54cbcfc1af41ba$export$4a3a3142573970c3().performance.now();
    $9a54cbcfc1af41ba$export$42da2a27efef173b.prototype.copyGLTo2DPutImageData.call(testContext, gl, testPipelineState);
    return drawImageTime > $9a54cbcfc1af41ba$export$4a3a3142573970c3().performance.now() - startTime;
};
//#endregion
//#region src/filters/shaders/baseFilter.ts
const $9a54cbcfc1af41ba$var$highPsourceCode = `precision highp float`;
const $9a54cbcfc1af41ba$var$identityFragmentShader = `
    ${$9a54cbcfc1af41ba$var$highPsourceCode};
    varying vec2 vTexCoord;
    uniform sampler2D uTexture;
    void main() {
      gl_FragColor = texture2D(uTexture, vTexCoord);
    }`;
const $9a54cbcfc1af41ba$var$vertexSource$1 = `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    void main() {
      vTexCoord = aPosition;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }`;
//#endregion
//#region src/filters/BaseFilter.ts
const $9a54cbcfc1af41ba$var$regex = new RegExp($9a54cbcfc1af41ba$var$highPsourceCode, "g");
var $9a54cbcfc1af41ba$var$BaseFilter = class {
    /**
	* Filter type
	*/ get type() {
        return this.constructor.type;
    }
    /**
	* Constructor
	* @param {Object} [options] Options object
	*/ constructor({ type: type, ...options } = {}){
        Object.assign(this, this.constructor.defaults, options);
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$identityFragmentShader;
    }
    getVertexSource() {
        return $9a54cbcfc1af41ba$var$vertexSource$1;
    }
    /**
	* Compile this filter's shader program.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
	* @param {String} fragmentSource fragmentShader source for compilation
	* @param {String} vertexSource vertexShader source for compilation
	*/ createProgram(gl, fragmentSource = this.getFragmentSource(), vertexSource = this.getVertexSource()) {
        const { WebGLProbe: { GLPrecision: GLPrecision = "highp" } } = $9a54cbcfc1af41ba$export$4bd44a2aa29d3d6e();
        if (GLPrecision !== "highp") fragmentSource = fragmentSource.replace($9a54cbcfc1af41ba$var$regex, $9a54cbcfc1af41ba$var$highPsourceCode.replace("highp", GLPrecision));
        const vertexShader = gl.createShader(gl.VERTEX_SHADER);
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        const program = gl.createProgram();
        if (!vertexShader || !fragmentShader || !program) throw new $9a54cbcfc1af41ba$var$FabricError("Vertex, fragment shader or program creation error");
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) throw new $9a54cbcfc1af41ba$var$FabricError(`Vertex shader compile error for ${this.type}: ${gl.getShaderInfoLog(vertexShader)}`);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) throw new $9a54cbcfc1af41ba$var$FabricError(`Fragment shader compile error for ${this.type}: ${gl.getShaderInfoLog(fragmentShader)}`);
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new $9a54cbcfc1af41ba$var$FabricError(`Shader link error for "${this.type}" ${gl.getProgramInfoLog(program)}`);
        const uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, "uStepW");
        uniformLocations.uStepH = gl.getUniformLocation(program, "uStepH");
        return {
            program: program,
            attributeLocations: this.getAttributeLocations(gl, program),
            uniformLocations: uniformLocations
        };
    }
    /**
	* Return a map of attribute names to WebGLAttributeLocation objects.
	*
	* @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	* @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
	* @returns {Object} A map of attribute names to attribute locations.
	*/ getAttributeLocations(gl, program) {
        return {
            aPosition: gl.getAttribLocation(program, "aPosition")
        };
    }
    /**
	* Return a map of uniform names to WebGLUniformLocation objects.
	*
	* @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	* @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
	* @returns {Object} A map of uniform names to uniform locations.
	*/ getUniformLocations(gl, program) {
        const locations = this.constructor.uniformLocations;
        const uniformLocations = {};
        for(let i = 0; i < locations.length; i++)uniformLocations[locations[i]] = gl.getUniformLocation(program, locations[i]);
        return uniformLocations;
    }
    /**
	* Send attribute data from this filter to its shader program on the GPU.
	*
	* @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	* @param {Object} attributeLocations A map of shader attribute names to their locations.
	*/ sendAttributeData(gl, attributeLocations, aPositionData) {
        const attributeLocation = attributeLocations.aPosition;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    }
    _setupFrameBuffer(options) {
        const gl = options.context;
        if (options.passes > 1) {
            const width = options.destinationWidth;
            const height = options.destinationHeight;
            if (options.sourceWidth !== width || options.sourceHeight !== height) {
                gl.deleteTexture(options.targetTexture);
                options.targetTexture = options.filterBackend.createTexture(gl, width, height);
            }
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
        } else {
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.finish();
        }
    }
    _swapTextures(options) {
        options.passes--;
        options.pass++;
        const temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
    }
    /**
	* Generic isNeutral implementation for one parameter based filters.
	* Used only in image applyFilters to discard filters that will not have an effect
	* on the image
	* Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
	* @param {Object} options
	**/ isNeutralState(options) {
        return false;
    }
    /**
	* Apply this filter to the input image data provided.
	*
	* Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	*
	* @param {Object} options
	* @param {Number} options.passes The number of filters remaining to be executed
	* @param {Boolean} options.webgl Whether to use webgl to render the filter.
	* @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	* @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	* @param {WebGLRenderingContext} options.context The GL context used for rendering.
	* @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	*/ applyTo(options) {
        if ($9a54cbcfc1af41ba$export$ec9091584da1706b(options)) {
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d(_options) {}
    /**
	* Returns a string that represent the current selected shader code for the filter.
	* Used to force recompilation when parameters change or to retrieve the shader from cache
	* @type string
	**/ getCacheKey() {
        return this.type;
    }
    /**
	* Retrieves the cached shader.
	* @param {Object} options
	* @param {WebGLRenderingContext} options.context The GL context used for rendering.
	* @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	* @return {WebGLProgram} the compiled program shader
	*/ retrieveShader(options) {
        const key = this.getCacheKey();
        if (!options.programCache[key]) options.programCache[key] = this.createProgram(options.context);
        return options.programCache[key];
    }
    /**
	* Apply this filter using webgl.
	*
	* @param {Object} options
	* @param {Number} options.passes The number of filters remaining to be executed
	* @param {Boolean} options.webgl Whether to use webgl to render the filter.
	* @param {WebGLTexture} options.originalTexture The texture of the original input image.
	* @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	* @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	* @param {WebGLRenderingContext} options.context The GL context used for rendering.
	* @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	*/ applyToWebGL(options) {
        const gl = options.context;
        const shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        else gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(gl, texture, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.activeTexture(gl.TEXTURE0);
    }
    unbindAdditionalTexture(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
    }
    /**
	* Send uniform data from this filter to its shader program on the GPU.
	*
	* Intended to be overridden by subclasses.
	*
	* @param {WebGLRenderingContext} _gl The canvas context used to compile the shader program.
	* @param {Object} _uniformLocations A map of shader uniform names to their locations.
	*/ sendUniformData(_gl, _uniformLocations) {}
    /**
	* If needed by a 2d filter, this functions can create an helper canvas to be used
	* remember that options.targetCanvas is available for use till end of chain.
	*/ createHelpLayer(options) {
        if (!options.helpLayer) {
            const { sourceWidth: sourceWidth, sourceHeight: sourceHeight } = options;
            options.helpLayer = $9a54cbcfc1af41ba$var$createCanvasElementFor({
                width: sourceWidth,
                height: sourceHeight
            });
        }
    }
    /**
	* Returns object representation of an instance
	* It will automatically export the default values of a filter,
	* stored in the static defaults property.
	* @return {Object} Object representation of an instance
	*/ toObject() {
        const defaultKeys = Object.keys(this.constructor.defaults || {});
        return {
            type: this.type,
            ...defaultKeys.reduce((acc, key)=>{
                acc[key] = this[key];
                return acc;
            }, {})
        };
    }
    /**
	* Returns a JSON representation of an instance
	* @return {Object} JSON
	*/ toJSON() {
        return this.toObject();
    }
    static async fromObject({ type: type, ...filterOptions }, _options) {
        return new this(filterOptions);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BaseFilter, "type", "BaseFilter");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BaseFilter, "uniformLocations", []);
//#endregion
//#region src/filters/shaders/blendColor.ts
const $9a54cbcfc1af41ba$var$blendColorFragmentSource = {
    multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
    screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
    add: "gl_FragColor.rgb += uColor.rgb;\n",
    difference: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
    subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
    lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
    darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
    exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
    overlay: `
    if (uColor.r < 0.5) {
      gl_FragColor.r *= 2.0 * uColor.r;
    } else {
      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);
    }
    if (uColor.g < 0.5) {
      gl_FragColor.g *= 2.0 * uColor.g;
    } else {
      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);
    }
    if (uColor.b < 0.5) {
      gl_FragColor.b *= 2.0 * uColor.b;
    } else {
      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);
    }
    `,
    tint: `
    gl_FragColor.rgb *= (1.0 - uColor.a);
    gl_FragColor.rgb += uColor.rgb;
    `
};
//#endregion
//#region src/filters/BlendColor.ts
const $9a54cbcfc1af41ba$var$blendColorDefaultValues = {
    color: "#F95C63",
    mode: "multiply",
    alpha: 1
};
/**
* Color Blend filter class
* @example
* const filter = new BlendColor({
*  color: '#000',
*  mode: 'multiply'
* });
*
* const filter = new BlendImage({
*  image: fabricImageObject,
*  mode: 'multiply'
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$BlendColor = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getCacheKey() {
        return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
        return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec4 uColor;
      varying vec2 vTexCoord;
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        gl_FragColor = color;
        if (color.a > 0.0) {
          ${$9a54cbcfc1af41ba$var$blendColorFragmentSource[this.mode]}
        }
      }
      `;
    }
    /**
	* Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const source = new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).getSource();
        const alpha = this.alpha;
        const tr = source[0] * alpha;
        const tg = source[1] * alpha;
        const tb = source[2] * alpha;
        const alpha1 = 1 - alpha;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            let oR, oG, oB;
            switch(this.mode){
                case "multiply":
                    oR = r * tr / 255;
                    oG = g * tg / 255;
                    oB = b * tb / 255;
                    break;
                case "screen":
                    oR = 255 - (255 - r) * (255 - tr) / 255;
                    oG = 255 - (255 - g) * (255 - tg) / 255;
                    oB = 255 - (255 - b) * (255 - tb) / 255;
                    break;
                case "add":
                    oR = r + tr;
                    oG = g + tg;
                    oB = b + tb;
                    break;
                case "difference":
                    oR = Math.abs(r - tr);
                    oG = Math.abs(g - tg);
                    oB = Math.abs(b - tb);
                    break;
                case "subtract":
                    oR = r - tr;
                    oG = g - tg;
                    oB = b - tb;
                    break;
                case "darken":
                    oR = Math.min(r, tr);
                    oG = Math.min(g, tg);
                    oB = Math.min(b, tb);
                    break;
                case "lighten":
                    oR = Math.max(r, tr);
                    oG = Math.max(g, tg);
                    oB = Math.max(b, tb);
                    break;
                case "overlay":
                    oR = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                    oG = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                    oB = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                    break;
                case "exclusion":
                    oR = tr + r - 2 * tr * r / 255;
                    oG = tg + g - 2 * tg * g / 255;
                    oB = tb + b - 2 * tb * b / 255;
                    break;
                case "tint":
                    oR = tr + r * alpha1;
                    oG = tg + g * alpha1;
                    oB = tb + b * alpha1;
            }
            data[i] = oR;
            data[i + 1] = oG;
            data[i + 2] = oB;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        const source = new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).getSource();
        source[0] = this.alpha * source[0] / 255;
        source[1] = this.alpha * source[1] / 255;
        source[2] = this.alpha * source[2] / 255;
        source[3] = this.alpha;
        gl.uniform4fv(uniformLocations.uColor, source);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendColor, "defaults", $9a54cbcfc1af41ba$var$blendColorDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendColor, "type", "BlendColor");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendColor, "uniformLocations", [
    "uColor"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$BlendColor);
//#endregion
//#region src/filters/shaders/blendImage.ts
const $9a54cbcfc1af41ba$var$fragmentSource$12 = {
    multiply: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.rgba *= color2.rgba;
      gl_FragColor = color;
    }
    `,
    mask: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.a = color2.a;
      gl_FragColor = color;
    }
    `
};
const $9a54cbcfc1af41ba$var$vertexSource = `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    uniform mat3 uTransformMatrix;
    void main() {
      vTexCoord = aPosition;
      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }
    `;
//#endregion
//#region src/filters/BlendImage.ts
const $9a54cbcfc1af41ba$var$blendImageDefaultValues = {
    mode: "multiply",
    alpha: 1
};
/**
* Image Blend filter class
* @example
* const filter = new filters.BlendColor({
*  color: '#000',
*  mode: 'multiply'
* });
*
* const filter = new BlendImage({
*  image: fabricImageObject,
*  mode: 'multiply'
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$BlendImage = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getCacheKey() {
        return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$12[this.mode];
    }
    getVertexSource() {
        return $9a54cbcfc1af41ba$var$vertexSource;
    }
    applyToWebGL(options) {
        const gl = options.context, texture = this.createTexture(options.filterBackend, this.image);
        this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
        super.applyToWebGL(options);
        this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    }
    createTexture(backend, image) {
        return backend.getCachedTexture(image.cacheKey, image.getElement());
    }
    /**
	* Calculate a transformMatrix to adapt the image to blend over
	* @param {Object} options
	* @param {WebGLRenderingContext} options.context The GL context used for rendering.
	* @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	*/ calculateMatrix() {
        const image = this.image, { width: width, height: height } = image.getElement();
        return [
            1 / image.scaleX,
            0,
            0,
            0,
            1 / image.scaleY,
            0,
            -image.left / width,
            -image.top / height,
            1
        ];
    }
    /**
	* Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data, width: width, height: height }, filterBackend: { resources: resources } }) {
        const image = this.image;
        if (!resources.blendImage) resources.blendImage = $9a54cbcfc1af41ba$var$createCanvasElement();
        const canvas1 = resources.blendImage;
        const context = canvas1.getContext("2d");
        if (canvas1.width !== width || canvas1.height !== height) {
            canvas1.width = width;
            canvas1.height = height;
        } else context.clearRect(0, 0, width, height);
        context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
        context.drawImage(image.getElement(), 0, 0, width, height);
        const blendData = context.getImageData(0, 0, width, height).data;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            const tr = blendData[i];
            const tg = blendData[i + 1];
            const tb = blendData[i + 2];
            const ta = blendData[i + 3];
            switch(this.mode){
                case "multiply":
                    data[i] = r * tr / 255;
                    data[i + 1] = g * tg / 255;
                    data[i + 2] = b * tb / 255;
                    data[i + 3] = a * ta / 255;
                    break;
                case "mask":
                    data[i + 3] = ta;
                    break;
            }
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        const matrix = this.calculateMatrix();
        gl.uniform1i(uniformLocations.uImage, 1);
        gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    }
    /**
	* Returns object representation of an instance
	* TODO: Handle the possibility of missing image better.
	* As of now a BlendImage filter without image can't be used with fromObject
	* @return {Object} Object representation of an instance
	*/ toObject() {
        return {
            ...super.toObject(),
            image: this.image && this.image.toObject()
        };
    }
    /**
	* Create filter instance from an object representation
	* @param {object} object Object to create an instance from
	* @param {object} [options]
	* @param {AbortSignal} [options.signal] handle aborting image loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @returns {Promise<BlendImage>}
	*/ static async fromObject({ type: type, image: image, ...filterOptions }, options) {
        return $9a54cbcfc1af41ba$export$3148ec5c6497ddc8.fromObject(image, options).then((enlivedImage)=>new this({
                ...filterOptions,
                image: enlivedImage
            }));
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendImage, "type", "BlendImage");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendImage, "defaults", $9a54cbcfc1af41ba$var$blendImageDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$BlendImage, "uniformLocations", [
    "uTransformMatrix",
    "uImage"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$BlendImage);
//#endregion
//#region src/filters/shaders/blur.ts
const $9a54cbcfc1af41ba$var$fragmentSource$11 = `
    precision highp float;
    uniform sampler2D uTexture;
    uniform vec2 uDelta;
    varying vec2 vTexCoord;
    const float nSamples = 15.0;
    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);
    float random(vec3 scale) {
      /* use the fragment position for a different seed per-pixel */
      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);
    }
    void main() {
      vec4 color = vec4(0.0);
      float totalC = 0.0;
      float totalA = 0.0;
      float offset = random(v3offset);
      for (float t = -nSamples; t <= nSamples; t++) {
        float percent = (t + offset - 0.5) / nSamples;
        vec4 sample = texture2D(uTexture, vTexCoord + uDelta * percent);
        float weight = 1.0 - abs(percent);
        float alpha = weight * sample.a;
        color.rgb += sample.rgb * alpha;
        color.a += alpha;
        totalA += weight;
        totalC += alpha;
      }
      gl_FragColor.rgb = color.rgb / totalC;
      gl_FragColor.a = color.a / totalA;
    }
  `;
//#endregion
//#region src/filters/Blur.ts
const $9a54cbcfc1af41ba$var$blurDefaultValues = {
    blur: 0
};
/**
* Blur filter class
* @example
* const filter = new Blur({
*   blur: 0.5
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$Blur = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$11;
    }
    applyTo(options) {
        if ($9a54cbcfc1af41ba$export$ec9091584da1706b(options)) {
            this.aspectRatio = options.sourceWidth / options.sourceHeight;
            options.passes++;
            this._setupFrameBuffer(options);
            this.horizontal = true;
            this.applyToWebGL(options);
            this._swapTextures(options);
            this._setupFrameBuffer(options);
            this.horizontal = false;
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d({ imageData: { data: data, width: width, height: height } }) {
        this.aspectRatio = width / height;
        this.horizontal = true;
        let blurValue = this.getBlurValue() * width;
        const imageData = new Uint8ClampedArray(data);
        const samples = 15;
        const bytesInRow = 4 * width;
        for(let i = 0; i < data.length; i += 4){
            let r = 0, g = 0, b = 0, a = 0, totalA = 0;
            const minIRow = i - i % bytesInRow;
            const maxIRow = minIRow + bytesInRow;
            for(let j = -samples + 1; j < samples; j++){
                const percent = j / samples;
                const distance = Math.floor(blurValue * percent) * 4;
                const weight = 1 - Math.abs(percent);
                let sampledPixel = i + distance;
                if (sampledPixel < minIRow) sampledPixel = minIRow;
                else if (sampledPixel > maxIRow) sampledPixel = maxIRow;
                const localAlpha = data[sampledPixel + 3] * weight;
                r += data[sampledPixel] * localAlpha;
                g += data[sampledPixel + 1] * localAlpha;
                b += data[sampledPixel + 2] * localAlpha;
                a += localAlpha;
                totalA += weight;
            }
            imageData[i] = r / a;
            imageData[i + 1] = g / a;
            imageData[i + 2] = b / a;
            imageData[i + 3] = a / totalA;
        }
        this.horizontal = false;
        blurValue = this.getBlurValue() * height;
        for(let i = 0; i < imageData.length; i += 4){
            let r = 0, g = 0, b = 0, a = 0, totalA = 0;
            const minIRow = i % bytesInRow;
            const maxIRow = imageData.length - bytesInRow + minIRow;
            for(let j = -samples + 1; j < samples; j++){
                const percent = j / samples;
                const distance = Math.floor(blurValue * percent) * bytesInRow;
                const weight = 1 - Math.abs(percent);
                let sampledPixel = i + distance;
                if (sampledPixel < minIRow) sampledPixel = minIRow;
                else if (sampledPixel > maxIRow) sampledPixel = maxIRow;
                const localAlpha = imageData[sampledPixel + 3] * weight;
                r += imageData[sampledPixel] * localAlpha;
                g += imageData[sampledPixel + 1] * localAlpha;
                b += imageData[sampledPixel + 2] * localAlpha;
                a += localAlpha;
                totalA += weight;
            }
            data[i] = r / a;
            data[i + 1] = g / a;
            data[i + 2] = b / a;
            data[i + 3] = a / totalA;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        const delta = this.chooseRightDelta();
        gl.uniform2fv(uniformLocations.uDelta, delta);
    }
    isNeutralState() {
        return this.blur === 0;
    }
    getBlurValue() {
        let blurScale = 1;
        const { horizontal: horizontal, aspectRatio: aspectRatio } = this;
        if (horizontal) {
            if (aspectRatio > 1) blurScale = 1 / aspectRatio;
        } else if (aspectRatio < 1) blurScale = aspectRatio;
        return blurScale * this.blur * .12;
    }
    /**
	* choose right value of image percentage to blur with
	* @returns {Array} a numeric array with delta values
	*/ chooseRightDelta() {
        const blur = this.getBlurValue();
        return this.horizontal ? [
            blur,
            0
        ] : [
            0,
            blur
        ];
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Blur, "type", "Blur");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Blur, "defaults", $9a54cbcfc1af41ba$var$blurDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Blur, "uniformLocations", [
    "uDelta"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Blur);
//#endregion
//#region src/filters/shaders/brightness.ts
const $9a54cbcfc1af41ba$var$fragmentSource$10 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBrightness;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += uBrightness;
    gl_FragColor = color;
  }
`;
//#endregion
//#region src/filters/Brightness.ts
const $9a54cbcfc1af41ba$var$brightnessDefaultValues = {
    brightness: 0
};
/**
* Brightness filter class
* @example
* const filter = new Brightness({
*   brightness: 0.05
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Brightness = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$10;
    }
    /**
	* Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const brightness = Math.round(this.brightness * 255);
        for(let i = 0; i < data.length; i += 4){
            data[i] += brightness;
            data[i + 1] += brightness;
            data[i + 2] += brightness;
        }
    }
    isNeutralState() {
        return this.brightness === 0;
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Brightness, "type", "Brightness");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Brightness, "defaults", $9a54cbcfc1af41ba$var$brightnessDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Brightness, "uniformLocations", [
    "uBrightness"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Brightness);
//#endregion
//#region src/filters/shaders/colorMatrix.ts
const $9a54cbcfc1af41ba$var$fragmentSource$9 = `
  precision highp float;
  uniform sampler2D uTexture;
  varying vec2 vTexCoord;
  uniform mat4 uColorMatrix;
  uniform vec4 uConstants;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color *= uColorMatrix;
    color += uConstants;
    gl_FragColor = color;
  }`;
//#endregion
//#region src/filters/ColorMatrix.ts
const $9a54cbcfc1af41ba$var$colorMatrixDefaultValues = {
    matrix: [
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
    ],
    colorsOnly: true
};
/**
* Color Matrix filter class
* @see {@link http://fabric5.fabricjs.com/image-filters|ImageFilters demo}
* @see {@link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl demo}
* @example <caption>Kodachrome filter</caption>
* const filter = new ColorMatrix({
*  matrix: [
1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
-0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
-0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
0, 0, 0, 1, 0
]
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$ColorMatrix = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$9;
    }
    /**
	* Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8Array to be filtered.
	*/ applyTo2d(options) {
        const data = options.imageData.data, m = this.matrix, colorsOnly = this.colorsOnly;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
            data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
            data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
            if (!colorsOnly) {
                const a = data[i + 3];
                data[i] += a * m[3];
                data[i + 1] += a * m[8];
                data[i + 2] += a * m[13];
                data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
            }
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        const m = this.matrix, matrix = [
            m[0],
            m[1],
            m[2],
            m[3],
            m[5],
            m[6],
            m[7],
            m[8],
            m[10],
            m[11],
            m[12],
            m[13],
            m[15],
            m[16],
            m[17],
            m[18]
        ], constants = [
            m[4],
            m[9],
            m[14],
            m[19]
        ];
        gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
        gl.uniform4fv(uniformLocations.uConstants, constants);
    }
    toObject() {
        return {
            ...super.toObject(),
            matrix: [
                ...this.matrix
            ]
        };
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$ColorMatrix, "type", "ColorMatrix");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$ColorMatrix, "defaults", $9a54cbcfc1af41ba$var$colorMatrixDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$ColorMatrix, "uniformLocations", [
    "uColorMatrix",
    "uConstants"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$ColorMatrix);
//#endregion
//#region src/filters/ColorMatrixFilters.ts
function $9a54cbcfc1af41ba$var$createColorMatrixFilter(key, matrix) {
    var _Class;
    const newClass = (_Class = class extends $9a54cbcfc1af41ba$var$ColorMatrix {
        toObject() {
            return {
                type: this.type,
                colorsOnly: this.colorsOnly
            };
        }
    }, $9a54cbcfc1af41ba$var$_defineProperty(_Class, "type", key), $9a54cbcfc1af41ba$var$_defineProperty(_Class, "defaults", {
        colorsOnly: false,
        matrix: matrix
    }), _Class);
    $9a54cbcfc1af41ba$export$2792378e23a7920c.setClass(newClass, key);
    return newClass;
}
const $9a54cbcfc1af41ba$var$Brownie = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Brownie", [
    .5997,
    .34553,
    -0.27082,
    0,
    .186,
    -0.0377,
    .86095,
    .15059,
    0,
    -0.1449,
    .24113,
    -0.07441,
    .44972,
    0,
    -0.02965,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$Vintage = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Vintage", [
    .62793,
    .32021,
    -0.03965,
    0,
    .03784,
    .02578,
    .64411,
    .03259,
    0,
    .02926,
    .0466,
    -0.08512,
    .52416,
    0,
    .02023,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$Kodachrome = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Kodachrome", [
    1.12855,
    -0.39673,
    -0.03992,
    0,
    .24991,
    -0.16404,
    1.08352,
    -0.05498,
    0,
    .09698,
    -0.16786,
    -0.56034,
    1.60148,
    0,
    .13972,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$Technicolor = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Technicolor", [
    1.91252,
    -0.85453,
    -0.09155,
    0,
    .04624,
    -0.30878,
    1.76589,
    -0.10601,
    0,
    -0.27589,
    -0.2311,
    -0.75018,
    1.84759,
    0,
    .12137,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$Polaroid = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Polaroid", [
    1.438,
    -0.062,
    -0.062,
    0,
    0,
    -0.122,
    1.378,
    -0.122,
    0,
    0,
    -0.016,
    -0.016,
    1.483,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$Sepia = $9a54cbcfc1af41ba$var$createColorMatrixFilter("Sepia", [
    .393,
    .769,
    .189,
    0,
    0,
    .349,
    .686,
    .168,
    0,
    0,
    .272,
    .534,
    .131,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $9a54cbcfc1af41ba$var$BlackWhite = $9a54cbcfc1af41ba$var$createColorMatrixFilter("BlackWhite", [
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    0,
    0,
    0,
    1,
    0
]);
//#endregion
//#region src/filters/Composed.ts
/**
* A container class that knows how to apply a sequence of filters to an input image.
*/ var $9a54cbcfc1af41ba$var$Composed = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    constructor(options = {}){
        super(options);
        this.subFilters = options.subFilters || [];
    }
    /**
	* Apply this container's filters to the input image provided.
	*
	* @param {Object} options
	* @param {Number} options.passes The number of filters remaining to be applied.
	*/ applyTo(options) {
        if ($9a54cbcfc1af41ba$export$ec9091584da1706b(options)) options.passes += this.subFilters.length - 1;
        this.subFilters.forEach((filter)=>{
            filter.applyTo(options);
        });
    }
    /**
	* Serialize this filter into JSON.
	* @returns {Object} A JSON representation of this filter.
	*/ toObject() {
        return {
            type: this.type,
            subFilters: this.subFilters.map((filter)=>filter.toObject())
        };
    }
    isNeutralState() {
        return !this.subFilters.some((filter)=>!filter.isNeutralState());
    }
    /**
	* Deserialize a JSON definition of a ComposedFilter into a concrete instance.
	* @param {oject} object Object to create an instance from
	* @param {object} [options]
	* @param {AbortSignal} [options.signal] handle aborting `BlendImage` filter loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
	* @returns {Promise<Composed>}
	*/ static fromObject(object, options) {
        return Promise.all((object.subFilters || []).map((filter)=>$9a54cbcfc1af41ba$export$2792378e23a7920c.getClass(filter.type).fromObject(filter, options))).then((enlivedFilters)=>new this({
                subFilters: enlivedFilters
            }));
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Composed, "type", "Composed");
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Composed);
//#endregion
//#region src/filters/shaders/constrast.ts
const $9a54cbcfc1af41ba$var$fragmentSource$8 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uContrast;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));
    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;
    gl_FragColor = color;
  }`;
//#endregion
//#region src/filters/Contrast.ts
const $9a54cbcfc1af41ba$var$contrastDefaultValues = {
    contrast: 0
};
/**
* Contrast filter class
* @example
* const filter = new Contrast({
*   contrast: 0.25
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Contrast = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$8;
    }
    isNeutralState() {
        return this.contrast === 0;
    }
    /**
	* Apply the Contrast operation to a Uint8Array representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8Array to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
        for(let i = 0; i < data.length; i += 4){
            data[i] = contrastF * (data[i] - 128) + 128;
            data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
            data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uContrast, this.contrast);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Contrast, "type", "Contrast");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Contrast, "defaults", $9a54cbcfc1af41ba$var$contrastDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Contrast, "uniformLocations", [
    "uContrast"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Contrast);
//#endregion
//#region src/filters/shaders/convolute.ts
const $9a54cbcfc1af41ba$var$fragmentSource$7 = {
    Convolute_3_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `,
    Convolute_3_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `,
    Convolute_5_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `,
    Convolute_5_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `,
    Convolute_7_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `,
    Convolute_7_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `,
    Convolute_9_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `,
    Convolute_9_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `
};
//#endregion
//#region src/filters/Convolute.ts
const $9a54cbcfc1af41ba$var$convoluteDefaultValues = {
    opaque: false,
    matrix: [
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
    ]
};
/**
* Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
* @example <caption>Sharpen filter</caption>
* const filter = new Convolute({
*   matrix: [ 0, -1,  0,
*            -1,  5, -1,
*             0, -1,  0 ]
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
* @example <caption>Blur filter</caption>
* const filter = new Convolute({
*   matrix: [ 1/9, 1/9, 1/9,
*             1/9, 1/9, 1/9,
*             1/9, 1/9, 1/9 ]
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
* @example <caption>Emboss filter</caption>
* const filter = new Convolute({
*   matrix: [ 1,   1,  1,
*             1, 0.7, -1,
*            -1,  -1, -1 ]
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
* @example <caption>Emboss filter with opaqueness</caption>
* const filter = new Convolute({
*   opaque: true,
*   matrix: [ 1,   1,  1,
*             1, 0.7, -1,
*            -1,  -1, -1 ]
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$Convolute = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getCacheKey() {
        return `${this.type}_${Math.sqrt(this.matrix.length)}_${this.opaque ? 1 : 0}`;
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$7[this.getCacheKey()];
    }
    /**
	* Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d(options) {
        const imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, alphaFac = this.opaque ? 1 : 0;
        let r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
        for(y = 0; y < sh; y++)for(x = 0; x < sw; x++){
            dstOff = (y * sw + x) * 4;
            r = 0;
            g = 0;
            b = 0;
            a = 0;
            for(cy = 0; cy < side; cy++)for(cx = 0; cx < side; cx++){
                scy = y + cy - halfSide;
                scx = x + cx - halfSide;
                if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) continue;
                srcOff = (scy * sw + scx) * 4;
                wt = weights[cy * side + cx];
                r += data[srcOff] * wt;
                g += data[srcOff + 1] * wt;
                b += data[srcOff + 2] * wt;
                if (!alphaFac) a += data[srcOff + 3] * wt;
            }
            dst[dstOff] = r;
            dst[dstOff + 1] = g;
            dst[dstOff + 2] = b;
            if (!alphaFac) dst[dstOff + 3] = a;
            else dst[dstOff + 3] = data[dstOff + 3];
        }
        options.imageData = output;
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    }
    /**
	* Returns object representation of an instance
	* @return {Object} Object representation of an instance
	*/ toObject() {
        return {
            ...super.toObject(),
            opaque: this.opaque,
            matrix: [
                ...this.matrix
            ]
        };
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Convolute, "type", "Convolute");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Convolute, "defaults", $9a54cbcfc1af41ba$var$convoluteDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Convolute, "uniformLocations", [
    "uMatrix",
    "uOpaque",
    "uHalfSize",
    "uSize"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Convolute);
//#endregion
//#region src/filters/shaders/gamma.ts
const $9a54cbcfc1af41ba$var$fragmentSource$6 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uGamma;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 correction = (1.0 / uGamma);
    color.r = pow(color.r, correction.r);
    color.g = pow(color.g, correction.g);
    color.b = pow(color.b, correction.b);
    gl_FragColor = color;
    gl_FragColor.rgb *= color.a;
  }
`;
//#endregion
//#region src/filters/Gamma.ts
const $9a54cbcfc1af41ba$var$GAMMA = "Gamma";
const $9a54cbcfc1af41ba$var$gammaDefaultValues = {
    gamma: [
        1,
        1,
        1
    ]
};
/**
* Gamma filter class
* @example
* const filter = new Gamma({
*   gamma: [1, 0.5, 2.1]
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Gamma = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$6;
    }
    constructor(options = {}){
        super(options);
        this.gamma = options.gamma || this.constructor.defaults.gamma.concat();
    }
    /**
	* Apply the Gamma operation to a Uint8Array representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8Array to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const gamma = this.gamma, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2];
        if (!this.rgbValues) this.rgbValues = {
            r: new Uint8Array(256),
            g: new Uint8Array(256),
            b: new Uint8Array(256)
        };
        const rgb = this.rgbValues;
        for(let i = 0; i < 256; i++){
            rgb.r[i] = Math.pow(i / 255, rInv) * 255;
            rgb.g[i] = Math.pow(i / 255, gInv) * 255;
            rgb.b[i] = Math.pow(i / 255, bInv) * 255;
        }
        for(let i = 0; i < data.length; i += 4){
            data[i] = rgb.r[data[i]];
            data[i + 1] = rgb.g[data[i + 1]];
            data[i + 2] = rgb.b[data[i + 2]];
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    }
    isNeutralState() {
        const { gamma: gamma } = this;
        return gamma[0] === 1 && gamma[1] === 1 && gamma[2] === 1;
    }
    toObject() {
        return {
            type: $9a54cbcfc1af41ba$var$GAMMA,
            gamma: this.gamma.concat()
        };
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Gamma, "type", $9a54cbcfc1af41ba$var$GAMMA);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Gamma, "defaults", $9a54cbcfc1af41ba$var$gammaDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Gamma, "uniformLocations", [
    "uGamma"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Gamma);
//#endregion
//#region src/filters/shaders/grayscale.ts
const $9a54cbcfc1af41ba$var$fragmentSource$5 = {
    average: `
    precision highp float;
    uniform sampler2D uTexture;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      float average = (color.r + color.b + color.g) / 3.0;
      gl_FragColor = vec4(average, average, average, color.a);
    }
    `,
    lightness: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `,
    luminosity: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `
};
//#endregion
//#region src/filters/Grayscale.ts
const $9a54cbcfc1af41ba$var$grayscaleDefaultValues = {
    mode: "average"
};
/**
* Grayscale image filter class
* @example
* const filter = new Grayscale();
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Grayscale = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    /**
	* Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8Array to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        for(let i = 0, value; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            switch(this.mode){
                case "average":
                    value = (r + g + b) / 3;
                    break;
                case "lightness":
                    value = (Math.min(r, g, b) + Math.max(r, g, b)) / 2;
                    break;
                case "luminosity":
                    value = .21 * r + .72 * g + .07 * b;
                    break;
            }
            data[i + 2] = data[i + 1] = data[i] = value;
        }
    }
    getCacheKey() {
        return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$5[this.mode];
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1i(uniformLocations.uMode, 1);
    }
    /**
	* Grayscale filter isNeutralState implementation
	* The filter is never neutral
	* on the image
	**/ isNeutralState() {
        return false;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Grayscale, "type", "Grayscale");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Grayscale, "defaults", $9a54cbcfc1af41ba$var$grayscaleDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Grayscale, "uniformLocations", [
    "uMode"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Grayscale);
//#endregion
//#region src/filters/HueRotation.ts
const $9a54cbcfc1af41ba$var$hueRotationDefaultValues = {
    ...$9a54cbcfc1af41ba$var$colorMatrixDefaultValues,
    rotation: 0
};
/**
* HueRotation filter class
* @example
* const filter = new HueRotation({
*   rotation: -0.5
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$HueRotation = class extends $9a54cbcfc1af41ba$var$ColorMatrix {
    calculateMatrix() {
        const rad = this.rotation * Math.PI, cosine = $9a54cbcfc1af41ba$var$cos(rad), sine = $9a54cbcfc1af41ba$var$sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sine, OneMinusCos = 1 - cosine;
        this.matrix = [
            cosine + OneMinusCos / 3,
            aThird * OneMinusCos - aThirdSqtSin,
            aThird * OneMinusCos + aThirdSqtSin,
            0,
            0,
            aThird * OneMinusCos + aThirdSqtSin,
            cosine + aThird * OneMinusCos,
            aThird * OneMinusCos - aThirdSqtSin,
            0,
            0,
            aThird * OneMinusCos - aThirdSqtSin,
            aThird * OneMinusCos + aThirdSqtSin,
            cosine + aThird * OneMinusCos,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
    }
    isNeutralState() {
        return this.rotation === 0;
    }
    applyTo(options) {
        this.calculateMatrix();
        super.applyTo(options);
    }
    toObject() {
        return {
            type: this.type,
            rotation: this.rotation
        };
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$HueRotation, "type", "HueRotation");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$HueRotation, "defaults", $9a54cbcfc1af41ba$var$hueRotationDefaultValues);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$HueRotation);
//#endregion
//#region src/filters/shaders/invert.ts
const $9a54cbcfc1af41ba$var$fragmentSource$4 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform int uInvert;
  uniform int uAlpha;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    if (uInvert == 1) {
      if (uAlpha == 1) {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);
      } else {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);
      }
    } else {
      gl_FragColor = color;
    }
  }
`;
//#endregion
//#region src/filters/Invert.ts
const $9a54cbcfc1af41ba$var$invertDefaultValues = {
    alpha: false,
    invert: true
};
/**
* @example
* const filter = new Invert();
* object.filters.push(filter);
* object.applyFilters(canvas.renderAll.bind(canvas));
*/ var $9a54cbcfc1af41ba$var$Invert = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    /**
	* Apply the Invert operation to a Uint8Array representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8Array to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        for(let i = 0; i < data.length; i += 4){
            data[i] = 255 - data[i];
            data[i + 1] = 255 - data[i + 1];
            data[i + 2] = 255 - data[i + 2];
            if (this.alpha) data[i + 3] = 255 - data[i + 3];
        }
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$4;
    }
    /**
	* Invert filter isNeutralState implementation
	* Used only in image applyFilters to discard filters that will not have an effect
	* on the image
	* @param {Object} options
	**/ isNeutralState() {
        return !this.invert;
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1i(uniformLocations.uInvert, Number(this.invert));
        gl.uniform1i(uniformLocations.uAlpha, Number(this.alpha));
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Invert, "type", "Invert");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Invert, "defaults", $9a54cbcfc1af41ba$var$invertDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Invert, "uniformLocations", [
    "uInvert",
    "uAlpha"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Invert);
//#endregion
//#region src/filters/shaders/noise.ts
const $9a54cbcfc1af41ba$var$fragmentSource$3 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uStepH;
  uniform float uNoise;
  uniform float uSeed;
  varying vec2 vTexCoord;
  float rand(vec2 co, float seed, float vScale) {
    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);
  }
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;
    gl_FragColor = color;
  }
`;
//#endregion
//#region src/filters/Noise.ts
const $9a54cbcfc1af41ba$var$noiseDefaultValues = {
    noise: 0
};
/**
* Noise filter class
* @example
* const filter = new Noise({
*   noise: 700
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$Noise = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$3;
    }
    /**
	* Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const noise = this.noise;
        for(let i = 0; i < data.length; i += 4){
            const rand = (.5 - Math.random()) * noise;
            data[i] += rand;
            data[i + 1] += rand;
            data[i + 2] += rand;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
        gl.uniform1f(uniformLocations.uSeed, Math.random());
    }
    isNeutralState() {
        return this.noise === 0;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Noise, "type", "Noise");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Noise, "defaults", $9a54cbcfc1af41ba$var$noiseDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Noise, "uniformLocations", [
    "uNoise",
    "uSeed"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Noise);
//#endregion
//#region src/filters/shaders/pixelate.ts
const $9a54cbcfc1af41ba$var$fragmentSource$2 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBlocksize;
  uniform float uStepW;
  uniform float uStepH;
  varying vec2 vTexCoord;
  void main() {
    float blockW = uBlocksize * uStepW;
    float blockH = uBlocksize * uStepH;
    int posX = int(vTexCoord.x / blockW);
    int posY = int(vTexCoord.y / blockH);
    float fposX = float(posX);
    float fposY = float(posY);
    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);
    vec4 color = texture2D(uTexture, squareCoords);
    gl_FragColor = color;
  }
`;
//#endregion
//#region src/filters/Pixelate.ts
const $9a54cbcfc1af41ba$var$pixelateDefaultValues = {
    blocksize: 4
};
/**
* Pixelate filter class
* @example
* const filter = new Pixelate({
*   blocksize: 8
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Pixelate = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    /**
	* Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data, width: width, height: height } }) {
        for(let i = 0; i < height; i += this.blocksize)for(let j = 0; j < width; j += this.blocksize){
            const index = i * 4 * width + j * 4;
            const r = data[index];
            const g = data[index + 1];
            const b = data[index + 2];
            const a = data[index + 3];
            for(let _i = i; _i < Math.min(i + this.blocksize, height); _i++)for(let _j = j; _j < Math.min(j + this.blocksize, width); _j++){
                const index = _i * 4 * width + _j * 4;
                data[index] = r;
                data[index + 1] = g;
                data[index + 2] = b;
                data[index + 3] = a;
            }
        }
    }
    /**
	* Indicate when the filter is not gonna apply changes to the image
	**/ isNeutralState() {
        return this.blocksize === 1;
    }
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$2;
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Pixelate, "type", "Pixelate");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Pixelate, "defaults", $9a54cbcfc1af41ba$var$pixelateDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Pixelate, "uniformLocations", [
    "uBlocksize"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Pixelate);
//#endregion
//#region src/filters/shaders/removeColor.ts
const $9a54cbcfc1af41ba$var$fragmentShader = `
precision highp float;
uniform sampler2D uTexture;
uniform vec4 uLow;
uniform vec4 uHigh;
varying vec2 vTexCoord;
void main() {
  gl_FragColor = texture2D(uTexture, vTexCoord);
  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {
    gl_FragColor.a = 0.0;
  }
}
`;
//#endregion
//#region src/filters/RemoveColor.ts
const $9a54cbcfc1af41ba$var$removeColorDefaultValues = {
    color: "#FFFFFF",
    distance: .02,
    useAlpha: false
};
/**
* Remove white filter class
* @example
* const filter = new RemoveColor({
*   threshold: 0.2,
* });
* object.filters.push(filter);
* object.applyFilters();
* canvas.renderAll();
*/ var $9a54cbcfc1af41ba$var$RemoveColor = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentShader;
    }
    /**
	* Applies filter to canvas element
	* @param {Object} canvasEl Canvas element to apply filter to
	*/ applyTo2d({ imageData: { data: data } }) {
        const distance = this.distance * 255, source = new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).getSource(), lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance
        ], highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance
        ];
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) data[i + 3] = 0;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        const source = new $9a54cbcfc1af41ba$export$892596cec99bc70e(this.color).getSource(), distance = this.distance, lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
        ], highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
        ];
        gl.uniform4fv(uniformLocations.uLow, lowC);
        gl.uniform4fv(uniformLocations.uHigh, highC);
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$RemoveColor, "type", "RemoveColor");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$RemoveColor, "defaults", $9a54cbcfc1af41ba$var$removeColorDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$RemoveColor, "uniformLocations", [
    "uLow",
    "uHigh"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$RemoveColor);
//#endregion
//#region src/filters/Resize.ts
const $9a54cbcfc1af41ba$var$resizeDefaultValues = {
    resizeType: "hermite",
    scaleX: 1,
    scaleY: 1,
    lanczosLobes: 3
};
/**
* Resize image filter class
* @example
* const filter = new Resize();
* object.filters.push(filter);
* object.applyFilters(canvas.renderAll.bind(canvas));
*/ var $9a54cbcfc1af41ba$var$Resize = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [
            1 / this.width,
            0
        ] : [
            0,
            1 / this.height
        ]);
        gl.uniform1fv(uniformLocations.uTaps, this.taps);
    }
    getFilterWindow() {
        const scale = this.tempScale;
        return Math.ceil(this.lanczosLobes / scale);
    }
    getCacheKey() {
        const filterWindow = this.getFilterWindow();
        return `${this.type}_${filterWindow}`;
    }
    getFragmentSource() {
        const filterWindow = this.getFilterWindow();
        return this.generateShader(filterWindow);
    }
    getTaps() {
        const lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)taps[i - 1] = lobeFunction(i * scale);
        return taps;
    }
    /**
	* Generate vertex and shader sources from the necessary steps numbers
	* @param {Number} filterWindow
	*/ generateShader(filterWindow) {
        const offsets = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)offsets[i - 1] = `${i}.0 * uDelta`;
        return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec2 uDelta;
      varying vec2 vTexCoord;
      uniform float uTaps[${filterWindow}];
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float sum = 1.0;
        ${offsets.map((offset, i)=>`
              color += texture2D(uTexture, vTexCoord + ${offset}) * uTaps[${i}] + texture2D(uTexture, vTexCoord - ${offset}) * uTaps[${i}];
              sum += 2.0 * uTaps[${i}];
            `).join("\n")}
        gl_FragColor = color / sum;
      }
    `;
    }
    applyToForWebgl(options) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;
        super.applyTo(options);
        options.sourceWidth = options.destinationWidth;
        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;
        super.applyTo(options);
        options.sourceHeight = options.destinationHeight;
    }
    /**
	* Apply the resize filter to the image
	* Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	*
	* @param {Object} options
	* @param {Number} options.passes The number of filters remaining to be executed
	* @param {Boolean} options.webgl Whether to use webgl to render the filter.
	* @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	* @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	* @param {WebGLRenderingContext} options.context The GL context used for rendering.
	* @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	*/ applyTo(options) {
        if ($9a54cbcfc1af41ba$export$ec9091584da1706b(options)) this.applyToForWebgl(options);
        else this.applyTo2d(options);
    }
    isNeutralState() {
        return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(lobes) {
        return (x)=>{
            if (x >= lobes || x <= -lobes) return 0;
            if (x < 1.1920929e-7 && x > -0.00000011920929) return 1;
            x *= Math.PI;
            const xx = x / lobes;
            return Math.sin(x) / x * Math.sin(xx) / xx;
        };
    }
    applyTo2d(options) {
        const imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
        this.rcpScaleX = 1 / scaleX;
        this.rcpScaleY = 1 / scaleY;
        const oW = imageData.width;
        const oH = imageData.height;
        const dW = Math.round(oW * scaleX);
        const dH = Math.round(oH * scaleY);
        let newData;
        if (this.resizeType === "sliceHack") newData = this.sliceByTwo(options, oW, oH, dW, dH);
        else if (this.resizeType === "hermite") newData = this.hermiteFastResize(options, oW, oH, dW, dH);
        else if (this.resizeType === "bilinear") newData = this.bilinearFiltering(options, oW, oH, dW, dH);
        else if (this.resizeType === "lanczos") newData = this.lanczosResize(options, oW, oH, dW, dH);
        else newData = new ImageData(dW, dH);
        options.imageData = newData;
    }
    /**
	* Filter sliceByTwo
	* @param {Object} canvasEl Canvas element to apply filter to
	* @param {Number} oW Original Width
	* @param {Number} oH Original Height
	* @param {Number} dW Destination Width
	* @param {Number} dH Destination Height
	* @returns {ImageData}
	*/ sliceByTwo(options, oW, oH, dW, dH) {
        const imageData = options.imageData;
        const mult = .5;
        let doneW = false;
        let doneH = false;
        let stepW = oW * mult;
        let stepH = oH * mult;
        const resources = options.filterBackend.resources;
        let sX = 0;
        let sY = 0;
        const dX = oW;
        let dY = 0;
        if (!resources.sliceByTwo) resources.sliceByTwo = $9a54cbcfc1af41ba$var$createCanvasElement();
        const tmpCanvas = resources.sliceByTwo;
        if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
            tmpCanvas.width = oW * 1.5;
            tmpCanvas.height = oH;
        }
        const ctx = tmpCanvas.getContext("2d");
        ctx.clearRect(0, 0, oW * 1.5, oH);
        ctx.putImageData(imageData, 0, 0);
        dW = Math.floor(dW);
        dH = Math.floor(dH);
        while(!doneW || !doneH){
            oW = stepW;
            oH = stepH;
            if (dW < Math.floor(stepW * mult)) stepW = Math.floor(stepW * mult);
            else {
                stepW = dW;
                doneW = true;
            }
            if (dH < Math.floor(stepH * mult)) stepH = Math.floor(stepH * mult);
            else {
                stepH = dH;
                doneH = true;
            }
            ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
            sX = dX;
            sY = dY;
            dY += stepH;
        }
        return ctx.getImageData(sX, sY, dW, dH);
    }
    /**
	* Filter lanczosResize
	* @param {Object} canvasEl Canvas element to apply filter to
	* @param {Number} oW Original Width
	* @param {Number} oH Original Height
	* @param {Number} dW Destination Width
	* @param {Number} dH Destination Height
	* @returns {ImageData}
	*/ lanczosResize(options, oW, oH, dW, dH) {
        function process(u) {
            let v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
            center.x = (u + .5) * ratioX;
            icenter.x = Math.floor(center.x);
            for(v = 0; v < dH; v++){
                center.y = (v + .5) * ratioY;
                icenter.y = Math.floor(center.y);
                a = 0;
                red = 0;
                green = 0;
                blue = 0;
                alpha = 0;
                for(i = icenter.x - range2X; i <= icenter.x + range2X; i++){
                    if (i < 0 || i >= oW) continue;
                    fX = Math.floor(1e3 * Math.abs(i - center.x));
                    if (!cacheLanc[fX]) cacheLanc[fX] = {};
                    for(let j = icenter.y - range2Y; j <= icenter.y + range2Y; j++){
                        if (j < 0 || j >= oH) continue;
                        fY = Math.floor(1e3 * Math.abs(j - center.y));
                        if (!cacheLanc[fX][fY]) cacheLanc[fX][fY] = lanczos(Math.sqrt(Math.pow(fX * rcpRatioX, 2) + Math.pow(fY * rcpRatioY, 2)) / 1e3);
                        weight = cacheLanc[fX][fY];
                        if (weight > 0) {
                            idx = (j * oW + i) * 4;
                            a += weight;
                            red += weight * srcData[idx];
                            green += weight * srcData[idx + 1];
                            blue += weight * srcData[idx + 2];
                            alpha += weight * srcData[idx + 3];
                        }
                    }
                }
                idx = (v * dW + u) * 4;
                destData[idx] = red / a;
                destData[idx + 1] = green / a;
                destData[idx + 2] = blue / a;
                destData[idx + 3] = alpha / a;
            }
            if (++u < dW) return process(u);
            else return destImg;
        }
        const srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = Math.ceil(ratioX * this.lanczosLobes / 2), range2Y = Math.ceil(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {
            x: 0,
            y: 0
        }, icenter = {
            x: 0,
            y: 0
        };
        return process(0);
    }
    /**
	* bilinearFiltering
	* @param {Object} canvasEl Canvas element to apply filter to
	* @param {Number} oW Original Width
	* @param {Number} oH Original Height
	* @param {Number} dW Destination Width
	* @param {Number} dH Destination Height
	* @returns {ImageData}
	*/ bilinearFiltering(options, oW, oH, dW, dH) {
        let a;
        let b;
        let c;
        let d;
        let x;
        let y;
        let i;
        let j;
        let xDiff;
        let yDiff;
        let chnl;
        let color;
        let offset = 0;
        let origPix;
        const ratioX = this.rcpScaleX;
        const ratioY = this.rcpScaleY;
        const w4 = 4 * (oW - 1);
        const pixels = options.imageData.data;
        const destImage = options.ctx.createImageData(dW, dH);
        const destPixels = destImage.data;
        for(i = 0; i < dH; i++)for(j = 0; j < dW; j++){
            x = Math.floor(ratioX * j);
            y = Math.floor(ratioY * i);
            xDiff = ratioX * j - x;
            yDiff = ratioY * i - y;
            origPix = 4 * (y * oW + x);
            for(chnl = 0; chnl < 4; chnl++){
                a = pixels[origPix + chnl];
                b = pixels[origPix + 4 + chnl];
                c = pixels[origPix + w4 + chnl];
                d = pixels[origPix + w4 + 4 + chnl];
                color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                destPixels[offset++] = color;
            }
        }
        return destImage;
    }
    /**
	* hermiteFastResize
	* @param {Object} canvasEl Canvas element to apply filter to
	* @param {Number} oW Original Width
	* @param {Number} oH Original Height
	* @param {Number} dW Destination Width
	* @param {Number} dH Destination Height
	* @returns {ImageData}
	*/ hermiteFastResize(options, oW, oH, dW, dH) {
        const ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = Math.ceil(ratioW / 2), ratioHHalf = Math.ceil(ratioH / 2), data = options.imageData.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
        for(let j = 0; j < dH; j++)for(let i = 0; i < dW; i++){
            const x2 = (i + j * dW) * 4;
            let weight = 0;
            let weights = 0;
            let weightsAlpha = 0;
            let gxR = 0;
            let gxG = 0;
            let gxB = 0;
            let gxA = 0;
            const centerY = (j + .5) * ratioH;
            for(let yy = Math.floor(j * ratioH); yy < (j + 1) * ratioH; yy++){
                const dy = Math.abs(centerY - (yy + .5)) / ratioHHalf, centerX = (i + .5) * ratioW, w0 = dy * dy;
                for(let xx = Math.floor(i * ratioW); xx < (i + 1) * ratioW; xx++){
                    let dx = Math.abs(centerX - (xx + .5)) / ratioWHalf;
                    const w = Math.sqrt(w0 + dx * dx);
                    if (w > 1 && w < -1) continue;
                    weight = 2 * w * w * w - 3 * w * w + 1;
                    if (weight > 0) {
                        dx = 4 * (xx + yy * oW);
                        gxA += weight * data[dx + 3];
                        weightsAlpha += weight;
                        if (data[dx + 3] < 255) weight = weight * data[dx + 3] / 250;
                        gxR += weight * data[dx];
                        gxG += weight * data[dx + 1];
                        gxB += weight * data[dx + 2];
                        weights += weight;
                    }
                }
            }
            data2[x2] = gxR / weights;
            data2[x2 + 1] = gxG / weights;
            data2[x2 + 2] = gxB / weights;
            data2[x2 + 3] = gxA / weightsAlpha;
        }
        return img2;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Resize, "type", "Resize");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Resize, "defaults", $9a54cbcfc1af41ba$var$resizeDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Resize, "uniformLocations", [
    "uDelta",
    "uTaps"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Resize);
//#endregion
//#region src/filters/shaders/saturation.ts
const $9a54cbcfc1af41ba$var$fragmentSource$1 = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uSaturation;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float rgMax = max(color.r, color.g);
    float rgbMax = max(rgMax, color.b);
    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;
    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;
    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;
    gl_FragColor = color;
  }
`;
//#endregion
//#region src/filters/Saturation.ts
const $9a54cbcfc1af41ba$var$saturationDefaultValues = {
    saturation: 0
};
/**
* Saturate filter class
* @example
* const filter = new Saturation({
*   saturation: 1
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Saturation = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource$1;
    }
    /**
	* Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const adjust = -this.saturation;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const max = Math.max(r, g, b);
            data[i] += max !== r ? (max - r) * adjust : 0;
            data[i + 1] += max !== g ? (max - g) * adjust : 0;
            data[i + 2] += max !== b ? (max - b) * adjust : 0;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    }
    isNeutralState() {
        return this.saturation === 0;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Saturation, "type", "Saturation");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Saturation, "defaults", $9a54cbcfc1af41ba$var$saturationDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Saturation, "uniformLocations", [
    "uSaturation"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Saturation);
//#endregion
//#region src/filters/shaders/vibrance.ts
const $9a54cbcfc1af41ba$var$fragmentSource = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uVibrance;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float max = max(color.r, max(color.g, color.b));
    float avg = (color.r + color.g + color.b) / 3.0;
    float amt = (abs(max - avg) * 2.0) * uVibrance;
    color.r += max != color.r ? (max - color.r) * amt : 0.00;
    color.g += max != color.g ? (max - color.g) * amt : 0.00;
    color.b += max != color.b ? (max - color.b) * amt : 0.00;
    gl_FragColor = color;
  }
`;
//#endregion
//#region src/filters/Vibrance.ts
const $9a54cbcfc1af41ba$var$vibranceDefaultValues = {
    vibrance: 0
};
/**
* Vibrance filter class
* @example
* const filter = new Vibrance({
*   vibrance: 1
* });
* object.filters.push(filter);
* object.applyFilters();
*/ var $9a54cbcfc1af41ba$var$Vibrance = class extends $9a54cbcfc1af41ba$var$BaseFilter {
    getFragmentSource() {
        return $9a54cbcfc1af41ba$var$fragmentSource;
    }
    /**
	* Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
	*
	* @param {Object} options
	* @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	*/ applyTo2d({ imageData: { data: data } }) {
        const adjust = -this.vibrance;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const max = Math.max(r, g, b);
            const avg = (r + g + b) / 3;
            const amt = Math.abs(max - avg) * 2 / 255 * adjust;
            data[i] += max !== r ? (max - r) * amt : 0;
            data[i + 1] += max !== g ? (max - g) * amt : 0;
            data[i + 2] += max !== b ? (max - b) * amt : 0;
        }
    }
    /**
	* Send data from this filter to its shader program's uniforms.
	*
	* @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	* @param {TWebGLUniformLocationMap} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	*/ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
    }
    isNeutralState() {
        return this.vibrance === 0;
    }
};
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Vibrance, "type", "Vibrance");
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Vibrance, "defaults", $9a54cbcfc1af41ba$var$vibranceDefaultValues);
$9a54cbcfc1af41ba$var$_defineProperty($9a54cbcfc1af41ba$var$Vibrance, "uniformLocations", [
    "uVibrance"
]);
$9a54cbcfc1af41ba$export$2792378e23a7920c.setClass($9a54cbcfc1af41ba$var$Vibrance);
//#endregion
//#region src/filters/filters.ts
var $9a54cbcfc1af41ba$export$82462a21aead86ed = /* @__PURE__ */ $9a54cbcfc1af41ba$var$__exportAll({
    BaseFilter: ()=>$9a54cbcfc1af41ba$var$BaseFilter,
    BlackWhite: ()=>$9a54cbcfc1af41ba$var$BlackWhite,
    BlendColor: ()=>$9a54cbcfc1af41ba$var$BlendColor,
    BlendImage: ()=>$9a54cbcfc1af41ba$var$BlendImage,
    Blur: ()=>$9a54cbcfc1af41ba$var$Blur,
    Brightness: ()=>$9a54cbcfc1af41ba$var$Brightness,
    Brownie: ()=>$9a54cbcfc1af41ba$var$Brownie,
    ColorMatrix: ()=>$9a54cbcfc1af41ba$var$ColorMatrix,
    Composed: ()=>$9a54cbcfc1af41ba$var$Composed,
    Contrast: ()=>$9a54cbcfc1af41ba$var$Contrast,
    Convolute: ()=>$9a54cbcfc1af41ba$var$Convolute,
    Gamma: ()=>$9a54cbcfc1af41ba$var$Gamma,
    Grayscale: ()=>$9a54cbcfc1af41ba$var$Grayscale,
    HueRotation: ()=>$9a54cbcfc1af41ba$var$HueRotation,
    Invert: ()=>$9a54cbcfc1af41ba$var$Invert,
    Kodachrome: ()=>$9a54cbcfc1af41ba$var$Kodachrome,
    Noise: ()=>$9a54cbcfc1af41ba$var$Noise,
    Pixelate: ()=>$9a54cbcfc1af41ba$var$Pixelate,
    Polaroid: ()=>$9a54cbcfc1af41ba$var$Polaroid,
    RemoveColor: ()=>$9a54cbcfc1af41ba$var$RemoveColor,
    Resize: ()=>$9a54cbcfc1af41ba$var$Resize,
    Saturation: ()=>$9a54cbcfc1af41ba$var$Saturation,
    Sepia: ()=>$9a54cbcfc1af41ba$var$Sepia,
    Technicolor: ()=>$9a54cbcfc1af41ba$var$Technicolor,
    Vibrance: ()=>$9a54cbcfc1af41ba$var$Vibrance,
    Vintage: ()=>$9a54cbcfc1af41ba$var$Vintage
});



var $7hmfH = parcelRequire("7hmfH");
const $95c555713171f487$export$67ea982130081db = new (0, $9a54cbcfc1af41ba$export$8d01c972ee8b14a9)('drawing-canvas', {
    enablePointerEvents: true,
    stopContextMenu: true,
    fireRightClick: true,
    uniformScaling: true,
    preserveObjectStacking: true
});
window.canvas = $95c555713171f487$export$67ea982130081db;
let $95c555713171f487$var$selectedTool = null //the id of the currently selected tool
;
let $95c555713171f487$var$currentObject = null // the object implementing the tool currently selected, if any
;
const $95c555713171f487$var$undoStackLength = 20 // max. length of undo/redo stacks
;
let $95c555713171f487$var$undos = [] // stack of user changes to objects for undo
;
let $95c555713171f487$var$redos = [] // stack of undos for redoing
;
let $95c555713171f487$export$f2efb2348b1e4771 = 0 // incremented when the background is amended
;
function $95c555713171f487$export$cf606e54e8a9990d() {
    $95c555713171f487$export$59b33278b5b2fc8a();
    $95c555713171f487$var$initDraw();
}
function $95c555713171f487$export$59b33278b5b2fc8a() {
    const underlay = (0, $7hmfH.elem)('underlay');
    const oldWidth = $95c555713171f487$export$67ea982130081db.getWidth();
    const oldHeight = $95c555713171f487$export$67ea982130081db.getHeight();
    $95c555713171f487$export$8a6e5c2ddf85cd20(1.0);
    $95c555713171f487$export$67ea982130081db.setDimensions({
        width: underlay.offsetWidth,
        height: underlay.offsetHeight
    });
    $95c555713171f487$export$67ea982130081db.calcOffset();
    $95c555713171f487$export$4ccc1b9eba0bcd20(($95c555713171f487$export$67ea982130081db.getWidth() - oldWidth) / 2, ($95c555713171f487$export$67ea982130081db.getHeight() - oldHeight) / 2, 1.0);
    $95c555713171f487$export$8a6e5c2ddf85cd20((0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4) ? (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getScale() : 1);
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
}
function $95c555713171f487$export$8a6e5c2ddf85cd20(zoom) {
    $95c555713171f487$export$67ea982130081db.zoomToPoint({
        x: $95c555713171f487$export$67ea982130081db.getWidth() / 2,
        y: $95c555713171f487$export$67ea982130081db.getHeight() / 2
    }, zoom);
}
function $95c555713171f487$export$4ccc1b9eba0bcd20(x, y, zoom) {
    zoom = zoom || (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getScale();
    $95c555713171f487$export$67ea982130081db.relativePan(new (0, $9a54cbcfc1af41ba$export$baf26146a414f24a)(x * zoom, y * zoom));
}
/**
 * set up the fabric context, the grid drawn on it and the tools
 */ function $95c555713171f487$var$initDraw() {
    (0, $9a54cbcfc1af41ba$export$bee544043763fa88).ownDefaults = {
        ...(0, $9a54cbcfc1af41ba$export$bee544043763fa88).ownDefaults,
        transparentCorners: false,
        cornerColor: 'blue',
        cornerSize: 5,
        cornerStyle: 'circle'
    };
    if (0, $5bc812abaa5f432b$export$c05995454a6ca00d) $95c555713171f487$var$drawGrid();
    $95c555713171f487$var$setUpToolbox();
    $95c555713171f487$export$67ea982130081db.setViewportTransform([
        1,
        0,
        0,
        1,
        $95c555713171f487$export$67ea982130081db.getWidth() / 2,
        $95c555713171f487$export$67ea982130081db.getHeight() / 2
    ]);
    $95c555713171f487$var$initAligningGuidelines();
}
function $95c555713171f487$export$dfdc6d14987fb95e() {
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
    if (0, $5bc812abaa5f432b$export$c05995454a6ca00d) $95c555713171f487$var$drawGrid();
}
function $95c555713171f487$export$7ec610621a8fb67b(event) {
    if (event.transaction.local === false && event.keysChanged.size > 0) //oddly, keys changed includes old, cleared keys, so use this instead.
    $95c555713171f487$export$8d588f71d329a9b1([
        ...event.changes.keys.keys()
    ]);
}
function $95c555713171f487$export$234b64ec3262770a() {
    $95c555713171f487$export$67ea982130081db.clear();
    $95c555713171f487$export$8d588f71d329a9b1([
        ...(0, $5bc812abaa5f432b$export$da7062de5ac36f9c).keys()
    ]);
}
async function $95c555713171f487$export$8d588f71d329a9b1(keys) {
    if (/back/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) keys.forEach((key)=>console.log('Key:', key, 'value:', (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).get(key)));
    for (const key of keys){
        /* active Selection and group have to be dealt with last, because they reference objects that may not have been put on the canvas yet */ const remoteParams = (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).get(key);
        if (!remoteParams) {
            console.error('Empty remoteParams in refreshFromMap()', key);
            continue;
        }
        const { type: type, ...otherParams } = remoteParams;
        switch(key){
            case 'undos':
                $95c555713171f487$var$undos = (0, $7hmfH.deepCopy)(remoteParams);
                $95c555713171f487$var$updateActiveButtons();
                continue;
            case 'redos':
                $95c555713171f487$var$redos = (0, $7hmfH.deepCopy)(remoteParams);
                $95c555713171f487$var$updateActiveButtons();
                continue;
            case 'sequence':
                continue;
            case 'activeSelection':
            case 'ActiveSelection':
                continue;
            default:
                {
                    let localObj = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === key);
                    // if object already exists, update it
                    if (localObj) switch(type){
                        case 'group':
                        case 'Group':
                            break;
                        case 'ungroup':
                            {
                                const items = localObj.removeAll() // returns the constituent objects
                                ;
                                $95c555713171f487$export$67ea982130081db.remove(localObj) // remove the group
                                ;
                                items.forEach((obj)=>$95c555713171f487$export$67ea982130081db.add(obj)) // add the constituent objects back to the canvas
                                ;
                                break;
                            }
                        case 'activeSelection':
                        case 'ActiveSelection':
                            break;
                        default:
                            localObj.set(otherParams);
                            break;
                    }
                    else {
                        // create a new object
                        switch(type){
                            case 'rect':
                            case 'Rect':
                                localObj = new $95c555713171f487$var$RectHandler();
                                break;
                            case 'circle':
                            case 'Circle':
                                localObj = new $95c555713171f487$var$CircleHandler();
                                break;
                            case 'line':
                            case 'Line':
                                localObj = new $95c555713171f487$var$LineHandler();
                                break;
                            case 'text':
                            case 'IText':
                            case 'Textbox':
                                localObj = new $95c555713171f487$var$TextHandler();
                                break;
                            case 'path':
                            case 'Path':
                                localObj = new (0, $9a54cbcfc1af41ba$export$4b2950bdac9b6ee9)();
                                break;
                            case 'image':
                            case 'Image':
                                (0, $9a54cbcfc1af41ba$export$3148ec5c6497ddc8).fromObject(remoteParams.imageObj).then((image)=>{
                                    image.setCoords();
                                    image.id = key;
                                    $95c555713171f487$export$67ea982130081db.add(image);
                                });
                                continue;
                            case 'group':
                            case 'Group':
                                continue;
                            case 'ungroup':
                                continue;
                            case 'activeSelection':
                            case 'ActiveSelection':
                                continue;
                            default:
                                throw new Error(`bad fabric object type in yDrawingMap.observe: ${type}`);
                        }
                        localObj.set(otherParams);
                        localObj.id = key;
                        $95c555713171f487$export$67ea982130081db.add(localObj);
                    }
                    // Fix for Line: Line.toObject() serializes x1/y1/x2/y2 as relative
                    // offsets (via calcLinePoints()), but Line._set() treats them as absolute
                    // coordinates and recalculates left/top via _setWidthHeight(), overriding
                    // the correct position. Re-apply the serialized left/top to correct this.
                    if ((type === 'line' || type === 'Line') && remoteParams.left != null) localObj.set({
                        left: remoteParams.left,
                        top: remoteParams.top
                    });
                    localObj.setCoords();
                }
        }
    }
    // now that ordinary objects are done
    for (const key of keys){
        const remoteParams = (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).get(key);
        if (remoteParams) switch(remoteParams.type){
            case 'group':
            case 'Group':
                {
                    const existingGroup = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === remoteParams.id);
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    if (existingGroup) {
                        const items = $95c555713171f487$export$67ea982130081db.getObjects()[0].removeAll();
                        // translate the object coordinates from local to the group to canvas coordinates
                        const asLeft = remoteParams.left;
                        const asTop = remoteParams.top;
                        const asHalfWidth = remoteParams.width / 2;
                        const asHalfHeight = remoteParams.height / 2;
                        // Update each object's coordinates
                        for(const i in remoteParams.members){
                            // its current location as a position relative to the group
                            const obj = remoteParams.objects[i];
                            // and the object on the canvas
                            const item = items[i];
                            item.set({
                                left: obj.left + asLeft + asHalfWidth,
                                top: obj.top + asTop + asHalfHeight
                            });
                            item.setCoords();
                            $95c555713171f487$export$67ea982130081db.add(item);
                        }
                        $95c555713171f487$export$67ea982130081db.remove(existingGroup);
                    }
                    const objectsInGroup = $95c555713171f487$export$67ea982130081db.getObjects().filter((obj)=>remoteParams.members.includes(obj.id));
                    objectsInGroup.forEach((obj)=>$95c555713171f487$export$67ea982130081db.remove(obj));
                    const group = new (0, $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4)(objectsInGroup);
                    group.id = key;
                    // give the new group the required position etc., but don't overwrite the layoutManager or the type
                    group.set((0, $7hmfH.clean)(remoteParams, {
                        layoutManager: true,
                        type: true
                    }));
                    group.members = remoteParams.members;
                    $95c555713171f487$var$setGroupBorderColor(group);
                    $95c555713171f487$export$67ea982130081db.add(group);
                    if (group.get('visible')) $95c555713171f487$export$67ea982130081db.setActiveObject(group);
                    break;
                }
            case 'ActiveSelection':
            case 'activeSelection':
                {
                    /* An active selection has canvas coordinates for its location and size, and
          the objects it includes have their positions set relative to the active selection.
          Thus to locate the objects relative to the canvas, we have to transform their coordinates.
          remoteParams provides the location and dimensions of the ActiveSelection, the ids of
          the selected objects, and copies of the selected objects (but these are missing their ids) */ if ($95c555713171f487$export$67ea982130081db.getActiveObject()) $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    const asLeft = remoteParams.left;
                    const asTop = remoteParams.top;
                    const asHalfWidth = remoteParams.width / 2;
                    const asHalfHeight = remoteParams.height / 2;
                    // Update each object's coordinates
                    for(const i in remoteParams.members){
                        // for each selected object, its id
                        const id = remoteParams.members[i];
                        // its current location as a relative position
                        const obj = remoteParams.objects[i];
                        // and the fabric object on the canvas
                        const fabricObj = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === id);
                        fabricObj.set({
                            left: obj.left + asLeft + asHalfWidth,
                            top: obj.top + asTop + asHalfHeight
                        });
                        fabricObj.setCoords();
                    }
                    break;
                }
            default:
                break;
        }
    }
    // and lastly reorder the objects if necessary
    if (keys.includes('sequence')) {
        const remoteParams = (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).get('sequence');
        remoteParams.forEach((id)=>{
            const obj = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === id);
            if (obj) $95c555713171f487$export$67ea982130081db.bringObjectToFront(obj);
        });
    }
    // if at start up, so not in drawing mode, don't show active selection borders
    if (!(0, $5bc812abaa5f432b$export$c05995454a6ca00d)) $95c555713171f487$export$67ea982130081db.discardActiveObject();
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
}
/**
 * Draw the background grid before rendering the fabric objects
 */ $95c555713171f487$export$67ea982130081db.on('before:render', ()=>{
    if (0, $5bc812abaa5f432b$export$c05995454a6ca00d) $95c555713171f487$var$drawGrid();
    $95c555713171f487$export$67ea982130081db.clearContext($95c555713171f487$export$67ea982130081db.contextTop);
});
$95c555713171f487$export$67ea982130081db.on('selection:created', (e)=>$95c555713171f487$var$updateSelection(e));
$95c555713171f487$export$67ea982130081db.on('selection:updated', (e)=>$95c555713171f487$var$updateSelection(e));
/**
 * update toolbox when user has selected more than 1 object
 * @param {canvasEvent} evt
 */ function $95c555713171f487$var$updateSelection(evt) {
    // only process updates caused by user (if evt.e is undefined, the update has been generated by remote activity)
    if (evt.e) {
        // ignore updates if user is in the middle of creating an object and happens to click on this one
        if ($95c555713171f487$var$selectedTool) return;
        const activeObject = $95c555713171f487$export$67ea982130081db.getActiveObject();
        const activeMembers = $95c555713171f487$export$67ea982130081db.getActiveObjects();
        // only record selections with more than 1 member object
        if (activeObject.type === 'activeselection' && activeMembers.length > 1) {
            if (!activeObject.id) activeObject.id = (0, $7hmfH.uuidv4)();
            activeObject.members = activeMembers.map((o)=>o.id);
        }
        if (activeMembers.length > 1) $95c555713171f487$var$closeOptionsDialogs();
        else if (evt.selected && evt.selected.length > 0 && evt.selected[0].type) {
            if (evt.selected[0].type !== $95c555713171f487$var$selectedTool) $95c555713171f487$var$closeOptionsDialogs();
            // no option possible when selecting path, group or image
            if (![
                'path',
                'group',
                'image'
            ].includes(evt.selected[0].type)) evt.selected[0].optionsDialog();
        }
        $95c555713171f487$var$updateActiveButtons();
    }
}
// save changes and update state when user has unselected all objects
$95c555713171f487$export$67ea982130081db.on('selection:cleared', (evt)=>{
    if (!evt.e) return; // ignore updates generated by remote activity
    $95c555713171f487$export$f94e63f0099c362e();
    // only allow deletion of selected objects
    (0, $7hmfH.elem)('bin').classList.add('disabled');
    (0, $7hmfH.elem)('group').classList.add('disabled');
});
// user has just finished creating a path (with pencil or marker) - save it
$95c555713171f487$export$67ea982130081db.on('path:created', ()=>{
    const obj = $95c555713171f487$var$getLastPath();
    obj.id = (0, $7hmfH.uuidv4)();
    $95c555713171f487$var$saveChange(obj, {
        path: obj.path,
        stroke: obj.stroke,
        strokeWidth: obj.strokeWidth,
        pathOffset: obj.pathOffset,
        fill: null
    }, 'insert');
});
// record object moves on undo stack and broadcast them
$95c555713171f487$export$67ea982130081db.on('object:modified', (rec)=>{
    const obj = rec.target;
    if (!obj.id) obj.id = (0, $7hmfH.uuidv4)();
    $95c555713171f487$var$saveChange(obj, {
        id: obj.id
    }, 'update');
});
/**
 * draw a grid on the drawing canvas
 * @param {Integer} gridSize - pixels between grid lines
 */ /* eslint-disable camelcase */ function $95c555713171f487$var$drawGrid(grid_size = 25) {
    const grid_context = (0, $7hmfH.elem)('drawing-canvas').getContext('2d');
    const currentCanvasWidth = $95c555713171f487$export$67ea982130081db.getWidth();
    const currentCanvasHeight = $95c555713171f487$export$67ea982130081db.getHeight();
    grid_context.save();
    grid_context.clearRect(0, 0, currentCanvasWidth, currentCanvasHeight);
    grid_context.strokeStyle = 'rgba(0, 0, 0, 0.2)';
    // Drawing vertical lines
    for(let x = 0; x <= currentCanvasWidth; x += grid_size){
        grid_context.beginPath();
        grid_context.moveTo(x + 0.5, 0);
        grid_context.lineTo(x + 0.5, currentCanvasHeight);
        grid_context.stroke();
    }
    // Drawing horizontal lines
    for(let y = 0; y <= currentCanvasHeight; y += grid_size){
        grid_context.beginPath();
        grid_context.moveTo(0, y + 0.5);
        grid_context.lineTo(currentCanvasWidth, y + 0.5);
        grid_context.stroke();
    }
    grid_context.restore();
}
/* eslint-enable camelcase */ /**
 * add event listeners to the tools to receive user clicks to select a tool
 */ function $95c555713171f487$var$setUpToolbox() {
    const tools = document.querySelectorAll('.tool');
    Array.from(tools).forEach((tool)=>{
        tool.addEventListener('click', $95c555713171f487$var$selectTool);
    });
    (0, $7hmfH.dragElement)((0, $7hmfH.elem)('toolbox'), (0, $7hmfH.elem)('toolbox-header'));
}
/**
 *
 * Toolbox
 *
 */ /**
 * When the user clicks a tool icon
 * unselect previous tool, select this one
 * and remember which tool is now selected
 * The undo, redo, delete and image tools are special, because they act
 * immediately when the icon is clicked
 * @param {object} event - the click event
 */ function $95c555713171f487$var$selectTool(event) {
    const tool = event.currentTarget;
    if (tool.id === 'undotool') {
        $95c555713171f487$var$currentObject = null;
        $95c555713171f487$var$toolHandler('undo').undo();
        return;
    }
    if (tool.id === 'redotool') {
        $95c555713171f487$var$currentObject = null;
        $95c555713171f487$var$toolHandler('undo').redo();
        return;
    }
    if (tool.id === 'group') {
        $95c555713171f487$var$currentObject = null;
        const activeObj = $95c555713171f487$export$67ea982130081db.getActiveObject();
        if (!activeObj) return;
        if (activeObj.type === 'group') $95c555713171f487$var$unGroup();
        else $95c555713171f487$var$makeGroup();
        return;
    }
    if (tool.id === 'bin') {
        $95c555713171f487$var$currentObject = null;
        $95c555713171f487$var$toolHandler('bin').delete();
        return;
    }
    //second click on selected tool - unselect it
    if ($95c555713171f487$var$selectedTool === tool.id) {
        $95c555713171f487$export$f94e63f0099c362e();
        return;
    }
    // changing tool; unselect previous one
    $95c555713171f487$export$f94e63f0099c362e();
    $95c555713171f487$var$selectedTool = tool.id;
    tool.classList.add('selected');
    // display options dialog
    // first hide the tool tip, which gets in the way of the options dialog
    tool.childNodes[3].style.visibility = 'hidden';
    const handler = $95c555713171f487$var$toolHandler($95c555713171f487$var$selectedTool);
    handler.optionsDialog();
    $95c555713171f487$export$67ea982130081db.isDrawingMode = tool.id === 'pencil' || tool.id === 'marker';
    // initialize brush for pencil and marker tools
    if ($95c555713171f487$export$67ea982130081db.isDrawingMode) {
        $95c555713171f487$export$67ea982130081db.freeDrawingBrush = new (0, $9a54cbcfc1af41ba$export$672d658927d3b57b)($95c555713171f487$export$67ea982130081db);
        $95c555713171f487$export$67ea982130081db.freeDrawingBrush.width = handler.width;
        $95c555713171f487$export$67ea982130081db.freeDrawingBrush.color = handler.color;
    }
    // if tool is 'image', get image file from user
    if (tool.id === 'image') {
        const fileInput = document.createElement('input');
        fileInput.id = 'fileInput';
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/*');
        fileInput.addEventListener('change', (e)=>{
            if (e.target.files && e.target.files.length > 0) $95c555713171f487$var$toolHandler($95c555713171f487$var$selectedTool).loadImage(e);
            else // User didn't select a file - deselect the tool
            $95c555713171f487$export$f94e63f0099c362e();
        });
        fileInput.addEventListener('cancel', ()=>{
            $95c555713171f487$export$f94e63f0099c362e();
        });
        fileInput.click();
    }
}
function $95c555713171f487$export$f94e63f0099c362e() {
    $95c555713171f487$var$unselectTool();
    $95c555713171f487$export$67ea982130081db.isDrawingMode = false;
    $95c555713171f487$export$67ea982130081db.discardActiveObject();
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
    $95c555713171f487$var$closeOptionsDialogs();
    $95c555713171f487$var$updateActiveButtons();
}
/**
 * unselect the current tool and close any option dialogs
 */ function $95c555713171f487$var$unselectTool() {
    if ($95c555713171f487$var$selectedTool) {
        const el = (0, $7hmfH.elem)($95c555713171f487$var$selectedTool);
        el.classList.remove('selected');
        el.childNodes[3].style.visibility = 'hidden';
    }
    $95c555713171f487$var$closeOptionsDialogs();
    $95c555713171f487$var$selectedTool = null;
    $95c555713171f487$var$currentObject = null;
}
/**
 * remove any option dialog that is open and currently displayed
 */ function $95c555713171f487$var$closeOptionsDialogs() {
    const box = (0, $7hmfH.elem)('optionsBox');
    if (box) box.remove();
}
/**
 * show whether some buttons are active or disabled, depending
 * on whether anything is selected and whether undo or redo is possible
 */ function $95c555713171f487$var$updateActiveButtons() {
    if ($95c555713171f487$var$undos.length > 0) (0, $7hmfH.elem)('undotool').classList.remove('disabled');
    else (0, $7hmfH.elem)('undotool').classList.add('disabled');
    if ($95c555713171f487$var$redos.length > 0) (0, $7hmfH.elem)('redotool').classList.remove('disabled');
    else (0, $7hmfH.elem)('redotool').classList.add('disabled');
    const nActiveObjects = $95c555713171f487$export$67ea982130081db.getActiveObjects().length;
    if (nActiveObjects > 0) (0, $7hmfH.elem)('bin').classList.remove('disabled');
    else (0, $7hmfH.elem)('bin').classList.add('disabled');
    if (nActiveObjects > 1) (0, $7hmfH.elem)('group').classList.remove('disabled');
    else if ($95c555713171f487$export$67ea982130081db.getActiveObject()?.type === 'group') (0, $7hmfH.elem)('group').classList.remove('disabled');
    else (0, $7hmfH.elem)('group').classList.add('disabled');
}
/**
 * return the correct instance of toolHandler for the given tool
 * @param {string} tool - the tool id
 * @returns {object} the tool handler instance
 */ function $95c555713171f487$var$toolHandler(tool) {
    if ($95c555713171f487$var$currentObject) return $95c555713171f487$var$currentObject;
    switch(tool){
        case 'rect':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$RectHandler();
            break;
        case 'circle':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$CircleHandler();
            break;
        case 'line':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$LineHandler();
            break;
        case 'text':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$TextHandler();
            break;
        case 'pencil':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$PencilHandler();
            break;
        case 'marker':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$MarkerHandler();
            break;
        case 'image':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$ImageHandler();
            break;
        case 'bin':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$DeleteHandler();
            break;
        case 'undo':
            $95c555713171f487$var$currentObject = new $95c555713171f487$var$UndoHandler();
            break;
    }
    return $95c555713171f487$var$currentObject;
}
/**
 * react to key presses and mouse movements
 */ // backspace = delete selected object
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && e.key === 'Backspace' || e.key === 'Delete') {
        const obj = $95c555713171f487$export$67ea982130081db.getActiveObject();
        if (obj && !obj.isEditing) {
            e.preventDefault();
            $95c555713171f487$var$currentObject = null;
            $95c555713171f487$var$toolHandler('bin').delete();
        }
    }
});
// ctrl+z = undo
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && (e.ctrlKey || e.metaKey) && e.key === 'z') {
        e.preventDefault();
        $95c555713171f487$var$currentObject = null;
        $95c555713171f487$var$toolHandler('undo').undo();
    }
});
// ctrl+y = redo
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && (e.ctrlKey || e.metaKey) && e.key === 'y') {
        e.preventDefault();
        $95c555713171f487$var$currentObject = null;
        $95c555713171f487$var$toolHandler('undo').redo();
    }
});
// arrow keys move selected object
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && e.key === 'ArrowUp') {
        e.preventDefault();
        $95c555713171f487$var$arrowMove('ArrowUp');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && e.key === 'ArrowDown') {
        e.preventDefault();
        $95c555713171f487$var$arrowMove('ArrowDown');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && e.key === 'ArrowLeft') {
        e.preventDefault();
        $95c555713171f487$var$arrowMove('ArrowLeft');
    }
});
window.addEventListener('keydown', (e)=>{
    if ((0, $5bc812abaa5f432b$export$c05995454a6ca00d) && e.key === 'ArrowRight') {
        e.preventDefault();
        $95c555713171f487$var$arrowMove('ArrowRight');
    }
});
/**
 *  handle mouse moves, despatching to tools or panning the canvas
 */ $95c555713171f487$export$67ea982130081db.on('mouse:down', function(options) {
    const event = options.e;
    // if right click on an object, display 'Send to back/front' popup menu
    if (event.button === 2) {
        if (options.target) (0, $7hmfH.addContextMenu)(event.target, [
            {
                label: 'Send to back',
                action: ()=>$95c555713171f487$var$sendToBack(options.target)
            },
            {
                label: 'Bring to front',
                action: ()=>$95c555713171f487$var$bringToFront(options.target)
            }
        ]);
        return;
    }
    if ($95c555713171f487$var$selectedTool) $95c555713171f487$var$toolHandler($95c555713171f487$var$selectedTool)[event.type](event);
    else if (!$95c555713171f487$export$67ea982130081db.getActiveObject()) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = event.clientX;
        this.lastPosY = event.clientY;
        this.defaultCursor = 'grabbing';
        this.setCursor(this.defaultCursor);
    }
});
/**
 * send the given object to the back of the canvas
 * @param {fabric.Object} obj - the fabric object to send to back
 */ function $95c555713171f487$var$sendToBack(obj) {
    $95c555713171f487$export$67ea982130081db.sendObjectToBack(obj);
    $95c555713171f487$var$saveChange(obj, {}, 'insert)');
}
/**
 * bring the given object to the front of the canvas
 * @param {fabric.Object} obj - the fabric object to bring to front
 */ function $95c555713171f487$var$bringToFront(obj) {
    $95c555713171f487$export$67ea982130081db.bringObjectToFront(obj);
    $95c555713171f487$var$saveChange(obj, {}, 'insert)');
}
$95c555713171f487$export$67ea982130081db.on('mouse:move', function(options) {
    const event = options.e;
    if ($95c555713171f487$var$selectedTool) $95c555713171f487$var$toolHandler($95c555713171f487$var$selectedTool)[event.type](event);
    else if (this.isDragging) {
        event.stopImmediatePropagation();
        const vpt = this.viewportTransform;
        const moveX = event.clientX - this.lastPosX;
        const moveY = event.clientY - this.lastPosY;
        vpt[4] += moveX;
        vpt[5] += moveY;
        const networkVP = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getViewPosition();
        (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).moveTo({
            position: {
                x: networkVP.x - moveX / vpt[0],
                y: networkVP.y - moveY / vpt[0]
            }
        });
        this.requestRenderAll();
        this.lastPosX = event.clientX;
        this.lastPosY = event.clientY;
    }
});
$95c555713171f487$export$67ea982130081db.on('mouse:up', function(options) {
    const event = options.e;
    if ($95c555713171f487$var$selectedTool) {
        $95c555713171f487$var$toolHandler($95c555713171f487$var$selectedTool)[event.type](event);
        $95c555713171f487$var$closeOptionsDialogs();
        $95c555713171f487$var$updateActiveButtons();
    } else {
        this.setViewportTransform(this.viewportTransform);
        this.isDragging = false;
        this.selection = true;
        this.defaultCursor = 'default';
        this.setCursor(this.defaultCursor);
    }
});
$95c555713171f487$export$67ea982130081db.on('mouse:dblclick', ()=>(0, $5bc812abaa5f432b$export$1e044b7877db048c)());
const $95c555713171f487$var$ARROWINCR = 1;
/**
 * cSpell: ignore ARROWINCR
 * move the selected object by ARROWINCR in the given direction
 * @param {string} direction - 'ArrowUp', 'ArrowDown', 'ArrowLeft', or 'ArrowRight'
 */ function $95c555713171f487$var$arrowMove(direction) {
    const activeObj = $95c555713171f487$export$67ea982130081db.getActiveObject();
    if (!activeObj) return;
    let top = activeObj.top;
    let left = activeObj.left;
    switch(direction){
        case 'ArrowUp':
            top -= $95c555713171f487$var$ARROWINCR;
            break;
        case 'ArrowDown':
            top += $95c555713171f487$var$ARROWINCR;
            break;
        case 'ArrowLeft':
            left -= $95c555713171f487$var$ARROWINCR;
            break;
        case 'ArrowRight':
            left += $95c555713171f487$var$ARROWINCR;
            break;
    }
    activeObj.set({
        left: left,
        top: top
    });
    activeObj.setCoords();
    $95c555713171f487$var$saveChange(activeObj, {}, 'update');
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
}
/**
 * Create an HTMLElement that will hold the options dialog
 * @param {String} tool
 * @returns HTMLElement
 */ function $95c555713171f487$var$makeOptionsDialog(tool) {
    if (!tool) return;
    const underlay = (0, $7hmfH.elem)('underlay');
    const box = document.createElement('div');
    box.className = 'options';
    box.id = 'optionsBox';
    box.style.top = `${(0, $7hmfH.elem)(tool).getBoundingClientRect().top - underlay.getBoundingClientRect().top}px`;
    box.style.left = `${(0, $7hmfH.elem)(tool).getBoundingClientRect().right + 10}px`;
    underlay.appendChild(box);
    return box;
}
/***************************************** Rect ********************************************/ const $95c555713171f487$var$cornerRadius = 10 // radius of rounded corners for rounded rectangle
;
class $95c555713171f487$var$RectHandler extends (0, $9a54cbcfc1af41ba$export$c79fc6492f3af13d) {
    constructor(){
        super({
            fill: '#ffffff',
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.roundCorners = $95c555713171f487$var$cornerRadius;
        this.id = (0, $7hmfH.uuidv4)();
        this.strokeUniform = true;
    }
    pointerdown(e) {
        this.setParams();
        this.dragging = true;
        this.start = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.width = 0;
        this.height = 0;
        this.rx = this.roundCorners;
        this.ry = this.roundCorners;
        $95c555713171f487$export$67ea982130081db.add(this);
        $95c555713171f487$export$67ea982130081db.selection = false;
    }
    pointermove(e) {
        if (!this.dragging) return;
        const pointer = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        const width = pointer.x - this.start.x;
        const height = pointer.y - this.start.y;
        this.set({
            left: this.start.x + width / 2,
            top: this.start.y + height / 2,
            width: Math.abs(width),
            height: Math.abs(height)
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    pointerup() {
        this.dragging = false;
        $95c555713171f487$var$currentObject = null;
        if (this.width && this.height) {
            $95c555713171f487$var$saveChange(this, {
                rx: this.rx,
                ry: this.ry,
                fill: this.fill,
                strokeWidth: this.strokeWidth,
                stroke: this.stroke
            }, 'insert');
            $95c555713171f487$export$67ea982130081db.selection = true;
            $95c555713171f487$export$67ea982130081db.setActiveObject(this);
        }
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
        $95c555713171f487$var$unselectTool();
    }
    update() {
        this.setParams();
        $95c555713171f487$var$saveChange(this, {
            rx: this.rx,
            ry: this.ry,
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        this.roundCorners = (0, $7hmfH.elem)('rounded').checked ? $95c555713171f487$var$cornerRadius : 0;
        let fill = (0, $7hmfH.elem)('fillColor').style.backgroundColor;
        // make white transparent
        if (fill === 'rgb(255, 255, 255)') fill = 'rgba(0, 0, 0, 0)';
        this.set({
            rx: this.roundCorners,
            ry: this.roundCorners,
            fill: fill,
            strokeWidth: parseInt((0, $7hmfH.elem)('borderWidth').value),
            stroke: (0, $7hmfH.elem)('borderColor').style.backgroundColor
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if ((0, $7hmfH.elem)('optionsBox')) return;
        this.box = $95c555713171f487$var$makeOptionsDialog('rect');
        this.box.innerHTML = `
	<div>Border width</div><div><input id="borderWidth"  type="number" min="0" max="99" size="2"></div>
	<div>Border Colour</div><div class="input-color-container">
		<div class="color-well" id="borderColor"></div>
	</div>	
  	<div>Fill Colour</div><div class="input-color-container">
  		<div class="color-well" id="fillColor"></div>
	</div>
	<div>Rounded</div><input type="checkbox" id="rounded"></div>`;
        (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('fillColor', ()=>this.update(), ()=>this.setParams());
        (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('borderColor', ()=>this.update(), ()=>this.setParams());
        const widthInput = (0, $7hmfH.elem)('borderWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        const borderColor = (0, $7hmfH.elem)('borderColor');
        borderColor.style.backgroundColor = this.stroke;
        const fillColor = (0, $7hmfH.elem)('fillColor');
        fillColor.style.backgroundColor = this.fill;
        const rounded = (0, $7hmfH.elem)('rounded');
        rounded.checked = this.roundCorners !== 0;
        rounded.addEventListener('change', ()=>{
            this.update();
        });
    }
}
/******************************************* Circle ********************************************/ class $95c555713171f487$var$CircleHandler extends (0, $9a54cbcfc1af41ba$export$c89a927ffc67e6fa) {
    constructor(){
        super({
            fill: '#ffffff',
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.id = (0, $7hmfH.uuidv4)();
    }
    pointerdown(e) {
        this.setParams();
        this.dragging = true;
        this.start = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.radius = 0;
        $95c555713171f487$export$67ea982130081db.add(this);
        $95c555713171f487$export$67ea982130081db.selection = false;
    }
    pointermove(e) {
        if (!this.dragging) return;
        const pointer = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        const radius = Math.sqrt((this.start.x - pointer.x) ** 2 + (this.start.y - pointer.y) ** 2) / 2;
        this.set({
            left: this.start.x + (pointer.x - this.start.x) / 2,
            top: this.start.y + (pointer.y - this.start.y) / 2,
            radius: radius
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    pointerup() {
        this.dragging = false;
        $95c555713171f487$var$currentObject = null;
        if (this.radius > 0) {
            $95c555713171f487$var$saveChange(this, {
                fill: this.fill,
                strokeWidth: this.strokeWidth,
                stroke: this.stroke,
                radius: this.radius
            }, 'insert');
            $95c555713171f487$export$67ea982130081db.selection = true;
            $95c555713171f487$export$67ea982130081db.setActiveObject(this);
        }
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
        $95c555713171f487$var$unselectTool();
    }
    update() {
        this.setParams();
        $95c555713171f487$var$saveChange(this, {
            fill: this.fill,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        let fill = (0, $7hmfH.elem)('fillColor').style.backgroundColor;
        // make white transparent
        if (fill === 'rgb(255, 255, 255)') fill = 'rgba(0, 0, 0, 0)';
        this.set({
            fill: fill,
            strokeWidth: parseInt((0, $7hmfH.elem)('borderWidth').value),
            stroke: (0, $7hmfH.elem)('borderColor').style.backgroundColor
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if ((0, $7hmfH.elem)('optionsBox')) return;
        this.box = $95c555713171f487$var$makeOptionsDialog('circle');
        this.box.innerHTML = `
	<div>Border width</div><div><input id="borderWidth"  type="number" min="0" max="99" size="2"></div>
	<div>Border Colour</div><div class="input-color-container">
		<div class="color-well" id="borderColor"></div>
	</div>	
  	<div>Fill Colour</div><div class="input-color-container">
  		<div class="color-well" id="fillColor"></div>
	</div>`;
        (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('fillColor', ()=>this.update(), ()=>this.setParams());
        (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('borderColor', ()=>this.update(), ()=>this.setParams());
        const widthInput = (0, $7hmfH.elem)('borderWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        const borderColor = (0, $7hmfH.elem)('borderColor');
        borderColor.style.backgroundColor = this.stroke;
        const fillColor = (0, $7hmfH.elem)('fillColor');
        fillColor.style.backgroundColor = this.fill;
    }
}
/******************************************* Line ********************************************/ class $95c555713171f487$var$LineHandler extends (0, $9a54cbcfc1af41ba$export$17d680238e50603e) {
    constructor(){
        super([
            0,
            0,
            0,
            0
        ], {
            strokeWidth: 1,
            stroke: '#000000',
            strokeUniform: true
        });
        this.dragging = false;
        this.axes = false;
        this.dashed = false;
        this.id = (0, $7hmfH.uuidv4)();
        this.stroke = '#000000';
        this.strokeWidth = 2;
        this.strokeUniform = true;
    }
    pointerdown(e) {
        this.setParams();
        this.dragging = true;
        $95c555713171f487$export$67ea982130081db.selection = false;
        this.start = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        this.set({
            x1: this.start.x,
            y1: this.start.y,
            x2: this.start.x,
            y2: this.start.y
        });
        $95c555713171f487$export$67ea982130081db.add(this);
    }
    pointermove(e) {
        if (!this.dragging) return;
        const endPoint = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        let x2 = endPoint.x;
        let y2 = endPoint.y;
        const x1 = this.start.x;
        const y1 = this.start.y;
        if (this.axes) {
            if (x2 - x1 > y2 - y1) y2 = y1;
            else x2 = x1;
        }
        this.set({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    pointerup() {
        this.dragging = false;
        $95c555713171f487$var$currentObject = null;
        if (this.x1 === this.x2 && this.y1 === this.y2) {
            $95c555713171f487$var$unselectTool();
            return;
        }
        $95c555713171f487$var$saveChange(this, {
            axes: this.axes,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke,
            strokeDashArray: this.strokeDashArray
        }, 'insert');
        $95c555713171f487$export$67ea982130081db.selection = true;
        $95c555713171f487$export$67ea982130081db.setActiveObject(this);
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
        $95c555713171f487$var$unselectTool();
    }
    update() {
        this.setParams();
        $95c555713171f487$var$saveChange(this, {
            axes: this.axes,
            strokeWidth: this.strokeWidth,
            stroke: this.stroke,
            strokeDashArray: this.strokeDashArray
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        this.axes = (0, $7hmfH.elem)('axes').checked;
        if (this.axes) {
            if (this.x2 - this.x1 > this.y2 - this.y1) this.y2 = this.y1;
            else this.x2 = this.x1;
            this.set({
                x1: this.x1,
                y1: this.y1,
                x2: this.x2,
                y2: this.y2
            });
        }
        // if line is constrained to horizontal/vertical (axes is true),
        // don't display a rotate control point
        this.setControlsVisibility({
            mtr: !this.axes,
            bl: false,
            br: true,
            mb: false,
            ml: false,
            mr: false,
            mt: false,
            tl: true,
            tr: false
        });
        this.set({
            strokeWidth: parseInt((0, $7hmfH.elem)('lineWidth').value),
            stroke: (0, $7hmfH.elem)('lineColor').style.backgroundColor,
            strokeDashArray: (0, $7hmfH.elem)('dashed').checked ? [
                10,
                10
            ] : null
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if ((0, $7hmfH.elem)('optionsBox')) return;
        this.box = $95c555713171f487$var$makeOptionsDialog('line');
        this.box.innerHTML = `
	<div>Line width</div><div><input id="lineWidth" type="number" min="0" max="99" size="1"></div>
	<div>Colour</div><div class="input-color-container">
		<div class="color-well" id="lineColor"></div>
	</div>
	<div>Dashed</div><div><input type="checkbox" id="dashed"></div>
	<div>Vert/Horiz</div><div><input type="checkbox" id="axes"></div>`;
        (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('lineColor', ()=>this.update(), ()=>this.setParams());
        const widthInput = (0, $7hmfH.elem)('lineWidth');
        widthInput.value = this.strokeWidth;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        const lineColor = (0, $7hmfH.elem)('lineColor');
        lineColor.style.backgroundColor = this.stroke;
        const dashed = (0, $7hmfH.elem)('dashed');
        dashed.checked = this.strokeDashArray;
        dashed.addEventListener('change', ()=>{
            this.update();
        });
        const axes = (0, $7hmfH.elem)('axes');
        axes.checked = this.axes;
        this.setControlsVisibility(this.axes);
        axes.addEventListener('change', ()=>{
            this.update();
        });
    }
}
/**************************************** Text ********************************************/ class $95c555713171f487$var$TextHandler extends (0, $9a54cbcfc1af41ba$export$8e3dca5fa4d5f04b) {
    constructor(){
        super('Text', {
            fontSize: 32,
            fill: '#000000',
            fontFamily: 'Oxygen'
        });
        this.id = (0, $7hmfH.uuidv4)();
        this.on('editing:entered', ()=>{
            $95c555713171f487$var$closeOptionsDialogs();
        });
    }
    pointerdown(e) {
        this.setParams();
        this.start = $95c555713171f487$export$67ea982130081db.getScenePoint(e);
        this.left = this.start.x;
        this.top = this.start.y;
        this.fontFamily = 'Oxygen';
        $95c555713171f487$export$67ea982130081db.add(this);
        $95c555713171f487$export$67ea982130081db.setActiveObject(this);
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
        $95c555713171f487$var$unselectTool();
        this.enterEditing();
        this.selectAll();
        this.on('editing:exited', ()=>{
            $95c555713171f487$var$saveChange(this, {
                fontSize: this.fontSize,
                fill: this.fill,
                fontFamily: 'Oxygen',
                text: this.text
            }, 'insert');
        });
    }
    pointermove() {}
    pointerup() {}
    update() {
        this.setParams();
        $95c555713171f487$var$saveChange(this, {
            fontSize: this.fontSize,
            fill: this.fill,
            text: this.text
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        this.set({
            fontSize: parseInt((0, $7hmfH.elem)('fontSize').value),
            fill: (0, $7hmfH.elem)('fontColor').style.backgroundColor
        });
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if (!(0, $7hmfH.elem)('optionsBox')) {
            this.box = $95c555713171f487$var$makeOptionsDialog('text');
            this.box.innerHTML = `
	<div>Size</div><div><input id="fontSize"  type="number" min="0" max="99" size="2"></div>
	<div>Colour</div><div class="input-color-container">
		<div class="color-well" id="fontColor"></div>
	</div>`;
            (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('fontColor', ()=>this.update(), ()=>this.setParams());
        }
        const fontSizeInput = (0, $7hmfH.elem)('fontSize');
        fontSizeInput.value = parseInt(this.fontSize);
        fontSizeInput.addEventListener('change', ()=>{
            this.update();
        });
        const fontColor = (0, $7hmfH.elem)('fontColor');
        fontColor.style.backgroundColor = this.fill;
    }
}
/***************************************** Pencil ********************************************/ class $95c555713171f487$var$PencilHandler extends (0, $9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    constructor(){
        super({
            width: 1,
            color: '#000000'
        });
        this.width = 1;
        this.color = '#000000';
    }
    pointerdown() {
        this.setParams();
        if ($95c555713171f487$export$67ea982130081db.freeDrawingBrush) {
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.width = this.width;
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.color = this.color;
        }
    }
    pointermove() {}
    pointerup() {}
    update() {
        this.setParams();
        const pathObj = $95c555713171f487$var$getLastPath();
        $95c555713171f487$var$saveChange(pathObj, {
            path: pathObj.path
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        this.width = parseInt((0, $7hmfH.elem)('pencilWidth').value);
        this.color = (0, $7hmfH.elem)('pencilColor').style.backgroundColor;
        if ($95c555713171f487$export$67ea982130081db.freeDrawingBrush) {
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.width = this.width;
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.color = this.color;
        }
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if (!(0, $7hmfH.elem)('optionsBox')) {
            this.box = $95c555713171f487$var$makeOptionsDialog('pencil');
            this.box.innerHTML = `
		<div>Width</div><div><input id="pencilWidth"  type="number" min="0" max="99" size="2"></div>
		<div>Colour</div><div class="input-color-container">
			<div class="color-well" id="pencilColor"></div>
		</div>`;
            (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('pencilColor', ()=>this.update(), ()=>this.setParams());
        }
        const widthInput = document.getElementById('pencilWidth');
        widthInput.value = this.width;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        const pencilColor = document.getElementById('pencilColor');
        pencilColor.style.backgroundColor = this.color;
    }
}
/***************************************** Marker ********************************************/ class $95c555713171f487$var$MarkerHandler extends (0, $9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    constructor(){
        super({
            width: 30,
            color: 'rgba(249, 255, 71, 0.5)',
            strokeLineCap: 'square',
            strokeLineJoin: 'bevel'
        });
        this.width = 30;
        this.color = 'rgba(249, 255, 71, 0.5)';
    }
    pointerdown() {
        this.setParams();
        if ($95c555713171f487$export$67ea982130081db.freeDrawingBrush) {
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.width = this.width;
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.color = this.color;
        }
    }
    pointermove() {}
    pointerup() {}
    update() {
        this.setParams();
        const pathObj = $95c555713171f487$var$getLastPath();
        $95c555713171f487$var$saveChange(pathObj, {
            path: pathObj.path
        }, 'update');
    }
    setParams() {
        if (!(0, $7hmfH.elem)('optionsBox')) return;
        this.width = parseInt((0, $7hmfH.elem)('pencilWidth').value);
        this.color = (0, $7hmfH.elem)('pencilColor').style.backgroundColor;
        if ($95c555713171f487$export$67ea982130081db.freeDrawingBrush) {
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.width = this.width;
            $95c555713171f487$export$67ea982130081db.freeDrawingBrush.color = this.color;
        }
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    optionsDialog() {
        if (!(0, $7hmfH.elem)('optionsBox')) {
            this.box = $95c555713171f487$var$makeOptionsDialog('marker');
            this.box.innerHTML = `		
			<div>Width</div><div><input id="pencilWidth"  type="number" min="0" max="99" size="2"></div>
			<div>Colour</div><div class="input-color-container">
			<div class="color-well" id="pencilColor"></div>
		</div>`;
            (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('pencilColor', ()=>this.update(), ()=>this.setParams());
        }
        const widthInput = document.getElementById('pencilWidth');
        widthInput.value = this.width;
        widthInput.addEventListener('change', ()=>{
            this.update();
        });
        const pencilColor = document.getElementById('pencilColor');
        pencilColor.style.backgroundColor = this.color;
    }
}
/**
 * called after a pencil or marker has been used to retrieve the path object that it created
 * @returns {fabric.Path} the last path object created
 */ function $95c555713171f487$var$getLastPath() {
    const objs = $95c555713171f487$export$67ea982130081db.getObjects();
    const path = objs[objs.length - 1];
    if (!path || path.type !== 'path') throw new Error('Last path is not a path');
    return path;
}
/**************************************** Image ********************************************/ class $95c555713171f487$var$ImageHandler extends (0, $9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    constructor(){
        super({});
    }
    loadImage(e) {
        if (e.target.files) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e)=>{
                const image = new Image();
                image.onload = (e)=>{
                    const imageElement = e.target;
                    // display image centred on viewport with max dimensions 300 x 300
                    if (imageElement.width > imageElement.height) {
                        if (imageElement.width > 300) imageElement.width = 300;
                    } else if (imageElement.height > 300) imageElement.height = 300;
                    this.imageInstance = new (0, $9a54cbcfc1af41ba$export$3148ec5c6497ddc8)(imageElement);
                    this.imageInstance.set({
                        left: $95c555713171f487$export$67ea982130081db.getVpCenter().x,
                        top: $95c555713171f487$export$67ea982130081db.getVpCenter().y
                    });
                    this.imageInstance.setCoords();
                    this.imageInstance.id = (0, $7hmfH.uuidv4)();
                    $95c555713171f487$export$67ea982130081db.add(this.imageInstance);
                    $95c555713171f487$var$saveChange(this.imageInstance, {}, 'insert');
                    $95c555713171f487$var$unselectTool();
                    $95c555713171f487$export$67ea982130081db.setActiveObject(this.imageInstance);
                    $95c555713171f487$export$67ea982130081db.requestRenderAll();
                };
                image.src = e.target.result;
            };
        }
    }
    pointerdown() {}
    pointermove() {}
    pointerup() {}
    update() {}
    optionsDialog() {}
}
/****************************************** Group ********************************************/ /**
 * create a group from the currently selected objects
 */ function $95c555713171f487$var$makeGroup() {
    const activeObj = $95c555713171f487$export$67ea982130081db.getActiveObject();
    if (!activeObj || $95c555713171f487$export$67ea982130081db.getActiveObjects().length < 2 || !(activeObj instanceof (0, $9a54cbcfc1af41ba$export$c57a942eef0ccd19))) {
        (0, $7hmfH.alertMsg)('Select multiple objects before grouping', 'warning');
        return;
    }
    // Get the objects from the active selection
    const objectsInGroup = activeObj.getObjects();
    // Remove the active selection
    $95c555713171f487$export$67ea982130081db.discardActiveObject();
    // Remove objects from canvas (they'll be added back as part of the group)
    objectsInGroup.forEach((obj)=>$95c555713171f487$export$67ea982130081db.remove(obj));
    // Create a new Group
    const group = new (0, $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4)(objectsInGroup);
    group.id = (0, $7hmfH.uuidv4)();
    group.members = objectsInGroup.map((ob)=>ob.id);
    $95c555713171f487$var$setGroupBorderColor(group);
    // Add the group to canvas
    $95c555713171f487$export$67ea982130081db.add(group);
    $95c555713171f487$export$67ea982130081db.setActiveObject(group);
    $95c555713171f487$var$saveChange(group, {}, 'insert');
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
    (0, $7hmfH.elem)('group').classList.remove('disabled');
    (0, $7hmfH.alertMsg)('Grouped', 'info');
}
/**
 * ungroup the currently selected group
 */ function $95c555713171f487$var$unGroup() {
    const activeObj = $95c555713171f487$export$67ea982130081db.getActiveObject();
    if (!activeObj || !(activeObj instanceof (0, $9a54cbcfc1af41ba$export$eb2fcfdbd7ba97d4))) return;
    const members = activeObj.getObjects();
    const items = activeObj.removeAll() // returns the objects
    ;
    $95c555713171f487$export$67ea982130081db.remove(activeObj);
    items.forEach((obj)=>$95c555713171f487$export$67ea982130081db.add(obj));
    $95c555713171f487$var$saveChange(activeObj, {
        type: 'ungroup',
        members: members.map((ob)=>ob.id)
    }, 'delete');
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
    (0, $7hmfH.elem)('group').classList.add('disabled');
    (0, $7hmfH.alertMsg)('Ungrouped', 'info');
}
/**
 * set the border color of the given group to green
 * @param {fabric.Group} group - the group object
 */ function $95c555713171f487$var$setGroupBorderColor(group) {
    group.set({
        borderColor: 'green',
        cornerColor: 'green',
        cornerStrokeColor: 'green'
    });
}
/************************************* Bin (delete) ********************************************/ class $95c555713171f487$var$DeleteHandler extends (0, $9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    constructor(){
        super({});
    }
    delete() {
        $95c555713171f487$var$deleteActiveObjects();
        $95c555713171f487$var$unselectTool();
    }
    pointerdown() {}
    pointermove() {}
    pointerup() {}
    optionsDialog() {}
}
/**
 * makes the active objects invisible
 * this allows 'undo' to re-instate the objects, by making them visible
 */ function $95c555713171f487$var$deleteActiveObjects() {
    $95c555713171f487$export$67ea982130081db.getActiveObjects().forEach((obj)=>{
        if (obj.isEditing) return;
        obj.set('visible', false);
        $95c555713171f487$var$saveChange(obj, {
            visible: false
        }, 'delete');
        if (obj.type === 'group') obj.forEachObject((member)=>{
            member.set('visible', false);
            $95c555713171f487$export$67ea982130081db.add(member);
            $95c555713171f487$var$saveChange(member, {
                visible: false
            }, 'delete');
        });
    });
    $95c555713171f487$export$67ea982130081db.discardActiveObject();
    $95c555713171f487$export$67ea982130081db.requestRenderAll();
}
/******************************************** Undo ********************************************/ class $95c555713171f487$var$UndoHandler extends (0, $9a54cbcfc1af41ba$export$5a5fba7eea6847b1) {
    constructor(){
        super({});
    }
    undo() {
        if ($95c555713171f487$var$undos.length === 0) return; // nothing on the undo stack
        const undo = $95c555713171f487$var$undos.pop();
        (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('undos', $95c555713171f487$var$undos);
        if ($95c555713171f487$var$undos.length === 0) (0, $7hmfH.elem)('undotool').classList.add('disabled');
        if (undo.id === 'selection') {
            $95c555713171f487$var$redos.push((0, $7hmfH.deepCopy)(undo));
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('redos', $95c555713171f487$var$redos);
            (0, $7hmfH.elem)('redotool').classList.remove('disabled');
            switch(undo.op){
                case 'add':
                    // reverse of add selection is dispose of it
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    $95c555713171f487$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        const prevSelParams = $95c555713171f487$var$undos.findLast((d)=>d.id === 'selection').params;
                        $95c555713171f487$export$67ea982130081db.getActiveObject().set({
                            angle: prevSelParams.angle,
                            left: prevSelParams.left,
                            scaleX: prevSelParams.scaleX,
                            scaleY: prevSelParams.scaleY,
                            top: prevSelParams.top
                        });
                    }
                    break;
                case 'discard':
                    {
                        // reverse of discard selection is add it
                        const selectedObjects = undo.params.oldMembers.map((id)=>$95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                        const sel = new (0, $9a54cbcfc1af41ba$export$c57a942eef0ccd19)(selectedObjects, {
                            canvas: $95c555713171f487$export$67ea982130081db
                        });
                        $95c555713171f487$export$67ea982130081db.setActiveObject(sel);
                        $95c555713171f487$var$updateActiveButtons();
                    }
                    break;
            }
            $95c555713171f487$export$67ea982130081db.requestRenderAll();
            return;
        }
        if (undo.params.type === 'group' || undo.params.type === 'ungroup') {
            $95c555713171f487$var$redos.push((0, $7hmfH.deepCopy)(undo));
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('redos', $95c555713171f487$var$redos);
            (0, $7hmfH.elem)('redotool').classList.remove('disabled');
            const obj = $95c555713171f487$export$67ea982130081db.getObjects().filter((o)=>o.id === undo.id)[0];
            switch(undo.op){
                case 'insert':
                    // reverse of add group is dispose of it
                    obj.set('visible', false);
                    $95c555713171f487$var$saveChange(obj, {
                        members: undo.params.members,
                        type: 'group'
                    }, null);
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    $95c555713171f487$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        // find the previous param set for this group, and set the object to those params
                        const prevDelta = $95c555713171f487$var$undos.findLast((d)=>d.id === undo.id);
                        const newParams = (0, $7hmfH.clean)(prevDelta.params, {
                            type: true,
                            layoutManager: true
                        });
                        obj.set(newParams);
                        obj.setCoords();
                        $95c555713171f487$var$saveChange(obj, prevDelta.params, null);
                        break;
                    }
                case 'delete':
                    // reverse of delete group is add it
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    obj.set('visible', true);
                    $95c555713171f487$var$saveChange(obj, {
                        members: undo.params.members,
                        type: 'group'
                    }, null);
                    $95c555713171f487$export$67ea982130081db.setActiveObject(obj);
                    $95c555713171f487$var$updateActiveButtons();
                    break;
            }
            $95c555713171f487$export$67ea982130081db.requestRenderAll();
            return;
        }
        // find the object to be undone from its id
        const obj = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === undo.id);
        // get the current state of the object, so that redo can return it to this state
        let newParams = undo.params;
        if (obj) {
            newParams = obj.toObject();
            // remove unneeded properties
            newParams = (0, $7hmfH.clean)(newParams, {
                type: true,
                layoutManager: true
            });
            // push the current state onto the redo stack
            $95c555713171f487$var$redos.push({
                id: undo.id,
                params: newParams,
                op: undo.op
            });
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('redos', $95c555713171f487$var$redos);
            (0, $7hmfH.elem)('redotool').classList.remove('disabled');
            switch(undo.op){
                case 'insert':
                    obj.set('visible', false);
                    $95c555713171f487$var$saveChange(obj, {
                        visible: false
                    }, null);
                    break;
                case 'delete':
                    obj.set('visible', true);
                    $95c555713171f487$var$saveChange(obj, {
                        visible: true
                    }, null);
                    break;
                case 'update':
                    {
                        // find the previous param set for this object, and set the object to those params
                        const prevDelta = $95c555713171f487$var$undos.findLast((d)=>d.id === obj.id);
                        obj.set('visible', true);
                        const newParams = (0, $7hmfH.clean)(prevDelta.params, {
                            type: true,
                            layoutManager: true
                        });
                        obj.set(newParams);
                        obj.setCoords();
                        $95c555713171f487$var$saveChange(obj, Object.assign(prevDelta.params, {
                            visible: true
                        }), null);
                        break;
                    }
            }
            $95c555713171f487$export$67ea982130081db.discardActiveObject();
        }
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    }
    redo() {
        if ($95c555713171f487$var$redos.length === 0) return;
        const redo = $95c555713171f487$var$redos.pop();
        (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('redos', $95c555713171f487$var$redos);
        if ($95c555713171f487$var$redos.length === 0) (0, $7hmfH.elem)('redotool').classList.add('disabled');
        if (redo.id === 'selection') {
            $95c555713171f487$var$undos.push((0, $7hmfH.deepCopy)(redo));
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('undos', $95c555713171f487$var$undos);
            (0, $7hmfH.elem)('undotool').classList.remove('disabled');
            switch(redo.op){
                case 'add':
                    {
                        const selectedObjects = redo.params.members.map((id)=>$95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === id));
                        const sel = new (0, $9a54cbcfc1af41ba$export$c57a942eef0ccd19)(selectedObjects, {
                            canvas: $95c555713171f487$export$67ea982130081db
                        });
                        $95c555713171f487$export$67ea982130081db.setActiveObject(sel);
                        $95c555713171f487$var$updateActiveButtons();
                        break;
                    }
                case 'update':
                    $95c555713171f487$export$67ea982130081db.getActiveObject().set({
                        angle: redo.params.angle,
                        left: redo.params.left,
                        scaleX: redo.params.scaleX,
                        scaleY: redo.params.scaleY,
                        top: redo.params.top
                    });
                    break;
                case 'discard':
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    $95c555713171f487$var$updateActiveButtons();
                    break;
            }
            $95c555713171f487$export$67ea982130081db.requestRenderAll();
            return;
        }
        if (redo.params.type === 'group' || redo.params.type === 'ungroup') {
            $95c555713171f487$var$undos.push((0, $7hmfH.deepCopy)(redo));
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('undos', $95c555713171f487$var$undos);
            (0, $7hmfH.elem)('undotool').classList.remove('disabled');
            const obj = $95c555713171f487$export$67ea982130081db.getObjects().filter((o)=>o.id === redo.id)[0];
            if (obj) switch(redo.op){
                case 'delete':
                    // reverse of add group is dispose of it
                    obj.set('visible', false);
                    $95c555713171f487$var$saveChange(obj, {
                        members: redo.params.members,
                        type: 'group'
                    }, null);
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    $95c555713171f487$var$updateActiveButtons();
                    break;
                case 'update':
                    {
                        // find the previous param set for this group, and set the object to those params
                        const prevDelta = $95c555713171f487$var$undos.findLast((d)=>d.id === redo.id);
                        const newParams = (0, $7hmfH.clean)(prevDelta.params, {
                            type: true,
                            layoutManager: true
                        });
                        obj.set(newParams);
                        obj.setCoords();
                        $95c555713171f487$var$saveChange(obj, prevDelta.params, null);
                        break;
                    }
                case 'insert':
                    // reverse of delete group is add it
                    $95c555713171f487$export$67ea982130081db.discardActiveObject();
                    obj.set('visible', true);
                    $95c555713171f487$var$saveChange(obj, {
                        members: redo.params.members,
                        type: 'group'
                    }, null);
                    $95c555713171f487$export$67ea982130081db.setActiveObject(obj);
                    $95c555713171f487$var$updateActiveButtons();
                    break;
            }
            $95c555713171f487$export$67ea982130081db.requestRenderAll();
            return;
        }
        const obj = $95c555713171f487$export$67ea982130081db.getObjects().find((o)=>o.id === redo.id);
        if (obj) {
            const newParams = {};
            for(const prop in redo.params)newParams[prop] = obj[prop];
            $95c555713171f487$var$undos.push({
                id: redo.id,
                params: newParams,
                op: redo.op
            });
            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('undos', $95c555713171f487$var$undos);
            (0, $7hmfH.elem)('undotool').classList.remove('disabled');
            switch(redo.op){
                case 'insert':
                    obj.set('visible', true);
                    $95c555713171f487$var$saveChange(obj, {
                        visible: true
                    }, null);
                    break;
                case 'delete':
                    obj.set('visible', false);
                    $95c555713171f487$var$saveChange(obj, {
                        visible: false
                    }, null);
                    break;
                case 'update':
                    {
                        const newParams = (0, $7hmfH.clean)(redo.params, {
                            type: true,
                            layoutManager: true
                        });
                        obj.set(newParams);
                        obj.setCoords();
                        $95c555713171f487$var$saveChange(obj, Object.assign(redo.params, {
                            visible: true
                        }), null);
                        break;
                    }
            }
            $95c555713171f487$export$67ea982130081db.discardActiveObject();
            $95c555713171f487$export$67ea982130081db.requestRenderAll();
        }
    }
}
/******************************************** Broadcast ********************************************/ /**
 * Broadcast the changes to other clients and
 * save the current state of the object on the undo stack
 * @param {String} obj the object
 * @param {Object} params the current state
 * @param {String} op insert|delete|update|null (if null, don't save on the undo stack)
 */ function $95c555713171f487$var$saveChange(obj, params = {}, op) {
    if (/back/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) console.trace('Saving change for object', obj, 'op:', op, 'params:', params);
    // get current object position as well as any format changes
    params = $95c555713171f487$var$getObjectData(obj, params);
    // send the object to other clients
    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(obj.id, params);
    //check whether the order of objects has changed; if so, save the new order
    const oldSequence = (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).get('sequence');
    const newSequence = $95c555713171f487$export$67ea982130081db.getObjects().map((obj)=>obj.id);
    let different = true;
    if (oldSequence) {
        different = newSequence.length !== oldSequence.length;
        if (!different) {
            for(let i = 0; i < oldSequence.length; i++)if (newSequence[i] !== oldSequence[i]) {
                different = true;
                break;
            }
        }
    }
    if (different) (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('sequence', newSequence);
    // save the change on the undo stack
    if (op) {
        $95c555713171f487$var$undos.push({
            op: op,
            id: obj.id,
            params: params
        });
        $95c555713171f487$var$undos = $95c555713171f487$var$undos.slice(-$95c555713171f487$var$undoStackLength);
        (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set('undos', $95c555713171f487$var$undos);
        (0, $7hmfH.elem)('undotool').classList.remove('disabled');
    }
    // count the number of changes, so we can log that the background has changed
    $95c555713171f487$export$f2efb2348b1e4771++;
}
/**
 * Collect the parameters that would allow the reproduction of the object
 * @param {object} obj - fabric object
 * @param {object} params - initial parameters
 * @returns {object} the object data with all parameters needed for reproduction
 */ function $95c555713171f487$var$getObjectData(obj, params) {
    params = {
        ...obj.toObject(),
        ...params
    };
    params.id = obj.id;
    params.type = params.type || obj.type;
    if (obj.type === 'path' || obj.type === 'Path') params.pathOffset = obj.pathOffset;
    if (obj.type === 'image' || obj.type === 'Image') params.imageObj = obj.toObject();
    if (params.type === 'ActiveSelection' || params.type === 'Group') params.members = obj.getObjects().map((o)=>o.id);
    return params;
}
/************************************************** Smart Guides ********************************************/ const $95c555713171f487$var$aligningLineOffset = 5;
const $95c555713171f487$var$aligningLineMargin = 4;
const $95c555713171f487$var$aligningLineWidth = 1;
const $95c555713171f487$var$aligningLineColor = 'rgb(255,0,0)';
const $95c555713171f487$var$aligningDash = [
    5,
    5
];
/**
 * initialize the smart guides that help align objects when moving them
 */ function $95c555713171f487$var$initAligningGuidelines() {
    const ctx = $95c555713171f487$export$67ea982130081db.getSelectionContext();
    let viewportTransform;
    let zoom = 1;
    let verticalLines = [];
    let horizontalLines = [];
    $95c555713171f487$export$67ea982130081db.on('mouse:down', function() {
        viewportTransform = $95c555713171f487$export$67ea982130081db.viewportTransform;
        zoom = $95c555713171f487$export$67ea982130081db.getZoom();
    });
    $95c555713171f487$export$67ea982130081db.on('object:moving', function(e) {
        if (!$95c555713171f487$export$67ea982130081db._currentTransform) return;
        const activeObject = e.target;
        const activeObjectCenter = activeObject.getCenterPoint();
        const activeObjectBoundingRect = activeObject.getBoundingRect();
        const activeObjectHalfHeight = activeObjectBoundingRect.height / (2 * viewportTransform[3]);
        const activeObjectHalfWidth = activeObjectBoundingRect.width / (2 * viewportTransform[0]);
        $95c555713171f487$export$67ea982130081db.getObjects().filter((object)=>object !== activeObject && object.visible).forEach((object)=>{
            const objectCenter = object.getCenterPoint();
            const objectBoundingRect = object.getBoundingRect();
            const objectHalfHeight = objectBoundingRect.height / (2 * viewportTransform[3]);
            const objectHalfWidth = objectBoundingRect.width / (2 * viewportTransform[0]);
            // snap by the horizontal center line
            snapVertical(objectCenter.x, activeObjectCenter.x, objectCenter.x);
            // snap by the left object edge matching left active edge
            snapVertical(objectCenter.x - objectHalfWidth, activeObjectCenter.x - activeObjectHalfWidth, objectCenter.x - objectHalfWidth + activeObjectHalfWidth);
            // snap by the left object edge matching right active edge
            snapVertical(objectCenter.x - objectHalfWidth, activeObjectCenter.x + activeObjectHalfWidth, objectCenter.x - objectHalfWidth - activeObjectHalfWidth);
            // snap by the right object edge matching right active edge
            snapVertical(objectCenter.x + objectHalfWidth, activeObjectCenter.x + activeObjectHalfWidth, objectCenter.x + objectHalfWidth - activeObjectHalfWidth);
            // snap by the right object edge matching left active edge
            snapVertical(objectCenter.x + objectHalfWidth, activeObjectCenter.x - activeObjectHalfWidth, objectCenter.x + objectHalfWidth + activeObjectHalfWidth);
            function snapVertical(objEdge, activeEdge, snapCenter) {
                if (isInRange(objEdge, activeEdge)) {
                    verticalLines.push({
                        x: objEdge,
                        y1: objectCenter.y < activeObjectCenter.y ? objectCenter.y - objectHalfHeight - $95c555713171f487$var$aligningLineOffset : objectCenter.y + objectHalfHeight + $95c555713171f487$var$aligningLineOffset,
                        y2: activeObjectCenter.y > objectCenter.y ? activeObjectCenter.y + activeObjectHalfHeight + $95c555713171f487$var$aligningLineOffset : activeObjectCenter.y - activeObjectHalfHeight - $95c555713171f487$var$aligningLineOffset
                    });
                    activeObject.setPositionByOrigin(new (0, $9a54cbcfc1af41ba$export$baf26146a414f24a)(snapCenter, activeObjectCenter.y), 'center', 'center');
                }
            }
            // snap by the vertical center line
            snapHorizontal(objectCenter.y, activeObjectCenter.y, objectCenter.y);
            // snap by the top object edge matching the top active edge
            snapHorizontal(objectCenter.y - objectHalfHeight, activeObjectCenter.y - activeObjectHalfHeight, objectCenter.y - objectHalfHeight + activeObjectHalfHeight);
            // snap by the top object edge matching the bottom active edge
            snapHorizontal(objectCenter.y - objectHalfHeight, activeObjectCenter.y + activeObjectHalfHeight, objectCenter.y - objectHalfHeight - activeObjectHalfHeight);
            // snap by the bottom object edge matching the bottom active edge
            snapHorizontal(objectCenter.y + objectHalfHeight, activeObjectCenter.y + activeObjectHalfHeight, objectCenter.y + objectHalfHeight - activeObjectHalfHeight);
            // snap by the bottom object edge matching the top active edge
            snapHorizontal(objectCenter.y + objectHalfHeight, activeObjectCenter.y - activeObjectHalfHeight, objectCenter.y + objectHalfHeight + activeObjectHalfHeight);
            function snapHorizontal(objEdge, activeObjEdge, snapCenter) {
                if (isInRange(objEdge, activeObjEdge)) {
                    horizontalLines.push({
                        y: objEdge,
                        x1: objectCenter.x < activeObjectCenter.x ? objectCenter.x - objectHalfWidth - $95c555713171f487$var$aligningLineOffset : objectCenter.x + objectHalfWidth + $95c555713171f487$var$aligningLineOffset,
                        x2: activeObjectCenter.x > objectCenter.x ? activeObjectCenter.x + activeObjectHalfWidth + $95c555713171f487$var$aligningLineOffset : activeObjectCenter.x - activeObjectHalfWidth - $95c555713171f487$var$aligningLineOffset
                    });
                    activeObject.setPositionByOrigin(new (0, $9a54cbcfc1af41ba$export$baf26146a414f24a)(activeObjectCenter.x, snapCenter), 'center', 'center');
                }
            }
        });
    });
    $95c555713171f487$export$67ea982130081db.on('after:render', function() {
        verticalLines.forEach((line)=>drawVerticalLine(line));
        horizontalLines.forEach((line)=>drawHorizontalLine(line));
        verticalLines = [];
        horizontalLines = [];
    });
    $95c555713171f487$export$67ea982130081db.on('mouse:up', function() {
        $95c555713171f487$export$67ea982130081db.requestRenderAll();
    });
    /**
   * draw a vertical alignment guide line
   * @param {object} coords - object with x, y1, y2 coordinates
   */ function drawVerticalLine(coords) {
        drawLine(coords.x + 0.5, coords.y1 > coords.y2 ? coords.y2 : coords.y1, coords.x + 0.5, coords.y2 > coords.y1 ? coords.y2 : coords.y1);
    }
    /**
   * draw a horizontal alignment guide line
   * @param {object} coords - object with x1, x2, y coordinates
   */ function drawHorizontalLine(coords) {
        drawLine(coords.x1 > coords.x2 ? coords.x2 : coords.x1, coords.y + 0.5, coords.x2 > coords.x1 ? coords.x2 : coords.x1, coords.y + 0.5);
    }
    /**
   * draw an alignment guide line between two points
   * @param {number} x1 - start x coordinate
   * @param {number} y1 - start y coordinate
   * @param {number} x2 - end x coordinate
   * @param {number} y2 - end y coordinate
   */ function drawLine(x1, y1, x2, y2) {
        ctx.save();
        ctx.lineWidth = $95c555713171f487$var$aligningLineWidth;
        ctx.strokeStyle = $95c555713171f487$var$aligningLineColor;
        ctx.setLineDash($95c555713171f487$var$aligningDash);
        ctx.beginPath();
        ctx.moveTo(x1 * zoom + viewportTransform[4], y1 * zoom + viewportTransform[5]);
        ctx.lineTo(x2 * zoom + viewportTransform[4], y2 * zoom + viewportTransform[5]);
        ctx.stroke();
        ctx.restore();
    }
    /**
   * return true if value2 is within value1 +/- aligningLineMargin
   * @param {number} value1
   * @param {number} value2
   * @returns Boolean
   */ function isInRange(value1, value2) {
        return value2 > value1 - $95c555713171f487$var$aligningLineMargin && value2 < value1 + $95c555713171f487$var$aligningLineMargin;
    }
}
/*************************************copy & paste ********************************************/ let $95c555713171f487$var$displacement = 0;
function $95c555713171f487$export$adee94ba21be2b8e(event) {
    if (document.getSelection().toString()) return; // only copy if there is no text selected (e.g. in Notes)
    const activeObjs = $95c555713171f487$export$67ea982130081db.getActiveObjects();
    if (activeObjs.length === 0) return;
    event.preventDefault();
    const group = $95c555713171f487$export$67ea982130081db.getActiveObject();
    let groupLeft = 0;
    let groupTop = 0;
    // if the active Object is a group, then the component object positions are relative to the
    // group top, left, not to the canvas.  Compensate for this
    if (group.type === 'ActiveSelection' || group.type === 'group') {
        groupTop = group.top + group.height / 2;
        groupLeft = group.left + group.width / 2;
    }
    $95c555713171f487$var$copyAsText(JSON.stringify(activeObjs.map((obj)=>$95c555713171f487$var$getObjectData(obj, {
            left: obj.left + groupLeft,
            top: obj.top + groupTop
        }))));
    $95c555713171f487$var$displacement = 0;
}
/**
 * copy the given text to the clipboard
 * @param {string} text - the text to copy
 * @returns {Promise<boolean>} true if copy was successful, false otherwise
 */ async function $95c555713171f487$var$copyAsText(text) {
    try {
        if (typeof navigator.clipboard.writeText !== 'function') throw new Error('navigator.clipboard.writeText not a function');
    } catch  {
        (0, $7hmfH.alertMsg)('Copying not implemented in this browser', 'error');
        return false;
    }
    try {
        await navigator.clipboard.writeText(text);
        (0, $7hmfH.alertMsg)('Copied', 'info');
        return true;
    } catch (err) {
        console.error('Failed to copy: ', err);
        (0, $7hmfH.alertMsg)('Copy failed', 'error');
        return false;
    }
}
async function $95c555713171f487$export$8b0e49c4b227c2a() {
    const clip = await $95c555713171f487$var$getClipboardContents();
    const paramsArray = JSON.parse(clip);
    if ($95c555713171f487$export$67ea982130081db.getActiveObject()) $95c555713171f487$export$67ea982130081db.discardActiveObject();
    $95c555713171f487$var$displacement += 10;
    for (const params of paramsArray){
        const { type: type, ...otherParams } = params;
        let copiedObj;
        switch(type){
            case 'rect':
            case 'Rect':
                copiedObj = new $95c555713171f487$var$RectHandler();
                break;
            case 'circle':
            case 'Circle':
                copiedObj = new $95c555713171f487$var$CircleHandler();
                break;
            case 'line':
            case 'Line':
                copiedObj = new $95c555713171f487$var$LineHandler();
                break;
            case 'text':
            case 'Text':
            case 'i-text':
            case 'IText':
                copiedObj = new $95c555713171f487$var$TextHandler();
                break;
            case 'path':
            case 'Path':
                copiedObj = new (0, $9a54cbcfc1af41ba$export$4b2950bdac9b6ee9)();
                break;
            case 'image':
            case 'Image':
                await (0, $9a54cbcfc1af41ba$export$3148ec5c6497ddc8).fromObject(params.imageObj).then((image)=>{
                    image.set({
                        left: params.left + $95c555713171f487$var$displacement,
                        top: params.top + $95c555713171f487$var$displacement,
                        id: (0, $7hmfH.uuidv4)()
                    });
                    $95c555713171f487$export$67ea982130081db.add(image);
                    $95c555713171f487$export$67ea982130081db.setActiveObject(image);
                    $95c555713171f487$var$saveChange(image, {
                        imageObj: image.toObject()
                    }, 'insert');
                });
                continue;
            default:
                throw new Error(`bad fabric object type in pasteFromClipboard: ${type}`);
        }
        copiedObj.set(otherParams);
        copiedObj.left += $95c555713171f487$var$displacement;
        copiedObj.top += $95c555713171f487$var$displacement;
        copiedObj.id = (0, $7hmfH.uuidv4)();
        $95c555713171f487$export$67ea982130081db.add(copiedObj);
        $95c555713171f487$export$67ea982130081db.setActiveObject(copiedObj);
        $95c555713171f487$var$saveChange(copiedObj, {}, 'insert');
    }
    (0, $7hmfH.alertMsg)('Pasted', 'info');
}
/**
 * retrieve the contents of the clipboard
 * @returns {Promise<string|null>} the clipboard contents, or null if read failed
 */ async function $95c555713171f487$var$getClipboardContents() {
    try {
        if (typeof navigator.clipboard.readText !== 'function') throw new Error('navigator.clipboard.readText not a function');
    } catch  {
        (0, $7hmfH.alertMsg)('Pasting not implemented in this browser', 'error');
        return null;
    }
    try {
        return await navigator.clipboard.readText();
    } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
        (0, $7hmfH.alertMsg)('Failed to paste', 'error');
        return null;
    }
}
function $95c555713171f487$export$aab3aebcdfaf4b16(pointsArray) {
    // do nothing if either yPointsArray is empty or yDrawingMap  already contains objects
    if ((0, $5bc812abaa5f432b$export$ffba1a0e51177788).length === 0 || (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).size > 0) return;
    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).clear();
    let options;
    const ids = [];
    $95c555713171f487$export$67ea982130081db.setViewportTransform([
        1,
        0,
        0,
        1,
        $95c555713171f487$export$67ea982130081db.getWidth() / 2,
        $95c555713171f487$export$67ea982130081db.getHeight() / 2
    ]);
    (0, $5bc812abaa5f432b$export$2a111da947c407d2).transact(()=>{
        pointsArray = $95c555713171f487$var$eraser(pointsArray);
        pointsArray.forEach((item)=>{
            const fabObj = {
                id: (0, $7hmfH.uuidv4)()
            };
            switch(item[0]){
                case 'options':
                    options = item[1];
                    break;
                case 'dashedLine':
                    fabObj.strokeDashArray = [
                        10,
                        10
                    ];
                // falls through
                case 'line':
                    fabObj.type = 'line';
                    fabObj.x1 = item[1][0];
                    fabObj.y1 = item[1][1];
                    fabObj.x2 = item[1][2];
                    fabObj.y2 = item[1][3];
                    fabObj.axes = false;
                    fabObj.stroke = options.strokeStyle;
                    fabObj.strokeWidth = options.lineWidth;
                    ids.push(fabObj.id);
                    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'rrect':
                    fabObj.rx = 10;
                    fabObj.ry = 10;
                // falls through
                case 'rect':
                    fabObj.type = 'rect';
                    fabObj.left = item[1][0];
                    fabObj.top = item[1][1];
                    fabObj.width = item[1][2];
                    fabObj.height = item[1][3];
                    fabObj.fill = options.fillStyle;
                    if (fabObj.fill === 'rgb(255, 255, 255)' || fabObj.fill === '#ffffff') fabObj.fill = 'rgba(0, 0, 0, 0)';
                    fabObj.stroke = options.strokeStyle;
                    fabObj.strokeWidth = options.lineWidth;
                    ids.push(fabObj.id);
                    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'text':
                    fabObj.type = 'text';
                    fabObj.fill = options.fillStyle;
                    fabObj.fontSize = Number.parseInt(options.font);
                    fabObj.text = item[1][0];
                    fabObj.left = item[1][1];
                    fabObj.top = item[1][2];
                    ids.push(fabObj.id);
                    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'image':
                    {
                        // this is a bit complicated because we have to allow for the async onload of the image
                        const image = new Image();
                        image.src = item[1][0];
                        const promise = new Promise((resolve)=>{
                            image.onload = function() {
                                const imageObj = new (0, $9a54cbcfc1af41ba$export$3148ec5c6497ddc8)(image, {
                                    left: item[1][1],
                                    top: item[1][2],
                                    width: item[1][3],
                                    height: item[1][4]
                                });
                                fabObj.type = 'image';
                                fabObj.imageObj = imageObj.toObject();
                                resolve(fabObj);
                            };
                        });
                        promise.then(()=>{
                            (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                            $95c555713171f487$export$8d588f71d329a9b1([
                                fabObj.id
                            ]);
                        });
                    }
                    break;
                case 'pencil':
                    break;
                case 'marker':
                    fabObj.type = 'circle';
                    fabObj.fill = options.fillStyle;
                    fabObj.strokeWidth = 0;
                    fabObj.stroke = options.fillStyle;
                    fabObj.left = item[1][0];
                    fabObj.top = item[1][1];
                    fabObj.radius = item[1][2] / 2;
                    ids.push(fabObj.id);
                    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(fabObj.id, fabObj);
                    break;
                case 'endShape':
                    break;
            }
        });
    });
    console.log('Background converted from v1 to v2');
    $95c555713171f487$export$8d588f71d329a9b1(ids);
}
/**
 * Simulate the effect of the v1 eraser by deleting all rects and textboxes that are overlapped by the
 * white circles produced by the v1 eraser
 * @returns {array} a filtered version of pointsArray, with 'erased' rects, texts and white marker circles omitted
 */ function $95c555713171f487$var$eraser() {
    const points = (0, $7hmfH.deepCopy)((0, $5bc812abaa5f432b$export$ffba1a0e51177788).toArray());
    let options = {};
    // work along pointsArray.
    for(let i = 0; i < points.length; i++){
        const point = points[i];
        // if not 'endShape' or 'options'
        if (point[0] === 'endShape') continue;
        if (point[0] === 'options') {
            options = point[1];
            continue;
        }
        //if circle and white
        if (point[0] === 'marker' && options.fillStyle === '#ffffff') {
            // starting at beginning test each array entry until reached current entry
            for(let j = 0; j < i; j++)// test whether circle overlaps shape
            if ($95c555713171f487$var$intersect(point, points[j])) // if so, change shape to 'deleted'
            points[j][0] = 'deleted';
            // when reach current entry, change circle to 'deleted' and repeat until end of array.
            point[0] = 'deleted';
        }
    }
    return points.filter((p)=>p[0] !== 'deleted');
}
/**
 * returns true iff the circle overlaps the shape (tests only rects and text boxes, not lines or pencil)
 * @param {array} circle - a marker item from yPointsArray
 * @param {array} shape - an item from yPointsArray
 * @returns {boolean} true if circle overlaps shape, false otherwise
 */ function $95c555713171f487$var$intersect(circle, shape) {
    const circObj = {
        x: circle[1][0],
        y: circle[1][1],
        r: circle[1][2]
    };
    switch(shape[0]){
        case 'rect':
        case 'rrect':
            {
                const rectObj = {
                    x: shape[1][0],
                    y: shape[1][1],
                    w: shape[1][2],
                    h: shape[1][3]
                };
                return $95c555713171f487$var$circleIntersectsRect(circObj, rectObj);
            }
        case 'text':
            // to simplify, just test whether the start point is covered by the circle
            return (circObj.x - shape[1][1]) ** 2 + (circObj.y - shape[1][2]) ** 2 < circObj.r ** 2;
        default:
            return false;
    }
}
/**
 * tests whether any part of the circle overlaps the rectangle
 * @param {object} circle - object with x, y as the circle's centre and r, the circle's radius
 * @param {object} rect - object with x, y for its top left, and width and height
 * @returns {boolean} true if circle overlaps rectangle, false otherwise
 */ function $95c555713171f487$var$circleIntersectsRect(circle, rect) {
    const distX = Math.abs(circle.x - rect.x - rect.w / 2);
    const distY = Math.abs(circle.y - rect.y - rect.h / 2);
    if (distX > rect.w / 2 + circle.r) return false;
    if (distY > rect.h / 2 + circle.r) return false;
    if (distX <= rect.w / 2) return true;
    if (distY <= rect.h / 2) return true;
    const dx = distX - rect.w / 2;
    const dy = distY - rect.h / 2;
    return dx * dx + dy * dy <= circle.r * circle.r;
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

  Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module handles operations related to the Styles tabs.  
 ******************************************************************************************************************** */ 
var $8L2sr = parcelRequire("8L2sr");

var $7AcYc = parcelRequire("7AcYc");

var $7hmfH = parcelRequire("7hmfH");


function $3ee4e83c23551e65$export$4ca77f8e2d7fc8b6() {
    // expand the styles object to include the default values
    $3ee4e83c23551e65$var$expandStylesObject();
    // Get all elements with class='sampleNode' and add listener and canvas
    const emptyDataSet = new (0, $7AcYc.DataSet)([]);
    let sampleElements = document.getElementsByClassName('sampleNode');
    for(let i = 0; i < sampleElements.length; i++){
        const groupId = `group${i}`;
        const sampleElement = sampleElements[i];
        const sampleOptions = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId];
        const groupLabel = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId].groupLabel;
        const nodeDataSet = new (0, $7AcYc.DataSet)([
            (0, $7hmfH.deepMerge)({
                id: '1',
                label: groupLabel === undefined ? '' : groupLabel
            }, sampleOptions, {
                chosen: false,
                widthConstraint: 50,
                heightConstraint: 50,
                font: {
                    size: 14
                },
                size: 50,
                margin: 10,
                scaling: {
                    label: {
                        enabled: false
                    }
                }
            })
        ]);
        $3ee4e83c23551e65$var$initSample(sampleElement, {
            nodes: nodeDataSet,
            edges: emptyDataSet
        });
        sampleElement.addEventListener('dblclick', ()=>{
            $3ee4e83c23551e65$var$editNodeStyle(sampleElement, groupId);
        });
        sampleElement.addEventListener('click', ()=>{
            (0, $5bc812abaa5f432b$export$7ac138a1e38951d6)(groupId, null);
        });
        sampleElement.addEventListener('pointerdown', (event)=>{
            if (event.button === 2) // right click)
            $3ee4e83c23551e65$var$styleNodeContextMenu(sampleElement, groupId);
        });
        sampleElement.addEventListener('mouseover', ()=>(0, $7hmfH.statusMsg)('Left click: apply style to selected; Double click: edit style; Right click: Select or Hide all with this style'));
        sampleElement.addEventListener('mouseout', ()=>(0, $7hmfH.clearStatusBar)());
        sampleElement.groupNode = groupId;
        sampleElement.dataSet = nodeDataSet;
    }
    // and to all sampleLinks
    sampleElements = document.getElementsByClassName('sampleLink');
    for(let i = 0; i < sampleElements.length; i++){
        const sampleElement = sampleElements[i];
        const groupId = `edge${i}`;
        const groupLabel = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId].groupLabel;
        const sampleOptions = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId];
        const edgeDataSet = new (0, $7AcYc.DataSet)([
            (0, $7hmfH.deepMerge)({
                id: '1',
                from: 1,
                to: 2,
                label: groupLabel === undefined ? '' : groupLabel
            }, sampleOptions, {
                font: {
                    size: 24,
                    color: 'black',
                    align: 'top',
                    vadjust: -40
                },
                widthConstraint: 100,
                value: 10
            })
        ]);
        const nodesDataSet = new (0, $7AcYc.DataSet)([
            {
                id: 1,
                size: 5,
                shape: 'dot',
                fixed: true,
                chosen: false
            },
            {
                id: 2,
                size: 5,
                shape: 'dot',
                fixed: true,
                chosen: false
            }
        ]);
        $3ee4e83c23551e65$var$initSample(sampleElement, {
            nodes: nodesDataSet,
            edges: edgeDataSet
        });
        sampleElement.addEventListener('dblclick', ()=>{
            $3ee4e83c23551e65$var$editLinkStyle(sampleElement, groupId);
        });
        sampleElement.addEventListener('click', ()=>{
            (0, $5bc812abaa5f432b$export$7ac138a1e38951d6)(null, groupId);
        });
        sampleElement.addEventListener('pointerdown', (event)=>{
            if (event.button === 2) // right click)
            $3ee4e83c23551e65$var$styleEdgeContextMenu(sampleElement, groupId);
        });
        sampleElement.addEventListener('mouseover', ()=>(0, $7hmfH.statusMsg)('Left click: apply style to selected; Double click: edit style; Right click: Select all with this style'));
        sampleElement.groupLink = groupId;
        sampleElement.dataSet = edgeDataSet;
    }
    // set up color pickers
    (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditFillColor', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditBorderColor', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('nodeStyleEditFontColor', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $5bc812abaa5f432b$export$cd571ca6d1702b73).createColorPicker('linkStyleEditLineColor', $3ee4e83c23551e65$var$linkEditSave);
    // set up listeners
    (0, $7hmfH.listen)('nodeStyleEditCancel', 'click', $3ee4e83c23551e65$var$nodeEditCancel);
    (0, $7hmfH.listen)('nodeStyleEditName', 'keyup', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $7hmfH.listen)('nodeStyleEditShape', 'change', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $7hmfH.listen)('nodeStyleEditBorder', 'change', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $7hmfH.listen)('nodeStyleEditFontSize', 'change', $3ee4e83c23551e65$var$nodeEditSave);
    (0, $7hmfH.listen)('nodeStyleEditSubmit', 'click', $3ee4e83c23551e65$var$nodeEditSubmit);
    (0, $7hmfH.listen)('linkStyleEditCancel', 'click', $3ee4e83c23551e65$var$linkEditCancel);
    (0, $7hmfH.listen)('linkStyleEditName', 'keyup', $3ee4e83c23551e65$var$linkEditSave);
    (0, $7hmfH.listen)('linkStyleEditWidth', 'input', $3ee4e83c23551e65$var$linkEditSave);
    (0, $7hmfH.listen)('linkStyleEditDashes', 'input', $3ee4e83c23551e65$var$linkEditSave);
    (0, $7hmfH.listen)('linkStyleEditArrows', 'change', $3ee4e83c23551e65$var$linkEditSave);
    (0, $7hmfH.listen)('linkStyleEditSubmit', 'click', $3ee4e83c23551e65$var$linkEditSubmit);
}
/**
 * assemble styles by merging the specifics into the default
 */ function $3ee4e83c23551e65$var$expandStylesObject() {
    let base = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.base;
    for(const prop in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes){
        const grp = (0, $7hmfH.deepMerge)(base, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[prop]);
        // make the hover and highlight colors the same as the basic ones
        grp.color.highlight = {};
        grp.color.highlight.border = grp.color.border;
        grp.color.highlight.background = grp.color.background;
        grp.color.hover = {};
        grp.color.hover.border = grp.color.border;
        grp.color.hover.background = grp.color.background;
        //		grp.font.size = base.font.size
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[prop] = grp;
    }
    base = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.base;
    for(const prop in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges){
        const grp = (0, $7hmfH.deepMerge)(base, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[prop]);
        grp.color.highlight = grp.color.color;
        grp.color.hover = grp.color.color;
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[prop] = grp;
    }
}
/**
 * create the sample network
 * @param {HTMLElement} wrapper
 * @param {object} sampleData
 */ function $3ee4e83c23551e65$var$initSample(wrapper, sampleData) {
    const options = {
        interaction: {
            dragNodes: false,
            dragView: false,
            selectable: true,
            zoomView: false
        },
        manipulation: {
            enabled: false
        },
        layout: {
            hierarchical: {
                enabled: true,
                direction: 'LR'
            }
        }
    };
    const net = new (0, $8L2sr.Network)(wrapper, sampleData, options);
    net.fit();
    net.storePositions();
    wrapper.net = net;
    return net;
}
const $3ee4e83c23551e65$var$factorsHiddenByStyle = {};
const $3ee4e83c23551e65$var$linksHiddenByStyle = {};
/**
 * Context menu for node styles
 * @param {HTMLElement} sampleElement
 * @param {string} groupId
 */ function $3ee4e83c23551e65$var$styleNodeContextMenu(sampleElement, groupId) {
    (0, $7hmfH.addContextMenu)(sampleElement, [
        {
            label: 'Select Factors',
            action: ()=>$3ee4e83c23551e65$var$selectFactorsWithStyle(groupId)
        },
        {
            label: `${sampleElement.dataset.hide === 'hidden' ? 'Unhide' : 'Hide'} Factors`,
            action: ()=>$3ee4e83c23551e65$var$hideFactorsWithStyle(sampleElement, groupId)
        }
    ]);
}
/**
 * Select all the factors with the given style
 * Used by Style context menu
 * @param {integer} groupId
 */ function $3ee4e83c23551e65$var$selectFactorsWithStyle(groupId) {
    (0, $5bc812abaa5f432b$export$3ec31f8909af8acf)((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.getIds({
        filter: (node)=>node.grp === groupId
    }));
}
/**
 * Hide or unhide all the factors with the given style
 * Used by Style context menu
 * @param {HTMLElement} sampleElement
 * @param {integer} groupId
 */ function $3ee4e83c23551e65$var$hideFactorsWithStyle(sampleElement, groupId) {
    const wasHidden = sampleElement.dataset.hide === 'hidden';
    const nodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>node.grp === groupId
    });
    nodes.forEach((node)=>{
        (0, $7hmfH.setNodeHidden)(node, !wasHidden);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodes);
    const edges = [];
    nodes.forEach((node)=>{
        const connectedEdges = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getConnectedEdges(node.id);
        connectedEdges.forEach((edgeId)=>{
            edges.push((0, $5bc812abaa5f432b$export$4051a07651545597).edges.get(edgeId));
        });
    });
    edges.forEach((edge)=>{
        (0, $7hmfH.setEdgeHidden)(edge, !wasHidden);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edges);
    $3ee4e83c23551e65$var$factorsHiddenByStyle[sampleElement.id] = !wasHidden;
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('factorsHiddenByStyle', $3ee4e83c23551e65$var$factorsHiddenByStyle);
    sampleElement.dataset.hide = wasHidden ? 'visible' : 'hidden';
}
/**
 * Context menu for edge styles
 * @param {HTMLElement} sampleElement
 * @param {string} groupId
 */ function $3ee4e83c23551e65$var$styleEdgeContextMenu(sampleElement, groupId) {
    (0, $7hmfH.addContextMenu)(sampleElement, [
        {
            label: 'Select Links',
            action: ()=>$3ee4e83c23551e65$var$selectLinksWithStyle(groupId)
        },
        {
            label: `${sampleElement.dataset.hide === 'hidden' ? 'Unhide' : 'Hide'} Links`,
            action: ()=>$3ee4e83c23551e65$var$hideLinksWithStyle(sampleElement, groupId)
        }
    ]);
}
/**
 * Select all the links with the given style
 * Used by Style context menu
 * @param {integer} groupId
 */ function $3ee4e83c23551e65$var$selectLinksWithStyle(groupId) {
    (0, $5bc812abaa5f432b$export$2c92a894f29aaee5)((0, $5bc812abaa5f432b$export$4051a07651545597).edges.getIds({
        filter: (edge)=>edge.grp === groupId
    }));
}
/**
 * Hide or unhide all the links with the given style
 * Used by Style context menu
 * @param {HTMLElement} sampleElement
 * @param {integer} groupId
 */ function $3ee4e83c23551e65$var$hideLinksWithStyle(sampleElement, groupId) {
    const wasHidden = sampleElement.dataset.hide === 'hidden';
    const edges = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get({
        filter: (edge)=>edge.grp === groupId
    });
    edges.forEach((edge)=>{
        (0, $7hmfH.setEdgeHidden)(edge, !wasHidden);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edges);
    $3ee4e83c23551e65$var$linksHiddenByStyle[sampleElement.id] = !wasHidden;
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('linksHiddenByStyle', $3ee4e83c23551e65$var$linksHiddenByStyle);
    sampleElement.dataset.hide = wasHidden ? 'visible' : 'hidden';
}
/**
 * open the dialog to edit a node style
 * @param {HTMLElement} styleElement
 * @param {number} groupId
 */ function $3ee4e83c23551e65$var$editNodeStyle(styleElement, groupId) {
    styleElement.net.unselectAll();
    const container = (0, $7hmfH.elem)('nodeStyleEditorContainer');
    container.groupId = groupId;
    // save the current style format (so that there can be a revert in case of cancelling the edit)
    container.origGroup = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId]);
    // save the div in which the style is displayed
    container.styleElement = styleElement;
    // set the style dialog widgets with the current values for the group style
    $3ee4e83c23551e65$var$updateNodeEditor(groupId);
    // display the style dialog
    $3ee4e83c23551e65$var$nodeEditorShow();
    (0, $7hmfH.elem)('nodeStyleEditName').focus();
}
/**
 * ensure that the edit node style dialog shows the current state of the style
 * @param {string} groupId
 */ function $3ee4e83c23551e65$var$updateNodeEditor(groupId) {
    const group = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId];
    (0, $7hmfH.elem)('nodeStyleEditName').value = group.groupLabel !== 'Sample' ? group.groupLabel : '';
    (0, $7hmfH.elem)('nodeStyleEditFillColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(group.color.background);
    (0, $7hmfH.elem)('nodeStyleEditBorderColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(group.color.border);
    (0, $7hmfH.elem)('nodeStyleEditFontColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(group.font.color);
    (0, $7hmfH.elem)('nodeStyleEditShape').value = group.shape;
    (0, $7hmfH.elem)('nodeStyleEditBorder').value = (0, $7hmfH.getDashes)(group.shapeProperties.borderDashes, group.borderWidth);
    (0, $7hmfH.elem)('nodeStyleEditFontSize').value = group.font.size;
    if (group.fixed) {
        (0, $7hmfH.elem)('nodeStyleEditFixed').style.display = 'inline';
        (0, $7hmfH.elem)('nodeStyleEditUnfixed').style.display = 'none';
    } else {
        (0, $7hmfH.elem)('nodeStyleEditFixed').style.display = 'none';
        (0, $7hmfH.elem)('nodeStyleEditUnfixed').style.display = 'inline';
    }
    (0, $7hmfH.elem)('nodeStyleEditFactorSize').value = (0, $7hmfH.factorSizeToPercent)(group.size);
    (0, $5bc812abaa5f432b$export$9d1298853f0e77f7)((0, $7hmfH.elem)('nodeStyleEditFactorSize'));
}
(0, $7hmfH.listen)('nodeStyleEditLock', 'click', $3ee4e83c23551e65$var$toggleNodeStyleLock);
/**
 * Toggle the lock state of the node style
 */ function $3ee4e83c23551e65$var$toggleNodeStyleLock() {
    const group = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[(0, $7hmfH.elem)('nodeStyleEditorContainer').groupId];
    if (group.fixed) {
        (0, $7hmfH.elem)('nodeStyleEditFixed').style.display = 'none';
        (0, $7hmfH.elem)('nodeStyleEditUnfixed').style.display = 'inline';
    } else {
        (0, $7hmfH.elem)('nodeStyleEditFixed').style.display = 'inline';
        (0, $7hmfH.elem)('nodeStyleEditUnfixed').style.display = 'none';
    }
    group.fixed = !group.fixed;
}
/**
 * save changes to the style made with the edit dialog to the style object
 */ function $3ee4e83c23551e65$var$nodeEditSave() {
    const groupId = (0, $7hmfH.elem)('nodeStyleEditorContainer').groupId;
    const group = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId];
    group.groupLabel = (0, $7hmfH.elem)('nodeStyleEditName').value;
    if (group.groupLabel === '') group.groupLabel = 'Sample';
    group.color.background = (0, $7hmfH.elem)('nodeStyleEditFillColor').style.backgroundColor;
    group.color.border = (0, $7hmfH.elem)('nodeStyleEditBorderColor').style.backgroundColor;
    group.color.highlight.background = group.color.background;
    group.color.highlight.border = group.color.border;
    group.color.hover.background = group.color.background;
    group.color.hover.border = group.color.border;
    group.font.color = (0, $7hmfH.elem)('nodeStyleEditFontColor').style.backgroundColor;
    group.shape = (0, $7hmfH.elem)('nodeStyleEditShape').value;
    const border = (0, $7hmfH.elem)('nodeStyleEditBorder').value;
    group.shapeProperties.borderDashes = (0, $7hmfH.convertDashes)(border);
    group.borderWidth = border === 'none' ? 0 : border === 'solid' ? 1 : 4;
    group.font.size = parseInt((0, $7hmfH.elem)('nodeStyleEditFontSize').value);
    (0, $7hmfH.setFactorSizeFromPercent)(group, (0, $7hmfH.elem)('nodeStyleEditFactorSize').value);
    $3ee4e83c23551e65$var$nodeEditUpdateStyleSample(group);
}
/**
 * update the style sample to show changes to style
 * @param {Object} group
 */ function $3ee4e83c23551e65$var$nodeEditUpdateStyleSample(group) {
    const groupId = (0, $7hmfH.elem)('nodeStyleEditorContainer').groupId;
    const styleElement = (0, $7hmfH.elem)('nodeStyleEditorContainer').styleElement;
    let node = styleElement.dataSet.get('1');
    node.label = group.groupLabel;
    // the node in the style sample does not change size
    node = (0, $7hmfH.deepMerge)(node, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId], {
        chosen: false,
        size: 50,
        widthConstraint: 50,
        heightConstraint: 50,
        margin: 10,
        font: {
            size: 14
        }
    });
    styleElement.dataSet.update(node);
}
/**
 * cancel any editing of the style and revert to what it was previously
 */ function $3ee4e83c23551e65$var$nodeEditCancel() {
    // restore saved group format
    const groupId = (0, $7hmfH.elem)('nodeStyleEditorContainer').groupId;
    (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId] = (0, $7hmfH.elem)('nodeStyleEditorContainer').origGroup;
    $3ee4e83c23551e65$var$nodeEditUpdateStyleSample((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId]);
    $3ee4e83c23551e65$var$nodeEditorHide();
}
/**
 * hide the node style editor dialog
 */ function $3ee4e83c23551e65$var$nodeEditorHide() {
    (0, $7hmfH.elem)('nodeStyleEditorContainer').classList.add('hideEditor');
}
/**
 * show the node style editor dialog
 */ function $3ee4e83c23551e65$var$nodeEditorShow() {
    const panelRect = (0, $7hmfH.elem)('panel').getBoundingClientRect();
    const container = (0, $7hmfH.elem)('nodeStyleEditorContainer');
    container.style.top = `${panelRect.top}px`;
    container.style.left = `${panelRect.left - 300}px`;
    container.classList.remove('hideEditor');
}
/**
 * save the edited style and close the style editor.  Update the nodes
 * in the map and the legend to the current style
 */ function $3ee4e83c23551e65$var$nodeEditSubmit() {
    $3ee4e83c23551e65$var$nodeEditSave();
    $3ee4e83c23551e65$var$nodeEditorHide();
    // apply updated style to all nodes having that style
    const groupId = (0, $7hmfH.elem)('nodeStyleEditorContainer').groupId;
    // somewhere - but I have no idea where or why, this is set to true, but it must be false
    (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId].scaling.label.enabled = false;
    $3ee4e83c23551e65$export$72639688f12e084([
        groupId
    ], true);
    (0, $5bc812abaa5f432b$export$4b63d58d2685a993).set(groupId, {
        node: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId]
    });
    $3ee4e83c23551e65$export$b8032ab161d91961();
    (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).redraw();
    (0, $5bc812abaa5f432b$export$e5fde6ebaea8ae1d)('edited a Factor style');
}
function $3ee4e83c23551e65$export$72639688f12e084(groupIds, force) {
    const nodesToUpdate = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (item)=>{
            return groupIds.includes(item.grp);
        }
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate.map((node)=>{
        return force ? (0, $7hmfH.deepMerge)(node, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[node.grp]) : (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[node.grp], node);
    }));
}
function $3ee4e83c23551e65$export$675fa328fb4ebccd(groupId) {
    const sampleElements = Array.from(document.getElementsByClassName('sampleNode'));
    const sampleElement = sampleElements[groupId.match(/\d+/)?.[0]];
    if (!sampleElement) return;
    let node = sampleElement.dataSet.get()[0];
    node = (0, $7hmfH.deepMerge)(node, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId], {
        chosen: false,
        size: 50,
        widthConstraint: 50,
        heightConstraint: 50,
        margin: 10,
        font: {
            size: 14
        }
    });
    node.label = node.groupLabel;
    sampleElement.dataSet.remove(node.id);
    sampleElement.dataSet.update(node);
    sampleElement.net.fit();
}
/**
 * open the dialog to edit a link style
 * @param {HTMLElement} styleElement
 * @param {string} groupId
 */ function $3ee4e83c23551e65$var$editLinkStyle(styleElement, groupId) {
    const container = (0, $7hmfH.elem)('linkStyleEditorContainer');
    container.styleElement = styleElement;
    container.groupId = groupId;
    // save the current style format (so that there can be a revert in case of cancelling the edit)
    container.origGroup = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId]);
    // set the style dialog widgets with the current values for the group style
    $3ee4e83c23551e65$var$updateLinkEditor(groupId);
    // display the style dialog
    $3ee4e83c23551e65$var$linkEditorShow();
    (0, $7hmfH.elem)('linkStyleEditName').focus();
}
/**
 * ensure that the edit link style dialog shows the current state of the style
 * @param {string} groupId
 */ function $3ee4e83c23551e65$var$updateLinkEditor(groupId) {
    const group = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId];
    (0, $7hmfH.elem)('linkStyleEditName').value = group.groupLabel !== 'Sample' ? group.groupLabel : '';
    (0, $7hmfH.elem)('linkStyleEditLineColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(group.color.color);
    (0, $7hmfH.elem)('linkStyleEditWidth').value = group.width;
    (0, $7hmfH.elem)('linkStyleEditDashes').value = (0, $7hmfH.getDashes)(group.dashes, 1);
    (0, $7hmfH.elem)('linkStyleEditArrows').value = $3ee4e83c23551e65$var$getArrows(group.arrows);
}
/**
 * save changes to the style made with the edit dialog to the style object
 */ function $3ee4e83c23551e65$var$linkEditSave() {
    const groupId = (0, $7hmfH.elem)('linkStyleEditorContainer').groupId;
    const group = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId];
    group.groupLabel = (0, $7hmfH.elem)('linkStyleEditName').value;
    if (group.groupLabel === '') group.groupLabel = 'Sample';
    group.color.color = (0, $7hmfH.elem)('linkStyleEditLineColor').style.backgroundColor;
    group.color.highlight = group.color.color;
    group.color.hover = group.color.color;
    group.width = parseInt((0, $7hmfH.elem)('linkStyleEditWidth').value);
    group.dashes = (0, $7hmfH.convertDashes)((0, $7hmfH.elem)('linkStyleEditDashes').value);
    groupArrows((0, $7hmfH.elem)('linkStyleEditArrows').value);
    $3ee4e83c23551e65$var$linkEditUpdateStyleSample(group);
    /**
   * Set the link object properties to show various arrow types
   * @param {string} val
   */ function groupArrows(val) {
        if (val !== '') {
            group.arrows.from.enabled = false;
            group.arrows.middle.enabled = false;
            group.arrows.to.enabled = true;
            if (val === 'none') group.arrows.to.enabled = false;
            else group.arrows.to.type = val;
        }
    }
}
/**
 * update the style sample to show changes to style
 * @param {Object} group
 */ function $3ee4e83c23551e65$var$linkEditUpdateStyleSample(group) {
    // update the style edge to show changes to style
    const groupId = (0, $7hmfH.elem)('linkStyleEditorContainer').groupId;
    const styleElement = (0, $7hmfH.elem)('linkStyleEditorContainer').styleElement;
    let edge = styleElement.dataSet.get('1');
    edge.label = group.groupLabel;
    edge = (0, $7hmfH.deepMerge)(edge, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId], {
        chosen: false
    });
    const dataSet = styleElement.dataSet;
    dataSet.update(edge);
}
/**
 * cancel any editing of the style and revert to what it was previously
 */ function $3ee4e83c23551e65$var$linkEditCancel() {
    // restore saved group format
    const groupId = (0, $7hmfH.elem)('linkStyleEditorContainer').groupId;
    (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId] = (0, $7hmfH.elem)('linkStyleEditorContainer').origGroup;
    $3ee4e83c23551e65$var$linkEditorHide();
}
/**
 * hide the link style editor dialog
 */ function $3ee4e83c23551e65$var$linkEditorHide() {
    (0, $7hmfH.elem)('linkStyleEditorContainer').classList.add('hideEditor');
}
/**
 * show the link style editor dialog
 */ function $3ee4e83c23551e65$var$linkEditorShow() {
    const panelRect = (0, $7hmfH.elem)('panel').getBoundingClientRect();
    const container = (0, $7hmfH.elem)('linkStyleEditorContainer');
    container.style.top = `${panelRect.top}px`;
    container.style.left = `${panelRect.left - 300}px`;
    container.classList.remove('hideEditor');
}
/**
 * save the edited style and close the style editor.  Update the links
 * in the map and the legend to the current style
 */ function $3ee4e83c23551e65$var$linkEditSubmit() {
    $3ee4e83c23551e65$var$linkEditSave();
    $3ee4e83c23551e65$var$linkEditorHide();
    // apply updated style to all edges having that style
    const groupId = (0, $7hmfH.elem)('linkStyleEditorContainer').groupId;
    $3ee4e83c23551e65$export$8e108f36b8804828([
        groupId
    ], true);
    (0, $5bc812abaa5f432b$export$4b63d58d2685a993).set(groupId, {
        edge: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId]
    });
    $3ee4e83c23551e65$export$b8032ab161d91961();
    (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).redraw();
    (0, $5bc812abaa5f432b$export$e5fde6ebaea8ae1d)('edited a Link style');
}
function $3ee4e83c23551e65$export$8e108f36b8804828(groupIds, force) {
    const edgesToUpdate = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get({
        filter: (item)=>{
            return groupIds.includes(item.grp) && !item.isClusterEdge;
        }
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToUpdate.map((edge)=>{
        return force ? (0, $7hmfH.deepMerge)(edge, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[edge.grp]) : (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[edge.grp], edge);
    }));
}
function $3ee4e83c23551e65$export$e496289367e7ce52(groupId) {
    const sampleElements = Array.from(document.getElementsByClassName('sampleLink'));
    const sampleElement = sampleElements[groupId.match(/\d+/)?.[0]];
    if (!sampleElement) return;
    let edge = sampleElement.dataSet.get()[0];
    edge = (0, $7hmfH.deepMerge)(edge, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[groupId], {
        chosen: false,
        value: 10
    });
    edge.label = edge.groupLabel;
    sampleElement.dataSet.remove(edge.id);
    sampleElement.dataSet.update(edge);
    sampleElement.net.fit();
}
/**
 * Convert from style object properties to arrow menu selection
 * @param {Object} prop
 */ function $3ee4e83c23551e65$var$getArrows(prop) {
    let val = 'none';
    if (prop.to?.enabled && prop.to.type) val = prop.to.type;
    return val;
}
/*  ------------display the map legend (includes all styles with a group label that is neither blank or 'Sample') */ const $3ee4e83c23551e65$var$LEGENDHEIGHT = 31;
const $3ee4e83c23551e65$var$LEGENDWIDTH = 50 //minimum width of legend - may be increased to fit style names
;
const $3ee4e83c23551e65$var$MAXLEGENDWIDTH = 240;
function $3ee4e83c23551e65$export$9a9b59e08de24cef(warn = false) {
    $3ee4e83c23551e65$export$6bbbe775699090bc();
    const namedNodeStyles = Object.keys((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes).filter((key)=>(0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[key].groupLabel && (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[key].groupLabel !== 'Sample');
    const namedEdgeStyles = Object.keys((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges).filter((key)=>(0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[key].groupLabel && (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[key].groupLabel !== 'Sample');
    const nItems = namedNodeStyles.length + namedEdgeStyles.length;
    if (nItems === 0) {
        if (warn) (0, $7hmfH.alertMsg)('Nothing to include in the Legend - rename some styles first', 'warn');
        (0, $7hmfH.elem)('showLegendSwitch').checked = false;
        return;
    }
    let lWidth = $3ee4e83c23551e65$var$LEGENDWIDTH;
    namedNodeStyles.forEach((style)=>{
        const labelWidth = (0, $7hmfH.getTextWidth)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[style].groupLabel);
        if (labelWidth > lWidth) lWidth = labelWidth;
    });
    namedEdgeStyles.forEach((style)=>{
        const labelWidth = (0, $7hmfH.getTextWidth)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[style].groupLabel);
        if (labelWidth > lWidth) lWidth = labelWidth;
    });
    lWidth += 60 // width of icon and padding
    ;
    if (lWidth > $3ee4e83c23551e65$var$MAXLEGENDWIDTH) lWidth = $3ee4e83c23551e65$var$MAXLEGENDWIDTH;
    const legendBox = document.createElement('div');
    legendBox.className = 'legend';
    legendBox.id = 'legendBox';
    (0, $7hmfH.elem)('main').appendChild(legendBox);
    const title = document.createElement('p');
    title.id = 'Legend';
    title.classList.add('legendTitle', 'dragHandle');
    title.appendChild(document.createTextNode('Legend'));
    legendBox.appendChild(title);
    legendBox.style.height = `${$3ee4e83c23551e65$var$LEGENDHEIGHT * nItems + title.offsetHeight}px`;
    legendBox.style.width = `${lWidth}px`;
    const legendWrapper = document.createElement('div');
    legendWrapper.className = 'legendWrapper';
    legendBox.appendChild(legendWrapper);
    (0, $7hmfH.dragElement)(legendBox, title);
    for(let i = 0; i < namedNodeStyles.length; i++){
        const canvas = document.createElement('div');
        canvas.className = 'legendCanvas';
        legendWrapper.appendChild(canvas);
        const legendData = {
            nodes: new (0, $7AcYc.DataSet)(),
            edges: new (0, $7AcYc.DataSet)()
        };
        const legendNetwork = new (0, $8L2sr.Network)(canvas, legendData, {
            physics: {
                enabled: false
            },
            interaction: {
                zoomView: false,
                dragView: false
            }
        });
        const node = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[namedNodeStyles[i]]);
        node.id = i + 10000;
        node.shape === 'text' ? node.label = 'groupLabel' : node.label = '';
        node.fixed = true;
        node.chosen = false;
        node.margin = 10;
        node.x = 0;
        node.y = 0;
        node.widthConstraint = 10;
        node.heightConstraint = 10;
        node.font.size = 10;
        node.size = 10;
        legendData.nodes.update(node);
        legendNetwork.fit();
        const style = document.createElement('div');
        style.className = 'legendStyleName';
        style.textContent = node.groupLabel;
        style.style.width = `${lWidth - 60}px`;
        legendWrapper.appendChild(style);
    }
    for(let i = 0; i < namedEdgeStyles.length; i++){
        const canvas = document.createElement('div');
        canvas.className = 'legendCanvas';
        legendWrapper.appendChild(canvas);
        const legendData = {
            nodes: new (0, $7AcYc.DataSet)(),
            edges: new (0, $7AcYc.DataSet)()
        };
        const legendNetwork = new (0, $8L2sr.Network)(canvas, legendData, {
            physics: {
                enabled: false
            },
            interaction: {
                zoomView: false,
                dragView: false
            }
        });
        const edge = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[namedEdgeStyles[i]]);
        edge.label = '';
        edge.id = i + 10000;
        edge.from = i + 20000;
        edge.to = i + 30000;
        edge.smooth = {
            type: 'straightCross'
        };
        edge.chosen = false;
        const nodes = [
            {
                id: edge.from,
                size: 5,
                shape: 'dot',
                x: -20,
                y: 0,
                fixed: true,
                chosen: false
            },
            {
                id: edge.to,
                shape: 'dot',
                size: 5,
                x: 20,
                y: 0,
                fixed: true,
                chosen: false
            }
        ];
        legendData.nodes.update(nodes);
        legendData.edges.update(edge);
        legendNetwork.fit();
        const style = document.createElement('div');
        style.className = 'legendStyleName';
        style.textContent = edge.groupLabel;
        style.style.width = `${lWidth - 60}px`;
        legendWrapper.appendChild(style);
    }
}
function $3ee4e83c23551e65$export$6bbbe775699090bc() {
    const legendBox = (0, $7hmfH.elem)('legendBox');
    if (legendBox) legendBox.remove();
}
function $3ee4e83c23551e65$export$b8032ab161d91961() {
    if ((0, $7hmfH.elem)('showLegendSwitch').checked) {
        $3ee4e83c23551e65$export$9a9b59e08de24cef(false);
        (0, $7hmfH.clearStatusBar)();
    }
}


/********************************************************************************************* 

PRSM Participatory System Mapper 

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

This software is licenced under the PolyForm Noncommercial License 1.0.0

<https://polyformproject.org/licenses/noncommercial/1.0.0>

See the file LICENSE.md for details.

This code handles the dropdown menu of recent maps and projects.  
********************************************************************************************/ 
var $7hmfH = parcelRequire("7hmfH");

var $03c9b366059f6377$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($03c9b366059f6377$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $03c9b366059f6377$exports = g;
});


/** @type {HTMLElement} The top-level rooms/maps/projects dropdown panel. */ const $7f60c5bdd5f6f512$var$mainMenu = (0, $7hmfH.elem)('rooms-menu');
/** @type {HTMLElement} The flyout panel listing saved projects. */ const $7f60c5bdd5f6f512$var$projectsMenu = (0, $7hmfH.elem)('projects-menu');
/** @type {HTMLElement} The flyout panel listing maps within a project. */ const $7f60c5bdd5f6f512$var$projectMapsMenu = (0, $7hmfH.elem)('project-maps-menu');
/** @type {HTMLElement} The scrollable container inside the main menu. */ const $7f60c5bdd5f6f512$var$scrollBox = (0, $7hmfH.elem)('rm-scroll-box');
/** @type {HTMLElement} The modal overlay used when creating a new project. */ const $7f60c5bdd5f6f512$var$modalOverlay = (0, $7hmfH.elem)('rm-modal-overlay');
/** @type {HTMLInputElement} The text input element for the new-project name. */ const $7f60c5bdd5f6f512$var$projectNameInput = (0, $7hmfH.elem)('projectNameInput');
/** @type {Object.<string, Object>} Map of project UIDs to project data objects. */ let $7f60c5bdd5f6f512$var$projects = {};
/** @type {Object.<string, string>} Map of room identifiers to map display titles. */ let $7f60c5bdd5f6f512$var$maps = {};
/** @type {string|null} UID of the currently highlighted/active project, or null. */ let $7f60c5bdd5f6f512$var$activeProject = null;
/** @type {ReturnType<typeof setTimeout>} Timer used to delay closing the menus on mouse-leave. */ let $7f60c5bdd5f6f512$var$closeTimer;
/** Maximum number of recent map entries retained in localStorage. */ const $7f60c5bdd5f6f512$var$TITLELISTLEN = 50;
function $7f60c5bdd5f6f512$export$aebc5f60a7b91add(title) {
    const recents = JSON.parse(localStorage.getItem('recents')) || {};
    $7f60c5bdd5f6f512$var$projects = recents.projects || {};
    $7f60c5bdd5f6f512$var$maps = (0, $7hmfH.clean)(recents, {
        projects: true
    });
    $7f60c5bdd5f6f512$var$maps.new = '<b>New Map</b>';
    $7f60c5bdd5f6f512$var$projects.new = '<b>New Project</b>';
    // only store the map room if the map has a title
    if (title !== 'Untitled map') $7f60c5bdd5f6f512$var$storeMapRoom((0, $5bc812abaa5f432b$export$f9d3fff8c23da278), title);
    // save only the most recent entries
    $7f60c5bdd5f6f512$var$maps = Object.fromEntries(Object.entries($7f60c5bdd5f6f512$var$maps).slice(-$7f60c5bdd5f6f512$var$TITLELISTLEN));
    $7f60c5bdd5f6f512$var$storeList();
    $7f60c5bdd5f6f512$var$renderProjects();
    $7f60c5bdd5f6f512$var$renderMaps();
}
/**
 * Renders the flat list of recent maps into the #map-list-items container.
 * Each entry is a clickable div that navigates to that map's room.
 */ function $7f60c5bdd5f6f512$var$renderMaps() {
    const container = (0, $7hmfH.elem)('map-list-items');
    container.innerHTML = '';
    Object.entries($7f60c5bdd5f6f512$var$maps).reverse().forEach(([url, title])=>{
        if (url !== 'new') {
            const div = document.createElement('div');
            div.className = 'rm-item';
            div.dataset.room = url;
            div.innerHTML = `<span>${title}</span>`;
            div.onclick = ()=>{
                $7f60c5bdd5f6f512$var$changeRoom(div);
            };
            div.onmouseenter = ()=>{
                $7f60c5bdd5f6f512$var$projectsMenu.classList.remove('show');
                $7f60c5bdd5f6f512$var$projectMapsMenu.classList.remove('show');
                $7f60c5bdd5f6f512$var$activeProject = null;
            };
            container.appendChild(div);
        }
    });
}
/**
 * Renders the list of projects into the #project-list-items container.
 * Each project entry shows a flyout of maps belonging to it on hover,
 * and a "New Project" entry that opens the creation modal.
 */ function $7f60c5bdd5f6f512$var$renderProjects() {
    const container = (0, $7hmfH.elem)('project-list-items');
    container.innerHTML = '';
    Object.entries($7f60c5bdd5f6f512$var$projects).reverse().forEach(([projectUID, projectData])=>{
        const div = document.createElement('div');
        div.className = 'rm-item';
        div.dataset.project = projectData;
        if (projectUID === 'new') {
            div.innerHTML = `<b>New Project</b>`;
            div.onclick = ()=>{
                $7f60c5bdd5f6f512$var$closeAll();
                $7f60c5bdd5f6f512$var$modalOverlay.style.display = 'flex';
                $7f60c5bdd5f6f512$var$projectNameInput.value = '';
                $7f60c5bdd5f6f512$var$projectNameInput.focus();
            };
            div.onmouseenter = (e)=>{
                clearTimeout($7f60c5bdd5f6f512$var$closeTimer);
                $7f60c5bdd5f6f512$var$projectMapsMenu.classList.remove('show');
                $7f60c5bdd5f6f512$var$activeProject = null;
            };
            container.appendChild(div);
            return;
        }
        div.innerHTML = `<span>${projectData.name}</span><span class="arrow">\u{25B6}</span>`;
        div.onmouseenter = (e)=>{
            clearTimeout($7f60c5bdd5f6f512$var$closeTimer);
            $7f60c5bdd5f6f512$var$activeProject = projectUID;
            const rect = div.getBoundingClientRect();
            $7f60c5bdd5f6f512$var$renderProjectMaps(projectData);
            $7f60c5bdd5f6f512$var$projectMapsMenu.style.top = rect.top + 'px';
            $7f60c5bdd5f6f512$var$projectMapsMenu.style.left = rect.right - 4 + 'px';
            $7f60c5bdd5f6f512$var$projectMapsMenu.classList.add('show');
        };
        container.appendChild(div);
    });
}
/**
 * Populates the project-maps flyout panel with the maps belonging to a project,
 * plus "Add this map" and "Delete this project" action items.
 * @param {Object.<string, string>} proj - Project data object where each key is a
 *   room URL (or 'name') and each value is the map title (or the project name).
 */ function $7f60c5bdd5f6f512$var$renderProjectMaps(proj) {
    const list = (0, $7hmfH.elem)('project-maps-list');
    list.innerHTML = '';
    Object.entries(proj).forEach(([url, title])=>{
        if (url !== 'name') {
            const div = document.createElement('div');
            div.className = 'rm-item';
            div.dataset.room = url;
            div.innerHTML = `<span>${title}</span>`;
            div.onclick = ()=>{
                $7f60c5bdd5f6f512$var$changeRoom(div);
            };
            list.appendChild(div);
        }
    });
    const addBtn = document.createElement('div');
    addBtn.className = 'rm-item';
    addBtn.style.color = (0, $7hmfH.getCSSVariable)('--tertiary-color');
    addBtn.textContent = 'Add this map to the project';
    addBtn.onclick = ()=>{
        $7f60c5bdd5f6f512$var$addMapToProject();
        $7f60c5bdd5f6f512$var$closeAll();
    };
    list.appendChild(addBtn);
    const delBtn = document.createElement('div');
    delBtn.className = 'rm-item';
    delBtn.style.color = (0, $7hmfH.getCSSVariable)('--alert-color');
    delBtn.textContent = 'Delete this project';
    delBtn.onclick = $7f60c5bdd5f6f512$var$deleteActiveProject;
    list.appendChild(delBtn);
}
/**
 * Stores a room/title pair in the maps object. If a map with the same title
 * already exists but the room is different,the current date/time is appended to make the title unique.
 * @param {string} room - The room identifier used as the URL search parameter.
 * @param {string} title - The display title for the map.
 */ function $7f60c5bdd5f6f512$var$storeMapRoom(room, title) {
    if ($7f60c5bdd5f6f512$var$maps[room] === title) return;
    if (Object.values($7f60c5bdd5f6f512$var$maps).includes(title.replace(/\w*(\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}:\d{2})/g, ''))) title += ` (${new Date().toLocaleString()})`;
    $7f60c5bdd5f6f512$var$maps[room] = title;
}
/**
 * Adds the currently open map to the active project.
 * Displays a warning if no project is active, the map is already in the
 * project, or the map still has the default 'Untitled map' title.
 */ function $7f60c5bdd5f6f512$var$addMapToProject() {
    if (!$7f60c5bdd5f6f512$var$activeProject) return (0, $7hmfH.alertMsg)('No project selected', 'error');
    const projectData = $7f60c5bdd5f6f512$var$projects[$7f60c5bdd5f6f512$var$activeProject];
    if ($7f60c5bdd5f6f512$var$projects[$7f60c5bdd5f6f512$var$activeProject][0, $5bc812abaa5f432b$export$f9d3fff8c23da278]) return (0, $7hmfH.alertMsg)('This map is already in the project', 'warn');
    const title = (0, $7hmfH.elem)('maptitle').innerHTML.trim();
    if (title === 'Untitled map') {
        (0, $7hmfH.alertMsg)('Please give your map a title before adding it to a project', 'warn');
        return;
    }
    projectData[0, $5bc812abaa5f432b$export$f9d3fff8c23da278] = title;
    $7f60c5bdd5f6f512$var$storeList();
    (0, $7hmfH.alertMsg)(`Added ${title} to the ${projectData.name} project`, 'info');
}
/**
 * Prompts the user to confirm deletion of the active project, then removes
 * it from storage, re-renders the projects menu, and closes all panels.
 */ function $7f60c5bdd5f6f512$var$deleteActiveProject() {
    if (!$7f60c5bdd5f6f512$var$activeProject) return;
    const projectName = $7f60c5bdd5f6f512$var$projects[$7f60c5bdd5f6f512$var$activeProject].name;
    if (!confirm(`Are you sure you want to delete the project "${projectName}"?`)) return;
    delete $7f60c5bdd5f6f512$var$projects[$7f60c5bdd5f6f512$var$activeProject];
    $7f60c5bdd5f6f512$var$storeList();
    (0, $7hmfH.alertMsg)(`Project ${projectName} deleted`, 'info');
    $7f60c5bdd5f6f512$var$activeProject = null;
    $7f60c5bdd5f6f512$var$renderProjects();
    $7f60c5bdd5f6f512$var$closeAll();
}
function $7f60c5bdd5f6f512$export$fb9d89ce24b70743(e) {
    e.stopPropagation();
    $7f60c5bdd5f6f512$var$scrollBox.style.maxHeight = (0, $7hmfH.elem)('net-pane').clientHeight - 20 + 'px';
    $7f60c5bdd5f6f512$var$mainMenu.classList.toggle('show');
}
/**
 * Persists the current projects and maps objects to localStorage
 * under the 'recents' key as a single serialised JSON object.
 */ function $7f60c5bdd5f6f512$var$storeList() {
    localStorage.setItem('recents', JSON.stringify({
        projects: {
            ...$7f60c5bdd5f6f512$var$projects
        },
        ...$7f60c5bdd5f6f512$var$maps
    }));
}
/**
 * User has clicked one of the previous map titles - confirm and change to the web page for that room
 * @param {HTMLDivElement} div The div element that was clicked, containing the room data attribute
 */ function $7f60c5bdd5f6f512$var$changeRoom(div) {
    if ((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.length > 0) {
        if (!confirm('Are you sure you want to move to a different map?')) return;
    }
    $7f60c5bdd5f6f512$var$closeAll();
    const url = new URL(document.location);
    url.search = div.dataset.room !== 'new' ? `?room=${div.dataset.room}` : '';
    window.location.replace(url);
}
// Keyboard Listeners
window.addEventListener('keydown', (e)=>{
    if (document.activeElement === $7f60c5bdd5f6f512$var$projectNameInput) {
        if (e.key === 'Enter') (0, $7hmfH.elem)('rm-modal-ok').click();
        if (e.key === 'Escape') (0, $7hmfH.elem)('rm-modal-cancel').click();
        return;
    }
    if (e.key === 'Delete' && $7f60c5bdd5f6f512$var$projectMapsMenu.classList.contains('show')) $7f60c5bdd5f6f512$var$deleteActiveProject();
});
const $7f60c5bdd5f6f512$var$observer = new MutationObserver(()=>{
    if ($7f60c5bdd5f6f512$var$mainMenu.classList.contains('show')) $7f60c5bdd5f6f512$var$scrollBox.scrollTop = 0;
});
$7f60c5bdd5f6f512$var$observer.observe($7f60c5bdd5f6f512$var$mainMenu, {
    attributes: true,
    attributeFilter: [
        'class'
    ]
});
(0, $7hmfH.elem)('rm-modal-cancel').onclick = ()=>$7f60c5bdd5f6f512$var$modalOverlay.style.display = 'none';
$7f60c5bdd5f6f512$var$modalOverlay.addEventListener('click', (event)=>{
    if (event.target === event.currentTarget) $7f60c5bdd5f6f512$var$modalOverlay.style.display = 'none';
});
(0, $7hmfH.elem)('rm-modal-ok').onclick = ()=>{
    const name = $7f60c5bdd5f6f512$var$projectNameInput.value.trim();
    if (name) {
        $7f60c5bdd5f6f512$var$projects[(0, $7hmfH.uuidv4)()] = {
            name: name
        };
        $7f60c5bdd5f6f512$var$renderProjects();
        (0, $7hmfH.alertMsg)(`New project created: ${name}`, 'info');
        $7f60c5bdd5f6f512$var$storeList();
    }
    $7f60c5bdd5f6f512$var$modalOverlay.style.display = 'none';
};
(0, $7hmfH.elem)('projectsTrigger').onmouseenter = (e)=>{
    clearTimeout($7f60c5bdd5f6f512$var$closeTimer);
    const rect = e.currentTarget.getBoundingClientRect();
    $7f60c5bdd5f6f512$var$projectsMenu.style.top = rect.top + 'px';
    $7f60c5bdd5f6f512$var$projectsMenu.style.left = rect.right - 4 + 'px';
    $7f60c5bdd5f6f512$var$projectsMenu.classList.add('show');
    $7f60c5bdd5f6f512$var$projectMapsMenu.classList.remove('show');
};
(0, $7hmfH.elem)('newMapTrigger').onclick = (e)=>{
    e.stopPropagation();
    $7f60c5bdd5f6f512$var$changeRoom(e.currentTarget);
};
(0, $7hmfH.elem)('saveListToFileTrigger').onclick = (e)=>{
    e.stopPropagation();
    const str = JSON.stringify({
        info: {
            type: 'PRSM map menu list',
            version: '1.0',
            date: new Date().toLocaleString()
        },
        projects: {
            ...$7f60c5bdd5f6f512$var$projects
        },
        ...$7f60c5bdd5f6f512$var$maps
    }, null, '\t');
    const blob = new Blob([
        str
    ], {
        type: 'text/plain;charset=utf-8'
    });
    (0, $03c9b366059f6377$exports.saveAs)(blob, 'PRSMMapList.prsml', {
        autoBom: true
    });
    (0, $7hmfH.statusMsg)('Map list saved to file.  To read it back in, drag and drop it over the map', 'info');
};
function $7f60c5bdd5f6f512$export$59a30cd752fdf847(str) {
    if ($7f60c5bdd5f6f512$var$badMapListFormat(str)) {
        (0, $7hmfH.alertMsg)('Invalid map list format: ' + $7f60c5bdd5f6f512$var$badMapListFormat(str), 'error');
        return;
    }
    try {
        const obj = JSON.parse(str);
        if (obj.projects && Object.keys(obj).length > 1) {
            $7f60c5bdd5f6f512$var$projects = {
                ...$7f60c5bdd5f6f512$var$projects,
                ...obj.projects
            };
            $7f60c5bdd5f6f512$var$maps = {
                ...$7f60c5bdd5f6f512$var$maps,
                ...(0, $7hmfH.clean)(obj, {
                    projects: true,
                    info: true
                })
            };
            $7f60c5bdd5f6f512$var$storeList();
            $7f60c5bdd5f6f512$var$renderProjects();
            $7f60c5bdd5f6f512$var$renderMaps();
            (0, $7hmfH.alertMsg)('Map list loaded successfully', 'info');
        } else (0, $7hmfH.alertMsg)('Invalid map list file', 'error');
    } catch (e) {
        (0, $7hmfH.alertMsg)('Error loading map list: ' + e.message, 'error');
    }
}
/**
 * Validates a JSON string against the PRSM map list format.
 * @param {string} jsonStr - The JSON string to validate.
 * @return {boolean|string} Returns false if valid, or a string describing the error.
 */ function $7f60c5bdd5f6f512$var$badMapListFormat(jsonStr) {
    let data;
    // 1. Check for valid JSON syntax
    try {
        data = JSON.parse(jsonStr);
    } catch (e) {
        return 'Invalid JSON: The string could not be parsed.';
    }
    // 2. Root must be a non-null object
    if (typeof data !== 'object' || data === null || Array.isArray(data)) return 'Format Error: Root must be a JSON object.';
    const tripleDashRegex = /^[a-zA-Z]{3}-[a-zA-Z]{3}-[a-zA-Z]{3}-[a-zA-Z]{3}$/;
    const uuid4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    // 3. Check for required 'projects' property
    if (!Object.hasOwn(data, 'projects')) return "Missing Property: Required 'projects' property is missing.";
    // 4. Validate Root level properties
    for(const key in data){
        if (key === 'projects') {
            if (typeof data.projects !== 'object' || data.projects === null || Array.isArray(data.projects)) return "Type Error: 'projects' must be an object.";
            continue;
        }
        if (key === 'info') {
            if (typeof data.info !== 'object' || data.info === null) return "Type Error: The 'info' property must be an object.";
            continue;
        }
        if (key === 'new') {
            if (typeof data.new !== 'string') return "Type Error: The root 'new' property must be a string.";
            continue;
        }
        if (!tripleDashRegex.test(key)) return `Validation Error: Unexpected root property name "${key}".`;
        if (typeof data[key] !== 'string') return `Type Error: Property "${key}" must have a string value.`;
    }
    // 5. Validate the 'projects' object contents
    const projects = data.projects;
    if (!Object.hasOwn(projects, 'new')) return "Missing Property: 'projects.new' is required.";
    if (typeof projects.new !== 'string') return "Type Error: 'projects.new' must be a string.";
    for(const projKey in projects){
        if (projKey === 'new') continue;
        if (!uuid4Regex.test(projKey)) return `Property Error: Key "${projKey}" in projects is not a valid UUID4 format.`;
        const projectEntry = projects[projKey];
        if (typeof projectEntry !== 'object' || projectEntry === null) return `Type Error: Project "${projKey}" must be an object.`;
        if (!Object.hasOwn(projectEntry, 'name')) return `Missing Property: Project "${projKey}" is missing the required "name" property.`;
        if (typeof projectEntry.name !== 'string') return `Type Error: The "name" property in project "${projKey}" must be a string.`;
        for(const subKey in projectEntry){
            if (subKey === 'name') continue;
            if (!tripleDashRegex.test(subKey)) return `Validation Error: Unexpected property "${subKey}" in project "${projKey}".`;
            if (typeof projectEntry[subKey] !== 'string') return `Type Error: Property "${subKey}" in project "${projKey}" must be a string.`;
        }
    }
    return false;
}
[
    $7f60c5bdd5f6f512$var$mainMenu,
    $7f60c5bdd5f6f512$var$projectsMenu,
    $7f60c5bdd5f6f512$var$projectMapsMenu
].forEach((panel)=>{
    panel.onmouseenter = ()=>clearTimeout($7f60c5bdd5f6f512$var$closeTimer);
    panel.onmouseleave = (e)=>{
        $7f60c5bdd5f6f512$var$closeTimer = setTimeout(()=>{
            const dest = e.relatedTarget;
            if (![
                $7f60c5bdd5f6f512$var$mainMenu,
                $7f60c5bdd5f6f512$var$projectsMenu,
                $7f60c5bdd5f6f512$var$projectMapsMenu
            ].some((p)=>p.contains(dest))) $7f60c5bdd5f6f512$var$closeAll();
        }, 150);
    };
});
/**
 * Hides all three menu panels (main menu, projects flyout, project-maps flyout)
 * by removing the 'show' CSS class from each.
 */ function $7f60c5bdd5f6f512$var$closeAll() {
    [
        $7f60c5bdd5f6f512$var$mainMenu,
        $7f60c5bdd5f6f512$var$projectsMenu,
        $7f60c5bdd5f6f512$var$projectMapsMenu
    ].forEach((m)=>m.classList.remove('show'));
}
window.onclick = (e)=>{
    if (e.target.id !== 'mapsTrigger') $7f60c5bdd5f6f512$var$closeAll();
};



var $lvw85 = parcelRequire("lvw85");
/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $50e22642e0e09299$var$emptyOptions = {};
function $50e22642e0e09299$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $50e22642e0e09299$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $50e22642e0e09299$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $50e22642e0e09299$var$one(value, includeImageAlt, includeHtml) {
    if ($50e22642e0e09299$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $50e22642e0e09299$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $50e22642e0e09299$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $50e22642e0e09299$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $50e22642e0e09299$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $50e22642e0e09299$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $1949e9d7020937a5$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: '&',
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: '`',
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: '>',
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: '^',
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: '<',
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: '\n',
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: '\t',
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: '_',
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: '|',
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: '&',
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: '*',
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: '\\',
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ':',
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ',',
    commat: '@',
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: '$',
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: '=',
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: '!',
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: 'fj',
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: '`',
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: '>',
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: '{',
    lbrack: '[',
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: '{',
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: '_',
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: '(',
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: '[',
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: '<',
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: '*',
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: '#',
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: '%',
    period: '.',
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: '+',
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: '?',
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: '}',
    rbrack: ']',
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: '}',
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ')',
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: ']',
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ';',
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: '/',
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: '|',
    vert: '|',
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


// To do: next major: use `Object.hasOwn`.
const $ad9664049664d211$var$own = {}.hasOwnProperty;
function $ad9664049664d211$export$289b6a6320f709b4(value) {
    return $ad9664049664d211$var$own.call((0, $1949e9d7020937a5$export$ec810d1aafce79a7), value) ? (0, $1949e9d7020937a5$export$ec810d1aafce79a7)[value] : false;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $eebec21212554d21$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $eebec21212554d21$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $eebec21212554d21$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $fd3f8b6b609326e9$var$hasOwnProperty = {}.hasOwnProperty;
function $fd3f8b6b609326e9$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$fd3f8b6b609326e9$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fd3f8b6b609326e9$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $fd3f8b6b609326e9$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$fd3f8b6b609326e9$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $fd3f8b6b609326e9$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fd3f8b6b609326e9$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $eebec21212554d21$export$869882364835d202)(existing, 0, 0, before);
}
function $fd3f8b6b609326e9$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$fd3f8b6b609326e9$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fd3f8b6b609326e9$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $fd3f8b6b609326e9$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $95a72c1cf6dba6e1$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $9a05bd0f391798a8$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $9a05bd0f391798a8$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $9a05bd0f391798a8$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $691c6bd14e69df31$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $acfa9f9317a70f27$export$d65d6b62c24d5436 = $acfa9f9317a70f27$var$regexCheck(/[A-Za-z]/);
const $acfa9f9317a70f27$export$75c76db11865a9f4 = $acfa9f9317a70f27$var$regexCheck(/[\dA-Za-z]/);
const $acfa9f9317a70f27$export$4397998b34fe597d = $acfa9f9317a70f27$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $acfa9f9317a70f27$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $acfa9f9317a70f27$export$ca8b5b1a6c320e6e = $acfa9f9317a70f27$var$regexCheck(/\d/);
const $acfa9f9317a70f27$export$eca2752363989806 = $acfa9f9317a70f27$var$regexCheck(/[\dA-Fa-f]/);
const $acfa9f9317a70f27$export$35794a7d1db99380 = $acfa9f9317a70f27$var$regexCheck(/[!-/:-@[-`{-~]/);
function $acfa9f9317a70f27$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $acfa9f9317a70f27$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $acfa9f9317a70f27$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $acfa9f9317a70f27$export$aa04114dd888a7a0 = $acfa9f9317a70f27$var$regexCheck(/\p{P}|\p{S}/u);
const $acfa9f9317a70f27$export$a0ff789c034ffdf4 = $acfa9f9317a70f27$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $acfa9f9317a70f27$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $5137b2f6a3a4800e$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $9a05bd0f391798a8$export$c564cdbbe6da493)($5137b2f6a3a4800e$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $5137b2f6a3a4800e$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $02b8ef7b0a1d81fc$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $02b8ef7b0a1d81fc$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $02b8ef7b0a1d81fc$var$protocolSource = /^https?$/i;
function $02b8ef7b0a1d81fc$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $fd3f8b6b609326e9$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $eebec21212554d21$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $eebec21212554d21$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $eebec21212554d21$export$4cbf152802aa238)(head, body);
        head = (0, $eebec21212554d21$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($02b8ef7b0a1d81fc$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $9a05bd0f391798a8$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $691c6bd14e69df31$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $02b8ef7b0a1d81fc$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $02b8ef7b0a1d81fc$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$02b8ef7b0a1d81fc$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $95a72c1cf6dba6e1$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $ad9664049664d211$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $02b8ef7b0a1d81fc$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $4a351b3b95a4a526$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $91e9190d51f64368$export$a7db06668cad9adb = {
    tokenize: $91e9190d51f64368$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $91e9190d51f64368$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $9278fe981d6f9a67$export$5a7bfc01df82fcd1 = {
    tokenize: $9278fe981d6f9a67$var$initializeDocument
};
/** @type {Construct} */ const $9278fe981d6f9a67$var$containerConstruct = {
    tokenize: $9278fe981d6f9a67$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $9278fe981d6f9a67$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $eebec21212554d21$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($9278fe981d6f9a67$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($9278fe981d6f9a67$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $eebec21212554d21$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $9278fe981d6f9a67$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d3123eef238d6d2f$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $d3123eef238d6d2f$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d3123eef238d6d2f$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $58abc10e58911df6$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $58abc10e58911df6$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $58abc10e58911df6$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $58abc10e58911df6$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $58abc10e58911df6$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $58abc10e58911df6$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $58abc10e58911df6$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $245cf07b611d16ef$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $58abc10e58911df6$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $245cf07b611d16ef$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $eebec21212554d21$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $245cf07b611d16ef$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $b58b7df659b053b7$export$a7db06668cad9adb = {
    resolve: $b58b7df659b053b7$var$resolveContent,
    tokenize: $b58b7df659b053b7$var$tokenizeContent
};
/** @type {Construct} */ const $b58b7df659b053b7$var$continuationConstruct = {
    partial: true,
    tokenize: $b58b7df659b053b7$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $b58b7df659b053b7$var$resolveContent(events) {
    (0, $245cf07b611d16ef$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b58b7df659b053b7$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return effects.check($b58b7df659b053b7$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b58b7df659b053b7$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $43db3a95bb1a074b$export$ccc7b0636abaffc3 = {
    tokenize: $43db3a95bb1a074b$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $43db3a95bb1a074b$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $d3123eef238d6d2f$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $b58b7df659b053b7$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $ba51a1baaba5cb42$export$50397835cbfdbc24 = {
    resolveAll: $ba51a1baaba5cb42$var$createResolver()
};
const $ba51a1baaba5cb42$export$22b082955e083ec3 = $ba51a1baaba5cb42$var$initializeFactory('string');
const $ba51a1baaba5cb42$export$6f093cfa640b7166 = $ba51a1baaba5cb42$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $ba51a1baaba5cb42$var$initializeFactory(field) {
    return {
        resolveAll: $ba51a1baaba5cb42$var$createResolver(field === 'text' ? $ba51a1baaba5cb42$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $ba51a1baaba5cb42$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $ba51a1baaba5cb42$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $46ef35cd786b7b83$exports = {};

$parcel$export($46ef35cd786b7b83$exports, "document", () => $46ef35cd786b7b83$export$5a7bfc01df82fcd1);
$parcel$export($46ef35cd786b7b83$exports, "contentInitial", () => $46ef35cd786b7b83$export$5a2181fb44b58173);
$parcel$export($46ef35cd786b7b83$exports, "flowInitial", () => $46ef35cd786b7b83$export$cf8bead395eff824);
$parcel$export($46ef35cd786b7b83$exports, "flow", () => $46ef35cd786b7b83$export$ccc7b0636abaffc3);
$parcel$export($46ef35cd786b7b83$exports, "string", () => $46ef35cd786b7b83$export$22b082955e083ec3);
$parcel$export($46ef35cd786b7b83$exports, "text", () => $46ef35cd786b7b83$export$6f093cfa640b7166);
$parcel$export($46ef35cd786b7b83$exports, "insideSpan", () => $46ef35cd786b7b83$export$d44f260a3f9b69f5);
$parcel$export($46ef35cd786b7b83$exports, "attentionMarkers", () => $46ef35cd786b7b83$export$b9c0b60d74426aea);
$parcel$export($46ef35cd786b7b83$exports, "disable", () => $46ef35cd786b7b83$export$e20fbacbb41798b);
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $f4fc34744abcdc3d$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $acfa9f9317a70f27$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $60c7f2760f76efa0$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $283759bc453108a4$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $283759bc453108a4$var$resolveAllAttention,
    tokenize: $283759bc453108a4$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $283759bc453108a4$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $283759bc453108a4$var$movePoint(start, -use);
            $283759bc453108a4$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $eebec21212554d21$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $eebec21212554d21$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $eebec21212554d21$export$4cbf152802aa238)(nextEvents, (0, $60c7f2760f76efa0$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $eebec21212554d21$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $eebec21212554d21$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $eebec21212554d21$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $283759bc453108a4$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $283759bc453108a4$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $7c3ead051bcf5e65$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $7c3ead051bcf5e65$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7c3ead051bcf5e65$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $acfa9f9317a70f27$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $acfa9f9317a70f27$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $ee24461665fd0146$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $ee24461665fd0146$var$tokenizeBlockQuoteContinuation
    },
    exit: $ee24461665fd0146$var$exit,
    name: 'blockQuote',
    tokenize: $ee24461665fd0146$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ee24461665fd0146$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ee24461665fd0146$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($ee24461665fd0146$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $ee24461665fd0146$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $f29bde8525202615$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $f29bde8525202615$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f29bde8525202615$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $acfa9f9317a70f27$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $73c9edeec3c4cb5e$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $73c9edeec3c4cb5e$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $73c9edeec3c4cb5e$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $acfa9f9317a70f27$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $acfa9f9317a70f27$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $acfa9f9317a70f27$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $acfa9f9317a70f27$export$75c76db11865a9f4) && !(0, $ad9664049664d211$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $f6e0f42d2a2ee52c$var$nonLazyContinuation = {
    partial: true,
    tokenize: $f6e0f42d2a2ee52c$var$tokenizeNonLazyContinuation
};
const $f6e0f42d2a2ee52c$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $f6e0f42d2a2ee52c$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f6e0f42d2a2ee52c$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($f6e0f42d2a2ee52c$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return effects.check($f6e0f42d2a2ee52c$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f6e0f42d2a2ee52c$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $25d8a32dd627981d$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $25d8a32dd627981d$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $25d8a32dd627981d$var$furtherStart = {
    partial: true,
    tokenize: $25d8a32dd627981d$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $25d8a32dd627981d$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return effects.attempt($25d8a32dd627981d$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $25d8a32dd627981d$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $bf9ce054ebc00b96$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $bf9ce054ebc00b96$var$previous,
    resolve: $bf9ce054ebc00b96$var$resolveCodeText,
    tokenize: $bf9ce054ebc00b96$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $bf9ce054ebc00b96$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $bf9ce054ebc00b96$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bf9ce054ebc00b96$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $f7b63b6621dd2577$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $acfa9f9317a70f27$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $acfa9f9317a70f27$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $668371159318acfe$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $00329dd0262d70f4$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $4fca87a38dd06ed6$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $7bef285675c7b6c9$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $7bef285675c7b6c9$var$tokenizeDefinition
};
/** @type {Construct} */ const $7bef285675c7b6c9$var$titleBefore = {
    partial: true,
    tokenize: $7bef285675c7b6c9$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7bef285675c7b6c9$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $668371159318acfe$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) ? (0, $4fca87a38dd06ed6$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $f7b63b6621dd2577$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($7bef285675c7b6c9$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7bef285675c7b6c9$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) ? (0, $4fca87a38dd06ed6$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $00329dd0262d70f4$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $9a38d2f107653173$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $9a38d2f107653173$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9a38d2f107653173$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $9b7fa99043af1dc8$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $9b7fa99043af1dc8$var$resolveHeadingAtx,
    tokenize: $9b7fa99043af1dc8$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $9b7fa99043af1dc8$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $eebec21212554d21$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9b7fa99043af1dc8$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $36589f3d517d87e3$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $36589f3d517d87e3$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $aba88229c2d0388f$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $aba88229c2d0388f$var$resolveToHtmlFlow,
    tokenize: $aba88229c2d0388f$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $aba88229c2d0388f$var$blankLineBefore = {
    partial: true,
    tokenize: $aba88229c2d0388f$var$tokenizeBlankLineBefore
};
const $aba88229c2d0388f$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $aba88229c2d0388f$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $aba88229c2d0388f$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $aba88229c2d0388f$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $36589f3d517d87e3$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $36589f3d517d87e3$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($aba88229c2d0388f$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($aba88229c2d0388f$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $36589f3d517d87e3$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $aba88229c2d0388f$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $aba88229c2d0388f$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $d3123eef238d6d2f$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $91dcb7eaac488395$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $91dcb7eaac488395$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $91dcb7eaac488395$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $029fd21c44dd9e6c$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $029fd21c44dd9e6c$var$resolveAllLabelEnd,
    resolveTo: $029fd21c44dd9e6c$var$resolveToLabelEnd,
    tokenize: $029fd21c44dd9e6c$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $029fd21c44dd9e6c$var$resourceConstruct = {
    tokenize: $029fd21c44dd9e6c$var$tokenizeResource
};
/** @type {Construct} */ const $029fd21c44dd9e6c$var$referenceFullConstruct = {
    tokenize: $029fd21c44dd9e6c$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $029fd21c44dd9e6c$var$referenceCollapsedConstruct = {
    tokenize: $029fd21c44dd9e6c$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $029fd21c44dd9e6c$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $eebec21212554d21$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $029fd21c44dd9e6c$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, (0, $60c7f2760f76efa0$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $eebec21212554d21$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $eebec21212554d21$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $029fd21c44dd9e6c$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($029fd21c44dd9e6c$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($029fd21c44dd9e6c$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($029fd21c44dd9e6c$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $029fd21c44dd9e6c$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) ? (0, $4fca87a38dd06ed6$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $f7b63b6621dd2577$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) ? (0, $4fca87a38dd06ed6$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $00329dd0262d70f4$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) ? (0, $4fca87a38dd06ed6$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $029fd21c44dd9e6c$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $668371159318acfe$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $029fd21c44dd9e6c$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $617990d5d194b66b$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $029fd21c44dd9e6c$export$470a5dafbbf62654).resolveAll,
    tokenize: $617990d5d194b66b$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $617990d5d194b66b$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $6b13d4b2c64dee7a$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $029fd21c44dd9e6c$export$470a5dafbbf62654).resolveAll,
    tokenize: $6b13d4b2c64dee7a$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6b13d4b2c64dee7a$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $f97b6be1a09afbe1$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $f97b6be1a09afbe1$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f97b6be1a09afbe1$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $91c897e719faa101$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $91c897e719faa101$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $91c897e719faa101$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $89e04b792f4b94b5$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $89e04b792f4b94b5$var$tokenizeListContinuation
    },
    exit: $89e04b792f4b94b5$var$tokenizeListEnd,
    name: 'list',
    tokenize: $89e04b792f4b94b5$var$tokenizeListStart
};
/** @type {Construct} */ const $89e04b792f4b94b5$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $89e04b792f4b94b5$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $89e04b792f4b94b5$var$indentConstruct = {
    partial: true,
    tokenize: $89e04b792f4b94b5$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $89e04b792f4b94b5$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $acfa9f9317a70f27$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $91c897e719faa101$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $acfa9f9317a70f27$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $d3123eef238d6d2f$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($89e04b792f4b94b5$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $89e04b792f4b94b5$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $d3123eef238d6d2f$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($89e04b792f4b94b5$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, effects.attempt($89e04b792f4b94b5$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $89e04b792f4b94b5$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $89e04b792f4b94b5$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $89e04b792f4b94b5$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $9344ec8187b015d4$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $9344ec8187b015d4$var$resolveToSetextUnderline,
    tokenize: $9344ec8187b015d4$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $9344ec8187b015d4$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9344ec8187b015d4$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code) ? (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $46ef35cd786b7b83$export$5a7bfc01df82fcd1 = {
    [42]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [43]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [45]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [48]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [49]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [50]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [51]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [52]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [53]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [54]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [55]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [56]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [57]: (0, $89e04b792f4b94b5$export$8837f4fc672e936d),
    [62]: (0, $ee24461665fd0146$export$200dcd0a5903c968)
};
const $46ef35cd786b7b83$export$5a2181fb44b58173 = {
    [91]: (0, $7bef285675c7b6c9$export$69f215ed977cdb73)
};
const $46ef35cd786b7b83$export$cf8bead395eff824 = {
    [-2]: (0, $25d8a32dd627981d$export$47910b7ab28d1853),
    [-1]: (0, $25d8a32dd627981d$export$47910b7ab28d1853),
    [32]: (0, $25d8a32dd627981d$export$47910b7ab28d1853)
};
const $46ef35cd786b7b83$export$ccc7b0636abaffc3 = {
    [35]: (0, $9b7fa99043af1dc8$export$3871e9deb360695c),
    [42]: (0, $91c897e719faa101$export$ba7b13e047416c03),
    [45]: [
        (0, $9344ec8187b015d4$export$e104e2de391dfde9),
        (0, $91c897e719faa101$export$ba7b13e047416c03)
    ],
    [60]: (0, $aba88229c2d0388f$export$476ac411cb7d0d8f),
    [61]: (0, $9344ec8187b015d4$export$e104e2de391dfde9),
    [95]: (0, $91c897e719faa101$export$ba7b13e047416c03),
    [96]: (0, $f6e0f42d2a2ee52c$export$c23e4921f8d87e7c),
    [126]: (0, $f6e0f42d2a2ee52c$export$c23e4921f8d87e7c)
};
const $46ef35cd786b7b83$export$22b082955e083ec3 = {
    [38]: (0, $73c9edeec3c4cb5e$export$e31905600aaf3d8e),
    [92]: (0, $f29bde8525202615$export$2005478564e78d96)
};
const $46ef35cd786b7b83$export$6f093cfa640b7166 = {
    [-5]: (0, $f97b6be1a09afbe1$export$8e62e0ad51c97b2),
    [-4]: (0, $f97b6be1a09afbe1$export$8e62e0ad51c97b2),
    [-3]: (0, $f97b6be1a09afbe1$export$8e62e0ad51c97b2),
    [33]: (0, $617990d5d194b66b$export$3d754936e25aa5f5),
    [38]: (0, $73c9edeec3c4cb5e$export$e31905600aaf3d8e),
    [42]: (0, $283759bc453108a4$export$45b92471da762af7),
    [60]: [
        (0, $7c3ead051bcf5e65$export$17ddf85e4c916ad6),
        (0, $91dcb7eaac488395$export$398af27f284914fe)
    ],
    [91]: (0, $6b13d4b2c64dee7a$export$5c0cee0701a3b584),
    [92]: [
        (0, $9a38d2f107653173$export$86c573ab9e06f418),
        (0, $f29bde8525202615$export$2005478564e78d96)
    ],
    [93]: (0, $029fd21c44dd9e6c$export$470a5dafbbf62654),
    [95]: (0, $283759bc453108a4$export$45b92471da762af7),
    [96]: (0, $bf9ce054ebc00b96$export$d24f93e715f9df88)
};
const $46ef35cd786b7b83$export$d44f260a3f9b69f5 = {
    null: [
        (0, $283759bc453108a4$export$45b92471da762af7),
        (0, $ba51a1baaba5cb42$export$50397835cbfdbc24)
    ]
};
const $46ef35cd786b7b83$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $46ef35cd786b7b83$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $deb19dfdf43f6d9a$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $eebec21212554d21$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $60c7f2760f76efa0$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $deb19dfdf43f6d9a$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $deb19dfdf43f6d9a$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $eebec21212554d21$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $deb19dfdf43f6d9a$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $deb19dfdf43f6d9a$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $7314bc288e1eae10$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $fd3f8b6b609326e9$export$86a865d89ef3c690)([
        $46ef35cd786b7b83$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $91e9190d51f64368$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $9278fe981d6f9a67$export$5a7bfc01df82fcd1)),
        flow: create((0, $43db3a95bb1a074b$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $ba51a1baaba5cb42$export$22b082955e083ec3)),
        text: create((0, $ba51a1baaba5cb42$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $deb19dfdf43f6d9a$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $9726bbaba10693ae$export$bd0e6e1378a871d7(events) {
    while(!(0, $245cf07b611d16ef$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $3a4670755ce1503f$var$search = /[\0\t\n\r]/g;
function $3a4670755ce1503f$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $3a4670755ce1503f$var$search.lastIndex = startPosition;
            match = $3a4670755ce1503f$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $56766f44a8a9d4d3$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $02b8ef7b0a1d81fc$export$ef7acd7185315e22)(options)((0, $9726bbaba10693ae$export$bd0e6e1378a871d7)((0, $7314bc288e1eae10$export$98e6a39c04603d36)(options).document().write((0, $3a4670755ce1503f$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $c7907535f4b9aef3$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $c7907535f4b9aef3$export$a0fb664af7d0cc44(value) {
    return value.replace($c7907535f4b9aef3$var$characterEscapeOrReference, $c7907535f4b9aef3$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $c7907535f4b9aef3$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $95a72c1cf6dba6e1$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $ad9664049664d211$export$289b6a6320f709b4)($2) || $0;
}




/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $f541df97ec03124b$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $f541df97ec03124b$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $f541df97ec03124b$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $f541df97ec03124b$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $f541df97ec03124b$var$point(point) {
    return $f541df97ec03124b$var$index(point && point.line) + ':' + $f541df97ec03124b$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $f541df97ec03124b$var$position(pos) {
    return $f541df97ec03124b$var$point(pos && pos.start) + '-' + $f541df97ec03124b$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $f541df97ec03124b$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


const $0d654817652ff70c$var$own = {}.hasOwnProperty;
function $0d654817652ff70c$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $0d654817652ff70c$var$compiler(options)((0, $9726bbaba10693ae$export$bd0e6e1378a871d7)((0, $7314bc288e1eae10$export$98e6a39c04603d36)(options).document().write((0, $3a4670755ce1503f$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $0d654817652ff70c$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $0d654817652ff70c$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($0d654817652ff70c$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $0d654817652ff70c$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $0d654817652ff70c$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $0d654817652ff70c$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $0d654817652ff70c$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $f541df97ec03124b$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $0d654817652ff70c$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $0d654817652ff70c$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $50e22642e0e09299$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $0d654817652ff70c$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $0d654817652ff70c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $0d654817652ff70c$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $c7907535f4b9aef3$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $95a72c1cf6dba6e1$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $ad9664049664d211$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $0d654817652ff70c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $0d654817652ff70c$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $0d654817652ff70c$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $0d654817652ff70c$var$configure(combined, value);
        else $0d654817652ff70c$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $0d654817652ff70c$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($0d654817652ff70c$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $0d654817652ff70c$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $f541df97ec03124b$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $f541df97ec03124b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $f541df97ec03124b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


/**
 * @import {Info, Join, Options, SafeConfig, State} from 'mdast-util-to-markdown'
 * @import {Nodes} from 'mdast'
 * @import {Enter, FlowParents, PhrasingParents, TrackFields} from './types.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $2a14c0a7825e2d76$var$own = {}.hasOwnProperty;
function $2a14c0a7825e2d76$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $2a14c0a7825e2d76$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $2a14c0a7825e2d76$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Options, State} from './types.js'
 */ const $63878fd64f5e7138$var$own = {}.hasOwnProperty;
function $63878fd64f5e7138$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$63878fd64f5e7138$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension)if ($63878fd64f5e7138$var$own.call(extension, key)) switch(key){
        case 'extensions':
            break;
        /* c8 ignore next 4 */ case 'unsafe':
            $63878fd64f5e7138$var$list(base[key], extension[key]);
            break;
        case 'join':
            $63878fd64f5e7138$var$list(base[key], extension[key]);
            break;
        case 'handlers':
            $63878fd64f5e7138$var$map(base[key], extension[key]);
            break;
        default:
            // @ts-expect-error: matches.
            base.options[key] = extension[key];
    }
    return base;
}
/**
 * @template T
 * @param {Array<T>} left
 * @param {Array<T> | null | undefined} right
 */ function $63878fd64f5e7138$var$list(left, right) {
    if (right) left.push(...right);
}
/**
 * @template T
 * @param {Record<string, T>} left
 * @param {Record<string, T> | null | undefined} right
 */ function $63878fd64f5e7138$var$map(left, right) {
    if (right) Object.assign(left, right);
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $d1c14ba0693b52bc$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $d1c14ba0693b52bc$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $d1c14ba0693b52bc$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $7f37f3ec0188f469$export$78221a09424368d(stack, pattern) {
    return $7f37f3ec0188f469$var$listInScope(stack, pattern.inConstruct, true) && !$7f37f3ec0188f469$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $7f37f3ec0188f469$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $70734483be2659d8$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $7f37f3ec0188f469$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $db951069d2dea5c7$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $68d4e17228dbb348$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $4a22cf0155657805$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $1c503e551dda49b0$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $4a22cf0155657805$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $68d4e17228dbb348$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $1c503e551dda49b0$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $db951069d2dea5c7$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $1c503e551dda49b0$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $359b779d78d87eba$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $c3f2e44c75d398e4$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $359b779d78d87eba$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $86c9cdd56a2e6f96$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $0833424d6a6479a1$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $5827a0fc7c674130$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$b16e2a3c083b6624$export$bef81ba411953b51.peek = $b16e2a3c083b6624$var$emphasisPeek;
function $b16e2a3c083b6624$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $86c9cdd56a2e6f96$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $5827a0fc7c674130$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $5827a0fc7c674130$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $b16e2a3c083b6624$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $bfc7e4a591ae2825$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$bfc7e4a591ae2825$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $bfc7e4a591ae2825$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $bfc7e4a591ae2825$var$ok;
    if (typeof test === 'function') return $bfc7e4a591ae2825$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $bfc7e4a591ae2825$var$anyFactory(test) : // narrows to `Array`.
    $bfc7e4a591ae2825$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $bfc7e4a591ae2825$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $bfc7e4a591ae2825$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9(tests[index]);
    return $bfc7e4a591ae2825$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $bfc7e4a591ae2825$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $bfc7e4a591ae2825$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $bfc7e4a591ae2825$var$typeFactory(check) {
    return $bfc7e4a591ae2825$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $bfc7e4a591ae2825$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($bfc7e4a591ae2825$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $bfc7e4a591ae2825$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $bfc7e4a591ae2825$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $c1936b5c531da4ff$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $cfb7310432f9e28b$var$empty = [];
const $cfb7310432f9e28b$export$f4d8133c446fe484 = true;
const $cfb7310432f9e28b$export$7f100f842f565dc9 = false;
const $cfb7310432f9e28b$export$8773f85c2fb2c116 = 'skip';
function $cfb7310432f9e28b$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $c1936b5c531da4ff$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $cfb7310432f9e28b$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $cfb7310432f9e28b$var$toResult(visitor(node, parents));
                if (result[0] === $cfb7310432f9e28b$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $cfb7310432f9e28b$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $cfb7310432f9e28b$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $cfb7310432f9e28b$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $cfb7310432f9e28b$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $cfb7310432f9e28b$var$empty : [
        value
    ];
}

/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $4f16da80681e04c5$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $cfb7310432f9e28b$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



function $47a09e91076e4318$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $4f16da80681e04c5$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $cfb7310432f9e28b$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $50e22642e0e09299$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $aea85b73efe7ed08$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $47a09e91076e4318$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $a425a39e6701132b$export$c0bb0b647f701bb5.peek = $a425a39e6701132b$var$htmlPeek;
function $a425a39e6701132b$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $a425a39e6701132b$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$9e63ddfbce11b984$export$5c452ff88e35e47d.peek = $9e63ddfbce11b984$var$imagePeek;
function $9e63ddfbce11b984$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $359b779d78d87eba$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $9e63ddfbce11b984$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $0f4a36c1f40a061b$export$f281796f6bc3b8db.peek = $0f4a36c1f40a061b$var$imageReferencePeek;
function $0f4a36c1f40a061b$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $0f4a36c1f40a061b$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $96bc8c9d0608b2f2$export$91b9bee19a0d8569.peek = $96bc8c9d0608b2f2$var$inlineCodePeek;
function $96bc8c9d0608b2f2$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $96bc8c9d0608b2f2$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $a1dc61ee2e242452$export$74cae3045e3179ed(node, state) {
    const raw = (0, $50e22642e0e09299$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$0086e6f309673dfe$export$9c30223ca0a664fb.peek = $0086e6f309673dfe$var$linkPeek;
function $0086e6f309673dfe$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $359b779d78d87eba$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $a1dc61ee2e242452$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $0086e6f309673dfe$var$linkPeek(node, _, state) {
    return (0, $a1dc61ee2e242452$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $1d54c7049c18fa3f$export$e6c469b1b7b2bc6a.peek = $1d54c7049c18fa3f$var$linkReferencePeek;
function $1d54c7049c18fa3f$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $1d54c7049c18fa3f$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $64c855048b318b2e$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $d22bbe8d78add761$export$e6803bf0889262a1(state) {
    const bullet = (0, $64c855048b318b2e$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $99c2c00ef12be868$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $27f63f04b88563d0$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $b2c20b0224320891$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $99c2c00ef12be868$export$98d522b78eddc19b)(state) : (0, $64c855048b318b2e$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $d22bbe8d78add761$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $27f63f04b88563d0$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $40082b4c7917bf55$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $79711815fcb38795$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $40082b4c7917bf55$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $64c855048b318b2e$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $f1ebcf923e746031$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $94dfe1e4bc683689$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $1ecd9f11fd915024$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $94dfe1e4bc683689$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $20630a4ccfe8c38a$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$122671328c7cfafe$export$59ae2c325a998f89.peek = $122671328c7cfafe$var$strongPeek;
function $122671328c7cfafe$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $20630a4ccfe8c38a$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $5827a0fc7c674130$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $5827a0fc7c674130$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $122671328c7cfafe$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $8eb98ed9de82d435$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $bc5398e2da7d4166$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $22f41fbccb0510cb$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $27f63f04b88563d0$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $bc5398e2da7d4166$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $67fd66f4271798e4$export$8f34ce051745d39e = {
    blockquote: $d1c14ba0693b52bc$export$67dc04e652a298ca,
    break: (0, $70734483be2659d8$export$371da9dd35aba193),
    code: $1c503e551dda49b0$export$6565f9f03506010b,
    definition: $c3f2e44c75d398e4$export$69f215ed977cdb73,
    emphasis: $b16e2a3c083b6624$export$bef81ba411953b51,
    hardBreak: $70734483be2659d8$export$371da9dd35aba193,
    heading: $aea85b73efe7ed08$export$46e4a324ac90507f,
    html: $a425a39e6701132b$export$c0bb0b647f701bb5,
    image: $9e63ddfbce11b984$export$5c452ff88e35e47d,
    imageReference: $0f4a36c1f40a061b$export$f281796f6bc3b8db,
    inlineCode: $96bc8c9d0608b2f2$export$91b9bee19a0d8569,
    link: $0086e6f309673dfe$export$9c30223ca0a664fb,
    linkReference: $1d54c7049c18fa3f$export$e6c469b1b7b2bc6a,
    list: $b2c20b0224320891$export$8837f4fc672e936d,
    listItem: $79711815fcb38795$export$76c7e83ecc9cdf05,
    paragraph: $f1ebcf923e746031$export$9c206ddddb32a9b,
    root: $1ecd9f11fd915024$export$e8e78c978b129247,
    strong: $122671328c7cfafe$export$59ae2c325a998f89,
    text: $8eb98ed9de82d435$export$6f093cfa640b7166,
    thematicBreak: $22f41fbccb0510cb$export$ba7b13e047416c03
};


/**
 * @import {Join} from 'mdast-util-to-markdown'
 */ 

const $00ca8a572d62faf4$export$f7e2c8231c57a8bd = [
    $00ca8a572d62faf4$var$joinDefaults
];
/** @type {Join} */ function $00ca8a572d62faf4$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === 'code' && (0, $68d4e17228dbb348$export$8c0df78a8cad9f4b)(right, state) && (left.type === 'list' || left.type === right.type && (0, $68d4e17228dbb348$export$8c0df78a8cad9f4b)(left, state))) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ('spread' in parent && typeof parent.spread === 'boolean') {
        if (left.type === 'paragraph' && // Two paragraphs.
        (left.type === right.type || right.type === 'definition' || // Paragraph followed by a setext heading.
        right.type === 'heading' && (0, $47a09e91076e4318$export$78863676235adfbc)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}


/**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $434aa0add5412d60$var$fullPhrasingSpans = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
const $434aa0add5412d60$export$aa1c11b655786597 = [
    {
        character: '\t',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    {
        character: '\r',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: '\n',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: ' ',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: '!',
        after: '\\[',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: 'titleQuote'
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: '#'
    },
    {
        character: '#',
        inConstruct: 'headingAtx',
        after: '(?:[\r\n]|$)'
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: '&',
        after: '[#A-Za-z]',
        inConstruct: 'phrasing'
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: 'titleApostrophe'
    },
    // A left paren could break out of a destination raw.
    {
        character: '(',
        inConstruct: 'destinationRaw'
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: '\\]',
        character: '(',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: '\\d+',
        character: ')'
    },
    {
        character: ')',
        inConstruct: 'destinationRaw'
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: '*',
        after: '(?:[ \t\r\n*])'
    },
    {
        character: '*',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: '+',
        after: '(?:[ \t\r\n])'
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: '-',
        after: '(?:[ \t\r\n-])'
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: '\\d+',
        character: '.',
        after: '(?:[ \t\r\n]|$)'
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: '<',
        after: '[!/?A-Za-z]'
    },
    {
        character: '<',
        after: '[!/?A-Za-z]',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    {
        character: '<',
        inConstruct: 'destinationLiteral'
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: '='
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: '>'
    },
    {
        character: '>',
        inConstruct: 'destinationLiteral'
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: '['
    },
    {
        character: '[',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    {
        character: '[',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: '\\',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    // A right bracket can exit labels.
    {
        character: ']',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: '_'
    },
    {
        character: '_',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: '`'
    },
    {
        character: '`',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedMetaGraveAccent'
        ]
    },
    {
        character: '`',
        inConstruct: 'phrasing',
        notInConstruct: $434aa0add5412d60$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: '~'
    }
];


/**
 * @import {AssociationId} from '../types.js'
 */ 
function $294484f63df0229f$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || '';
    return (0, $c7907535f4b9aef3$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @import {CompilePattern} from '../types.js'
 */ /**
 * @type {CompilePattern}
 */ function $8fbe759f6ece7fec$export$2db8af076f277cbf(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') + (pattern.before ? '(?:' + pattern.before + ')' : '');
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (pattern.after ? '(?:' + pattern.after + ')' : ''), 'g');
    }
    return pattern._compiled;
}


/**
 * @import {Handle, Info, State} from 'mdast-util-to-markdown'
 * @import {PhrasingParents} from '../types.js'
 */ 
function $e1d239bd32cdef5c$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    /** @type {string | undefined} */ let encodeAfter;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: '',
                after: '',
                ...tracker.current()
            }).charAt(0) : '';
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(''));
        }
        let value = state.handle(child, parent, state, {
            ...tracker.current(),
            after: after,
            before: before
        });
        // If we had to encode the first character after the previous node and it’s
        // still the same character,
        // encode it.
        if (encodeAfter && encodeAfter === value.slice(0, 1)) value = (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(encodeAfter.charCodeAt(0)) + value.slice(1);
        const encodingInfo = state.attentionEncodeSurroundingInfo;
        state.attentionEncodeSurroundingInfo = undefined;
        encodeAfter = undefined;
        // If we have to encode the first character before the current node and
        // it’s still the same character,
        // encode it.
        if (encodingInfo) {
            if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) results[results.length - 1] = results[results.length - 1].slice(0, -1) + (0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(before.charCodeAt(0));
            if (encodingInfo.after) encodeAfter = after;
        }
        tracker.move(value);
        results.push(value);
        before = value.slice(-1);
    }
    indexStack.pop();
    return results.join('');
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {FlowChildren, FlowParents, TrackFields} from '../types.js'
 */ /**
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $de8257e12d8645c5$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: '\n',
            after: '\n',
            ...tracker.current()
        })));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($de8257e12d8645c5$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {FlowChildren} left
 * @param {FlowChildren} right
 * @param {FlowParents} parent
 * @param {State} state
 * @returns {string}
 */ function $de8257e12d8645c5$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === 'number') return '\n'.repeat(1 + result);
        if (result === false) return '\n\n<!---->\n\n';
    }
    return '\n\n';
}


/**
 * @import {IndentLines} from '../types.js'
 */ const $f3a519ccf2c65bbc$var$eol = /\r?\n|\r/g;
function $f3a519ccf2c65bbc$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $f3a519ccf2c65bbc$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @import {SafeConfig, State} from 'mdast-util-to-markdown'
 */ 

function $15e5755e4f4dfc2f$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || '') + (input || '') + (config.after || '');
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $7f37f3ec0188f469$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = 'before' in pattern || Boolean(pattern.atBreak);
            const after = 'after' in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($15e5755e4f4dfc2f$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($15e5755e4f4dfc2f$var$escapeBackslashes(value.slice(start, position), '\\'));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push('\\');
        else {
            // Character reference.
            result.push((0, $0833424d6a6479a1$export$5810cf1e579e9d5b)(value.charCodeAt(position)));
            start++;
        }
    }
    result.push($15e5755e4f4dfc2f$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $15e5755e4f4dfc2f$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $15e5755e4f4dfc2f$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push('\\');
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join('');
}


/**
 * @import {CreateTracker, TrackCurrent, TrackMove, TrackShift} from '../types.js'
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $2227a4bc9f992916$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || '';
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


function $877c19cfc64e21ee$export$49a1dda9e62e8ae6(tree, options) {
    const settings = options || {};
    /** @type {State} */ const state = {
        associationId: (0, $294484f63df0229f$export$c4ca1a6065421754),
        containerPhrasing: $877c19cfc64e21ee$var$containerPhrasingBound,
        containerFlow: $877c19cfc64e21ee$var$containerFlowBound,
        createTracker: (0, $2227a4bc9f992916$export$6b2a7d5132615086),
        compilePattern: $8fbe759f6ece7fec$export$2db8af076f277cbf,
        enter: enter,
        // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
        // here.
        handlers: {
            ...(0, $67fd66f4271798e4$export$8f34ce051745d39e)
        },
        // @ts-expect-error: add `handle` in a second.
        handle: undefined,
        indentLines: $f3a519ccf2c65bbc$export$7c3cf23d514b264a,
        indexStack: [],
        join: [
            ...(0, $00ca8a572d62faf4$export$f7e2c8231c57a8bd)
        ],
        options: {},
        safe: $877c19cfc64e21ee$var$safeBound,
        stack: [],
        unsafe: [
            ...(0, $434aa0add5412d60$export$aa1c11b655786597)
        ]
    };
    (0, $63878fd64f5e7138$export$8d21e34596265fa2)(state, settings);
    if (state.options.tightDefinitions) state.join.push($877c19cfc64e21ee$var$joinDefinition);
    state.handle = (0, $2a14c0a7825e2d76$export$d6a12bfbbedf6185)('type', {
        invalid: $877c19cfc64e21ee$var$invalid,
        unknown: $877c19cfc64e21ee$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: '\n',
        after: '\n',
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += '\n';
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        /**
     * @returns {undefined}
     */ function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $877c19cfc64e21ee$var$invalid(value) {
    throw new Error('Cannot handle value `' + value + '`, expected node');
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $877c19cfc64e21ee$var$unknown(value) {
    // Always a node.
    const node = /** @type {Nodes} */ value;
    throw new Error('Cannot handle unknown node `' + node.type + '`');
}
/** @type {Join} */ function $877c19cfc64e21ee$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === 'definition' && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {PhrasingParents} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $877c19cfc64e21ee$var$containerPhrasingBound(parent, info) {
    return (0, $e1d239bd32cdef5c$export$f4090a9439f37631)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $877c19cfc64e21ee$var$containerFlowBound(parent, info) {
    return (0, $de8257e12d8645c5$export$134f7fdacfea8b16)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $877c19cfc64e21ee$var$safeBound(value, config) {
    return (0, $15e5755e4f4dfc2f$export$170b8c323eee7bec)(this, value, config);
}


/**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $c30f35b797570b34$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


function $7d95a64d44713b74$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $7d95a64d44713b74$export$411ce8e5a71e3069() {}
function $7d95a64d44713b74$export$dcb8b3f0e2de7e49() {}
function $7d95a64d44713b74$export$565e9d9bd6b6e0d4() {}



/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $449ffa62ae6d5527$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $51b9ad122ce6e84b$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $bfc7e4a591ae2825$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $51b9ad122ce6e84b$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $cfb7310432f9e28b$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $51b9ad122ce6e84b$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $51b9ad122ce6e84b$var$toExpression(tuple[0]),
            $51b9ad122ce6e84b$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $51b9ad122ce6e84b$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $449ffa62ae6d5527$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $51b9ad122ce6e84b$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $69eeab88740312f1$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $69eeab88740312f1$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $69eeab88740312f1$export$b6afdfff2163546f() {
    return {
        transforms: [
            $69eeab88740312f1$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $69eeab88740312f1$var$enterLiteralAutolink,
            literalAutolinkEmail: $69eeab88740312f1$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $69eeab88740312f1$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $69eeab88740312f1$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $69eeab88740312f1$var$exitLiteralAutolink,
            literalAutolinkEmail: $69eeab88740312f1$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $69eeab88740312f1$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $69eeab88740312f1$var$exitLiteralAutolinkWww
        }
    };
}
function $69eeab88740312f1$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $69eeab88740312f1$var$inConstruct,
                notInConstruct: $69eeab88740312f1$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $69eeab88740312f1$var$inConstruct,
                notInConstruct: $69eeab88740312f1$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $69eeab88740312f1$var$inConstruct,
                notInConstruct: $69eeab88740312f1$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $69eeab88740312f1$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $69eeab88740312f1$var$transformGfmAutolinkLiterals(tree) {
    (0, $51b9ad122ce6e84b$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $69eeab88740312f1$var$findUrl
        ],
        [
            /(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu,
            $69eeab88740312f1$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $69eeab88740312f1$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$69eeab88740312f1$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$69eeab88740312f1$var$isCorrectDomain(domain)) return false;
    const parts = $69eeab88740312f1$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $69eeab88740312f1$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$69eeab88740312f1$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $69eeab88740312f1$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $69eeab88740312f1$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $c30f35b797570b34$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $c30f35b797570b34$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $69eeab88740312f1$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code) || (0, $acfa9f9317a70f27$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$87ce4ccfe3f49698$var$footnoteReference.peek = $87ce4ccfe3f49698$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $87ce4ccfe3f49698$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $87ce4ccfe3f49698$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $87ce4ccfe3f49698$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $87ce4ccfe3f49698$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $87ce4ccfe3f49698$var$enterFootnoteCallString,
            gfmFootnoteCall: $87ce4ccfe3f49698$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $87ce4ccfe3f49698$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $87ce4ccfe3f49698$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $87ce4ccfe3f49698$var$exitFootnoteCallString,
            gfmFootnoteCall: $87ce4ccfe3f49698$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $87ce4ccfe3f49698$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $87ce4ccfe3f49698$var$exitFootnoteDefinition
        }
    };
}
function $87ce4ccfe3f49698$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    let firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $87ce4ccfe3f49698$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        const tracker = state.createTracker(info);
        let value = tracker.move('[^');
        const exit = state.enter('footnoteDefinition');
        const subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $87ce4ccfe3f49698$var$mapAll : $87ce4ccfe3f49698$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $87ce4ccfe3f49698$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $87ce4ccfe3f49698$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $87ce4ccfe3f49698$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $f7143a0660f1dcfa$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$f7143a0660f1dcfa$var$handleDelete.peek = $f7143a0660f1dcfa$var$peekDelete;
function $f7143a0660f1dcfa$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $f7143a0660f1dcfa$var$enterStrikethrough
        },
        exit: {
            strikethrough: $f7143a0660f1dcfa$var$exitStrikethrough
        }
    };
}
function $f7143a0660f1dcfa$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $f7143a0660f1dcfa$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $f7143a0660f1dcfa$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $f7143a0660f1dcfa$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $f7143a0660f1dcfa$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $f7143a0660f1dcfa$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $f7143a0660f1dcfa$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $18603bcaf3bfe332$var$defaultStringLength(value) {
    return value.length;
}
function $18603bcaf3bfe332$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $18603bcaf3bfe332$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $18603bcaf3bfe332$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $18603bcaf3bfe332$var$toAlignment(align[columnIndex]);
    else {
        const code = $18603bcaf3bfe332$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $18603bcaf3bfe332$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $18603bcaf3bfe332$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}



function $dac9e65efa34ebd4$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $dac9e65efa34ebd4$var$enterTable,
            tableData: $dac9e65efa34ebd4$var$enterCell,
            tableHeader: $dac9e65efa34ebd4$var$enterCell,
            tableRow: $dac9e65efa34ebd4$var$enterRow
        },
        exit: {
            codeText: $dac9e65efa34ebd4$var$exitCodeText,
            table: $dac9e65efa34ebd4$var$exitTable,
            tableData: $dac9e65efa34ebd4$var$exit,
            tableHeader: $dac9e65efa34ebd4$var$exit,
            tableRow: $dac9e65efa34ebd4$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$enterTable(token) {
    const align = token._align;
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $dac9e65efa34ebd4$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $dac9e65efa34ebd4$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $dac9e65efa34ebd4$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $dac9e65efa34ebd4$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $18603bcaf3bfe332$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $67fd66f4271798e4$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $3cd3fb4c24d107de$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $3cd3fb4c24d107de$var$exitCheck,
            taskListCheckValueUnchecked: $3cd3fb4c24d107de$var$exitCheck,
            paragraph: $3cd3fb4c24d107de$var$exitParagraphWithTaskListItem
        }
    };
}
function $3cd3fb4c24d107de$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $3cd3fb4c24d107de$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3cd3fb4c24d107de$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3cd3fb4c24d107de$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $7d95a64d44713b74$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $3cd3fb4c24d107de$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $67fd66f4271798e4$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $4d40947a9f1f7899$export$95adae814eb7433e() {
    return [
        (0, $69eeab88740312f1$export$b6afdfff2163546f)(),
        (0, $87ce4ccfe3f49698$export$c9d5ad4bdf6ff801)(),
        (0, $f7143a0660f1dcfa$export$34d64e709dd0b9bb)(),
        (0, $dac9e65efa34ebd4$export$8bd0ec8ecf6adb7d)(),
        (0, $3cd3fb4c24d107de$export$a427a608608b215f)()
    ];
}
function $4d40947a9f1f7899$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $69eeab88740312f1$export$d3ace9096b01c39d)(),
            (0, $87ce4ccfe3f49698$export$3727766a73a6c09f)(options),
            (0, $f7143a0660f1dcfa$export$1632835bd2c84956)(),
            (0, $dac9e65efa34ebd4$export$dafcad76ea6e0045)(options),
            (0, $3cd3fb4c24d107de$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $300b7f5f9ddd5b92$var$wwwPrefix = {
    tokenize: $300b7f5f9ddd5b92$var$tokenizeWwwPrefix,
    partial: true
};
const $300b7f5f9ddd5b92$var$domain = {
    tokenize: $300b7f5f9ddd5b92$var$tokenizeDomain,
    partial: true
};
const $300b7f5f9ddd5b92$var$path = {
    tokenize: $300b7f5f9ddd5b92$var$tokenizePath,
    partial: true
};
const $300b7f5f9ddd5b92$var$trail = {
    tokenize: $300b7f5f9ddd5b92$var$tokenizeTrail,
    partial: true
};
const $300b7f5f9ddd5b92$var$emailDomainDotTrail = {
    tokenize: $300b7f5f9ddd5b92$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $300b7f5f9ddd5b92$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $300b7f5f9ddd5b92$var$tokenizeWwwAutolink,
    previous: $300b7f5f9ddd5b92$var$previousWww
};
const $300b7f5f9ddd5b92$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $300b7f5f9ddd5b92$var$tokenizeProtocolAutolink,
    previous: $300b7f5f9ddd5b92$var$previousProtocol
};
const $300b7f5f9ddd5b92$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $300b7f5f9ddd5b92$var$tokenizeEmailAutolink,
    previous: $300b7f5f9ddd5b92$var$previousEmail
};
/** @type {ConstructRecord} */ const $300b7f5f9ddd5b92$var$text = {};
function $300b7f5f9ddd5b92$export$608123d9b549151() {
    return {
        text: $300b7f5f9ddd5b92$var$text
    };
}
/** @type {Code} */ let $300b7f5f9ddd5b92$var$code = 48;
// Add alphanumerics.
while($300b7f5f9ddd5b92$var$code < 123){
    $300b7f5f9ddd5b92$var$text[$300b7f5f9ddd5b92$var$code] = $300b7f5f9ddd5b92$var$emailAutolink;
    $300b7f5f9ddd5b92$var$code++;
    if ($300b7f5f9ddd5b92$var$code === 58) $300b7f5f9ddd5b92$var$code = 65;
    else if ($300b7f5f9ddd5b92$var$code === 91) $300b7f5f9ddd5b92$var$code = 97;
}
$300b7f5f9ddd5b92$var$text[43] = $300b7f5f9ddd5b92$var$emailAutolink;
$300b7f5f9ddd5b92$var$text[45] = $300b7f5f9ddd5b92$var$emailAutolink;
$300b7f5f9ddd5b92$var$text[46] = $300b7f5f9ddd5b92$var$emailAutolink;
$300b7f5f9ddd5b92$var$text[95] = $300b7f5f9ddd5b92$var$emailAutolink;
$300b7f5f9ddd5b92$var$text[72] = [
    $300b7f5f9ddd5b92$var$emailAutolink,
    $300b7f5f9ddd5b92$var$protocolAutolink
];
$300b7f5f9ddd5b92$var$text[104] = [
    $300b7f5f9ddd5b92$var$emailAutolink,
    $300b7f5f9ddd5b92$var$protocolAutolink
];
$300b7f5f9ddd5b92$var$text[87] = [
    $300b7f5f9ddd5b92$var$emailAutolink,
    $300b7f5f9ddd5b92$var$wwwAutolink
];
$300b7f5f9ddd5b92$var$text[119] = [
    $300b7f5f9ddd5b92$var$emailAutolink,
    $300b7f5f9ddd5b92$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$300b7f5f9ddd5b92$var$gfmAtext(code) || !$300b7f5f9ddd5b92$var$previousEmail.call(self, self.previous) || $300b7f5f9ddd5b92$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($300b7f5f9ddd5b92$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($300b7f5f9ddd5b92$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$300b7f5f9ddd5b92$var$previousWww.call(self, self.previous) || $300b7f5f9ddd5b92$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($300b7f5f9ddd5b92$var$wwwPrefix, effects.attempt($300b7f5f9ddd5b92$var$domain, effects.attempt($300b7f5f9ddd5b92$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $300b7f5f9ddd5b92$var$previousProtocol.call(self, self.previous) && !$300b7f5f9ddd5b92$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $acfa9f9317a70f27$export$67dbf494fc8394df)(code) || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code) || (0, $acfa9f9317a70f27$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($300b7f5f9ddd5b92$var$domain, effects.attempt($300b7f5f9ddd5b92$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($300b7f5f9ddd5b92$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $acfa9f9317a70f27$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($300b7f5f9ddd5b92$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code) || (0, $acfa9f9317a70f27$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $300b7f5f9ddd5b92$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $300b7f5f9ddd5b92$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $300b7f5f9ddd5b92$var$previousProtocol(code) {
    return !(0, $acfa9f9317a70f27$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $300b7f5f9ddd5b92$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $300b7f5f9ddd5b92$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $300b7f5f9ddd5b92$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $acfa9f9317a70f27$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $300b7f5f9ddd5b92$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $df40a8f214bd9a76$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $df40a8f214bd9a76$var$literalAutolinkEmail,
            literalAutolinkHttp: $df40a8f214bd9a76$var$literalAutolinkHttp,
            literalAutolinkWww: $df40a8f214bd9a76$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $df40a8f214bd9a76$var$literalAutolinkWww(token) {
    $df40a8f214bd9a76$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $df40a8f214bd9a76$var$literalAutolinkEmail(token) {
    $df40a8f214bd9a76$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $df40a8f214bd9a76$var$literalAutolinkHttp(token) {
    $df40a8f214bd9a76$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $df40a8f214bd9a76$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $d4b01d3b5123694b$var$indent = {
    tokenize: $d4b01d3b5123694b$var$tokenizeIndent,
    partial: true
};
function $d4b01d3b5123694b$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $d4b01d3b5123694b$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $d4b01d3b5123694b$var$tokenizeDefinitionContinuation
                },
                exit: $d4b01d3b5123694b$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $d4b01d3b5123694b$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $d4b01d3b5123694b$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $d4b01d3b5123694b$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4b01d3b5123694b$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $d4b01d3b5123694b$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4b01d3b5123694b$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4b01d3b5123694b$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4b01d3b5123694b$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $d3123eef238d6d2f$export$d50d28ce3ab2a612), ok, effects.attempt($d4b01d3b5123694b$var$indent, ok, nok));
}
/** @type {Exiter} */ function $d4b01d3b5123694b$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4b01d3b5123694b$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $169a3a00ad67f475$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $169a3a00ad67f475$var$emptyOptions = {};
function $169a3a00ad67f475$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $169a3a00ad67f475$export$a731a1f6cf81900c(options) {
    const config = options || $169a3a00ad67f475$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $169a3a00ad67f475$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$169a3a00ad67f475$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $691c6bd14e69df31$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $5137b2f6a3a4800e$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $27a57fbb9b4567bf$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $eebec21212554d21$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $60c7f2760f76efa0$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $eebec21212554d21$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $eebec21212554d21$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $f4fc34744abcdc3d$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $36b6d42c9782c2df$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $f61d52131bc09320$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $f61d52131bc09320$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $f61d52131bc09320$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $7b121bd9945876c6$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $7eefa81d67177f68$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $7eefa81d67177f68$var$tokenizeTable,
                resolveAll: $7eefa81d67177f68$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7eefa81d67177f68$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $7eefa81d67177f68$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $f61d52131bc09320$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $7eefa81d67177f68$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $7eefa81d67177f68$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $7eefa81d67177f68$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $7eefa81d67177f68$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $7eefa81d67177f68$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $7eefa81d67177f68$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $7b121bd9945876c6$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $7eefa81d67177f68$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $7eefa81d67177f68$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $7eefa81d67177f68$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $7eefa81d67177f68$var$getPoint(context.events, range[2]);
        const relatedEnd = $7eefa81d67177f68$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $7eefa81d67177f68$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $7eefa81d67177f68$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $7eefa81d67177f68$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $7eefa81d67177f68$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $55daa8720f77391e$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $55daa8720f77391e$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $55daa8720f77391e$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $55daa8720f77391e$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $55daa8720f77391e$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $55daa8720f77391e$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $55daa8720f77391e$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $8791d896af4f9927$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $8791d896af4f9927$var$reText = new RegExp('^' + $8791d896af4f9927$var$reFlow.source, 'i');
function $8791d896af4f9927$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $8791d896af4f9927$var$exitHtmlData.call(this, token, $8791d896af4f9927$var$reFlow);
            },
            htmlTextData (token) {
                $8791d896af4f9927$var$exitHtmlData.call(this, token, $8791d896af4f9927$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $8791d896af4f9927$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $739440d03107e192$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $739440d03107e192$var$tokenizeTasklistCheck
};
function $739440d03107e192$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $739440d03107e192$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $739440d03107e192$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $acfa9f9317a70f27$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $acfa9f9317a70f27$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $acfa9f9317a70f27$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $739440d03107e192$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $739440d03107e192$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $4a351b3b95a4a526$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $adc4c4f9ee44084d$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $36918e2b8ec3852a$export$59ffe8c4d7a4aab2(options) {
    return (0, $fd3f8b6b609326e9$export$86a865d89ef3c690)([
        (0, $300b7f5f9ddd5b92$export$608123d9b549151)(),
        (0, $d4b01d3b5123694b$export$c82499b6656305df)(),
        (0, $27a57fbb9b4567bf$export$8bbec8ea1400a00e)(options),
        (0, $7eefa81d67177f68$export$e36cebda627bf2dd)(),
        (0, $739440d03107e192$export$2912e8b2802475ff)()
    ]);
}
function $36918e2b8ec3852a$export$6983b82e6105d62a(options) {
    return (0, $fd3f8b6b609326e9$export$eaf8c406dfb0a620)([
        (0, $df40a8f214bd9a76$export$999603f1f1c3d2f9)(),
        (0, $169a3a00ad67f475$export$a731a1f6cf81900c)(options),
        (0, $36b6d42c9782c2df$export$58acedca46108820)(),
        (0, $55daa8720f77391e$export$c64626c032567c7f)(),
        (0, $8791d896af4f9927$export$c9bf87ea36d00682)(),
        (0, $adc4c4f9ee44084d$export$4b6a13e2af1b08ed)()
    ]);
}


/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $e0174373d1448f25$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $e0174373d1448f25$export$2e2bcd8739ae039 = $e0174373d1448f25$var$last;


const $9aa9f05e55106570$var$getPreviousType = (ancestors, node)=>{
    var _a, _b;
    const child = (_a = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ancestors)) === null || _a === void 0 ? void 0 : _a.children;
    const previousType = (_b = child === null || child === void 0 ? void 0 : child[child.indexOf(node) - 1]) === null || _b === void 0 ? void 0 : _b.type;
    return previousType !== null && previousType !== void 0 ? previousType : 'firstOne';
};
const $9aa9f05e55106570$var$getNextType = (ancestors, node)=>{
    var _a, _b;
    const child = (_a = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ancestors)) === null || _a === void 0 ? void 0 : _a.children;
    const nextType = (_b = child === null || child === void 0 ? void 0 : child[child.indexOf(node) + 1]) === null || _b === void 0 ? void 0 : _b.type;
    return nextType !== null && nextType !== void 0 ? nextType : 'lastOne';
};
const $9aa9f05e55106570$var$root = ({ node: node, process: handle, ancestors: ancestors })=>{
    if (node.type !== 'root') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $9aa9f05e55106570$var$paragraph = ({ node: node, process: handle, ancestors: ancestors, ops: ops })=>{
    if (node.type !== 'paragraph') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    ops.push({
        insert: '\n'
    });
    // if (['paragraph', 'code', 'heading'].includes(getNextType(ancestors, node))) {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $9aa9f05e55106570$var$text = ({ node: node, ancestors: ancestors, ops: ops })=>{
    if (node.type !== 'text') return;
    const attrs = {};
    if (ancestors.find((it)=>it.type === 'strong')) attrs.bold = true;
    if (ancestors.find((it)=>it.type === 'emphasis')) attrs.italic = true;
    if (ancestors.find((it)=>it.type === 'delete')) attrs.strike = true;
    if (Object.keys(attrs).length > 0) ops.push({
        insert: node.value,
        attributes: attrs
    });
    else ops.push({
        insert: node.value
    });
    return true;
};
const $9aa9f05e55106570$var$strong = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'strong' && node.type !== 'emphasis' && node.type !== 'delete') return;
    const attrs = {};
    if (node.type === 'strong') attrs.bold = true;
    if (node.type === 'emphasis') attrs.italic = true;
    if (node.type === 'delete') attrs.strike = true;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $9aa9f05e55106570$var$heading = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'heading') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    ops.push({
        insert: '\n',
        attributes: {
            header: node.depth
        }
    });
    return true;
};
const $9aa9f05e55106570$var$list = ({ node: node, ancestors: ancestors, process: handle })=>{
    if (node.type !== 'list') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    // if (getNextType(ancestors, node) === 'list') {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $9aa9f05e55106570$var$listItem = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    var _a, _b;
    if (node.type !== 'listItem') return;
    const item = node;
    item.children.filter((it)=>it.type !== 'list').forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    if (((_a = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ops)) === null || _a === void 0 ? void 0 : _a.insert) === '\n' && !((_b = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ops)) === null || _b === void 0 ? void 0 : _b.attributes)) ops.pop();
    const list = ancestors.filter((it)=>it.type === 'list');
    const lastList = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(list);
    const op = {
        insert: '\n',
        attributes: {
            list: item.checked === null ? (lastList === null || lastList === void 0 ? void 0 : lastList.ordered) ? 'ordered' : 'bullet' : item.checked ? 'checked' : 'unchecked'
        }
    };
    if (list.length > 1) op.attributes.indent = list.length - 1;
    ops.push(op);
    item.children.filter((it)=>it.type === 'list').forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    return true;
};
const $9aa9f05e55106570$var$blockquote = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    var _a, _b;
    if (node.type !== 'blockquote') return;
    node.children.forEach((it)=>handle(it, [
            ...ancestors,
            node
        ]));
    if (((_a = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ops)) === null || _a === void 0 ? void 0 : _a.insert) === '\n' && !((_b = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ops)) === null || _b === void 0 ? void 0 : _b.attributes)) ops.pop();
    ops.push({
        insert: '\n',
        attributes: {
            blockquote: true
        }
    });
    return true;
};
const $9aa9f05e55106570$var$link = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'link') return;
    node.children.forEach((child)=>{
        ops.push({
            insert: child.value,
            attributes: {
                link: node.url
            }
        });
    });
    return true;
};
const $9aa9f05e55106570$var$image = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'image') return;
    ops.push({
        insert: {
            image: node.url
        },
        attributes: {
            alt: node.alt
        }
    });
    return true;
};
const $9aa9f05e55106570$var$code = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'code') return;
    ops.push({
        insert: node.value
    }, {
        insert: '\n',
        attributes: {
            'code-block': true
        }
    });
    // if (['paragraph'].includes(getNextType(ancestors, node))) {
    //   ops.push({ insert: '\n' } as Op)
    // }
    return true;
};
const $9aa9f05e55106570$var$inlineCode = ({ node: node, ancestors: ancestors, ops: ops, process: handle })=>{
    if (node.type !== 'inlineCode') return;
    ops.push({
        insert: node.value,
        attributes: {
            code: true
        }
    });
    return true;
};
const $9aa9f05e55106570$var$generic = ({ node: node, ancestors: ancestors, ops: ops })=>{
    ops.push({
        insert: (0, $877c19cfc64e21ee$export$49a1dda9e62e8ae6)(node, {
            extensions: [
                (0, $4d40947a9f1f7899$export$ea77de6901e7c72b)()
            ]
        })
    });
    return true;
};
const $9aa9f05e55106570$var$breaking = ({ node: node, ancestors: ancestors, ops: ops, process: process })=>{
    if (node.type !== 'break') return;
    const prevType = $9aa9f05e55106570$var$getPreviousType(ancestors, node);
    const nextType = $9aa9f05e55106570$var$getNextType(ancestors, node);
    if (prevType !== 'text' || nextType !== 'text') {
        ops.push({
            insert: '\n'
        });
        return true;
    }
    const old = ops[ops.length - 1];
    const child = (0, $e0174373d1448f25$export$2e2bcd8739ae039)(ancestors).children;
    const nextNode = child[child.indexOf(node) + 1];
    ops[ops.length - 1] = {
        insert: old.insert + '\n' + nextNode.value
    };
    child.splice(child.indexOf(nextNode), 1);
    return true;
};
function $9aa9f05e55106570$var$markdownToDelta(source, options = {}) {
    let ast;
    if (typeof source === 'string') ast = (0, $0d654817652ff70c$export$d744d789c09bfde6)(source, {
        extensions: [
            (0, $36918e2b8ec3852a$export$59ffe8c4d7a4aab2)()
        ],
        mdastExtensions: [
            (0, $4d40947a9f1f7899$export$95adae814eb7433e)()
        ]
    });
    else ast = source;
    const ops = [];
    function process(node, ancestors) {
        const handles = [
            $9aa9f05e55106570$var$root,
            $9aa9f05e55106570$var$paragraph,
            $9aa9f05e55106570$var$text,
            $9aa9f05e55106570$var$strong,
            $9aa9f05e55106570$var$heading,
            $9aa9f05e55106570$var$list,
            $9aa9f05e55106570$var$listItem,
            $9aa9f05e55106570$var$blockquote,
            $9aa9f05e55106570$var$link,
            $9aa9f05e55106570$var$image,
            $9aa9f05e55106570$var$code,
            $9aa9f05e55106570$var$inlineCode,
            $9aa9f05e55106570$var$breaking,
            $9aa9f05e55106570$var$generic
        ];
        if (options.handle) handles.unshift(options.handle);
        for (const handle of handles){
            const result = handle({
                node: node,
                ancestors: ancestors,
                ops: ops,
                process: process
            });
            if (result) return;
        }
    }
    process(ast, []);
    return ops;
}
var $9aa9f05e55106570$export$2e2bcd8739ae039 = $9aa9f05e55106570$var$markdownToDelta;



/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var $7182e7c5b448927c$exports = {};
"use strict";


var $be857304663aed78$require$Buffer = $7182e7c5b448927c$exports.Buffer;
var $be857304663aed78$var$XLSX = {};
$be857304663aed78$var$XLSX.version = '0.20.3';
var $be857304663aed78$var$current_codepage = 1200, $be857304663aed78$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $be857304663aed78$var$$cptable;
var $be857304663aed78$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $be857304663aed78$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $be857304663aed78$var$set_ansi = function(cp /*:number*/ ) {
    if ($be857304663aed78$var$VALID_ANSI.indexOf(cp) == -1) return;
    $be857304663aed78$var$current_ansi = $be857304663aed78$var$CS2CP[0] = cp;
};
function $be857304663aed78$var$reset_ansi() {
    $be857304663aed78$var$set_ansi(1252);
}
var $be857304663aed78$var$set_cp = function(cp /*:number*/ ) {
    $be857304663aed78$var$current_codepage = cp;
    $be857304663aed78$var$set_ansi(cp);
};
function $be857304663aed78$var$reset_cp() {
    $be857304663aed78$var$set_cp(1200);
    $be857304663aed78$var$reset_ansi();
}
function $be857304663aed78$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $be857304663aed78$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $be857304663aed78$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $be857304663aed78$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $be857304663aed78$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $be857304663aed78$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $be857304663aed78$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $be857304663aed78$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $be857304663aed78$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $be857304663aed78$export$58f247d16f363b86(cptable) {
    $be857304663aed78$var$$cptable = cptable;
    $be857304663aed78$var$set_cp = function(cp /*:number*/ ) {
        $be857304663aed78$var$current_codepage = cp;
        $be857304663aed78$var$set_ansi(cp);
    };
    $be857304663aed78$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $be857304663aed78$var$$cptable.utils.decode(1200, $be857304663aed78$var$char_codes(data.slice(2)));
        return data;
    };
    $be857304663aed78$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($be857304663aed78$var$current_codepage === 1200) return String.fromCharCode(x);
        return $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $be857304663aed78$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_ansi, [
            x
        ])[0];
    };
    $be857304663aed78$var$cpdoit();
}
var $be857304663aed78$var$DENSE = null;
var $be857304663aed78$var$DIF_XL = true;
var $be857304663aed78$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $be857304663aed78$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $be857304663aed78$var$Base64_map.charAt(e1) + $be857304663aed78$var$Base64_map.charAt(e2) + $be857304663aed78$var$Base64_map.charAt(e3) + $be857304663aed78$var$Base64_map.charAt(e4);
    }
    return o;
}
function $be857304663aed78$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $be857304663aed78$var$Base64_map.charAt(e1) + $be857304663aed78$var$Base64_map.charAt(e2) + $be857304663aed78$var$Base64_map.charAt(e3) + $be857304663aed78$var$Base64_map.charAt(e4);
    }
    return o;
}
function $be857304663aed78$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $be857304663aed78$var$Base64_map.charAt(e1) + $be857304663aed78$var$Base64_map.charAt(e2) + $be857304663aed78$var$Base64_map.charAt(e3) + $be857304663aed78$var$Base64_map.charAt(e4);
    }
    return o;
}
function $be857304663aed78$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $be857304663aed78$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $be857304663aed78$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $be857304663aed78$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $be857304663aed78$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $be857304663aed78$var$has_buf = /*#__PURE__*/ function() {
    return typeof $be857304663aed78$require$Buffer !== 'undefined' && false;
}();
var $be857304663aed78$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $be857304663aed78$require$Buffer !== 'undefined') {
        var nbfs = !$be857304663aed78$require$Buffer.from;
        if (!nbfs) try {
            $be857304663aed78$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $be857304663aed78$require$Buffer(buf, enc) : new $be857304663aed78$require$Buffer(buf);
        } : $be857304663aed78$require$Buffer.from.bind($be857304663aed78$require$Buffer);
    }
    return function() {};
}();
var $be857304663aed78$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $be857304663aed78$require$Buffer === 'undefined') return false;
    var x = $be857304663aed78$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $be857304663aed78$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($be857304663aed78$var$has_buf) return $be857304663aed78$require$Buffer.alloc ? $be857304663aed78$require$Buffer.alloc(len) : new $be857304663aed78$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $be857304663aed78$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($be857304663aed78$var$has_buf) return $be857304663aed78$require$Buffer.allocUnsafe ? $be857304663aed78$require$Buffer.allocUnsafe(len) : new $be857304663aed78$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $be857304663aed78$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($be857304663aed78$var$has_buf) return $be857304663aed78$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $be857304663aed78$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $be857304663aed78$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $be857304663aed78$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $be857304663aed78$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $be857304663aed78$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $be857304663aed78$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $be857304663aed78$var$bconcat = $be857304663aed78$var$has_buf ? function(bufs) {
    return $be857304663aed78$require$Buffer.concat(bufs.map(function(buf) {
        return $be857304663aed78$require$Buffer.isBuffer(buf) ? buf : $be857304663aed78$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($be857304663aed78$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $be857304663aed78$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $be857304663aed78$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $be857304663aed78$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $be857304663aed78$var$bconcat(out);
}
var $be857304663aed78$var$chr0 = /\u0000/g, $be857304663aed78$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $be857304663aed78$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $be857304663aed78$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $be857304663aed78$var$fill('0', d - t.length) + t;
}
function $be857304663aed78$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $be857304663aed78$var$fill(' ', d - t.length) + t;
}
function $be857304663aed78$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $be857304663aed78$var$fill(' ', d - t.length);
}
function $be857304663aed78$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $be857304663aed78$var$fill('0', d - t.length) + t;
}
function $be857304663aed78$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $be857304663aed78$var$fill('0', d - t.length) + t;
}
var $be857304663aed78$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $be857304663aed78$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $be857304663aed78$var$p2_32 || v < -$be857304663aed78$var$p2_32) return $be857304663aed78$var$pad0r1(v, d);
    var i = Math.round(v);
    return $be857304663aed78$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $be857304663aed78$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $be857304663aed78$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $be857304663aed78$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $be857304663aed78$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $be857304663aed78$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $be857304663aed78$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $be857304663aed78$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $be857304663aed78$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $be857304663aed78$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $be857304663aed78$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $be857304663aed78$var$fill("0", s.length - 15);
    return Number(n);
}
function $be857304663aed78$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $be857304663aed78$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $be857304663aed78$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $be857304663aed78$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $be857304663aed78$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $be857304663aed78$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $be857304663aed78$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $be857304663aed78$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $be857304663aed78$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $be857304663aed78$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $be857304663aed78$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $be857304663aed78$var$SSF_large_exp(v);
    return $be857304663aed78$var$SSF_strip_decimal($be857304663aed78$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $be857304663aed78$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $be857304663aed78$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $be857304663aed78$var$SSF_format(14, $be857304663aed78$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $be857304663aed78$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $be857304663aed78$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $be857304663aed78$var$months[val1.m - 1][1];
                case 5:
                    return $be857304663aed78$var$months[val1.m - 1][0];
                default:
                    return $be857304663aed78$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $be857304663aed78$var$days[val1.q][0];
                default:
                    return $be857304663aed78$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $be857304663aed78$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $be857304663aed78$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $be857304663aed78$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $be857304663aed78$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $be857304663aed78$var$pct1 = /%/g;
function $be857304663aed78$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($be857304663aed78$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $be857304663aed78$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $be857304663aed78$var$fill("%", mul);
}
function $be857304663aed78$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $be857304663aed78$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $be857304663aed78$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $be857304663aed78$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $be857304663aed78$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $be857304663aed78$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $be857304663aed78$var$fill(" ", r[1].length + 1 + r[4].length) : $be857304663aed78$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $be857304663aed78$var$pad0(myd, r[4].length));
}
function $be857304663aed78$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $be857304663aed78$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $be857304663aed78$var$dec1 = /^#*0*\.([0#]+)/;
var $be857304663aed78$var$closeparen = /\)[^)]*[0#]/;
var $be857304663aed78$var$phone = /\(###\) ###\\?-####/;
function $be857304663aed78$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $be857304663aed78$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $be857304663aed78$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $be857304663aed78$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $be857304663aed78$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $be857304663aed78$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($be857304663aed78$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $be857304663aed78$var$write_num_flt('n', ffmt, val1);
        return '(' + $be857304663aed78$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $be857304663aed78$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $be857304663aed78$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $be857304663aed78$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $be857304663aed78$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $be857304663aed78$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $be857304663aed78$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $be857304663aed78$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($be857304663aed78$var$frac1)) return $be857304663aed78$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $be857304663aed78$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($be857304663aed78$var$dec1)) {
        o = $be857304663aed78$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $be857304663aed78$var$hashq(r[1])).replace(/\.$/, "." + $be857304663aed78$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $be857304663aed78$var$fill("0", $be857304663aed78$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $be857304663aed78$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $be857304663aed78$var$commaify($be857304663aed78$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $be857304663aed78$var$write_num_flt(type, fmt, -val1) : $be857304663aed78$var$commaify("" + (Math.floor(val1) + $be857304663aed78$var$carry(val1, r[1].length))) + "." + $be857304663aed78$var$pad0($be857304663aed78$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $be857304663aed78$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $be857304663aed78$var$_strrev($be857304663aed78$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $be857304663aed78$var$_strrev($be857304663aed78$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($be857304663aed78$var$phone)) {
        o = $be857304663aed78$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $be857304663aed78$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $be857304663aed78$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $be857304663aed78$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $be857304663aed78$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $be857304663aed78$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $be857304663aed78$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $be857304663aed78$var$rpad_(ff[2], ri) : $be857304663aed78$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $be857304663aed78$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $be857304663aed78$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $be857304663aed78$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $be857304663aed78$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $be857304663aed78$var$write_num_flt(type, fmt, -val1) : $be857304663aed78$var$commaify($be857304663aed78$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $be857304663aed78$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $be857304663aed78$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $be857304663aed78$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $be857304663aed78$var$commaify($be857304663aed78$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $be857304663aed78$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $be857304663aed78$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $be857304663aed78$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $be857304663aed78$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $be857304663aed78$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($be857304663aed78$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $be857304663aed78$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $be857304663aed78$var$fill("%", mul);
}
function $be857304663aed78$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $be857304663aed78$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $be857304663aed78$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($be857304663aed78$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $be857304663aed78$var$write_num_int('n', ffmt, val1);
        return '(' + $be857304663aed78$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $be857304663aed78$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $be857304663aed78$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $be857304663aed78$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $be857304663aed78$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $be857304663aed78$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $be857304663aed78$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($be857304663aed78$var$frac1)) return $be857304663aed78$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $be857304663aed78$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($be857304663aed78$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $be857304663aed78$var$hashq(r[1])).replace(/\.$/, "." + $be857304663aed78$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $be857304663aed78$var$fill("0", $be857304663aed78$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $be857304663aed78$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $be857304663aed78$var$write_num_int(type, fmt, -val1) : $be857304663aed78$var$commaify("" + val1) + "." + $be857304663aed78$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $be857304663aed78$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $be857304663aed78$var$_strrev($be857304663aed78$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $be857304663aed78$var$_strrev($be857304663aed78$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($be857304663aed78$var$phone)) {
        o = $be857304663aed78$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $be857304663aed78$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $be857304663aed78$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $be857304663aed78$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $be857304663aed78$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $be857304663aed78$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $be857304663aed78$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $be857304663aed78$var$rpad_(ff[2], ri) : $be857304663aed78$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $be857304663aed78$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $be857304663aed78$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $be857304663aed78$var$write_num_int(type, fmt, -val1) : $be857304663aed78$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $be857304663aed78$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $be857304663aed78$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $be857304663aed78$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $be857304663aed78$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $be857304663aed78$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $be857304663aed78$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $be857304663aed78$var$write_num_int(type, fmt, val1) : $be857304663aed78$var$write_num_flt(type, fmt, val1);
}
function $be857304663aed78$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $be857304663aed78$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $be857304663aed78$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($be857304663aed78$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($be857304663aed78$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $be857304663aed78$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$be857304663aed78$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $be857304663aed78$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $be857304663aed78$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $be857304663aed78$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($be857304663aed78$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $be857304663aed78$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$be857304663aed78$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $be857304663aed78$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $be857304663aed78$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $be857304663aed78$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $be857304663aed78$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $be857304663aed78$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $be857304663aed78$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $be857304663aed78$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $be857304663aed78$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $be857304663aed78$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $be857304663aed78$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $be857304663aed78$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($be857304663aed78$var$cfregex2);
        var m2 = fmt[1].match($be857304663aed78$var$cfregex2);
        return $be857304663aed78$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $be857304663aed78$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $be857304663aed78$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $be857304663aed78$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$be857304663aed78$var$SSF_default_map[fmt]] || $be857304663aed78$var$table_fmt[$be857304663aed78$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $be857304663aed78$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($be857304663aed78$var$SSF_isgeneral(sfmt, 0)) return $be857304663aed78$var$SSF_general(v, o);
    if (v instanceof Date) v = $be857304663aed78$var$datenum(v, o.date1904);
    var f = $be857304663aed78$var$choose_fmt(sfmt, v);
    if ($be857304663aed78$var$SSF_isgeneral(f[1])) return $be857304663aed78$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $be857304663aed78$var$eval_fmt(f[1], v, o, f[0]);
}
function $be857304663aed78$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($be857304663aed78$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($be857304663aed78$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $be857304663aed78$var$table_fmt[idx] = fmt;
    return idx;
}
function $be857304663aed78$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $be857304663aed78$var$SSF_load(tbl[i], i);
}
function $be857304663aed78$var$make_ssf() {
    $be857304663aed78$var$table_fmt = $be857304663aed78$var$SSF_init_table();
}
var $be857304663aed78$export$40d8edd678456c2b = {
    format: $be857304663aed78$var$SSF_format,
    load: $be857304663aed78$var$SSF_load,
    _table: $be857304663aed78$var$table_fmt,
    load_table: $be857304663aed78$var$SSF_load_table,
    parse_date_code: $be857304663aed78$var$SSF_parse_date_code,
    is_date: $be857304663aed78$var$fmt_is_date,
    get_table: function get_table() {
        return $be857304663aed78$export$40d8edd678456c2b._table = $be857304663aed78$var$table_fmt;
    }
};
var $be857304663aed78$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $be857304663aed78$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $be857304663aed78$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $be857304663aed78$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($be857304663aed78$var$dateNFregex, "(\\d+)");
    $be857304663aed78$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $be857304663aed78$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($be857304663aed78$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $be857304663aed78$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $be857304663aed78$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $be857304663aed78$var$SSF__load(fmt, idx) {
    return $be857304663aed78$var$SSF_load($be857304663aed78$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $be857304663aed78$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $be857304663aed78$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $be857304663aed78$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $be857304663aed78$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $be857304663aed78$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $be857304663aed78$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $be857304663aed78$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $be857304663aed78$var$new_buf(0);
        return $be857304663aed78$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $be857304663aed78$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($be857304663aed78$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $be857304663aed78$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $be857304663aed78$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $be857304663aed78$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $be857304663aed78$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $be857304663aed78$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $be857304663aed78$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $be857304663aed78$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($be857304663aed78$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $be857304663aed78$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($be857304663aed78$var$s2a($be857304663aed78$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($be857304663aed78$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($be857304663aed78$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $be857304663aed78$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $be857304663aed78$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($be857304663aed78$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($be857304663aed78$var$chr1);
        UCPath = UCPath.replace($be857304663aed78$var$chr0, '');
        if (m) UCPath = UCPath.replace($be857304663aed78$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($be857304663aed78$var$chr1, '!') : UCFullPaths[w]).replace($be857304663aed78$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($be857304663aed78$var$chr1, '!') : UCPaths[w]).replace($be857304663aed78$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $be857304663aed78$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($be857304663aed78$var$has_buf) return $be857304663aed78$require$Buffer.isBuffer(o) ? o : $be857304663aed78$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $be857304663aed78$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($be857304663aed78$var$has_buf) {
            var o = $be857304663aed78$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $be857304663aed78$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $be857304663aed78$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $be857304663aed78$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $be857304663aed78$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $be857304663aed78$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $be857304663aed78$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $be857304663aed78$var$CRC32.bstr(fi.content, 0) : $be857304663aed78$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $be857304663aed78$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $be857304663aed78$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $be857304663aed78$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $be857304663aed78$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $be857304663aed78$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $be857304663aed78$var$bconcat([
            $be857304663aed78$var$bconcat(out /*:any*/ ),
            $be857304663aed78$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $be857304663aed78$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $be857304663aed78$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $be857304663aed78$var$s2a($be857304663aed78$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $be857304663aed78$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $be857304663aed78$var$ReadShift,
        CheckField: $be857304663aed78$var$CheckField,
        prep_blob: $be857304663aed78$var$prep_blob,
        bconcat: $be857304663aed78$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $be857304663aed78$var$_fs;
function $be857304663aed78$export$a48eb669e1768bcf(fs) {
    $be857304663aed78$var$_fs = fs;
}
/* normalize data for blob ctor */ function $be857304663aed78$var$blobify(data) {
    if (typeof data === "string") return $be857304663aed78$var$s2ab(data);
    if (Array.isArray(data)) return $be857304663aed78$var$a2u(data);
    return data;
}
/* write or download file */ function $be857304663aed78$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $be857304663aed78$var$_fs !== 'undefined' && $be857304663aed78$var$_fs.writeFileSync) return enc ? $be857304663aed78$var$_fs.writeFileSync(fname, payload, enc) : $be857304663aed78$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $be857304663aed78$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $be857304663aed78$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $be857304663aed78$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $be857304663aed78$var$Base64_encode_arr(new Uint8Array($be857304663aed78$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $be857304663aed78$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $be857304663aed78$var$read_binary(path /*:string*/ ) {
    if (typeof $be857304663aed78$var$_fs !== 'undefined') return $be857304663aed78$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $be857304663aed78$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $be857304663aed78$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $be857304663aed78$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $be857304663aed78$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $be857304663aed78$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $be857304663aed78$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $be857304663aed78$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $be857304663aed78$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $be857304663aed78$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $be857304663aed78$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $be857304663aed78$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $be857304663aed78$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $be857304663aed78$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $be857304663aed78$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $be857304663aed78$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $be857304663aed78$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $be857304663aed78$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $be857304663aed78$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $be857304663aed78$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $be857304663aed78$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $be857304663aed78$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($be857304663aed78$var$pdre1);
    if (m) return new Date((date1904 ? $be857304663aed78$var$dnthresh2 : $be857304663aed78$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($be857304663aed78$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($be857304663aed78$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $be857304663aed78$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(arr)) {
        if (debomit && $be857304663aed78$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $be857304663aed78$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $be857304663aed78$var$utf8write($be857304663aed78$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $be857304663aed78$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $be857304663aed78$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $be857304663aed78$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $be857304663aed78$var$dup(o[k]);
    return out;
}
function $be857304663aed78$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $be857304663aed78$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $be857304663aed78$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $be857304663aed78$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $be857304663aed78$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $be857304663aed78$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $be857304663aed78$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $be857304663aed78$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $be857304663aed78$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $be857304663aed78$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($be857304663aed78$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $be857304663aed78$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($be857304663aed78$var$FDRE1);
    if (M) return $be857304663aed78$var$fuzzytime1(M);
    M = lnos.match($be857304663aed78$var$FDRE2);
    if (M) return $be857304663aed78$var$fuzzytime2(M);
    M = lnos.match($be857304663aed78$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($be857304663aed78$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $be857304663aed78$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $be857304663aed78$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $be857304663aed78$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $be857304663aed78$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $be857304663aed78$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $be857304663aed78$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $be857304663aed78$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $be857304663aed78$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $be857304663aed78$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$be857304663aed78$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $be857304663aed78$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $be857304663aed78$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $be857304663aed78$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $be857304663aed78$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $be857304663aed78$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $be857304663aed78$var$cc2str(data.content, true);
    if (data.data) return $be857304663aed78$var$debom(data.data);
    if (data.asNodeBuffer && $be857304663aed78$var$has_buf) return $be857304663aed78$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $be857304663aed78$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $be857304663aed78$var$debom($be857304663aed78$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $be857304663aed78$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $be857304663aed78$var$char_codes(data.data);
    if (data.asNodeBuffer && $be857304663aed78$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $be857304663aed78$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $be857304663aed78$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $be857304663aed78$var$getdatabin(data) : $be857304663aed78$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $be857304663aed78$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $be857304663aed78$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $be857304663aed78$var$getzipfile(zip, file /*:string*/ ) {
    var o = $be857304663aed78$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $be857304663aed78$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $be857304663aed78$var$getdata($be857304663aed78$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $be857304663aed78$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $be857304663aed78$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $be857304663aed78$var$getdatastr($be857304663aed78$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $be857304663aed78$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $be857304663aed78$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $be857304663aed78$var$getdatabin($be857304663aed78$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $be857304663aed78$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $be857304663aed78$var$zipentries(zip) {
    var k = zip.FullPaths || $be857304663aed78$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $be857304663aed78$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($be857304663aed78$var$has_buf) res = $be857304663aed78$var$Buffer_from(content);
            else res = $be857304663aed78$var$utf8decode(content);
            return $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $be857304663aed78$var$zip_new() {
    return $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_new();
}
function $be857304663aed78$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $be857304663aed78$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $be857304663aed78$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $be857304663aed78$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $be857304663aed78$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $be857304663aed78$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $be857304663aed78$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $be857304663aed78$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $be857304663aed78$var$tagregex2 = /<[^<>]*>/g;
var $be857304663aed78$var$tagregex = /*#__PURE__*/ $be857304663aed78$var$XML_HEADER.match($be857304663aed78$var$tagregex1) ? $be857304663aed78$var$tagregex1 : $be857304663aed78$var$tagregex2;
var $be857304663aed78$var$nsregex = /<\w*:/, $be857304663aed78$var$nsregex2 = /<(\/?)\w+:/;
function $be857304663aed78$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($be857304663aed78$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $be857304663aed78$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($be857304663aed78$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $be857304663aed78$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($be857304663aed78$var$nsregex2, "<$1");
}
var $be857304663aed78$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $be857304663aed78$var$rencoding = /*#__PURE__*/ $be857304663aed78$var$evert($be857304663aed78$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $be857304663aed78$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $be857304663aed78$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $be857304663aed78$var$decregex = /[&<>'"]/g, $be857304663aed78$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $be857304663aed78$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($be857304663aed78$var$decregex, function(y) {
        return $be857304663aed78$var$rencoding[y];
    }).replace($be857304663aed78$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $be857304663aed78$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $be857304663aed78$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $be857304663aed78$var$htmlcharegex = /[\u0000-\u001f]/g;
function $be857304663aed78$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($be857304663aed78$var$decregex, function(y) {
        return $be857304663aed78$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($be857304663aed78$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $be857304663aed78$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($be857304663aed78$var$decregex, function(y) {
        return $be857304663aed78$var$rencoding[y];
    }).replace($be857304663aed78$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $be857304663aed78$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $be857304663aed78$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $be857304663aed78$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $be857304663aed78$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $be857304663aed78$var$utf8readb(data) {
    var out = $be857304663aed78$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $be857304663aed78$var$utf8readc(data) {
    return $be857304663aed78$var$Buffer_from(data, 'binary').toString('utf8');
}
var $be857304663aed78$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $be857304663aed78$var$utf8read = $be857304663aed78$var$has_buf && /*#__PURE__*/ ($be857304663aed78$var$utf8readc($be857304663aed78$var$utf8corpus) == /*#__PURE__*/ $be857304663aed78$var$utf8reada($be857304663aed78$var$utf8corpus) && $be857304663aed78$var$utf8readc || /*#__PURE__*/ $be857304663aed78$var$utf8readb($be857304663aed78$var$utf8corpus) == /*#__PURE__*/ $be857304663aed78$var$utf8reada($be857304663aed78$var$utf8corpus) && $be857304663aed78$var$utf8readb) || $be857304663aed78$var$utf8reada;
var $be857304663aed78$var$utf8write /*:StringConv*/  = $be857304663aed78$var$has_buf ? function(data) {
    return $be857304663aed78$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $be857304663aed78$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $be857304663aed78$var$vtvregex = /<\/?(?:vt:)?variant>/g, $be857304663aed78$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $be857304663aed78$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $be857304663aed78$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $be857304663aed78$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($be857304663aed78$var$vtvregex, "").match($be857304663aed78$var$vtmregex);
        if (v) res.push({
            v: $be857304663aed78$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $be857304663aed78$var$wtregex = /(^\s|\s$|\n)/;
function $be857304663aed78$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($be857304663aed78$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $be857304663aed78$var$wxt_helper(h) /*:string*/ {
    return $be857304663aed78$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $be857304663aed78$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $be857304663aed78$var$wxt_helper(h) : "") + (g != null ? (g.match($be857304663aed78$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $be857304663aed78$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $be857304663aed78$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $be857304663aed78$var$writextag('vt:lpwstr', $be857304663aed78$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $be857304663aed78$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $be857304663aed78$var$escapexml(String(s)));
        case 'boolean':
            return $be857304663aed78$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $be857304663aed78$var$writextag('vt:filetime', $be857304663aed78$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $be857304663aed78$var$xlml_normalize(d) /*:string*/ {
    if ($be857304663aed78$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $be857304663aed78$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $be857304663aed78$var$utf8read($be857304663aed78$var$a2s($be857304663aed78$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $be857304663aed78$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $be857304663aed78$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $be857304663aed78$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $be857304663aed78$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $be857304663aed78$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $be857304663aed78$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $be857304663aed78$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $be857304663aed78$var$__toBuffer = $be857304663aed78$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $be857304663aed78$require$Buffer.isBuffer(bufs[0][0]) ? $be857304663aed78$require$Buffer.concat(bufs[0].map(function(x) {
        return $be857304663aed78$require$Buffer.isBuffer(x) ? x : $be857304663aed78$var$Buffer_from(x);
    })) : $be857304663aed78$var$___toBuffer(bufs);
} : $be857304663aed78$var$___toBuffer;
var $be857304663aed78$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($be857304663aed78$var$__readUInt16LE(b, i)));
    return ss.join("").replace($be857304663aed78$var$chr0, '');
};
var $be857304663aed78$var$__utf16le = $be857304663aed78$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$be857304663aed78$require$Buffer.isBuffer(b) || !$be857304663aed78$var$buf_utf16le) return $be857304663aed78$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($be857304663aed78$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $be857304663aed78$var$___utf16le;
var $be857304663aed78$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $be857304663aed78$var$__hexlify = $be857304663aed78$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $be857304663aed78$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $be857304663aed78$var$___hexlify(b, s, l);
} : $be857304663aed78$var$___hexlify;
var $be857304663aed78$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($be857304663aed78$var$__readUInt8(b, i)));
    return ss.join("");
};
var $be857304663aed78$var$__utf8 = $be857304663aed78$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $be857304663aed78$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $be857304663aed78$var$___utf8(b, s, e);
} : $be857304663aed78$var$___utf8;
var $be857304663aed78$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $be857304663aed78$var$__readUInt32LE(b, i);
    return len > 0 ? $be857304663aed78$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $be857304663aed78$var$__lpstr = $be857304663aed78$var$___lpstr;
var $be857304663aed78$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $be857304663aed78$var$__readUInt32LE(b, i);
    return len > 0 ? $be857304663aed78$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $be857304663aed78$var$__cpstr = $be857304663aed78$var$___cpstr;
var $be857304663aed78$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $be857304663aed78$var$__readUInt32LE(b, i);
    return len > 0 ? $be857304663aed78$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $be857304663aed78$var$__lpwstr = $be857304663aed78$var$___lpwstr;
var $be857304663aed78$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $be857304663aed78$var$__readUInt32LE(b, i);
    return len > 0 ? $be857304663aed78$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $be857304663aed78$var$__lpp4 = $be857304663aed78$var$___lpp4;
var $be857304663aed78$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $be857304663aed78$var$__readUInt32LE(b, i);
    return len > 0 ? $be857304663aed78$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $be857304663aed78$var$__8lpp4 = $be857304663aed78$var$___8lpp4;
var $be857304663aed78$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $be857304663aed78$var$read_double_le(b, idx);
};
var $be857304663aed78$var$__double = $be857304663aed78$var$___double;
var $be857304663aed78$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($be857304663aed78$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $be857304663aed78$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$be857304663aed78$require$Buffer.isBuffer(b)) return $be857304663aed78$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $be857304663aed78$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$be857304663aed78$require$Buffer.isBuffer(b)) return $be857304663aed78$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $be857304663aed78$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$be857304663aed78$require$Buffer.isBuffer(b) || !$be857304663aed78$var$buf_utf16le) return $be857304663aed78$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $be857304663aed78$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$be857304663aed78$require$Buffer.isBuffer(b) || !$be857304663aed78$var$buf_utf16le) return $be857304663aed78$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $be857304663aed78$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$be857304663aed78$require$Buffer.isBuffer(b)) return $be857304663aed78$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $be857304663aed78$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($be857304663aed78$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $be857304663aed78$var$___double(b, i);
    };
    $be857304663aed78$var$is_buf = function is_buf_b(a) {
        return $be857304663aed78$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $be857304663aed78$var$cpdoit() {
    $be857304663aed78$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $be857304663aed78$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($be857304663aed78$var$chr0, '');
    };
    $be857304663aed78$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $be857304663aed78$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $be857304663aed78$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $be857304663aed78$var$__readUInt32LE(b, i);
        return len > 0 ? $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $be857304663aed78$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $be857304663aed78$var$__readUInt32LE(b, i);
        return len > 0 ? $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $be857304663aed78$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $be857304663aed78$var$__readUInt32LE(b, i);
        return len > 0 ? $be857304663aed78$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $be857304663aed78$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $be857304663aed78$var$__readUInt32LE(b, i);
        return len > 0 ? $be857304663aed78$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $be857304663aed78$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $be857304663aed78$var$__readUInt32LE(b, i);
        return len > 0 ? $be857304663aed78$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $be857304663aed78$var$$cptable !== 'undefined') $be857304663aed78$var$cpdoit();
var $be857304663aed78$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $be857304663aed78$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $be857304663aed78$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $be857304663aed78$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $be857304663aed78$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $be857304663aed78$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $be857304663aed78$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(this) && $be857304663aed78$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($be857304663aed78$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $be857304663aed78$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $be857304663aed78$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $be857304663aed78$var$$cptable !== 'undefined') o = $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $be857304663aed78$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $be857304663aed78$var$__lpstr(this, this.l);
            size = 4 + $be857304663aed78$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $be857304663aed78$var$__cpstr(this, this.l);
            size = 4 + $be857304663aed78$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $be857304663aed78$var$__lpwstr(this, this.l);
            size = 4 + 2 * $be857304663aed78$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $be857304663aed78$var$__readUInt32LE(this, this.l);
            o = $be857304663aed78$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $be857304663aed78$var$__readUInt32LE(this, this.l);
            o = $be857304663aed78$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $be857304663aed78$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($be857304663aed78$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $be857304663aed78$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($be857304663aed78$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $be857304663aed78$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $be857304663aed78$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($be857304663aed78$var$_getchar($be857304663aed78$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $be857304663aed78$var$$cptable !== 'undefined') {
                o = $be857304663aed78$var$$cptable.utils.decode($be857304663aed78$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $be857304663aed78$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $be857304663aed78$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($be857304663aed78$var$_getchar($be857304663aed78$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $be857304663aed78$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $be857304663aed78$var$__readInt16LE : $be857304663aed78$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $be857304663aed78$var$__readInt32LE : $be857304663aed78$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $be857304663aed78$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $be857304663aed78$var$__double(this, this.l);
                        else oR = $be857304663aed78$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $be857304663aed78$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $be857304663aed78$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $be857304663aed78$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $be857304663aed78$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $be857304663aed78$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$be857304663aed78$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $be857304663aed78$var$$cptable !== 'undefined' && $be857304663aed78$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $be857304663aed78$var$$cptable.utils.encode($be857304663aed78$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $be857304663aed78$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $be857304663aed78$var$$cptable.utils.encode($be857304663aed78$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $be857304663aed78$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $be857304663aed78$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $be857304663aed78$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $be857304663aed78$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $be857304663aed78$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $be857304663aed78$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $be857304663aed78$var$ReadShift /*:: :any)*/ ;
    blob.chk = $be857304663aed78$var$CheckField;
    blob.write_shift = $be857304663aed78$var$WriteShift;
}
function $be857304663aed78$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $be857304663aed78$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $be857304663aed78$var$new_raw_buf(sz);
    $be857304663aed78$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $be857304663aed78$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $be857304663aed78$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $be857304663aed78$var$XLSBRecordEnum[RT] || $be857304663aed78$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $be857304663aed78$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $be857304663aed78$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $be857304663aed78$var$has_buf && typeof $be857304663aed78$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $be857304663aed78$var$new_buf(sz);
        $be857304663aed78$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $be857304663aed78$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $be857304663aed78$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $be857304663aed78$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $be857304663aed78$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $be857304663aed78$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $be857304663aed78$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $be857304663aed78$var$shift_range_xls(cell, range, opts) {
    var out = $be857304663aed78$var$dup(cell);
    out.s = $be857304663aed78$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $be857304663aed78$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $be857304663aed78$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $be857304663aed78$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $be857304663aed78$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $be857304663aed78$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $be857304663aed78$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $be857304663aed78$var$fix_row(s);
    return s;
}
function $be857304663aed78$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $be857304663aed78$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $be857304663aed78$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $be857304663aed78$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $be857304663aed78$var$encode_row(r.e.r);
    }
    return $be857304663aed78$var$encode_cell_xls(r.s, opts.biff) + ":" + $be857304663aed78$var$encode_cell_xls(r.e, opts.biff);
}
function $be857304663aed78$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($be857304663aed78$var$unfix_row(rowstr), 10) - 1;
}
function $be857304663aed78$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $be857304663aed78$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $be857304663aed78$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $be857304663aed78$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $be857304663aed78$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $be857304663aed78$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $be857304663aed78$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $be857304663aed78$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $be857304663aed78$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $be857304663aed78$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $be857304663aed78$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $be857304663aed78$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $be857304663aed78$var$decode_cell(range),
        e: $be857304663aed78$var$decode_cell(range)
    };
    return {
        s: $be857304663aed78$var$decode_cell(range.slice(0, idx)),
        e: $be857304663aed78$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $be857304663aed78$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $be857304663aed78$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $be857304663aed78$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $be857304663aed78$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $be857304663aed78$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $be857304663aed78$var$decode_range(a1);
    return "$" + $be857304663aed78$var$encode_col(s.s.c) + "$" + $be857304663aed78$var$encode_row(s.s.r) + ":$" + $be857304663aed78$var$encode_col(s.e.c) + "$" + $be857304663aed78$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $be857304663aed78$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $be857304663aed78$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $be857304663aed78$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $be857304663aed78$var$SSF_format(cell.z, q ? $be857304663aed78$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $be857304663aed78$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $be857304663aed78$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $be857304663aed78$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $be857304663aed78$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $be857304663aed78$var$safe_format_cell(cell, cell.v);
    return $be857304663aed78$var$safe_format_cell(cell, v);
}
function $be857304663aed78$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $be857304663aed78$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $be857304663aed78$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($be857304663aed78$var$DENSE != null && dense == null) dense = $be857304663aed78$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $be857304663aed78$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $be857304663aed78$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $be857304663aed78$var$table_fmt[14];
                    if (!o.UTC) cell.v = $be857304663aed78$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $be857304663aed78$var$SSF_format(cell.z, $be857304663aed78$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $be857304663aed78$var$datenum(cell.v, o.date1904);
                        cell.w = $be857304663aed78$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $be857304663aed78$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $be857304663aed78$var$encode_range(range);
    return ws;
}
function $be857304663aed78$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $be857304663aed78$var$sheet_add_aoa(null, data, opts);
}
function $be857304663aed78$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $be857304663aed78$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $be857304663aed78$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $be857304663aed78$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $be857304663aed78$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $be857304663aed78$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $be857304663aed78$var$write_StrRun(run, o) {
    if (!o) o = $be857304663aed78$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $be857304663aed78$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $be857304663aed78$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($be857304663aed78$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $be857304663aed78$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $be857304663aed78$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $be857304663aed78$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $be857304663aed78$var$parse_BrtCommentText = $be857304663aed78$var$parse_RichStr;
function $be857304663aed78$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $be857304663aed78$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $be857304663aed78$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $be857304663aed78$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $be857304663aed78$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $be857304663aed78$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $be857304663aed78$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $be857304663aed78$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $be857304663aed78$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $be857304663aed78$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $be857304663aed78$var$parse_XLSBCodeName = $be857304663aed78$var$parse_XLWideString;
var $be857304663aed78$var$write_XLSBCodeName = $be857304663aed78$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $be857304663aed78$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $be857304663aed78$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $be857304663aed78$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $be857304663aed78$var$parse_XLNameWideString = $be857304663aed78$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $be857304663aed78$var$parse_RelID = $be857304663aed78$var$parse_XLNullableWideString;
var $be857304663aed78$var$write_RelID = $be857304663aed78$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $be857304663aed78$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $be857304663aed78$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $be857304663aed78$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $be857304663aed78$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $be857304663aed78$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $be857304663aed78$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $be857304663aed78$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $be857304663aed78$var$parse_UncheckedRfX = $be857304663aed78$var$parse_RfX;
var $be857304663aed78$var$write_UncheckedRfX = $be857304663aed78$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $be857304663aed78$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $be857304663aed78$var$write_Xnum(data, o) {
    return (o || $be857304663aed78$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $be857304663aed78$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $be857304663aed78$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $be857304663aed78$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $be857304663aed78$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $be857304663aed78$var$write_BrtColor(color, o) {
    if (!o) o = $be857304663aed78$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $be857304663aed78$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $be857304663aed78$var$write_FontFlags(font, o) {
    if (!o) o = $be857304663aed78$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $be857304663aed78$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $be857304663aed78$var$parse_ClipboardFormatOrAnsiString(o) {
    return $be857304663aed78$var$parse_ClipboardFormatOrString(o, 1);
}
function $be857304663aed78$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $be857304663aed78$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $be857304663aed78$var$VT_I2 = 0x0002;
var $be857304663aed78$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $be857304663aed78$var$VT_BOOL = 0x000B;
var $be857304663aed78$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $be857304663aed78$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $be857304663aed78$var$VT_FILETIME = 0x0040;
var $be857304663aed78$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $be857304663aed78$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $be857304663aed78$var$VT_VECTOR_VARIANT = 0x100C;
var $be857304663aed78$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $be857304663aed78$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $be857304663aed78$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $be857304663aed78$var$VT_CUSTOM = [
    $be857304663aed78$var$VT_STRING,
    $be857304663aed78$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $be857304663aed78$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $be857304663aed78$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $be857304663aed78$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $be857304663aed78$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $be857304663aed78$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $be857304663aed78$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $be857304663aed78$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $be857304663aed78$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $be857304663aed78$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $be857304663aed78$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $be857304663aed78$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $be857304663aed78$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $be857304663aed78$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $be857304663aed78$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $be857304663aed78$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $be857304663aed78$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $be857304663aed78$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $be857304663aed78$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $be857304663aed78$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $be857304663aed78$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $be857304663aed78$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $be857304663aed78$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $be857304663aed78$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $be857304663aed78$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $be857304663aed78$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $be857304663aed78$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $be857304663aed78$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $be857304663aed78$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $be857304663aed78$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $be857304663aed78$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $be857304663aed78$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $be857304663aed78$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $be857304663aed78$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $be857304663aed78$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $be857304663aed78$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $be857304663aed78$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $be857304663aed78$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $be857304663aed78$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $be857304663aed78$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $be857304663aed78$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $be857304663aed78$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $be857304663aed78$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $be857304663aed78$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $be857304663aed78$var$_XLSIcv = /*#__PURE__*/ $be857304663aed78$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $be857304663aed78$var$XLSIcv = /*#__PURE__*/ $be857304663aed78$var$dup($be857304663aed78$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $be857304663aed78$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $be857304663aed78$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $be857304663aed78$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $be857304663aed78$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $be857304663aed78$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $be857304663aed78$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $be857304663aed78$var$parse_ct(data /*:?string*/ ) {
    var ct = $be857304663aed78$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch(y[0].replace($be857304663aed78$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$be857304663aed78$var$ct2type[y.ContentType]] !== undefined) ct[$be857304663aed78$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $be857304663aed78$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $be857304663aed78$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $be857304663aed78$var$evert_arr($be857304663aed78$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $be857304663aed78$var$XML_HEADER;
        o[o.length] = $be857304663aed78$var$writextag('Types', null, {
            'xmlns': $be857304663aed78$var$XMLNS.CT,
            'xmlns:xsd': $be857304663aed78$var$XMLNS.xsd,
            'xmlns:xsi': $be857304663aed78$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $be857304663aed78$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $be857304663aed78$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $be857304663aed78$var$CT_LIST[w][opts.bookType] || $be857304663aed78$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $be857304663aed78$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $be857304663aed78$var$CT_LIST[w][opts.bookType] || $be857304663aed78$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $be857304663aed78$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $be857304663aed78$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $be857304663aed78$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $be857304663aed78$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $be857304663aed78$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $be857304663aed78$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $be857304663aed78$var$write_rels(rels) /*:string*/ {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $be857304663aed78$var$XMLNS.RELS
        })
    ];
    $be857304663aed78$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $be857304663aed78$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $be857304663aed78$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $be857304663aed78$var$RELS.HLINK,
        $be857304663aed78$var$RELS.XPATH,
        $be857304663aed78$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $be857304663aed78$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $be857304663aed78$var$parse_manifest(d, opts) {
    var str = $be857304663aed78$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $be857304663aed78$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $be857304663aed78$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $be857304663aed78$var$write_manifest(manifest) {
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $be857304663aed78$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $be857304663aed78$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $be857304663aed78$var$write_rdf(rdf) {
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($be857304663aed78$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($be857304663aed78$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($be857304663aed78$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $be857304663aed78$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $be857304663aed78$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $be857304663aed78$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $be857304663aed78$var$parse_core_props(data) {
    var p = {};
    data = $be857304663aed78$var$utf8read(data);
    for(var i = 0; i < $be857304663aed78$var$CORE_PROPS.length; ++i){
        var f = $be857304663aed78$var$CORE_PROPS[i], cur = $be857304663aed78$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $be857304663aed78$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $be857304663aed78$var$parseDate(p[f[1]]);
    }
    return p;
}
function $be857304663aed78$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $be857304663aed78$var$escapexml(g);
    o[o.length] = h ? $be857304663aed78$var$writextag(f, g, h) : $be857304663aed78$var$writetag(f, g);
}
function $be857304663aed78$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $be857304663aed78$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $be857304663aed78$var$XMLNS.dc,
            'xmlns:dcterms': $be857304663aed78$var$XMLNS.dcterms,
            'xmlns:dcmitype': $be857304663aed78$var$XMLNS.dcmitype,
            'xmlns:xsi': $be857304663aed78$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $be857304663aed78$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $be857304663aed78$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $be857304663aed78$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $be857304663aed78$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $be857304663aed78$var$CORE_PROPS.length; ++i){
        var f = $be857304663aed78$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $be857304663aed78$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $be857304663aed78$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $be857304663aed78$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $be857304663aed78$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $be857304663aed78$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $be857304663aed78$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $be857304663aed78$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $be857304663aed78$var$utf8read(data);
    $be857304663aed78$var$EXT_PROPS.forEach(function(f) {
        var xml = ($be857304663aed78$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $be857304663aed78$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $be857304663aed78$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $be857304663aed78$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $be857304663aed78$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $be857304663aed78$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $be857304663aed78$var$XML_HEADER;
    o[o.length] = $be857304663aed78$var$writextag('Properties', null, {
        'xmlns': $be857304663aed78$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $be857304663aed78$var$XMLNS.vt
    });
    $be857304663aed78$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $be857304663aed78$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $be857304663aed78$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $be857304663aed78$var$custregex = /<[^<>]+>[^<]*/g;
function $be857304663aed78$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($be857304663aed78$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $be857304663aed78$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $be857304663aed78$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $be857304663aed78$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $be857304663aed78$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $be857304663aed78$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $be857304663aed78$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('Properties', null, {
            'xmlns': $be857304663aed78$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $be857304663aed78$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $be857304663aed78$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $be857304663aed78$var$writextag('property', $be857304663aed78$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $be857304663aed78$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $be857304663aed78$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $be857304663aed78$var$evert_XLMLDPM;
function $be857304663aed78$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$be857304663aed78$var$evert_XLMLDPM) $be857304663aed78$var$evert_XLMLDPM = $be857304663aed78$var$evert($be857304663aed78$var$XLMLDocPropsMap);
    tag = $be857304663aed78$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $be857304663aed78$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $be857304663aed78$var$keys($be857304663aed78$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $be857304663aed78$var$CORE_PROPS.length; ++i)if ($be857304663aed78$var$CORE_PROPS[i][1] == m) return $be857304663aed78$var$CORE_PROPS[i];
        for(i = 0; i < $be857304663aed78$var$EXT_PROPS.length; ++i)if ($be857304663aed78$var$EXT_PROPS[i][1] == m) return $be857304663aed78$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($be857304663aed78$var$writetag($be857304663aed78$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $be857304663aed78$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $be857304663aed78$var$XLMLNS.o
    });
}
function $be857304663aed78$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $be857304663aed78$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $be857304663aed78$var$CORE_PROPS.length; ++i)if (k == $be857304663aed78$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $be857304663aed78$var$EXT_PROPS.length; ++i)if (k == $be857304663aed78$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($be857304663aed78$var$writextag($be857304663aed78$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $be857304663aed78$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($be857304663aed78$var$writextag($be857304663aed78$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $be857304663aed78$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $be857304663aed78$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $be857304663aed78$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $be857304663aed78$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $be857304663aed78$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $be857304663aed78$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $be857304663aed78$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $be857304663aed78$var$parse_lpwstr(blob);
    return $be857304663aed78$var$parse_lpstr(blob, stringType, pad);
}
function $be857304663aed78$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $be857304663aed78$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $be857304663aed78$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $be857304663aed78$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $be857304663aed78$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($be857304663aed78$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $be857304663aed78$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($be857304663aed78$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $be857304663aed78$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $be857304663aed78$var$parse_TypedPropertyValue(blob, $be857304663aed78$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $be857304663aed78$var$parse_TypedPropertyValue(blob, $be857304663aed78$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $be857304663aed78$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($be857304663aed78$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $be857304663aed78$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($be857304663aed78$var$chr0, '').replace($be857304663aed78$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $be857304663aed78$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $be857304663aed78$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $be857304663aed78$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $be857304663aed78$var$VT_VARIANT) {
        if (t !== type && $be857304663aed78$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $be857304663aed78$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $be857304663aed78$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $be857304663aed78$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $be857304663aed78$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $be857304663aed78$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $be857304663aed78$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $be857304663aed78$var$parse_VtString(blob, t, !opts.raw).replace($be857304663aed78$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $be857304663aed78$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($be857304663aed78$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $be857304663aed78$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $be857304663aed78$var$parse_VtVecLpwstrValue(blob) : $be857304663aed78$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $be857304663aed78$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $be857304663aed78$var$new_buf(4), p = $be857304663aed78$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $be857304663aed78$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $be857304663aed78$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $be857304663aed78$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $be857304663aed78$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $be857304663aed78$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $be857304663aed78$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $be857304663aed78$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $be857304663aed78$var$parse_TypedPropertyValue(blob, $be857304663aed78$var$VT_I2);
                $be857304663aed78$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $be857304663aed78$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $be857304663aed78$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $be857304663aed78$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $be857304663aed78$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $be857304663aed78$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $be857304663aed78$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $be857304663aed78$var$parseDate($be857304663aed78$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $be857304663aed78$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $be857304663aed78$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $be857304663aed78$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $be857304663aed78$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $be857304663aed78$var$new_buf(8), pio = $be857304663aed78$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $be857304663aed78$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $be857304663aed78$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $be857304663aed78$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $be857304663aed78$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($be857304663aed78$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $be857304663aed78$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $be857304663aed78$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $be857304663aed78$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $be857304663aed78$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $be857304663aed78$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $be857304663aed78$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $be857304663aed78$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $be857304663aed78$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $be857304663aed78$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $be857304663aed78$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $be857304663aed78$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $be857304663aed78$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $be857304663aed78$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $be857304663aed78$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $be857304663aed78$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $be857304663aed78$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $be857304663aed78$var$bconcat(bufs);
}
function $be857304663aed78$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $be857304663aed78$var$writezeroes(n, o) {
    if (!o) o = $be857304663aed78$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $be857304663aed78$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $be857304663aed78$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $be857304663aed78$var$writebool(v /*:any*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $be857304663aed78$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $be857304663aed78$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $be857304663aed78$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $be857304663aed78$var$parslurp(blob, length, $be857304663aed78$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $be857304663aed78$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $be857304663aed78$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $be857304663aed78$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $be857304663aed78$var$current_codepage;
    if (opts && opts.biff >= 8) $be857304663aed78$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $be857304663aed78$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $be857304663aed78$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $be857304663aed78$var$current_codepage;
    $be857304663aed78$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $be857304663aed78$var$current_codepage = cp;
    return z;
}
function $be857304663aed78$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $be857304663aed78$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $be857304663aed78$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $be857304663aed78$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $be857304663aed78$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $be857304663aed78$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $be857304663aed78$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $be857304663aed78$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $be857304663aed78$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $be857304663aed78$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $be857304663aed78$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($be857304663aed78$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $be857304663aed78$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($be857304663aed78$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $be857304663aed78$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $be857304663aed78$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $be857304663aed78$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $be857304663aed78$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($be857304663aed78$var$chr0, "") : "";
    return o;
}
function $be857304663aed78$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $be857304663aed78$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $be857304663aed78$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $be857304663aed78$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $be857304663aed78$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $be857304663aed78$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $be857304663aed78$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $be857304663aed78$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $be857304663aed78$var$write_Hyperlink(hl) {
    var out = $be857304663aed78$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $be857304663aed78$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $be857304663aed78$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $be857304663aed78$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $be857304663aed78$var$parse_LongRGB(blob, length) {
    var x = $be857304663aed78$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $be857304663aed78$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $be857304663aed78$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $be857304663aed78$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $be857304663aed78$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $be857304663aed78$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $be857304663aed78$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $be857304663aed78$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $be857304663aed78$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $be857304663aed78$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $be857304663aed78$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $be857304663aed78$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $be857304663aed78$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $be857304663aed78$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $be857304663aed78$var$parse_Ref = $be857304663aed78$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $be857304663aed78$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $be857304663aed78$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $be857304663aed78$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $be857304663aed78$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $be857304663aed78$var$FtTab = {
    0x00: $be857304663aed78$var$parse_FtSkip,
    /* FtEnd */ 0x04: $be857304663aed78$var$parse_FtSkip,
    /* FtMacro */ 0x05: $be857304663aed78$var$parse_FtSkip,
    /* FtButton */ 0x06: $be857304663aed78$var$parse_FtSkip,
    /* FtGmo */ 0x07: $be857304663aed78$var$parse_FtCf,
    /* FtCf */ 0x08: $be857304663aed78$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $be857304663aed78$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $be857304663aed78$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $be857304663aed78$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $be857304663aed78$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $be857304663aed78$var$parse_FtNts,
    /* FtNts */ 0x0E: $be857304663aed78$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $be857304663aed78$var$parse_FtSkip,
    /* FtGboData */ 0x10: $be857304663aed78$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $be857304663aed78$var$parse_FtSkip,
    /* FtRboData */ 0x12: $be857304663aed78$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $be857304663aed78$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $be857304663aed78$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $be857304663aed78$var$parse_FtCmo
};
function $be857304663aed78$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $be857304663aed78$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $be857304663aed78$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $be857304663aed78$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $be857304663aed78$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $be857304663aed78$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $be857304663aed78$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $be857304663aed78$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $be857304663aed78$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $be857304663aed78$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $be857304663aed78$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $be857304663aed78$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $be857304663aed78$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $be857304663aed78$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $be857304663aed78$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $be857304663aed78$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $be857304663aed78$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($be857304663aed78$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $be857304663aed78$var$write_SST(sst, opts) {
    var header = $be857304663aed78$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $be857304663aed78$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $be857304663aed78$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $be857304663aed78$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $be857304663aed78$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $be857304663aed78$var$parse_ForceFullCalculation(blob) {
    var header = $be857304663aed78$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $be857304663aed78$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $be857304663aed78$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $be857304663aed78$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $be857304663aed78$var$write_Window1() {
    var o = $be857304663aed78$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $be857304663aed78$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $be857304663aed78$var$write_Window2(view) {
    var o = $be857304663aed78$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $be857304663aed78$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $be857304663aed78$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $be857304663aed78$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $be857304663aed78$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $be857304663aed78$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $be857304663aed78$var$parse_LabelSst(blob, length, opts) {
    var cell = $be857304663aed78$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $be857304663aed78$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $be857304663aed78$var$new_buf(10);
    $be857304663aed78$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $be857304663aed78$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, length, opts);
    var str = $be857304663aed78$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $be857304663aed78$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $be857304663aed78$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $be857304663aed78$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $be857304663aed78$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $be857304663aed78$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $be857304663aed78$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $be857304663aed78$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $be857304663aed78$var$parse_BIFF2Format = $be857304663aed78$var$parse_XLUnicodeString2;
function $be857304663aed78$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $be857304663aed78$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $be857304663aed78$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $be857304663aed78$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $be857304663aed78$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $be857304663aed78$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $be857304663aed78$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $be857304663aed78$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $be857304663aed78$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $be857304663aed78$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($be857304663aed78$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $be857304663aed78$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $be857304663aed78$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $be857304663aed78$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $be857304663aed78$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $be857304663aed78$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $be857304663aed78$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $be857304663aed78$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $be857304663aed78$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $be857304663aed78$var$write_BIFF2XF(xf) {
    var o = $be857304663aed78$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $be857304663aed78$var$write_BIFF3XF(xf) {
    var o = $be857304663aed78$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $be857304663aed78$var$write_BIFF4XF = $be857304663aed78$var$write_BIFF3XF;
function $be857304663aed78$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $be857304663aed78$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $be857304663aed78$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $be857304663aed78$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $be857304663aed78$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $be857304663aed78$var$parse_BoolErr(blob, length, opts) {
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 6, opts);
    var val1 = $be857304663aed78$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $be857304663aed78$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $be857304663aed78$var$new_buf(8);
    $be857304663aed78$var$write_XLSCell(R, C, os, o);
    $be857304663aed78$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $be857304663aed78$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 6, opts);
    var xnum = $be857304663aed78$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $be857304663aed78$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $be857304663aed78$var$new_buf(14);
    $be857304663aed78$var$write_XLSCell(R, C, os, o);
    $be857304663aed78$var$write_Xnum(v, o);
    return o;
}
var $be857304663aed78$var$parse_XLHeaderFooter = $be857304663aed78$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $be857304663aed78$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($be857304663aed78$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $be857304663aed78$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $be857304663aed78$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $be857304663aed78$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $be857304663aed78$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $be857304663aed78$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $be857304663aed78$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $be857304663aed78$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $be857304663aed78$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($be857304663aed78$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $be857304663aed78$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $be857304663aed78$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $be857304663aed78$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $be857304663aed78$var$parse_ShrFmla(blob, length, opts) {
    var ref = $be857304663aed78$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $be857304663aed78$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $be857304663aed78$var$parse_Array(blob, length, opts) {
    var ref = $be857304663aed78$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $be857304663aed78$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $be857304663aed78$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $be857304663aed78$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $be857304663aed78$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $be857304663aed78$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $be857304663aed78$var$parse_NoteSh(blob, length, opts);
}
function $be857304663aed78$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $be857304663aed78$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $be857304663aed78$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($be857304663aed78$var$parse_Ref8U(blob, length));
    return merges;
}
function $be857304663aed78$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $be857304663aed78$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$be857304663aed78$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $be857304663aed78$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $be857304663aed78$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $be857304663aed78$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $be857304663aed78$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $be857304663aed78$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $be857304663aed78$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($be857304663aed78$var$parse_BIFF5OT[ot] || $be857304663aed78$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $be857304663aed78$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $be857304663aed78$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $be857304663aed78$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $be857304663aed78$var$parse_HLink(blob, length) {
    var ref = $be857304663aed78$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $be857304663aed78$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $be857304663aed78$var$write_HLink(hl) {
    var O = $be857304663aed78$var$new_buf(24);
    var ref = $be857304663aed78$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $be857304663aed78$var$bconcat([
        O,
        $be857304663aed78$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $be857304663aed78$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $be857304663aed78$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($be857304663aed78$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $be857304663aed78$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $be857304663aed78$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $be857304663aed78$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $be857304663aed78$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $be857304663aed78$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $be857304663aed78$var$CountryEnum[d] || d;
    return o;
}
function $be857304663aed78$var$write_Country(o) {
    if (!o) o = $be857304663aed78$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $be857304663aed78$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($be857304663aed78$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $be857304663aed78$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($be857304663aed78$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $be857304663aed78$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $be857304663aed78$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $be857304663aed78$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $be857304663aed78$var$write_ColInfo(col, idx) {
    var o = $be857304663aed78$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $be857304663aed78$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $be857304663aed78$var$parse_Xnum(blob, 8);
    o.footer = $be857304663aed78$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $be857304663aed78$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $be857304663aed78$var$write_RRTabId(n /*:number*/ ) {
    var out = $be857304663aed78$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $be857304663aed78$var$parse_Blank = $be857304663aed78$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $be857304663aed78$var$parse_Scl = $be857304663aed78$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $be857304663aed78$var$parse_String = $be857304663aed78$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $be857304663aed78$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $be857304663aed78$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $be857304663aed78$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $be857304663aed78$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 7, opts);
    var str = $be857304663aed78$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $be857304663aed78$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 7, opts);
    var num = $be857304663aed78$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $be857304663aed78$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $be857304663aed78$var$new_buf(15);
    $be857304663aed78$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $be857304663aed78$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $be857304663aed78$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $be857304663aed78$var$new_buf(9);
    $be857304663aed78$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $be857304663aed78$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $be857304663aed78$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $be857304663aed78$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $be857304663aed78$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $be857304663aed78$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $be857304663aed78$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $be857304663aed78$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $be857304663aed78$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $be857304663aed78$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $be857304663aed78$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $be857304663aed78$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $be857304663aed78$var$s2a($be857304663aed78$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $be857304663aed78$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $be857304663aed78$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $be857304663aed78$var$$cptable !== "undefined" ? $be857304663aed78$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $be857304663aed78$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $be857304663aed78$var$prep_blob(dd, 0);
                var s = typeof $be857304663aed78$var$$cptable !== "undefined" ? $be857304663aed78$var$$cptable.utils.decode(current_cp, dd) : $be857304663aed78$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $be857304663aed78$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $be857304663aed78$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $be857304663aed78$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $be857304663aed78$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $be857304663aed78$var$current_codepage;
        if (+o.codepage >= 0) $be857304663aed78$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $be857304663aed78$var$buf_array();
        var aoa /*:AOA*/  = $be857304663aed78$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $be857304663aed78$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $be857304663aed78$var$$cptable !== "undefined" && typeof col[j] == "string" ? $be857304663aed78$var$$cptable.utils.encode($be857304663aed78$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $be857304663aed78$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $be857304663aed78$var$current_codepage + ", using 1252");
            $be857304663aed78$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $be857304663aed78$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $be857304663aed78$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $be857304663aed78$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $be857304663aed78$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $be857304663aed78$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $be857304663aed78$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($be857304663aed78$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(d) ? d.toString('binary') : $be857304663aed78$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($be857304663aed78$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $be857304663aed78$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $be857304663aed78$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $be857304663aed78$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $be857304663aed78$var$RBErr[val1];
                            } else if (!isNaN($be857304663aed78$var$fuzzynum(val1))) {
                                val1 = $be857304663aed78$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $be857304663aed78$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $be857304663aed78$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $be857304663aed78$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $be857304663aed78$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $be857304663aed78$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $be857304663aed78$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $be857304663aed78$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $be857304663aed78$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $be857304663aed78$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $be857304663aed78$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $be857304663aed78$var$aoa_to_sheet(aoa, _opts);
        $be857304663aed78$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $be857304663aed78$var$sheet_to_workbook(o, opts);
        $be857304663aed78$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $be857304663aed78$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $be857304663aed78$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $be857304663aed78$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $be857304663aed78$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $be857304663aed78$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $be857304663aed78$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $be857304663aed78$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $be857304663aed78$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($be857304663aed78$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(d) ? d.toString('binary') : $be857304663aed78$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($be857304663aed78$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($be857304663aed78$var$fuzzynum(value))) arr[R][C] = $be857304663aed78$var$fuzzynum(value);
                    else if (!isNaN($be857304663aed78$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $be857304663aed78$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $be857304663aed78$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($be857304663aed78$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $be857304663aed78$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $be857304663aed78$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $be857304663aed78$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $be857304663aed78$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$be857304663aed78$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $be857304663aed78$var$SSF_format(cell.z || $be857304663aed78$var$table_fmt[14], $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $be857304663aed78$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $be857304663aed78$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $be857304663aed78$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $be857304663aed78$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $be857304663aed78$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $be857304663aed78$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $be857304663aed78$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $be857304663aed78$var$SSF_format(cell.z || $be857304663aed78$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $be857304663aed78$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $be857304663aed78$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($be857304663aed78$var$fuzzynum(data))) arr[R][C] = $be857304663aed78$var$fuzzynum(data);
        else if (!isNaN($be857304663aed78$var$fuzzydate(data).getDate())) arr[R][C] = $be857304663aed78$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $be857304663aed78$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $be857304663aed78$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($be857304663aed78$var$DENSE != null && o.dense == null) o.dense = $be857304663aed78$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $be857304663aed78$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($be857304663aed78$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $be857304663aed78$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $be857304663aed78$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $be857304663aed78$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $be857304663aed78$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $be857304663aed78$var$parseDate(news);
                    if (o && o.UTC === false) v = $be857304663aed78$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $be857304663aed78$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $be857304663aed78$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $be857304663aed78$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $be857304663aed78$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $be857304663aed78$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$be857304663aed78$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $be857304663aed78$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $be857304663aed78$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $be857304663aed78$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $be857304663aed78$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $be857304663aed78$var$$cptable !== 'undefined') str = $be857304663aed78$var$$cptable.utils.decode(opts.codepage, d);
                else str = $be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(d) ? d.toString('binary') : $be857304663aed78$var$a2s(d);
                break;
            case 'array':
                str = $be857304663aed78$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $be857304663aed78$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $be857304663aed78$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $be857304663aed78$var$$cptable !== 'undefined' && opts.codepage) str = $be857304663aed78$var$$cptable.utils.decode(opts.codepage, $be857304663aed78$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $be857304663aed78$var$ETH.to_sheet(opts.type == 'string' ? str : $be857304663aed78$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $be857304663aed78$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $be857304663aed78$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $be857304663aed78$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($be857304663aed78$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $be857304663aed78$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $be857304663aed78$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $be857304663aed78$var$PRN.to_workbook(d, opts);
    }
}
var $be857304663aed78$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $be857304663aed78$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($be857304663aed78$var$s2a($be857304663aed78$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($be857304663aed78$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($be857304663aed78$var$DENSE != null && o.dense == null) o.dense = $be857304663aed78$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $be857304663aed78$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $be857304663aed78$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $be857304663aed78$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$be857304663aed78$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$be857304663aed78$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $be857304663aed78$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $be857304663aed78$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$be857304663aed78$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $be857304663aed78$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $be857304663aed78$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $be857304663aed78$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $be857304663aed78$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $be857304663aed78$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $be857304663aed78$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $be857304663aed78$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $be857304663aed78$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $be857304663aed78$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $be857304663aed78$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $be857304663aed78$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $be857304663aed78$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $be857304663aed78$var$table_fmt[14]
                        }));
                        else $be857304663aed78$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $be857304663aed78$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $be857304663aed78$var$format_cell(cell);
                        $be857304663aed78$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $be857304663aed78$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $be857304663aed78$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $be857304663aed78$var$buf_array();
        $be857304663aed78$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $be857304663aed78$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $be857304663aed78$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $be857304663aed78$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $be857304663aed78$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $be857304663aed78$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $be857304663aed78$var$format_cell(cell);
                        /* TODO: max len? */ $be857304663aed78$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $be857304663aed78$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $be857304663aed78$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $be857304663aed78$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $be857304663aed78$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $be857304663aed78$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $be857304663aed78$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $be857304663aed78$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $be857304663aed78$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $be857304663aed78$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $be857304663aed78$var$encode_col(V) : $be857304663aed78$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $be857304663aed78$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $be857304663aed78$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $be857304663aed78$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $be857304663aed78$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $be857304663aed78$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $be857304663aed78$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $be857304663aed78$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $be857304663aed78$var$prep_blob(d, 0);
        var o = opts || {};
        if ($be857304663aed78$var$DENSE != null && o.dense == null) o.dense = $be857304663aed78$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $be857304663aed78$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $be857304663aed78$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $be857304663aed78$var$encode_range(range);
                    $be857304663aed78$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $be857304663aed78$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $be857304663aed78$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $be857304663aed78$var$dup(cell);
                            if (cell.t == "n" && cell.z && $be857304663aed78$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $be857304663aed78$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $be857304663aed78$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $be857304663aed78$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $be857304663aed78$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($be857304663aed78$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $be857304663aed78$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $be857304663aed78$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $be857304663aed78$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $be857304663aed78$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $be857304663aed78$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $be857304663aed78$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $be857304663aed78$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $be857304663aed78$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $be857304663aed78$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $be857304663aed78$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $be857304663aed78$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $be857304663aed78$var$utf8read(x);
        if (html) z.h = $be857304663aed78$var$escapehtml(z.t);
    } else if (/*y = */ x.match($be857304663aed78$var$sirregex)) {
        z.r = $be857304663aed78$var$utf8read(x);
        z.t = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(($be857304663aed78$var$str_remove_xml_ns_g(x, "rPh").match($be857304663aed78$var$sitregex) || []).join("").replace($be857304663aed78$var$tagregex, "")), true);
        if (html) z.h = $be857304663aed78$var$rs_to_html($be857304663aed78$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $be857304663aed78$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $be857304663aed78$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $be857304663aed78$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $be857304663aed78$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($be857304663aed78$var$sstr1, "").split($be857304663aed78$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $be857304663aed78$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $be857304663aed78$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $be857304663aed78$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $be857304663aed78$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o[o.length] = $be857304663aed78$var$writextag('sst', null, {
        xmlns: $be857304663aed78$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($be857304663aed78$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $be857304663aed78$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $be857304663aed78$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $be857304663aed78$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $be857304663aed78$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $be857304663aed78$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $be857304663aed78$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $be857304663aed78$var$write_BrtSSTItem = $be857304663aed78$var$write_RichStr;
function $be857304663aed78$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $be857304663aed78$var$buf_array();
    $be857304663aed78$var$write_record(ba, 0x009F /* BrtBeginSst */ , $be857304663aed78$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$be857304663aed78$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $be857304663aed78$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $be857304663aed78$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $be857304663aed78$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $be857304663aed78$var$$cptable !== 'undefined') return $be857304663aed78$var$$cptable.utils.encode($be857304663aed78$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $be857304663aed78$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $be857304663aed78$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    o.U = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    o.W = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $be857304663aed78$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $be857304663aed78$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($be857304663aed78$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $be857304663aed78$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $be857304663aed78$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    o.U = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    o.W = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $be857304663aed78$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $be857304663aed78$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $be857304663aed78$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $be857304663aed78$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $be857304663aed78$var$parse_EncryptionInfo(blob) {
    var vers = $be857304663aed78$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $be857304663aed78$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $be857304663aed78$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $be857304663aed78$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $be857304663aed78$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $be857304663aed78$var$parse_EncryptionHeader(blob, sz);
    var verifier = $be857304663aed78$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $be857304663aed78$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $be857304663aed78$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($be857304663aed78$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $be857304663aed78$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $be857304663aed78$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $be857304663aed78$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $be857304663aed78$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $be857304663aed78$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $be857304663aed78$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $be857304663aed78$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $be857304663aed78$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $be857304663aed78$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $be857304663aed78$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $be857304663aed78$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $be857304663aed78$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $be857304663aed78$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $be857304663aed78$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $be857304663aed78$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $be857304663aed78$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $be857304663aed78$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $be857304663aed78$var$parseuint16(blob),
        verificationBytes: $be857304663aed78$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $be857304663aed78$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $be857304663aed78$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $be857304663aed78$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $be857304663aed78$var$parse_RC4Header(blob, length);
    else o.Data = $be857304663aed78$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $be857304663aed78$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $be857304663aed78$var$parse_FilePassHeader(blob, length - 2, o);
    else $be857304663aed78$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $be857304663aed78$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $be857304663aed78$var$rtf_to_sheet_str($be857304663aed78$var$Base64_decode(d), opts);
        case "binary":
            return $be857304663aed78$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $be857304663aed78$var$rtf_to_sheet_str($be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(d) ? d.toString("binary") : $be857304663aed78$var$a2s(d), opts);
        case "array":
            return $be857304663aed78$var$rtf_to_sheet_str($be857304663aed78$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $be857304663aed78$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $be857304663aed78$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($be857304663aed78$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $be857304663aed78$var$fuzzynum(cell.v);
                        } else if ($be857304663aed78$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $be857304663aed78$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$be857304663aed78$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $be857304663aed78$var$encode_range(range);
    return ws;
}
function $be857304663aed78$var$rtf_to_workbook(d, opts) {
    var wb = $be857304663aed78$var$sheet_to_workbook($be857304663aed78$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $be857304663aed78$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $be857304663aed78$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $be857304663aed78$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($be857304663aed78$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $be857304663aed78$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $be857304663aed78$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $be857304663aed78$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $be857304663aed78$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $be857304663aed78$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $be857304663aed78$var$rgb2HSL($be857304663aed78$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $be857304663aed78$var$rgb2Hex($be857304663aed78$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $be857304663aed78$var$DEF_MDW = 6, $be857304663aed78$var$MAX_MDW = 15, $be857304663aed78$var$MIN_MDW = 1, $be857304663aed78$var$MDW = $be857304663aed78$var$DEF_MDW;
function $be857304663aed78$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $be857304663aed78$var$MDW) / 256) * $be857304663aed78$var$MDW);
}
function $be857304663aed78$var$px2char(px) {
    return Math.floor((px - 5) / $be857304663aed78$var$MDW * 100 + 0.5) / 100;
}
function $be857304663aed78$var$char2width(chr) {
    return Math.round((chr * $be857304663aed78$var$MDW + 5) / $be857304663aed78$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $be857304663aed78$var$cycle_width(collw) {
    return $be857304663aed78$var$char2width($be857304663aed78$var$px2char($be857304663aed78$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $be857304663aed78$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $be857304663aed78$var$cycle_width(collw)), _MDW = $be857304663aed78$var$MDW;
    if (delta > 0.005) {
        for($be857304663aed78$var$MDW = $be857304663aed78$var$MIN_MDW; $be857304663aed78$var$MDW < $be857304663aed78$var$MAX_MDW; ++$be857304663aed78$var$MDW)if (Math.abs(collw - $be857304663aed78$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $be857304663aed78$var$cycle_width(collw));
            _MDW = $be857304663aed78$var$MDW;
        }
    }
    $be857304663aed78$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $be857304663aed78$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $be857304663aed78$var$width2px(coll.width);
        coll.wch = $be857304663aed78$var$px2char(coll.wpx);
        coll.MDW = $be857304663aed78$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $be857304663aed78$var$px2char(coll.wpx);
        coll.width = $be857304663aed78$var$char2width(coll.wch);
        coll.MDW = $be857304663aed78$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $be857304663aed78$var$char2width(coll.wch);
        coll.wpx = $be857304663aed78$var$width2px(coll.width);
        coll.MDW = $be857304663aed78$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $be857304663aed78$var$DEF_PPI = 96, $be857304663aed78$var$PPI = $be857304663aed78$var$DEF_PPI;
function $be857304663aed78$var$px2pt(px) {
    return px * 96 / $be857304663aed78$var$PPI;
}
function $be857304663aed78$var$pt2px(pt) {
    return pt * $be857304663aed78$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $be857304663aed78$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $be857304663aed78$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $be857304663aed78$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $be857304663aed78$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $be857304663aed78$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $be857304663aed78$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $be857304663aed78$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $be857304663aed78$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $be857304663aed78$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $be857304663aed78$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $be857304663aed78$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $be857304663aed78$var$XLSIcv[1];
                    if (!icv) icv = $be857304663aed78$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $be857304663aed78$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $be857304663aed78$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $be857304663aed78$var$keys($be857304663aed78$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $be857304663aed78$var$table_fmt[k[i]];
    var m = t.match($be857304663aed78$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $be857304663aed78$var$parsexmltag(m[i]);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $be857304663aed78$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $be857304663aed78$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $be857304663aed78$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $be857304663aed78$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $be857304663aed78$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $be857304663aed78$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $be857304663aed78$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $be857304663aed78$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x), i = 0;
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $be857304663aed78$var$cellXF_uint.length; ++i)if (xf[$be857304663aed78$var$cellXF_uint[i]]) xf[$be857304663aed78$var$cellXF_uint[i]] = parseInt(xf[$be857304663aed78$var$cellXF_uint[i]], 10);
                for(i = 0; i < $be857304663aed78$var$cellXF_bool.length; ++i)if (xf[$be857304663aed78$var$cellXF_bool[i]]) xf[$be857304663aed78$var$cellXF_bool[i]] = $be857304663aed78$var$parsexmlbool(xf[$be857304663aed78$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $be857304663aed78$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $be857304663aed78$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $be857304663aed78$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $be857304663aed78$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $be857304663aed78$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $be857304663aed78$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $be857304663aed78$var$remove_doctype($be857304663aed78$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $be857304663aed78$var$str_match_xml_ns(data, "numFmts")) $be857304663aed78$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $be857304663aed78$var$str_match_xml_ns(data, "fonts")) $be857304663aed78$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $be857304663aed78$var$str_match_xml_ns(data, "fills")) $be857304663aed78$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $be857304663aed78$var$str_match_xml_ns(data, "borders")) $be857304663aed78$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $be857304663aed78$var$str_match_xml_ns(data, "cellXfs")) $be857304663aed78$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $be857304663aed78$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('styleSheet', null, {
            'xmlns': $be857304663aed78$var$XMLNS_main[0],
            'xmlns:vt': $be857304663aed78$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $be857304663aed78$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $be857304663aed78$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $be857304663aed78$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $be857304663aed78$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $be857304663aed78$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $be857304663aed78$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $be857304663aed78$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $be857304663aed78$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $be857304663aed78$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $be857304663aed78$var$parse_XLWideString(data, length - 21);
    return out;
}
function $be857304663aed78$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $be857304663aed78$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $be857304663aed78$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $be857304663aed78$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $be857304663aed78$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $be857304663aed78$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $be857304663aed78$var$parse_BrtFill = $be857304663aed78$var$parsenoop;
function $be857304663aed78$var$write_BrtFill(fill, o) {
    if (!o) o = $be857304663aed78$var$new_buf(84);
    if (!$be857304663aed78$var$rev_XLSBFillPTNames) $be857304663aed78$var$rev_XLSBFillPTNames = $be857304663aed78$var$evert($be857304663aed78$var$XLSBFillPTNames);
    var fls /*:number*/  = $be857304663aed78$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $be857304663aed78$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $be857304663aed78$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $be857304663aed78$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $be857304663aed78$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $be857304663aed78$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $be857304663aed78$var$write_Blxf(data, o) {
    if (!o) o = $be857304663aed78$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $be857304663aed78$var$parse_BrtBorder = $be857304663aed78$var$parsenoop;
function $be857304663aed78$var$write_BrtBorder(border, o) {
    if (!o) o = $be857304663aed78$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $be857304663aed78$var$write_Blxf(null, o); /* top */ 
    $be857304663aed78$var$write_Blxf(null, o); /* bottom */ 
    $be857304663aed78$var$write_Blxf(null, o); /* left */ 
    $be857304663aed78$var$write_Blxf(null, o); /* right */ 
    $be857304663aed78$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $be857304663aed78$var$write_BrtStyle(style, o) {
    if (!o) o = $be857304663aed78$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $be857304663aed78$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $be857304663aed78$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $be857304663aed78$var$new_buf(2052);
    o.write_shift(4, cnt);
    $be857304663aed78$var$write_XLNullableWideString(defTableStyle, o);
    $be857304663aed78$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $be857304663aed78$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $be857304663aed78$var$table_fmt)styles.NumberFmt[y] = $be857304663aed78$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $be857304663aed78$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $be857304663aed78$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $be857304663aed78$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $be857304663aed78$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $be857304663aed78$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $be857304663aed78$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $be857304663aed78$var$write_record(ba, 0x002C /* BrtFmt */ , $be857304663aed78$var$write_BrtFmt(i, NF[i]));
    });
    $be857304663aed78$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $be857304663aed78$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $be857304663aed78$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $be857304663aed78$var$write_UInt32LE(cnt));
    $be857304663aed78$var$write_record(ba, 0x002B /* BrtFont */ , $be857304663aed78$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $be857304663aed78$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $be857304663aed78$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $be857304663aed78$var$write_record(ba, 0x025B /* BrtBeginFills */ , $be857304663aed78$var$write_UInt32LE(cnt));
    $be857304663aed78$var$write_record(ba, 0x002D /* BrtFill */ , $be857304663aed78$var$write_BrtFill({
        patternType: "none"
    }));
    $be857304663aed78$var$write_record(ba, 0x002D /* BrtFill */ , $be857304663aed78$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $be857304663aed78$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $be857304663aed78$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $be857304663aed78$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $be857304663aed78$var$write_UInt32LE(cnt));
    $be857304663aed78$var$write_record(ba, 0x002E /* BrtBorder */ , $be857304663aed78$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $be857304663aed78$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $be857304663aed78$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $be857304663aed78$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $be857304663aed78$var$write_UInt32LE(cnt));
    $be857304663aed78$var$write_record(ba, 0x002F /* BrtXF */ , $be857304663aed78$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $be857304663aed78$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $be857304663aed78$var$write_CELLXFS_bin(ba, data) {
    $be857304663aed78$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $be857304663aed78$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $be857304663aed78$var$write_record(ba, 0x002F /* BrtXF */ , $be857304663aed78$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $be857304663aed78$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $be857304663aed78$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $be857304663aed78$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $be857304663aed78$var$write_UInt32LE(cnt));
    $be857304663aed78$var$write_record(ba, 0x0030 /* BrtStyle */ , $be857304663aed78$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $be857304663aed78$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $be857304663aed78$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $be857304663aed78$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $be857304663aed78$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $be857304663aed78$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $be857304663aed78$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $be857304663aed78$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $be857304663aed78$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $be857304663aed78$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $be857304663aed78$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $be857304663aed78$var$write_sty_bin(wb, opts) {
    var ba = $be857304663aed78$var$buf_array();
    $be857304663aed78$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $be857304663aed78$var$write_FMTS_bin(ba, wb.SSF);
    $be857304663aed78$var$write_FONTS_bin(ba, wb);
    $be857304663aed78$var$write_FILLS_bin(ba, wb);
    $be857304663aed78$var$write_BORDERS_bin(ba, wb);
    $be857304663aed78$var$write_CELLSTYLEXFS_bin(ba, wb);
    $be857304663aed78$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $be857304663aed78$var$write_STYLES_bin(ba, wb);
    $be857304663aed78$var$write_DXFS_bin(ba, wb);
    $be857304663aed78$var$write_TABLESTYLES_bin(ba, wb);
    $be857304663aed78$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $be857304663aed78$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $be857304663aed78$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $be857304663aed78$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$be857304663aed78$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $be857304663aed78$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $be857304663aed78$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $be857304663aed78$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $be857304663aed78$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $be857304663aed78$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $be857304663aed78$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $be857304663aed78$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $be857304663aed78$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $be857304663aed78$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $be857304663aed78$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $be857304663aed78$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $be857304663aed78$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $be857304663aed78$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $be857304663aed78$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $be857304663aed78$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $be857304663aed78$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $be857304663aed78$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $be857304663aed78$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $be857304663aed78$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $be857304663aed78$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $be857304663aed78$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $be857304663aed78$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $be857304663aed78$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $be857304663aed78$var$parse_IcvXF(blob, length) {
    return $be857304663aed78$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $be857304663aed78$var$parse_XFExtGradient(blob, length) {
    return $be857304663aed78$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $be857304663aed78$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $be857304663aed78$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $be857304663aed78$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $be857304663aed78$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($be857304663aed78$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $be857304663aed78$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $be857304663aed78$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $be857304663aed78$var$parse_XLWideString(data, length - 8)
    };
}
function $be857304663aed78$var$write_BrtMdtinfo(data) {
    var o = $be857304663aed78$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $be857304663aed78$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $be857304663aed78$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $be857304663aed78$var$write_BrtMdb(mdb) {
    var o = $be857304663aed78$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $be857304663aed78$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $be857304663aed78$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $be857304663aed78$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $be857304663aed78$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $be857304663aed78$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $be857304663aed78$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $be857304663aed78$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $be857304663aed78$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $be857304663aed78$var$write_xlmeta_bin() {
    var ba = $be857304663aed78$var$buf_array();
    $be857304663aed78$var$write_record(ba, 332);
    $be857304663aed78$var$write_record(ba, 334, $be857304663aed78$var$write_UInt32LE(1));
    $be857304663aed78$var$write_record(ba, 335, $be857304663aed78$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $be857304663aed78$var$write_record(ba, 336);
    $be857304663aed78$var$write_record(ba, 339, $be857304663aed78$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $be857304663aed78$var$write_record(ba, 52);
    $be857304663aed78$var$write_record(ba, 35, $be857304663aed78$var$write_UInt32LE(514));
    $be857304663aed78$var$write_record(ba, 4096, $be857304663aed78$var$write_UInt32LE(0));
    $be857304663aed78$var$write_record(ba, 4097, $be857304663aed78$var$writeuint16(1));
    $be857304663aed78$var$write_record(ba, 36);
    $be857304663aed78$var$write_record(ba, 53);
    $be857304663aed78$var$write_record(ba, 340);
    $be857304663aed78$var$write_record(ba, 337, $be857304663aed78$var$write_BrtBeginEsmdb(1, true));
    $be857304663aed78$var$write_record(ba, 51, $be857304663aed78$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $be857304663aed78$var$write_record(ba, 338);
    $be857304663aed78$var$write_record(ba, 333);
    return ba.end();
}
function $be857304663aed78$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($be857304663aed78$var$tagregex, function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $be857304663aed78$var$write_xlmeta_xml() {
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $be857304663aed78$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($be857304663aed78$var$tagregex) || []).forEach(function(x) {
        var y = $be857304663aed78$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $be857304663aed78$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $be857304663aed78$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $be857304663aed78$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $be857304663aed78$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $be857304663aed78$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $be857304663aed78$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $be857304663aed78$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $be857304663aed78$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $be857304663aed78$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($be857304663aed78$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($be857304663aed78$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $be857304663aed78$var$parsexmltag(x);
            switch($be857304663aed78$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $be857304663aed78$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $be857304663aed78$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $be857304663aed78$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $be857304663aed78$var$writextag("xml", null, {
            'xmlns:v': $be857304663aed78$var$XLMLNS.v,
            'xmlns:o': $be857304663aed78$var$XLMLNS.o,
            'xmlns:x': $be857304663aed78$var$XLMLNS.x,
            'xmlns:mv': $be857304663aed78$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $be857304663aed78$var$writextag("o:shapelayout", $be857304663aed78$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($be857304663aed78$var$writextag("v:shapetype", [
        $be857304663aed78$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $be857304663aed78$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($be857304663aed78$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $be857304663aed78$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $be857304663aed78$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $be857304663aed78$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $be857304663aed78$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $be857304663aed78$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $be857304663aed78$var$writextag("v:shadow", null, shadata),
        $be857304663aed78$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $be857304663aed78$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $be857304663aed78$var$writetag('x:AutoFill', "False"),
        $be857304663aed78$var$writetag('x:Row', String(c.r)),
        $be857304663aed78$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $be857304663aed78$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $be857304663aed78$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $be857304663aed78$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $be857304663aed78$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $be857304663aed78$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $be857304663aed78$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $be857304663aed78$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $be857304663aed78$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $be857304663aed78$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $be857304663aed78$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $be857304663aed78$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $be857304663aed78$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('comments', null, {
            'xmlns': $be857304663aed78$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $be857304663aed78$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($be857304663aed78$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $be857304663aed78$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($be857304663aed78$var$escapexml(c.a)) + '"><text>');
            o.push($be857304663aed78$var$writetag("t", c.t == null ? "" : $be857304663aed78$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($be857304663aed78$var$writetag("t", $be857304663aed78$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $be857304663aed78$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($be857304663aed78$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $be857304663aed78$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('ThreadedComments', null, {
            'xmlns': $be857304663aed78$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($be857304663aed78$var$writextag('threadedComment', $be857304663aed78$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $be857304663aed78$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($be857304663aed78$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $be857304663aed78$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('personList', null, {
            'xmlns': $be857304663aed78$var$XMLNS.TCMNT,
            'xmlns:x': $be857304663aed78$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($be857304663aed78$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $be857304663aed78$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $be857304663aed78$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $be857304663aed78$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $be857304663aed78$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $be857304663aed78$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $be857304663aed78$var$parse_BrtCommentAuthor = $be857304663aed78$var$parse_XLWideString;
function $be857304663aed78$var$write_BrtCommentAuthor(data) {
    return $be857304663aed78$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $be857304663aed78$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $be857304663aed78$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $be857304663aed78$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $be857304663aed78$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $be857304663aed78$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $be857304663aed78$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $be857304663aed78$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $be857304663aed78$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $be857304663aed78$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $be857304663aed78$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $be857304663aed78$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $be857304663aed78$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $be857304663aed78$var$decode_cell(comment[0]),
                e: $be857304663aed78$var$decode_cell(comment[0])
            };
            $be857304663aed78$var$write_record(ba, 0x027B /* BrtBeginComment */ , $be857304663aed78$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $be857304663aed78$var$write_record(ba, 0x027D /* BrtCommentText */ , $be857304663aed78$var$write_BrtCommentText(c));
            $be857304663aed78$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $be857304663aed78$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $be857304663aed78$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $be857304663aed78$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $be857304663aed78$var$make_vba_xls(cfb) {
    var newcfb = $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $be857304663aed78$export$9f0e51cd97c572a.write(newcfb);
}
function $be857304663aed78$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $be857304663aed78$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $be857304663aed78$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $be857304663aed78$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $be857304663aed78$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $be857304663aed78$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $be857304663aed78$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $be857304663aed78$var$encode_col(C) + (rRel ? "" : "$") + $be857304663aed78$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $be857304663aed78$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $be857304663aed78$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $be857304663aed78$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($be857304663aed78$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $be857304663aed78$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $be857304663aed78$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $be857304663aed78$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($be857304663aed78$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $be857304663aed78$var$encode_col($be857304663aed78$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $be857304663aed78$var$encode_row($be857304663aed78$var$decode_row($5) + delta.r));
    });
}
function $be857304663aed78$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $be857304663aed78$var$decode_range(range), s = r.s, c = $be857304663aed78$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $be857304663aed78$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $be857304663aed78$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $be857304663aed78$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $be857304663aed78$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $be857304663aed78$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $be857304663aed78$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $be857304663aed78$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $be857304663aed78$var$parse_ColRelU(blob, 2);
    var C = $be857304663aed78$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $be857304663aed78$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $be857304663aed78$var$parse_ColRelU(blob, 2), R = $be857304663aed78$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $be857304663aed78$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $be857304663aed78$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $be857304663aed78$var$parse_ColRelU(blob, 2);
    var C = $be857304663aed78$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $be857304663aed78$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $be857304663aed78$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $be857304663aed78$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $be857304663aed78$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $be857304663aed78$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $be857304663aed78$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $be857304663aed78$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $be857304663aed78$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $be857304663aed78$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $be857304663aed78$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $be857304663aed78$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $be857304663aed78$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $be857304663aed78$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $be857304663aed78$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $be857304663aed78$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $be857304663aed78$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $be857304663aed78$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $be857304663aed78$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $be857304663aed78$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $be857304663aed78$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $be857304663aed78$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $be857304663aed78$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $be857304663aed78$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $be857304663aed78$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $be857304663aed78$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $be857304663aed78$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $be857304663aed78$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $be857304663aed78$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $be857304663aed78$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $be857304663aed78$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $be857304663aed78$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $be857304663aed78$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $be857304663aed78$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $be857304663aed78$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $be857304663aed78$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $be857304663aed78$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $be857304663aed78$var$FtabArgc[iftab],
        $be857304663aed78$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $be857304663aed78$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $be857304663aed78$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $be857304663aed78$var$Ftab : $be857304663aed78$var$Cetab)[tab[1]]
    ];
}
function $be857304663aed78$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $be857304663aed78$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $be857304663aed78$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $be857304663aed78$var$parse_PtgErr(blob) {
    blob.l++;
    return $be857304663aed78$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $be857304663aed78$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $be857304663aed78$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $be857304663aed78$var$parse_PtgNum(blob) {
    blob.l++;
    return $be857304663aed78$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $be857304663aed78$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $be857304663aed78$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $be857304663aed78$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $be857304663aed78$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $be857304663aed78$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $be857304663aed78$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $be857304663aed78$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $be857304663aed78$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $be857304663aed78$var$parse_UncheckedRfX : $be857304663aed78$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $be857304663aed78$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $be857304663aed78$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $be857304663aed78$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $be857304663aed78$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $be857304663aed78$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $be857304663aed78$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $be857304663aed78$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $be857304663aed78$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $be857304663aed78$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $be857304663aed78$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $be857304663aed78$var$parse_PtgMemErr = $be857304663aed78$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $be857304663aed78$var$parse_PtgMemNoMem = $be857304663aed78$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $be857304663aed78$var$parse_PtgTbl = $be857304663aed78$var$parsenoop;
function $be857304663aed78$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $be857304663aed78$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $be857304663aed78$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $be857304663aed78$var$parse_PtgElfCol = $be857304663aed78$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $be857304663aed78$var$parse_PtgElfColS = $be857304663aed78$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $be857304663aed78$var$parse_PtgElfColSV = $be857304663aed78$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $be857304663aed78$var$parse_PtgElfColV = $be857304663aed78$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $be857304663aed78$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $be857304663aed78$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $be857304663aed78$var$parse_PtgElfRadical = $be857304663aed78$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $be857304663aed78$var$parse_PtgElfRadicalLel = $be857304663aed78$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $be857304663aed78$var$parse_PtgElfRadicalS = $be857304663aed78$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $be857304663aed78$var$parse_PtgElfRw = $be857304663aed78$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $be857304663aed78$var$parse_PtgElfRwV = $be857304663aed78$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $be857304663aed78$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $be857304663aed78$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $be857304663aed78$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $be857304663aed78$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $be857304663aed78$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $be857304663aed78$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $be857304663aed78$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $be857304663aed78$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $be857304663aed78$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $be857304663aed78$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $be857304663aed78$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $be857304663aed78$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $be857304663aed78$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $be857304663aed78$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $be857304663aed78$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $be857304663aed78$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $be857304663aed78$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $be857304663aed78$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $be857304663aed78$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $be857304663aed78$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $be857304663aed78$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $be857304663aed78$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $be857304663aed78$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $be857304663aed78$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $be857304663aed78$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $be857304663aed78$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $be857304663aed78$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $be857304663aed78$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $be857304663aed78$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $be857304663aed78$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $be857304663aed78$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $be857304663aed78$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $be857304663aed78$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $be857304663aed78$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $be857304663aed78$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $be857304663aed78$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $be857304663aed78$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $be857304663aed78$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $be857304663aed78$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $be857304663aed78$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $be857304663aed78$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $be857304663aed78$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $be857304663aed78$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $be857304663aed78$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $be857304663aed78$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $be857304663aed78$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $be857304663aed78$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $be857304663aed78$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $be857304663aed78$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $be857304663aed78$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $be857304663aed78$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $be857304663aed78$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $be857304663aed78$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $be857304663aed78$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $be857304663aed78$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $be857304663aed78$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $be857304663aed78$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $be857304663aed78$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $be857304663aed78$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $be857304663aed78$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $be857304663aed78$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $be857304663aed78$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $be857304663aed78$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $be857304663aed78$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $be857304663aed78$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $be857304663aed78$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $be857304663aed78$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $be857304663aed78$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $be857304663aed78$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $be857304663aed78$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $be857304663aed78$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $be857304663aed78$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $be857304663aed78$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $be857304663aed78$var$parse_PtgSxName
    },
    0xFF: {}
};
var $be857304663aed78$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $be857304663aed78$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $be857304663aed78$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $be857304663aed78$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $be857304663aed78$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $be857304663aed78$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $be857304663aed78$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $be857304663aed78$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $be857304663aed78$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $be857304663aed78$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $be857304663aed78$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $be857304663aed78$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $be857304663aed78$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $be857304663aed78$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $be857304663aed78$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $be857304663aed78$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($be857304663aed78$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $be857304663aed78$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $be857304663aed78$var$PtgTypes[id] || $be857304663aed78$var$PtgTypes[$be857304663aed78$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $be857304663aed78$var$Ptg18 : $be857304663aed78$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $be857304663aed78$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $be857304663aed78$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $be857304663aed78$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $be857304663aed78$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $be857304663aed78$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $be857304663aed78$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $be857304663aed78$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $be857304663aed78$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $be857304663aed78$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $be857304663aed78$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $be857304663aed78$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $be857304663aed78$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($be857304663aed78$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $be857304663aed78$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($be857304663aed78$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $be857304663aed78$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($be857304663aed78$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $be857304663aed78$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $be857304663aed78$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $be857304663aed78$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $be857304663aed78$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($be857304663aed78$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $be857304663aed78$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($be857304663aed78$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $be857304663aed78$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $be857304663aed78$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($be857304663aed78$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $be857304663aed78$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $be857304663aed78$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $be857304663aed78$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $be857304663aed78$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$be857304663aed78$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$be857304663aed78$var$encode_cell(c)];
                    stack.push($be857304663aed78$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($be857304663aed78$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $be857304663aed78$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $be857304663aed78$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $be857304663aed78$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $be857304663aed78$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $be857304663aed78$var$parsenoop(blob, length - 2)
    ];
    var rgce = $be857304663aed78$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $be857304663aed78$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $be857304663aed78$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $be857304663aed78$var$parsenoop(blob, length - 2)
    ];
    var rgce = $be857304663aed78$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $be857304663aed78$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $be857304663aed78$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $be857304663aed78$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $be857304663aed78$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $be857304663aed78$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $be857304663aed78$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $be857304663aed78$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $be857304663aed78$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $be857304663aed78$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($be857304663aed78$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $be857304663aed78$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $be857304663aed78$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $be857304663aed78$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $be857304663aed78$var$write_Xnum(value);
    return $be857304663aed78$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $be857304663aed78$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $be857304663aed78$var$parse_XLSCell(blob, 6, opts);
    var val1 = $be857304663aed78$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $be857304663aed78$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $be857304663aed78$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $be857304663aed78$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $be857304663aed78$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $be857304663aed78$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $be857304663aed78$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $be857304663aed78$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $be857304663aed78$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $be857304663aed78$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $be857304663aed78$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $be857304663aed78$var$parse_XLSBArrayParsedFormula = $be857304663aed78$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $be857304663aed78$var$parse_XLSBCellParsedFormula = $be857304663aed78$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $be857304663aed78$var$parse_XLSBNameParsedFormula = $be857304663aed78$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $be857304663aed78$var$parse_XLSBSharedParsedFormula = $be857304663aed78$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $be857304663aed78$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $be857304663aed78$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $be857304663aed78$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $be857304663aed78$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $be857304663aed78$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $be857304663aed78$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $be857304663aed78$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $be857304663aed78$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $be857304663aed78$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $be857304663aed78$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $be857304663aed78$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $be857304663aed78$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $be857304663aed78$var$write_XLSBFormulaRef(str) {
    var cell = $be857304663aed78$var$decode_cell(str);
    var out = $be857304663aed78$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $be857304663aed78$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $be857304663aed78$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $be857304663aed78$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $be857304663aed78$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $be857304663aed78$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $be857304663aed78$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $be857304663aed78$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $be857304663aed78$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $be857304663aed78$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $be857304663aed78$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $be857304663aed78$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $be857304663aed78$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $be857304663aed78$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $be857304663aed78$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $be857304663aed78$var$decode_range(_str);
    var out = $be857304663aed78$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $be857304663aed78$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $be857304663aed78$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $be857304663aed78$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $be857304663aed78$var$write_XLSBFormulaErr(+$be857304663aed78$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $be857304663aed78$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $be857304663aed78$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $be857304663aed78$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $be857304663aed78$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $be857304663aed78$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $be857304663aed78$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $be857304663aed78$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $be857304663aed78$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $be857304663aed78$var$write_XLSBNameParsedFormula = $be857304663aed78$var$write_XLSBFormula;
var $be857304663aed78$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $be857304663aed78$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $be857304663aed78$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $be857304663aed78$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $be857304663aed78$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($be857304663aed78$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $be857304663aed78$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $be857304663aed78$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $be857304663aed78$var$strs = {}; // shared strings
var $be857304663aed78$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $be857304663aed78$var$browser_has_Map = typeof Map !== 'undefined';
function $be857304663aed78$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($be857304663aed78$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $be857304663aed78$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($be857304663aed78$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $be857304663aed78$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $be857304663aed78$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $be857304663aed78$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $be857304663aed78$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $be857304663aed78$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $be857304663aed78$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $be857304663aed78$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $be857304663aed78$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $be857304663aed78$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $be857304663aed78$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($be857304663aed78$var$table_fmt[fmtid] == null) $be857304663aed78$var$SSF__load($be857304663aed78$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $be857304663aed78$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $be857304663aed78$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $be857304663aed78$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $be857304663aed78$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $be857304663aed78$var$SSF_general(p.v, $be857304663aed78$var$_ssfopts);
        } else if (p.t === 'd') p.w = $be857304663aed78$var$SSF_format(fmtid, $be857304663aed78$var$datenum(p.v, !!date1904), $be857304663aed78$var$_ssfopts);
        else p.w = $be857304663aed78$var$SSF_format(fmtid, p.v, $be857304663aed78$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $be857304663aed78$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $be857304663aed78$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $be857304663aed78$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $be857304663aed78$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $be857304663aed78$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $be857304663aed78$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $be857304663aed78$var$encode_range(d);
}
var $be857304663aed78$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $be857304663aed78$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $be857304663aed78$var$dimregex = /"(\w*:\w*)"/;
var $be857304663aed78$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $be857304663aed78$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $be857304663aed78$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $be857304663aed78$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $be857304663aed78$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($be857304663aed78$var$DENSE != null && opts.dense == null) opts.dense = $be857304663aed78$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $be857304663aed78$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($be857304663aed78$var$sheetprregex);
    if (sheetPr) $be857304663aed78$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $be857304663aed78$var$str_match_xml_ns(data1, "sheetPr")) $be857304663aed78$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($be857304663aed78$var$dimregex);
        if (ref && !(opts && opts.nodim)) $be857304663aed78$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $be857304663aed78$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $be857304663aed78$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($be857304663aed78$var$colregex);
        if (cols) $be857304663aed78$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $be857304663aed78$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($be857304663aed78$var$afregex);
    if (afilter) s['!autofilter'] = $be857304663aed78$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($be857304663aed78$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $be857304663aed78$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($be857304663aed78$var$hlinkregex);
    if (hlink) $be857304663aed78$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($be857304663aed78$var$marginregex);
    if (margins) s['!margins'] = $be857304663aed78$var$parse_ws_xml_margins($be857304663aed78$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $be857304663aed78$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $be857304663aed78$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $be857304663aed78$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $be857304663aed78$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $be857304663aed78$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $be857304663aed78$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $be857304663aed78$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(data.codeName));
}
function $be857304663aed78$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $be857304663aed78$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $be857304663aed78$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $be857304663aed78$var$utf8write($be857304663aed78$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $be857304663aed78$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $be857304663aed78$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $be857304663aed78$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $be857304663aed78$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $be857304663aed78$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $be857304663aed78$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $be857304663aed78$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $be857304663aed78$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $be857304663aed78$var$writextag('sheetProtection', null, o);
}
function $be857304663aed78$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $be857304663aed78$var$parsexmltag($be857304663aed78$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $be857304663aed78$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $be857304663aed78$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $be857304663aed78$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $be857304663aed78$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $be857304663aed78$var$write_ws_xml_margins(margin) /*:string*/ {
    $be857304663aed78$var$default_margins(margin);
    return $be857304663aed78$var$writextag('pageMargins', null, margin);
}
function $be857304663aed78$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $be857304663aed78$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $be857304663aed78$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $be857304663aed78$var$find_mdw_colw(coll.width);
        }
        $be857304663aed78$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $be857304663aed78$var$dup(coll);
    }
}
function $be857304663aed78$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $be857304663aed78$var$writextag('col', null, $be857304663aed78$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $be857304663aed78$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $be857304663aed78$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $be857304663aed78$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $be857304663aed78$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $be857304663aed78$var$decode_range(ws["!ref"]).e.r;
        ref = $be857304663aed78$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $be857304663aed78$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $be857304663aed78$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $be857304663aed78$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $be857304663aed78$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $be857304663aed78$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($be857304663aed78$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $be857304663aed78$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $be857304663aed78$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $be857304663aed78$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $be857304663aed78$var$writextag("sheetViews", $be857304663aed78$var$writextag("sheetView", null, sview), {});
}
function $be857304663aed78$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $be857304663aed78$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $be857304663aed78$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $be857304663aed78$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $be857304663aed78$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $be857304663aed78$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $be857304663aed78$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $be857304663aed78$var$writetag('v', $be857304663aed78$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $be857304663aed78$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $be857304663aed78$var$writetag('v', '' + $be857304663aed78$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $be857304663aed78$var$writextag('f', $be857304663aed78$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $be857304663aed78$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $be857304663aed78$var$writextag('c', v, o);
}
var $be857304663aed78$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $be857304663aed78$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $be857304663aed78$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $be857304663aed78$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $be857304663aed78$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $be857304663aed78$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $be857304663aed78$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $be857304663aed78$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $be857304663aed78$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $be857304663aed78$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $be857304663aed78$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $be857304663aed78$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $be857304663aed78$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $be857304663aed78$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $be857304663aed78$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $be857304663aed78$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $be857304663aed78$var$parsexmltag(cref[0]);
                                var ___f = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $be857304663aed78$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $be857304663aed78$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $be857304663aed78$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $be857304663aed78$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $be857304663aed78$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $be857304663aed78$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $be857304663aed78$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $be857304663aed78$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $be857304663aed78$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $be857304663aed78$var$parseDate(p.v, date1904);
                        else {
                            p.v = $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $be857304663aed78$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $be857304663aed78$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $be857304663aed78$var$fmt_is_date($be857304663aed78$var$table_fmt[fmtid])) {
                    p.v = $be857304663aed78$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $be857304663aed78$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $be857304663aed78$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $be857304663aed78$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $be857304663aed78$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $be857304663aed78$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $be857304663aed78$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $be857304663aed78$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $be857304663aed78$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $be857304663aed78$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $be857304663aed78$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $be857304663aed78$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $be857304663aed78$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $be857304663aed78$var$XML_HEADER,
        $be857304663aed78$var$writextag('worksheet', null, {
            'xmlns': $be857304663aed78$var$XMLNS_main[0],
            'xmlns:r': $be857304663aed78$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $be857304663aed78$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $be857304663aed78$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $be857304663aed78$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $be857304663aed78$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $be857304663aed78$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $be857304663aed78$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $be857304663aed78$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $be857304663aed78$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $be857304663aed78$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $be857304663aed78$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $be857304663aed78$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $be857304663aed78$var$add_rels(rels, -1, $be857304663aed78$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $be857304663aed78$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $be857304663aed78$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $be857304663aed78$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $be857304663aed78$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $be857304663aed78$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $be857304663aed78$var$writetag("ignoredErrors", $be857304663aed78$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $be857304663aed78$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $be857304663aed78$var$RELS.DRAW);
        o[o.length] = $be857304663aed78$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $be857304663aed78$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $be857304663aed78$var$RELS.VML);
        o[o.length] = $be857304663aed78$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $be857304663aed78$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $be857304663aed78$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $be857304663aed78$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $be857304663aed78$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$be857304663aed78$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $be857304663aed78$var$write_row_header(ba, ws, range, R) {
    var o = $be857304663aed78$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $be857304663aed78$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $be857304663aed78$var$parse_BrtWsDim = $be857304663aed78$var$parse_UncheckedRfX;
var $be857304663aed78$var$write_BrtWsDim = $be857304663aed78$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $be857304663aed78$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $be857304663aed78$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $be857304663aed78$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $be857304663aed78$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $be857304663aed78$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $be857304663aed78$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $be857304663aed78$var$parse_BrtCellBlank(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $be857304663aed78$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(8);
    return $be857304663aed78$var$write_XLSBCell(ncell, o);
}
function $be857304663aed78$var$parse_BrtShortBlank(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $be857304663aed78$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(4);
    return $be857304663aed78$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $be857304663aed78$var$parse_BrtCellBool(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $be857304663aed78$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(9);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $be857304663aed78$var$parse_BrtShortBool(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $be857304663aed78$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(5);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $be857304663aed78$var$parse_BrtCellError(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $be857304663aed78$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(9);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $be857304663aed78$var$parse_BrtShortError(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $be857304663aed78$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(8);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $be857304663aed78$var$parse_BrtCellIsst(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $be857304663aed78$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(12);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $be857304663aed78$var$parse_BrtShortIsst(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $be857304663aed78$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(8);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $be857304663aed78$var$parse_BrtCellReal(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var value = $be857304663aed78$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $be857304663aed78$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(16);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    $be857304663aed78$var$write_Xnum(cell.v, o);
    return o;
}
function $be857304663aed78$var$parse_BrtShortReal(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var value = $be857304663aed78$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $be857304663aed78$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(12);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    $be857304663aed78$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $be857304663aed78$var$parse_BrtCellRk(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var value = $be857304663aed78$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $be857304663aed78$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(12);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    $be857304663aed78$var$write_RkNumber(cell.v, o);
    return o;
}
function $be857304663aed78$var$parse_BrtShortRk(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var value = $be857304663aed78$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $be857304663aed78$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(8);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    $be857304663aed78$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $be857304663aed78$var$parse_BrtCellRString(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var value = $be857304663aed78$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $be857304663aed78$var$parse_BrtCellSt(data) {
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    var value = $be857304663aed78$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $be857304663aed78$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $be857304663aed78$var$new_buf(12 + 4 * cell.v.length);
    $be857304663aed78$var$write_XLSBCell(ncell, o);
    $be857304663aed78$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $be857304663aed78$var$parse_BrtShortSt(data) {
    var cell = $be857304663aed78$var$parse_XLSBShortCell(data);
    var value = $be857304663aed78$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $be857304663aed78$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $be857304663aed78$var$new_buf(8 + 4 * data.length);
    $be857304663aed78$var$write_XLSBShortCell(ncell, o);
    $be857304663aed78$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $be857304663aed78$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $be857304663aed78$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $be857304663aed78$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $be857304663aed78$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $be857304663aed78$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $be857304663aed78$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $be857304663aed78$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $be857304663aed78$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $be857304663aed78$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $be857304663aed78$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $be857304663aed78$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $be857304663aed78$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $be857304663aed78$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $be857304663aed78$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $be857304663aed78$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $be857304663aed78$var$parse_BrtMergeCell = $be857304663aed78$var$parse_UncheckedRfX;
var $be857304663aed78$var$write_BrtMergeCell = $be857304663aed78$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $be857304663aed78$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $be857304663aed78$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $be857304663aed78$var$parse_UncheckedRfX(data, 16);
    var relId = $be857304663aed78$var$parse_XLNullableWideString(data);
    var loc = $be857304663aed78$var$parse_XLWideString(data);
    var tooltip = $be857304663aed78$var$parse_XLWideString(data);
    var display = $be857304663aed78$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $be857304663aed78$var$write_BrtHLink(l, rId) {
    var o = $be857304663aed78$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $be857304663aed78$var$write_UncheckedRfX({
        s: $be857304663aed78$var$decode_cell(l[0]),
        e: $be857304663aed78$var$decode_cell(l[0])
    }, o);
    $be857304663aed78$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $be857304663aed78$var$write_XLWideString(loc || "", o);
    $be857304663aed78$var$write_XLWideString(l[1].Tooltip || "", o);
    $be857304663aed78$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $be857304663aed78$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $be857304663aed78$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $be857304663aed78$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $be857304663aed78$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $be857304663aed78$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $be857304663aed78$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $be857304663aed78$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $be857304663aed78$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(18);
    var p = $be857304663aed78$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $be857304663aed78$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $be857304663aed78$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $be857304663aed78$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $be857304663aed78$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $be857304663aed78$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $be857304663aed78$var$new_buf(48);
    $be857304663aed78$var$default_margins(margins);
    $be857304663aed78$var$BrtMarginKeys.forEach(function(k) {
        $be857304663aed78$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $be857304663aed78$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $be857304663aed78$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $be857304663aed78$var$write_BrtCellIgnoreEC(ref) {
    var o = $be857304663aed78$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $be857304663aed78$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $be857304663aed78$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $be857304663aed78$var$new_buf(66);
    o.write_shift(2, sp.password ? $be857304663aed78$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $be857304663aed78$var$parse_BrtDVal() {}
function $be857304663aed78$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $be857304663aed78$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($be857304663aed78$var$DENSE != null && opts.dense == null) opts.dense = $be857304663aed78$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $be857304663aed78$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $be857304663aed78$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $be857304663aed78$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $be857304663aed78$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $be857304663aed78$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $be857304663aed78$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $be857304663aed78$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $be857304663aed78$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$be857304663aed78$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $be857304663aed78$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $be857304663aed78$var$fmt_is_date($be857304663aed78$var$table_fmt[cf.numFmtId])) {
                    var _d = $be857304663aed78$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$be857304663aed78$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$be857304663aed78$var$encode_col(C) + rr];
                cell.f = $be857304663aed78$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $be857304663aed78$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$be857304663aed78$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$be857304663aed78$var$encode_col(C) + rr];
                cell.f = $be857304663aed78$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $be857304663aed78$var$find_mdw_colw(val1.w / 256);
                    }
                    $be857304663aed78$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $be857304663aed78$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $be857304663aed78$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $be857304663aed78$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $be857304663aed78$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $be857304663aed78$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $be857304663aed78$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $be857304663aed78$var$dup(cell);
            cell.z = cell.z || $be857304663aed78$var$table_fmt[14];
            cell.v = $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $be857304663aed78$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $be857304663aed78$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $be857304663aed78$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $be857304663aed78$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $be857304663aed78$var$write_BrtShortIsst(cell, o));
                else $be857304663aed78$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $be857304663aed78$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $be857304663aed78$var$write_record(ba, 0x0011 /* BrtShortSt */ , $be857304663aed78$var$write_BrtShortSt(cell, o));
                else $be857304663aed78$var$write_record(ba, 0x0006 /* BrtCellSt */ , $be857304663aed78$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $be857304663aed78$var$write_record(ba, 0x000D /* BrtShortRk */ , $be857304663aed78$var$write_BrtShortRk(cell, o));
                else $be857304663aed78$var$write_record(ba, 0x0002 /* BrtCellRk */ , $be857304663aed78$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $be857304663aed78$var$write_record(ba, 0x000E /* BrtShortError */ , $be857304663aed78$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $be857304663aed78$var$write_record(ba, 0x0003 /* BrtCellError */ , $be857304663aed78$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $be857304663aed78$var$write_record(ba, 0x000E /* BrtShortError */ , $be857304663aed78$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $be857304663aed78$var$write_record(ba, 0x0003 /* BrtCellError */ , $be857304663aed78$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $be857304663aed78$var$write_record(ba, 0x0010 /* BrtShortReal */ , $be857304663aed78$var$write_BrtShortReal(cell, o));
            else $be857304663aed78$var$write_record(ba, 0x0005 /* BrtCellReal */ , $be857304663aed78$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $be857304663aed78$var$write_record(ba, 0x000F /* BrtShortBool */ , $be857304663aed78$var$write_BrtShortBool(cell, o));
            else $be857304663aed78$var$write_record(ba, 0x0004 /* BrtCellBool */ , $be857304663aed78$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $be857304663aed78$var$write_record(ba, 0x000E /* BrtShortError */ , $be857304663aed78$var$write_BrtShortError(cell, o));
            else $be857304663aed78$var$write_record(ba, 0x0003 /* BrtCellError */ , $be857304663aed78$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $be857304663aed78$var$write_record(ba, 0x000C /* BrtShortBlank */ , $be857304663aed78$var$write_BrtShortBlank(cell, o));
    else $be857304663aed78$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $be857304663aed78$var$write_BrtCellBlank(cell, o));
    return true;
}
function $be857304663aed78$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $be857304663aed78$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $be857304663aed78$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $be857304663aed78$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $be857304663aed78$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $be857304663aed78$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $be857304663aed78$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $be857304663aed78$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $be857304663aed78$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $be857304663aed78$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $be857304663aed78$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $be857304663aed78$var$write_BrtMergeCell(m));
    });
    $be857304663aed78$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $be857304663aed78$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $be857304663aed78$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $be857304663aed78$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $be857304663aed78$var$write_BrtColInfo(i, m));
    });
    $be857304663aed78$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $be857304663aed78$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $be857304663aed78$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $be857304663aed78$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $be857304663aed78$var$write_BrtCellIgnoreEC($be857304663aed78$var$safe_decode_range(ws['!ref'])));
    $be857304663aed78$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $be857304663aed78$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $be857304663aed78$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $be857304663aed78$var$RELS.HLINK);
        $be857304663aed78$var$write_record(ba, 0x01EE /* BrtHLink */ , $be857304663aed78$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $be857304663aed78$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $be857304663aed78$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $be857304663aed78$var$RELS.VML);
        $be857304663aed78$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $be857304663aed78$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $be857304663aed78$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $be857304663aed78$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $be857304663aed78$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $be857304663aed78$var$decode_range(ws["!ref"]).e.r;
        ref = $be857304663aed78$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $be857304663aed78$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $be857304663aed78$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $be857304663aed78$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $be857304663aed78$var$fix_range(ref)
    });
    $be857304663aed78$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $be857304663aed78$var$write_UncheckedRfX($be857304663aed78$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $be857304663aed78$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $be857304663aed78$var$write_WSVIEWS2(ba, ws, Workbook) {
    $be857304663aed78$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $be857304663aed78$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $be857304663aed78$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $be857304663aed78$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $be857304663aed78$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $be857304663aed78$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $be857304663aed78$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $be857304663aed78$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $be857304663aed78$var$write_BrtSheetProtection(ws['!protect']));
}
function $be857304663aed78$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $be857304663aed78$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $be857304663aed78$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $be857304663aed78$var$write_record(ba, 0x0093 /* BrtWsProp */ , $be857304663aed78$var$write_BrtWsProp(c, ws['!outline']));
    $be857304663aed78$var$write_record(ba, 0x0094 /* BrtWsDim */ , $be857304663aed78$var$write_BrtWsDim(r));
    $be857304663aed78$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $be857304663aed78$var$write_WSFMTINFO(ba, ws);
    $be857304663aed78$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $be857304663aed78$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $be857304663aed78$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $be857304663aed78$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $be857304663aed78$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $be857304663aed78$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $be857304663aed78$var$write_record(ba, 0x01DC /* BrtMargins */ , $be857304663aed78$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $be857304663aed78$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $be857304663aed78$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $be857304663aed78$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $be857304663aed78$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $be857304663aed78$var$unescapexml(($be857304663aed78$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($be857304663aed78$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $be857304663aed78$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($be857304663aed78$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $be857304663aed78$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $be857304663aed78$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $be857304663aed78$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $be857304663aed78$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $be857304663aed78$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($be857304663aed78$var$sheetprregex);
    if (sheetPr) $be857304663aed78$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $be857304663aed78$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $be857304663aed78$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $be857304663aed78$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $be857304663aed78$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $be857304663aed78$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $be857304663aed78$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $be857304663aed78$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $be857304663aed78$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $be857304663aed78$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $be857304663aed78$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $be857304663aed78$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $be857304663aed78$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $be857304663aed78$var$parse_wb_defaults(wb) {
    $be857304663aed78$var$push_defaults(wb.WBProps, $be857304663aed78$var$WBPropsDef);
    $be857304663aed78$var$push_defaults(wb.CalcPr, $be857304663aed78$var$CalcPrDef);
    $be857304663aed78$var$push_defaults_array(wb.WBView, $be857304663aed78$var$WBViewDef);
    $be857304663aed78$var$push_defaults_array(wb.Sheets, $be857304663aed78$var$SheetDef);
    $be857304663aed78$var$_ssfopts.date1904 = $be857304663aed78$var$parsexmlbool(wb.WBProps.date1904);
}
function $be857304663aed78$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $be857304663aed78$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $be857304663aed78$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $be857304663aed78$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $be857304663aed78$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $be857304663aed78$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $be857304663aed78$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $be857304663aed78$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $be857304663aed78$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$be857304663aed78$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $be857304663aed78$var$formula_quote_sheet_name(n) + "!" + $be857304663aed78$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $be857304663aed78$var$wbnsregex = /<\w+:workbook/;
function $be857304663aed78$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($be857304663aed78$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $be857304663aed78$var$parsexmltag(x);
        switch($be857304663aed78$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($be857304663aed78$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $be857304663aed78$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $be857304663aed78$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $be857304663aed78$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $be857304663aed78$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($be857304663aed78$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $be857304663aed78$var$unescapexml($be857304663aed78$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($be857304663aed78$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $be857304663aed78$var$parse_wb_defaults(wb);
    return wb;
}
function $be857304663aed78$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $be857304663aed78$var$XML_HEADER
    ];
    o[o.length] = $be857304663aed78$var$writextag('workbook', null, {
        'xmlns': $be857304663aed78$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $be857304663aed78$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $be857304663aed78$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $be857304663aed78$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $be857304663aed78$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $be857304663aed78$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $be857304663aed78$var$writextag('definedName', $be857304663aed78$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $be857304663aed78$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $be857304663aed78$var$parse_RelID(data, length - 8);
    z.name = $be857304663aed78$var$parse_XLWideString(data);
    return z;
}
function $be857304663aed78$var$write_BrtBundleSh(data, o) {
    if (!o) o = $be857304663aed78$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $be857304663aed78$var$write_RelID(data.strRelID, o);
    $be857304663aed78$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $be857304663aed78$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $be857304663aed78$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $be857304663aed78$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $be857304663aed78$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $be857304663aed78$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $be857304663aed78$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $be857304663aed78$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $be857304663aed78$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $be857304663aed78$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $be857304663aed78$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $be857304663aed78$var$write_BrtName(name, wb) {
    var o = $be857304663aed78$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($be857304663aed78$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $be857304663aed78$var$write_XLWideString(dname),
        $be857304663aed78$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($be857304663aed78$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $be857304663aed78$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $be857304663aed78$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $be857304663aed78$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $be857304663aed78$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $be857304663aed78$var$parse_BrtFRTArchID$
    };
    $be857304663aed78$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $be857304663aed78$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $be857304663aed78$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $be857304663aed78$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $be857304663aed78$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $be857304663aed78$var$write_record(ba, 0x009C /* BrtBundleSh */ , $be857304663aed78$var$write_BrtBundleSh(d));
    }
    $be857304663aed78$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $be857304663aed78$var$write_BrtFileVersion(data, o) {
    if (!o) o = $be857304663aed78$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $be857304663aed78$var$write_XLWideString("SheetJS", o);
    $be857304663aed78$var$write_XLWideString($be857304663aed78$var$XLSX.version, o);
    $be857304663aed78$var$write_XLWideString($be857304663aed78$var$XLSX.version, o);
    $be857304663aed78$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $be857304663aed78$var$write_BrtBookView(idx, o) {
    if (!o) o = $be857304663aed78$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $be857304663aed78$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $be857304663aed78$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $be857304663aed78$var$write_record(ba, 0x009E /* BrtBookView */ , $be857304663aed78$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $be857304663aed78$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $be857304663aed78$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $be857304663aed78$var$write_record(ba, 0x0027 /* BrtName */ , $be857304663aed78$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $be857304663aed78$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $be857304663aed78$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $be857304663aed78$var$write_EXTERNALS_xlsb(ba, wb) {
    $be857304663aed78$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $be857304663aed78$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $be857304663aed78$var$write_record(ba, 0x016A /* BrtExternSheet */ , $be857304663aed78$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $be857304663aed78$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $be857304663aed78$var$write_wb_bin(wb, opts) {
    var ba = $be857304663aed78$var$buf_array();
    $be857304663aed78$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $be857304663aed78$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $be857304663aed78$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $be857304663aed78$var$write_record(ba, 0x0099 /* BrtWbProp */ , $be857304663aed78$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $be857304663aed78$var$write_BOOKVIEWS(ba, wb, opts);
    $be857304663aed78$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $be857304663aed78$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $be857304663aed78$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $be857304663aed78$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $be857304663aed78$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_wb_bin(data /*:any*/ , opts);
    return $be857304663aed78$var$parse_wb_xml(data /*:any*/ , opts);
}
function $be857304663aed78$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $be857304663aed78$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $be857304663aed78$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $be857304663aed78$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $be857304663aed78$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $be857304663aed78$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $be857304663aed78$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $be857304663aed78$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $be857304663aed78$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $be857304663aed78$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $be857304663aed78$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_sst_bin(data /*:any*/ , opts);
    return $be857304663aed78$var$parse_sst_xml(data /*:any*/ , opts);
}
function $be857304663aed78$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_comments_bin(data /*:any*/ , opts);
    return $be857304663aed78$var$parse_comments_xml(data /*:any*/ , opts);
}
function $be857304663aed78$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $be857304663aed78$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $be857304663aed78$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $be857304663aed78$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $be857304663aed78$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $be857304663aed78$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $be857304663aed78$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $be857304663aed78$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $be857304663aed78$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $be857304663aed78$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($be857304663aed78$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($be857304663aed78$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $be857304663aed78$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($be857304663aed78$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($be857304663aed78$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $be857304663aed78$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $be857304663aed78$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $be857304663aed78$var$XLMLFormatMap[format] || $be857304663aed78$var$unescapexml(format);
    if (fmt === "General") return $be857304663aed78$var$SSF_general(value);
    return $be857304663aed78$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $be857304663aed78$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $be857304663aed78$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $be857304663aed78$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$be857304663aed78$var$unescapexml(key)] = oval;
}
function $be857304663aed78$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $be857304663aed78$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $be857304663aed78$var$SSF_general_num(cell.v);
            } else cell.w = $be857304663aed78$var$SSF_general(cell.v);
        } else cell.w = $be857304663aed78$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $be857304663aed78$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $be857304663aed78$var$fmt_is_date(z)) {
            var _d = $be857304663aed78$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $be857304663aed78$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $be857304663aed78$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $be857304663aed78$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $be857304663aed78$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $be857304663aed78$var$xlml_fixstr($be857304663aed78$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $be857304663aed78$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $be857304663aed78$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $be857304663aed78$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $be857304663aed78$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $be857304663aed78$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $be857304663aed78$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $be857304663aed78$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $be857304663aed78$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $be857304663aed78$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $be857304663aed78$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $be857304663aed78$var$xlml_prefix_dname(dname) {
    return $be857304663aed78$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $be857304663aed78$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $be857304663aed78$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $be857304663aed78$var$make_ssf();
    var str = $be857304663aed78$var$debom($be857304663aed78$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $be857304663aed78$var$$cptable !== 'undefined') str = $be857304663aed78$var$$cptable.utils.decode(65001, $be857304663aed78$var$char_codes(str));
        else str = $be857304663aed78$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $be857304663aed78$var$dup(opts);
        _o.type = "string";
        return $be857304663aed78$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $be857304663aed78$var$html_to_workbook(str, opts);
    $be857304663aed78$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $be857304663aed78$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $be857304663aed78$var$table_fmt[15],
        "Short Date": $be857304663aed78$var$table_fmt[14],
        "Long Time": $be857304663aed78$var$table_fmt[19],
        "Medium Time": $be857304663aed78$var$table_fmt[18],
        "Short Time": $be857304663aed78$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $be857304663aed78$var$table_fmt[2],
        "Standard": $be857304663aed78$var$table_fmt[4],
        "Percent": $be857304663aed78$var$table_fmt[10],
        "Scientific": $be857304663aed78$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($be857304663aed78$var$DENSE != null && opts.dense == null) opts.dense = $be857304663aed78$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $be857304663aed78$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $be857304663aed78$var$xlmlregex.lastIndex = 0;
    str = $be857304663aed78$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $be857304663aed78$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $be857304663aed78$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$be857304663aed78$var$encode_col(c) + $be857304663aed78$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $be857304663aed78$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$be857304663aed78$var$encode_col(cma) + $be857304663aed78$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $be857304663aed78$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $be857304663aed78$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $be857304663aed78$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $be857304663aed78$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                sheetname = $be857304663aed78$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $be857304663aed78$var$process_style_xlml(styles, stag, opts);
            else stag = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $be857304663aed78$var$unescapexml($be857304663aed78$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($be857304663aed78$var$XLMLFormatMap[stag.nf]) stag.nf = $be857304663aed78$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($be857304663aed78$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($be857304663aed78$var$table_fmt[ssfidx] == null) {
                    $be857304663aed78$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $be857304663aed78$var$MDW = $be857304663aed78$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $be857304663aed78$var$process_col(cstys[_col]);
            }
            if (seencol) $be857304663aed78$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $be857304663aed78$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $be857304663aed78$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $be857304663aed78$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $be857304663aed78$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $be857304663aed78$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $be857304663aed78$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                if (!$be857304663aed78$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $be857304663aed78$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $be857304663aed78$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $be857304663aed78$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $be857304663aed78$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $be857304663aed78$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$be857304663aed78$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$be857304663aed78$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $be857304663aed78$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$be857304663aed78$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$be857304663aed78$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $be857304663aed78$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $be857304663aed78$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $be857304663aed78$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $be857304663aed78$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $be857304663aed78$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $be857304663aed78$var$parse_xlml_xml($be857304663aed78$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $be857304663aed78$var$parse_xlml_xml(data, opts);
        case "array":
            return $be857304663aed78$var$parse_xlml_xml($be857304663aed78$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $be857304663aed78$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($be857304663aed78$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($be857304663aed78$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $be857304663aed78$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $be857304663aed78$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($be857304663aed78$var$writextag('NumberFormat', null, {
            "ss:Format": $be857304663aed78$var$escapexml($be857304663aed78$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($be857304663aed78$var$writextag('Style', payload.join(""), o));
    });
    return $be857304663aed78$var$writextag("Styles", styles.join(""));
}
function $be857304663aed78$var$write_name_xlml(n) {
    return $be857304663aed78$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $be857304663aed78$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $be857304663aed78$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($be857304663aed78$var$write_name_xlml(n));
    }
    return $be857304663aed78$var$writextag("Names", out.join(""));
}
function $be857304663aed78$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($be857304663aed78$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $be857304663aed78$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($be857304663aed78$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($be857304663aed78$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($be857304663aed78$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($be857304663aed78$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($be857304663aed78$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($be857304663aed78$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($be857304663aed78$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($be857304663aed78$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($be857304663aed78$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $be857304663aed78$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $be857304663aed78$var$XLMLNS.x
    });
}
function $be857304663aed78$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $be857304663aed78$var$xlml_unfixstr(c.t || "");
        var d = $be857304663aed78$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $be857304663aed78$var$writextag("Comment", d, p);
    }).join("");
}
function $be857304663aed78$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $be857304663aed78$var$escapexml($be857304663aed78$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $be857304663aed78$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $be857304663aed78$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $be857304663aed78$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $be857304663aed78$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $be857304663aed78$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $be857304663aed78$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $be857304663aed78$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $be857304663aed78$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $be857304663aed78$var$write_ws_xlml_comment(cell.c);
    return $be857304663aed78$var$writextag("Cell", m, attr);
}
function $be857304663aed78$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $be857304663aed78$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $be857304663aed78$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $be857304663aed78$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $be857304663aed78$var$process_col(n);
        var w = !!n.width;
        var p = $be857304663aed78$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $be857304663aed78$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($be857304663aed78$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $be857304663aed78$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($be857304663aed78$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $be857304663aed78$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $be857304663aed78$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $be857304663aed78$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($be857304663aed78$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $be857304663aed78$var$a1_to_rc($be857304663aed78$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $be857304663aed78$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (wb.SSF) {
        $be857304663aed78$var$make_ssf();
        $be857304663aed78$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $be857304663aed78$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $be857304663aed78$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($be857304663aed78$var$write_props_xlml(wb, opts));
    d.push($be857304663aed78$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($be857304663aed78$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($be857304663aed78$var$writextag("Worksheet", $be857304663aed78$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $be857304663aed78$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $be857304663aed78$var$write_sty_xlml(wb, opts);
    return $be857304663aed78$var$XML_HEADER + $be857304663aed78$var$writextag("Workbook", d.join(""), {
        'xmlns': $be857304663aed78$var$XLMLNS.ss,
        'xmlns:o': $be857304663aed78$var$XLMLNS.o,
        'xmlns:x': $be857304663aed78$var$XLMLNS.x,
        'xmlns:ss': $be857304663aed78$var$XLMLNS.ss,
        'xmlns:dt': $be857304663aed78$var$XLMLNS.dt,
        'xmlns:html': $be857304663aed78$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $be857304663aed78$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $be857304663aed78$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $be857304663aed78$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $be857304663aed78$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $be857304663aed78$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $be857304663aed78$var$__readUInt16LE(blob, blob.l), next = $be857304663aed78$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $be857304663aed78$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $be857304663aed78$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $be857304663aed78$var$XLSRecordEnum[nextrt = $be857304663aed78$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $be857304663aed78$var$bconcat(bufs);
    $be857304663aed78$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $be857304663aed78$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $be857304663aed78$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $be857304663aed78$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $be857304663aed78$var$SSF_general_num(p.v);
            } else p.w = $be857304663aed78$var$SSF_general(p.v);
        } else p.w = $be857304663aed78$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $be857304663aed78$var$fmt_is_date($be857304663aed78$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $be857304663aed78$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $be857304663aed78$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $be857304663aed78$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($be857304663aed78$var$DENSE != null && options.dense == null) options.dense = $be857304663aed78$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $be857304663aed78$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $be857304663aed78$var$XLSIcv[icv];
        return $be857304663aed78$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $be857304663aed78$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $be857304663aed78$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $be857304663aed78$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $be857304663aed78$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $be857304663aed78$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $be857304663aed78$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $be857304663aed78$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $be857304663aed78$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $be857304663aed78$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $be857304663aed78$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $be857304663aed78$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $be857304663aed78$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $be857304663aed78$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $be857304663aed78$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $be857304663aed78$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$be857304663aed78$var$encode_col(val1.c) + $be857304663aed78$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $be857304663aed78$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $be857304663aed78$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $be857304663aed78$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $be857304663aed78$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $be857304663aed78$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $be857304663aed78$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $be857304663aed78$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $be857304663aed78$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $be857304663aed78$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$be857304663aed78$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$be857304663aed78$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $be857304663aed78$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $be857304663aed78$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $be857304663aed78$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $be857304663aed78$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($be857304663aed78$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $be857304663aed78$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $be857304663aed78$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($be857304663aed78$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $be857304663aed78$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$be857304663aed78$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$be857304663aed78$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$be857304663aed78$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$be857304663aed78$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $be857304663aed78$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $be857304663aed78$var$find_mdw_colw(val1.w / 256);
                        }
                        $be857304663aed78$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $be857304663aed78$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $be857304663aed78$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $be857304663aed78$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $be857304663aed78$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $be857304663aed78$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $be857304663aed78$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $be857304663aed78$var$parse_PropertySetStream(DSI, $be857304663aed78$var$DocSummaryPIDDSI, $be857304663aed78$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $be857304663aed78$var$parse_PropertySetStream(SI, $be857304663aed78$var$SummaryPIDSI, $be857304663aed78$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $be857304663aed78$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $be857304663aed78$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $be857304663aed78$var$evert_key($be857304663aed78$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $be857304663aed78$var$evert_key($be857304663aed78$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $be857304663aed78$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $be857304663aed78$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($be857304663aed78$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $be857304663aed78$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $be857304663aed78$var$write_PropertySetStream(SEntries, $be857304663aed78$var$PSCLSID.SI, SummaryRE, $be857304663aed78$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $be857304663aed78$var$write_PropertySetStream(DSEntries, $be857304663aed78$var$PSCLSID.DSI, DocSummaryRE, $be857304663aed78$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $be857304663aed78$var$PSCLSID.UDI));
}
function $be857304663aed78$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $be857304663aed78$var$fix_read_opts(options);
    $be857304663aed78$var$reset_cp();
    if (options.codepage) $be857304663aed78$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $be857304663aed78$var$s2a($be857304663aed78$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $be857304663aed78$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $be857304663aed78$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $be857304663aed78$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $be857304663aed78$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $be857304663aed78$var$parse_workbook(WB.content, options);
        else if ((_data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $be857304663aed78$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $be857304663aed78$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $be857304663aed78$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $be857304663aed78$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $be857304663aed78$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $be857304663aed78$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $be857304663aed78$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $be857304663aed78$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $be857304663aed78$var$fill_vba_xls(cfb, $be857304663aed78$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $be857304663aed78$var$XLSBRecordEnum = {
    0x0000: {
        f: $be857304663aed78$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $be857304663aed78$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $be857304663aed78$var$parse_BrtCellRk
    },
    0x0003: {
        f: $be857304663aed78$var$parse_BrtCellError
    },
    0x0004: {
        f: $be857304663aed78$var$parse_BrtCellBool
    },
    0x0005: {
        f: $be857304663aed78$var$parse_BrtCellReal
    },
    0x0006: {
        f: $be857304663aed78$var$parse_BrtCellSt
    },
    0x0007: {
        f: $be857304663aed78$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $be857304663aed78$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $be857304663aed78$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $be857304663aed78$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $be857304663aed78$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $be857304663aed78$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $be857304663aed78$var$parse_BrtShortRk
    },
    0x000E: {
        f: $be857304663aed78$var$parse_BrtShortError
    },
    0x000F: {
        f: $be857304663aed78$var$parse_BrtShortBool
    },
    0x0010: {
        f: $be857304663aed78$var$parse_BrtShortReal
    },
    0x0011: {
        f: $be857304663aed78$var$parse_BrtShortSt
    },
    0x0012: {
        f: $be857304663aed78$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $be857304663aed78$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $be857304663aed78$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $be857304663aed78$var$parse_BrtFont
    },
    0x002C: {
        f: $be857304663aed78$var$parse_BrtFmt
    },
    0x002D: {
        f: $be857304663aed78$var$parse_BrtFill
    },
    0x002E: {
        f: $be857304663aed78$var$parse_BrtBorder
    },
    0x002F: {
        f: $be857304663aed78$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $be857304663aed78$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $be857304663aed78$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $be857304663aed78$var$parse_ColInfo
    },
    0x003E: {
        f: $be857304663aed78$var$parse_BrtCellRString
    },
    0x003F: {
        f: $be857304663aed78$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $be857304663aed78$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $be857304663aed78$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $be857304663aed78$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $be857304663aed78$var$parse_BrtWsProp
    },
    0x0094: {
        f: $be857304663aed78$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $be857304663aed78$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $be857304663aed78$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $be857304663aed78$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $be857304663aed78$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $be857304663aed78$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $be857304663aed78$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $be857304663aed78$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $be857304663aed78$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $be857304663aed78$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $be857304663aed78$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $be857304663aed78$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $be857304663aed78$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $be857304663aed78$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $be857304663aed78$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $be857304663aed78$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $be857304663aed78$var$parse_RelID
    },
    0x0227: {
        f: $be857304663aed78$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $be857304663aed78$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $be857304663aed78$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $be857304663aed78$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $be857304663aed78$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $be857304663aed78$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $be857304663aed78$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $be857304663aed78$var$parse_Formula
    },
    0x000a: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x000c: {
        f: $be857304663aed78$var$parseuint16
    },
    0x000d: {
        f: $be857304663aed78$var$parseuint16
    },
    0x000e: {
        f: $be857304663aed78$var$parsebool
    },
    0x000f: {
        f: $be857304663aed78$var$parsebool
    },
    0x0010: {
        f: $be857304663aed78$var$parse_Xnum
    },
    0x0011: {
        f: $be857304663aed78$var$parsebool
    },
    0x0012: {
        f: $be857304663aed78$var$parsebool
    },
    0x0013: {
        f: $be857304663aed78$var$parseuint16
    },
    0x0014: {
        f: $be857304663aed78$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $be857304663aed78$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $be857304663aed78$var$parse_ExternSheet
    },
    0x0018: {
        f: $be857304663aed78$var$parse_Lbl
    },
    0x0019: {
        f: $be857304663aed78$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $be857304663aed78$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $be857304663aed78$var$parsebool
    },
    0x0023: {
        f: $be857304663aed78$var$parse_ExternName
    },
    0x0026: {
        f: $be857304663aed78$var$parse_Xnum
    },
    0x0027: {
        f: $be857304663aed78$var$parse_Xnum
    },
    0x0028: {
        f: $be857304663aed78$var$parse_Xnum
    },
    0x0029: {
        f: $be857304663aed78$var$parse_Xnum
    },
    0x002a: {
        f: $be857304663aed78$var$parsebool
    },
    0x002b: {
        f: $be857304663aed78$var$parsebool
    },
    0x002f: {
        f: $be857304663aed78$var$parse_FilePass
    },
    0x0031: {
        f: $be857304663aed78$var$parse_Font
    },
    0x0033: {
        f: $be857304663aed78$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $be857304663aed78$var$parse_Window1
    },
    0x0040: {
        f: $be857304663aed78$var$parsebool
    },
    0x0041: {
        f: $be857304663aed78$var$parse_Pane
    },
    0x0042: {
        f: $be857304663aed78$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $be857304663aed78$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $be857304663aed78$var$parse_WriteAccess
    },
    0x005d: {
        f: $be857304663aed78$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $be857304663aed78$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $be857304663aed78$var$parsebool
    },
    0x007d: {
        f: $be857304663aed78$var$parse_ColInfo
    },
    0x0080: {
        f: $be857304663aed78$var$parse_Guts
    },
    0x0081: {
        f: $be857304663aed78$var$parse_WsBool
    },
    0x0082: {
        f: $be857304663aed78$var$parseuint16
    },
    0x0083: {
        f: $be857304663aed78$var$parsebool
    },
    0x0084: {
        f: $be857304663aed78$var$parsebool
    },
    0x0085: {
        f: $be857304663aed78$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $be857304663aed78$var$parse_Country
    },
    0x008d: {
        f: $be857304663aed78$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $be857304663aed78$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $be857304663aed78$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $be857304663aed78$var$parse_Scl
    },
    0x00a1: {
        f: $be857304663aed78$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $be857304663aed78$var$parse_MulRk
    },
    0x00be: {
        f: $be857304663aed78$var$parse_MulBlank
    },
    0x00c1: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $be857304663aed78$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $be857304663aed78$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $be857304663aed78$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $be857304663aed78$var$parse_XF
    },
    0x00e1: {
        f: $be857304663aed78$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $be857304663aed78$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $be857304663aed78$var$parse_SST
    },
    0x00fd: {
        f: $be857304663aed78$var$parse_LabelSst
    },
    0x00ff: {
        f: $be857304663aed78$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $be857304663aed78$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $be857304663aed78$var$parsebool
    },
    0x0161: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $be857304663aed78$var$parse_SupBook
    },
    0x01af: {
        f: $be857304663aed78$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $be857304663aed78$var$parse_TxO
    },
    0x01b7: {
        f: $be857304663aed78$var$parsebool
    },
    0x01b8: {
        f: $be857304663aed78$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $be857304663aed78$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $be857304663aed78$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x01c1: {
        f: $be857304663aed78$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x0200: {
        f: $be857304663aed78$var$parse_Dimensions
    },
    0x0201: {
        f: $be857304663aed78$var$parse_Blank
    },
    0x0203: {
        f: $be857304663aed78$var$parse_Number
    },
    0x0204: {
        f: $be857304663aed78$var$parse_Label
    },
    0x0205: {
        f: $be857304663aed78$var$parse_BoolErr
    },
    0x0207: {
        f: $be857304663aed78$var$parse_String
    },
    0x0208: {
        f: $be857304663aed78$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $be857304663aed78$var$parse_Array
    },
    0x0225: {
        f: $be857304663aed78$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $be857304663aed78$var$parse_Window2
    },
    0x027e: {
        f: $be857304663aed78$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $be857304663aed78$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $be857304663aed78$var$parse_ShrFmla
    },
    0x0800: {
        f: $be857304663aed78$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $be857304663aed78$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $be857304663aed78$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $be857304663aed78$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $be857304663aed78$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $be857304663aed78$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $be857304663aed78$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $be857304663aed78$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $be857304663aed78$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $be857304663aed78$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $be857304663aed78$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $be857304663aed78$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $be857304663aed78$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $be857304663aed78$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $be857304663aed78$var$parse_BIFF2INT
    },
    0x0003: {
        f: $be857304663aed78$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $be857304663aed78$var$parse_BIFF2STR
    },
    0x0005: {
        f: $be857304663aed78$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $be857304663aed78$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $be857304663aed78$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $be857304663aed78$var$parseuint16
    },
    0x001e: {
        f: $be857304663aed78$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $be857304663aed78$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $be857304663aed78$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $be857304663aed78$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $be857304663aed78$var$parse_BIFF2XF
    },
    0x0044: {
        f: $be857304663aed78$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $be857304663aed78$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $be857304663aed78$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $be857304663aed78$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $be857304663aed78$var$parse_Formula
    },
    0x0209: {
        f: $be857304663aed78$var$parse_BOF
    },
    0x0218: {
        f: $be857304663aed78$var$parse_Lbl
    },
    0x0223: {
        f: $be857304663aed78$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $be857304663aed78$var$parse_BIFF3XF
    },
    0x0406: {
        f: $be857304663aed78$var$parse_Formula
    },
    0x0409: {
        f: $be857304663aed78$var$parse_BOF
    },
    0x0443: {
        f: $be857304663aed78$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $be857304663aed78$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $be857304663aed78$var$is_buf(payload)) ba.push(payload);
}
function $be857304663aed78$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $be857304663aed78$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $be857304663aed78$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $be857304663aed78$var$new_buf(9);
    $be857304663aed78$var$write_BIFF2Cell(out, r, c);
    $be857304663aed78$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $be857304663aed78$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $be857304663aed78$var$new_buf(8 + 2 * val1.length);
    $be857304663aed78$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $be857304663aed78$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $be857304663aed78$var$write_biff_rec(ba, 0x001C, $be857304663aed78$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $be857304663aed78$var$write_biff_rec(ba, 0x001C, $be857304663aed78$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$be857304663aed78$var$write_biff_rec(ba, 0x001C, $be857304663aed78$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $be857304663aed78$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0002, $be857304663aed78$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0005, $be857304663aed78$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0005, $be857304663aed78$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0003, $be857304663aed78$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0005, $be857304663aed78$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $be857304663aed78$var$write_biff_rec(ba, 0x0004, $be857304663aed78$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $be857304663aed78$var$write_biff_rec(ba, 0x0001, $be857304663aed78$var$write_BIFF2Cell(null, R, C));
}
function $be857304663aed78$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $be857304663aed78$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $be857304663aed78$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $be857304663aed78$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $be857304663aed78$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $be857304663aed78$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $be857304663aed78$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $be857304663aed78$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $be857304663aed78$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $be857304663aed78$var$write_biff_rec(ba, 0x0022, $be857304663aed78$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $be857304663aed78$var$buf_array();
    $be857304663aed78$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $be857304663aed78$var$write_biff_rec(ba, 0x001E, $be857304663aed78$var$write_BIFF2Format(f));
        else $be857304663aed78$var$write_biff_rec(ba, 0x041E, $be857304663aed78$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $be857304663aed78$var$write_biff_rec(ba, 0x0043, $be857304663aed78$var$write_BIFF2XF(xf));
                break;
            case 3:
                $be857304663aed78$var$write_biff_rec(ba, 0x0243, $be857304663aed78$var$write_BIFF3XF(xf));
                break;
            case 4:
                $be857304663aed78$var$write_biff_rec(ba, 0x0443, $be857304663aed78$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $be857304663aed78$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $be857304663aed78$var$b8oid = 1, $be857304663aed78$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $be857304663aed78$var$write_MsoDrawingGroup() {
    var buf = $be857304663aed78$var$new_buf(82 + 8 * $be857304663aed78$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $be857304663aed78$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $be857304663aed78$var$b8ocnts.length);
    buf.write_shift(4, $be857304663aed78$var$b8oid);
    buf.write_shift(4, $be857304663aed78$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $be857304663aed78$var$b8ocnts.length; ++i)acc += $be857304663aed78$var$b8ocnts[i] && $be857304663aed78$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $be857304663aed78$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $be857304663aed78$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $be857304663aed78$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $be857304663aed78$var$buf_array(), baseid = $be857304663aed78$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$be857304663aed78$var$b8oid;
        var oasc = $be857304663aed78$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $be857304663aed78$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $be857304663aed78$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $be857304663aed78$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $be857304663aed78$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $be857304663aed78$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $be857304663aed78$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $be857304663aed78$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $be857304663aed78$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $be857304663aed78$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $be857304663aed78$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $be857304663aed78$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $be857304663aed78$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $be857304663aed78$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $be857304663aed78$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $be857304663aed78$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $be857304663aed78$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $be857304663aed78$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $be857304663aed78$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $be857304663aed78$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $be857304663aed78$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $be857304663aed78$var$write_biff_rec(ba, 0x001C, n);
    });
    $be857304663aed78$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $be857304663aed78$var$b8oid
    ]);
    ++$be857304663aed78$var$b8oid;
}
function $be857304663aed78$var$write_FONTS_biff8(ba, data, opts) {
    $be857304663aed78$var$write_biff_rec(ba, 0x0031 /* Font */ , $be857304663aed78$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $be857304663aed78$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $be857304663aed78$var$write_biff_rec(ba, 0x041E /* Format */ , $be857304663aed78$var$write_Format(i, NF[i], opts));
    });
}
function $be857304663aed78$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $be857304663aed78$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $be857304663aed78$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $be857304663aed78$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $be857304663aed78$var$write_Ref8U($be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $be857304663aed78$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $be857304663aed78$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$be857304663aed78$var$write_biff_rec(ba, 0x00e0 /* XF */ , $be857304663aed78$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $be857304663aed78$var$write_biff_rec(ba, 0x00e0 /* XF */ , $be857304663aed78$var$write_XF(c, 0, opts));
    });
}
function $be857304663aed78$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $be857304663aed78$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $be857304663aed78$var$write_HLink(HL));
        if (HL[1].Tooltip) $be857304663aed78$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $be857304663aed78$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $be857304663aed78$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $be857304663aed78$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $be857304663aed78$var$write_ColInfo($be857304663aed78$var$col_obj_w(idx, col), idx));
    });
}
function $be857304663aed78$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $be857304663aed78$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $be857304663aed78$var$write_biff_rec(ba, 0x0201 /* Blank */ , $be857304663aed78$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $be857304663aed78$var$write_biff_rec(ba, 0x0006 /* Formula */ , $be857304663aed78$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $be857304663aed78$var$datenum($be857304663aed78$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $be857304663aed78$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $be857304663aed78$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $be857304663aed78$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $be857304663aed78$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $be857304663aed78$var$write_biff_rec(ba, 0x0203 /* Number */ , $be857304663aed78$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $be857304663aed78$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $be857304663aed78$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $be857304663aed78$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $be857304663aed78$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $be857304663aed78$var$write_LabelSst(R, C, isst, os, opts));
            } else $be857304663aed78$var$write_biff_rec(ba, 0x0204 /* Label */ , $be857304663aed78$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $be857304663aed78$var$write_biff_rec(ba, 0x0201 /* Blank */ , $be857304663aed78$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $be857304663aed78$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $be857304663aed78$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $be857304663aed78$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $be857304663aed78$var$write_biff_rec(ba, 0x0809, $be857304663aed78$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $be857304663aed78$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $be857304663aed78$var$writeuint16(1));
    $be857304663aed78$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $be857304663aed78$var$writeuint16(100));
    $be857304663aed78$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $be857304663aed78$var$writebool(true));
    $be857304663aed78$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $be857304663aed78$var$write_Xnum(0.001));
    $be857304663aed78$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $be857304663aed78$var$writebool(true));
    $be857304663aed78$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $be857304663aed78$var$writeuint16(1));
    $be857304663aed78$var$write_biff_rec(ba, 0x0080 /* Guts */ , $be857304663aed78$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $be857304663aed78$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $be857304663aed78$var$writebool(false));
    /* ... */ if (b8) $be857304663aed78$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $be857304663aed78$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $be857304663aed78$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $be857304663aed78$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $be857304663aed78$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $be857304663aed78$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $be857304663aed78$var$write_comments_biff8(ba, comments);
    else $be857304663aed78$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $be857304663aed78$var$write_biff_rec(ba, 0x023e /* Window2 */ , $be857304663aed78$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $be857304663aed78$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $be857304663aed78$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $be857304663aed78$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $be857304663aed78$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $be857304663aed78$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $be857304663aed78$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $be857304663aed78$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $be857304663aed78$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $be857304663aed78$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $be857304663aed78$var$write_biff_rec(A, 0x0809, $be857304663aed78$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $be857304663aed78$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $be857304663aed78$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $be857304663aed78$var$writeuint16(0x04b0) : null);
    $be857304663aed78$var$write_biff_rec(A, 0x00c1 /* Mms */ , $be857304663aed78$var$writezeroes(2));
    if (b5) $be857304663aed78$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $be857304663aed78$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $be857304663aed78$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $be857304663aed78$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $be857304663aed78$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $be857304663aed78$var$write_biff_rec(A, 0x0042 /* CodePage */ , $be857304663aed78$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $be857304663aed78$var$write_biff_rec(A, 0x0161 /* DSF */ , $be857304663aed78$var$writeuint16(0));
    if (b8) $be857304663aed78$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $be857304663aed78$var$write_biff_rec(A, 0x013d /* RRTabId */ , $be857304663aed78$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $be857304663aed78$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $be857304663aed78$var$write_biff_rec(A, 0x01ba /* CodeName */ , $be857304663aed78$var$write_XLUnicodeString(cname, opts));
    }
    $be857304663aed78$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $be857304663aed78$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $be857304663aed78$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(A, 0x0012 /* Protect */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(A, 0x0013 /* Password */ , $be857304663aed78$var$writeuint16(0));
    if (b8) $be857304663aed78$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $be857304663aed78$var$writebool(false));
    if (b8) $be857304663aed78$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $be857304663aed78$var$writeuint16(0));
    $be857304663aed78$var$write_biff_rec(A, 0x003d /* Window1 */ , $be857304663aed78$var$write_Window1(opts));
    $be857304663aed78$var$write_biff_rec(A, 0x0040 /* Backup */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(A, 0x008d /* HideObj */ , $be857304663aed78$var$writeuint16(0));
    $be857304663aed78$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $be857304663aed78$var$writebool($be857304663aed78$var$safe1904(wb) == "true"));
    $be857304663aed78$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $be857304663aed78$var$writebool(true));
    if (b8) $be857304663aed78$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $be857304663aed78$var$writebool(false));
    $be857304663aed78$var$write_biff_rec(A, 0x00DA /* BookBool */ , $be857304663aed78$var$writeuint16(0));
    /* ... */ $be857304663aed78$var$write_FONTS_biff8(A, wb, opts);
    $be857304663aed78$var$write_FMTS_biff8(A, wb.SSF, opts);
    $be857304663aed78$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $be857304663aed78$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $be857304663aed78$var$writebool(false));
    var a = A.end();
    var C = $be857304663aed78$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $be857304663aed78$var$write_biff_rec(C, 0x008C /* Country */ , $be857304663aed78$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $be857304663aed78$var$b8ocnts.length) $be857304663aed78$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $be857304663aed78$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $be857304663aed78$var$write_biff_continue(C, 0x00FC /* SST */ , $be857304663aed78$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $be857304663aed78$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $be857304663aed78$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $be857304663aed78$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $be857304663aed78$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $be857304663aed78$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $be857304663aed78$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (wb && wb.SSF) {
        $be857304663aed78$var$make_ssf();
        $be857304663aed78$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $be857304663aed78$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $be857304663aed78$var$b8oid = 1;
    $be857304663aed78$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $be857304663aed78$var$fix_write_opts(o);
    o.cellXfs = [];
    $be857304663aed78$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $be857304663aed78$var$write_ws_biff8(i, o, wb);
    bufs.unshift($be857304663aed78$var$write_biff8_global(wb, bufs, o));
    return $be857304663aed78$var$bconcat(bufs);
}
function $be857304663aed78$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $be857304663aed78$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $be857304663aed78$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $be857304663aed78$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $be857304663aed78$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $be857304663aed78$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $be857304663aed78$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $be857304663aed78$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $be857304663aed78$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $be857304663aed78$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($be857304663aed78$var$fuzzynum(m))) o = {
                t: 'n',
                v: $be857304663aed78$var$fuzzynum(m)
            };
            else if (!isNaN($be857304663aed78$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $be857304663aed78$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $be857304663aed78$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $be857304663aed78$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $be857304663aed78$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $be857304663aed78$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $be857304663aed78$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$be857304663aed78$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $be857304663aed78$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $be857304663aed78$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $be857304663aed78$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $be857304663aed78$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $be857304663aed78$var$escapehtml(cell.w || ($be857304663aed78$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $be857304663aed78$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $be857304663aed78$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($be857304663aed78$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $be857304663aed78$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $be857304663aed78$var$HTML_END = '</body></html>';
function $be857304663aed78$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $be857304663aed78$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $be857304663aed78$var$sheet_to_workbook($be857304663aed78$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $be857304663aed78$var$book_new();
    mtch.forEach(function(s, idx) {
        $be857304663aed78$var$book_append_sheet(wb, $be857304663aed78$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $be857304663aed78$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $be857304663aed78$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $be857304663aed78$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $be857304663aed78$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $be857304663aed78$var$decode_range(ws['!ref'] || "A1");
    out.push($be857304663aed78$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($be857304663aed78$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $be857304663aed78$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $be857304663aed78$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $be857304663aed78$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($be857304663aed78$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $be857304663aed78$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $be857304663aed78$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $be857304663aed78$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $be857304663aed78$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($be857304663aed78$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $be857304663aed78$var$fuzzynum(v)
                };
                else if (!isNaN($be857304663aed78$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $be857304663aed78$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $be857304663aed78$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $be857304663aed78$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $be857304663aed78$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $be857304663aed78$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $be857304663aed78$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$be857304663aed78$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $be857304663aed78$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $be857304663aed78$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $be857304663aed78$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $be857304663aed78$var$sheet_add_dom(ws, table, _opts);
}
function $be857304663aed78$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $be857304663aed78$var$sheet_to_workbook($be857304663aed78$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $be857304663aed78$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $be857304663aed78$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $be857304663aed78$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $be857304663aed78$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $be857304663aed78$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $be857304663aed78$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $be857304663aed78$var$xlml_normalize(d);
    $be857304663aed78$var$xlmlregex.lastIndex = 0;
    str = $be857304663aed78$var$remove_doctype($be857304663aed78$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $be857304663aed78$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $be857304663aed78$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $be857304663aed78$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $be857304663aed78$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            NF += "0." + $be857304663aed78$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $be857304663aed78$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($be857304663aed78$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $be857304663aed78$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $be857304663aed78$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $be857304663aed78$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $be857304663aed78$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $be857304663aed78$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if ($be857304663aed78$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $be857304663aed78$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $be857304663aed78$var$fill("0", +y["min-integer-digits"] || 1);
            if ($be857304663aed78$var$parsexmlbool(y["grouping"])) tNF = $be857304663aed78$var$commaify($be857304663aed78$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $be857304663aed78$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $be857304663aed78$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $be857304663aed78$var$xlmlregex.lastIndex;
                etpos = -+$be857304663aed78$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $be857304663aed78$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($be857304663aed78$var$DENSE != null && opts.dense == null) opts.dense = $be857304663aed78$var$DENSE;
    var str = $be857304663aed78$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $be857304663aed78$var$xlmlregex.lastIndex = 0;
    str = $be857304663aed78$var$remove_doctype($be857304663aed78$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $be857304663aed78$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $be857304663aed78$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $be857304663aed78$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$be857304663aed78$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $be857304663aed78$var$ods_to_csf_formula($be857304663aed78$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $be857304663aed78$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                ctag2 = $be857304663aed78$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $be857304663aed78$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $be857304663aed78$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $be857304663aed78$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $be857304663aed78$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $be857304663aed78$var$fmt_is_date(q.z)) {
                            q.v = $be857304663aed78$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $be857304663aed78$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $be857304663aed78$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $be857304663aed78$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $be857304663aed78$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $be857304663aed78$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $be857304663aed78$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $be857304663aed78$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $be857304663aed78$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $be857304663aed78$var$dup(q);
                        } else {
                            ws[$be857304663aed78$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$be857304663aed78$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $be857304663aed78$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $be857304663aed78$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $be857304663aed78$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $be857304663aed78$var$xlmlregex.lastIndex;
                $be857304663aed78$var$parse_ods_styles(str.slice(nfidx, $be857304663aed78$var$xlmlregex.lastIndex), _opts, number_format_map);
                $be857304663aed78$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $be857304663aed78$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            _Ref = $be857304663aed78$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $be857304663aed78$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $be857304663aed78$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $be857304663aed78$var$ods_to_csf_3D($be857304663aed78$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $be857304663aed78$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $be857304663aed78$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $be857304663aed78$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $be857304663aed78$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($be857304663aed78$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $be857304663aed78$var$parse_manifest($be857304663aed78$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $be857304663aed78$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $be857304663aed78$var$parse_ods_styles($be857304663aed78$var$utf8read(styles), opts);
    var content = $be857304663aed78$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $be857304663aed78$var$parse_content_xml($be857304663aed78$var$utf8read(content), opts, Styles);
    if ($be857304663aed78$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $be857304663aed78$var$parse_core_props($be857304663aed78$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $be857304663aed78$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $be857304663aed78$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $be857304663aed78$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $be857304663aed78$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $be857304663aed78$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $be857304663aed78$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $be857304663aed78$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $be857304663aed78$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $be857304663aed78$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $be857304663aed78$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $be857304663aed78$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $be857304663aed78$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $be857304663aed78$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $be857304663aed78$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $be857304663aed78$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $be857304663aed78$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $be857304663aed78$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $be857304663aed78$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $be857304663aed78$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $be857304663aed78$var$writextag("number:" + type + "-style", payload, nopts);
}
function $be857304663aed78$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $be857304663aed78$var$csf_to_ods_3D(name.Ref);
        return "        " + $be857304663aed78$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $be857304663aed78$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $be857304663aed78$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $be857304663aed78$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $be857304663aed78$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $be857304663aed78$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $be857304663aed78$var$escapexml($be857304663aed78$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $be857304663aed78$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $be857304663aed78$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $be857304663aed78$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $be857304663aed78$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $be857304663aed78$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $be857304663aed78$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $be857304663aed78$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $be857304663aed78$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($be857304663aed78$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $be857304663aed78$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $be857304663aed78$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$be857304663aed78$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $be857304663aed78$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $be857304663aed78$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $be857304663aed78$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $be857304663aed78$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $be857304663aed78$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($be857304663aed78$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($be857304663aed78$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $be857304663aed78$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $be857304663aed78$var$write_content_ods(wb, opts);
    var zip = $be857304663aed78$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $be857304663aed78$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$XML_HEADER + $be857304663aed78$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $be857304663aed78$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $be857304663aed78$require$Buffer !== "undefined") {
            if (typeof $be857304663aed78$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $be857304663aed78$require$Buffer.from == "function" ? $be857304663aed78$require$Buffer.from([
                72,
                62
            ]) : new $be857304663aed78$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $be857304663aed78$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $be857304663aed78$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $be857304663aed78$var$utf8read($be857304663aed78$var$a2s(u8));
}
function $be857304663aed78$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $be857304663aed78$var$s2a($be857304663aed78$var$utf8write(str));
}
function $be857304663aed78$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $be857304663aed78$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $be857304663aed78$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $be857304663aed78$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $be857304663aed78$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $be857304663aed78$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$be857304663aed78$var$subarray](0, L);
}
function $be857304663aed78$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($be857304663aed78$var$parse_varint49(buf, ptr));
    return out;
}
function $be857304663aed78$var$write_packed_varints(nums) {
    return $be857304663aed78$var$u8concat(nums.map(function(x) {
        return $be857304663aed78$var$write_varint49(x);
    }));
}
function $be857304663aed78$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $be857304663aed78$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $be857304663aed78$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $be857304663aed78$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$be857304663aed78$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$be857304663aed78$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $be857304663aed78$var$parse_varint49(buf, ptr);
                data = buf[$be857304663aed78$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$be857304663aed78$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $be857304663aed78$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($be857304663aed78$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($be857304663aed78$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $be857304663aed78$var$u8concat(out);
}
function $be857304663aed78$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $be857304663aed78$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $be857304663aed78$var$parse_varint49(buf, ptr);
        var ai = $be857304663aed78$var$parse_shallow(buf[$be857304663aed78$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $be857304663aed78$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $be857304663aed78$var$parse_shallow(b.data);
            var fl = $be857304663aed78$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$be857304663aed78$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $be857304663aed78$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $be857304663aed78$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $be857304663aed78$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $be857304663aed78$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $be857304663aed78$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $be857304663aed78$var$write_shallow(ai);
        bufs.push($be857304663aed78$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $be857304663aed78$var$u8concat(bufs);
}
function $be857304663aed78$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $be857304663aed78$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$be857304663aed78$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$be857304663aed78$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$be857304663aed78$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$be857304663aed78$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $be857304663aed78$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $be857304663aed78$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $be857304663aed78$var$parse_snappy_chunk(t, buf[$be857304663aed78$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $be857304663aed78$var$u8concat(out);
}
function $be857304663aed78$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $be857304663aed78$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$be857304663aed78$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $be857304663aed78$var$u8concat(out);
}
var $be857304663aed78$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $be857304663aed78$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $be857304663aed78$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $be857304663aed78$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $be857304663aed78$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $be857304663aed78$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $be857304663aed78$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $be857304663aed78$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $be857304663aed78$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $be857304663aed78$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $be857304663aed78$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$be857304663aed78$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$be857304663aed78$var$subarray](0, 4)));
    }
    if (zidx > -1) $be857304663aed78$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $be857304663aed78$var$parse_new_storage(buf, lut, opts) {
    var dv = $be857304663aed78$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $be857304663aed78$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $be857304663aed78$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $be857304663aed78$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $be857304663aed78$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$be857304663aed78$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$be857304663aed78$var$subarray](0, 4)));
    }
    doff += $be857304663aed78$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $be857304663aed78$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $be857304663aed78$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $be857304663aed78$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $be857304663aed78$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $be857304663aed78$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($be857304663aed78$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $be857304663aed78$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($be857304663aed78$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$be857304663aed78$var$subarray](0, l);
}
function $be857304663aed78$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $be857304663aed78$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$be857304663aed78$var$subarray](0, l);
}
function $be857304663aed78$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $be857304663aed78$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $be857304663aed78$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $be857304663aed78$var$parse_TSP_Reference(buf) {
    var pb = $be857304663aed78$var$parse_shallow(buf);
    return $be857304663aed78$var$varint_to_i32(pb[1][0].data);
}
function $be857304663aed78$var$write_TSP_Reference(idx) {
    return $be857304663aed78$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(idx)
            }
        ]
    ]);
}
function $be857304663aed78$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $be857304663aed78$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $be857304663aed78$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $be857304663aed78$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $be857304663aed78$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $be857304663aed78$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $be857304663aed78$var$parse_TST_TableDataList(M, root) {
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    var type = $be857304663aed78$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $be857304663aed78$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $be857304663aed78$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $be857304663aed78$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$be857304663aed78$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $be857304663aed78$var$parse_shallow(rt.data);
                var rtpref = M[$be857304663aed78$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $be857304663aed78$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $be857304663aed78$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $be857304663aed78$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $be857304663aed78$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $be857304663aed78$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$be857304663aed78$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $be857304663aed78$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $be857304663aed78$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $be857304663aed78$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $be857304663aed78$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $be857304663aed78$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$be857304663aed78$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $be857304663aed78$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $be857304663aed78$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $be857304663aed78$var$parse_shallow(u8);
    var R = $be857304663aed78$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $be857304663aed78$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $be857304663aed78$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $be857304663aed78$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$be857304663aed78$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$be857304663aed78$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $be857304663aed78$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($be857304663aed78$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $be857304663aed78$var$mappa(pb[5], function(u8) {
        return $be857304663aed78$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $be857304663aed78$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $be857304663aed78$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $be857304663aed78$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $be857304663aed78$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$be857304663aed78$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $be857304663aed78$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $be857304663aed78$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$be857304663aed78$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($be857304663aed78$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $be857304663aed78$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $be857304663aed78$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $be857304663aed78$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($be857304663aed78$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($be857304663aed78$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $be857304663aed78$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $be857304663aed78$var$parse_shallow(pb[4][0].data);
    var lut = $be857304663aed78$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $be857304663aed78$var$parse_TST_TableDataList(M, M[$be857304663aed78$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $be857304663aed78$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $be857304663aed78$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $be857304663aed78$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $be857304663aed78$var$varint_to_i32(kv[1][0].data);
        var tidx = $be857304663aed78$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $be857304663aed78$var$parse_shallow(t.data);
        var ref2 = M[$be857304663aed78$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $be857304663aed78$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $be857304663aed78$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $be857304663aed78$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$be857304663aed78$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $be857304663aed78$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $be857304663aed78$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $be857304663aed78$var$parse_shallow(pi.data);
            var origin = $be857304663aed78$var$u8_to_dataview($be857304663aed78$var$parse_shallow(merge[1][0].data)[1][0].data), size = $be857304663aed78$var$u8_to_dataview($be857304663aed78$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $be857304663aed78$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $be857304663aed78$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $be857304663aed78$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $be857304663aed78$var$parse_shallow(u);
                var formula = $be857304663aed78$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $be857304663aed78$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $be857304663aed78$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $be857304663aed78$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $be857304663aed78$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $be857304663aed78$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $be857304663aed78$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $be857304663aed78$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $be857304663aed78$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $be857304663aed78$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $be857304663aed78$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $be857304663aed78$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$be857304663aed78$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $be857304663aed78$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $be857304663aed78$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $be857304663aed78$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $be857304663aed78$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $be857304663aed78$var$mappa(pb[2], $be857304663aed78$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $be857304663aed78$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($be857304663aed78$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $be857304663aed78$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $be857304663aed78$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $be857304663aed78$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $be857304663aed78$var$mappa(pb[1], $be857304663aed78$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $be857304663aed78$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $be857304663aed78$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $be857304663aed78$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $be857304663aed78$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $be857304663aed78$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $be857304663aed78$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $be857304663aed78$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $be857304663aed78$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $be857304663aed78$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $be857304663aed78$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $be857304663aed78$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $be857304663aed78$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $be857304663aed78$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $be857304663aed78$var$write_new_storage(data[C], lut);
                    _celload = $be857304663aed78$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $be857304663aed78$var$write_new_storage(data[C], lut);
                _celload = $be857304663aed78$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $be857304663aed78$var$write_new_storage(data[C], lut);
                _celload = $be857304663aed78$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $be857304663aed78$var$write_varint49(cnt);
    tri[5][0].data = $be857304663aed78$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $be857304663aed78$var$u8concat(cell_storage);
    tri[3][0].data = $be857304663aed78$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $be857304663aed78$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $be857304663aed78$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $be857304663aed78$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $be857304663aed78$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $be857304663aed78$var$parse_iwa_file($be857304663aed78$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $be857304663aed78$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $be857304663aed78$var$parse_iwa_file($be857304663aed78$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($be857304663aed78$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $be857304663aed78$var$write_TSP_Color_RGB(r, g, b) {
    return $be857304663aed78$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $be857304663aed78$var$write_varint49(1)
            }
        ]
    ]);
}
function $be857304663aed78$var$get_author_color(n) {
    switch(n){
        case 0:
            return $be857304663aed78$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $be857304663aed78$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $be857304663aed78$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $be857304663aed78$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $be857304663aed78$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $be857304663aed78$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $be857304663aed78$var$build_numbers_deps(cfb);
    var docroot = $be857304663aed78$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $be857304663aed78$var$mappa($be857304663aed78$var$parse_shallow(docroot.messages[0].data)[1], $be857304663aed78$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $be857304663aed78$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $be857304663aed78$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $be857304663aed78$var$mappa($be857304663aed78$var$parse_shallow(docroot.messages[0].data)[1], $be857304663aed78$var$parse_TSP_Reference);
        }
        $be857304663aed78$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $be857304663aed78$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $be857304663aed78$var$parse_iwa_file($be857304663aed78$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $be857304663aed78$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $be857304663aed78$var$parse_iwa_file($be857304663aed78$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $be857304663aed78$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $be857304663aed78$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $be857304663aed78$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $be857304663aed78$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $be857304663aed78$var$write_varint49(Math.max(newid + 1, $be857304663aed78$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $be857304663aed78$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $be857304663aed78$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file([
        {
            id: id,
            messages: [
                $be857304663aed78$var$write_iwam(type, $be857304663aed78$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
        $be857304663aed78$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
    });
    return id;
}
function $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $be857304663aed78$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $be857304663aed78$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $be857304663aed78$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $be857304663aed78$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $be857304663aed78$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $be857304663aed78$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $be857304663aed78$var$write_shallow(parent);
}
function $be857304663aed78$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $be857304663aed78$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $be857304663aed78$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $be857304663aed78$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $be857304663aed78$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $be857304663aed78$var$varint_to_i32($be857304663aed78$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $be857304663aed78$var$write_shallow(parent);
}
function $be857304663aed78$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $be857304663aed78$var$parse_shallow(docroot.messages[0].data);
        sheetref = $be857304663aed78$var$parse_TSP_Reference($be857304663aed78$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $be857304663aed78$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $be857304663aed78$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $be857304663aed78$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $be857304663aed78$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $be857304663aed78$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $be857304663aed78$var$write_shallow(doc);
    });
    var tiaref = -1;
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $be857304663aed78$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $be857304663aed78$var$mappa(sa[2], $be857304663aed78$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $be857304663aed78$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $be857304663aed78$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $be857304663aed78$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $be857304663aed78$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $be857304663aed78$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
            });
            $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $be857304663aed78$var$write_shallow(sa);
    });
    var tmaref = -1;
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $be857304663aed78$var$parse_shallow(tiaroot.messages[0].data);
        var da = $be857304663aed78$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $be857304663aed78$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $be857304663aed78$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $be857304663aed78$var$write_shallow(da);
        var oldtmaref = $be857304663aed78$var$parse_TSP_Reference(tia[2][0].data);
        $be857304663aed78$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $be857304663aed78$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $be857304663aed78$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $be857304663aed78$var$write_TSP_Reference(tmaref);
        var tma = $be857304663aed78$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $be857304663aed78$var$write_shallow(tia);
    });
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $be857304663aed78$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $be857304663aed78$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $be857304663aed78$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $be857304663aed78$var$parse_shallow(tma[45][0].data);
            var ref = $be857304663aed78$var$parse_TSP_Reference(srrta[1][0].data);
            $be857304663aed78$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $be857304663aed78$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $be857304663aed78$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $be857304663aed78$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $be857304663aed78$var$parse_TSP_Reference(hsea[8][0].data);
                    $be857304663aed78$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $be857304663aed78$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $be857304663aed78$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $be857304663aed78$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $be857304663aed78$var$parse_TSP_Reference(store[n][0].data);
            var newref = $be857304663aed78$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $be857304663aed78$var$numbers_del_oref(tmaroot, oldref);
            $be857304663aed78$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $be857304663aed78$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                    $be857304663aed78$var$numbers_add_meta(mlist, newref, newloc);
                    $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $be857304663aed78$var$write_TSP_Reference(newref);
        });
        var row_headers = $be857304663aed78$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $be857304663aed78$var$parse_TSP_Reference(tspref.data);
            var newref = $be857304663aed78$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $be857304663aed78$var$numbers_del_oref(tmaroot, oldref);
            $be857304663aed78$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $be857304663aed78$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                    $be857304663aed78$var$numbers_add_meta(mlist, newref, newloc);
                    $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
                });
            }
            tspref.data = $be857304663aed78$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $be857304663aed78$var$write_shallow(row_headers);
        var tiles = $be857304663aed78$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $be857304663aed78$var$parse_shallow(t.data);
            var oldtileref = $be857304663aed78$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $be857304663aed78$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $be857304663aed78$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $be857304663aed78$var$numbers_del_oref(tmaroot, oldtileref);
                $be857304663aed78$var$numbers_add_oref(tmaroot, newtileref);
                $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file([
                    oldtile
                ])));
                $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $be857304663aed78$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $be857304663aed78$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $be857304663aed78$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $be857304663aed78$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $be857304663aed78$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $be857304663aed78$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(Math.max(newtileref + 1, $be857304663aed78$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $be857304663aed78$var$write_TSP_Reference(newtileref);
            t.data = $be857304663aed78$var$write_shallow(tst);
        });
        store[3][0].data = $be857304663aed78$var$write_shallow(tiles);
        tma[4][0].data = $be857304663aed78$var$write_shallow(store);
        tmaroot.messages[0].data = $be857304663aed78$var$write_shallow(tma);
    });
}
function $be857304663aed78$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $be857304663aed78$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $be857304663aed78$var$stru8(wsname)
            }
        ];
        drawables = $be857304663aed78$var$mappa(sheetref[2], $be857304663aed78$var$parse_TSP_Reference);
        docroot.messages[0].data = $be857304663aed78$var$write_shallow(sheetref);
    });
    var tia = $be857304663aed78$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $be857304663aed78$var$parse_TSP_Reference($be857304663aed78$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $be857304663aed78$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $be857304663aed78$var$USE_WIDE_ROWS = true;
function $be857304663aed78$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $be857304663aed78$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($be857304663aed78$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $be857304663aed78$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $be857304663aed78$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $be857304663aed78$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $be857304663aed78$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $be857304663aed78$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $be857304663aed78$var$parse_TSP_Reference($be857304663aed78$var$parse_shallow(store[1][0].data)[2][0].data);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $be857304663aed78$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $be857304663aed78$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $be857304663aed78$var$write_varint49(R2);
            _bucket[4][0].data = $be857304663aed78$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $be857304663aed78$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $be857304663aed78$var$write_shallow(base_bucket);
    });
    var col_header_ref = $be857304663aed78$var$parse_TSP_Reference(store[2][0].data);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $be857304663aed78$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $be857304663aed78$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $be857304663aed78$var$write_varint49(C);
            _bucket[4][0].data = $be857304663aed78$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $be857304663aed78$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $be857304663aed78$var$write_shallow(base_bucket);
    });
    var rbtree = $be857304663aed78$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $be857304663aed78$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $be857304663aed78$var$write_varint49(tstride)
        }
    ];
    var tileref = $be857304663aed78$var$parse_TSP_Reference($be857304663aed78$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $be857304663aed78$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $be857304663aed78$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $be857304663aed78$var$varint_to_i32($be857304663aed78$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $be857304663aed78$var$varint_to_i32($be857304663aed78$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $be857304663aed78$var$varint_to_i32($be857304663aed78$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $be857304663aed78$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
    });
    $be857304663aed78$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $be857304663aed78$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49($be857304663aed78$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $be857304663aed78$var$write_TST_TileRowInfo(data[R], LUT, $be857304663aed78$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $be857304663aed78$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $be857304663aed78$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $be857304663aed78$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $be857304663aed78$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $be857304663aed78$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $be857304663aed78$var$write_iwam(6002, $be857304663aed78$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $be857304663aed78$var$compress_iwa_file($be857304663aed78$var$write_iwa_file([
            newtile
        ]));
        $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $be857304663aed78$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $be857304663aed78$var$write_varint49(Math.max(newtileid + 1, $be857304663aed78$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
        });
        $be857304663aed78$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $be857304663aed78$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $be857304663aed78$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $be857304663aed78$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $be857304663aed78$var$write_shallow(tilestore);
    store[9][0].data = $be857304663aed78$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $be857304663aed78$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $be857304663aed78$var$write_iwam(6144, $be857304663aed78$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $be857304663aed78$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $be857304663aed78$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $be857304663aed78$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $be857304663aed78$var$write_TSP_Reference(mergeid)
            }
        ];
        $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
            $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
        });
        $be857304663aed78$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $be857304663aed78$var$parse_TSP_Reference(store[4][0].data);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $be857304663aed78$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $be857304663aed78$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $be857304663aed78$var$write_shallow(sstdata);
    });
    var rsstref = $be857304663aed78$var$parse_TSP_Reference(store[17][0].data);
    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $be857304663aed78$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $be857304663aed78$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $be857304663aed78$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $be857304663aed78$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $be857304663aed78$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $be857304663aed78$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $be857304663aed78$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $be857304663aed78$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $be857304663aed78$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $be857304663aed78$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $be857304663aed78$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $be857304663aed78$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $be857304663aed78$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $be857304663aed78$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $be857304663aed78$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $be857304663aed78$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $be857304663aed78$var$numbers_add_oref(rsstroot, rtpaid);
            $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $be857304663aed78$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $be857304663aed78$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $be857304663aed78$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $be857304663aed78$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $be857304663aed78$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $be857304663aed78$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $be857304663aed78$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $be857304663aed78$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                        $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $be857304663aed78$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $be857304663aed78$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $be857304663aed78$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $be857304663aed78$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $be857304663aed78$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $be857304663aed78$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $be857304663aed78$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $be857304663aed78$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $be857304663aed78$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $be857304663aed78$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $be857304663aed78$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $be857304663aed78$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $be857304663aed78$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $be857304663aed78$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $be857304663aed78$var$numbers_add_oref(cmntroot, csaid);
                $be857304663aed78$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $be857304663aed78$var$parse_shallow(ai.messages[0].data);
                    $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $be857304663aed78$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $be857304663aed78$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $be857304663aed78$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $be857304663aed78$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $be857304663aed78$var$write_shallow(store);
    tmaroot.messages[0].data = $be857304663aed78$var$write_shallow(pb);
}
function $be857304663aed78$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $be857304663aed78$var$fix_read_opts(opts) {
    $be857304663aed78$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $be857304663aed78$var$fix_write_opts(opts) {
    $be857304663aed78$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $be857304663aed78$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($be857304663aed78$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($be857304663aed78$var$RELS.CS && n == $be857304663aed78$var$RELS.CS) return "chart";
    if ($be857304663aed78$var$RELS.DS && n == $be857304663aed78$var$RELS.DS) return "dialog";
    if ($be857304663aed78$var$RELS.MS && n == $be857304663aed78$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $be857304663aed78$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $be857304663aed78$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $be857304663aed78$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $be857304663aed78$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $be857304663aed78$var$getzipstr(zip, dfile, true);
    if (draw) $be857304663aed78$var$parse_vml($be857304663aed78$var$utf8read(draw), sheet, comments || []);
}
function $be857304663aed78$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $be857304663aed78$var$parse_rels($be857304663aed78$var$getzipstr(zip, relsPath, true), path);
        var data = $be857304663aed78$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $be857304663aed78$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $be857304663aed78$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $be857304663aed78$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $be857304663aed78$var$get_rels_path(dfile);
                var draw = $be857304663aed78$var$parse_drawing($be857304663aed78$var$getzipstr(zip, dfile, true), $be857304663aed78$var$parse_rels($be857304663aed78$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $be857304663aed78$var$resolve_path(draw, dfile);
                var crelsp = $be857304663aed78$var$get_rels_path(chartp);
                _ws = $be857304663aed78$var$parse_chart($be857304663aed78$var$getzipstr(zip, chartp, true), chartp, opts, $be857304663aed78$var$parse_rels($be857304663aed78$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $be857304663aed78$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $be857304663aed78$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $be857304663aed78$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $be857304663aed78$var$RELS.CMNT) {
                dfile = $be857304663aed78$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $be857304663aed78$var$parse_cmnt($be857304663aed78$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $be857304663aed78$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $be857304663aed78$var$RELS.TCMNT) {
                dfile = $be857304663aed78$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($be857304663aed78$var$parse_tcmnt_xml($be857304663aed78$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $be857304663aed78$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $be857304663aed78$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $be857304663aed78$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $be857304663aed78$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $be857304663aed78$var$make_ssf();
    opts = opts || {};
    $be857304663aed78$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($be857304663aed78$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $be857304663aed78$var$parse_ods(zip, opts);
    /* UOC */ if ($be857304663aed78$var$safegetzipfile(zip, 'objectdata.xml')) return $be857304663aed78$var$parse_ods(zip, opts);
    /* Numbers */ if ($be857304663aed78$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $be857304663aed78$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $be857304663aed78$var$parse_numbers_iwa(zip, opts);
            var _zip = $be857304663aed78$export$9f0e51cd97c572a.utils.cfb_new();
            $be857304663aed78$var$zipentries(zip).forEach(function(e) {
                $be857304663aed78$var$zip_add_file(_zip, e, $be857304663aed78$var$getzipbin(zip, e));
            });
            return $be857304663aed78$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$be857304663aed78$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($be857304663aed78$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($be857304663aed78$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $be857304663aed78$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $be857304663aed78$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $be857304663aed78$require$Buffer.isBuffer(index_zip.content)) return $be857304663aed78$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $be857304663aed78$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $be857304663aed78$var$zipentries(zip);
    var dir = $be857304663aed78$var$parse_ct($be857304663aed78$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($be857304663aed78$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$be857304663aed78$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $be857304663aed78$var$strs = [];
        if (dir.sst) try {
            $be857304663aed78$var$strs = $be857304663aed78$var$parse_sst($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $be857304663aed78$var$parse_theme_xml($be857304663aed78$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $be857304663aed78$var$parse_sty($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $be857304663aed78$var$parse_rels($be857304663aed78$var$getzipstr(zip, $be857304663aed78$var$get_rels_path($be857304663aed78$var$strip_front_slash(link))), link);
            return $be857304663aed78$var$parse_xlink($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $be857304663aed78$var$parse_wb($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $be857304663aed78$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $be857304663aed78$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $be857304663aed78$var$getzipstr(zip, $be857304663aed78$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $be857304663aed78$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $be857304663aed78$var$parse_cc($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$be857304663aed78$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $be857304663aed78$var$parse_rels($be857304663aed78$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $be857304663aed78$var$parse_xlmeta($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $be857304663aed78$var$parse_people_xml($be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $be857304663aed78$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $be857304663aed78$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$be857304663aed78$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$be857304663aed78$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $be857304663aed78$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $be857304663aed78$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $be857304663aed78$var$dup($be857304663aed78$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $be857304663aed78$var$getzipdata(zip, $be857304663aed78$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $be857304663aed78$var$CT_VBA) out.vbaraw = $be857304663aed78$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $be857304663aed78$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $be857304663aed78$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $be857304663aed78$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $be857304663aed78$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $be857304663aed78$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $be857304663aed78$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $be857304663aed78$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $be857304663aed78$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (wb && wb.SSF) {
        $be857304663aed78$var$make_ssf();
        $be857304663aed78$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $be857304663aed78$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($be857304663aed78$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $be857304663aed78$var$new_ct();
    $be857304663aed78$var$fix_write_opts(opts = opts || {});
    var zip = $be857304663aed78$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $be857304663aed78$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 2, f, $be857304663aed78$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 3, f, $be857304663aed78$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $be857304663aed78$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $be857304663aed78$var$add_rels(opts.rels, 4, f, $be857304663aed78$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $be857304663aed78$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $be857304663aed78$var$zip_add_file(zip, cf, $be857304663aed78$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $be857304663aed78$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $be857304663aed78$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $be857304663aed78$var$zip_add_file(zip, cf, $be857304663aed78$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $be857304663aed78$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $be857304663aed78$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $be857304663aed78$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $be857304663aed78$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $be857304663aed78$var$zip_add_file(zip, $be857304663aed78$var$get_rels_path(f), $be857304663aed78$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $be857304663aed78$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 1, f, $be857304663aed78$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $be857304663aed78$var$write_theme(wb.Themes, opts);
    $be857304663aed78$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $be857304663aed78$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "styles." + wbext, $be857304663aed78$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $be857304663aed78$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $be857304663aed78$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $be857304663aed78$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_people_xml(people, opts));
        ct.people.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "persons/person.xml", $be857304663aed78$var$RELS.PEOPLE);
    }
    $be857304663aed78$var$zip_add_file(zip, "[Content_Types].xml", $be857304663aed78$var$write_ct(ct, opts));
    $be857304663aed78$var$zip_add_file(zip, '_rels/.rels', $be857304663aed78$var$write_rels(opts.rels));
    $be857304663aed78$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $be857304663aed78$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $be857304663aed78$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (wb && wb.SSF) {
        $be857304663aed78$var$make_ssf();
        $be857304663aed78$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $be857304663aed78$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($be857304663aed78$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $be857304663aed78$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $be857304663aed78$var$new_ct();
    $be857304663aed78$var$fix_write_opts(opts = opts || {});
    var zip = $be857304663aed78$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $be857304663aed78$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 2, f, $be857304663aed78$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 3, f, $be857304663aed78$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $be857304663aed78$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $be857304663aed78$var$add_rels(opts.rels, 4, f, $be857304663aed78$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $be857304663aed78$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $be857304663aed78$var$zip_add_file(zip, cf, $be857304663aed78$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $be857304663aed78$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $be857304663aed78$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $be857304663aed78$var$zip_add_file(zip, cf, $be857304663aed78$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $be857304663aed78$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $be857304663aed78$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $be857304663aed78$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $be857304663aed78$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $be857304663aed78$var$zip_add_file(zip, $be857304663aed78$var$get_rels_path(f), $be857304663aed78$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $be857304663aed78$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $be857304663aed78$var$add_rels(opts.rels, 1, f, $be857304663aed78$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $be857304663aed78$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "styles." + wbext, $be857304663aed78$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $be857304663aed78$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $be857304663aed78$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $be857304663aed78$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $be857304663aed78$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $be857304663aed78$var$zip_add_file(zip, f, $be857304663aed78$var$write_people_xml(people, opts));
        ct.people.push(f);
        $be857304663aed78$var$add_rels(opts.wbrels, -1, "persons/person.xml", $be857304663aed78$var$RELS.PEOPLE);
    }
    $be857304663aed78$var$zip_add_file(zip, "[Content_Types].xml", $be857304663aed78$var$write_ct(ct, opts));
    $be857304663aed78$var$zip_add_file(zip, '_rels/.rels', $be857304663aed78$var$write_rels(opts.rels));
    $be857304663aed78$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $be857304663aed78$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $be857304663aed78$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $be857304663aed78$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $be857304663aed78$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($be857304663aed78$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $be857304663aed78$var$parse_xlsxcfb(cfb, opts);
    return $be857304663aed78$export$b41972a043aba84c(cfb, opts);
}
function $be857304663aed78$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $be857304663aed78$var$zip_read(d, o);
    return $be857304663aed78$export$b165387946f79a1(zip, o);
}
function $be857304663aed78$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $be857304663aed78$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $be857304663aed78$var$PRN.to_workbook(data, o);
}
function $be857304663aed78$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $be857304663aed78$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $be857304663aed78$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $be857304663aed78$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $be857304663aed78$var$utf8read(str);
    o.type = "binary";
    return $be857304663aed78$var$read_plaintext(str, o);
}
function $be857304663aed78$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $be857304663aed78$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $be857304663aed78$var$$cptable !== "undefined" ? $be857304663aed78$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $be857304663aed78$var$utf16lereadu(d.slice(2)) : $be857304663aed78$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $be857304663aed78$var$read_plaintext(d, o);
}
function $be857304663aed78$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $be857304663aed78$var$utf8write(data);
}
function $be857304663aed78$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $be857304663aed78$var$PRN.to_workbook(data, o);
    }
    return $be857304663aed78$var$PRN.to_workbook(d, o);
}
function $be857304663aed78$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $be857304663aed78$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $be857304663aed78$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $be857304663aed78$export$aafa59e2e03f2942(new Uint8Array(data), (o = $be857304663aed78$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $be857304663aed78$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $be857304663aed78$var$_ssfopts = {};
    if (o.dateNF) $be857304663aed78$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $be857304663aed78$var$has_buf && $be857304663aed78$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $be857304663aed78$var$has_buf ? "buffer" : "binary";
        d = $be857304663aed78$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$be857304663aed78$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $be857304663aed78$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $be857304663aed78$var$dup(o);
            o.type = 'array';
            return $be857304663aed78$export$aafa59e2e03f2942($be857304663aed78$var$ab2a(d), o);
        }
    }
    switch((n = $be857304663aed78$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $be857304663aed78$var$read_cfb($be857304663aed78$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $be857304663aed78$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $be857304663aed78$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $be857304663aed78$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $be857304663aed78$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $be857304663aed78$var$read_zip(d, o) : $be857304663aed78$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $be857304663aed78$var$parse_xlml(d, o) : $be857304663aed78$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $be857304663aed78$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $be857304663aed78$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $be857304663aed78$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $be857304663aed78$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $be857304663aed78$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $be857304663aed78$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $be857304663aed78$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($be857304663aed78$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $be857304663aed78$var$DBF.to_workbook(d, o);
    return $be857304663aed78$var$read_prn(data, d, o, str);
}
function $be857304663aed78$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $be857304663aed78$export$aafa59e2e03f2942(filename, o);
}
function $be857304663aed78$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $be857304663aed78$var$write_dl(o.file, $be857304663aed78$export$9f0e51cd97c572a.write(cfb, {
                type: $be857304663aed78$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $be857304663aed78$export$9f0e51cd97c572a.write(cfb, o);
}
function $be857304663aed78$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $be857304663aed78$var$write_ods(wb, opts);
        case "numbers":
            return $be857304663aed78$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $be857304663aed78$var$write_zip_xlsb(wb, opts);
        default:
            return $be857304663aed78$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $be857304663aed78$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $be857304663aed78$var$dup(opts || {});
    var z = $be857304663aed78$var$write_zip(wb, o);
    return $be857304663aed78$var$write_zip_denouement(z, o);
}
function $be857304663aed78$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $be857304663aed78$var$dup(opts || {});
    var z = $be857304663aed78$var$write_zip_xlsx(wb, o);
    return $be857304663aed78$var$write_zip_denouement(z, o);
}
function $be857304663aed78$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $be857304663aed78$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $be857304663aed78$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($be857304663aed78$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $be857304663aed78$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $be857304663aed78$var$write_dl(o.file, out);
    return o.type == "string" ? $be857304663aed78$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $be857304663aed78$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $be857304663aed78$var$write_xlscfb(wb, o);
    return $be857304663aed78$var$write_cfb_ctr(cfb, o);
}
function $be857304663aed78$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $be857304663aed78$var$Base64_encode($be857304663aed78$var$utf8write(o));
        case "binary":
            return $be857304663aed78$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $be857304663aed78$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($be857304663aed78$var$has_buf) return $be857304663aed78$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $be857304663aed78$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $be857304663aed78$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $be857304663aed78$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $be857304663aed78$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($be857304663aed78$var$has_buf) return $be857304663aed78$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $be857304663aed78$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $be857304663aed78$var$Base64_encode(bstr) : opts.type == 'string' ? $be857304663aed78$var$utf8read(bstr) : bstr;
        case "file":
            return $be857304663aed78$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $be857304663aed78$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $be857304663aed78$var$reset_cp();
    $be857304663aed78$var$check_wb(wb);
    var o = $be857304663aed78$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $be857304663aed78$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $be857304663aed78$var$s2ab(out);
    }
    return $be857304663aed78$var$write_zip_typeXLSX(wb, o);
}
function $be857304663aed78$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $be857304663aed78$var$reset_cp();
    $be857304663aed78$var$check_wb(wb);
    var o = $be857304663aed78$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $be857304663aed78$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $be857304663aed78$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $be857304663aed78$var$write_stxt_type($be857304663aed78$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $be857304663aed78$var$write_binary_type($be857304663aed78$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $be857304663aed78$var$write_string_type($be857304663aed78$var$write_ods(wb, o), o);
        case 'wk1':
            return $be857304663aed78$var$write_binary_type($be857304663aed78$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $be857304663aed78$var$write_binary_type($be857304663aed78$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $be857304663aed78$var$write_binary_type($be857304663aed78$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $be857304663aed78$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $be857304663aed78$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $be857304663aed78$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $be857304663aed78$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $be857304663aed78$var$resolve_book_type(o);
    return $be857304663aed78$export$68d8715fc104d294(wb, o);
}
function $be857304663aed78$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $be857304663aed78$var$resolve_book_type(o);
    return $be857304663aed78$export$f6ca43591cb061b1(wb, o);
}
function $be857304663aed78$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $be857304663aed78$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $be857304663aed78$var$_fs.writeFile(filename, $be857304663aed78$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $be857304663aed78$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $be857304663aed78$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$be857304663aed78$var$fmt_is_date(val1.z)) break;
                v = $be857304663aed78$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $be857304663aed78$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $be857304663aed78$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $be857304663aed78$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $be857304663aed78$var$safe_decode_range(range);
            break;
        case 'number':
            r = $be857304663aed78$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $be857304663aed78$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $be857304663aed78$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $be857304663aed78$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $be857304663aed78$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $be857304663aed78$var$qreg = /"/g;
function $be857304663aed78$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $be857304663aed78$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $be857304663aed78$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($be857304663aed78$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($be857304663aed78$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $be857304663aed78$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $be857304663aed78$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $be857304663aed78$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $be857304663aed78$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $be857304663aed78$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $be857304663aed78$var$sheet_to_csv(sheet, opts);
    if (typeof $be857304663aed78$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $be857304663aed78$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $be857304663aed78$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $be857304663aed78$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $be857304663aed78$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $be857304663aed78$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $be857304663aed78$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($be857304663aed78$var$DENSE != null && dense == null) dense = $be857304663aed78$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $be857304663aed78$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $be857304663aed78$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $be857304663aed78$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $be857304663aed78$var$encode_col(_C + C) + $be857304663aed78$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $be857304663aed78$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $be857304663aed78$var$datenum(v);
                    }
                    z = cell != null && cell.z && $be857304663aed78$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $be857304663aed78$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $be857304663aed78$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$be857304663aed78$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $be857304663aed78$var$encode_range(range);
    return ws;
}
function $be857304663aed78$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $be857304663aed78$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $be857304663aed78$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $be857304663aed78$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $be857304663aed78$var$ws_get_cell_stub(ws, $be857304663aed78$var$encode_cell(R));
    /* R and C are 0-based indices */ return $be857304663aed78$var$ws_get_cell_stub(ws, $be857304663aed78$var$encode_col(C || 0) + $be857304663aed78$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $be857304663aed78$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $be857304663aed78$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $be857304663aed78$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $be857304663aed78$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $be857304663aed78$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $be857304663aed78$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $be857304663aed78$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $be857304663aed78$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $be857304663aed78$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $be857304663aed78$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $be857304663aed78$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $be857304663aed78$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $be857304663aed78$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $be857304663aed78$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $be857304663aed78$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $be857304663aed78$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $be857304663aed78$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $be857304663aed78$var$encode_range(wsr);
    return ws;
}
var $be857304663aed78$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $be857304663aed78$var$encode_col,
    encode_row: $be857304663aed78$var$encode_row,
    encode_cell: $be857304663aed78$var$encode_cell,
    encode_range: $be857304663aed78$var$encode_range,
    decode_col: $be857304663aed78$var$decode_col,
    decode_row: $be857304663aed78$var$decode_row,
    split_cell: $be857304663aed78$var$split_cell,
    decode_cell: $be857304663aed78$var$decode_cell,
    decode_range: $be857304663aed78$var$decode_range,
    format_cell: $be857304663aed78$var$format_cell,
    sheet_new: $be857304663aed78$var$sheet_new,
    sheet_add_aoa: $be857304663aed78$var$sheet_add_aoa,
    sheet_add_json: $be857304663aed78$var$sheet_add_json,
    sheet_add_dom: $be857304663aed78$var$sheet_add_dom,
    aoa_to_sheet: $be857304663aed78$var$aoa_to_sheet,
    json_to_sheet: $be857304663aed78$var$json_to_sheet,
    table_to_sheet: $be857304663aed78$var$parse_dom_table,
    table_to_book: $be857304663aed78$var$table_to_book,
    sheet_to_csv: $be857304663aed78$var$sheet_to_csv,
    sheet_to_txt: $be857304663aed78$var$sheet_to_txt,
    sheet_to_json: $be857304663aed78$var$sheet_to_json,
    sheet_to_html: $be857304663aed78$var$sheet_to_html,
    sheet_to_formulae: $be857304663aed78$var$sheet_to_formulae,
    sheet_to_row_object_array: $be857304663aed78$var$sheet_to_json,
    sheet_get_cell: $be857304663aed78$var$ws_get_cell_stub,
    book_new: $be857304663aed78$var$book_new,
    book_append_sheet: $be857304663aed78$var$book_append_sheet,
    book_set_sheet_visibility: $be857304663aed78$var$book_set_sheet_visibility,
    cell_set_number_format: $be857304663aed78$var$cell_set_number_format,
    cell_set_hyperlink: $be857304663aed78$var$cell_set_hyperlink,
    cell_set_internal_link: $be857304663aed78$var$cell_set_internal_link,
    cell_add_comment: $be857304663aed78$var$cell_add_comment,
    sheet_set_array_formula: $be857304663aed78$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $be857304663aed78$var$_Readable;
function $be857304663aed78$var$set_readable(R) {
    $be857304663aed78$var$_Readable = R;
}
function $be857304663aed78$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $be857304663aed78$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $be857304663aed78$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $be857304663aed78$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $be857304663aed78$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $be857304663aed78$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $be857304663aed78$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $be857304663aed78$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $be857304663aed78$var$HTML_END;
    stream.push(header);
    var r = $be857304663aed78$var$decode_range(ws['!ref']);
    stream.push($be857304663aed78$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($be857304663aed78$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $be857304663aed78$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $be857304663aed78$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $be857304663aed78$var$safe_decode_range(range);
            break;
        case 'number':
            r = $be857304663aed78$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $be857304663aed78$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $be857304663aed78$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $be857304663aed78$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $be857304663aed78$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $be857304663aed78$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $be857304663aed78$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $be857304663aed78$var$dup($be857304663aed78$var$table_fmt);
    if (wb.SSF) {
        $be857304663aed78$var$make_ssf();
        $be857304663aed78$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $be857304663aed78$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $be857304663aed78$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $be857304663aed78$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $be857304663aed78$var$dup(cell);
                    cell.z = $be857304663aed78$var$table_fmt[14];
                }
                $be857304663aed78$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $be857304663aed78$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $be857304663aed78$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($be857304663aed78$var$XML_HEADER);
                stream.push("<Workbook" + $be857304663aed78$var$wxt_helper({
                    'xmlns': $be857304663aed78$var$XLMLNS.ss,
                    'xmlns:o': $be857304663aed78$var$XLMLNS.o,
                    'xmlns:x': $be857304663aed78$var$XLMLNS.x,
                    'xmlns:ss': $be857304663aed78$var$XLMLNS.ss,
                    'xmlns:dt': $be857304663aed78$var$XLMLNS.dt,
                    'xmlns:html': $be857304663aed78$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($be857304663aed78$var$write_props_xlml(wb, opts));
                stream.push($be857304663aed78$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($be857304663aed78$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $be857304663aed78$var$wxt_helper({
                    "ss:Name": $be857304663aed78$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $be857304663aed78$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $be857304663aed78$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $be857304663aed78$var$process_col(n);
                        var w = !!n.width;
                        var p = $be857304663aed78$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $be857304663aed78$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($be857304663aed78$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $be857304663aed78$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $be857304663aed78$var$encode_col(C) + $be857304663aed78$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($be857304663aed78$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($be857304663aed78$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $be857304663aed78$var$a1_to_rc($be857304663aed78$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $be857304663aed78$export$4938110305e6185f = {
    to_json: $be857304663aed78$var$write_json_stream,
    to_html: $be857304663aed78$var$write_html_stream,
    to_csv: $be857304663aed78$var$write_csv_stream,
    to_xlml: $be857304663aed78$var$write_xlml_stream,
    set_readable: $be857304663aed78$var$set_readable
};
const $be857304663aed78$export$83d89fbfd8236492 = $be857304663aed78$var$XLSX.version;
var $be857304663aed78$export$2e2bcd8739ae039 = {
    parse_xlscfb: $be857304663aed78$export$b41972a043aba84c,
    parse_zip: $be857304663aed78$export$b165387946f79a1,
    read: $be857304663aed78$export$aafa59e2e03f2942,
    readFile: $be857304663aed78$export$72c04af63de9061a,
    readFileSync: $be857304663aed78$export$72c04af63de9061a,
    write: $be857304663aed78$export$68d8715fc104d294,
    writeFile: $be857304663aed78$export$552bfb764b5cd2b4,
    writeFileSync: $be857304663aed78$export$552bfb764b5cd2b4,
    writeFileAsync: $be857304663aed78$export$25469296c4b8ebda,
    writeXLSX: $be857304663aed78$export$f6ca43591cb061b1,
    writeFileXLSX: $be857304663aed78$export$40a06aea54ee074e,
    utils: $be857304663aed78$export$eab97d15b1788b8d,
    set_fs: $be857304663aed78$export$a48eb669e1768bcf,
    set_cptable: $be857304663aed78$export$58f247d16f363b86,
    stream: $be857304663aed78$export$4938110305e6185f,
    SSF: $be857304663aed78$export$40d8edd678456c2b,
    CFB: $be857304663aed78$export$9f0e51cd97c572a
};



var $93qLg = parcelRequire("93qLg");
'use strict';
const $2438f44761dfbbef$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $2438f44761dfbbef$var$nameChar = $2438f44761dfbbef$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $2438f44761dfbbef$export$e8f2644f7085b4b1 = '[' + $2438f44761dfbbef$var$nameStartChar + '][' + $2438f44761dfbbef$var$nameChar + ']*';
const $2438f44761dfbbef$var$regexName = new RegExp('^' + $2438f44761dfbbef$export$e8f2644f7085b4b1 + '$');
function $2438f44761dfbbef$export$aaa9734c55cb7a19(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
}
const $2438f44761dfbbef$export$998d7ff9801e90bb = function(string) {
    const match = $2438f44761dfbbef$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
function $2438f44761dfbbef$export$a5edf3f35b6dd392(v) {
    return typeof v !== 'undefined';
}
function $2438f44761dfbbef$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $2438f44761dfbbef$export$bf7199a9ebcb84a9(v) {
    if ($2438f44761dfbbef$export$a5edf3f35b6dd392(v)) return v;
    else return '';
}
const $2438f44761dfbbef$export$a992756d162cd0c0 = [
    // '__proto__',
    // 'constructor',
    // 'prototype',
    'hasOwnProperty',
    'toString',
    'valueOf',
    '__defineGetter__',
    '__defineSetter__',
    '__lookupGetter__',
    '__lookupSetter__'
];
const $2438f44761dfbbef$export$deb3cacd0e79cda8 = [
    "__proto__",
    "constructor",
    "prototype"
];



const $59ada2bd4c3e0111$var$defaultOnDangerousProperty = (name)=>{
    if ((0, $2438f44761dfbbef$export$a992756d162cd0c0).includes(name)) return "__" + name;
    return name;
};
const $59ada2bd4c3e0111$export$ba43bf67f3d48107 = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    entityDecoder: null,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    },
    // skipEmptyListItem: false
    captureMetaData: false,
    maxNestedTags: 100,
    strictReservedNames: true,
    jPath: true,
    onDangerousProperty: $59ada2bd4c3e0111$var$defaultOnDangerousProperty
};
/**
 * Validates that a property name is safe to use
 * @param {string} propertyName - The property name to validate
 * @param {string} optionName - The option field name (for error message)
 * @throws {Error} If property name is dangerous
 */ function $59ada2bd4c3e0111$var$validatePropertyName(propertyName, optionName) {
    if (typeof propertyName !== 'string') return; // Only validate string property names
    const normalized = propertyName.toLowerCase();
    if ((0, $2438f44761dfbbef$export$a992756d162cd0c0).some((dangerous)=>normalized === dangerous.toLowerCase())) throw new Error(`[SECURITY] Invalid ${optionName}: "${propertyName}" is a reserved JavaScript keyword that could cause prototype pollution`);
    if ((0, $2438f44761dfbbef$export$deb3cacd0e79cda8).some((dangerous)=>normalized === dangerous.toLowerCase())) throw new Error(`[SECURITY] Invalid ${optionName}: "${propertyName}" is a reserved JavaScript keyword that could cause prototype pollution`);
}
/**
 * Normalizes processEntities option for backward compatibility
 * @param {boolean|object} value 
 * @returns {object} Always returns normalized object
 */ function $59ada2bd4c3e0111$var$normalizeProcessEntities(value, htmlEntities) {
    // Boolean backward compatibility
    if (typeof value === 'boolean') return {
        enabled: value,
        maxEntitySize: 10000,
        maxExpansionDepth: 10000,
        maxTotalExpansions: Infinity,
        maxExpandedLength: 100000,
        maxEntityCount: 1000,
        allowedTags: null,
        tagFilter: null,
        appliesTo: "all"
    };
    // Object config - merge with defaults
    if (typeof value === 'object' && value !== null) return {
        enabled: value.enabled !== false,
        maxEntitySize: Math.max(1, value.maxEntitySize ?? 10000),
        maxExpansionDepth: Math.max(1, value.maxExpansionDepth ?? 10000),
        maxTotalExpansions: Math.max(1, value.maxTotalExpansions ?? Infinity),
        maxExpandedLength: Math.max(1, value.maxExpandedLength ?? 100000),
        maxEntityCount: Math.max(1, value.maxEntityCount ?? 1000),
        allowedTags: value.allowedTags ?? null,
        tagFilter: value.tagFilter ?? null,
        appliesTo: value.appliesTo ?? "all"
    };
    // Default to enabled with limits
    return $59ada2bd4c3e0111$var$normalizeProcessEntities(true);
}
const $59ada2bd4c3e0111$export$ecbd7d678ac4909b = function(options) {
    const built = Object.assign({}, $59ada2bd4c3e0111$export$ba43bf67f3d48107, options);
    // Validate property names to prevent prototype pollution
    const propertyNameOptions = [
        {
            value: built.attributeNamePrefix,
            name: 'attributeNamePrefix'
        },
        {
            value: built.attributesGroupName,
            name: 'attributesGroupName'
        },
        {
            value: built.textNodeName,
            name: 'textNodeName'
        },
        {
            value: built.cdataPropName,
            name: 'cdataPropName'
        },
        {
            value: built.commentPropName,
            name: 'commentPropName'
        }
    ];
    for (const { value: value, name: name } of propertyNameOptions)if (value) $59ada2bd4c3e0111$var$validatePropertyName(value, name);
    if (built.onDangerousProperty === null) built.onDangerousProperty = $59ada2bd4c3e0111$var$defaultOnDangerousProperty;
    // Always normalize processEntities for backward compatibility and validation
    built.processEntities = $59ada2bd4c3e0111$var$normalizeProcessEntities(built.processEntities, built.htmlEntities);
    built.unpairedTagsSet = new Set(built.unpairedTags);
    // Convert old-style stopNodes for backward compatibility
    if (built.stopNodes && Array.isArray(built.stopNodes)) built.stopNodes = built.stopNodes.map((node)=>{
        if (typeof node === 'string' && node.startsWith('*.')) // Old syntax: *.tagname meant "tagname anywhere"
        // Convert to new syntax: ..tagname
        return '..' + node.substring(2);
        return node;
    });
    //console.debug(built.processEntities)
    return built;
};



'use strict';
let $1d0979e96b37bc5b$var$METADATA_SYMBOL;
if (typeof Symbol !== "function") $1d0979e96b37bc5b$var$METADATA_SYMBOL = "@@xmlMetadata";
else $1d0979e96b37bc5b$var$METADATA_SYMBOL = Symbol("XML Node Metadata");
class $1d0979e96b37bc5b$export$2e2bcd8739ae039 {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = Object.create(null); //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node, startIndex) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
        // if requested, add the startIndex
        if (startIndex !== undefined) // Note: for now we just overwrite the metadata. If we had more complex metadata,
        // we might need to do an object append here:  metadata = { ...metadata, startIndex }
        this.child[this.child.length - 1][$1d0979e96b37bc5b$var$METADATA_SYMBOL] = {
            startIndex: startIndex
        };
    }
    /** symbol used for metadata */ static getMetaDataSymbol() {
        return $1d0979e96b37bc5b$var$METADATA_SYMBOL;
    }
}



class $057cde97f5d8e852$export$2e2bcd8739ae039 {
    constructor(options){
        this.suppressValidationErr = !options;
        this.options = options;
    }
    readDocType(xmlData, i) {
        const entities = Object.create(null);
        let entityCount = 0;
        if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
            i = i + 9;
            let angleBracketsCount = 1;
            let hasBody = false, comment = false;
            let exp = "";
            for(; i < xmlData.length; i++){
                if (xmlData[i] === '<' && !comment) {
                    if (hasBody && $057cde97f5d8e852$var$hasSeq(xmlData, "!ENTITY", i)) {
                        i += 7;
                        let entityName, val;
                        [entityName, val, i] = this.readEntityExp(xmlData, i + 1, this.suppressValidationErr);
                        if (val.indexOf("&") === -1) {
                            if (this.options.enabled !== false && this.options.maxEntityCount != null && entityCount >= this.options.maxEntityCount) throw new Error(`Entity count (${entityCount + 1}) exceeds maximum allowed (${this.options.maxEntityCount})`);
                            //const escaped = entityName.replace(/[.\-+*:]/g, '\\.');
                            //const escaped = entityName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                            entities[entityName] = val;
                            entityCount++;
                        }
                    } else if (hasBody && $057cde97f5d8e852$var$hasSeq(xmlData, "!ELEMENT", i)) {
                        i += 8; //Not supported
                        const { index: index } = this.readElementExp(xmlData, i + 1);
                        i = index;
                    } else if (hasBody && $057cde97f5d8e852$var$hasSeq(xmlData, "!ATTLIST", i)) i += 8; //Not supported
                    else if (hasBody && $057cde97f5d8e852$var$hasSeq(xmlData, "!NOTATION", i)) {
                        i += 9; //Not supported
                        const { index: index } = this.readNotationExp(xmlData, i + 1, this.suppressValidationErr);
                        i = index;
                    } else if ($057cde97f5d8e852$var$hasSeq(xmlData, "!--", i)) comment = true;
                    else throw new Error(`Invalid DOCTYPE`);
                    angleBracketsCount++;
                    exp = "";
                } else if (xmlData[i] === '>') {
                    if (comment) {
                        if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                            comment = false;
                            angleBracketsCount--;
                        }
                    } else angleBracketsCount--;
                    if (angleBracketsCount === 0) break;
                } else if (xmlData[i] === '[') hasBody = true;
                else exp += xmlData[i];
            }
            if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
        } else throw new Error(`Invalid Tag instead of DOCTYPE`);
        return {
            entities: entities,
            i: i
        };
    }
    readEntityExp(xmlData, i) {
        //External entities are not supported
        //    <!ENTITY ext SYSTEM "http://normal-website.com" >
        //Parameter entities are not supported
        //    <!ENTITY entityname "&anotherElement;">
        //Internal entities are supported
        //    <!ENTITY entityname "replacement text">
        // Skip leading whitespace after <!ENTITY
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read entity name
        const startIndex = i;
        while(i < xmlData.length && !/\s/.test(xmlData[i]) && xmlData[i] !== '"' && xmlData[i] !== "'")i++;
        let entityName = xmlData.substring(startIndex, i);
        $057cde97f5d8e852$var$validateEntityName(entityName);
        // Skip whitespace after entity name
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Check for unsupported constructs (external entities or parameter entities)
        if (!this.suppressValidationErr) {
            if (xmlData.substring(i, i + 6).toUpperCase() === "SYSTEM") throw new Error("External entities are not supported");
            else if (xmlData[i] === "%") throw new Error("Parameter entities are not supported");
        }
        // Read entity value (internal entity)
        let entityValue = "";
        [i, entityValue] = this.readIdentifierVal(xmlData, i, "entity");
        // Validate entity size
        if (this.options.enabled !== false && this.options.maxEntitySize != null && entityValue.length > this.options.maxEntitySize) throw new Error(`Entity "${entityName}" size (${entityValue.length}) exceeds maximum allowed size (${this.options.maxEntitySize})`);
        i--;
        return [
            entityName,
            entityValue,
            i
        ];
    }
    readNotationExp(xmlData, i) {
        // Skip leading whitespace after <!NOTATION
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read notation name
        const startIndex = i;
        while(i < xmlData.length && !/\s/.test(xmlData[i]))i++;
        let notationName = xmlData.substring(startIndex, i);
        !this.suppressValidationErr && $057cde97f5d8e852$var$validateEntityName(notationName);
        // Skip whitespace after notation name
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Check identifier type (SYSTEM or PUBLIC)
        const identifierType = xmlData.substring(i, i + 6).toUpperCase();
        if (!this.suppressValidationErr && identifierType !== "SYSTEM" && identifierType !== "PUBLIC") throw new Error(`Expected SYSTEM or PUBLIC, found "${identifierType}"`);
        i += identifierType.length;
        // Skip whitespace after identifier type
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read public identifier (if PUBLIC)
        let publicIdentifier = null;
        let systemIdentifier = null;
        if (identifierType === "PUBLIC") {
            [i, publicIdentifier] = this.readIdentifierVal(xmlData, i, "publicIdentifier");
            // Skip whitespace after public identifier
            i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
            // Optionally read system identifier
            if (xmlData[i] === '"' || xmlData[i] === "'") [i, systemIdentifier] = this.readIdentifierVal(xmlData, i, "systemIdentifier");
        } else if (identifierType === "SYSTEM") {
            // Read system identifier (mandatory for SYSTEM)
            [i, systemIdentifier] = this.readIdentifierVal(xmlData, i, "systemIdentifier");
            if (!this.suppressValidationErr && !systemIdentifier) throw new Error("Missing mandatory system identifier for SYSTEM notation");
        }
        return {
            notationName: notationName,
            publicIdentifier: publicIdentifier,
            systemIdentifier: systemIdentifier,
            index: --i
        };
    }
    readIdentifierVal(xmlData, i, type) {
        let identifierVal = "";
        const startChar = xmlData[i];
        if (startChar !== '"' && startChar !== "'") throw new Error(`Expected quoted string, found "${startChar}"`);
        i++;
        const startIndex = i;
        while(i < xmlData.length && xmlData[i] !== startChar)i++;
        identifierVal = xmlData.substring(startIndex, i);
        if (xmlData[i] !== startChar) throw new Error(`Unterminated ${type} value`);
        i++;
        return [
            i,
            identifierVal
        ];
    }
    readElementExp(xmlData, i) {
        // <!ELEMENT br EMPTY>
        // <!ELEMENT div ANY>
        // <!ELEMENT title (#PCDATA)>
        // <!ELEMENT book (title, author+)>
        // <!ELEMENT name (content-model)>
        // Skip leading whitespace after <!ELEMENT
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read element name
        const startIndex = i;
        while(i < xmlData.length && !/\s/.test(xmlData[i]))i++;
        let elementName = xmlData.substring(startIndex, i);
        // Validate element name
        if (!this.suppressValidationErr && !(0, $2438f44761dfbbef$export$998d7ff9801e90bb)(elementName)) throw new Error(`Invalid element name: "${elementName}"`);
        // Skip whitespace after element name
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        let contentModel = "";
        // Expect '(' to start content model
        if (xmlData[i] === "E" && $057cde97f5d8e852$var$hasSeq(xmlData, "MPTY", i)) i += 4;
        else if (xmlData[i] === "A" && $057cde97f5d8e852$var$hasSeq(xmlData, "NY", i)) i += 2;
        else if (xmlData[i] === "(") {
            i++; // Move past '('
            // Read content model
            const startIndex = i;
            while(i < xmlData.length && xmlData[i] !== ")")i++;
            contentModel = xmlData.substring(startIndex, i);
            if (xmlData[i] !== ")") throw new Error("Unterminated content model");
        } else if (!this.suppressValidationErr) throw new Error(`Invalid Element Expression, found "${xmlData[i]}"`);
        return {
            elementName: elementName,
            contentModel: contentModel.trim(),
            index: i
        };
    }
    readAttlistExp(xmlData, i) {
        // Skip leading whitespace after <!ATTLIST
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read element name
        let startIndex = i;
        while(i < xmlData.length && !/\s/.test(xmlData[i]))i++;
        let elementName = xmlData.substring(startIndex, i);
        // Validate element name
        $057cde97f5d8e852$var$validateEntityName(elementName);
        // Skip whitespace after element name
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read attribute name
        startIndex = i;
        while(i < xmlData.length && !/\s/.test(xmlData[i]))i++;
        let attributeName = xmlData.substring(startIndex, i);
        // Validate attribute name
        if (!$057cde97f5d8e852$var$validateEntityName(attributeName)) throw new Error(`Invalid attribute name: "${attributeName}"`);
        // Skip whitespace after attribute name
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read attribute type
        let attributeType = "";
        if (xmlData.substring(i, i + 8).toUpperCase() === "NOTATION") {
            attributeType = "NOTATION";
            i += 8; // Move past "NOTATION"
            // Skip whitespace after "NOTATION"
            i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
            // Expect '(' to start the list of notations
            if (xmlData[i] !== "(") throw new Error(`Expected '(', found "${xmlData[i]}"`);
            i++; // Move past '('
            // Read the list of allowed notations
            let allowedNotations = [];
            while(i < xmlData.length && xmlData[i] !== ")"){
                const startIndex = i;
                while(i < xmlData.length && xmlData[i] !== "|" && xmlData[i] !== ")")i++;
                let notation = xmlData.substring(startIndex, i);
                // Validate notation name
                notation = notation.trim();
                if (!$057cde97f5d8e852$var$validateEntityName(notation)) throw new Error(`Invalid notation name: "${notation}"`);
                allowedNotations.push(notation);
                // Skip '|' separator or exit loop
                if (xmlData[i] === "|") {
                    i++; // Move past '|'
                    i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i); // Skip optional whitespace after '|'
                }
            }
            if (xmlData[i] !== ")") throw new Error("Unterminated list of notations");
            i++; // Move past ')'
            // Store the allowed notations as part of the attribute type
            attributeType += " (" + allowedNotations.join("|") + ")";
        } else {
            // Handle simple types (e.g., CDATA, ID, IDREF, etc.)
            const startIndex = i;
            while(i < xmlData.length && !/\s/.test(xmlData[i]))i++;
            attributeType += xmlData.substring(startIndex, i);
            // Validate simple attribute type
            const validTypes = [
                "CDATA",
                "ID",
                "IDREF",
                "IDREFS",
                "ENTITY",
                "ENTITIES",
                "NMTOKEN",
                "NMTOKENS"
            ];
            if (!this.suppressValidationErr && !validTypes.includes(attributeType.toUpperCase())) throw new Error(`Invalid attribute type: "${attributeType}"`);
        }
        // Skip whitespace after attribute type
        i = $057cde97f5d8e852$var$skipWhitespace(xmlData, i);
        // Read default value
        let defaultValue = "";
        if (xmlData.substring(i, i + 8).toUpperCase() === "#REQUIRED") {
            defaultValue = "#REQUIRED";
            i += 8;
        } else if (xmlData.substring(i, i + 7).toUpperCase() === "#IMPLIED") {
            defaultValue = "#IMPLIED";
            i += 7;
        } else [i, defaultValue] = this.readIdentifierVal(xmlData, i, "ATTLIST");
        return {
            elementName: elementName,
            attributeName: attributeName,
            attributeType: attributeType,
            defaultValue: defaultValue,
            index: i
        };
    }
}
const $057cde97f5d8e852$var$skipWhitespace = (data, index)=>{
    while(index < data.length && /\s/.test(data[index]))index++;
    return index;
};
function $057cde97f5d8e852$var$hasSeq(data, seq, i) {
    for(let j = 0; j < seq.length; j++){
        if (seq[j] !== data[i + j + 1]) return false;
    }
    return true;
}
function $057cde97f5d8e852$var$validateEntityName(name) {
    if ((0, $2438f44761dfbbef$export$998d7ff9801e90bb)(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}


const $d1661821a19d4a29$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $d1661821a19d4a29$var$binRegex = /^0b[01]+$/;
const $d1661821a19d4a29$var$octRegex = /^0o[0-7]+$/;
const $d1661821a19d4a29$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
const $d1661821a19d4a29$var$consider = {
    hex: true,
    binary: false,
    octal: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true,
    //skipLike: /regex/,
    infinity: "original"
};
function $d1661821a19d4a29$export$2e2bcd8739ae039(str, options = {}) {
    options = Object.assign({}, $d1661821a19d4a29$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (trimmedStr.length === 0) return str;
    else if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (trimmedStr === "0") return 0;
    else if (options.hex && $d1661821a19d4a29$var$hexRegex.test(trimmedStr)) return $d1661821a19d4a29$var$parse_int(trimmedStr, 16);
    else if (options.binary && $d1661821a19d4a29$var$binRegex.test(trimmedStr)) return $d1661821a19d4a29$var$parse_int(trimmedStr, 2);
    else if (options.octal && $d1661821a19d4a29$var$octRegex.test(trimmedStr)) return $d1661821a19d4a29$var$parse_int(trimmedStr, 8);
    else if (!isFinite(trimmedStr)) return $d1661821a19d4a29$var$handleInfinity(str, Number(trimmedStr), options);
    else if (trimmedStr.includes('e') || trimmedStr.includes('E')) return $d1661821a19d4a29$var$resolveEnotation(str, trimmedStr, options);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $d1661821a19d4a29$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1] || "";
            const leadingZeros = match[2];
            let numTrimmedByZeros = $d1661821a19d4a29$var$trimZeros(match[3]); //complete num without leading zeros
            const decimalAdjacentToLeadingZeros = sign ? str[leadingZeros.length + 1] === "." : str[leadingZeros.length] === ".";
            //trim ending zeros for floating number
            if (!options.leadingZeros //leading zeros are not allowed
             && (leadingZeros.length > 1 || leadingZeros.length === 1 && !decimalAdjacentToLeadingZeros)) // 00, 00.3, +03.24, 03, 03.24
            return str;
            else {
                const num = Number(trimmedStr);
                const parsedStr = String(num);
                if (num === 0) return num;
                if (parsedStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (parsedStr === "0") return num; //0.0
                    else if (parsedStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (parsedStr === `${sign}${numTrimmedByZeros}`) return num;
                    else return str;
                }
                let n = leadingZeros ? numTrimmedByZeros : trimmedStr;
                if (leadingZeros) // -009 => -9
                return n === parsedStr || sign + n === parsedStr ? num : str;
                else // +9
                return n === parsedStr || n === sign + parsedStr ? num : str;
            }
        } else return str;
    }
}
const $d1661821a19d4a29$var$eNotationRegx = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
function $d1661821a19d4a29$var$resolveEnotation(str, trimmedStr, options) {
    if (!options.eNotation) return str;
    const notation = trimmedStr.match($d1661821a19d4a29$var$eNotationRegx);
    if (notation) {
        let sign = notation[1] || "";
        const eChar = notation[3].indexOf("e") === -1 ? "E" : "e";
        const leadingZeros = notation[2];
        const eAdjacentToLeadingZeros = sign ? str[leadingZeros.length + 1] === eChar : str[leadingZeros.length] === eChar;
        if (leadingZeros.length > 1 && eAdjacentToLeadingZeros) return str;
        else if (leadingZeros.length === 1 && (notation[3].startsWith(`.${eChar}`) || notation[3][0] === eChar)) return Number(trimmedStr);
        else if (leadingZeros.length > 0) {
            // Has leading zeros — only accept if leadingZeros option allows it
            if (options.leadingZeros && !eAdjacentToLeadingZeros) {
                trimmedStr = (notation[1] || "") + notation[3];
                return Number(trimmedStr);
            } else return str;
        } else // No leading zeros — always valid e-notation, parse it
        return Number(trimmedStr);
    } else return str;
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $d1661821a19d4a29$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substring(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $d1661821a19d4a29$var$parse_int(numStr, base) {
    const str = numStr.trim();
    if (base === 2 || base === 8) numStr = str.substring(2);
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
/**
 * Handle infinite values based on user option
 * @param {string} str - original input string
 * @param {number} num - parsed number (Infinity or -Infinity)
 * @param {object} options - user options
 * @returns {string|number|null} based on infinity option
 */ function $d1661821a19d4a29$var$handleInfinity(str, num, options) {
    const isPositive = num === Infinity;
    switch(options.infinity.toLowerCase()){
        case "null":
            return null;
        case "infinity":
            return num; // Return Infinity or -Infinity
        case "string":
            return isPositive ? "Infinity" : "-Infinity";
        case "original":
        default:
            return str; // Return original string like "1e1000"
    }
}


function $233d0f6ad1318d74$export$2e2bcd8739ae039(ignoreAttributes) {
    if (typeof ignoreAttributes === 'function') return ignoreAttributes;
    if (Array.isArray(ignoreAttributes)) return (attrName)=>{
        for (const pattern of ignoreAttributes){
            if (typeof pattern === 'string' && attrName === pattern) return true;
            if (pattern instanceof RegExp && pattern.test(attrName)) return true;
        }
    };
    return ()=>false;
}


/**
 * fast-xml-tagger - XML/JSON path matching library
 * 
 * Provides efficient path tracking and pattern matching for XML/JSON parsers.
 * 
 * @example
 * import { Expression, Matcher } from 'fast-xml-tagger';
 * 
 * // Create expression (parse once)
 * const expr = new Expression("root.users.user[id]");
 * 
 * // Create matcher (track path)
 * const matcher = new Matcher();
 * matcher.push("root", [], {}, 0);
 * matcher.push("users", [], {}, 0);
 * matcher.push("user", ["id", "type"], { id: "123", type: "admin" }, 0);
 * 
 * // Match
 * if (matcher.matches(expr)) {
 *   console.log("Match found!");
 * }
 */ /**
 * Expression - Parses and stores a tag pattern expression
 * 
 * Patterns are parsed once and stored in an optimized structure for fast matching.
 * 
 * @example
 * const expr = new Expression("root.users.user");
 * const expr2 = new Expression("..user[id]:first");
 * const expr3 = new Expression("root/users/user", { separator: '/' });
 */ class $9bcc5932ad359b39$export$2e2bcd8739ae039 {
    /**
   * Create a new Expression
   * @param {string} pattern - Pattern string (e.g., "root.users.user", "..user[id]")
   * @param {Object} options - Configuration options
   * @param {string} options.separator - Path separator (default: '.')
   */ constructor(pattern, options = {}, data){
        this.pattern = pattern;
        this.separator = options.separator || '.';
        this.segments = this._parse(pattern);
        this.data = data;
        // Cache expensive checks for performance (O(1) instead of O(n))
        this._hasDeepWildcard = this.segments.some((seg)=>seg.type === 'deep-wildcard');
        this._hasAttributeCondition = this.segments.some((seg)=>seg.attrName !== undefined);
        this._hasPositionSelector = this.segments.some((seg)=>seg.position !== undefined);
    }
    /**
   * Parse pattern string into segments
   * @private
   * @param {string} pattern - Pattern to parse
   * @returns {Array} Array of segment objects
   */ _parse(pattern) {
        const segments = [];
        // Split by separator but handle ".." specially
        let i = 0;
        let currentPart = '';
        while(i < pattern.length)if (pattern[i] === this.separator) {
            // Check if next char is also separator (deep wildcard)
            if (i + 1 < pattern.length && pattern[i + 1] === this.separator) {
                // Flush current part if any
                if (currentPart.trim()) {
                    segments.push(this._parseSegment(currentPart.trim()));
                    currentPart = '';
                }
                // Add deep wildcard
                segments.push({
                    type: 'deep-wildcard'
                });
                i += 2; // Skip both separators
            } else {
                // Regular separator
                if (currentPart.trim()) segments.push(this._parseSegment(currentPart.trim()));
                currentPart = '';
                i++;
            }
        } else {
            currentPart += pattern[i];
            i++;
        }
        // Flush remaining part
        if (currentPart.trim()) segments.push(this._parseSegment(currentPart.trim()));
        return segments;
    }
    /**
   * Parse a single segment
   * @private
   * @param {string} part - Segment string (e.g., "user", "ns::user", "user[id]", "ns::user:first")
   * @returns {Object} Segment object
   */ _parseSegment(part) {
        const segment = {
            type: 'tag'
        };
        // NEW NAMESPACE SYNTAX (v2.0):
        // ============================
        // Namespace uses DOUBLE colon (::)
        // Position uses SINGLE colon (:)
        // 
        // Examples:
        //   "user"              → tag
        //   "user:first"        → tag + position
        //   "user[id]"          → tag + attribute
        //   "user[id]:first"    → tag + attribute + position
        //   "ns::user"          → namespace + tag
        //   "ns::user:first"    → namespace + tag + position
        //   "ns::user[id]"      → namespace + tag + attribute
        //   "ns::user[id]:first" → namespace + tag + attribute + position
        //   "ns::first"         → namespace + tag named "first" (NO ambiguity!)
        //
        // This eliminates all ambiguity:
        //   :: = namespace separator
        //   :  = position selector
        //   [] = attributes
        // Step 1: Extract brackets [attr] or [attr=value]
        let bracketContent = null;
        let withoutBrackets = part;
        const bracketMatch = part.match(/^([^\[]+)(\[[^\]]*\])(.*)$/);
        if (bracketMatch) {
            withoutBrackets = bracketMatch[1] + bracketMatch[3];
            if (bracketMatch[2]) {
                const content = bracketMatch[2].slice(1, -1);
                if (content) bracketContent = content;
            }
        }
        // Step 2: Check for namespace (double colon ::)
        let namespace = undefined;
        let tagAndPosition = withoutBrackets;
        if (withoutBrackets.includes('::')) {
            const nsIndex = withoutBrackets.indexOf('::');
            namespace = withoutBrackets.substring(0, nsIndex).trim();
            tagAndPosition = withoutBrackets.substring(nsIndex + 2).trim(); // Skip ::
            if (!namespace) throw new Error(`Invalid namespace in pattern: ${part}`);
        }
        // Step 3: Parse tag and position (single colon :)
        let tag = undefined;
        let positionMatch = null;
        if (tagAndPosition.includes(':')) {
            const colonIndex = tagAndPosition.lastIndexOf(':'); // Use last colon for position
            const tagPart = tagAndPosition.substring(0, colonIndex).trim();
            const posPart = tagAndPosition.substring(colonIndex + 1).trim();
            // Verify position is a valid keyword
            const isPositionKeyword = [
                'first',
                'last',
                'odd',
                'even'
            ].includes(posPart) || /^nth\(\d+\)$/.test(posPart);
            if (isPositionKeyword) {
                tag = tagPart;
                positionMatch = posPart;
            } else // Not a valid position keyword, treat whole thing as tag
            tag = tagAndPosition;
        } else tag = tagAndPosition;
        if (!tag) throw new Error(`Invalid segment pattern: ${part}`);
        segment.tag = tag;
        if (namespace) segment.namespace = namespace;
        // Step 4: Parse attributes
        if (bracketContent) {
            if (bracketContent.includes('=')) {
                const eqIndex = bracketContent.indexOf('=');
                segment.attrName = bracketContent.substring(0, eqIndex).trim();
                segment.attrValue = bracketContent.substring(eqIndex + 1).trim();
            } else segment.attrName = bracketContent.trim();
        }
        // Step 5: Parse position selector
        if (positionMatch) {
            const nthMatch = positionMatch.match(/^nth\((\d+)\)$/);
            if (nthMatch) {
                segment.position = 'nth';
                segment.positionValue = parseInt(nthMatch[1], 10);
            } else segment.position = positionMatch;
        }
        return segment;
    }
    /**
   * Get the number of segments
   * @returns {number}
   */ get length() {
        return this.segments.length;
    }
    /**
   * Check if expression contains deep wildcard
   * @returns {boolean}
   */ hasDeepWildcard() {
        return this._hasDeepWildcard;
    }
    /**
   * Check if expression has attribute conditions
   * @returns {boolean}
   */ hasAttributeCondition() {
        return this._hasAttributeCondition;
    }
    /**
   * Check if expression has position selectors
   * @returns {boolean}
   */ hasPositionSelector() {
        return this._hasPositionSelector;
    }
    /**
   * Get string representation
   * @returns {string}
   */ toString() {
        return this.pattern;
    }
}



class $320711df150d3c5d$export$d05bc1ad70adb86e {
    /**
   * @param {Matcher} matcher - The parent Matcher instance to read from.
   */ constructor(matcher){
        this._matcher = matcher;
    }
    /**
   * Get the path separator used by the parent matcher.
   * @returns {string}
   */ get separator() {
        return this._matcher.separator;
    }
    /**
   * Get current tag name.
   * @returns {string|undefined}
   */ getCurrentTag() {
        const path = this._matcher.path;
        return path.length > 0 ? path[path.length - 1].tag : undefined;
    }
    /**
   * Get current namespace.
   * @returns {string|undefined}
   */ getCurrentNamespace() {
        const path = this._matcher.path;
        return path.length > 0 ? path[path.length - 1].namespace : undefined;
    }
    /**
   * Get current node's attribute value.
   * @param {string} attrName
   * @returns {*}
   */ getAttrValue(attrName) {
        const path = this._matcher.path;
        if (path.length === 0) return undefined;
        return path[path.length - 1].values?.[attrName];
    }
    /**
   * Check if current node has an attribute.
   * @param {string} attrName
   * @returns {boolean}
   */ hasAttr(attrName) {
        const path = this._matcher.path;
        if (path.length === 0) return false;
        const current = path[path.length - 1];
        return current.values !== undefined && attrName in current.values;
    }
    /**
   * Get current node's sibling position (child index in parent).
   * @returns {number}
   */ getPosition() {
        const path = this._matcher.path;
        if (path.length === 0) return -1;
        return path[path.length - 1].position ?? 0;
    }
    /**
   * Get current node's repeat counter (occurrence count of this tag name).
   * @returns {number}
   */ getCounter() {
        const path = this._matcher.path;
        if (path.length === 0) return -1;
        return path[path.length - 1].counter ?? 0;
    }
    /**
   * Get current node's sibling index (alias for getPosition).
   * @returns {number}
   * @deprecated Use getPosition() or getCounter() instead
   */ getIndex() {
        return this.getPosition();
    }
    /**
   * Get current path depth.
   * @returns {number}
   */ getDepth() {
        return this._matcher.path.length;
    }
    /**
   * Get path as string.
   * @param {string} [separator] - Optional separator (uses default if not provided)
   * @param {boolean} [includeNamespace=true]
   * @returns {string}
   */ toString(separator, includeNamespace = true) {
        return this._matcher.toString(separator, includeNamespace);
    }
    /**
   * Get path as array of tag names.
   * @returns {string[]}
   */ toArray() {
        return this._matcher.path.map((n)=>n.tag);
    }
    /**
   * Match current path against an Expression.
   * @param {Expression} expression
   * @returns {boolean}
   */ matches(expression) {
        return this._matcher.matches(expression);
    }
    /**
   * Match any expression in the given set against the current path.
   * @param {ExpressionSet} exprSet
   * @returns {boolean}
   */ matchesAny(exprSet) {
        return exprSet.matchesAny(this._matcher);
    }
}
class $320711df150d3c5d$export$2e2bcd8739ae039 {
    /**
   * Create a new Matcher.
   * @param {Object} [options={}]
   * @param {string} [options.separator='.'] - Default path separator
   */ constructor(options = {}){
        this.separator = options.separator || '.';
        this.path = [];
        this.siblingStacks = [];
        // Each path node: { tag, values, position, counter, namespace? }
        // values only present for current (last) node
        // Each siblingStacks entry: Map<tagName, count> tracking occurrences at each level
        this._pathStringCache = null;
        this._view = new $320711df150d3c5d$export$d05bc1ad70adb86e(this);
    }
    /**
   * Push a new tag onto the path.
   * @param {string} tagName
   * @param {Object|null} [attrValues=null]
   * @param {string|null} [namespace=null]
   */ push(tagName, attrValues = null, namespace = null) {
        this._pathStringCache = null;
        // Remove values from previous current node (now becoming ancestor)
        if (this.path.length > 0) this.path[this.path.length - 1].values = undefined;
        // Get or create sibling tracking for current level
        const currentLevel = this.path.length;
        if (!this.siblingStacks[currentLevel]) this.siblingStacks[currentLevel] = new Map();
        const siblings = this.siblingStacks[currentLevel];
        // Create a unique key for sibling tracking that includes namespace
        const siblingKey = namespace ? `${namespace}:${tagName}` : tagName;
        // Calculate counter (how many times this tag appeared at this level)
        const counter = siblings.get(siblingKey) || 0;
        // Calculate position (total children at this level so far)
        let position = 0;
        for (const count of siblings.values())position += count;
        // Update sibling count for this tag
        siblings.set(siblingKey, counter + 1);
        // Create new node
        const node = {
            tag: tagName,
            position: position,
            counter: counter
        };
        if (namespace !== null && namespace !== undefined) node.namespace = namespace;
        if (attrValues !== null && attrValues !== undefined) node.values = attrValues;
        this.path.push(node);
    }
    /**
   * Pop the last tag from the path.
   * @returns {Object|undefined} The popped node
   */ pop() {
        if (this.path.length === 0) return undefined;
        this._pathStringCache = null;
        const node = this.path.pop();
        if (this.siblingStacks.length > this.path.length + 1) this.siblingStacks.length = this.path.length + 1;
        return node;
    }
    /**
   * Update current node's attribute values.
   * Useful when attributes are parsed after push.
   * @param {Object} attrValues
   */ updateCurrent(attrValues) {
        if (this.path.length > 0) {
            const current = this.path[this.path.length - 1];
            if (attrValues !== null && attrValues !== undefined) current.values = attrValues;
        }
    }
    /**
   * Get current tag name.
   * @returns {string|undefined}
   */ getCurrentTag() {
        return this.path.length > 0 ? this.path[this.path.length - 1].tag : undefined;
    }
    /**
   * Get current namespace.
   * @returns {string|undefined}
   */ getCurrentNamespace() {
        return this.path.length > 0 ? this.path[this.path.length - 1].namespace : undefined;
    }
    /**
   * Get current node's attribute value.
   * @param {string} attrName
   * @returns {*}
   */ getAttrValue(attrName) {
        if (this.path.length === 0) return undefined;
        return this.path[this.path.length - 1].values?.[attrName];
    }
    /**
   * Check if current node has an attribute.
   * @param {string} attrName
   * @returns {boolean}
   */ hasAttr(attrName) {
        if (this.path.length === 0) return false;
        const current = this.path[this.path.length - 1];
        return current.values !== undefined && attrName in current.values;
    }
    /**
   * Get current node's sibling position (child index in parent).
   * @returns {number}
   */ getPosition() {
        if (this.path.length === 0) return -1;
        return this.path[this.path.length - 1].position ?? 0;
    }
    /**
   * Get current node's repeat counter (occurrence count of this tag name).
   * @returns {number}
   */ getCounter() {
        if (this.path.length === 0) return -1;
        return this.path[this.path.length - 1].counter ?? 0;
    }
    /**
   * Get current node's sibling index (alias for getPosition).
   * @returns {number}
   * @deprecated Use getPosition() or getCounter() instead
   */ getIndex() {
        return this.getPosition();
    }
    /**
   * Get current path depth.
   * @returns {number}
   */ getDepth() {
        return this.path.length;
    }
    /**
   * Get path as string.
   * @param {string} [separator] - Optional separator (uses default if not provided)
   * @param {boolean} [includeNamespace=true]
   * @returns {string}
   */ toString(separator, includeNamespace = true) {
        const sep = separator || this.separator;
        const isDefault = sep === this.separator && includeNamespace === true;
        if (isDefault) {
            if (this._pathStringCache !== null) return this._pathStringCache;
            const result = this.path.map((n)=>n.namespace ? `${n.namespace}:${n.tag}` : n.tag).join(sep);
            this._pathStringCache = result;
            return result;
        }
        return this.path.map((n)=>includeNamespace && n.namespace ? `${n.namespace}:${n.tag}` : n.tag).join(sep);
    }
    /**
   * Get path as array of tag names.
   * @returns {string[]}
   */ toArray() {
        return this.path.map((n)=>n.tag);
    }
    /**
   * Reset the path to empty.
   */ reset() {
        this._pathStringCache = null;
        this.path = [];
        this.siblingStacks = [];
    }
    /**
   * Match current path against an Expression.
   * @param {Expression} expression
   * @returns {boolean}
   */ matches(expression) {
        const segments = expression.segments;
        if (segments.length === 0) return false;
        if (expression.hasDeepWildcard()) return this._matchWithDeepWildcard(segments);
        return this._matchSimple(segments);
    }
    /**
   * @private
   */ _matchSimple(segments) {
        if (this.path.length !== segments.length) return false;
        for(let i = 0; i < segments.length; i++){
            if (!this._matchSegment(segments[i], this.path[i], i === this.path.length - 1)) return false;
        }
        return true;
    }
    /**
   * @private
   */ _matchWithDeepWildcard(segments) {
        let pathIdx = this.path.length - 1;
        let segIdx = segments.length - 1;
        while(segIdx >= 0 && pathIdx >= 0){
            const segment = segments[segIdx];
            if (segment.type === 'deep-wildcard') {
                segIdx--;
                if (segIdx < 0) return true;
                const nextSeg = segments[segIdx];
                let found = false;
                for(let i = pathIdx; i >= 0; i--)if (this._matchSegment(nextSeg, this.path[i], i === this.path.length - 1)) {
                    pathIdx = i - 1;
                    segIdx--;
                    found = true;
                    break;
                }
                if (!found) return false;
            } else {
                if (!this._matchSegment(segment, this.path[pathIdx], pathIdx === this.path.length - 1)) return false;
                pathIdx--;
                segIdx--;
            }
        }
        return segIdx < 0;
    }
    /**
   * @private
   */ _matchSegment(segment, node, isCurrentNode) {
        if (segment.tag !== '*' && segment.tag !== node.tag) return false;
        if (segment.namespace !== undefined) {
            if (segment.namespace !== '*' && segment.namespace !== node.namespace) return false;
        }
        if (segment.attrName !== undefined) {
            if (!isCurrentNode) return false;
            if (!node.values || !(segment.attrName in node.values)) return false;
            if (segment.attrValue !== undefined) {
                if (String(node.values[segment.attrName]) !== String(segment.attrValue)) return false;
            }
        }
        if (segment.position !== undefined) {
            if (!isCurrentNode) return false;
            const counter = node.counter ?? 0;
            if (segment.position === 'first' && counter !== 0) return false;
            else if (segment.position === 'odd' && counter % 2 !== 1) return false;
            else if (segment.position === 'even' && counter % 2 !== 0) return false;
            else if (segment.position === 'nth' && counter !== segment.positionValue) return false;
        }
        return true;
    }
    /**
   * Match any expression in the given set against the current path.
   * @param {ExpressionSet} exprSet
   * @returns {boolean}
   */ matchesAny(exprSet) {
        return exprSet.matchesAny(this);
    }
    /**
   * Create a snapshot of current state.
   * @returns {Object}
   */ snapshot() {
        return {
            path: this.path.map((node)=>({
                    ...node
                })),
            siblingStacks: this.siblingStacks.map((map)=>new Map(map))
        };
    }
    /**
   * Restore state from snapshot.
   * @param {Object} snapshot
   */ restore(snapshot) {
        this._pathStringCache = null;
        this.path = snapshot.path.map((node)=>({
                ...node
            }));
        this.siblingStacks = snapshot.siblingStacks.map((map)=>new Map(map));
    }
    /**
   * Return the read-only {@link MatcherView} for this matcher.
   *
   * The same instance is returned on every call — no allocation occurs.
   * It always reflects the current parser state and is safe to pass to
   * user callbacks without risk of accidental mutation.
   *
   * @returns {MatcherView}
   *
   * @example
   * const view = matcher.readOnly();
   * // pass view to callbacks — it stays in sync automatically
   * view.matches(expr);       // ✓
   * view.getCurrentTag();     // ✓
   * // view.push(...)         // ✗ method does not exist — caught by TypeScript
   */ readOnly() {
        return this._view;
    }
}


/**
 * ExpressionSet - An indexed collection of Expressions for efficient bulk matching
 *
 * Instead of iterating all expressions on every tag, ExpressionSet pre-indexes
 * them at insertion time by depth and terminal tag name. At match time, only
 * the relevant bucket is evaluated — typically reducing checks from O(E) to O(1)
 * lookup plus O(small bucket) matches.
 *
 * Three buckets are maintained:
 *  - `_byDepthAndTag`  — exact depth + exact tag name  (tightest, used first)
 *  - `_wildcardByDepth` — exact depth + wildcard tag `*` (depth-matched only)
 *  - `_deepWildcards`  — expressions containing `..`  (cannot be depth-indexed)
 *
 * @example
 * import { Expression, ExpressionSet } from 'fast-xml-tagger';
 *
 * // Build once at config time
 * const stopNodes = new ExpressionSet();
 * stopNodes.add(new Expression('root.users.user'));
 * stopNodes.add(new Expression('root.config.setting'));
 * stopNodes.add(new Expression('..script'));
 *
 * // Query on every tag — hot path
 * if (stopNodes.matchesAny(matcher)) { ... }
 */ class $c7c856523c50dec8$export$2e2bcd8739ae039 {
    constructor(){
        /** @type {Map<string, import('./Expression.js').default[]>} depth:tag → expressions */ this._byDepthAndTag = new Map();
        /** @type {Map<number, import('./Expression.js').default[]>} depth → wildcard-tag expressions */ this._wildcardByDepth = new Map();
        /** @type {import('./Expression.js').default[]} expressions containing deep wildcard (..) */ this._deepWildcards = [];
        /** @type {Set<string>} pattern strings already added — used for deduplication */ this._patterns = new Set();
        /** @type {boolean} whether the set is sealed against further additions */ this._sealed = false;
    }
    /**
   * Add an Expression to the set.
   * Duplicate patterns (same pattern string) are silently ignored.
   *
   * @param {import('./Expression.js').default} expression - A pre-constructed Expression instance
   * @returns {this} for chaining
   * @throws {TypeError} if called after seal()
   *
   * @example
   * set.add(new Expression('root.users.user'));
   * set.add(new Expression('..script'));
   */ add(expression) {
        if (this._sealed) throw new TypeError('ExpressionSet is sealed. Create a new ExpressionSet to add more expressions.');
        // Deduplicate by pattern string
        if (this._patterns.has(expression.pattern)) return this;
        this._patterns.add(expression.pattern);
        if (expression.hasDeepWildcard()) {
            this._deepWildcards.push(expression);
            return this;
        }
        const depth = expression.length;
        const lastSeg = expression.segments[expression.segments.length - 1];
        const tag = lastSeg?.tag;
        if (!tag || tag === '*') {
            // Can index by depth but not by tag
            if (!this._wildcardByDepth.has(depth)) this._wildcardByDepth.set(depth, []);
            this._wildcardByDepth.get(depth).push(expression);
        } else {
            // Tightest bucket: depth + tag
            const key = `${depth}:${tag}`;
            if (!this._byDepthAndTag.has(key)) this._byDepthAndTag.set(key, []);
            this._byDepthAndTag.get(key).push(expression);
        }
        return this;
    }
    /**
   * Add multiple expressions at once.
   *
   * @param {import('./Expression.js').default[]} expressions - Array of Expression instances
   * @returns {this} for chaining
   *
   * @example
   * set.addAll([
   *   new Expression('root.users.user'),
   *   new Expression('root.config.setting'),
   * ]);
   */ addAll(expressions) {
        for (const expr of expressions)this.add(expr);
        return this;
    }
    /**
   * Check whether a pattern string is already present in the set.
   *
   * @param {import('./Expression.js').default} expression
   * @returns {boolean}
   */ has(expression) {
        return this._patterns.has(expression.pattern);
    }
    /**
   * Number of expressions in the set.
   * @type {number}
   */ get size() {
        return this._patterns.size;
    }
    /**
   * Seal the set against further modifications.
   * Useful to prevent accidental mutations after config is built.
   * Calling add() or addAll() on a sealed set throws a TypeError.
   *
   * @returns {this}
   */ seal() {
        this._sealed = true;
        return this;
    }
    /**
   * Whether the set has been sealed.
   * @type {boolean}
   */ get isSealed() {
        return this._sealed;
    }
    /**
   * Test whether the matcher's current path matches any expression in the set.
   *
   * Evaluation order (cheapest → most expensive):
   *  1. Exact depth + tag bucket  — O(1) lookup, typically 0–2 expressions
   *  2. Depth-only wildcard bucket — O(1) lookup, rare
   *  3. Deep-wildcard list         — always checked, but usually small
   *
   * @param {import('./Matcher.js').default} matcher - Matcher instance (or readOnly view)
   * @returns {boolean} true if any expression matches the current path
   *
   * @example
   * if (stopNodes.matchesAny(matcher)) {
   *   // handle stop node
   * }
   */ matchesAny(matcher) {
        return this.findMatch(matcher) !== null;
    }
    /**
 * Find and return the first Expression that matches the matcher's current path.
 *
 * Uses the same evaluation order as matchesAny (cheapest → most expensive):
 *  1. Exact depth + tag bucket
 *  2. Depth-only wildcard bucket
 *  3. Deep-wildcard list
 *
 * @param {import('./Matcher.js').default} matcher - Matcher instance (or readOnly view)
 * @returns {import('./Expression.js').default | null} the first matching Expression, or null
 *
 * @example
 * const expr = stopNodes.findMatch(matcher);
 * if (expr) {
 *   // access expr.config, expr.pattern, etc.
 * }
 */ findMatch(matcher) {
        const depth = matcher.getDepth();
        const tag = matcher.getCurrentTag();
        // 1. Tightest bucket — most expressions live here
        const exactKey = `${depth}:${tag}`;
        const exactBucket = this._byDepthAndTag.get(exactKey);
        if (exactBucket) for(let i = 0; i < exactBucket.length; i++){
            if (matcher.matches(exactBucket[i])) return exactBucket[i];
        }
        // 2. Depth-matched wildcard-tag expressions
        const wildcardBucket = this._wildcardByDepth.get(depth);
        if (wildcardBucket) for(let i = 0; i < wildcardBucket.length; i++){
            if (matcher.matches(wildcardBucket[i])) return wildcardBucket[i];
        }
        // 3. Deep wildcards — cannot be pre-filtered by depth or tag
        for(let i = 0; i < this._deepWildcards.length; i++){
            if (matcher.matches(this._deepWildcards[i])) return this._deepWildcards[i];
        }
        return null;
    }
}


var $6f0d1c969d7c34ff$export$2e2bcd8739ae039 = {
    Expression: $9bcc5932ad359b39$export$2e2bcd8739ae039,
    Matcher: $320711df150d3c5d$export$2e2bcd8739ae039,
    ExpressionSet: $c7c856523c50dec8$export$2e2bcd8739ae039
};


// ---------------------------------------------------------------------------
// Complete HTML5 named entity reference
// Organized by logical categories for easy maintenance and selective importing
// ---------------------------------------------------------------------------
/**
 * Basic Latin & Special Characters
 * @type {Record<string, string>}
 */ const $81cffe5414622c29$export$7c8839302c4c489a = {
    amp: '&',
    AMP: '&',
    lt: '<',
    LT: '<',
    gt: '>',
    GT: '>',
    quot: '"',
    QUOT: '"',
    apos: "'",
    lsquo: "\u2018",
    rsquo: "\u2019",
    ldquo: "\u201C",
    rdquo: "\u201D",
    lsquor: "\u201A",
    rsquor: "\u2019",
    ldquor: "\u201E",
    bdquo: "\u201E",
    comma: ',',
    period: '.',
    colon: ':',
    semi: ';',
    excl: '!',
    quest: '?',
    num: '#',
    dollar: '$',
    percent: '%',
    amp: '&',
    ast: '*',
    commat: '@',
    lowbar: '_',
    verbar: '|',
    vert: '|',
    sol: '/',
    bsol: '\\',
    lbrace: '{',
    rbrace: '}',
    lbrack: '[',
    rbrack: ']',
    lpar: '(',
    rpar: ')',
    nbsp: '\u00a0',
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    COPY: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: '\u00ad',
    reg: "\xae",
    REG: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    half: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    times: "\xd7",
    div: "\xf7",
    divide: "\xf7"
};
const $81cffe5414622c29$export$ecdeff5dafddf4da = {
    Agrave: "\xc0",
    agrave: "\xe0",
    Aacute: "\xc1",
    aacute: "\xe1",
    Acirc: "\xc2",
    acirc: "\xe2",
    Atilde: "\xc3",
    atilde: "\xe3",
    Auml: "\xc4",
    auml: "\xe4",
    Aring: "\xc5",
    aring: "\xe5",
    AElig: "\xc6",
    aelig: "\xe6",
    Ccedil: "\xc7",
    ccedil: "\xe7",
    Egrave: "\xc8",
    egrave: "\xe8",
    Eacute: "\xc9",
    eacute: "\xe9",
    Ecirc: "\xca",
    ecirc: "\xea",
    Euml: "\xcb",
    euml: "\xeb",
    Igrave: "\xcc",
    igrave: "\xec",
    Iacute: "\xcd",
    iacute: "\xed",
    Icirc: "\xce",
    icirc: "\xee",
    Iuml: "\xcf",
    iuml: "\xef",
    ETH: "\xd0",
    eth: "\xf0",
    Ntilde: "\xd1",
    ntilde: "\xf1",
    Ograve: "\xd2",
    ograve: "\xf2",
    Oacute: "\xd3",
    oacute: "\xf3",
    Ocirc: "\xd4",
    ocirc: "\xf4",
    Otilde: "\xd5",
    otilde: "\xf5",
    Ouml: "\xd6",
    ouml: "\xf6",
    Oslash: "\xd8",
    oslash: "\xf8",
    Ugrave: "\xd9",
    ugrave: "\xf9",
    Uacute: "\xda",
    uacute: "\xfa",
    Ucirc: "\xdb",
    ucirc: "\xfb",
    Uuml: "\xdc",
    uuml: "\xfc",
    Yacute: "\xdd",
    yacute: "\xfd",
    THORN: "\xde",
    thorn: "\xfe",
    szlig: "\xdf",
    yuml: "\xff",
    Yuml: "\u0178"
};
const $81cffe5414622c29$export$1e7d5b1b82189261 = {
    Amacr: "\u0100",
    amacr: "\u0101",
    Abreve: "\u0102",
    abreve: "\u0103",
    Aogon: "\u0104",
    aogon: "\u0105",
    Cacute: "\u0106",
    cacute: "\u0107",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cdot: "\u010A",
    cdot: "\u010B",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    Emacr: "\u0112",
    emacr: "\u0113",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    Edot: "\u0116",
    edot: "\u0117",
    Eogon: "\u0118",
    eogon: "\u0119",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gdot: "\u0120",
    gdot: "\u0121",
    Gcedil: "\u0122",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    Itilde: "\u0128",
    itilde: "\u0129",
    Imacr: "\u012A",
    imacr: "\u012B",
    Iogon: "\u012E",
    iogon: "\u012F",
    Idot: "\u0130",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    kgreen: "\u0138",
    Lacute: "\u0139",
    lacute: "\u013A",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Nacute: "\u0143",
    nacute: "\u0144",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ENG: "\u014A",
    eng: "\u014B",
    Omacr: "\u014C",
    omacr: "\u014D",
    Odblac: "\u0150",
    odblac: "\u0151",
    OElig: "\u0152",
    oelig: "\u0153",
    Racute: "\u0154",
    racute: "\u0155",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    Sacute: "\u015A",
    sacute: "\u015B",
    Scirc: "\u015C",
    scirc: "\u015D",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scaron: "\u0160",
    scaron: "\u0161",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    Utilde: "\u0168",
    utilde: "\u0169",
    Umacr: "\u016A",
    umacr: "\u016B",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Uring: "\u016E",
    uring: "\u016F",
    Udblac: "\u0170",
    udblac: "\u0171",
    Uogon: "\u0172",
    uogon: "\u0173",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zdot: "\u017B",
    zdot: "\u017C",
    Zcaron: "\u017D",
    zcaron: "\u017E"
};
const $81cffe5414622c29$export$c863fdf1b2a741e1 = {
    Alpha: "\u0391",
    alpha: "\u03B1",
    Beta: "\u0392",
    beta: "\u03B2",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Delta: "\u0394",
    delta: "\u03B4",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    varepsilon: "\u03F5",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Eta: "\u0397",
    eta: "\u03B7",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    vartheta: "\u03D1",
    Iota: "\u0399",
    iota: "\u03B9",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    varkappa: "\u03F0",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Mu: "\u039C",
    mu: "\u03BC",
    Nu: "\u039D",
    nu: "\u03BD",
    Xi: "\u039E",
    xi: "\u03BE",
    Omicron: "\u039F",
    omicron: "\u03BF",
    Pi: "\u03A0",
    pi: "\u03C0",
    piv: "\u03D6",
    varpi: "\u03D6",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    varrho: "\u03F1",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    varsigma: "\u03C2",
    Tau: "\u03A4",
    tau: "\u03C4",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    upsi: "\u03C5",
    Upsi: "\u03D2",
    upsih: "\u03D2",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    varphi: "\u03D5",
    Chi: "\u03A7",
    chi: "\u03C7",
    Psi: "\u03A8",
    psi: "\u03C8",
    Omega: "\u03A9",
    omega: "\u03C9",
    ohm: "\u03A9",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    digamma: "\u03DD"
};
const $81cffe5414622c29$export$cb301ddec60497fb = {
    Afr: "\uD835\uDD04",
    afr: "\uD835\uDD1E",
    Acy: "\u0410",
    acy: "\u0430",
    Bcy: "\u0411",
    bcy: "\u0431",
    Vcy: "\u0412",
    vcy: "\u0432",
    Gcy: "\u0413",
    gcy: "\u0433",
    Dcy: "\u0414",
    dcy: "\u0434",
    IEcy: "\u0415",
    iecy: "\u0435",
    IOcy: "\u0401",
    iocy: "\u0451",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    Zcy: "\u0417",
    zcy: "\u0437",
    Icy: "\u0418",
    icy: "\u0438",
    Jcy: "\u0419",
    jcy: "\u0439",
    Kcy: "\u041A",
    kcy: "\u043A",
    Lcy: "\u041B",
    lcy: "\u043B",
    Mcy: "\u041C",
    mcy: "\u043C",
    Ncy: "\u041D",
    ncy: "\u043D",
    Ocy: "\u041E",
    ocy: "\u043E",
    Pcy: "\u041F",
    pcy: "\u043F",
    Rcy: "\u0420",
    rcy: "\u0440",
    Scy: "\u0421",
    scy: "\u0441",
    Tcy: "\u0422",
    tcy: "\u0442",
    Ucy: "\u0423",
    ucy: "\u0443",
    Fcy: "\u0424",
    fcy: "\u0444",
    KHcy: "\u0425",
    khcy: "\u0445",
    TScy: "\u0426",
    tscy: "\u0446",
    CHcy: "\u0427",
    chcy: "\u0447",
    SHcy: "\u0428",
    shcy: "\u0448",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    Ycy: "\u042B",
    ycy: "\u044B",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    Ecy: "\u042D",
    ecy: "\u044D",
    YUcy: "\u042E",
    yucy: "\u044E",
    YAcy: "\u042F",
    yacy: "\u044F",
    DJcy: "\u0402",
    djcy: "\u0452",
    GJcy: "\u0403",
    gjcy: "\u0453",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    DScy: "\u0405",
    dscy: "\u0455",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    YIcy: "\u0407",
    yicy: "\u0457",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    LJcy: "\u0409",
    ljcy: "\u0459",
    NJcy: "\u040A",
    njcy: "\u045A",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    DZcy: "\u040F",
    dzcy: "\u045F"
};
const $81cffe5414622c29$export$da5c1e34018ecc43 = {
    plus: '+',
    minus: "\u2212",
    mnplus: "\u2213",
    mp: "\u2213",
    pm: "\xb1",
    times: "\xd7",
    div: "\xf7",
    divide: "\xf7",
    sdot: "\u22C5",
    star: "\u2606",
    starf: "\u2605",
    bigstar: "\u2605",
    lowast: "\u2217",
    ast: '*',
    midast: '*',
    compfn: "\u2218",
    smallcircle: "\u2218",
    bullet: "\u2022",
    bull: "\u2022",
    nbsp: '\u00a0',
    hellip: "\u2026",
    mldr: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    tprime: "\u2034",
    bprime: "\u2035",
    backprime: "\u2035",
    minus: "\u2212",
    minusd: "\u2238",
    dotminus: "\u2238",
    plusdo: "\u2214",
    dotplus: "\u2214",
    plusmn: "\xb1",
    minusplus: "\u2213",
    mnplus: "\u2213",
    mp: "\u2213",
    setminus: "\u2216",
    smallsetminus: "\u2216",
    Backslash: "\u2216",
    setmn: "\u2216",
    ssetmn: "\u2216",
    lowbar: '_',
    verbar: '|',
    vert: '|',
    VerticalLine: '|',
    colon: ':',
    Colon: "\u2237",
    Proportion: "\u2237",
    ratio: "\u2236",
    equals: '=',
    ne: "\u2260",
    nequiv: "\u2262",
    equiv: "\u2261",
    Congruent: "\u2261",
    sim: "\u223C",
    thicksim: "\u223C",
    thksim: "\u223C",
    sime: "\u2243",
    simeq: "\u2243",
    TildeEqual: "\u2243",
    asymp: "\u2248",
    approx: "\u2248",
    thickapprox: "\u2248",
    thkap: "\u2248",
    TildeTilde: "\u2248",
    ncong: "\u2247",
    cong: "\u2245",
    TildeFullEqual: "\u2245",
    asympeq: "\u224D",
    CupCap: "\u224D",
    bump: "\u224E",
    Bumpeq: "\u224E",
    HumpDownHump: "\u224E",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    HumpEqual: "\u224F",
    dotminus: "\u2238",
    minusd: "\u2238",
    plusdo: "\u2214",
    dotplus: "\u2214",
    le: "\u2264",
    LessEqual: "\u2264",
    ge: "\u2265",
    GreaterEqual: "\u2265",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    greater: '>',
    less: '<'
};
const $81cffe5414622c29$export$9b8bfe77cc233ab4 = {
    alefsym: "\u2135",
    aleph: "\u2135",
    beth: "\u2136",
    gimel: "\u2137",
    daleth: "\u2138",
    forall: "\u2200",
    ForAll: "\u2200",
    part: "\u2202",
    PartialD: "\u2202",
    exist: "\u2203",
    Exists: "\u2203",
    nexist: "\u2204",
    nexists: "\u2204",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    varnothing: "\u2205",
    nabla: "\u2207",
    Del: "\u2207",
    isin: "\u2208",
    isinv: "\u2208",
    in: "\u2208",
    Element: "\u2208",
    notin: "\u2209",
    notinva: "\u2209",
    ni: "\u220B",
    niv: "\u220B",
    SuchThat: "\u220B",
    ReverseElement: "\u220B",
    notni: "\u220C",
    notniva: "\u220C",
    prod: "\u220F",
    Product: "\u220F",
    coprod: "\u2210",
    Coproduct: "\u2210",
    sum: "\u2211",
    Sum: "\u2211",
    minus: "\u2212",
    mp: "\u2213",
    plusdo: "\u2214",
    dotplus: "\u2214",
    setminus: "\u2216",
    lowast: "\u2217",
    radic: "\u221A",
    Sqrt: "\u221A",
    prop: "\u221D",
    propto: "\u221D",
    Proportional: "\u221D",
    varpropto: "\u221D",
    infin: "\u221E",
    infintie: "\u29DD",
    ang: "\u2220",
    angle: "\u2220",
    angmsd: "\u2221",
    measuredangle: "\u2221",
    angsph: "\u2222",
    mid: "\u2223",
    VerticalBar: "\u2223",
    nmid: "\u2224",
    nsmid: "\u2224",
    npar: "\u2226",
    parallel: "\u2225",
    spar: "\u2225",
    nparallel: "\u2226",
    nspar: "\u2226",
    and: "\u2227",
    wedge: "\u2227",
    or: "\u2228",
    vee: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    Integral: "\u222B",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Conint: "\u222F",
    DoubleContourIntegral: "\u222F",
    Cconint: "\u2230",
    there4: "\u2234",
    therefore: "\u2234",
    Therefore: "\u2234",
    becaus: "\u2235",
    because: "\u2235",
    Because: "\u2235",
    ratio: "\u2236",
    Proportion: "\u2237",
    minusd: "\u2238",
    dotminus: "\u2238",
    mDDot: "\u223A",
    homtht: "\u223B",
    sim: "\u223C",
    bsimg: "\u223D",
    backsim: "\u223D",
    ac: "\u223E",
    mstpos: "\u223E",
    acd: "\u223F",
    VerticalTilde: "\u2240",
    wr: "\u2240",
    wreath: "\u2240",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsimeq: "\u2244",
    ncong: "\u2247",
    simne: "\u2246",
    ncongdot: "\u2A6D\u0338",
    ngsim: "\u2275",
    nsim: "\u2241",
    napprox: "\u2249",
    nap: "\u2249",
    ngeq: "\u2271",
    nge: "\u2271",
    nleq: "\u2270",
    nle: "\u2270",
    ngtr: "\u226F",
    ngt: "\u226F",
    nless: "\u226E",
    nlt: "\u226E",
    nprec: "\u2280",
    npr: "\u2280",
    nsucc: "\u2281",
    nsc: "\u2281"
};
const $81cffe5414622c29$export$675be1772fb8d439 = {
    larr: "\u2190",
    leftarrow: "\u2190",
    LeftArrow: "\u2190",
    uarr: "\u2191",
    uparrow: "\u2191",
    UpArrow: "\u2191",
    rarr: "\u2192",
    rightarrow: "\u2192",
    RightArrow: "\u2192",
    darr: "\u2193",
    downarrow: "\u2193",
    DownArrow: "\u2193",
    harr: "\u2194",
    leftrightarrow: "\u2194",
    LeftRightArrow: "\u2194",
    varr: "\u2195",
    updownarrow: "\u2195",
    UpDownArrow: "\u2195",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    UpperLeftArrow: "\u2196",
    nearr: "\u2197",
    nearrow: "\u2197",
    UpperRightArrow: "\u2197",
    searr: "\u2198",
    searrow: "\u2198",
    LowerRightArrow: "\u2198",
    swarr: "\u2199",
    swarrow: "\u2199",
    LowerLeftArrow: "\u2199",
    lArr: "\u21D0",
    Leftarrow: "\u21D0",
    uArr: "\u21D1",
    Uparrow: "\u21D1",
    rArr: "\u21D2",
    Rightarrow: "\u21D2",
    dArr: "\u21D3",
    Downarrow: "\u21D3",
    hArr: "\u21D4",
    Leftrightarrow: "\u21D4",
    iff: "\u21D4",
    vArr: "\u21D5",
    Updownarrow: "\u21D5",
    lAarr: "\u21DA",
    Lleftarrow: "\u21DA",
    rAarr: "\u21DB",
    Rrightarrow: "\u21DB",
    lrarr: "\u21C6",
    leftrightarrows: "\u21C6",
    rlarr: "\u21C4",
    rightleftarrows: "\u21C4",
    lrhar: "\u21CB",
    leftrightharpoons: "\u21CB",
    ReverseEquilibrium: "\u21CB",
    rlhar: "\u21CC",
    rightleftharpoons: "\u21CC",
    Equilibrium: "\u21CC",
    udarr: "\u21C5",
    UpArrowDownArrow: "\u21C5",
    duarr: "\u21F5",
    DownArrowUpArrow: "\u21F5",
    llarr: "\u21C7",
    leftleftarrows: "\u21C7",
    rrarr: "\u21C9",
    rightrightarrows: "\u21C9",
    ddarr: "\u21CA",
    downdownarrows: "\u21CA",
    har: "\u21BD",
    lhard: "\u21BD",
    leftharpoondown: "\u21BD",
    lharu: "\u21BC",
    leftharpoonup: "\u21BC",
    rhard: "\u21C1",
    rightharpoondown: "\u21C1",
    rharu: "\u21C0",
    rightharpoonup: "\u21C0",
    lsh: "\u21B0",
    Lsh: "\u21B0",
    rsh: "\u21B1",
    Rsh: "\u21B1",
    ldsh: "\u21B2",
    rdsh: "\u21B3",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    crarr: "\u21B5",
    nwarrow: "\u2196",
    nearrow: "\u2197",
    searrow: "\u2198",
    swarrow: "\u2199",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nrightarrow: "\u219B",
    nrarr: "\u219B",
    larrtl: "\u21A2",
    rarrtl: "\u21A3",
    leftarrowtail: "\u21A2",
    rightarrowtail: "\u21A3",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Larr: "\u219E",
    Rarr: "\u21A0",
    larrhk: "\u21A9",
    rarrhk: "\u21AA",
    larrlp: "\u21AB",
    looparrowleft: "\u21AB",
    rarrlp: "\u21AC",
    looparrowright: "\u21AC",
    harrw: "\u21AD",
    leftrightsquigarrow: "\u21AD",
    nrarrw: "\u219D\u0338",
    rarrw: "\u219D",
    rightsquigarrow: "\u219D",
    larrbfs: "\u291F",
    rarrbfs: "\u2920",
    nvHarr: "\u2904",
    nvlArr: "\u2902",
    nvrArr: "\u2903",
    larrfs: "\u291D",
    rarrfs: "\u291E",
    Map: "\u2905",
    larrsim: "\u2973",
    rarrsim: "\u2974",
    harrcir: "\u2948",
    Uarrocir: "\u2949",
    lurdshar: "\u294A",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    rdldhar: "\u2969",
    lrhard: "\u296D",
    rlhar: "\u21CC",
    uharr: "\u21BE",
    uharl: "\u21BF",
    dharr: "\u21C2",
    dharl: "\u21C3",
    Uarr: "\u219F",
    Darr: "\u21A1",
    zigrarr: "\u21DD",
    nwArr: "\u21D6",
    neArr: "\u21D7",
    seArr: "\u21D8",
    swArr: "\u21D9",
    nharr: "\u21AE",
    nhArr: "\u21CE",
    nlarr: "\u219A",
    nlArr: "\u21CD",
    nrarr: "\u219B",
    nrArr: "\u21CF",
    larrb: "\u21E4",
    LeftArrowBar: "\u21E4",
    rarrb: "\u21E5",
    RightArrowBar: "\u21E5"
};
const $81cffe5414622c29$export$511e1d54a4a8684e = {
    square: "\u25A1",
    Square: "\u25A1",
    squ: "\u25A1",
    squf: "\u25AA",
    squarf: "\u25AA",
    blacksquar: "\u25AA",
    blacksquare: "\u25AA",
    FilledVerySmallSquare: "\u25AA",
    blk34: "\u2593",
    blk12: "\u2592",
    blk14: "\u2591",
    block: "\u2588",
    srect: "\u25AD",
    rect: "\u25AD",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    dotsquare: "\u22A1",
    triangle: "\u25B5",
    tri: "\u25B5",
    trine: "\u25B5",
    utri: "\u25B5",
    triangledown: "\u25BF",
    dtri: "\u25BF",
    tridown: "\u25BF",
    triangleleft: "\u25C3",
    ltri: "\u25C3",
    triangleright: "\u25B9",
    rtri: "\u25B9",
    blacktriangle: "\u25B4",
    utrif: "\u25B4",
    blacktriangledown: "\u25BE",
    dtrif: "\u25BE",
    blacktriangleleft: "\u25C2",
    ltrif: "\u25C2",
    blacktriangleright: "\u25B8",
    rtrif: "\u25B8",
    loz: "\u25CA",
    lozenge: "\u25CA",
    blacklozenge: "\u29EB",
    lozf: "\u29EB",
    bigcirc: "\u25EF",
    xcirc: "\u25EF",
    circ: "\u02C6",
    Circle: "\u25CB",
    cir: "\u25CB",
    o: "\u25CB",
    bullet: "\u2022",
    bull: "\u2022",
    hellip: "\u2026",
    mldr: "\u2026",
    nldr: "\u2025",
    boxh: "\u2500",
    HorizontalLine: "\u2500",
    boxv: "\u2502",
    boxdr: "\u250C",
    boxdl: "\u2510",
    boxur: "\u2514",
    boxul: "\u2518",
    boxvr: "\u251C",
    boxvl: "\u2524",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxvh: "\u253C",
    boxH: "\u2550",
    boxV: "\u2551",
    boxdR: "\u2552",
    boxDr: "\u2553",
    boxDR: "\u2554",
    boxDl: "\u2555",
    boxdL: "\u2556",
    boxDL: "\u2557",
    boxuR: "\u2558",
    boxUr: "\u2559",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxUL: "\u255D",
    boxvR: "\u255E",
    boxVr: "\u255F",
    boxVR: "\u2560",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxVL: "\u2563",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxHD: "\u2566",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxHU: "\u2569",
    boxvH: "\u256A",
    boxVh: "\u256B",
    boxVH: "\u256C"
};
const $81cffe5414622c29$export$d1b7b2e62fe6473b = {
    excl: '!',
    iexcl: "\xa1",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: '\u00ad',
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    nbsp: '\u00a0',
    comma: ',',
    period: '.',
    colon: ':',
    semi: ';',
    vert: '|',
    Verbar: "\u2016",
    verbar: '|',
    dblac: "\u02DD",
    circ: "\u02C6",
    caron: "\u02C7",
    breve: "\u02D8",
    dot: "\u02D9",
    ring: "\u02DA",
    ogon: "\u02DB",
    tilde: "\u02DC",
    DiacriticalGrave: '`',
    DiacriticalAcute: "\xb4",
    DiacriticalTilde: "\u02DC",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    grave: '`',
    acute: "\xb4"
};
const $81cffe5414622c29$export$ebe860a2db7990ad = {
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    euro: "\u20AC",
    dollar: '$',
    euro: "\u20AC",
    fnof: "\u0192",
    inr: "\u20B9",
    af: "\u060B",
    birr: "\u1265\u122D",
    peso: "\u20B1",
    rub: "\u20BD",
    won: "\u20A9",
    yuan: "\xa5",
    cedil: "\xb8"
};
const $81cffe5414622c29$export$a123669f53de103e = {
    frac12: "\xbd",
    half: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044"
};
const $81cffe5414622c29$export$63e43b7dd865cf5c = {
    trade: "\u2122",
    TRADE: "\u2122",
    telrec: "\u2315",
    target: "\u2316",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    urcorn: "\u231D",
    urcorner: "\u231D",
    dlcorn: "\u231E",
    llcorner: "\u231E",
    drcorn: "\u231F",
    lrcorner: "\u231F",
    intercal: "\u22BA",
    intcal: "\u22BA",
    oplus: "\u2295",
    CirclePlus: "\u2295",
    ominus: "\u2296",
    CircleMinus: "\u2296",
    otimes: "\u2297",
    CircleTimes: "\u2297",
    osol: "\u2298",
    odot: "\u2299",
    CircleDot: "\u2299",
    oast: "\u229B",
    circledast: "\u229B",
    odash: "\u229D",
    circleddash: "\u229D",
    ocirc: "\u229A",
    circledcirc: "\u229A",
    boxplus: "\u229E",
    plusb: "\u229E",
    boxminus: "\u229F",
    minusb: "\u229F",
    boxtimes: "\u22A0",
    timesb: "\u22A0",
    boxdot: "\u22A1",
    sdotb: "\u22A1",
    veebar: "\u22BB",
    vee: "\u2228",
    barvee: "\u22BD",
    and: "\u2227",
    wedge: "\u2227",
    Cap: "\u22D2",
    Cup: "\u22D3",
    Fork: "\u22D4",
    pitchfork: "\u22D4",
    epar: "\u22D5",
    ltlarr: "\u2976",
    nvap: "\u224D\u20D2",
    nvsim: "\u223C\u20D2",
    nvge: "\u2265\u20D2",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvgt: ">\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrtrie: "\u22B5\u20D2",
    Vdash: "\u22A9",
    dashv: "\u22A3",
    vDash: "\u22A8",
    Vdash: "\u22A9",
    Vvdash: "\u22AA",
    nvdash: "\u22AC",
    nvDash: "\u22AD",
    nVdash: "\u22AE",
    nVDash: "\u22AF"
};
const $81cffe5414622c29$export$c1e6e52592632948 = {
    ...$81cffe5414622c29$export$7c8839302c4c489a,
    ...$81cffe5414622c29$export$ecdeff5dafddf4da,
    ...$81cffe5414622c29$export$1e7d5b1b82189261,
    ...$81cffe5414622c29$export$c863fdf1b2a741e1,
    ...$81cffe5414622c29$export$cb301ddec60497fb,
    ...$81cffe5414622c29$export$da5c1e34018ecc43,
    ...$81cffe5414622c29$export$9b8bfe77cc233ab4,
    ...$81cffe5414622c29$export$675be1772fb8d439,
    ...$81cffe5414622c29$export$511e1d54a4a8684e,
    ...$81cffe5414622c29$export$d1b7b2e62fe6473b,
    ...$81cffe5414622c29$export$ebe860a2db7990ad,
    ...$81cffe5414622c29$export$a123669f53de103e,
    ...$81cffe5414622c29$export$63e43b7dd865cf5c
};
const $81cffe5414622c29$export$48469d80b7dadb83 = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: "\""
};
const $81cffe5414622c29$export$3c95c40e0611087b = {
    nbsp: '\u00a0',
    copy: '\u00a9',
    reg: '\u00ae',
    trade: '\u2122',
    mdash: '\u2014',
    ndash: '\u2013',
    hellip: '\u2026',
    laquo: '\u00ab',
    raquo: '\u00bb',
    lsquo: '\u2018',
    rsquo: '\u2019',
    ldquo: '\u201c',
    rdquo: '\u201d',
    bull: '\u2022',
    para: '\u00b6',
    sect: '\u00a7',
    deg: '\u00b0',
    frac12: '\u00bd',
    frac14: '\u00bc',
    frac34: '\u00be'
} // ---------------------------------------------------------------------------
 // Note: NUMERIC_ENTITIES (&#NNN; / &#xHH;) are handled by the scanner directly
 // via String.fromCodePoint() without any map lookup.
 // ---------------------------------------------------------------------------
;

// ---------------------------------------------------------------------------
// Built-in named entity map  (name → replacement string)
// No regex, no {regex,val} objects — just flat key/value pairs.
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const $9233d3b748d815fb$var$SPECIAL_CHARS = new Set('!?\\\\/[]$%{}^&*()<>|+');
/**
 * Validate that an entity name contains no dangerous characters.
 * @param {string} name
 * @returns {string} the name, unchanged
 * @throws {Error} on invalid characters
 */ function $9233d3b748d815fb$var$validateEntityName(name) {
    if (name[0] === '#') throw new Error(`[EntityReplacer] Invalid character '#' in entity name: "${name}"`);
    for (const ch of name){
        if ($9233d3b748d815fb$var$SPECIAL_CHARS.has(ch)) throw new Error(`[EntityReplacer] Invalid character '${ch}' in entity name: "${name}"`);
    }
    return name;
}
/**
 * Merge one or more entity maps into a flat name→string map.
 * Accepts either:
 *   - plain string values:             { amp: '&' }
 *   - legacy {regex,val} / {regx,val}: { lt: { regex: /.../, val: '<' } }
 *
 * Values containing '&' are skipped (recursive expansion risk).
 *
 * @param {...object} maps
 * @returns {Record<string, string>}
 */ function $9233d3b748d815fb$var$mergeEntityMaps(...maps) {
    const out = Object.create(null);
    for (const map of maps){
        if (!map) continue;
        for (const key of Object.keys(map)){
            const raw = map[key];
            if (typeof raw === 'string') out[key] = raw;
            else if (raw && typeof raw === 'object' && raw.val !== undefined) {
                // Legacy {regex,val} or {regx,val} — extract the string val only
                const val = raw.val;
                if (typeof val === 'string') out[key] = val;
            // function vals are not supported in the scanner — skip
            }
        }
    }
    return out;
}
// ---------------------------------------------------------------------------
// applyLimitsTo helpers
// ---------------------------------------------------------------------------
const $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL = 'external'; // input/runtime + persistent external maps
const $9233d3b748d815fb$var$LIMIT_TIER_BASE = 'base'; // DEFAULT_XML_ENTITIES + namedEntities (system) maps
const $9233d3b748d815fb$var$LIMIT_TIER_ALL = 'all'; // every entity regardless of tier
/**
 * Resolve `applyLimitsTo` option into a normalised Set of tier strings.
 * Accepted values: 'external' | 'base' | 'all' | string[]
 * Default: 'external' (only untrusted injected entities are counted).
 * @param {string|string[]|undefined} raw
 * @returns {Set<string>}
 */ function $9233d3b748d815fb$var$parseLimitTiers(raw) {
    if (!raw || raw === $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL) return new Set([
        $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL
    ]);
    if (raw === $9233d3b748d815fb$var$LIMIT_TIER_ALL) return new Set([
        $9233d3b748d815fb$var$LIMIT_TIER_ALL
    ]);
    if (raw === $9233d3b748d815fb$var$LIMIT_TIER_BASE) return new Set([
        $9233d3b748d815fb$var$LIMIT_TIER_BASE
    ]);
    if (Array.isArray(raw)) return new Set(raw);
    return new Set([
        $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL
    ]); // safe default for unrecognised values
}
// ---------------------------------------------------------------------------
// NCR (Numeric Character Reference) classification
// ---------------------------------------------------------------------------
// Severity order — higher number = stricter action.
// Used to enforce minimum action levels for specific codepoint ranges.
const $9233d3b748d815fb$var$NCR_LEVEL = Object.freeze({
    allow: 0,
    leave: 1,
    remove: 2,
    throw: 3
});
// XML 1.0 §2.2: allowed chars are #x9 | #xA | #xD | [#x20-#xD7FF] | [#xE000-#xFFFD] | [#x10000-#x10FFFF]
// Restricted C0: U+0001–U+001F excluding U+0009, U+000A, U+000D
const $9233d3b748d815fb$var$XML10_ALLOWED_C0 = new Set([
    0x09,
    0x0A,
    0x0D
]);
/**
 * Parse the `ncr` constructor option into flat, hot-path-friendly fields.
 * @param {object|undefined} ncr
 * @returns {{ xmlVersion: number, onLevel: number, nullLevel: number }}
 */ function $9233d3b748d815fb$var$parseNCRConfig(ncr) {
    if (!ncr) return {
        xmlVersion: 1.0,
        onLevel: $9233d3b748d815fb$var$NCR_LEVEL.allow,
        nullLevel: $9233d3b748d815fb$var$NCR_LEVEL.remove
    };
    const xmlVersion = ncr.xmlVersion === 1.1 ? 1.1 : 1.0;
    const onLevel = $9233d3b748d815fb$var$NCR_LEVEL[ncr.onNCR] ?? $9233d3b748d815fb$var$NCR_LEVEL.allow;
    const nullLevel = $9233d3b748d815fb$var$NCR_LEVEL[ncr.nullNCR] ?? $9233d3b748d815fb$var$NCR_LEVEL.remove;
    // 'allow' is not meaningful for null — clamp to at least 'remove'
    const clampedNull = Math.max(nullLevel, $9233d3b748d815fb$var$NCR_LEVEL.remove);
    return {
        xmlVersion: xmlVersion,
        onLevel: onLevel,
        nullLevel: clampedNull
    };
}
class $9233d3b748d815fb$export$2e2bcd8739ae039 {
    /**
   * @param {object} [options]
   * @param {object|null}  [options.namedEntities]        — extra named entities merged into base map
   * @param {object}  [options.limit]                 — security limits
   * @param {number}       [options.limit.maxTotalExpansions=0]  — 0 = unlimited
   * @param {number}       [options.limit.maxExpandedLength=0]   — 0 = unlimited
   * @param {'external'|'base'|'all'|string[]} [options.limit.applyLimitsTo='external']
   *   Which entity tiers count against the security limits:
   *   - 'external' (default) — only input/runtime + persistent external entities
   *   - 'base'               — only DEFAULT_XML_ENTITIES + namedEntities
   *   - 'all'                — every entity regardless of tier
   *   - string[]             — explicit combination, e.g. ['external', 'base']
   * @param {((resolved: string, original: string) => string)|null} [options.postCheck=null]
   * @param {string[]} [options.remove=[]] — entity names (e.g. ['nbsp', '#13']) to delete (replace with empty string)
   * @param {string[]} [options.leave=[]]  — entity names to keep as literal (unchanged in output)
   * @param {object}   [options.ncr]       — Numeric Character Reference controls
   * @param {1.0|1.1}  [options.ncr.xmlVersion=1.0]
   *   XML version governing which codepoint ranges are restricted:
   *   - 1.0 — C0 controls U+0001–U+001F (except U+0009/000A/000D) are prohibited
   *   - 1.1 — C0 controls are allowed when written as NCRs; C1 (U+007F–U+009F) decoded as-is
   * @param {'allow'|'leave'|'remove'|'throw'} [options.ncr.onNCR='allow']
   *   Base action for numeric references. Severity order: allow < leave < remove < throw.
   *   For codepoint ranges that carry a minimum level (surrogates → remove, XML 1.0 C0 → remove),
   *   the effective action is max(onNCR, rangeMinimum).
   * @param {'remove'|'throw'} [options.ncr.nullNCR='remove']
   *   Action for U+0000 (null). 'allow' and 'leave' are clamped to 'remove' since null is never safe.
   */ constructor(options = {}){
        this._limit = options.limit || {};
        this._maxTotalExpansions = this._limit.maxTotalExpansions || 0;
        this._maxExpandedLength = this._limit.maxExpandedLength || 0;
        this._postCheck = typeof options.postCheck === 'function' ? options.postCheck : (r)=>r;
        this._limitTiers = $9233d3b748d815fb$var$parseLimitTiers(this._limit.applyLimitsTo ?? $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL);
        this._numericAllowed = options.numericAllowed ?? true;
        // Base map: DEFAULT_XML_ENTITIES + user-supplied extras. Immutable after construction.
        this._baseMap = $9233d3b748d815fb$var$mergeEntityMaps((0, $81cffe5414622c29$export$48469d80b7dadb83), options.namedEntities || null);
        // Persistent external entities — survive across documents.
        // Stored as a separate map so reset() never touches them.
        /** @type {Record<string, string>} */ this._externalMap = Object.create(null);
        // Input / runtime entities — current document only, wiped on reset().
        /** @type {Record<string, string>} */ this._inputMap = Object.create(null);
        // Per-document counters
        this._totalExpansions = 0;
        this._expandedLength = 0;
        // --- New: remove / leave sets ---
        /** @type {Set<string>} */ this._removeSet = new Set(options.remove && Array.isArray(options.remove) ? options.remove : []);
        /** @type {Set<string>} */ this._leaveSet = new Set(options.leave && Array.isArray(options.leave) ? options.leave : []);
        // --- NCR config (parsed into flat fields for hot-path speed) ---
        const ncrCfg = $9233d3b748d815fb$var$parseNCRConfig(options.ncr);
        this._ncrXmlVersion = ncrCfg.xmlVersion;
        this._ncrOnLevel = ncrCfg.onLevel;
        this._ncrNullLevel = ncrCfg.nullLevel;
    }
    // -------------------------------------------------------------------------
    // Persistent external entity registration
    // -------------------------------------------------------------------------
    /**
   * Replace the full set of persistent external entities.
   * All keys are validated — throws on invalid characters.
   * @param {Record<string, string | { regex?: RegExp, val: string }>} map
   */ setExternalEntities(map) {
        if (map) for (const key of Object.keys(map))$9233d3b748d815fb$var$validateEntityName(key);
        this._externalMap = $9233d3b748d815fb$var$mergeEntityMaps(map);
    }
    /**
   * Add a single persistent external entity.
   * @param {string} key
   * @param {string} value
   */ addExternalEntity(key, value) {
        $9233d3b748d815fb$var$validateEntityName(key);
        if (typeof value === 'string' && value.indexOf('&') === -1) this._externalMap[key] = value;
    }
    // -------------------------------------------------------------------------
    // Input / runtime entity registration (per document)
    // -------------------------------------------------------------------------
    /**
   * Inject DOCTYPE entities for the current document.
   * Also resets per-document expansion counters.
   * @param {Record<string, string | { regx?: RegExp, regex?: RegExp, val: string }>} map
   */ addInputEntities(map) {
        this._totalExpansions = 0;
        this._expandedLength = 0;
        this._inputMap = $9233d3b748d815fb$var$mergeEntityMaps(map);
    }
    // -------------------------------------------------------------------------
    // Per-document reset
    // -------------------------------------------------------------------------
    /**
   * Wipe input/runtime entities and reset counters.
   * Call this before processing each new document.
   * @returns {this}
   */ reset() {
        this._inputMap = Object.create(null);
        this._totalExpansions = 0;
        this._expandedLength = 0;
        return this;
    }
    // -------------------------------------------------------------------------
    // XML version (can be set after construction, e.g. once parser reads <?xml?>)
    // -------------------------------------------------------------------------
    /**
   * Update the XML version used for NCR classification.
   * Call this as soon as the document's `<?xml version="...">` declaration is parsed.
   * @param {1.0|1.1|number} version
   */ setXmlVersion(version) {
        this._ncrXmlVersion = version === 1.1 ? 1.1 : 1.0;
    }
    // -------------------------------------------------------------------------
    // Primary API
    // -------------------------------------------------------------------------
    /**
   * Replace all entity references in `str` in a single pass.
   *
   * @param {string} str
   * @returns {string}
   */ decode(str) {
        if (typeof str !== 'string' || str.length === 0) return str;
        //TODO: check if needed
        //if (str.indexOf('&') === -1) return str; // fast path — no entities at all
        const original = str;
        const chunks = [];
        const len = str.length;
        let last = 0; // start of next unprocessed literal chunk
        let i = 0;
        const limitExpansions = this._maxTotalExpansions > 0;
        const limitLength = this._maxExpandedLength > 0;
        const checkLimits = limitExpansions || limitLength;
        while(i < len){
            // Scan forward to next '&'
            if (str.charCodeAt(i) !== 38 /* '&' */ ) {
                i++;
                continue;
            }
            // --- Found '&' at position i ---
            // Scan forward to ';'
            let j = i + 1;
            while(j < len && str.charCodeAt(j) !== 59 /* ';' */  && j - i <= 32)j++;
            if (j >= len || str.charCodeAt(j) !== 59) {
                // No closing ';' within window — treat '&' as literal
                i++;
                continue;
            }
            // Raw token between '&' and ';' (exclusive)
            const token = str.slice(i + 1, j);
            if (token.length === 0) {
                i++;
                continue;
            }
            let replacement;
            let tier; // which limit tier this entity belongs to
            if (this._removeSet.has(token)) {
                // Remove entity: replace with empty string
                replacement = '';
                // If entity was unknown (replacement undefined), we still need a tier for limits.
                // Treat as external tier because it's user-directed removal of an unknown reference.
                if (tier === undefined) tier = $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL;
            } else if (this._leaveSet.has(token)) {
                // Do not replace — keep original &token; as literal
                i++;
                continue;
            } else if (token.charCodeAt(0) === 35 /* '#' */ ) {
                // ---- Numeric / NCR reference ----
                // NCR classification always runs first — prohibited codepoints must be
                // caught regardless of numericAllowed.
                const ncrResult = this._resolveNCR(token);
                if (ncrResult === undefined) {
                    // 'leave' action — keep original &token; as-is
                    i++;
                    continue;
                }
                replacement = ncrResult; // '' for remove, char string for allow
                tier = $9233d3b748d815fb$var$LIMIT_TIER_BASE;
            } else {
                // ---- Named reference ----
                const resolved = this._resolveName(token);
                replacement = resolved?.value;
                tier = resolved?.tier;
            }
            if (replacement === undefined) {
                // Unknown entity — leave as-is, advance past '&' only
                i++;
                continue;
            }
            // Flush literal chunk before this entity
            if (i > last) chunks.push(str.slice(last, i));
            chunks.push(replacement);
            last = j + 1; // skip past ';'
            i = last;
            // Apply expansion limits only if this tier is being tracked
            if (checkLimits && this._tierCounts(tier)) {
                if (limitExpansions) {
                    this._totalExpansions++;
                    if (this._totalExpansions > this._maxTotalExpansions) throw new Error(`[EntityReplacer] Entity expansion count limit exceeded: ` + `${this._totalExpansions} > ${this._maxTotalExpansions}`);
                }
                if (limitLength) {
                    // delta: replacement.length minus the raw &token; length (token.length + 2 for '&' and ';')
                    const delta = replacement.length - (token.length + 2);
                    if (delta > 0) {
                        this._expandedLength += delta;
                        if (this._expandedLength > this._maxExpandedLength) throw new Error(`[EntityReplacer] Expanded content length limit exceeded: ` + `${this._expandedLength} > ${this._maxExpandedLength}`);
                    }
                }
            }
        }
        // Flush trailing literal
        if (last < len) chunks.push(str.slice(last));
        // If nothing was replaced, chunks is empty — return original
        const result = chunks.length === 0 ? str : chunks.join('');
        return this._postCheck(result, original);
    }
    // -------------------------------------------------------------------------
    // Private: limit tier check
    // -------------------------------------------------------------------------
    /**
   * Returns true if a resolved entity of the given tier should count
   * against the expansion/length limits.
   * @param {string} tier  — LIMIT_TIER_EXTERNAL | LIMIT_TIER_BASE
   * @returns {boolean}
   */ _tierCounts(tier) {
        if (this._limitTiers.has($9233d3b748d815fb$var$LIMIT_TIER_ALL)) return true;
        return this._limitTiers.has(tier);
    }
    // -------------------------------------------------------------------------
    // Private: entity resolution
    // -------------------------------------------------------------------------
    /**
   * Resolve a named entity token (without & and ;).
   * Priority: inputMap > externalMap > baseMap
   * Returns the resolved value tagged with its limit tier.
   *
   * @param {string} name
   * @returns {{ value: string, tier: string }|undefined}
   */ _resolveName(name) {
        // input and external both count as 'external' tier for limit purposes —
        // they are injected at runtime and are the untrusted surface.
        if (name in this._inputMap) return {
            value: this._inputMap[name],
            tier: $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL
        };
        if (name in this._externalMap) return {
            value: this._externalMap[name],
            tier: $9233d3b748d815fb$var$LIMIT_TIER_EXTERNAL
        };
        if (name in this._baseMap) return {
            value: this._baseMap[name],
            tier: $9233d3b748d815fb$var$LIMIT_TIER_BASE
        };
        return undefined;
    }
    /**
   * Classify a codepoint and return the minimum action level that must be applied.
   * Returns -1 when no minimum is imposed (normal allow path).
   *
   * Ranges checked (in priority order):
   *   1. U+0000            — null, governed by nullNCR (always ≥ remove)
   *   2. U+D800–U+DFFF     — surrogates, always prohibited (min: remove)
   *   3. U+0001–U+001F \ {0x09,0x0A,0x0D}  — XML 1.0 restricted C0 (min: remove)
   *      (skipped in XML 1.1 — C0 controls are allowed when written as NCRs)
   *
   * @param {number} cp  — codepoint
   * @returns {number}   — minimum NCR_LEVEL value, or -1 for no restriction
   */ _classifyNCR(cp) {
        // 1. Null
        if (cp === 0) return this._ncrNullLevel;
        // 2. Surrogates — always prohibited, minimum 'remove'
        if (cp >= 0xD800 && cp <= 0xDFFF) return $9233d3b748d815fb$var$NCR_LEVEL.remove;
        // 3. XML 1.0 restricted C0 controls
        if (this._ncrXmlVersion === 1.0) {
            if (cp >= 0x01 && cp <= 0x1F && !$9233d3b748d815fb$var$XML10_ALLOWED_C0.has(cp)) return $9233d3b748d815fb$var$NCR_LEVEL.remove;
        }
        return -1; // no restriction
    }
    /**
   * Execute a resolved NCR action.
   *
   * @param {number} action   — NCR_LEVEL value
   * @param {string} token    — raw token (e.g. '#38') for error messages
   * @param {number} cp       — codepoint, used only for error messages
   * @returns {string|undefined}
   *   - decoded character string  → 'allow'
   *   - ''                        → 'remove'
   *   - undefined                 → 'leave' (caller must skip past '&' only)
   *   - throws Error              → 'throw'
   */ _applyNCRAction(action, token, cp) {
        switch(action){
            case $9233d3b748d815fb$var$NCR_LEVEL.allow:
                return String.fromCodePoint(cp);
            case $9233d3b748d815fb$var$NCR_LEVEL.remove:
                return '';
            case $9233d3b748d815fb$var$NCR_LEVEL.leave:
                return undefined; // signal: keep literal
            case $9233d3b748d815fb$var$NCR_LEVEL.throw:
                throw new Error(`[EntityDecoder] Prohibited numeric character reference ` + `&${token}; (U+${cp.toString(16).toUpperCase().padStart(4, '0')})`);
            default:
                return String.fromCodePoint(cp);
        }
    }
    /**
   * Full NCR resolution pipeline for a numeric token.
   *
   * Steps:
   *   1. Parse the codepoint (decimal or hex).
   *   2. Validate the raw codepoint range (NaN, <0, >0x10FFFF).
   *   3. If numericAllowed is false and no minimum restriction applies → leave as-is.
   *   4. Classify the codepoint to find the minimum required action level.
   *   5. Resolve effective action = max(onNCR, minimum).
   *   6. Apply and return.
   *
   * @param {string} token  — e.g. '#38', '#x26', '#X26'
   * @returns {string|undefined}
   *   - string (incl. '')  — replacement ('' = remove)
   *   - undefined          — leave original &token; as-is
   */ _resolveNCR(token) {
        // Step 1: parse codepoint
        const second = token.charCodeAt(1);
        let cp;
        if (second === 120 /* x */  || second === 88 /* X */ ) cp = parseInt(token.slice(2), 16);
        else cp = parseInt(token.slice(1), 10);
        // Step 2: out-of-range → leave as-is unconditionally
        if (Number.isNaN(cp) || cp < 0 || cp > 0x10FFFF) return undefined;
        // Step 3: classify to get minimum action level
        const minimum = this._classifyNCR(cp);
        // Step 4: if numericAllowed is false and no hard minimum → leave
        if (!this._numericAllowed && minimum < $9233d3b748d815fb$var$NCR_LEVEL.remove) return undefined;
        // Step 5: effective action = max(configured onNCR, range minimum)
        const effective = minimum === -1 ? this._ncrOnLevel : Math.max(this._ncrOnLevel, minimum);
        // Step 6: apply
        return this._applyNCRAction(effective, token, cp);
    }
}


'use strict';
// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
// Helper functions for attribute and namespace handling
/**
 * Extract raw attributes (without prefix) from prefixed attribute map
 * @param {object} prefixedAttrs - Attributes with prefix from buildAttributesMap
 * @param {object} options - Parser options containing attributeNamePrefix
 * @returns {object} Raw attributes for matcher
 */ function $0caa19c7578d5a33$var$extractRawAttributes(prefixedAttrs, options) {
    if (!prefixedAttrs) return {};
    // Handle attributesGroupName option
    const attrs = options.attributesGroupName ? prefixedAttrs[options.attributesGroupName] : prefixedAttrs;
    if (!attrs) return {};
    const rawAttrs = {};
    for(const key in attrs)// Remove the attribute prefix to get raw name
    if (key.startsWith(options.attributeNamePrefix)) {
        const rawName = key.substring(options.attributeNamePrefix.length);
        rawAttrs[rawName] = attrs[key];
    } else // Attribute without prefix (shouldn't normally happen, but be safe)
    rawAttrs[key] = attrs[key];
    return rawAttrs;
}
/**
 * Extract namespace from raw tag name
 * @param {string} rawTagName - Tag name possibly with namespace (e.g., "soap:Envelope")
 * @returns {string|undefined} Namespace or undefined
 */ function $0caa19c7578d5a33$var$extractNamespace(rawTagName) {
    if (!rawTagName || typeof rawTagName !== 'string') return undefined;
    const colonIndex = rawTagName.indexOf(':');
    if (colonIndex !== -1 && colonIndex > 0) {
        const ns = rawTagName.substring(0, colonIndex);
        // Don't treat xmlns as a namespace
        if (ns !== 'xmlns') return ns;
    }
    return undefined;
}
class $0caa19c7578d5a33$export$2e2bcd8739ae039 {
    constructor(options, externalEntities){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.parseXml = $0caa19c7578d5a33$var$parseXml;
        this.parseTextData = $0caa19c7578d5a33$var$parseTextData;
        this.resolveNameSpace = $0caa19c7578d5a33$var$resolveNameSpace;
        this.buildAttributesMap = $0caa19c7578d5a33$var$buildAttributesMap;
        this.isItStopNode = $0caa19c7578d5a33$var$isItStopNode;
        this.replaceEntitiesValue = $0caa19c7578d5a33$var$replaceEntitiesValue;
        this.readStopNodeData = $0caa19c7578d5a33$var$readStopNodeData;
        this.saveTextToParentTag = $0caa19c7578d5a33$var$saveTextToParentTag;
        this.addChild = $0caa19c7578d5a33$var$addChild;
        this.ignoreAttributesFn = (0, $233d0f6ad1318d74$export$2e2bcd8739ae039)(this.options.ignoreAttributes);
        this.entityExpansionCount = 0;
        this.currentExpandedLength = 0;
        let namedEntities = {
            ...(0, $81cffe5414622c29$export$48469d80b7dadb83)
        };
        if (this.options.entityDecoder) this.entityDecoder = this.options.entityDecoder;
        else {
            if (typeof this.options.htmlEntities === "object") namedEntities = this.options.htmlEntities;
            else if (this.options.htmlEntities === true) namedEntities = {
                ...(0, $81cffe5414622c29$export$3c95c40e0611087b),
                ...(0, $81cffe5414622c29$export$ebe860a2db7990ad)
            };
            this.entityDecoder = new (0, $9233d3b748d815fb$export$2e2bcd8739ae039)({
                namedEntities: {
                    ...namedEntities,
                    ...externalEntities
                },
                numericAllowed: this.options.htmlEntities,
                limit: {
                    maxTotalExpansions: this.options.processEntities.maxTotalExpansions,
                    maxExpandedLength: this.options.processEntities.maxExpandedLength,
                    applyLimitsTo: this.options.processEntities.appliesTo
                }
            });
        }
        // Initialize path matcher for path-expression-matcher
        this.matcher = new (0, $320711df150d3c5d$export$2e2bcd8739ae039)();
        // Live read-only proxy of matcher — PEM creates and caches this internally.
        // All user callbacks receive this instead of the mutable matcher.
        this.readonlyMatcher = this.matcher.readOnly();
        // Flag to track if current node is a stop node (optimization)
        this.isCurrentNodeStopNode = false;
        // Pre-compile stopNodes expressions
        this.stopNodeExpressionsSet = new (0, $c7c856523c50dec8$export$2e2bcd8739ae039)();
        const stopNodesOpts = this.options.stopNodes;
        if (stopNodesOpts && stopNodesOpts.length > 0) {
            for(let i = 0; i < stopNodesOpts.length; i++){
                const stopNodeExp = stopNodesOpts[i];
                if (typeof stopNodeExp === 'string') // Convert string to Expression object
                this.stopNodeExpressionsSet.add(new (0, $9bcc5932ad359b39$export$2e2bcd8739ae039)(stopNodeExp));
                else if (stopNodeExp instanceof (0, $9bcc5932ad359b39$export$2e2bcd8739ae039)) // Already an Expression object
                this.stopNodeExpressionsSet.add(stopNodeExp);
            }
            this.stopNodeExpressionsSet.seal();
        }
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string|Matcher} jPath - jPath string or Matcher instance based on options.jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $0caa19c7578d5a33$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    const options = this.options;
    if (val !== undefined) {
        if (options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val, tagName, jPath);
            // Pass jPath string or matcher based on options.jPath setting
            const jPathOrMatcher = options.jPath ? jPath.toString() : jPath;
            const newval = options.tagValueProcessor(tagName, val, jPathOrMatcher, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (options.trimValues) return $0caa19c7578d5a33$var$parseValue(val, options.parseTagValue, options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $0caa19c7578d5a33$var$parseValue(val, options.parseTagValue, options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $0caa19c7578d5a33$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $0caa19c7578d5a33$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $0caa19c7578d5a33$var$buildAttributesMap(attrStr, jPath, tagName, force = false) {
    const options = this.options;
    if (force === true || options.ignoreAttributes !== true && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = (0, $2438f44761dfbbef$export$aaa9734c55cb7a19)(attrStr, $0caa19c7578d5a33$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        // Pre-process values once: trim + entity replacement
        // Reused in both matcher update and second pass
        const processedVals = new Array(len);
        let hasRawAttrs = false;
        const rawAttrsForMatcher = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            const oldVal = matches[i][4];
            if (attrName.length && oldVal !== undefined) {
                let val = oldVal;
                if (options.trimValues) val = val.trim();
                val = this.replaceEntitiesValue(val, tagName, this.readonlyMatcher);
                processedVals[i] = val;
                rawAttrsForMatcher[attrName] = val;
                hasRawAttrs = true;
            }
        }
        // Update matcher ONCE before second pass, if applicable
        if (hasRawAttrs && typeof jPath === 'object' && jPath.updateCurrent) jPath.updateCurrent(rawAttrsForMatcher);
        // Hoist toString() once — path doesn't change during attribute processing
        const jPathStr = options.jPath ? jPath.toString() : this.readonlyMatcher;
        // Second pass: apply processors, build final attrs
        let hasAttrs = false;
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            if (this.ignoreAttributesFn(attrName, jPathStr)) continue;
            let aName = options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (options.transformAttributeName) aName = options.transformAttributeName(aName);
                aName = $0caa19c7578d5a33$var$sanitizeName(aName, options);
                if (matches[i][4] !== undefined) {
                    // Reuse already-processed value — no double entity replacement
                    const oldVal = processedVals[i];
                    const newVal = options.attributeValueProcessor(attrName, oldVal, jPathStr);
                    if (newVal === null || newVal === undefined) attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) attrs[aName] = newVal;
                    else attrs[aName] = $0caa19c7578d5a33$var$parseValue(oldVal, options.parseAttributeValue, options.numberParseOptions);
                    hasAttrs = true;
                } else if (options.allowBooleanAttributes) {
                    attrs[aName] = true;
                    hasAttrs = true;
                }
            }
        }
        if (!hasAttrs) return;
        if (options.attributesGroupName && !options.preserveOrder) {
            const attrCollection = {};
            attrCollection[options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $0caa19c7578d5a33$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)('!xml');
    let currentNode = xmlObj;
    let textData = "";
    // Reset matcher for new document
    this.matcher.reset();
    this.entityDecoder.reset();
    // Reset entity expansion counters for this document
    this.entityExpansionCount = 0;
    this.currentExpandedLength = 0;
    const options = this.options;
    const docTypeReader = new (0, $057cde97f5d8e852$export$2e2bcd8739ae039)(options.processEntities);
    const xmlLen = xmlData.length;
    for(let i = 0; i < xmlLen; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            const c1 = xmlData.charCodeAt(i + 1);
            if (c1 === 47) {
                const closeIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                tagName = $0caa19c7578d5a33$var$transformTagName(options.transformTagName, tagName, "", options).tagName;
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, this.readonlyMatcher);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = this.matcher.getCurrentTag();
                if (tagName && options.unpairedTagsSet.has(tagName)) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                if (lastTagName && options.unpairedTagsSet.has(lastTagName)) {
                    // Pop the unpaired tag
                    this.matcher.pop();
                    this.tagsNodeStack.pop();
                }
                // Pop the closing tag
                this.matcher.pop();
                this.isCurrentNodeStopNode = false; // Reset flag when closing tag
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (c1 === 63) {
                let tagData = $0caa19c7578d5a33$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, this.readonlyMatcher);
                const attsMap = this.buildAttributesMap(tagData.tagExp, this.matcher, tagData.tagName, true);
                if (attsMap) {
                    const ver = attsMap[this.options.attributeNamePrefix + "version"];
                    this.entityDecoder.setXmlVersion(Number(ver) || 1.0);
                }
                if (options.ignoreDeclaration && tagData.tagName === "?xml" || options.ignorePiTags) ;
                else {
                    const childNode = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)(tagData.tagName);
                    childNode.add(options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent && options.ignoreAttributes !== true) childNode[":@"] = attsMap;
                    this.addChild(currentNode, childNode, this.readonlyMatcher, i);
                }
                i = tagData.closeIndex + 1;
            } else if (c1 === 33 && xmlData.charCodeAt(i + 2) === 45 && xmlData.charCodeAt(i + 3) === 45) {
                const endIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, this.readonlyMatcher);
                    currentNode.add(options.commentPropName, [
                        {
                            [options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (c1 === 33 && xmlData.charCodeAt(i + 2) === 68) {
                const result = docTypeReader.readDocType(xmlData, i);
                this.entityDecoder.addInputEntities(result.entities);
                i = result.i;
            } else if (c1 === 33 && xmlData.charCodeAt(i + 2) === 91) {
                const closeIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, this.readonlyMatcher);
                let val = this.parseTextData(tagExp, currentNode.tagname, this.readonlyMatcher, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (options.cdataPropName) currentNode.add(options.cdataPropName, [
                    {
                        [options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $0caa19c7578d5a33$var$readTagExp(xmlData, i, options.removeNSPrefix);
                // Safety check: readTagExp can return undefined
                if (!result) {
                    // Log context for debugging
                    const context = xmlData.substring(Math.max(0, i - 50), Math.min(xmlLen, i + 50));
                    throw new Error(`readTagExp returned undefined at position ${i}. Context: "${context}"`);
                }
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                ({ tagName: tagName, tagExp: tagExp } = $0caa19c7578d5a33$var$transformTagName(options.transformTagName, tagName, tagExp, options));
                if (options.strictReservedNames && (tagName === options.commentPropName || tagName === options.cdataPropName || tagName === options.textNodeName || tagName === options.attributesGroupName)) throw new Error(`Invalid tag name: ${tagName}`);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, this.readonlyMatcher, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && options.unpairedTagsSet.has(lastTag.tagname)) {
                    currentNode = this.tagsNodeStack.pop();
                    this.matcher.pop();
                }
                // Clean up self-closing syntax BEFORE processing attributes
                // This is where tagExp gets the trailing / removed
                let isSelfClosing = false;
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    isSelfClosing = true;
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    // Re-check attrExpPresent after cleaning
                    attrExpPresent = tagName !== tagExp;
                }
                // Now process attributes with CLEAN tagExp (no trailing /)
                let prefixedAttrs = null;
                let rawAttrs = {};
                let namespace = undefined;
                // Extract namespace from rawTagName
                namespace = $0caa19c7578d5a33$var$extractNamespace(rawTagName);
                // Push tag to matcher FIRST (with empty attrs for now) so callbacks see correct path
                if (tagName !== xmlObj.tagname) this.matcher.push(tagName, {}, namespace);
                // Now build attributes - callbacks will see correct matcher state
                if (tagName !== tagExp && attrExpPresent) {
                    // Build attributes (returns prefixed attributes for the tree)
                    // Note: buildAttributesMap now internally updates the matcher with raw attributes
                    prefixedAttrs = this.buildAttributesMap(tagExp, this.matcher, tagName);
                    if (prefixedAttrs) // Extract raw attributes (without prefix) for our use
                    //TODO: seems a performance overhead
                    rawAttrs = $0caa19c7578d5a33$var$extractRawAttributes(prefixedAttrs, options);
                }
                // Now check if this is a stop node (after attributes are set)
                if (tagName !== xmlObj.tagname) this.isCurrentNodeStopNode = this.isItStopNode();
                const startIndex = i;
                if (this.isCurrentNodeStopNode) {
                    let tagContent = "";
                    // For self-closing tags, content is empty
                    if (isSelfClosing) i = result.closeIndex;
                    else if (options.unpairedTagsSet.has(tagName)) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)(tagName);
                    if (prefixedAttrs) childNode[":@"] = prefixedAttrs;
                    // For stop nodes, store raw content as-is without any processing
                    childNode.add(options.textNodeName, tagContent);
                    this.matcher.pop(); // Pop the stop node tag
                    this.isCurrentNodeStopNode = false; // Reset flag
                    this.addChild(currentNode, childNode, this.readonlyMatcher, startIndex);
                } else {
                    //selfClosing tag
                    if (isSelfClosing) {
                        ({ tagName: tagName, tagExp: tagExp } = $0caa19c7578d5a33$var$transformTagName(options.transformTagName, tagName, tagExp, options));
                        const childNode = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)(tagName);
                        if (prefixedAttrs) childNode[":@"] = prefixedAttrs;
                        this.addChild(currentNode, childNode, this.readonlyMatcher, startIndex);
                        this.matcher.pop(); // Pop self-closing tag
                        this.isCurrentNodeStopNode = false; // Reset flag
                    } else if (options.unpairedTagsSet.has(tagName)) {
                        const childNode = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)(tagName);
                        if (prefixedAttrs) childNode[":@"] = prefixedAttrs;
                        this.addChild(currentNode, childNode, this.readonlyMatcher, startIndex);
                        this.matcher.pop(); // Pop unpaired tag
                        this.isCurrentNodeStopNode = false; // Reset flag
                        i = result.closeIndex;
                        continue;
                    } else {
                        const childNode = new (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039)(tagName);
                        if (this.tagsNodeStack.length > options.maxNestedTags) throw new Error("Maximum nested tags exceeded");
                        this.tagsNodeStack.push(currentNode);
                        if (prefixedAttrs) childNode[":@"] = prefixedAttrs;
                        this.addChild(currentNode, childNode, this.readonlyMatcher, startIndex);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $0caa19c7578d5a33$var$addChild(currentNode, childNode, matcher, startIndex) {
    // unset startIndex if not requested
    if (!this.options.captureMetaData) startIndex = undefined;
    // Pass jPath string or matcher based on options.jPath setting
    const jPathOrMatcher = this.options.jPath ? matcher.toString() : matcher;
    const result = this.options.updateTag(childNode.tagname, jPathOrMatcher, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode, startIndex);
    } else currentNode.addChild(childNode, startIndex);
}
/**
 * @param {object} val - Entity object with regex and val properties
 * @param {string} tagName - Tag name
 * @param {string|Matcher} jPath - jPath string or Matcher instance based on options.jPath
 */ function $0caa19c7578d5a33$var$replaceEntitiesValue(val, tagName, jPath) {
    const entityConfig = this.options.processEntities;
    if (!entityConfig || !entityConfig.enabled) return val;
    // Check if tag is allowed to contain entities
    if (entityConfig.allowedTags) {
        const jPathOrMatcher = this.options.jPath ? jPath.toString() : jPath;
        const allowed = Array.isArray(entityConfig.allowedTags) ? entityConfig.allowedTags.includes(tagName) : entityConfig.allowedTags(tagName, jPathOrMatcher);
        if (!allowed) return val;
    }
    // Apply custom tag filter if provided
    if (entityConfig.tagFilter) {
        const jPathOrMatcher = this.options.jPath ? jPath.toString() : jPath;
        if (!entityConfig.tagFilter(tagName, jPathOrMatcher)) return val; // Skip based on custom filter
    }
    return this.entityDecoder.decode(val);
}
function $0caa19c7578d5a33$var$saveTextToParentTag(textData, parentNode, matcher, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = parentNode.child.length === 0;
        textData = this.parseTextData(textData, parentNode.tagname, matcher, false, parentNode[":@"] ? Object.keys(parentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") parentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
/**
 * @param {Array<Expression>} stopNodeExpressions - Array of compiled Expression objects
 * @param {Matcher} matcher - Current path matcher
 */ function $0caa19c7578d5a33$var$isItStopNode() {
    if (this.stopNodeExpressionsSet.size === 0) return false;
    return this.matcher.matchesAny(this.stopNodeExpressionsSet);
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $0caa19c7578d5a33$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    //TODO: ignore boolean attributes in tag expression
    //TODO: if ignore attributes, dont read full attribute expression but the end. But read for xml declaration
    let attrBoundary = 0;
    const len = xmlData.length;
    const closeCode0 = closingChar.charCodeAt(0);
    const closeCode1 = closingChar.length > 1 ? closingChar.charCodeAt(1) : -1;
    let result = '';
    let segmentStart = i;
    for(let index = i; index < len; index++){
        const code = xmlData.charCodeAt(index);
        if (attrBoundary) {
            if (code === attrBoundary) attrBoundary = 0;
        } else if (code === 34 || code === 39) attrBoundary = code;
        else if (code === closeCode0) {
            if (closeCode1 !== -1) {
                if (xmlData.charCodeAt(index + 1) === closeCode1) {
                    result += xmlData.substring(segmentStart, index);
                    return {
                        data: result,
                        index: index
                    };
                }
            } else {
                result += xmlData.substring(segmentStart, index);
                return {
                    data: result,
                    index: index
                };
            }
        } else if (code === 9 && !attrBoundary) {
            // Flush accumulated segment, add space, start new segment
            result += xmlData.substring(segmentStart, index) + ' ';
            segmentStart = index + 1;
        }
    }
}
function $0caa19c7578d5a33$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $0caa19c7578d5a33$var$findClosingChar(xmlData, char, i, errMsg) {
    const closingIndex = xmlData.indexOf(char, i);
    if (closingIndex === -1) throw new Error(errMsg);
    return closingIndex; // no offset needed
}
function $0caa19c7578d5a33$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $0caa19c7578d5a33$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $0caa19c7578d5a33$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    const xmllen = xmlData.length;
    for(; i < xmllen; i++)if (xmlData[i] === "<") {
        const c1 = xmlData.charCodeAt(i + 1);
        if (c1 === 47) {
            const closeIndex = $0caa19c7578d5a33$var$findClosingChar(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (c1 === 63) {
            const closeIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (c1 === 33 && xmlData.charCodeAt(i + 2) === 45 && xmlData.charCodeAt(i + 3) === 45) {
            const closeIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (c1 === 33 && xmlData.charCodeAt(i + 2) === 91) {
            const closeIndex = $0caa19c7578d5a33$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $0caa19c7578d5a33$var$readTagExp(xmlData, i, false);
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $0caa19c7578d5a33$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return (0, $d1661821a19d4a29$export$2e2bcd8739ae039)(val, options);
    } else {
        if ((0, $2438f44761dfbbef$export$a5edf3f35b6dd392)(val)) return val;
        else return '';
    }
}
function $0caa19c7578d5a33$var$fromCodePoint(str, base, prefix) {
    const codePoint = Number.parseInt(str, base);
    if (codePoint >= 0 && codePoint <= 0x10FFFF) return String.fromCodePoint(codePoint);
    else return prefix + str + ";";
}
function $0caa19c7578d5a33$var$transformTagName(fn, tagName, tagExp, options) {
    if (fn) {
        const newTagName = fn(tagName);
        if (tagExp === tagName) tagExp = newTagName;
        tagName = newTagName;
    }
    tagName = $0caa19c7578d5a33$var$sanitizeName(tagName, options);
    return {
        tagName: tagName,
        tagExp: tagExp
    };
}
function $0caa19c7578d5a33$var$sanitizeName(name, options) {
    if ((0, $2438f44761dfbbef$export$deb3cacd0e79cda8).includes(name)) throw new Error(`[SECURITY] Invalid name: "${name}" is a reserved JavaScript keyword that could cause prototype pollution`);
    else if ((0, $2438f44761dfbbef$export$a992756d162cd0c0).includes(name)) return options.onDangerousProperty(name);
    return name;
}




'use strict';
const $dbfdab03c9e8f1f5$var$METADATA_SYMBOL = (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039).getMetaDataSymbol();
/**
 * Helper function to strip attribute prefix from attribute map
 * @param {object} attrs - Attributes with prefix (e.g., {"@_class": "code"})
 * @param {string} prefix - Attribute prefix to remove (e.g., "@_")
 * @returns {object} Attributes without prefix (e.g., {"class": "code"})
 */ function $dbfdab03c9e8f1f5$var$stripAttributePrefix(attrs, prefix) {
    if (!attrs || typeof attrs !== 'object') return {};
    if (!prefix) return attrs;
    const rawAttrs = {};
    for(const key in attrs)if (key.startsWith(prefix)) {
        const rawName = key.substring(prefix.length);
        rawAttrs[rawName] = attrs[key];
    } else // Attribute without prefix (shouldn't normally happen, but be safe)
    rawAttrs[key] = attrs[key];
    return rawAttrs;
}
function $dbfdab03c9e8f1f5$export$2e2bcd8739ae039(node, options, matcher, readonlyMatcher) {
    return $dbfdab03c9e8f1f5$var$compress(node, options, matcher, readonlyMatcher);
}
/**
 * @param {array} arr 
 * @param {object} options 
 * @param {Matcher} matcher - Path matcher instance
 * @returns object
 */ function $dbfdab03c9e8f1f5$var$compress(arr, options, matcher, readonlyMatcher) {
    let text;
    const compressedObj = {}; //This is intended to be a plain object
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $dbfdab03c9e8f1f5$var$propName(tagObj);
        // Push current property to matcher WITH RAW ATTRIBUTES (no prefix)
        if (property !== undefined && property !== options.textNodeName) {
            const rawAttrs = $dbfdab03c9e8f1f5$var$stripAttributePrefix(tagObj[":@"] || {}, options.attributeNamePrefix);
            matcher.push(property, rawAttrs);
        }
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $dbfdab03c9e8f1f5$var$compress(tagObj[property], options, matcher, readonlyMatcher);
            const isLeaf = $dbfdab03c9e8f1f5$var$isLeafTag(val, options);
            if (Object.keys(val).length === 0 && options.alwaysCreateTextNode) val[options.textNodeName] = "";
            if (tagObj[":@"]) $dbfdab03c9e8f1f5$var$assignAttributes(val, tagObj[":@"], readonlyMatcher, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (tagObj[$dbfdab03c9e8f1f5$var$METADATA_SYMBOL] !== undefined && typeof val === "object" && val !== null) val[$dbfdab03c9e8f1f5$var$METADATA_SYMBOL] = tagObj[$dbfdab03c9e8f1f5$var$METADATA_SYMBOL]; // copy over metadata
            if (compressedObj[property] !== undefined && Object.prototype.hasOwnProperty.call(compressedObj, property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else {
                //TODO: if a node is not an array, then check if it should be an array
                //also determine if it is a leaf node
                // Pass jPath string or readonlyMatcher based on options.jPath setting
                const jPathOrMatcher = options.jPath ? readonlyMatcher.toString() : readonlyMatcher;
                if (options.isArray(property, jPathOrMatcher, isLeaf)) compressedObj[property] = [
                    val
                ];
                else compressedObj[property] = val;
            }
            // Pop property from matcher after processing
            if (property !== undefined && property !== options.textNodeName) matcher.pop();
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $dbfdab03c9e8f1f5$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $dbfdab03c9e8f1f5$var$assignAttributes(obj, attrMap, readonlyMatcher, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i]; // This is the PREFIXED name (e.g., "@_class")
            // Strip prefix for matcher path (for isArray callback)
            const rawAttrName = atrrName.startsWith(options.attributeNamePrefix) ? atrrName.substring(options.attributeNamePrefix.length) : atrrName;
            // For attributes, we need to create a temporary path
            // Pass jPath string or matcher based on options.jPath setting
            const jPathOrMatcher = options.jPath ? readonlyMatcher.toString() + "." + rawAttrName : readonlyMatcher;
            if (options.isArray(atrrName, jPathOrMatcher, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $dbfdab03c9e8f1f5$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}



'use strict';
const $31b1c0f7b9b04d60$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
function $31b1c0f7b9b04d60$export$a22775fa5e2eebd9(xmlData, options) {
    options = Object.assign({}, $31b1c0f7b9b04d60$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $31b1c0f7b9b04d60$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $31b1c0f7b9b04d60$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$31b1c0f7b9b04d60$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', msg, $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $31b1c0f7b9b04d60$var$readAttributeStr(xmlData, i);
                if (result === false) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $31b1c0f7b9b04d60$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $31b1c0f7b9b04d60$var$getErrorObject(isValid.err.code, isValid.err.msg, $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $31b1c0f7b9b04d60$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $31b1c0f7b9b04d60$var$getErrorObject(isValid.err.code, isValid.err.msg, $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $31b1c0f7b9b04d60$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $31b1c0f7b9b04d60$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $31b1c0f7b9b04d60$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidChar', "char '&' is not expected.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$31b1c0f7b9b04d60$var$isWhiteSpace(xmlData[i])) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidXml', "Extra text at the end", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($31b1c0f7b9b04d60$var$isWhiteSpace(xmlData[i])) continue;
            return $31b1c0f7b9b04d60$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
}
function $31b1c0f7b9b04d60$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $31b1c0f7b9b04d60$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $31b1c0f7b9b04d60$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $31b1c0f7b9b04d60$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $31b1c0f7b9b04d60$var$doubleQuote = '"';
const $31b1c0f7b9b04d60$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $31b1c0f7b9b04d60$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $31b1c0f7b9b04d60$var$doubleQuote || xmlData[i] === $31b1c0f7b9b04d60$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $31b1c0f7b9b04d60$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $31b1c0f7b9b04d60$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = (0, $2438f44761dfbbef$export$aaa9734c55cb7a19)(attrStr, $31b1c0f7b9b04d60$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $31b1c0f7b9b04d60$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $31b1c0f7b9b04d60$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $31b1c0f7b9b04d60$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$31b1c0f7b9b04d60$var$validateAttrName(attrName)) return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $31b1c0f7b9b04d60$var$getPositionFromMatch(matches[i]));
        if (!Object.prototype.hasOwnProperty.call(attrNames, attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $31b1c0f7b9b04d60$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $31b1c0f7b9b04d60$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $31b1c0f7b9b04d60$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $31b1c0f7b9b04d60$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $31b1c0f7b9b04d60$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $31b1c0f7b9b04d60$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $31b1c0f7b9b04d60$var$validateAttrName(attrName) {
    return (0, $2438f44761dfbbef$export$998d7ff9801e90bb)(attrName);
}
// const startsWithXML = /^xml/i;
function $31b1c0f7b9b04d60$var$validateTagName(tagname) {
    return (0, $2438f44761dfbbef$export$998d7ff9801e90bb)(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $31b1c0f7b9b04d60$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $31b1c0f7b9b04d60$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}



class $26a6c9bf8a5ea073$export$2e2bcd8739ae039 {
    constructor(options){
        this.externalEntities = {};
        this.options = (0, $59ada2bd4c3e0111$export$ecbd7d678ac4909b)(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Uint8Array} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData !== "string" && xmlData.toString) xmlData = xmlData.toString();
        else if (typeof xmlData !== "string") throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = (0, $31b1c0f7b9b04d60$export$a22775fa5e2eebd9)(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new (0, $0caa19c7578d5a33$export$2e2bcd8739ae039)(this.options, this.externalEntities);
        // orderedObjParser.entityDecoder.setExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return (0, $dbfdab03c9e8f1f5$export$2e2bcd8739ae039)(orderedResult, this.options, orderedObjParser.matcher, orderedObjParser.readonlyMatcher);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
    /**
     * Returns a Symbol that can be used to access the metadata
     * property on a node.
     * 
     * If Symbol is not available in the environment, an ordinary property is used
     * and the name of the property is here returned.
     * 
     * The XMLMetaData property is only present when `captureMetaData`
     * is true in the options.
     */ static getMetaDataSymbol() {
        return (0, $1d0979e96b37bc5b$export$2e2bcd8739ae039).getMetaDataSymbol();
    }
}





var $fmvtn = parcelRequire("fmvtn");
const $c5391cf84cf40afe$var$NODEWIDTH = 10 // chars for label splitting
;
let $c5391cf84cf40afe$var$lastFileName = '' // the name of the file last read in
;
let $c5391cf84cf40afe$var$msg = '';
function $c5391cf84cf40afe$export$12d9b7805ed59d8e(e) {
    const file = e.target.files[0];
    if (!file) return;
    const fileName = file.name;
    $c5391cf84cf40afe$var$lastFileName = fileName;
    document.body.style.cursor = 'wait';
    (0, $7hmfH.statusMsg)("Reading '" + fileName + "'");
    $c5391cf84cf40afe$var$msg = '';
    e.target.value = '';
    const reader = new FileReader();
    reader.onloadend = function(e) {
        try {
            document.body.style.cursor = 'wait';
            $c5391cf84cf40afe$var$loadFile(e.target.result);
            if (!$c5391cf84cf40afe$var$msg) (0, $7hmfH.statusMsg)(`Read '${fileName}'`);
        } catch (err) {
            document.body.style.cursor = 'default';
            (0, $7hmfH.alertMsg)("Error reading '" + fileName + "': " + err.message, 'error');
            console.log(err);
            (0, $5bc812abaa5f432b$export$c265e176a8e0f011)();
        }
        document.body.style.cursor = 'default';
    };
    reader.readAsArrayBuffer(file);
}
function $c5391cf84cf40afe$export$c47c8b06a9966d9f() {
    (0, $7hmfH.elem)('fileInput').click();
}
/**
 * Allow user to open a file by dragging and dropping it over the PRSM window
 */ (0, $7hmfH.elem)('container').addEventListener('drop', (e)=>{
    e.preventDefault();
    const dt = e.dataTransfer;
    const files = dt.files;
    if (files.length > 0) $c5391cf84cf40afe$export$12d9b7805ed59d8e({
        target: {
            files: files
        }
    });
});
(0, $7hmfH.elem)('container').addEventListener('dragover', (e)=>{
    e.preventDefault();
});
/**
 * determine what kind of file it is, parse it and replace any current map with the one read from the file
 * @param {string} contents - what is in the file
 */ function $c5391cf84cf40afe$var$loadFile(contents) {
    const extn = $c5391cf84cf40afe$var$lastFileName.split('.').pop().toLowerCase();
    // saved menu of maps treated as a special case, to avoid deleting the current map when loading the menu
    if (extn === 'prsml') {
        (0, $7f60c5bdd5f6f512$export$59a30cd752fdf847)($c5391cf84cf40afe$var$arrayBufferToString(contents));
        return;
    }
    if ((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.length > 0) {
        if (!confirm('Loading a file will delete the current network.  Are you sure you want to replace it?')) return;
    }
    (0, $5bc812abaa5f432b$export$fb931cd598921492)();
    // load the file as one single yjs transaction to reduce server traffic
    (0, $5bc812abaa5f432b$export$c265e176a8e0f011)();
    (0, $5bc812abaa5f432b$export$2a111da947c407d2).transact(()=>{
        switch(extn){
            case 'csv':
                $c5391cf84cf40afe$var$loadCSV($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'graphml':
                $c5391cf84cf40afe$var$loadGraphML($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'gml':
                $c5391cf84cf40afe$var$loadGML($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'json':
                $c5391cf84cf40afe$var$loadKumufile($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'prsm':
                $c5391cf84cf40afe$var$loadPRSMfile($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'gv':
            case 'dot':
                $c5391cf84cf40afe$var$loadDOTfile($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'xlsx':
            case 'xls':
                $c5391cf84cf40afe$var$loadExcelfile(contents);
                break;
            case 'gexf':
                $c5391cf84cf40afe$var$loadGEXFfile($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            case 'drawio':
            case 'xml':
                $c5391cf84cf40afe$var$loadDrawIOfile($c5391cf84cf40afe$var$arrayBufferToString(contents));
                break;
            default:
                throw new Error('Unrecognised file name suffix');
        }
        const nodesToUpdate = [];
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((n)=>{
            // ensure that all nodes have a grp property (converting 'group' property for old format files)
            if (!n.grp) n.grp = n.group ? 'group' + n.group % 9 : 'group0';
            // reassign the sample properties to the nodes
            n = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[n.grp], n);
            // version 1.6 made changes to label scaling
            n.scaling = {
                label: {
                    enabled: false,
                    max: 40,
                    min: 10
                },
                max: 100,
                min: 10
            };
            nodesToUpdate.push(n);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
        // same for edges
        const edgesToUpdate = [];
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().forEach((e)=>{
            // ensure that all edges have a grp property (converting 'group' property for old format files)
            if (!e.grp) e.grp = e.group ? 'edge' + e.group % 9 : 'edge0';
            // reassign the sample properties to the edges
            e = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[e.grp], e);
            edgesToUpdate.push(e);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToUpdate);
        (0, $5bc812abaa5f432b$export$1e044b7877db048c)();
        (0, $3ee4e83c23551e65$export$b8032ab161d91961)();
        // Allow open file undo unless the loaded file is blank (no factors). This gives
        // users a way of zeroing a map.
        (0, $5bc812abaa5f432b$export$e5fde6ebaea8ae1d)('loaded &lt;' + $c5391cf84cf40afe$var$lastFileName + '&gt;', false, (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.length === 0);
    });
    (0, $5bc812abaa5f432b$export$f796f85272199be2).clear();
    $c5391cf84cf40afe$var$deleteSavedRollbacks();
    (0, $5bc812abaa5f432b$export$e810bab53f2cc5ca)();
    (0, $5bc812abaa5f432b$export$c1a1b42e4610dc4a)();
    (0, $5bc812abaa5f432b$export$5323aa6dd0c7006b)((0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles') || {});
    (0, $5bc812abaa5f432b$export$5dfa5433ac89eafa)();
}
/**
 * convert an ArrayBuffer to String
 * @param {arrayBuffer} contents
 * @returns string
 */ function $c5391cf84cf40afe$var$arrayBufferToString(contents) {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(new DataView(contents));
}
/**
 * delete any saved rollbacks for the current room from localForage
 */ async function $c5391cf84cf40afe$var$deleteSavedRollbacks() {
    const keys = await (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).keys();
    keys.forEach((key)=>{
        if (key.startsWith((0, $5bc812abaa5f432b$export$f9d3fff8c23da278))) (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).removeItem(key);
    });
}
/**
 * Parse and load a PRSM map file, or a JSON file exported from Gephi
 * @param {string} str
 */ function $c5391cf84cf40afe$var$loadPRSMfile(str) {
    if (str[0] !== '{') str = (0, $93qLg.decompressFromUTF16)(str);
    const json = JSON.parse(str);
    if (json.version && (0, $fmvtn.version).substring(0, 3) > json.version.substring(0, 3)) {
        (0, $7hmfH.alertMsg)('Warning: file was created in an earlier version', 'warn');
        $c5391cf84cf40afe$var$msg = 'old version';
    }
    (0, $5bc812abaa5f432b$export$7ac138a1e38951d6)(json.lastNodeSample, json.lastLinkSample);
    if (json.mapTitle) (0, $5bc812abaa5f432b$export$807f940a96777041).set('mapTitle', (0, $5bc812abaa5f432b$export$f229389f565c6b3f)(json.mapTitle));
    if (json.attributeTitles) (0, $5bc812abaa5f432b$export$807f940a96777041).set('attributeTitles', json.attributeTitles);
    else (0, $5bc812abaa5f432b$export$807f940a96777041).set('attributeTitles', {});
    if (json.edges.length > 0 && 'source' in json.edges[0]) {
        // the file is from Gephi and needs to be translated
        const parsed = (0, $8L2sr.parseGephiNetwork)(json, {
            edges: {
                inheritColors: false
            },
            nodes: {
                fixed: false,
                parseColor: true
            }
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(parsed.nodes);
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(parsed.edges);
    } else {
        json.nodes.forEach((n)=>{
            // at version 1.5, the title: property was renamed to note:
            if (!n.note && n.title) n.note = n.title.replace(/<br>|<p>/g, '\n');
            delete n.title;
            if (n.note && !(n.note instanceof Object)) n.note = {
                ops: [
                    {
                        insert: n.note
                    }
                ]
            };
            n.label = (0, $7hmfH.splitText)(n.label);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(json.nodes);
        json.edges.forEach((e)=>{
            if (!e.note && e.title) e.note = e.title.replace(/<br>|<p>/g, '\n');
            delete e.title;
            if (e.note && !(e.note instanceof Object)) e.note = {
                ops: [
                    {
                        insert: e.note
                    }
                ]
            };
            if (e.label) e.label = (0, $7hmfH.splitText)(e.label);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(json.edges);
    }
    // before v1.4, the style array was called samples
    if (json.samples) json.styles = json.samples;
    if (json.styles) {
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes, json.styles.nodes);
        for(const n in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes)delete (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[n].chosen;
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges, json.styles.edges);
        for(const e in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges)delete (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[e].chosen;
        for(const groupId in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes){
            (0, $5bc812abaa5f432b$export$4b63d58d2685a993).set(groupId, {
                node: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[groupId]
            });
            if (groupId.match(/\d+/)?.[0]) (0, $3ee4e83c23551e65$export$675fa328fb4ebccd)(groupId);
        }
        for(const edgeId in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges){
            (0, $5bc812abaa5f432b$export$4b63d58d2685a993).set(edgeId, {
                edge: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[edgeId]
            });
            if (edgeId.match(/\d+/)?.[0]) (0, $3ee4e83c23551e65$export$e496289367e7ce52)(edgeId);
        }
    }
    (0, $5bc812abaa5f432b$export$da7062de5ac36f9c).clear();
    (0, $95c555713171f487$export$67ea982130081db).clear();
    (0, $5bc812abaa5f432b$export$ffba1a0e51177788).delete(0, (0, $5bc812abaa5f432b$export$ffba1a0e51177788).length);
    if (json.underlay) {
        // background from v1; update it
        (0, $5bc812abaa5f432b$export$ffba1a0e51177788).insert(0, json.underlay);
        if ((0, $5bc812abaa5f432b$export$ffba1a0e51177788).length > 0) (0, $95c555713171f487$export$aab3aebcdfaf4b16)((0, $5bc812abaa5f432b$export$ffba1a0e51177788).toArray());
    }
    if (json.background) {
        (0, $95c555713171f487$export$cf606e54e8a9990d)();
        const map = JSON.parse(json.background);
        for (const [key, value] of Object.entries(map))(0, $5bc812abaa5f432b$export$da7062de5ac36f9c).set(key, value);
        (0, $95c555713171f487$export$8d588f71d329a9b1)(Object.keys(map));
    }
    (0, $5bc812abaa5f432b$export$d920e34eaf2b21cb).delete(0, (0, $5bc812abaa5f432b$export$d920e34eaf2b21cb).length);
    if (json.history) (0, $5bc812abaa5f432b$export$d920e34eaf2b21cb).insert(0, json.history);
    if (json.description) {
        (0, $5bc812abaa5f432b$export$807f940a96777041).set('mapDescription', json.description);
        (0, $5bc812abaa5f432b$export$3a86b7dfc26ebfa6)();
        (0, $5bc812abaa5f432b$export$cff30a8f7435ec50)(json.description);
    }
    // node sizing has to be done after nodes have been created
    (0, $5bc812abaa5f432b$export$9758cac25f26dd85)((0, $5bc812abaa5f432b$export$807f940a96777041).get('sizing'));
    if (json.buttons) $c5391cf84cf40afe$var$setButtonStatus(json.buttons);
}
/**
 * parse and load a GraphViz (.DOT or .GV) file
 *  uses the vis-network DOT parser, which is pretty hopeless -
 *  e.g. it does not manage dotted or dashed node borders and
 *  requires some massaging of the parameters it does recognise
 *
 * @param {string} graph contents of DOT file
 * @returns nodes and edges as an object
 */ function $c5391cf84cf40afe$var$loadDOTfile(graph) {
    const parsedData = (0, $8L2sr.parseDOTNetwork)(graph);
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(parsedData.nodes.map((node)=>{
        const n = (0, $7hmfH.strip)(node, [
            'id',
            'label',
            'color',
            'shape',
            'font',
            'width'
        ]);
        if (!n.id) n.id = (0, $7hmfH.uuidv4)();
        if (!n.color) n.color = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes['group0'].color);
        if (!n.font) n.font = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes['group0'].font);
        if (!n.shape) n.shape = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes['group0'].shape);
        if (n.font?.size) n.font.size = parseInt(n.font.size);
        if (n.width) n.borderWidth = parseInt(n.width);
        if (n.shape === 'plaintext') {
            n.shape = 'text';
            n.borderWidth = 0;
        }
        return n;
    }));
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(parsedData.edges.map((edge)=>{
        const e = (0, $7hmfH.strip)(edge, [
            'id',
            'from',
            'to',
            'label',
            'color',
            'dashes'
        ]);
        if (!e.id) e.id = (0, $7hmfH.uuidv4)();
        if (!e.color) e.color = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges['edge0'].color);
        if (!e.dashes) e.dashes = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges['edge0'].dashes);
        if (!e.width) e.width = e.width ? parseInt(e.width) : (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges['edge0'].width;
        return e;
    }));
}
/**
 * parse and load a graphML file
 * @param {string} graphML
 */ function $c5391cf84cf40afe$var$loadGraphML(graphML) {
    const options = {
        ignoreAttributes: false,
        attributeNamePrefix: '',
        alwaysCreateTextNode: false,
        isArray: (name, jpath)=>{
            // Define which elements should always be arrays
            const arrayPaths = [
                'graphml.key',
                'graphml.graph.node',
                'graphml.graph.edge',
                'graphml.graph.node.data',
                'graphml.graph.edge.data'
            ];
            return arrayPaths.includes(jpath);
        },
        textNodeName: '#text',
        trimValues: true
    };
    const parser = new (0, $26a6c9bf8a5ea073$export$2e2bcd8739ae039)(options);
    const parsedData = parser.parse(graphML);
    if (parsedData.graphml && parsedData.graphml.graph) {
        const attributeNames = {};
        if (parsedData.graphml.key) parsedData.graphml.key.forEach((key)=>{
            attributeNames[key.id] = key['attr.name'];
        });
        const nodes = parsedData.graphml.graph.node.map((node)=>{
            const nodeData = {};
            if (node.data) node.data.forEach((data)=>{
                nodeData[attributeNames[data['key']]] = data['#text'];
            });
            return {
                id: node['id'],
                ...nodeData
            };
        });
        const edges = parsedData.graphml.graph.edge.map((edge)=>{
            const edgeData = {};
            if (edge.data) edge.data.forEach((data)=>{
                edgeData[attributeNames[data['key']]] = data['#text'];
            });
            return {
                id: edge['id'],
                source: edge['source'],
                target: edge['target'],
                ...edgeData
            };
        });
        const nodesToUpdate = [];
        nodes.forEach((node)=>{
            const n = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.group0);
            if (!node.id) throw new Error(`No ID for node ${node.label}`);
            n.id = node.id;
            n.label = node.label ? node.label : node.id;
            if (node.size) n.size = node.size;
            if (node.x) n.x = node.x;
            if (node.y) n.y = node.y;
            if (node.r !== undefined && node.g !== undefined && node.b !== undefined) {
                n.color.background = `rgb(${node.r},${node.g},${node.b})`;
                n.font.color = (0, $7hmfH.rgbIsLight)(node.r, node.g, node.b) ? 'rgb(0,0,0)' : 'rgb(255,255,255)';
            }
            nodesToUpdate.push(n);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
        // and each edge
        const edgesToUpdate = [];
        edges.forEach((edge)=>{
            const e = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.edge0);
            if (!edge.id) throw new Error('Missing edge ID');
            e.id = edge.id;
            if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.source)) throw new Error(`No node ${edge.source} for source of edge ID ${edge.id}`);
            e.from = edge.source;
            if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.target)) throw new Error(`No node ${edge.target} for source of edge ID ${edge.id}`);
            e.to = edge.target;
            e.width = edge.weight > 20 ? 20 : edge.weight < 1 ? 1 : edge.weight;
            edgesToUpdate.push(e);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToUpdate);
    } else {
        (0, $7hmfH.alertMsg)('Bad format in GraphML file', 'error');
        throw new Error('Bad format in GraphML file');
    }
}
/**
 * Parse and load a Gephi GEXF file into PRSM format
 * @param {string} gexf - XML string from file
 */ function $c5391cf84cf40afe$var$loadGEXFfile(gexf) {
    const parser = new (0, $26a6c9bf8a5ea073$export$2e2bcd8739ae039)({
        ignoreAttributes: false,
        attributeNamePrefix: '',
        processEntities: true,
        isArray: (name)=>[
                'node',
                'edge',
                'attribute',
                'attvalue'
            ].includes(name),
        transformTagName: (tag)=>tag.startsWith('viz:') ? tag.replace('viz:', 'viz_') : tag
    });
    const jsonObj = parser.parse(gexf);
    const graph = jsonObj.gexf?.graph || jsonObj.graph;
    if (!graph) throw new Error('Invalid GEXF format: no graph found');
    const attributes = processAttributes(graph.attributes);
    const nodes = (graph.nodes?.node || []).map((node)=>({
            id: node.id,
            label: node.label || node.id,
            attributes: processAttributeValues(node.attvalues?.attvalue || []),
            ...processVizAttributes(node),
            ...processNodePosition(node)
        }));
    const edges = (graph.edges?.edge || []).map((edge)=>({
            id: edge.id,
            source: edge.source,
            target: edge.target,
            type: edge.type || graph.defaultedgetype || 'directed',
            weight: parseFloat(edge.weight) || 1,
            attributes: processAttributeValues(edge.attvalues?.attvalue || []),
            ...processEdgeVizAttributes(edge)
        }));
    const attributeNames = {
        ...(0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles') || {}
    };
    Object.entries(attributes.nodes).forEach(([id, { title: title }])=>attributeNames[id] = title);
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('attributeTitles', attributeNames);
    const nodesToUpdate = nodes.map((node)=>{
        if (!node.id) throw new Error(`No ID for node ${node.label}`);
        const base = {
            ...(0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.group0),
            ...node.attributes
        };
        const color = node.viz?.color ? rgba(node.viz.color) : base.color.background;
        return {
            ...base,
            id: node.id,
            label: node.label,
            x: node.position?.x,
            y: node.position?.y,
            size: node.viz?.size,
            shape: node.viz?.shape,
            color: {
                border: color,
                background: color,
                highlight: {
                    border: color,
                    background: color
                },
                hover: {
                    border: color,
                    background: color
                }
            },
            font: color ? {
                ...base.font,
                color: (0, $7hmfH.rgbIsLight)(color.r, color.g, color.b) ? 'rgb(0,0,0)' : 'rgb(255,255,255)'
            } : base.font
        };
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
    const edgesToUpdate = edges.map((edge)=>{
        if (!edge.id) throw new Error('Missing edge ID');
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.source)) throw new Error(`No node ${edge.source} for edge ${edge.id}`);
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.target)) throw new Error(`No node ${edge.target} for edge ${edge.id}`);
        const base = (0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.edge0);
        const color = edge.viz?.color ? rgba(edge.viz.color) : base.color.color;
        const width = Math.min(20, Math.max(1, edge.weight));
        return {
            ...base,
            id: edge.id,
            from: edge.source,
            to: edge.target,
            width: width,
            color: {
                color: color,
                highlight: color,
                hover: color,
                opacity: 1
            }
        };
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToUpdate);
    // === Helpers ===
    function processAttributes(attributesNode) {
        const result = {
            nodes: {},
            edges: {}
        };
        if (!attributesNode) return result;
        const attributes = Array.isArray(attributesNode) ? attributesNode : [
            attributesNode
        ];
        (attributes || []).forEach(({ class: cls, attribute: attribute = [] })=>{
            attribute.forEach(({ id: id, title: title, name: name, type: type })=>{
                result[cls === 'node' ? 'nodes' : 'edges'][id] = {
                    title: title || name,
                    type: type || 'string'
                };
            });
        });
        return result;
    }
    function processAttributeValues(attvalues) {
        return (Array.isArray(attvalues) ? attvalues : []).reduce((acc, { for: key, value: value })=>{
            if (key !== undefined && value !== undefined) acc[key] = value;
            return acc;
        }, {});
    }
    /* eslint-disable camelcase */ // GEXF format uses snake_case for viz_* properties (e.g. viz_size, viz_color, viz_shape, viz_position, viz_thickness)
    function processVizAttributes(el) {
        const { viz_size: viz_size, viz_color: viz_color, viz_shape: viz_shape } = el;
        const viz = {};
        if (viz_size) viz.size = parseFloat(viz_size.value || viz_size.size);
        if (viz_color) viz.color = {
            r: parseInt(viz_color.r || 0),
            g: parseInt(viz_color.g || 0),
            b: parseInt(viz_color.b || 0),
            a: parseFloat(viz_color.a ?? 1.0)
        };
        if (viz_shape) viz.shape = viz_shape.value;
        return Object.keys(viz).length ? {
            viz: viz
        } : {};
    }
    function processNodePosition({ viz_position: viz_position, x: x, y: y, z: z }) {
        const pos = viz_position ? {
            x: +viz_position.x || 0,
            y: +viz_position.y || 0,
            z: +viz_position.z || 0
        } : x || y || z ? {
            x: +x,
            y: +y,
            z: +z
        } : null;
        return pos ? {
            position: pos
        } : {};
    }
    function processEdgeVizAttributes({ viz_thickness: viz_thickness, viz_color: viz_color, viz_shape: viz_shape }) {
        const viz = {};
        if (viz_thickness) viz.thickness = parseFloat(viz_thickness.value);
        if (viz_color) viz.color = {
            r: parseInt(viz_color.r || 0),
            g: parseInt(viz_color.g || 0),
            b: parseInt(viz_color.b || 0),
            a: parseFloat(viz_color.a ?? 1.0)
        };
        if (viz_shape) viz.shape = viz_shape.value;
        return Object.keys(viz).length ? {
            viz: viz
        } : {};
    }
    /* eslint-enable camelcase */ function rgba({ r: r, g: g, b: b, a: a = 1.0 }) {
        return `rgba(${r},${g},${b},${a})`;
    }
}
/**
 * Parse and load a file exported from Draw.io
 * The file must be in XML format, as exported from Draw.io
 * The file should contain a single mxGraphModel element with mxCell elements for nodes and edges.
 * The nodes should have a label and an mxGeometry element with x, y, width and height attributes.
 * Other node cells are ignored, as are nodes holding images
 * The edges should have a source and target attribute.
 * @param {string} contents
 */ function $c5391cf84cf40afe$var$loadDrawIOfile(contents) {
    const parser = new (0, $26a6c9bf8a5ea073$export$2e2bcd8739ae039)({
        ignoreAttributes: false,
        attributeNamePrefix: ''
    });
    const jsonObj = parser.parse(contents);
    const graph = jsonObj.mxfile?.diagram?.mxGraphModel.root.mxCell;
    if (!graph) throw new Error('Invalid Draw.io format: no graph found');
    const nodes = [];
    const edges = [];
    graph.forEach((cell)=>{
        // skip the root cell
        if (cell.mxGeometry) {
            if (cell.edge) {
                let edge = {
                    ...(0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.base),
                    id: cell.id,
                    from: cell.source,
                    to: cell.target,
                    label: (0, $7hmfH.splitText)((cell.value || '').replace(/<[^>]*>/g, '').replace('&nbsp;', ' ')),
                    grp: 'drawIOEdge'
                };
                if (!cell.source || !cell.target) {
                    console.warn(`Edge ${cell.id} has no source or target, ignoring it`);
                    edge = 'ignore';
                } else if (cell.style) {
                    const style = cell.style.split(';');
                    style.forEach((s)=>{
                        if (s.startsWith('strokeColor')) edge.color.color = (0, $7hmfH.hexToRgba)(s.split('=')[1]);
                        else if (s.startsWith('strokeWidth')) edge.width = parseInt(s.split('=')[1]);
                        else if (s.startsWith('dashed')) edge.dashes = s.split('=')[1] === '1';
                    });
                }
                if (edge !== 'ignore') edges.push(edge);
            } else {
                let node = {
                    ...(0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.base),
                    id: cell.id,
                    label: (0, $7hmfH.splitText)((cell.value || ' ').replace(/<[^>]*>/g, '').replace('&nbsp;', ' ')),
                    x: parseFloat(cell.mxGeometry.x),
                    y: parseFloat(cell.mxGeometry.y),
                    widthConstraint: {
                        minimum: parseFloat(cell.mxGeometry.width)
                    },
                    heightConstraint: {
                        minimum: parseFloat(cell.mxGeometry.height)
                    },
                    grp: 'drawIOnode'
                };
                if (!node.id || node.label.trim() === '') {
                    //ignore nodes with blank labels
                    console.warn(`Ignoring node ${node.id} without an Id or with a blank label`);
                    node = 'ignore';
                } else {
                    if (cell.style) {
                        const style = cell.style.split(';');
                        // default node style is a white box with thin black border
                        node.color.background = 'rgba(255, 255, 255, 1)';
                        node.borderWidth = 1;
                        node.color.border = 'rgba(0, 0, 0, 1)';
                        node.shape = 'box';
                        style.forEach((s)=>{
                            if (s === 'ellipse') {
                                node.shape = 'ellipse';
                                node.heightConstraint = {
                                    minimum: 50
                                };
                            } else if (s === 'text') {
                                node.shape = 'text';
                                node.borderWidth = 0;
                            }
                            if (s.startsWith('fillColor')) node.color.background = (0, $7hmfH.hexToRgba)(s.split('=')[1]);
                            else if (s.startsWith('strokeColor')) node.color.border = (0, $7hmfH.hexToRgba)(s.split('=')[1]);
                            else if (s.startsWith('strokeWidth')) node.borderWidth = parseInt(s.split('=')[1]);
                            else if (s.startsWith('shape')) node.shape = s.split('=')[1];
                            else if (s.startsWith('image')) {
                                // ignore image nodes
                                console.warn(`Ignoring image node ${node.label} (${node.id})`);
                                node = 'ignore';
                            } else if (s.startsWith('fontColor')) node.font.color = (0, $7hmfH.hexToRgba)(s.split('=')[1]);
                            else if (s.startsWith('round')) node.shapeProperties = {
                                borderRadius: parseInt(s.split('=')[1]) ? 6 : 0
                            };
                        });
                    }
                    if (node !== 'ignore') nodes.push(node);
                }
            }
        }
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodes);
    // check all edges are connected to nodes
    edges.forEach((edge)=>{
        if (!edge.id) throw new Error('Missing edge ID');
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.from)) throw new Error(`Missing 'from' factor: ${edge.from} for edge: ${edge.id}`);
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.to)) throw new Error(`Missing 'to' factor: ${edge.to} for edge: ${edge.id}`);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edges);
}
/**
 * Parse and load a Kumu file
 * The file must be in JSON format, as exported from Kumu.
 *
 * @param {string} str - JSON string from Kumu file
 * @returns {void}
 *
 */ function $c5391cf84cf40afe$var$loadKumufile(str) {
    const kumuData = JSON.parse(str);
    const elements = kumuData.elements;
    if (!elements) throw new Error('Invalid Kumu file: no elements found');
    const defaultMap = kumuData.defaultMap;
    const connections = kumuData.connections || [];
    const maps = kumuData.maps;
    const defaultPerspective = maps.find((map)=>map._id === defaultMap).defaultPerspective;
    if (!defaultPerspective) throw new Error('Invalid Kumu file: no default perspective found');
    const perspectives = kumuData.perspectives;
    const attributes = kumuData.attributes || {};
    const nodeMap = new Map();
    const edgeMap = new Map();
    // convert from Kumu element shapes to nearest PRSM factor shapes
    const shapeConversion = {
        circle: 'ellipse',
        rectangle: 'box',
        diamond: 'diamond',
        triangle: 'triangle',
        hexagon: 'hexagon',
        square: 'box',
        pill: 'box',
        pentagon: 'hexagon',
        octagon: 'hexagon'
    };
    // get names of attributes and save them
    let attributeToUseAsNodeStyle = 'Category' // the name of the attribute that will be used to style nodes
    ;
    let attributeToUseAsLinkStyle = 'Relationship impact' // the name of the attribute that will be used to style links
    ;
    if (kumuData.description) {
        attributeToUseAsNodeStyle = /PRSMFactorStyleAttribute\s*=\s['|"](.*)['|"]/i.exec(kumuData.description)?.[1] || attributeToUseAsNodeStyle;
        attributeToUseAsLinkStyle = /PRSMLinkStyleAttribute\s*=\s['|"](.*)['|"]/i.exec(kumuData.description)?.[1] || attributeToUseAsLinkStyle;
    }
    let attributeToUseAsNodeStyleId // the id of the attribute that will be used to style nodes
    ;
    const attributeNames = {
        ...(0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles') || {}
    };
    attributes.forEach((attr)=>{
        if (![
            'Description',
            'Label'
        ].includes(attr.name)) attributeNames[attr._id] = attr.name;
        if (attr.name === attributeToUseAsNodeStyle) {
            attributeToUseAsNodeStyleId = attr._id;
            // use the values as the names of the node styles
            let group = 0;
            for (const styleName of attr.values){
                (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[`group${group}`].groupLabel = styleName;
                (0, $3ee4e83c23551e65$export$675fa328fb4ebccd)(`group${group}`);
                if (group >= 15) break;
                group++;
            }
        }
        if (attr.name === attributeToUseAsLinkStyle) {
            // use the values as the names of the link styles
            let group = 0;
            for (const styleName of attr.values){
                (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[`edge${group}`].groupLabel = styleName;
                (0, $3ee4e83c23551e65$export$e496289367e7ce52)(`edge${group}`);
                if (group >= 9) break;
                group++;
            }
        }
    });
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('attributeTitles', attributeNames);
    // get perspective, edit PRSM styles and apply styles to factors and links
    const perspective = perspectives.find((p)=>p._id === defaultPerspective);
    // translate KUMU CSS style format to an object for easier access
    const pStyles = $c5391cf84cf40afe$var$parseKumuPerspectiveStyle(perspective.style);
    // console.log("Styles:", pStyles)
    /* Use the Perspective element styles to set the PRSM styles
  e.g element["category"="Driver"]
{
  color: #d73027;
  border-colour: black;
  border-width: 10;
}
  will name a PRSM node style "Driver" with a background color of #d73027, 
  a black border and a border width of 10.
  */ const elementStyles = pStyles['element-styles'];
    for (const eStyle of elementStyles)if (eStyle.match?.category) {
        // find the style with the category name
        const style = Object.entries((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes).find((a)=>a[1].groupLabel === eStyle.match.category)[0];
        const styleNode = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[style];
        styleNode.color.background = eStyle.styles.color;
        styleNode.color.border = eStyle.styles['border-color'] || 'black';
        styleNode.borderWidth = eStyle.styles['border-width'] / 10 || 0;
        styleNode.font.color = eStyle.styles['font-color'] || 'rgb(0,0,0)';
        styleNode.shape = shapeConversion[eStyle.styles['shape']] || 'dot';
        (0, $3ee4e83c23551e65$export$675fa328fb4ebccd)(style);
    }
    // get all elements
    elements.forEach((element)=>{
        const label = element?.attributes?.label;
        const note = element?.attributes?.description || '';
        const attributes = {};
        for(const attr in attributeNames){
            const value = element?.attributes[attributeNames[attr].toLowerCase()];
            // flatten attribute value from an array to a set of strings
            attributes[attr] = Array.isArray(value) ? value.join(' | ') : value;
        }
        // skip elements with no label
        if (label) nodeMap.set(element._id, {
            ...(0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.base),
            id: element._id,
            label: (0, $7hmfH.splitText)((label || ' ').replace(/<[^>]*>/g, '').replace('&nbsp;', ' ')),
            note: note ? (0, $9aa9f05e55106570$export$2e2bcd8739ae039)(note) : '',
            shape: 'circle',
            shapeProperties: {
                borderRadius: 0
            },
            grp: 'kumuGroup',
            ...attributes
        });
    });
    const ignoredCategories = pStyles['@settings'].ignore;
    const defaultFontSize = pStyles['@settings']['font-size'] || 250;
    const defaultElementSize = pStyles['@settings']['element-size'] || 100;
    nodeMap.forEach((node, id)=>{
        const category = node[attributeToUseAsNodeStyleId];
        let group;
        for(const style in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes)if ((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[style].groupLabel === category) group = style;
        if (group) {
            node = (0, $7hmfH.deepMerge)(node, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[group], {
                grp: group
            });
            // if the node is in an ignored category, hide it
            const hideNode = ignoredCategories && ignoredCategories.includes(category);
            if (hideNode) node = (0, $7hmfH.setNodeHidden)(node, hideNode);
        }
        nodeMap.set(id, node);
    });
    // get all links
    // first, amend the styles for the links
    const edgeStyles = pStyles['connection-styles'];
    for (const lStyle of edgeStyles)if (lStyle.match[attributeToUseAsLinkStyle]) {
        // find the style with the category name
        const style = Object.entries((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges).find((a)=>a[1].groupLabel === lStyle.match[attributeToUseAsLinkStyle])[0];
        const styleEdge = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[style];
        styleEdge.color.color = lStyle.styles.color;
        (0, $3ee4e83c23551e65$export$e496289367e7ce52)(style);
    }
    connections.forEach((connection)=>{
        const label = connection?.attributes?.label || '';
        const note = connection?.attributes?.description || '';
        edgeMap.set(connection._id, {
            ...(0, $7hmfH.deepCopy)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.base),
            id: connection._id,
            from: connection.from,
            to: connection.to,
            label: (0, $7hmfH.splitText)((label || '').replace(/<[^>]*>/g, '').replace('&nbsp;', ' ')),
            note: note ? (0, $9aa9f05e55106570$export$2e2bcd8739ae039)(note) : '',
            groupLabel: connection?.attributes[attributeToUseAsLinkStyle.toLowerCase()],
            grp: 'kumuEdge'
        });
    });
    edgeMap.forEach((edge, id)=>{
        let group;
        for(const style in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges)if ((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[style].groupLabel === edge.groupLabel) {
            group = style;
            break;
        }
        if (group) {
            edge = (0, $7hmfH.deepMerge)(edge, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[group], {
                grp: group
            });
            edgeMap.set(id, edge);
        }
    });
    const map = maps.find((m)=>m._id === defaultMap);
    if (map.description) {
        const description = (0, $9aa9f05e55106570$export$2e2bcd8739ae039)(map.description);
        (0, $5bc812abaa5f432b$export$807f940a96777041).set('mapDescription', description);
        (0, $5bc812abaa5f432b$export$cff30a8f7435ec50)({
            text: description
        });
    }
    if (map.name) (0, $5bc812abaa5f432b$export$807f940a96777041).set('mapTitle', (0, $5bc812abaa5f432b$export$f229389f565c6b3f)(map.name));
    if (map.elements) map.elements.forEach((element)=>{
        const node = nodeMap.get(element.element);
        if (node) {
            const color = element.style.color;
            if (color) {
                node.color = {
                    background: color,
                    border: color,
                    hover: {
                        background: color,
                        border: color
                    },
                    highlight: {
                        background: color,
                        border: color
                    }
                };
                if (node.color.background === 'transparent' || node.color.background === 'rgba(0,0,0,0)') node.shape = 'text';
            }
            node.font.size = defaultFontSize;
            if (element.style.fontColor) node.font.color = element.style.fontColor;
            if (element.style.fontSize) node.font.size = element.style.fontSize;
            if (element.style.fontFace) node.font.face = element.style.fontFace;
            if (element.style.shape) node.shape = shapeConversion[element.style.shape];
            if (element.style.shape === 'pill') node.shapeProperties = {
                borderRadius: 20
            };
            const size = element.style.size || defaultElementSize;
            node.size = size;
            if (element.position) {
                node.x = element?.position?.x;
                node.y = element?.position?.y;
            }
        }
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(Array.from(nodeMap.values()));
    if (map.connections) {
        map.connections.forEach((connection)=>{
            const edge = edgeMap.get(connection.connection);
            if (connection.style.color) {
                const color = connection.style.color;
                edge.color = {
                    color: color,
                    hover: color,
                    highlight: color
                };
            }
            edge.font = {
                color: connection.style.fontColor || 'rgb(0, 0, 0)',
                size: connection.style.fontSize || defaultFontSize,
                face: connection.style.fontFace || 'Oxygen'
            };
            if ((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.from).nodeHidden || (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.to).nodeHidden) (0, $7hmfH.setEdgeHidden)(edge, true);
            edgeMap.set(connection._id, edge);
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(Array.from(edgeMap.values()));
    }
}
function $c5391cf84cf40afe$var$parseKumuPerspectiveStyle(input) {
    const result = {
        '@view': {},
        '@controls': {},
        '@settings': {},
        '#background': {},
        'element-styles': [],
        'connection-styles': []
    };
    // Clean up input
    const clean = input.replace(/\\n/g, '\n').replace(/\\t/g, '').replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*$/gm, '$1').trim();
    // Utility to parse blocks like @view 'X' { @settings { ... } }
    function parseBlock(label, blockString) {
        const settingsMatch = blockString.match(/@settings\s*\{([^}]*)\}/s);
        if (!settingsMatch) return {};
        const settingsContent = settingsMatch[1].trim();
        return parseKeyValueBlock(settingsContent);
    }
    // Utility to parse key-value pairs (semicolon-separated)
    function parseKeyValueBlock(text) {
        const obj = {};
        const lines = text.split(/;\s*\n?/).filter(Boolean);
        for (const line of lines){
            let [key, value] = line.split(/:\s+/);
            if (!key || value === undefined) continue;
            key = key.trim();
            obj[key] = cleanValue(value);
        }
        return obj;
    }
    // Utility to clean and convert values
    function cleanValue(val) {
        if (!val) return null;
        val = val.trim().replace(/;/g, '').replace(/^"|"$/g, '');
        if (val === 'True') return true;
        if (val === 'False') return false;
        if (!isNaN(val)) return Number(val);
        if (val.includes(',')) return val.split(',').map((v)=>cleanValue(v.trim()));
        return val;
    }
    // Parse all @view blocks
    const viewRegex = /@view\s+'([^']+)'\s*\{([^}]*?\})/gs;
    let match;
    while((match = viewRegex.exec(clean)) !== null){
        const [, name, body] = match;
        result['@view'][name] = {
            '@settings': parseBlock(name, body)
        };
    }
    // Parse @settings (global)
    const [, , globalSettingsMatch] = clean.match(/\}\s*(@settings\s*\{([^}]+)\})/s);
    if (globalSettingsMatch) result['@settings'] = parseKeyValueBlock(globalSettingsMatch);
    // Parse #background
    const bgMatch = clean.match(/#background\s*\{([^}]+)\}/s);
    if (bgMatch) result['#background'] = parseKeyValueBlock(bgMatch[1]);
    // Parse element styles
    const elementRegex = /element\["([^"]+)"="?([^"\]]*)"?\]\s*\{([^}]+)\}/gs;
    while((match = elementRegex.exec(clean)) !== null){
        const [, key, val, styleBody] = match;
        const styleObj = parseKeyValueBlock(styleBody);
        result['element-styles'].push({
            match: {
                [key]: val
            },
            styles: styleObj
        });
    }
    // Parse connection styles
    const connRegex = /connection\["([^"]+)"="?([^"\]]*)"?\]\s*\{([^}]+)\}/gs;
    while((match = connRegex.exec(clean)) !== null){
        const [, key, val, styleBody] = match;
        const styleObj = parseKeyValueBlock(styleBody);
        result['connection-styles'].push({
            match: {
                [key]: val
            },
            styles: styleObj
        });
    }
    // Parse controls
    function parseToObject(input) {
        const match = input.match(/@controls\s*{([\s\S]*)}$/);
        if (!match) return null // Not a valid @controls block
        ;
        const content = `{${match[1]}` // restore root-level opening brace
        ;
        const tokens = content.match(/([{}])|("[^"]*"|\w[\w-]*)\s*:?\s*("[^"]*"|[^;{}]+)?;?/g);
        if (!tokens) return {};
        let index = 0;
        function parseBlock() {
            const result = {};
            while(index < tokens.length){
                const token = tokens[index++].trim();
                if (token === '}') return result;
                else if (token === '{') continue;
                const nextToken = tokens[index] ? tokens[index].trim() : null;
                if (nextToken === '{') {
                    index++;
                    const child = parseBlock();
                    if (result[token]) {
                        if (Array.isArray(result[token])) result[token].push(child);
                        else result[token] = [
                            result[token],
                            child
                        ];
                    } else result[token] = child;
                } else if (token.includes(':')) {
                    const [key, val] = token.split(/\s*:\s*/);
                    result[key] = cleanValue(val);
                } else if (nextToken && nextToken.includes(':')) {
                    const [, val] = nextToken.split(/\s*:\s*/);
                    index++;
                    result[token] = cleanValue(val);
                }
            }
            return result;
        }
        index++ // Skip initial {
        ;
        return parseBlock();
    }
    result['@controls'] = parseToObject(clean);
    return result;
}
/**
 * Parse and load a GML file
 * @param {string} gml
 */ function $c5391cf84cf40afe$var$loadGML(gml) {
    if (gml.search('graph') < 0) throw new Error('invalid GML format');
    const tokens = gml.match(/"[^"]+"|[\w]+|\[|\]/g);
    let node;
    let edge;
    let edgeId = 0;
    let tok = tokens.shift();
    while(tok){
        switch(tok){
            case 'graph':
                break;
            case 'node':
                tokens.shift() // [
                ;
                node = {};
                tok = tokens.shift();
                while(tok !== ']'){
                    switch(tok){
                        case 'id':
                            node.id = tokens.shift().toString();
                            break;
                        case 'label':
                            node.label = (0, $7hmfH.splitText)(tokens.shift().replace(/"/g, ''), $c5391cf84cf40afe$var$NODEWIDTH);
                            break;
                        case 'color':
                        case 'colour':
                            node.color = {};
                            node.color.background = tokens.shift().replace(/"/g, '');
                            break;
                        case '[':
                            while(tok !== ']')tok = tokens.shift();
                            break;
                        default:
                            break;
                    }
                    tok = tokens.shift() // ]
                    ;
                }
                if (node.label === undefined) node.label = node.id;
                (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(node);
                break;
            case 'edge':
                tokens.shift() // [
                ;
                edge = {};
                tok = tokens.shift();
                while(tok !== ']'){
                    switch(tok){
                        case 'id':
                            edge.id = tokens.shift().toString();
                            break;
                        case 'source':
                            edge.from = tokens.shift().toString();
                            break;
                        case 'target':
                            edge.to = tokens.shift().toString();
                            break;
                        case 'label':
                            edge.label = tokens.shift().replace(/"/g, '');
                            break;
                        case 'color':
                        case 'colour':
                            edge.color = tokens.shift().replace(/"/g, '');
                            break;
                        case '[':
                            while(tok !== ']')tok = tokens.shift();
                            break;
                        default:
                            break;
                    }
                    tok = tokens.shift() // ]
                    ;
                }
                if (edge.id === undefined) edge.id = (edgeId++).toString();
                (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(edge);
                break;
            default:
                break;
        }
        tok = tokens.shift();
    }
}
/**
 * Read a comma separated values file consisting of 'From' label and 'to' label, on each row,
   with a header row (ignored) 
  optional, cols 3 and 4 can include the groups (styles) of the from and to nodes,
  column 5 can include the style of the edge.  All these must be integers between 1 and 9
 * @param {string} csv 
 */ function $c5391cf84cf40afe$var$loadCSV(csv) {
    const lines = csv.split(/\r\n|\n/);
    const labels = new Map();
    const links = [];
    for(let i = 1; i < lines.length; i++){
        if (lines[i].length <= 2) continue; // empty line
        const line = splitCSVrow(lines[i]);
        const from = node(line[0], line[2], i);
        const to = node(line[1], line[3], i);
        let grp = line[4];
        if (grp) grp = 'edge' + (parseInt(grp.trim()) - 1);
        links.push({
            id: (0, $7hmfH.uuidv4)(),
            from: from.id,
            to: to.id,
            grp: grp
        });
    }
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(Array.from(labels.values()));
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(links);
    /**
   * Parse a CSV row, accounting for commas inside quotes
   * @param {string} row
   * @returns array of fields
   */ function splitCSVrow(row) {
        let insideQuote = false;
        const entries = [];
        let entry = [];
        row.split('').forEach(function(character) {
            if (character === '"') insideQuote = !insideQuote;
            else if (character === ',' && !insideQuote) {
                entries.push(entry.join(''));
                entry = [];
            } else entry.push(character);
        });
        entries.push(entry.join(''));
        return entries;
    }
    /**
   * retrieves or creates a (new) node object with given label and style,
   * @param {string} label
   * @param {number} grp
   * @param {number} lineNo the file line where this node was read from
   * @returns the node object
   */ function node(label, grp, lineNo) {
        label = label.trim();
        if (grp) {
            const styleNo = parseInt(grp);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > 9) throw new Error(`Line ${lineNo}: Columns 3 and 4 must be values between 1 and 9 or blank (found ${grp})`);
            grp = 'group' + (styleNo - 1);
        }
        if (labels.get(label) === undefined) labels.set(label, {
            id: (0, $7hmfH.uuidv4)(),
            label: label.toString(),
            grp: grp
        });
        return labels.get(label);
    }
}
/**
 * Reads map data from an Excel file.  The file must have two spreadsheets in the workbook, named Factors and Links
 * In the spreadsheet, there must be a header row, and columns for (minimally) Label (and for links, also From and To,
 * with entries with the exact same text as the Labels in the Factor sheet.  There may be a Style column, which is used
 * to specify the style for the Factor or Link (numbered from 1 to 9).  There may be a Description (or note or Note)
 * column, the contents of which are treated as a Factor or Link note.  Any other columns are treated as holding values
 * for additional Attributes.
 *
 * Uses https://sheetjs.com/
 *
 * @param {*} contents
 * @returns nodes and edges data
 */ function $c5391cf84cf40afe$var$loadExcelfile(contents) {
    const workbook = (0, $be857304663aed78$export$aafa59e2e03f2942)(contents);
    const factorsSS = workbook.Sheets['Factors'];
    if (!factorsSS) throw new Error('Sheet named Factors not found in Workbook');
    const linksSS = workbook.Sheets['Links'];
    if (!linksSS) throw new Error('Sheet named Links not found in Workbook');
    // attributeNames is an object with properties attributeField: attributeTitle
    const attributeNames = {};
    /* 
   Transform data about factors into an array of objects, with properties named after the column headings
   (with first letter lower cased if necessary) and values from that row's cells.
   add a GUID to the object,  change 'Style' property to 'grp'
   Style is a style number
   Put value of Description or Notes property into notes
   Check that any other property names are not in the list of known attribute names; if so add that property name to the attribute name list 
   Place the factor either at the given x and y coordinates or at some random location
   */ // convert data from Factors sheet into an array of objects with properties starting with lower case letters
    const factors = (0, $be857304663aed78$export$eab97d15b1788b8d).sheet_to_json(factorsSS).map((f)=>lowerInitialLetterOfProps(f));
    const maxIndexOfFactorStyles = Object.keys((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes).length - 1;
    factors.forEach((f)=>{
        f.id = (0, $7hmfH.uuidv4)();
        if (f.style) {
            const styleNo = parseInt(f.style);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > maxIndexOfFactorStyles) throw new Error(`Factors - Line ${f.__rowNum__}: Style must be a number between 1 and ${maxIndexOfFactorStyles} or blank (found ${f.style})`);
            f.grp = 'group' + (styleNo - 1);
            if (f.groupLabel) {
                const styleDataSet = Array.from(document.getElementsByClassName('sampleNode'))[styleNo - 1].dataSet;
                const styleNode = styleDataSet.get('1');
                styleNode.label = f.groupLabel;
                styleNode.groupLabel = f.groupLabel;
                styleDataSet.update(styleNode);
                (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[f.grp].groupLabel = f.groupLabel;
            }
            delete f.style;
        }
        if (!f.label) throw new Error(`Factors - Line ${f.__rowNum__}: Factor does not have a Label`);
        const note = f.description || f.note;
        if (note) {
            f.note = {
                ops: [
                    {
                        insert: note + '\n'
                    }
                ]
            };
            delete f.description;
        }
        if (f.creator) {
            f.created = {
                time: f.createdTime ? Date.parse(f.createdTime) : Date.now(),
                user: f.creator
            };
            delete f.createdTime;
        }
        if (f.modifier) {
            f.modified = {
                time: f.modifiedTime ? Date.parse(f.modifiedTime) : Date.now(),
                user: f.modifier
            };
            delete f.modifiedTime;
        }
        // filter out known properties, leaving the rest to become attributes
        Object.keys(f).filter((k)=>![
                'id',
                'grp',
                'label',
                'groupLabel',
                'shape',
                'note',
                'created',
                'createdTime',
                'creator',
                'modified',
                'modifiedTime',
                'modifier',
                'x',
                'y',
                '__rowNum__'
            ].includes(k)).forEach((k)=>{
            let attributeField = Object.keys(attributeNames).find((prop)=>attributeNames[prop] === k);
            if (!attributeField) {
                // not found, so add
                attributeField = 'att' + (Object.keys(attributeNames).length + 1);
                attributeNames[attributeField] = k;
            }
            f[attributeField] = f[k];
            delete f[k];
        });
        f.x = parseInt(f.x);
        if (!f.x || isNaN(f.x)) f.x = Math.random() * 500;
        f.y = parseInt(f.y);
        if (!f.y || isNaN(f.y)) f.y = Math.random() * 500;
    });
    /* for each row of links
  add a GUID
  look up from and to in factor objects and replace with their ids
  add other attributes as for factors */ const links = (0, $be857304663aed78$export$eab97d15b1788b8d).sheet_to_json(linksSS).map((l)=>lowerInitialLetterOfProps(l));
    links.forEach((l)=>{
        l.id = (0, $7hmfH.uuidv4)();
        if (l.style) {
            const styleNo = parseInt(l.style);
            if (isNaN(styleNo) || styleNo < 1 || styleNo > 9) throw new Error(`Links - Line ${l.__rowNum__}: Style must be a number between 1 and 9, a style name, or blank (found ${l.style})`);
            l.grp = 'edge' + (styleNo - 1);
            if (l.groupLabel) {
                const styleDataSet = Array.from(document.getElementsByClassName('sampleLink'))[styleNo - 1].dataSet;
                const styleEdge = styleDataSet.get('1');
                styleEdge.label = l.groupLabel;
                styleEdge.groupLabel = l.groupLabel;
                styleDataSet.update(styleEdge);
                (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[l.grp].groupLabel = l.groupLabel;
            }
            delete l.style;
        }
        if (l.creator) {
            l.created = {
                time: l.createdTime ? Date.parse(l.createdTime) : Date.now(),
                user: l.creator
            };
            delete l.createdTime;
        }
        if (l.modifier) {
            l.modified = {
                time: l.modifiedTime ? Date.parse(l.modifiedTime) : Date.now(),
                user: l.modifier
            };
            delete l.modifiedTime;
        }
        const fromFactor = factors.find((factor)=>factor.label === l.from);
        if (fromFactor) l.from = fromFactor.id;
        else throw new Error(`Links - Line ${l.__rowNum__}: From factor (${l.from}) not found for link`);
        const toFactor = factors.find((factor)=>factor.label === l.to);
        if (toFactor) l.to = toFactor.id;
        else throw new Error(`Links - Line ${l.__rowNum__}: To factor (${l.to}) not found for link`);
        const note = l.description || l.note;
        if (note) {
            l.note = {
                ops: [
                    {
                        insert: note + '\n'
                    }
                ]
            };
            delete l.description;
        }
        Object.keys(l).filter((k)=>![
                'id',
                'from',
                'to',
                'grp',
                'groupLabel',
                'creator',
                'created',
                'label',
                'modified',
                'modifier',
                'note',
                '__rowNum__'
            ].includes(k)).forEach((k)=>{
            let attributeField = Object.keys(attributeNames).find((prop)=>attributeNames[prop] === k);
            if (!attributeField) {
                // not found, so add
                attributeField = 'att' + (Object.keys(attributeNames).length + 1);
                attributeNames[attributeField] = k;
            }
            l[attributeField] = l[k];
            delete l[k];
        });
    });
    factors.forEach((f)=>{
        f.label = (0, $7hmfH.splitText)(f.label, $c5391cf84cf40afe$var$NODEWIDTH);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.add(factors);
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.add(links);
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('attributeTitles', attributeNames);
    /**
   * ensure the initial letter of each property of obj is lower case
   * @param {object} obj
   * @returns copy of object
   */ function lowerInitialLetterOfProps(obj) {
        return Object.fromEntries(Object.entries(obj).map(([k, v])=>[
                (0, $7hmfH.lowerFirstLetter)(k),
                v
            ]));
    }
}
function $c5391cf84cf40afe$export$37a761894e599695() {
    (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).storePositions();
    const attributes = (0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles') || [];
    const nodeFields = [
        'id',
        'label',
        'note',
        'grp',
        'x',
        'y',
        'color',
        'font',
        'borderWidth',
        'shape',
        'shapeProperties',
        'margin',
        'thumbUp',
        'thumbDown',
        'created',
        'modified'
    ];
    let json = JSON.stringify({
        saved: new Date(Date.now()).toLocaleString(),
        version: $fmvtn.version,
        room: $5bc812abaa5f432b$export$f9d3fff8c23da278,
        mapTitle: (0, $7hmfH.elem)('maptitle').innerText,
        lastNodeSample: $5bc812abaa5f432b$export$794b27baf354ffba,
        lastLinkSample: $5bc812abaa5f432b$export$a01f2d76756b77a5,
        // clustering, and up/down, paths between and x links away settings are not saved (and hidden property is not saved)
        buttons: $c5391cf84cf40afe$var$getButtonStatus(),
        attributeTitles: (0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles'),
        styles: $2044cce2dd0aa04b$export$9dd6ff9ea0189349,
        nodes: (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
            fields: [
                ...nodeFields,
                ...Object.keys(attributes)
            ],
            filter: (n)=>!n.isCluster
        }),
        edges: (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get({
            fields: [
                'id',
                'arrows',
                'color',
                'created',
                'dashes',
                'font',
                'from',
                'grp',
                'label',
                'modified',
                'note',
                'smooth',
                'to',
                'width'
            ],
            filter: (e)=>!e.isClusterEdge
        }),
        background: JSON.stringify((0, $5bc812abaa5f432b$export$da7062de5ac36f9c).toJSON()),
        history: (0, $5bc812abaa5f432b$export$d920e34eaf2b21cb).map((s)=>{
            s.state = null;
            return s;
        }),
        description: (0, $5bc812abaa5f432b$export$807f940a96777041).get('mapDescription')
    }, null, '\t');
    if (!/plain/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) json = (0, $93qLg.compressToUTF16)(json);
    $c5391cf84cf40afe$var$saveStr(json, 'prsm');
    (0, $5bc812abaa5f432b$export$38a5743670a777eb)();
}
/**
 * return an object with the current Network panel setting for saving
 * settings for link radius and up/down stream are not saved
 * @return an object with the Network panel settings
 */ function $c5391cf84cf40afe$var$getButtonStatus() {
    return {
        snapToGrid: (0, $7hmfH.elem)('snaptogridswitch').checked,
        curve: (0, $7hmfH.elem)('curveSelect').value,
        background: (0, $7hmfH.elem)('netBackColorWell').style.backgroundColor,
        legend: (0, $7hmfH.elem)('showLegendSwitch').checked,
        sizing: (0, $7hmfH.elem)('sizing').value
    };
}
/**
 * Set the Network panel buttons to their values loaded from a file
 * @param {Object} settings
 */ function $c5391cf84cf40afe$var$setButtonStatus(settings) {
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('snapToGrid', settings.snapToGrid);
    (0, $5bc812abaa5f432b$export$95ff17332160327a)(settings.snapToGrid);
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('curve', settings.curve);
    (0, $5bc812abaa5f432b$export$264d5714f8b2c7d8)(settings.curve);
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('background', settings.background || '#ffffff');
    (0, $5bc812abaa5f432b$export$2e65e79124cca55d)((0, $5bc812abaa5f432b$export$807f940a96777041).get('background'));
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('legend', settings.legend);
    (0, $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9)(settings.legend);
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('sizing', settings.sizing);
    // sizing done after the nodes have been created: sizing(settings.sizing)
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('radius', {
        radiusSetting: 'All',
        selected: []
    });
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('stream', {
        streamSetting: 'All',
        selected: []
    });
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('paths', {
        pathsSetting: 'All',
        selected: []
    });
    (0, $5bc812abaa5f432b$export$807f940a96777041).set('cluster', 'none');
    (0, $5bc812abaa5f432b$export$8b2b949f916968c1)('none');
}
/**
 * Save the string to a local file
 * @param {string} str file contents
 * @param {string} extn file extension
 *
 * Browser will only ask for name and location of the file to be saved if
 * it has a user setting to do so.  Otherwise, it is saved at a default
 * download location with a default name.
 */ function $c5391cf84cf40afe$var$saveStr(str, extn) {
    $c5391cf84cf40afe$export$20ca267bc6805c64(extn);
    const blob = new Blob([
        str
    ], {
        type: 'text/plain;charset=utf-8'
    });
    (0, $03c9b366059f6377$exports.saveAs)(blob, $c5391cf84cf40afe$var$lastFileName, {
        autoBom: true
    });
}
/**
 * save the map as a PNG image file
 */ const $c5391cf84cf40afe$var$maxScale = 5 // max upscaling for image (avoids blowing up very small networks excessively)
;
function $c5391cf84cf40afe$export$f0cc1c631fa5bb45() {
    document.body.style.cursor = 'wait';
    $c5391cf84cf40afe$export$20ca267bc6805c64('png');
    // create a very large canvas, so we can download at high resolution
    (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).storePositions();
    // first, create a large offscreen div to hold a copy of the network at the required width
    const bigWidth = 8192 / window.devicePixelRatio // half the number of pixels in the image file (also half the height, as the image is square)
    ;
    const bigMargin = 256 / window.devicePixelRatio // white space around network so not too close to printable edge
    ;
    const bigNetDiv = document.createElement('div');
    bigNetDiv.id = 'big-net-pane';
    bigNetDiv.style.position = 'absolute';
    bigNetDiv.style.top = '-9999px';
    bigNetDiv.style.left = '-9999px';
    bigNetDiv.style.width = `${bigWidth}px`;
    bigNetDiv.style.height = `${bigWidth}px`;
    (0, $7hmfH.elem)('main').appendChild(bigNetDiv);
    // create an offscreen canvas of the same size to apply the background to
    const bigBackgroundCanvas = new OffscreenCanvas(bigWidth, bigWidth);
    bigBackgroundCanvas.id = 'big-background-canvas';
    const bigFabricCanvas = new (0, $9a54cbcfc1af41ba$export$ad01921fb0b1386e)('big-background-canvas', {
        width: bigWidth,
        height: bigWidth
    });
    // make a network with the same nodes and links as the original map
    const bigNetwork = new (0, $8L2sr.Network)(bigNetDiv, (0, $5bc812abaa5f432b$export$4051a07651545597), {
        physics: {
            enabled: false
        },
        edges: {
            smooth: {
                enabled: (0, $7hmfH.elem)('curveSelect').value === 'Curved',
                type: 'cubicBezier'
            }
        }
    });
    bigNetwork.on('afterDrawing', async (bigNetContext)=>{
        // copy the background objects to the big fabric canvas
        await bigFabricCanvas.loadFromJSON(JSON.stringify((0, $95c555713171f487$export$67ea982130081db)));
        // adjust the fabric canvas scale and center to match the big network and match the background colour
        bigFabricCanvas.setZoom(bigNetwork.getScale());
        const fcCenter = bigFabricCanvas.getVpCenter();
        bigFabricCanvas.relativePan({
            x: bigNetwork.getScale() * (fcCenter.x - center.x),
            y: bigNetwork.getScale() * (fcCenter.y - center.y)
        });
        bigFabricCanvas.set('backgroundColor', (0, $7hmfH.elem)('underlay').style.backgroundColor || 'rgb(255, 255, 255)');
        bigFabricCanvas.requestRenderAll();
        // create an image version of the background and copy it onto the big network canvas
        const bigBackgroundImage = document.createElement('img');
        bigBackgroundImage.onload = function() {
            bigNetContext.globalCompositeOperation = 'destination-over';
            bigNetContext.drawImage(bigBackgroundImage, 0, 0, bigWidth, bigWidth);
            // save the canvas to a file
            bigNetContext.canvas.toBlob((blob)=>{
                if (!blob) {
                    (0, $7hmfH.alertMsg)('Image too large to export', 'error');
                    document.body.style.cursor = 'default';
                    return;
                }
                (0, $03c9b366059f6377$exports.saveAs)(blob, $c5391cf84cf40afe$var$lastFileName);
                document.body.style.cursor = 'default';
            });
            // clean up
            bigNetwork.destroy();
            bigNetDiv.remove();
            bigFabricCanvas.dispose();
        };
        bigBackgroundImage.src = bigFabricCanvas.toDataURL();
    });
    const box = mapBoundingBox((0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4), (0, $95c555713171f487$export$67ea982130081db), (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getSelectedNodes());
    let scale = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getScale() * Math.min((bigWidth - bigMargin) / (box.right - box.left), (bigWidth - bigMargin) / (box.bottom - box.top));
    if (scale > $c5391cf84cf40afe$var$maxScale) scale = $c5391cf84cf40afe$var$maxScale;
    const center = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).DOMtoCanvas({
        x: 0.5 * (box.right + box.left),
        y: 0.5 * (box.bottom + box.top)
    });
    bigNetwork.moveTo({
        scale: scale,
        position: center
    });
    /**
   * Get a bounding box for everything on the map (the nodes and the background objects)
   * @param {object} ntwk the map on which the nodes are placed
   * @param {array} selectedNodes Ids of selected nodes, if any
   * @returns box as an object, with dimensions in DOM coords
   */ function mapBoundingBox(ntwk, fabCanvas, selectedNodes = []) {
        let top = Infinity;
        let bottom = -Infinity;
        let left = Infinity;
        let right = -Infinity;
        // use all nodes if none selected
        if (selectedNodes.length === 0) selectedNodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.map((n)=>n.id);
        selectedNodes.forEach((nodeId)=>{
            const canvasBB = ntwk.getBoundingBox(nodeId);
            const tl = ntwk.canvasToDOM({
                x: canvasBB.left,
                y: canvasBB.top
            });
            const br = ntwk.canvasToDOM({
                x: canvasBB.right,
                y: canvasBB.bottom
            });
            if (left > tl.x) left = tl.x;
            if (right < br.x) right = br.x;
            if (top > tl.y) top = tl.y;
            if (bottom < br.y) bottom = br.y;
        });
        // only include background objects if no nodes are selected
        if (selectedNodes.length === 0) fabCanvas.forEachObject((obj)=>{
            const boundingBox = obj.getBoundingRect();
            console.log(obj, boundingBox);
            if (left > boundingBox.left) left = boundingBox.left;
            if (right < boundingBox.left + boundingBox.width) right = boundingBox.left + boundingBox.width;
            if (top > boundingBox.top) top = boundingBox.top;
            if (bottom < boundingBox.top + boundingBox.height) bottom = boundingBox.top + boundingBox.height;
        });
        if (left === Infinity) top = bottom = left = right = 0;
        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom
        };
    }
}

async function $c5391cf84cf40afe$export$83b54ab4d55d8ebe() {
    let delta = {
        ops: [
            {
                insert: '\n'
            }
        ]
    };
    // start with the title of the map if there is one
    const title = (0, $7hmfH.elem)('maptitle').innerText;
    if (title !== 'Untitled map') delta = {
        ops: [
            {
                insert: title
            },
            {
                attributes: {
                    header: 1
                },
                insert: '\n'
            }
        ]
    };
    // get contents of map note if there is one
    if ((0, $5bc812abaa5f432b$export$807f940a96777041).get('mapDescription')) delta.ops = delta.ops.concat([
        {
            insert: 'Description of the map'
        },
        {
            attributes: {
                header: 2
            },
            insert: '\n'
        }
    ], (0, $5bc812abaa5f432b$export$807f940a96777041).get('mapDescription').text.ops);
    // add notes for factors
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().toSorted((a, b)=>a.label.localeCompare(b.label)).forEach((n)=>{
        delta.ops = delta.ops.concat([
            {
                insert: `Factor: ${(0, $7hmfH.stripNL)(n.label)}`
            },
            {
                attributes: {
                    header: 2
                },
                insert: '\n'
            }
        ], n.note ? n.note.ops : [
            {
                insert: '[No note]\n'
            }
        ]);
    });
    // add notes for links
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.forEach((e)=>{
        const heading = `Link from '${(0, $7hmfH.stripNL)((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.from).label)}' to '${(0, $7hmfH.stripNL)((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.to).label)}'`;
        delta.ops = delta.ops.concat([
            {
                insert: heading
            },
            {
                attributes: {
                    header: 2
                },
                insert: '\n'
            }
        ]);
        delta.ops = delta.ops.concat(e.note ? e.note.ops : [
            {
                insert: '[No note]\n'
            }
        ]);
    });
    // save the delta as a Word file
    const quillToWordConfig = {
        exportAs: 'blob',
        paragraphStyles: {
            normal: {
                paragraph: {
                    spacing: {
                        line: 240
                    }
                }
            }
        }
    };
    const ql = await (parcelRequire("dKU2C"));
    const docAsBlob = await ql.generateWord(delta, quillToWordConfig);
    $c5391cf84cf40afe$export$20ca267bc6805c64('docx');
    (0, $03c9b366059f6377$exports.saveAs)(docAsBlob, $c5391cf84cf40afe$var$lastFileName);
}
function $c5391cf84cf40afe$export$20ca267bc6805c64(extn = 'prsm') {
    const title = (0, $7hmfH.elem)('maptitle').innerText;
    if (title === 'Untitled map') $c5391cf84cf40afe$var$lastFileName = 'network';
    else $c5391cf84cf40afe$var$lastFileName = title.replace(/\s+/g, '').replaceAll('.', '_').toLowerCase();
    $c5391cf84cf40afe$var$lastFileName += '.' + extn;
}
function $c5391cf84cf40afe$export$5803f461b1d4777f() {
    // set up Quill note conversion
    const dummyDiv = document.createElement('div');
    dummyDiv.id = 'dummy-div';
    dummyDiv.style.display = 'none';
    (0, $5bc812abaa5f432b$export$34e0f9847d4c02dd).appendChild(dummyDiv);
    const qed = new (0, $lvw85.default)('#dummy-div');
    // create workbook
    const workbook = (0, $be857304663aed78$export$eab97d15b1788b8d).book_new();
    // Factors
    let rows = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().filter((n)=>!n.isCluster).map((n)=>{
        if (n.created) {
            n.creator = n.created.user;
            n.createdTime = new Date(n.created.time).toISOString();
        }
        if (n.modified) {
            n.modifier = n.modified.user;
            n.modifiedTime = new Date(n.modified.time).toISOString();
        }
        n.style = parseInt(n.grp.substring(5)) + 1;
        if (n.note) n.Note = quillToText(n.note);
        // don't save any of the listed properties
        return omit(n, [
            'bc',
            'borderWidth',
            'borderWidthSelected',
            'color',
            'created',
            'fixed',
            'font',
            'grp',
            'hidden',
            'id',
            'clusteredIn',
            'level',
            'labelHighlightBold',
            'locked',
            'margin',
            'modified',
            'nodeHidden',
            'opacity',
            'oldFont',
            'oldFontColor',
            'oldLabel',
            'note',
            'scaling',
            'shadow',
            'shapeProperties',
            'size',
            'heightConstraint',
            'val',
            'value',
            'wasFixed',
            'widthConstraint'
        ]);
    });
    const factorWorksheet = (0, $be857304663aed78$export$eab97d15b1788b8d).json_to_sheet(rows);
    (0, $be857304663aed78$export$eab97d15b1788b8d).book_append_sheet(workbook, factorWorksheet, 'Factors');
    // Links
    const edges = (0, $7hmfH.deepCopy)((0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().filter((e)=>!e.isClusterEdge));
    rows = edges.map((e)=>{
        if (e.created) {
            e.creator = e.created.user;
            e.createdTime = new Date(e.created.time).toISOString();
        }
        if (e.modified) {
            e.modifier = e.modified.user;
            e.modifiedTime = new Date(e.modified.time).toISOString();
        }
        e.style = parseInt(e.grp.substring(4)) + 1;
        e.from = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.from).label;
        e.to = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.to).label;
        if (e.note) e.Note = quillToText(e.note);
        return omit(e, [
            'arrows',
            'color',
            'created',
            'dashes',
            'font',
            'grp',
            'hoverWidth',
            'id',
            'note',
            'selectionWidth',
            'width'
        ]);
    });
    const linksWorksheet = (0, $be857304663aed78$export$eab97d15b1788b8d).json_to_sheet(rows);
    (0, $be857304663aed78$export$eab97d15b1788b8d).book_append_sheet(workbook, linksWorksheet, 'Links');
    $c5391cf84cf40afe$export$20ca267bc6805c64('xlsx');
    (0, $be857304663aed78$export$40a06aea54ee074e)(workbook, $c5391cf84cf40afe$var$lastFileName);
    dummyDiv.remove();
    function omit(obj, props) {
        return Object.keys(obj).filter((key)=>props.indexOf(key) < 0).reduce((obj2, key)=>{
            obj2[key] = obj[key];
            return obj2;
        }, {});
    }
    /**
   *
   * @param {object} ops
   * @returns contents of Quill note as plain text
   */ function quillToText(ops) {
        qed.setContents(ops);
        // use qed.root.innerHTML to convert to HTML if that is preferred
        return qed.getText();
    }
}
function $c5391cf84cf40afe$export$e680efcc3295c085() {
    let str = 'Creator "prsm ' + (0, $fmvtn.version) + ' on ' + new Date(Date.now()).toLocaleString() + '"\ngraph\n[\n\tdirected 1\n';
    const nodeIds = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.map((n)=>n.id) //use integers, not GUIDs for node ids
    ;
    for (const node of (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get()){
        str += '\tnode\n\t[\n\t\tid ' + nodeIds.indexOf(node.id);
        if (node.label) str += '\n\t\tlabel "' + node.label.replace(/"/g, "'") + '"';
        const color = node.color.background || (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.group0.color.background;
        str += '\n\t\tcolor "' + color + '"';
        str += '\n\t]\n';
    }
    for (const edge of (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get()){
        str += '\tedge\n\t[\n\t\tsource ' + nodeIds.indexOf(edge.from);
        str += '\n\t\ttarget ' + nodeIds.indexOf(edge.to);
        if (edge.label) str += '\n\t\tlabel "' + edge.label + '"';
        const color = edge.color.color || (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.edge0.color.color;
        str += '\n\t\tcolor "' + color + '"';
        str += '\n\t]\n';
    }
    str += '\n]';
    $c5391cf84cf40afe$var$saveStr(str, 'gml');
}
function $c5391cf84cf40afe$export$5e98004ecc179104() {
    let str = `/* Creator PRSM ${(0, $fmvtn.version)} on ${new Date(Date.now()).toLocaleString()} */\ndigraph {\n`;
    for (const node of (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get())str += `"${node.id}" [label="${node.label}", 
			color="${(0, $7hmfH.standardizeColor)(node.color.border)}", fillcolor="${(0, $7hmfH.standardizeColor)(node.color.background)}",
			shape="${node.shape === 'text' ? 'plaintext' : node.shape}",
			${gvNodeStyle(node)},
			fontsize="${node.font.size}", fontcolor="${(0, $7hmfH.standardizeColor)(node.font.color)}"]\n`;
    for (const edge of (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get())str += `"${edge.from}" -> "${edge.to}" [label="${edge.label || ''}", 
			color="${(0, $7hmfH.standardizeColor)(edge.color.color)}"
			style="${gvConvertEdgeStyle(edge)}"]\n`;
    str += '}\n';
    $c5391cf84cf40afe$var$saveStr(str, 'gv');
    function gvNodeStyle(node) {
        const bDashes = node.shapeProperties.borderDashes;
        let val = 'style="filled';
        if (Array.isArray(bDashes)) val += ', dotted';
        else val += `, ${bDashes ? 'dashed' : 'solid'}`;
        val += `", penwidth="${node.borderWidth}"`;
        return val;
    }
    function gvConvertEdgeStyle(edge) {
        const bDashes = edge.dashes;
        let val = 'solid';
        if (Array.isArray(bDashes)) {
            if (bDashes[0] === 10) val = 'dashed';
            else val = 'dotted';
        }
        return val;
    }
}
function $c5391cf84cf40afe$export$71d078d741b17db4() {
    let str = `<?xml version="1.0" encoding="UTF-8"?>
	<graphml xmlns="http://graphml.graphdrawing.org/xmlns" 
	xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
	xsi:schemaLocation="http://graphml.graphdrawing.org/xmlns/1.0/graphml.xsd">
	<key id="d0" for="node" attr.name="label" attr.type="string"/>
	<key id="d1" for="node" attr.name="style" attr.type="int"/>
	<key id="d2" for="node" attr.name="color" attr.type="string"/>
	<key id="d3" for="node" attr.name="shape" attr.type="string"/>
	<key id="d4" for="node" attr.name="x" attr.type="float"/>
	<key id="d5" for="node" attr.name="y" attr.type="float"/>
	<key id="d6" for="node" attr.name="r" attr.type="int"/>
	<key id="d7" for="node" attr.name="g" attr.type="int"/>
	<key id="d8" for="node" attr.name="b" attr.type="int"/>
	<key id="d9" for="node" attr.name="size" attr.type="int"/>
	<key id="d10" for="edge" attr.name="label" attr.type="string"/>
	<key id="d11" for="edge" attr.name="style" attr.type="int"/>
	<key id="d12" for="edge" attr.name="color" attr.type="string"/>
	<key id="d13" for="edge" attr.name="r" attr.type="int"/>
	<key id="d14" for="edge" attr.name="g" attr.type="int"/>
	<key id="d15" for="edge" attr.name="b" attr.type="int"/>
	<key id="d16" for="edge" attr.name="weight" attr.type="int"/>
	<graph id="${(0, $7hmfH.elem)('maptitle').innerText}" edgedefault="directed">`;
    for (const node of (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get()){
        const color = node.color.background || (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes.group0.color.background;
        const rgb = (0, $7hmfH.rgbToArray)(color);
        str += `
		<node id="${node.id}">
			<data key="d0">${(0, $7hmfH.encodeHTMLEntities)(node.label)}</data>
			<data key="d1">${parseInt(node.grp.substring(5)) + 1}</data>
			<data key="d2">${color}</data>
			<data key="d3">${node.shape}</data>
			<data key="d4">${node.x}</data>
			<data key="d5">${node.y}</data>
			<data key="d6">${rgb[0]}</data>
			<data key="d7">${rgb[1]}</data>
			<data key="d8">${rgb[2]}</data>
			<data key="d9">${node.size}</data>
		</node>`;
    }
    for (const edge of (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get()){
        const color = edge.color.color || (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges.edge0.color.background;
        const rgb = (0, $7hmfH.rgbToArray)(color);
        str += `
		<edge id="${edge.id}" source="${edge.from}" target="${edge.to}">
			<data key="d10">${(0, $7hmfH.encodeHTMLEntities)(edge.label || '')}</data>
			<data key="d11">${parseInt(edge.grp.substring(4)) + 1}</data>
			<data key="d12">${color}</data>
			<data key="d13">${rgb[0]}</data>
			<data key="d14">${rgb[1]}</data>
			<data key="d15">${rgb[2]}</data>
			<data key="d16">${edge.width}</data>
		</edge>`;
    }
    str += `
	</graph>
	</graphml>`;
    $c5391cf84cf40afe$var$saveStr(str, 'graphml');
}
function $c5391cf84cf40afe$export$b3b39f9f40757282() {
    let str = `<?xml version='1.0' encoding='UTF-8'?>
		<gexf xmlns="http://gexf.net/1.3" version="1.3" xmlns:viz="http://gexf.net/1.3/viz" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://gexf.net/1.3 http://gexf.net/1.3/gexf.xsd">
		<meta lastmodifieddate="${new Date(Date.now()).toISOString().slice(0, 10)}">
			<creator>PRSM ${(0, $fmvtn.version)}</creator>
			<title>${(0, $7hmfH.elem)('maptitle').innerText}</title>
			<description>Generated from ${window.location.href}</description>
		</meta>
		<graph defaultedgetype="directed" mode="static">`;
    const attributeNames = (0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles') || {};
    if (attributeNames) {
        str += `
			<attributes class="node" mode="static">
	`;
        Object.keys(attributeNames).forEach((attr)=>{
            str += `		<attribute id="${attr}" title="${attributeNames[attr]}" type="string"/>
	`;
        });
        str += `		</attributes>`;
    }
    str += `
		<nodes>`;
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.forEach((node)=>{
        str += `
			<node id="${node.id}"
			label="${node.label}">`;
        if (attributeNames) {
            str += `
			<attvalues>`;
            Object.keys(attributeNames).forEach((attr)=>{
                if (node[attr]) str += `
				<attvalue for="${attr}" value="${node[attr]}"/>`;
            });
            str += `
			</attvalues>`;
        }
        str += `
			<viz:size value="${node.size}"/>
			<viz:position x="${node.x}" y="${node.y}"/>
			</node>`;
    });
    str += `
		</nodes>
		<edges>
    `;
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.forEach((edge)=>{
        str += `
		<edge id="${edge.id}" 
		source="${edge.from}" 
		target="${edge.to}"/>
		`;
    });
    str += `
		</edges>
      </graph>
	</gexf>`;
    $c5391cf84cf40afe$var$saveStr(str, 'gexf');
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU General Public License for more details.

	You should have received a copy of the GNU General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module handles the display of tutorial help messages to beginners.  
 ******************************************************************************************************************** */ /**
 * Class to display help messages in sequence as a user guide
 *
 * Each HTML element that should have a tutorial message should include the attributes:
 * data-step {number} specifies the order of the sequence of messages
 * data-tutorial: the message (can include HTML tags)
 * data-position: the location of the message relative to the element, one of
 * above, above-left, above-middle, above-right, left, right and below and their variants
 * or splash (which positions the message in the middle of the viewport)
 * To initialise:
 *  tutorial = new Tutorial()
 *  tutorial.start()
 *
 *  tutorial.onstep(Array of step numbers or a step number, callback) Evaluate call back
 *       after displaying tutorial message
 *  tutorial.onexit(callback) Evaluate callback when user finishes or skips the tutorial
 */ var $6666ea8fb56349cb$exports = {};
$6666ea8fb56349cb$exports = import.meta.resolve("aiC9t");


class $94ac8045488418c1$export$2e2bcd8739ae039 {
    constructor(){
        this.step = 0;
        this.steps = Array.from(document.querySelectorAll('[data-step]')).sort((a, b)=>{
            return parseInt(a.dataset.step) - parseInt(b.dataset.step);
        });
        this.back = null;
    }
    /**
   * initialise the step counter and display the first step
   * @param {number} start optional step to start at (if not provided, start at the lowest numbered step)
   */ start(start) {
        if (start !== undefined) this.step = start;
        this.stepStart();
    }
    /**
   * create a tutorial element and position it
   */ stepStart() {
        const elem = this.steps[this.step];
        const text = elem.dataset.tutorial;
        const position = elem.dataset.position;
        const classToAdd = elem.dataset.tutorialclass;
        let prevLegend = 'Back';
        let nextLegend = 'Next';
        // first and last have special buttons
        if (this.step === 0) prevLegend = 'Skip';
        if (this.step === this.steps.length - 1) nextLegend = 'Done';
        const dialog = document.createElement('div');
        dialog.className = `tutorial-dialog ${position}`;
        if (classToAdd) dialog.classList.add(classToAdd);
        dialog.id = 'tutorial';
        dialog.innerHTML = `
<div class="tutorial-arrow ${position}"></div>
<div class="x-button" id="tutorial-cancel">&times;</div>
<div class="text">
    ${text}
</div>
<input
    type="button"
    value="${nextLegend}"
    id="next"
    class="tutorial-button next"
/>
<input
    type="button"
    value="${prevLegend}"
    id="prev"
    class="tutorial-button prev"
/>
</div>`;
        dialog.style.visibility = 'hidden';
        document.querySelector('body').appendChild(dialog);
        // position the tutorial item and the border around the item being explained
        const dialogBR = dialog.getBoundingClientRect();
        const elemBR = elem.getBoundingClientRect();
        let top = elemBR.top;
        let left = elemBR.left;
        if (position === 'splash') {
            if (!this.back) {
                this.back = document.createElement('div');
                this.back.classList.add('tutorial-background');
                elem.insertAdjacentElement('afterend', this.back);
            }
            dialog.classList.add('splash');
            if (this.step === 0) {
                // initial splash screen for new users
                dialog.classList.add('intro-splash');
                const img = document.createElement('img');
                img.src = new URL($6666ea8fb56349cb$exports);
                document.getElementById('intro-logo').appendChild(img);
            }
        } else {
            const border = document.createElement('div');
            border.className = 'tutorial-border';
            border.id = 'tutorial-border';
            border.style.top = elemBR.top - 3 + 'px';
            border.style.left = elemBR.left - 3 + 'px';
            border.style.width = elemBR.width + 'px';
            border.style.height = elemBR.height + 'px';
            document.querySelector('body').appendChild(border);
            switch(position){
                case 'below':
                case 'below-right':
                case 'below-middle':
                case 'below-left':
                    top = elemBR.bottom + 15;
                    break;
                case 'above':
                case 'above-left':
                case 'above-middle':
                case 'above-right':
                    top = elemBR.top - dialogBR.height - 15;
                    break;
                case 'right':
                case 'right-middle':
                case 'right-bottom':
                    left = elemBR.right + 15;
                    break;
                case 'left':
                case 'left-middle':
                case 'left-bottom':
                    left = elemBR.left - dialogBR.width - 15;
                    break;
                default:
                    console.log(`Tutorial: Unknown data-position at step ${this.step}`);
                    break;
            }
            // ensure the dialog is in the viewport
            if (top < 0) top = 0;
            if (top > window.innerHeight - dialogBR.height) top = window.innerHeight - dialogBR.height;
            if (left < 0) left = 0;
            if (left > window.innerWidth - dialogBR.width) left = window.innerWidth - dialogBR.width;
            dialog.style.top = top + 'px';
            dialog.style.left = left + 'px';
        }
        dialog.style.visibility = '';
        // add event listeners to buttons to increment/decrement step,
        // destroy this dialog and then call step() to display next one
        document.querySelector('#next').addEventListener('click', ()=>{
            this.step += 1;
            this.stepFinish();
        });
        document.querySelector('#prev').addEventListener('click', ()=>{
            this.step -= 1;
            this.stepFinish();
        });
        document.querySelector('#tutorial-cancel').addEventListener('click', ()=>{
            this.step = this.steps.length;
            this.stepFinish();
        });
        // call onsstepstart function if to run now
        this.runStepStart();
    }
    runStepStart() {
        if (this.onstep === undefined) return;
        if (Array.isArray(this.onstep)) {
            if (this.onstep.indexOf(this.step) === -1) return;
        } else {
            if (this.onstep !== this.step) return;
        }
        if (typeof this.onstepfn === 'function') this.onstepfn();
    }
    /**
   * destroy the tutorial dialog, remove the border around the item being explained, and
   * and call stepStart() to display the next one
   */ stepFinish() {
        const dialog = document.querySelector('#tutorial');
        if (dialog) dialog.remove();
        const border = document.querySelector('#tutorial-border');
        if (border) border.remove();
        if (this.step < 0 || this.step >= this.steps.length) this.stepsEnd();
        else this.stepStart();
    }
    /**
   * called on exit
   */ stepsEnd() {
        if (this.back) {
            this.back.remove();
            this.back = null;
        }
        if (typeof this.onexitfn === 'function') this.onexitfn();
    }
    /**
   * store the cleanup function until needed
   * @param {function} callback
   */ onexit(callback) {
        this.onexitfn = callback;
    }
    onstep(step, callback) {
        this.onstep = step;
        this.onstepfn = callback;
    }
}



/*********************************************************************************************************************  

PRSM Participatory System Mapper 

    Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module does trophic layout.  
 ******************************************************************************************************************** */ /*
translation of the Trophic Levels algorithm to javascript

NG 18 December 2020

*/ /* simple minded adjacency matrix manipulation functions.
 * They generally assume that the matrix is square (no checks are done
 * that they are).
 * Assumes all weights are unity (TODO: allow weighted edges)
 * Matrix data structure is just an array of arrays
 */ 
/**
 * convert a directed adjacency matrix to an undirected one
 * mirror the elements above the leading diagonal to below it
 * @param {array[]} a
 * @returns {array[]} a copy of a
 */ function $a8c877a0bae3f8d4$var$undirected(a) {
    const b = Array(a.length);
    for(let i = 0; i < a.length; i++){
        b[i] = new Array(a.length);
        b[i][i] = a[i][i];
    }
    for(let i = 0; i < a.length; i++){
        for(let j = i + 1; j < a.length; j++)if (a[i][j] || a[j][i]) {
            b[i][j] = 1;
            b[j][i] = 1;
        } else {
            b[i][j] = 0;
            b[j][i] = 0;
        }
    }
    return b;
}
/**
 * check that all nodes are connected to at least one other node
 * i.e. every row includes at least one 1
 * @param {array[]} a
 */ function $a8c877a0bae3f8d4$var$connected(a) {
    for(let i = 0; i < a.length; i++){
        let nonzero = false;
        for(let j = 0; j < a.length; j++)if (a[i][j] !== 0) {
            nonzero = true;
            break;
        }
        if (!nonzero) return false;
    }
    return true;
}
/**
 * swap cell values across the leading diagonal
 * @param {array[]} a
 * @returns {array[]} a transposed copy of a
 */ function $a8c877a0bae3f8d4$var$transpose(a) {
    const b = new Array(a.length);
    for(let i = 0; i < a.length; i++){
        b[i] = new Array(a.length);
        for(let j = 0; j < a.length; j++)b[i][j] = a[j][i];
    }
    return b;
}
/**
 * return a vector of the number of edges out of a node
 * @param {array[]} a
 * @returns {array}
 */ /* eslint-disable camelcase */ function $a8c877a0bae3f8d4$var$out_degree(a) {
    const v = new Array(a.length);
    for(let row = 0; row < a.length; row++)v[row] = $a8c877a0bae3f8d4$var$sumVec(a[row]);
    return v;
}
/**
 * return a vector of the number of edges into a node
 * @param {array[]} a
 * @returns {array}
 */ function $a8c877a0bae3f8d4$var$in_degree(a) {
    return $a8c877a0bae3f8d4$var$out_degree($a8c877a0bae3f8d4$var$transpose(a));
}
/* eslint-enable camelcase */ /**
 * returns the summation of the values in the vector
 * @param {array} v
 * @returns {number}
 */ function $a8c877a0bae3f8d4$var$sumVec(v) {
    let sum = 0;
    for(let i = 0; i < v.length; i++)sum += v[i];
    return sum;
}
/**
 * v1 - v2
 * @param {array} v1
 * @param {array} v2
 * @returns {array}
 */ function $a8c877a0bae3f8d4$var$subVec(v1, v2) {
    const res = new Array(v1.length);
    for(let i = 0; i < v1.length; i++)res[i] = v1[i] - v2[i];
    return res;
}
/**
 * v1 + v2
 * @param {array} v1
 * @param {array} v2
 * @returns {array}
 */ function $a8c877a0bae3f8d4$var$addVec(v1, v2) {
    const res = new Array(v1.length);
    for(let i = 0; i < v1.length; i++)res[i] = v1[i] + v2[i];
    return res;
}
/**
 * subtract matrix b from a
 * @param {array[]} a
 * @param {array[]} b
 */ function $a8c877a0bae3f8d4$var$subtract(a, b) {
    const c = new Array(a.length);
    for(let i = 0; i < a.length; i++)c[i] = $a8c877a0bae3f8d4$var$subVec(a[i], b[i]);
    return c;
}
/**
 * Add matrix a to its transpose, but normalise the cell values resulting to 0/1
 * @param {array[]} a
 * @returns {array[]} a copy of the result
 */ function $a8c877a0bae3f8d4$var$mergeTranspose(a) {
    const b = $a8c877a0bae3f8d4$var$transpose(a);
    for(let i = 0; i < a.length; i++){
        for(let j = 0; j < a.length; j++)if (a[i][j] > 0) b[i][j] = 1;
    }
    return b;
}
/**
 * create a new matrix of size n, with all cells zero
 * @param {number} n
 */ function $a8c877a0bae3f8d4$var$zero(n) {
    const b = new Array(n);
    for(let i = 0; i < n; i++)b[i] = new Array(n).fill(0);
    return b;
}
/**
 * create a zero matrix with v as the leading diagonal
 * @param {array} v
 * @returns {array[]}
 */ function $a8c877a0bae3f8d4$var$diag(v) {
    const b = $a8c877a0bae3f8d4$var$zero(v.length);
    for(let i = 0; i < v.length; i++)b[i][i] = v[i];
    return b;
}
/**
 * subtract the minimum value of any cell from each cell of the vector
 * @param {array} v
 */ function $a8c877a0bae3f8d4$var$rebase(v) {
    const min = Math.min(...v);
    const res = new Array(v.length);
    for(let i = 0; i < v.length; i++)res[i] = v[i] - min;
    return res;
}
/**
 * solve Ax=B by Gauss-Jordan elimination method
 * adapted from https://www.npmjs.com/package/linear-equation-system
 * @param {array[]} A
 * @param {array} B
 */ function $a8c877a0bae3f8d4$var$solve(A, B) {
    let system = A.slice();
    for(let i = 0; i < B.length; i++)system[i].push(B[i]);
    for(let i = 0; i < system.length; i++){
        const pivotRow = findPivotRow(system, i);
        if (!pivotRow) return false //Singular system
        ;
        if (pivotRow !== i) system = swapRows(system, i, pivotRow);
        const pivot = system[i][i];
        for(let j = i; j < system[i].length; j++)//divide row by pivot
        system[i][j] = system[i][j] / pivot;
        for(let j = i + 1; j < system.length; j++)// Cancel below pivot
        if (system[j][i] !== 0) {
            const operable = system[j][i];
            for(let k = i; k < system[i].length; k++)system[j][k] -= operable * system[i][k];
        }
    }
    for(let i = system.length - 1; i > 0; i--){
        // Back substitution
        for(let j = i - 1; j >= 0; j--)if (system[j][i] !== 0) {
            const operable = system[j][i];
            for(let k = j; k < system[j].length; k++)system[j][k] -= operable * system[i][k];
        }
    }
    const answer = [];
    for(let i = 0; i < system.length; i++)answer.push(system[i].pop());
    return answer;
    function findPivotRow(sys, index) {
        let row = index;
        for(let i = index; i < sys.length; i++)if (Math.abs(sys[i][index]) > Math.abs(sys[row][index])) row = i;
        if (sys[row][index] === 0) return false;
        return row;
    }
    function swapRows(sys, row1, row2) {
        const cache = sys[row1];
        sys[row1] = sys[row2];
        sys[row2] = cache;
        return sys;
    }
}
/**
 * Round the cell values of v to the given number of decimal places
 * @param {array} v
 * @param {number} places
 */ function $a8c877a0bae3f8d4$var$round(v, places) {
    for(let i = 0; i < v.length; i++)v[i] = v[i].toFixed(places);
    return v;
}
/* --------------------------------------------------------------------*/ /**
 * This is the Trophic Levels Algorithm
 *
 * @param {array[]} a square adjacency matrix
 * @returns {array} levels (heights)
 */ /* eslint-disable camelcase */ function $a8c877a0bae3f8d4$var$get_trophic_levels(a) {
    // get undirected matrix
    const au = $a8c877a0bae3f8d4$var$undirected(a);
    // check connected
    if ($a8c877a0bae3f8d4$var$connected(au)) {
        // get in degree vector
        const in_deg = $a8c877a0bae3f8d4$var$in_degree(a);
        // get out degree vector
        const out_deg = $a8c877a0bae3f8d4$var$out_degree(a);
        // get in - out
        const v = $a8c877a0bae3f8d4$var$subVec(in_deg, out_deg);
        // get diagonal matrix, subtract (adj. matrix plus its transpose)
        const L = $a8c877a0bae3f8d4$var$subtract($a8c877a0bae3f8d4$var$diag($a8c877a0bae3f8d4$var$addVec(in_deg, out_deg)), $a8c877a0bae3f8d4$var$mergeTranspose(a));
        // set (0,0) to zero
        L[0][0] = 0;
        // do linear solve
        let h = $a8c877a0bae3f8d4$var$solve(L, v);
        if (!h) throw new Error('Singular matrix');
        // base to zero
        h = $a8c877a0bae3f8d4$var$rebase(h);
        // round to 3 decimal places
        h = $a8c877a0bae3f8d4$var$round(h, 3);
        // return tropic heights
        return h;
    } else throw new Error('Network must be weakly connected');
}
/* eslint-enable camelcase */ /**
 * convert a vector of objects, each an edge referencing from and to nodes
 * to an adjacency matrix.  nodes is a list of nodes that acts as the index for the adj. matrix.
 * @param {array} v list of edges
 * @param {array} nodes list of node Ids
 * @returns matrix
 */ function $a8c877a0bae3f8d4$var$edgeListToAdjMatrix(v, nodes) {
    const a = $a8c877a0bae3f8d4$var$zero(nodes.length);
    for(let i = 0; i < v.length; i++)a[nodes.indexOf(v[i].from)][nodes.indexOf(v[i].to)] = 1;
    return a;
}
/**
 * returns a list of the node Ids mentioned in a vector of edges
 * @param {array} v edges
 */ function $a8c877a0bae3f8d4$var$nodeList(v) {
    const nodes = [];
    for(let i = 0; i < v.length; i++){
        if (nodes.indexOf(v[i].from) === -1) nodes.push(v[i].from);
        if (nodes.indexOf(v[i].to) === -1) nodes.push(v[i].to);
    }
    return nodes;
}
/**
 * given a complete set of edges, returns a list of lists of edges, each list being the edges of a connected component
 * @param {object} data
 */ function $a8c877a0bae3f8d4$var$connectedComponents(data) {
    const edges = data.edges.get();
    const cc = [];
    const added = [];
    let component = [];
    // starting from each edge...
    edges.forEach((e)=>{
        if (!added.includes(e)) {
            component = [];
            //do a depth first search for connected edges
            dfs(e);
            cc.push(component);
        }
    });
    /**
   * depth first search for edges connected to 'to' or 'from' nodes of this edge
   * adds edges found to component array
   * @param {object} e
   */ function dfs(e) {
        added.push(e);
        component.push(e);
        edges.filter((next)=>{
            return e !== next && (next.from === e.to || next.to === e.from || next.from === -e.from || next.to === e.to);
        }).forEach((next)=>{
            if (!added.includes(next)) dfs(next);
        });
    }
    return cc;
}
function $a8c877a0bae3f8d4$export$cc9ec954c05f1d69(data) {
    // get a list of lists of connected components, each list being pairs of to and from nodes
    // process each connected component individually
    // nodes that are not connected to anything (degree 0) moved to the base level
    const updatedNodes = [];
    // save min and max x coordinates of nodes
    const minX = Math.min(...data.nodes.map((n)=>n.x));
    const maxX = Math.max(...data.nodes.map((n)=>n.x));
    $a8c877a0bae3f8d4$var$connectedComponents(data).forEach((edges)=>{
        const nodeIds = $a8c877a0bae3f8d4$var$nodeList(edges);
        const nodes = data.nodes.get(nodeIds);
        // convert to an adjacency matrix
        const adj = $a8c877a0bae3f8d4$var$edgeListToAdjMatrix(edges, nodeIds);
        // get trophic levels
        let levels = $a8c877a0bae3f8d4$var$get_trophic_levels(adj);
        // experimental: round levels to integers within the range 0 .. NLEVELS
        let range = Math.max(...levels) - Math.min(...levels);
        levels = levels.map((l)=>Math.round(l * (0, $5bc812abaa5f432b$export$4448800f068b9d2f) / range));
        // rescale x to match original max and min
        range = Math.max(...levels) - Math.min(...levels);
        // if all nodes are at same trophic height (range === 0, so scale would be infinity), line them up
        const scale = range > 0.000001 ? (maxX - minX) / range : 0;
        // move nodes to new positions
        for(let i = 0; i < nodeIds.length; i++){
            const node = nodes[i];
            node.x = levels[i] * scale + minX;
            node.level = levels[i];
            updatedNodes.push(node);
        }
    });
    // move all the rest (i.e. unconnected nodes) to the base level
    data.nodes.get().filter((n)=>!updatedNodes.some((u)=>n.id === u.id)).forEach((n)=>{
        n.x = minX;
        n.level = 0;
    });
    return data.nodes.get();
}


/*********************************************************************************************************************  

PRSM Participatory System Mapper 

    Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.


This module clusters factors  
 ******************************************************************************************************************** */ 
var $7hmfH = parcelRequire("7hmfH");


function $f00af92264e1701c$export$54c7dfe5600eab89(attribute) {
    if (!attribute) return;
    (0, $5bc812abaa5f432b$export$2a111da947c407d2).transact(()=>{
        $f00af92264e1701c$var$unCluster();
        switch(attribute){
            case 'none':
                break;
            case 'color':
                $f00af92264e1701c$var$clusterByColor();
                break;
            case 'style':
                $f00af92264e1701c$var$clusterByStyle();
                break;
            case 'louvain':
                $f00af92264e1701c$var$clusterByLouvain();
                break;
            default:
                $f00af92264e1701c$var$clusterByAttribute(attribute);
                break;
        }
    });
}
/**
 *
 * @param {String} attribute
 */ function $f00af92264e1701c$var$clusterByAttribute(attribute) {
    if (!attribute) return;
    // collect all different values of the attribute that are in use
    const attValues = new Set();
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster && node[attribute]) attValues.add(node[attribute]);
    });
    // build groups map value -> member nodes
    const groups = {};
    for (const value of attValues)groups[value] = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>node[attribute] === value && !node.clusteredIn && !node.isCluster
    });
    $f00af92264e1701c$var$clusterGroups(groups, (value)=>{
        return {
            id: `cluster-${attribute}-${value}`,
            label: `${(0, $5bc812abaa5f432b$export$807f940a96777041).get('attributeTitles')[attribute]} ${value}`,
            color: (0, $7hmfH.makeColor)()
        };
    });
}
/**
 * Cluster nodes by their background color.
 *
 * Groups nodes that share the same standardized background color and creates a cluster node
 * placed at the members' centroid.
 *
 * @returns {void}
 */ function $f00af92264e1701c$var$clusterByColor() {
    // collect all different values of the attribute that are in use
    const colors = new Set();
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster) colors.add((0, $7hmfH.standardizeColor)(node.color.background));
    });
    // build groups map color -> member nodes
    const groups = {};
    for (const color of colors)groups[color] = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>(0, $7hmfH.standardizeColor)(node.color.background) === color && !node.clusteredIn && !node.isCluster
    });
    let clusterNumber = 0;
    $f00af92264e1701c$var$clusterGroups(groups, (color)=>{
        return {
            id: `cluster-color-${color}`,
            label: `Cluster ${++clusterNumber}`,
            color: color
        };
    });
}
/**
 * Cluster nodes by their visual style group.
 *
 * Groups nodes by their grp value (visual style) and creates cluster nodes using
 * the style's configured color and label.
 *
 * @returns {void}
 */ function $f00af92264e1701c$var$clusterByStyle() {
    // collect all different values of the style that are in use
    const stylesInUse = new Set();
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((node)=>{
        if (!node.isCluster) stylesInUse.add(node.grp);
    });
    // build groups map style -> member nodes
    const groups = {};
    for (const style of stylesInUse)groups[style] = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>node.grp === style && !node.clusteredIn && !node.isCluster
    });
    $f00af92264e1701c$var$clusterGroups(groups, (style)=>{
        return {
            id: `cluster-style-${style}`,
            label: `${(0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[style].groupLabel} cluster`,
            color: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[style].color.background
        };
    });
}
/**
 * Clusters the nodes in the graph using the Louvain method.
 * @returns {void}
 */ function $f00af92264e1701c$var$clusterByLouvain() {
    const nodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>!node.isCluster
    });
    const edges = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get({
        filter: (edge)=>!edge.isClusterEdge
    }).map(({ from: from, to: to, weight: weight, ...rest })=>({
            source: from,
            target: to,
            weight: weight || 1.0,
            ...rest
        }));
    if (edges.length === 0) {
        (0, $7hmfH.alertMsg)('No edges in the network - cannot cluster by Louvain method', 'error');
        (0, $7hmfH.elem)('clustering').value = 'none';
        return;
    }
    const nodeIds = nodes.map((n)=>n.id);
    const result = $f00af92264e1701c$var$jLouvain(nodeIds, edges);
    // result is an object with props nodeId: community number
    // Group nodes by community to ensure one cluster node per community
    const communities = {};
    for (const n of nodes){
        const comm = result[n.id];
        if (comm === undefined) continue;
        // skip already clustered or cluster nodes
        if (n.clusteredIn || n.isCluster) continue;
        communities[comm] ??= [];
        communities[comm].push(n);
    }
    // find the most frequent background colour in the nodes of each each community
    // and use it to color the cluster node
    const commColors = {};
    for(const comm in communities)commColors[comm] = (0, $7hmfH.mostFrequentString)(communities[comm].map((n)=>n.color.background));
    $f00af92264e1701c$var$clusterGroups(communities, (comm)=>{
        return {
            id: `cluster-louvain-${comm}`,
            label: `Cluster ${parseInt(comm) + 1}`,
            color: commColors[comm]
        };
    });
}
/**
 * Generic grouping-based clustering routine.
 * Builds cluster nodes for each entry in `groups` using the provided
 * `makeProps(key, members)` function which must return { id, label, color }.
 *
 * @param {Object} groups - map of groupKey to Array of nodes
 * @param {function(string, Array): {id:string, label:string, color:string}} makeProps
 */ function $f00af92264e1701c$var$clusterGroups(groups, makeProps) {
    (0, $5bc812abaa5f432b$export$9bc34f54445cb725)();
    const nodesToUpdate = [];
    for (const [key, members] of Object.entries(groups)){
        // clusters must have at least 2 nodes
        if (!members || members.length <= 1) continue;
        const { id: id, label: label, color: color } = makeProps(key, members);
        const clusterNode = $f00af92264e1701c$var$makeClusterNode(id, label, color);
        let sumx = 0;
        let sumy = 0;
        let nInCluster = 0;
        for (const node of members){
            node.clusteredIn = clusterNode.id;
            (0, $7hmfH.setNodeHidden)(node, true);
            sumx += node.x;
            sumy += node.y;
            nInCluster++;
            nodesToUpdate.push(node);
        }
        // place cluster node at centroid
        clusterNode.x = sumx / nInCluster;
        clusterNode.y = sumy / nInCluster;
        nodesToUpdate.push(clusterNode);
    }
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
    $f00af92264e1701c$var$showClusterLinks();
}
/**
 * Return a data url for an image to represent a cluster shaded with the given colour
 * @param {string} color
 * @returns data-url
 */ function $f00af92264e1701c$var$clusterImage(color) {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
             <path fill="${color}" fill-rule="evenodd" d="M8 0a2.25 2.25 0 00-.75 4.372v.465a3.25 3.25 
             0 00-1.797 1.144l-.625-.366a2.25 2.25 0 10-1.038 1.13l1.026.602a3.261 3.261 0 000 
             1.306l-1.026.601a2.25 2.25 0 101.038 1.13l.625-.366a3.25 3.25 0 001.797 1.145v.465a2.25 
             2.25 0 101.5 0v-.465a3.25 3.25 0 001.797-1.145l.625.366a2.25 2.25 0 
             101.038-1.13l-1.026-.6a3.26 3.26 0 000-1.307l1.026-.601a2.25 2.25 0 
             10-1.038-1.13l-.625.365A3.251 3.251 0 008.75 4.837v-.465A2.25 2.25 0 
             008 0zm-.75 2.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM2.75 4a.75.75 0 
             100 1.5.75.75 0 000-1.5zm0 6.5a.75.75 0 100 1.5.75.75 0 000-1.5zm4.5 
             3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm6-3.25a.75.75 0 100 1.5.75.75 
             0 000-1.5zm0-6.5a.75.75 0 100 1.5.75.75 0 000-1.5zM6.395 7.3a1.75 1.75 0 
             113.21 1.4 1.75 1.75 0 01-3.21-1.4z" clip-rule="evenodd"/>
            </svg>`);
}
/**
 * Create an object to format a new cluster node
 * The font is always black
 * @param {string} id cluster nodeId
 * @param {string} label cluster node label
 * @param {string} color of cluster node
 * @returns {object} cluster node object
 */ function $f00af92264e1701c$var$makeClusterNode(id, label, color) {
    return (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes['cluster'], {
        id: id,
        label: label,
        isCluster: true,
        hidden: false,
        shape: 'image',
        image: $f00af92264e1701c$var$clusterImage(color),
        size: 50,
        font: {
            color: 'rgb(0,0,0)'
        }
    });
}
/**
 * Create links to cluster nodes and hide links that are now inside clustered nodes
 */ function $f00af92264e1701c$var$showClusterLinks() {
    // hide all links between clusters initially
    const edgesToUpdate = [];
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().forEach((edge)=>{
        if (edge.isClusterEdge) {
            edge.hidden = true;
            edge.label = '';
        }
    });
    for (const edge of (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get()){
        if (edge.isClusterEdge) continue;
        // if edge is between two nodes neither of which are in a cluster, show it
        // if edge is from and to nodes that are in the same cluster, hide it
        // if edge is from a node not in a cluster, and to a node in a cluster, hide it and make a cluster edge for it
        // and vice versa
        // if edge is between two nodes both in (different) clusters, hide it and make a cluster edge for it
        const fromNode = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.from);
        const toNode = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(edge.to);
        (0, $7hmfH.setEdgeHidden)(edge, true);
        if (!fromNode.clusteredIn && !toNode.clusteredIn) (0, $7hmfH.setEdgeHidden)(edge, false);
        else if (fromNode.clusteredIn === toNode.clusteredIn) (0, $7hmfH.setEdgeHidden)(edge, true);
        else if (!fromNode.clusteredIn && toNode.clusteredIn) makeClusterLink(edge.from, toNode.clusteredIn);
        else if (fromNode.clusteredIn && !toNode.clusteredIn) makeClusterLink(fromNode.clusteredIn, edge.to);
        else if (fromNode.clusteredIn && toNode.clusteredIn) makeClusterLink(fromNode.clusteredIn, toNode.clusteredIn);
        else (0, $7hmfH.setEdgeHidden)(edge, false) // shouldn't happen
        ;
        edgesToUpdate.push(edge);
    }
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToUpdate);
    if (/cluster/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) {
        console.log('Nodes');
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((n)=>{
            console.log([
                n.id,
                n.label,
                n.hidden,
                n.clusteredIn
            ]);
        });
        console.log('Edges');
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().forEach((e)=>{
            console.log([
                e.id,
                (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.from).label,
                (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.to).label,
                e.hidden
            ]);
        });
    }
    /**
   * Reuse existing edge or create a new one
   * @param {string} fromId
   * @param {string} toId
   */ function makeClusterLink(fromId, toId) {
        let edge = edgesToUpdate.filter((e)=>fromId === e.from && toId === e.to).shift();
        if (!edge) edge = (0, $7hmfH.deepMerge)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges['cluster'], {
            id: `cledge-${(0, $7hmfH.uuidv4)()}`,
            from: fromId,
            to: toId,
            isClusterEdge: true
        });
        edge.hidden = false;
        edge.label = edge.label ? (parseInt(edge.label) + 1).toString() : '1';
        edgesToUpdate.push(edge);
    }
}
function $f00af92264e1701c$export$14b245ef7e84f38d(clusterNodeId) {
    const clusterNode = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(clusterNodeId);
    // if user has right clicked on a factor that is not a cluster, and clustering is
    // set, re-cluster
    if (!clusterNode.isCluster) {
        const attribute = (0, $7hmfH.elem)('clustering').value;
        if (attribute !== 'none') $f00af92264e1701c$export$54c7dfe5600eab89(attribute);
        return;
    }
    (0, $5bc812abaa5f432b$export$2a111da947c407d2).transact(()=>{
        (0, $5bc812abaa5f432b$export$9bc34f54445cb725)();
        const nodesToUpdate = [];
        const edgesToRemove = [];
        const nodesInCluster = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
            filter: (node)=>node.clusteredIn === clusterNode.id
        });
        for (const node of nodesInCluster){
            (0, $7hmfH.setNodeHidden)(node, false);
            node.clusteredIn = null;
            nodesToUpdate.push(node);
        }
        // hide the cluster node
        clusterNode.hidden = true;
        // and the edges that link it
        const eIds = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getConnectedEdges(clusterNode.id);
        for (const eId of eIds)edgesToRemove.push(eId);
        nodesToUpdate.push(clusterNode);
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.remove(edgesToRemove);
        $f00af92264e1701c$var$showClusterLinks();
    });
    if ((0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (n)=>n.isCluster && !n.hidden
    }).length === 0) // all clusters have been opened; reset the cluster select to None
    (0, $7hmfH.elem)('clustering').value = 'none';
}
/**
 * Remove all clusters, unhide member nodes and restore their edges.
 *
 * This reverses any clustering previously applied by hiding cluster nodes,
 * revealing their member nodes and removing cluster edges.
 *
 * @returns {void}
 */ function $f00af92264e1701c$var$unCluster() {
    const nodesToUpdate = [];
    const edgesToRemove = [];
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
        filter: (node)=>node.isCluster
    }).forEach((clusterNode)=>{
        const nodesInCluster = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get({
            filter: (node)=>node.clusteredIn === clusterNode.id
        });
        for (const node of nodesInCluster){
            (0, $7hmfH.setNodeHidden)(node, false);
            node.clusteredIn = null;
            nodesToUpdate.push(node);
        }
        clusterNode.hidden = true;
        // and the edges that link it
        const eIds = (0, $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4).getConnectedEdges(clusterNode.id);
        for (const eId of eIds)edgesToRemove.push(eId);
        nodesToUpdate.push(clusterNode);
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToUpdate);
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.remove(edgesToRemove);
    $f00af92264e1701c$var$showClusterLinks();
}
/****************************************************** Louvain clustering ******************************************************
 * Author: Corneliu S. (github.com/upphiminn)
 *
 * This is a javascript implementation of the Louvain
 * community detection algorithm (http://arxiv.org/abs/0803.0476)
 * Based on https://bitbucket.org/taynaud/python-louvain/overview
 *
 * Modernized to ES2023
 */ /*
 Original Author: Corneliu S. (github.com/upphiminn)

 This is a javascript implementation of the Louvain
 community detection algorithm (http://arxiv.org/abs/0803.0476)
 Based on https://bitbucket.org/taynaud/python-louvain/overview

 Modernized to ES2023 and with jsDoc comments added by Nigel Gilbert
 */ /**
 * jLouvain Community Detection Algorithm
 *
 * Usage:
 *   const result = jLouvain(nodes, edges, initialPartition);
 *
 * @param {Array} nodes - Array of node identifiers
 * @param {Array} edges - Array of edge objects with {source, target, weight} format
 * @param {Object} [initialPartition] - Optional initial partition mapping {nodeId: communityId}
 * @returns {Object} Community assignments {nodeId: communityId}
 */ function $f00af92264e1701c$var$jLouvain(nodes, edges, initialPartition = null) {
    // Constants
    const PASS_MAX = -1 // continue until no improvement
    ;
    const MIN_MODULARITY_IMPROVEMENT = 0.0000001;
    /**
   * Remove duplicate values from array using Set
   * @param {Array} array - Input array with potential duplicates
   * @returns {Array} Array with unique values only
   */ const uniqify = (array)=>[
            ...new Set(array)
        ];
    /**
   * Calculate the total degree (weighted sum of edges) for a given node
   * @param {Object} graph - Graph object with _assocMat adjacency matrix
   * @param {number|string} node - Node identifier
   * @returns {number} Total weighted degree of the node
   */ const getDegreeForNode = (graph, node)=>{
        const neighbours = graph._assocMat[node] ? Object.keys(graph._assocMat[node]) : [];
        return neighbours.reduce((weight, neighbour)=>{
            let value = graph._assocMat[node][neighbour] ?? 1;
            if (node === neighbour) value *= 2 // Self-loops count double
            ;
            return weight + value;
        }, 0);
    };
    /**
   * Get all neighbouring nodes for a given node
   * @param {Object} graph - Graph object with _assocMat adjacency matrix
   * @param {number|string} node - Node identifier
   * @returns {string[]} Array of neighbour node identifiers (as strings)
   */ const getNeighboursOfNode = (graph, node)=>{
        return graph._assocMat[node] ? Object.keys(graph._assocMat[node]) : [];
    };
    /**
   * Get the weight of an edge between two nodes
   * @param {Object} graph - Graph object with _assocMat adjacency matrix
   * @param {number|string} node1 - First node identifier
   * @param {number|string} node2 - Second node identifier
   * @returns {number|undefined} Edge weight or undefined if no edge exists
   */ const getEdgeWeight = (graph, node1, node2)=>{
        return graph._assocMat[node1]?.[node2];
    };
    /**
   * Calculate the total weight of all edges in the graph
   * @param {Object} graph - Graph object with edges array
   * @returns {number} Sum of all edge weights
   */ const getGraphSize = (graph)=>{
        return graph.edges.reduce((size, edge)=>size + edge.weight, 0);
    };
    /**
   * Add an edge to the graph, updating both the edge list and adjacency matrix
   * @param {Object} graph - Graph object to modify
   * @param {Object} edge - Edge object with source, target, and weight properties
   * @param {Object} localState - Local state object with edgeIndex Map
   */ const addEdgeToGraph = (graph, edge, localState)=>{
        updateAssocMat(graph, edge);
        const edgeKey = `${edge.source}_${edge.target}`;
        if (localState.edgeIndex.has(edgeKey)) {
            const index = localState.edgeIndex.get(edgeKey);
            graph.edges[index].weight = edge.weight;
        } else {
            graph.edges.push(edge);
            localState.edgeIndex.set(edgeKey, graph.edges.length - 1);
        }
    };
    /**
   * Create an adjacency matrix from a list of edges
   * @param {Array} edgeList - Array of edge objects with source, target, and weight
   * @returns {Object} Adjacency matrix where mat[source][target] = weight
   */ const makeAssocMat = (edgeList)=>{
        const mat = {};
        edgeList.forEach(({ source: source, target: target, weight: weight })=>{
            mat[source] ??= {};
            mat[source][target] = weight;
            mat[target] ??= {};
            mat[target][source] = weight;
        });
        return mat;
    };
    /**
   * Update the adjacency matrix of a graph with a new edge
   * @param {Object} graph - Graph object with _assocMat property
   * @param {Object} edge - Edge object with source, target, and weight properties
   */ const updateAssocMat = (graph, { source: source, target: target, weight: weight })=>{
        graph._assocMat[source] ??= {};
        graph._assocMat[source][target] = weight;
        graph._assocMat[target] ??= {};
        graph._assocMat[target][source] = weight;
    };
    /**
   * Create a deep copy of an object using structuredClone
   * @param {*} obj - Object to clone
   * @returns {*} Deep copy of the input object
   */ const clone = (obj)=>{
        if (obj === null || typeof obj !== 'object') return obj;
        return structuredClone(obj);
    };
    // Core Algorithm
    /**
   * Initialize the status object for community detection algorithm
   * @param {Object} graph - Graph object with nodes and adjacency matrix
   * @param {Object} status - Status object to initialize (modified in place)
   * @param {Object|null} part - Optional initial partition, null for default initialization
   */ const initStatus = (graph, status, part)=>{
        status.nodes_to_com = {};
        status.total_weight = getGraphSize(graph);
        status.internals = {};
        status.degrees = {};
        status.gDegrees = {};
        status.loops = {};
        if (!part) graph.nodes.forEach((node, i)=>{
            status.nodes_to_com[node] = i;
            const deg = getDegreeForNode(graph, node);
            if (deg < 0) throw new TypeError('Graph should only have positive weights.');
            status.degrees[i] = deg;
            status.gDegrees[node] = deg;
            status.loops[node] = getEdgeWeight(graph, node, node) ?? 0;
            status.internals[i] = status.loops[node];
        });
        else graph.nodes.forEach((node)=>{
            const com = part[node];
            status.nodes_to_com[node] = com;
            const deg = getDegreeForNode(graph, node);
            status.degrees[com] = (status.degrees[com] ?? 0) + deg;
            status.gDegrees[node] = deg;
            const neighbours = getNeighboursOfNode(graph, node);
            const inc = neighbours.reduce((acc, neighbour)=>{
                const weight = graph._assocMat[node][neighbour];
                if (weight <= 0) throw new TypeError('Graph should only have positive weights.');
                if (part[neighbour] === com) return acc + (neighbour === node ? weight : weight / 2.0);
                return acc;
            }, 0);
            status.internals[com] = (status.internals[com] ?? 0) + inc;
        });
    };
    /**
   * Calculate the modularity score for the current community partition
   * @param {Object} status - Status object containing community assignments and metrics
   * @returns {number} Modularity score (higher is better)
   */ const calculateModularity = (status)=>{
        // eslint-disable-next-line camelcase
        const { total_weight: links, nodes_to_com: nodes_to_com, internals: internals, degrees: degrees } = status;
        const communities = uniqify(Object.values(nodes_to_com));
        return communities.reduce((result, com)=>{
            const inDegree = internals[com] ?? 0;
            const degree = degrees[com] ?? 0;
            if (links > 0) return result + inDegree / links - Math.pow(degree / (2.0 * links), 2);
            return result;
        }, 0.0);
    };
    /**
   * Get the communities of neighbouring nodes and their edge weights
   * @param {number|string} node - Node identifier
   * @param {Object} graph - Graph object with adjacency matrix
   * @param {Object} status - Status object with community assignments
   * @returns {Object} Object mapping community IDs to total edge weights
   */ const getNeighbourCommunities = (node, graph, status)=>{
        // Compute the communities in the neighbourhood of the node
        const weights = {};
        const neighbourhood = getNeighboursOfNode(graph, node);
        neighbourhood.forEach((neighbour)=>{
            // Convert neighbour to same type as node for comparison
            // Since neighbour comes from Object.keys(), it's a string
            if (String(neighbour) !== String(node)) {
                const weight = graph._assocMat[node][neighbour] ?? 1;
                const neighbourCom = status.nodes_to_com[neighbour];
                weights[neighbourCom] = (weights[neighbourCom] ?? 0) + weight;
            }
        });
        return weights;
    };
    /**
   * Insert a node into a community and update the status accordingly
   * @param {number|string} node - Node identifier
   * @param {number|string} com - Community identifier
   * @param {number} weight - Weight of edges to this community
   * @param {Object} status - Status object to update
   */ const insertNode = (node, com, weight, status)=>{
        // Insert node into community and modify status
        status.nodes_to_com[node] = +com;
        status.degrees[com] = (status.degrees[com] ?? 0) + (status.gDegrees[node] ?? 0);
        status.internals[com] = (status.internals[com] ?? 0) + weight + (status.loops[node] ?? 0);
    };
    /**
   * Remove a node from a community and update the status accordingly
   * @param {number|string} node - Node identifier
   * @param {number|string} com - Community identifier
   * @param {number} weight - Weight of edges to this community
   * @param {Object} status - Status object to update
   */ const removeNode = (node, com, weight, status)=>{
        // Remove node from community and modify status
        status.degrees[com] = (status.degrees[com] ?? 0) - (status.gDegrees[node] ?? 0);
        status.internals[com] = (status.internals[com] ?? 0) - weight - (status.loops[node] ?? 0);
        status.nodes_to_com[node] = -1;
    };
    /**
   * Renumber communities to have consecutive IDs starting from 0
   * @param {Object} dict - Dictionary mapping nodes to community IDs
   * @returns {Object} New dictionary with renumbered community IDs
   */ const renumberCommunities = (dict)=>{
        const ret = clone(dict);
        const newValues = new Map();
        let count = 0;
        Object.keys(dict).forEach((key)=>{
            const value = dict[key];
            if (!newValues.has(value)) newValues.set(value, count++);
            ret[key] = newValues.get(value);
        });
        return ret;
    };
    /**
   * Perform one level of the Louvain algorithm - optimize community assignments
   * @param {Object} graph - Graph object with nodes and adjacency matrix
   * @param {Object} status - Status object with current community assignments (modified in place)
   */ const computeOneLevel = (graph, status)=>{
        // Compute one level of the Communities Dendrogram
        let modifiedFlag = true;
        let nbPassDone = 0;
        let curMod = calculateModularity(status);
        let newMod = curMod;
        while(modifiedFlag && nbPassDone !== PASS_MAX){
            curMod = newMod;
            modifiedFlag = false;
            nbPassDone += 1;
            graph.nodes.forEach((node)=>{
                const comNode = status.nodes_to_com[node];
                const degcTotw = (status.gDegrees[node] ?? 0) / (status.total_weight * 2.0);
                const neighCommunities = getNeighbourCommunities(node, graph, status);
                removeNode(node, comNode, neighCommunities[comNode] ?? 0.0, status);
                const { bestCom: bestCom } = Object.keys(neighCommunities).reduce((best, com)=>{
                    const incr = neighCommunities[com] - (status.degrees[com] ?? 0.0) * degcTotw;
                    if (incr > best.bestIncrease) return {
                        bestCom: com,
                        bestIncrease: incr
                    };
                    return best;
                }, {
                    bestCom: comNode,
                    bestIncrease: 0
                });
                insertNode(node, bestCom, neighCommunities[bestCom] ?? 0, status);
                if (bestCom !== comNode) modifiedFlag = true;
            });
            newMod = calculateModularity(status);
            if (newMod - curMod < MIN_MODULARITY_IMPROVEMENT) break;
        }
    };
    /**
   * Create an induced graph where nodes are communities from the partition
   * @param {Object} partition - Mapping of original nodes to community IDs
   * @param {Object} graph - Original graph object
   * @param {Object} localState - Local state for edge indexing
   * @returns {Object} New graph where each node represents a community
   */ const createInducedGraph = (partition, graph, localState)=>{
        const ret = {
            nodes: [],
            edges: [],
            _assocMat: {}
        };
        // Add nodes from partition values
        const partitionValues = Object.values(partition);
        ret.nodes = uniqify(partitionValues);
        graph.edges.forEach(({ source: source, target: target, weight: weight = 1 })=>{
            const com1 = partition[source];
            const com2 = partition[target];
            const wPrec = getEdgeWeight(ret, com1, com2) ?? 0;
            const newWeight = wPrec + weight;
            addEdgeToGraph(ret, {
                source: com1,
                target: com2,
                weight: newWeight
            }, localState);
        });
        localState.edgeIndex.clear();
        return ret;
    };
    /**
   * Extract the partition at a specific level of the dendrogram
   * @param {Array} dendrogram - Array of partitions at each level
   * @param {number} level - Level to extract (0 = first level, higher = more aggregated)
   * @returns {Object} Node to community mapping at the specified level
   */ const partitionAtLevel = (dendrogram, level)=>{
        const partition = clone(dendrogram[0]);
        for(let i = 1; i <= level; i++)Object.keys(partition).forEach((key)=>{
            const node = key;
            const com = partition[key];
            partition[node] = dendrogram[i][com];
        });
        return partition;
    };
    /**
   * Generate the complete dendrogram (hierarchy) of community partitions
   * @param {Object} graph - Input graph with nodes, edges, and adjacency matrix
   * @param {Object|null} partInit - Optional initial partition
   * @param {Object} localState - Local state for algorithm execution
   * @returns {Array} Array of partitions, each representing a level in the hierarchy
   */ const generatedendrogram = (graph, partInit, localState)=>{
        if (graph.edges.length === 0) return Object.fromEntries(graph.nodes.map((node)=>[
                node,
                node
            ]));
        const status = {};
        initStatus(graph, status, partInit);
        let mod = calculateModularity(status);
        const statusList = [];
        computeOneLevel(graph, status);
        let newMod = calculateModularity(status);
        let partition = renumberCommunities(status.nodes_to_com);
        statusList.push(partition);
        mod = newMod;
        let currentGraph = createInducedGraph(partition, graph, localState);
        initStatus(currentGraph, status);
        while(true){
            computeOneLevel(currentGraph, status);
            newMod = calculateModularity(status);
            if (newMod - mod < MIN_MODULARITY_IMPROVEMENT) break;
            partition = renumberCommunities(status.nodes_to_com);
            statusList.push(partition);
            mod = newMod;
            currentGraph = createInducedGraph(partition, currentGraph, localState);
            initStatus(currentGraph, status);
        }
        return statusList;
    };
    // Create local state for this instance
    const localState = {
        edgeIndex: new Map()
    };
    // Build the graph structure
    const assocMat = makeAssocMat(edges);
    const graph = {
        nodes: nodes,
        edges: edges,
        _assocMat: assocMat
    };
    // Generate dendrogram and return final partition
    const dendrogram = generatedendrogram(graph, initialPartition, localState);
    return partitionAtLevel(dendrogram, 0);
}


/**
 * Some functions for examining and merging maps - not for public consumption, but useful
 * for diagnosing problems and for special operations on maps
 */ 
var $eokS8 = parcelRequire("eokS8");

var $dGheI = parcelRequire("dGheI");

var $7AcYc = parcelRequire("7AcYc");


var $7hmfH = parcelRequire("7hmfH");
/* --------------------------------- Merge maps ----------------------------- */ /*
 * Evaluate mergeRoom(string: room code) e.g. mergeRoom('WBI-CRD-ROB-XDK')
 *   adds all factors and links in the 'other' map to this one
 *   if a factor occurs in both maps and is identical in both, nothing is added
 *   if a factor is in both maps, but the label is different, a new factor is added
 *     that is a clone of the 'other' factor, but with a dashed red border and with
 *     cloned links that are dashed.
 *
 * Evaluate diffRoom(string: room code) e.g. diffRoom('WBI-CRD-ROB-XDK')
 *  to list all the differences in the console
 */ let $a8a79648246a2e5c$var$bwsp //  websocket to other room
;
let $a8a79648246a2e5c$var$bdata // the data from the other room
;
let $a8a79648246a2e5c$var$bNodesMap // map of nodes from the other room
;
let $a8a79648246a2e5c$var$bEdgesMap //  map of edges from the other room
;
function $a8a79648246a2e5c$export$ac1ea0fcd93fecda(otherRoom) {
    const bDoc = new $eokS8.Doc();
    $a8a79648246a2e5c$var$bwsp = new (0, $dGheI.WebsocketProvider)((0, $5bc812abaa5f432b$export$3f859614deccc31b), `prsm${otherRoom}`, bDoc);
    $a8a79648246a2e5c$var$bwsp.disconnectBc();
    $a8a79648246a2e5c$var$bNodesMap = bDoc.getMap('nodes');
    $a8a79648246a2e5c$var$bEdgesMap = bDoc.getMap('edges');
    const bNodes = new (0, $7AcYc.DataSet)();
    const bEdges = new (0, $7AcYc.DataSet)();
    $a8a79648246a2e5c$var$bdata = {
        nodes: bNodes,
        edges: bEdges
    };
}
function $a8a79648246a2e5c$var$mergeMaps() {
    let history = '' // collect history log entries, so that the log can be updated all at once
    ;
    (0, $5bc812abaa5f432b$export$2a111da947c407d2).transact(()=>{
        const nodesToAdd = [] // collect new nodes to add to map A
        ;
        const edgesToAdd = [] // and edges
        ;
        const substitutes = new Map() // when two nodes have different ids, but identical labels,
        ;
        // use this as a conversion look up table from one id to the other
        const newNodes = new Map();
        for (const BNode of $a8a79648246a2e5c$var$bdata.nodes.get()){
            if (BNode.isCluster) continue;
            // for each node in the other map
            let ANode = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(BNode.id) // see whether there is a node in this map with the same id
            ;
            // if not, see whether there is a node in this map with the same label, and treat this node as the same as the node in the other map
            if (!ANode) {
                const sameLabelNodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().filter((an)=>an.label.replace(/\s/g, '') === BNode.label.replace(/\s/g, ''));
                if (sameLabelNodes.length > 1) {
                    console.log(`%cMatching factors by label ('${BNode.label}'), but there are two or more factors with this label in this map`, 'color: red');
                    (0, $7hmfH.alertMsg)(`Matching factors by label ('${BNode.label}'), but there are two or more factors with this label in the map`, 'warn');
                }
                ANode = sameLabelNodes[0];
                if (ANode) {
                    // map works both ways - OK since ids are unique
                    substitutes.set(BNode.id, ANode.id);
                    substitutes.set(ANode.id, BNode.id);
                }
            }
            if (ANode) {
                // if there is, check whether the label is the same
                if (ANode.label.replace(/\s/g, '') !== BNode.label.replace(/\s/g, '')) {
                    // if not, make a clone of the other node with a new id
                    logMerge(`'${ANode.label}' Factor in this map does not match Factor from other map with new label: '${BNode.label}'. Factor with new label added.`);
                    // generate a new id for BNode.  change border to dashed red.  Add it to the map
                    const newNode = (0, $7hmfH.deepCopy)(BNode);
                    newNode.id = (0, $7hmfH.uuidv4)();
                    newNode.shapeProperties.borderDashes = true;
                    newNode.borderWidth = 4;
                    newNode.borderWidthSelected = 4;
                    newNode.color.border = '#ff0000';
                    newNode.color.highlight.border = '#ff0000';
                    newNode.x = ANode.x + 30;
                    newNode.y = ANode.y + 30;
                    // add it to this map
                    nodesToAdd.push(newNode);
                    // add to lookup table of existing node id to clone node id
                    newNodes.set(BNode.id, newNode.id);
                } else {
                    if (ANode.grp !== BNode.grp) // label is the same, but style is not - just report this
                    logMerge(`Style: '${ANode.grp}' does not match style: '${BNode.grp}' from other map for Factor: '${ANode.label}. Existing style retained.`);
                    if (!(0, $7hmfH.objectEquals)(ANode.note, BNode.note)) {
                        // if the note is different, change it to the note from the other map
                        ANode.note = BNode.note;
                        logMerge(`Note for the Factor: '${ANode.label}' changed to the Note from the Factor in the other map`);
                        nodesToAdd.push(ANode);
                    }
                }
            } else {
                // the node is on the other map, but not on this one - add it.
                nodesToAdd.push(BNode);
                logMerge(`added new Factor: '${BNode.label}'`);
            }
        }
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToAdd);
        $a8a79648246a2e5c$var$bdata.edges.get().forEach((BEdge)=>{
            // Some edges on the other map may have been going to/from nodes that have been cloned and given a new id.
            // Clone these edges, giving them the new from: or to: node ids and make them dashed.
            let newEdge = null;
            if (newNodes.has(BEdge.from)) {
                // this edge goes from a node that has been cloned - adjust the from: id
                newEdge = (0, $7hmfH.deepCopy)(BEdge);
                newEdge.from = newNodes.get(BEdge.from);
                // it might also go to a cloned node -if so, adjust the to: id
                if (newNodes.has(newEdge.to)) newEdge.to = newNodes.get(newEdge.to);
            } else if (newNodes.has(BEdge.to)) {
                // this edge goes to a cloned node
                newEdge = (0, $7hmfH.deepCopy)(BEdge);
                newEdge.to = newNodes.get(BEdge.to);
            }
            if (newEdge) {
                // give the cloned edge a new id
                newEdge.id = (0, $7hmfH.uuidv4)();
                // make the edge dashed, red and thick
                newEdge.dashes = true;
                newEdge.width = 4;
                newEdge.color.color = 'rgb(255, 0, 0)';
                edgesToAdd.push(newEdge);
                logMerge(`added Link between new Factor(s): '${(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(newEdge.from).label}' to '${(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(newEdge.to).label}'`);
            }
            // now deal with the other map's edges
            let AEdge = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get(BEdge.id);
            if (!AEdge) {
                // check to see if there is a link in map A that goes from and to the same nodes as
                // this link in map B, although it has a different id, remembering that the map A
                // and map B nodes may have been matched by label, rather than id.
                let from = BEdge.from;
                if (substitutes.get(from)) from = substitutes.get(from);
                let to = BEdge.to;
                if (substitutes.get(to)) to = substitutes.get(to);
                const sameEdges = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().filter((e)=>e.from === from && e.to === to);
                if (sameEdges) AEdge = sameEdges[0];
            }
            if (BEdge.label && BEdge.label.trim() === '') BEdge.label = undefined;
            const edgeName = BEdge.label || `from [${$a8a79648246a2e5c$var$bdata.nodes.get(BEdge.from).label}] to [${$a8a79648246a2e5c$var$bdata.nodes.get(BEdge.to).label}]`;
            if (AEdge) {
                if ((AEdge.label && AEdge.label.trim() !== '' || BEdge.label && BEdge.label.trim() !== '') && AEdge.label !== BEdge.label) logMerge(`Link with label: '${AEdge.label}' does not match link from other map with label: '${BEdge.label}'.  Existing label retained.`);
                else {
                    if (AEdge.grp !== BEdge.grp) logMerge(`Link with style: '${AEdge.grp}' does not match style: '${BEdge.grp}' from other map for link '${edgeName}'. Existing style retained.`);
                    if (!(0, $7hmfH.objectEquals)(AEdge.note, BEdge.note)) {
                        AEdge.note = BEdge.note;
                        logMerge(`Note for Link: '${edgeName}' changed to the Note from the Link in the other map`);
                        edgesToAdd.push(AEdge);
                    }
                }
            } else {
                // if BEdge's from or to nodes have been substituted for a node in the A map
                // with the same label, change the from or to ids to the A map version
                if (substitutes.get(BEdge.from)) BEdge.from = substitutes.get(BEdge.from);
                if (substitutes.get(BEdge.to)) BEdge.to = substitutes.get(BEdge.to);
                edgesToAdd.push(BEdge);
                logMerge(`added new Link: '${edgeName}'`);
            }
        });
        // now check that all edges in the existing map are also in the other map
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.forEach((AEdge)=>{
            let BEdge = $a8a79648246a2e5c$var$bdata.edges.get(AEdge.id);
            if (!BEdge) {
                let from = AEdge.from;
                if (substitutes.get(from)) from = substitutes.get(from);
                let to = AEdge.to;
                if (substitutes.get(to)) to = substitutes.get(to);
                const sameEdges = $a8a79648246a2e5c$var$bdata.edges.get().filter((e)=>e.from === from && e.to === to);
                if (sameEdges) BEdge = sameEdges[0];
            }
        });
        (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodesToAdd);
        (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edgesToAdd);
    });
    (0, $5bc812abaa5f432b$export$e5fde6ebaea8ae1d)(history, 'Merge');
    function logMerge(action) {
        history += '<br />' + action;
    }
}
function $a8a79648246a2e5c$export$547fdf2442351faf(otherRoom) {
    $a8a79648246a2e5c$export$ac1ea0fcd93fecda(otherRoom);
    console.log('%cMerging map at %s (map A) with map at %s (map B)', 'font-weight: bold', (0, $5bc812abaa5f432b$export$f9d3fff8c23da278), otherRoom);
    $a8a79648246a2e5c$var$bwsp.on('sync', (status)=>{
        if (!status) return;
        $a8a79648246a2e5c$var$bNodesMap.forEach((n)=>$a8a79648246a2e5c$var$bdata.nodes.update(n));
        $a8a79648246a2e5c$var$bEdgesMap.forEach((e)=>$a8a79648246a2e5c$var$bdata.edges.update(e));
        $a8a79648246a2e5c$var$mergeMaps();
        $a8a79648246a2e5c$var$bwsp.disconnect();
        console.log('Finished');
    });
    return 'Please wait...';
}
/**
 * Print to console the differences between the given map and the current map
 */ function $a8a79648246a2e5c$var$diffMaps() {
    for (const BNode of $a8a79648246a2e5c$var$bdata.nodes.get()){
        if (BNode.isCluster) continue;
        // for each node in the other map
        let ANode = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(BNode.id) // see whether there is a node in this map with the same id
        ;
        if (!ANode) {
            const sameLabelNodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().filter((an)=>an.label.replace(/\s/g, '') === BNode.label.replace(/\s/g, ''));
            if (sameLabelNodes.length > 1) console.log(`%cMatching factors by label [%c${$a8a79648246a2e5c$var$inline(BNode.label)}%c], but there are two or more factors with this label in this map`, 'color: red', 'color:green', 'color:red');
            else if (sameLabelNodes.length === 1) console.log(`%cMatching factors by label [%c${$a8a79648246a2e5c$var$inline(BNode.label)}%c] because there is no pair of factors with the same id`, 'color: black', 'color:green', 'color: black');
            ANode = sameLabelNodes[0];
        }
        if (ANode) {
            // if there is, check whether the label is the same
            if (ANode.label.replace(/\s/g, '') !== BNode.label.replace(/\s/g, '')) console.log(`Factor label in map A: [%c${$a8a79648246a2e5c$var$inline(ANode.label)}%c] does not match label in map B: [%c${$a8a79648246a2e5c$var$inline(BNode.label)}%c].`, 'color:green', 'color:black', 'color:green', 'color:black');
            else if (ANode.grp !== BNode.grp) console.log(`Factor style in map A : ${ANode.grp} does not match style in map B: ${BNode.grp} for Factor: [%c${$a8a79648246a2e5c$var$inline(ANode.label)}%c]. `, 'color:green', 'color:black');
        } else // the node is on the other map, but not on this one - add it.
        console.log(`Factor: [%c${$a8a79648246a2e5c$var$inline(BNode.label)}%c] in map B is not in map A`, 'color:green', 'color:black');
    }
    // now check that all nodes in the existing map are also in the other map
    for (const ANode of (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get()){
        if (ANode.isCluster) continue;
        if (!$a8a79648246a2e5c$var$bdata.nodes.get(ANode.id)) console.log(`Factor: [%c${$a8a79648246a2e5c$var$inline(ANode.label)}%c] in map A is not in map B`, 'color:green', 'color:black');
    }
    // now deal with the other map's edges
    $a8a79648246a2e5c$var$bdata.edges.get().forEach((BEdge)=>{
        const AEdge = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get(BEdge.id);
        if (BEdge.label && BEdge.label.trim() === '') BEdge.label = undefined;
        const edgeName = BEdge.label || `[${$a8a79648246a2e5c$var$bdata.nodes.get(BEdge.from).label}] --> [${$a8a79648246a2e5c$var$bdata.nodes.get(BEdge.to).label}]`;
        if (AEdge) {
            if ((AEdge.label && AEdge.label.trim() !== '' || BEdge.label && BEdge.label.trim() !== '') && AEdge.label !== BEdge.label) console.log(`Link label in map A: [%c${$a8a79648246a2e5c$var$inline(AEdge.label)}%c] does not match label:[%c${$a8a79648246a2e5c$var$inline(BEdge.label)}%c] in map B.  `, 'color:green', 'color:black', 'color:green', 'color:black');
            else if (AEdge.grp !== BEdge.grp) console.log(`Link style: '${AEdge.grp}' in map A does not match style: '${BEdge.grp}' in map B for link [%c${$a8a79648246a2e5c$var$inline(edgeName)}%c]. `, 'color:green', 'color:black');
        } else console.log(`Map A does not include the link: %c${$a8a79648246a2e5c$var$inline(edgeName)}%c in map B. `, 'color:green', 'color:black');
    });
    // now check that all edges in the existing map are also in the other map
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.forEach((AEdge)=>{
        if (!$a8a79648246a2e5c$var$bdata.edges.get(AEdge.id)) {
            const edgeName = AEdge.label && AEdge.label.trim() !== '' || `[${(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(AEdge.from).label}] --> [${(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(AEdge.to).label}]`;
            console.log(`Link %c${$a8a79648246a2e5c$var$inline(edgeName)}%c in map A is not in map B`, 'color:green', 'color:black');
        }
    });
}
function $a8a79648246a2e5c$export$8150c7da8c1e5fc2(otherRoom) {
    $a8a79648246a2e5c$export$ac1ea0fcd93fecda(otherRoom);
    console.log('%cComparing map at %s (map A) with map at %s (map B)', 'font-weight: bold', (0, $5bc812abaa5f432b$export$f9d3fff8c23da278), otherRoom);
    $a8a79648246a2e5c$var$bwsp.on('sync', (status)=>{
        if (!status) return;
        $a8a79648246a2e5c$var$bNodesMap.forEach((n)=>$a8a79648246a2e5c$var$bdata.nodes.update(n));
        $a8a79648246a2e5c$var$bEdgesMap.forEach((e)=>$a8a79648246a2e5c$var$bdata.edges.update(e));
        $a8a79648246a2e5c$var$diffMaps();
        $a8a79648246a2e5c$var$bwsp.disconnect();
    });
    return true;
}
function $a8a79648246a2e5c$export$9d64036b9b8c0207(id) {
    if (!id) return id;
    const node = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(id);
    if (!node) return 'node not found';
    return node.label;
}
/**
 * replace all white space with single space characters
 * @param {string} label
 * @returns string
 */ function $a8a79648246a2e5c$var$inline(label) {
    return label.replace(/\s+/g, ' ').trim();
}
function $a8a79648246a2e5c$export$383e0e82785949bc() {
    const nodes = (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get();
    nodes.forEach((n)=>{
        if (n.created) n.created = undefined;
        if (n.modified) n.modified = undefined;
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.update(nodes);
    const edges = (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get();
    edges.forEach((e)=>{
        if (e.created) e.created = undefined;
        if (e.modified) e.modified = undefined;
    });
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.update(edges);
}
function $a8a79648246a2e5c$export$2cad840c32f2e04e(del = false) {
    // check all factors have labels
    (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get().forEach((n)=>{
        if (!n.label || n.label === '' || n.label.trim() === '') {
            console.log('Bad factor:', n);
            if (del) {
                (0, $5bc812abaa5f432b$export$4051a07651545597).nodes.remove(n.id);
                console.log('Deleted factor', n);
            }
        }
    });
    // check all links have existing to and from factors
    (0, $5bc812abaa5f432b$export$4051a07651545597).edges.get().forEach((e)=>{
        let ok = true;
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.from)) {
            console.log('Missing from factor', e);
            ok = false;
        }
        if (!(0, $5bc812abaa5f432b$export$4051a07651545597).nodes.get(e.to)) {
            console.log('Missing to factor', e);
            ok = false;
        }
        if (!ok && del) {
            (0, $5bc812abaa5f432b$export$4051a07651545597).edges.remove(e.id);
            console.log('Deleted edge: ', e);
        }
    });
}
window.sanityCheck = $a8a79648246a2e5c$export$2cad840c32f2e04e;



var $lvw85 = parcelRequire("lvw85");



/********************************************************************************************* 

PRSM Participatory System Mapper 

MIT License

Copyright (c) [2022] Nigel Gilbert email: prsm@prsm.uk

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This module generates responses using an LLM.  
********************************************************************************************/ 


var $7hmfH = parcelRequire("7hmfH");
// Function to send a message to the AI and get a response
async function $5b1c69f3dc1e76b0$var$chat(userMessage, systemPrompt = null) {
    try {
        // Backend API endpoint
        let API_ENDPOINT = `${(0, $5bc812abaa5f432b$export$a135e81e9a047f61)}/api/chat`;
        if (/local/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) {
            console.log('Using LOCAL AI API endpoint');
            API_ENDPOINT = 'http://localhost:3001/api/chat';
        }
        if (/prompt/.test((0, $5bc812abaa5f432b$export$1c9f709888824e05))) {
            console.log('System Prompt:', systemPrompt);
            console.log('User Message:', userMessage);
        }
        // Call backend proxy API
        const response = await fetch(`${API_ENDPOINT}/${(0, $5bc812abaa5f432b$export$f9d3fff8c23da278)}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                message: userMessage,
                systemPrompt: systemPrompt
            })
        });
        if (!response.ok) throw new Error(`${response.statusText} (${response.status})` || 'Unknown error');
        const data = await response.json();
        return data.response;
    } catch (err) {
        console.log(`ERROR: ${err.message}`);
        (0, $7hmfH.alertMsg)(`AI: ${err.message}`, 'error');
        return `Error: ${err.message}`;
    }
}
async function $5b1c69f3dc1e76b0$export$d96944eb3d865634(userMessage, systemPrompt) {
    const markdown = await $5b1c69f3dc1e76b0$var$chat(userMessage, systemPrompt);
    return (0, $9aa9f05e55106570$export$2e2bcd8739ae039)(markdown);
}



var $fmvtn = parcelRequire("fmvtn");

var $93qLg = parcelRequire("93qLg");
var $22f0b6d95e6d12d9$exports = {};

$parcel$export($22f0b6d95e6d12d9$exports, "create", () => $22f0b6d95e6d12d9$export$185802fd694ee1f5, (v) => $22f0b6d95e6d12d9$export$185802fd694ee1f5 = v);
$parcel$export($22f0b6d95e6d12d9$exports, "toCanvas", () => $22f0b6d95e6d12d9$export$f87f6982d1fd4f81, (v) => $22f0b6d95e6d12d9$export$f87f6982d1fd4f81 = v);
$parcel$export($22f0b6d95e6d12d9$exports, "toDataURL", () => $22f0b6d95e6d12d9$export$723e4939e5a27c8, (v) => $22f0b6d95e6d12d9$export$723e4939e5a27c8 = v);
$parcel$export($22f0b6d95e6d12d9$exports, "toString", () => $22f0b6d95e6d12d9$export$f84e8e69fd4488a5, (v) => $22f0b6d95e6d12d9$export$f84e8e69fd4488a5 = v);
var $22f0b6d95e6d12d9$export$185802fd694ee1f5;
var $22f0b6d95e6d12d9$export$f87f6982d1fd4f81;
var $22f0b6d95e6d12d9$export$723e4939e5a27c8;
// only svg for now.
var $22f0b6d95e6d12d9$export$f84e8e69fd4488a5;
var $17d183fcc26de4fe$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$17d183fcc26de4fe$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $a7df831c4015c6db$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $96c994fe3c36049b$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $96c994fe3c36049b$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $96c994fe3c36049b$export$ed1d66da50968976;
var $96c994fe3c36049b$export$6733b14783f975c2;
var $96c994fe3c36049b$export$ce5b1274f8597fa0;
var $96c994fe3c36049b$export$43dd553ecded716d;
let $96c994fe3c36049b$var$toSJISFunction;
const $96c994fe3c36049b$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$96c994fe3c36049b$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$96c994fe3c36049b$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $96c994fe3c36049b$var$CODEWORDS_COUNT[version];
};
$96c994fe3c36049b$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$96c994fe3c36049b$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $96c994fe3c36049b$var$toSJISFunction = f;
};
$96c994fe3c36049b$export$ce5b1274f8597fa0 = function() {
    return typeof $96c994fe3c36049b$var$toSJISFunction !== 'undefined';
};
$96c994fe3c36049b$export$43dd553ecded716d = function toSJIS(kanji) {
    return $96c994fe3c36049b$var$toSJISFunction(kanji);
};


var $924d47bf491ccdc9$export$61196ced6d74a310;
var $924d47bf491ccdc9$export$3a1a48c8f6ef640e;
var $924d47bf491ccdc9$export$3722cfe417b6ed86;
var $924d47bf491ccdc9$export$7f8ddf7c7c20b3cd;
var $924d47bf491ccdc9$export$1ea939691cdc45b8;
var $924d47bf491ccdc9$export$6788812c4e6611e6;
$924d47bf491ccdc9$export$61196ced6d74a310 = {
    bit: 1
};
$924d47bf491ccdc9$export$3a1a48c8f6ef640e = {
    bit: 0
};
$924d47bf491ccdc9$export$3722cfe417b6ed86 = {
    bit: 3
};
$924d47bf491ccdc9$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $924d47bf491ccdc9$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $924d47bf491ccdc9$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $924d47bf491ccdc9$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $924d47bf491ccdc9$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $924d47bf491ccdc9$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$924d47bf491ccdc9$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$924d47bf491ccdc9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($924d47bf491ccdc9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $924d47bf491ccdc9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $fa81f9d4f1add94e$exports = {};
function $fa81f9d4f1add94e$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$fa81f9d4f1add94e$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$fa81f9d4f1add94e$exports = $fa81f9d4f1add94e$var$BitBuffer;


var $40dc4faf18686883$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $40dc4faf18686883$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $40dc4faf18686883$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $40dc4faf18686883$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $40dc4faf18686883$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $40dc4faf18686883$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$40dc4faf18686883$exports = $40dc4faf18686883$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $a00d0031eda2e7fb$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $a00d0031eda2e7fb$export$c39457c570f2b189;

var $a00d0031eda2e7fb$require$getSymbolSize = $96c994fe3c36049b$export$8d4a06d3facd414b;
$a00d0031eda2e7fb$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $a00d0031eda2e7fb$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$a00d0031eda2e7fb$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $a00d0031eda2e7fb$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $52e17453c65ba7f3$export$c39457c570f2b189;

var $52e17453c65ba7f3$require$getSymbolSize = $96c994fe3c36049b$export$8d4a06d3facd414b;
const $52e17453c65ba7f3$var$FINDER_PATTERN_SIZE = 7;
$52e17453c65ba7f3$export$c39457c570f2b189 = function getPositions(version) {
    const size = $52e17453c65ba7f3$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $52e17453c65ba7f3$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $52e17453c65ba7f3$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $61f816dbfa8e3339$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $61f816dbfa8e3339$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $61f816dbfa8e3339$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $61f816dbfa8e3339$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $61f816dbfa8e3339$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $61f816dbfa8e3339$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $61f816dbfa8e3339$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $61f816dbfa8e3339$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $61f816dbfa8e3339$export$fe9625aaceb0e563;
$61f816dbfa8e3339$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $61f816dbfa8e3339$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$61f816dbfa8e3339$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$61f816dbfa8e3339$export$6788812c4e6611e6 = function from(value) {
    return $61f816dbfa8e3339$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$61f816dbfa8e3339$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $61f816dbfa8e3339$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $61f816dbfa8e3339$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $61f816dbfa8e3339$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $61f816dbfa8e3339$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$61f816dbfa8e3339$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $61f816dbfa8e3339$var$PenaltyScores.N2;
};
$61f816dbfa8e3339$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $61f816dbfa8e3339$var$PenaltyScores.N3;
};
$61f816dbfa8e3339$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $61f816dbfa8e3339$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $61f816dbfa8e3339$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $61f816dbfa8e3339$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$61f816dbfa8e3339$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $61f816dbfa8e3339$var$getMaskAt(pattern, row, col));
    }
};
$61f816dbfa8e3339$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($61f816dbfa8e3339$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $61f816dbfa8e3339$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $61f816dbfa8e3339$export$a5fd3a02c14d0b3e(data) + $61f816dbfa8e3339$export$9a9385107a518e46(data) + $61f816dbfa8e3339$export$ade754353f0dc75e(data) + $61f816dbfa8e3339$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $61f816dbfa8e3339$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $00f08ecf8c44702e$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $00f08ecf8c44702e$export$683d1b3e8a1a8438;

const $00f08ecf8c44702e$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $00f08ecf8c44702e$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$00f08ecf8c44702e$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $924d47bf491ccdc9$export$61196ced6d74a310:
            return $00f08ecf8c44702e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $924d47bf491ccdc9$export$3a1a48c8f6ef640e:
            return $00f08ecf8c44702e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $924d47bf491ccdc9$export$3722cfe417b6ed86:
            return $00f08ecf8c44702e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $924d47bf491ccdc9$export$7f8ddf7c7c20b3cd:
            return $00f08ecf8c44702e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$00f08ecf8c44702e$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $924d47bf491ccdc9$export$61196ced6d74a310:
            return $00f08ecf8c44702e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $924d47bf491ccdc9$export$3a1a48c8f6ef640e:
            return $00f08ecf8c44702e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $924d47bf491ccdc9$export$3722cfe417b6ed86:
            return $00f08ecf8c44702e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $924d47bf491ccdc9$export$7f8ddf7c7c20b3cd:
            return $00f08ecf8c44702e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $72e4d3f5fe7a4eca$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $7177b62aeed45919$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $7177b62aeed45919$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $7177b62aeed45919$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4258f230b301526d$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4258f230b301526d$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $4258f230b301526d$export$6e3a27864ab166fe;
const $4258f230b301526d$var$EXP_TABLE = new Uint8Array(512);
const $4258f230b301526d$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $4258f230b301526d$var$EXP_TABLE[i] = x;
        $4258f230b301526d$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$4258f230b301526d$var$EXP_TABLE[i] = $4258f230b301526d$var$EXP_TABLE[i - 255];
})();
$4258f230b301526d$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $4258f230b301526d$var$LOG_TABLE[n];
};
$4258f230b301526d$export$b310ec824aaee37f = function exp(n) {
    return $4258f230b301526d$var$EXP_TABLE[n];
};
$4258f230b301526d$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $4258f230b301526d$var$EXP_TABLE[$4258f230b301526d$var$LOG_TABLE[x] + $4258f230b301526d$var$LOG_TABLE[y]];
};


$7177b62aeed45919$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $4258f230b301526d$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$7177b62aeed45919$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $4258f230b301526d$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$7177b62aeed45919$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $7177b62aeed45919$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $4258f230b301526d$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $72e4d3f5fe7a4eca$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $72e4d3f5fe7a4eca$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $7177b62aeed45919$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $72e4d3f5fe7a4eca$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $7177b62aeed45919$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$72e4d3f5fe7a4eca$exports = $72e4d3f5fe7a4eca$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $08f64103826fd668$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $08f64103826fd668$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $08f64103826fd668$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $08f64103826fd668$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $2fd28fa141c7d3fb$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $2fd28fa141c7d3fb$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $2fd28fa141c7d3fb$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $2fd28fa141c7d3fb$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $2fd28fa141c7d3fb$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $2fd28fa141c7d3fb$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $2fd28fa141c7d3fb$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $2fd28fa141c7d3fb$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $2fd28fa141c7d3fb$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $23468e8fcd76a4c8$export$1ea939691cdc45b8;
$23468e8fcd76a4c8$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $0fc96686d7bbb163$export$a4d452c2363c8e12;
var $0fc96686d7bbb163$export$9df7c29d562bab83;
var $0fc96686d7bbb163$export$8f4bf8f7eb581284;
var $0fc96686d7bbb163$export$4d318981b5a83836;
var $0fc96686d7bbb163$export$376a9ed239d6c1c8;
var $0fc96686d7bbb163$export$175f16aef75a4569;
var $0fc96686d7bbb163$export$50b7f9bf92c74274;
var $0fc96686d7bbb163$export$4ba5f52893b4ac97;
const $0fc96686d7bbb163$var$numeric = '[0-9]+';
const $0fc96686d7bbb163$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $0fc96686d7bbb163$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$0fc96686d7bbb163$var$kanji = $0fc96686d7bbb163$var$kanji.replace(/u/g, '\\u');
const $0fc96686d7bbb163$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $0fc96686d7bbb163$var$kanji + ')(?:.|[\r\n]))+';
$0fc96686d7bbb163$export$a4d452c2363c8e12 = new RegExp($0fc96686d7bbb163$var$kanji, 'g');
$0fc96686d7bbb163$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$0fc96686d7bbb163$export$8f4bf8f7eb581284 = new RegExp($0fc96686d7bbb163$var$byte, 'g');
$0fc96686d7bbb163$export$4d318981b5a83836 = new RegExp($0fc96686d7bbb163$var$numeric, 'g');
$0fc96686d7bbb163$export$376a9ed239d6c1c8 = new RegExp($0fc96686d7bbb163$var$alphanumeric, 'g');
const $0fc96686d7bbb163$var$TEST_KANJI = new RegExp('^' + $0fc96686d7bbb163$var$kanji + '$');
const $0fc96686d7bbb163$var$TEST_NUMERIC = new RegExp('^' + $0fc96686d7bbb163$var$numeric + '$');
const $0fc96686d7bbb163$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$0fc96686d7bbb163$export$175f16aef75a4569 = function testKanji(str) {
    return $0fc96686d7bbb163$var$TEST_KANJI.test(str);
};
$0fc96686d7bbb163$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $0fc96686d7bbb163$var$TEST_NUMERIC.test(str);
};
$0fc96686d7bbb163$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $0fc96686d7bbb163$var$TEST_ALPHANUMERIC.test(str);
};


$2fd28fa141c7d3fb$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$2fd28fa141c7d3fb$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$2fd28fa141c7d3fb$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$2fd28fa141c7d3fb$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$2fd28fa141c7d3fb$export$bb410559a65d3418 = {
    bit: -1
};
$2fd28fa141c7d3fb$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$23468e8fcd76a4c8$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$2fd28fa141c7d3fb$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($0fc96686d7bbb163$export$50b7f9bf92c74274(dataStr)) return $2fd28fa141c7d3fb$export$4d318981b5a83836;
    else if ($0fc96686d7bbb163$export$4ba5f52893b4ac97(dataStr)) return $2fd28fa141c7d3fb$export$376a9ed239d6c1c8;
    else if ($0fc96686d7bbb163$export$175f16aef75a4569(dataStr)) return $2fd28fa141c7d3fb$export$a4d452c2363c8e12;
    else return $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
};
$2fd28fa141c7d3fb$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$2fd28fa141c7d3fb$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $2fd28fa141c7d3fb$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $2fd28fa141c7d3fb$export$4d318981b5a83836;
        case 'alphanumeric':
            return $2fd28fa141c7d3fb$export$376a9ed239d6c1c8;
        case 'kanji':
            return $2fd28fa141c7d3fb$export$a4d452c2363c8e12;
        case 'byte':
            return $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$2fd28fa141c7d3fb$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($2fd28fa141c7d3fb$export$1ea939691cdc45b8(value)) return value;
    try {
        return $2fd28fa141c7d3fb$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $08f64103826fd668$var$G18 = 7973;
const $08f64103826fd668$var$G18_BCH = $96c994fe3c36049b$export$ed1d66da50968976($08f64103826fd668$var$G18);
function $08f64103826fd668$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $08f64103826fd668$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $08f64103826fd668$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $2fd28fa141c7d3fb$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $08f64103826fd668$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $08f64103826fd668$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $08f64103826fd668$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $08f64103826fd668$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $08f64103826fd668$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $2fd28fa141c7d3fb$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$08f64103826fd668$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($23468e8fcd76a4c8$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$08f64103826fd668$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$23468e8fcd76a4c8$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $96c994fe3c36049b$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $00f08ecf8c44702e$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $2fd28fa141c7d3fb$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $08f64103826fd668$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $2fd28fa141c7d3fb$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $2fd28fa141c7d3fb$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $2fd28fa141c7d3fb$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $2fd28fa141c7d3fb$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$08f64103826fd668$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $924d47bf491ccdc9$export$6788812c4e6611e6(errorCorrectionLevel, $924d47bf491ccdc9$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $08f64103826fd668$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $08f64103826fd668$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$08f64103826fd668$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$23468e8fcd76a4c8$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($96c994fe3c36049b$export$ed1d66da50968976(d) - $08f64103826fd668$var$G18_BCH >= 0)d ^= $08f64103826fd668$var$G18 << $96c994fe3c36049b$export$ed1d66da50968976(d) - $08f64103826fd668$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $44d25a954a28ae7d$export$eee5438974ef6f0e;

const $44d25a954a28ae7d$var$G15 = 1335;
const $44d25a954a28ae7d$var$G15_MASK = 21522;
const $44d25a954a28ae7d$var$G15_BCH = $96c994fe3c36049b$export$ed1d66da50968976($44d25a954a28ae7d$var$G15);
$44d25a954a28ae7d$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($96c994fe3c36049b$export$ed1d66da50968976(d) - $44d25a954a28ae7d$var$G15_BCH >= 0)d ^= $44d25a954a28ae7d$var$G15 << $96c994fe3c36049b$export$ed1d66da50968976(d) - $44d25a954a28ae7d$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $44d25a954a28ae7d$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $190f57a2f70a9c99$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $190f57a2f70a9c99$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $190f57a2f70a9c99$export$89ab1afb9839589b;

var $67f37372ce1efd5d$exports = {};

function $67f37372ce1efd5d$var$NumericData(data) {
    this.mode = $2fd28fa141c7d3fb$export$4d318981b5a83836;
    this.data = data.toString();
}
$67f37372ce1efd5d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$67f37372ce1efd5d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$67f37372ce1efd5d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $67f37372ce1efd5d$var$NumericData.getBitsLength(this.data.length);
};
$67f37372ce1efd5d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$67f37372ce1efd5d$exports = $67f37372ce1efd5d$var$NumericData;


var $4eee375daeae3cb1$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $4eee375daeae3cb1$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $4eee375daeae3cb1$var$AlphanumericData(data) {
    this.mode = $2fd28fa141c7d3fb$export$376a9ed239d6c1c8;
    this.data = data;
}
$4eee375daeae3cb1$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$4eee375daeae3cb1$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4eee375daeae3cb1$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $4eee375daeae3cb1$var$AlphanumericData.getBitsLength(this.data.length);
};
$4eee375daeae3cb1$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $4eee375daeae3cb1$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $4eee375daeae3cb1$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($4eee375daeae3cb1$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$4eee375daeae3cb1$exports = $4eee375daeae3cb1$var$AlphanumericData;


var $de559d59b6f9f6f3$exports = {};

function $de559d59b6f9f6f3$var$ByteData(data) {
    this.mode = $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$de559d59b6f9f6f3$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$de559d59b6f9f6f3$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$de559d59b6f9f6f3$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $de559d59b6f9f6f3$var$ByteData.getBitsLength(this.data.length);
};
$de559d59b6f9f6f3$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$de559d59b6f9f6f3$exports = $de559d59b6f9f6f3$var$ByteData;


var $6e74ce9b0cfac980$exports = {};


function $6e74ce9b0cfac980$var$KanjiData(data) {
    this.mode = $2fd28fa141c7d3fb$export$a4d452c2363c8e12;
    this.data = data;
}
$6e74ce9b0cfac980$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$6e74ce9b0cfac980$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$6e74ce9b0cfac980$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $6e74ce9b0cfac980$var$KanjiData.getBitsLength(this.data.length);
};
$6e74ce9b0cfac980$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $96c994fe3c36049b$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$6e74ce9b0cfac980$exports = $6e74ce9b0cfac980$var$KanjiData;




var $f774a42af95e4999$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $f774a42af95e4999$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $f774a42af95e4999$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $f774a42af95e4999$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $f774a42af95e4999$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $f774a42af95e4999$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$f774a42af95e4999$exports = $f774a42af95e4999$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $190f57a2f70a9c99$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $190f57a2f70a9c99$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $190f57a2f70a9c99$var$getSegmentsFromString(dataStr) {
    const numSegs = $190f57a2f70a9c99$var$getSegments($0fc96686d7bbb163$export$4d318981b5a83836, $2fd28fa141c7d3fb$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $190f57a2f70a9c99$var$getSegments($0fc96686d7bbb163$export$376a9ed239d6c1c8, $2fd28fa141c7d3fb$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($96c994fe3c36049b$export$ce5b1274f8597fa0()) {
        byteSegs = $190f57a2f70a9c99$var$getSegments($0fc96686d7bbb163$export$8f4bf8f7eb581284, $2fd28fa141c7d3fb$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $190f57a2f70a9c99$var$getSegments($0fc96686d7bbb163$export$a4d452c2363c8e12, $2fd28fa141c7d3fb$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $190f57a2f70a9c99$var$getSegments($0fc96686d7bbb163$export$9df7c29d562bab83, $2fd28fa141c7d3fb$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $190f57a2f70a9c99$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $2fd28fa141c7d3fb$export$4d318981b5a83836:
            return $67f37372ce1efd5d$exports.getBitsLength(length);
        case $2fd28fa141c7d3fb$export$376a9ed239d6c1c8:
            return $4eee375daeae3cb1$exports.getBitsLength(length);
        case $2fd28fa141c7d3fb$export$a4d452c2363c8e12:
            return $6e74ce9b0cfac980$exports.getBitsLength(length);
        case $2fd28fa141c7d3fb$export$8f4bf8f7eb581284:
            return $de559d59b6f9f6f3$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $190f57a2f70a9c99$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $190f57a2f70a9c99$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $2fd28fa141c7d3fb$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2fd28fa141c7d3fb$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $2fd28fa141c7d3fb$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $2fd28fa141c7d3fb$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2fd28fa141c7d3fb$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $2fd28fa141c7d3fb$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2fd28fa141c7d3fb$export$8f4bf8f7eb581284,
                        length: $190f57a2f70a9c99$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $2fd28fa141c7d3fb$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $2fd28fa141c7d3fb$export$8f4bf8f7eb581284,
                        length: $190f57a2f70a9c99$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $190f57a2f70a9c99$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $190f57a2f70a9c99$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $190f57a2f70a9c99$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $190f57a2f70a9c99$var$getSegmentBitsLength(node.length, node.mode) + 4 + $2fd28fa141c7d3fb$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $190f57a2f70a9c99$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $2fd28fa141c7d3fb$export$1bd4c93ffb42e55e(data);
    mode = $2fd28fa141c7d3fb$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $2fd28fa141c7d3fb$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $2fd28fa141c7d3fb$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $2fd28fa141c7d3fb$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $2fd28fa141c7d3fb$export$a4d452c2363c8e12 && !$96c994fe3c36049b$export$ce5b1274f8597fa0()) mode = $2fd28fa141c7d3fb$export$8f4bf8f7eb581284;
    switch(mode){
        case $2fd28fa141c7d3fb$export$4d318981b5a83836:
            return new $67f37372ce1efd5d$exports(data);
        case $2fd28fa141c7d3fb$export$376a9ed239d6c1c8:
            return new $4eee375daeae3cb1$exports(data);
        case $2fd28fa141c7d3fb$export$a4d452c2363c8e12:
            return new $6e74ce9b0cfac980$exports(data);
        case $2fd28fa141c7d3fb$export$8f4bf8f7eb581284:
            return new $de559d59b6f9f6f3$exports(data);
    }
}
$190f57a2f70a9c99$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($190f57a2f70a9c99$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($190f57a2f70a9c99$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$190f57a2f70a9c99$export$3004f64547af360e = function fromString(data, version) {
    const segs = $190f57a2f70a9c99$var$getSegmentsFromString(data, $96c994fe3c36049b$export$ce5b1274f8597fa0());
    const nodes = $190f57a2f70a9c99$var$buildNodes(segs);
    const graph = $190f57a2f70a9c99$var$buildGraph(nodes, version);
    const path = $f774a42af95e4999$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $190f57a2f70a9c99$export$571d59b505e6bb4e($190f57a2f70a9c99$var$mergeSegments(optimizedSegs));
};
$190f57a2f70a9c99$export$89ab1afb9839589b = function rawSplit(data) {
    return $190f57a2f70a9c99$export$571d59b505e6bb4e($190f57a2f70a9c99$var$getSegmentsFromString(data, $96c994fe3c36049b$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a7df831c4015c6db$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $52e17453c65ba7f3$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $a7df831c4015c6db$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a7df831c4015c6db$var$setupAlignmentPattern(matrix, version) {
    const pos = $a00d0031eda2e7fb$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a7df831c4015c6db$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $08f64103826fd668$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $a7df831c4015c6db$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $44d25a954a28ae7d$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $a7df831c4015c6db$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $a7df831c4015c6db$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $fa81f9d4f1add94e$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $2fd28fa141c7d3fb$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $96c994fe3c36049b$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $00f08ecf8c44702e$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $a7df831c4015c6db$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $a7df831c4015c6db$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $96c994fe3c36049b$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $00f08ecf8c44702e$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $00f08ecf8c44702e$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $72e4d3f5fe7a4eca$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $a7df831c4015c6db$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $190f57a2f70a9c99$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $190f57a2f70a9c99$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $08f64103826fd668$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $190f57a2f70a9c99$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $08f64103826fd668$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $a7df831c4015c6db$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $96c994fe3c36049b$export$8d4a06d3facd414b(version);
    const modules = new $40dc4faf18686883$exports(moduleCount);
    // Add function modules
    $a7df831c4015c6db$var$setupFinderPattern(modules, version);
    $a7df831c4015c6db$var$setupTimingPattern(modules);
    $a7df831c4015c6db$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $a7df831c4015c6db$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $a7df831c4015c6db$var$setupVersionInfo(modules, version);
    // Add data codewords
    $a7df831c4015c6db$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $61f816dbfa8e3339$export$fe9625aaceb0e563(modules, $a7df831c4015c6db$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $61f816dbfa8e3339$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $a7df831c4015c6db$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$a7df831c4015c6db$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $924d47bf491ccdc9$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $924d47bf491ccdc9$export$6788812c4e6611e6(options.errorCorrectionLevel, $924d47bf491ccdc9$export$3a1a48c8f6ef640e);
        version = $08f64103826fd668$export$6788812c4e6611e6(options.version);
        mask = $61f816dbfa8e3339$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $96c994fe3c36049b$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $a7df831c4015c6db$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $6620f373585d881e$export$b3890eb0ae9dca99;
var $6620f373585d881e$export$c3e5526bbaf70a25;
var $4b9ed9bcbe5737bd$export$d2312e68e1f5ad00;
var $4b9ed9bcbe5737bd$export$5cdac61cf538712e;
var $4b9ed9bcbe5737bd$export$c3a1a1f268a8142b;
var $4b9ed9bcbe5737bd$export$83136f57c739c5f3;
function $4b9ed9bcbe5737bd$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$4b9ed9bcbe5737bd$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $4b9ed9bcbe5737bd$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $4b9ed9bcbe5737bd$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$4b9ed9bcbe5737bd$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$4b9ed9bcbe5737bd$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $4b9ed9bcbe5737bd$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$4b9ed9bcbe5737bd$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $4b9ed9bcbe5737bd$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $6620f373585d881e$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $6620f373585d881e$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$6620f373585d881e$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $6620f373585d881e$var$getCanvasElement();
    opts = $4b9ed9bcbe5737bd$export$d2312e68e1f5ad00(opts);
    const size = $4b9ed9bcbe5737bd$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $4b9ed9bcbe5737bd$export$83136f57c739c5f3(image.data, qrData, opts);
    $6620f373585d881e$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$6620f373585d881e$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $6620f373585d881e$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $1291e59555671a9a$export$b3890eb0ae9dca99;

function $1291e59555671a9a$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $1291e59555671a9a$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $1291e59555671a9a$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $1291e59555671a9a$var$svgCmd('M', col + margin, 0.5 + row + margin) : $1291e59555671a9a$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $1291e59555671a9a$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$1291e59555671a9a$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $4b9ed9bcbe5737bd$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $1291e59555671a9a$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $1291e59555671a9a$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $1291e59555671a9a$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $22f0b6d95e6d12d9$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$17d183fcc26de4fe$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $a7df831c4015c6db$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $a7df831c4015c6db$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$22f0b6d95e6d12d9$export$185802fd694ee1f5 = $a7df831c4015c6db$export$185802fd694ee1f5;
$22f0b6d95e6d12d9$export$f87f6982d1fd4f81 = $22f0b6d95e6d12d9$var$renderCanvas.bind(null, $6620f373585d881e$export$b3890eb0ae9dca99);
$22f0b6d95e6d12d9$export$723e4939e5a27c8 = $22f0b6d95e6d12d9$var$renderCanvas.bind(null, $6620f373585d881e$export$c3e5526bbaf70a25);
$22f0b6d95e6d12d9$export$f84e8e69fd4488a5 = $22f0b6d95e6d12d9$var$renderCanvas.bind(null, function(data, _, opts) {
    return $1291e59555671a9a$export$b3890eb0ae9dca99(data, opts);
});


const $5bc812abaa5f432b$var$appName = 'Participatory System Mapper';
const $5bc812abaa5f432b$var$shortAppName = 'PRSM';
const $5bc812abaa5f432b$var$GRIDSPACING = 50 // for snap to grid
;
const $5bc812abaa5f432b$var$NODEWIDTH = 10 // chars for label splitting
;
const $5bc812abaa5f432b$var$TIMETOSLEEP = 900000 // if no mouse movement for this time, user is assumed to have left or is sleeping
;
const $5bc812abaa5f432b$var$TIMETOEDIT = 300000 // if node/edge edit dialog is not saved after this time, the edit is cancelled
;
const $5bc812abaa5f432b$var$magnification = 3 // magnification of the loupe (magnifier 'glass')
;
const $5bc812abaa5f432b$export$4448800f068b9d2f = 20 // max. number of levels for trophic layout
;
const $5bc812abaa5f432b$var$ROLLBACKS = 15 // max. number of versions stored for rollback
;
let $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4;
let $5bc812abaa5f432b$export$f9d3fff8c23da278;
let $5bc812abaa5f432b$export$1c9f709888824e05 = '';
console.log(`${$5bc812abaa5f432b$var$appName} version ${(0, $fmvtn.version)} [features: ${(0, $fmvtn.features).ai ? 'AI' : 'no AI'}]`);
const $5bc812abaa5f432b$export$a135e81e9a047f61 = window.location.origin;
let $5bc812abaa5f432b$var$viewOnly // when true, user can only view, not modify, the network
;
let $5bc812abaa5f432b$var$showCopyMapButton = false // show the Copy Map button on the navbar in viewOnly mode
;
let $5bc812abaa5f432b$var$nodes // a dataset of nodes
;
let $5bc812abaa5f432b$var$edges // a dataset of edges
;
let $5bc812abaa5f432b$export$4051a07651545597 // an object with the nodes and edges datasets as properties
;
const $5bc812abaa5f432b$export$2a111da947c407d2 = new $eokS8.Doc();
let $5bc812abaa5f432b$export$3f859614deccc31b = 'wss://www.prsm.uk/wss' // web socket server URL
;
let $5bc812abaa5f432b$var$wsProvider // web socket provider
;
let $5bc812abaa5f432b$export$4d35f98e5d7d0978 // unique ID for this browser
;
let $5bc812abaa5f432b$var$yNodesMap // shared map of nodes
;
let $5bc812abaa5f432b$var$yEdgesMap // shared map of edges
;
let $5bc812abaa5f432b$export$4b63d58d2685a993 // shared map of styles
;
let $5bc812abaa5f432b$export$807f940a96777041 // shared map of global network settings
;
let $5bc812abaa5f432b$export$ffba1a0e51177788 // shared array of the background drawing commands
;
let $5bc812abaa5f432b$export$da7062de5ac36f9c // shared map of background objects
;
let $5bc812abaa5f432b$export$f796f85272199be2 // shared list of commands for undo
;
let $5bc812abaa5f432b$var$dontUndo // when non-null, don't add an item to the undo stack
;
let $5bc812abaa5f432b$var$yAwareness // awareness channel
;
let $5bc812abaa5f432b$export$d920e34eaf2b21cb // log of actions
;
let $5bc812abaa5f432b$export$34e0f9847d4c02dd //the DOM body element
;
let $5bc812abaa5f432b$export$4b72f5d71fff605 // the DOM pane showing the network
;
let $5bc812abaa5f432b$var$panel // the DOM right side panel element
;
let $5bc812abaa5f432b$var$myNameRec // the user's name record {actual name, type, etc.}
;
let $5bc812abaa5f432b$export$794b27baf354ffba = 'group0' // the last used node style
;
let $5bc812abaa5f432b$export$a01f2d76756b77a5 = 'edge0' // the last used edge style
;
let $5bc812abaa5f432b$var$magnifying = false // true when the magnifier is active
;
let $5bc812abaa5f432b$var$inAddMode = false // true when adding a new Factor to the network; used to choose cursor pointer
;
let $5bc812abaa5f432b$var$inEditMode = false //true when node or edge is being edited (dialog is open)
;
let $5bc812abaa5f432b$var$snapToGridToggle = false // true when snapping nodes to the (unseen) grid
;
let $5bc812abaa5f432b$export$c05995454a6ca00d = false // true when the drawing layer is uppermost
;
let $5bc812abaa5f432b$var$showNotesToggle = true // show notes when factors and links are selected
;
let $5bc812abaa5f432b$var$showVotingToggle = false // whether to show the voting thumb up/down buttons under factors
;
// if set, there are  nodes that need to be hidden when the map is drawn for the first time
const $5bc812abaa5f432b$var$hiddenNodes = {
    radiusSetting: null,
    streamSetting: null,
    pathsSetting: null,
    selected: []
};
const $5bc812abaa5f432b$var$tutorial = new (0, $94ac8045488418c1$export$2e2bcd8739ae039)() // object driving the tutorial
;
const $5bc812abaa5f432b$export$cd571ca6d1702b73 = new (0, $7hmfH.CP)() // color picker
;
let $5bc812abaa5f432b$var$checkMapSaved = false // if the map is new (no 'room' in URL), or has been imported from a file, and changes have been made, warn user before quitting
;
let $5bc812abaa5f432b$var$dirty = false // map has been changed by user and may need saving
;
let $5bc812abaa5f432b$var$followme // clientId of user's cursor to follow
;
let $5bc812abaa5f432b$var$editor = null // Quill editor
;
let $5bc812abaa5f432b$var$popupWindow = null // window for editing Notes
;
let $5bc812abaa5f432b$var$popupEditor = null // Quill editor in popup window
;
let $5bc812abaa5f432b$var$sideDrawEditor = null // Quill editor in side drawer
;
let $5bc812abaa5f432b$var$loadingDelayTimer // timer to delay the start of the loading animation for few moments
;
let $5bc812abaa5f432b$var$noServerTimer = null // timer to show no server connection message
;
let $5bc812abaa5f432b$var$netLoaded = false // becomes true when map is fully displayed
;
let $5bc812abaa5f432b$var$savedState = '' // the current state of the map (nodes, edges, network settings) before current user action
;
const $5bc812abaa5f432b$var$setupStartTime = Date.now() // time when setup started
;
/**
 * top level function to initialise everything
 */ window.addEventListener('load', ()=>{
    $5bc812abaa5f432b$var$loadingDelayTimer = setTimeout(()=>{
        (0, $7hmfH.elem)('loading').style.display = 'block';
    }, 200);
    // if no sync after half a minute, show no server connection message
    $5bc812abaa5f432b$var$noServerTimer = setTimeout(()=>{
        $5bc812abaa5f432b$var$displayNoServerWarning();
    }, 30000);
    $5bc812abaa5f432b$var$addEventListeners();
    $5bc812abaa5f432b$var$setUpPage();
    (0, $95c555713171f487$export$cf606e54e8a9990d)();
    $5bc812abaa5f432b$var$startY();
    $5bc812abaa5f432b$var$setUpUserName();
    $5bc812abaa5f432b$var$setUpAwareness();
    $5bc812abaa5f432b$var$setUpShareDialog();
    $5bc812abaa5f432b$var$draw();
    $5bc812abaa5f432b$var$setUpSamplesMap();
});
/**
 * Clean up before user departs
 */ window.onbeforeunload = function(event) {
    $5bc812abaa5f432b$var$unlockAll();
    $5bc812abaa5f432b$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'done'
    });
    $5bc812abaa5f432b$var$yAwareness.setLocalState(null);
    // get confirmation from user before exiting if there are unsaved changes
    if ($5bc812abaa5f432b$var$checkMapSaved && $5bc812abaa5f432b$var$dirty) {
        event.preventDefault();
        event.returnValue = 'You have unsaved unchanges.  Are you sure you want to leave?';
    }
};
/**
 * Display a warning that no server connection could be made
 */ function $5bc812abaa5f432b$var$displayNoServerWarning() {
    (0, $7hmfH.elem)('loading').style.display = 'none';
    clearTimeout($5bc812abaa5f432b$var$loadingDelayTimer);
    (0, $7hmfH.elem)('no-server').style.display = 'block';
    clearTimeout($5bc812abaa5f432b$var$noServerTimer);
}
/**
 * Set up all the permanent event listeners
 */ function $5bc812abaa5f432b$var$addEventListeners() {
    (0, $7hmfH.listen)('maptitle', 'keydown', (e)=>{
        // disallow Enter key
        if (e.key === 'Enter') e.preventDefault();
    });
    (0, $7hmfH.listen)('net-pane', 'keydown', (e)=>{
        if (e.which === 8 || e.which === 46) $5bc812abaa5f432b$var$deleteNode();
    });
    (0, $7hmfH.listen)('rooms-menu-caret', 'click', (0, $7f60c5bdd5f6f512$export$fb9d89ce24b70743));
    (0, $7hmfH.listen)('maptitle', 'keydown', (e)=>{
        if (e.target.innerText === 'Untitled map') window.getSelection().selectAllChildren(e.target);
    });
    (0, $7hmfH.listen)('maptitle', 'keyup', $5bc812abaa5f432b$var$mapTitle);
    (0, $7hmfH.listen)('maptitle', 'paste', $5bc812abaa5f432b$var$pasteMapTitle);
    (0, $7hmfH.listen)('maptitle', 'click', (e)=>{
        if (e.target.innerText === 'Untitled map') window.getSelection().selectAllChildren(e.target);
    });
    (0, $7hmfH.listen)('body', 'keydown', (e)=>{
        if (e.ctrlKey && e.key === 's' || e.metaKey && e.key === 's') {
            (0, $c5391cf84cf40afe$export$37a761894e599695)();
            e.preventDefault();
        }
    });
    (0, $7hmfH.listen)('body', 'keydown', (e)=>{
        if (e.ctrlKey && e.key === 'o' || e.metaKey && e.key === 'o') {
            (0, $c5391cf84cf40afe$export$c47c8b06a9966d9f)();
            e.preventDefault();
        }
    });
    (0, $7hmfH.listen)('body', 'keydown', (e)=>{
        if (e.ctrlKey && e.key === 'z' || e.metaKey && e.key === 'z') {
            $5bc812abaa5f432b$var$undo();
            e.preventDefault();
        }
    });
    (0, $7hmfH.listen)('body', 'keydown', (e)=>{
        if (e.ctrlKey && e.key === 'y' || e.metaKey && e.key === 'y') {
            $5bc812abaa5f432b$var$redo();
            e.preventDefault();
        }
    });
    (0, $7hmfH.listen)('addNode', 'click', $5bc812abaa5f432b$var$plusNode);
    (0, $7hmfH.listen)('net-pane', 'contextmenu', $5bc812abaa5f432b$var$contextMenu);
    (0, $7hmfH.listen)('net-pane', 'click', $5bc812abaa5f432b$var$unFollow);
    //listen('net-pane', 'click', removeTitleDropDown)
    (0, $7hmfH.listen)('drawer-handle', 'click', ()=>{
        (0, $7hmfH.elem)('drawer-wrapper').classList.toggle('hide-drawer');
    });
    (0, $7hmfH.listen)('addLink', 'click', $5bc812abaa5f432b$var$plusLink);
    (0, $7hmfH.listen)('deleteNode', 'click', $5bc812abaa5f432b$var$deleteNode);
    (0, $7hmfH.listen)('undo', 'click', $5bc812abaa5f432b$var$undo);
    (0, $7hmfH.listen)('redo', 'click', $5bc812abaa5f432b$var$redo);
    (0, $7hmfH.listen)('fileInput', 'change', (0, $c5391cf84cf40afe$export$12d9b7805ed59d8e));
    (0, $7hmfH.listen)('openFile', 'click', (0, $c5391cf84cf40afe$export$c47c8b06a9966d9f));
    (0, $7hmfH.listen)('replaceMap', 'click', (0, $c5391cf84cf40afe$export$c47c8b06a9966d9f));
    (0, $7hmfH.listen)('mergeMap', 'click', $5bc812abaa5f432b$var$mergeMap);
    (0, $7hmfH.listen)('merge', 'click', $5bc812abaa5f432b$var$doMerge);
    (0, $7hmfH.listen)('mergeClose', 'click', ()=>(0, $7hmfH.elem)('mergeDialog').close());
    (0, $7hmfH.listen)('saveFile', 'click', (0, $c5391cf84cf40afe$export$37a761894e599695));
    (0, $7hmfH.listen)('exportPRSM', 'click', (0, $c5391cf84cf40afe$export$37a761894e599695));
    (0, $7hmfH.listen)('exportImage', 'click', (0, $c5391cf84cf40afe$export$f0cc1c631fa5bb45));
    (0, $7hmfH.listen)('exportExcel', 'click', (0, $c5391cf84cf40afe$export$5803f461b1d4777f));
    (0, $7hmfH.listen)('exportGML', 'click', (0, $c5391cf84cf40afe$export$e680efcc3295c085));
    (0, $7hmfH.listen)('exportDOT', 'click', (0, $c5391cf84cf40afe$export$5e98004ecc179104));
    (0, $7hmfH.listen)('exportGraphML', 'click', (0, $c5391cf84cf40afe$export$71d078d741b17db4));
    (0, $7hmfH.listen)('exportGEXF', 'click', (0, $c5391cf84cf40afe$export$b3b39f9f40757282));
    (0, $7hmfH.listen)('exportNotes', 'click', (0, $c5391cf84cf40afe$export$83b54ab4d55d8ebe));
    (0, $7hmfH.listen)('copy-map', 'click', ()=>$5bc812abaa5f432b$var$doClone(false));
    (0, $7hmfH.listen)('search', 'click', $5bc812abaa5f432b$var$search);
    (0, $7hmfH.listen)('help', 'click', (0, $7hmfH.displayHelp));
    (0, $7hmfH.listen)('panelToggle', 'click', $5bc812abaa5f432b$var$togglePanel);
    (0, $7hmfH.listen)('zoom', 'change', $5bc812abaa5f432b$var$zoomnet);
    (0, $7hmfH.listen)('navbar', 'dblclick', $5bc812abaa5f432b$export$1e044b7877db048c);
    (0, $7hmfH.listen)('zoomminus', 'click', ()=>{
        $5bc812abaa5f432b$var$zoomincr(-0.1);
    });
    (0, $7hmfH.listen)('zoomplus', 'click', ()=>{
        $5bc812abaa5f432b$var$zoomincr(0.1);
    });
    (0, $7hmfH.listen)('nodesButton', 'click', (e)=>{
        $5bc812abaa5f432b$var$openTab('nodesTab', e);
    });
    (0, $7hmfH.listen)('linksButton', 'click', (e)=>{
        $5bc812abaa5f432b$var$openTab('linksTab', e);
    });
    (0, $7hmfH.listen)('networkButton', 'click', (e)=>{
        $5bc812abaa5f432b$var$openTab('networkTab', e);
    });
    (0, $7hmfH.listen)('analysisButton', 'click', (e)=>{
        $5bc812abaa5f432b$var$openTab('analysisTab', e);
    });
    (0, $7hmfH.listen)('layoutSelect', 'change', $5bc812abaa5f432b$var$autoLayout);
    (0, $7hmfH.listen)('snaptogridswitch', 'click', $5bc812abaa5f432b$var$snapToGridSwitch);
    (0, $7hmfH.listen)('curveSelect', 'change', $5bc812abaa5f432b$var$selectCurve);
    (0, $7hmfH.listen)('drawing', 'click', $5bc812abaa5f432b$var$toggleDrawingLayer);
    (0, $7hmfH.listen)('allFactors', 'click', $5bc812abaa5f432b$var$selectAllFactors);
    (0, $7hmfH.listen)('allLinks', 'click', $5bc812abaa5f432b$var$selectAllLinks);
    (0, $7hmfH.listen)('showLegendSwitch', 'click', $5bc812abaa5f432b$var$legendSwitch);
    (0, $7hmfH.listen)('showVotingSwitch', 'click', $5bc812abaa5f432b$var$votingSwitch);
    (0, $7hmfH.listen)('showUsersSwitch', 'click', $5bc812abaa5f432b$var$showUsersSwitch);
    (0, $7hmfH.listen)('showHistorySwitch', 'click', $5bc812abaa5f432b$var$showHistorySwitch);
    (0, $7hmfH.listen)('showNotesSwitch', 'click', $5bc812abaa5f432b$var$showNotesSwitch);
    (0, $7hmfH.listen)('clustering', 'change', $5bc812abaa5f432b$var$selectClustering);
    (0, $7hmfH.listen)('pin', 'click', $5bc812abaa5f432b$var$setFixed);
    (0, $7hmfH.listen)('newNodeWindow', 'click', $5bc812abaa5f432b$var$openNotesWindow);
    (0, $7hmfH.listen)('newEdgeWindow', 'click', $5bc812abaa5f432b$var$openNotesWindow);
    (0, $7hmfH.listen)('sparklesNode', 'click', $5bc812abaa5f432b$var$genAINode);
    (0, $7hmfH.listen)('sparklesEdge', 'click', $5bc812abaa5f432b$var$genAIEdge);
    (0, $7hmfH.listen)('sparklesSideNote', 'click', $5bc812abaa5f432b$var$genAISideNote);
    Array.from(document.getElementsByName('radius')).forEach((elem)=>{
        elem.addEventListener('change', $5bc812abaa5f432b$var$analyse);
    });
    Array.from(document.getElementsByName('stream')).forEach((elem)=>{
        elem.addEventListener('change', $5bc812abaa5f432b$var$analyse);
    });
    Array.from(document.getElementsByName('paths')).forEach((elem)=>{
        elem.addEventListener('change', $5bc812abaa5f432b$var$analyse);
    });
    (0, $7hmfH.listen)('sizing', 'change', $5bc812abaa5f432b$var$sizingSwitch);
    Array.from(document.getElementsByClassName('sampleNode')).forEach((elem)=>elem.addEventListener('click', (event)=>{
            $5bc812abaa5f432b$var$applySampleToNode(event);
        }));
    Array.from(document.getElementsByClassName('sampleLink')).forEach((elem)=>elem.addEventListener('click', (event)=>{
            $5bc812abaa5f432b$var$applySampleToLink(event);
        }));
    (0, $7hmfH.listen)('nodeStyleEditFactorSize', 'input', (event)=>$5bc812abaa5f432b$export$9d1298853f0e77f7(event.target));
    (0, $7hmfH.listen)('history-copy', 'click', $5bc812abaa5f432b$var$copyHistoryToClipboard);
    (0, $7hmfH.listen)('body', 'copy', $5bc812abaa5f432b$var$copyToClipboard);
    (0, $7hmfH.listen)('body', 'paste', $5bc812abaa5f432b$var$pasteFromClipboard);
    // change pointer when entering drag handles
    Array.from(document.getElementsByClassName('drag-handle')).forEach((el)=>{
        el.addEventListener('pointerenter', ()=>el.style.cursor = 'move');
        el.addEventListener('pointerout', ()=>el.style.cursor = 'auto');
    });
    // if user has changed to this  tab, ensure that the network has been drawn
    document.addEventListener('visibilitychange', ()=>{
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.redraw();
    });
}
/**
 * create all the DOM elements on the web page
 */ function $5bc812abaa5f432b$var$setUpPage() {
    (0, $7hmfH.elem)('version').innerHTML = (0, $fmvtn.version);
    $5bc812abaa5f432b$export$34e0f9847d4c02dd = (0, $7hmfH.elem)('container');
    $5bc812abaa5f432b$export$4b72f5d71fff605 = (0, $7hmfH.elem)('net-pane');
    $5bc812abaa5f432b$var$panel = (0, $7hmfH.elem)('panel');
    // check debug options set on URL: ?debug=yjs|gui|cluster|viewing|start|copyButton
    // each of these generates trace output on the console
    const searchParams = new URL(document.location).searchParams;
    if (searchParams.has('debug')) $5bc812abaa5f432b$export$1c9f709888824e05 = searchParams.get('debug');
    // don't allow user to change anything if URL includes ?viewing
    // this is now obsolete, but retained for backwards compatibility
    $5bc812abaa5f432b$var$viewOnly = searchParams.has('viewing');
    if ($5bc812abaa5f432b$var$viewOnly) $5bc812abaa5f432b$var$hideNavButtons();
    if (searchParams.has('copyButton')) $5bc812abaa5f432b$var$showCopyMapButton = true;
    // treat user as first time user if URL includes ?start=true
    if (searchParams.has('start')) localStorage.setItem('doneIntro', 'false');
    $5bc812abaa5f432b$var$panel.classList.add('hide');
    $5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden = true;
    $5bc812abaa5f432b$export$cd571ca6d1702b73.createColorPicker('netBackColorWell', $5bc812abaa5f432b$var$updateNetBack);
    $5bc812abaa5f432b$var$setUpPinchZoom();
    (0, $3ee4e83c23551e65$export$4ca77f8e2d7fc8b6)();
    $5bc812abaa5f432b$export$7ac138a1e38951d6($5bc812abaa5f432b$export$794b27baf354ffba, $5bc812abaa5f432b$export$a01f2d76756b77a5);
    $5bc812abaa5f432b$var$makeNotesPanelResizeable((0, $7hmfH.elem)('nodeNotePanel'));
    $5bc812abaa5f432b$var$makeNotesPanelResizeable((0, $7hmfH.elem)('edgeNotePanel'));
    (0, $7hmfH.dragElement)((0, $7hmfH.elem)('nodeNotePanel'), (0, $7hmfH.elem)('nodeNoteHeader'));
    (0, $7hmfH.dragElement)((0, $7hmfH.elem)('edgeNotePanel'), (0, $7hmfH.elem)('edgeNoteHeader'));
    $5bc812abaa5f432b$var$hideNotes();
    $5bc812abaa5f432b$var$setUpSideDrawer();
    // remove AI sparkle buttons if not providing AI features
    if (!(0, $fmvtn.features).ai) Array.from(document.getElementsByClassName('sparkle')).forEach((elem)=>{
        elem.style.display = 'none';
    });
    $5bc812abaa5f432b$var$displayWhatsNew();
}
const $5bc812abaa5f432b$var$sliderColor = getComputedStyle(document.documentElement).getPropertyValue('--slider');
function $5bc812abaa5f432b$export$9d1298853f0e77f7(sliderEl) {
    const sliderValue = sliderEl.value;
    sliderEl.style.background = `linear-gradient(to right, ${$5bc812abaa5f432b$var$sliderColor} ${sliderValue}%, #ccc ${sliderValue}%)`;
}
/**
 * show the What's New modal dialog unless this is a new user or user has already seen this dialog
 * for this (Major.Minor) version
 */ function $5bc812abaa5f432b$var$displayWhatsNew() {
    // new user - don't tell them what is new
    if (!localStorage.getItem('doneIntro')) return;
    const versionDecoded = (0, $fmvtn.version).match(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)/);
    const seen = localStorage.getItem('seenWN');
    if (seen) {
        const seenDecoded = seen.match(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)/);
        // if this is a new minor version, show the What's New dialog else return without showing it
        if (seenDecoded && versionDecoded[1] === seenDecoded[1] && versionDecoded[2] === seenDecoded[2]) return;
    }
    (0, $7hmfH.elem)('whatsnewversion').innerHTML = `Version ${0, $fmvtn.version}`;
    (0, $7hmfH.elem)('whatsnew').style.display = 'flex';
    (0, $7hmfH.elem)('net-pane').addEventListener('click', $5bc812abaa5f432b$var$hideWhatsNew, {
        once: true
    });
}
/**
 * hide the What's New dialog when the user has clicked Continue, and note that the user has seen it
 */ function $5bc812abaa5f432b$var$hideWhatsNew() {
    localStorage.setItem('seenWN', (0, $fmvtn.version));
    (0, $7hmfH.elem)('whatsnew').style.display = 'none';
}
/**
 * create a new shared document and start the WebSocket provider
 */ function $5bc812abaa5f432b$var$startY() {
    const url = new URL(document.location);
    // get the room number from the URL, or if none, generate a new one
    $5bc812abaa5f432b$export$f9d3fff8c23da278 = url.searchParams.get('room');
    if ($5bc812abaa5f432b$export$f9d3fff8c23da278 == null || $5bc812abaa5f432b$export$f9d3fff8c23da278 === '') {
        $5bc812abaa5f432b$export$f9d3fff8c23da278 = $5bc812abaa5f432b$var$generateRoom();
        $5bc812abaa5f432b$var$checkMapSaved = true;
        // save that this is a new room in session storage
        sessionStorage.setItem('newRoom', 'true');
        // rewrite the URL to include the room and reload from there
        console.log(`Generated new room: ${$5bc812abaa5f432b$export$f9d3fff8c23da278} and storage is ${sessionStorage.getItem('newRoom')}`);
        window.location.replace(`${window.location.origin}${window.location.pathname}?room=${$5bc812abaa5f432b$export$f9d3fff8c23da278}${$5bc812abaa5f432b$export$1c9f709888824e05 ? `&debug=${$5bc812abaa5f432b$export$1c9f709888824e05}` : ''}`);
    // NB never gets here, because of the reload
    } else $5bc812abaa5f432b$export$f9d3fff8c23da278 = $5bc812abaa5f432b$export$f9d3fff8c23da278.toUpperCase();
    // connect websocket provider
    // if debug flag includes 'local' or using a non-standard port (i.e neither 80 nor 443)
    // assume that the websocket port is 1234 in the same domain as the url
    if (/local/.test($5bc812abaa5f432b$export$1c9f709888824e05) || url.port && url.port !== 80 && url.port !== 443) $5bc812abaa5f432b$export$3f859614deccc31b = `ws://${url.hostname}:1234`;
    $5bc812abaa5f432b$var$wsProvider = new (0, $dGheI.WebsocketProvider)($5bc812abaa5f432b$export$3f859614deccc31b, `prsm${$5bc812abaa5f432b$export$f9d3fff8c23da278}`, $5bc812abaa5f432b$export$2a111da947c407d2);
    $5bc812abaa5f432b$var$wsProvider.on('synced', ()=>{
        clearTimeout($5bc812abaa5f432b$var$noServerTimer);
        // if this is a clone, load the cloned data
        $5bc812abaa5f432b$var$initiateClone();
        // (if the room already exists, wait until the map data is loaded before displaying it)
        if (sessionStorage.getItem('newRoom') && sessionStorage.getItem('newRoom') === 'false') $5bc812abaa5f432b$var$displayNetPane(`${(0, $7hmfH.exactTime)()} all content loaded from ${$5bc812abaa5f432b$export$3f859614deccc31b}`);
        else // if this is a new map, display it
        $5bc812abaa5f432b$var$displayNetPane(`${(0, $7hmfH.exactTime)()} no remote content loaded from ${$5bc812abaa5f432b$export$3f859614deccc31b}`);
        sessionStorage.setItem('newRoom', 'false');
    });
    $5bc812abaa5f432b$var$wsProvider.disconnectBc();
    $5bc812abaa5f432b$var$wsProvider.on('status', (event)=>{
        console.log(`${(0, $7hmfH.exactTime)()}${event.status}${event.status === 'connected' ? ' to' : ' from'} room ${$5bc812abaa5f432b$export$f9d3fff8c23da278} using ${$5bc812abaa5f432b$export$3f859614deccc31b}`);
    });
    /* 
  create a yMap for the nodes and one for the edges (we need two because there is no 
  guarantee that the the ids of nodes will differ from the ids of edges) 
   */ $5bc812abaa5f432b$var$yNodesMap = $5bc812abaa5f432b$export$2a111da947c407d2.getMap('nodes');
    $5bc812abaa5f432b$var$yEdgesMap = $5bc812abaa5f432b$export$2a111da947c407d2.getMap('edges');
    $5bc812abaa5f432b$export$4b63d58d2685a993 = $5bc812abaa5f432b$export$2a111da947c407d2.getMap('samples');
    $5bc812abaa5f432b$export$807f940a96777041 = $5bc812abaa5f432b$export$2a111da947c407d2.getMap('network');
    $5bc812abaa5f432b$export$ffba1a0e51177788 = $5bc812abaa5f432b$export$2a111da947c407d2.getArray('points');
    $5bc812abaa5f432b$export$da7062de5ac36f9c = $5bc812abaa5f432b$export$2a111da947c407d2.getMap('drawing');
    $5bc812abaa5f432b$export$d920e34eaf2b21cb = $5bc812abaa5f432b$export$2a111da947c407d2.getArray('history');
    $5bc812abaa5f432b$var$yAwareness = $5bc812abaa5f432b$var$wsProvider.awareness;
    /* set up observers to listen for changes in the yMaps */ $5bc812abaa5f432b$export$2a111da947c407d2.on('afterTransaction', ()=>{
        if (!$5bc812abaa5f432b$var$netLoaded) $5bc812abaa5f432b$export$1e044b7877db048c();
    });
    if (/trans/.test($5bc812abaa5f432b$export$1c9f709888824e05)) $5bc812abaa5f432b$export$2a111da947c407d2.on('afterTransaction', (tr)=>{
        console.log(`${(0, $7hmfH.exactTime)()} transaction (${JSON.stringify(tr)})  (${tr.local ? 'local' : 'remote'})`);
        console.log('netLoaded', $5bc812abaa5f432b$var$netLoaded);
        const nodesEvent = tr.changed.get($5bc812abaa5f432b$var$yNodesMap);
        if (nodesEvent) console.log(nodesEvent);
        const edgesEvent = tr.changed.get($5bc812abaa5f432b$var$yEdgesMap);
        if (edgesEvent) console.log(edgesEvent);
        const sampleEvent = tr.changed.get($5bc812abaa5f432b$export$4b63d58d2685a993);
        if (sampleEvent) console.log(sampleEvent);
        const netEvent = tr.changed.get($5bc812abaa5f432b$export$807f940a96777041);
        if (netEvent) console.log(netEvent);
    });
    $5bc812abaa5f432b$export$4d35f98e5d7d0978 = $5bc812abaa5f432b$export$2a111da947c407d2.clientID;
    console.log(`My client ID: ${$5bc812abaa5f432b$export$4d35f98e5d7d0978}`);
    /* set up the undo managers */ $5bc812abaa5f432b$export$f796f85272199be2 = new $eokS8.UndoManager([
        $5bc812abaa5f432b$var$yNodesMap,
        $5bc812abaa5f432b$var$yEdgesMap,
        $5bc812abaa5f432b$export$807f940a96777041
    ], {
        trackedOrigins: new Set([
            null
        ])
    });
    $5bc812abaa5f432b$var$dontUndo = null;
    $5bc812abaa5f432b$var$nodes = new (0, $7AcYc.DataSet)();
    $5bc812abaa5f432b$var$edges = new (0, $7AcYc.DataSet)();
    $5bc812abaa5f432b$export$4051a07651545597 = {
        nodes: $5bc812abaa5f432b$var$nodes,
        edges: $5bc812abaa5f432b$var$edges
    };
    /* 
  for convenience when debugging
   */ window.debug = $5bc812abaa5f432b$export$1c9f709888824e05;
    window.data = $5bc812abaa5f432b$export$4051a07651545597;
    window.clientID = $5bc812abaa5f432b$export$4d35f98e5d7d0978;
    window.yNodesMap = $5bc812abaa5f432b$var$yNodesMap;
    window.yEdgesMap = $5bc812abaa5f432b$var$yEdgesMap;
    window.ySamplesMap = $5bc812abaa5f432b$export$4b63d58d2685a993;
    window.yNetMap = $5bc812abaa5f432b$export$807f940a96777041;
    window.yUndoManager = $5bc812abaa5f432b$export$f796f85272199be2;
    window.yHistory = $5bc812abaa5f432b$export$d920e34eaf2b21cb;
    window.yPointsArray = $5bc812abaa5f432b$export$ffba1a0e51177788;
    window.yDrawingMap = $5bc812abaa5f432b$export$da7062de5ac36f9c;
    window.styles = (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349);
    window.yAwareness = $5bc812abaa5f432b$var$yAwareness;
    window.mergeRoom = (0, $a8a79648246a2e5c$export$547fdf2442351faf);
    window.diffRoom = (0, $a8a79648246a2e5c$export$8150c7da8c1e5fc2);
    window.wsProvider = $5bc812abaa5f432b$var$wsProvider;
    /* 
  nodes.on listens for when local nodes or edges are changed (added, updated or removed).
  If a local node is removed, the yMap is updated to broadcast to other clients that the node 
  has been deleted. If a local node is added or updated, that is also broadcast.
   */ $5bc812abaa5f432b$var$nodes.on('*', (evt, properties, origin)=>{
        $5bc812abaa5f432b$var$yjsTrace('nodes.on', `${evt}  ${JSON.stringify(properties.items)} origin: ${origin} dontUndo: ${$5bc812abaa5f432b$var$dontUndo}`);
        if (!$5bc812abaa5f432b$var$viewOnly) $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
            properties.items.forEach((id)=>{
                if (origin === null) {
                    // this is a local change
                    if (evt === 'remove') $5bc812abaa5f432b$var$yNodesMap.delete(id.toString());
                    else $5bc812abaa5f432b$var$yNodesMap.set(id.toString(), (0, $7hmfH.deepCopy)($5bc812abaa5f432b$var$nodes.get(id)));
                }
            });
        }, $5bc812abaa5f432b$var$dontUndo);
        $5bc812abaa5f432b$var$dontUndo = null;
    });
    /* 
  yNodesMap.observe listens for changes in the yMap, receiving a set of the keys that have
  had changed values.  If the change was to delete an entry, the corresponding node and all links to/from it are
  removed from the local nodes dataSet. Otherwise, if the received node differs from the local one, 
  the local node dataSet is updated (which includes adding a new node if it does not already exist locally).
   */ $5bc812abaa5f432b$var$yNodesMap.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yNodesMap.observe', evt);
        const nodesToUpdate = [];
        const nodesToRemove = [];
        for (const key of evt.keysChanged)if ($5bc812abaa5f432b$var$yNodesMap.has(key)) {
            const obj = $5bc812abaa5f432b$var$yNodesMap.get(key);
            if ((0, $7hmfH.objectEquals)(obj, {
                dummy: true
            })) continue; // skip dummy entry
            if (!(0, $7hmfH.objectEquals)(obj, $5bc812abaa5f432b$export$4051a07651545597.nodes.get(key))) {
                // fix nodes if this is a view only copy
                if ($5bc812abaa5f432b$var$viewOnly) obj.fixed = true;
                nodesToUpdate.push((0, $7hmfH.deepCopy)(obj));
                // if a note on a node is being remotely edited and is on display here, update the local note and the pin badge
                if ($5bc812abaa5f432b$var$editor && $5bc812abaa5f432b$var$editor.id === key && evt.transaction.local === false) {
                    $5bc812abaa5f432b$var$editor.setContents(obj.note);
                    (0, $7hmfH.elem)('fixed').style.display = obj.fixed ? 'inline' : 'none';
                    (0, $7hmfH.elem)('unfixed').style.display = obj.fixed ? 'none' : 'inline';
                }
            }
        } else {
            $5bc812abaa5f432b$var$hideNotes();
            if ($5bc812abaa5f432b$export$4051a07651545597.nodes.get(key)) $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(key).forEach((edge)=>nodesToRemove.push(edge));
            nodesToRemove.push(key);
        }
        if (nodesToUpdate.length > 0) $5bc812abaa5f432b$var$nodes.update(nodesToUpdate, 'remote');
        if (nodesToRemove.length > 0) $5bc812abaa5f432b$var$nodes.remove(nodesToRemove, 'remote');
        if (nodesToUpdate.length > 0 || nodesToRemove.length > 0) {
            // if user is in mid-flight adding a Factor or Link, and someone else has changed data,
            // vis-network will cancel the edit mode for this user.  Re-instate it.
            if ($5bc812abaa5f432b$var$inAddMode === 'addLink') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addEdgeMode();
            if ($5bc812abaa5f432b$var$inAddMode === 'addNode') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addNodeMode();
        }
        if (/changes/.test($5bc812abaa5f432b$export$1c9f709888824e05) && (nodesToUpdate.length > 0 || nodesToRemove.length > 0)) showChange(evt, $5bc812abaa5f432b$var$yNodesMap);
    });
    /* 
  See comments above about nodes
   */ $5bc812abaa5f432b$var$edges.on('*', (evt, properties, origin)=>{
        $5bc812abaa5f432b$var$yjsTrace('edges.on', `${evt}  ${JSON.stringify(properties.items)} origin: ${origin} dontUndo: ${$5bc812abaa5f432b$var$dontUndo}`);
        if (!$5bc812abaa5f432b$var$viewOnly) $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
            properties.items.forEach((id)=>{
                if (origin === null) {
                    if (evt === 'remove') $5bc812abaa5f432b$var$yEdgesMap.delete(id.toString());
                    else $5bc812abaa5f432b$var$yEdgesMap.set(id.toString(), (0, $7hmfH.deepCopy)($5bc812abaa5f432b$var$edges.get(id)));
                }
            });
        }, $5bc812abaa5f432b$var$dontUndo);
        $5bc812abaa5f432b$var$dontUndo = null;
    });
    $5bc812abaa5f432b$var$yEdgesMap.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yEdgesMap.observe', evt);
        const edgesToUpdate = [];
        const edgesToRemove = [];
        for (const key of evt.keysChanged)if ($5bc812abaa5f432b$var$yEdgesMap.has(key)) {
            const obj = $5bc812abaa5f432b$var$yEdgesMap.get(key);
            if ((0, $7hmfH.objectEquals)(obj, {
                dummy: true
            })) continue; // skip dummy entry
            if (!(0, $7hmfH.objectEquals)(obj, $5bc812abaa5f432b$export$4051a07651545597.edges.get(key))) {
                edgesToUpdate.push((0, $7hmfH.deepCopy)(obj));
                if ($5bc812abaa5f432b$var$editor && $5bc812abaa5f432b$var$editor.id === key && evt.transaction.local === false) $5bc812abaa5f432b$var$editor.setContents(obj.note);
            }
        } else {
            $5bc812abaa5f432b$var$hideNotes();
            edgesToRemove.push(key);
        }
        if (edgesToUpdate.length > 0) $5bc812abaa5f432b$var$edges.update(edgesToUpdate, 'remote');
        if (edgesToRemove.length > 0) $5bc812abaa5f432b$var$edges.remove(edgesToRemove, 'remote');
        if (edgesToUpdate.length > 0 || edgesToRemove.length > 0) {
            // if user is in mid-flight adding a Factor or Link, and someone else has changed data,
            // vis-network will cancel the edit mode for this user.  Re-instate it.
            if ($5bc812abaa5f432b$var$inAddMode === 'addLink') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addEdgeMode();
            if ($5bc812abaa5f432b$var$inAddMode === 'addNode') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addNodeMode();
        }
        if (/changes/.test($5bc812abaa5f432b$export$1c9f709888824e05) && (edgesToUpdate.length > 0 || edgesToRemove.length > 0)) showChange(evt, $5bc812abaa5f432b$var$yEdgesMap);
    });
    /**
   * utility trace function that prints the change in the value of a YMap property to the console
   * @param {YEvent} evt
   * @param {MapType} ymap
   */ function showChange(evt, ymap) {
        evt.changes.keys.forEach((change, key)=>{
            if (change.action === 'add') console.log(`Property "${key}" was added. 
				Initial value: `, ymap.get(key));
            else if (change.action === 'update') console.log(`Property "${key}" was updated. 
					New value: "`, ymap.get(key), `"
					Previous value: "`, change.oldValue, `" 
					Difference: "`, typeof change.oldValue === 'object' && typeof ymap.get(key) === 'object' ? (0, $2e5ed1f18cd62599$export$2e2bcd8739ae039)(change.oldValue, ymap.get(key)) : `${change.oldValue} ${ymap.get(key)}`, `"`);
            else if (change.action === 'delete') console.log(`Property "${key}" was deleted. 
				Previous value: `, change.oldValue);
        });
    }
    $5bc812abaa5f432b$export$4b63d58d2685a993.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('ySamplesMap.observe', evt);
        const nodesToUpdate = [];
        const edgesToUpdate = [];
        for (const key of evt.keysChanged){
            const sample = $5bc812abaa5f432b$export$4b63d58d2685a993.get(key);
            if (sample.node !== undefined) {
                if (!(0, $7hmfH.objectEquals)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[key], sample.node)) {
                    (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[key] = sample.node;
                    (0, $3ee4e83c23551e65$export$675fa328fb4ebccd)(key);
                    nodesToUpdate.push(key);
                }
            } else if (!(0, $7hmfH.objectEquals)((0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[key], sample.edge)) {
                (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[key] = sample.edge;
                (0, $3ee4e83c23551e65$export$e496289367e7ce52)(key);
                edgesToUpdate.push(key);
            }
        }
        if (nodesToUpdate) (0, $3ee4e83c23551e65$export$72639688f12e084)(nodesToUpdate);
        if (edgesToUpdate) (0, $3ee4e83c23551e65$export$8e108f36b8804828)(edgesToUpdate);
        if (nodesToUpdate.length > 0 || edgesToUpdate.length > 0) {
            // if user is in mid-flight adding a Factor or Link, and someone else has changed data,
            // vis-network will cancel the edit mode for this user.  Re-instate it.
            if ($5bc812abaa5f432b$var$inAddMode === 'addLink') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addEdgeMode();
            if ($5bc812abaa5f432b$var$inAddMode === 'addNode') $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addNodeMode();
        }
    });
    /*
  Map controls (those on the Network tab) are of three kinds:
  1. Those that affect only the local map and are not promulgated to other users
  e.g zoom, show drawing layer, show history
  2. Those where the control status (e.g. whether a switch is on or off) is promulgated,
  but the effect of the switch is handled by yNodesMap and yEdgesMap (e.g. Show Factors
    x links away; Size Factors to)
  3. Those whose effects are promulgated and switches controlled here by yNetMap (e.g
    Background)
  For cases 2 and 3, the functions called here must not invoke yNetMap.set() to avoid loops
  */ $5bc812abaa5f432b$export$807f940a96777041.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('YNetMap.observe', evt);
        if (evt.transaction.origin) for (const key of evt.keysChanged){
            const obj = $5bc812abaa5f432b$export$807f940a96777041.get(key);
            switch(key){
                case 'viewOnly':
                    $5bc812abaa5f432b$var$viewOnly = $5bc812abaa5f432b$var$viewOnly || obj;
                    if ($5bc812abaa5f432b$var$viewOnly) {
                        $5bc812abaa5f432b$var$hideNavButtons();
                        $5bc812abaa5f432b$export$3a86b7dfc26ebfa6();
                    }
                    break;
                case 'mapTitle':
                case 'maptitle':
                    $5bc812abaa5f432b$export$f229389f565c6b3f(obj);
                    break;
                case 'snapToGrid':
                    $5bc812abaa5f432b$export$95ff17332160327a(obj);
                    break;
                case 'curve':
                    $5bc812abaa5f432b$export$264d5714f8b2c7d8(obj);
                    break;
                case 'background':
                    $5bc812abaa5f432b$export$2e65e79124cca55d(obj);
                    break;
                case 'legend':
                    $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9(obj, false);
                    break;
                case 'voting':
                    $5bc812abaa5f432b$var$setVoting(obj);
                    break;
                case 'showNotes':
                    $5bc812abaa5f432b$var$doShowNotes(obj);
                    break;
                case 'radius':
                    $5bc812abaa5f432b$var$hiddenNodes.radiusSetting = obj.radiusSetting;
                    $5bc812abaa5f432b$var$hiddenNodes.selected = obj.selected;
                    $5bc812abaa5f432b$var$setRadioVal('radius', $5bc812abaa5f432b$var$hiddenNodes.radiusSetting);
                    break;
                case 'stream':
                    $5bc812abaa5f432b$var$hiddenNodes.streamSetting = obj.streamSetting;
                    $5bc812abaa5f432b$var$hiddenNodes.selected = obj.selected;
                    $5bc812abaa5f432b$var$setRadioVal('stream', $5bc812abaa5f432b$var$hiddenNodes.streamSetting);
                    break;
                case 'paths':
                    $5bc812abaa5f432b$var$hiddenNodes.pathsSetting = obj.pathsSetting;
                    $5bc812abaa5f432b$var$hiddenNodes.selected = obj.selected;
                    $5bc812abaa5f432b$var$setRadioVal('paths', $5bc812abaa5f432b$var$hiddenNodes.pathsSetting);
                    break;
                case 'sizing':
                    $5bc812abaa5f432b$export$9758cac25f26dd85(obj);
                    break;
                case 'hideAndStream':
                case 'linkRadius':
                    break;
                case 'factorsHiddenByStyle':
                    $5bc812abaa5f432b$var$updateFactorsOrLinksHiddenByStyle(obj);
                    break;
                case 'linksHiddenByStyle':
                    $5bc812abaa5f432b$var$updateFactorsOrLinksHiddenByStyle(obj);
                    break;
                case 'attributeTitles':
                    $5bc812abaa5f432b$export$5323aa6dd0c7006b(obj);
                    break;
                case 'cluster':
                    $5bc812abaa5f432b$export$8b2b949f916968c1(obj);
                    break;
                case 'mapDescription':
                    $5bc812abaa5f432b$export$cff30a8f7435ec50(obj);
                    break;
                case 'lastLoaded':
                case 'version':
                    break;
                default:
                    console.log('Bad key in yMapNet.observe: ', key);
            }
        }
    });
    $5bc812abaa5f432b$export$ffba1a0e51177788.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yPointsArray.observe', $5bc812abaa5f432b$export$ffba1a0e51177788.get($5bc812abaa5f432b$export$ffba1a0e51177788.length - 1));
        if (evt.transaction.local === false) (0, $95c555713171f487$export$aab3aebcdfaf4b16)($5bc812abaa5f432b$export$ffba1a0e51177788.toArray());
    });
    $5bc812abaa5f432b$export$da7062de5ac36f9c.observe((evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yDrawingMap.observe', evt);
        (0, $95c555713171f487$export$7ec610621a8fb67b)(evt);
    });
    $5bc812abaa5f432b$export$d920e34eaf2b21cb.observe(()=>{
        $5bc812abaa5f432b$var$yjsTrace('yHistory.observe', $5bc812abaa5f432b$export$d920e34eaf2b21cb.get($5bc812abaa5f432b$export$d920e34eaf2b21cb.length - 1));
        if ((0, $7hmfH.elem)('showHistorySwitch').checked) $5bc812abaa5f432b$var$showHistory();
    });
    $5bc812abaa5f432b$export$f796f85272199be2.on('stack-item-added', (evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yUndoManager.on stack-item-added', evt);
        if (/changes/.test($5bc812abaa5f432b$export$1c9f709888824e05)) evt.changedParentTypes.forEach((v)=>{
            showChange(v[0], v[0].target);
        });
        $5bc812abaa5f432b$export$e810bab53f2cc5ca();
    });
    $5bc812abaa5f432b$export$f796f85272199be2.on('stack-item-popped', (evt)=>{
        $5bc812abaa5f432b$var$yjsTrace('yUndoManager.on stack-item-popped', evt);
        if (/changes/.test($5bc812abaa5f432b$export$1c9f709888824e05)) evt.changedParentTypes.forEach((v)=>{
            showChange(v[0], v[0].target);
        });
        pruneDanglingEdges();
        $5bc812abaa5f432b$export$e810bab53f2cc5ca();
    });
    /**
   * In some slightly obscure circumstances, (specifically, client A undoes the creation of a factor that
   * client B has subsequently linked to another factor), the undo operation can result in a link that
   * has no source or destination factor.  Tracking such a situation is rather complex, so this cleans
   * up the mess without bothering about its cause.
   */ function pruneDanglingEdges() {
        $5bc812abaa5f432b$export$4051a07651545597.edges.forEach((edge)=>{
            if ($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.from) === null) {
                $5bc812abaa5f432b$var$dontUndo = 'danglingEdge';
                $5bc812abaa5f432b$export$4051a07651545597.edges.remove(edge.id);
            }
            if ($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.to) == null) {
                $5bc812abaa5f432b$var$dontUndo = 'danglingEdge';
                $5bc812abaa5f432b$export$4051a07651545597.edges.remove(edge.id);
            }
        });
    }
} // end startY()
/**
 * load cloned data from localStorage
 * if there is no clone, returns without doing anything
 */ async function $5bc812abaa5f432b$var$initiateClone() {
    try {
        const clone = await (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).getItem('clone');
        if (clone) try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).removeItem('clone');
            const state = $5bc812abaa5f432b$var$restoreState(clone);
            $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(state.options.created.action, state.options.created.actor);
        } catch (err) {
            console.log('Cant delete localForage clone key: ', err);
        }
    } catch (err) {
        console.log('Cant get localForage clone key: ', err);
    }
}
/**
 * Given a compressed binary string retrieved from local storage, restore the map state
 * @param {UTF16string} compressedState
 * @return {object} the restored state
 */ function $5bc812abaa5f432b$var$restoreState(compressedState) {
    const state = JSON.parse((0, $93qLg.decompressFromUTF16)(compressedState));
    $5bc812abaa5f432b$export$4051a07651545597.nodes.clear();
    $5bc812abaa5f432b$export$4051a07651545597.edges.clear();
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(state.nodes);
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(state.edges);
    $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
        for(const k in state.net)$5bc812abaa5f432b$export$807f940a96777041.set(k, state.net[k]);
        $5bc812abaa5f432b$var$viewOnly = state.net.viewOnly || false;
        $5bc812abaa5f432b$export$4051a07651545597.nodes.get().forEach((obj)=>obj.fixed = $5bc812abaa5f432b$var$viewOnly);
        if ($5bc812abaa5f432b$var$viewOnly) {
            $5bc812abaa5f432b$var$hideNavButtons();
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragNodes: false,
                    dragEdges: false,
                    hover: false
                }
            });
        }
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes = (0, $7hmfH.deepCopy)(state.samples.nodes);
        (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges = (0, $7hmfH.deepCopy)(state.samples.edges);
        for(const k in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes){
            $5bc812abaa5f432b$export$4b63d58d2685a993.set(k, {
                node: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[k]
            });
            (0, $3ee4e83c23551e65$export$675fa328fb4ebccd)(k);
        }
        for(const k in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges){
            $5bc812abaa5f432b$export$4b63d58d2685a993.set(k, {
                edge: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[k]
            });
            (0, $3ee4e83c23551e65$export$e496289367e7ce52)(k);
        }
        $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9(state.net.legend, true);
        if (state.paint) {
            $5bc812abaa5f432b$export$ffba1a0e51177788.delete(0, $5bc812abaa5f432b$export$ffba1a0e51177788.length);
            $5bc812abaa5f432b$export$ffba1a0e51177788.insert(0, state.paint);
        }
        if (state.drawing) {
            for(const k in state.drawing)$5bc812abaa5f432b$export$da7062de5ac36f9c.set(k, state.drawing[k]);
            (0, $95c555713171f487$export$234b64ec3262770a)();
        }
    }, 'clone');
    $5bc812abaa5f432b$export$9bc34f54445cb725();
    $5bc812abaa5f432b$export$1e044b7877db048c();
    return state;
}
/**
 * Display observed yjs event
 * @param {string} where
 * @param {object} what
 */ function $5bc812abaa5f432b$var$yjsTrace(where, what) {
    if (/yjs/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log((0, $7hmfH.exactTime)(), where, what);
}
/**
 * create a random string of the form AAA-BBB-CCC-DDD
 */ function $5bc812abaa5f432b$var$generateRoom() {
    let room = '';
    for(let i = 0; i < 4; i++){
        for(let j = 0; j < 3; j++)room += String.fromCharCode(65 + Math.floor(Math.random() * 26));
        if (i < 3) room += '-';
    }
    return room;
}
/**
 * randomly create some nodes and edges as a binary tree, mainly used for testing
 * @param {number} nNodes
 */ function $5bc812abaa5f432b$var$getRandomData(nNodes) {
    const SFNdata = (0, $7hmfH.getScaleFreeNetwork)(nNodes);
    $5bc812abaa5f432b$var$nodes.add(SFNdata.nodes);
    $5bc812abaa5f432b$var$edges.add(SFNdata.edges);
    (0, $3ee4e83c23551e65$export$72639688f12e084)([
        'group0'
    ]);
    (0, $3ee4e83c23551e65$export$8e108f36b8804828)([
        'edge0'
    ]);
    $5bc812abaa5f432b$export$f0aab65e28c411fe();
}
/**
 * Once any existing map has been loaded, fit it to the pane and reveal it
 * @param {string} msg message for console
 */ function $5bc812abaa5f432b$var$displayNetPane(msg) {
    console.log(msg);
    if (!$5bc812abaa5f432b$var$netLoaded) {
        (0, $7hmfH.elem)('loading').style.display = 'none';
        $5bc812abaa5f432b$export$1e044b7877db048c();
        $5bc812abaa5f432b$export$f229389f565c6b3f($5bc812abaa5f432b$export$807f940a96777041.get('mapTitle'));
        $5bc812abaa5f432b$export$4b72f5d71fff605.style.visibility = 'visible';
        clearTimeout($5bc812abaa5f432b$var$loadingDelayTimer);
        $5bc812abaa5f432b$export$f796f85272199be2.clear();
        $5bc812abaa5f432b$export$e810bab53f2cc5ca();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.unselectAll();
        $5bc812abaa5f432b$var$setUpTutorial();
        $5bc812abaa5f432b$var$netLoaded = true;
        $5bc812abaa5f432b$export$5dfa5433ac89eafa();
        $5bc812abaa5f432b$var$savedState = $5bc812abaa5f432b$export$fb931cd598921492();
        $5bc812abaa5f432b$var$setAnalysisButtonsFromRemote();
        $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
        $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9($5bc812abaa5f432b$export$807f940a96777041.get('legend'), false);
        console.log((0, $7hmfH.exactTime)(), `Doc size: ${(0, $7hmfH.humanSize)($eokS8.encodeStateAsUpdate($5bc812abaa5f432b$export$2a111da947c407d2).length)}, Load time: ${((Date.now() - $5bc812abaa5f432b$var$setupStartTime) / 1000).toFixed(1)}s`);
        $5bc812abaa5f432b$export$807f940a96777041.set('lastLoaded', Date.now());
        $5bc812abaa5f432b$export$807f940a96777041.set('version', (0, $fmvtn.version));
    }
}
// to handle iPad viewport sizing problem when tab bar appears and to keep panels on screen
$5bc812abaa5f432b$var$setvh();
window.onresize = function() {
    $5bc812abaa5f432b$var$setvh();
    $5bc812abaa5f432b$var$keepPaneInWindow($5bc812abaa5f432b$var$panel);
    (0, $95c555713171f487$export$59b33278b5b2fc8a)();
};
/**
 * Hack to get window size when orientation changes.  Should use screen.orientation, but this is not
 * implemented by Safari
 */ const $5bc812abaa5f432b$var$portrait = window.matchMedia('(orientation: portrait)');
$5bc812abaa5f432b$var$portrait.addEventListener('change', ()=>{
    $5bc812abaa5f432b$var$setvh();
});
/**
 * in View Only mode, hide all the Nav Bar buttons except the search button
 * and make the map title not editable
 */ function $5bc812abaa5f432b$var$hideNavButtons() {
    (0, $7hmfH.elem)('buttons').style.visibility = 'hidden';
    (0, $7hmfH.elem)('search').parentElement.style.visibility = 'visible';
    (0, $7hmfH.elem)('search').parentElement.style.borderLeft = 'none';
    if ($5bc812abaa5f432b$var$showCopyMapButton) {
        (0, $7hmfH.elem)('copy-map-button').style.display = 'block';
        (0, $7hmfH.elem)('copy-map-button').style.visibility = 'visible';
    }
    (0, $7hmfH.elem)('maptitle').contentEditable = 'false';
    if (!$5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden) {
        $5bc812abaa5f432b$var$panel.classList.add('hide');
        $5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden = true;
    }
}
/** restore all the Nav Bar buttons when leaving view only mode (e.g. when
 * going back online)
 */ function $5bc812abaa5f432b$var$showNavButtons() {
    (0, $7hmfH.elem)('buttons').style.visibility = 'visible';
    (0, $7hmfH.elem)('search').parentElement.style.visibility = 'visible';
    (0, $7hmfH.elem)('search').parentElement.style.borderLeft = '1px solid rgb(255, 255, 255)';
    (0, $7hmfH.elem)('copy-map-button').style.display = 'none';
    (0, $7hmfH.elem)('maptitle').contentEditable = 'true';
}
/**
 * cancel View Only mode (only available via the console)
 */ function $5bc812abaa5f432b$var$cancelViewOnly() {
    $5bc812abaa5f432b$var$viewOnly = false;
    $5bc812abaa5f432b$export$807f940a96777041.set('viewOnly', false);
    $5bc812abaa5f432b$var$showNavButtons();
    $5bc812abaa5f432b$export$4051a07651545597.nodes.get().forEach((obj)=>obj.fixed = false);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: true,
            hover: true
        }
    });
}
window.cancelViewOnly = $5bc812abaa5f432b$var$cancelViewOnly;
/**
 * to handle iOS weirdness in fixing the vh unit (see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/)
 */ function $5bc812abaa5f432b$var$setvh() {
    document.body.height = window.innerHeight;
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
/**
 * retrieve or generate user's name
 */ function $5bc812abaa5f432b$var$setUpUserName() {
    try {
        $5bc812abaa5f432b$var$myNameRec = JSON.parse(localStorage.getItem('myName'));
    } catch  {
        $5bc812abaa5f432b$var$myNameRec = null;
    }
    $5bc812abaa5f432b$var$saveUserName($5bc812abaa5f432b$var$myNameRec?.name ? $5bc812abaa5f432b$var$myNameRec.name : '');
    console.log(`My name: ${$5bc812abaa5f432b$var$myNameRec.name}`);
}
/**
 * Save a new user name into local storage
 * @param {String} name
 */ function $5bc812abaa5f432b$var$saveUserName(name) {
    if (name.length > 0) {
        $5bc812abaa5f432b$var$myNameRec.name = name.replace(/[&<>*"']/g, '');
        $5bc812abaa5f432b$var$myNameRec.anon = false;
    } else $5bc812abaa5f432b$var$myNameRec = (0, $7hmfH.generateName)();
    $5bc812abaa5f432b$var$myNameRec.id = $5bc812abaa5f432b$export$4d35f98e5d7d0978;
    localStorage.setItem('myName', JSON.stringify($5bc812abaa5f432b$var$myNameRec));
    $5bc812abaa5f432b$var$yAwareness.setLocalState({
        user: $5bc812abaa5f432b$var$myNameRec
    });
    $5bc812abaa5f432b$var$showAvatars();
}
/**
 * if this is the user's first time, show them how the user interface works
 */ function $5bc812abaa5f432b$var$setUpTutorial() {
    if (localStorage.getItem('doneIntro') !== 'done' && $5bc812abaa5f432b$var$viewOnly === false) {
        $5bc812abaa5f432b$var$tutorial.onexit(function() {
            localStorage.setItem('doneIntro', 'done');
        });
        $5bc812abaa5f432b$var$tutorial.onstep(0, ()=>{
            const splashNameBox = (0, $7hmfH.elem)('splashNameBox');
            const anonName = $5bc812abaa5f432b$var$myNameRec.name || (0, $7hmfH.generateName)().name;
            splashNameBox.placeholder = anonName;
            splashNameBox.focus();
            splashNameBox.addEventListener('blur', ()=>{
                $5bc812abaa5f432b$var$saveUserName(splashNameBox.value || anonName);
            });
            splashNameBox.addEventListener('keyup', (e)=>{
                if (e.key === 'Enter') splashNameBox.blur();
            });
        });
        $5bc812abaa5f432b$var$tutorial.start();
    }
}
/**
 * draw the network, after setting the vis-network options
 */ function $5bc812abaa5f432b$var$draw() {
    // for testing, you can append ?t=XXX to the URL of the page, where XXX is the number
    // of factors to include in a random network
    const url = new URL(document.location.href.toLowerCase());
    const nNodes = parseInt(url.searchParams.get('t'));
    if (nNodes) $5bc812abaa5f432b$var$getRandomData(nNodes);
    // create a network
    const options = {
        nodes: {
            chosen: {
                node: function(values, id, selected) {
                    values.shadow = selected;
                }
            }
        },
        edges: {
            chosen: {
                edge: function(values, id, selected) {
                    values.shadow = selected;
                }
            },
            smooth: {
                type: 'cubicBezier'
            }
        },
        physics: {
            enabled: false,
            stabilization: false
        },
        interaction: {
            multiselect: true,
            selectConnectedEdges: false,
            hover: false,
            hoverConnectedEdges: false,
            zoomView: false,
            tooltipDelay: 0,
            dragEdges: true
        },
        manipulation: {
            enabled: false,
            addNode: function(item, callback) {
                item.label = '';
                item = (0, $7hmfH.deepMerge)(item, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[$5bc812abaa5f432b$export$794b27baf354ffba]);
                item.grp = $5bc812abaa5f432b$export$794b27baf354ffba;
                item.created = $5bc812abaa5f432b$export$fc00ee57782020aa();
                $5bc812abaa5f432b$var$addLabel(item, $5bc812abaa5f432b$var$cancelAdd, callback);
                $5bc812abaa5f432b$var$showPressed('addNode', 'remove');
            },
            editNode: function(item, callback) {
                // for some weird reason, vis-network copies the group properties into the
                // node properties before calling this fn, which we don't want.  So we
                // revert to using the original node properties before continuing.
                item = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.id);
                item.modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
                const point = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM({
                    x: item.x,
                    y: item.y
                });
                $5bc812abaa5f432b$var$editNode(item, point, $5bc812abaa5f432b$var$cancelEdit, callback);
            },
            addEdge: function(item, callback) {
                $5bc812abaa5f432b$var$inAddMode = false;
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                    interaction: {
                        dragView: true,
                        selectable: true
                    }
                });
                $5bc812abaa5f432b$var$showPressed('addLink', 'remove');
                if (item.from === item.to) {
                    callback(null);
                    $5bc812abaa5f432b$var$stopEdit();
                    return;
                }
                if ($5bc812abaa5f432b$var$duplEdge(item.from, item.to).length > 0) {
                    (0, $7hmfH.alertMsg)('There is already a link from this Factor to the other.', 'error');
                    callback(null);
                    $5bc812abaa5f432b$var$stopEdit();
                    return;
                }
                if ($5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.from).isCluster || $5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.to).isCluster) {
                    (0, $7hmfH.alertMsg)('Links cannot be made to or from a cluster', 'error');
                    callback(null);
                    $5bc812abaa5f432b$var$stopEdit();
                    return;
                }
                item = (0, $7hmfH.deepMerge)(item, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[$5bc812abaa5f432b$export$a01f2d76756b77a5]);
                item.grp = $5bc812abaa5f432b$export$a01f2d76756b77a5;
                item.created = $5bc812abaa5f432b$export$fc00ee57782020aa();
                (0, $7hmfH.clearStatusBar)();
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'addEdge' // ensure still in Add mode, in case others have done something meanwhile
                ;
                callback(item);
                $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`added link from '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.from).label}' to '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.to).label}'`);
            },
            editEdge: {
                editWithoutDrag: function(item, callback) {
                    item = $5bc812abaa5f432b$export$4051a07651545597.edges.get(item.id);
                    item.modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
                    // find midpoint of edge
                    const point = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM({
                        x: ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getPosition(item.from).x + $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getPosition(item.to).x) / 2,
                        y: ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getPosition(item.from).y + $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getPosition(item.to).y) / 2
                    });
                    $5bc812abaa5f432b$var$editEdge(item, point, $5bc812abaa5f432b$var$cancelEdit, callback);
                }
            },
            deleteNode: function(item, callback) {
                let locked = false;
                item.nodes.forEach((nId)=>{
                    const n = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(nId);
                    if (n.locked) {
                        locked = true;
                        (0, $7hmfH.alertMsg)(`Factor '${(0, $7hmfH.shorten)(n.oldLabel)}' can't be deleted because it is locked`, 'warn');
                        callback(null);
                    }
                });
                if (locked) return;
                (0, $7hmfH.clearStatusBar)();
                $5bc812abaa5f432b$var$hideNotes();
                // delete also all the edges that link to the nodes being deleted
                item.nodes.forEach((nId)=>{
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId).forEach((eId)=>{
                        if (item.edges.indexOf(eId) === -1) item.edges.push(eId);
                    });
                });
                item.edges.forEach((edgeId)=>{
                    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`deleted link from '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId).from).label}' to '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId).to).label}'`);
                });
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.unselectAll();
                item.nodes.forEach((nodeId)=>{
                    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`deleted factor: '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(nodeId).label}'`);
                });
                callback(item);
            },
            deleteEdge: function(item, callback) {
                item.edges.forEach((edgeId)=>{
                    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`deleted link from '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId).from).label}' to '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId).to).label}'`);
                });
                callback(item);
            },
            controlNodeStyle: {
                shape: 'dot',
                color: 'red',
                size: 5,
                group: undefined
            }
        }
    };
    if ($5bc812abaa5f432b$var$viewOnly) options.interaction = {
        dragNodes: false,
        dragEdges: false,
        hover: false
    };
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4 = new (0, $8L2sr.Network)($5bc812abaa5f432b$export$4b72f5d71fff605, $5bc812abaa5f432b$export$4051a07651545597, options);
    window.network = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4;
    (0, $7hmfH.elem)('zoom').value = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
    // start with factor tab open, but hidden
    (0, $7hmfH.elem)('nodesButton').click();
    // listen for click events on the network pane
    let doubleClickTimer = null;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('click', (params)=>{
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('**click**', params);
        // if user is doing an analysis, and has clicked on a node, show the node notes
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('stream') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') {
            if (!$5bc812abaa5f432b$var$showNotesToggle) return;
            $5bc812abaa5f432b$var$hideNotes();
            const clickedNodeId = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getNodeAt(params.pointer.DOM);
            if (clickedNodeId) $5bc812abaa5f432b$var$showNodeData(clickedNodeId);
            else {
                const clickedEdgeId = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getEdgeAt(params.pointer.DOM);
                if (clickedEdgeId) $5bc812abaa5f432b$var$showEdgeData(clickedEdgeId);
            }
            return;
        }
        // if user has clicked on a portal node, open the map in another tab and go to it
        if (params.nodes.length === 1) {
            const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(params.nodes[0]);
            // tricky stuff to distinguish a single click (move to map) from a double click (edit node)
            if (node.portal && doubleClickTimer === null) doubleClickTimer = setTimeout(()=>{
                window.open(`${window.location.pathname}?room=${node.portal}`, node.portal);
                doubleClickTimer = null;
            }, 500);
        }
        // Might be a click on a thumb up/down. If so, increment the vote count
        if ($5bc812abaa5f432b$var$showVotingToggle) for (const node of $5bc812abaa5f432b$export$4051a07651545597.nodes.get()){
            const bBox = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
            const clickPos = params.pointer.canvas;
            if (clickPos.x > bBox.left && clickPos.x < bBox.right && clickPos.y > bBox.bottom && clickPos.y < bBox.bottom + 20) {
                if (clickPos.x < bBox.left + (bBox.right - bBox.left) / 2) {
                    // if user has not already voted for this, add their vote, i.e. add their clientID
                    // or if they have voted, remove it
                    if (node.thumbUp?.includes($5bc812abaa5f432b$export$4d35f98e5d7d0978)) node.thumbUp = node.thumbUp.filter((c)=>c !== $5bc812abaa5f432b$export$4d35f98e5d7d0978);
                    else if (node.thumbUp) node.thumbUp.push($5bc812abaa5f432b$export$4d35f98e5d7d0978);
                    else node.thumbUp = [
                        $5bc812abaa5f432b$export$4d35f98e5d7d0978
                    ];
                } else {
                    if (node.thumbDown?.includes($5bc812abaa5f432b$export$4d35f98e5d7d0978)) node.thumbDown = node.thumbDown.filter((c)=>c !== $5bc812abaa5f432b$export$4d35f98e5d7d0978);
                    else if (node.thumbDown) node.thumbDown.push($5bc812abaa5f432b$export$4d35f98e5d7d0978);
                    else node.thumbDown = [
                        $5bc812abaa5f432b$export$4d35f98e5d7d0978
                    ];
                }
                $5bc812abaa5f432b$export$4051a07651545597.nodes.update(node);
                return;
            }
        }
        // check for modifier keys
        const keys = params.event.pointers[0];
        if (!keys) return;
        if (keys.metaKey) {
            // if the Command key (on a Mac) is down, and the click is on a node/edge, log it to the console
            // this makes debugging easier
            if (params.nodes.length === 1) {
                const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(params.nodes[0]);
                console.log('node = ', node);
                window.node = node;
            }
            if (params.edges.length === 1) {
                const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(params.edges[0]);
                console.log('edge = ', edge);
                window.edge = edge;
            }
            return;
        }
        if (keys.ctrlKey) {
            const e = params.event.pointers[0];
            // if the Control key is down, show the magnifier
            if (!$5bc812abaa5f432b$var$inEditMode && e.ctrlKey && !$5bc812abaa5f432b$var$magnifying) showMagnifier(e);
        }
        if (keys.altKey) {
            // if the Option/ALT key is down, add a node if on the background
            if (params.nodes.length === 0 && params.edges.length === 0) {
                const pos = params.pointer.canvas;
                let item = {
                    id: (0, $7hmfH.uuidv4)(),
                    label: '',
                    x: pos.x,
                    y: pos.y
                };
                item = (0, $7hmfH.deepMerge)(item, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[$5bc812abaa5f432b$export$794b27baf354ffba]);
                item.grp = $5bc812abaa5f432b$export$794b27baf354ffba;
                $5bc812abaa5f432b$var$addLabel(item, $5bc812abaa5f432b$var$clearPopUp, function(newItem) {
                    if (newItem !== null) $5bc812abaa5f432b$export$4051a07651545597.nodes.add(newItem);
                });
            }
            // eslint-disable-next-line no-useless-return
            return;
        }
    /* if (keys.shiftKey) {
      // do nothing: Vis-network selects nodes in this mode
      return
    } */ });
    // despatch to edit a node or an edge or to fit the network on the pane
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('doubleClick', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('**doubleClick**');
        clearTimeout(doubleClickTimer);
        doubleClickTimer = null;
        if (params.nodes.length === 1) {
            if (!($5bc812abaa5f432b$var$viewOnly || $5bc812abaa5f432b$var$inEditMode)) $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.editNode();
        } else if (params.edges.length === 1) {
            if (!($5bc812abaa5f432b$var$viewOnly || $5bc812abaa5f432b$var$inEditMode)) $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.editEdgeMode();
        } else $5bc812abaa5f432b$export$1e044b7877db048c();
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('selectNode', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('selectNode', params);
        // if user is doing an analysis, do nothing
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('stream') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') return;
        // if a 'hidden' node is clicked, it is selected, but we don't want this
        // reset the selected nodes to all except the hidden one
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
            nodes: params.nodes.filter((id)=>!$5bc812abaa5f432b$export$4051a07651545597.nodes.get(id).nodeHidden),
            edges: params.edges.filter((id)=>!$5bc812abaa5f432b$export$4051a07651545597.edges.get(id).edgeHidden)
        });
        $5bc812abaa5f432b$var$showSelected();
        $5bc812abaa5f432b$var$showNodeOrEdgeData();
        $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All') $5bc812abaa5f432b$var$analyse();
        if ($5bc812abaa5f432b$var$getRadioVal('stream') !== 'All') $5bc812abaa5f432b$var$analyse();
        if ($5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') $5bc812abaa5f432b$var$analyse();
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('deselectNode', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('deselectNode', params);
        // if user is doing an analysis, do nothing, but first reselect the unselected nodes
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('stream') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') {
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
                nodes: params.previousSelection.nodes.map((node)=>node.id),
                edges: params.previousSelection.edges.map((edge)=>edge.id)
            });
            return;
        }
        // if some other node(s) are already selected, and the user has
        // clicked on one of the selected nodes, do nothing,
        // i.e reselect all the nodes previously selected
        // similarly, if the user has clicked on a 'hidden' node,
        // reselect the previous nodes and do nothing
        if (params.nodes) {
            // clicked on a node
            const prevSelIds = params.previousSelection.nodes.map((node)=>node.id);
            let hiddenEdge;
            if (params.edges.length) hiddenEdge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(params.edges[0]).edgeHidden;
            if (prevSelIds.includes(params.nodes[0]) || $5bc812abaa5f432b$export$4051a07651545597.nodes.get(params.nodes[0]).nodeHidden || hiddenEdge) {
                // reselect the previously selected nodes
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.selectNodes(params.previousSelection.nodes.map((node)=>node.id), false);
                return;
            }
        }
        $5bc812abaa5f432b$var$showSelected();
        $5bc812abaa5f432b$var$showNodeOrEdgeData();
        $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('hoverNode', function() {
        $5bc812abaa5f432b$var$changeCursor('grab');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('blurNode', function() {
        $5bc812abaa5f432b$var$changeCursor('default');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('selectEdge', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('selectEdge');
        // if user is doing an analysis, do nothing
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('stream') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') return;
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
            nodes: params.nodes.filter((id)=>!$5bc812abaa5f432b$export$4051a07651545597.nodes.get(id).nodeHidden),
            edges: params.edges.filter((id)=>!$5bc812abaa5f432b$export$4051a07651545597.edges.get(id).edgeHidden)
        });
        $5bc812abaa5f432b$var$showSelected();
        $5bc812abaa5f432b$var$showNodeOrEdgeData();
        $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('deselectEdge', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('deselectEdge');
        // if user is doing an analysis, do nothing, but first reselect the unselected nodes
        if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('stream') !== 'All' || $5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') {
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
                nodes: params.previousSelection.nodes.map((node)=>node.id),
                edges: params.previousSelection.edges.map((edge)=>edge.id)
            });
            return;
        }
        if (params.edges) {
            // clicked on an edge(see selectNode for comments)
            const prevSelIds = params.previousSelection.edges.map((edge)=>edge.id);
            if (prevSelIds.includes(params.edges[0]) || $5bc812abaa5f432b$export$4051a07651545597.edges.get(params.edges[0]).edgeHidden) {
                // reselect the previously selected edges
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.selectEdges(params.previousSelection.edges.map((edge)=>edge.id), false);
                return;
            }
        }
        $5bc812abaa5f432b$var$hideNotes();
        $5bc812abaa5f432b$var$showSelected();
        $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('oncontext', function(e) {
        const nodeId = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getNodeAt(e.pointer.DOM);
        if (nodeId) (0, $f00af92264e1701c$export$14b245ef7e84f38d)(nodeId);
    });
    let viewPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('dragStart', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('dragStart');
        viewPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
        const e = params.event.pointers[0];
        if (e.ctrlKey) {
            // if the Control key is down, show the magnifier and prevent dragging the map
            if (!$5bc812abaa5f432b$var$inEditMode && !$5bc812abaa5f432b$var$magnifying) showMagnifier(e);
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: false,
                    selectable: false
                }
            });
            return;
        }
        if (e.altKey) {
            if (!$5bc812abaa5f432b$var$inAddMode) {
                $5bc812abaa5f432b$var$removeFactorCursor();
                $5bc812abaa5f432b$var$changeCursor('crosshair');
                $5bc812abaa5f432b$var$inAddMode = 'addLink';
                $5bc812abaa5f432b$var$showPressed('addLink', 'add');
                (0, $7hmfH.statusMsg)('Now drag to the middle of the Destination factor');
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                    interaction: {
                        dragView: false,
                        selectable: false
                    }
                });
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addEdgeMode();
                return;
            }
        }
        $5bc812abaa5f432b$var$changeCursor('grabbing');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('dragging', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log(`dragging`);
        const endViewPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
        (0, $95c555713171f487$export$4ccc1b9eba0bcd20)(viewPosition.x - endViewPosition.x, viewPosition.y - endViewPosition.y);
        viewPosition = endViewPosition;
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('dragEnd', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('dragEnd');
        const endViewPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
        (0, $95c555713171f487$export$4ccc1b9eba0bcd20)(viewPosition.x - endViewPosition.x, viewPosition.y - endViewPosition.y);
        if (!$5bc812abaa5f432b$var$inEditMode && $5bc812abaa5f432b$var$magnifying) {
            closeMagnifier();
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: true,
                    selectable: true
                }
            });
        }
        const newPositions = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getPositions(params.nodes);
        $5bc812abaa5f432b$export$4051a07651545597.nodes.update($5bc812abaa5f432b$export$4051a07651545597.nodes.get(params.nodes).map((n)=>{
            n.x = newPositions[n.id].x;
            n.y = newPositions[n.id].y;
            if ($5bc812abaa5f432b$var$snapToGridToggle) $5bc812abaa5f432b$var$snapToGrid(n);
            return n;
        }));
        if (params.nodes.length > 0) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`moved factor${params.nodes.length > 1 ? 's' : ''}: '${params.nodes.map((id)=>(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(id).label)).join("', '")}'`);
        if (params.edges.length > 0) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`curved an edge`);
        $5bc812abaa5f432b$var$changeCursor('default');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('controlNodeDragging', function() {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('controlNodeDragging');
        $5bc812abaa5f432b$var$changeCursor('crosshair');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('controlNodeDragEnd', function(event) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('controlNodeDragEnd');
        if (event.controlEdge.from !== event.controlEdge.to) $5bc812abaa5f432b$var$changeCursor('default');
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('edgeCurvatureChanged', function(params) {
        if (/gui/.test($5bc812abaa5f432b$export$1c9f709888824e05)) console.log('edgeCurvatureChanged', params);
        const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(params.edgeId);
        edge.smooth = {
            type: params.type,
            roundness: params.roundness
        };
        $5bc812abaa5f432b$export$4051a07651545597.edges.update(edge);
    });
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('beforeDrawing', (ctx)=>(0, $95c555713171f487$export$dfdc6d14987fb95e)(ctx));
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('afterDrawing', (ctx)=>$5bc812abaa5f432b$var$drawBadges(ctx));
    // listen for changes to the network structure
    // and recalculate the network statistics when there is one
    $5bc812abaa5f432b$export$4051a07651545597.nodes.on('add', $5bc812abaa5f432b$export$f0aab65e28c411fe);
    $5bc812abaa5f432b$export$4051a07651545597.nodes.on('remove', $5bc812abaa5f432b$export$f0aab65e28c411fe);
    $5bc812abaa5f432b$export$4051a07651545597.edges.on('add', $5bc812abaa5f432b$export$f0aab65e28c411fe);
    $5bc812abaa5f432b$export$4051a07651545597.edges.on('remove', $5bc812abaa5f432b$export$f0aab65e28c411fe);
    /* --------------------------------------------set up the magnifier --------------------------------------------*/ const magSize = 300 // diameter of loupe
    ;
    const halfMagSize = magSize / 2.0;
    const netPaneCanvas = $5bc812abaa5f432b$export$4b72f5d71fff605.firstElementChild.firstElementChild;
    const magnifier = document.createElement('canvas');
    magnifier.width = magSize;
    magnifier.height = magSize;
    magnifier.className = 'magnifier';
    const magnifierCtx = magnifier.getContext('2d');
    magnifierCtx.fillStyle = 'white';
    $5bc812abaa5f432b$export$4b72f5d71fff605.appendChild(magnifier);
    let bigNetPane = null;
    let bigNetwork = null;
    let bigNetCanvas = null;
    let netPaneRect = null;
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('keydown', (e)=>{
        if (!$5bc812abaa5f432b$var$inEditMode && e.ctrlKey && !$5bc812abaa5f432b$var$magnifying) showMagnifier(e);
    });
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('mousemove', (e)=>{
        if ($5bc812abaa5f432b$var$magnifying && !$5bc812abaa5f432b$var$inEditMode && e.ctrlKey) showMagnifier(e);
    });
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('keyup', (e)=>{
        if (e.key === 'Control') closeMagnifier();
    });
    // ensure magnifier shows even if mouse is over the panel (e.g. when doing analysis)
    $5bc812abaa5f432b$var$panel.addEventListener('keydown', (e)=>{
        if (!$5bc812abaa5f432b$var$inEditMode && e.ctrlKey && !$5bc812abaa5f432b$var$magnifying) showMagnifier(e);
    });
    $5bc812abaa5f432b$var$panel.addEventListener('mousemove', (e)=>{
        if ($5bc812abaa5f432b$var$magnifying && !$5bc812abaa5f432b$var$inEditMode && e.ctrlKey) showMagnifier(e);
    });
    $5bc812abaa5f432b$var$panel.addEventListener('keyup', (e)=>{
        if (e.key === 'Control') closeMagnifier();
    });
    /**
   * create a copy of the network, but magnified and off screen
   */ function createMagnifier(e) {
        if (bigNetPane) {
            bigNetwork.destroy();
            bigNetPane.remove();
        }
        if ($5bc812abaa5f432b$export$c05995454a6ca00d) return;
        netPaneRect = $5bc812abaa5f432b$export$4b72f5d71fff605.getBoundingClientRect();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
        bigNetPane = document.createElement('div');
        bigNetPane.id = 'big-net-pane';
        bigNetPane.style.position = 'absolute';
        bigNetPane.style.top = '-9999px';
        bigNetPane.style.left = '-9999px';
        bigNetPane.style.width = `${$5bc812abaa5f432b$export$4b72f5d71fff605.offsetWidth * $5bc812abaa5f432b$var$magnification}px`;
        bigNetPane.style.height = `${$5bc812abaa5f432b$export$4b72f5d71fff605.offsetHeight * $5bc812abaa5f432b$var$magnification}px`;
        $5bc812abaa5f432b$export$4b72f5d71fff605.appendChild(bigNetPane);
        const bigNetData = {
            nodes: new (0, $7AcYc.DataSet)(),
            edges: new (0, $7AcYc.DataSet)()
        };
        bigNetData.nodes.add($5bc812abaa5f432b$export$4051a07651545597.nodes.get());
        bigNetData.edges.add($5bc812abaa5f432b$export$4051a07651545597.edges.get());
        bigNetwork = new (0, $8L2sr.Network)(bigNetPane, bigNetData, {
            physics: {
                enabled: false
            }
        });
        bigNetCanvas = bigNetPane.firstElementChild.firstElementChild;
        bigNetwork.on('afterDrawing', ()=>{
            $5bc812abaa5f432b$export$2c4cf0d98d0d7068(bigNetCanvas);
        });
        bigNetwork.moveTo({
            position: $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition(),
            scale: $5bc812abaa5f432b$var$magnification * $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale()
        });
        $5bc812abaa5f432b$export$4b72f5d71fff605.style.cursor = 'none';
        magnifier.style.display = 'none';
    }
    /**
   * display the loupe, centred on the mouse pointer, and fill it with
   * an image copied from the magnified network
   */ function showMagnifier(e) {
        e.preventDefault();
        if ($5bc812abaa5f432b$export$c05995454a6ca00d) return;
        $5bc812abaa5f432b$var$magnifying = true;
        if (bigNetCanvas == null) createMagnifier();
        magnifierCtx.fillRect(0, 0, magSize, magSize);
        magnifierCtx.drawImage(bigNetCanvas, (e.clientX - netPaneRect.x) * bigNetCanvas.width / netPaneCanvas.clientWidth - halfMagSize, (e.clientY - netPaneRect.y) * bigNetCanvas.height / netPaneCanvas.clientHeight - halfMagSize, magSize, magSize, 0, 0, magSize, magSize);
        magnifier.style.top = `${e.clientY - netPaneRect.y - halfMagSize}px`;
        magnifier.style.left = `${e.clientX - netPaneRect.x - halfMagSize}px`;
        magnifier.style.display = 'block';
    }
    /**
   * destroy the magnified network copy
   */ function closeMagnifier() {
        if (bigNetPane) {
            bigNetwork.destroy();
            bigNetPane.remove();
        }
        $5bc812abaa5f432b$export$4b72f5d71fff605.style.cursor = 'default';
        magnifier.style.display = 'none';
        $5bc812abaa5f432b$var$magnifying = false;
    }
} // end draw()
/**
 * set up the ySamplesMap with the node and edge styles defined in styles
 * This has to be done after the window has been drawn
 */ function $5bc812abaa5f432b$var$setUpSamplesMap() {
    for(const k in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes)$5bc812abaa5f432b$export$4b63d58d2685a993.set(k, {
        node: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[k]
    });
    for(const k in (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges)$5bc812abaa5f432b$export$4b63d58d2685a993.set(k, {
        edge: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[k]
    });
}
function $5bc812abaa5f432b$export$2c4cf0d98d0d7068(canvas) {
    const context = canvas.getContext('2d');
    context.setTransform();
    context.globalCompositeOperation = 'destination-over';
    // apply the background objects
    const backgroundCanvas = document.getElementById('underlay').firstElementChild.firstElementChild;
    context.drawImage(backgroundCanvas, 0, 0, canvas.width, canvas.height);
    // apply the background colour, if any, or white
    context.fillStyle = (0, $7hmfH.elem)('underlay').style.backgroundColor || 'rgb(255, 255, 255)';
    context.fillRect(0, 0, canvas.width, canvas.height);
    return canvas;
}
function $5bc812abaa5f432b$export$5dfa5433ac89eafa(ratio = 5) {
    let fullNetPane, fullNetwork, initialScale, initialPosition, minimapWidth, minimapHeight;
    const minimapWrapper = document.getElementById('minimapWrapper') // a div to contain the minimap
    ;
    const minimapImage = document.getElementById('minimapImage') // an img, child of minimapWrapper
    ;
    const minimapRadar = document.getElementById('minimapRadar') // a div, child of minimapWrapper
    ;
    // size the minimap
    minimapSetup();
    // set up dragging of the radar overlay
    let dragging = false // if true, ignore clicks when user is dragging radar overlay
    ;
    dragRadar();
    /**
   * Set the size of the minimap and its components
   */ function minimapSetup() {
        const { clientWidth: clientWidth, clientHeight: clientHeight } = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.body.container;
        minimapWidth = clientWidth / ratio;
        minimapHeight = clientHeight / ratio;
        minimapWrapper.style.width = `${minimapWidth}px`;
        minimapWrapper.style.height = `${minimapHeight}px`;
        minimapRadar.style.width = `${minimapWidth}px`;
        minimapRadar.style.height = `${minimapHeight}px`;
        drawMinimapImage();
        drawRadar();
    }
    /**
   * Draw a copy of the full network offscreen, then create an image of it
   * The visible network can't be used, because it may be scaled and panned, but the minimap image needs to
   * show the full network
   */ function drawMinimapImage() {
        if (!(0, $7hmfH.elem)('fullnetPane')) {
            // if the full network does not exist, create it
            fullNetPane = document.createElement('div');
            fullNetPane.style.position = 'absolute';
            fullNetPane.style.top = '-9999px';
            fullNetPane.style.left = '-9999px';
            fullNetPane.style.width = `${$5bc812abaa5f432b$export$4b72f5d71fff605.offsetWidth}px`;
            fullNetPane.style.height = `${$5bc812abaa5f432b$export$4b72f5d71fff605.offsetHeight}px`;
            fullNetPane.id = 'fullNetPane';
            $5bc812abaa5f432b$export$4b72f5d71fff605.appendChild(fullNetPane);
            fullNetwork = new (0, $8L2sr.Network)(fullNetPane, $5bc812abaa5f432b$export$4051a07651545597, {
                physics: {
                    enabled: false
                }
            });
        }
        fullNetwork.setOptions({
            edges: {
                smooth: (0, $7hmfH.elem)('curveSelect').value === 'cubicBezier'
            }
        });
        fullNetwork.fit();
        initialScale = fullNetwork.getScale();
        initialPosition = fullNetwork.getViewPosition();
        const fullNetworklCanvas = fullNetPane.firstElementChild.firstElementChild;
        fullNetwork.on('afterDrawing', ()=>{
            // make the image as a reduced version of the fullNetwork
            const tempCanvas = document.createElement('canvas');
            const tempContext = tempCanvas.getContext('2d');
            tempCanvas.width = minimapWidth;
            tempCanvas.height = minimapHeight;
            tempContext.drawImage(fullNetworklCanvas, 0, 0, minimapWidth, minimapHeight);
            minimapImage.src = tempCanvas.toDataURL();
            minimapImage.width = minimapWidth;
            minimapImage.height = minimapHeight;
        });
    }
    /**
   * Move a radar overlay on the minimap to show the current view of the network
   */ function drawRadar() {
        const scale = initialScale / $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
        // fade out the whole minimap if the network is all visible in the viewport
        // (there is no value in having a minimap in this case)
        if (scale >= 1 && networkInPane()) {
            minimapWrapper.style.display = 'none';
            return;
        } else minimapWrapper.style.display = 'block';
        const currentDOMPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition());
        const initialDOMPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM(initialPosition);
        minimapRadar.style.left = `${Math.round((currentDOMPosition.x - initialDOMPosition.x) * scale / ratio + minimapWidth * (1 - scale) / 2)}px`;
        minimapRadar.style.top = `${Math.round((currentDOMPosition.y - initialDOMPosition.y) * scale / ratio + minimapHeight * (1 - scale) / 2)}px`;
        minimapRadar.style.width = `${minimapWidth * scale}px`;
        minimapRadar.style.height = `${minimapHeight * scale}px`;
    }
    /**
   *
   * @returns {boolean} - true if the network is entirely within the viewport
   */ function networkInPane() {
        const netPaneTopLeft = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: 0,
            y: 0
        });
        const netPaneBottomRight = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: $5bc812abaa5f432b$export$4b72f5d71fff605.clientWidth,
            y: $5bc812abaa5f432b$export$4b72f5d71fff605.clientHeight
        });
        for (const nodeId of $5bc812abaa5f432b$export$4051a07651545597.nodes.getIds()){
            const boundingBox = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(nodeId);
            if (boundingBox.left < netPaneTopLeft.x) return false;
            if (boundingBox.right > netPaneBottomRight.x) return false;
            if (boundingBox.top < netPaneTopLeft.y) return false;
            if (boundingBox.bottom > netPaneBottomRight.y) return false;
        }
        return true;
    }
    /**
   * Whenever the network is resized, the minimap needs to be resized and the radar overlay moved
   */ $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('resize', ()=>{
        minimapSetup();
    });
    /**
   * Whenever the network is changed, panned or zoomed, the radar overlay needs to be moved
   */ $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('afterDrawing', ()=>{
        drawRadar();
    });
    /**
   * Set up dragging of the radar overlay
   */ function dragRadar() {
        let x, y, radarStart;
        minimapRadar.addEventListener('pointerdown', dragMouseDown);
        minimapWrapper.addEventListener('wheel', (e)=>{
            e.preventDefault();
            // reject all but vertical touch movements
            if (Math.abs(e.deltaX) <= 1) $5bc812abaa5f432b$var$zoomscroll(e);
        }, {
            passive: false
        });
        /**
     * note that the mouse is down on the radar overlay and start dragging
     * @param {event} e
     */ function dragMouseDown(e) {
            e.preventDefault();
            x = e.clientX;
            y = e.clientY;
            radarStart = {
                x: minimapRadar.offsetLeft,
                y: minimapRadar.offsetTop
            };
            minimapRadar.addEventListener('pointermove', drag);
            minimapRadar.addEventListener('pointerup', dragMouseUp);
        }
        /**
     * move the radar overlay as the mouse moves
     * @param {event} e
     */ function drag(e) {
            e.preventDefault();
            dragging = true;
            const dx = e.clientX - x;
            const dy = e.clientY - y;
            let left = radarStart.x + dx;
            let top = radarStart.y + dy;
            if (left < 0) left = 0;
            if (left + minimapRadar.offsetWidth >= minimapWidth) left = minimapWidth - minimapRadar.offsetWidth;
            if (top < 0) top = 0;
            if (top + minimapRadar.offsetHeight >= minimapHeight) top = minimapHeight - minimapRadar.offsetHeight;
            minimapRadar.style.left = `${Math.round(left)}px`;
            minimapRadar.style.top = `${Math.round(top)}px`;
            const initialDOMPosition = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM(initialPosition);
            const scale = initialScale / $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
            const radarRect = minimapRadar.getBoundingClientRect();
            const wrapperRect = minimapWrapper.getBoundingClientRect();
            const prevPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.moveTo({
                position: $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
                    x: (radarRect.left - wrapperRect.left + (radarRect.width - wrapperRect.width) / 2) * ratio / scale + initialDOMPosition.x,
                    y: (radarRect.top - wrapperRect.top + (radarRect.height - wrapperRect.height) / 2) * ratio / scale + initialDOMPosition.y
                })
            });
            // move background as well , keeping them in sync
            const newPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
            const newScale = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
            (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(1.0);
            (0, $95c555713171f487$export$4ccc1b9eba0bcd20)(prevPos.x - newPos.x, prevPos.y - newPos.y, 1.0);
            (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(newScale);
        }
        /**
     * note that the mouse is up and stop dragging
     * @param {event} e
     */ function dragMouseUp(e) {
            e.preventDefault();
            if (dragging) {
                minimapRadar.removeEventListener('pointermove', drag);
                minimapRadar.removeEventListener('pointerup', dragMouseUp);
            }
        }
    }
}
function $5bc812abaa5f432b$export$c265e176a8e0f011() {
    $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
        $5bc812abaa5f432b$export$9bc34f54445cb725();
        $5bc812abaa5f432b$var$ensureNotDrawing();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.destroy();
        $5bc812abaa5f432b$var$checkMapSaved = true;
        $5bc812abaa5f432b$export$4051a07651545597.nodes.clear();
        $5bc812abaa5f432b$export$4051a07651545597.edges.clear();
        $5bc812abaa5f432b$export$da7062de5ac36f9c.clear();
        (0, $95c555713171f487$export$67ea982130081db).clear();
        $5bc812abaa5f432b$var$draw();
    });
}
function $5bc812abaa5f432b$export$38a5743670a777eb() {
    $5bc812abaa5f432b$var$checkMapSaved = false;
    $5bc812abaa5f432b$var$dirty = false;
}
function $5bc812abaa5f432b$export$c1a1b42e4610dc4a() {
    if ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes().length > 0 || $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges().length > 0) (0, $7hmfH.elem)('deleteNode').classList.remove('disabled');
    else (0, $7hmfH.elem)('deleteNode').classList.add('disabled');
}
function $5bc812abaa5f432b$var$contextMenu(event) {
    event.preventDefault();
}
function $5bc812abaa5f432b$export$fc00ee57782020aa() {
    return {
        time: Date.now(),
        user: $5bc812abaa5f432b$var$myNameRec.name
    };
}
window.timestamp = $5bc812abaa5f432b$export$fc00ee57782020aa;
/**
 * Generate a key for a time slot in the history log
 *
 * @param {integer} time
 * @returns {string} key
 */ function $5bc812abaa5f432b$var$timekey(time) {
    return $5bc812abaa5f432b$export$f9d3fff8c23da278 + time;
}
async function $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(action, actor, dontSaveState = null) {
    const now = Date.now();
    $5bc812abaa5f432b$export$d920e34eaf2b21cb.push([
        {
            action: action,
            time: now,
            user: actor || $5bc812abaa5f432b$var$myNameRec.name
        }
    ]);
    // store the current state of the map for possible rollback
    if (!dontSaveState) await (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).setItem($5bc812abaa5f432b$var$timekey(now), $5bc812abaa5f432b$var$savedState).then(()=>{
        $5bc812abaa5f432b$var$savedState = $5bc812abaa5f432b$export$fb931cd598921492({
            viewOnly: false
        });
        // delete all but the last ROLLBACKS saved states
        for(let i = 0; i < $5bc812abaa5f432b$export$d920e34eaf2b21cb.length - $5bc812abaa5f432b$var$ROLLBACKS; i++){
            const obj = $5bc812abaa5f432b$export$d920e34eaf2b21cb.get(i);
            if (obj.time) (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).removeItem($5bc812abaa5f432b$var$timekey(obj.time));
        }
    });
    if ((0, $7hmfH.elem)('history-window').style.display === 'block') $5bc812abaa5f432b$var$showHistory();
    $5bc812abaa5f432b$var$dirty = true;
}
function $5bc812abaa5f432b$export$fb931cd598921492(options) {
    const netMap = $5bc812abaa5f432b$export$807f940a96777041.toJSON();
    netMap.viewOnly = options?.viewOnly || false;
    return (0, $93qLg.compressToUTF16)(JSON.stringify({
        nodes: $5bc812abaa5f432b$export$4051a07651545597.nodes.get(),
        edges: $5bc812abaa5f432b$export$4051a07651545597.edges.get(),
        net: netMap,
        samples: (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349),
        paint: $5bc812abaa5f432b$export$ffba1a0e51177788.toArray(),
        drawing: $5bc812abaa5f432b$export$da7062de5ac36f9c.toJSON(),
        options: options
    }));
}
/******************************************************** map notes side drawer *********************************************************/ /**
 * set up the side drawer for notes
 */ function $5bc812abaa5f432b$var$setUpSideDrawer() {
    $5bc812abaa5f432b$var$sideDrawEditor = new (0, $lvw85.default)((0, $7hmfH.elem)('drawer-editor'), {
        modules: {
            //we need to have this in HTML, to add the AI sparkle icon to the tools
            toolbar: $5bc812abaa5f432b$var$viewOnly ? null : '#sideNotesToolbar'
        },
        placeholder: 'Notes about the map',
        theme: 'snow',
        readOnly: $5bc812abaa5f432b$var$viewOnly
    });
    $5bc812abaa5f432b$var$sideDrawEditor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') $5bc812abaa5f432b$export$807f940a96777041.set('mapDescription', {
            text: (0, $7hmfH.isQuillEmpty)($5bc812abaa5f432b$var$sideDrawEditor) ? '' : $5bc812abaa5f432b$var$sideDrawEditor.getContents()
        });
    });
}
function $5bc812abaa5f432b$export$cff30a8f7435ec50(contents) {
    $5bc812abaa5f432b$var$sideDrawEditor.setContents(contents.text);
}
function $5bc812abaa5f432b$export$3a86b7dfc26ebfa6() {
    $5bc812abaa5f432b$var$sideDrawEditor.disable();
    (0, $7hmfH.elem)('drawer').firstElementChild.style.display = 'none';
}
async function $5bc812abaa5f432b$var$genAISideNote() {
    if ($5bc812abaa5f432b$export$4051a07651545597.nodes.length === 0) {
        (0, $7hmfH.alertMsg)('Add some factors and causal links to the map first', 'error');
        return;
    }
    (0, $7hmfH.alertMsg)('Processing...', 'info', true);
    $5bc812abaa5f432b$var$sideDrawEditor.setText('Processing...\n');
    const sparklesElem = (0, $7hmfH.elem)('sparklesSideNote');
    sparklesElem.classList.add('rotating');
    const causes = $5bc812abaa5f432b$export$4051a07651545597.edges.get().map((e)=>$5bc812abaa5f432b$export$4051a07651545597.nodes.get(e.from).label.replaceAll('\n', ' ') + ' causes ' + $5bc812abaa5f432b$export$4051a07651545597.nodes.get(e.to).label.replaceAll('\n', ' ')).join('; ');
    let title = (0, $7hmfH.elem)('maptitle').innerText;
    if (title === 'Untitled map') title = 'System Map';
    const aiResponse = await (0, $5b1c69f3dc1e76b0$export$d96944eb3d865634)(`I want you to generate a compact, readable narrative description of a system map.

I will provide:
\u{2022} A title for the system map.
\u{2022} A list of causal links, each given as a pair of factors in the form \u{201C}A causes B\u{201D}, where A is the cause and B is the effect.

Your task is to:
	1.	Produce a short, coherent, well-structured markdown description explaining the main dynamics of the system.
	2.	Cluster related factors, highlight feedback loops if present, and describe the overall behaviour of the system.
	3.	Avoid restating every causal link individually. Instead, synthesise them into a readable explanation.
	4.	Use bullet points where appropriate but do *not* include a title or any section headings.
	5.	Keep the description concise and accessible, suitable for a briefing note.  Use no more than 300 words.
  
Output only the final description in markdown.

Here is the title and list of causal links:
Title: >>>${title}<<<
Causal Links:
 >>>${causes}<<<`);
    $5bc812abaa5f432b$var$sideDrawEditor.setContents(aiResponse);
    $5bc812abaa5f432b$export$807f940a96777041.set('mapDescription', {
        text: $5bc812abaa5f432b$var$sideDrawEditor.getContents()
    });
    sparklesElem.classList.remove('rotating');
    (0, $7hmfH.cancelAlertMsg)();
}
/************************************************************* badges around the factors ******************************************/ const $5bc812abaa5f432b$var$noteImage = new Image();
$5bc812abaa5f432b$var$noteImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FyZC10ZXh0IiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik0xNC41IDNhLjUuNSAwIDAgMSAuNS41djlhLjUuNSAwIDAgMS0uNS41aC0xM2EuNS41IDAgMCAxLS41LS41di05YS41LjUgMCAwIDEgLjUtLjVoMTN6bS0xMy0xQTEuNSAxLjUgMCAwIDAgMCAzLjV2OUExLjUgMS41IDAgMCAwIDEuNSAxNGgxM2ExLjUgMS41IDAgMCAwIDEuNS0xLjV2LTlBMS41IDEuNSAwIDAgMCAxNC41IDJoLTEzeiIvPgogIDxwYXRoIGQ9Ik0zIDUuNWEuNS41IDAgMCAxIC41LS41aDlhLjUuNSAwIDAgMSAwIDFoLTlhLjUuNSAwIDAgMS0uNS0uNXpNMyA4YS41LjUgMCAwIDEgLjUtLjVoOWEuNS41IDAgMCAxIDAgMWgtOUEuNS41IDAgMCAxIDMgOHptMCAyLjVhLjUuNSAwIDAgMSAuNS0uNWg2YS41LjUgMCAwIDEgMCAxaC02YS41LjUgMCAwIDEtLjUtLjV6Ii8+Cjwvc3ZnPg==';
const $5bc812abaa5f432b$var$pinImage = new Image();
$5bc812abaa5f432b$var$pinImage.src = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%20class%3D%22bi%20bi-pin-fill%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20d%3D%22M4.146.146A.5.5%200%200%201%204.5%200h7a.5.5%200%200%201%20.5.5c0%20.68-.342%201.174-.646%201.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36%207.775%2013%208.527%2013%209.5a.5.5%200%200%201-.5.5h-4v4.5c0%20.276-.224%201.5-.5%201.5s-.5-1.224-.5-1.5V10h-4a.5.5%200%200%201-.5-.5c0-.973.64-1.725%201.17-2.189A6%206%200%200%201%205%206.708V2.277a3%203%200%200%201-.354-.298C4.342%201.674%204%201.179%204%20.5a.5.5%200%200%201%20.146-.354%22%2F%3E%3C%2Fsvg%3E';
const $5bc812abaa5f432b$var$thumbUpImage = new Image();
$5bc812abaa5f432b$var$thumbUpImage.src = 'data:image/svg+xml;base64,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';
const $5bc812abaa5f432b$var$thumbUpFilledImage = new Image();
$5bc812abaa5f432b$var$thumbUpFilledImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaGFuZC10aHVtYnMtdXAtZmlsbCIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBkPSJNNi45NTYgMS43NDVDNy4wMjEuODEgNy45MDguMDg3IDguODY0LjMyNWwuMjYxLjA2NmMuNDYzLjExNi44NzQuNDU2IDEuMDEyLjk2NS4yMi44MTYuNTMzIDIuNTExLjA2MiA0LjUxYTkuODQgOS44NCAwIDAgMSAuNDQzLS4wNTFjLjcxMy0uMDY1IDEuNjY5LS4wNzIgMi41MTYuMjEuNTE4LjE3My45OTQuNjgxIDEuMiAxLjI3My4xODQuNTMyLjE2IDEuMTYyLS4yMzQgMS43MzMuMDU4LjExOS4xMDMuMjQyLjEzOC4zNjMuMDc3LjI3LjExMy41NjcuMTEzLjg1NiAwIC4yODktLjAzNi41ODYtLjExMy44NTYtLjAzOS4xMzUtLjA5LjI3My0uMTYuNDA0LjE2OS4zODcuMTA3LjgxOS0uMDAzIDEuMTQ4YTMuMTYzIDMuMTYzIDAgMCAxLS40ODguOTAxYy4wNTQuMTUyLjA3Ni4zMTIuMDc2LjQ2NSAwIC4zMDUtLjA4OS42MjUtLjI1My45MTJDMTMuMSAxNS41MjIgMTIuNDM3IDE2IDExLjUgMTZIOGMtLjYwNSAwLTEuMDctLjA4MS0xLjQ2Ni0uMjE4YTQuODIgNC44MiAwIDAgMS0uOTctLjQ4NGwtLjA0OC0uMDNjLS41MDQtLjMwNy0uOTk5LS42MDktMi4wNjgtLjcyMkMyLjY4MiAxNC40NjQgMiAxMy44NDYgMiAxM1Y5YzAtLjg1LjY4NS0xLjQzMiAxLjM1Ny0xLjYxNS44NDktLjIzMiAxLjU3NC0uNzg3IDIuMTMyLTEuNDEuNTYtLjYyNy45MTQtMS4yOCAxLjAzOS0xLjYzOS4xOTktLjU3NS4zNTYtMS41MzkuNDI4LTIuNTl6Ii8+Cjwvc3ZnPg==';
const $5bc812abaa5f432b$var$thumbDownImage = new Image();
$5bc812abaa5f432b$var$thumbDownImage.src = 'data:image/svg+xml;base64,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';
const $5bc812abaa5f432b$var$thumbDownFilledImage = new Image();
$5bc812abaa5f432b$var$thumbDownFilledImage.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaGFuZC10aHVtYnMtZG93bi1maWxsIiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik02Ljk1NiAxNC41MzRjLjA2NS45MzYuOTUyIDEuNjU5IDEuOTA4IDEuNDJsLjI2MS0uMDY1YTEuMzc4IDEuMzc4IDAgMCAwIDEuMDEyLS45NjVjLjIyLS44MTYuNTMzLTIuNTEyLjA2Mi00LjUxLjEzNi4wMi4yODUuMDM3LjQ0My4wNTEuNzEzLjA2NSAxLjY2OS4wNzEgMi41MTYtLjIxMS41MTgtLjE3My45OTQtLjY4IDEuMi0xLjI3MmExLjg5NiAxLjg5NiAwIDAgMC0uMjM0LTEuNzM0Yy4wNTgtLjExOC4xMDMtLjI0Mi4xMzgtLjM2Mi4wNzctLjI3LjExMy0uNTY4LjExMy0uODU2IDAtLjI5LS4wMzYtLjU4Ni0uMTEzLS44NTdhMi4wOTQgMi4wOTQgMCAwIDAtLjE2LS40MDNjLjE2OS0uMzg3LjEwNy0uODItLjAwMy0xLjE0OWEzLjE2MiAzLjE2MiAwIDAgMC0uNDg4LS45Yy4wNTQtLjE1My4wNzYtLjMxMy4wNzYtLjQ2NWExLjg2IDEuODYgMCAwIDAtLjI1My0uOTEyQzEzLjEuNzU3IDEyLjQzNy4yOCAxMS41LjI4SDhjLS42MDUgMC0xLjA3LjA4LTEuNDY2LjIxN2E0LjgyMyA0LjgyMyAwIDAgMC0uOTcuNDg1bC0uMDQ4LjAyOWMtLjUwNC4zMDgtLjk5OS42MS0yLjA2OC43MjNDMi42ODIgMS44MTUgMiAyLjQzNCAyIDMuMjc5djRjMCAuODUxLjY4NSAxLjQzMyAxLjM1NyAxLjYxNi44NDkuMjMyIDEuNTc0Ljc4NyAyLjEzMiAxLjQxLjU2LjYyNi45MTQgMS4yOCAxLjAzOSAxLjYzOC4xOTkuNTc1LjM1NiAxLjU0LjQyOCAyLjU5MXoiLz4KPC9zdmc+';
/**
 * draw badges (icons) around Factors and Links
 * @param {CanvasRenderingContext2D} ctx NetPane canvas context
 */ function $5bc812abaa5f432b$var$drawBadges(ctx) {
    // pin for pinned factors
    if (!$5bc812abaa5f432b$var$viewOnly) // for a view only map, factors are always pinned, so don't bother with pin badges
    $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((node)=>!node.nodeHidden && node.fixed && !node.clusteredIn).forEach((node)=>{
        const box = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
        drawTheBadge($5bc812abaa5f432b$var$pinImage, ctx, box.left - 10, box.top);
    });
    // note card for Factors and Links with Notes
    $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((node)=>!node.hidden && !node.nodeHidden && node.note && node.note !== 'Notes' && !node.clusteredIn && $5bc812abaa5f432b$var$showNotesToggle).forEach((node)=>{
        const box = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
        drawTheBadge($5bc812abaa5f432b$var$noteImage, ctx, box.right, box.top);
    });
    // an edge note badge is placed where a middle arrow would be
    const changedEdges = [];
    $5bc812abaa5f432b$export$4051a07651545597.edges.get().forEach((edge)=>{
        if (!edge.edgeHidden && edge.note && edge.note !== 'Notes' && edge.arrows && edge.arrows.middle && !edge.arrows.middle.enabled && $5bc812abaa5f432b$var$showNotesToggle) {
            // there is a note, but the badge is not shown, so show it
            changedEdges.push(edge);
            edge.arrows.middle.enabled = true;
            edge.arrows.middle.type = 'image';
            edge.arrows.middle.src = $5bc812abaa5f432b$var$noteImage.src;
        } else if ((!edge.note || edge.note && edge.note === 'Notes' || edge.edgeHidden || !$5bc812abaa5f432b$var$showNotesToggle) && edge.arrows && edge.arrows.middle && edge.arrows.middle.enabled) {
            // there is not a note, but the badge is shown, so remove it
            changedEdges.push(edge);
            edge.arrows.middle.enabled = false;
        }
    });
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(changedEdges);
    // draw the voting thumbs up/down (but not for nodes inside a cluster, or for cluster nodes)
    if ($5bc812abaa5f432b$var$showVotingToggle) $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((node)=>!node.hidden && !node.nodeHidden && !node.clusteredIn && !node.isCluster).forEach((node)=>{
        const box = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(node.id);
        drawTheBadge(node.thumbUp?.includes($5bc812abaa5f432b$export$4d35f98e5d7d0978) ? $5bc812abaa5f432b$var$thumbUpFilledImage : $5bc812abaa5f432b$var$thumbUpImage, ctx, box.left + 20, box.bottom);
        drawThumbCount(ctx, node.thumbUp, box.left + 36, box.bottom + 10);
        drawTheBadge(node.thumbDown?.includes($5bc812abaa5f432b$export$4d35f98e5d7d0978) ? $5bc812abaa5f432b$var$thumbDownFilledImage : $5bc812abaa5f432b$var$thumbDownImage, ctx, box.right - 36, box.bottom);
        drawThumbCount(ctx, node.thumbDown, box.right - 20, box.bottom + 10);
    });
    /**
   *
   * @param {image} badgeImage
   * @param {context} ctx
   * @param {number} x
   * @param {number} y
   */ function drawTheBadge(badgeImage, ctx, x, y) {
        ctx.beginPath();
        ctx.drawImage(badgeImage, Math.floor(x), Math.floor(y));
    }
    /**
   * draw the length of the voters array, i.e. the count of those who have voted
   * @param {context} ctx
   * @param {array} voters
   * @param {number} x
   * @param {number} y
   */ function drawThumbCount(ctx, voters, x, y) {
        if (voters) {
            ctx.beginPath();
            ctx.fillStyle = 'black';
            ctx.fillText(voters.length.toString(), x, y);
        }
    }
}
/**
 * Move the node to the nearest spot that it on the grid
 * @param {object} node
 */ function $5bc812abaa5f432b$var$snapToGrid(node) {
    node.x = $5bc812abaa5f432b$var$GRIDSPACING * Math.round(node.x / $5bc812abaa5f432b$var$GRIDSPACING);
    node.y = $5bc812abaa5f432b$var$GRIDSPACING * Math.round(node.y / $5bc812abaa5f432b$var$GRIDSPACING);
}
/*************************************************************** clipboard ************************************** */ /**
 * Copy the selected nodes and links to the clipboard
 * NB this doesn't yet work in Firefox, as they haven't implemented the Clipboard API and Permissions yet.
 * @param {Event} event
 */ function $5bc812abaa5f432b$var$copyToClipboard(event) {
    if (document.getSelection().toString()) return; // only copy factors if there is no text selected (e.g. in Notes)
    event.preventDefault();
    if ($5bc812abaa5f432b$export$c05995454a6ca00d) {
        (0, $95c555713171f487$export$adee94ba21be2b8e)(event);
        return;
    }
    const nIds = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    const eIds = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    if (nIds.length + eIds.length === 0) {
        (0, $7hmfH.alertMsg)('Nothing selected to copy', 'warn');
        return;
    }
    const nodes = [];
    const edges = [];
    nIds.forEach((nId)=>{
        nodes.push($5bc812abaa5f432b$export$4051a07651545597.nodes.get(nId));
        const edgesFromNode = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId);
        edgesFromNode.forEach((eId)=>{
            const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(eId);
            if (nIds.includes(edge.to) && nIds.includes(edge.from) && !edges.find((e)=>e.id === eId)) edges.push(edge);
        });
    });
    eIds.forEach((eId)=>{
        const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(eId);
        if (!nodes.find((n)=>n.id === edge.from)) nodes.push($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.from));
        if (!nodes.find((n)=>n.id === edge.to)) nodes.push($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.to));
        if (!edges.find((e)=>e.id === eId)) edges.push($5bc812abaa5f432b$export$4051a07651545597.edges.get(eId));
    });
    $5bc812abaa5f432b$var$copyText(JSON.stringify({
        nodes: nodes,
        edges: edges
    }));
}
/**
 * copy the contents of the history log to the clipboard
 * @param {object} event
 */ function $5bc812abaa5f432b$var$copyHistoryToClipboard(event) {
    event.preventDefault();
    const history = $5bc812abaa5f432b$export$d920e34eaf2b21cb.toArray().map((rec)=>`${(0, $7hmfH.timeAndDate)(rec.time, true)}\t${rec.user}\t${rec.action.replace(/\s+/g, ' ').trim()}\n`).join('');
    $5bc812abaa5f432b$var$copyText(history);
}
async function $5bc812abaa5f432b$var$copyText(text) {
    try {
        if (typeof navigator.clipboard.writeText !== 'function') throw new Error('navigator.clipboard.writeText not a function');
    } catch  {
        (0, $7hmfH.alertMsg)('Copying not implemented in this browser', 'error');
        return false;
    }
    try {
        await navigator.clipboard.writeText(text);
        (0, $7hmfH.alertMsg)('Copied to clipboard', 'info');
        return true;
    } catch (err) {
        console.error('Failed to copy: ', err);
        (0, $7hmfH.alertMsg)('Copy failed', 'error');
        return false;
    }
}
async function $5bc812abaa5f432b$var$pasteFromClipboard() {
    if ($5bc812abaa5f432b$export$c05995454a6ca00d) {
        (0, $95c555713171f487$export$8b0e49c4b227c2a)();
        return;
    }
    const clip = await $5bc812abaa5f432b$var$getClipboardContents();
    let nodes;
    let edges;
    try {
        ({ nodes: nodes, edges: edges } = JSON.parse(clip));
    } catch  {
        // silently return (i.e. use system paste) if there is nothing relevant on the clipboard
        return;
    }
    $5bc812abaa5f432b$export$9bc34f54445cb725();
    nodes.forEach((node)=>{
        const oldId = node.id;
        node.id = (0, $7hmfH.uuidv4)();
        node.x += 40;
        node.y += 40;
        edges.forEach((edge)=>{
            if (edge.from === oldId) edge.from = node.id;
            if (edge.to === oldId) edge.to = node.id;
        });
    });
    edges.forEach((edge)=>{
        edge.id = (0, $7hmfH.uuidv4)();
    });
    $5bc812abaa5f432b$export$4051a07651545597.nodes.add(nodes);
    $5bc812abaa5f432b$export$4051a07651545597.edges.add(edges);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
        nodes: nodes.map((n)=>n.id),
        edges: edges.map((e)=>e.id)
    });
    $5bc812abaa5f432b$var$showSelected();
    (0, $7hmfH.alertMsg)('Pasted', 'info');
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d('pasted factors and/or links from clipboard');
}
async function $5bc812abaa5f432b$var$getClipboardContents() {
    try {
        if (typeof navigator.clipboard.readText !== 'function') throw new Error('navigator.clipboard.readText not a function');
    } catch  {
        (0, $7hmfH.alertMsg)('Pasting not implemented in this browser', 'error');
        return null;
    }
    try {
        return await navigator.clipboard.readText();
    } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
        (0, $7hmfH.alertMsg)('Failed to paste', 'error');
        return null;
    }
}
/* ----------------- dialogues for creating and editing nodes and links ----------------*/ let $5bc812abaa5f432b$var$currentCaptureReturn = null;
/**
 * Initialise the dialog for creating nodes/edges
 * @param {string} popUpTitle
 * @param {number} height
 * @param {object} item
 * @param {function} cancelAction
 * @param {function} saveAction
 * @param {function} callback
 */ function $5bc812abaa5f432b$var$initPopUp(popUpTitle, item, cancelAction, saveAction, callback) {
    $5bc812abaa5f432b$var$inAddMode = false;
    $5bc812abaa5f432b$var$inEditMode = true;
    $5bc812abaa5f432b$var$changeCursor('default');
    // elem('popup').style.height = `${height}px`
    (0, $7hmfH.elem)('popup').style.borderColor = item.color.background;
    (0, $7hmfH.elem)('popup-operation').innerHTML = popUpTitle;
    (0, $7hmfH.elem)('popup-saveButton').onclick = saveAction.bind(this, item, callback);
    (0, $7hmfH.elem)('popup-cancelButton').onclick = cancelAction.bind(this, item, callback);
    const popupLabel = (0, $7hmfH.elem)('popup-label');
    popupLabel.style.fontSize = '14px';
    popupLabel.innerText = item.label === undefined ? '' : item.label;
    popupLabel.focus();
    // Set the cursor to the end
    (0, $7hmfH.setEndOfContenteditable)(popupLabel);
    if ($5bc812abaa5f432b$var$currentCaptureReturn) (0, $7hmfH.elem)('popup').removeEventListener('keydown', $5bc812abaa5f432b$var$currentCaptureReturn);
    function captureReturn(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            (0, $7hmfH.elem)('popup').removeEventListener('keydown', captureReturn);
            $5bc812abaa5f432b$var$currentCaptureReturn = null;
            saveAction(item, callback);
        } else if (e.key === 'Escape') {
            (0, $7hmfH.elem)('popup').removeEventListener('keydown', captureReturn);
            $5bc812abaa5f432b$var$currentCaptureReturn = null;
            cancelAction(item, callback);
        }
    }
    $5bc812abaa5f432b$var$currentCaptureReturn = captureReturn;
    (0, $7hmfH.listen)('popup', 'keydown', captureReturn);
}
/**
 * Position the editing dialog box so that it is to the left of the item being edited,
 * but not outside the window
 * @param {Object} point
 */ function $5bc812abaa5f432b$var$positionPopUp(point) {
    const popUp = (0, $7hmfH.elem)('popup');
    popUp.style.display = 'block';
    // popup appears to the left of the given point
    popUp.style.top = `${point.y - popUp.offsetHeight / 2}px`;
    const left = point.x - popUp.offsetWidth / 2 - 3;
    popUp.style.left = `${left < 0 ? 0 : left}px`;
    (0, $7hmfH.dragElement)(popUp, (0, $7hmfH.elem)('popup-top'));
}
/**
 * Hide the editing dialog box
 */ function $5bc812abaa5f432b$var$clearPopUp() {
    (0, $7hmfH.elem)('popup-saveButton').onclick = null;
    (0, $7hmfH.elem)('popup-cancelButton').onclick = null;
    (0, $7hmfH.elem)('popup-label').onkeyup = null;
    if ($5bc812abaa5f432b$var$currentCaptureReturn) {
        (0, $7hmfH.elem)('popup').removeEventListener('keydown', $5bc812abaa5f432b$var$currentCaptureReturn);
        $5bc812abaa5f432b$var$currentCaptureReturn = null;
    }
    (0, $7hmfH.elem)('popup').style.display = 'none';
    if ((0, $7hmfH.elem)('popup-editor')) (0, $7hmfH.elem)('popup-editor').remove();
    if ((0, $7hmfH.elem)('popup').timer) {
        clearTimeout((0, $7hmfH.elem)('popup').timer);
        (0, $7hmfH.elem)('popup').timer = undefined;
    }
    $5bc812abaa5f432b$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'done'
    });
    $5bc812abaa5f432b$var$inEditMode = false;
}
/**
 * User has pressed 'cancel' - abandon adding a node and hide the dialog
 * @param {Function} callback
 */ function $5bc812abaa5f432b$var$cancelAdd(item, callback) {
    $5bc812abaa5f432b$var$clearPopUp();
    callback(null);
    $5bc812abaa5f432b$var$stopEdit();
}
/**
 * User has pressed 'cancel' - abandon the edit and hide the dialog
 * @param {object} item
 * @param {function} [callback]
 */ function $5bc812abaa5f432b$var$cancelEdit(item, callback) {
    $5bc812abaa5f432b$var$clearPopUp();
    item.label = item.oldLabel;
    item.font.color = item.oldFontColor;
    if (item.shape === 'portal') item.shape = 'image';
    if (item.from) $5bc812abaa5f432b$var$unlockEdge(item);
    else $5bc812abaa5f432b$var$unlockNode(item);
    if (callback) callback(null);
    $5bc812abaa5f432b$var$stopEdit();
}
/**
 * A factor is being created:  get its label from the user
 * @param {Object} item - the node
 * @param {Function} cancelAction
 * @param {Function} callback
 */ function $5bc812abaa5f432b$var$addLabel(item, cancelAction, callback) {
    if ((0, $7hmfH.elem)('popup').style.display === 'block') return; // can't add factor when factor is already being added
    $5bc812abaa5f432b$var$initPopUp('Add Factor', item, cancelAction, $5bc812abaa5f432b$var$saveLabel, callback);
    const pos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM({
        x: item.x,
        y: item.y
    });
    $5bc812abaa5f432b$var$positionPopUp(pos);
    $5bc812abaa5f432b$var$removeFactorCursor();
    $5bc812abaa5f432b$var$ghostFactor(pos);
    (0, $7hmfH.elem)('popup-label').focus();
}
/**
 * broadcast to other users that a new factor is being added here
 * @param {Object} pos offset coordinates of Add Factor dialog
 */ function $5bc812abaa5f432b$var$ghostFactor(pos) {
    $5bc812abaa5f432b$var$yAwareness.setLocalStateField('addingFactor', {
        state: 'adding',
        pos: $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.DOMtoCanvas(pos),
        name: $5bc812abaa5f432b$var$myNameRec.name
    });
    (0, $7hmfH.elem)('popup').timer = setTimeout(()=>{
        // close it after a time if the user has gone away
        $5bc812abaa5f432b$var$yAwareness.setLocalStateField('addingFactor', {
            state: 'done'
        });
    }, $5bc812abaa5f432b$var$TIMETOEDIT);
}
/**
 * called when a node has been added.  Save the label provided
 * @param {Object} node the item that has been added
 * @param {Function} callback
 */ function $5bc812abaa5f432b$var$saveLabel(node, callback) {
    node.label = (0, $7hmfH.splitText)((0, $7hmfH.elem)('popup-label').innerText, $5bc812abaa5f432b$var$NODEWIDTH);
    $5bc812abaa5f432b$var$clearPopUp();
    if (node.label === '') {
        (0, $7hmfH.alertMsg)('No label: cancelled', 'error');
        callback(null);
        return;
    }
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'addNode' // ensure still in Add mode, in case others have done something meanwhile
    ;
    callback(node);
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`added factor '${node.label}'`);
}
/**
 * Draw a dialog box for user to edit a node
 * @param {Object} item the node
 * @param {Object} point the centre of the node
 * @param {Function} cancelAction what to do if the edit is cancelled
 * @param {Function} callback what to do if the edit is saved
 */ function $5bc812abaa5f432b$var$editNode(item, point, cancelAction, callback) {
    if (item.locked) return;
    $5bc812abaa5f432b$var$initPopUp('Edit Factor', item, cancelAction, $5bc812abaa5f432b$var$saveNode, callback);
    (0, $7hmfH.elem)('popup').insertAdjacentHTML('beforeend', `
		<div class="popup-editor" id="popup-editor">
    
<!-- Header Labels -->

    <div class="grid-header">fill</div>
    <div class="grid-header">border</div>
    <div class="grid-header">font</div>

    <!-- Color Wells -->

			<div class="input-color-container">
				<div class="color-well" id="node-backgroundColor"></div>
			</div>
			<div class="input-color-container">
				<div class="color-well" id="node-borderColor"></div>
			</div>
			<div class="input-color-container">
				<div class="color-well" id="node-fontColor"></div>
			</div>

    <!-- Selection Dropdowns -->

			<div>
				<select name="nodeEditShape" id="nodeEditShape">
					<option value="box">Shape...</option>
					<option value="ellipse">Ellipse</option>
					<option value="circle">Circle</option>
					<option value="dot">Dot</option>
					<option value="box">Rect</option>
					<option value="diamond">Diamond</option>
					<option value="star">Star</option>
					<option value="triangle">Triangle</option>
					<option value="hexagon">Hexagon</option>
					<option value="text">Text</option>
					<option value="portal">Portal</option>
          <option value="image" disabled>Cluster</option>
				</select>
			</div>
			<div>
				<select name="nodeEditBorder" id="node-borderType">
					<option value="solid" selected>Solid</option>
					<option value="dashed">Dashed</option>
					<option value="dots">Dotted</option>
					<option value="none">No border</option>
				</select>
			</div>
			<div>
				<select name="nodeEditFontSize" id="nodeEditFontSize">
					<option value="14">Size...</option>
					<option value="24">Large</option>
					<option value="14">Normal</option>
					<option value="10">Small</option>
				</select>
			</div>
    <!-- Size Slider (Spans full width) -->
      <div id="popup-sizer">
          <div class="sizer-label">Size</div>
          <input type="range" class="range" id="nodeEditSizer"
          style="background: linear-gradient(to right, rgb(13, 38, 68) 0%, rgb(204, 204, 204) 0%);">
      </div>
		</div>
		`);
    $5bc812abaa5f432b$export$cd571ca6d1702b73.createColorPicker('node-backgroundColor');
    (0, $7hmfH.elem)('node-backgroundColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(item.color.background);
    if (item.shape === 'image' && !item.isCluster) {
        item.shape = 'portal';
        if ((0, $7hmfH.elem)('popup-portal-room')) (0, $7hmfH.elem)('popup-portal-room').value = item.portal;
        else makePortalInput(item.portal);
    }
    (0, $7hmfH.elem)('nodeEditShape').value = item.shape;
    $5bc812abaa5f432b$export$cd571ca6d1702b73.createColorPicker('node-borderColor');
    (0, $7hmfH.elem)('node-borderColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(item.color.border);
    $5bc812abaa5f432b$export$cd571ca6d1702b73.createColorPicker('node-fontColor');
    (0, $7hmfH.elem)('node-fontColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(item.font.color);
    (0, $7hmfH.elem)('node-borderType').value = (0, $7hmfH.getDashes)(item.shapeProperties.borderDashes, item.borderWidth);
    (0, $7hmfH.elem)('nodeEditFontSize').value = item.font.size;
    (0, $7hmfH.elem)('nodeEditSizer').value = (0, $7hmfH.factorSizeToPercent)(item.size);
    $5bc812abaa5f432b$export$9d1298853f0e77f7((0, $7hmfH.elem)('nodeEditSizer'));
    (0, $7hmfH.listen)('nodeEditSizer', 'input', (event)=>$5bc812abaa5f432b$export$9d1298853f0e77f7(event.target));
    (0, $7hmfH.listen)('nodeEditShape', 'change', (event)=>{
        if (event.target.value === 'portal') makePortalInput(item.portal);
        else {
            (0, $7hmfH.elem)('popup-portal-link')?.remove();
            item.portal = undefined;
        }
    });
    $5bc812abaa5f432b$var$positionPopUp(point);
    (0, $7hmfH.elem)('popup-label').focus();
    (0, $7hmfH.elem)('popup').timer = setTimeout(()=>{
        //ensure that the node cannot be locked out for ever
        $5bc812abaa5f432b$var$cancelEdit(item, callback);
        (0, $7hmfH.alertMsg)('Edit timed out', 'warn');
    }, $5bc812abaa5f432b$var$TIMETOEDIT);
    $5bc812abaa5f432b$var$lockNode(item);
    /**
   * Generate HTML for the textarea to obtain the room name of the portal
   * @param {string} portal room name to go to
   */ function makePortalInput(portal) {
        portal = portal || '';
        // expand the dialog to accommodate the textarea
        //   elem('popup').style.height = `${230}px`
        (0, $7hmfH.elem)('popup-editor').insertAdjacentHTML('beforeend', `<div id="popup-portal-link">
      				<label for="popup-portal-room">Map:</label>
      				<textarea id="popup-portal-room" rows="1" placeholder="ABC-DEF-GHI-JKL">${portal}</textarea>
    			</div>`);
    }
}
// fancy portal image icon
const $5bc812abaa5f432b$var$portalSvg = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#ff0000" d="M298.736 21.016c-99.298 0-195.928 104.647-215.83 233.736-7.074 45.887-3.493 88.68 8.512 124.787-4.082-6.407-7.92-13.09-11.467-20.034-16.516-32.335-24.627-65.378-25-96.272-11.74 36.254-8.083 82.47 14.482 126.643 27.7 54.227 81.563 91.94 139.87 97.502 5.658.725 11.447 1.108 17.364 1.108 99.298 0 195.93-104.647 215.83-233.736 9.28-60.196.23-115.072-22.133-156.506 21.625 21.867 36.56 45.786 44.617 69.496.623-30.408-14.064-65.766-44.21-95.806-33.718-33.598-77.227-50.91-114.995-50.723-2.328-.118-4.67-.197-7.04-.197zm-5.6 36.357c40.223 0 73.65 20.342 95.702 53.533 15.915 42.888 12.51 108.315.98 147.858-16.02 54.944-40.598 96.035-79.77 126.107-41.79 32.084-98.447 24.39-115.874-5.798-1.365-2.363-2.487-4.832-3.38-7.385 11.724 14.06 38.188 14.944 61.817 1.3 25.48-14.71 38.003-40.727 27.968-58.108-10.036-17.384-38.826-19.548-64.307-4.837-9.83 5.676-17.72 13.037-23.14 20.934.507-1.295 1.043-2.59 1.626-3.88-18.687 24.49-24.562 52.126-12.848 72.417 38.702 45.923 98.07 25.503 140.746-6.426 37.95-28.392 72.32-73.55 89.356-131.988 1.265-4.34 2.416-8.677 3.467-13.008-.286 2.218-.59 4.442-.934 6.678-16.807 109.02-98.412 197.396-182.272 197.396-35.644 0-65.954-15.975-87.74-42.71-26.492-48.396-15.988-142.083 4.675-185.15 26.745-55.742 66.133-122.77 134.324-116.804 46.03 4.027 63.098 58.637 39.128 116.22-8.61 20.685-21.192 39.314-36.21 54.313 24.91-16.6 46.72-42.13 59.572-73 23.97-57.583 6.94-113.422-39.13-116.805-85.737-6.296-137.638 58.55-177.542 128.485-9.21 19.9-16.182 40.35-20.977 60.707.494-7.435 1.312-14.99 2.493-22.652C127.67 145.75 209.275 57.373 293.135 57.373z"></path></g></svg>`;
/**
 * save the node format details that have been edited
 * @param {Object} item the node that has been edited
 * @param {Function} callback
 */ function $5bc812abaa5f432b$var$saveNode(item, callback) {
    $5bc812abaa5f432b$var$unlockNode(item);
    item.label = (0, $7hmfH.splitText)((0, $7hmfH.elem)('popup-label').innerText, $5bc812abaa5f432b$var$NODEWIDTH);
    if (item.label === '') {
        // if there is no label, cancel (nodes must have a label)
        (0, $7hmfH.alertMsg)('No label: cancelled', 'error');
        callback(null);
    }
    let color = (0, $7hmfH.elem)('node-backgroundColor').style.backgroundColor;
    item.color.background = color;
    item.color.highlight.background = color;
    item.color.hover.background = color;
    color = (0, $7hmfH.elem)('node-borderColor').style.backgroundColor;
    item.color.border = color;
    item.color.highlight.border = color;
    item.color.hover.border = color;
    item.font.color = (0, $7hmfH.elem)('node-fontColor').style.backgroundColor;
    const borderType = (0, $7hmfH.elem)('node-borderType').value;
    item.borderWidth = borderType === 'none' ? 0 : borderType === 'solid' ? 1 : 4;
    item.shapeProperties.borderDashes = (0, $7hmfH.convertDashes)(borderType);
    item.shape = (0, $7hmfH.elem)('nodeEditShape').value;
    if (item.shape === 'portal') {
        item.portal = (0, $7hmfH.elem)('popup-portal-room')?.value;
        if (!item.portal) {
            (0, $7hmfH.alertMsg)('No map room provided', 'error');
            callback(null);
            return;
        }
        item.portal = item.portal.match(/[a-zA-Z]{3}-[a-zA-Z]{3}-[a-zA-Z]{3}-[a-zA-Z]{3}/);
        if (!item.portal) {
            (0, $7hmfH.alertMsg)('Ill-formed map room provided', 'error');
            callback(null);
            return;
        }
        item.portal = item.portal[0];
        item.shape = 'image';
        item.image = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent($5bc812abaa5f432b$var$portalSvg);
    }
    if (item.isCluster) item.shape = 'image';
    item.font.size = parseInt((0, $7hmfH.elem)('nodeEditFontSize').value);
    (0, $7hmfH.setFactorSizeFromPercent)(item, (0, $7hmfH.elem)('nodeEditSizer').value);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'editNode' // ensure still in Add mode, in case others have done something meanwhile
    ;
    if (item.label.replace(/\s+|\n/g, '') === item.oldLabel.replace(/\s+|\n/g, '')) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`edited factor: '${item.label}'`);
    else $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`edited factor, changing label from '${item.oldLabel}' to '${item.label}'`);
    $5bc812abaa5f432b$var$clearPopUp();
    callback(item);
}
/**
 * User is about to edit the node.  Make sure that no one else can edit it simultaneously
 * @param {Node} item
 */ function $5bc812abaa5f432b$var$lockNode(item) {
    item.locked = true;
    item.opacity = 0.3;
    item.oldLabel = item.label;
    item.oldFontColor = item.font.color;
    item.label = `${item.label}\n\n[Being edited by ${$5bc812abaa5f432b$var$myNameRec.name}]`;
    item.wasFixed = Boolean(item.fixed);
    item.fixed = true;
    $5bc812abaa5f432b$var$dontUndo = 'locked';
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(item);
}
/**
 * User has finished editing the node.  Unlock it.
 * @param {Node} item
 */ function $5bc812abaa5f432b$var$unlockNode(item) {
    item.locked = false;
    item.opacity = 1;
    item.fixed = item.wasFixed;
    item.label = item.oldLabel;
    $5bc812abaa5f432b$var$dontUndo = 'unlocked';
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(item);
    $5bc812abaa5f432b$var$showNodeOrEdgeData();
}
/**
 * ensure that all factors and links are unlocked (called only when user leaves the page, to clear up for others)
 */ function $5bc812abaa5f432b$var$unlockAll() {
    $5bc812abaa5f432b$export$4051a07651545597.nodes.forEach((node)=>{
        if (node.locked) $5bc812abaa5f432b$var$cancelEdit((0, $7hmfH.deepCopy)(node));
    });
    $5bc812abaa5f432b$export$4051a07651545597.edges.forEach((edge)=>{
        if (edge.locked) $5bc812abaa5f432b$var$cancelEdit((0, $7hmfH.deepCopy)(edge));
    });
}
/**
 * Draw a dialog box for user to edit an edge
 * @param {Object} item the edge
 * @param {Object} point the centre of the edge
 * @param {Function} cancelAction what to do if the edit is cancelled
 * @param {Function} callback what to do if the edit is saved
 */ function $5bc812abaa5f432b$var$editEdge(item, point, cancelAction, callback) {
    if (item.locked) return;
    $5bc812abaa5f432b$var$initPopUp('Edit Link', item, cancelAction, $5bc812abaa5f432b$var$saveEdge, callback);
    (0, $7hmfH.elem)('popup').insertAdjacentHTML('beforeend', `<div class="popup-editor" id="popup-editor">
		<div class="grid-header">colour</div>
		<div></div>
		<div></div>
		<div class="input-color-container">
			<div class="color-well" id="linkEditLineColor"></div>
		</div>
		<div>
			<select name="linkEditWidth" id="linkEditWidth">
				<option value="1">Width: 1</option>
				<option value="4">Width: 4</option>
				<option value="8">Width: 8</option>
			</select>
		</div>
		<div>
			<select name="linkEditArrows" id="linkEditArrows">
				<option value="vee">Arrows...</option>
				<option value="vee">Sharp</option>
				<option value="arrow">Triangle</option>
				<option value="bar">Bar</option>
				<option value="circle">Circle</option>
				<option value="box">Box</option>
				<option value="diamond">Diamond</option>
				<option value="none">None</option>
			</select>
		</div>
		<div>
			<select name="linkEditDashes" id="linkEditDashes">
				<option value="solid" selected>Solid line</option>
				<option value="dashedLinks">Dashed line</option>
				<option value="dots">Dotted line</option>
			</select>
		</div>
		<div>
			<select id="linkEditFontSize">
				<option value="24">Large font</option>
				<option value="14" selected>Normal font</option>
				<option value="10">Small font</option>
			</select>
		</div>
	</div>
`);
    (0, $7hmfH.elem)('popup').style.borderColor = item.color.color;
    (0, $7hmfH.elem)('linkEditWidth').value = parseInt(item.width);
    $5bc812abaa5f432b$export$cd571ca6d1702b73.createColorPicker('linkEditLineColor');
    (0, $7hmfH.elem)('linkEditLineColor').style.backgroundColor = (0, $7hmfH.standardizeColor)(item.color.color);
    (0, $7hmfH.elem)('linkEditDashes').value = (0, $7hmfH.getDashes)(item.dashes, null);
    (0, $7hmfH.elem)('linkEditArrows').value = item.arrows.to.enabled ? item.arrows.to.type : 'none';
    (0, $7hmfH.elem)('linkEditFontSize').value = parseInt(item.font.size);
    $5bc812abaa5f432b$var$positionPopUp(point);
    (0, $7hmfH.elem)('popup-label').focus();
    (0, $7hmfH.elem)('popup').timer = setTimeout(()=>{
        //ensure that the edge cannot be locked out for ever
        $5bc812abaa5f432b$var$cancelEdit(item, callback);
        (0, $7hmfH.alertMsg)('Edit timed out', 'warn');
    }, $5bc812abaa5f432b$var$TIMETOEDIT);
    $5bc812abaa5f432b$var$lockEdge(item);
}
/**
 * save the edge format details that have been edited
 * @param {Object} item the edge that has been edited
 * @param {Function} callback
 */ function $5bc812abaa5f432b$var$saveEdge(item, callback) {
    $5bc812abaa5f432b$var$unlockEdge(item);
    item.label = (0, $7hmfH.splitText)((0, $7hmfH.elem)('popup-label').innerText, $5bc812abaa5f432b$var$NODEWIDTH);
    if (item.label === '') item.label = '\0';
    const color = (0, $7hmfH.elem)('linkEditLineColor').style.backgroundColor;
    item.color.color = color;
    item.color.hover = color;
    item.color.highlight = color;
    item.width = parseInt((0, $7hmfH.elem)('linkEditWidth').value);
    if (!item.width) item.width = 1;
    item.dashes = (0, $7hmfH.convertDashes)((0, $7hmfH.elem)('linkEditDashes').value);
    item.arrows.to = {
        enabled: (0, $7hmfH.elem)('linkEditArrows').value !== 'none',
        type: (0, $7hmfH.elem)('linkEditArrows').value
    };
    item.font.size = parseInt((0, $7hmfH.elem)('linkEditFontSize').value);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.manipulation.inMode = 'editEdge' // ensure still in edit mode, in case others have done something meanwhile
    ;
    // vis-network silently deselects all edges in the callback (why?).  So we have to mark this edge as unselected in preparation
    (0, $7hmfH.clearStatusBar)();
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`edited link from '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.from).label}' to '${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(item.to).label}'`);
    $5bc812abaa5f432b$var$clearPopUp();
    callback(item);
}
function $5bc812abaa5f432b$var$lockEdge(item) {
    item.locked = true;
    item.font.color = 'rgba(0,0,0,0.5)';
    item.opacity = 0.1;
    item.oldLabel = item.label || ' ';
    item.label = `Being edited by ${$5bc812abaa5f432b$var$myNameRec.name}`;
    $5bc812abaa5f432b$var$dontUndo = 'locked';
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(item);
}
/**
 * User has finished editing the edge.  Unlock it.
 * @param {object} item
 */ function $5bc812abaa5f432b$var$unlockEdge(item) {
    item.locked = false;
    item.font.color = 'rgba(0,0,0,1)';
    item.opacity = 1;
    item.label = item.oldLabel;
    item.oldLabel = undefined;
    $5bc812abaa5f432b$var$dontUndo = 'unlocked';
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(item);
    $5bc812abaa5f432b$var$showNodeOrEdgeData();
}
/* ----------------- end of node and edge creation and editing dialog -----------------*/ /**
 * if there is already a link from the 'from' node to the 'to' node, return it
 * @param {Object} from A node
 * @param {Object} to Another node
 */ function $5bc812abaa5f432b$var$duplEdge(from, to) {
    return $5bc812abaa5f432b$export$4051a07651545597.edges.get({
        filter: function(item) {
            return item.from === from && item.to === to;
        }
    });
}
/**
 * Change the cursor style for the net pane and nav bar
 * @param {object} newCursorStyle
 */ function $5bc812abaa5f432b$var$changeCursor(newCursorStyle) {
    if ($5bc812abaa5f432b$var$inAddMode) return;
    $5bc812abaa5f432b$export$4b72f5d71fff605.style.cursor = newCursorStyle;
    (0, $7hmfH.elem)('navbar').style.cursor = newCursorStyle;
}
/**
 * User has set or changed the map title: update the UI and broadcast the new title
 * @param {event} e
 */ function $5bc812abaa5f432b$var$mapTitle(e) {
    let title = e.target.innerText.trim();
    title = $5bc812abaa5f432b$export$f229389f565c6b3f(title);
    $5bc812abaa5f432b$export$807f940a96777041.set('mapTitle', title);
}
function $5bc812abaa5f432b$var$pasteMapTitle(e) {
    e.preventDefault();
    let paste = (e.clipboardData || window.clipboardData).getData('text/plain');
    if (paste instanceof HTMLElement) paste = paste.textContent;
    const selection = window.getSelection();
    if (!selection.rangeCount) return false;
    selection.deleteFromDocument();
    selection.getRangeAt(0).insertNode(document.createTextNode(paste));
    $5bc812abaa5f432b$export$f229389f565c6b3f((0, $7hmfH.elem)('maptitle').innerText);
}
function $5bc812abaa5f432b$export$f229389f565c6b3f(title) {
    const div = (0, $7hmfH.elem)('maptitle');
    (0, $7hmfH.clearStatusBar)();
    if (!title) title = 'Untitled map';
    if (title === 'Untitled map') {
        div.classList.add('unsetmaptitle');
        document.title = $5bc812abaa5f432b$var$appName;
    } else {
        if (title.length > 50) {
            title = title.slice(0, 50);
            (0, $7hmfH.alertMsg)('Map title is too long: truncated', 'warn');
        }
        div.classList.remove('unsetmaptitle');
        document.title = `${title}: ${$5bc812abaa5f432b$var$shortAppName} map`;
    }
    if (title !== div.innerText.trim()) div.innerText = title;
    if (title.length >= 50) (0, $7hmfH.setEndOfContenteditable)(div);
    (0, $c5391cf84cf40afe$export$20ca267bc6805c64)();
    (0, $7f60c5bdd5f6f512$export$aebc5f60a7b91add)(title);
    return title;
}
function $5bc812abaa5f432b$export$9bc34f54445cb725() {
    $5bc812abaa5f432b$var$hideNotes();
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.unselectAll();
    (0, $7hmfH.clearStatusBar)();
}
var $b0e29a5231fe0f2c$exports = {};
var $d4c1b3532db9c06f$exports = {};
"use strict";
$d4c1b3532db9c06f$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $b0e29a5231fe0f2c$var$url = new URL(import.meta.resolve("8CIys"));
$b0e29a5231fe0f2c$exports = $d4c1b3532db9c06f$exports($b0e29a5231fe0f2c$var$url.toString(), $b0e29a5231fe0f2c$var$url.origin, true);


/* 
  ----------- Calculate statistics in the background -------------
*/ // set  up a web worker to calculate network statistics in parallel with whatever
// the user is doing
const $5bc812abaa5f432b$var$worker = new Worker($b0e29a5231fe0f2c$exports);
function $5bc812abaa5f432b$export$f0aab65e28c411fe() {
    // wait 200 mSecs for things to settle down before recalculating
    setTimeout(()=>{
        $5bc812abaa5f432b$var$worker.postMessage([
            $5bc812abaa5f432b$var$nodes.get(),
            $5bc812abaa5f432b$var$edges.get()
        ]);
    }, 200);
}
$5bc812abaa5f432b$var$worker.onmessage = function(e) {
    if (typeof e.data === 'string') (0, $7hmfH.alertMsg)(e.data, 'error');
    else {
        const nodesToUpdate = [];
        $5bc812abaa5f432b$export$4051a07651545597.nodes.get().forEach((n)=>{
            if (n.bc !== e.data[n.id]) {
                n.bc = e.data[n.id];
                nodesToUpdate.push(n);
            }
        });
        if (nodesToUpdate) $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodesToUpdate);
    }
};
/* 
  ----------- Status messages ---------------------------------------
*/ /**
 * return a string listing the labels of the given nodes, with nice connecting words
 * @param {Array} factors List of node Ids
 * @param {Boolean} suppressType If true, don't start string with 'Factors'
 */ function $5bc812abaa5f432b$var$listFactors(factors, suppressType) {
    if (factors.length > 5) return `${factors.length} factors`;
    let str = '';
    if (!suppressType) {
        str = 'Factor';
        if (factors.length > 1) str = `${str}s`;
        str = `${str}: `;
    }
    return str + lf(factors);
    function lf(factors) {
        // recursive fn to return a string of the node labels, separated by commas and 'and'
        const n = factors.length;
        const label = `'${(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(factors[0]).label)}'`;
        if (n === 1) return label;
        factors.shift();
        if (n === 2) return label.concat(` and ${lf(factors)}`);
        return label.concat(`, ${lf(factors)}`);
    }
}
/**
 * return a string listing the number of Links, or if just one, the starting and ending factors
 * @param {Array} links
 */ function $5bc812abaa5f432b$var$listLinks(links) {
    if (links.length > 1) return `${links.length} links`;
    const link = $5bc812abaa5f432b$export$4051a07651545597.edges.get(links[0]);
    return `Link from "${(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(link.from).label)}" to "${(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(link.to).label)}"`;
}
/**
 * returns string of currently selected labels of links and factors, nicely formatted
 * @returns {String} string of labels of links and factors, nicely formatted
 */ function $5bc812abaa5f432b$var$selectedLabels() {
    const selectedNodes = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    const selectedEdges = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    let msg = '';
    if (selectedNodes.length > 0) msg = $5bc812abaa5f432b$var$listFactors(selectedNodes);
    if (selectedNodes.length > 0 && selectedEdges.length > 0) msg += ' and ';
    if (selectedEdges.length > 0) msg += $5bc812abaa5f432b$var$listLinks(selectedEdges);
    return msg;
}
/**
 * show the nodes and links selected in the status bar
 */ function $5bc812abaa5f432b$var$showSelected() {
    const msg = $5bc812abaa5f432b$var$selectedLabels();
    if (msg.length > 0) (0, $7hmfH.statusMsg)(`${msg} selected`);
    else (0, $7hmfH.clearStatusBar)();
    $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
}
/* ----------------------------------------zoom slider -------------------------------------------- */ (0, $8L2sr.Network).prototype.zoom = function(scale) {
    const newScale = scale === undefined ? 1 : scale < 0.001 ? 0.001 : scale;
    const animationOptions = {
        scale: newScale,
        animation: {
            duration: 0
        }
    };
    this.view.moveTo(animationOptions);
    (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(newScale);
};
function $5bc812abaa5f432b$export$1e044b7877db048c() {
    const prevPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.fit({
        position: {
            x: 0,
            y: 0
        }
    });
    const newPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
    const newScale = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
    (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(1.0);
    (0, $95c555713171f487$export$4ccc1b9eba0bcd20)(prevPos.x - newPos.x, prevPos.y - newPos.y, 1.0);
    (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(newScale);
    (0, $7hmfH.elem)('zoom').value = newScale;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
}
/**
 * expand/reduce the network view using the value in the zoom slider
 */ function $5bc812abaa5f432b$var$zoomnet() {
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.zoom(Number((0, $7hmfH.elem)('zoom').value));
}
/**
 * zoom by the given amount (+ve or -ve);
 * used by the + and - buttons at the ends of the zoom slider
 * and by trackpad zoom/pinch.
 * If the new zoom level becomes below zero, do nothing
 * @param {Number} incr
 */ function $5bc812abaa5f432b$var$zoomincr(incr) {
    let newScale = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale() * (1 + incr);
    if (newScale <= 0) newScale = 0.015;
    if (newScale <= 4 && newScale >= 0) (0, $7hmfH.elem)('zoom').value = newScale;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.zoom(newScale);
}
/**
 * Set up pinch-to-zoom using native touch events
 */ function $5bc812abaa5f432b$var$setUpPinchZoom() {
    let initialDistance = null;
    let initialScale = 1;
    function getTouchDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('touchstart', (e)=>{
        if (e.touches.length === 2) {
            e.preventDefault();
            initialDistance = getTouchDistance(e.touches[0], e.touches[1]);
            initialScale = Number((0, $7hmfH.elem)('zoom').value);
        }
    }, {
        passive: false
    });
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('touchmove', (e)=>{
        if (e.touches.length === 2 && initialDistance) {
            e.preventDefault();
            const currentDistance = getTouchDistance(e.touches[0], e.touches[1]);
            const scale = currentDistance / initialDistance;
            let newZoom = initialScale * scale;
            if (newZoom > 4) newZoom = 4;
            if (newZoom <= 0.015) newZoom = 0.015;
            (0, $7hmfH.elem)('zoom').value = newZoom;
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.zoom(newZoom);
        }
    }, {
        passive: false
    });
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('touchend', (e)=>{
        if (e.touches.length < 2) initialDistance = null;
    });
    $5bc812abaa5f432b$export$4b72f5d71fff605.addEventListener('touchcancel', ()=>{
        initialDistance = null;
    });
}
let $5bc812abaa5f432b$var$clicks = 0 // accumulate 'mousewheel' clicks sent while display is updating
;
let $5bc812abaa5f432b$var$ticking = false // if true, we are waiting for an AnimationFrame */
;
// see https://www.html5rocks.com/en/tutorials/speed/animations/
// listen for zoom/pinch (confusingly, referred to as mousewheel events)
(0, $7hmfH.listen)('net-pane', 'wheel', (e)=>{
    e.preventDefault();
    // reject all but vertical touch movements
    if (Math.abs(e.deltaX) <= 1) $5bc812abaa5f432b$var$zoomscroll(e);
}, // must be passive, else pinch/zoom is intercepted by the browser itself
{
    passive: false
});
// also for the background underlay, so that user can zoom when drawing
// NB not (yet) implemented for tablets
(0, $7hmfH.listen)('underlay', 'wheel', (e)=>{
    e.preventDefault();
    // reject all but vertical touch movements
    if (Math.abs(e.deltaX) <= 1) $5bc812abaa5f432b$var$zoomscroll(e);
}, // must be passive, else pinch/zoom is intercepted by the browser itself
{
    passive: false
});
/**
 * Zoom using a trackpad (with a mousewheel or two fingers)
 * @param {Event} event
 */ function $5bc812abaa5f432b$var$zoomscroll(event) {
    $5bc812abaa5f432b$var$clicks += event.deltaY;
    $5bc812abaa5f432b$var$requestZoom();
}
function $5bc812abaa5f432b$var$requestZoom() {
    if (!$5bc812abaa5f432b$var$ticking) requestAnimationFrame($5bc812abaa5f432b$var$zoomUpdate);
    $5bc812abaa5f432b$var$ticking = true;
}
const $5bc812abaa5f432b$var$MOUSEWHEELZOOMRATE = 0.01 // how many 'clicks' of the mouse wheel/finger track correspond to 1 zoom increment
;
function $5bc812abaa5f432b$var$zoomUpdate() {
    $5bc812abaa5f432b$var$zoomincr(-$5bc812abaa5f432b$var$clicks * $5bc812abaa5f432b$var$MOUSEWHEELZOOMRATE);
    $5bc812abaa5f432b$var$ticking = false;
    $5bc812abaa5f432b$var$clicks = 0;
}
/* -----------Operations related to the top button bar (not the side panel)------------- */ /**
 * react to the user pressing the Add node button
 * handles cases when the button is disabled; has previously been pressed; and the Add link
 * button is active, as well as the normal case
 *
 */ function $5bc812abaa5f432b$var$plusNode() {
    switch($5bc812abaa5f432b$var$inAddMode){
        case 'disabled':
            return;
        case 'addNode':
            $5bc812abaa5f432b$var$removeFactorCursor();
            $5bc812abaa5f432b$var$showPressed('addNode', 'remove');
            $5bc812abaa5f432b$var$stopEdit();
            break;
        case 'addLink':
            $5bc812abaa5f432b$var$showPressed('addLink', 'remove');
            $5bc812abaa5f432b$var$stopEdit();
        default:
            // false
            // don't allow user to add a factor while editing another one
            if ((0, $7hmfH.elem)('popup').style.display === 'block') break;
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.unselectAll();
            $5bc812abaa5f432b$var$changeCursor('cell');
            $5bc812abaa5f432b$var$ghostCursor();
            $5bc812abaa5f432b$var$inAddMode = 'addNode';
            $5bc812abaa5f432b$var$showPressed('addNode', 'add');
            $5bc812abaa5f432b$export$9bc34f54445cb725();
            (0, $7hmfH.statusMsg)('Click on the map to add a factor');
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addNodeMode();
    }
}
/**
 * show a box attached to the cursor to guide where the Factor will be placed when the user clicks.
 */ function $5bc812abaa5f432b$var$ghostCursor() {
    // no ghost cursor if the hardware only supports touch
    if (!window.matchMedia('(any-hover: hover)').matches) return;
    const box = document.createElement('div');
    box.classList.add('ghost-factor', 'factor-cursor');
    box.innerText = 'Click on the map to add a factor';
    box.id = 'factor-cursor';
    document.body.appendChild(box);
    const netPaneRect = $5bc812abaa5f432b$export$4b72f5d71fff605.getBoundingClientRect();
    document.addEventListener('pointermove', (event)=>{
        keepInWindow(event, box, netPaneRect);
    });
    function keepInWindow(event, box, netPaneRect) {
        const boxHalfWidth = box.offsetWidth / 2;
        const boxHalfHeight = box.offsetHeight / 2;
        const left = event.pageX - boxHalfWidth;
        box.style.left = `${left <= netPaneRect.left ? netPaneRect.left : left >= netPaneRect.right - box.offsetWidth ? netPaneRect.right - box.offsetWidth : left}px`;
        const top = event.pageY - boxHalfHeight;
        box.style.top = `${top <= netPaneRect.top ? netPaneRect.top : top >= netPaneRect.bottom - box.offsetHeight ? netPaneRect.bottom - box.offsetHeight : top}px`;
    }
}
/**
 * remove the factor cursor if it exists
 */ function $5bc812abaa5f432b$var$removeFactorCursor() {
    const factorCursor = (0, $7hmfH.elem)('factor-cursor');
    if (factorCursor) factorCursor.remove();
    (0, $7hmfH.clearStatusBar)();
}
/**
 * react to the user pressing the Add Link button
 * handles cases when the button is disabled; has previously been pressed; and the Add Node
 * button is active, as well as the normal case
 */ function $5bc812abaa5f432b$var$plusLink() {
    switch($5bc812abaa5f432b$var$inAddMode){
        case 'disabled':
            return;
        case 'addLink':
            $5bc812abaa5f432b$var$showPressed('addLink', 'remove');
            $5bc812abaa5f432b$var$stopEdit();
            break;
        case 'addNode':
            $5bc812abaa5f432b$var$showPressed('addNode', 'remove');
            $5bc812abaa5f432b$var$stopEdit() // falls through
            ;
        default:
            // false
            // don't allow user to add a factor while editing another one
            if ((0, $7hmfH.elem)('popup').style.display === 'block') break;
            $5bc812abaa5f432b$var$removeFactorCursor();
            if ($5bc812abaa5f432b$export$4051a07651545597.nodes.length < 2) {
                (0, $7hmfH.alertMsg)('Two Factors needed to link', 'error');
                break;
            }
            $5bc812abaa5f432b$var$changeCursor('crosshair');
            $5bc812abaa5f432b$var$inAddMode = 'addLink';
            $5bc812abaa5f432b$var$showPressed('addLink', 'add');
            $5bc812abaa5f432b$export$9bc34f54445cb725();
            (0, $7hmfH.statusMsg)('Now drag from the middle of the Source factor to the middle of the Destination factor');
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                interaction: {
                    dragView: false,
                    selectable: false
                }
            });
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.addEdgeMode();
    }
}
/**
 * cancel adding node and links
 */ function $5bc812abaa5f432b$var$stopEdit() {
    $5bc812abaa5f432b$var$inAddMode = false;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.disableEditMode();
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragView: true,
            selectable: true
        }
    });
    (0, $7hmfH.clearStatusBar)();
    $5bc812abaa5f432b$var$changeCursor('default');
}
/**
 * Add or remove the CSS style showing that the button has been pressed
 * @param {string} el the Id of the button
 * @param {*} action whether to add or remove the style
 *
 */ function $5bc812abaa5f432b$var$showPressed(el, action) {
    (0, $7hmfH.elem)(el).children.item(0).classList[action]('pressed');
}
function $5bc812abaa5f432b$var$undo() {
    if ($5bc812abaa5f432b$var$buttonIsDisabled('undo')) return;
    $5bc812abaa5f432b$export$9bc34f54445cb725();
    $5bc812abaa5f432b$export$f796f85272199be2.undo();
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d('undid last action');
    $5bc812abaa5f432b$export$e810bab53f2cc5ca();
}
function $5bc812abaa5f432b$var$redo() {
    if ($5bc812abaa5f432b$var$buttonIsDisabled('redo')) return;
    $5bc812abaa5f432b$export$9bc34f54445cb725();
    $5bc812abaa5f432b$export$f796f85272199be2.redo();
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d('redid last action');
    $5bc812abaa5f432b$export$e810bab53f2cc5ca();
}
function $5bc812abaa5f432b$export$e810bab53f2cc5ca() {
    $5bc812abaa5f432b$var$setButtonDisabledStatus('undo', $5bc812abaa5f432b$export$f796f85272199be2.undoStack.length === 0);
    $5bc812abaa5f432b$var$setButtonDisabledStatus('redo', $5bc812abaa5f432b$export$f796f85272199be2.redoStack.length === 0);
}
/**
 * Returns true if the button is not disabled
 * @param {String} id
 * @returns Boolean
 */ function $5bc812abaa5f432b$var$buttonIsDisabled(id) {
    return (0, $7hmfH.elem)(id).classList.contains('disabled');
}
/**
 * Change the visible state of a button
 * @param {String} id
 * @param {Boolean} state - true to make the button disabled
 */ function $5bc812abaa5f432b$var$setButtonDisabledStatus(id, state) {
    if (state) (0, $7hmfH.elem)(id).classList.add('disabled');
    else (0, $7hmfH.elem)(id).classList.remove('disabled');
}
/**
 * Delete the selected node, plus all the edges that connect to it (so no edge is left dangling)
 */ function $5bc812abaa5f432b$var$deleteNode() {
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.deleteSelected();
    (0, $7hmfH.clearStatusBar)();
    $5bc812abaa5f432b$export$c1a1b42e4610dc4a();
}
/**
 * set up the modal dialog that opens when the user clicks the Share icon in the nav bar
 */ function $5bc812abaa5f432b$var$setUpShareDialog() {
    const modal = (0, $7hmfH.elem)('shareModal');
    const inputElem = (0, $7hmfH.elem)('text-to-copy');
    const copiedText = (0, $7hmfH.elem)('copied-text');
    const qrcode = (0, $7hmfH.elem)('qr-code');
    // When the user clicks the button, open the modal
    (0, $7hmfH.listen)('share', 'click', ()=>{
        const path = `${window.location.pathname}?room=${$5bc812abaa5f432b$export$f9d3fff8c23da278}`;
        const linkToShare = window.location.origin + path;
        copiedText.style.display = 'none';
        qrcode.src = '';
        generateQR(linkToShare).then((qr)=>{
            qrcode.src = qr;
        });
        modal.style.display = 'block';
        inputElem.cols = linkToShare.length.toString();
        inputElem.value = linkToShare;
        inputElem.style.height = `${inputElem.scrollHeight - 3}px`;
        inputElem.select();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
    });
    (0, $7hmfH.listen)('clone-button', 'click', ()=>openWindow('clone'));
    (0, $7hmfH.listen)('view-button', 'click', ()=>openWindow('view'));
    (0, $7hmfH.listen)('table-button', 'click', ()=>openWindow('table'));
    // When the user clicks on <span> (x), close the modal
    (0, $7hmfH.listen)('modal-close', 'click', (event)=>closeShareDialog(event));
    // When the user clicks anywhere on the background, close it
    (0, $7hmfH.listen)('shareModal', 'click', (event)=>closeShareDialog(event));
    (0, $7hmfH.listen)('copy-text', 'click', (e)=>{
        e.preventDefault();
        // Select the text
        inputElem.select();
        if ($5bc812abaa5f432b$var$copyText(inputElem.value)) copiedText.style.display = 'inline-block';
    });
    async function generateQR(text) {
        try {
            return await (0, (/*@__PURE__*/$parcel$interopDefault($22f0b6d95e6d12d9$exports))).toDataURL(text);
        } catch (err) {
            console.error(err);
        }
    }
    function openWindow(type) {
        let path = '';
        switch(type){
            case 'clone':
                $5bc812abaa5f432b$var$doClone(false);
                break;
            case 'view':
                $5bc812abaa5f432b$var$doClone(true);
                break;
            case 'table':
                {
                    path = `${window.location.pathname.replace('prsm.html', 'table.html')}?room=${$5bc812abaa5f432b$export$f9d3fff8c23da278}`;
                    const debugType = new URL(window.location.href).searchParams.get('debug');
                    if (debugType) path += `&debug=${debugType}`;
                    window.open(path, '_blank');
                    break;
                }
            default:
                console.log('Bad case in openWindow()');
                break;
        }
        modal.style.display = 'none';
    }
    function closeShareDialog(event) {
        if (event.target === modal || event.target === (0, $7hmfH.elem)('modal-close')) modal.style.display = 'none';
    }
}
function $5bc812abaa5f432b$var$doClone(onlyView) {
    // undo any ongoing analysis and unselect all nodes and edges
    $5bc812abaa5f432b$var$setRadioVal('radius', 'All');
    $5bc812abaa5f432b$var$setRadioVal('stream', 'All');
    $5bc812abaa5f432b$var$setRadioVal('paths', 'All');
    $5bc812abaa5f432b$var$analyse();
    $5bc812abaa5f432b$export$9bc34f54445cb725();
    const options = {
        created: {
            action: `cloned this map from room: ${$5bc812abaa5f432b$export$f9d3fff8c23da278 + (onlyView ? ' (Read Only)' : '')}`,
            actor: $5bc812abaa5f432b$var$myNameRec.name
        },
        viewOnly: onlyView
    };
    // save state as a UTF16 string
    const state = $5bc812abaa5f432b$export$fb931cd598921492(options);
    // save it in local storage
    (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).setItem('clone', state).then(()=>{
        // make a room id
        const clonedRoom = $5bc812abaa5f432b$var$generateRoom();
        // open a new map
        let path = `${window.location.pathname}?room=${clonedRoom}`;
        const debugType = new URL(window.location.href).searchParams.get('debug');
        if (onlyView && (0, $7hmfH.elem)('addCopyButton').checked) path += '&copyButton';
        if (debugType) path += `&debug=${debugType}`;
        window.open(path, '_blank');
        $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`made a ${onlyView ? 'read-only copy' : 'clone'} of the map into room: ${clonedRoom}`);
    }).catch(function(err) {
        console.log('Error saving clone to local storage:', err);
    });
}
function $5bc812abaa5f432b$var$mergeMap() {
    (0, $7hmfH.elem)('mergedRoom').value = '';
    (0, $7hmfH.elem)('mergeDialog').showModal();
}
function $5bc812abaa5f432b$var$doMerge() {
    const path = (0, $7hmfH.elem)('mergedRoom').value;
    if (!path) {
        (0, $7hmfH.alertMsg)('No map given to merge', 'error');
        return;
    }
    try {
        const url = new URL(path);
        const roomToMerge = url.searchParams.get('room');
        console.log('merging ', roomToMerge);
        (0, $a8a79648246a2e5c$export$547fdf2442351faf)(roomToMerge);
        $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`merged map from room: ${roomToMerge}`);
    } catch  {
        (0, $7hmfH.alertMsg)('Invalid map URL', 'error');
        return;
    }
    (0, $7hmfH.elem)('mergeDialog').close();
}
/* ----------------------------------------------------------- Search ------------------------------------------------------*/ /**
 * Open an input for user to type label of node to search for and generate suggestions when user starts typing
 */ function $5bc812abaa5f432b$var$search() {
    const searchBar = (0, $7hmfH.elem)('search-bar');
    if (searchBar.style.display === 'block') $5bc812abaa5f432b$var$hideSearchBar();
    else {
        searchBar.style.display = 'block';
        (0, $7hmfH.elem)('search-icon').style.display = 'block';
        searchBar.focus();
        (0, $7hmfH.listen)('search-bar', 'keyup', $5bc812abaa5f432b$var$searchTargets);
    }
}
/**
 * generate and display a set of suggestions - nodes with labels that include the substring that the user has typed
 */ function $5bc812abaa5f432b$var$searchTargets() {
    let str = (0, $7hmfH.elem)('search-bar').value;
    if (!str || str === ' ') {
        if ((0, $7hmfH.elem)('targets')) (0, $7hmfH.elem)('targets').remove();
        return;
    }
    let targets = (0, $7hmfH.elem)('targets');
    if (targets) targets.remove();
    targets = document.createElement('ul');
    targets.id = 'targets';
    targets.classList.add('search-ul');
    str = str.toLowerCase();
    const suggestions = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>n.label.toLowerCase().includes(str));
    suggestions.forEach((n)=>{
        const li = document.createElement('li');
        li.classList.add('search-suggestion');
        const div = document.createElement('div');
        div.classList.add('search-suggestion-text');
        div.innerText = n.label.replace(/\n/g, ' ');
        div.dataset.id = n.id;
        div.addEventListener('click', (event)=>$5bc812abaa5f432b$var$doSearch(event));
        li.appendChild(div);
        targets.appendChild(li);
    });
    (0, $7hmfH.elem)('suggestion-list').appendChild(targets);
}
/**
 * do the search using the string in the search bar and, when found, focus on that node
 */ function $5bc812abaa5f432b$var$doSearch(event) {
    const nodeId = event.target.dataset.id;
    if (nodeId) {
        const prevPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.focus(nodeId, {
            scale: 1.0,
            animation: {
                duration: 500
            }
        });
        const newPos = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getViewPosition();
        const newScale = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getScale();
        (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(1.0);
        (0, $95c555713171f487$export$4ccc1b9eba0bcd20)(prevPos.x - newPos.x, prevPos.y - newPos.y, 1.0);
        (0, $95c555713171f487$export$8a6e5c2ddf85cd20)(newScale);
        (0, $7hmfH.elem)('zoom').value = newScale;
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
        $5bc812abaa5f432b$var$hideSearchBar();
    }
}
function $5bc812abaa5f432b$var$hideSearchBar() {
    const searchBar = (0, $7hmfH.elem)('search-bar');
    if ((0, $7hmfH.elem)('targets')) (0, $7hmfH.elem)('targets').remove();
    searchBar.value = '';
    searchBar.style.display = 'none';
    (0, $7hmfH.elem)('search-icon').style.display = 'none';
}
/**
 * show or hide the side panel
 */ function $5bc812abaa5f432b$var$togglePanel() {
    if ($5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden) {
        $5bc812abaa5f432b$var$panel.classList.remove('hide');
        $5bc812abaa5f432b$var$positionNotes();
    } else $5bc812abaa5f432b$var$panel.classList.add('hide');
    $5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden = !$5bc812abaa5f432b$export$34e0f9847d4c02dd.panelHidden;
}
(0, $7hmfH.dragElement)((0, $7hmfH.elem)('panel'), (0, $7hmfH.elem)('panelHeader'));
/* ------------------------------------------------operations related to the side panel -------------------------------------*/ /**
 * when the window is resized, make sure that the pane is still visible
 * @param {HTMLelement} pane
 */ function $5bc812abaa5f432b$var$keepPaneInWindow(pane) {
    if (pane.offsetLeft + pane.offsetWidth > $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetLeft + $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetWidth) pane.style.left = `${$5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetLeft + $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetWidth - pane.offsetWidth}px`;
    if (pane.offsetTop + pane.offsetHeight > $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetTop + $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetHeight) pane.style.top = `${$5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetTop + $5bc812abaa5f432b$export$34e0f9847d4c02dd.offsetHeight - pane.offsetHeight - document.querySelector('footer').offsetHeight}px`;
}
// CSpell: ignore tabcontent, tablinks
function $5bc812abaa5f432b$var$openTab(tabId, evt) {
    const tabcontent = document.getElementsByClassName('tabcontent');
    // Get all elements with class="tabcontent" and hide them by moving them off screen
    for(let i = 0; i < tabcontent.length; i++)tabcontent[i].classList.add('hide');
    // Get all elements with class="tablinks" and remove the class "active"
    const tablinks = document.getElementsByClassName('tablinks');
    for(let i = 0; i < tablinks.length; i++)tablinks[i].className = tablinks[i].className.replace(' active', '');
    // Show the current tab, and add an "active" class to the button that opened the tab
    (0, $7hmfH.elem)(tabId).classList.remove('hide');
    evt.currentTarget.className += ' active';
    (0, $7hmfH.clearStatusBar)();
    // if a Notes panel is in the way, move it
    $5bc812abaa5f432b$var$positionNotes();
}
// Factors and Links Tabs
function $5bc812abaa5f432b$var$applySampleToNode(event) {
    if (event.detail !== 1) return; // only process single clicks here
    const selectedNodeIds = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes();
    if (selectedNodeIds.length === 0) return;
    const nodesToUpdate = [];
    const sample = event.currentTarget.groupNode;
    for (let node of $5bc812abaa5f432b$export$4051a07651545597.nodes.get(selectedNodeIds)){
        if (node.isCluster) break;
        if (sample !== node.grp) {
            node = (0, $7hmfH.deepMerge)(node, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[sample]);
            node.grp = sample;
            node.modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
            nodesToUpdate.push(node);
        }
    }
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodesToUpdate);
    const nNodes = nodesToUpdate.length;
    if (nNodes) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`applied ${(0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).nodes[sample].groupLabel} style to ${nNodes === 1 ? nodesToUpdate[0].label : nNodes + ' factors'}`);
    $5bc812abaa5f432b$export$794b27baf354ffba = sample;
}
/**
 * Apply the sample's format to the selected links
 * @param {event} event
 */ function $5bc812abaa5f432b$var$applySampleToLink(event) {
    if (event.detail !== 1) return; // only process single clicks here
    const sample = event.currentTarget.groupLink;
    const selectedEdges = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges();
    if (selectedEdges.length === 0) return;
    const edgesToUpdate = [];
    for (let edge of $5bc812abaa5f432b$export$4051a07651545597.edges.get(selectedEdges)){
        if (edge.isClusterEdge) break;
        if (sample !== edge.grp) {
            edge = (0, $7hmfH.deepMerge)(edge, (0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[sample]);
            edge.grp = sample;
            edge.modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
            edgesToUpdate.push(edge);
        }
    }
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(edgesToUpdate);
    const nEdges = edgesToUpdate.length;
    if (nEdges) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`applied ${(0, $2044cce2dd0aa04b$export$9dd6ff9ea0189349).edges[sample].groupLabel} style to ${nEdges} link${nEdges === 1 ? '' : 's'} `);
    $5bc812abaa5f432b$export$a01f2d76756b77a5 = sample;
}
function $5bc812abaa5f432b$export$7ac138a1e38951d6(nodeId, linkId) {
    if (nodeId) {
        $5bc812abaa5f432b$export$794b27baf354ffba = nodeId;
        const sampleNodes = Array.from(document.getElementsByClassName('sampleNode'));
        const node = sampleNodes.filter((e)=>e.groupNode === nodeId)[0];
        sampleNodes.forEach((n)=>n.classList.remove('sampleSelected'));
        node.classList.add('sampleSelected');
    }
    if (linkId) {
        $5bc812abaa5f432b$export$a01f2d76756b77a5 = linkId;
        const sampleLinks = Array.from(document.getElementsByClassName('sampleLink'));
        const link = sampleLinks.filter((e)=>e.groupLink === linkId)[0];
        sampleLinks.forEach((n)=>n.classList.remove('sampleSelected'));
        link.classList.add('sampleSelected');
    }
}
/**
 * Hide or reveal all the Factors or Links with the given style
 * @param {Object} obj {sample: state}
 */ function $5bc812abaa5f432b$var$updateFactorsOrLinksHiddenByStyle(obj) {
    for(const sampleElementId in obj){
        const sampleElement = (0, $7hmfH.elem)(sampleElementId);
        const state = obj[sampleElementId];
        sampleElement.dataset.hide = state ? 'hidden' : 'visible';
        sampleElement.style.opacity = state ? 0.6 : 1.0;
    }
}
/********************************************************Notes********************************************** */ /**
 * Globally either display or don't display notes when a factor or link is selected
 * @param {Event} e
 */ function $5bc812abaa5f432b$var$showNotesSwitch(e) {
    $5bc812abaa5f432b$var$showNotesToggle = e.target.checked;
    $5bc812abaa5f432b$var$doShowNotes($5bc812abaa5f432b$var$showNotesToggle);
    $5bc812abaa5f432b$export$807f940a96777041.set('showNotes', $5bc812abaa5f432b$var$showNotesToggle);
}
function $5bc812abaa5f432b$var$doShowNotes(toggle) {
    (0, $7hmfH.elem)('showNotesSwitch').checked = toggle;
    $5bc812abaa5f432b$var$showNotesToggle = toggle;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.redraw();
    $5bc812abaa5f432b$var$showNodeOrEdgeData();
}
/**
 * User has clicked the pinned badge.  Toggle pin state and fix the location of the node
 */ function $5bc812abaa5f432b$var$setFixed() {
    if ($5bc812abaa5f432b$var$viewOnly) return;
    const pinned = (0, $7hmfH.elem)('fixed').style.display === 'none';
    const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$var$editor.id);
    node.fixed = pinned;
    (0, $7hmfH.elem)('fixed').style.display = node.fixed ? 'inline' : 'none';
    (0, $7hmfH.elem)('unfixed').style.display = node.fixed ? 'none' : 'inline';
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(node);
}
/**
 * Display a panel to show info about the selected edge or node
 */ function $5bc812abaa5f432b$var$showNodeOrEdgeData() {
    $5bc812abaa5f432b$var$hideNotes();
    if (!$5bc812abaa5f432b$var$showNotesToggle) return;
    if ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes().length === 1) $5bc812abaa5f432b$var$showNodeData();
    else if ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges().length === 1) $5bc812abaa5f432b$var$showEdgeData();
}
/**
 * open another window (popupWindow) in which Notes can be edited
 */ function $5bc812abaa5f432b$var$openNotesWindow() {
    $5bc812abaa5f432b$var$popupWindow = window.open('./dist/NoteWindow.html', 'popupWindowName', 'toolbar=no,width=600,height=600');
}
/**
 * Hide the Node or Edge Data panel
 */ function $5bc812abaa5f432b$var$hideNotes() {
    if ($5bc812abaa5f432b$var$editor == null) return;
    let notesPanel = document.getElementById('nodeNotePanel');
    if (notesPanel.classList.contains('hide')) notesPanel = document.getElementById('edgeNotePanel');
    if (notesPanel.classList.contains('hide')) return;
    notesPanel.classList.add('hide');
    document.getSelection().removeAllRanges();
    notesPanel.querySelector('.ql-toolbar')?.remove();
    $5bc812abaa5f432b$var$editor = null;
    if ($5bc812abaa5f432b$var$popupWindow) $5bc812abaa5f432b$var$popupWindow.close();
}
/**
 * Show the notes box and the fixed node check box
 * @param {integer} nodeId
 */ function $5bc812abaa5f432b$var$showNodeData(nodeId) {
    const panel = (0, $7hmfH.elem)('nodeNotePanel');
    nodeId = nodeId || $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes()[0];
    const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(nodeId);
    (0, $7hmfH.elem)('fixed').style.display = node.fixed && !$5bc812abaa5f432b$var$viewOnly ? 'inline' : 'none';
    (0, $7hmfH.elem)('unfixed').style.display = node.fixed || $5bc812abaa5f432b$var$viewOnly ? 'none' : 'inline';
    (0, $7hmfH.elem)('nodeLabel').innerHTML = node.label ? (0, $7hmfH.shorten)(node.label) : '';
    if (node.created) {
        (0, $7hmfH.elem)('nodeCreated').innerHTML = `${(0, $7hmfH.timeAndDate)(node.created.time)} by ${node.created.user}`;
        (0, $7hmfH.elem)('nodeCreation').style.display = 'flex';
    } else (0, $7hmfH.elem)('nodeCreation').style.display = 'none';
    if (node.modified) {
        (0, $7hmfH.elem)('nodeModified').innerHTML = `${(0, $7hmfH.timeAndDate)(node.modified.time)} by ${node.modified.user}`;
        (0, $7hmfH.elem)('nodeModification').style.display = 'flex';
    } else (0, $7hmfH.elem)('nodeModification').style.display = 'none';
    $5bc812abaa5f432b$var$editor = new (0, $lvw85.default)('#node-notes', {
        modules: {
            toolbar: $5bc812abaa5f432b$var$viewOnly ? null : [
                'bold',
                'italic',
                'underline',
                'link',
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                },
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ]
        },
        placeholder: 'Notes',
        theme: 'snow',
        readOnly: $5bc812abaa5f432b$var$viewOnly
    });
    window.editor = $5bc812abaa5f432b$var$editor // used by popupEditor to access this editor
    ;
    $5bc812abaa5f432b$var$editor.id = node.id;
    if (node.note) {
        if (node.note instanceof Object) $5bc812abaa5f432b$var$editor.setContents(node.note);
        else $5bc812abaa5f432b$var$editor.setText(node.note);
    } else $5bc812abaa5f432b$var$editor.setText('');
    $5bc812abaa5f432b$var$editor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') {
            $5bc812abaa5f432b$export$4051a07651545597.nodes.update({
                id: nodeId,
                note: (0, $7hmfH.isQuillEmpty)($5bc812abaa5f432b$var$editor) ? '' : $5bc812abaa5f432b$var$editor.getContents(),
                modified: $5bc812abaa5f432b$export$fc00ee57782020aa()
            });
            if ($5bc812abaa5f432b$var$popupWindow) {
                $5bc812abaa5f432b$var$popupEditor = $5bc812abaa5f432b$var$popupWindow.popupEditor;
                if ($5bc812abaa5f432b$var$popupEditor) $5bc812abaa5f432b$var$popupEditor.setContents($5bc812abaa5f432b$var$editor.getContents());
            }
        }
    });
    panel.classList.remove('hide');
    $5bc812abaa5f432b$var$positionNotes();
}
/**
 * user has clicked on the sparkles icon in a Factor window
 * return the output from an LLM asked to explain the factor
 */ async function $5bc812abaa5f432b$var$genAINode() {
    const sparklesElem = (0, $7hmfH.elem)('sparklesNode');
    sparklesElem.classList.add('rotating');
    const nodeId = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes()[0];
    const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(nodeId);
    let context = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().map((n)=>n.label.replaceAll('\n', ' ')).join(', ');
    const userPrompt = $5bc812abaa5f432b$var$editor.getText().trim();
    if (!userPrompt.includes('This text has been generated by AI')) context += `, and also consider: ${userPrompt}`;
    const systemPrompt = `You are to explain a single factor, A.
Follow all the instructions below for your response:

Write a compact, clear explanation of what A is, what it measures and how it may vary.

Structure the output in the following order without using any section headings or a title:
1 Introduction
2 Bullet points explaining features of A.
3 Evidence section containing academic citations and links to relevant web pages
4 Summary
Always begin the answer with: > ***This text has been generated by AI. It needs to be checked carefully.***
Do not begin by repeating the factor that is being explained.
The introduction should be no more than 50 words.
The bullet points should clearly explain features of A in no more than 150 words.
The evidence section should provide academic references that support the explanation, with a brief explanation of how each reference supports it.
All academic references must include full citations (author, date, title, source). Do not include DOIs.  You must verify that all academic references that you mention actually exist.
Always embed links for any referenced web pages.
The summary should concisely restate the main points in no more than 50 words.

Maximum total output length: 200 words.
Format everything in Markdown.`;
    (0, $7hmfH.alertMsg)('Processing...', 'info', true);
    $5bc812abaa5f432b$var$editor.setText('Processing...\n');
    const aiResponse = await (0, $5b1c69f3dc1e76b0$export$d96944eb3d865634)(`Explain ${node.label}. Use these keywords as context: ${context}`, systemPrompt);
    $5bc812abaa5f432b$var$editor.setContents(aiResponse);
    const modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update({
        id: nodeId,
        note: (0, $7hmfH.isQuillEmpty)($5bc812abaa5f432b$var$editor) ? '' : $5bc812abaa5f432b$var$editor.getContents(),
        modified: modified
    });
    (0, $7hmfH.elem)('nodeModified').innerHTML = `${(0, $7hmfH.timeAndDate)(modified.time)} by ${modified.user}`;
    $5bc812abaa5f432b$var$positionNotes();
    sparklesElem.classList.remove('rotating');
    if ($5bc812abaa5f432b$var$popupWindow) {
        $5bc812abaa5f432b$var$popupEditor = $5bc812abaa5f432b$var$popupWindow.popupEditor;
        if ($5bc812abaa5f432b$var$popupEditor) $5bc812abaa5f432b$var$popupEditor.setContents($5bc812abaa5f432b$var$editor.getContents());
    }
    (0, $7hmfH.cancelAlertMsg)();
}
/**
 * Make the notes panel resizeable by dragging its corner handles
 * @param {HTMLElement} notePanel
 */ function $5bc812abaa5f432b$var$makeNotesPanelResizeable(notePanel) {
    const notePanelCornerHandle = notePanel.querySelector('.corner-handle');
    const notePanelTopLeftHandle = notePanel.querySelector('.corner-handle-top-left');
    let isResizingCorner = false;
    let isResizingTopLeft = false;
    let startX = 0;
    let startY = 0;
    let startWidth = 0;
    let startHeight = 0;
    let startLeft = 0;
    let startTop = 0;
    // Bottom-right corner handle
    notePanelCornerHandle.addEventListener('pointerdown', (e)=>{
        isResizingCorner = true;
        startX = e.clientX;
        startY = e.clientY;
        const styles = window.getComputedStyle(notePanel);
        startWidth = parseInt(styles.width, 10);
        startHeight = parseInt(styles.height, 10);
        document.body.style.userSelect = 'none';
        // Prevent default touch behaviors like scrolling
        notePanelCornerHandle.style.touchAction = 'none';
    });
    // Top-left corner handle
    notePanelTopLeftHandle.addEventListener('pointerdown', (e)=>{
        isResizingTopLeft = true;
        startX = e.clientX;
        startY = e.clientY;
        const styles = window.getComputedStyle(notePanel);
        startWidth = parseInt(styles.width, 10);
        startHeight = parseInt(styles.height, 10);
        startLeft = parseInt(styles.left, 10);
        startTop = parseInt(styles.top, 10);
        document.body.style.userSelect = 'none';
        // Prevent default touch behaviors like scrolling
        notePanelTopLeftHandle.style.touchAction = 'none';
    });
    document.addEventListener('pointermove', (e)=>{
        if (isResizingCorner) {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            const newWidth = startWidth + dx;
            const newHeight = startHeight + dy;
            if (newWidth > 150) notePanel.style.width = newWidth + 'px';
            if (newHeight > 200) notePanel.style.height = newHeight + 'px';
        } else if (isResizingTopLeft) {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            const newWidth = startWidth - dx;
            const newHeight = startHeight - dy;
            if (newWidth > 150) {
                notePanel.style.width = newWidth + 'px';
                notePanel.style.left = startLeft + dx + 'px';
            }
            if (newHeight > 200) {
                notePanel.style.height = newHeight + 'px';
                notePanel.style.top = startTop + dy + 'px';
            }
        }
    });
    document.addEventListener('pointerup', ()=>{
        isResizingCorner = false;
        isResizingTopLeft = false;
        document.body.style.userSelect = 'auto';
        $5bc812abaa5f432b$var$positionNotes();
    });
}
/**
 * Show the notes box for an edge
 * @param {integer} edgeId
 */ function $5bc812abaa5f432b$var$showEdgeData(edgeId) {
    const panel = (0, $7hmfH.elem)('edgeNotePanel');
    edgeId = edgeId || $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges()[0];
    const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId);
    (0, $7hmfH.elem)('edgeLabel').innerHTML = edge.label?.trim().length ? edge.label : `Link from "${(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.from).label)}" to "${(0, $7hmfH.shorten)($5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.to).label)}"`;
    if (edge.created) {
        (0, $7hmfH.elem)('edgeCreated').innerHTML = `${(0, $7hmfH.timeAndDate)(edge.created.time)} by ${edge.created.user}`;
        (0, $7hmfH.elem)('edgeCreation').style.display = 'flex';
    } else (0, $7hmfH.elem)('edgeCreation').style.display = 'none';
    if (edge.modified) {
        (0, $7hmfH.elem)('edgeModified').innerHTML = `${(0, $7hmfH.timeAndDate)(edge.modified.time)} by ${edge.modified.user}`;
        (0, $7hmfH.elem)('edgeModification').style.display = 'flex';
    } else (0, $7hmfH.elem)('edgeModification').style.display = 'none';
    $5bc812abaa5f432b$var$editor = new (0, $lvw85.default)('#edge-notes', {
        modules: {
            toolbar: $5bc812abaa5f432b$var$viewOnly ? null : [
                'bold',
                'italic',
                'underline',
                'link',
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                },
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ]
        },
        placeholder: 'Notes',
        theme: 'snow',
        readOnly: $5bc812abaa5f432b$var$viewOnly
    });
    $5bc812abaa5f432b$var$editor.id = edge.id;
    window.editor = $5bc812abaa5f432b$var$editor // used by popupEditor to access this editor
    ;
    if (edge.note) {
        if (edge.note instanceof Object) $5bc812abaa5f432b$var$editor.setContents(edge.note);
        else $5bc812abaa5f432b$var$editor.setText(edge.note);
    } else $5bc812abaa5f432b$var$editor.setText('');
    $5bc812abaa5f432b$var$editor.on('text-change', (delta, oldDelta, source)=>{
        if (source === 'user') {
            $5bc812abaa5f432b$export$4051a07651545597.edges.update({
                id: edgeId,
                note: (0, $7hmfH.isQuillEmpty)($5bc812abaa5f432b$var$editor) ? '' : $5bc812abaa5f432b$var$editor.getContents(),
                modified: $5bc812abaa5f432b$export$fc00ee57782020aa()
            });
            if ($5bc812abaa5f432b$var$popupWindow) {
                $5bc812abaa5f432b$var$popupEditor = $5bc812abaa5f432b$var$popupWindow.popupEditor;
                if ($5bc812abaa5f432b$var$popupEditor) $5bc812abaa5f432b$var$popupEditor.setContents($5bc812abaa5f432b$var$editor.getContents());
            }
        }
    });
    panel.classList.remove('hide');
    $5bc812abaa5f432b$var$positionNotes();
}
/**
 * user has clicked on the sparkles icon in a Link node window
 * return the output from an LLM asked to elaborate on the causal
 * relationship between the two linked factors
 */ async function $5bc812abaa5f432b$var$genAIEdge() {
    const sparklesElem = (0, $7hmfH.elem)('sparklesEdge');
    sparklesElem.classList.add('rotating');
    const edgeId = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedEdges()[0];
    const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(edgeId);
    let context = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().map((n)=>n.label.replaceAll('\n', ' ')).join(', ');
    const userPrompt = $5bc812abaa5f432b$var$editor.getText().trim();
    if (!userPrompt.includes('This text has been generated by AI')) context += `, and also consider: ${userPrompt}`;
    const systemPrompt = `You are to explain a single causal link of the form A causes B.
Follow all the instructions below for your response:

Write a compact, clear explanation of why or how A causes B.
Do not introduce new factors that are not present in the inputs.
Do not restate or describe the whole system \u{2014} focus only on the causal pathway from A to B, optionally referencing intermediary factors if necessary to provide a clear causal pathway.
Structure the output in the following order without using any section headings or a title:
1 Introduction
2 Bullet points explaining the causal reasoning
3 Evidence section containing academic citations and links to relevant web pages
4 Summary
Always begin the answer with: > ***This text has been generated by AI. It needs to be checked carefully.***
Do not begin by repeating the causal link that is being explained.
The introduction should be no more than 50 words.
The bullet points should clearly explain the causal reasoning in no more than 150 words.
The evidence section should provide academic references that support the causal link, with a brief explanation of how each reference supports the link.
All academic references must include full citations (author, date, title, source). Do not include DOIs.  You must verify that all academic references that you mention actually exist.
Always embed links for any referenced web pages.
The summary should concisely restate the main points in no more than 50 words.

Maximum total output length: 200 words.
Format everything in Markdown.`;
    (0, $7hmfH.alertMsg)('Processing...', 'info', true);
    $5bc812abaa5f432b$var$editor.setText('Processing...\n');
    const aiResponse = await (0, $5b1c69f3dc1e76b0$export$d96944eb3d865634)(`
Explain the causal link from ${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.from).label} to ${$5bc812abaa5f432b$export$4051a07651545597.nodes.get(edge.to).label}. 
Use these keywords as context: ${context}`, systemPrompt);
    $5bc812abaa5f432b$var$editor.setContents(aiResponse);
    const modified = $5bc812abaa5f432b$export$fc00ee57782020aa();
    $5bc812abaa5f432b$export$4051a07651545597.edges.update({
        id: edgeId,
        note: (0, $7hmfH.isQuillEmpty)($5bc812abaa5f432b$var$editor) ? '' : $5bc812abaa5f432b$var$editor.getContents(),
        modified: modified
    });
    (0, $7hmfH.elem)('edgeModified').innerHTML = `${(0, $7hmfH.timeAndDate)(modified.time)} by ${modified.user}`;
    $5bc812abaa5f432b$var$positionNotes();
    sparklesElem.classList.remove('rotating');
    if ($5bc812abaa5f432b$var$popupWindow) {
        $5bc812abaa5f432b$var$popupEditor = $5bc812abaa5f432b$var$popupWindow.popupEditor;
        if ($5bc812abaa5f432b$var$popupEditor) $5bc812abaa5f432b$var$popupEditor.setContents($5bc812abaa5f432b$var$editor.getContents());
    }
    (0, $7hmfH.cancelAlertMsg)();
}
/**
 * ensure that the panel is not outside the net pane, nor obscuring the Settings panel
 * @param {HTMLElement} notesPanel
 */ function $5bc812abaa5f432b$var$positionNotes() {
    let notesPanel = document.getElementById('nodeNotePanel');
    if (notesPanel.classList.contains('hide')) notesPanel = document.getElementById('edgeNotePanel');
    if (notesPanel.classList.contains('hide')) return;
    const netPane = document.getElementById('net-pane');
    const settings = document.getElementById('panel');
    let notesPanelRect = notesPanel.getBoundingClientRect();
    const settingsRect = settings.getBoundingClientRect();
    const netPaneRect = netPane.getBoundingClientRect();
    // if the notes would cover up the settings panel, move the notes to the left of the settings panel
    if (notesPanelRect.right > settingsRect.left && notesPanelRect.top < settingsRect.bottom) {
        notesPanel.style.left = `${settingsRect.left - notesPanelRect.width - 10}px`;
        notesPanelRect = notesPanel.getBoundingClientRect();
    }
    // if the notes panel is taller than the net pane, increase its width and reduce its height
    if (notesPanelRect.height > netPaneRect.height - 20) {
        notesPanel.style.width = `$({
						(notesPanelRect.width * notesPanelRect.height) / (netPaneRect.height - 20)
					}px`;
        notesPanel.style.height = `${netPaneRect.height - 20}px`;
        notesPanel.style.left = `${notesPanelRect.right - notesPanelRect.width}px`;
        notesPanel.style.top = 10;
        notesPanelRect = notesPanel.getBoundingClientRect();
    }
    // if the notes panel is wider than the net pane, reduce its width
    if (notesPanelRect.width > netPaneRect.width) {
        notesPanel.style.width = `${netPaneRect.width - 20}px`;
        notesPanel.style.left = 10;
        notesPanelRect = notesPanel.getBoundingClientRect();
    }
    // if the notes panel is outside the boundary of the net pane, shift it into the pane
    if (notesPanelRect.left < netPaneRect.left + 10) notesPanel.style.left = `${netPaneRect.left + 10}px`;
    if (notesPanelRect.right > netPaneRect.right - 10) notesPanel.style.left = `${netPaneRect.right - notesPanelRect.width - 10}px`;
    const visibleBottom = Math.min(notesPanelRect.bottom, notesPanelRect.top + notesPanel.offsetHeight);
    if (visibleBottom > netPaneRect.bottom - 10) notesPanel.style.top = `${netPaneRect.bottom - notesPanel.offsetHeight - 10}px`;
    if (notesPanelRect.top < netPaneRect.top + 10) notesPanel.style.top = `${netPaneRect.top + 10}px`;
}
// Network tab
/**
 * Choose and apply a layout algorithm
 */ function $5bc812abaa5f432b$var$autoLayout(e) {
    const option = e.target.value;
    const selectElement = (0, $7hmfH.elem)('layoutSelect');
    selectElement.value = option;
    const label = selectElement.options[selectElement.selectedIndex].innerText;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions() // record current positions so it can be undone
    ;
    if ($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.physics.options.enabled) {
        // another layout already in progress - cancel it first
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.off('stabilized');
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.stopSimulation();
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
            physics: {
                enabled: false
            }
        });
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
        (0, $7hmfH.alertMsg)(`Previous layout cancelled`, 'warn');
        (0, $7hmfH.clearStatusBar)();
    }
    $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
        switch(option){
            case 'off':
                $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
                    physics: {
                        enabled: false
                    }
                });
                break;
            case 'trophic':
                try {
                    (0, $a8c877a0bae3f8d4$export$cc9ec954c05f1d69)($5bc812abaa5f432b$export$4051a07651545597);
                    trophicDistribute();
                    $5bc812abaa5f432b$export$4051a07651545597.nodes.update($5bc812abaa5f432b$export$4051a07651545597.nodes.get());
                    (0, $7hmfH.elem)('layoutSelect').value = 'off';
                    (0, $7hmfH.statusMsg)('Trophic layout applied');
                } catch (e) {
                    (0, $7hmfH.alertMsg)(`Trophic layout: ${e.message}`, 'error');
                }
                break;
            case 'fan':
                {
                    const nodes = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>!n.nodeHidden);
                    nodes.forEach((n)=>n.level = undefined);
                    const selectedNodes = $5bc812abaa5f432b$var$getSelectedAndFixedNodes().map((nId)=>$5bc812abaa5f432b$export$4051a07651545597.nodes.get(nId));
                    if (selectedNodes.length === 0) {
                        (0, $7hmfH.alertMsg)('At least one Factor needs to be selected', 'error');
                        (0, $7hmfH.elem)('layoutSelect').value = 'off';
                        return;
                    }
                    // if Up or Down stream are selected, use those for the direction
                    let direction = 'from';
                    if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'downstream') direction = 'to';
                    else if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'upstream') direction = 'from';
                    else {
                        // if neither,
                        //  and more links from the selected nodes are going upstream then downstream,
                        //  put the selected nodes on the right, else on the left
                        let nUp = 0;
                        let nDown = 0;
                        selectedNodes.forEach((sl)=>{
                            nUp += $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(sl.id, 'to').filter((nId)=>!$5bc812abaa5f432b$export$4051a07651545597.nodes.get(nId).nodeHidden).length;
                            nDown += $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(sl.id, 'from').filter((nId)=>!$5bc812abaa5f432b$export$4051a07651545597.nodes.get(nId).nodeHidden).length;
                        });
                        direction = nUp > nDown ? 'to' : 'from';
                    }
                    const minX = Math.min(...nodes.map((n)=>n.x));
                    const maxX = Math.max(...nodes.map((n)=>n.x));
                    selectedNodes.forEach((n)=>{
                        setZLevel(n, direction);
                    });
                    nodes.forEach((n)=>{
                        if (n.level === undefined) n.level = 0;
                    });
                    const maxLevel = Math.max(...nodes.map((n)=>n.level));
                    const gap = (maxX - minX) / maxLevel;
                    for(let l = 0; l <= maxLevel; l++){
                        let x = l * gap + minX;
                        if (direction === 'from') x = maxX - l * gap;
                        const nodesOnLevel = nodes.filter((n)=>n.level === l);
                        nodesOnLevel.forEach((n)=>n.x = x);
                        const ySpaceNeeded = nodesOnLevel.map((n)=>{
                            const box = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(n.id);
                            return box.bottom - box.top + 10;
                        }).reduce((a, b)=>a + b, 0);
                        const yGap = ySpaceNeeded / nodesOnLevel.length;
                        let newY = -ySpaceNeeded / 2;
                        nodesOnLevel.sort((a, b)=>a.y - b.y).forEach((n)=>{
                            n.y = newY;
                            newY += yGap;
                        });
                    }
                    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodes);
                    (0, $7hmfH.elem)('layoutSelect').value = 'off';
                    (0, $7hmfH.statusMsg)('Fan layout applied');
                }
                break;
            case 'barnesHut':
            case 'repulsion':
                {
                    (0, $7hmfH.statusMsg)('Working...');
                    const options = {
                        physics: {
                            solver: option,
                            stabilization: true
                        }
                    };
                    options.physics[option] = {};
                    options.physics[option].springLength = avEdgeLength();
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions(options);
                    // cancel the iterative algorithms as soon as they have stabilized
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('stabilized', ()=>cancelLayout());
                }
                break;
            case 'forceAtlas2Based':
                {
                    (0, $7hmfH.statusMsg)('Working...');
                    const options = {
                        physics: {
                            solver: 'forceAtlas2Based',
                            forceAtlas2Based: {
                                theta: 2,
                                gravitationalConstant: -500,
                                centralGravity: 0.01,
                                springConstant: 0.3,
                                springLength: 0,
                                damping: 0.8,
                                avoidOverlap: 1
                            }
                        }
                    };
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions(options);
                    // cancel the iterative algorithms as soon as they have stabilized
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('stabilized', ()=>cancelLayout());
                    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.on('stabilizationProgress', (obj)=>{
                        (0, $7hmfH.statusMsg)(`Working... ${obj.iterations} iterations of ${obj.total}`);
                    });
                    break;
                }
            default:
                console.log('Unknown layout option');
                break;
        }
    });
    // if the layout doesn't stabilize, cancel it after 30 seconds
    setTimeout(()=>{
        cancelLayout();
    }, 30000);
    $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`applied ${label} layout`);
    /**
   * cancel the iterative layout algorithms
   */ function cancelLayout() {
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
            physics: {
                enabled: false
            }
        });
        $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.storePositions();
        (0, $7hmfH.elem)('layoutSelect').value = 'off';
        if (option !== 'off') (0, $7hmfH.statusMsg)(`${label} layout applied`);
        else (0, $7hmfH.statusMsg)('Layout cancelled');
        $5bc812abaa5f432b$export$4051a07651545597.nodes.update($5bc812abaa5f432b$export$4051a07651545597.nodes.get());
    }
    /**
   * set the levels for fan, using a breadth first search
   * @param {object} node root node
   * @param {string} direction either 'from' or 'to', depending on whether the links to use are point from or to the node
   */ function setZLevel(node, direction) {
        let q = [
            node
        ];
        let level = 0;
        node.level = 0;
        while(q.length > 0){
            const currentNode = q.shift();
            const connectedNodes = $5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(currentNode.id, direction)).filter((n)=>!n.nodeHidden && n.level === undefined);
            if (connectedNodes.length > 0) {
                level = currentNode.level + 1;
                connectedNodes.forEach((n)=>{
                    n.level = level;
                });
                q = q.concat(connectedNodes);
            }
        }
    }
    /**
   * find the average length of all edges, as a guide to the layout spring length
   * so that map is roughly as spaced out as before layout
   * @returns average length (in canvas units)
   */ function avEdgeLength() {
        let edgeSum = 0;
        $5bc812abaa5f432b$export$4051a07651545597.edges.forEach((e)=>{
            const from = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(e.from);
            const to = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(e.to);
            edgeSum += Math.sqrt((from.x - to.x) ** 2 + (from.y - to.y) ** 2);
        });
        return edgeSum / $5bc812abaa5f432b$export$4051a07651545597.edges.length;
    }
    /**
   * At each level for a trophic layout, distribute the Factors equally along the vertical axis,
   * avoiding overlaps
   */ function trophicDistribute() {
        for(let level = 0; level <= $5bc812abaa5f432b$export$4448800f068b9d2f; level++){
            const nodesOnLevel = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>n.level === level);
            const ySpaceNeeded = nodesOnLevel.map((n)=>{
                const box = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getBoundingBox(n.id);
                return box.bottom - box.top + 10;
            }).reduce((a, b)=>a + b, 0);
            const gap = ySpaceNeeded / nodesOnLevel.length;
            let newY = -ySpaceNeeded / 2;
            nodesOnLevel.sort((a, b)=>a.y - b.y).forEach((n)=>{
                n.y = newY;
                newY += gap;
            });
        }
    }
}
function $5bc812abaa5f432b$var$snapToGridSwitch(e) {
    $5bc812abaa5f432b$var$snapToGridToggle = e.target.checked;
    $5bc812abaa5f432b$export$95ff17332160327a($5bc812abaa5f432b$var$snapToGridToggle);
    $5bc812abaa5f432b$export$807f940a96777041.set('snapToGrid', $5bc812abaa5f432b$var$snapToGridToggle);
}
function $5bc812abaa5f432b$export$95ff17332160327a(toggle) {
    (0, $7hmfH.elem)('snaptogridswitch').checked = toggle;
    if (toggle) $5bc812abaa5f432b$export$4051a07651545597.nodes.update($5bc812abaa5f432b$export$4051a07651545597.nodes.get().map((n)=>{
        $5bc812abaa5f432b$var$snapToGrid(n);
        return n;
    }));
}
function $5bc812abaa5f432b$var$selectCurve(e) {
    const option = e.target.value;
    $5bc812abaa5f432b$export$264d5714f8b2c7d8(option);
    $5bc812abaa5f432b$export$807f940a96777041.set('curve', option);
}
function $5bc812abaa5f432b$export$264d5714f8b2c7d8(option) {
    (0, $7hmfH.elem)('curveSelect').value = option;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
        /*     edges: {
          smooth: option === 'Curved' ? { type: 'cubicBezier' } : false,
        }, */ edges: {
            smooth: {
                type: 'cubicBezier',
                roundness: option === 'Curved' ? 0.5 : 0.0
            }
        }
    });
}
function $5bc812abaa5f432b$var$updateNetBack(color) {
    const ul = (0, $7hmfH.elem)('underlay');
    ul.style.backgroundColor = color;
    // if in drawing mode, make the underlay translucent so that network shows through
    if ((0, $7hmfH.elem)('toolbox').style.display === 'block') $5bc812abaa5f432b$var$makeTranslucent(ul);
    $5bc812abaa5f432b$export$807f940a96777041.set('background', color);
}
const $5bc812abaa5f432b$var$backgroundOpacity = 0.6;
function $5bc812abaa5f432b$var$makeTranslucent(el) {
    el.style.backgroundColor = getComputedStyle(el).backgroundColor.replace(')', `, ${$5bc812abaa5f432b$var$backgroundOpacity})`).replace('rgb', 'rgba');
}
function $5bc812abaa5f432b$var$makeSolid(el) {
    el.style.backgroundColor = getComputedStyle(el).backgroundColor.replace(`, ${$5bc812abaa5f432b$var$backgroundOpacity})`, ')').replace('rgba', 'rgb');
}
function $5bc812abaa5f432b$export$2e65e79124cca55d(color) {
    (0, $7hmfH.elem)('underlay').style.backgroundColor = color;
    if ((0, $7hmfH.elem)('toolbox').style.display === 'block') $5bc812abaa5f432b$var$makeTranslucent((0, $7hmfH.elem)('underlay'));
    (0, $7hmfH.elem)('netBackColorWell').style.backgroundColor = color;
}
function $5bc812abaa5f432b$var$toggleDrawingLayer() {
    $5bc812abaa5f432b$export$c05995454a6ca00d = (0, $7hmfH.elem)('toolbox').style.display === 'block';
    const ul = (0, $7hmfH.elem)('underlay');
    if ($5bc812abaa5f432b$export$c05995454a6ca00d) {
        // close drawing layer
        (0, $95c555713171f487$export$f94e63f0099c362e)();
        (0, $7hmfH.elem)('toolbox').style.display = 'none';
        (0, $7hmfH.elem)('underlay').style.zIndex = 0;
        $5bc812abaa5f432b$var$makeSolid(ul);
        document.querySelector('.upper-canvas').style.zIndex = 0;
        $5bc812abaa5f432b$var$inAddMode = false;
        (0, $7hmfH.elem)('buttons').style.visibility = 'visible';
        $5bc812abaa5f432b$var$setButtonDisabledStatus('addNode', false);
        $5bc812abaa5f432b$var$setButtonDisabledStatus('addLink', false);
        $5bc812abaa5f432b$export$e810bab53f2cc5ca();
        if ((0, $7hmfH.elem)('showLegendSwitch').checked) (0, $3ee4e83c23551e65$export$9a9b59e08de24cef)();
        if (0, $95c555713171f487$export$f2efb2348b1e4771) $5bc812abaa5f432b$export$e5fde6ebaea8ae1d('drew on the background layer');
        $5bc812abaa5f432b$var$changeCursor('default');
    } else {
        // expose drawing layer
        (0, $7hmfH.elem)('toolbox').style.display = 'block';
        ul.style.zIndex = 70;
        ul.style.cursor = 'default';
        document.querySelector('.upper-canvas').style.zIndex = 71;
        // make the underlay (which is now overlay) translucent
        $5bc812abaa5f432b$var$makeTranslucent(ul);
        (0, $3ee4e83c23551e65$export$6bbbe775699090bc)();
        $5bc812abaa5f432b$var$inAddMode = 'disabled';
        (0, $7hmfH.elem)('buttons').style.visibility = 'hidden';
        (0, $7hmfH.elem)('help-button').style.visibility = 'visible';
        $5bc812abaa5f432b$var$setButtonDisabledStatus('addNode', true);
        $5bc812abaa5f432b$var$setButtonDisabledStatus('addLink', true);
        $5bc812abaa5f432b$var$setButtonDisabledStatus('undo', true);
        $5bc812abaa5f432b$var$setButtonDisabledStatus('redo', true);
    }
    $5bc812abaa5f432b$export$c05995454a6ca00d = !$5bc812abaa5f432b$export$c05995454a6ca00d;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.redraw();
}
function $5bc812abaa5f432b$var$ensureNotDrawing() {
    if (!$5bc812abaa5f432b$export$c05995454a6ca00d) return;
    $5bc812abaa5f432b$var$toggleDrawingLayer();
    (0, $7hmfH.elem)('drawing').checked = false;
}
function $5bc812abaa5f432b$var$selectAllFactors() {
    $5bc812abaa5f432b$export$3ec31f8909af8acf($5bc812abaa5f432b$export$4051a07651545597.nodes.getIds({
        filter: (n)=>!n.nodeHidden
    }));
    $5bc812abaa5f432b$var$showSelected();
}
function $5bc812abaa5f432b$export$3ec31f8909af8acf(nodeIds) {
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.selectNodes(nodeIds, false);
    $5bc812abaa5f432b$var$showSelected();
}
function $5bc812abaa5f432b$var$selectAllLinks() {
    $5bc812abaa5f432b$export$2c92a894f29aaee5($5bc812abaa5f432b$export$4051a07651545597.edges.getIds({
        filter: (e)=>!e.edgeHidden
    }));
    $5bc812abaa5f432b$var$showSelected();
}
function $5bc812abaa5f432b$export$2c92a894f29aaee5(edgeIds) {
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.selectEdges(edgeIds);
    $5bc812abaa5f432b$var$showSelected();
}
/**
 * Selects all the nodes and edges that have been created or modified by a user
 */ function $5bc812abaa5f432b$var$selectUsersItems(event) {
    event.preventDefault();
    const userName = event.target.dataset.userName;
    const usersNodes = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>n.created?.user === userName || n.modified?.user === userName).map((n)=>n.id);
    const userEdges = $5bc812abaa5f432b$export$4051a07651545597.edges.get().filter((e)=>e.created?.user === userName || e.modified?.user === userName).map((e)=>e.id);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setSelection({
        nodes: usersNodes,
        edges: userEdges
    });
    $5bc812abaa5f432b$var$showSelected();
}
/**
 * Toggle display of the legend and record its setting
 * @param {event} e
 */ function $5bc812abaa5f432b$var$legendSwitch(e) {
    const on = e.target.checked;
    $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9(on, true);
    $5bc812abaa5f432b$export$807f940a96777041.set('legend', on);
}
function $5bc812abaa5f432b$export$e8f1ea4a10bfd1c9(on, warn) {
    (0, $7hmfH.elem)('showLegendSwitch').checked = on;
    if (on) (0, $3ee4e83c23551e65$export$9a9b59e08de24cef)(warn);
    else (0, $3ee4e83c23551e65$export$6bbbe775699090bc)();
}
function $5bc812abaa5f432b$var$votingSwitch(e) {
    const on = e.target.checked;
    $5bc812abaa5f432b$var$setVoting(on);
    $5bc812abaa5f432b$export$807f940a96777041.set('voting', on);
}
function $5bc812abaa5f432b$var$setVoting(on) {
    (0, $7hmfH.elem)('showVotingSwitch').checked = on;
    $5bc812abaa5f432b$var$showVotingToggle = on;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.redraw();
}
/************************************************************** Analysis tab ************************************************* */ /**
 *
 * @param {String} name of Radio button group
 * @returns value of the button that is checked
 */ function $5bc812abaa5f432b$var$getRadioVal(name) {
    // get list of radio buttons with specified name
    const radios = document.getElementsByName(name);
    // loop through list of radio buttons
    for(let i = 0, len = radios.length; i < len; i++){
        if (radios[i].checked) return radios[i].value;
    }
}
/**
 *
 * @param {String} name of the radio button group
 * @param {*} value check the button with this value
 */ function $5bc812abaa5f432b$var$setRadioVal(name, value) {
    // get list of radio buttons with specified name
    const radios = document.getElementsByName(name);
    // loop through list of radio buttons and set the check on the one with the value
    for(let i = 0, len = radios.length; i < len; i++)radios[i].checked = radios[i].value === value;
}
/**
 * Return an array of the node Ids of Factors that are selected or are pinned (fixed in position)
 * @returns Array
 */ function $5bc812abaa5f432b$var$getSelectedAndFixedNodes() {
    return [
        ...new Set($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getSelectedNodes().concat($5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>n.fixed).map((n)=>n.id)))
    ];
}
/**
 * Sets the Analysis radio buttons and Factor selection according to values in global hiddenNodes
 *  (which is set when yNetMap is loaded, or when a file is read in)
 */ function $5bc812abaa5f432b$var$setAnalysisButtonsFromRemote() {
    if ($5bc812abaa5f432b$var$netLoaded) {
        const selectedNodes = [].concat($5bc812abaa5f432b$var$hiddenNodes.selected) // ensure that hiddenNodes.selected is an array
        ;
        if ($5bc812abaa5f432b$var$hiddenNodes.radiusSetting !== 'All' || $5bc812abaa5f432b$var$hiddenNodes.streamSetting !== 'All' || $5bc812abaa5f432b$var$hiddenNodes.pathsSetting !== 'All') {
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.selectNodes(selectedNodes, false) // in viewing  only mode, this does nothing
            ;
            if (selectedNodes.length > 0) {
                if (!$5bc812abaa5f432b$var$viewOnly) (0, $7hmfH.statusMsg)(`${$5bc812abaa5f432b$var$listFactors($5bc812abaa5f432b$var$getSelectedAndFixedNodes())} selected`);
            } else (0, $7hmfH.clearStatusBar)();
        }
        $5bc812abaa5f432b$var$showNodeOrEdgeData();
        if ($5bc812abaa5f432b$var$hiddenNodes.radiusSetting) $5bc812abaa5f432b$var$setRadioVal('radius', $5bc812abaa5f432b$var$hiddenNodes.radiusSetting);
        if ($5bc812abaa5f432b$var$hiddenNodes.streamSetting) $5bc812abaa5f432b$var$setRadioVal('stream', $5bc812abaa5f432b$var$hiddenNodes.streamSetting);
        if ($5bc812abaa5f432b$var$hiddenNodes.pathsSetting) $5bc812abaa5f432b$var$setRadioVal('paths', $5bc812abaa5f432b$var$hiddenNodes.pathsSetting);
    }
}
function $5bc812abaa5f432b$var$setYMapAnalysisButtons() {
    const selectedNodes = $5bc812abaa5f432b$var$getSelectedAndFixedNodes();
    $5bc812abaa5f432b$export$807f940a96777041.set('radius', {
        radiusSetting: $5bc812abaa5f432b$var$getRadioVal('radius'),
        selected: selectedNodes
    });
    $5bc812abaa5f432b$export$807f940a96777041.set('stream', {
        streamSetting: $5bc812abaa5f432b$var$getRadioVal('stream'),
        selected: selectedNodes
    });
    $5bc812abaa5f432b$export$807f940a96777041.set('paths', {
        pathsSetting: $5bc812abaa5f432b$var$getRadioVal('paths'),
        selected: selectedNodes
    });
}
/**
 * Hide factors and links to show only those closest to the selected factors and/or
 * those up/downstream and/or those on paths between the selected factors
 */ function $5bc812abaa5f432b$var$analyse() {
    const selectedNodes = $5bc812abaa5f432b$var$getSelectedAndFixedNodes();
    $5bc812abaa5f432b$var$setYMapAnalysisButtons();
    // get all nodes and edges and unhide them before hiding those not wanted to be visible
    const nodes = $5bc812abaa5f432b$export$4051a07651545597.nodes.get().filter((n)=>!n.isCluster).map((n)=>{
        (0, $7hmfH.setNodeHidden)(n, false);
        return n;
    });
    const edges = $5bc812abaa5f432b$export$4051a07651545597.edges.get().filter((e)=>!e.isClusterEdge).map((e)=>{
        (0, $7hmfH.setEdgeHidden)(e, false);
        return e;
    });
    $5bc812abaa5f432b$var$cancelHiddenStyles();
    // if showing everything, we are done
    if ($5bc812abaa5f432b$var$getRadioVal('radius') === 'All' && $5bc812abaa5f432b$var$getRadioVal('stream') === 'All' && $5bc812abaa5f432b$var$getRadioVal('paths') === 'All') {
        resetAll();
        $5bc812abaa5f432b$var$showSelected();
        $5bc812abaa5f432b$var$showNodeOrEdgeData();
        return;
    }
    // check that at least one factor is selected
    if (selectedNodes.length === 0 && $5bc812abaa5f432b$var$getRadioVal('paths') === 'All') {
        (0, $7hmfH.alertMsg)('A Factor needs to be selected', 'error');
        resetAll();
        return;
    }
    // but paths between factors needs at least two
    if ($5bc812abaa5f432b$var$getRadioVal('paths') !== 'All' && selectedNodes.length < 2) {
        (0, $7hmfH.alertMsg)('Select at least 2 factors to show paths between them', 'warn');
        resetAll();
        return;
    }
    $5bc812abaa5f432b$var$hideNotes();
    // these operations are not commutative (at least for networks with loops), so do them all in order
    if ($5bc812abaa5f432b$var$getRadioVal('radius') !== 'All') hideNodesByRadius(selectedNodes, parseInt($5bc812abaa5f432b$var$getRadioVal('radius')));
    if ($5bc812abaa5f432b$var$getRadioVal('stream') !== 'All') hideNodesByStream(selectedNodes, $5bc812abaa5f432b$var$getRadioVal('stream'));
    if ($5bc812abaa5f432b$var$getRadioVal('paths') !== 'All') hideNodesByPaths(selectedNodes, $5bc812abaa5f432b$var$getRadioVal('paths'));
    // finally display the map with its hidden factors and edges
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodes);
    $5bc812abaa5f432b$export$4051a07651545597.edges.update(edges);
    // announce what has been done
    let streamMsg = '';
    if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'upstream') streamMsg = 'upstream';
    if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'downstream') streamMsg = 'downstream';
    let radiusMsg = '';
    if ($5bc812abaa5f432b$var$getRadioVal('radius') === '1') radiusMsg = 'within one link';
    if ($5bc812abaa5f432b$var$getRadioVal('radius') === '2') radiusMsg = 'within two links';
    if ($5bc812abaa5f432b$var$getRadioVal('radius') === '3') radiusMsg = 'within three links';
    let pathsMsg = '';
    if ($5bc812abaa5f432b$var$getRadioVal('paths') === 'allPaths') pathsMsg = ': showing all paths';
    if ($5bc812abaa5f432b$var$getRadioVal('paths') === 'shortestPath') pathsMsg = ': showing shortest paths';
    if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'All' && $5bc812abaa5f432b$var$getRadioVal('radius') === 'All') (0, $7hmfH.statusMsg)(`Showing  ${$5bc812abaa5f432b$var$getRadioVal('paths') === 'allPaths' ? 'all paths' : 'shortest paths'} between ${$5bc812abaa5f432b$var$listFactors($5bc812abaa5f432b$var$getSelectedAndFixedNodes(), true)}`);
    else (0, $7hmfH.statusMsg)(`Factors ${streamMsg} ${streamMsg && radiusMsg ? ' and ' : ''} ${radiusMsg} of ${$5bc812abaa5f432b$var$listFactors($5bc812abaa5f432b$var$getSelectedAndFixedNodes(), true)}${pathsMsg}`);
    /**
   * return all to neutral analysis state
   */ function resetAll() {
        $5bc812abaa5f432b$var$setRadioVal('radius', 'All');
        $5bc812abaa5f432b$var$setRadioVal('stream', 'All');
        $5bc812abaa5f432b$var$setRadioVal('paths', 'All');
        $5bc812abaa5f432b$var$setYMapAnalysisButtons();
        $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodes);
        $5bc812abaa5f432b$export$4051a07651545597.edges.update(edges);
    }
    /**
   * Hide factors that are more than radius links distant from those selected
   * @param {string[]} selectedNodes
   * @param {Integer} radius
   */ function hideNodesByRadius(selectedNodes, radius) {
        const nodeIdsInRadiusSet = new Set();
        const linkIdsInRadiusSet = new Set();
        // put those factors and links within radius links into these sets
        if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'upstream' || $5bc812abaa5f432b$var$getRadioVal('stream') === 'All') inSet(selectedNodes, radius, 'to');
        if ($5bc812abaa5f432b$var$getRadioVal('stream') === 'downstream' || $5bc812abaa5f432b$var$getRadioVal('stream') === 'All') inSet(selectedNodes, radius, 'from');
        // hide all nodes and edges not in radius
        nodes.forEach((n)=>{
            if (!nodeIdsInRadiusSet.has(n.id)) (0, $7hmfH.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInRadiusSet.has(e.id)) (0, $7hmfH.setEdgeHidden)(e, true);
        });
        // add links between factors that are in radius set, to give an ego network
        nodeIdsInRadiusSet.forEach((f)=>{
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(f).forEach((e)=>{
                const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(e);
                if (nodeIdsInRadiusSet.has(edge.from) && nodeIdsInRadiusSet.has(edge.to)) (0, $7hmfH.setEdgeHidden)(edge, false);
            });
        });
        /**
     * recursive function to collect Factors and Links within radius links from any of the nodes listed in nodeIds
     * Factor ids are collected in nodeIdsInRadiusSet and links in linkIdsInRadiusSet
     * Links are followed in a consistent direction, i.e. if 'to', only links directed away from the the nodes are followed
     * @param {string[]} nodeIds
     * @param {number} radius
     * @param {string} direction - either 'from' or 'to'
     */ function inSet(nodeIds, radius, direction) {
            if (radius < 0) return;
            nodeIds.forEach((nId)=>{
                const linked = [];
                nodeIdsInRadiusSet.add(nId);
                const links = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(nId).filter((e)=>$5bc812abaa5f432b$export$4051a07651545597.edges.get(e)[direction] === nId);
                if (links && radius > 0) links.forEach((lId)=>{
                    linkIdsInRadiusSet.add(lId);
                    linked.push($5bc812abaa5f432b$export$4051a07651545597.edges.get(lId)[direction === 'to' ? 'from' : 'to']);
                });
                if (linked) inSet(linked, radius - 1, direction);
            });
        }
    }
    /**
   * Hide factors that are not up or downstream from the selected factors.
   * Does not include links or factors that are already hidden
   * @param {string[]} selectedNodes
   * @param {string} direction - 'upstream' or 'downstream'
   */ function hideNodesByStream(selectedNodes, upOrDown) {
        const nodeIdsInStreamSet = new Set();
        const linkIdsInStreamSet = new Set();
        const radiusVal = $5bc812abaa5f432b$var$getRadioVal('radius');
        let radius = Infinity;
        if (radiusVal !== 'All') radius = parseInt(radiusVal);
        let direction = 'to';
        if (upOrDown === 'upstream') direction = 'from';
        // breadth first search for all Factors that are downstream and less than or equal to radius links away
        $5bc812abaa5f432b$export$4051a07651545597.nodes.map((n)=>n.level = undefined);
        selectedNodes.forEach((nodeId)=>{
            nodeIdsInStreamSet.add(nodeId);
            const node = $5bc812abaa5f432b$export$4051a07651545597.nodes.get(nodeId);
            let q = [
                node
            ];
            let level = 0;
            node.level = 0;
            while(q.length > 0 && level <= radius){
                const currentNode = q.shift();
                const connectedNodes = $5bc812abaa5f432b$export$4051a07651545597.nodes.get($5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(currentNode.id, direction)).filter((n)=>!(n.nodeHidden || nodeIdsInStreamSet.has(n.id)));
                if (connectedNodes.length > 0) {
                    level = currentNode.level + 1;
                    connectedNodes.forEach((n)=>{
                        nodeIdsInStreamSet.add(n.id);
                        n.level = level;
                    });
                    q = q.concat(connectedNodes);
                }
            }
        });
        // hide all nodes and edges not up or down stream
        nodes.forEach((n)=>{
            if (!nodeIdsInStreamSet.has(n.id)) (0, $7hmfH.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInStreamSet.has(e.id)) (0, $7hmfH.setEdgeHidden)(e, true);
        });
        // add links between factors that are in radius set, to give an ego network
        nodeIdsInStreamSet.forEach((f)=>{
            $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(f).forEach((e)=>{
                const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(e);
                if (nodeIdsInStreamSet.has(edge.from) && nodeIdsInStreamSet.has(edge.to)) (0, $7hmfH.setEdgeHidden)(edge, false);
            });
        });
    }
    /**
   * Hide all factors and links that are not on the shortest path (or all paths) between the selected factors
   * Avoids factors or links that are hidden
   * @param {string[]} selectedNodes
   * @param {string} pathType - either 'allPaths' or 'shortestPath'
   */ function hideNodesByPaths(selectedNodes, pathType) {
        // paths is an array of objects with from and to node ids, or an empty array if there is no path
        const paths = shortestPaths(selectedNodes, pathType === 'allPaths');
        if (paths.length === 0) {
            (0, $7hmfH.alertMsg)('No path between the selected Factors', 'info');
            $5bc812abaa5f432b$var$setRadioVal('paths', 'All');
            $5bc812abaa5f432b$var$setYMapAnalysisButtons();
            return;
        }
        // hide nodes and links that are not included in paths
        const nodeIdsInPathsSet = new Set();
        const linkIdsInPathsSet = new Set();
        paths.forEach((links)=>{
            links.forEach((link)=>{
                const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get({
                    filter: (e)=>e.to === link.to && e.from === link.from
                })[0];
                linkIdsInPathsSet.add(edge.id);
                nodeIdsInPathsSet.add(edge.from);
                nodeIdsInPathsSet.add(edge.to);
            });
        });
        // hide all factors and links that are not in the set of paths
        nodes.forEach((n)=>{
            if (!nodeIdsInPathsSet.has(n.id)) (0, $7hmfH.setNodeHidden)(n, true);
        });
        edges.forEach((e)=>{
            if (!linkIdsInPathsSet.has(e.id)) (0, $7hmfH.setEdgeHidden)(e, true);
        });
        /**
     * Given two or more selected factors, return a list of all the links that are either on any path between them, or just the ones on the shortest paths between them
     * @param {Boolean} all when true, find all the links that connect to the selected factors; when false, find the shortest paths between the selected factors
     * @returns	Arrays of objects with from: and to: properties for all the links (an empty array if there is no path between any of the selected factors)
     */ function shortestPaths(selectedNodes, all) {
            const visited = new Map();
            const allPaths = [];
            // list of all pairs of the selected factors
            const combos = selectedNodes.flatMap((v, i)=>selectedNodes.slice(i + 1).map((w)=>[
                        v,
                        w
                    ]));
            // for each pair, find the sequences of links in both directions and combine them
            combos.forEach((combo)=>{
                const source = combo[0];
                const dest = combo[1];
                let links = pathList(source, dest, all);
                if (links.length > 0) allPaths.push(links);
                links = pathList(dest, source, all);
                if (links.length > 0) allPaths.push(links);
            });
            return allPaths;
            /**
       * find the paths (as a list of links) that connect the source and destination
       * @param {String} source
       * @param {String} dest
       * @param {Boolean} all true of all paths between Source and Destination are wanted; false if just the shortest path
       * @returns an array of lists of links that connect the paths
       */ function pathList(source, dest, all) {
                visited.clear();
                const links = [];
                let paths = getPaths(source, dest);
                // if no path found, getPaths return an array of length greater than the total number of factors in the map, or a string
                // in this case, return an empty list
                if (!Array.isArray(paths) || paths.length === $5bc812abaa5f432b$export$4051a07651545597.nodes.length + 1) paths = [];
                if (!all) for(let i = 0; i < paths.length - 1; i++)links.push({
                    from: paths[i],
                    to: paths[i + 1]
                });
                return links;
                /**
         * recursively explore the map starting from source until destination is reached.
         * stop if a factor has already been visited, or at a dead end (zero out-degree)
         * @param {String} source
         * @param {String} dest
         * @returns an array of factors, the path so far followed
         */ function getPaths(source, dest) {
                    if (source === dest) return [
                        dest
                    ];
                    visited.set(source, true);
                    let path = [
                        source
                    ];
                    // only consider nodes and edges that are not hidden
                    const connectedNodes = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedEdges(source).filter((e)=>{
                        const edge = $5bc812abaa5f432b$export$4051a07651545597.edges.get(e);
                        return !edge.edgeHidden && edge.from === source;
                    }).map((e)=>$5bc812abaa5f432b$export$4051a07651545597.edges.get(e).to);
                    if (connectedNodes.length === 0) return 'deadend';
                    if (all) // all paths between the source and destination
                    connectedNodes.forEach((next)=>{
                        const vis = visited.get(next);
                        if (vis === 'onpath') {
                            links.push({
                                from: source,
                                to: next
                            });
                            path = path.concat([
                                next
                            ]);
                        } else if (!vis) {
                            const p = getPaths(next, dest);
                            if (Array.isArray(p) && p.length > 0) {
                                links.push({
                                    from: source,
                                    to: next
                                });
                                visited.set(next, 'onpath');
                                path = path.concat(p);
                            }
                        }
                    });
                    else {
                        // shortest path between the source and destination
                        let bestPath = [];
                        let bestPathLength = $5bc812abaa5f432b$export$4051a07651545597.nodes.length;
                        connectedNodes.forEach((next)=>{
                            let p = visited.get(next);
                            if (!p) {
                                p = getPaths(next, dest);
                                visited.set(next, p);
                            }
                            if (Array.isArray(p) && p.length > 0) {
                                if (p.length < bestPathLength) {
                                    bestPath = p;
                                    bestPathLength = p.length;
                                }
                            }
                        });
                        path = path.concat(bestPath);
                    }
                    // if no progress has been made (the path is just the initial source factor), return an empty path
                    if (path.length === 1) path = [];
                    return path;
                }
            }
        }
    }
}
/**
 * Unset the indicators on the Settings Factor and Link tabs that show that Factors/Links with
 * these styles are hidden
 * Assumes that the factors and links have already been unhidden - this just  removes the UI indicators
 */ function $5bc812abaa5f432b$var$cancelHiddenStyles() {
    Array.from(document.getElementsByClassName('sampleNode')).filter((n)=>n.dataset.hide === 'hidden').forEach((n)=>{
        n.dataset.hide = 'visible';
        n.style.opacity = 1.0;
    });
    Array.from(document.getElementsByClassName('sampleLink')).filter((e)=>e.dataset.hide === 'hidden').forEach((e)=>{
        e.dataset.hide = 'visible';
        e.style.opacity = 1.0;
    });
}
function $5bc812abaa5f432b$var$sizingSwitch(e) {
    const metric = e.target.value;
    $5bc812abaa5f432b$export$9758cac25f26dd85(metric);
    $5bc812abaa5f432b$export$807f940a96777041.set('sizing', metric);
}
/**
 * set the size of the nodes proportional to the selected metric
 * @param {String} metric none, all the same size, in degree, out degree or betweenness centrality
 */ // constants for sizes of nodes
const $5bc812abaa5f432b$var$MIN_WIDTH = 50;
const $5bc812abaa5f432b$var$EQUAL_WIDTH = 100;
const $5bc812abaa5f432b$var$MAX_WIDTH = 200;
function $5bc812abaa5f432b$export$9758cac25f26dd85(metric) {
    const nodesToUpdate = [];
    let min = Number.MAX_VALUE;
    let max = 0;
    $5bc812abaa5f432b$export$4051a07651545597.nodes.forEach((node)=>{
        const oldValue = node.val;
        switch(metric){
            case 'Off':
            case 'Equal':
                node.val = 0;
                break;
            case 'Inputs':
                node.val = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'from').length;
                break;
            case 'Outputs':
                node.val = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'to').length;
                break;
            case 'Leverage':
                {
                    const inDegree = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'from').length;
                    const outDegree = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.getConnectedNodes(node.id, 'to').length;
                    node.val = inDegree === 0 ? 0 : outDegree / inDegree;
                    break;
                }
            case 'Centrality':
                node.val = node.bc;
                break;
        }
        if (node.val < min) min = node.val;
        if (node.val > max) max = node.val;
        if (metric === 'Off' || metric === 'Equal' || node.val !== oldValue) nodesToUpdate.push(node);
    });
    $5bc812abaa5f432b$export$4051a07651545597.nodes.forEach((node)=>{
        switch(metric){
            case 'Off':
                node.widthConstraint = node.heightConstraint = false;
                node.size = 25;
                break;
            case 'Equal':
                node.widthConstraint = node.heightConstraint = node.size = $5bc812abaa5f432b$var$EQUAL_WIDTH;
                break;
            default:
                node.widthConstraint = node.heightConstraint = node.size = $5bc812abaa5f432b$var$MIN_WIDTH + $5bc812abaa5f432b$var$MAX_WIDTH * scale(min, max, node.val);
        }
    });
    $5bc812abaa5f432b$export$4051a07651545597.nodes.update(nodesToUpdate);
    (0, $7hmfH.elem)('sizing').value = metric;
    function scale(min, max, value) {
        if (max === min) return 0.5;
        else return Math.max(0, (value - min) * (1 / (max - min)));
    }
}
// Note: most of the clustering functionality is in cluster.js
/**
 * User has chosen a clustering option
 * @param {Event} e
 */ function $5bc812abaa5f432b$var$selectClustering(e) {
    const option = e.target.value;
    // it doesn't make much sense to cluster while the factors are hidden, so undo that
    $5bc812abaa5f432b$var$setRadioVal('radius', 'All');
    $5bc812abaa5f432b$var$setRadioVal('stream', 'All');
    $5bc812abaa5f432b$var$setRadioVal('paths', 'All');
    $5bc812abaa5f432b$var$setYMapAnalysisButtons();
    $5bc812abaa5f432b$export$2a111da947c407d2.transact(()=>{
        $5bc812abaa5f432b$export$4051a07651545597.nodes.update($5bc812abaa5f432b$export$4051a07651545597.nodes.get().map((n)=>{
            (0, $7hmfH.setNodeHidden)(n, false);
            return n;
        }));
        $5bc812abaa5f432b$export$4051a07651545597.edges.update($5bc812abaa5f432b$export$4051a07651545597.edges.get().map((e)=>{
            (0, $7hmfH.setEdgeHidden)(e, false);
            return e;
        }));
    });
    (0, $f00af92264e1701c$export$54c7dfe5600eab89)(option);
    $5bc812abaa5f432b$export$1e044b7877db048c();
    $5bc812abaa5f432b$export$807f940a96777041.set('cluster', option);
}
function $5bc812abaa5f432b$export$8b2b949f916968c1(option) {
    (0, $7hmfH.elem)('clustering').value = option;
}
function $5bc812abaa5f432b$export$5323aa6dd0c7006b(obj) {
    // remove any old select items, other than the standard ones (which are the first 4: None, Style, Color, Community)
    const select = (0, $7hmfH.elem)('clustering');
    for(let i = select.options.length - 1; i >= 4; i--)select.remove(i);
    // append the ones provided
    for(const property in obj)if (obj[property] !== '*deleted*') {
        const opt = document.createElement('option');
        opt.value = property;
        opt.text = (0, $7hmfH.shorten)(obj[property], 12);
        select.add(opt, null);
    }
}
/* ---------------------------------------history window --------------------------------*/ /**
 * display the history log in a window
 */ function $5bc812abaa5f432b$var$showHistory(smoothScroll = true) {
    (0, $7hmfH.elem)('history-window').style.display = 'block';
    const log = (0, $7hmfH.elem)('history-log');
    log.innerHTML = $5bc812abaa5f432b$export$d920e34eaf2b21cb.toArray().map((rec)=>`<div class="history-time">${(0, $7hmfH.timeAndDate)(rec.time)}: </div>
		<div class="history-action">${rec.user} ${rec.action}</div>
		<div class="history-rollback" data-time="${rec.time}"></div>`).join(' ');
    Promise.all(Array.from(document.querySelectorAll('div.history-rollback')).map((e)=>$5bc812abaa5f432b$var$addRollbackIcon(e))).then(()=>$5bc812abaa5f432b$var$scrollHistoryToBottom(smoothScroll));
}
/**
 * Scroll the history log wrapper so the most recent entry is visible at the bottom
 */ function $5bc812abaa5f432b$var$scrollHistoryToBottom(smoothScroll) {
    const wrapper = (0, $7hmfH.elem)('history-log-wrapper');
    const log = (0, $7hmfH.elem)('history-log');
    requestAnimationFrame(()=>{
        wrapper.scrollTo({
            top: log.offsetHeight - wrapper.clientHeight,
            behavior: smoothScroll ? 'smooth' : 'instant'
        });
    });
}
/**
 * add a button for rolling back if there is state data corresponding to this log record
 * @param {HTMLElement} e - history record
 * */ async function $5bc812abaa5f432b$var$addRollbackIcon(e) {
    await (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).getItem($5bc812abaa5f432b$var$timekey(parseInt(e.dataset.time))).then((state)=>{
        if (state) {
            e.id = `hist${e.dataset.time}`;
            e.innerHTML = `<div class="tooltip">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bootstrap-reboot" viewBox="0 0 16 16">
				<path d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8z"/>
				<path d="M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6z"/>
				</svg>
				<span class="tooltiptext rollbacktip">Rollback to before this action</span>
			</div>
		</div>`;
            if ((0, $7hmfH.elem)(e.id)) (0, $7hmfH.listen)(e.id, 'click', $5bc812abaa5f432b$var$rollback);
        }
    });
}
/**
 * Restores the state of the map to a previous one
 * @param {Event} event
 * @returns null if no rollback possible or cancelled
 */ function $5bc812abaa5f432b$var$rollback(event) {
    const rbTime = parseInt(event.currentTarget.dataset.time);
    (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).getItem($5bc812abaa5f432b$var$timekey(rbTime)).then((rb)=>{
        if (!rb) return;
        if (!confirm(`Roll back the map to what it was before ${(0, $7hmfH.timeAndDate)(rbTime)}?`)) return;
        $5bc812abaa5f432b$var$restoreState(rb);
        (0, (/*@__PURE__*/$parcel$interopDefault($3568a0eaf2cac7b9$exports))).removeItem($5bc812abaa5f432b$var$timekey(rbTime));
        $5bc812abaa5f432b$export$e5fde6ebaea8ae1d(`rolled back the map to what it was before ${(0, $7hmfH.timeAndDate)(rbTime, true)}`, null, 'rollback');
    });
}
function $5bc812abaa5f432b$var$showHistorySwitch() {
    if ((0, $7hmfH.elem)('showHistorySwitch').checked) $5bc812abaa5f432b$var$showHistory(false);
    else (0, $7hmfH.elem)('history-window').style.display = 'none';
}
(0, $7hmfH.listen)('history-close', 'click', $5bc812abaa5f432b$var$historyClose);
function $5bc812abaa5f432b$var$historyClose() {
    (0, $7hmfH.elem)('history-window').style.display = 'none';
    (0, $7hmfH.elem)('showHistorySwitch').checked = false;
}
(0, $7hmfH.dragElement)((0, $7hmfH.elem)('history-window'), (0, $7hmfH.elem)('history-header'));
/* --------------------------------------- avatars and shared cursors--------------------------------*/ let $5bc812abaa5f432b$var$oldViewOnly = $5bc812abaa5f432b$var$viewOnly // save the viewOnly state
;
/* tell user if they are offline and disconnect websocket server */ window.addEventListener('offline', ()=>{
    (0, $7hmfH.alertMsg)('No network connection - working offline (view only)', 'info');
    $5bc812abaa5f432b$var$wsProvider.shouldConnect = false;
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: false,
            hover: false
        }
    });
    $5bc812abaa5f432b$var$hideNavButtons();
    $5bc812abaa5f432b$var$sideDrawEditor.enable(false);
    $5bc812abaa5f432b$var$oldViewOnly = $5bc812abaa5f432b$var$viewOnly;
    $5bc812abaa5f432b$var$viewOnly = true;
});
window.addEventListener('online', ()=>{
    $5bc812abaa5f432b$var$wsProvider.connect();
    (0, $7hmfH.alertMsg)('Network connection re-established', 'info');
    $5bc812abaa5f432b$var$viewOnly = $5bc812abaa5f432b$var$oldViewOnly;
    if (!$5bc812abaa5f432b$var$viewOnly) $5bc812abaa5f432b$var$showNavButtons();
    $5bc812abaa5f432b$var$sideDrawEditor.enable(true);
    $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.setOptions({
        interaction: {
            dragNodes: true,
            hover: true
        }
    });
    $5bc812abaa5f432b$var$showAvatars();
});
/**
 *  set up user monitoring (awareness)
 */ function $5bc812abaa5f432b$var$setUpAwareness() {
    $5bc812abaa5f432b$var$showAvatars();
    $5bc812abaa5f432b$var$yAwareness.on('change', (event)=>$5bc812abaa5f432b$var$receiveEvent(event));
    // regularly broadcast our own state, every 20 seconds
    setInterval(()=>{
        $5bc812abaa5f432b$var$yAwareness.setLocalStateField('pkt', {
            time: Date.now()
        });
    }, 20000);
    // if debug = fake, generate fake mouse events every 200 ms for testing
    if (/fake/.test($5bc812abaa5f432b$export$1c9f709888824e05)) setInterval(()=>{
        $5bc812abaa5f432b$var$yAwareness.setLocalStateField('cursor', {
            x: Math.random() * 1000 - 500,
            y: Math.random() * 1000 - 500
        });
    }, 200);
    // fade out avatar when there has been no movement of the mouse for 15 minutes
    $5bc812abaa5f432b$var$asleep(false);
    let sleepTimer = setTimeout(()=>$5bc812abaa5f432b$var$asleep(true), $5bc812abaa5f432b$var$TIMETOSLEEP);
    // throttle mousemove broadcast to avoid overloading server
    let throttled = false;
    const THROTTLETIME = 200;
    window.addEventListener('mousemove', (e)=>{
        // broadcast my mouse movements
        if (throttled) return;
        throttled = true;
        setTimeout(()=>throttled = false, THROTTLETIME);
        clearTimeout(sleepTimer);
        $5bc812abaa5f432b$var$asleep(false);
        sleepTimer = setTimeout(()=>$5bc812abaa5f432b$var$asleep(true), $5bc812abaa5f432b$var$TIMETOSLEEP);
        // broadcast current position of mouse in canvas coordinates
        const box = $5bc812abaa5f432b$export$4b72f5d71fff605.getBoundingClientRect();
        $5bc812abaa5f432b$var$yAwareness.setLocalStateField('cursor', $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.DOMtoCanvas({
            x: Math.round(e.clientX - box.left),
            y: Math.round(e.clientY - box.top)
        }));
    });
}
/**
 * Set the awareness local state to show whether this client is sleeping (no mouse movement for 15 minutes)
 * @param {Boolean} isSleeping
 */ function $5bc812abaa5f432b$var$asleep(isSleeping) {
    if ($5bc812abaa5f432b$var$myNameRec.asleep === isSleeping) return;
    $5bc812abaa5f432b$var$myNameRec.asleep = isSleeping;
    $5bc812abaa5f432b$var$yAwareness.setLocalState({
        user: $5bc812abaa5f432b$var$myNameRec
    });
    $5bc812abaa5f432b$var$showAvatars();
    //disconnect from websocket server to save resources when sleeping
    if (isSleeping) $5bc812abaa5f432b$var$wsProvider.disconnect();
    else $5bc812abaa5f432b$var$wsProvider.connect();
}
/**
 * display the awareness events
 * @param {object} event
 */ function $5bc812abaa5f432b$var$traceUsers(event) {
    let msg = '';
    event.added.forEach((id)=>{
        msg += `Added ${user(id)} (${id}) `;
    });
    event.updated.forEach((id)=>{
        msg += `Updated ${user(id)} (${id}) `;
    });
    event.removed.forEach((id)=>{
        msg += `Removed (${id}) `;
    });
    console.log('yAwareness', (0, $7hmfH.exactTime)(), msg);
    function user(id) {
        const userRec = $5bc812abaa5f432b$var$yAwareness.getStates().get(id);
        return (0, $7hmfH.isEmpty)(userRec.user) ? id : userRec.user.name;
    }
}
const $5bc812abaa5f432b$var$lastMicePositions = new Map();
const $5bc812abaa5f432b$var$lastAvatarStatus = new Map();
let $5bc812abaa5f432b$var$refreshAvatars = true;
/**
 * Despatch to deal with event
 * @param {object} event - from yAwareness.on('change')
 */ function $5bc812abaa5f432b$var$receiveEvent(event) {
    if (/aware/.test($5bc812abaa5f432b$export$1c9f709888824e05)) $5bc812abaa5f432b$var$traceUsers(event);
    if ((0, $7hmfH.elem)('showUsersSwitch').checked) {
        const box = $5bc812abaa5f432b$export$4b72f5d71fff605.getBoundingClientRect();
        const changed = event.added.concat(event.updated);
        changed.forEach((userId)=>{
            const rec = $5bc812abaa5f432b$var$yAwareness.getStates().get(userId);
            if (userId !== $5bc812abaa5f432b$export$4d35f98e5d7d0978 && rec.cursor && !(0, $7hmfH.objectEquals)(rec.cursor, $5bc812abaa5f432b$var$lastMicePositions.get(userId))) {
                $5bc812abaa5f432b$var$showOtherMouse(userId, rec.cursor, box);
                $5bc812abaa5f432b$var$lastMicePositions.set(userId, rec.cursor);
            }
            if (rec.user) {
                // if anything has changed, redisplay the avatars
                if ($5bc812abaa5f432b$var$refreshAvatars || !(0, $7hmfH.objectEquals)(rec.user, $5bc812abaa5f432b$var$lastAvatarStatus.get(userId))) $5bc812abaa5f432b$var$showAvatars();
                $5bc812abaa5f432b$var$lastAvatarStatus.set(userId, rec.user);
                // set a timer for this avatar to self-destruct if no update has been received for a minute
                const ava = (0, $7hmfH.elem)(`ava${userId}`);
                if (ava) {
                    clearTimeout(ava.timer);
                    ava.timer = setTimeout($5bc812abaa5f432b$var$removeAvatar, 60000, ava);
                }
            }
            if (userId !== $5bc812abaa5f432b$export$4d35f98e5d7d0978 && rec.addingFactor) $5bc812abaa5f432b$var$showGhostFactor(userId, rec.addingFactor);
        });
    }
    if ($5bc812abaa5f432b$var$followme) $5bc812abaa5f432b$var$followUser();
}
/**
 * Display another user's mouse pointers (if they are inside the canvas)
 */ function $5bc812abaa5f432b$var$showOtherMouse(userId, cursor, box) {
    const cursorDiv = (0, $7hmfH.elem)(userId.toString());
    if (cursorDiv) {
        const p = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM(cursor);
        p.x += box.left;
        p.y += box.top;
        cursorDiv.style.top = `${p.y}px`;
        cursorDiv.style.left = `${p.x}px`;
        cursorDiv.style.display = p.x < box.left || p.x > box.right || p.y > box.bottom || p.y < box.top ? 'none' : 'block';
    }
}
/**
 * Place a circle at the top left of the net pane to represent each user who is online
 * Also create a cursor (a div) for each of the users
 */ function $5bc812abaa5f432b$var$showAvatars() {
    $5bc812abaa5f432b$var$refreshAvatars = false;
    const recs = Array.from($5bc812abaa5f432b$var$yAwareness.getStates());
    // remove and save myself (using clientID as the id, not name)
    const me = recs.splice(recs.findIndex((a)=>a[0] === $5bc812abaa5f432b$export$4d35f98e5d7d0978), 1);
    const nameRecs = recs.map(([, value])=>value.user || null).filter((e)=>e) // remove any records without a user record
    .filter((v, i, a)=>a.findIndex((t)=>t.name === v.name) === i) // remove duplicates, by name
    .sort((a, b)=>a.name.charAt(0).toUpperCase() > b.name.charAt(0).toUpperCase() ? 1 : -1) // sort names
    ;
    if (me.length === 0) return; // app is unloading
    nameRecs.unshift(me[0][1].user) // push myself on to the front
    ;
    const avatars = (0, $7hmfH.elem)('avatars');
    const currentCursors = [];
    // check that an avatar exists for each name; if not create one.  If it does, check that it is still looking right
    nameRecs.forEach((nameRec)=>{
        const ava = (0, $7hmfH.elem)(`ava${nameRec.id}`);
        if (nameRec.name === 'debug') {
            // skip the debug user
            if (ava) $5bc812abaa5f432b$var$removeAvatar(ava);
            return;
        }
        const shortName = (0, $7hmfH.initials)(nameRec.name);
        if (ava === null) {
            makeAvatar(nameRec);
            $5bc812abaa5f432b$var$refreshAvatars = true;
        } else {
            // to avoid flashes, don't touch anything that is already correct
            if (ava.dataset.tooltip !== nameRec.name) ava.dataset.tooltip = nameRec.name;
            const circle = ava.firstChild;
            if (circle.style.backgroundColor !== nameRec.color) circle.style.backgroundColor = nameRec.color;
            const circleBorderColor = nameRec.anon ? 'white' : 'black';
            if (circle.style.borderColor !== circleBorderColor) circle.style.borderColor = circleBorderColor;
            if (circle.innerText !== shortName) circle.innerText = shortName;
            const circleFontColor = circle.style.color;
            if (circleFontColor !== (nameRec.isLight ? 'black' : 'white')) circle.style.color = nameRec.isLight ? 'black' : 'white';
            const opacity = nameRec.asleep ? 0.2 : 1.0;
            if (circle.style.opacity !== opacity) circle.style.opacity = opacity;
        }
        if (nameRec.id !== $5bc812abaa5f432b$export$4d35f98e5d7d0978) {
            // don't create a cursor for myself
            let cursorDiv = (0, $7hmfH.elem)(nameRec.id);
            if (cursorDiv === null) cursorDiv = makeCursor(nameRec);
            else {
                if (nameRec.asleep) cursorDiv.style.display = 'none';
                if (cursorDiv.innerText !== shortName) cursorDiv.innerText = shortName;
                if (cursorDiv.style.backgroundColor !== nameRec.color) cursorDiv.style.backgroundColor = nameRec.color;
            }
            currentCursors.push(cursorDiv);
        }
    });
    // re-order the avatars into alpha order, without gaps, with me at the start
    const df = document.createDocumentFragment();
    nameRecs.forEach((nameRec)=>{
        // skip debug user
        if (nameRec.name === 'debug') return;
        df.appendChild((0, $7hmfH.elem)(`ava${nameRec.id}`));
    });
    avatars.replaceChildren(df);
    // delete any cursors that remain from before
    const cursorsToDelete = Array.from(document.querySelectorAll('.shared-cursor')).filter((a)=>!currentCursors.includes(a));
    cursorsToDelete.forEach((e)=>e.remove());
    /**
   * create an avatar as a div with initials inside
   * @param {object} nameRec
   */ function makeAvatar(nameRec) {
        const ava = document.createElement('div');
        ava.classList.add('hoverme');
        if ($5bc812abaa5f432b$var$followme === nameRec.id) ava.classList.add('followme');
        ava.id = `ava${nameRec.id}`;
        ava.dataset.tooltip = nameRec.name;
        // the broadcast awareness sometimes loses a client (i.e. broadcasts that it has been removed)
        // when it actually hasn't (e.g. if there is a comms glitch).  So instead, we set a timer
        // and delete the avatar only if nothing is heard from that user for a minute
        ava.timer = setTimeout($5bc812abaa5f432b$var$removeAvatar, 60000, ava);
        const circle = document.createElement('div');
        circle.classList.add('round');
        circle.style.backgroundColor = nameRec.color;
        if (nameRec.anon) circle.style.borderColor = 'white';
        circle.innerText = (0, $7hmfH.initials)(nameRec.name);
        circle.style.color = nameRec.isLight ? 'black' : 'white';
        circle.style.opacity = nameRec.asleep ? 0.2 : 1.0;
        circle.dataset.client = nameRec.id;
        circle.dataset.userName = nameRec.name;
        ava.appendChild(circle);
        avatars.appendChild(ava);
        circle.addEventListener('click', nameRec.id === $5bc812abaa5f432b$export$4d35f98e5d7d0978 ? $5bc812abaa5f432b$var$renameUser : $5bc812abaa5f432b$var$follow);
        circle.addEventListener('contextmenu', $5bc812abaa5f432b$var$selectUsersItems);
        circle.addEventListener('mouseover', ()=>(0, $7hmfH.statusMsg)(nameRec.id === $5bc812abaa5f432b$export$4d35f98e5d7d0978 ? 'Click to change your name. Right click to select all your edits' : `Click to follow this person. Right click to select all this person's edits`));
        circle.addEventListener('mouseout', ()=>(0, $7hmfH.clearStatusBar)());
    }
    /**
   * make a pseudo cursor (a div)
   * @param {object} nameRec
   * @returns a div
   */ function makeCursor(nameRec) {
        const cursorDiv = document.createElement('div');
        cursorDiv.className = 'shared-cursor';
        cursorDiv.id = nameRec.id;
        cursorDiv.style.backgroundColor = nameRec.color;
        cursorDiv.innerText = (0, $7hmfH.initials)(nameRec.name);
        cursorDiv.style.color = nameRec.isLight ? 'black' : 'white';
        cursorDiv.style.display = 'none' // hide it until we get coordinates at next mousemove
        ;
        $5bc812abaa5f432b$export$34e0f9847d4c02dd.appendChild(cursorDiv);
        return cursorDiv;
    }
}
/**
 * destroy the avatar - the user is no longer on line
 * @param {HTMLelement} ava
 */ function $5bc812abaa5f432b$var$removeAvatar(ava) {
    $5bc812abaa5f432b$var$refreshAvatars = true;
    ava.remove();
}
function $5bc812abaa5f432b$var$showUsersSwitch() {
    const on = (0, $7hmfH.elem)('showUsersSwitch').checked;
    document.querySelectorAll('div.shared-cursor').forEach((node)=>{
        node.style.display = on ? 'block' : 'none';
    });
    (0, $7hmfH.elem)('avatars').style.display = on ? 'flex' : 'none';
}
/**
 * User has clicked on an avatar.  Start following this avatar
 * @param {event} event
 */ function $5bc812abaa5f432b$var$follow(event) {
    if ($5bc812abaa5f432b$var$followme) $5bc812abaa5f432b$var$unFollow();
    const user = parseInt(event.target.dataset.client, 10);
    if (user === $5bc812abaa5f432b$export$4d35f98e5d7d0978) return;
    $5bc812abaa5f432b$var$followme = user;
    (0, $7hmfH.elem)(`ava${$5bc812abaa5f432b$var$followme}`).classList.add('followme');
    const userName = (0, $7hmfH.elem)(`ava${user}`).dataset.tooltip;
    (0, $7hmfH.alertMsg)(`Following ${userName}`, 'info');
}
/**
 * User was following another user, but has now clicked off the avatar, so stop following
 */ function $5bc812abaa5f432b$var$unFollow() {
    if (!$5bc812abaa5f432b$var$followme) return;
    (0, $7hmfH.elem)(`ava${$5bc812abaa5f432b$var$followme}`).classList.remove('followme');
    $5bc812abaa5f432b$var$followme = undefined;
    (0, $7hmfH.elem)('errMsg').classList.remove('fadeInAndOut');
    (0, $7hmfH.clearStatusBar)();
}
/**
 * move the map so that the followed cursor is always in the centre of the pane
 */ function $5bc812abaa5f432b$var$followUser() {
    const userRec = $5bc812abaa5f432b$var$yAwareness.getStates().get($5bc812abaa5f432b$var$followme);
    if (!userRec) return;
    if (userRec.user.asleep) $5bc812abaa5f432b$var$unFollow();
    const userPosition = userRec.cursor;
    if (userPosition) $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.moveTo({
        position: userPosition
    });
}
/**
 * User has clicked on their own avatar.  Prompt them to change their own name.
 */ function $5bc812abaa5f432b$var$renameUser() {
    const newName = prompt('Enter your new name', $5bc812abaa5f432b$var$myNameRec.name);
    $5bc812abaa5f432b$var$saveUserName(newName);
    (0, $7hmfH.clearStatusBar)();
}
/**
 * show a ghost box where another user is adding a factor
 * addingFactor is an object with properties:
 * state: adding', or 'done' to indicate that the ghost box should be removed
 * pos: a position (of the Add Factor dialog); 'done'
 * name: the name of the other user
 * @param {Integer} userId other user's client Id
 * @param {object} addingFactor
 */ function $5bc812abaa5f432b$var$showGhostFactor(userId, addingFactor) {
    const id = `ghost-factor${userId}`;
    switch(addingFactor.state){
        case 'done':
            {
                const ghostDiv = (0, $7hmfH.elem)(id);
                if (ghostDiv) ghostDiv.remove();
                break;
            }
        case 'adding':
            if (!(0, $7hmfH.elem)(id)) {
                const ghostDiv = document.createElement('div');
                ghostDiv.className = 'ghost-factor';
                ghostDiv.id = `ghost-factor${userId}`;
                ghostDiv.innerText = `[New factor\nbeing added by\n${addingFactor.name}]`;
                const p = $5bc812abaa5f432b$export$21fcfd9d5c6ebbd4.canvasToDOM(addingFactor.pos);
                const box = $5bc812abaa5f432b$export$34e0f9847d4c02dd.getBoundingClientRect();
                p.x += box.left;
                p.y += box.top;
                ghostDiv.style.top = `${p.y - 50}px`;
                ghostDiv.style.left = `${p.x - 187}px`;
                ghostDiv.style.display = p.x < box.left || p.x > box.right || p.y > box.bottom || p.y < box.top ? 'none' : 'block';
                $5bc812abaa5f432b$export$4b72f5d71fff605.appendChild(ghostDiv);
            }
            break;
        default:
            console.log(`Bad adding factor: ${addingFactor}`);
    }
}


//# sourceMappingURL=prsm.1e811db3.js.map
